webpackJsonp([0],{

/***/ "../node_modules/@krakenjs/beaver-logger/dist/beaver-logger.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (root, factory) {
    "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.beaver = factory() : root.beaver = factory();
}("undefined" != typeof self ? self : undefined, function () {
    return function (modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = !0;
            return module.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function (exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.r = function (exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        };
        __webpack_require__.t = function (value, mode) {
            1 & mode && (value = __webpack_require__(value));
            if (8 & mode) return value;
            if (4 & mode && "object" == (typeof value === "undefined" ? "undefined" : _typeof(value)) && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            });
            if (2 & mode && "string" != typeof value) for (var key in value) {
                __webpack_require__.d(ns, key, function (key) {
                    return value[key];
                }.bind(null, key));
            }return ns;
        };
        __webpack_require__.n = function (module) {
            var getter = module && module.__esModule ? function () {
                return module["default"];
            } : function () {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function (object, property) {
            return {}.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 0);
    }([function (module, __webpack_exports__, __webpack_require__) {
        

        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "Logger", function () {
            return Logger;
        });
        __webpack_require__.d(__webpack_exports__, "LOG_LEVEL", function () {
            return LOG_LEVEL;
        });
        __webpack_require__.d(__webpack_exports__, "PROTOCOL", function () {
            return constants_PROTOCOL;
        });
        __webpack_require__.d(__webpack_exports__, "canUseSendBeacon", function () {
            return canUseSendBeacon;
        });
        __webpack_require__.d(__webpack_exports__, "extendIfDefined", function () {
            return extendIfDefined;
        });
        __webpack_require__.d(__webpack_exports__, "sendBeacon", function () {
            return sendBeacon;
        });
        __webpack_require__.d(__webpack_exports__, "getHTTPTransport", function () {
            return getHTTPTransport;
        });
        function _extends() {
            return (_extends = Object.assign || function (target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        ({}).hasOwnProperty.call(source, key) && (target[key] = source[key]);
                    }
                }
                return target;
            }).apply(this, arguments);
        }
        function utils_isPromise(item) {
            try {
                if (!item) return !1;
                if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                if ("undefined" != typeof window && "function" == typeof window.Window && item instanceof window.Window) return !1;
                if ("undefined" != typeof window && "function" == typeof window.constructor && item instanceof window.constructor) return !1;
                var _toString = {}.toString;
                if (_toString) {
                    var name = _toString.call(item);
                    if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                }
                if ("function" == typeof item.then) return !0;
            } catch (err) {
                return !1;
            }
            return !1;
        }
        var dispatchedErrors = [];
        var possiblyUnhandledPromiseHandlers = [];
        var activeCount = 0;
        var flushPromise;
        function flushActive() {
            if (!activeCount && flushPromise) {
                var promise = flushPromise;
                flushPromise = null;
                promise.resolve();
            }
        }
        function startActive() {
            activeCount += 1;
        }
        function endActive() {
            activeCount -= 1;
            flushActive();
        }
        var promise_ZalgoPromise = function () {
            function ZalgoPromise(handler) {
                var _this = this;
                this.resolved = void 0;
                this.rejected = void 0;
                this.errorHandled = void 0;
                this.value = void 0;
                this.error = void 0;
                this.handlers = void 0;
                this.dispatching = void 0;
                this.stack = void 0;
                this.resolved = !1;
                this.rejected = !1;
                this.errorHandled = !1;
                this.handlers = [];
                if (handler) {
                    var _result;
                    var _error;
                    var resolved = !1;
                    var rejected = !1;
                    var isAsync = !1;
                    startActive();
                    try {
                        handler(function (res) {
                            if (isAsync) _this.resolve(res);else {
                                resolved = !0;
                                _result = res;
                            }
                        }, function (err) {
                            if (isAsync) _this.reject(err);else {
                                rejected = !0;
                                _error = err;
                            }
                        });
                    } catch (err) {
                        endActive();
                        this.reject(err);
                        return;
                    }
                    endActive();
                    isAsync = !0;
                    resolved ? this.resolve(_result) : rejected && this.reject(_error);
                }
            }
            var _proto = ZalgoPromise.prototype;
            _proto.resolve = function (result) {
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                this.resolved = !0;
                this.value = result;
                this.dispatch();
                return this;
            };
            _proto.reject = function (error) {
                var _this2 = this;
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                if (!error) {
                    var _err = error && "function" == typeof error.toString ? error.toString() : {}.toString.call(error);
                    error = new Error("Expected reject to be called with Error, got " + _err);
                }
                this.rejected = !0;
                this.error = error;
                this.errorHandled || setTimeout(function () {
                    _this2.errorHandled || function (err, promise) {
                        if (-1 === dispatchedErrors.indexOf(err)) {
                            dispatchedErrors.push(err);
                            setTimeout(function () {
                                throw err;
                            }, 1);
                            for (var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++) {
                                possiblyUnhandledPromiseHandlers[j](err, promise);
                            }
                        }
                    }(error, _this2);
                }, 1);
                this.dispatch();
                return this;
            };
            _proto.asyncReject = function (error) {
                this.errorHandled = !0;
                this.reject(error);
                return this;
            };
            _proto.dispatch = function () {
                var resolved = this.resolved,
                    rejected = this.rejected,
                    handlers = this.handlers;
                if (!this.dispatching && (resolved || rejected)) {
                    this.dispatching = !0;
                    startActive();
                    var chain = function chain(firstPromise, secondPromise) {
                        return firstPromise.then(function (res) {
                            secondPromise.resolve(res);
                        }, function (err) {
                            secondPromise.reject(err);
                        });
                    };
                    for (var i = 0; i < handlers.length; i++) {
                        var _handlers$i = handlers[i],
                            onSuccess = _handlers$i.onSuccess,
                            onError = _handlers$i.onError,
                            promise = _handlers$i.promise;
                        var _result2 = void 0;
                        if (resolved) try {
                            _result2 = onSuccess ? onSuccess(this.value) : this.value;
                        } catch (err) {
                            promise.reject(err);
                            continue;
                        } else if (rejected) {
                            if (!onError) {
                                promise.reject(this.error);
                                continue;
                            }
                            try {
                                _result2 = onError(this.error);
                            } catch (err) {
                                promise.reject(err);
                                continue;
                            }
                        }
                        if (_result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected)) {
                            var promiseResult = _result2;
                            promiseResult.resolved ? promise.resolve(promiseResult.value) : promise.reject(promiseResult.error);
                            promiseResult.errorHandled = !0;
                        } else utils_isPromise(_result2) ? _result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected) ? _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error) : chain(_result2, promise) : promise.resolve(_result2);
                    }
                    handlers.length = 0;
                    this.dispatching = !1;
                    endActive();
                }
            };
            _proto.then = function (onSuccess, onError) {
                if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                var promise = new ZalgoPromise();
                this.handlers.push({
                    promise: promise,
                    onSuccess: onSuccess,
                    onError: onError
                });
                this.errorHandled = !0;
                this.dispatch();
                return promise;
            };
            _proto["catch"] = function (onError) {
                return this.then(void 0, onError);
            };
            _proto["finally"] = function (onFinally) {
                if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                return this.then(function (result) {
                    return ZalgoPromise["try"](onFinally).then(function () {
                        return result;
                    });
                }, function (err) {
                    return ZalgoPromise["try"](onFinally).then(function () {
                        throw err;
                    });
                });
            };
            _proto.timeout = function (time, err) {
                var _this3 = this;
                if (this.resolved || this.rejected) return this;
                var timeout = setTimeout(function () {
                    _this3.resolved || _this3.rejected || _this3.reject(err || new Error("Promise timed out after " + time + "ms"));
                }, time);
                return this.then(function (result) {
                    clearTimeout(timeout);
                    return result;
                });
            };
            _proto.toPromise = function () {
                if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                return Promise.resolve(this);
            };
            _proto.lazy = function () {
                this.errorHandled = !0;
                return this;
            };
            ZalgoPromise.resolve = function (value) {
                return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise(function (resolve, reject) {
                    return value.then(resolve, reject);
                }) : new ZalgoPromise().resolve(value);
            };
            ZalgoPromise.reject = function (error) {
                return new ZalgoPromise().reject(error);
            };
            ZalgoPromise.asyncReject = function (error) {
                return new ZalgoPromise().asyncReject(error);
            };
            ZalgoPromise.all = function (promises) {
                var promise = new ZalgoPromise();
                var count = promises.length;
                var results = [].slice();
                if (!count) {
                    promise.resolve(results);
                    return promise;
                }
                var chain = function chain(i, firstPromise, secondPromise) {
                    return firstPromise.then(function (res) {
                        results[i] = res;
                        0 == (count -= 1) && promise.resolve(results);
                    }, function (err) {
                        secondPromise.reject(err);
                    });
                };
                for (var i = 0; i < promises.length; i++) {
                    var prom = promises[i];
                    if (prom instanceof ZalgoPromise) {
                        if (prom.resolved) {
                            results[i] = prom.value;
                            count -= 1;
                            continue;
                        }
                    } else if (!utils_isPromise(prom)) {
                        results[i] = prom;
                        count -= 1;
                        continue;
                    }
                    chain(i, ZalgoPromise.resolve(prom), promise);
                }
                0 === count && promise.resolve(results);
                return promise;
            };
            ZalgoPromise.hash = function (promises) {
                var result = {};
                var awaitPromises = [];
                var _loop = function _loop(key) {
                    if (promises.hasOwnProperty(key)) {
                        var value = promises[key];
                        utils_isPromise(value) ? awaitPromises.push(value.then(function (res) {
                            result[key] = res;
                        })) : result[key] = value;
                    }
                };
                for (var key in promises) {
                    _loop(key);
                }return ZalgoPromise.all(awaitPromises).then(function () {
                    return result;
                });
            };
            ZalgoPromise.map = function (items, method) {
                return ZalgoPromise.all(items.map(method));
            };
            ZalgoPromise.onPossiblyUnhandledException = function (handler) {
                return function (handler) {
                    possiblyUnhandledPromiseHandlers.push(handler);
                    return {
                        cancel: function cancel() {
                            possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                        }
                    };
                }(handler);
            };
            ZalgoPromise["try"] = function (method, context, args) {
                if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                var result;
                startActive();
                try {
                    result = method.apply(context, args || []);
                } catch (err) {
                    endActive();
                    return ZalgoPromise.reject(err);
                }
                endActive();
                return ZalgoPromise.resolve(result);
            };
            ZalgoPromise.delay = function (_delay) {
                return new ZalgoPromise(function (resolve) {
                    setTimeout(resolve, _delay);
                });
            };
            ZalgoPromise.isPromise = function (value) {
                return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
            };
            ZalgoPromise.flush = function () {
                return function (Zalgo) {
                    var promise = flushPromise = flushPromise || new Zalgo();
                    flushActive();
                    return promise;
                }(ZalgoPromise);
            };
            return ZalgoPromise;
        }();
        function _setPrototypeOf(o, p) {
            return (_setPrototypeOf = Object.setPrototypeOf || function (o, p) {
                o.__proto__ = p;
                return o;
            })(o, p);
        }
        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass);
        }
        var IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
        function getActualProtocol(win) {
            void 0 === win && (win = window);
            return win.location.protocol;
        }
        function getProtocol(win) {
            void 0 === win && (win = window);
            if (win.mockDomain) {
                var protocol = win.mockDomain.split("//")[0];
                if (protocol) return protocol;
            }
            return getActualProtocol(win);
        }
        function isAboutProtocol(win) {
            void 0 === win && (win = window);
            return "about:" === getProtocol(win);
        }
        function canReadFromWindow(win) {
            try {
                return !0;
            } catch (err) {}
            return !1;
        }
        function getActualDomain(win) {
            void 0 === win && (win = window);
            var location = win.location;
            if (!location) throw new Error("Can not read window location");
            var protocol = getActualProtocol(win);
            if (!protocol) throw new Error("Can not read window protocol");
            if ("file:" === protocol) return "file://";
            if ("about:" === protocol) {
                var parent = function (win) {
                    void 0 === win && (win = window);
                    if (win) try {
                        if (win.parent && win.parent !== win) return win.parent;
                    } catch (err) {}
                }(win);
                return parent && canReadFromWindow() ? getActualDomain(parent) : "about://";
            }
            var host = location.host;
            if (!host) throw new Error("Can not read window host");
            return protocol + "//" + host;
        }
        function getDomain(win) {
            void 0 === win && (win = window);
            var domain = getActualDomain(win);
            return domain && win.mockDomain && 0 === win.mockDomain.indexOf("mock:") ? win.mockDomain : domain;
        }
        function isSameDomain(win) {
            if (!function (win) {
                try {
                    if (win === window) return !0;
                } catch (err) {}
                try {
                    var desc = Object.getOwnPropertyDescriptor(win, "location");
                    if (desc && !1 === desc.enumerable) return !1;
                } catch (err) {}
                try {
                    if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                } catch (err) {}
                try {
                    if (function (win) {
                        void 0 === win && (win = window);
                        return "mock:" === getProtocol(win);
                    }(win) && canReadFromWindow()) return !0;
                } catch (err) {}
                try {
                    if (getActualDomain(win) === getActualDomain(window)) return !0;
                } catch (err) {}
                return !1;
            }(win)) return !1;
            try {
                if (win === window) return !0;
                if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                if (getDomain(window) === getDomain(win)) return !0;
            } catch (err) {}
            return !1;
        }
        var iframeWindows = [];
        var iframeFrames = [];
        function isWindowClosed(win, allowMock) {
            void 0 === allowMock && (allowMock = !0);
            try {
                if (win === window) return !1;
            } catch (err) {
                return !0;
            }
            try {
                if (!win) return !0;
            } catch (err) {
                return !0;
            }
            try {
                if (win.closed) return !0;
            } catch (err) {
                return !err || err.message !== IE_WIN_ACCESS_ERROR;
            }
            if (allowMock && isSameDomain(win)) try {
                if (win.mockclosed) return !0;
            } catch (err) {}
            try {
                if (!win.parent || !win.top) return !0;
            } catch (err) {}
            var iframeIndex = function (collection, item) {
                for (var i = 0; i < collection.length; i++) {
                    try {
                        if (collection[i] === item) return i;
                    } catch (err) {}
                }return -1;
            }(iframeWindows, win);
            if (-1 !== iframeIndex) {
                var frame = iframeFrames[iframeIndex];
                if (frame && function (frame) {
                    if (!frame.contentWindow) return !0;
                    if (!frame.parentNode) return !0;
                    var doc = frame.ownerDocument;
                    if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
                        var parent = frame;
                        for (; parent.parentNode && parent.parentNode !== parent;) {
                            parent = parent.parentNode;
                        }if (!parent.host || !doc.documentElement.contains(parent.host)) return !0;
                    }
                    return !1;
                }(frame)) return !0;
            }
            return !1;
        }
        function isWindow(obj) {
            try {
                if (obj === window) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if ("[object Window]" === {}.toString.call(obj)) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (window.Window && obj instanceof window.Window) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.self === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.parent === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.top === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
            } catch (err) {
                return !0;
            }
            try {
                if ("postMessage" in obj && "self" in obj && "location" in obj) return !0;
            } catch (err) {}
            return !1;
        }
        function util_safeIndexOf(collection, item) {
            for (var i = 0; i < collection.length; i++) {
                try {
                    if (collection[i] === item) return i;
                } catch (err) {}
            }return -1;
        }
        var weakmap_CrossDomainSafeWeakMap = function () {
            function CrossDomainSafeWeakMap() {
                this.name = void 0;
                this.weakmap = void 0;
                this.keys = void 0;
                this.values = void 0;
                this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__";
                if (function () {
                    if ("undefined" == typeof WeakMap) return !1;
                    if (void 0 === Object.freeze) return !1;
                    try {
                        var testWeakMap = new WeakMap();
                        var testKey = {};
                        Object.freeze(testKey);
                        testWeakMap.set(testKey, "__testvalue__");
                        return "__testvalue__" === testWeakMap.get(testKey);
                    } catch (err) {
                        return !1;
                    }
                }()) try {
                    this.weakmap = new WeakMap();
                } catch (err) {}
                this.keys = [];
                this.values = [];
            }
            var _proto = CrossDomainSafeWeakMap.prototype;
            _proto._cleanupClosedWindows = function () {
                var weakmap = this.weakmap;
                var keys = this.keys;
                for (var i = 0; i < keys.length; i++) {
                    var value = keys[i];
                    if (isWindow(value) && isWindowClosed(value)) {
                        if (weakmap) try {
                            weakmap["delete"](value);
                        } catch (err) {}
                        keys.splice(i, 1);
                        this.values.splice(i, 1);
                        i -= 1;
                    }
                }
            };
            _proto.isSafeToReadWrite = function (key) {
                return !isWindow(key);
            };
            _proto.set = function (key, value) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    weakmap.set(key, value);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var name = this.name;
                    var entry = key[name];
                    entry && entry[0] === key ? entry[1] = value : Object.defineProperty(key, name, {
                        value: [key, value],
                        writable: !0
                    });
                    return;
                } catch (err) {}
                this._cleanupClosedWindows();
                var keys = this.keys;
                var values = this.values;
                var index = util_safeIndexOf(keys, key);
                if (-1 === index) {
                    keys.push(key);
                    values.push(value);
                } else values[index] = value;
            };
            _proto.get = function (key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    if (weakmap.has(key)) return weakmap.get(key);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    return entry && entry[0] === key ? entry[1] : void 0;
                } catch (err) {}
                this._cleanupClosedWindows();
                var index = util_safeIndexOf(this.keys, key);
                if (-1 !== index) return this.values[index];
            };
            _proto["delete"] = function (key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    weakmap["delete"](key);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                } catch (err) {}
                this._cleanupClosedWindows();
                var keys = this.keys;
                var index = util_safeIndexOf(keys, key);
                if (-1 !== index) {
                    keys.splice(index, 1);
                    this.values.splice(index, 1);
                }
            };
            _proto.has = function (key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    if (weakmap.has(key)) return !0;
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    return !(!entry || entry[0] !== key);
                } catch (err) {}
                this._cleanupClosedWindows();
                return -1 !== util_safeIndexOf(this.keys, key);
            };
            _proto.getOrSet = function (key, getter) {
                if (this.has(key)) return this.get(key);
                var value = getter();
                this.set(key, value);
                return value;
            };
            return CrossDomainSafeWeakMap;
        }();
        function _getPrototypeOf(o) {
            return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            })(o);
        }
        function _isNativeReflectConstruct() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
                return !0;
            } catch (e) {
                return !1;
            }
        }
        function construct_construct(Parent, args, Class) {
            return (construct_construct = _isNativeReflectConstruct() ? Reflect.construct : function (Parent, args, Class) {
                var a = [null];
                a.push.apply(a, args);
                var instance = new (Function.bind.apply(Parent, a))();
                Class && _setPrototypeOf(instance, Class.prototype);
                return instance;
            }).apply(null, arguments);
        }
        function wrapNativeSuper_wrapNativeSuper(Class) {
            var _cache = "function" == typeof Map ? new Map() : void 0;
            return (wrapNativeSuper_wrapNativeSuper = function wrapNativeSuper_wrapNativeSuper(Class) {
                if (null === Class || !(fn = Class, -1 !== Function.toString.call(fn).indexOf("[native code]"))) return Class;
                var fn;
                if ("function" != typeof Class) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== _cache) {
                    if (_cache.has(Class)) return _cache.get(Class);
                    _cache.set(Class, Wrapper);
                }
                function Wrapper() {
                    return construct_construct(Class, arguments, _getPrototypeOf(this).constructor);
                }
                Wrapper.prototype = Object.create(Class.prototype, {
                    constructor: {
                        value: Wrapper,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                });
                return _setPrototypeOf(Wrapper, Class);
            })(Class);
        }
        function getFunctionName(fn) {
            return fn.name || fn.__name__ || fn.displayName || "anonymous";
        }
        function setFunctionName(fn, name) {
            try {
                delete fn.name;
                fn.name = name;
            } catch (err) {}
            fn.__name__ = fn.displayName = name;
            return fn;
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "uid_" + "xxxxxxxxxx".replace(/./g, function () {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            }) + "_" + function (str) {
                if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (m, p1) {
                    return String.fromCharCode(parseInt(p1, 16));
                })).replace(/[=]/g, "");
                if ("undefined" != typeof Buffer) return Buffer.from(str, "utf8").toString("base64").replace(/[=]/g, "");
                throw new Error("Can not find window.btoa or Buffer");
            }(new Date().toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        }
        var objectIDs;
        function serializeArgs(args) {
            try {
                return JSON.stringify([].slice.call(args), function (subkey, val) {
                    return "function" == typeof val ? "memoize[" + function (obj) {
                        objectIDs = objectIDs || new weakmap_CrossDomainSafeWeakMap();
                        if (null == obj || "object" != (typeof obj === "undefined" ? "undefined" : _typeof(obj)) && "function" != typeof obj) throw new Error("Invalid object");
                        var uid = objectIDs.get(obj);
                        if (!uid) {
                            uid = (typeof obj === "undefined" ? "undefined" : _typeof(obj)) + ":" + uniqueID();
                            objectIDs.set(obj, uid);
                        }
                        return uid;
                    }(val) + "]" : function (element) {
                        var passed = !1;
                        try {
                            (element instanceof window.Element || null !== element && "object" == (typeof element === "undefined" ? "undefined" : _typeof(element)) && 1 === element.nodeType && "object" == _typeof(element.style) && "object" == _typeof(element.ownerDocument)) && (passed = !0);
                        } catch (_) {}
                        return passed;
                    }(val) ? {} : val;
                });
            } catch (err) {
                throw new Error("Arguments not serializable -- can not be used to memoize");
            }
        }
        function getEmptyObject() {
            return {};
        }
        var memoizeGlobalIndex = 0;
        var memoizeGlobalIndexValidFrom = 0;
        function memoize(method, options) {
            void 0 === options && (options = {});
            var _options$thisNamespac = options.thisNamespace,
                thisNamespace = void 0 !== _options$thisNamespac && _options$thisNamespac,
                cacheTime = options.time;
            var simpleCache;
            var thisCache;
            var memoizeIndex = memoizeGlobalIndex;
            memoizeGlobalIndex += 1;
            var memoizedFunction = function memoizedFunction() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }if (memoizeIndex < memoizeGlobalIndexValidFrom) {
                    simpleCache = null;
                    thisCache = null;
                    memoizeIndex = memoizeGlobalIndex;
                    memoizeGlobalIndex += 1;
                }
                var cache;
                cache = thisNamespace ? (thisCache = thisCache || new weakmap_CrossDomainSafeWeakMap()).getOrSet(this, getEmptyObject) : simpleCache = simpleCache || {};
                var cacheKey;
                try {
                    cacheKey = serializeArgs(args);
                } catch (_unused) {
                    return method.apply(this, arguments);
                }
                var cacheResult = cache[cacheKey];
                if (cacheResult && cacheTime && Date.now() - cacheResult.time < cacheTime) {
                    delete cache[cacheKey];
                    cacheResult = null;
                }
                if (cacheResult) return cacheResult.value;
                var time = Date.now();
                var value = method.apply(this, arguments);
                cache[cacheKey] = {
                    time: time,
                    value: value
                };
                return value;
            };
            memoizedFunction.reset = function () {
                simpleCache = null;
                thisCache = null;
            };
            return setFunctionName(memoizedFunction, (options.name || getFunctionName(method)) + "::memoized");
        }
        memoize.clear = function () {
            memoizeGlobalIndexValidFrom = memoizeGlobalIndex;
        };
        function src_util_noop() {}
        memoize(function (obj) {
            if (Object.values) return Object.values(obj);
            var result = [];
            for (var key in obj) {
                obj.hasOwnProperty(key) && result.push(obj[key]);
            }return result;
        });
        function objFilter(obj, filter) {
            void 0 === filter && (filter = Boolean);
            var result = {};
            for (var key in obj) {
                obj.hasOwnProperty(key) && filter(obj[key], key) && (result[key] = obj[key]);
            }return result;
        }
        var util_ExtendableError = function (_Error) {
            _inheritsLoose(ExtendableError, _Error);
            function ExtendableError(message) {
                var _this6;
                (_this6 = _Error.call(this, message) || this).name = _this6.constructor.name;
                "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(function (self) {
                    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }(_this6), _this6.constructor) : _this6.stack = new Error(message).stack;
                return _this6;
            }
            return ExtendableError;
        }(wrapNativeSuper_wrapNativeSuper(Error));
        function isDocumentReady() {
            return Boolean(document.body) && "complete" === document.readyState;
        }
        function isDocumentInteractive() {
            return Boolean(document.body) && "interactive" === document.readyState;
        }
        memoize(function () {
            return new promise_ZalgoPromise(function (resolve) {
                if (isDocumentReady() || isDocumentInteractive()) return resolve();
                var interval = setInterval(function () {
                    if (isDocumentReady() || isDocumentInteractive()) {
                        clearInterval(interval);
                        return resolve();
                    }
                }, 10);
            });
        });
        function dom_isBrowser() {
            return "undefined" != typeof window && void 0 !== window.location;
        }
        _inheritsLoose(function () {
            return _ExtendableError.apply(this, arguments) || this;
        }, _ExtendableError = util_ExtendableError);
        var _ExtendableError;
        var currentScript = "undefined" != typeof document ? document.currentScript : null;
        var getCurrentScript = memoize(function () {
            if (currentScript) return currentScript;
            if (currentScript = function () {
                try {
                    var stack = function () {
                        try {
                            throw new Error("_");
                        } catch (err) {
                            return err.stack || "";
                        }
                    }();
                    var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(stack);
                    var scriptLocation = stackDetails && stackDetails[1];
                    if (!scriptLocation) return;
                    for (var _i22 = 0, _Array$prototype$slic2 = [].slice.call(document.getElementsByTagName("script")).reverse(); _i22 < _Array$prototype$slic2.length; _i22++) {
                        var script = _Array$prototype$slic2[_i22];
                        if (script.src && script.src === scriptLocation) return script;
                    }
                } catch (err) {}
            }()) return currentScript;
            throw new Error("Can not determine current script");
        });
        var currentUID = uniqueID();
        memoize(function () {
            var script;
            try {
                script = getCurrentScript();
            } catch (err) {
                return currentUID;
            }
            var uid = script.getAttribute("data-uid");
            if (uid && "string" == typeof uid) return uid;
            if ((uid = script.getAttribute("data-uid-auto")) && "string" == typeof uid) return uid;
            if (script.src) {
                var hashedString = function (str) {
                    var hash = "";
                    for (var i = 0; i < str.length; i++) {
                        var total = str[i].charCodeAt(0) * i;
                        str[i + 1] && (total += str[i + 1].charCodeAt(0) * (i - 1));
                        hash += String.fromCharCode(97 + Math.abs(total) % 26);
                    }
                    return hash;
                }(JSON.stringify({
                    src: script.src,
                    dataset: script.dataset
                }));
                uid = "uid_" + hashedString.slice(hashedString.length - 30);
            } else uid = uniqueID();
            script.setAttribute("data-uid-auto", uid);
            return uid;
        });
        var http_headerBuilders = [];
        var LOG_LEVEL = {
            DEBUG: "debug",
            INFO: "info",
            WARN: "warn",
            ERROR: "error"
        };
        var constants_PROTOCOL = {
            FILE: "file:"
        };
        var AUTO_FLUSH_LEVEL = [LOG_LEVEL.WARN, LOG_LEVEL.ERROR];
        var LOG_LEVEL_PRIORITY = [LOG_LEVEL.ERROR, LOG_LEVEL.WARN, LOG_LEVEL.INFO, LOG_LEVEL.DEBUG];
        var DEFAULT_LOG_LEVEL = LOG_LEVEL.WARN;
        var canUseSendBeacon = function canUseSendBeacon(_ref) {
            var headers = _ref.headers,
                enableSendBeacon = _ref.enableSendBeacon;
            var hasHeaders = headers && Object.keys(headers).length;
            return !!(window && window.navigator.sendBeacon && !hasHeaders && enableSendBeacon && window.Blob);
        };
        var sendBeacon = function sendBeacon(_ref2) {
            var _ref2$win = _ref2.win,
                win = void 0 === _ref2$win ? window : _ref2$win,
                url = _ref2.url,
                data = _ref2.data,
                _ref2$useBlob = _ref2.useBlob,
                useBlob = void 0 === _ref2$useBlob || _ref2$useBlob;
            try {
                var json = JSON.stringify(data);
                if (!win.navigator.sendBeacon) throw new Error("No sendBeacon available");
                if (useBlob) {
                    var blob = new Blob([json], {
                        type: "application/json"
                    });
                    return win.navigator.sendBeacon(url, blob);
                }
                return win.navigator.sendBeacon(url, json);
            } catch (e) {
                return !1;
            }
        };
        var extendIfDefined = function extendIfDefined(target, source) {
            for (var key in source) {
                source.hasOwnProperty(key) && (target[key] = source[key]);
            }
        };
        function getHTTPTransport(httpWin) {
            return function (_ref) {
                var url = _ref.url,
                    method = _ref.method,
                    headers = _ref.headers,
                    json = _ref.json,
                    _ref$enableSendBeacon = _ref.enableSendBeacon,
                    enableSendBeacon = void 0 !== _ref$enableSendBeacon && _ref$enableSendBeacon;
                return promise_ZalgoPromise["try"](function () {
                    var httpWindow = httpWin || window;
                    var win = isSameDomain(httpWindow) ? function (win) {
                        if (!isSameDomain(win)) throw new Error("Expected window to be same domain");
                        return win;
                    }(httpWindow) : window;
                    var beaconResult = !1;
                    canUseSendBeacon({
                        headers: headers,
                        enableSendBeacon: enableSendBeacon
                    }) && (beaconResult = sendBeacon({
                        win: win,
                        url: url,
                        data: json,
                        useBlob: !0
                    }));
                    return beaconResult || function (_ref) {
                        var url = _ref.url,
                            _ref$method = _ref.method,
                            method = void 0 === _ref$method ? "get" : _ref$method,
                            _ref$headers = _ref.headers,
                            headers = void 0 === _ref$headers ? {} : _ref$headers,
                            json = _ref.json,
                            data = _ref.data,
                            body = _ref.body,
                            _ref$win = _ref.win,
                            win = void 0 === _ref$win ? window : _ref$win,
                            _ref$timeout = _ref.timeout,
                            timeout = void 0 === _ref$timeout ? 0 : _ref$timeout;
                        return new promise_ZalgoPromise(function (resolve, reject) {
                            if (json && data || json && body || data && json) throw new Error("Only options.json or options.data or options.body should be passed");
                            var normalizedHeaders = {};
                            for (var _i4 = 0, _Object$keys2 = Object.keys(headers); _i4 < _Object$keys2.length; _i4++) {
                                var _key2 = _Object$keys2[_i4];
                                normalizedHeaders[_key2.toLowerCase()] = headers[_key2];
                            }
                            json ? normalizedHeaders["content-type"] = normalizedHeaders["content-type"] || "application/json" : (data || body) && (normalizedHeaders["content-type"] = normalizedHeaders["content-type"] || "application/x-www-form-urlencoded; charset=utf-8");
                            normalizedHeaders.accept = normalizedHeaders.accept || "application/json";
                            for (var _i6 = 0; _i6 < http_headerBuilders.length; _i6++) {
                                var builtHeaders = (0, http_headerBuilders[_i6])();
                                for (var _i8 = 0, _Object$keys4 = Object.keys(builtHeaders); _i8 < _Object$keys4.length; _i8++) {
                                    var _key3 = _Object$keys4[_i8];
                                    normalizedHeaders[_key3.toLowerCase()] = builtHeaders[_key3];
                                }
                            }
                            var xhr = new win.XMLHttpRequest();
                            xhr.addEventListener("load", function () {
                                var responseHeaders = function (rawHeaders) {
                                    void 0 === rawHeaders && (rawHeaders = "");
                                    var result = {};
                                    for (var _i2 = 0, _rawHeaders$trim$spli2 = rawHeaders.trim().split("\n"); _i2 < _rawHeaders$trim$spli2.length; _i2++) {
                                        var _line$split = _rawHeaders$trim$spli2[_i2].split(":"),
                                            _key = _line$split[0],
                                            values = _line$split.slice(1);
                                        result[_key.toLowerCase()] = values.join(":").trim();
                                    }
                                    return result;
                                }(this.getAllResponseHeaders());
                                if (!this.status) return reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: no response status code."));
                                var contentType = responseHeaders["content-type"];
                                var isJSON = contentType && (0 === contentType.indexOf("application/json") || 0 === contentType.indexOf("text/json"));
                                var responseBody = this.responseText;
                                try {
                                    responseBody = JSON.parse(responseBody);
                                } catch (err) {
                                    if (isJSON) return reject(new Error("Invalid json: " + this.responseText + "."));
                                }
                                return resolve({
                                    status: this.status,
                                    headers: responseHeaders,
                                    body: responseBody
                                });
                            }, !1);
                            xhr.addEventListener("error", function (evt) {
                                reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: " + evt.toString() + "."));
                            }, !1);
                            xhr.open(method, url, !0);
                            for (var _key4 in normalizedHeaders) {
                                normalizedHeaders.hasOwnProperty(_key4) && xhr.setRequestHeader(_key4, normalizedHeaders[_key4]);
                            }json ? body = JSON.stringify(json) : data && (body = Object.keys(data).map(function (key) {
                                return encodeURIComponent(key) + "=" + (data ? encodeURIComponent(data[key]) : "");
                            }).join("&"));
                            xhr.timeout = timeout;
                            xhr.ontimeout = function () {
                                reject(new Error("Request to " + method.toLowerCase() + " " + url + " has timed out"));
                            };
                            xhr.send(body);
                        });
                    }({
                        win: win,
                        url: url,
                        method: method,
                        headers: headers,
                        json: json
                    });
                }).then(src_util_noop);
            };
        }
        function Logger(_ref) {
            var url = _ref.url,
                prefix = _ref.prefix,
                metricNamespacePrefix = _ref.metricNamespacePrefix,
                _ref$logLevel = _ref.logLevel,
                logLevel = void 0 === _ref$logLevel ? DEFAULT_LOG_LEVEL : _ref$logLevel,
                _ref$transport = _ref.transport,
                transport = void 0 === _ref$transport ? getHTTPTransport() : _ref$transport,
                _ref$flushInterval = _ref.flushInterval,
                flushInterval = void 0 === _ref$flushInterval ? 6e4 : _ref$flushInterval,
                _ref$enableSendBeacon = _ref.enableSendBeacon,
                enableSendBeacon = void 0 !== _ref$enableSendBeacon && _ref$enableSendBeacon;
            var events = [];
            var tracking = [];
            var metrics = [];
            var payloadBuilders = [];
            var metaBuilders = [];
            var trackingBuilders = [];
            var metricDimensionBuilders = [];
            var headerBuilders = [];
            function print(level, event, payload) {
                if (dom_isBrowser() && window.console && window.console.log && !(LOG_LEVEL_PRIORITY.indexOf(level) > LOG_LEVEL_PRIORITY.indexOf(logLevel))) {
                    var args = [event];
                    args.push(payload);
                    (payload.error || payload.warning) && args.push("\n\n", payload.error || payload.warning);
                    try {
                        window.console[level] && window.console[level].apply ? window.console[level].apply(window.console, args) : window.console.log && window.console.log.apply && window.console.log.apply(window.console, args);
                    } catch (err) {}
                }
            }
            function immediateFlush() {
                return promise_ZalgoPromise["try"](function () {
                    if (dom_isBrowser() && window.location.protocol !== constants_PROTOCOL.FILE && (events.length || tracking.length || metrics.length)) {
                        var meta = {};
                        for (var _i2 = 0; _i2 < metaBuilders.length; _i2++) {
                            extendIfDefined(meta, (0, metaBuilders[_i2])(meta));
                        }var headers = {};
                        for (var _i4 = 0; _i4 < headerBuilders.length; _i4++) {
                            extendIfDefined(headers, (0, headerBuilders[_i4])(headers));
                        }var res;
                        url && (res = transport({
                            method: "POST",
                            url: url,
                            headers: headers,
                            json: {
                                events: events,
                                meta: meta,
                                tracking: tracking,
                                metrics: metrics
                            },
                            enableSendBeacon: enableSendBeacon
                        })["catch"](src_util_noop));
                        events = [];
                        tracking = [];
                        metrics = [];
                        return promise_ZalgoPromise.resolve(res).then(src_util_noop);
                    }
                });
            }
            var flush = function (method, delay) {
                void 0 === delay && (delay = 50);
                var promise;
                var timeout;
                return setFunctionName(function () {
                    timeout && clearTimeout(timeout);
                    var localPromise = promise = promise || new promise_ZalgoPromise();
                    timeout = setTimeout(function () {
                        promise = null;
                        timeout = null;
                        promise_ZalgoPromise["try"](method).then(function (result) {
                            localPromise.resolve(result);
                        }, function (err) {
                            localPromise.reject(err);
                        });
                    }, delay);
                    return localPromise;
                }, getFunctionName(method) + "::promiseDebounced");
            }(immediateFlush);
            function log(level, event, payload) {
                void 0 === payload && (payload = {});
                if (!dom_isBrowser()) return logger;
                prefix && (event = prefix + "_" + event);
                var logPayload = _extends({}, objFilter(payload), {
                    timestamp: Date.now().toString()
                });
                for (var _i6 = 0; _i6 < payloadBuilders.length; _i6++) {
                    extendIfDefined(logPayload, (0, payloadBuilders[_i6])(logPayload));
                }!function (level, event, payload) {
                    events.push({
                        level: level,
                        event: event,
                        payload: payload
                    });
                    -1 !== AUTO_FLUSH_LEVEL.indexOf(level) && flush();
                }(level, event, logPayload);
                print(level, event, logPayload);
                return logger;
            }
            function addBuilder(builders, builder) {
                builders.push(builder);
                return logger;
            }
            function metric(metricPayload) {
                if (!dom_isBrowser()) return logger;
                metricNamespacePrefix && (metricPayload.metricNamespace = metricNamespacePrefix + "." + metricPayload.metricNamespace);
                metricDimensionBuilders.length > 0 && !metricPayload.dimensions && (metricPayload.dimensions = {});
                for (var _i10 = 0; _i10 < metricDimensionBuilders.length; _i10++) {
                    extendIfDefined(metricPayload.dimensions || {}, (0, metricDimensionBuilders[_i10])(metricPayload.dimensions || {}));
                }print(LOG_LEVEL.DEBUG, "metric." + metricPayload.metricNamespace, metricPayload.dimensions || {});
                metrics.push(metricPayload);
                return logger;
            }
            dom_isBrowser() && (method = flush, time = flushInterval, function loop() {
                setTimeout(function () {
                    method();
                    loop();
                }, time);
            }());
            var method, time;
            if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) {
                window.addEventListener("beforeunload", function () {
                    immediateFlush();
                });
                window.addEventListener("unload", function () {
                    immediateFlush();
                });
                window.addEventListener("pagehide", function () {
                    immediateFlush();
                });
            }
            var logger = {
                debug: function debug(event, payload) {
                    return log(LOG_LEVEL.DEBUG, event, payload);
                },
                info: function info(event, payload) {
                    return log(LOG_LEVEL.INFO, event, payload);
                },
                warn: function warn(event, payload) {
                    return log(LOG_LEVEL.WARN, event, payload);
                },
                error: function error(event, payload) {
                    return log(LOG_LEVEL.ERROR, event, payload);
                },
                track: function track(payload) {
                    void 0 === payload && (payload = {});
                    if (!dom_isBrowser()) return logger;
                    var trackingPayload = objFilter(payload);
                    for (var _i8 = 0; _i8 < trackingBuilders.length; _i8++) {
                        extendIfDefined(trackingPayload, (0, trackingBuilders[_i8])(trackingPayload));
                    }print(LOG_LEVEL.DEBUG, "track", trackingPayload);
                    tracking.push(trackingPayload);
                    return logger;
                },
                metric: metric,
                metricCounter: function metricCounter(metricPayload) {
                    var _metricPayload$value;
                    return metric({
                        metricNamespace: metricPayload.namespace,
                        metricEventName: metricPayload.event,
                        metricValue: null != (_metricPayload$value = metricPayload.value) ? _metricPayload$value : 1,
                        metricType: "counter",
                        dimensions: metricPayload.dimensions
                    });
                },
                metricGauge: function metricGauge(metricPayload) {
                    return metric({
                        metricNamespace: metricPayload.namespace,
                        metricEventName: metricPayload.event,
                        metricValue: metricPayload.value,
                        metricType: "gauge",
                        dimensions: metricPayload.dimensions
                    });
                },
                flush: flush,
                immediateFlush: immediateFlush,
                addPayloadBuilder: function addPayloadBuilder(builder) {
                    return addBuilder(payloadBuilders, builder);
                },
                addMetaBuilder: function addMetaBuilder(builder) {
                    return addBuilder(metaBuilders, builder);
                },
                addMetricDimensionBuilder: function addMetricDimensionBuilder(builder) {
                    return addBuilder(metricDimensionBuilders, builder);
                },
                addTrackingBuilder: function addTrackingBuilder(builder) {
                    return addBuilder(trackingBuilders, builder);
                },
                addHeaderBuilder: function addHeaderBuilder(builder) {
                    return addBuilder(headerBuilders, builder);
                },
                setTransport: function setTransport(newTransport) {
                    transport = newTransport;
                    return logger;
                },
                configure: function configure(opts) {
                    opts.url && (url = opts.url);
                    opts.prefix && (prefix = opts.prefix);
                    opts.logLevel && (logLevel = opts.logLevel);
                    opts.transport && (transport = opts.transport);
                    opts.flushInterval && (flushInterval = opts.flushInterval);
                    opts.enableSendBeacon && (enableSendBeacon = opts.enableSendBeacon);
                    return logger;
                },
                __buffer__: {
                    get events() {
                        return events;
                    },
                    get tracking() {
                        return tracking;
                    },
                    get metrics() {
                        return metrics;
                    }
                }
            };
            Object.defineProperty(logger, "__buffer__", {
                writable: !1
            });
            return logger;
        }
    }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../node_modules/call-bind-apply-helpers/actualApply.js":
/***/ (function(module, exports, __webpack_require__) {



var bind = __webpack_require__("../node_modules/function-bind/index.js");

var $apply = __webpack_require__("../node_modules/call-bind-apply-helpers/functionApply.js");
var $call = __webpack_require__("../node_modules/call-bind-apply-helpers/functionCall.js");
var $reflectApply = __webpack_require__("../node_modules/call-bind-apply-helpers/reflectApply.js");

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);



/***/ }),

/***/ "../node_modules/call-bind-apply-helpers/applyBind.js":
/***/ (function(module, exports, __webpack_require__) {



var bind = __webpack_require__("../node_modules/function-bind/index.js");
var $apply = __webpack_require__("../node_modules/call-bind-apply-helpers/functionApply.js");
var actualApply = __webpack_require__("../node_modules/call-bind-apply-helpers/actualApply.js");

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};



/***/ }),

/***/ "../node_modules/call-bind-apply-helpers/functionApply.js":
/***/ (function(module, exports) {



/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;



/***/ }),

/***/ "../node_modules/call-bind-apply-helpers/functionCall.js":
/***/ (function(module, exports) {



/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;



/***/ }),

/***/ "../node_modules/call-bind-apply-helpers/index.js":
/***/ (function(module, exports, __webpack_require__) {



var bind = __webpack_require__("../node_modules/function-bind/index.js");
var $TypeError = __webpack_require__("../node_modules/es-errors/type.js");

var $call = __webpack_require__("../node_modules/call-bind-apply-helpers/functionCall.js");
var $actualApply = __webpack_require__("../node_modules/call-bind-apply-helpers/actualApply.js");

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};



/***/ }),

/***/ "../node_modules/call-bind-apply-helpers/reflectApply.js":
/***/ (function(module, exports) {



/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;



/***/ }),

/***/ "../node_modules/call-bind/callBound.js":
/***/ (function(module, exports, __webpack_require__) {



var GetIntrinsic = __webpack_require__("../node_modules/get-intrinsic/index.js");

var callBind = __webpack_require__("../node_modules/call-bind/index.js");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};



/***/ }),

/***/ "../node_modules/call-bind/index.js":
/***/ (function(module, exports, __webpack_require__) {



var setFunctionLength = __webpack_require__("../node_modules/set-function-length/index.js");

var $defineProperty = __webpack_require__("../node_modules/es-define-property/index.js");

var callBindBasic = __webpack_require__("../node_modules/call-bind-apply-helpers/index.js");
var applyBind = __webpack_require__("../node_modules/call-bind-apply-helpers/applyBind.js");

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = originalFunction.length - (arguments.length - 1);
	return setFunctionLength(
		func,
		1 + (adjustedLength > 0 ? adjustedLength : 0),
		true
	);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}



/***/ }),

/***/ "../node_modules/core-js/fn/array/find.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.array.find.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.find;

/***/ }),

/***/ "../node_modules/core-js/fn/array/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.array.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.includes;

/***/ }),

/***/ "../node_modules/core-js/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.object.assign.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.assign;

/***/ }),

/***/ "../node_modules/core-js/fn/object/entries.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.entries.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.entries;

/***/ }),

/***/ "../node_modules/core-js/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.values.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.values;

/***/ }),

/***/ "../node_modules/core-js/fn/string/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.string.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").String.includes;

/***/ }),

/***/ "../node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {



module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {



// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("../node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {



// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {



// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return val; // find
              case 6:
                return index; // findIndex
              case 2:
                result.push(val); // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }return C === undefined ? Array : C;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {



// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {



var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {



var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {



// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {



// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {



// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "../node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {



// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "../node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),

/***/ "../node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }return true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {



module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "../node_modules/core-js/modules/_function-to-string.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__("../node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);

/***/ }),

/***/ "../node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {



// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {



var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {



var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = !__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),

/***/ "../node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {



module.exports = false;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {


// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {



var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-gops.js":
/***/ (function(module, exports) {



exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {



var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {



exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {



var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {



module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("../node_modules/core-js/modules/_uid.js")('src');
var $toString = __webpack_require__("../node_modules/core-js/modules/_function-to-string.js");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("../node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),

/***/ "../node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {



var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {



var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("../node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "../node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {



// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {



var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {



// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "../node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {



var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {



var store = __webpack_require__("../node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var _Symbol = __webpack_require__("../node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {


// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);

/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("../node_modules/core-js/modules/_object-assign.js") });

/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {


// https://github.com/tc39/Array.prototype.includes

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('includes');

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),

/***/ "../node_modules/credit-card-type/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var cardTypes = __webpack_require__("../node_modules/credit-card-type/dist/lib/card-types.js");
var add_matching_cards_to_results_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/add-matching-cards-to-results.js");
var is_valid_input_type_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/is-valid-input-type.js");
var find_best_match_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/find-best-match.js");
var clone_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/clone.js");
var customCards = {};
var cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard"
};
var ORIGINAL_TEST_ORDER = [cardNames.VISA, cardNames.MASTERCARD, cardNames.AMERICAN_EXPRESS, cardNames.DINERS_CLUB, cardNames.DISCOVER, cardNames.JCB, cardNames.UNIONPAY, cardNames.MAESTRO, cardNames.ELO, cardNames.MIR, cardNames.HIPER, cardNames.HIPERCARD];
var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
function findType(cardType) {
    return customCards[cardType] || cardTypes[cardType];
}
function getAllCardTypes() {
    return testOrder.map(function (cardType) {
        return clone_1.clone(findType(cardType));
    });
}
function getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) {
        ignoreErrorForNotExisting = false;
    }
    var position = testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) {
        throw new Error('"' + name + '" is not a supported card type.');
    }
    return position;
}
function creditCardType(cardNumber) {
    var results = [];
    if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
        return results;
    }
    if (cardNumber.length === 0) {
        return getAllCardTypes();
    }
    testOrder.forEach(function (cardType) {
        var cardConfiguration = findType(cardType);
        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    var bestMatch = find_best_match_1.findBestMatch(results);
    if (bestMatch) {
        return [bestMatch];
    }
    return results;
}
creditCardType.getTypeInfo = function (cardType) {
    return clone_1.clone(findType(cardType));
};
creditCardType.removeCard = function (name) {
    var position = getCardPosition(name);
    testOrder.splice(position, 1);
};
creditCardType.addCard = function (config) {
    var existingCardPosition = getCardPosition(config.type, true);
    customCards[config.type] = config;
    if (existingCardPosition === -1) {
        testOrder.push(config.type);
    }
};
creditCardType.updateCard = function (cardType, updates) {
    var originalObject = customCards[cardType] || cardTypes[cardType];
    if (!originalObject) {
        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
    }
    if (updates.type && originalObject.type !== updates.type) {
        throw new Error("Cannot overwrite type parameter.");
    }
    var clonedCard = clone_1.clone(originalObject);
    clonedCard = __assign(__assign({}, clonedCard), updates);
    customCards[clonedCard.type] = clonedCard;
};
creditCardType.changeOrder = function (name, position) {
    var currentPosition = getCardPosition(name);
    testOrder.splice(currentPosition, 1);
    testOrder.splice(position, 0, name);
};
creditCardType.resetModifications = function () {
    testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
    customCards = {};
};
creditCardType.types = cardNames;
module.exports = creditCardType;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/add-matching-cards-to-results.js":
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", { value: true });
exports.addMatchingCardsToResults = void 0;
var clone_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/clone.js");
var matches_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/matches.js");
function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for (i = 0; i < cardConfiguration.patterns.length; i++) {
        var pattern = cardConfiguration.patterns[i];
        if (!matches_1.matches(cardNumber, pattern)) {
            continue;
        }
        var clonedCardConfiguration = clone_1.clone(cardConfiguration);
        if (Array.isArray(pattern)) {
            patternLength = String(pattern[0]).length;
        } else {
            patternLength = String(pattern).length;
        }
        if (cardNumber.length >= patternLength) {
            clonedCardConfiguration.matchStrength = patternLength;
        }
        results.push(clonedCardConfiguration);
        break;
    }
}
exports.addMatchingCardsToResults = addMatchingCardsToResults;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/card-types.js":
/***/ (function(module, exports) {



var cardTypes = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [4],
        gaps: [4, 8, 12],
        lengths: [16, 18, 19],
        code: {
            name: "CVV",
            size: 3
        }
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3
        }
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [34, 37],
        gaps: [4, 10],
        lengths: [15],
        code: {
            name: "CID",
            size: 4
        }
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [[300, 305], 36, 38, 39],
        gaps: [4, 10],
        lengths: [14, 16, 19],
        code: {
            name: "CVV",
            size: 3
        }
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [6011, [644, 649], 65],
        gaps: [4, 8, 12],
        lengths: [16, 19],
        code: {
            name: "CID",
            size: 3
        }
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [2131, 1800, [3528, 3589]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVV",
            size: 3
        }
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [620, [624, 626], [62100, 62182], [62184, 62187], [62185, 62197], [62200, 62205], [622010, 622999], 622018, [622019, 622999], [62207, 62209], [622126, 622925], [623, 626], 6270, 6272, 6276, [627700, 627779], [627781, 627799], [6282, 6289], 6291, 6292, 810, [8110, 8131], [8132, 8151], [8152, 8163], [8164, 8171]],
        gaps: [4, 8, 12],
        lengths: [14, 15, 16, 17, 18, 19],
        code: {
            name: "CVN",
            size: 3
        }
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [493698, [500000, 504174], [504176, 506698], [506779, 508999], [56, 59], 63, 67, 6],
        gaps: [4, 8, 12],
        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
        code: {
            name: "CVC",
            size: 3
        }
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [401178, 401179, 438935, 457631, 457632, 431274, 451416, 457393, 504175, [506699, 506778], [509000, 509999], 627780, 636297, 636368, [650031, 650033], [650035, 650051], [650405, 650439], [650485, 650538], [650541, 650598], [650700, 650718], [650720, 650727], [650901, 650978], [651652, 651679], [655000, 655019], [655021, 655058]],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVE",
            size: 3
        }
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [[2200, 2204]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVP2",
            size: 3
        }
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3
        }
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [606282],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3
        }
    }
};
module.exports = cardTypes;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/clone.js":
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", { value: true });
exports.clone = void 0;
function clone(originalObject) {
    if (!originalObject) {
        return null;
    }
    return JSON.parse(JSON.stringify(originalObject));
}
exports.clone = clone;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/find-best-match.js":
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", { value: true });
exports.findBestMatch = void 0;
function hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
        return result.matchStrength;
    }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */
    return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
}
function findBestMatch(results) {
    if (!hasEnoughResultsToDetermineBestMatch(results)) {
        return null;
    }
    return results.reduce(function (bestMatch, result) {
        if (!bestMatch) {
            return result;
        }
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */
        if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
            return result;
        }
        return bestMatch;
    });
}
exports.findBestMatch = findBestMatch;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/is-valid-input-type.js":
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInputType = void 0;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
exports.isValidInputType = isValidInputType;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/matches.js":
/***/ (function(module, exports) {


/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */

Object.defineProperty(exports, "__esModule", { value: true });
exports.matches = void 0;
function matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}
function matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}
function matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) {
        return matchesRange(cardNumber, pattern[0], pattern[1]);
    }
    return matchesPattern(cardNumber, pattern);
}
exports.matches = matches;

/***/ }),

/***/ "../node_modules/define-data-property/index.js":
/***/ (function(module, exports, __webpack_require__) {



var $defineProperty = __webpack_require__("../node_modules/es-define-property/index.js");

var $SyntaxError = __webpack_require__("../node_modules/es-errors/syntax.js");
var $TypeError = __webpack_require__("../node_modules/es-errors/type.js");

var gopd = __webpack_require__("../node_modules/gopd/index.js");

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};



/***/ }),

/***/ "../node_modules/dunder-proto/get.js":
/***/ (function(module, exports, __webpack_require__) {



var callBind = __webpack_require__("../node_modules/call-bind-apply-helpers/index.js");
var gOPD = __webpack_require__("../node_modules/gopd/index.js");

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;



/***/ }),

/***/ "../node_modules/es-define-property/index.js":
/***/ (function(module, exports) {



/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;



/***/ }),

/***/ "../node_modules/es-errors/eval.js":
/***/ (function(module, exports) {



/** @type {import('./eval')} */
module.exports = EvalError;



/***/ }),

/***/ "../node_modules/es-errors/index.js":
/***/ (function(module, exports) {



/** @type {import('.')} */
module.exports = Error;



/***/ }),

/***/ "../node_modules/es-errors/range.js":
/***/ (function(module, exports) {



/** @type {import('./range')} */
module.exports = RangeError;



/***/ }),

/***/ "../node_modules/es-errors/ref.js":
/***/ (function(module, exports) {



/** @type {import('./ref')} */
module.exports = ReferenceError;



/***/ }),

/***/ "../node_modules/es-errors/syntax.js":
/***/ (function(module, exports) {



/** @type {import('./syntax')} */
module.exports = SyntaxError;



/***/ }),

/***/ "../node_modules/es-errors/type.js":
/***/ (function(module, exports) {



/** @type {import('./type')} */
module.exports = TypeError;



/***/ }),

/***/ "../node_modules/es-errors/uri.js":
/***/ (function(module, exports) {



/** @type {import('./uri')} */
module.exports = URIError;



/***/ }),

/***/ "../node_modules/es-object-atoms/index.js":
/***/ (function(module, exports) {



/** @type {import('.')} */
module.exports = Object;



/***/ }),

/***/ "../node_modules/function-bind/implementation.js":
/***/ (function(module, exports) {



/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};



/***/ }),

/***/ "../node_modules/function-bind/index.js":
/***/ (function(module, exports, __webpack_require__) {



var implementation = __webpack_require__("../node_modules/function-bind/implementation.js");

module.exports = Function.prototype.bind || implementation;



/***/ }),

/***/ "../node_modules/get-intrinsic/index.js":
/***/ (function(module, exports, __webpack_require__) {



var undefined;

var $Object = __webpack_require__("../node_modules/es-object-atoms/index.js");

var $Error = __webpack_require__("../node_modules/es-errors/index.js");
var $EvalError = __webpack_require__("../node_modules/es-errors/eval.js");
var $RangeError = __webpack_require__("../node_modules/es-errors/range.js");
var $ReferenceError = __webpack_require__("../node_modules/es-errors/ref.js");
var $SyntaxError = __webpack_require__("../node_modules/es-errors/syntax.js");
var $TypeError = __webpack_require__("../node_modules/es-errors/type.js");
var $URIError = __webpack_require__("../node_modules/es-errors/uri.js");

var abs = __webpack_require__("../node_modules/math-intrinsics/abs.js");
var floor = __webpack_require__("../node_modules/math-intrinsics/floor.js");
var max = __webpack_require__("../node_modules/math-intrinsics/max.js");
var min = __webpack_require__("../node_modules/math-intrinsics/min.js");
var pow = __webpack_require__("../node_modules/math-intrinsics/pow.js");
var round = __webpack_require__("../node_modules/math-intrinsics/round.js");
var sign = __webpack_require__("../node_modules/math-intrinsics/sign.js");

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function(' return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__("../node_modules/gopd/index.js");
var $defineProperty = __webpack_require__("../node_modules/es-define-property/index.js");

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__("../node_modules/has-symbols/index.js")();

var getProto = __webpack_require__("../node_modules/get-proto/index.js");
var $ObjectGPO = __webpack_require__("../node_modules/get-proto/Object.getPrototypeOf.js");
var $ReflectGPO = __webpack_require__("../node_modules/get-proto/Reflect.getPrototypeOf.js");

var $apply = __webpack_require__("../node_modules/call-bind-apply-helpers/functionApply.js");
var $call = __webpack_require__("../node_modules/call-bind-apply-helpers/functionCall.js");

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__("../node_modules/function-bind/index.js");
var hasOwn = __webpack_require__("../node_modules/hasown/index.js");
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};



/***/ }),

/***/ "../node_modules/get-proto/Object.getPrototypeOf.js":
/***/ (function(module, exports, __webpack_require__) {



var $Object = __webpack_require__("../node_modules/es-object-atoms/index.js");

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;



/***/ }),

/***/ "../node_modules/get-proto/Reflect.getPrototypeOf.js":
/***/ (function(module, exports) {



/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;



/***/ }),

/***/ "../node_modules/get-proto/index.js":
/***/ (function(module, exports, __webpack_require__) {



var reflectGetProto = __webpack_require__("../node_modules/get-proto/Reflect.getPrototypeOf.js");
var originalGetProto = __webpack_require__("../node_modules/get-proto/Object.getPrototypeOf.js");

var getDunderProto = __webpack_require__("../node_modules/dunder-proto/get.js");

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;



/***/ }),

/***/ "../node_modules/gopd/gOPD.js":
/***/ (function(module, exports) {



/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



/***/ }),

/***/ "../node_modules/gopd/index.js":
/***/ (function(module, exports, __webpack_require__) {



/** @type {import('.')} */
var $gOPD = __webpack_require__("../node_modules/gopd/gOPD.js");

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;



/***/ }),

/***/ "../node_modules/has-property-descriptors/index.js":
/***/ (function(module, exports, __webpack_require__) {



var $defineProperty = __webpack_require__("../node_modules/es-define-property/index.js");

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;



/***/ }),

/***/ "../node_modules/has-symbols/index.js":
/***/ (function(module, exports, __webpack_require__) {



var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__("../node_modules/has-symbols/shams.js");

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};



/***/ }),

/***/ "../node_modules/has-symbols/shams.js":
/***/ (function(module, exports) {



/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};



/***/ }),

/***/ "../node_modules/hasown/index.js":
/***/ (function(module, exports, __webpack_require__) {



var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__("../node_modules/function-bind/index.js");

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);



/***/ }),

/***/ "../node_modules/lodash/lodash.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js"), __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../node_modules/math-intrinsics/abs.js":
/***/ (function(module, exports) {



/** @type {import('./abs')} */
module.exports = Math.abs;



/***/ }),

/***/ "../node_modules/math-intrinsics/floor.js":
/***/ (function(module, exports) {



/** @type {import('./floor')} */
module.exports = Math.floor;



/***/ }),

/***/ "../node_modules/math-intrinsics/isNaN.js":
/***/ (function(module, exports) {



/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



/***/ }),

/***/ "../node_modules/math-intrinsics/max.js":
/***/ (function(module, exports) {



/** @type {import('./max')} */
module.exports = Math.max;



/***/ }),

/***/ "../node_modules/math-intrinsics/min.js":
/***/ (function(module, exports) {



/** @type {import('./min')} */
module.exports = Math.min;



/***/ }),

/***/ "../node_modules/math-intrinsics/pow.js":
/***/ (function(module, exports) {



/** @type {import('./pow')} */
module.exports = Math.pow;



/***/ }),

/***/ "../node_modules/math-intrinsics/round.js":
/***/ (function(module, exports) {



/** @type {import('./round')} */
module.exports = Math.round;



/***/ }),

/***/ "../node_modules/math-intrinsics/sign.js":
/***/ (function(module, exports, __webpack_require__) {



var $isNaN = __webpack_require__("../node_modules/math-intrinsics/isNaN.js");

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};



/***/ }),

/***/ "../node_modules/node-uuid/uuid.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_RESULT__;//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

/*global window, require, define */
(function(_window) {
  

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;

  function setupBrowser() {
    // Allow for MSIE11 msCrypto
    var _crypto = _window.crypto || _window.msCrypto;

    if (!_rng && _crypto && _crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      //
      // Moderately fast, high quality
      try {
        var _rnds8 = new Uint8Array(16);
        _whatwgRNG = _rng = function whatwgRNG() {
          _crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
        _rng();
      } catch(e) {}
    }

    if (!_rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var  _rnds = new Array(16);
      _mathRNG = _rng = function() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return _rnds;
      };
      if ('undefined' !== typeof console && console.warn) {
        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
      }
    }
  }

  function setupNode() {
    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
    //
    // Moderately fast, high quality
    if (true) {
      try {
        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
        _nodeRNG = _rng = _rb && function() {return _rb(16);};
        _rng();
      } catch(e) {}
    }
  }

  if (_window) {
    setupBrowser();
  } else {
    setupNode();
  }

  // Buffer class to use
  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) === 'string') {
      buf = (options === 'binary') ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;
  uuid._rng = _rng;
  uuid._mathRNG = _mathRNG;
  uuid._nodeRNG = _nodeRNG;
  uuid._whatwgRNG = _whatwgRNG;

  if (('undefined' !== typeof module) && module.exports) {
    // Publish as node.js module
    module.exports = uuid;
  } else if (true) {
    // Publish as AMD module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {return uuid;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


  } else {
    // Publish as global (in browsers)
    _previousRoot = _window.uuid;

    // **`noConflict()` - (browser only) to reset global 'uuid' var**
    uuid.noConflict = function() {
      _window.uuid = _previousRoot;
      return uuid;
    };

    _window.uuid = uuid;
  }
})('undefined' !== typeof window ? window : null);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-credit-components/src/choose-credit-offer/faq/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"faq\">\n    <div class=\"clearfix\">\n        <a id=\"toggleAll\" class=\"hideAll\" ng-click=\"actions.toggleAllFAQ()\">{{toggleText}}</a>\n        <h2 class=\"beta\" id=\"title\">{{content('FAQ.title')}}</h2>\n    </div>\n    <ul>\n        <li ng-class=\"{ expanded:faqExtended[0], collapsed:!faqExtended[0], faqContent:true}\">\n            <div class='action' ng-click=\"actions.toggleFAQ(0)\">\n                <span ng-class=\"{ plus:!faqExtended[0], minus:faqExtended[0], faqAction:true}\"></span>\n                <p class=\"gamma\">{{content('FAQ.question1')}}</p>\n            </div>\n            <div class=\"answer secondary longerAnswer\">\n                <span class='action' ng-bind-html=\"htmlContent('FAQ.answer1')\"></span>\n                <div class=\"amortizationTableDEContainer\">\n                    <table class=\"amortizationTableDE\">\n                        <tbody>\n                            <tr class=\"amortizationHeader lastRow\">\n                                <th/>\n                                <th>{{content('FAQ.month')}}</th>\n                                <th>{{content('FAQ.amountBefore')}}</th>\n                                <th>{{content('FAQ.installment')}}</th>\n                                <th>{{content('FAQ.interest')}}</th>\n                                <th>{{content('FAQ.repayment')}}</th>\n                                <th>{{content('FAQ.amountAfter')}}</th>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td class=\"firstColumn\" rowspan=\"6\">\n                                    <p class=\"firstRow\" ng-bind-html=\"htmlContent('FAQ.examplePurchaseAmount1')\" />\n                                    <p ng-bind-html=\"htmlContent('FAQ.exampleAPR1')\" />\n                                </td>\n                                <td> 1 </td>\n                                <td> 389,00 </td>\n                                <td> 66,66 </td>\n                                <td> 3,10 </td>\n                                <td> 63,56 </td>\n                                <td> 325,44 </td>\n\n                            </tr>\n                             <tr class=\"amortizationContent\">\n\n                                <td> 2 </td>\n                                <td> 325,44 </td>\n                                <td> 66,66 </td>\n                                <td> 2,59 </td>\n                                <td> 64,07 </td>\n                                <td> 261,37 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                <td> 3 </td>\n                                <td> 261,37 </td>\n                                <td> 66,66 </td>\n                                <td> 2,08 </td>\n                                <td> 64,58 </td>\n                                <td> 196,79 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                <td> 4 </td>\n                                <td> 196,79 </td>\n                                <td> 66,66 </td>\n                                <td> 1,57 </td>\n                                <td> 65,09 </td>\n                                <td> 131,70 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                 <td> 5 </td>\n                                <td> 131,70 </td>\n                                <td> 66,66 </td>\n                                <td> 1,05 </td>\n                                <td> 65,61 </td>\n                                <td> 66,09 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent lastRow\">\n                                <td> 6 </td>\n                                <td> 66,09 </td>\n                                <td> 66,62 </td>\n                                <td> 0,53 </td>\n                                <td> 66,09 </td>\n                                <td> 0,00 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td class=\"firstColumn endOfTable\" rowspan=\"12\">\n                                    <p class=\"firstRow\" ng-bind-html=\"htmlContent('FAQ.examplePurchaseAmount2')\" />\n                                    <p class=\"firstRow\" ng-bind-html=\"htmlContent('FAQ.exampleInstallmentTerm2')\" />\n                                    <p ng-bind-html=\"htmlContent('FAQ.exampleAPR2')\" />\n                                </td>\n                                <td> 1 </td>\n                                <td> 699,00 </td>\n                                <td> 60,72 </td>\n                                <td> 4,49 </td>\n                                <td> 56,23 </td>\n                                <td> 642,77 </td>\n\n                            </tr>\n                             <tr class=\"amortizationContent\">\n                                <td> 2 </td>\n                                <td> 642,77 </td>\n                                <td> 60,72 </td>\n                                <td> 4,13 </td>\n                                <td> 56,59 </td>\n                                <td> 586,18 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 3 </td>\n                                <td> 586,18 </td>\n                                <td> 60,72 </td>\n                                <td> 3,77 </td>\n                                <td> 56,95 </td>\n                                <td> 529,23 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 4 </td>\n                                <td> 529,23 </td>\n                                <td> 60,72 </td>\n                                <td> 3,40 </td>\n                                <td> 57,32 </td>\n                                <td>  471,91</td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                 <td> 5 </td>\n                                <td> 471,91 </td>\n                                <td> 60,72 </td>\n                                <td> 3,03 </td>\n                                <td> 57,69 </td>\n                                <td> 414,22 </td>\n\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 6 </td>\n                                <td> 414,22 </td>\n                                <td> 60,72 </td>\n                                <td> 2,56 </td>\n                                <td> 58,06 </td>\n                                <td> 356,16 </td>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 7 </td>\n                                <td> 356,16 </td>\n                                <td> 60,72 </td>\n                                <td> 2,29 </td>\n                                <td> 58,43 </td>\n                                <td> 297,73 </td>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 8 </td>\n                                <td> 297,73 </td>\n                                <td> 60,72 </td>\n                                <td> 1,91 </td>\n                                <td> 58,81 </td>\n                                <td> 238,92 </td>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n                                <td> 9 </td>\n                                <td> 238,92 </td>\n                                <td> 60,72 </td>\n                                <td> 1,54 </td>\n                                <td> 59,18 </td>\n                                <td> 179,74 </td>\n                            </tr>\n                            <tr class=\"amortizationContent\">\n\n                                <td> 10 </td>\n                                <td> 179,74 </td>\n                                <td> 60,72 </td>\n                                <td> 1,16 </td>\n                                <td> 59,56 </td>\n                                <td> 120,18 </td>\n                            </tr>\n                             <tr class=\"amortizationContent\">\n                                <td> 11 </td>\n                                <td> 120,18 </td>\n                                <td> 60,72 </td>\n                                <td> 0,77 </td>\n                                <td> 59,95 </td>\n                                <td> 60,23 </td>\n                            </tr>\n                             <tr class=\"amortizationContent\">\n                                <td class=\"endOfTable\"> 12 </td>\n                                <td class=\"endOfTable\"> 60,23 </td>\n                                <td class=\"endOfTable\"> 60,62 </td>\n                                <td class=\"endOfTable\"> 0,39 </td>\n                                <td class=\"endOfTable\"> 60,23 </td>\n                                <td class=\"endOfTable\"> 0,00 </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n\n            </div>\n        </li>\n             \n        <li ng-class=\"{ expanded:faqExtended[1], collapsed:!faqExtended[1], faqContent:true}\">\n            <div class='action' ng-click=\"actions.toggleFAQ(1)\">\n                <span ng-class=\"{ plus:!faqExtended[1], minus:faqExtended[1], faqAction:true}\"></span>\n                <p class=\"gamma\">{{content('FAQ.question3')}}</p>\n            </div>\n            <div class=\"answer secondary\">{{content('FAQ.answer3')}}</div>\n        </li>\n        <li ng-class=\"{ expanded:faqExtended[2], collapsed:!faqExtended[2], faqContent:true, last:true}\">\n            <div class='action' ng-click=\"actions.toggleFAQ(2)\">\n                <span ng-class=\"{ plus:!faqExtended[2], minus:faqExtended[2], faqAction:true}\"></span>\n                <p class=\"gamma\">{{content('FAQ.question4')}}</p>\n            </div>\n            <div class=\"answer secondary\">{{content('FAQ.answer4')}}</div>\n        </li>\n    </ul>\n</div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ (function(module, exports) {

module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ (function(module, exports) {

module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/generic-message/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n        <div class=\"returnButton\" ng-if=\"enableSuccessReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{returnButtonLabel}}\" ng-click=\"goToMerchant()\" ng-disabled=\"disableReturnToMerchantButton\"/>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"message.msgs || message.msgKeys\">\n    <div id=\"notifications\" role=\"alert\" aria-live=\"assertive\" content >\n        <div id=\"pageLevelErrors\" ng-class=\"[{'extendedMsg': isgreyheader}, 'msg-' + message.type, 'msgPage']\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs track by $index\">\n                    <span data-ng-bind-html=\"msg\" data-test-id=\"message\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys track by $index\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys, message.compileWith)\" data-test-id=\"message\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner-button/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"spinnerBtn\" content>\n    <button track-submit={{track}} ng-click=\"submit()\" class=\"btn full\">\n        <div ng-show=\"isProcessing\" ng-class=\"{processing: isProcessing}\" class=\"spinner\"></div>\n        <div ng-hide=\"isProcessing\" class=\"text\" ng-bind-html=\"htmlContent(buttonText)\"></div>\n    </button>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\" />\n        <p class=\"loader\" />\n        <p id=\"spinner-message\" tabIndex=\"0\" role=\"alert\" class=\"loadingMessage\">\n            {{ message }}\n        </p>\n        <p id=\"spinner-submessage\" tabIndex=\"0\" role=\"alert\" class=\"loadingSubHeading\" ng-if=\"subMessage\">\n            {{ subMessage }}\n        </p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/object-inspect/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(1);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/qs/lib/formats.js":
/***/ (function(module, exports) {



var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};



/***/ }),

/***/ "../node_modules/qs/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



var stringify = __webpack_require__("../node_modules/qs/lib/stringify.js");
var parse = __webpack_require__("../node_modules/qs/lib/parse.js");
var formats = __webpack_require__("../node_modules/qs/lib/formats.js");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};



/***/ }),

/***/ "../node_modules/qs/lib/parse.js":
/***/ (function(module, exports, __webpack_require__) {



var utils = __webpack_require__("../node_modules/qs/lib/utils.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};



/***/ }),

/***/ "../node_modules/qs/lib/stringify.js":
/***/ (function(module, exports, __webpack_require__) {



var getSideChannel = __webpack_require__("../node_modules/side-channel/index.js");
var utils = __webpack_require__("../node_modules/qs/lib/utils.js");
var formats = __webpack_require__("../node_modules/qs/lib/formats.js");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};



/***/ }),

/***/ "../node_modules/qs/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {



var formats = __webpack_require__("../node_modules/qs/lib/formats.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};



/***/ }),

/***/ "../node_modules/sanitize-caja/index.js":
/***/ (function(module, exports, __webpack_require__) {

var html_sanitize = __webpack_require__("../node_modules/sanitize-caja/sanitizer-bundle.js");

module.exports = function(_) {
    if (!_) return '';
    return html_sanitize(_, cleanUrl, cleanId);
};

// https://bugzilla.mozilla.org/show_bug.cgi?id=255107
function cleanUrl(url) {
    
    if (/^https?/.test(url.getScheme())) return url.toString();
    if (/^mailto?/.test(url.getScheme())) return url.toString();
    if ('data' == url.getScheme() && /^image/.test(url.getPath())) {
        return url.toString();
    }
}

function cleanId(id) { return id; }



/***/ }),

/***/ "../node_modules/sanitize-caja/sanitizer-bundle.js":
/***/ (function(module, exports, __webpack_require__) {


// Copyright (C) 2010 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview
 * Implements RFC 3986 for parsing/formatting URIs.
 *
 * @author mikesamuel@gmail.com
 * \@provides URI
 * \@overrides window
 */

var URI = (function () {

/**
 * creates a uri from the string form.  The parser is relaxed, so special
 * characters that aren't escaped but don't cause ambiguities will not cause
 * parse failures.
 *
 * @return {URI|null}
 */
function parse(uriStr) {
  var m = ('' + uriStr).match(URI_RE_);
  if (!m) { return null; }
  return new URI(
      nullIfAbsent(m[1]),
      nullIfAbsent(m[2]),
      nullIfAbsent(m[3]),
      nullIfAbsent(m[4]),
      nullIfAbsent(m[5]),
      nullIfAbsent(m[6]),
      nullIfAbsent(m[7]));
}


/**
 * creates a uri from the given parts.
 *
 * @param scheme {string} an unencoded scheme such as "http" or null
 * @param credentials {string} unencoded user credentials or null
 * @param domain {string} an unencoded domain name or null
 * @param port {number} a port number in [1, 32768].
 *    -1 indicates no port, as does null.
 * @param path {string} an unencoded path
 * @param query {Array.<string>|string|null} a list of unencoded cgi
 *   parameters where even values are keys and odds the corresponding values
 *   or an unencoded query.
 * @param fragment {string} an unencoded fragment without the "#" or null.
 * @return {URI}
 */
function create(scheme, credentials, domain, port, path, query, fragment) {
  var uri = new URI(
      encodeIfExists2(scheme, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_),
      encodeIfExists2(
          credentials, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_),
      encodeIfExists(domain),
      port > 0 ? port.toString() : null,
      encodeIfExists2(path, URI_DISALLOWED_IN_PATH_),
      null,
      encodeIfExists(fragment));
  if (query) {
    if ('string' === typeof query) {
      uri.setRawQuery(query.replace(/[^?&=0-9A-Za-z_\-~.%]/g, encodeOne));
    } else {
      uri.setAllParameters(query);
    }
  }
  return uri;
}
function encodeIfExists(unescapedPart) {
  if ('string' == typeof unescapedPart) {
    return encodeURIComponent(unescapedPart);
  }
  return null;
};
/**
 * if unescapedPart is non null, then escapes any characters in it that aren't
 * valid characters in a url and also escapes any special characters that
 * appear in extra.
 *
 * @param unescapedPart {string}
 * @param extra {RegExp} a character set of characters in [\01-\177].
 * @return {string|null} null iff unescapedPart == null.
 */
function encodeIfExists2(unescapedPart, extra) {
  if ('string' == typeof unescapedPart) {
    return encodeURI(unescapedPart).replace(extra, encodeOne);
  }
  return null;
};
/** converts a character in [\01-\177] to its url encoded equivalent. */
function encodeOne(ch) {
  var n = ch.charCodeAt(0);
  return '%' + '0123456789ABCDEF'.charAt((n >> 4) & 0xf) +
      '0123456789ABCDEF'.charAt(n & 0xf);
}

/**
 * {@updoc
 *  $ normPath('foo/./bar')
 *  # 'foo/bar'
 *  $ normPath('./foo')
 *  # 'foo'
 *  $ normPath('foo/.')
 *  # 'foo'
 *  $ normPath('foo//bar')
 *  # 'foo/bar'
 * }
 */
function normPath(path) {
  return path.replace(/(^|\/)\.(?:\/|$)/g, '$1').replace(/\/{2,}/g, '/');
}

var PARENT_DIRECTORY_HANDLER = new RegExp(
    ''
    // A path break
    + '(/|^)'
    // followed by a non .. path element
    // (cannot be . because normPath is used prior to this RegExp)
    + '(?:[^./][^/]*|\\.{2,}(?:[^./][^/]*)|\\.{3,}[^/]*)'
    // followed by .. followed by a path break.
    + '/\\.\\.(?:/|$)');

var PARENT_DIRECTORY_HANDLER_RE = new RegExp(PARENT_DIRECTORY_HANDLER);

var EXTRA_PARENT_PATHS_RE = /^(?:\.\.\/)*(?:\.\.$)?/;

/**
 * Normalizes its input path and collapses all . and .. sequences except for
 * .. sequences that would take it above the root of the current parent
 * directory.
 * {@updoc
 *  $ collapse_dots('foo/../bar')
 *  # 'bar'
 *  $ collapse_dots('foo/./bar')
 *  # 'foo/bar'
 *  $ collapse_dots('foo/../bar/./../../baz')
 *  # 'baz'
 *  $ collapse_dots('../foo')
 *  # '../foo'
 *  $ collapse_dots('../foo').replace(EXTRA_PARENT_PATHS_RE, '')
 *  # 'foo'
 * }
 */
function collapse_dots(path) {
  if (path === null) { return null; }
  var p = normPath(path);
  // Only /../ left to flatten
  var r = PARENT_DIRECTORY_HANDLER_RE;
  // We replace with $1 which matches a / before the .. because this
  // guarantees that:
  // (1) we have at most 1 / between the adjacent place,
  // (2) always have a slash if there is a preceding path section, and
  // (3) we never turn a relative path into an absolute path.
  for (var q; (q = p.replace(r, '$1')) != p; p = q) {};
  return p;
}

/**
 * resolves a relative url string to a base uri.
 * @return {URI}
 */
function resolve(baseUri, relativeUri) {
  // there are several kinds of relative urls:
  // 1. //foo - replaces everything from the domain on.  foo is a domain name
  // 2. foo - replaces the last part of the path, the whole query and fragment
  // 3. /foo - replaces the the path, the query and fragment
  // 4. ?foo - replace the query and fragment
  // 5. #foo - replace the fragment only

  var absoluteUri = baseUri.clone();
  // we satisfy these conditions by looking for the first part of relativeUri
  // that is not blank and applying defaults to the rest

  var overridden = relativeUri.hasScheme();

  if (overridden) {
    absoluteUri.setRawScheme(relativeUri.getRawScheme());
  } else {
    overridden = relativeUri.hasCredentials();
  }

  if (overridden) {
    absoluteUri.setRawCredentials(relativeUri.getRawCredentials());
  } else {
    overridden = relativeUri.hasDomain();
  }

  if (overridden) {
    absoluteUri.setRawDomain(relativeUri.getRawDomain());
  } else {
    overridden = relativeUri.hasPort();
  }

  var rawPath = relativeUri.getRawPath();
  var simplifiedPath = collapse_dots(rawPath);
  if (overridden) {
    absoluteUri.setPort(relativeUri.getPort());
    simplifiedPath = simplifiedPath
        && simplifiedPath.replace(EXTRA_PARENT_PATHS_RE, '');
  } else {
    overridden = !!rawPath;
    if (overridden) {
      // resolve path properly
      if (simplifiedPath.charCodeAt(0) !== 0x2f /* / */) {  // path is relative
        var absRawPath = collapse_dots(absoluteUri.getRawPath() || '')
            .replace(EXTRA_PARENT_PATHS_RE, '');
        var slash = absRawPath.lastIndexOf('/') + 1;
        simplifiedPath = collapse_dots(
            (slash ? absRawPath.substring(0, slash) : '')
            + collapse_dots(rawPath))
            .replace(EXTRA_PARENT_PATHS_RE, '');
      }
    } else {
      simplifiedPath = simplifiedPath
          && simplifiedPath.replace(EXTRA_PARENT_PATHS_RE, '');
      if (simplifiedPath !== rawPath) {
        absoluteUri.setRawPath(simplifiedPath);
      }
    }
  }

  if (overridden) {
    absoluteUri.setRawPath(simplifiedPath);
  } else {
    overridden = relativeUri.hasQuery();
  }

  if (overridden) {
    absoluteUri.setRawQuery(relativeUri.getRawQuery());
  } else {
    overridden = relativeUri.hasFragment();
  }

  if (overridden) {
    absoluteUri.setRawFragment(relativeUri.getRawFragment());
  }

  return absoluteUri;
}

/**
 * a mutable URI.
 *
 * This class contains setters and getters for the parts of the URI.
 * The <tt>getXYZ</tt>/<tt>setXYZ</tt> methods return the decoded part -- so
 * <code>uri.parse('/foo%20bar').getPath()</code> will return the decoded path,
 * <tt>/foo bar</tt>.
 *
 * <p>The raw versions of fields are available too.
 * <code>uri.parse('/foo%20bar').getRawPath()</code> will return the raw path,
 * <tt>/foo%20bar</tt>.  Use the raw setters with care, since
 * <code>URI::toString</code> is not guaranteed to return a valid url if a
 * raw setter was used.
 *
 * <p>All setters return <tt>this</tt> and so may be chained, a la
 * <code>uri.parse('/foo').setFragment('part').toString()</code>.
 *
 * <p>You should not use this constructor directly -- please prefer the factory
 * functions {@link uri.parse}, {@link uri.create}, {@link uri.resolve}
 * instead.</p>
 *
 * <p>The parameters are all raw (assumed to be properly escaped) parts, and
 * any (but not all) may be null.  Undefined is not allowed.</p>
 *
 * @constructor
 */
function URI(
    rawScheme,
    rawCredentials, rawDomain, port,
    rawPath, rawQuery, rawFragment) {
  this.scheme_ = rawScheme;
  this.credentials_ = rawCredentials;
  this.domain_ = rawDomain;
  this.port_ = port;
  this.path_ = rawPath;
  this.query_ = rawQuery;
  this.fragment_ = rawFragment;
  /**
   * @type {Array|null}
   */
  this.paramCache_ = null;
}

/** returns the string form of the url. */
URI.prototype.toString = function () {
  var out = [];
  if (null !== this.scheme_) { out.push(this.scheme_, ':'); }
  if (null !== this.domain_) {
    out.push('//');
    if (null !== this.credentials_) { out.push(this.credentials_, '@'); }
    out.push(this.domain_);
    if (null !== this.port_) { out.push(':', this.port_.toString()); }
  }
  if (null !== this.path_) { out.push(this.path_); }
  if (null !== this.query_) { out.push('?', this.query_); }
  if (null !== this.fragment_) { out.push('#', this.fragment_); }
  return out.join('');
};

URI.prototype.clone = function () {
  return new URI(this.scheme_, this.credentials_, this.domain_, this.port_,
                 this.path_, this.query_, this.fragment_);
};

URI.prototype.getScheme = function () {
  // HTML5 spec does not require the scheme to be lowercased but
  // all common browsers except Safari lowercase the scheme.
  return this.scheme_ && decodeURIComponent(this.scheme_).toLowerCase();
};
URI.prototype.getRawScheme = function () {
  return this.scheme_;
};
URI.prototype.setScheme = function (newScheme) {
  this.scheme_ = encodeIfExists2(
      newScheme, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_);
  return this;
};
URI.prototype.setRawScheme = function (newScheme) {
  this.scheme_ = newScheme ? newScheme : null;
  return this;
};
URI.prototype.hasScheme = function () {
  return null !== this.scheme_;
};


URI.prototype.getCredentials = function () {
  return this.credentials_ && decodeURIComponent(this.credentials_);
};
URI.prototype.getRawCredentials = function () {
  return this.credentials_;
};
URI.prototype.setCredentials = function (newCredentials) {
  this.credentials_ = encodeIfExists2(
      newCredentials, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_);

  return this;
};
URI.prototype.setRawCredentials = function (newCredentials) {
  this.credentials_ = newCredentials ? newCredentials : null;
  return this;
};
URI.prototype.hasCredentials = function () {
  return null !== this.credentials_;
};


URI.prototype.getDomain = function () {
  return this.domain_ && decodeURIComponent(this.domain_);
};
URI.prototype.getRawDomain = function () {
  return this.domain_;
};
URI.prototype.setDomain = function (newDomain) {
  return this.setRawDomain(newDomain && encodeURIComponent(newDomain));
};
URI.prototype.setRawDomain = function (newDomain) {
  this.domain_ = newDomain ? newDomain : null;
  // Maintain the invariant that paths must start with a slash when the URI
  // is not path-relative.
  return this.setRawPath(this.path_);
};
URI.prototype.hasDomain = function () {
  return null !== this.domain_;
};


URI.prototype.getPort = function () {
  return this.port_ && decodeURIComponent(this.port_);
};
URI.prototype.setPort = function (newPort) {
  if (newPort) {
    newPort = Number(newPort);
    if (newPort !== (newPort & 0xffff)) {
      throw new Error('Bad port number ' + newPort);
    }
    this.port_ = '' + newPort;
  } else {
    this.port_ = null;
  }
  return this;
};
URI.prototype.hasPort = function () {
  return null !== this.port_;
};


URI.prototype.getPath = function () {
  return this.path_ && decodeURIComponent(this.path_);
};
URI.prototype.getRawPath = function () {
  return this.path_;
};
URI.prototype.setPath = function (newPath) {
  return this.setRawPath(encodeIfExists2(newPath, URI_DISALLOWED_IN_PATH_));
};
URI.prototype.setRawPath = function (newPath) {
  if (newPath) {
    newPath = String(newPath);
    this.path_ = 
      // Paths must start with '/' unless this is a path-relative URL.
      (!this.domain_ || /^\//.test(newPath)) ? newPath : '/' + newPath;
  } else {
    this.path_ = null;
  }
  return this;
};
URI.prototype.hasPath = function () {
  return null !== this.path_;
};


URI.prototype.getQuery = function () {
  // From http://www.w3.org/Addressing/URL/4_URI_Recommentations.html
  // Within the query string, the plus sign is reserved as shorthand notation
  // for a space.
  return this.query_ && decodeURIComponent(this.query_).replace(/\+/g, ' ');
};
URI.prototype.getRawQuery = function () {
  return this.query_;
};
URI.prototype.setQuery = function (newQuery) {
  this.paramCache_ = null;
  this.query_ = encodeIfExists(newQuery);
  return this;
};
URI.prototype.setRawQuery = function (newQuery) {
  this.paramCache_ = null;
  this.query_ = newQuery ? newQuery : null;
  return this;
};
URI.prototype.hasQuery = function () {
  return null !== this.query_;
};

/**
 * sets the query given a list of strings of the form
 * [ key0, value0, key1, value1, ... ].
 *
 * <p><code>uri.setAllParameters(['a', 'b', 'c', 'd']).getQuery()</code>
 * will yield <code>'a=b&c=d'</code>.
 */
URI.prototype.setAllParameters = function (params) {
  if (typeof params === 'object') {
    if (!(params instanceof Array)
        && (params instanceof Object
            || Object.prototype.toString.call(params) !== '[object Array]')) {
      var newParams = [];
      var i = -1;
      for (var k in params) {
        var v = params[k];
        if ('string' === typeof v) {
          newParams[++i] = k;
          newParams[++i] = v;
        }
      }
      params = newParams;
    }
  }
  this.paramCache_ = null;
  var queryBuf = [];
  var separator = '';
  for (var j = 0; j < params.length;) {
    var k = params[j++];
    var v = params[j++];
    queryBuf.push(separator, encodeURIComponent(k.toString()));
    separator = '&';
    if (v) {
      queryBuf.push('=', encodeURIComponent(v.toString()));
    }
  }
  this.query_ = queryBuf.join('');
  return this;
};
URI.prototype.checkParameterCache_ = function () {
  if (!this.paramCache_) {
    var q = this.query_;
    if (!q) {
      this.paramCache_ = [];
    } else {
      var cgiParams = q.split(/[&\?]/);
      var out = [];
      var k = -1;
      for (var i = 0; i < cgiParams.length; ++i) {
        var m = cgiParams[i].match(/^([^=]*)(?:=(.*))?$/);
        // From http://www.w3.org/Addressing/URL/4_URI_Recommentations.html
        // Within the query string, the plus sign is reserved as shorthand
        // notation for a space.
        out[++k] = decodeURIComponent(m[1]).replace(/\+/g, ' ');
        out[++k] = decodeURIComponent(m[2] || '').replace(/\+/g, ' ');
      }
      this.paramCache_ = out;
    }
  }
};
/**
 * sets the values of the named cgi parameters.
 *
 * <p>So, <code>uri.parse('foo?a=b&c=d&e=f').setParameterValues('c', ['new'])
 * </code> yields <tt>foo?a=b&c=new&e=f</tt>.</p>
 *
 * @param key {string}
 * @param values {Array.<string>} the new values.  If values is a single string
 *   then it will be treated as the sole value.
 */
URI.prototype.setParameterValues = function (key, values) {
  // be nice and avoid subtle bugs where [] operator on string performs charAt
  // on some browsers and crashes on IE
  if (typeof values === 'string') {
    values = [ values ];
  }

  this.checkParameterCache_();
  var newValueIndex = 0;
  var pc = this.paramCache_;
  var params = [];
  for (var i = 0, k = 0; i < pc.length; i += 2) {
    if (key === pc[i]) {
      if (newValueIndex < values.length) {
        params.push(key, values[newValueIndex++]);
      }
    } else {
      params.push(pc[i], pc[i + 1]);
    }
  }
  while (newValueIndex < values.length) {
    params.push(key, values[newValueIndex++]);
  }
  this.setAllParameters(params);
  return this;
};
URI.prototype.removeParameter = function (key) {
  return this.setParameterValues(key, []);
};
/**
 * returns the parameters specified in the query part of the uri as a list of
 * keys and values like [ key0, value0, key1, value1, ... ].
 *
 * @return {Array.<string>}
 */
URI.prototype.getAllParameters = function () {
  this.checkParameterCache_();
  return this.paramCache_.slice(0, this.paramCache_.length);
};
/**
 * returns the value<b>s</b> for a given cgi parameter as a list of decoded
 * query parameter values.
 * @return {Array.<string>}
 */
URI.prototype.getParameterValues = function (paramNameUnescaped) {
  this.checkParameterCache_();
  var values = [];
  for (var i = 0; i < this.paramCache_.length; i += 2) {
    if (paramNameUnescaped === this.paramCache_[i]) {
      values.push(this.paramCache_[i + 1]);
    }
  }
  return values;
};
/**
 * returns a map of cgi parameter names to (non-empty) lists of values.
 * @return {Object.<string,Array.<string>>}
 */
URI.prototype.getParameterMap = function (paramNameUnescaped) {
  this.checkParameterCache_();
  var paramMap = {};
  for (var i = 0; i < this.paramCache_.length; i += 2) {
    var key = this.paramCache_[i++],
      value = this.paramCache_[i++];
    if (!(key in paramMap)) {
      paramMap[key] = [value];
    } else {
      paramMap[key].push(value);
    }
  }
  return paramMap;
};
/**
 * returns the first value for a given cgi parameter or null if the given
 * parameter name does not appear in the query string.
 * If the given parameter name does appear, but has no '<tt>=</tt>' following
 * it, then the empty string will be returned.
 * @return {string|null}
 */
URI.prototype.getParameterValue = function (paramNameUnescaped) {
  this.checkParameterCache_();
  for (var i = 0; i < this.paramCache_.length; i += 2) {
    if (paramNameUnescaped === this.paramCache_[i]) {
      return this.paramCache_[i + 1];
    }
  }
  return null;
};

URI.prototype.getFragment = function () {
  return this.fragment_ && decodeURIComponent(this.fragment_);
};
URI.prototype.getRawFragment = function () {
  return this.fragment_;
};
URI.prototype.setFragment = function (newFragment) {
  this.fragment_ = newFragment ? encodeURIComponent(newFragment) : null;
  return this;
};
URI.prototype.setRawFragment = function (newFragment) {
  this.fragment_ = newFragment ? newFragment : null;
  return this;
};
URI.prototype.hasFragment = function () {
  return null !== this.fragment_;
};

function nullIfAbsent(matchPart) {
  return ('string' == typeof matchPart) && (matchPart.length > 0)
         ? matchPart
         : null;
}




/**
 * a regular expression for breaking a URI into its component parts.
 *
 * <p>http://www.gbiv.com/protocols/uri/rfc/rfc3986.html#RFC2234 says
 * As the "first-match-wins" algorithm is identical to the "greedy"
 * disambiguation method used by POSIX regular expressions, it is natural and
 * commonplace to use a regular expression for parsing the potential five
 * components of a URI reference.
 *
 * <p>The following line is the regular expression for breaking-down a
 * well-formed URI reference into its components.
 *
 * <pre>
 * ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
 *  12            3  4          5       6  7        8 9
 * </pre>
 *
 * <p>The numbers in the second line above are only to assist readability; they
 * indicate the reference points for each subexpression (i.e., each paired
 * parenthesis). We refer to the value matched for subexpression <n> as $<n>.
 * For example, matching the above expression to
 * <pre>
 *     http://www.ics.uci.edu/pub/ietf/uri/#Related
 * </pre>
 * results in the following subexpression matches:
 * <pre>
 *    $1 = http:
 *    $2 = http
 *    $3 = //www.ics.uci.edu
 *    $4 = www.ics.uci.edu
 *    $5 = /pub/ietf/uri/
 *    $6 = <undefined>
 *    $7 = <undefined>
 *    $8 = #Related
 *    $9 = Related
 * </pre>
 * where <undefined> indicates that the component is not present, as is the
 * case for the query component in the above example. Therefore, we can
 * determine the value of the five components as
 * <pre>
 *    scheme    = $2
 *    authority = $4
 *    path      = $5
 *    query     = $7
 *    fragment  = $9
 * </pre>
 *
 * <p>msamuel: I have modified the regular expression slightly to expose the
 * credentials, domain, and port separately from the authority.
 * The modified version yields
 * <pre>
 *    $1 = http              scheme
 *    $2 = <undefined>       credentials -\
 *    $3 = www.ics.uci.edu   domain       | authority
 *    $4 = <undefined>       port        -/
 *    $5 = /pub/ietf/uri/    path
 *    $6 = <undefined>       query without ?
 *    $7 = Related           fragment without #
 * </pre>
 */
var URI_RE_ = new RegExp(
      "^" +
      "(?:" +
        "([^:/?#]+)" +         // scheme
      ":)?" +
      "(?://" +
        "(?:([^/?#]*)@)?" +    // credentials
        "([^/?#:@]*)" +        // domain
        "(?::([0-9]+))?" +     // port
      ")?" +
      "([^?#]+)?" +            // path
      "(?:\\?([^#]*))?" +      // query
      "(?:#(.*))?" +           // fragment
      "$"
      );

var URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_ = /[#\/\?@]/g;
var URI_DISALLOWED_IN_PATH_ = /[\#\?]/g;

URI.parse = parse;
URI.create = create;
URI.resolve = resolve;
URI.collapse_dots = collapse_dots;  // Visible for testing.

// lightweight string-based api for loadModuleMaker
URI.utils = {
  mimeTypeOf: function (uri) {
    var uriObj = parse(uri);
    if (/\.html$/.test(uriObj.getPath())) {
      return 'text/html';
    } else {
      return 'application/javascript';
    }
  },
  resolve: function (base, uri) {
    if (base) {
      return resolve(parse(base), parse(uri)).toString();
    } else {
      return '' + uri;
    }
  }
};


return URI;
})();

// Copyright Google Inc.
// Licensed under the Apache Licence Version 2.0
// Autogenerated at Mon Feb 25 13:05:42 EST 2013
// @overrides window
// @provides html4
var html4 = {};
html4.atype = {
  'NONE': 0,
  'URI': 1,
  'URI_FRAGMENT': 11,
  'SCRIPT': 2,
  'STYLE': 3,
  'HTML': 12,
  'ID': 4,
  'IDREF': 5,
  'IDREFS': 6,
  'GLOBAL_NAME': 7,
  'LOCAL_NAME': 8,
  'CLASSES': 9,
  'FRAME_TARGET': 10,
  'MEDIA_QUERY': 13
};
html4[ 'atype' ] = html4.atype;
html4.ATTRIBS = {
  '*::class': 9,
  '*::dir': 0,
  '*::draggable': 0,
  '*::hidden': 0,
  '*::id': 4,
  '*::inert': 0,
  '*::itemprop': 0,
  '*::itemref': 6,
  '*::itemscope': 0,
  '*::lang': 0,
  '*::onblur': 2,
  '*::onchange': 2,
  '*::onclick': 2,
  '*::ondblclick': 2,
  '*::onfocus': 2,
  '*::onkeydown': 2,
  '*::onkeypress': 2,
  '*::onkeyup': 2,
  '*::onload': 2,
  '*::onmousedown': 2,
  '*::onmousemove': 2,
  '*::onmouseout': 2,
  '*::onmouseover': 2,
  '*::onmouseup': 2,
  '*::onreset': 2,
  '*::onscroll': 2,
  '*::onselect': 2,
  '*::onsubmit': 2,
  '*::onunload': 2,
  '*::spellcheck': 0,
  '*::style': 3,
  '*::title': 0,
  '*::translate': 0,
  'a::accesskey': 0,
  'a::coords': 0,
  'a::href': 1,
  'a::hreflang': 0,
  'a::name': 7,
  'a::onblur': 2,
  'a::onfocus': 2,
  'a::shape': 0,
  'a::tabindex': 0,
  'a::target': 10,
  'a::type': 0,
  'area::accesskey': 0,
  'area::alt': 0,
  'area::coords': 0,
  'area::href': 1,
  'area::nohref': 0,
  'area::onblur': 2,
  'area::onfocus': 2,
  'area::shape': 0,
  'area::tabindex': 0,
  'area::target': 10,
  'audio::controls': 0,
  'audio::loop': 0,
  'audio::mediagroup': 5,
  'audio::muted': 0,
  'audio::preload': 0,
  'bdo::dir': 0,
  'blockquote::cite': 1,
  'br::clear': 0,
  'button::accesskey': 0,
  'button::disabled': 0,
  'button::name': 8,
  'button::onblur': 2,
  'button::onfocus': 2,
  'button::tabindex': 0,
  'button::type': 0,
  'button::value': 0,
  'canvas::height': 0,
  'canvas::width': 0,
  'caption::align': 0,
  'col::align': 0,
  'col::char': 0,
  'col::charoff': 0,
  'col::span': 0,
  'col::valign': 0,
  'col::width': 0,
  'colgroup::align': 0,
  'colgroup::char': 0,
  'colgroup::charoff': 0,
  'colgroup::span': 0,
  'colgroup::valign': 0,
  'colgroup::width': 0,
  'command::checked': 0,
  'command::command': 5,
  'command::disabled': 0,
  'command::icon': 1,
  'command::label': 0,
  'command::radiogroup': 0,
  'command::type': 0,
  'data::value': 0,
  'del::cite': 1,
  'del::datetime': 0,
  'details::open': 0,
  'dir::compact': 0,
  'div::align': 0,
  'dl::compact': 0,
  'fieldset::disabled': 0,
  'font::color': 0,
  'font::face': 0,
  'font::size': 0,
  'form::accept': 0,
  'form::action': 1,
  'form::autocomplete': 0,
  'form::enctype': 0,
  'form::method': 0,
  'form::name': 7,
  'form::novalidate': 0,
  'form::onreset': 2,
  'form::onsubmit': 2,
  'form::target': 10,
  'h1::align': 0,
  'h2::align': 0,
  'h3::align': 0,
  'h4::align': 0,
  'h5::align': 0,
  'h6::align': 0,
  'hr::align': 0,
  'hr::noshade': 0,
  'hr::size': 0,
  'hr::width': 0,
  'iframe::align': 0,
  'iframe::frameborder': 0,
  'iframe::height': 0,
  'iframe::marginheight': 0,
  'iframe::marginwidth': 0,
  'iframe::width': 0,
  'img::align': 0,
  'img::alt': 0,
  'img::border': 0,
  'img::height': 0,
  'img::hspace': 0,
  'img::ismap': 0,
  'img::name': 7,
  'img::src': 1,
  'img::usemap': 11,
  'img::vspace': 0,
  'img::width': 0,
  'input::accept': 0,
  'input::accesskey': 0,
  'input::align': 0,
  'input::alt': 0,
  'input::autocomplete': 0,
  'input::checked': 0,
  'input::disabled': 0,
  'input::inputmode': 0,
  'input::ismap': 0,
  'input::list': 5,
  'input::max': 0,
  'input::maxlength': 0,
  'input::min': 0,
  'input::multiple': 0,
  'input::name': 8,
  'input::onblur': 2,
  'input::onchange': 2,
  'input::onfocus': 2,
  'input::onselect': 2,
  'input::placeholder': 0,
  'input::readonly': 0,
  'input::required': 0,
  'input::size': 0,
  'input::src': 1,
  'input::step': 0,
  'input::tabindex': 0,
  'input::type': 0,
  'input::usemap': 11,
  'input::value': 0,
  'ins::cite': 1,
  'ins::datetime': 0,
  'label::accesskey': 0,
  'label::for': 5,
  'label::onblur': 2,
  'label::onfocus': 2,
  'legend::accesskey': 0,
  'legend::align': 0,
  'li::type': 0,
  'li::value': 0,
  'map::name': 7,
  'menu::compact': 0,
  'menu::label': 0,
  'menu::type': 0,
  'meter::high': 0,
  'meter::low': 0,
  'meter::max': 0,
  'meter::min': 0,
  'meter::value': 0,
  'ol::compact': 0,
  'ol::reversed': 0,
  'ol::start': 0,
  'ol::type': 0,
  'optgroup::disabled': 0,
  'optgroup::label': 0,
  'option::disabled': 0,
  'option::label': 0,
  'option::selected': 0,
  'option::value': 0,
  'output::for': 6,
  'output::name': 8,
  'p::align': 0,
  'pre::width': 0,
  'progress::max': 0,
  'progress::min': 0,
  'progress::value': 0,
  'q::cite': 1,
  'select::autocomplete': 0,
  'select::disabled': 0,
  'select::multiple': 0,
  'select::name': 8,
  'select::onblur': 2,
  'select::onchange': 2,
  'select::onfocus': 2,
  'select::required': 0,
  'select::size': 0,
  'select::tabindex': 0,
  'source::type': 0,
  'table::align': 0,
  'table::bgcolor': 0,
  'table::border': 0,
  'table::cellpadding': 0,
  'table::cellspacing': 0,
  'table::frame': 0,
  'table::rules': 0,
  'table::summary': 0,
  'table::width': 0,
  'tbody::align': 0,
  'tbody::char': 0,
  'tbody::charoff': 0,
  'tbody::valign': 0,
  'td::abbr': 0,
  'td::align': 0,
  'td::axis': 0,
  'td::bgcolor': 0,
  'td::char': 0,
  'td::charoff': 0,
  'td::colspan': 0,
  'td::headers': 6,
  'td::height': 0,
  'td::nowrap': 0,
  'td::rowspan': 0,
  'td::scope': 0,
  'td::valign': 0,
  'td::width': 0,
  'textarea::accesskey': 0,
  'textarea::autocomplete': 0,
  'textarea::cols': 0,
  'textarea::disabled': 0,
  'textarea::inputmode': 0,
  'textarea::name': 8,
  'textarea::onblur': 2,
  'textarea::onchange': 2,
  'textarea::onfocus': 2,
  'textarea::onselect': 2,
  'textarea::placeholder': 0,
  'textarea::readonly': 0,
  'textarea::required': 0,
  'textarea::rows': 0,
  'textarea::tabindex': 0,
  'textarea::wrap': 0,
  'tfoot::align': 0,
  'tfoot::char': 0,
  'tfoot::charoff': 0,
  'tfoot::valign': 0,
  'th::abbr': 0,
  'th::align': 0,
  'th::axis': 0,
  'th::bgcolor': 0,
  'th::char': 0,
  'th::charoff': 0,
  'th::colspan': 0,
  'th::headers': 6,
  'th::height': 0,
  'th::nowrap': 0,
  'th::rowspan': 0,
  'th::scope': 0,
  'th::valign': 0,
  'th::width': 0,
  'thead::align': 0,
  'thead::char': 0,
  'thead::charoff': 0,
  'thead::valign': 0,
  'tr::align': 0,
  'tr::bgcolor': 0,
  'tr::char': 0,
  'tr::charoff': 0,
  'tr::valign': 0,
  'track::default': 0,
  'track::kind': 0,
  'track::label': 0,
  'track::srclang': 0,
  'ul::compact': 0,
  'ul::type': 0,
  'video::controls': 0,
  'video::height': 0,
  'video::loop': 0,
  'video::mediagroup': 5,
  'video::muted': 0,
  'video::poster': 1,
  'video::preload': 0,
  'video::width': 0
};
html4[ 'ATTRIBS' ] = html4.ATTRIBS;
html4.eflags = {
  'OPTIONAL_ENDTAG': 1,
  'EMPTY': 2,
  'CDATA': 4,
  'RCDATA': 8,
  'UNSAFE': 16,
  'FOLDABLE': 32,
  'SCRIPT': 64,
  'STYLE': 128,
  'VIRTUALIZED': 256
};
html4[ 'eflags' ] = html4.eflags;
// these are bitmasks of the eflags above.
html4.ELEMENTS = {
  'a': 0,
  'abbr': 0,
  'acronym': 0,
  'address': 0,
  'applet': 272,
  'area': 2,
  'article': 0,
  'aside': 0,
  'audio': 0,
  'b': 0,
  'base': 274,
  'basefont': 274,
  'bdi': 0,
  'bdo': 0,
  'big': 0,
  'blockquote': 0,
  'body': 305,
  'br': 2,
  'button': 0,
  'canvas': 0,
  'caption': 0,
  'center': 0,
  'cite': 0,
  'code': 0,
  'col': 2,
  'colgroup': 1,
  'command': 2,
  'data': 0,
  'datalist': 0,
  'dd': 1,
  'del': 0,
  'details': 0,
  'dfn': 0,
  'dialog': 272,
  'dir': 0,
  'div': 0,
  'dl': 0,
  'dt': 1,
  'em': 0,
  'fieldset': 0,
  'figcaption': 0,
  'figure': 0,
  'font': 0,
  'footer': 0,
  'form': 0,
  'frame': 274,
  'frameset': 272,
  'h1': 0,
  'h2': 0,
  'h3': 0,
  'h4': 0,
  'h5': 0,
  'h6': 0,
  'head': 305,
  'header': 0,
  'hgroup': 0,
  'hr': 2,
  'html': 305,
  'i': 0,
  'iframe': 16,
  'img': 2,
  'input': 2,
  'ins': 0,
  'isindex': 274,
  'kbd': 0,
  'keygen': 274,
  'label': 0,
  'legend': 0,
  'li': 1,
  'link': 274,
  'map': 0,
  'mark': 0,
  'menu': 0,
  'meta': 274,
  'meter': 0,
  'nav': 0,
  'nobr': 0,
  'noembed': 276,
  'noframes': 276,
  'noscript': 276,
  'object': 272,
  'ol': 0,
  'optgroup': 0,
  'option': 1,
  'output': 0,
  'p': 1,
  'param': 274,
  'pre': 0,
  'progress': 0,
  'q': 0,
  's': 0,
  'samp': 0,
  'script': 84,
  'section': 0,
  'select': 0,
  'small': 0,
  'source': 2,
  'span': 0,
  'strike': 0,
  'strong': 0,
  'style': 148,
  'sub': 0,
  'summary': 0,
  'sup': 0,
  'table': 0,
  'tbody': 1,
  'td': 1,
  'textarea': 8,
  'tfoot': 1,
  'th': 1,
  'thead': 1,
  'time': 0,
  'title': 280,
  'tr': 1,
  'track': 2,
  'tt': 0,
  'u': 0,
  'ul': 0,
  'var': 0,
  'video': 0,
  'wbr': 2
};
html4[ 'ELEMENTS' ] = html4.ELEMENTS;
html4.ELEMENT_DOM_INTERFACES = {
  'a': 'HTMLAnchorElement',
  'abbr': 'HTMLElement',
  'acronym': 'HTMLElement',
  'address': 'HTMLElement',
  'applet': 'HTMLAppletElement',
  'area': 'HTMLAreaElement',
  'article': 'HTMLElement',
  'aside': 'HTMLElement',
  'audio': 'HTMLAudioElement',
  'b': 'HTMLElement',
  'base': 'HTMLBaseElement',
  'basefont': 'HTMLBaseFontElement',
  'bdi': 'HTMLElement',
  'bdo': 'HTMLElement',
  'big': 'HTMLElement',
  'blockquote': 'HTMLQuoteElement',
  'body': 'HTMLBodyElement',
  'br': 'HTMLBRElement',
  'button': 'HTMLButtonElement',
  'canvas': 'HTMLCanvasElement',
  'caption': 'HTMLTableCaptionElement',
  'center': 'HTMLElement',
  'cite': 'HTMLElement',
  'code': 'HTMLElement',
  'col': 'HTMLTableColElement',
  'colgroup': 'HTMLTableColElement',
  'command': 'HTMLCommandElement',
  'data': 'HTMLElement',
  'datalist': 'HTMLDataListElement',
  'dd': 'HTMLElement',
  'del': 'HTMLModElement',
  'details': 'HTMLDetailsElement',
  'dfn': 'HTMLElement',
  'dialog': 'HTMLDialogElement',
  'dir': 'HTMLDirectoryElement',
  'div': 'HTMLDivElement',
  'dl': 'HTMLDListElement',
  'dt': 'HTMLElement',
  'em': 'HTMLElement',
  'fieldset': 'HTMLFieldSetElement',
  'figcaption': 'HTMLElement',
  'figure': 'HTMLElement',
  'font': 'HTMLFontElement',
  'footer': 'HTMLElement',
  'form': 'HTMLFormElement',
  'frame': 'HTMLFrameElement',
  'frameset': 'HTMLFrameSetElement',
  'h1': 'HTMLHeadingElement',
  'h2': 'HTMLHeadingElement',
  'h3': 'HTMLHeadingElement',
  'h4': 'HTMLHeadingElement',
  'h5': 'HTMLHeadingElement',
  'h6': 'HTMLHeadingElement',
  'head': 'HTMLHeadElement',
  'header': 'HTMLElement',
  'hgroup': 'HTMLElement',
  'hr': 'HTMLHRElement',
  'html': 'HTMLHtmlElement',
  'i': 'HTMLElement',
  'iframe': 'HTMLIFrameElement',
  'img': 'HTMLImageElement',
  'input': 'HTMLInputElement',
  'ins': 'HTMLModElement',
  'isindex': 'HTMLUnknownElement',
  'kbd': 'HTMLElement',
  'keygen': 'HTMLKeygenElement',
  'label': 'HTMLLabelElement',
  'legend': 'HTMLLegendElement',
  'li': 'HTMLLIElement',
  'link': 'HTMLLinkElement',
  'map': 'HTMLMapElement',
  'mark': 'HTMLElement',
  'menu': 'HTMLMenuElement',
  'meta': 'HTMLMetaElement',
  'meter': 'HTMLMeterElement',
  'nav': 'HTMLElement',
  'nobr': 'HTMLElement',
  'noembed': 'HTMLElement',
  'noframes': 'HTMLElement',
  'noscript': 'HTMLElement',
  'object': 'HTMLObjectElement',
  'ol': 'HTMLOListElement',
  'optgroup': 'HTMLOptGroupElement',
  'option': 'HTMLOptionElement',
  'output': 'HTMLOutputElement',
  'p': 'HTMLParagraphElement',
  'param': 'HTMLParamElement',
  'pre': 'HTMLPreElement',
  'progress': 'HTMLProgressElement',
  'q': 'HTMLQuoteElement',
  's': 'HTMLElement',
  'samp': 'HTMLElement',
  'script': 'HTMLScriptElement',
  'section': 'HTMLElement',
  'select': 'HTMLSelectElement',
  'small': 'HTMLElement',
  'source': 'HTMLSourceElement',
  'span': 'HTMLSpanElement',
  'strike': 'HTMLElement',
  'strong': 'HTMLElement',
  'style': 'HTMLStyleElement',
  'sub': 'HTMLElement',
  'summary': 'HTMLElement',
  'sup': 'HTMLElement',
  'table': 'HTMLTableElement',
  'tbody': 'HTMLTableSectionElement',
  'td': 'HTMLTableDataCellElement',
  'textarea': 'HTMLTextAreaElement',
  'tfoot': 'HTMLTableSectionElement',
  'th': 'HTMLTableHeaderCellElement',
  'thead': 'HTMLTableSectionElement',
  'time': 'HTMLTimeElement',
  'title': 'HTMLTitleElement',
  'tr': 'HTMLTableRowElement',
  'track': 'HTMLTrackElement',
  'tt': 'HTMLElement',
  'u': 'HTMLElement',
  'ul': 'HTMLUListElement',
  'var': 'HTMLElement',
  'video': 'HTMLVideoElement',
  'wbr': 'HTMLElement'
};
html4[ 'ELEMENT_DOM_INTERFACES' ] = html4.ELEMENT_DOM_INTERFACES;
html4.ueffects = {
  'NOT_LOADED': 0,
  'SAME_DOCUMENT': 1,
  'NEW_DOCUMENT': 2
};
html4[ 'ueffects' ] = html4.ueffects;
html4.URIEFFECTS = {
  'a::href': 2,
  'area::href': 2,
  'blockquote::cite': 0,
  'command::icon': 1,
  'del::cite': 0,
  'form::action': 2,
  'img::src': 1,
  'input::src': 1,
  'ins::cite': 0,
  'q::cite': 0,
  'video::poster': 1
};
html4[ 'URIEFFECTS' ] = html4.URIEFFECTS;
html4.ltypes = {
  'UNSANDBOXED': 2,
  'SANDBOXED': 1,
  'DATA': 0
};
html4[ 'ltypes' ] = html4.ltypes;
html4.LOADERTYPES = {
  'a::href': 2,
  'area::href': 2,
  'blockquote::cite': 2,
  'command::icon': 1,
  'del::cite': 2,
  'form::action': 2,
  'img::src': 1,
  'input::src': 1,
  'ins::cite': 2,
  'q::cite': 2,
  'video::poster': 1
};
html4[ 'LOADERTYPES' ] = html4.LOADERTYPES;

// Copyright (C) 2006 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview
 * An HTML sanitizer that can satisfy a variety of security policies.
 *
 * <p>
 * The HTML sanitizer is built around a SAX parser and HTML element and
 * attributes schemas.
 *
 * If the cssparser is loaded, inline styles are sanitized using the
 * css property and value schemas.  Else they are remove during
 * sanitization.
 *
 * If it exists, uses parseCssDeclarations, sanitizeCssProperty,  cssSchema
 *
 * @author mikesamuel@gmail.com
 * @author jasvir@gmail.com
 * \@requires html4, URI
 * \@overrides window
 * \@provides html, html_sanitize
 */

// The Turkish i seems to be a non-issue, but abort in case it is.
if ('I'.toLowerCase() !== 'i') { throw 'I/i problem'; }

/**
 * \@namespace
 */
var html = (function(html4) {

  // For closure compiler
  var parseCssDeclarations, sanitizeCssProperty, cssSchema;
  if ('undefined' !== typeof window) {
    parseCssDeclarations = window['parseCssDeclarations'];
    sanitizeCssProperty = window['sanitizeCssProperty'];
    cssSchema = window['cssSchema'];
  }

  // The keys of this object must be 'quoted' or JSCompiler will mangle them!
  // This is a partial list -- lookupEntity() uses the host browser's parser
  // (when available) to implement full entity lookup.
  // Note that entities are in general case-sensitive; the uppercase ones are
  // explicitly defined by HTML5 (presumably as compatibility).
  var ENTITIES = {
    'lt': '<',
    'LT': '<',
    'gt': '>',
    'GT': '>',
    'amp': '&',
    'AMP': '&',
    'quot': '"',
    'apos': '\'',
    'nbsp': '\u00A0'
  };

  // Patterns for types of entity/character reference names.
  var decimalEscapeRe = /^#(\d+)$/;
  var hexEscapeRe = /^#x([0-9A-Fa-f]+)$/;
  // contains every entity per http://www.w3.org/TR/2011/WD-html5-20110113/named-character-references.html
  var safeEntityNameRe = /^[A-Za-z][A-za-z0-9]+$/;
  // Used as a hook to invoke the browser's entity parsing. <textarea> is used
  // because its content is parsed for entities but not tags.
  // TODO(kpreid): This retrieval is a kludge and leads to silent loss of
  // functionality if the document isn't available.
  var entityLookupElement =
      ('undefined' !== typeof window && window['document'])
          ? window['document'].createElement('textarea') : null;
  /**
   * Decodes an HTML entity.
   *
   * {\@updoc
   * $ lookupEntity('lt')
   * # '<'
   * $ lookupEntity('GT')
   * # '>'
   * $ lookupEntity('amp')
   * # '&'
   * $ lookupEntity('nbsp')
   * # '\xA0'
   * $ lookupEntity('apos')
   * # "'"
   * $ lookupEntity('quot')
   * # '"'
   * $ lookupEntity('#xa')
   * # '\n'
   * $ lookupEntity('#10')
   * # '\n'
   * $ lookupEntity('#x0a')
   * # '\n'
   * $ lookupEntity('#010')
   * # '\n'
   * $ lookupEntity('#x00A')
   * # '\n'
   * $ lookupEntity('Pi')      // Known failure
   * # '\u03A0'
   * $ lookupEntity('pi')      // Known failure
   * # '\u03C0'
   * }
   *
   * @param {string} name the content between the '&' and the ';'.
   * @return {string} a single unicode code-point as a string.
   */
  function lookupEntity(name) {
    // TODO: entity lookup as specified by HTML5 actually depends on the
    // presence of the ";".
    if (ENTITIES.hasOwnProperty(name)) { return ENTITIES[name]; }
    var m = name.match(decimalEscapeRe);
    if (m) {
      return String.fromCharCode(parseInt(m[1], 10));
    } else if (!!(m = name.match(hexEscapeRe))) {
      return String.fromCharCode(parseInt(m[1], 16));
    } else if (entityLookupElement && safeEntityNameRe.test(name)) {
      entityLookupElement.innerHTML = '&' + name + ';';
      var text = entityLookupElement.textContent;
      ENTITIES[name] = text;
      return text;
    } else {
      return '&' + name + ';';
    }
  }

  function decodeOneEntity(_, name) {
    return lookupEntity(name);
  }

  var nulRe = /\0/g;
  function stripNULs(s) {
    return s.replace(nulRe, '');
  }

  var ENTITY_RE_1 = /&(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/g;
  var ENTITY_RE_2 = /^(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/;
  /**
   * The plain text of a chunk of HTML CDATA which possibly containing.
   *
   * {\@updoc
   * $ unescapeEntities('')
   * # ''
   * $ unescapeEntities('hello World!')
   * # 'hello World!'
   * $ unescapeEntities('1 &lt; 2 &amp;&AMP; 4 &gt; 3&#10;')
   * # '1 < 2 && 4 > 3\n'
   * $ unescapeEntities('&lt;&lt <- unfinished entity&gt;')
   * # '<&lt <- unfinished entity>'
   * $ unescapeEntities('/foo?bar=baz&copy=true')  // & often unescaped in URLS
   * # '/foo?bar=baz&copy=true'
   * $ unescapeEntities('pi=&pi;&#x3c0;, Pi=&Pi;\u03A0') // FIXME: known failure
   * # 'pi=\u03C0\u03c0, Pi=\u03A0\u03A0'
   * }
   *
   * @param {string} s a chunk of HTML CDATA.  It must not start or end inside
   *     an HTML entity.
   */
  function unescapeEntities(s) {
    return s.replace(ENTITY_RE_1, decodeOneEntity);
  }

  var ampRe = /&/g;
  var looseAmpRe = /&([^a-z#]|#(?:[^0-9x]|x(?:[^0-9a-f]|$)|$)|$)/gi;
  var ltRe = /[<]/g;
  var gtRe = />/g;
  var quotRe = /\"/g;

  /**
   * Escapes HTML special characters in attribute values.
   *
   * {\@updoc
   * $ escapeAttrib('')
   * # ''
   * $ escapeAttrib('"<<&==&>>"')  // Do not just escape the first occurrence.
   * # '&#34;&lt;&lt;&amp;&#61;&#61;&amp;&gt;&gt;&#34;'
   * $ escapeAttrib('Hello <World>!')
   * # 'Hello &lt;World&gt;!'
   * }
   */
  function escapeAttrib(s) {
    return ('' + s).replace(ampRe, '&amp;').replace(ltRe, '&lt;')
        .replace(gtRe, '&gt;').replace(quotRe, '&#34;');
  }

  /**
   * Escape entities in RCDATA that can be escaped without changing the meaning.
   * {\@updoc
   * $ normalizeRCData('1 < 2 &&amp; 3 > 4 &amp;& 5 &lt; 7&8')
   * # '1 &lt; 2 &amp;&amp; 3 &gt; 4 &amp;&amp; 5 &lt; 7&amp;8'
   * }
   */
  function normalizeRCData(rcdata) {
    return rcdata
        .replace(looseAmpRe, '&amp;$1')
        .replace(ltRe, '&lt;')
        .replace(gtRe, '&gt;');
  }

  // TODO(felix8a): validate sanitizer regexs against the HTML5 grammar at
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/syntax.html
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html

  // We initially split input so that potentially meaningful characters
  // like '<' and '>' are separate tokens, using a fast dumb process that
  // ignores quoting.  Then we walk that token stream, and when we see a
  // '<' that's the start of a tag, we use ATTR_RE to extract tag
  // attributes from the next token.  That token will never have a '>'
  // character.  However, it might have an unbalanced quote character, and
  // when we see that, we combine additional tokens to balance the quote.

  var ATTR_RE = new RegExp(
    '^\\s*' +
    '([-.:\\w]+)' +             // 1 = Attribute name
    '(?:' + (
      '\\s*(=)\\s*' +           // 2 = Is there a value?
      '(' + (                   // 3 = Attribute value
        // TODO(felix8a): maybe use backref to match quotes
        '(\")[^\"]*(\"|$)' +    // 4, 5 = Double-quoted string
        '|' +
        '(\')[^\']*(\'|$)' +    // 6, 7 = Single-quoted string
        '|' +
        // Positive lookahead to prevent interpretation of
        // <foo a= b=c> as <foo a='b=c'>
        // TODO(felix8a): might be able to drop this case
        '(?=[a-z][-\\w]*\\s*=)' +
        '|' +
        // Unquoted value that isn't an attribute name
        // (since we didn't match the positive lookahead above)
        '[^\"\'\\s]*' ) +
      ')' ) +
    ')?',
    'i');

  // false on IE<=8, true on most other browsers
  var splitWillCapture = ('a,b'.split(/(,)/).length === 3);

  // bitmask for tags with special parsing, like <script> and <textarea>
  var EFLAGS_TEXT = html4.eflags['CDATA'] | html4.eflags['RCDATA'];

  /**
   * Given a SAX-like event handler, produce a function that feeds those
   * events and a parameter to the event handler.
   *
   * The event handler has the form:{@code
   * {
   *   // Name is an upper-case HTML tag name.  Attribs is an array of
   *   // alternating upper-case attribute names, and attribute values.  The
   *   // attribs array is reused by the parser.  Param is the value passed to
   *   // the saxParser.
   *   startTag: function (name, attribs, param) { ... },
   *   endTag:   function (name, param) { ... },
   *   pcdata:   function (text, param) { ... },
   *   rcdata:   function (text, param) { ... },
   *   cdata:    function (text, param) { ... },
   *   startDoc: function (param) { ... },
   *   endDoc:   function (param) { ... }
   * }}
   *
   * @param {Object} handler a record containing event handlers.
   * @return {function(string, Object)} A function that takes a chunk of HTML
   *     and a parameter.  The parameter is passed on to the handler methods.
   */
  function makeSaxParser(handler) {
    // Accept quoted or unquoted keys (Closure compat)
    var hcopy = {
      cdata: handler.cdata || handler['cdata'],
      comment: handler.comment || handler['comment'],
      endDoc: handler.endDoc || handler['endDoc'],
      endTag: handler.endTag || handler['endTag'],
      pcdata: handler.pcdata || handler['pcdata'],
      rcdata: handler.rcdata || handler['rcdata'],
      startDoc: handler.startDoc || handler['startDoc'],
      startTag: handler.startTag || handler['startTag']
    };
    return function(htmlText, param) {
      return parse(htmlText, hcopy, param);
    };
  }

  // Parsing strategy is to split input into parts that might be lexically
  // meaningful (every ">" becomes a separate part), and then recombine
  // parts if we discover they're in a different context.

  // TODO(felix8a): Significant performance regressions from -legacy,
  // tested on
  //    Chrome 18.0
  //    Firefox 11.0
  //    IE 6, 7, 8, 9
  //    Opera 11.61
  //    Safari 5.1.3
  // Many of these are unusual patterns that are linearly slower and still
  // pretty fast (eg 1ms to 5ms), so not necessarily worth fixing.

  // TODO(felix8a): "<script> && && && ... <\/script>" is slower on all
  // browsers.  The hotspot is htmlSplit.

  // TODO(felix8a): "<p title='>>>>...'><\/p>" is slower on all browsers.
  // This is partly htmlSplit, but the hotspot is parseTagAndAttrs.

  // TODO(felix8a): "<a><\/a><a><\/a>..." is slower on IE9.
  // "<a>1<\/a><a>1<\/a>..." is faster, "<a><\/a>2<a><\/a>2..." is faster.

  // TODO(felix8a): "<p<p<p..." is slower on IE[6-8]

  var continuationMarker = {};
  function parse(htmlText, handler, param) {
    var m, p, tagName;
    var parts = htmlSplit(htmlText);
    var state = {
      noMoreGT: false,
      noMoreEndComments: false
    };
    parseCPS(handler, parts, 0, state, param);
  }

  function continuationMaker(h, parts, initial, state, param) {
    return function () {
      parseCPS(h, parts, initial, state, param);
    };
  }

  function parseCPS(h, parts, initial, state, param) {
    try {
      if (h.startDoc && initial == 0) { h.startDoc(param); }
      var m, p, tagName;
      for (var pos = initial, end = parts.length; pos < end;) {
        var current = parts[pos++];
        var next = parts[pos];
        switch (current) {
        case '&':
          if (ENTITY_RE_2.test(next)) {
            if (h.pcdata) {
              h.pcdata('&' + next, param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
            pos++;
          } else {
            if (h.pcdata) { h.pcdata("&amp;", param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '<\/':
          if (m = /^([-\w:]+)[^\'\"]*/.exec(next)) {
            if (m[0].length === next.length && parts[pos + 1] === '>') {
              // fast case, no attribute parsing needed
              pos += 2;
              tagName = m[1].toLowerCase();
              if (h.endTag) {
                h.endTag(tagName, param, continuationMarker,
                  continuationMaker(h, parts, pos, state, param));
              }
            } else {
              // slow case, need to parse attributes
              // TODO(felix8a): do we really care about misparsing this?
              pos = parseEndTag(
                parts, pos, h, param, continuationMarker, state);
            }
          } else {
            if (h.pcdata) {
              h.pcdata('&lt;/', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '<':
          if (m = /^([-\w:]+)\s*\/?/.exec(next)) {
            if (m[0].length === next.length && parts[pos + 1] === '>') {
              // fast case, no attribute parsing needed
              pos += 2;
              tagName = m[1].toLowerCase();
              if (h.startTag) {
                h.startTag(tagName, [], param, continuationMarker,
                  continuationMaker(h, parts, pos, state, param));
              }
              // tags like <script> and <textarea> have special parsing
              var eflags = html4.ELEMENTS[tagName];
              if (eflags & EFLAGS_TEXT) {
                var tag = { name: tagName, next: pos, eflags: eflags };
                pos = parseText(
                  parts, tag, h, param, continuationMarker, state);
              }
            } else {
              // slow case, need to parse attributes
              pos = parseStartTag(
                parts, pos, h, param, continuationMarker, state);
            }
          } else {
            if (h.pcdata) {
              h.pcdata('&lt;', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '<\!--':
          // The pathological case is n copies of '<\!--' without '-->', and
          // repeated failure to find '-->' is quadratic.  We avoid that by
          // remembering when search for '-->' fails.
          if (!state.noMoreEndComments) {
            // A comment <\!--x--> is split into three tokens:
            //   '<\!--', 'x--', '>'
            // We want to find the next '>' token that has a preceding '--'.
            // pos is at the 'x--'.
            for (p = pos + 1; p < end; p++) {
              if (parts[p] === '>' && /--$/.test(parts[p - 1])) { break; }
            }
            if (p < end) {
              if (h.comment) {
                var comment = parts.slice(pos, p).join('');
                h.comment(
                  comment.substr(0, comment.length - 2), param,
                  continuationMarker,
                  continuationMaker(h, parts, p + 1, state, param));
              }
              pos = p + 1;
            } else {
              state.noMoreEndComments = true;
            }
          }
          if (state.noMoreEndComments) {
            if (h.pcdata) {
              h.pcdata('&lt;!--', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '<\!':
          if (!/^\w/.test(next)) {
            if (h.pcdata) {
              h.pcdata('&lt;!', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          } else {
            // similar to noMoreEndComment logic
            if (!state.noMoreGT) {
              for (p = pos + 1; p < end; p++) {
                if (parts[p] === '>') { break; }
              }
              if (p < end) {
                pos = p + 1;
              } else {
                state.noMoreGT = true;
              }
            }
            if (state.noMoreGT) {
              if (h.pcdata) {
                h.pcdata('&lt;!', param, continuationMarker,
                  continuationMaker(h, parts, pos, state, param));
              }
            }
          }
          break;
        case '<?':
          // similar to noMoreEndComment logic
          if (!state.noMoreGT) {
            for (p = pos + 1; p < end; p++) {
              if (parts[p] === '>') { break; }
            }
            if (p < end) {
              pos = p + 1;
            } else {
              state.noMoreGT = true;
            }
          }
          if (state.noMoreGT) {
            if (h.pcdata) {
              h.pcdata('&lt;?', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '>':
          if (h.pcdata) {
            h.pcdata("&gt;", param, continuationMarker,
              continuationMaker(h, parts, pos, state, param));
          }
          break;
        case '':
          break;
        default:
          if (h.pcdata) {
            h.pcdata(current, param, continuationMarker,
              continuationMaker(h, parts, pos, state, param));
          }
          break;
        }
      }
      if (h.endDoc) { h.endDoc(param); }
    } catch (e) {
      if (e !== continuationMarker) { throw e; }
    }
  }

  // Split str into parts for the html parser.
  function htmlSplit(str) {
    // can't hoist this out of the function because of the re.exec loop.
    var re = /(<\/|<\!--|<[!?]|[&<>])/g;
    str += '';
    if (splitWillCapture) {
      return str.split(re);
    } else {
      var parts = [];
      var lastPos = 0;
      var m;
      while ((m = re.exec(str)) !== null) {
        parts.push(str.substring(lastPos, m.index));
        parts.push(m[0]);
        lastPos = m.index + m[0].length;
      }
      parts.push(str.substring(lastPos));
      return parts;
    }
  }

  function parseEndTag(parts, pos, h, param, continuationMarker, state) {
    var tag = parseTagAndAttrs(parts, pos);
    // drop unclosed tags
    if (!tag) { return parts.length; }
    if (h.endTag) {
      h.endTag(tag.name, param, continuationMarker,
        continuationMaker(h, parts, pos, state, param));
    }
    return tag.next;
  }

  function parseStartTag(parts, pos, h, param, continuationMarker, state) {
    var tag = parseTagAndAttrs(parts, pos);
    // drop unclosed tags
    if (!tag) { return parts.length; }
    if (h.startTag) {
      h.startTag(tag.name, tag.attrs, param, continuationMarker,
        continuationMaker(h, parts, tag.next, state, param));
    }
    // tags like <script> and <textarea> have special parsing
    if (tag.eflags & EFLAGS_TEXT) {
      return parseText(parts, tag, h, param, continuationMarker, state);
    } else {
      return tag.next;
    }
  }

  var endTagRe = {};

  // Tags like <script> and <textarea> are flagged as CDATA or RCDATA,
  // which means everything is text until we see the correct closing tag.
  function parseText(parts, tag, h, param, continuationMarker, state) {
    var end = parts.length;
    if (!endTagRe.hasOwnProperty(tag.name)) {
      endTagRe[tag.name] = new RegExp('^' + tag.name + '(?:[\\s\\/]|$)', 'i');
    }
    var re = endTagRe[tag.name];
    var first = tag.next;
    var p = tag.next + 1;
    for (; p < end; p++) {
      if (parts[p - 1] === '<\/' && re.test(parts[p])) { break; }
    }
    if (p < end) { p -= 1; }
    var buf = parts.slice(first, p).join('');
    if (tag.eflags & html4.eflags['CDATA']) {
      if (h.cdata) {
        h.cdata(buf, param, continuationMarker,
          continuationMaker(h, parts, p, state, param));
      }
    } else if (tag.eflags & html4.eflags['RCDATA']) {
      if (h.rcdata) {
        h.rcdata(normalizeRCData(buf), param, continuationMarker,
          continuationMaker(h, parts, p, state, param));
      }
    } else {
      throw new Error('bug');
    }
    return p;
  }

  // at this point, parts[pos-1] is either "<" or "<\/".
  function parseTagAndAttrs(parts, pos) {
    var m = /^([-\w:]+)/.exec(parts[pos]);
    var tag = {};
    tag.name = m[1].toLowerCase();
    tag.eflags = html4.ELEMENTS[tag.name];
    var buf = parts[pos].substr(m[0].length);
    // Find the next '>'.  We optimistically assume this '>' is not in a
    // quoted context, and further down we fix things up if it turns out to
    // be quoted.
    var p = pos + 1;
    var end = parts.length;
    for (; p < end; p++) {
      if (parts[p] === '>') { break; }
      buf += parts[p];
    }
    if (end <= p) { return void 0; }
    var attrs = [];
    while (buf !== '') {
      m = ATTR_RE.exec(buf);
      if (!m) {
        // No attribute found: skip garbage
        buf = buf.replace(/^[\s\S][^a-z\s]*/, '');

      } else if ((m[4] && !m[5]) || (m[6] && !m[7])) {
        // Unterminated quote: slurp to the next unquoted '>'
        var quote = m[4] || m[6];
        var sawQuote = false;
        var abuf = [buf, parts[p++]];
        for (; p < end; p++) {
          if (sawQuote) {
            if (parts[p] === '>') { break; }
          } else if (0 <= parts[p].indexOf(quote)) {
            sawQuote = true;
          }
          abuf.push(parts[p]);
        }
        // Slurp failed: lose the garbage
        if (end <= p) { break; }
        // Otherwise retry attribute parsing
        buf = abuf.join('');
        continue;

      } else {
        // We have an attribute
        var aName = m[1].toLowerCase();
        var aValue = m[2] ? decodeValue(m[3]) : '';
        attrs.push(aName, aValue);
        buf = buf.substr(m[0].length);
      }
    }
    tag.attrs = attrs;
    tag.next = p + 1;
    return tag;
  }

  function decodeValue(v) {
    var q = v.charCodeAt(0);
    if (q === 0x22 || q === 0x27) { // " or '
      v = v.substr(1, v.length - 2);
    }
    return unescapeEntities(stripNULs(v));
  }

  /**
   * Returns a function that strips unsafe tags and attributes from html.
   * @param {function(string, Array.<string>): ?Array.<string>} tagPolicy
   *     A function that takes (tagName, attribs[]), where tagName is a key in
   *     html4.ELEMENTS and attribs is an array of alternating attribute names
   *     and values.  It should return a record (as follows), or null to delete
   *     the element.  It's okay for tagPolicy to modify the attribs array,
   *     but the same array is reused, so it should not be held between calls.
   *     Record keys:
   *        attribs: (required) Sanitized attributes array.
   *        tagName: Replacement tag name.
   * @return {function(string, Array)} A function that sanitizes a string of
   *     HTML and appends result strings to the second argument, an array.
   */
  function makeHtmlSanitizer(tagPolicy) {
    var stack;
    var ignoring;
    var emit = function (text, out) {
      if (!ignoring) { out.push(text); }
    };
    return makeSaxParser({
      'startDoc': function(_) {
        stack = [];
        ignoring = false;
      },
      'startTag': function(tagNameOrig, attribs, out) {
        if (ignoring) { return; }
        if (!html4.ELEMENTS.hasOwnProperty(tagNameOrig)) { return; }
        var eflagsOrig = html4.ELEMENTS[tagNameOrig];
        if (eflagsOrig & html4.eflags['FOLDABLE']) {
          return;
        }

        var decision = tagPolicy(tagNameOrig, attribs);
        if (!decision) {
          ignoring = !(eflagsOrig & html4.eflags['EMPTY']);
          return;
        } else if (typeof decision !== 'object') {
          throw new Error('tagPolicy did not return object (old API?)');
        }
        if ('attribs' in decision) {
          attribs = decision['attribs'];
        } else {
          throw new Error('tagPolicy gave no attribs');
        }
        var eflagsRep;
        var tagNameRep;
        if ('tagName' in decision) {
          tagNameRep = decision['tagName'];
          eflagsRep = html4.ELEMENTS[tagNameRep];
        } else {
          tagNameRep = tagNameOrig;
          eflagsRep = eflagsOrig;
        }
        // TODO(mikesamuel): relying on tagPolicy not to insert unsafe
        // attribute names.

        // If this is an optional-end-tag element and either this element or its
        // previous like sibling was rewritten, then insert a close tag to
        // preserve structure.
        if (eflagsOrig & html4.eflags['OPTIONAL_ENDTAG']) {
          var onStack = stack[stack.length - 1];
          if (onStack && onStack.orig === tagNameOrig &&
              (onStack.rep !== tagNameRep || tagNameOrig !== tagNameRep)) {
                out.push('<\/', onStack.rep, '>');
          }
        }

        if (!(eflagsOrig & html4.eflags['EMPTY'])) {
          stack.push({orig: tagNameOrig, rep: tagNameRep});
        }

        out.push('<', tagNameRep);
        for (var i = 0, n = attribs.length; i < n; i += 2) {
          var attribName = attribs[i],
              value = attribs[i + 1];
          if (value !== null && value !== void 0) {
            out.push(' ', attribName, '="', escapeAttrib(value), '"');
          }
        }
        out.push('>');

        if ((eflagsOrig & html4.eflags['EMPTY'])
            && !(eflagsRep & html4.eflags['EMPTY'])) {
          // replacement is non-empty, synthesize end tag
          out.push('<\/', tagNameRep, '>');
        }
      },
      'endTag': function(tagName, out) {
        if (ignoring) {
          ignoring = false;
          return;
        }
        if (!html4.ELEMENTS.hasOwnProperty(tagName)) { return; }
        var eflags = html4.ELEMENTS[tagName];
        if (!(eflags & (html4.eflags['EMPTY'] | html4.eflags['FOLDABLE']))) {
          var index;
          if (eflags & html4.eflags['OPTIONAL_ENDTAG']) {
            for (index = stack.length; --index >= 0;) {
              var stackElOrigTag = stack[index].orig;
              if (stackElOrigTag === tagName) { break; }
              if (!(html4.ELEMENTS[stackElOrigTag] &
                    html4.eflags['OPTIONAL_ENDTAG'])) {
                // Don't pop non optional end tags looking for a match.
                return;
              }
            }
          } else {
            for (index = stack.length; --index >= 0;) {
              if (stack[index].orig === tagName) { break; }
            }
          }
          if (index < 0) { return; }  // Not opened.
          for (var i = stack.length; --i > index;) {
            var stackElRepTag = stack[i].rep;
            if (!(html4.ELEMENTS[stackElRepTag] &
                  html4.eflags['OPTIONAL_ENDTAG'])) {
              out.push('<\/', stackElRepTag, '>');
            }
          }
          if (index < stack.length) {
            tagName = stack[index].rep;
          }
          stack.length = index;
          out.push('<\/', tagName, '>');
        }
      },
      'pcdata': emit,
      'rcdata': emit,
      'cdata': emit,
      'endDoc': function(out) {
        for (; stack.length; stack.length--) {
          out.push('<\/', stack[stack.length - 1].rep, '>');
        }
      }
    });
  }

  var ALLOWED_URI_SCHEMES = /^(?:https?|mailto|data)$/i;

  function safeUri(uri, effect, ltype, hints, naiveUriRewriter) {
    if (!naiveUriRewriter) { return null; }
    try {
      var parsed = URI.parse('' + uri);
      if (parsed) {
        if (!parsed.hasScheme() ||
            ALLOWED_URI_SCHEMES.test(parsed.getScheme())) {
          var safe = naiveUriRewriter(parsed, effect, ltype, hints);
          return safe ? safe.toString() : null;
        }
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  function log(logger, tagName, attribName, oldValue, newValue) {
    if (!attribName) {
      logger(tagName + " removed", {
        change: "removed",
        tagName: tagName
      });
    }
    if (oldValue !== newValue) {
      var changed = "changed";
      if (oldValue && !newValue) {
        changed = "removed";
      } else if (!oldValue && newValue)  {
        changed = "added";
      }
      logger(tagName + "." + attribName + " " + changed, {
        change: changed,
        tagName: tagName,
        attribName: attribName,
        oldValue: oldValue,
        newValue: newValue
      });
    }
  }

  function lookupAttribute(map, tagName, attribName) {
    var attribKey;
    attribKey = tagName + '::' + attribName;
    if (map.hasOwnProperty(attribKey)) {
      return map[attribKey];
    }
    attribKey = '*::' + attribName;
    if (map.hasOwnProperty(attribKey)) {
      return map[attribKey];
    }
    return void 0;
  }
  function getAttributeType(tagName, attribName) {
    return lookupAttribute(html4.ATTRIBS, tagName, attribName);
  }
  function getLoaderType(tagName, attribName) {
    return lookupAttribute(html4.LOADERTYPES, tagName, attribName);
  }
  function getUriEffect(tagName, attribName) {
    return lookupAttribute(html4.URIEFFECTS, tagName, attribName);
  }

  /**
   * Sanitizes attributes on an HTML tag.
   * @param {string} tagName An HTML tag name in lowercase.
   * @param {Array.<?string>} attribs An array of alternating names and values.
   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
   *     apply to URI attributes; it can return a new string value, or null to
   *     delete the attribute.  If unspecified, URI attributes are deleted.
   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
   *     to attributes containing HTML names, element IDs, and space-separated
   *     lists of classes; it can return a new string value, or null to delete
   *     the attribute.  If unspecified, these attributes are kept unchanged.
   * @return {Array.<?string>} The sanitized attributes as a list of alternating
   *     names and values, where a null value means to omit the attribute.
   */
  function sanitizeAttribs(tagName, attribs,
    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
    // TODO(felix8a): it's obnoxious that domado duplicates much of this
    // TODO(felix8a): maybe consistently enforce constraints like target=
    for (var i = 0; i < attribs.length; i += 2) {
      var attribName = attribs[i];
      var value = attribs[i + 1];
      var oldValue = value;
      var atype = null, attribKey;
      if ((attribKey = tagName + '::' + attribName,
           html4.ATTRIBS.hasOwnProperty(attribKey)) ||
          (attribKey = '*::' + attribName,
           html4.ATTRIBS.hasOwnProperty(attribKey))) {
        atype = html4.ATTRIBS[attribKey];
      }
      if (atype !== null) {
        switch (atype) {
          case html4.atype['NONE']: break;
          case html4.atype['SCRIPT']:
            value = null;
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          case html4.atype['STYLE']:
            if ('undefined' === typeof parseCssDeclarations) {
              value = null;
              if (opt_logger) {
                log(opt_logger, tagName, attribName, oldValue, value);
	      }
              break;
            }
            var sanitizedDeclarations = [];
            parseCssDeclarations(
                value,
                {
                  declaration: function (property, tokens) {
                    var normProp = property.toLowerCase();
                    var schema = cssSchema[normProp];
                    if (!schema) {
                      return;
                    }
                    sanitizeCssProperty(
                        normProp, schema, tokens,
                        opt_naiveUriRewriter
                        ? function (url) {
                            return safeUri(
                                url, html4.ueffects.SAME_DOCUMENT,
                                html4.ltypes.SANDBOXED,
                                {
                                  "TYPE": "CSS",
                                  "CSS_PROP": normProp
                                }, opt_naiveUriRewriter);
                          }
                        : null);
                    sanitizedDeclarations.push(property + ': ' + tokens.join(' '));
                  }
                });
            value = sanitizedDeclarations.length > 0 ?
              sanitizedDeclarations.join(' ; ') : null;
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          case html4.atype['ID']:
          case html4.atype['IDREF']:
          case html4.atype['IDREFS']:
          case html4.atype['GLOBAL_NAME']:
          case html4.atype['LOCAL_NAME']:
          case html4.atype['CLASSES']:
            value = opt_nmTokenPolicy ? opt_nmTokenPolicy(value) : value;
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          case html4.atype['URI']:
            value = safeUri(value,
              getUriEffect(tagName, attribName),
              getLoaderType(tagName, attribName),
              {
                "TYPE": "MARKUP",
                "XML_ATTR": attribName,
                "XML_TAG": tagName
              }, opt_naiveUriRewriter);
              if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          case html4.atype['URI_FRAGMENT']:
            if (value && '#' === value.charAt(0)) {
              value = value.substring(1);  // remove the leading '#'
              value = opt_nmTokenPolicy ? opt_nmTokenPolicy(value) : value;
              if (value !== null && value !== void 0) {
                value = '#' + value;  // restore the leading '#'
              }
            } else {
              value = null;
            }
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          default:
            value = null;
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
        }
      } else {
        value = null;
        if (opt_logger) {
          log(opt_logger, tagName, attribName, oldValue, value);
        }
      }
      attribs[i + 1] = value;
    }
    return attribs;
  }

  /**
   * Creates a tag policy that omits all tags marked UNSAFE in html4-defs.js
   * and applies the default attribute sanitizer with the supplied policy for
   * URI attributes and NMTOKEN attributes.
   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
   *     apply to URI attributes.  If not given, URI attributes are deleted.
   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
   *     to attributes containing HTML names, element IDs, and space-separated
   *     lists of classes.  If not given, such attributes are left unchanged.
   * @return {function(string, Array.<?string>)} A tagPolicy suitable for
   *     passing to html.sanitize.
   */
  function makeTagPolicy(
    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
    return function(tagName, attribs) {
      if (!(html4.ELEMENTS[tagName] & html4.eflags['UNSAFE'])) {
        return {
          'attribs': sanitizeAttribs(tagName, attribs,
            opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger)
        };
      } else {
        if (opt_logger) {
          log(opt_logger, tagName, undefined, undefined, undefined);
        }
      }
    };
  }

  /**
   * Sanitizes HTML tags and attributes according to a given policy.
   * @param {string} inputHtml The HTML to sanitize.
   * @param {function(string, Array.<?string>)} tagPolicy A function that
   *     decides which tags to accept and sanitizes their attributes (see
   *     makeHtmlSanitizer above for details).
   * @return {string} The sanitized HTML.
   */
  function sanitizeWithPolicy(inputHtml, tagPolicy) {
    var outputArray = [];
    makeHtmlSanitizer(tagPolicy)(inputHtml, outputArray);
    return outputArray.join('');
  }

  /**
   * Strips unsafe tags and attributes from HTML.
   * @param {string} inputHtml The HTML to sanitize.
   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
   *     apply to URI attributes.  If not given, URI attributes are deleted.
   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
   *     to attributes containing HTML names, element IDs, and space-separated
   *     lists of classes.  If not given, such attributes are left unchanged.
   */
  function sanitize(inputHtml,
    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
    var tagPolicy = makeTagPolicy(
      opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger);
    return sanitizeWithPolicy(inputHtml, tagPolicy);
  }

  // Export both quoted and unquoted names for Closure linkage.
  var html = {};
  html.escapeAttrib = html['escapeAttrib'] = escapeAttrib;
  html.makeHtmlSanitizer = html['makeHtmlSanitizer'] = makeHtmlSanitizer;
  html.makeSaxParser = html['makeSaxParser'] = makeSaxParser;
  html.makeTagPolicy = html['makeTagPolicy'] = makeTagPolicy;
  html.normalizeRCData = html['normalizeRCData'] = normalizeRCData;
  html.sanitize = html['sanitize'] = sanitize;
  html.sanitizeAttribs = html['sanitizeAttribs'] = sanitizeAttribs;
  html.sanitizeWithPolicy = html['sanitizeWithPolicy'] = sanitizeWithPolicy;
  html.unescapeEntities = html['unescapeEntities'] = unescapeEntities;
  return html;
})(html4);

var html_sanitize = html['sanitize'];

// Loosen restrictions of Caja's
// html-sanitizer to allow for styling
html4.ATTRIBS['*::style'] = 0;
html4.ELEMENTS['style'] = 0;
html4.ATTRIBS['a::target'] = 0;
html4.ELEMENTS['video'] = 0;
html4.ATTRIBS['video::src'] = 0;
html4.ATTRIBS['video::poster'] = 0;
html4.ATTRIBS['video::controls'] = 0;
html4.ELEMENTS['audio'] = 0;
html4.ATTRIBS['audio::src'] = 0;
html4.ATTRIBS['video::autoplay'] = 0;
html4.ATTRIBS['video::controls'] = 0;

if (true) {
    module.exports = html_sanitize;
}



/***/ }),

/***/ "../node_modules/set-function-length/index.js":
/***/ (function(module, exports, __webpack_require__) {



var GetIntrinsic = __webpack_require__("../node_modules/get-intrinsic/index.js");
var define = __webpack_require__("../node_modules/define-data-property/index.js");
var hasDescriptors = __webpack_require__("../node_modules/has-property-descriptors/index.js")();
var gOPD = __webpack_require__("../node_modules/gopd/index.js");

var $TypeError = __webpack_require__("../node_modules/es-errors/type.js");
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};



/***/ }),

/***/ "../node_modules/side-channel/index.js":
/***/ (function(module, exports, __webpack_require__) {



var GetIntrinsic = __webpack_require__("../node_modules/get-intrinsic/index.js");
var callBound = __webpack_require__("../node_modules/call-bind/callBound.js");
var inspect = __webpack_require__("../node_modules/object-inspect/index.js");

var $TypeError = __webpack_require__("../node_modules/es-errors/type.js");
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	for (; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			// eslint-disable-next-line no-extra-parens
			curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

/** @type {import('.').listGet} */
var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('.').ListNode<typeof value>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('.').listHas} */
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @type {WeakMap<object, unknown>} */ var $wm;
	/** @type {Map<object, unknown>} */ var $m;
	/** @type {import('.').RootNode<unknown>} */ var $o;

	/** @type {import('.').Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};



/***/ }),

/***/ "../node_modules/squid/dist/core/api.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Api = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.$getLatestCorrelationID = $getLatestCorrelationID;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 API
 ---

 This layer is responsible for handling api requests. It has a number of responsibilities:

 - Caching responses
 - Transparently returning data that has been preloaded into the initial page response
 - Instrumentation
 - Batching multiple api calls into a single http request
 - Handling multiple types of responses and dispatching to the correct handlers
 - Emitting loading events for all http calls
 */

_config.$meta.headers = _config.$meta.headers || {};
_config.$meta.headers['x-cookies'] = _typeof(_config.$meta.headers['x-cookies']) !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];

// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
function cookiesEnabled() {
    return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
}

// Cache for api responses, when cache: true
var cache = {};
var standardHeaders = {};

var latestCorrelationID = _config.$meta.correlationId;

// Window load promise
var windowLoad = _util.$util.memoize(function () {
    return _promise.$promise.resolver(function (resolve) {
        if (document.readyState === 'complete') {
            resolve();
        } else {
            window.addEventListener('load', resolve);
        }
    });
});

// Buffer for batch requests made within the same frame
var batchQueue = {};

// Backwards compat
window.pre = {};

// Transient cache resolvers
var transientCache = {};

// Transient cache resolvers
var transientCacheResolvers = {};

// Metabuilder
var metaBuilder = void 0;

// Add to transientCache
window.preload = function (method, url, data, name) {

    if (name) {
        window.pre[name] = {
            method: method,
            uri: url,
            res: data
        };
    }

    var key = method + ':' + url;
    var resolvers = transientCacheResolvers[key] || [];

    transientCache[key] = data;

    while (resolvers.length) {
        resolvers.pop().call();
    }
};

// Preload complete
var preloadComplete = false;

window.preloadComplete = function () {
    preloadComplete = true;
    Object.keys(transientCacheResolvers).forEach(function (key) {
        var resolvers = transientCacheResolvers[key] || [];

        while (resolvers.length) {
            resolvers.pop().call();
        }
    });
};

_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');

var $Api = exports.$Api = _class.$Class.extend('$Api', {

    // Cache any GET responses indefinitely
    cache: false,

    // Http timeout for all requests
    timeout: 45000,

    // Default number of attempts on aborted requests and 500 server errors
    getAttempts: 3,
    postAttempts: 1,

    // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
    action: function action(_action, options) {
        options.action = _action;
        return this.post(options);
    },

    // GET on a resource myapi.retrieve() -> GET /my/api
    retrieve: function retrieve(options) {
        options.method = 'get';
        return this.call(options);
    },

    // POST on a resource myapi.retrieve() -> POST /my/api
    post: function post(options) {
        options.method = 'post';
        return this.call(options);
    },

    // Generic handler for calling an api and dispatching requests to the right place
    call: function call(options) {
        var self = this;

        // Set up request options and params. `options` is an object which should contain everything
        // the request needs to run and handle the response

        options.api = this;
        options.uri = this.getURI(options.model, options.action);
        options.params = options.params || {};
        options.cache = options.cache || self.cache && options.method === 'get';
        options.name = this.buildAPIName(options);
        options.meta = this.buildMeta();
        options.transientError = options.transientError || false;
        options.cacheKey = _util.$util.buildURL(options.uri, options.params);

        _logger.$logger.info(options.name + '_call', {
            name: options.name,
            method: options.method,
            uri: options.uri
        });

        if (!options.silent) {
            _event.$event.emit('loading');
        }

        // Decide where to get the response
        return _promise.$promise.first([

        // If caching is enabled and we have the data in local cache, use the cache
        function () {
            if (options.cache && cache[options.cacheKey]) {
                return cache[options.cacheKey];
            }
        },

        // Otherwise if we have transient cache data for this api, we can use that
        function () {
            return _promise.$promise.providing(self.hasTransientCacheData(options), function () {

                // The reason we use self.attemptRequest here is so any errors in the cached response
                // can trigger the retry code path, as if it were a regular request
                return self.attemptRequest(options);
            });
        },

        // If we're in batch mode, queue up a batch request
        function () {
            if (options.batch) {
                return self.batchRequest(options);
            }
        },

        // Otherwise attempt a regular http request (at this point an http call is guaranteed)
        function () {
            return self.attemptRequest(options);
        }])['finally'](function () {

            if (!options.silent) {
                _event.$event.emit('loaded');
            }
        }).then(function (res) {

            // Cache the response if we need to
            if (options.cache) {
                cache[options.cacheKey] = res;
            }

            // Handle the response
            return self.handleResponse(res.data, options);
        }, function (err) {

            // $BatchShortCircuit will be thrown if:
            //
            // 1. batch api call B depends on api call A, but-
            // 2. api call A fails
            //
            // In which case we end up in a situation where had it been a regular chain of events,
            // api B would never have been called in the first place.
            //
            // One possibility here is to return $unresolved, which prevents the promise from ever
            // resolving, but this has the potential to cause a lot of difficulty debugging and strange
            // corner cases.
            //
            // Instead we opt to simply reject the promise, and not call any of the response handlers

            if (err instanceof _error.$BatchShortCircuit) {
                return _promise.$promise.reject(err);
            }

            // Otherwise, handle the error normally
            return self.handleErrorResponse(err, options);
        });
    },

    // Set up a batch request for processing in the next frame
    batchRequest: function batchRequest(options) {

        // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
        // layer is to combine multiple atomic api calls into a single http request, without forcing
        // developers to create large orchestration layers on the client/server with cross-cutting concerns.
        //
        // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
        // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
        // individual api call to the correct handler.
        //
        // The way this is implemented is to place each response in the transient api cache, then to yield
        // control to the regular api request handler, which will handle instrumentation and retries

        // For quick dev-time feedback...
        _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
        _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);

        var name = options.batch.name;
        var id = options.batch.id;

        // Add the batch request options to the batchQueue for processing on the next frame
        var batch = batchQueue[name] = batchQueue[name] || {};

        batch[id] = options;

        // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
        return this.buildBatchRequest(name).then(function (results) {

            // We get back a mapping of id->response, so we now extract the response for our api
            // call. If we have no response, we can assume the call was never made, and short circuit.
            return results[id].then(function (result) {
                return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
            });
        });
    },

    // Process all of the accumulated batch api requests
    buildBatchRequest: _promise.$promise.debounce(function (name) {

        var self = this;
        var batch = batchQueue[name];
        var batchIds = _class.$Class.keys(batch);
        var batchData = {};
        var headers = {};

        delete batchQueue[name];

        // If we have just a single request, we can short-circuit and just hit that api

        if (batchIds.length === 1) {

            var batchId = batchIds[0];
            var opts = batch[batchId];

            var results = {};

            results[batchId] = opts.api.attemptRequest(opts);
            return results;
        }

        // Build the request to send to the server side. This is an mapping of id->request, each containing
        // the method, uri, data, and dependencies for each api.
        //
        // Specifying a dependency for an api essentially means the back-end will only
        // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.

        _util.$util.forEach(batch, function (options, id) {

            batchData[id] = {
                method: options.method,
                uri: options.api.getURI(options.model, options.action, true),
                data: options.data,
                params: options.params,
                dependencies: options.batch.dependencies
            };

            _util.$util.extend(headers, options.headers);
        });

        // Unfortunate circular dependency... $Api depends on another api.
        //
        // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
        // does not respond the first time, our batch request can still get through.

        return $batchApi.action(name, { // eslint-disable-line no-use-before-define
            data: batchData,
            headers: headers
        }).then(function (res) {

            // The final response will be a mapping of id->response-promise.
            //
            // However, we do not treat this data as our final response. Instead, we simply use it to
            // prime our transient cache, then proceed to jump to our regular request handler. This will
            // take care of retries and instrumentation as if this were a regular request.
            //
            // Note that a retry for $batchApi is different to a retry for an individual api. If
            // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
            // can just retry the individual api call.

            return self.handleBatchResponse(batch, res.data);
        });
    }),

    // Process the responses for all of the batch requests we sent to the server
    handleBatchResponse: function handleBatchResponse(batch, data) {

        var self = this;

        var promises = {};

        // Loop over each individual api response contained in the batch response, and process the result

        _util.$util.forEach(batch, function (options, id) {

            // Store each response promise so we can check and wait for api dependencies

            promises[id] = _promise.$promise.run(function () {

                // Check if all of the dependencies are present for our individual api call. To do this
                // we must wait until the dependent api call is entirely complete, including any retries.

                var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {

                    if (!batch[depName]) {
                        _logger.$logger.info('missing_batch_dependency', {
                            dependency: depName,
                            available: Object.keys(batch).join('|')
                        });
                    }

                    return !batch[depName] || promises[depName].then(function (dependency) {
                        return dependency && dependency.data && dependency.data.ack === 'success';
                    });
                });

                // If our dependencies are present, we can continue, otherwise we are not interested in
                // the result of the individual api call - if its dependency is not present, it will not be.

                return _promise.$promise.providing(depsPresent, function () {

                    // If there is data returned for the individual call, add it to the transient cache

                    return _promise.$promise.providing(data[id], function (result) {
                        var uri = options.api.getURI(options.model, options.action);

                        uri = _util.$util.buildURL(uri, options.params);

                        self.addTransientCacheData(options.method, uri, result);
                    }).then(function () {

                        // Regardless of whether or not there is data, we can now attempt the request.
                        // This will either get the data from the transient cache, or make an http call,
                        // and handle any retries that need to be made.

                        return options.api.attemptRequest(options);
                    });
                });
            });
        });

        return promises;
    },

    // Handle the request and any retries, using either the transient cache or http calls
    attemptRequest: function attemptRequest(options) {
        var self = this;
        var attempts = 1;
        if (_config.$config.enableCheckoutRetries) {
            // ui:enableCheckoutRetries=true
            attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;
        }

        // We allow a certain number of attempts/retries for each api call
        return _promise.$promise.attempt(attempts, function (remaining) {

            // Query the transient cache
            return self.getTransientCacheResponse(options).then(function (res) {

                // If we can get a response from the transient cache, then use it
                if (res) {
                    return res;
                }

                // Otherwise resort to making an http call
                return self.getHttpResponse(options);
            })['catch'](function (res) {

                // If our request was aborted without even a status code, force a single retry
                if ((!res || !res.status) && attempts === 1) {

                    _logger.$logger.warn('api_retry_aborted', {
                        method: options.method,
                        uri: options.uri
                    });

                    return self.getHttpResponse(options);
                }

                return _promise.$promise.reject(res);
            })['catch'](function (res) {

                // If our request was 401 denied (probably due to a CSRF error), force a single retry
                if (res.status === 401) {

                    _logger.$logger.warn('api_retry_401', {
                        method: options.method,
                        uri: options.uri
                    });

                    return self.getHttpResponse(options);
                }

                return _promise.$promise.reject(res);
            })['catch'](function (res) {

                // Set the correct response and ack for 401
                if (res.status === 401) {
                    return {
                        data: {
                            ack: 'permission_denied'
                        }
                    };
                }

                // Setup to throw a TOO_MANY_REQUESTS contingency for 429 response from ratelimiter (velocityserv)
                if (res.status === 429) {
                    return {
                        data: {
                            ack: 'contingency',
                            contingency: 'TOO_MANY_REQUESTS'
                        }
                    };
                }

                // If we have any remaining retries, log and reject
                if (remaining) {

                    _logger.$logger.warn('api_retry', {
                        method: options.method,
                        uri: options.uri
                    });

                    return _promise.$promise.reject(res);
                }

                // Otherwise reject the request with the appropriate error

                // We got ack=error in the response
                if (res && res.data && res.data.ack === 'error') {
                    return _promise.$promise.reject(new _error.$ApiError('api_error', { // eslint-disable-line no-reserved-keys
                        name: options.name,
                        method: options.method,
                        uri: options.uri,
                        stack: res.data.stack,
                        transient: options.transientError
                    }));
                }

                // We got a response error status
                else if (res && res.status) {
                        return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, { // eslint-disable-line no-reserved-keys
                            uri: options.uri,
                            transient: options.transientError
                        }));
                    } else if (res && res.error) {
                        return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, { // eslint-disable-line no-reserved-keys
                            uri: options.uri,
                            transient: options.transientError
                        }));
                    }

                    // The request was aborted
                    else {
                            return _promise.$promise.reject(new _error.$ApiError('request_aborted', { // eslint-disable-line no-reserved-keys
                                uri: options.uri,
                                transient: options.transientError
                            }));
                        }
            });
        });
    },

    // Get an api response via http
    getHttpResponse: function getHttpResponse(options) {
        var self = this;

        var startTime = _util.$util.now();

        var request = this.http(options);

        return request['finally'](function () {

            // Calculate the end-to-end duration of the request from the client's perspective
            options.duration = _util.$util.now() - startTime;
        })['catch'](function (res) {

            // Turn responses with an ack into a 'success' so it makes it to the standard handlers
            if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
                return res;
            }

            return _promise.$promise.reject(res);
        }).then(function (res) {
            self.saveResponseState(res);

            var loggerPayload = {
                name: options.name,
                method: options.method,
                uri: options.uri,
                server: res.data.server,
                time: options.duration,
                duration: options.duration,
                corrid: res && res.headers('Paypal-Debug-Id')
            };

            // In certain browsers we can match up this api call to the performance data from the browser
            if (window.performance && window.performance.getEntries) {
                _util.$util.forEach(window.performance.getEntries(), function (resource) {
                    if (resource.name && resource.name.indexOf(options.uri) > -1) {
                        _util.$util.extend(loggerPayload, resource);
                    }
                });
            }

            _logger.$logger.info('api_response', loggerPayload);

            if (res && res.status) {
                _logger.$logger.info('http_response_' + res.status);
            }

            return res;
        }, function (res) {
            self.saveResponseState(res);

            if (res && res.status) {
                _logger.$logger.info('http_response_' + res.status, {
                    corrid: res.headers('Paypal-Debug-Id'),
                    referenceId: res.headers('X-Reference-Header') || undefined // To not serialize this data if not present
                });
            }

            return _promise.$promise.reject(res);
        });
    },

    setTransientCache: function setTransientCache(data) {
        throw new Error('NotImplemented');
    },

    // Get an individual api response from the transient cache, as an object
    getTransientCacheData: function getTransientCacheData(options, pop) {

        if (!_config.$config.enablePreload) {
            return _promise.$promise.resolve();
        }

        var preMethod = options.method.toLowerCase();
        var preUri = _util.$util.buildURL(options.uri, options.params);

        var key = preMethod + ':' + preUri;

        return _promise.$promise.resolver(function (resolve) {

            function res() {
                var data = transientCache[key];

                if (pop) {
                    delete transientCache[key];
                }
                resolve(data);
            }

            if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
                return res();
            }

            transientCacheResolvers[key] = transientCacheResolvers[key] || [];
            transientCacheResolvers[key].push(res);

            windowLoad().then(res);
        });
    },

    // Check if the transient cache has the data for a particular api
    hasTransientCacheData: function hasTransientCacheData(options) {
        return this.getTransientCacheData(options, false).then(function (data) {
            return Boolean(data);
        });
    },

    // Add data to the transient cache
    addTransientCacheData: function addTransientCacheData(method, uri, data) {
        var key = method + ':' + uri;

        transientCache[key] = data;
    },

    // Get an individual api response from transient cache, as a res promise with the correct status code
    getTransientCacheResponse: function getTransientCacheResponse(options) {

        return this.getTransientCacheData(options, true).then(function (data) {

            // Preload data does not come with a response code, so massage it into a response promise
            if (data) {
                if (data.ack === 'error') {
                    return _promise.$promise.reject({
                        status: 500,
                        data: data
                    });
                } else if (data.ack === 'permission_denied') {
                    return _promise.$promise.reject({
                        status: 401,
                        data: data
                    });
                } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
                    return {
                        status: 400,
                        data: data
                    };
                } else {
                    return {
                        status: 200,
                        data: data
                    };
                }
            }

            // Log a cache miss if we are currently in the first-page load
            else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
                    _logger.$logger.info('preload_cache_miss', {
                        uri: options.uri
                    });
                }
        });
    },

    getHeaders: function getHeaders(options) {

        if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
            _logger.$logger.warn('missing_csrf_jwt');
        }

        var headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
        };

        _util.$util.extend(headers, standardHeaders);

        if (window.xprops && window.xprops.clientMetadataID) {
            headers['paypal-client-metadata-id'] = window.xprops.clientMetadataID;
        } else if (_util.$util.param('client-metadata-id')) {
            headers['paypal-client-metadata-id'] = _util.$util.param('client-metadata-id');
        }

        if (!cookiesEnabled()) {
            headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
        }

        if (options.headers) {
            _util.$util.extend(headers, options.headers);
        }

        return headers;
    },
    http: function http(options) {
        return this.httpJQuery(options);
    },


    /*
     // Raw http call
    httpAngular: function(options) {
         let request = {
            method: options.method,
            url: options.uri,
            data: {
                data: options.data,
                meta: options.meta
            },
            headers: this.getHeaders(options),
            params: options.params,
            requestType: 'json',
            responseType: 'json',
            timeout: this.timeout
        };
         if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
            request.params.meta = JSON.stringify(options.meta);
        }
         return $http(request);
    },
     */

    httpJQuery: function httpJQuery(options) {

        var request = {
            method: options.method,
            data: options.method === 'get' ? options.params : JSON.stringify({
                data: options.data,
                meta: options.meta || {}
            }),
            headers: this.getHeaders(options),
            timeout: this.timeout
        };

        if (options.method === 'post') {
            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
        } else if (options.method === 'get') {
            request.data.meta = JSON.stringify(options.meta);
        }

        return _promise.$promise.resolver(function (resolve, reject) {

            function getRes(res, data) {
                return {
                    status: res.status,
                    data: data,
                    headers: function headers(name) {
                        return res.getResponseHeader(name);
                    }
                };
            }

            request.success = function (data, status, res) {
                return resolve(getRes(res, data));
            };

            request.error = function (res) {
                if (res && res.status) {
                    if (res.status >= 400) {
                        return reject(getRes(res, res.responseJSON));
                    } else {
                        return resolve(getRes(res, res.responseJSON));
                    }
                }

                return reject({
                    status: 0,
                    headers: _util.$util.noop,
                    error: res && res.statusText
                });
            };

            _jquery2['default'].ajax(options.uri, request);
        });
    },

    // Save cookies and jwt-csrf token from the response
    saveResponseState: function saveResponseState(res) {

        if (res.headers('x-csrf-jwt')) {
            _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
            _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
            _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
        }

        if (res.headers('X-cookies')) {

            _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');

            // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
            _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
        }

        latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
    },

    // Dispatch the response to the correct handlers
    handleResponse: function handleResponse(res, options) {
        var loggerName = 'ui_' + options.name;

        var loggerPayload = {
            name: options.name,
            method: options.method,
            uri: options.uri,
            time: options.duration,
            duration: options.duration
        };

        // Here we dispatch the response to the correct handler based on the ack.
        //
        // ack=success     -> options.success()
        // ack=error       -> options.error()
        // ack=validation  -> options.validation()
        // ack=contingency -> options.contingencies[contingency]()
        //
        // Why do this rather than just rejecting the promise with a custom error?
        //
        // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
        // b) Angular promises have no `.done()`, so callers can not assert that they have handled
        //    every error they want to. This is exacerbated by the fact that there is no single thread
        //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
        //
        // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
        // and the global error handler will be invoked. The api responses are also given as promises.

        var resultModel = options.resultModel || options.model;

        /* jshint maxcomplexity: 17 */
        return _promise.$promise.call(function () {

            // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack

            if (res.data && resultModel) {

                if (resultModel.populate) {
                    resultModel.populate(res.data);
                } else {
                    _util.$util.extend(resultModel, res.data);
                }
            }

            if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
                return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
                    return _util.$util.extend(resultModel, children);
                });
            }
        }).then(function () {
            // eslint-disable-line max-statements

            // Handle each ack type, throw errors accordingly

            if (res.ack === 'success') {
                _logger.$logger.info(loggerName + '_success', loggerPayload);

                if (options.success) {
                    if (options.success instanceof Function) {
                        return options.success(res.data);
                    }
                    return options.success;
                }

                return res;
            }

            if (options.failSilently) {
                return;
            }

            if (res.ack === 'contingency') {
                _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
                    contingency: res.contingency
                }));

                if (!res.contingency) {
                    throw new _error.$ApiError('expected_contingency_name', {
                        api: options.name
                    });
                }

                var contingency = new _error.$Contingency(res.contingency, { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });

                if (resultModel) {
                    resultModel.errorData = res.errorData || {};
                }

                var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);

                _util.$util.extend(contingency, res.errorData);

                if (handler) {
                    if (handler instanceof Function) {
                        return handler(contingency.message, contingency);
                    }
                    return handler;
                }

                throw contingency;
            } else if (res.ack === 'validation') {
                _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
                    validation: res.validation
                }));

                if (options.validation) {
                    return options.validation(res.validation);
                }

                throw new _error.$ApiError('validation', { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });
            } else if (res.ack === 'permission_denied') {
                _logger.$logger.info(loggerName + '_denied', loggerPayload);

                var properties = {
                    transient: options.transientError
                };

                if (res.reason) {
                    properties.reason = res.reason;
                }

                throw new _error.$Forbidden(options.uri + ': forbidden', properties);
            } else {
                _logger.$logger.info(loggerName + '_noack', loggerPayload);

                throw new _error.$ApiError('noack', { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });
            }
        });
    },

    // Handle http error responses (ack=error or unhandled errors)
    handleErrorResponse: function handleErrorResponse(err, options) {

        return _promise.$promise.run(function () {

            // If the caller provides an error handler, let them handle it
            if (options.error) {
                return options.error(err);
            }

            // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
            // this will always end up in the global error handler due to how angular promises work.
            throw err;
        });
    },

    // Build the uri for the api call
    getURI: function getURI(model, action, relative) {
        var self = this;

        // build the uri as a seriest of segments
        var uri = [];

        uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {

            // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})

            key = key.slice(2);
            key = key.substring(0, key.length - 1);

            var component = model.get ? model.get(key) : model[key];

            if (!component) {
                return '';
            }

            return '/' + component;
        }).replace(/:[\w\.]+/g, function (key) {

            // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})

            key = key.slice(1);

            var component = model.get ? model.get(key) : model[key];

            if (!component) {
                throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
            }

            return component;
        }));

        // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
        if (action) {
            uri.push(action);
        }

        // Add the extension (e.g. for doing a GET on a .json resource)
        if (this.ext) {
            uri[uri.length - 1] += '.' + this.ext;
        }

        // Join the uri segments and strip any extra slashes
        uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');

        // Add on the base uri, e.g. /webapps/hermes
        if (!relative) {
            uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
        }

        return uri;
    },

    // Attach meta data provided by the parent app
    buildMeta: function buildMeta() {
        if (metaBuilder) {
            return metaBuilder();
        }
    },

    // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
    buildAPIName: function buildAPIName(options) {
        var self = this;
        var apiName = self.uri.replace(/^\/+/, ''). // Remove leading '/'
        replace(/\//g, '_'). // Replace remaining '/' with '_'
        replace(/\?(.*)/, ''). // Remove everything after '?'
        replace(/[^a-zA-Z0-9_]/g, '');

        apiName = options.action ? apiName + '_' + options.action : apiName;
        apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
        return apiName;
    }
});

$Api.reopenClass({
    clearCache: function clearCache() {
        cache = {};
    }
});

$Api.registerMetaBuilder = function (builder) {
    metaBuilder = builder;
};

$Api.addHeader = function (name, value) {
    standardHeaders[name] = value;
};

var $batchApi = new $Api({
    uri: '/api/batch',
    postAttempts: 3
});

function $getLatestCorrelationID() {
    return latestCorrelationID;
}

angular.value("$Api", $Api);
angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
_logger.$logger;

_event.$event;

_class.$Class;

_util.$util;

_promise.$promise;

_config.$config;

_config.$meta;

_error.$Contingency;

_error.$Forbidden;

_error.$ApiError;

_error.$BatchShortCircuit;

_loader.$loader;

/***/ }),

/***/ "../node_modules/squid/dist/core/class.js":
/***/ (function(module, exports) {



exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 Class
 -----

 A class pattern, adding sugar on top of javascript prototypes

 ### Basic Usage

 let MyClass = Class.extend({
 foo: 'bar';
 });

 myInstance = new MyClass({
 hello: 'world'
 });

 console.log(myInstance.foo, myInstance.hello)

 In this example, `foo` becomes a property on `MyClass`'s prototype,
 and `hello` becomes a property on `myInstance`.

 ### Default Object Methods

 - `init()`: Called after the object is first instantiated, with all properties available

 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default

 e.g. `myInstance.get('foo.bar.baz', 'some_default');`

 Default return value is undefined

 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep

 e.g. `myInstance.set('foo.bar.baz', 'some_value');`

 Error is thrown if no object is found to set the value on

 - `setProperties(<object>)`: Set all the properties from an object onto your object

 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`

 Can not be used with nested properties

 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair

 */

// Object Create
// -------------
//
// Shim for Object.create, if it is not supported by our browser
//
// let myPrototype = {foo: 'bar'}
// let myObject = create(myPrototype)

// Create an empty anonymous constructor with no side effects, for re-use later
var EmptyConstructor = function EmptyConstructor() {}; // eslint-disable-line no-empty-function

var create = Object.create || function create(obj) {

    // Set a temporary prototype
    EmptyConstructor.prototype = obj;

    // Create an object using our temporary constructor/prototype
    var instance = new EmptyConstructor();

    // Reset the prototype for next time
    EmptyConstructor.prototype = null;

    // Return our new object, created without side effects
    return instance;
};

function _extend(obj, source) {

    if (!source) {
        return obj;
    }

    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            obj[key] = source[key];
        }
    }

    return obj;
}

// Is Object
// ---------
//
// Check of a let is an object or not
//
// isobject({}) -> true
// isobject('foo') -> false

function isobject(obj) {
    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Object;
}

// Transpose properties
// -------------------------------------------------------------------
//
// Transpose properties from a list of objects onto a recipient object
//
// let recipient = {};
// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
// recipient -> {a: 1, b: 2, c:3}

function transpose(recipient, args) {

    // Loop through all args
    for (var i = 0; i < args.length; i++) {
        var ob = args[i];

        // Ignore anything that is not an object
        if (!isobject(ob)) {
            continue;
        }

        // Loop through all keys in our object
        for (var key in ob) {

            // Ignore any prototypal properties
            if (!ob.hasOwnProperty(key)) {
                continue;
            }

            var item = ob[key];

            // Give the function a name
            if (item instanceof Function) {
                item.__name__ = key;
            }

            recipient[key] = item;
        }
    }
}

// Construct a Class
// -----------------
//
// This is the primary constructor for all $Class objects

function construct() {
    // eslint-disable-line no-unused-vars

    // Call any custom constructor;
    if (this.construct) {
        var ob = this.construct.apply(this, arguments);

        // If we get a new object back, return that to the user
        if (isobject(ob)) {
            return ob;
        }
    }

    // Load any provided properties directly onto the object
    transpose(this, arguments);

    // Initialize the object
    if (this.init) {
        this.init();
    }
}

// Reopen an object
// ----------------
//
// Add properties to the constructor's prototype
//
//     let Animal = $Class.extend();
//
//     Animal.reopen({
//       type: 'animal',
//     });
//
//     let cat = new Animal;
//     console.log(cat.type);
function reopen() {

    // Add some more properies to our prototype
    transpose(this.prototype, arguments);

    return this;
}

// Reopen a class
// --------------
//
// Add properties to the constructor. These will propogate through future extends
//
//     let Animal = $Class.extend();
//
//     Animal.reopenClass({
//       fromCache: function(id) {
//         return cache[id] || new this({id: id});
//       }
//     }
//
//     let cat = Animal.fromCache('cat_54');

function reopenClass() {

    // Add some more properies to our class
    transpose(this, arguments);

    // Add to __classmethods__
    transpose(this.__classmethods__, arguments);

    return this;
}

function isChild(Cls) {
    return Cls && Cls.prototype instanceof this;
}

// Generate a new class
// --------------------
//
// Generate a new constructor, with the specified name, and attach all static and prototypal methods

var id = 0;

function extend(name) {
    // eslint-disable-line max-statements
    var Cls = void 0;
    var className = void 0;
    var args = void 0;
    var argsLength = void 0;
    var startIndex = void 0;

    // Accept an optional class name
    if (typeof name === 'string') {

        // Guard against javascript injection
        if (!name.match(/^[\w$][\w\d]*$/)) {
            throw new Error('Class name can not include special characters: ' + name);
        }

        // Use the provided name and slice out the first argument
        className = name;
        argsLength = arguments.length && arguments.length - 1;
        startIndex = 1;
    } else {

        // Otherwise default to the parent name, or 'Object' if generating our first class
        className = this.name || 'Object';
        argsLength = arguments.length;
        startIndex = 0;
    }

    args = new Array(argsLength);
    for (var i = startIndex; i < arguments.length; i++) {
        args[i - startIndex] = arguments[i];
    }

    // Dynamically create our constructor with a custom name
    Cls = function Cls() {
        return construct.apply(this, arguments);
    };
    Object.defineProperty(Cls, 'name', { value: className, writable: false });

    // Store the class name for future reference
    Cls.__name__ = className;

    // Set up a classmethods object. These will be inherited through subsequent extend() calls
    Cls.__classmethods__ = {
        extend: extend,
        reopen: reopen,
        reopenClass: reopenClass,
        isChild: isChild
    };

    id += 1;
    Cls.id = id;

    // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
    if (this && this !== window) {

        // Inherit everything from superclass prototype
        Cls.prototype = create(this.prototype);

        // Re-set the constructor, which is overwritten by create
        Cls.prototype.constructor = Cls;

        // Add a reference to the superclass prototype for super method calls
        Cls.prototype._super = this.prototype;

        // Inherit any class methods from the superclass
        _extend(Cls.__classmethods__, this.__classmethods__);
    }

    // Add the class methods to our existing class
    _extend(Cls, Cls.__classmethods__);

    // Load any provided properties onto the constructor's prototype
    transpose(Cls.prototype, args);

    // Temporary: allow access from console/debugger
    if (className.indexOf('$') === 0) {
        window[className] = Cls;
    } else {
        window['$' + className] = Cls;
    }

    return Cls;
}

// Multi-layer get
// ---------------
//
// Recursively gets a deep path from an object, returning a default value if any level is not found
//
// let obj = {bar: {baz: 1}}
// get(obj, 'bar.baz', 'default') -> 1
// get(obj, 'aaa.bbb', 'default') -> default

function _get(item, path, def) {

    if (!path) {
        return def;
    }

    path = path.split('.');

    // Loop through each section of our key path
    for (var i = 0; i < path.length; i++) {

        // If we have an object, we can get the key
        if (isobject(item)) {
            item = item[path[i]];
            // Otherwise, we should return the default (undefined if not provided)
        } else {
            return def;
        }
    }

    // If our final result is undefined, we should return the default
    return item === undefined ? def : item;
}

// Multi-layer set
// ---------------
//
// Recursively sets a deep path from an object
//
// let obj = {bar: {baz: 1}}
// set(obj, 'bar.baz', 2)
// obj.bar.baz -> 1

function _set(item, path, value) {
    path = path.split('.');

    // Loop through each section of our key path except the last
    for (var i = 0; i < path.length - 1; i++) {

        // Get the next item down
        item = item[path[i]];

        // If we have an object, we're good
        if (isobject(item)) {
            continue;
            // Otherwise, there's nothing to set our key on
        } else {
            throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
        }
    }

    // Do the set on the retrieved object with our value
    item[path[path.length - 1]] = value;
}

// Loop through object
// -------------------
//
// Loop an object and apply a function for each key/value
//
// let ob = {a: 1, b: 2, c: 3}
// each(ob, console.log) -> a 1  b 2  c 3

function each(ob, callback) {
    for (var key in ob) {
        if (ob.hasOwnProperty(key)) {
            callback.call(ob, key, ob[key]);
        }
    }
}

// Gey keys of object
// ------------------
//
// Shim for Object.keys if it does not already exist
//
// let ob = {a: 1, b: 2, c: 3}
// keys(ob) -> ['a', 'b', 'c']

function _keys(ob) {

    if (Object.keys) {
        return Object.keys(ob);
    }

    var result = [];

    for (var key in ob) {
        if (ob.hasOwnProperty(key)) {
            result.push(key);
        }
    }

    return result;
}

// Create a base class that can be inherited from
// ----------------------------------------------
//
// This is the public interface to the Class module.
// All classes with extend from Class and be provided with a set of base convenience methods.

var $Class = exports.$Class = extend('Class', {

    init: function init() {
        // Empty init class, so calls to _super can be safely made
    },

    get: function get(path, def) {
        return _get(this, path, def);
    },

    set: function set(path, value) {
        _set(this, path, value);
    },

    setProperties: function setProperties() {
        transpose(this, arguments);
    },

    forEach: function forEach(callback) {
        each(this, callback);
    },

    keys: function keys() {
        return _keys(this);
    }
});

$Class.get = _get;
$Class.set = _set;
$Class.keys = _keys;

angular.value("$Class", $Class);

/***/ }),

/***/ "../node_modules/squid/dist/core/config.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var $meta = exports.$meta = window.meta || {};
var $cookies = exports.$cookies = window.cookies || {};
var $config = exports.$config = window.config || {};
angular.value("$meta", $meta);
angular.value("$cookies", $cookies);
angular.value("$config", $config);

/***/ }),

/***/ "../node_modules/squid/dist/core/dom.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$dom = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var $dom = exports.$dom = {

    elementReady: function elementReady(id) {

        return _promise.$promise.resolver(function (resolve, reject) {

            if (document.getElementById(id)) {
                return resolve();
            }

            var interval = setInterval(function () {
                if (document.getElementById(id)) {
                    clearInterval(interval);
                    return resolve();
                }
            }, 10);

            setTimeout(60000, reject);
        });
    },

    loadScript: function loadScript(name, src, timeout) {
        var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        return _promise.$promise.resolver(function (resolve, reject) {
            var script = document.createElement('script');
            var loadTimeout = void 0;

            function clearScriptLoadTimeout() {
                if (loadTimeout) {
                    clearTimeout(loadTimeout);
                    loadTimeout = undefined;
                }
            }

            script.onload = function () {
                clearScriptLoadTimeout();
                setTimeout(resolve, 10);
            };

            // For Internet explorer 8 support
            script.onreadystatechange = function () {
                if (this.readyState === 'complete' || this.readyState === 'loaded') {
                    clearScriptLoadTimeout();
                    setTimeout(resolve, 10);
                }
            };

            script.onerror = function (event) {
                _logger.$logger.info('script_error', {
                    script: src
                });
                return reject(new Error(name + '_loading_error'));
            };

            if (timeout) {
                loadTimeout = setTimeout(function () {
                    _logger.$logger.info('script_load_timedout', {
                        script: src
                    });
                    return reject(new Error(name + '_loading_timed_out'));
                }, timeout);
            }

            script.setAttribute('src', src);

            for (var _iterator = Object.keys(attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var attribute = _ref;

                script.setAttribute(attribute, attributes[attribute]);
            }

            document.body.appendChild(script);
        });
    },

    cssReady: function cssReady(id) {

        var el = document.getElementById(id);

        return _promise.$promise.resolver(function (resolve, reject) {

            var timeout = void 0;
            var interval = void 0;

            function check() {
                _util.$util.forEach(document.styleSheets, function (stylesheet) {
                    if (stylesheet.href === el.href) {
                        clearInterval(interval);
                        clearTimeout(timeout);
                        resolve();
                    }
                });
            }

            timeout = setTimeout(function () {
                clearInterval(interval);
                reject();
                throw new Error('css_loading_timed_out');
            }, 30000);

            interval = setInterval(check, 20);
            check();
        });
    }
};

angular.value("$dom", $dom);
_logger.$logger;

_promise.$promise;

_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$BatchShortCircuit = exports.$ShortCircuit = exports.$FallbackError = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
    var message = _ref[0],
        file = _ref[1],
        line = _ref[2],
        col = _ref[3],
        err = _ref[4];


    original();

    _event.$event.emit('$windowError', {
        message: message && (message.stack || message).toString(),
        file: file && file.toString(),
        line: line && line.toString(),
        col: col && col.toString(),
        stack: err && (err.stack || err).toString()
    });
});

var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {

    construct: function construct(err, properties) {

        if (err instanceof Error) {
            err = err.message;
        }

        if (properties) {
            _util.$util.extend(this, properties);
        }

        this.payload = properties;

        this.message = err;
    }
});

var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
    handle: function handle(handlers) {
        var handler = handlers[this.message] || handlers['DEFAULT'];

        if (handler) {
            var result = handler.call(this, this.message, this);

            if (typeof result !== 'undefined') {
                return result;
            }
            return true;
        }
    }
});

var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');

var $ApiError = exports.$ApiError = $Error.extend('$ApiError');

var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
    init: function init() {
        this.reason = this.reason || '';
        this.product = this.product || '';
        this.entryPoint = this.entryPoint || '';
    }
});

/**
 * $ShortCircuit should be thrown if you want to bypass the remainder of a promise chain, and you've already
 * done error handling for the rejection. It should be handled with a no-op in app's $exceptionHandler
 */
var $ShortCircuit = exports.$ShortCircuit = $Error.extend('$ShortCircuit');

// TO-BE-DEPRECATED: Use $ShortCircuit instead
var $BatchShortCircuit = exports.$BatchShortCircuit = $ShortCircuit;

angular.value("$Error", $Error);
angular.value("$Contingency", $Contingency);
angular.value("$Forbidden", $Forbidden);
angular.value("$ApiError", $ApiError);
angular.value("$FallbackError", $FallbackError);
angular.value("$ShortCircuit", $ShortCircuit);
angular.value("$BatchShortCircuit", $BatchShortCircuit);
_event.$event;

_class.$Class;

_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/event.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$event = undefined;

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var handlers = {};

var customEventEmitter = void 0;

var $event = exports.$event = {
    use: function use(eventEmitter) {
        customEventEmitter = eventEmitter;

        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var eventName = _ref;

            if (handlers[eventName]) {
                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref2;

                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }

                    var handler = _ref2;

                    customEventEmitter.on(eventName, handler);
                }
            }
        }
    },
    on: function on(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.on(eventName, method);
        }

        handlers[eventName] = handlers[eventName] || [];
        handlers[eventName].push(method);

        var cancelled = false;

        function cancel() {
            if (!cancelled) {
                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
                cancelled = true;
            }
        }

        cancel.cancel = cancel;
        return cancel;
    },
    once: function once(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.once(eventName, method);
        }

        var listener = $event.on(eventName, function () {
            listener.cancel();
            return method.apply(this, arguments);
        });

        return listener;
    },
    emit: function emit(eventName) {
        if (customEventEmitter) {
            var _customEventEmitter;

            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
        }

        var event = {
            preventDefault: function preventDefault() {
                event.defaultPrevented = true;
            }
        };

        if (handlers[eventName]) {
            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }

                var handler = _ref3;

                handler.apply(this, [event].concat(Array.prototype.slice.call(arguments)));
            }
        }

        return event;
    },
    broadcast: function broadcast(eventName) {

        if (customEventEmitter) {
            var _customEventEmitter2;

            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
        }

        return $event.emit.apply($event, arguments);
    },


    refCount: function refCount($scope, start, stop) {
        return _promise.$promise.resolver(function (resolve) {

            var count = 0;

            var cancelStartListener = $scope.$on(start, function (event, data) {
                count += 1;
            });

            var cancelStopListener = $scope.$on(stop, function (event, data) {
                setTimeout(function () {
                    count -= 1;
                    res(); // eslint-disable-line no-use-before-define
                }, 50);
            });

            function res() {
                if (!count) {

                    if (cancelStartListener && cancelStopListener) {
                        cancelStartListener();
                        cancelStopListener();
                    }

                    return resolve();
                }
            }

            setTimeout(res, 50);
        });
    },

    compose: function compose(start, end, startAll, endAll) {
        var debounce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


        var count = 0;
        var active = false;

        $event.on(start, function () {
            if (!count) {
                setTimeout(function () {
                    if (count && !active) {
                        active = true;
                        $event.emit(startAll);
                    }
                }, debounce);
            }

            count += 1;
        });

        $event.on(end, function () {

            setTimeout(function () {
                count -= 1;

                if (!count && active) {
                    active = false;
                    $event.emit(endAll);
                }
            }, 0);
        });

        return {
            getCount: function getCount() {
                return count;
            },
            isActive: function isActive() {
                return Boolean(count);
            },
            reset: function reset() {
                count = 0;
            }
        };
    }
};

angular.value("$event", $event);
_promise.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/core/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _api = __webpack_require__("../node_modules/squid/dist/core/api.js");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

Object.keys(_class).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _class[key];
    }
  });
});

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

Object.keys(_event).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _event[key];
    }
  });
});

var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");

Object.keys(_integration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _integration[key];
    }
  });
});

var _model = __webpack_require__("../node_modules/squid/dist/core/model.js");

Object.keys(_model).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _model[key];
    }
  });
});

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

Object.keys(_promise).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _promise[key];
    }
  });
});

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});

var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");

Object.keys(_loader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _loader[key];
    }
  });
});

var _dom = __webpack_require__("../node_modules/squid/dist/core/dom.js");

Object.keys(_dom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dom[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/core/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$integration = exports.$CONTEXT = exports.$DEFAULT = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var $DEFAULT = exports.$DEFAULT = 'DEFAULT';

var $CONTEXT = exports.$CONTEXT = {

    // Full page checkout
    FULLPAGE: 'FULLPAGE',

    // Checkout in popup
    POPUP: 'POPUP',

    // Checkout in lightbox (iframe)
    LIGHTBOX: 'LIGHTBOX',

    // Web view
    WEBVIEW: 'WEBVIEW',

    // Native checkout
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};

var $integration = exports.$integration = {

    flow: $DEFAULT,

    init: function init(flow, config) {
        this.config = config || {};

        if (flow) {
            this.setFlow(flow);
        }

        this.setContext(this.getContext());
    },
    getContext: function getContext() {

        if (this.isIFrame()) {
            return $CONTEXT.LIGHTBOX;
        } else if (this.isPopup()) {
            return $CONTEXT.POPUP;
        } else {
            return $CONTEXT.FULLPAGE;
        }
    },
    isPopup: function isPopup() {
        return Boolean(window.opener);
    },
    isIFrame: function isIFrame() {
        return window.top !== window.self;
    },
    setContext: function setContext(context) {
        _logger.$logger.info('integration_context_' + context);
        this.context = context;
    },
    setFlow: function setFlow(flow) {
        _logger.$logger.info('integration_flow_' + flow);
        this.flow = flow;
    },
    is: function is(context, flow) {
        return this.isContext(context) && this.isFlow(flow);
    },
    isContext: function isContext(context) {
        return this.context === context;
    },
    isFlow: function isFlow(flow) {
        return this.flow === flow;
    },
    getConfig: function getConfig(key) {

        this.context = this.getContext();

        if (!this.config) {
            return;
        }

        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {

            return this.config[this.context][this.flow][key];
        }

        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {

            return this.config[this.context][key];
        }

        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {

            return this.config[$DEFAULT][this.flow][key];
        }

        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {

            return this.config[$DEFAULT][key];
        }
    },
    error: function error(message) {
        return new Error('Integration error: ' + this.context + ' / ' + this.flow + ' :: ' + message);
    }
};

angular.value("$DEFAULT", $DEFAULT);
angular.value("$CONTEXT", $CONTEXT);
angular.value("$integration", $integration);
_logger.$logger;

/***/ }),

/***/ "../node_modules/squid/dist/core/loader.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$loader = undefined;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _firstLoad = false;

var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded', 100);

var $loader = exports.$loader = {

    isLoading: function isLoading() {
        return Boolean(loader.getCount());
    },
    firstLoad: function firstLoad() {
        return _firstLoad;
    },
    reset: function reset() {
        loader.reset();
    }
};

_event.$event.on('allLoaded', function () {
    _firstLoad = true;
});

angular.value("$loader", $loader);
_event.$event;

/***/ }),

/***/ "../node_modules/squid/dist/core/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Model = undefined;

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var $Model = exports.$Model = _class.$Class.extend('$Model', {

    init: function init() {

        if (this.keys().length) {
            this.onPopulate();
        }

        if (this.id) {
            var _cache = this.constructor._modelCache = this.constructor._modelCache || {};

            _cache[this.id] = this;
        }

        this.meta = {
            populated: false
        };
    },

    /**
     * Add the passed in properties to this Model.
     * Sets the meta.populated to true. This flag
     * can be used later to determine if the model is populated.
     * Calls onPopulate() in the end.
     */
    populate: function populate() {

        this.meta.populated = true;
        this.setProperties.apply(this, arguments);
        delete this.meta.invalidated;
        this.onPopulate();
        return this;
    },

    fetchChildren: function fetchChildren() {
        return _promise.$promise.resolve();
    },

    /**
     * Override this method, to execute any logic after model is populated.
     */
    onPopulate: function onPopulate() {// eslint-disable-line no-empty-function

    },

    /**
     * Override this method, to execute any logic after model is invalidated.
     */
    onInvalidate: function onInvalidate() {// eslint-disable-line no-empty-function

    },

    /**
     * Override this method to return a Mock instance. Must return a promise which resolves to model.
     */
    fetchMock: function fetchMock() {// eslint-disable-line no-empty-function

    },

    /**
     * Retrieves the model.
     *
     * If model is already populated just returns a promise which resolves to `this`
     * If there is a retriever for this model, then return the retreiver.
     * Else calls the api to retrieve the model.
     *
     * @param options
     * @returns {*}
     */
    retrieve: function retrieve(options) {
        var self = this;

        options = options || {};

        if (self.meta.populated) {

            if (options.success) {
                return _promise.$promise.resolve(options.success(self));
            }

            return _promise.$promise.resolve(this);
        }

        if (this.retriever) {
            return this.retriever;
        }

        if (!this.api) {
            throw new Error('Tried to populate a model with no api');
        }

        options.model = this;

        this.retriever = this.api.retrieve(options).then(function (res) {
            return self;
        })['finally'](function () {
            delete self.retriever;
        });

        return this.retriever;
    },

    /**
     * Calls a post on the api to save this model. Takes options as parameters.
     * options will passed down to api.post.
     *
     * @param options
     * @returns {*|HttpPromise}
     */
    save: function save(options) {
        options = options || {};
        options.model = this;

        options.data = options.data || this.serialize();

        return this.api.post(options);
    },

    /**
     * Calls Api.action to perform any action on the model.
     *
     * Takes action name and optional 'options' object as parameters.
     *
     * Ex: $CheckoutSession.actions('create', [options])
     *
     * @param action
     * @param options
     * @returns {*}
     */
    action: function action(_action, options) {
        options = options || {};
        options.model = this;

        return this.api.action(_action, options);
    },

    /**
     * Use this method to force a api call to get the data.
     *
     * @param options
     * @returns {*}
     */
    reload: function reload(options) {
        this.meta.populated = false;
        return this.retrieve(options);
    },

    stringify: function stringify() {
        return JSON.stringify(this, 2);
    },

    log: function log() {
        console.log(this.stringify());
    },

    serialize: function serialize() {// eslint-disable-line no-empty-function

    },

    /**
     * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
     */
    invalidate: function invalidate() {
        this.meta.populated = false;
        this.meta.invalidated = true;
        this.onInvalidate();
    },

    /**
     * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
     *
     * @param Cls
     * @param child
     * @returns {*}
     */
    child: function child(Cls, _child) {

        if (!_child) {
            return;
        }

        return Cls.create(_child.id || this.id, { parent: this }).populate(_child);
    },

    /**
     *
     * @param Cls
     * @param children
     * @returns {*}
     */
    children: function children(Cls, _children) {
        var self = this;

        if (!_children) {
            return _children;
        }

        return _util.$util.map(_children, function (child) {
            return self.child(Cls, child);
        });
    }
});

var cache = {};

$Model.reopenClass({

    instance: function instance(id) {

        var modelCache = cache[this.id] = cache[this.id] || {};
        var instance = modelCache[id || 0] || this.create.apply(this, arguments);

        return instance;
    },

    retrieveInstance: function retrieveInstance() {
        return this.instance.apply(this, arguments).retrieve();
    },

    create: function create(id) {

        var modelCache = cache[this.id] = cache[this.id] || {};
        var instance = modelCache[id || 0] = new this({ // eslint-disable-line new-cap
            id: id || 0
        });

        instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));

        return instance;
    },

    fetch: function fetch() {
        console.warn('Model.fetch is deprecated, please use Model.instance');
        return this.instance.apply(this, arguments);
    },

    clearCache: function clearCache() {
        cache = {};
    },

    /**
     * should invalidate all models where the invalidationKey is found truthy
     *
     * invalidationKey: key of type string to look for in a model
     * example: $Model.bulkInvalidate('invalidateOnLogout');
     */
    bulkInvalidate: function bulkInvalidate(invalidationKey) {
        if (!invalidationKey) {
            return;
        }
        _util.$util.forEach(cache, function (modelCache, key) {
            _util.$util.forEach(modelCache, function (modelInstance, instanceId) {
                if (modelInstance[invalidationKey]) {
                    modelInstance.invalidate();
                }
            });
        });
    }
});

angular.value("$Model", $Model);
_class.$Class;

_util.$util;

_promise.$promise;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/core/promise.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$promise = $promise;

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

var Promise = window.Promise;

function $promise(obj) {
    return Promise.resolve(obj);
}

_util.$util.extend($promise, {
    use: function use(CustomPromise) {
        Promise = CustomPromise;
        if (!window.Promise) {
            window.Promise = CustomPromise;
        }
    },
    resolver: function resolver(method) {
        return new Promise(method);
    },
    resolve: function resolve(value) {
        return Promise.resolve(value);
    },
    reject: function reject(value) {
        return Promise.reject(value);
    },


    run: function run(method) {
        return Promise.resolve().then(method);
    },

    call: function call(method) {
        return Promise.resolve().then(method);
    },

    sequential: function sequential(methods) {

        var prom = Promise.resolve();

        _util.$util.forEach(methods, function (method) {
            prom = prom.then(method);
        });

        return prom;
    },

    sleep: function sleep(time) {
        return new Promise(function (resolve) {
            setTimeout(resolve, time);
        });
    },

    map: function map(items, method) {

        var promises = void 0;

        if (items instanceof Array) {
            promises = [];
        } else if (items instanceof Object) {
            promises = {};
        } else {
            return Promise.resolve();
        }

        return this.all(_util.$util.map(items, function (item, key) {

            promises[key] = Promise.resolve(item).then(function (result) {
                return method(result, key, promises);
            });

            return promises[key];
        }));
    },

    all: function all(items) {

        if (items instanceof Array) {
            return Promise.all(items);
        } else if (items instanceof Object) {
            return this.hash(items);
        }

        return Promise.resolve([]);
    },

    hash: function hash(obj) {
        var results = {};

        return Promise.all(_util.$util.map(obj, function (item, key) {
            return Promise.resolve(item).then(function (result) {
                results[key] = result;
            });
        })).then(function () {
            return results;
        });
    },

    extend: function extend(obj, hash) {
        return this.hash(hash || {}).then(function (data) {
            _util.$util.extend(obj, data);
        });
    },

    attempt: function attempt(attempts, method) {

        attempts -= 1;

        return Promise.resolve().then(function () {
            return method(attempts);
        })['catch'](function (err) {

            if (attempts) {
                return $promise.attempt(attempts, method);
            }

            return Promise.reject(err);
        });
    },

    debounce: function debounce(method, time) {

        var timeout = void 0;
        var resolvers = {};

        return function () {

            var self = this;
            var args = arguments;
            var key = JSON.stringify(args);

            resolvers[key] = resolvers[key] || [];

            return new Promise(function (resolve) {
                resolvers[key].push(resolve);
                clearTimeout(timeout);

                timeout = setTimeout(function () {

                    var result = method.apply(self, args);

                    _util.$util.forEach(resolvers[key], function (resolver) {
                        resolver(result);
                    });

                    delete resolvers[key];
                }, time);
            });
        };
    },

    every: function every(collection, handler) {
        return this.map(collection, function (item) {
            return handler(item);
        }).then(function (results) {
            return _util.$util.every(results);
        });
    },

    providing: function providing(condition, handler) {
        return Promise.resolve(condition).then(function (result) {
            if (result) {
                return handler(result);
            }
        });
    },

    until: function until(condition, pollTime, timeout, alwaysResolve) {

        return new Promise(function (resolve, reject) {
            if (condition()) {
                return resolve();
            }

            var interval = setInterval(function () {
                if (condition()) {
                    clearInterval(interval);
                    return resolve();
                }
            }, pollTime);

            if (timeout) {
                setTimeout(function () {
                    clearInterval(interval);
                    return alwaysResolve ? resolve() : reject();
                }, timeout);
            }
        });
    },

    first: function first(handlers) {

        var prom = $promise.resolve();
        var result = void 0;

        _util.$util.forEach(handlers, function (handler) {
            prom = prom.then(function () {
                return result || handler();
            }).then(function (handlerResult) {
                result = handlerResult;
                return result;
            });
        });

        return prom;
    },

    shortCircuit: function shortCircuit() {
        return $promise.reject(new _error.$ShortCircuit());
    }
});

angular.value("$promise", $promise);
_util.$util;

_error.$ShortCircuit;

/***/ }),

/***/ "../node_modules/squid/dist/core/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$unresolved = exports.$util = exports.isUnsafeRedirect = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.$getRedirectUrl = $getRedirectUrl;
exports.$dispatch = $dispatch;
exports.$experiment = $experiment;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var redirected = false;
var paramCache = {};

var blacklist = ['password', 'pr_password'];
var blacklistRegex = new RegExp('(' + blacklist.join('|') + ')=([^&]*)', 'g');
var sanitizeUrlForLogging = function sanitizeUrlForLogging(inputUrl) {
    return inputUrl.replace(blacklistRegex, function (match, key, value) {
        return key + '=**';
    });
};

var isUnsafeRedirect = exports.isUnsafeRedirect = function isUnsafeRedirect(url) {
    return url.toLowerCase().replace(/\s/g, '').indexOf('javascript:') !== -1;
}; // eslint-disable-line no-script-url

var $util = exports.$util = {

    forEach: function forEach(collection, method) {
        if (collection instanceof Array) {
            for (var i = 0; i < collection.length; i++) {
                method(collection[i], i);
            }
        } else if (collection instanceof Object) {
            for (var key in collection) {
                if (collection.hasOwnProperty(key)) {
                    method(collection[key], key);
                }
            }
        }
    },

    idleTimeout: function idleTimeout(time) {
        setTimeout(function () {
            _logger.$logger.info('page_idle');
            $util.reload();
        }, time);
    },


    reload: function reload() {
        _logger.$logger.info('reload');
        _event.$event.emit('loading');
        location.reload();
    },

    /**
     * replace:
     * Insert URL params provided and reload the window
     * This does not find the param if it already exists in the URL. It will add it again
     * @param params {Object} param - Params to add as URL params
     */
    replace: function replace(params) {
        if (params) {
            // Note: This won't replace the
            var url = $util.buildURL(location.href.split('#')[0], params);

            url = '' + url + window.location.hash;

            _logger.$logger.info('replace', { url: url });
            _event.$event.emit('loading');
            location.replace(url);
        } else {
            $util.reload();
        }
    },

    /**
    * redirect:
    * Redirects user to the given Url with options for different redirect behaviours
    * @param params {String} url - redirect url
    * @param params {Object} options - Optional param can have flags effecting behaviour of redirect
    */
    redirect: function redirect(url, options) {

        // optional flag to allow an iframe to Bust out of iframe mode by setting window.top.location = window.location.href
        var frameBust = options && options.frameBust;

        // Optional flag for url to not show up in browsing history. Handles back button scenario from CAPE to HERMES
        var replace = options && options.replace;

        if (isUnsafeRedirect(url)) {
            // eslint-disable-line
            _logger.$logger.error('unsafe_redirect_url', {
                url: url
            });
            throw new Error('Unsafe redirect url: ' + url);
        }

        _logger.$logger.info('redirect', {
            url: sanitizeUrlForLogging(url)
        });

        _event.$event.on('$stateChangeStart', function (event) {
            if (_angular.$rootScope.allowStateChangeAfterRedirect) {
                // at this point flow redirected buyer to return url. The return url did not display any page.
                // So, the review page/xoon sign up page with spinner(processing) will not be cleared giving impression that PayPal is still processing
                // At this time, we redirect buyer to a generic message page indicating that PayPal's processing is finished
                _logger.$logger.info('allow_state_change_after_redirect');
                _event.$event.emit('loaded');
                return;
            }
            _logger.$logger.info('state_change_after_redirect');
            event.preventDefault();
        });

        function redir() {

            if (redirected) {
                _logger.$logger.info('redirected');
                return;
            }

            _logger.$logger.info('redir', {
                url: sanitizeUrlForLogging(url)
            });

            window.onunload = window.onbeforeunload = function () {}; // eslint-disable-line no-empty-function

            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false || frameBust) {
                if (replace) {
                    _logger.$logger.info('windowLocationReplace', {
                        redirecTop: _integration.$integration.getConfig('REDIRECT_TOP'),
                        frameBust: frameBust
                    });
                    window.top.location.replace(url);
                } else {
                    _logger.$logger.info('windowTopLocation', {
                        redirecTop: _integration.$integration.getConfig('REDIRECT_TOP'),
                        frameBust: frameBust
                    });
                    window.top.location = url;
                }
            } else if (replace) {
                _logger.$logger.info('windowLocationReplace');
                window.location.replace(url);
            } else {
                _logger.$logger.info('windowLocation');
                window.location = url;
            }

            redirected = true;
        }

        _event.$event.emit('loading');

        _logger.$logger.flush().then(redir);
        setTimeout(redir, 500);

        _logger.$logger.done();
    },

    cookiesEnabled: function cookiesEnabled() {
        var cookiesEnabled = void 0;

        document.cookie = '_cookiecheck=1';
        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        return cookiesEnabled;
    },

    storageEnabled: function storageEnabled(api) {
        try {
            window[api].setItem('__feature_test__', '0');
            window[api].removeItem('__feature_test__');
            return true;
        } catch (e) {
            return false;
        }
    },

    sessionStorageEnabled: function sessionStorageEnabled() {
        return this.storageEnabled('sessionStorage');
    },

    localStorageEnabled: function localStorageEnabled() {
        return this.storageEnabled('localStorage');
    },

    params: function params(string) {

        if (typeof string !== 'string') {
            string = this.queryString().slice(1);
        }

        var params = {};

        if (!string) {
            return params;
        }

        if (paramCache[string]) {
            return $util.extend({}, paramCache[string]);
        }

        $util.forEach(string.split('&'), function (pair) {
            pair = pair.split('=');

            if (pair[0]) {
                params[decodeURIComponent(pair[0])] = pair[1] && decodeURIComponent(pair[1]);
            }
        });

        paramCache[string] = params;

        return params;
    },

    queryString: function queryString() {
        if (window.location.search) {
            return window.location.search;
        } else {
            var string = window.location.href;
            var idx = string.indexOf('&');
            var rIdx = string.lastIndexOf('#');

            if (idx) {
                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
            }
        }
        return '';
    },

    queryStringSplice: function queryStringSplice(qs, insert, remove) {
        if (qs.indexOf('?') === 0) {
            qs = qs.slice(1);
        }

        var params = $util.extend(this.params(qs), insert);

        $util.forEach(remove, function (key) {
            delete params[key];
        });

        return '?' + this.paramToQueryString(params);
    },

    extend: function extend(obj, source) {

        if (!source) {
            return obj;
        }

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                obj[key] = source[key];
            }
        }

        return obj;
    },


    paramToQueryString: function paramToQueryString(params) {
        return this.filter(this.map(Object.keys(params).sort(), function (key) {
            if (!params[key]) {
                return;
            }

            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        })).join('&');
    },

    param: function $param(name) {
        return this.params()[name];
    },

    hashParam: function hashParam(name) {
        return this.params(window.location.hash.slice(1))[name];
    },

    base64Decode: function base64Decode(encodedString) {
        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    base64Encode: function base64Encode(decodedString) {
        return decodedString && window.btoa(decodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    /*
     * decodeAndParse :
     * 1 - Base64Decode
     * 2 - URI Decode
     * 3 - Split string into a nvp object
     * return obj
     */
    decodeAndParse: function decodeAndParse(encodedString) {
        if (encodedString) {
            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
        }
    },

    assert: function $assert(value, message, payload) {
        if (!value) {
            throw new Error(message, payload || {});
        }
    },

    map: function $map(array, method) {

        array = array || [];

        var results = void 0;

        if (array instanceof Array) {
            results = [];

            $util.forEach(array, function () {
                results.push(method.apply(this, arguments));
            });

            return results;
        } else if (array instanceof Object) {

            results = {};

            $util.forEach(array, function (val, key) {
                results[key] = method.apply(this, arguments);
            });

            return results;
        } else {
            throw new Error('$util.map expects array or object');
        }
    },

    filter: function $filter(array, method) {
        method = method || Boolean;
        var results = [];

        $util.forEach(array, function (item) {
            if (method.apply(this, arguments)) {
                results.push(item);
            }
        });

        return results;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#find()
     * If you have an object, use the lodash or underscore .find() method
     *
     * @deprecated
     */
    find: function $find(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.find() is deprecated, use Array#find, which we have polyfilled, or _.find() for Objects instead.');
        }

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return array[i];
            }
        }
    },

    findIndex: function $find(array, method) {

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return i;
            }
        }
    },

    range: function range(start, end) {
        if (!end) {
            end = start;
            start = 0;
        }

        var result = [];

        for (var i = start; i < end; i++) {
            result.push(i);
        }

        return result;
    },

    pad: function $pad(string, n, char) {

        n = n || 0;
        char = char || '0';

        var padding = Array(n + 1).join(char.toString());

        return (padding + string).slice(-n);
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#some() -- NOTE: Unlike Array#some(),
     * the return value of $util.some() isn't always a Boolean. It's return value
     * is whatever the passed callback returns. If you are using $util.some to
     * find an object in an array then you need to use $util.find instead of Array#some().
     * Ex:
     *      1. const preferredCard = $util.some(cardsArray, cards => card.isPreferred && card);
     *          preferredCard will be the preferred card object or undefined if there isn't a
     *          preferred card.
     *      2. const hasPreferred = cardsArray.some(cards => card.isPreferred && card);
     *          Taking the code from #1 and simply swapping out $util.some for Array#some()
     *          will result in a different return value, in this case the Boolean true if
     *          there is a preferred card, otherwise false. In this case, instead of using
     *          Array#some() you should use $util.find() (Array#find() isn't supported in IE9)
     *          as seen below:
     *         const preferredCard = $util.find(cardsArray, card => card.isPreferred);
     *
     * If you have an object, use the lodash or underscore .some() method
     *
     * @deprecated
     */
    some: function $some(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.some() is deprecated, use Array#some (use $util.find() if you are using\n                        $util.some() to return someting other than a boolean) or lodash/underscore.some() instead.');
        }

        var result = void 0;

        $util.forEach(array, function (item, key) {
            if (!result) {
                result = method(item, key);
            }
        });

        return result;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#every()
     * If you have an object, use the lodash or underscore .every() method
     *
     * @deprecated
     */
    every: function $every(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.every() is deprecated, use Array#every, which we have polyfilled, or _.every() for Objects instead.');
        }

        method = method || Boolean;

        var result = true;

        $util.forEach(array, function (item) {
            if (!method(item)) {
                result = false;
            }
        });

        return result;
    },

    reduce: function $reduce(array, method, intial) {
        $util.forEach(array, function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            intial = method.apply(undefined, [intial].concat(args));
        });

        return intial;
    },

    isPopup: function isPopup() {
        return _integration.$integration.isPopup();
    },

    isIFrame: function isIFrame() {
        return _integration.$integration.isIFrame();
    },

    buildURL: function buildURL(url, params) {
        /*
         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
         */
        this.assert(url, 'buildURL :: expected url');

        var paramKeys = Object.keys(params || {});

        if (JSON.stringify(params) === '{}') {
            return url;
        }

        if (!paramKeys.length) {
            return url;
        }

        if (url.indexOf('?') === -1) {
            url += '?';
        } else {
            url += '&';
        }

        url += this.paramToQueryString(params);

        return url;
    },

    paypalURL: function paypalURL(url, params) {
        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;

        return this.buildURL(url, params);
    },

    override: function override(obj, methodName, handler) {
        var existing = obj[methodName];

        obj[methodName] = function () {
            if (existing) {
                try {
                    existing.apply(obj, arguments);
                } catch (err) {
                    _logger.$logger.error(methodName + 'event_error', {
                        error: err.toString
                    });
                }
            }

            return handler.apply(obj, arguments);
        };
    },

    result: function result(method) {
        return method();
    },

    memoize: function memoize(method) {

        function memoized() {
            var key = JSON.stringify(arguments, function (_, value) {
                switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
                    case 'function':
                        throw new Error('Cannot memoize functional arguments');
                    case 'undefined':
                        return 'undefined';
                    default:
                        return value;
                }
            });

            if (!memoized.cache.hasOwnProperty(key)) {
                memoized.cache[key] = method.apply(this, arguments);
            }

            return memoized.cache[key];
        }

        memoized.cache = {};

        memoized.flush = function () {
            memoized.cache = {};
        };

        return memoized;
    },

    now: function now() {
        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
    },

    bindObject: function bindObject(obj, self) {
        return $util.map(obj, function (method) {
            return method.bind(self);
        });
    },

    hashStr: function hashStr(str) {
        var hash = 0;
        var i = void 0;
        var chr = void 0;
        var len = void 0;

        if (str.length === 0) {
            return hash;
        }
        for (i = 0, len = str.length; i < len; i++) {
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
            // Convert to 32bit integer
            hash |= 0; // eslint-disable-line no-bitwise
        }
        return Math.abs(hash);
    },

    hash: function hash() {
        return this.hashStr(Math.random());
    },

    popup: function popup(name, url, options, callback) {

        callback = $util.once(callback);

        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
            return key + '=' + options[key];
        }).join(', '));

        var interval = void 0;

        function checkWindowClosed() {
            if (win.closed) {
                clearInterval(interval);
                callback();
            }
        }

        interval = setInterval(checkWindowClosed, 50);
        setTimeout(checkWindowClosed);

        try {
            var close = win.close;

            win.close = function () {
                close.apply(this, arguments);
                checkWindowClosed();
            };
        } catch (err) {
            // pass
        }

        return win;
    },

    unique: function unique(collection) {
        return collection.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    },

    monkeyPatch: function monkeyPatch(mod, prop, method) {
        var original = mod[prop];

        mod[prop] = function () {
            var _this = this,
                _arguments = arguments;

            return method.call(this, arguments, function (self, args) {
                if (original) {
                    return original.apply(self || _this, args || _arguments);
                }
            });
        };
    },
    once: function once(method) {
        var called = false;

        return function () {
            if (!called) {
                called = true;
                return method.apply(this, arguments);
            }
        };
    },
    camelToDasherize: function camelToDasherize(string) {
        return string.replace(/([A-Z])/g, function (g) {
            return '-' + g.toLowerCase();
        });
    },
    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
        return string.replace(/([a-z][A-Z])/g, function (g) {
            return g[0] + '_' + g[1];
        }).toUpperCase();
    },
    dasherizeToCamel: function dasherizeToCamel(string) {
        return string.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
    },


    parentWindow: function parentWindow() {
        if (window.opener) {
            return window.opener;
        } else if (window.parent !== window) {
            return window.parent;
        }
    },

    hasRTL: function hasRTL(str) {
        return new RegExp('[\u0590-\u07BF]').test(str);
    },
    noop: function noop() {// eslint-disable-line no-empty-function

    },


    /**
     * @function isObject - tests to see if a passed argument is an Object. Returns `false`
     *      for anything that is 'object-like' but not an actual Object (Array, Set, Map, ect)
     *      as well as for `null` and `Object.create(null)`
     * @param {*} o
     * @returns {boolean}
     */
    isObject: function isObject(o) {
        var oAsString = Object.prototype.toString.call(o);

        return o instanceof Object && oAsString === '[object Object]';
    },


    /**
     * @function debounce
     * @param {function} callback
     * @param {number} time
     * @returns {function}
     */
    debounce: function debounce(callback, time) {
        var timeout = void 0;

        return function () {
            var _this2 = this;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            var functionCall = function functionCall() {
                return callback.apply(_this2, args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(functionCall, time);
        };
    },


    /**
     * @function getProperty
     * @param {object} obj
     * @param {string} propString
     * @param {string} splitOn
     * @returns {*}
     *
     * Ex:
     *  const obj = {
     *      a: {
     *          b: {
     *              c: 'property c'
     *          },
     *          'key.with.periods': 10
     *      }
     *  };
     *  const c = $util.getProperty(obj, 'a.b.c'); // c === 'property c'
     *  const f = $util.getProperty(obj, 'a.b.c.d.e.f'); // f === undefined
     *  const fDefault = $util.getProperty(
     *      obj,
     *      'a.b.c.d.e.f',
     *      { default: 'default value for f' }
     *  ); // f === 'default value for f'
     *  const n = $util.getProperty(obj, 'a,b,key.with.periods', { splitOn: ',' }); // n === 10
     */
    getProperty: function getProperty(obj) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _options$splitOn = options.splitOn,
            splitOn = _options$splitOn === undefined ? '.' : _options$splitOn,
            defaultValue = options['default'];


        if (!this.isObject(obj) || typeof path !== 'string' || typeof splitOn !== 'string') {
            return;
        }

        var pathArray = path.split(splitOn);
        var prop = obj[pathArray.shift()];

        while (prop && pathArray.length && this.isObject(prop)) {
            prop = prop[pathArray.shift()];
        }

        return pathArray.length || prop === undefined ? defaultValue : prop;
    }
};

var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };

function $getRedirectUrl(product, params) {
    var url = '';
    var urlParams = $util.params();

    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
    }

    url += _config.$config.urls.fallbackUrl[product];

    $util.extend(urlParams, params || {});

    // cmd is a reserved slingshot param
    if (urlParams.cmd) {
        delete urlParams.cmd;
    }

    return $util.buildURL(url, urlParams);
}

function $dispatch(product, params, stateChange) {
    $util.assert(product, 'expected product');

    _logger.$logger.log('info', 'dispatch', {
        product: product
    });

    _event.$event.emit('loading');

    var url = '';

    url = $getRedirectUrl(product, params);

    // fire an event for xo-tracking to listen to and do fpti logging
    if (stateChange) {
        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
    }

    return $util.redirect(url);
}

function $experiment(name, sample, id, loggerPayload) {

    var throttle = $util.hashStr(name + '_' + id) % 100;

    var group = void 0;

    if ($util.param(name) === 'true') {
        group = 'test_forced';
    } else if ($util.param(name) === 'false') {
        group = 'control_forced';
    } else if (throttle < sample) {
        group = 'test';
    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
        // eslint-disable-line no-extra-parens
        group = 'control';
    } else {
        group = 'throttle';
    }

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: name,
        pxp_trtmnt_id: group
    });

    _logger.$logger.info(name + '_' + group, loggerPayload || {});

    if (group === 'test' || group === 'test_forced') {
        return true;
    } else if (group === 'control') {
        return false;
    }
}

angular.value("isUnsafeRedirect", isUnsafeRedirect);
angular.value("$util", $util);
angular.value("$unresolved", $unresolved);
angular.value("$getRedirectUrl", $getRedirectUrl);
angular.value("$dispatch", $dispatch);
angular.value("$experiment", $experiment);
_event.$event;

_logger.$logger;

_config.$config;

_config.$meta;

_integration.$integration;

_angular.$log;

_angular.$rootScope;

/***/ }),

/***/ "../node_modules/squid/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _ng = __webpack_require__("../node_modules/squid/dist/ng/index.js");

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");

Object.keys(_paypal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paypal[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/currency.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCurrencySymbol = exports.truncateCurrencyConversionString = undefined;
exports.roundingAndSeparators = roundingAndSeparators;
exports.formatCurrency = formatCurrency;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g'); // everything to do with currency formatting

// quick Griffin reference on currency format:
// ¤ : Currency Symbol = $
// # : Amount = 186432.431
// C : Currency Code = USD

var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
var ENDS_IN_WHITESPACE = new RegExp('\s$');
var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
var HUNDREDS_SPLITTER = /(\d)(?=(\d\d)+\d$)/g; // eslint-disable-line fasec/no-unsafe-regex

// This seems to be the only currency / locale specific exception in Griffin
var STYLE_EXCEPTION = {
    'tr TR TRY': '# ¤;-# ¤'
};

var AmountOnlyStyle = '#;-#'; // A currency style for number only. $9USD -> 9.00

// Griffin exceptions for separators at hundreds- xx,xx,xxx format
var HUNDREDS_SEPARATOR_EXCEPTION = ['IN', 'BT', 'MV', 'NP'];

var isObject = function isObject(param) {
    return Object.prototype.toString.call(param) === '[object Object]';
};

// Griffin "fuzzy logic"
// apparently if the symbol is at least "66% similar" to the code, ignore it
function maybeIgnoreSymbol(style, symbol, code) {

    // THIS IS NOT COMMUTATIVE
    function fuzzyMatch(code, symbol) {
        // eslint-disable-line no-shadow
        if (code === symbol) {
            return 100;
        } else {
            var codeParts = code.split('');
            var symbolParts = symbol.split('');
            var equivalency = codeParts.reduce(function (equiv, codePart) {
                var symbolPos = symbolParts.indexOf(codePart);

                if (symbolPos !== -1) {
                    symbolParts.splice(symbolPos, 1);
                    return equiv + 1;
                }
                return equiv;
            }, 0);
            var weight = equivalency / codeParts.length;

            return weight * 100;
        }
    }

    var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;

    return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
}

// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
// and thousand separators
function roundingAndSeparators(amountString, _ref, _ref2) {
    var lang = _ref.lang,
        country = _ref.country;
    var decimalPlaces = _ref2.decimalPlaces,
        dot = _ref2.dot,
        comma = _ref2.comma;

    var value = parseFloat(amountString);
    var truncate = decimalPlaces === 0;
    var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
    var exception = HUNDREDS_SEPARATOR_EXCEPTION.indexOf(country) > -1; // special exceptions
    var wholeString = exception ? amountParts[0].replace(HUNDREDS_SPLITTER, '$1,') : amountParts[0].replace(THOUSANDS_SPLITTER, comma);
    var decimalString = amountParts[1] || '00';

    return truncate ? wholeString : '' + wholeString + dot + decimalString;
}

// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
function forceCodeToRight(style) {
    var parts = CODE_IN_FRONT.exec(style) || [];
    var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
    var newStyle = style;

    // if CODE_IN_FRONT regex matches, array indexes -
    // [1] negative symbol plus whitespace, if any,
    // [2] the "C" plus any whitespace,
    // [3] whatever is after "C"
    if (parts.length === 4) {
        newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
    }

    return newStyle;
}

// deal with
// 1. exceptions for specific locales
// 2. positive and negative styles
// 3. griffin fuzzy logic
// 4. UED consistency logic
function getFinalStyle() {
    var styleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
    var _ref3 = arguments[1];
    var lang = _ref3.lang,
        country = _ref3.country;
    var _ref4 = arguments[2];
    var value = _ref4.value,
        _ref4$symbol = _ref4.symbol,
        symbol = _ref4$symbol === undefined ? '' : _ref4$symbol,
        code = _ref4.code;

    var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
    var currencyStyle = exception || styleString;

    var _currencyStyle$split = currencyStyle.split(';'),
        positiveStyle = _currencyStyle$split[0],
        negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;


    var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
    var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions

    return forceCodeToRight(griffinStyle);
}

// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
// and produce the final result.
//
// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
function applyCurrencyStyle(finalStyle, amountFormatted, _ref5) {
    var symbol = _ref5.symbol,
        code = _ref5.code,
        _ref5$wrapCodeInSpan = _ref5.wrapCodeInSpan,
        wrapCodeInSpan = _ref5$wrapCodeInSpan === undefined ? false : _ref5$wrapCodeInSpan;

    // the style will take care of negative symbol (see getFinalStyle function above)
    var absoluteAmountFormatted = amountFormatted.replace('-', '');

    // parallel operation is safer than serial replace
    return finalStyle.split('').map(function (char) {
        switch (char) {
            case 'C':
                return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
            case '¤':
                return symbol;
            case '#':
                return absoluteAmountFormatted;
            default:
                return char;
        }
    }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
}

/**
 * @function formatCurrency
 * @param {string|number} amount Amount can be a string or a number
 * @param {string} code
 * @param {boolean} wrapCodeInSpan
 * @param {string} [style=SymbolISOCurrency]
 * @returns {string} formatted currency string
 */
function formatCurrency(amount, code, wrapCodeInSpan) {
    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SymbolISOCurrency';

    if (isObject(amount) || typeof amount === 'undefined' || amount === null) {
        return;
    }

    var _ref6 = _locale.$locale.metadata || {},
        _ref6$number = _ref6.number,
        numberConfig = _ref6$number === undefined ? {} : _ref6$number,
        _ref6$currency = _ref6.currency,
        currencyConfig = _ref6$currency === undefined ? {} : _ref6$currency;

    var _currencyConfig$digit = currencyConfig.digits,
        digits = _currencyConfig$digit === undefined ? {} : _currencyConfig$digit,
        _currencyConfig$style = currencyConfig.styles,
        styles = _currencyConfig$style === undefined ? {} : _currencyConfig$style,
        _currencyConfig$suppo = currencyConfig.supportedSymbols,
        currencySymbols = _currencyConfig$suppo === undefined ? {} : _currencyConfig$suppo;

    var value = parseFloat(amount);

    styles.AmountOnlyStyle = AmountOnlyStyle;
    var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    var amountFormatted = roundingAndSeparators(amount.toString(), _locale.$locale, { decimalPlaces: digits[code], dot: dot, comma: comma });

    if (code) {
        var symbol = currencySymbols[code];
        var finalStyle = getFinalStyle(styles[style], _locale.$locale, { value: value, symbol: symbol, code: code });

        return applyCurrencyStyle(finalStyle, amountFormatted, { symbol: symbol, code: code, wrapCodeInSpan: wrapCodeInSpan });
    }

    return amountFormatted; // HTML?
}

/**
 * @function truncateCurrencyConversionString
 * @description Takes a fullString, amount, and amountForex and truncates
 *      the number in the full string to number of digits in amountForex.
 *      This function is used to format the PayPal currency conversion
 *      rate that is displayed to the user (e.g. '1 CAD = $0.7459 USD')
 *      e.g. inputs of:
 *          fullString = '$0.745994235 USD'
 *          amount = '0.745994235'
 *          amountForex = '0.7459'
 *      results in an output of '$0.7459 USD'
 * @param {object} Contains keys 'fullString', 'amount', and 'amountForex'
 * @returns {string}
 */
var truncateCurrencyConversionString = exports.truncateCurrencyConversionString = function truncateCurrencyConversionString() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fullString = _ref7.fullString,
        amount = _ref7.amount,
        amountForex = _ref7.amountForex;

    var allArgsAreStrings = [fullString, amount, amountForex].every(function (s) {
        return typeof s === 'string';
    });

    if (!allArgsAreStrings) {
        return fullString || '';
    }

    // Some countries, e.g. France, use commas instead of decimals
    var target = amountForex.includes(',') ? amount.replace('.', ',') : amount;

    return fullString.replace(target, amountForex);
};

/**
 * @description takes a currency code and
 *  returns either a code or a symbol based
 *  on our currency mapping.
 *  eg: USD -> $ , RUB -> RUB
 *
 * @param {*} code
 * @returns {string}
 */
var getCurrencySymbol = exports.getCurrencySymbol = function getCurrencySymbol(code) {
    var _ref8 = _locale.$locale.metadata || {},
        _ref8$currency = _ref8.currency,
        currency = _ref8$currency === undefined ? {
        supportedSymbols: {}
    } : _ref8$currency;

    return currency.supportedSymbols[code];
};

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/feature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$feature = $feature;
exports.$featureCountries = $featureCountries;

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

function $feature(prop, def, country) {

    var features = _core.$config.features || {};

    country = country || _locale.$locale.country;
    // 1. Check the feature is present in country
    var result = _core.$Class.get(features[country], prop);

    if (result !== undefined) {
        return result;
    }
    // 2. Check the feature is present in feature group

    Object.keys(_core.$config.regions).some(function (region) {
        if (_core.$config.regions[region].indexOf(country) !== -1) {
            result = _core.$Class.get(features[region], prop);
            return result !== undefined;
        }

        return false;
    });

    if (result !== undefined) {
        return result;
    }
    // 3. Check the feature is present in default group
    result = _core.$Class.get(features.DEFAULT, prop);

    if (result !== undefined) {
        return result;
    }
    return def;
}

// Build a list of all countries in our feature list and regions
// populate countries with out REGION names in the list
var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
    return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
});

// populate all the region countries in to allcountries
_core.$util.forEach(_core.$config.regions, function (countries, region) {
    _core.$util.forEach(countries, function (country) {
        if (allCountries.indexOf(country) === -1) {
            allCountries.push(country);
        }
    });
});

function $featureCountries(prop) {
    // Find the countries with a certain feature enabled
    return allCountries.filter(function (country) {
        return $feature(prop, false, country);
    });
}

angular.value("$feature", $feature);
angular.value("$featureCountries", $featureCountries);
_core.$config;

_core.$Class;

_core.$util;

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");

Object.keys(_currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _currency[key];
    }
  });
});

var _feature = __webpack_require__("../node_modules/squid/dist/locale/feature.js");

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _name = __webpack_require__("../node_modules/squid/dist/locale/name.js");

Object.keys(_name).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _name[key];
    }
  });
});

var _quantity = __webpack_require__("../node_modules/squid/dist/locale/quantity.js");

Object.keys(_quantity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _quantity[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/locale.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
exports.sanitize = sanitize;
exports.Content = Content;
exports.$contentVersion = $contentVersion;
exports.$renderContent = $renderContent;
exports.$flushContent = $flushContent;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");

function sanitize(html) {
    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
} /* eslint-disable no-use-before-define */


var JSONStringify = JSON.stringify;

JSON.stringify = function (item) {
    if (item instanceof Content) {
        return item.toString();
    }
    return JSONStringify.apply(this, arguments);
};

function Content(key, props) {
    this.key = key;
    this.props = props;
}

Content.cache = {};

Content.get = function (key, props) {

    if (!key) {
        return '';
    }

    props = props || {};

    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
    var cacheVal = Content.cache[cacheKey];

    if (cacheVal !== undefined) {
        return cacheVal;
    }

    cacheVal = Content.cache[cacheKey] = new Content(key, props);

    return cacheVal;
};

Content.prototype.toString = Content.prototype.valueOf = function () {
    if (this.string) {
        return this.string;
    }

    this.string = this.render(false);

    return this.string;
};

Content.prototype.toSafeString = function () {
    if (this.safeString) {
        return this.safeString;
    }

    this.safeString = this.render(true);

    return this.safeString;
};

Content.prototype.render = function (safe) {
    var _this = this;

    if (!this.key) {
        return '';
    }

    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
    var keys = this.key.split('.');

    for (var i = 0; i < keys.length; i++) {
        if (value) {
            value = value[keys[i]];
        } else {
            break;
        }
    }

    if (!value) {
        return '';
    }

    return value.replace(/\{\w+\}/g, function (prop) {
        prop = prop.slice(1, prop.length - 1);

        if (prop === 'country') {
            return $locale.country;
        }

        if (prop === 'lang') {
            return $locale.lang;
        }

        if (!_this.props[prop]) {
            if (!_core.$loader.isLoading()) {
                _logger.$logger.warn('missing_content_prop', {
                    key: _this.key,
                    prop: prop
                }, { unique: true });
            }

            return '';
        }

        var propStr = _this.props[prop].toString();

        if (safe) {
            return sanitize(propStr);
        }

        return propStr;
    });
};

var contentCache = {};
var currentVersion = void 0;

window.addContent = function (country, lang, content, version) {
    var countryCache = contentCache[country] = contentCache[country] || {};

    countryCache[lang] = content;
    currentVersion = version;
};

var metadataCache = {};

window.addMetadata = function (country, lang, metadata) {
    var metadataVersion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';

    var countryCache = metadataCache[country] = metadataCache[country] || {};

    countryCache[lang] = countryCache[lang] || {};
    countryCache[lang][metadataVersion] = metadata;
};

function $contentVersion() {
    return currentVersion || '';
}

var PP_SPECIAL_COUNTRIES_ISO_CODES = {
    C2: 'CN'
};

var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/locales/:countryCode/:lang',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                    _logger.$logger.info('cached_content');
                    return contentCache[model.countryCode][model.lang];
                }

                _logger.$logger.info('retrieve_content', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                            _logger.$logger.info('content_retrieved');
                            return contentCache[model.countryCode][model.lang];
                        }

                        throw new Error('content_not_available');
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (content) {
                model.setProperties(content);
                return content;
            });
        }
    }),

    change: function change(country, lang) {

        if (country === this.countryCode && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        this.countryCode = country;
        this.lang = lang;

        return this.reload().then(function () {
            _core.$event.broadcast('contentChange');
        });
    }
});

var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {

    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/metadata/:country/:lang/:version?/metadata',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                var metadataVersion = model.version || 'default';

                if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
                    _logger.$logger.info('cached_metadata');
                    return metadataCache[model.country][model.lang][metadataVersion];
                }

                _logger.$logger.info('retrieve_metadata', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
                        if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
                            _logger.$logger.info('metadata_retrieved', {
                                uri: uri
                            });
                            return metadataCache[model.country][model.lang][metadataVersion];
                        }

                        // Retry if not found in cache
                        _logger.$logger.info('metadata_not_available', {
                            uri: uri
                        });
                        return _core.$promise.reject(new Error('metadata_not_available'));
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (metadata) {
                model.setProperties(metadata);
                return metadata;
            });
        }
    }),

    setVersion: function setVersion(country, lang) {
        var _this2 = this;

        var versionPxpName = _core.$config.features[country] && _core.$config.features[country].metadataVersionName;

        if (versionPxpName && _core.$config.metadataPxpExperiments[versionPxpName]) {
            var pxp = (0, _paypal.$pxp)(_core.$config.metadataPxpExperiments[versionPxpName].experimentName, {
                'ctx.COUNTRY': country,
                'ctx.LANGUAGE': lang
            }, _core.$config.metadataPxpExperiments[versionPxpName].experimentTreatmentName);

            return pxp.then(function (treatment) {
                if (treatment) {
                    _this2.version = versionPxpName;
                    _logger.$logger.info('metadata_version_set', {
                        country: country,
                        lang: lang,
                        version: versionPxpName
                    });
                } else {
                    delete _this2.version;
                }
            })['catch'](function () {
                delete _this2.version;
            })['finally'](function () {
                return _core.$promise.resolve();
            });
        } else {
            delete this.version;
            return _core.$promise.resolve();
        }
    },

    change: function change(country, lang) {
        var _this3 = this;

        this.country = country;
        this.lang = lang;

        return this.setVersion(country, lang).then(function () {
            return _this3.reload().then(function () {
                if (!_this3.noBroadcast) {
                    _core.$event.broadcast('metadataChange');
                }
            });
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (_core.$config.supportedCountries) {
            if (!_core.$config.supportedCountries[country]) {
                country = this.country;
            }

            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
                lang = _core.$config.supportedCountries[country][0];
            }
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    normalizeAddressFields: function normalizeAddressFields(content) {

        var CONTENT_MAPPING = {
            line1Label: 'streetAddress',
            line2Label: 'streetAddress2',
            cityLabel: 'city',
            stateLabel: 'state',
            postcodeLabel: 'postalCode'
        };

        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
        for (var prop in CONTENT_MAPPING) {
            if (this.addressEntry && this.addressEntry.strings[prop]) {
                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
            }
        }
    }
});

function mapLanguage(lang) {
    var unselectableLanguages = _core.$config.unselectableLanguages || [];

    if (unselectableLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            return 'en';
        }
    }

    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];

    if (unsupportedLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            var s = lang + '_locale_not_supported';

            throw new Error(s);
        }
    }

    return lang;
}

var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
    api: new _core.$Api({
        uri: '/api/locale'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.content = $ContentModel.instance();
        this.metadata = $MetadataModel.instance();
    },

    retrieve: function retrieve() {
        var self = this;

        return this._super.retrieve.apply(this, arguments).then(function (result) {
            self.lang = mapLanguage(self.lang);
            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {

                // TODO: This at build time... or make sure griffin metadata is complete
                self.metadata.normalizeAddressFields(self.content);

                return result;
            });
        });
    },

    change: function change(country, lang) {

        var self = this;

        lang = mapLanguage(lang);

        if (country === this.country && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        _logger.$logger.info('locale_change', {
            country: country,
            lang: lang
        });

        this.country = country;
        this.lang = lang;

        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {

            // TODO: This at build time... or make sure griffin metadata is complete
            self.metadata.normalizeAddressFields(self.content);

            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
            return loadedData;
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (!_core.$config.supportedCountries[country]) {
            country = this.country;
        }

        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
            lang = _core.$config.supportedCountries[country][0];
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    chooseCountry: function chooseCountry(country) {
        return this.choose(country, null);
    },

    chooseLang: function chooseLang(lang) {
        return this.choose(null, lang);
    },

    getLocaleCode: function getLocaleCode() {
        return this.lang + '_' + this.country;
    },

    getCountryCodeISO: function getCountryCodeISO() {
        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
    }
});

var $locale = exports.$locale = $LocaleModel.instance();

function $renderContent(key, props) {
    return Content.get(key, props);
}

function $flushContent() {
    contentCache = {};
    Content.cache = {};
    $locale.content = $ContentModel.create();
    $locale.metadata = $MetadataModel.create();
    metadataCache = {};
}

var $localeHelper = exports.$localeHelper = {
    /**
     *
     * @param locale - Ex: en_US
     * @returns {{country: *, dialect}}
     */
    normalizeLocale: function normalizeLocale(locale) {
        if (!locale) {
            return {};
        }

        locale = locale.replace('-', '_');

        var country = void 0;
        var language = void 0;

        if (locale.match(/^\w{2}_\w{2}$/)) {
            locale = locale.split('_');

            language = locale[0];
            country = locale[1];
        } else {
            language = locale;
        }

        return {
            country: country,
            language: language
        };
    }
};

angular.value("sanitize", sanitize);
angular.value("Content", Content);
angular.value("$contentVersion", $contentVersion);
angular.value("$ContentModel", $ContentModel);
angular.value("$MetadataModel", $MetadataModel);
angular.value("$LocaleModel", $LocaleModel);
angular.value("$locale", $locale);
angular.value("$renderContent", $renderContent);
angular.value("$flushContent", $flushContent);
angular.value("$localeHelper", $localeHelper);
_logger.$logger;

_core.$event;

_core.$Model;

_core.$Api;

_core.$meta;

_core.$promise;

_core.$config;

_core.$loader;

_core.$dom;

_paypal.$pxp;

/***/ }),

/***/ "../node_modules/squid/dist/locale/name.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatNameInformal = formatNameInformal;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

// Mapping of Griffin fields to name fields that should be used
var SUBSTITUTED_FIELDS = {
    givenName: 'first_name',
    surname: 'last_name'
};

// Taken from griffin-paypal: test if a string is Latin
function isLatin(str) {
    if (!str) {
        return true;
    }

    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 0x24F) {
            return false;
        }
    }

    return true;
}

/**
 * Formats name into informal format based on Griffin metadata
 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
 * @return {String}      The formatted string, or null if data is missing
 */
function formatNameInformal(name) {
    var layoutMetadata = _locale.$locale.metadata.nameInformal;
    var layout = null;

    if (!layoutMetadata) {
        return name.first_name || null; // Default to first name if metadata not loaded
    }

    // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
    if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
        layout = layoutMetadata['latinLayout'];
    } else {
        layout = layoutMetadata['layout'];
    }

    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
    var formattedName = [];

    for (var i = 0; i < layout.length; i++) {
        var namePart = layout[i];

        if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
            formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
        } else if (namePart['$'] === 'separator') {
            formattedName.push(namePart._);
        }
    }

    return formattedName.join('');
}

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/quantity.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatQuantity = formatQuantity;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");

// format a quantity to add a thousand separator based on a locality
function formatQuantity(quantity) {
    var _ref = _locale.$locale.metadata || {},
        _ref$number = _ref.number,
        numberConfig = _ref$number === undefined ? {} : _ref$number;

    var dot = '';
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    return (0, _currency.roundingAndSeparators)(quantity.toString(), _locale.$locale, { decimalPlaces: 0, dot: dot, comma: comma });
}

_locale.$locale;

_currency.roundingAndSeparators;

/***/ }),

/***/ "../node_modules/squid/dist/ng/component.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Component = undefined;
exports.$populate = $populate;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

(0, _directive.$registerDirective)('prevent-default', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click', function (event) {
                event.preventDefault();
            });
        }
    };
});

(0, _directive.$registerDirective)('stop-propagation', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click keydown keypress keyup', function (event) {
                event.stopPropagation();
            });
        }
    };
});

(0, _directive.$registerDirective)('validate-submit', function () {

    return {
        link: function link($scope, $element, $attrs) {

            var $form = $element.closest('form');
            var form = $scope[$form.prop('name')];
            var formID_element = $attrs.form; // take the form attribute from submit button
            var formID_linked = $element[0] // take the id from the linked form element
            && $element[0].form && $element[0].form.id;
            var isLinkedForm = formID_element && formID_element === formID_linked; // Checking for confirmation. May not be required. Presence should be good enough.

            if (isLinkedForm) {
                $form = angular.element(document.getElementById(formID_linked));
                var scope = $form.scope(); // Linked forms should mantain form scope

                form = scope[$form.prop('name')];
            }

            $element.on('click', function (event) {
                event.preventDefault();

                $form.addClass('validated');
                $scope.validated = true;
                form.$setSubmitted();

                if (form.$valid) {
                    try {
                        $scope.$eval($attrs.validateSubmit);
                    } catch (err) {
                        _angular.$injector.get('$exceptionHandler')(err);
                    }
                } else {
                    $form.find('.ng-invalid:first').focus();
                }
            });
        }
    };
});

function assertModelsRetrievedOrEmpty(items) {
    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
        angular.forEach(items, function (item, name) {
            if (item instanceof _core.$Model) {
                if (item.meta.populated) {
                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
                }
            }
        });
    }
}

function setUpComponentRoute($scope, $Component, angular) {
    var componentRoute = $scope.componentRoute;

    componentRoute.scope = $scope;

    componentRoute.scope.goto = function (route) {
        componentRoute.goto(route);
    };

    var parentRoute = componentRoute.parent;

    if (parentRoute) {
        var parentScope = parentRoute.scope;
        var parentDirective = parentRoute.getDirective();
        var childSpec = componentRoute.childSpec;

        if (childSpec.config) {
            if (parentDirective instanceof $Component) {
                parentScope.viewConfig = childSpec.config.call(parentScope);
            } else {
                throw new Error('In order to use config() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }

        if (childSpec.props) {
            if (parentDirective instanceof $Component) {
                angular.extend($scope, childSpec.props.call(parentScope));
            } else {
                throw new Error('In order to use props() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }
    }
}

var $Component = exports.$Component = _core.$Class.extend('$Component', {

    onPopulate: angular.noop,

    init: function init() {
        var _this = this,
            _arguments = arguments;

        this.validate();

        this.name = _core.$util.dasherizeToCamel(this.tag);

        var wrapperType = this.wrapperType === 'span' ? 'span' : 'div';

        this.template = '<' + wrapperType + ' class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</' + wrapperType + '>';

        this.scope = this.scope || {};
        this.resolve = this.resolve || {};
        this.props = this.props || {};
        this.rootEvents = this.rootEvents || {};

        this.actions = this.actions || {};

        this.lifecycle = this.lifecycle || {};
        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
        this.lifecycle.populate = this.lifecycle.populate || angular.noop;

        if (this.scope && Object.keys(this.scope).length) {

            if (this.props && Object.keys(this.props).length) {
                throw new Error('Can not defined scope and props on the same component');
            }

            this.scope.componentRoute = '=';
            this.scope['export'] = '@';

            this.props = _core.$util.map(this.scope, function (type, key) {
                return {
                    type: {
                        '=': 'var',
                        '@': 'str'
                    }[type],
                    required: false
                };
            });
        } else {

            this.props.componentRoute = {
                type: 'var',
                required: false
            };

            this.props['export'] = {
                type: 'str',
                required: false
            };

            var isRequired = function isRequired() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    required = _ref.required,
                    optional = _ref.optional;

                return [true, 'true'].indexOf(required) > -1 || [false, 'false'].indexOf(optional) > -1;
            };

            this.scope = _core.$util.map(this.props, function (spec, key) {
                return {
                    'var': isRequired(spec) ? '=' : '=?',
                    str: isRequired(spec) ? '@' : '@?'
                }[spec.type || 'var'];
            });
        }

        var originalController = this.controller || angular.noop;

        this.controller = ['$scope', '$element', function ($scope, $element) {
            $scope.$element = $element;

            $scope.$on('$destroy', function () {
                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
                    delete $scope.componentRoute.parent.scope.viewConfig;
                }
                _this.lifecycle.exit.call($scope);
            });

            $scope.props = {};

            if ($scope.componentRoute) {
                setUpComponentRoute($scope, $Component, angular);
            }

            angular.forEach(_this.props, function (type, key) {

                var prop = _this.props[key];
                var required = prop.required !== false;
                var def = void 0;

                if (prop['default'] instanceof Function) {
                    def = _core.$util.memoize(prop['default'].bind($scope));
                } else {
                    def = function def() {
                        return prop['default'];
                    };
                }

                var UNDEFINED = {
                    'var': undefined,
                    str: ''
                }[prop.type];

                Object.defineProperty($scope.props, key, {
                    get: function get() {
                        var val = $scope[key];

                        if (val === UNDEFINED) {
                            if (required) {
                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
                            }

                            return def();
                        }

                        return val;
                    },

                    set: function set() {
                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
                    }
                });
            });

            $scope.fields = {};

            $scope.actions = _core.$util.bindObject(_this.actions, $scope);

            Object.keys(_this.rootEvents).forEach(function (eventName) {
                var cancel = _core.$event.on(eventName, function (event) {
                    _this.rootEvents[eventName].apply($scope, _arguments);
                });

                $scope.$on('$destroy', cancel);
            });

            $scope.display = true;

            $scope.reload = function () {

                if (!$scope.populated) {
                    throw new Error('Can not reload unpopulated component');
                }

                $scope.display = false;
                setTimeout(function () {
                    $scope.display = true;
                });
            };

            $scope.componentScope = $scope;

            if ($scope.props['export'] && $scope.$parent.componentScope) {

                $scope.exports = angular.extend({}, _this.exports || {}, {
                    reload: $scope.reload
                });

                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
                    get: function get() {
                        return $scope.exports;
                    },

                    configurable: true
                });
            }

            $scope._enablePopulateEvents = true;

            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
            _this.lifecycle.enter.call($scope);

            $scope._enablePopulateEvents = false;

            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
                if (toState === $scope.props.componentRoute) {
                    _this.lifecycle.reenter.call($scope);
                }
            });

            $scope.$on('$destroy', cancelReEnterEvent);

            return _core.$promise.sequential([function () {
                $scope.$emit('_populating');
            }, function () {
                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {

                    if (angular.isObject(resolver)) {
                        $scope[name] = resolver;
                        return resolver;
                    }

                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
                        assertModelsRetrievedOrEmpty(data);

                        return _core.$promise.hash(data).then(function (resolvedData) {

                            $scope[name] = resolvedData;
                            return resolvedData;
                        });
                    });
                });
            }, function () {

                $scope.populated = true;

                $scope.$emit('_populated');

                _core.$event.refCount($scope, '_populating', '_populated').then(function () {

                    $scope.$on('populated', function (populatedEvent) {
                        populatedEvent.stopPropagation();
                    });

                    $scope.$emit('populated');
                    _this.onPopulate.call($scope);
                    _this.lifecycle.populate.call($scope);
                });
            }]);
        }];
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var componentName = this.constructor.name;

        if (!this.tag) {
            throw new Error(componentName + ' :: expected property \'tag\'');
        }

        if (!this.tag.match(/^[a-z0-9-]+$/)) {
            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
        }

        if (!this.template) {
            throw new Error(componentName + ' :: expected property \'template\'');
        }

        if (this.resolve) {
            angular.forEach(this.resolve, function (resolver, name) {
                if (!(resolver instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
                }
            });
        }

        if (this.props) {
            angular.forEach(this.props, function (prop, name) {

                if (!(prop instanceof Object)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
                }

                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
                }

                if (prop['default'] && prop.required) {
                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
                }

                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
                }
            });
        }

        if (this.actions) {
            angular.forEach(this.actions, function (action, name) {
                if (!(action instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
                }
            });
        }

        if (this.lifecycle) {
            Object.keys(this.lifecycle).forEach(function (name) {
                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
                }
            });
        }
    }
});

$Component.reopenClass({

    extend: function extend() {

        var SubClass = _core.$Class.extend.apply(this, arguments);
        var spec = new SubClass();

        angular.module().directive(spec.name, function () {
            return spec;
        });

        return SubClass;
    },

    render: function render(scope) {
        _core.$event.emit('$resetState');

        var $scope = _angular.$rootScope.$new();

        angular.extend($scope, scope);

        var attrs = Object.keys(scope).map(function (key) {
            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
        }.bind(this)).join(' ');

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';

        console.log('RENDER', html, scope);

        var element = (0, _angular.$compile)(html)($scope);

        // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
        angular.element(document.body).append(element);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            element.remove();
        }));

        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        element.updateProps = function (props) {
            angular.extend($scope, props);
            $scope.$digest();
            setTimeout.flush();
        };

        return element;
    }
});

function autoConvertDirectiveToComponent(_ref2, original) {
    var name = _ref2[0],
        factory = _ref2[1];


    if (!angular.isFunction(factory)) {
        return original();
    }

    var tag = _core.$util.camelToDasherize(name);
    var spec = _angular.$injector.invoke(factory);

    if (spec.controller) {
        var originalController = spec.controller;

        spec.controller = ['$scope', '$element', function ($scope, $element) {
            $scope._enablePopulateEvents = true;
            var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });

            $scope._enablePopulateEvents = false;
            return result;
        }];
    }

    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
        return original(this, [name, function () {
            return spec;
        }]);
    }

    if (spec.componentize) {

        $Component.extend('$' + name + 'Component', spec, {
            tag: tag
        });

        return this;
    }

    return original(this, [name, function () {
        return spec;
    }]);
}

_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);

// $populate needs to go away

function $populate($scope, instances) {

    $scope.$on = $scope.$on || angular.noop;
    $scope.$emit = $scope.$emit || angular.noop;

    var _enablePopulateEvents = $scope._enablePopulateEvents;

    if (_enablePopulateEvents) {
        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
            $scope.$emit('populated');
        });
    }

    $scope.$on('populated', function (populatedEvent) {
        populatedEvent.stopPropagation();
    });

    if (_enablePopulateEvents) {
        $scope.$emit('_populating');
    }

    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {

        var promise = void 0;

        if (instance.then) {
            promise = instance;
        } else {
            promise = instance.retrieve();
            $scope[name] = instance;
        }

        return promise.then(function (result) {
            $scope[name] = result;
            return result;
        });
    })).then(function (result) {

        if (_enablePopulateEvents) {
            $scope.$emit('_populated');
        }

        return result;
    });
}

angular.value("$Component", $Component);
angular.value("$populate", $populate);
_angular.$rootScope;

_angular.$compile;

_angular.$injector;

_angular.$compileProvider;

_core.$Class;

_core.$Model;

_core.$util;

_core.$promise;

_core.$config;

_core.$event;

_ng.$cleanRootScope;

_directive.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/ng/core.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

_core.$event.use({
    on: function on() {
        return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
    },
    once: function once(name, handler) {
        var cancel = _core.$event.on(name, function () {
            cancel();
            handler.apply(this, arguments);
        }, true);

        return cancel;
    },
    emit: function emit() {
        return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
    },
    broadcast: function broadcast() {
        return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
    }
});

_core.$promise.use(_angular.$q);

_angular.$q;

_angular.$rootScope;

_core.$event;

_core.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/ng/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$registerDirective = $registerDirective;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function $registerDirective(tag, definition) {

    var directiveName = tag.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });

    return _angular2["default"].module().directive(directiveName, definition);
}

_angular2["default"].value("$registerDirective", $registerDirective);

/***/ }),

/***/ "../node_modules/squid/dist/ng/events.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

angular.module().run(function () {

    _core.$event.on('$stateChangeStart', function (event) {
        _core.$event.emit('loading');
        _core.$event.emit('loaded');
    });

    var startLoadTime = 0;
    var currentState = 'checkout_init';

    function currentStateName() {
        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
    }

    _core.$event.on('startLoad', function () {

        if (startLoadTime) {
            startLoadTime = _core.$util.now();
        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {

            var performance = window.performance;
            var timing = window.performance.timing || {};
            var now = performance.now();

            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
        }
    });

    _core.$event.on('allLoaded', function () {

        var newState = currentStateName();

        if (!newState) {
            return;
        }

        if (currentState === newState) {
            _core.$event.emit('page_reloaded', currentState);
        } else {

            var duration = void 0;

            if (startLoadTime) {
                duration = _core.$util.now() - startLoadTime;
            }

            var payload = {
                start: currentState,
                end: newState,
                time: duration,
                duration: duration
            };

            _core.$event.emit('$transition', {
                from: currentState,
                toState: _uiRouter.$state.current,
                duration: duration
            });

            _logger.$logger.info('transition', payload);
            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);

            _core.$event.emit('page_loaded', currentState, newState);
            _logger.$logger.flush();

            currentState = newState;
        }
    });

    _core.$event.emit('loading');

    var cancel = _core.$event.on('$stateChangeSuccess', function () {
        if (_uiRouter.$state.current.template) {
            cancel();
            setTimeout(function () {
                _core.$event.emit('loaded');
            }, 50);
        }
    });
});

_uiRouter.$state;

_logger.$logger;

_core.$event;

_core.$util;

/***/ }),

/***/ "../node_modules/squid/dist/ng/feature.js":
/***/ (function(module, exports, __webpack_require__) {



var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

(0, _directive.$registerDirective)('feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
            };
        }
    };
});

(0, _directive.$registerDirective)('unless-feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="!enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
            };
        }
    };
});
_directive.$registerDirective;

_locale.$feature;

_core.$integration;

/***/ }),

/***/ "../node_modules/squid/dist/ng/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _core = __webpack_require__("../node_modules/squid/dist/ng/core.js");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _route = __webpack_require__("../node_modules/squid/dist/ng/route.js");

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});

var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");

Object.keys(_component).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _component[key];
    }
  });
});

var _feature = __webpack_require__("../node_modules/squid/dist/ng/feature.js");

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _locale = __webpack_require__("../node_modules/squid/dist/ng/locale.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _module = __webpack_require__("../node_modules/squid/dist/ng/module.js");

Object.keys(_module).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _module[key];
    }
  });
});

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});

var _events = __webpack_require__("../node_modules/squid/dist/ng/events.js");

Object.keys(_events).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _events[key];
    }
  });
});

var _pxp = __webpack_require__("../node_modules/squid/dist/ng/pxp.js");

Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pxp[key];
    }
  });
});

var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");

Object.keys(_lazyLoadRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lazyLoadRoutes[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/ng/lazyLoadRoutes.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.lazyLoadRoute = exports.findRelativeState = exports.initRoute = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var getHash = function getHash(url) {
    if (!url || !~url.indexOf('#')) {
        // eslint-disable-line no-bitwise
        return;
    }

    url = url.split('#');
    return url[url.length - 1];
};

/**
 *
 * get parent state, e.g "checkout.sidebar.addCard" -> "checkout.sidebar"
 */
var getParentState = function getParentState(path) {
    return _uiRouter.$state.get(path.slice(0, path.lastIndexOf('.')));
};

/**
 * Find route by slug
 * path - full path of the current route, e.g "checkout.payWithSelection"
 * slug - path of the route that we want to search, e.g "payWithSelection"
 */
var getRoute = function getRoute(path, slug) {
    var route = getParentState(path);

    if (!route) {
        return;
    }
    var children = route.children;

    if (children) {
        return children.find(function (child) {
            return child.slug === slug;
        });
    }
};

/**
 * Lazy load children routes in the background
 */
var lazyLoadChildren = function lazyLoadChildren(children) {
    if (children) {
        _logger.$logger.info('lazy_loading_route_load_children');
        children.forEach(function (child) {
            if (child.lazyRoute) {
                // request to download js chunk (dynamic import)
                child.lazyRoute();
            }
        });
    }
};

/**
 * Dynamically load route and initialize / register it
 * @param {Object} routeObj - route object from Route definition, e.g
 *  {
 *      name: '$PayWithSelection',
 *      slug: 'payWithSelection',
 *      lazyRouter: () => import('pages/payWithSelection/route)
 *  }
 *
 * @param {Route} parent - parent of the passed routeObj
 * @param {String} fullRoutePath - full path of the route, e.g "checkout.payWithselection"
 */
var initRoute = exports.initRoute = function initRoute(routeObj, parent, fullRoutePath) {
    if (!routeObj) {
        return;
    }

    var name = routeObj.name,
        slug = routeObj.slug,
        attributes = routeObj.attributes,
        lazyRoute = routeObj.lazyRoute;


    _logger.$logger.info('lazy_loading_route_init', {
        name: name,
        slug: slug,
        fullRoutePath: fullRoutePath
    });

    return lazyRoute().then(function (route) {
        if (!route) {
            return;
        }
        if ((typeof route === 'undefined' ? 'undefined' : _typeof(route)) === 'object') {
            route = route[name];
        }
        var childRoute = new route({ //eslint-disable-line
            parent: parent || getParentState(fullRoutePath),
            childSpec: _core.$util.extend(routeObj, { route: route }),
            childAttributes: attributes
        });
        childRoute.register();
        return childRoute;
    });
};

/**
 * Promisify all lazy routes
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes
 *      1. Go through each possible route, e.g 'checkout', 'checkout.sidebar', 'checkout.sidebar.addCardFlow', 'checkout.sidebar.addCardFlow.addCard'
 *      2. Check if each exists / already registered
 *      3. if route is not registered -> find that route and return promise
 * @param {String} targetState full path of the target route
 * Returns an array of promisified functions
 */
var findAndPromisifyRoutes = function findAndPromisifyRoutes(targetState) {
    var splittedTargetState = targetState.split('.');
    var states = splittedTargetState.slice(1);
    var routes = [];
    var path = splittedTargetState[0];

    states.forEach(function (state) {
        path += '.' + state;
        var fullRoutePath = path;

        if (!_uiRouter.$state.get(path)) {
            routes.push(function (parent) {
                var route = getRoute(fullRoutePath, state);

                return initRoute(route, parent, fullRoutePath);
            });
        }
    });
    return routes;
};

/**
 * Checks if it's a relative path (having `.` or `^`)
 * @param {String} stateName - path of the state, e.g `.mychildRoute`
 */
var isRelative = function isRelative(stateName) {
    return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
};

/**
 * finds a full path of the relative state name
 * examples:
 * '^' - will go to a parent state
 * '^.sibling' - will go to a sibling state
 * '.child.grandchild' - will go to grandchild state
 * @param {String / Object} stateOrName - state to find, e.g `^.selectFi`
 * Returns full path name of the state, e.g `^.selectFi` -> `checkout.selectFi`
 */
var findRelativeState = exports.findRelativeState = function findRelativeState(stateOrName) {
    if (!stateOrName) {
        return;
    }
    var base = _uiRouter.$state.current;

    var rel = stateOrName.split('.');
    var current = base;
    var i = 0;

    for (; i < rel.length; i++) {
        if (rel[i] === '' && i === 0) {
            current = base;
            continue;
        }
        if (rel[i] === '^') {
            if (!current.parent) {
                throw new Error('lazy-loading: path \'' + stateOrName + '\' not valid for state \'' + base.name + '\'');
            }
            current = current.parent;
            continue;
        }
        break;
    }
    rel = rel.slice(i).join('.');
    return current.name + (current.name && rel ? '.' : '') + rel;
};

/**
 * Lazy load route and redirect if successfull or reject if route was not found
 * Note: routes will be loading sequentialy for now to load parent routes first if they are lazy as well.
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes and represent separate js chunk
 *      We have to load each js chunk in order one by one to be able to register them and attach to corresponding parents.
 * @param {String} targetState - route path, e.g 'checkout.payWithSelection'
 * @param {Object} targetParams - params which route may need
 * @param {Boolean} shouldChangeState - if state should be changed after route is loaded
 */
var lazyLoadRoute = exports.lazyLoadRoute = function lazyLoadRoute(targetState) {
    var targetParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shouldChangeState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!targetState) {
        return _core.$promise.reject(new Error('lazy_loading_target_state_is_empty'));
    }
    _logger.$logger.info('lazy_loading_route', {
        targetState: targetState,
        targetParams: targetParams
    });
    if (isRelative(targetState)) {
        targetState = findRelativeState(targetState, _uiRouter.$state.current);
    }
    _core.$event.emit('loading');

    var routes = findAndPromisifyRoutes(targetState);

    return _core.$promise.sequential(routes).then(function (result) {
        if (_uiRouter.$state.get(targetState)) {
            if (result) {
                lazyLoadChildren(result.children);
            }
            _logger.$logger.info('lazy_loading_route_state_change', {
                targetState: targetState,
                targetParams: targetParams
            });
            if (!shouldChangeState) {
                return _core.$promise.resolve();
            }
            return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                if (err.message === 'transition prevented' || err.message === 'transition superseded') {
                    return _core.$promise.resolve();
                }
                return _core.$promise.reject(err);
            });
        } else {
            return _core.$promise.reject(new Error('lazy_loading_state_was_not_loaded'));
        }
    })['catch'](function (error) {
        // in case of exceptions, spinner must dissapear, because for each 'loading' event
        // that's sent in the beginning of the function must be corresponding 'loaded' event
        // otherwise, there will be infinite spinner

        _logger.$logger.info('lazy_loading_route_error', {
            targetState: targetState,
            targetParams: targetParams,
            errorMessage: error && error.message,
            errorStack: error && error.stack
        });

        return _core.$promise.reject(error);
    })['finally'](function () {
        _core.$event.emit('loaded');
    });
};

/**
 * mostly needed for use cases when user types route manually
 */
window.addEventListener('hashchange', function (event) {
    if (_config.$meta.codeSplitting) {
        var fromHash = getHash(event.oldURL);
        var toHash = getHash(event.newURL || window.location.hash);

        // skip lazy loading in case hash is undefined or empty
        // example -> <a href="#" ng-click="openModal()">OpenModal</a>
        // in that case `toHash` will be empty
        if (!toHash) {
            return;
        }

        var getHashQueryParams = function getHashQueryParams(path) {
            var splittedPath = path.split('?');
            // e.g #/checkout/genericError?code=ERROR_CODE -> code=ERROR_CODE
            var hashParams = splittedPath.length > 1 && splittedPath[1];

            if (hashParams) {
                // e.g code=ERROR_CODE -> { code: ERROR_CODE }
                return _core.$util.params(hashParams);
            }
        };
        // e.g #/checkout/review -> checkout.review
        var path = toHash.slice(1).replace(/\//g, '.');
        var hashQueryParams = getHashQueryParams(path);

        if (hashQueryParams) {
            // e.g checkout.genericError?code=ERROR_CODE -> checkout.genericError
            path = path.split('?')[0];
        }

        if (_uiRouter.$state.get(path)) {
            return;
        }

        _logger.$logger.info('hashchange_lazy_loading', {
            from: fromHash,
            to: toHash
        });

        lazyLoadRoute(path, hashQueryParams)['catch'](function () {
            _logger.$logger.info('hashchange_lazy_loading_error', {
                from: fromHash,
                to: toHash,
                params: hashQueryParams
            });
        });
    }
});

_uiRouter.$state;

_logger.$logger;

_core.$util;

_core.$promise;

_core.$event;

_config.$meta;

/***/ }),

/***/ "../node_modules/squid/dist/ng/locale.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

(0, _angular.$registerDirective)('content', function () {
    return {
        restrict: 'A',

        link: function link($scope, element, attributes) {
            $scope.content = $scope.htmlContent = function (key, props) {
                if (attributes.content) {
                    key = attributes.content + '.' + key;
                }
                var content = _locale.Content.get(key, props);

                if (content.toString()) {
                    return content;
                } else {
                    return;
                }
            };
        }
    };
});

(0, _angular.$registerDirective)('bind-html-compile', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $scope.$watch(function () {
                return $scope.$eval($attrs.bindHtmlCompile);
            }, function (value) {
                $element.html(value && value.toString());
                (0, _angular.$compile)($element.contents())($scope);
            });
        }
    };
});

(0, _angular.$registerDirective)('format-currency', function () {

    return {
        restrict: 'E',
        template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
        scope: {
            amount: '=?',
            symbol: '=?',
            code: '=?',
            currencyStyle: '@?'
        },
        controller: ['$scope', function ($scope) {

            function format() {
                $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
            }

            $scope.$on('$destroy', _core.$event.on('localeChange', format));

            $scope.$watch('amount', function (newValue, oldValue) {
                if (newValue !== oldValue && _locale.$locale.country) {
                    format();
                }
            });

            if (_locale.$locale.country) {
                format();
            }
        }] // controller
    }; // return
}); // registerDirective


(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().value('$sanitize', function (val) {
    if (val instanceof _locale.Content) {
        return val.toSafeString();
    }
    return (0, _locale.sanitize)(val);
});

_angular.$sce;

_angular.$registerDirective;

_angular.$compile;

_core.$event;

_locale.formatCurrency;

_locale.sanitize;

_locale.Content;

_locale.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/squid/dist/ng", "../node_modules/squid/dist/ng/locale.js"))

/***/ }),

/***/ "../node_modules/squid/dist/ng/module.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.module = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _module = _angular2['default'].module;
exports.module = _module;

/***/ }),

/***/ "../node_modules/squid/dist/ng/ng.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$angularInvoke = $angularInvoke;
exports.$once = $once;
exports.$cleanRootScope = $cleanRootScope;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

function $angularInvoke(method) {
    try {
        return method();
    } catch (err) {
        _angular.$injector.get('$exceptionHandler')(err);
    }
}

function $once(name, handler) {
    var cancel = _core.$event.on(name, function () {
        cancel();
        handler.apply(this, arguments);
    }, true);
}

function $cleanRootScope(rootScope) {

    var keys = Object.keys(rootScope);

    var autoCleanupEventHandlers = [];
    var eventHandlers = [];
    var eventCancelers = [];

    _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
        var name = _ref[0],
            handler = _ref[1],
            once = _ref[2];


        var cancel = original();

        var $state = void 0;

        try {
            $state = _angular.$injector.get('$state');
        } catch (err) {
            // pass
        }

        if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
            autoCleanupEventHandlers.push(cancel);
            return function autoCleanedUpCancel() {}; // eslint-disable-line no-empty-function
        }

        if (once) {
            eventCancelers.push(cancel);
            return cancel;
        }

        // Let ng-router do its thing
        if (handler.toString().indexOf('updateView') !== -1) {
            return cancel;
        }

        var stack = void 0;

        try {
            throw new Error('$rootScope.$on');
        } catch (err) {
            stack = err.stack;
        }

        var reference = {
            name: name,
            handler: handler.toString(),
            stack: stack
        };

        eventHandlers.push(reference);

        return function () {
            cancel();
            eventHandlers.splice(eventHandlers.indexOf(reference), 1);
        };
    });

    return function () {

        _core.$event.emit('$destroy');

        autoCleanupEventHandlers.forEach(function (canceler) {
            return canceler();
        });
        autoCleanupEventHandlers = [];

        Object.keys(rootScope).forEach(function (key) {
            if (keys.indexOf(key) === -1) {
                delete rootScope[key];
            }
        });

        if (eventHandlers.length) {
            throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
                return eventHandler.name + '\n\n' + eventHandler.handler + '\n\n' + eventHandler.stack;
            }).join('\n\n'));
        }

        eventCancelers.forEach(function (cancel) {
            return cancel();
        });
    };
}

angular.value("$angularInvoke", $angularInvoke);
angular.value("$once", $once);
angular.value("$cleanRootScope", $cleanRootScope);
_angular.$injector;

_core.$util;

_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

_core.$event.on('pxp_res', function (event, pxpRes) {
    _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
    _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
    _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
});

_uiRouter.$state;

_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ComponentRoute = exports.$Route = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");

var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {

    childSpec: {},

    init: function init() {
        var _this = this;

        this.validate();

        this.url = '/' + (this.path || this.name);

        if (this.query) {
            this.url += '?' + this.query.join('&');
        }

        this.hasResolver = Boolean(this.resolve);

        var controller = this.controller = ['$scope', function ($scope) {
            $scope.route = _this;
            if ($scope.componentScope) {
                delete $scope.componentScope.view;
            }
        }];

        if (this.get('resolve.action')) {
            this.controller = ['$scope', 'action', function ($scope, action) {
                _angular.$injector.invoke(controller, this, { $scope: $scope });
                if (action) {
                    if (!action.newState) {
                        _angular.$location.replace();
                    }

                    if (angular.isObject(action) && action.to) {
                        _uiRouter.$state.go(action.to, action.params);
                    } else {
                        _uiRouter.$state.go(action);
                    }
                }
            }];
        }
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var routeName = this.constructor.name;

        if (!this.name && !this.path) {
            throw new Error(routeName + ' :: expected property \'path\'');
        }

        if (this.url) {
            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
        }

        if (this.query && !(this.query instanceof Array)) {
            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
        }

        if (this.controller) {
            // throw new Error(`${routeName} :: unexpected property 'controller'`);
        }

        if (this.resolve) {
            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
            }

            Object.keys(this.resolve).forEach(function (name) {
                if (name === 'data') {
                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
                } else if (name !== 'action') {
                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
                }
            });
        }

        if (this.template) {
            throw new Error(routeName + ' :: unexpected property \'template\'');
        }

        if (!this.directive && !this.resolve && !this.resolve.action) {
            throw new Error(routeName + ' :: expected property \'directive\'');
        }

        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
        }

        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
        }

        if (this.children) {
            this.children.forEach(function (childSpec) {

                if (!childSpec.route && !childSpec.name) {
                    throw new Error(routeName + ' :: child expected property \'route\'');
                }

                var ChildRoute = childSpec.route;
                var childName = childSpec.name || ChildRoute.name;

                // skip loading route as it won't be available to validate
                if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
                    return;
                }

                if (!ChildRoute && childSpec.name) {
                    try {
                        ChildRoute = _angular.$injector.get(childSpec.name);
                    } catch (err) {
                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
                    }
                }

                if (!$Route.isChild(ChildRoute)) {
                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
                }
            });
        }
    },
    goto: function goto(route) {
        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
    },
    getDirective: function getDirective() {
        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
    },
    getDirectiveTag: function getDirectiveTag() {
        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
    },


    bootstrap: function bootstrap(defaultState, middleware) {
        var _this2 = this;

        return (0, _ng.$angularInvoke)(function () {
            // only bootstrap if not bootstrapped already
            var element = angular.element(document.body);

            if (!element.injector()) {
                angular.bootstrap(element, ['app']);
            }

            return _this2.load(defaultState, middleware);
        });
    },

    load: function load(defaultState, middleware) {

        defaultState = defaultState || this.defaultState;
        middleware = middleware || this.middleware;

        _logger.$logger.info('bootstrap_route', {
            route: this.path || this.name
        });

        var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
            var unfoundState = _ref.unfoundState,
                fromState = _ref.fromState,
                fromParams = _ref.fromParams,
                _ref$logName = _ref.logName,
                logName = _ref$logName === undefined ? '' : _ref$logName;

            _logger.$logger.error('state_not_found' + logName, {
                name: unfoundState.to,
                from: fromState.name,
                fromParams: fromParams,
                hash: window.location.hash
            });
            throw new Error('state_not_found' + logName + ': ' + unfoundState.to);
        };

        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (!_config.$meta.codeSplitting) {
                event.preventDefault();
                logStateNotFoundAndThrow({ unfoundState: unfoundState, fromState: fromState, fromParams: fromParams });
            }
        });

        // for code splitting this event handler will be triggered every single time user tries to load lazy route
        // so we need to have it being listening more than once
        _core.$event.on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (_config.$meta.codeSplitting) {
                event.preventDefault();
                // if route was not found - lazy load it or throw state_not_found if it was not found
                (0, _lazyLoadRoutes.lazyLoadRoute)(unfoundState.to, unfoundState.toParams)['catch'](function () {
                    logStateNotFoundAndThrow({ unfoundState: unfoundState, fromState: fromState, fromParams: fromParams, logName: '_lazy_loading' });
                });
            }
        });

        this.register();

        _uiRouter.$urlRouterProvider.otherwise(function () {
            return _logger.$logger.info('otherwise_after_bootstrap', {
                hash: window.location.hash
            });
        });

        this.runMiddleware(middleware).then(function () {
            var targetState = void 0;
            var targetParams = void 0;

            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {

                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');

                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
            }

            _logger.$logger.info('initializing_route', {
                target: targetState,
                defaultState: defaultState,
                hash: window.location.hash
            });

            _angular.$location.replace();

            /**
             * load default state in case target state was not found
             * e.g checkout.landing - is the default state in Hermes
             */
            var loadDefaultState = function loadDefaultState() {
                if (_uiRouter.$state.get(defaultState)) {
                    _logger.$logger.info('default_state', {
                        stateName: defaultState
                    });
                    return _uiRouter.$state.go(defaultState)['catch'](function (err) {
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: defaultState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                }

                throw new Error('Default state not found: ' + defaultState);
            };

            if (targetState) {
                var logUnknownState = function logUnknownState() {
                    var logName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    _logger.$logger.info('unknown_state' + logName, {
                        stateName: targetState
                    });
                };

                if (_uiRouter.$state.get(targetState)) {
                    _logger.$logger.info('existing_state', {
                        stateName: targetState
                    });
                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                        // lib/js/security.js event listener handles auth required state changes
                        // and cancels transitions if user not authenticated
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: targetState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                } else if (_config.$meta.codeSplitting) {
                    // try to lazy load route and catch / handle redirect errors
                    // 1. If route was not found -> log and try to load default state
                    // 2. If route was found but redirect throws an error -> reject
                    return (0, _lazyLoadRoutes.lazyLoadRoute)(targetState, targetParams)['catch'](function (err) {
                        if (err.message === 'lazy_loading_state_was_not_loaded') {
                            logUnknownState('_lazy_loading');
                            return loadDefaultState();
                        } else {
                            return _core.$promise.reject(err);
                        }
                    });
                } else {
                    logUnknownState();
                }
            }
            return loadDefaultState();
        })['catch'](function (err) {
            return _angular.$injector.get('$exceptionHandler')(err);
        });
    },

    runMiddleware: function runMiddleware(middleware) {

        _logger.$logger.info('middleware', {
            priority: _core.$util.map(middleware, function (method) {
                return method.name;
            }).join('|')
        });

        var promise = _core.$promise.resolve();

        angular.forEach(middleware, function (method) {
            promise = promise.then(function () {

                if (method.name) {
                    _logger.$logger.info('middleware_' + method.name);
                }

                return method();
            });
        });

        return promise;
    },

    register: function register() {
        var _this3 = this;

        this.template = this.constructTemplate(this.childAttributes || {});

        this.absolutePath = this.path || this.name;

        if (this.parent) {
            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
        }

        if (!_uiRouter.$state.get(this.absolutePath)) {
            _uiRouter.$stateProvider.state(this.absolutePath, this);
        }

        angular.forEach(this.children, function (childSpec) {
            // skip registering child if it's supposed to be lazy loaded
            if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
                return;
            }
            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);

            var childRoute = new ChildRoute({
                parent: _this3,
                childSpec: childSpec,
                childAttributes: childSpec.attributes
            });

            childRoute.register();
        });
    },

    /**
     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
     * '<xo-add-bank/>'.
     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
     *
     * @param attributes - A map of name value pairs - {name: value}.
     * @returns {string}
     */
    constructTemplate: function constructTemplate(attributes) {
        var self = this;

        if (!self.directive) {
            return;
        }

        attributes['component-route'] = 'route';

        if (this.parent) {
            attributes['export'] = 'view';
        }

        var tag = this.getDirectiveTag();

        var paramString = '';

        angular.forEach(attributes, function (value, key) {
            paramString += ' ' + key + '="' + value + '"';
        });

        return '<div ' + tag + ' ' + paramString + '></div>';
    }
});

if (!_uiRouter.$state.get('default')) {
    _uiRouter.$stateProvider.state('default', {
        auth: false
    });
}

$Route.reopenClass({
    render: function render(props) {

        _core.$event.emit('$resetState');
        _core.$loader.reset();
        _uiRouter.$state.go('default');
        setTimeout.flush();

        var $scope = angular.extend(_angular.$rootScope.$new(), props);

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var element = (0, _angular.$compile)('<div id="app"><ui-view></ui-view></div>')($scope);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            _core.$loader.reset();
            angular.element(document.getElementById('app')).remove();
        }));

        var route = new this({
            // Pass child attributes to simulate a route receiving scope variables from the parent
            childAttributes: _core.$util.reduce(props, function (result, val, key) {
                result[_core.$util.camelToDasherize(key)] = key;
                return result;
            }, {})
        });

        route.bootstrap(route.defaultState || route.path || route.name);
        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
        angular.element(document.body).append(element);

        return element;
    },


    assertActive: function assertActive() {
        var isState = _uiRouter.$state.current instanceof this;

        if (!isState) {
            throw new Error('Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
        }
    }
});

function getPageTitle(stateName) {

    var state = _uiRouter.$state.get(stateName);

    if (!state) {
        return;
    }

    if (state.titleContent) {
        return _locale.$locale.content.get(state.titleContent);
    }
}

function changePageTitle() {

    document.documentElement.setAttribute('lang', _locale.$locale.lang);

    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
        return;
    }

    var fullStateTitle = [];

    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {

        var stateName = [a, b].filter(Boolean).join('.');
        var stateTitle = getPageTitle(stateName);

        if (stateTitle) {
            fullStateTitle.push(stateTitle);
        }

        return stateName;
    }, null);

    document.title = _core.$util.unique(fullStateTitle).join(' - ');
}

_core.$event.on('$stateChangeSuccess', changePageTitle);
_core.$event.on('contentChange', changePageTitle);

var $ComponentRoute = exports.$ComponentRoute = $Route;

angular.value("$Route", $Route);
angular.value("$ComponentRoute", $ComponentRoute);
_angular.$rootScope;

_angular.$location;

_angular.$injector;

_angular.$compile;

_uiRouter.$state;

_uiRouter.$stateProvider;

_uiRouter.$urlRouterProvider;

_logger.$logger;

_core.$config;

_core.$Class;

_core.$util;

_core.$promise;

_core.$event;

_core.$loader;

_locale.$locale;

_component.$Component;

_ng.$cleanRootScope;

_ng.$angularInvoke;

_ng.$once;

_config.$meta;

_lazyLoadRoutes.lazyLoadRoute;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/config.js":
/***/ (function(module, exports, __webpack_require__) {



var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");

_core.$config.deploy = _core.$config.deploy || _env.$env;

_core.$config;

_env.$env;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/env.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var $env = exports.$env = {

    isLocal: function isLocal() {
        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
    },

    isStage: function isStage() {
        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
    },

    isSandbox: function isSandbox() {
        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
    },

    isLive: function isLive() {
        return window.location.hostname === 'www.paypal.com';
    },

    isTest: function isTest() {
        return false;
    }
};

angular.value("$env", $env);

/***/ }),

/***/ "../node_modules/squid/dist/paypal/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");

Object.keys(_env).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _env[key];
    }
  });
});

var _config = __webpack_require__("../node_modules/squid/dist/paypal/config.js");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _pxp = __webpack_require__("../node_modules/squid/dist/paypal/pxp.js");

Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pxp[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/paypal/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPModel = undefined;
exports.$getPxpTreatments = $getPxpTreatments;
exports.$pxp = $pxp;
exports.$pxpMatch = $pxpMatch;
exports.$pxpFactors = $pxpFactors;
exports.$elmo = $elmo;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var $PXPModel = exports.$PXPModel = _core.$Model.extend({
    api: new _core.$Api({
        uri: '/api/pxp/:pagename'
    })
});

function logPxp(pxpRes, params, logPayload) {
    var exp_name = [];
    var xe = [];
    var xt = [];
    var isElmoExperiment = params.isElmoExperiment;

    angular.forEach(pxpRes.treatments, function (treatment) {

        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
            experiment: pxpRes.pagename,
            treatment: treatment.treatment_name,
            experiment_id: treatment.experiment_id,
            treatment_id: treatment.treatment_id,
            loc_country: _locale.$locale.country,
            loc_lang: _locale.$locale.lang,
            exp_source: isElmoExperiment ? 'elmo' : 'pxp'
        }, params, logPayload));

        exp_name.push(treatment.treatment_name);
        xe.push(treatment.experiment_id);
        xt.push(treatment.treatment_id);
    });

    _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
        pxp_exp_id: xe.join('|'),
        pxp_trtmnt_id: xt.join('|'),
        treatments: exp_name.join('|'),
        loc_country: _locale.$locale.country,
        loc_lang: _locale.$locale.lang,
        exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    }, params, logPayload));

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: xe.join(','),
        pxp_trtmnt_id: xt.join(','),
        exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    });

    _core.$event.emit('pxp_res', pxpRes);
}

function $getPxpTreatments(id, params, logPayload) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isElmoExperiment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;


    return _core.$promise.run(function () {
        if (isElmoExperiment) {
            Object.assign(params, { isElmoExperiment: isElmoExperiment });
        }

        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });
        var forceTreatments = _core.$util.param('pxp_' + id) || _core.$util.param('elmo_' + id);

        if (forceTreatments) {
            var treatments = forceTreatments.split(',').filter(Boolean);

            pxp.treatments = treatments.map(function (treatment_name) {
                return {
                    treatment_name: treatment_name
                };
            });

            return pxp;
        }

        if (forceApiCall) {
            pxp.cached = false;

            return pxp.reload({
                params: params,
                silent: silent
            });
        }

        return pxp.retrieve({
            params: params,
            silent: silent,
            // Ignore all errors from this api, by passing transientError as true
            // Pxps are not critical calls, so they should fail silently without fallbacks (page reload / showing error page)
            transientError: true
        });
    }).then(function (pxp) {
        if (!pxp.cached) {
            logPxp(pxp, params, logPayload);
        }

        pxp.cached = true;

        return pxp;
    });
}

function $pxp(id, params, pattern) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isElmoExperiment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (!pattern) {
        pattern = params;
        params = {};
    }

    pattern = new RegExp('^' + pattern + '$');

    return exports.$getPxpTreatments(id, params, null, forceApiCall, silent, isElmoExperiment).then(function (experimentResponse) {
        var result = void 0;

        (experimentResponse.treatments || []).some(function (treatment) {
            if (!pattern.test(treatment.treatment_name)) {
                return false;
            }

            result = {
                treatment_name: treatment.treatment_name,
                factors: treatment.factors
            };

            return true;
        });

        return result;
    });
}

function $pxpMatch(id, params, patterns, logPayload) {
    if (!patterns) {
        patterns = params;
        params = {};
    }

    return exports.$getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
        var result = {};

        angular.forEach(patterns, function (pattern, name) {
            pattern = new RegExp('^' + pattern + '$');
            result[name] = false;

            (pxpResponse.treatments || []).some(function (treatment) {
                if (!pattern.test(treatment.treatment_name)) {
                    return false;
                }

                result[name] = true;
                return true;
            });
        });

        return result;
    });
}

function $pxpFactors(id, params, pattern) {
    params.factors = 'true';
    return $pxp(id, params, pattern).then(function (pxpResponse) {
        var result = void 0;

        if (pxpResponse && pxpResponse.factors) {
            result = { treatment_name: pxpResponse.treatment_name };
            var pxpFactors = pxpResponse.factors;
            var length = pxpFactors.length;

            for (var i = 0; i < length; i++) {
                result[pxpFactors[i].name] = pxpFactors[i].value;
            }
        }

        return result;
    });
}

function $elmo(id, params, pattern) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    var isElmoExperiment = true;

    return $pxp(id, params, pattern, forceApiCall, silent, isElmoExperiment);
}

window.$pxp = $pxp;
window.$elmo = $elmo;

angular.value("$PXPModel", $PXPModel);
angular.value("$getPxpTreatments", $getPxpTreatments);
angular.value("$pxp", $pxp);
angular.value("$pxpMatch", $pxpMatch);
angular.value("$pxpFactors", $pxpFactors);
angular.value("$elmo", $elmo);
_logger.$logger;

_core.$Model;

_core.$Api;

_core.$util;

_core.$promise;

_core.$event;

_locale.$locale;

/***/ }),

/***/ "../node_modules/ul-inline/dist/inject.js":
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

!function(a,b){a.PAYPAL=a.PAYPAL||{},a.PAYPAL.unifiedLogin=b()}(this,function(){function a(a,b){var c,d={src:a,height:b.height||239,style:"width: 100%;",name:b.name||"injectedUl",frameborder:0,scrolling:b.scrolling||"no",title:b.title||"PayPal",sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"},e=document.createElement("iframe");b.hide&&(d.style=d.style+"display: none;");for(c in d)e.setAttribute(c,d[c]);return e}function b(a,b,c){var d,e=a||window.location.origin||window.location.protocol+"//"+window.location.host,f=e+(c||"/signin/inject/"),g=b?"?":"",h=0;if(!b)return f;for(d in b)h>0&&(g+="&"),g=g+d+"="+encodeURIComponent(b[d]),h+=1;return f+g}function c(a){var b,c="";try{if(a.source.name!==q.name)return}catch(d){return}if(b=g(a.origin),!f(b))throw new Error("PostMessage iframe domain ("+b+"), must be a *.paypal.com domain");if(c=a&&a.data,"string"==typeof c)try{c=JSON.parse(c)}catch(h){throw new Error("Invalid JSON string sent to onPostMessage handler: "+c)}c.data&&"resize"===c.data.event?e(q,c.data.heightInPx):c.data&&"htmlRendered"===c.data.event?x=!0:!w&&p?p(c):w&&v.push(c)}function d(a){a&&"resize"===a.event?e(s,a.heightInPx):r(a)}function e(a,b){a.setAttribute("height",b)}function f(a){var b=/\.paypal\.com$/gi;return b.test(a)}function g(a){if(a){var b=/^https?:\/\/(.*\.paypal\.com)(:[0-9]+)?$/gi,c=b.exec(a);return c&&c[1]}}function h(){var a;if(p){for(a=0;a<v.length;a++)p(v[a]);v=[],w=!1}}function i(c){var d,e,h,i,k;if(!c||!c.targetElement)throw h="targetElement",new Error("The "+h+" option is required");if(c.origin&&(i=g(c.origin),!f(i)))throw new Error('All values for the "origin" setting must match *.paypal.com');for(u=c.config||{},e=b(c.origin,c.queryParams,c.iframePathname),k=c.xhrRequest&&c.xhrRequest===!0,d=k||c.preLoadedSource?a("about:blank",u):a(e,u),t=c.targetElement;c.targetElement.hasChildNodes();)c.targetElement.removeChild(c.targetElement.lastChild);return c.targetElement.appendChild(d),"directMessageIframe"===c.iframeType?(s=d,r=c.onPostMessage):(q=d,p=c.onPostMessage,j()),k?n(e,function(a){a&&o(d,a)}):c.preLoadedSource&&o(d,c.preLoadedSource),w=p?!1:!0,{iframe:d,onPostMessageCallback:p}}function j(){window.addEventListener?window.addEventListener("message",c,!1):window.attachEvent("onmessage",c)}function k(a){p=a,h()}function l(){t.parentNode&&t.parentNode.removeChild(t)}function m(b){var c,d,e,f,g="about:blank";if(!x)return void setTimeout(function(){m(b)},50);for(b.onPostMessage&&k(b.onPostMessage),u.hide=!1,c=a(g,u);b.targetElement.hasChildNodes();)b.targetElement.removeChild(b.targetElement.lastChild);b.targetElement.appendChild(c),d=q.contentWindow.document,e=d.documentElement.outerHTML,f=c.contentWindow.document,f.open(),f.write(e),f.close(),l(),q=c,t=b.targetElement}function n(a,b){var c;window.XMLHttpRequest?c=new XMLHttpRequest:window.ActiveXObject&&(c=new ActiveXObject("Microsoft.XMLHTTP")),c&&(c.onreadystatechange=function(){4==c.readyState&&200==c.status&&b(c.responseText)},c.open("GET",a,!0),c.send())}function o(a,b){a.contentWindow.inlineUlContents=b,a.src='javascript:window["inlineUlContents"]'}var p,q,r,s,t,u,v=[],w=!1,x=!1;return{inject:i,copyPasteIframe:m,removeTargetElement:l,messageDispatcher:c,nonPostMessageDispatcher:d}});

}.call(window));

/***/ }),

/***/ "../node_modules/xo-address-components/src/add-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddAddressComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown-multiline/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

__webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js");

__webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _template = __webpack_require__("../node_modules/xo-address-components/src/add-address/template.html");

var _template2 = _interopRequireDefault(_template);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddAddressComponent = exports.$xoAddAddressComponent = _squid.$Component.extend('$xoAddAddressComponent', {
    tag: 'xo-add-address',
    template: _template2['default'],
    props: {
        address: {
            type: 'var',
            required: false
        },
        isShipping: {
            type: 'var',
            required: false
        },
        country: {
            type: 'var',
            required: false
        },
        metadata: {
            type: 'str',
            required: false
        },
        hideButtonHandler: {
            type: 'var',
            required: false
        },
        hideCep: {
            type: 'var',
            required: false
        },
        hideAddPreferred: {
            type: 'var',
            required: false
        },
        hideName: {
            type: 'var',
            required: false
        },
        triggerZipCodeBlur: {
            type: 'var',
            required: false
        },
        triggerZipCodeKeyPress: {
            type: 'var',
            required: false
        },
        renderBillingAddCheckbox: {
            type: 'var',
            required: false
        }
    },
    controller: ['$scope', '$populate', '$CheckoutAppDataModel', '$ShippingRuleSummaryModel', '$CheckoutPayeeModel', '$CheckoutCartModel', function ($scope, $populate, $CheckoutAppDataModel, $ShippingRuleSummaryModel, $CheckoutPayeeModel, $CheckoutCartModel) {
        // eslint-disable-line max-statements

        $scope.token = _angular.$rootScope.token;

        if ($scope.token) {
            $populate($scope, {
                checkoutCart: $CheckoutCartModel.instance($scope.token).retrieve(),
                checkoutAppData: $CheckoutAppDataModel.instance($scope.token).retrieve(),
                checkoutPayee: $CheckoutPayeeModel.instance($scope.token).retrieve()
            }).then(function () {
                // Snt Flow check
                if ($scope.checkoutAppData.is_snt_supported()) {
                    if (_squid.$config.readRulesSummaryFromAppData === true || _squid.$config.readRulesSummaryFromAppData === 'true') {
                        _logger.$logger.info('setting_snt_or_callback_flow_for_snt_from_app_data');
                        $scope.snt_or_callback_flow = $scope.checkoutAppData.is_snt_enabled();
                    } else {
                        $populate($scope, {
                            profileRulesSummary: $ShippingRuleSummaryModel.instance($scope.token).retrieve({
                                params: {
                                    merchant_id: $scope.checkoutPayee.merchant.id,
                                    currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
                                }
                            })
                        }).then(function () {
                            // Variable to determine the county is optional or required for GB SNT and CALLBACK flows.
                            // with out being the county required, shipping methods won't populate.
                            // JIRA ID : PPPLMER-71514
                            _logger.$logger.info('setting_snt_or_callback_flow_for_snt');
                            $scope.snt_or_callback_flow = !!($scope.profileRulesSummary && $scope.profileRulesSummary.isSnTEnabled);
                        });
                    }
                } else if ($scope.checkoutCart.instantUpdateIntegration) {
                    _logger.$logger.info('setting_snt_or_callback_flow_for_callback');
                    $scope.snt_or_callback_flow = true;
                }
            });
        }

        var sortStates = void 0;
        var country = $scope.country || $scope.address && $scope.address.country;

        $scope.country = country;
        $scope.locale = _squid.$locale;
        $scope.metadata = _squid.$MetadataModel.create();

        // If the user changes their shipping/billing address country, fetch that metadata (if needed) and re-render.
        $scope.$watch('country', function () {
            $scope.metadata.choose($scope.country, $scope.locale.lang);
            onCountryChange();
        });

        function onCountryChange() {
            sortStates = (0, _squid.$feature)('sortStatesForAddress', false, $scope.country);

            if (sortStates) {
                getSortedStateList();
            }
        }

        onCountryChange();

        // If the user changes languagle toggle, fetch that metadata (if needed) and re-render.
        $scope.$on('contentChange', function () {
            $scope.metadata.choose($scope.country, $scope.locale.lang);
        });

        /**
         * Prefix to use for `id`, `name`, and `for` attributes. This is needed because Xoon will sometimes display both billing
         * and shipping address forms on the same page and without a prefix there will be duplicte `id`s and `name`s on the page.
         */
        $scope.attrPrefix = $scope.isShipping ? 'shipping' : 'billing';

        $scope.$watch('address.state', function () {
            _angular.$rootScope.$emit($scope.attrPrefix + 'AddressStateChange', $scope.address);
        });

        $scope.normalizeCountry = function (countryCode) {
            return (0, _squid.$feature)('AddressFormat', countryCode, countryCode) || countryCode;
        };

        $scope.isAddPreferred = (0, _squid.$feature)('preferredShipping', false, $scope.country) && $scope.isShipping;
        $scope.isAddressLookupEnabled = (0, _squid.$feature)('addressLookup', false, $scope.country);
        $scope.isShowLookupFields = $scope.isAddressLookupEnabled;

        if ($scope.isShowLookupFields) {
            // Show the Address Lookup Fields only when the hideButtonHandler function is passed by the caller.
            if ($scope.hideButtonHandler) {
                $scope.hideButtonHandler(true);
            } else {
                $scope.isShowLookupFields = false;
            }
        }

        function getSortedStateList() {
            var states = _squid.$locale.content.get(sortStates, {});
            var statesList = [];

            angular.forEach(states, function (key, value) {
                statesList.push({ code: value, sname: key });
            });
            statesList.sort(function (a, b) {
                return a.sname.localeCompare(b.sname);
            });

            $scope.sortedStatesList = statesList;
        }

        $scope.formatZip = function () {
            var unformatted = $scope.address.postal_code && $scope.address.postal_code.replace(/[^0-9]/gi, '');
            var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3)]].map(function (x) {
                return x[1] && x[0] + x[1] || '';
            }).join('');

            $scope.address.postal_code = formatted;
        };

        function getAddress(address) {
            var COMMA = ', ';
            var SPACE = ' ';
            var line1 = void 0;
            var line2 = void 0;

            function prefix(str, prefixStr) {
                if (str) {
                    return (prefixStr ? prefixStr : '') + str;
                }
                return '';
            }

            if (!address.deliveryAddresses || angular.isArray(address.deliveryAddresses) && address.deliveryAddresses.length === 0) {
                // if deliveryAddresses is not an array or is empty
                // line would be empty, hence return to caller.
                return;
            }

            var array = address.deliveryAddresses;

            if (array.length > 1) {
                // populate line2 from the last element
                line2 = array.pop();
            }
            line1 = array.join(COMMA);

            var displayLine1 = line1 + prefix(line2, COMMA);
            var displayLine2 = prefix(address.city) + prefix(address.state, COMMA) + prefix(address.postal_code, SPACE);
            var displayLine3 = prefix(address.country);

            return {
                line1: line1,
                line2: line2,
                city: address.city,
                state: address.state,
                postal_code: address.postal_code,
                country: address.country,
                displayLine1: displayLine1,
                displayLine2: displayLine2,
                displayLine3: displayLine3,
                dropDownAddress: displayLine1 + prefix(displayLine2, ' \\n ') + prefix(displayLine3, ' \\n ')
            };
        }

        function populateAddressFormFields(address) {
            $scope.address.line1 = address.line1;
            $scope.address.line2 = address.line2;
            $scope.address.city = address.city;
            $scope.address.state = address.state;
            $scope.address.postal_code = address.postal_code;
            $scope.address.neighborhood = address.neighborhood;
        }

        /**
         * Show error message and display the full-address fields
         */
        function populateErrorMessage() {
            var messages = [];

            messages.push($scope.locale.content.get('addressBook.lookupError'));
            $scope.lookupFailureMessage = {
                msgs: messages,
                type: 'warning'
            };
            $scope.isShowLookupFields = false;
            $scope.isLookupFailure = true;
        }

        function processLookupResult(list) {
            if (list.length > 1) {
                // Show drop-down list of all addresses
                $scope.isLookupSuccess = true;
                $scope.isShowLookupDropDown = true;
                $scope.lookupAddressList = list.map(function (addr) {
                    return getAddress(addr);
                });
            } else if (list.length === 1) {
                // Show single address component
                $scope.isLookupSuccess = true;
                $scope.isShowLookupDropDown = false;

                var address = getAddress(list[0]);

                $scope.singleAddress = address;
                populateAddressFormFields(address);
            } else {
                populateErrorMessage();
            }
        }

        if ($scope.address) {
            $scope.lastPrefilledZip = $scope.address.postal_code;
        }

        $scope.prefill = function () {
            var cepPattern = /^(\d{5}-\d{3}|\d{5}|\d{8})$/;
            var first_name = void 0;
            var last_name = void 0;

            if ($scope.lastPrefilledZip === $scope.address.postal_code || !cepPattern.test($scope.address.postal_code)) {
                return;
            }

            if ($scope.isShipping) {
                first_name = $scope.address.first_name;
                last_name = $scope.address.last_name;
            }

            $scope.prefillAddress = new _index.$PrefillAddressModel({
                id: $scope.token,
                address: {
                    country: $scope.address.country,
                    postal_code: $scope.address.postal_code
                }
            });

            return $scope.prefillAddress.save({
                data: $scope.prefillAddress,
                success: function success(result) {
                    if (result) {
                        populateAddressFormFields(result);
                        $scope.lastPrefilledZip = $scope.address.postal_code;
                        if ($scope.isShipping) {
                            $scope.address.first_name = first_name;
                            $scope.address.last_name = last_name;
                        }
                    }
                }
            });
        };

        $scope.findAddress = function () {
            $scope.lookupAddress = _index.$PrefillAddressModel.create($scope.token, {
                address: {
                    country: $scope.address.country,
                    postal_code: $scope.address.postal_code,
                    house_number: $scope.address.house_number,
                    building_name: $scope.address.building_name
                }
            });

            if (document.querySelector('#lookupZip.ng-invalid')) {
                document.querySelector('#addressLookupFields').classList.add('validated');
            } else {
                $scope.isLookupProcessing = true;
                $scope.lookupAddress.save({
                    data: $scope.lookupAddress,
                    silent: true,
                    success: function success(result) {
                        processLookupResult(result);
                        $scope.hideButtonHandler(false);
                    },
                    contingencies: {
                        INTERNAL_ERROR: populateErrorMessage
                    }
                });
            }
        };

        $scope.changeAddressDropDown = function () {
            populateAddressFormFields($scope.address.selectedAddress);
        };

        $scope.showFullAddress = function () {
            $scope.isShowLookupFields = false;
            $scope.hideButtonHandler(false);
        };

        /**
         * Pass an array of group names to retrieve the list of states
         * e.g. ['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies']
         */
        var stateNamesInGroup = [];

        $scope.retrieveStateNamesInGroup = function (groups) {
            if (stateNamesInGroup.length) {
                // Angular keeps watching for this method as its used in ng-model, hence return cached data.
                return stateNamesInGroup;
            }
            var content = _squid.$locale.content;

            angular.forEach(groups, function (group) {
                var groupName = content.common[group];
                var statesList = content[group];

                angular.forEach(statesList, function (value, key) {
                    stateNamesInGroup.push({
                        key: key,
                        value: value,
                        group: groupName
                    });
                });
            });
            return stateNamesInGroup;
        };

        $scope.zipCodeBlur = function () {
            if ($scope.triggerZipCodeBlur) {
                _angular.$rootScope.$emit('zip_code_blur');
            }
        };

        $scope.zipCodeKeyPress = function (event) {
            if ($scope.triggerZipCodeKeyPress) {
                _angular.$rootScope.$emit('zip_code_keypress', { event: event });
            }
        };
    }]
});

angular.value("$xoAddAddressComponent", $xoAddAddressComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$MetadataModel;

_index.$PrefillAddressModel;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-address-components/src/add-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addressForm\" class=\"addressForm\" content ng-class=\"country\">\n    <xo-name-input user=\"address\" country=\"{{country}}\" ng-if=\"isShipping && !hideName\" attr-prefix=\"attrPrefix\"></xo-name-input>\n    <div ng-switch=\"normalizeCountry(country)\" class=\"addressGroup clearfix\">\n        <div ng-switch-when=\"BR\">\n            <xo-zipcode id=\"zipcode\" prefix-attrs-with=\"{{attrPrefix}}\" attr-prefix=\"attrPrefix\" country=\"BR\" address=\"address\"\n                zip-label=\"{{content('common.cep')}}\" zip-error-key=\"common.valueInvalid\" done-fn=\"prefill\" ng-if=\"!hideCep\"></xo-zipcode>\n\n            <div id=\"addressFields\" prefix-attrs-with=\"{{attrPrefix}}\">\n                <div class=\"streetName clearfix\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\"\n                            maxlength=\"60\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip required prefix-attrs-with=\"{{attrPrefix}}\"/>\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.streetAddress') }}\n                        </label>\n                    </div>\n                    <div class=\"inputField streetNumber\" floating-label>\n                        <input type=\"text\" name=\"streetNumber\" id=\"streetNumber\" ng-pattern=\"/^(?=.*[0-9])([a-zA-Z0-9]+)$/\"\n                            ng-model=\"address.streetNumber\" value=\"\" maxlength=\"6\" ariaRequired=\"true\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                        <label for=\"streetNumber\" id=\"streetNumberLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.streetNumber') }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\"\n                        maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential neighborhood\" floating-label>\n                    <input type=\"text\" name=\"neighborhood\" id=\"neighborhood\" ng-model=\"address.neighborhood\"\n                        value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" ariaRequired=\"true\"\n                        data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"neighborhood\" id=\"neighborhoodLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.neighborhood') }}\n                    </label>\n                </div>\n                <div class=\"inputField confidential clearfix\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.onlyCity') }}</label>\n                    </div>\n                    <div class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-options=\"state.code as state.sname for state in sortedStatesList\"\n                            ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\"\n                            data-test-id=\"BR:addressProvince\" prefix-attrs-with=\"{{attrPrefix}}\" required >\n                            <option value=\"\">{{ content('common.otherState') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.otherState') }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-switch-when=\"GB\">\n            <!-- start: Show all the fields for Add Address if isShowLookupFields is false -->\n            <div ng-if=\"!isShowLookupFields\">\n                <div ng-if=\"isAddressLookupEnabled\">\n                    <div ng-if=\"isShipping\" class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                    </div>\n                    <div ng-show=\"isLookupFailure\" class=\"lookupFailureMsg\">\n                        <xo-message message=\"lookupFailureMessage\"></xo-message>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line1\" floating-label>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress') }}</label>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\"\n                        autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential city\" floating-label>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.onlyCity') }}</label>\n                </div>\n                <div class=\"stateZip clearfix\">\n                    <div class=\"dropdown confidential state inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\"\n                                aria-required=\"true\" prefix-attrs-with=\"{{attrPrefix}}\" ng-required=\"snt_or_callback_flow\"\n                                ng-options=\"c.key as c.value group by c.group for c in retrieveStateNamesInGroup(['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies'])\">\n                                <option value=\"\">{{ snt_or_callback_flow ? content('common.county') : content('common.countyOptional') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ snt_or_callback_flow ? content('common.county') : content('common.countyOptional') }}</label>\n                    </div>\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\"\n                            autocomplete=\"off\" data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                        \"country\": \"GB\"\n                                    }\n                                }'\n                            xo-error-tooltip required />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.zip') }}</label>\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show all the fields -->\n            <!-- start: Show only the address lookup fields -->\n            <div ng-if=\"isShowLookupFields\" id=\"addressLookup\" class=\"addressLookup\" prefix-attrs-with=\"{{attrPrefix}}\">\n                <div ng-hide=\"isLookupSuccess\" id=\"addressLookupFields\" prefix-attrs-with=\"{{attrPrefix}}\"> <!-- class=\"validated\" -->\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addBillingAddress.lookupTitle') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">{{ content('addressBook.enterFullAddress') }}</a>\n                    </div>\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField confidential lookupZip\">\n                            <input type=\"text\" name=\"lookupZip\" id=\"lookupZip\" ng-model=\"address.postal_code\" value=\"\"\n                                autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                                data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                    \"country\": \"GB\"\n                                    }\n                                }'\n                                ng-disabled=\"isLookupProcessing\" xo-error-tooltip required />\n                            <label for=\"lookupZip\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                                {{ content('common.zip') }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"inputField confidential houseNo\" floating-label>\n                        <input type=\"text\" id=\"houseNo\" name=\"houseNo\" ng-model=\"address.house_number\"\n                            value=\"\" maxlength=\"50\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip\n                            ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"houseNo\" id=\"houseNoLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.houseBldgNo') }}\n                        </label>\n                    </div>\n                    <div class=\"inputField confidential buildingName\" floating-label>\n                        <input type=\"text\" id=\"buildingName\" ng-model=\"address.building_name\"\n                            value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" name=\"buildingName\"\n                            ng-disabled=\"isLookupProcessing\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"buildingName\" id=\"buildingNameLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.houseBldgName') }}\n                        </label>\n                    </div>\n                    <button track-submit ng-click=\"findAddress()\" id=\"findAddressButton\" class=\"btn full continue\"\n                            ng-class=\"{processing: isLookupProcessing}\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        <div ng-show=\"isLookupProcessing\" class=\"spinner\">\n                            <p class=\"loader\" ></p>\n                        </div>\n                        <div ng-hide=\"isLookupProcessing\" class=\"text\">{{ content('addressBook.findAddress') }}</div>\n                    </button>\n                </div>\n                <div ng-show=\"isLookupSuccess\">\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">\n                            {{ content('common.change') }}\n                        </a>\n                    </div>\n                    <div ng-if=\"isShowLookupDropDown\" id=\"lookedupDropDown\"\n                        class=\"dropdown confidential clearfix\" prefix-attrs-with=\"{{attrPrefix}}\">\n\n                        <select xo-dropdown-multiline ng-model=\"address.selectedAddress\"\n                                ng-change=\"changeAddressDropDown()\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                id=\"addressDropDown\" ng-required=\"isShowLookupDropDown\">\n                            <option value=\"\" selected=\"selected\">\n                                {{ content('addressBook.selectYourAddress', { count: lookupAddressList.length}) }}\n                            </option>\n                            <option ng-repeat=\"addr in lookupAddressList track by $index\" value=\"{{$index}}\">\n                                {{ addr.dropDownAddress }}\n                            </option>\n                        </select>\n                    </div>\n                    <div ng-hide=\"isShowLookupDropDown\" class=\"singleAddress\">\n                        {{ singleAddress.displayLine1 }}<br/>\n                        {{ singleAddress.displayLine2 }}<br/>\n                        {{ singleAddress.displayLine3 }}\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show only the address lookup fields -->\n        </div>\n        <!-- GB end -->\n        <!-- IE begin -->\n        <div ng-switch-when=\"IE\">\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout track by $index\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                            autocapitalize=\"off\" aria-required=\"{{layoutItem.required}}\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line1Label || metadata.addressEntry.strings[country].line1Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            xo-error-tooltip maxlength=\"50\" aria-required=\"{{layoutItem.required}}\" ng-required=\"{{layoutItem.required}}\"\n                            autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                        <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line2Label || metadata.addressEntry.strings[country].line2Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"{{layoutItem.required}}\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].cityLabel || metadata.addressEntry.strings[country].cityLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList\"\n                        class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown prefix-attrs-with=\"{{attrPrefix}}\"\n                            ng-options=\"state.$id as state.$id for state in (locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\"\n                            ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"{{layoutItem.required}}\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateList }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                    <!-- state input field is not marked as required as OAS is currently not validating state field for empty value or for any regex check -->\n                    <div ng-if=\"!(locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\" class=\"inputField confidential state\"\n                        floating-label>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                </div>\n                <!-- postalcode input field is not marked as required as OAS is currently not validating state field for empty value or for any regex check -->\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" ng-blur=\"zipCodeBlur()\"\n                            ng-keypress=\"zipCodeKeyPress()\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                            data-error-key=\"validation.validZipCode\" maxlength=\"{{layoutItem.maxLength}}\" xo-error-tooltip prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].postcodeLabel || metadata.addressEntry.strings[country].postcodeLabel }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- IE end -->\n\n        <div ng-switch-default>\n            <!-- Griffin metadata DOES exist for this country -->\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout track by $index\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label directionality>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\"\n                            track-focus-and-blur=\"line1\"\n                            autocapitalize=\"off\" aria-required=\"{{layoutItem.required}}\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line1Label || metadata.addressEntry.strings[country].line1Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label directionality>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" aria-required=\"{{layoutItem.required}}\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\"\n                            track-focus-and-blur=\"line2\"\n                            xo-error-tooltip autocapitalize=\"off\" autocomplete=\"off\" ng-required=\"{{layoutItem.required}}\" data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line2Label || metadata.addressEntry.strings[country].line2Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label directionality>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            track-focus-and-blur=\"city\"\n                            autocapitalize=\"off\" aria-required=\"{{layoutItem.required}}\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].cityLabel || metadata.addressEntry.strings[country].cityLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList\"\n                        class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id.toUpperCase() as state.$elt for state in (locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\"\n                            track-focus-and-blur=\"state\"\n                            ng-model=\"address.state\" id=\"state\" aria-required=\"{{layoutItem.required}}\" ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                    <!-- state input field is not marked as required as OAS is currently not validating state field for empty value or for any regex check -->\n                    <div ng-if=\"!(locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\" class=\"inputField confidential state\"\n                        floating-label directionality>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\"\n                            track-focus-and-blur=\"state\"\n                            aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <xo-zipcode id=\"zipcode\" zip-entry=\"layoutItem\" country=\"{{country}}\"\n                                max-length=\"layoutItem.maxLength\" address=\"address\" attr-prefix=\"attrPrefix\"\n                                done-fn=\"zipCodeBlur\" prefix-attrs-with=\"{{attrPrefix}}\" aria-required=\"{{layoutItem.required}}\"\n                                key-press-fn=\"zipCodeKeyPress\" zip-required=\"layoutItem.required\"\n                                zip-label=\"{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].postcodeLabel || metadata.addressEntry.strings[country].postcodeLabel }}\"\n                                zip-error-key=\"validation.validZipCode\"></xo-zipcode>\n                </div>\n            </div>\n            <!-- Griffin metadata DOES NOT exist for this country -->\n            <div ng-if=\"!metadata.addressEntry.layout\">\n                <div class=\"inputField confidential line1\" floating-label directionality>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" data-test-id=\"addrSt\" ng-model=\"address.line1\"\n                        value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                        track-focus-and-blur=\"line1\"\n                        data-error-key=\"common.valueInvalid\" xo-error-tooltip required prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.stAddress') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential city\" floating-label directionality>\n                    <input type=\"text\" name=\"city\" id=\"city\"data-test-id=\"addrCity\" maxLength=\"100\" ng-model=\"address.city\"\n                        track-focus-and-blur=\"city\"\n                        value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.otherCity') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential state\" floating-label directionality>\n                    <input type=\"text\" name=\"state\" id=\"state\" data-test-id=\"addrState\" ng-model=\"address.state\"\n                        track-focus-and-blur=\"state\"\n                        value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.optionalState') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential postalCode\" floating-label directionality>\n                    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" data-test-id=\"addrZipcode\" ng-model=\"address.postal_code\"\n                        track-focus-and-blur=\"postalCode\"\n                        value=\"\"  ng-blur=\"zipCodeBlur()\" ng-keypress=\"zipCodeKeyPress()\" autocapitalize=\"off\" aria-required=\"true\"\n                        autocomplete=\"off\" data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"/>\n                    <label for=\"postalCode\" id=\"zipLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.optionalPostalCode') }}\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isAddPreferred && !hideAddPreferred\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\" ng-model=\"address.preferred_address\" name=\"addPreferred\" id=\"addPreferred\" />\n        <label for=\"addPreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n    </div>\n\n    <div ng-if=\"renderBillingAddCheckbox\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\"  ng-model=\"address.isBA\" name=\"isBA\" id=\"addVenmoBA\" />\n        <label for=\"addVenmoBA\">{{ content('memberReview.useShippingAsBilling') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddressDisplayComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-address-components/src/address-display/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-address-components/src/address-display/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddressDisplayComponent = exports.$xoAddressDisplayComponent = _squid.$Component.extend('$xoAddressDisplayComponent', {
    tag: 'xo-address-display',
    template: _template2['default'],
    props: {
        address: {
            type: 'var',
            required: false
        },
        showPreferred: {
            type: 'str',
            required: false
        },
        countryCode: {
            type: 'var',
            required: false
        },
        displayFormattedAddr: {
            type: 'var',
            required: false
        }
    },
    actions: {
        formatAddress: function formatAddress(address) {
            var COMMA = ', ';
            var SPACE = ' ';

            function prefix(str, prefixStr) {
                if (str) {
                    return (prefixStr ? prefixStr : '') + str;
                }
                return '';
            }

            var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
            var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
            var displayLine3 = address.country ? prefix(address.country) : '';

            return {
                displayLine1: displayLine1,
                displayLine2: displayLine2,
                displayLine3: displayLine3
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            var address = this.props.address || {};
            var countryCode = typeof this.props.countryCode === 'undefined' ? address.country || address.country_code : this.props.countryCode;

            this.isPreferred = this.props.showPreferred && address.preferred_address && (0, _squid.$feature)('preferredShipping', false, countryCode);
            if (this.props.displayFormattedAddr) {
                this.formattedAddr = this.actions.formatAddress(address);
                this.$watchCollection('props.address', function (newVal) {
                    _this.formattedAddr = _this.actions.formatAddress(newVal);
                });
            }
        }
    }
});

angular.value("$xoAddressDisplayComponent", $xoAddressDisplayComponent);
_squid.$Component;

_squid.$feature;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"adr\" ng-class=[props.countryCode] content>\n    <div ng-if=\"props.address.full_address && !props.displayFormattedAddr\" class=\"confidential\">\n        <span class=\"full-address\" directionality-text=\"props.address.full_address\" data-test-id=\"fullAddress\">{{props.address.full_address}}</span>\n        <span class=\"country adr-break\">{{content('countryList.'+props.address.country)}}</span>\n    </div>\n\n    <div ng-if=\"props.displayFormattedAddr\" class=\"shippingAddress\">\n        {{formattedAddr.displayLine1}}<br/>\n        {{formattedAddr.displayLine2}}<br/>\n        {{formattedAddr.displayLine3}}\n    </div>\n\n    <div ng-if=\"isPreferred\" class=\"preferred\">\n        <span>\n            {{content('shippingAddress.preferred')}}\n        </span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization-edit/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization-edit/styles.less");

var _template = __webpack_require__("../node_modules/xo-address-components/src/address-normalization-edit/template.html");

var _template2 = _interopRequireDefault(_template);

var _statusconfig = __webpack_require__("../node_modules/xo-address-components/src/address-normalization-edit/statusconfig.json");

var _statusconfig2 = _interopRequireDefault(_statusconfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var normalizationState = {
    error: 'error',
    normalizedAddressUnavailable: 'normalizedAddressUnavailable',
    requiredFieldsDontMatch: 'requiredFieldsDontMatch',
    normalizedAddressAvailable: 'normalizedAddressAvailable',
    fullMatch: 'fullMatch'
};

exports['default'] = _squid.$Component.extend('xoAddressNormalizationEdit', {
    tag: 'xo-address-normalization-edit',
    template: _template2['default'],

    lifecycle: {
        populate: function populate() {
            var _this = this;

            (0, _angular.$timeout)(function () {
                return _this.$element.find('#closeForm').focus();
            }, 1000);
        }
    },

    scope: {
        id: '=?',
        address: '=?',
        sidebar: '=?',
        strictAddressNormalization: '=?',
        backUri: '=?',
        doneFn: '=?'
    },

    controller: ['$scope', '$element', function ($scope, $element) {
        _squid.$util.assert($scope.address, 'Original Address cannot be empty');

        if (!(0, _squid.$feature)('addressNormalizationEdit', false, $scope.address.country)) {
            return $scope.doneFn();
        }
        var $el = $($element);
        var config = JSON.parse(_statusconfig2['default']);
        var strictMode = $scope.strictAddressNormalization;

        $scope.normalization = config.status.initial;
        $scope.disableChangeShippingCountry = true;
        $scope.userEditAddress = false;
        $scope.normalizedEditAddress = false;

        (0, _squid.$populate)($scope, {
            checkoutSession: _index2.$CheckoutSessionModel.instance($scope.id)
        }).then(function () {
            var normalizationValue = void 0;
            fpti('prepare_' + $scope.normalization.instrumentation.transitionTo, $scope.address);
            $scope.servAddress = copyAddress($scope.address, 'NORMALIZED', $scope.address);

            getAddressNormalizationStatus().then(function () {
                if (normalizationValue === normalizationState.error) {
                    throw new Error('ERROR_ON_ADDRESS_NORMALIZATION_SERVICE');
                } else if (normalizationValue === normalizationState.fullMatch) {
                    updateAddress($scope.servAddress);
                } else {
                    $scope.showNormalizationForm = true;
                    trinityResponseCallback(normalizationValue);
                }
            })['catch'](function (error) {
                errorHandler(name, error, 'getAddressNormalizationStatus', 'error');
                $scope.doneFn();
            });

            function getAddressNormalizationStatus() {
                $scope.addressNormalization = new _index.$AddressNormalizationModel({
                    id: $scope.id,
                    address: $scope.servAddress
                });

                return $scope.addressNormalization.save({
                    data: $scope.addressNormalization,

                    contingencies: {
                        VALIDATION_ERROR: function VALIDATION_ERROR() {
                            normalizationValue = normalizationState.normalizedAddressUnavailable;
                        }
                    },

                    success: function success(result) {
                        normalizationValue = normalizationState.fullMatch;
                        // If empty response from Trinity, stop the user to double check his address
                        if (!result) {
                            normalizationValue = normalizationState.normalizedAddressUnavailable;
                            return;
                        }
                        $scope.normalizedAddress = copyAddress(result, 'NORMALIZED', $scope.servAddress);
                        // If normalized and original adddress are equal, don't stop the user
                        if (addressesEqual($scope.normalizedAddress, $scope.servAddress)) {
                            normalizationValue = normalizationState.fullMatch;
                            return;
                        }
                        if (strictMode) {
                            normalizationValue = normalizationState.normalizedAddressAvailable;
                            return;
                        }
                        if (!strictMode && !requiredFieldsMatch(result, $scope.servAddress)) {
                            normalizationValue = normalizationState.requiredFieldsDontMatch;
                            return;
                        }
                    },

                    error: function error() {
                        normalizationValue = normalizationState.error;
                    }
                });
            }

            function setFormStatus(status) {
                switch (status) {
                    case normalizationState.normalizedAddressAvailable:
                        $scope.normalizedAddressEdit = copyAddress($scope.normalizedAddress);
                        $scope.normalization = config.status.normalizedAddressAvailable;
                        break;
                    case normalizationState.requiredFieldsDontMatch:
                        $scope.servAddressEdit = copyAddress($scope.normalizedAddress, 'UNNORMALIZED_USER_PREFERRED');
                        $scope.normalization = config.status.requiredFieldsDontMatch;
                        break;
                    default:
                        $scope.servAddressEdit = copyAddress($scope.servAddress, 'UNNORMALIZED_USER_PREFERRED');
                        $scope.normalization = config.status.normalizedAddressUnavailable;
                        break;
                }
            }

            function trinityResponseCallback(response) {
                setFormStatus(response);
                // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
                _angular.$rootScope.$applyAsync(function () {
                    centerLightBox();
                    $(window).resize(centerLightBox);
                });
            }

            function focusFirstError() {
                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            }

            function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = $($el.find('[ng-model="address.' + field.field + '"]'));

                            if ($field.length === 0 && field.field === 'zip') {
                                $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                            }
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                        }
                    });
                    focusFirstError();
                }
            }

            var errorHandler = function errorHandler(name, err, action, type) {
                _logger.$logger.error('address_normalization_edit', {
                    'int_error_code': err,
                    'int_error_description': action + '-' + type,
                    'error_source': 'paymentapiplatformserv'
                });
            };

            function updateAddress(address) {
                $scope.checkoutSession.shipping.action('update', {
                    data: address,
                    resultModel: $scope.checkoutSession,
                    success: function success(result) {
                        $scope.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['smallToolTip.onlyAddressUpdated']
                        };
                        fpti('process_' + $scope.normalization.instrumentation.transitionTo, address);
                        $scope.doneFn();
                    },
                    validation: function validation(res) {
                        handleValidation(res);
                    },
                    contingencies: function contingencies(name, err) {
                        errorHandler(name, err, 'updateAddress', 'contingency');
                        $scope.doneFn();
                    },

                    error: function error(name, err) {
                        errorHandler(name, err, 'updateAddress', 'error');
                        $scope.doneFn();
                    }
                });
            }

            $scope.saveAndContinue = function () {
                switch ($scope.normalization.addressSelected) {
                    case 'normalizedAddress':
                        if (addressesEqual($scope.normalizedAddress, $scope.normalizedAddressEdit)) {
                            $scope.servAddress = copyAddress($scope.normalizedAddress);
                        } else {
                            $scope.servAddress = copyAddress($scope.normalizedAddressEdit, 'UNNORMALIZED_USER_PREFERRED');
                        }
                        break;
                    case 'editedAddress':
                        if (normalizationValue === normalizationState.requiredFieldsDontMatch && addressesEqual($scope.servAddressEdit, $scope.normalizedAddress)) {
                            $scope.servAddress = copyAddress($scope.servAddressEdit, 'NORMALIZED');
                        } else {
                            $scope.servAddress = copyAddress($scope.servAddressEdit, 'UNNORMALIZED_USER_PREFERRED');
                        }

                        break;
                    default:
                        break;
                }
                updateAddress($scope.servAddress);
            };

            function getName(name, country) {
                // Lets use griffin to get Name from Full Name
                var index = name.trim().indexOf(' ');
                var firstName = name.substr(0, index);
                var lastName = name.substr(index + 1);

                var recipientName = firstName + ' ' + lastName;
                if ((0, _squid.$feature)('nameFormat', country, country) === 'LastFirst') {
                    recipientName = lastName + ' ' + firstName;
                }

                return {
                    recipient_name: recipientName,
                    first_name: firstName,
                    last_name: lastName
                };
            }

            // This function is based on US Address fields
            // To extend to other countries, excluding fields
            // that don't belong to address works better (i.e. id, name, etc)
            function copyAddress(address, normalizationStatus, sessionInfo) {
                var name = getName(address.recipient_name || sessionInfo.recipient_name || sessionInfo.name, address.country);

                var localAddress = {
                    id: address.id || sessionInfo.id,
                    recipient_name: name.recipient_name,
                    first_name: name.first_name,
                    last_name: name.last_name,
                    line1: address.line1,
                    line2: address.line2,
                    city: address.city,
                    state: address.state,
                    postal_code: address.postal_code,
                    country: address.country,
                    normalization_status: normalizationStatus || address.normalization_status,
                    preferred_address: sessionInfo ? sessionInfo.preferred_address : address.preferred_address,
                    default_address: sessionInfo ? sessionInfo.default_address || sessionInfo['default'] : address.default_address
                };

                return localAddress;
            }

            function getShortPostalCode(address) {
                var dashIndex = address.postal_code.indexOf('-');
                return dashIndex !== -1 ? address.postal_code.substr(0, dashIndex) : address.postal_code;
            }

            function requiredFieldsMatch(addressOne, addressTwo) {
                var requiredFields = (0, _squid.$feature)('normalizationRequiredFields');
                $scope.missMatch = {};
                var fieldsMissMatch = void 0;
                for (var field in requiredFields) {
                    if (field === 'postalCode') {
                        $scope.missMatch[field] = getShortPostalCode(addressOne) !== getShortPostalCode(addressTwo);
                    } else {
                        $scope.missMatch[field] = addressOne[field] !== addressTwo[field];
                    }
                    fieldsMissMatch |= $scope.missMatch[field];
                }
                return !fieldsMissMatch;
            }

            // make space and case insensitive. sub empty vals for undefined.
            function desensitizedAddress(addr) {
                for (var key in addr) {
                    var val = addr[key];
                    if (addr.hasOwnProperty(key)) {
                        if (val && val.length) {
                            addr[key] = val.trim().toLowerCase();
                        } else {
                            addr[key] = undefined;
                        }
                    }
                }
                return addr;
            }

            function addressesEqual(address1, address2) {
                var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
                var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));

                if (!addressOne || !addressTwo) {
                    return false;
                }

                return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
            }

            function fpti(toValue, address) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'addr_norm',
                    to: toValue,
                    shipping_address_id: address.id,
                    normalized: address.normalization_status
                });
            }

            $scope.selection = function (value) {
                $scope.normalization.addressSelected = value;
                $scope.normalization.instrumentation = config.instrumentation[value];
            };

            $scope.showUserEditAddress = function () {
                $scope.userEditAddress = !$scope.userEditAddress;
                $scope.normalizedEditAddress = false;
                $el.find('#addressOriginal').prop('checked', true);
                $scope.selection('enteredAddress');
            };

            $scope.showNormalizedEditAddress = function () {
                $scope.normalizedEditAddress = !$scope.normalizedEditAddress;
                $scope.userEditAddress = false;
                $el.find('#addressNormalized').prop('checked', true);
                $scope.selection('normalizedAddress');
            };

            function centerLightBox() {
                var element = $('#lbox');
                if (!element.length) {
                    return;
                }

                var windowElement = $(window);
                var lboxContainerElem = $('#lboxContainer');
                element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
                element.css('width', '65%');
                var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
                var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
                var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
                if (computedLeft < leftBound) {
                    element.css('width', lboxContainerElem.width() * 0.8);
                }
                element.css('left', Math.max(0, elementLeft) + 'px');
                return element;
            }

            // Australia displays address line2 first
            $scope.isLine2First = function () {
                return $scope.address.country === 'AU';
            };

            $scope.removeValidation = function () {
                $el.find('form').removeClass('validated');
            };
        });
    }]
});


_angular.$timeout;

_angular.$rootScope;

_squid.$Component;

_squid.$populate;

_squid.$feature;

_squid.$util;

_index.$AddressNormalizationModel;

_index2.$CheckoutSessionModel;

_logger.$logger;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization-edit/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddressNormalizationFactory', function () {
    var getAddressNormalizationElmoResult = function getAddressNormalizationElmoResult(shippingCountry) {
        return (0, _squid.$elmo)('xo_hermes_address_normalization', { 'ctx.country': _squid.$locale.country, 'ctx.shippingCountry': shippingCountry }, 'xo_hermes_address_normalization_treatment').then(function (result) {
            return result && result.treatment_name;
        });
    };

    return {
        getAddressNormalizationElmoResult: getAddressNormalizationElmoResult
    };
});

_squid.$locale;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-address-components/src/address-normalization-edit", "../node_modules/xo-address-components/src/address-normalization-edit/factory.js"))

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization-edit/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddressNormalizationEditRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization-edit/directive.js");

var $AddressNormalizationEditRoute = exports.$AddressNormalizationEditRoute = _squid.$ComponentRoute.extend('AddressNormalizationEditRoute', {
    name: 'addressNormalizationEdit',
    titleContent: 'addressNormalization.addressmatch',
    directive: 'xo-address-normalization-edit',
    trackingData: {
        fptiState: 'address_normalization_edit',
        buzname: {
            'fullpage': {
                'pagename': '%::address_normalization_edit',
                'pagename2': '%::address_normalization_edit:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,

    children: []
});

angular.value("$AddressNormalizationEditRoute", $AddressNormalizationEditRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization-edit/statusconfig.json":
/***/ (function(module, exports) {



module.exports = "{\n    \"status\": {\n        \"initial\": {\n            \"status\": \"initial\",\n            \"addressSelected\": \"originalAddress\",\n            \"form\": {},\n            \"instrumentation\": {\n                \"transitionTo\": \"add_norm_original\",\n                \"transitionName\": \"address_normalization_normalizedAddres\"\n            }\n        },\n        \"normalizedAddressAvailable\": {\n            \"status\": \"normalizedAddressAvailable\",\n            \"addressSelected\": \"normalizedAddress\",\n            \"form\": {\n                \"title\": \"addressNormalization.titlePartialMatch\",\n                \"updateTitle\":  \"addressNormalization.originalAddress\"\n            },\n            \"instrumentation\": {\n                \"transitionTo\": \"add_norm_choose\",\n                \"transitionName\": \"address_normalization_normalizedAddres\"\n            }\n        },\n        \"requiredFieldsDontMatch\": {\n            \"status\": \"requiredFieldsDontMatch\",\n            \"addressSelected\": \"editedAddress\",\n            \"form\": {\n                \"title\": \"addressNormalization.titleUpdatedShippingAddress\",\n                \"originalAddress\": \"addressNormalization.undeliverableAddress\",\n                \"editAddress\": \"addressNormalization.updatedAddress\"\n            },\n            \"instrumentation\": {\n                \"transitionTo\": \"add_norm_edit\",\n                \"transitionName\": \"address_normalization_enteredAddress\"\n            }\n        },\n        \"normalizedAddressUnavailable\": {\n            \"status\": \"normalizedAddressUnavailable\",\n            \"addressSelected\": \"editedAddress\",\n            \"form\": {\n                \"title\": \"addressNormalization.titleUpdateYourAddress\",\n                \"originalAddress\": \"addressNormalization.undeliverableAddress\",\n                \"editAddress\": \"addressNormalization.newAddress\"\n            },\n            \"instrumentation\": {\n                \"transitionTo\": \"add_norm_edit\",\n                \"transitionName\": \"address_normalization_enteredAddress\"\n            }\n        }\n    },\n    \"instrumentation\": {\n        \"normalizedAddres\": {\n            \"transitionTo\": \"add_norm_choose\",\n            \"transitionName\": \"address_normalization_normalizedAddres\"\n        },\n        \"enteredAddress\": {\n            \"transitionTo\": \"add_norm_edit\",\n            \"transitionName\": \"address_normalization_enteredAddress\"\n        }\n    }\n}\n\n";

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization-edit/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization-edit/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"showNormalizationForm\" content id=\"addressNormalizationEdit\" xo-tray-height>\n    <div class=\"asideHeader\">\n        <a link-button ui-sref=\"{{backUri}}\" id=closeForm class=\"close focusableIcon\" aria-label=\"Back button\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <div class=\"logo\"></div>\n        <h1 class=\"gamma\">{{ content(normalization.form.title) }}</h1>\n        <div class=\"headerBorder\"></div>\n    </div>\n    <div class=\"asideContent\">\n        <form method=\"post\" id=\"addressNormalizationForm\" name=\"addressNormalizationForm\" class=\"asideView container\" content novalidate form-autofocus>\n            <div ng-if=\"normalization.status === 'normalizedAddressAvailable'\">\n                <div id=\"normalizedAdrSection\" class=\"normalizedAdrSection radioButton\">\n                    <input type=\"radio\"\n                           id=\"addressNormalized\"\n                           name=\"normalizedAddress\"\n                           value=\"normalizedAddress\"\n                           ng-click=\"selection('normalizedAddress')\"\n                           checked=\"checked\"\n                    />\n                    <label class=\"addressLabel\" for=\"addressNormalized\">\n                        <div class=\"address\">\n                            <p class=\"theta addressStatus\" data-ng-bind-html=\"htmlContent('addressNormalization.updatedAddress')\"></p>\n                            <div ng-if=\"!normalizedEditAddress\">\n                                <div class=\"confidential streets street-address\">\n                                    <div ng-if=\"normalizedAddressEdit.line2\">{{normalizedAddressEdit.line1}}, {{normalizedAddressEdit.line2}},</div>\n                                    <div ng-if=\"!normalizedAddressEdit.line2\">{{normalizedAddressEdit.line1}},</div>\n                                </div>\n                                <div class=\"confidential\">\n                                    <span class=\"locality\">{{normalizedAddressEdit.city}}</span>, <span class=\"state\">{{normalizedAddressEdit.state}}</span>\n                                    <span class=\"postal-code adr-break\">{{normalizedAddressEdit.postal_code}},&nbsp;{{content('countryList.'+normalizedAddressEdit.country)}}</span>\n                                </div>\n                            </div>\n                            <div ng-if=\"normalizedEditAddress\">\n                                <div>\n                                    <xo-select-shipping-country token=\"id\" shipping-address=\"normalizedAddressEdit\"></xo-select-shipping-country>\n                                </div>\n                                <div>\n                                    <xo-add-address country=\"normalizedAddressEdit.country\" address=\"normalizedAddressEdit\" is-shipping=\"true\" hide-name=\"true\" hide-add-preferred=\"true\"\n                                                    token=\"id\"></xo-add-address>\n                                </div>\n                            </div>\n                        </div>\n                    </label>\n                    <a id=\"editNormalized\" class=\"editAddress\" ng-click=\"showNormalizedEditAddress()\">\n                        {{ content('common.edit') }}\n                    </a>\n                </div>\n\n                <div class=\"editAddrSection radioButton\">\n                    <input type=\"radio\"\n                           id=\"addressOriginal\"\n                           name=\"normalizedAddress\"\n                           value=\"enteredAddress\"\n                           ng-click=\"selection('enteredAddress')\"\n                    >\n                    <label class=\"addressLabel\" for=\"addressOriginal\">\n                        <div class=\"address\">\n                            <p class=\"theta addressStatus\" data-ng-bind-html=\"htmlContent('addressNormalization.originalAddress')\"></p>\n                            <div ng-if=\"!userEditAddress\">\n                                <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                                    <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                                </div>\n                                <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                                    <div ng-if=\"address.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                                    <div ng-if=\"!address.line2\">{{servAddress.line1}}</div>\n                                </div>\n                                <div class=\"confidential\">\n                                    <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                                    <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                                </div>\n                            </div>\n                            <div ng-if=\"userEditAddress\">\n                                <div>\n                                    <xo-select-shipping-country token=\"id\" shipping-address=\"servAddress\"></xo-select-shipping-country>\n                                </div>\n                                <div>\n                                    <xo-add-address country=\"servAddress.country\" address=\"servAddress\" is-shipping=\"true\" hide-name=\"true\" hide-add-preferred=\"true\"\n                                                    token=\"id\"></xo-add-address>\n                                </div>\n                            </div>\n                        </div>\n                    </label>\n                    <a id=\"editOriginal\" class=\"editAddress\" ng-click=\"showUserEditAddress()\">\n                        {{ content('common.edit') }}\n                    </a>\n                </div>\n            </div>\n\n            <div ng-if=\"normalization.status === 'requiredFieldsDontMatch' || normalization.status === 'normalizedAddressUnavailable'\">\n                <div id=\"noMatchOriginalAddrSection\" class=\"originalAdrSection\">\n                    <div class=\"address\">\n                        <p class=\"theta addressStatus\">{{ content(normalization.form.originalAddress) }}</p>\n                        <div>\n                            <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                                <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                            </div>\n                            <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                                <div ng-if=\"servAddress.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                                <div ng-if=\"!servAddress.line2\">{{servAddress.line1}}</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\" ng-class=\"{'warning': missMatch.state}\">{{servAddress.state}}</span>\n                                <span class=\"postal-code adr-break\" ng-class=\"{'warning': missMatch.postalCode}\">{{servAddress.postal_code}},</span>\n                                <span>{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div id=\"noMatchEditAddrSection\" class=\"editAddrSection\">\n                    <div class=\"address\">\n                        <p class=\"theta addressStatus\">{{ content(normalization.form.editAddress) }}</p>\n                        <xo-message ng-if=\"message\" message=\"message\"></xo-message>\n                        <xo-select-shipping-country shipping-address=\"servAddressEdit\"\n                                                    disable-change-shipping-country=\"disableChangeShippingCountry\"\n                                                    token=\"id\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n\n                        <xo-add-address country=\"servAddressEdit.country\" address=\"servAddressEdit\" is-shipping=\"true\"\n                                        token=\"id\" hide-name=\"true\" hide-add-preferred=\"true\"></xo-add-address>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"buttons\">\n                <input track-submit=\"{{normalization.instrumentation.transitionName}}\" id=\"saveAndContinue\" type=\"submit\" value=\"{{ content('common.saveAndContinue') }}\" class=\"btn\" validate-submit=\"saveAndContinue()\">\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/styles.less");

var _template = __webpack_require__("../node_modules/xo-address-components/src/address-normalization/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddressNormalization', function () {
    return {
        template: _template2['default'],
        scope: {
            id: '=?',
            address: '=?',
            doneFn: '=?',
            sidebar: '=?',
            hideBackButton: '=?'
        },

        controller: ['$scope', function ($scope) {
            _squid.$util.assert($scope.address, 'Original Address cannot be empty');

            $scope.showNormalization = false;

            var normalize = (0, _squid.$feature)('addressNormalization', false, $scope.address.country);
            if (!normalize) {
                $scope.doneFn($scope.address, false);
                return;
            }

            var userEnteredAddress;
            var addrFormat = (0, _squid.$feature)('FormatAddressForNormalization', $scope.address.country, $scope.address.country);

            $scope.addressSelected = 'normalizedAddress';
            $scope.transitionName = 'address_normalization_normalizedAddress';

            // Brazil specific format
            if (addrFormat === 'AddressBR') {
                userEnteredAddress = angular.fromJson(angular.toJson($scope.address));
                userEnteredAddress.line1 = $scope.address.line1 + '  ' + $scope.address.streetNumber;
                userEnteredAddress.line2 = $scope.address.neighborhood;
            }

            $scope.servAddress = userEnteredAddress ? userEnteredAddress : $scope.address;
            $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';

            $scope.addressNormalization = new _index.$AddressNormalizationModel({
                id: $scope.id,
                address: $scope.servAddress
            });

            function centerLightBox() {
                var element = $('#lbox');
                if (!element.length) {
                    return;
                }

                var windowElement = $(window);
                var lboxContainerElem = $('#lboxContainer');
                element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
                element.css('width', '65%');
                var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
                var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
                var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
                if (computedLeft < leftBound) {
                    element.css('width', lboxContainerElem.width() * 0.8);
                }
                element.css('left', Math.max(0, elementLeft) + 'px');
                return element;
            }

            function trinityResponseCallback() {
                $scope.showNormalization = true;

                // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
                (0, _angular.$timeout)(function () {
                    centerLightBox();
                    $(window).resize(centerLightBox);
                });
            }

            $scope.addressNormalization.save({
                data: $scope.addressNormalization,

                contingencies: {
                    VALIDATION_ERROR: function VALIDATION_ERROR() {
                        trinityResponseCallback();
                        $scope.transitionName = 'address_normalization_enteredAddress';
                        return;
                    }
                },

                success: function success(result) {
                    trinityResponseCallback();
                    if (result === false) {
                        // trinity doesn't find any match
                        $scope.transitionName = 'address_normalization_enteredAddress';
                        return;
                    }
                    $scope.normalizedAddress = result;
                    $scope.normalizedAddress.normalization_status = 'NORMALIZED';

                    if (addrFormat === 'AddressBR') {
                        $scope.normalizedAddress.line1 = $scope.normalizedAddress.streetName + '  ' + $scope.normalizedAddress.streetNumber;
                        $scope.normalizedAddress.line2 = $scope.normalizedAddress.neighborhood;
                    }

                    // if the two addresses equal, no need to show the panel
                    if ($scope.isEqual($scope.normalizedAddress, $scope.servAddress)) {
                        if ($scope.servAddress.preferred_address) {
                            $scope.normalizedAddress.preferred_address = true;
                        }

                        if (addrFormat === 'AddressBR' && $scope.address.line2) {
                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
                        }
                        $scope.callback($scope.normalizedAddress, false);
                    } else if (addrFormat === 'AddressBR' && $scope.address.line2) {
                        $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
                    }
                },

                error: trinityResponseCallback
            });

            // make space and case insensitive. sub empty vals for undefined.
            function desensitizedAddress(addr) {
                for (var key in addr) {
                    var val = addr[key];
                    if (addr.hasOwnProperty(key)) {
                        if (val && val.length) {
                            addr[key] = val.trim().toLowerCase();
                        } else {
                            addr[key] = undefined;
                        }
                    }
                }
                return addr;
            }

            // check if the two address are the same
            $scope.isEqual = function (address1, address2) {
                var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
                var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));

                if (!addressOne || !addressTwo) {
                    return false;
                }

                return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
            };

            // Australia displays address line2 first
            $scope.isLine2First = function () {
                return $scope.address.country === 'AU';
            };

            $scope.onBack = function () {
                $scope.callback($scope.address, true);
            };

            $scope.selection = function (value) {
                $scope.transitionName = 'address_normalization_' + value;
            };

            $scope.onContinue = function () {
                $scope.addressSelected = this.addressNormalizationForm.addressSelected;

                if ($scope.addressSelected && $scope.addressSelected.$modelValue === 'normalizedAddress') {
                    if ($scope.servAddress.preferred_address) {
                        $scope.normalizedAddress.preferred_address = true;
                    }
                    $scope.callback($scope.normalizedAddress, false);
                } else {
                    $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
                    if (addrFormat === 'AddressBR' && $scope.address.line2) {
                        $scope.servAddress.line1 = $scope.servAddress.line1 + ' ' + $scope.address.line2;
                    }
                    $scope.callback($scope.servAddress, false);
                }
            };

            $scope.callback = function (address, isBack) {
                $scope.doneFn(address, isBack);
            };
        }]
    };
});

_angular.$timeout;

_squid.$feature;

_squid.$util;

_index.$AddressNormalizationModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddressNormalizationRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/directive.js");

var $AddressNormalizationRoute = exports.$AddressNormalizationRoute = _squid.$ComponentRoute.extend('AddressNormalizationRoute', {
    name: 'addressNormalization',
    titleContent: 'addressNormalization.addressmatch',
    directive: 'xo-address-normalization',
    trackingData: {
        fptiState: 'address_normalization',
        buzname: {
            'fullpage': {
                'pagename': '%::address_normalization',
                'pagename2': '%::address_normalization:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,

    children: []
});

angular.value("$AddressNormalizationRoute", $AddressNormalizationRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"showNormalization\" content id=\"addressNormalization\" xo-tray-height>\n    <xo-aside-header heading='asideHeader.selectNormalizedAddress' hidex='true' ng-if=\"sidebar\"></xo-aside-header>\n    <div class=\"asideContent\">\n        <form method=\"post\" class=\"formSmall asideView container\" novalidate=\"novalidate\" name=\"addressNormalizationForm\">\n            <div ng-if=\"normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.title') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.intro') }}</p>\n                <div class=\"normalizedAdrSection radio\">\n                    <p class=\"theta\" data-ng-bind-html=\"htmlContent('addressNormalization.addressmatch')\"></p>\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" id=\"defaultAddress\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"normalizedAddress\" ng-click=\"selection('normalizedAddress')\" class=\"addrRadio span2\" checked=\"true\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\">\n                                <div ng-if=\"normalizedAddress.line2\">{{normalizedAddress.line1}}, {{normalizedAddress.line2}},</div>\n                                <div ng-if=\"!normalizedAddress.line2\">{{normalizedAddress.line1}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{normalizedAddress.city}}</span>, <span class=\"state\">{{normalizedAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{normalizedAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n                <div class=\"enteredAddrSection radio subContainer\">\n                    <p class=\"addressNormalizationIntro\" data-ng-bind-html=\"htmlContent('addressNormalization.addressenter')\"></p>\n\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"enteredAddress\" ng-click=\"selection('enteredAddress')\" class=\"addrRadio span2\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                                <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                            </div>\n                            <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                                <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}},</div>\n                                <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n            </div>\n            <div ng-if=\"!normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.noaddressmatchTitle') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.noaddressmatchMsg') }}</p>\n                <input type=\"hidden\" name=\"addressdisplay\" value=\"enteredAddress\">\n                <div class=\"enteredAddrSection subContainer\">\n                    <p class=\"theta\">{{ content('addressNormalization.addressyouenter') }}</p>\n                    <div class=\"adr\">\n                        <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                            {{servAddress.line2}} {{servAddress.line1}},\n                        </div>\n                        <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                            <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}}</div>\n                            <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}}</div>\n                        </div>\n                        <div class=\"confidential\">\n                            <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                            <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"buttons\" ng-if=\"!hideBackButton\">\n                <input id=\"back\" type=\"submit\" value=\"{{ content('common.back') }}\" class=\"btn firstHalf btn-secondary\" ng-click=\"onBack()\" >\n                <input track-submit=\"{{transitionName}}\" id=\"continue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn secondHalf\" ng-click=\"onContinue()\">\n            </div>\n            <div class=\"buttons\" ng-if=\"hideBackButton\">\n                <input track-submit=\"{{transitionName}}\" id=\"fullContinue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-click=\"onContinue()\">\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-beaver/dist/level.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module('beaver.level', []).factory('$logLevel', function () {
    return {
        INFO: 'info',
        DEBUG: 'debug',
        ERROR: 'error',
        WARN: 'warn',
        ALERT: 'alert'
    };
}).factory('$consoleLogLevel', function () {
    return {
        info: 'info',
        debug: 'debug',
        error: 'error',
        warn: 'warn',
        alert: 'info'
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/level.js"))

/***/ }),

/***/ "../node_modules/xo-beaver/dist/logger.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _level = __webpack_require__("../node_modules/xo-beaver/dist/level.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable angular/di */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Logger', function () {
    var logger = {};
    var HERMES_DEV_COOKIE = 'hermesdev';

    _angular2['default'].forEach(_level.$logLevel, function (level) {
        logger[level] = function (event, payload, settings) {
            return this.log(level, event, payload, settings);
        };
    });

    var hostname = _angular.$window.location && _angular.$window.location.hostname || '';
    var uniqueEvents = [];

    _angular2['default'].extend(logger, {
        autoLog: [_level.$logLevel.WARNING, _level.$logLevel.ERROR],
        flushInterval: 10 * 60 * 1000,
        heartbeatInterval: 5000,
        sizeLimit: 500,
        debounceInterval: 10,
        uri: '/api/log',
        rootTxnUri: '/api/log/crt',
        hearbeatMaxThreshold: 50,
        deploy: {
            isLocal: function isLocal() {
                return hostname === 'localhost' || hostname === 'localhost.paypal.com';
            },

            isStage: function isStage() {
                return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
            },

            isLive: function isLive() {
                return hostname === 'www.paypal.com';
            }
        },

        init: function init() {
            var self = this;

            this.buffer = [];

            var previousBeforeUnloadHandler = _angular.$window.onbeforeunload;

            _angular.$window.onbeforeunload = function (event) {
                if (self.isDone) {
                    return;
                }

                self.info('window_beforeunload');

                if (previousBeforeUnloadHandler) {
                    return previousBeforeUnloadHandler.apply(this, arguments);
                }
            };

            var previousUnloadHandler = _angular.$window.onunload;

            _angular.$window.onunload = function (event) {

                if (self.isDone) {
                    return;
                }

                self.info('window_unload');
                self._flush();

                self.done();

                if (previousUnloadHandler) {
                    return previousUnloadHandler.apply(this, arguments);
                }
            };

            this.heartbeat();
            this.daemon();
        },

        heartbeat: function heartbeat() {
            var self = this;

            if (!window.enablePerformance) {
                return;
            }

            function timestamp() {
                var perf = window.performance;

                return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
            }

            var howBusy = {
                lastSampledTime: timestamp(),
                lastLag: 0,
                maxLag: 0,
                dampendedLag: 0
            };

            var count = 0;

            (0, _angular.$interval)(function () {

                if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
                    count = 0;
                }

                if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
                    return;
                }

                count += 1;

                var payload = {
                    count: count
                };

                var now = timestamp();

                howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
                howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
                howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
                howBusy.lastSampledTime = now;

                payload.lastLag = howBusy.lastLag.toFixed(4);
                payload.maxLag = howBusy.maxLag.toFixed(4);
                payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
                payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);

                if (howBusy.lastLag > 10000) {
                    self.info('toobusy', {}, {
                        noConsole: true,
                        unique: true
                    });
                }

                self.info('heartbeat', payload, {
                    noConsole: true
                });
            }, this.heartbeatInterval);
        },

        done: function done() {
            this.flush(true);
            this.isDone = true;
        },

        addPerformanceData: function addPerformanceData(payload) {

            if (window.enablePerformance) {
                var performance = window.performance;
                var timing = window.performance.timing || {};
                var now = performance.now();

                if (window.clientStartTime && _angular2['default'].isUndefined(payload.client_elapsed)) {
                    payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
                }

                if (timing.connectEnd && timing.navigationStart && _angular2['default'].isUndefined(payload.req_elapsed)) {
                    payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
                }
            }
        },

        addLocaleData: function addLocaleData(payload) {

            var context = {};

            try {
                context = _angular.$injector.get('$metaBuilder').buildContext();
            } catch (err) {
                return; // Continue without adding locale data
            }
            if (context.locale && context.locale.country) {
                payload.site_cntry = context.locale.country;
            }
        },

        /* jslint maxcomplexity: false */
        log: function log(level, event, payload, settings) {
            var self = this;

            payload = payload || {};

            if (_angular2['default'].isArray(payload) || !_angular2['default'].isObject(payload)) {
                payload = {
                    payload: payload
                };
            }
            settings = settings || {};

            if (settings.unique) {
                var hash = event + ':' + _angular2['default'].toJson(payload);

                if (uniqueEvents.indexOf(hash) > -1) {
                    return self;
                }
                uniqueEvents.push(hash);
            }

            payload.pageID = window.meta && window.meta.pageID;

            this.addPerformanceData(payload);
            this.addLocaleData(payload);

            self.print(level, event, payload, settings);

            if (this.buffer.length >= this.sizeLimit) {
                if (this.buffer.length === this.sizeLimit) {
                    return self.enqueue('warn', 'logger_max_buffer_length');
                }
                return self;
            }

            return self.enqueue(level, event, payload, settings);
        },

        getTimestamp: function getTimestamp() {
            var now = Date.now();

            return window.logOffset ? window.logOffset + now : now;
        },

        enqueue: function enqueue(level, event, payload, settings) {
            payload = payload || {};
            settings = settings || {};

            var data = {
                level: level,
                event: event,
                timestamp: this.getTimestamp(),
                payload: payload
            };

            this.buffer.push(data);

            // If the log level is classified as autolog, then flush the data
            if (this.autoLog.indexOf(level) > -1) {
                this.flush();
            }

            return this;
        },

        shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {

            if (settings.noConsole) {
                return false;
            }

            if (window.meta && window.meta.corp) {
                return true;
            }

            if (this.deploy.isLocal() || this.deploy.isStage()) {
                return true;
            }

            var cookies = window.cookies || {};

            if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
                return true;
            }

            return false;
        },

        print: function print(level, event, payload, settings) {

            if (!this.shouldPrintLogsToConsole(settings)) {
                return;
            }

            var args = [event];

            if (payload) {
                args.push(payload);

                if (payload.stack || payload.error || payload.warning) {
                    args.push('\n\n', payload.stack || payload.error || payload.warning);
                }
            }

            _angular.$log[_level.$consoleLogLevel[level] || 'info'].apply(_angular.$log, args);
        },

        flush: function flush(immediate) {
            var self = this;

            if (!this.buffer.length) {
                return _angular.$q.when();
            }

            if (immediate) {
                return _angular.$q.when(this._flush());
            }

            if (self.debouncer_timeout) {
                _angular.$timeout.cancel(self.debouncer_timeout);
            }

            self.debouncer_timeout = (0, _angular.$timeout)(function () {

                var resolver = self.debouncer_resolver;

                delete self.debouncer_promise;
                delete self.debouncer_resolver;
                delete self.debouncer_timeout;

                self._flush().then(function () {
                    resolver();
                });
            }, this.debounceInterval);

            self.debouncer_promise = self.debouncer_promise || (0, _angular.$q)(function (resolver) {
                self.debouncer_resolver = resolver;
            });

            return self.debouncer_promise;
        },

        _flush: function _flush() {
            var self = this;

            if (!self.buffer.length) {
                return _angular.$q.when();
            }

            var meta = {};

            try {
                meta = _angular.$injector.get('$metaBuilder').build();
            } catch (err) {
                // @TODO - Log error
            }

            var req = this.ajax('post', _angular.$window.meta.logURL || _angular.$window.config.urls.baseUrl + this.uri, {
                data: {
                    events: self.buffer
                },
                meta: meta
            });

            self.buffer = [];

            return req;
        },

        ajax: function ajax(method, url, json) {
            return (0, _angular.$q)(function (resolve) {
                var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
                var req = new XRequest('MSXML2.XMLHTTP.3.0');
                var logAppName = _angular.$window.meta.logAppName;

                req.open(method.toUpperCase(), url);

                req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                req.setRequestHeader('Content-type', 'application/json');

                if (logAppName) {
                    req.setRequestHeader('x-app-name', logAppName);
                }

                req.onreadystatechange = function () {
                    if (req.readyState > 3) {
                        resolve();
                    }
                };
                req.send(_angular2['default'].toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
            });
        },

        daemon: function daemon() {
            this.stop();

            var self = this;

            this.timer = (0, _angular.$interval)(function () {
                self.flush();
            }, this.flushInterval);
        },

        stop: function stop() {
            if (this.timer) {
                _angular.$interval.cancel(this.timer);
            }
        },

        createCalRootTxn: function createCalRootTxn(data, txnName) {
            if (data !== null && _angular2['default'].isObject(data)) {
                var rootTxnData = { 'data': {}, 'transactionName': '' };
                var url = '' + _angular.$window.config.urls.baseUrl + this.rootTxnUri;
                if (_angular2['default'].isString(txnName)) {
                    rootTxnData.transactionName = txnName;
                }
                Object.assign(rootTxnData.data, data);
                this.ajax('post', url, rootTxnData);
            }
        }
    });

    function Logger(val) {
        _angular2['default'].extend(this, val);
        this.init();
    }

    Logger.prototype = logger;
    Logger.prototype.constructor = Logger;

    return Logger;
}).factory('$logger', ['$Logger', function ($Logger) {
    return new $Logger();
}]).run(['$logger', function ($logger) {
    _angular2['default'].forEach(window.beaconQueue, function (payload) {
        $logger.log(payload.level, payload.event, payload);
    });

    window.beacon = function (level, events, payload) {
        _angular2['default'].forEach(events, function (event) {
            $logger.log(level, event, payload);
        });
    };
}]);

_level.$logLevel;

_level.$consoleLogLevel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/logger.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/template.html");

var _template2 = _interopRequireDefault(_template);

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BMLStateHandler', function () {
    var APPROVED = 'APPROVED';
    var SOFT_DECLINED = 'SOFT_DECLINED';
    var DECLINED = 'DECLINED';
    var FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER = 'FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER';
    var NEED_SIGNATURE = 'NEED_SIGNATURE';
    var PENDING_COMPLETION_STATUS = 'PENDING_COMPLETION_STATUS';
    var FULL_APPLY_REQUIRED = 'FULL_APPLY_REQUIRED';
    var UNKNOWN_DECISION = 'UNKNOWN_DECISION';
    var INELIGIBLE = 'INELIGIBLE'; // TODO; This state is returned by applybml but was not defined in Aries
    var MAX_SOFT_DECLINES = config.bmlMaxSoftDeclines; // eslint-disable-line block-scoped-var,no-undef

    var BMLStateHandler = function BMLStateHandler(bmlData) {
        this.reviewUrl = bmlData.reviewUrl;
        this.bml = bmlData.bml;
        this.bmlApply = bmlData.bmlApply;
        this.bmlComplete = bmlData.bmlComplete;
        this.checkoutSession = bmlData.checkoutSession;
        this.auth = bmlData.auth;
        this.purchase = bmlData.purchase;
        this.patchPhone = bmlData.patchPhone;
        this.billingAddresses = bmlData.billingAddresses;
        this.merchant = bmlData.merchant;
        this.merchantId = bmlData.merchantId;

        this.handlers = {};
        this.handlers[APPROVED] = this.handleAppStatusApproved;
        this.handlers[DECLINED] = this.handleAppStatusDeclined;
        this.handlers[SOFT_DECLINED] = this.handleAppStatusSoftDeclined;
        this.handlers[FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER] = this.handleAppStatusFundingInsExist;
        this.handlers[NEED_SIGNATURE] = this.handleAppStatusNeedSignature;
        this.handlers[PENDING_COMPLETION_STATUS] = this.handleAppStatusPendingCompletion;
        this.handlers[UNKNOWN_DECISION] = this.handleAppStatusUnknownDecision;
        this.handlers[FULL_APPLY_REQUIRED] = this.handleAppStatusFullApplyRequired;
        this.handlers[INELIGIBLE] = this.handleAppStatusIneligible;
    };

    BMLStateHandler.prototype.payInFullRedirect = function payInFullRedirect(result) {
        _logger.$logger.info('APPLYFORBML_VIEW_OPTOUTBML');
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.termsAndCondition = function termsAndCondition(result) {
        _uiRouter.$state.go('^.bmltermsandconditions');
    };

    BMLStateHandler.prototype.handleAppStatusIneligible = function handleAppStatusIneligible(result) {
        _logger.$logger.info('APPLYFORBML_INELIGIBLE');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlIneligible'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusUnknownDecision = function handleAppStatusUnknownDecision(result) {
        _logger.$logger.info('APPLYFORBML_UNKNOWN_DECISION');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlUnknownDecision'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusApproved = function handleAppStatusApproved(result) {
        _logger.$logger.info('APPLYFORBML_ACTION_BMLSUCCESS');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlSuccess'
        });
        this.checkoutSession.fundingOptions.action('update', {
            resultModel: this.checkoutSession,
            data: {
                planId: this.bml.financial_instrument_id
            },
            success: $.proxy(function (successResult) {
                _uiRouter.$state.go(this.reviewUrl);
            }, this),
            contingencies: {
                DEFAULT: function DEFAULT(name) {
                    _uiRouter.$state.go(this.reviewUrl);
                }
            }
        });
    };

    BMLStateHandler.prototype.handleAppStatusPendingCompletion = function handleAppStatusPendingCompletion(result) {
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'completeBmlApply'
        });
        this.completeApplication(result.application_id);
    };

    BMLStateHandler.prototype.handleAppStatusNeedSignature = function handleAppStatusNeedSignature(result) {
        _logger.$logger.info('APPLYFORBML_NEED_SIGNATURE');
        this.bml.application_id = result.application_id;
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'needSignature'
        });
        _uiRouter.$state.go('^.bmlsignature');
    };

    BMLStateHandler.prototype.handleAppStatusDeclined = function handleAppStatusDeclined(result) {

        _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINEHARD');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'creditDeclineHard'
        });
        this.bml.application_status = 'DECLINED';
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;

        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusSoftDeclined = function handleAppStatusSoftDeclined(result) {

        this.bml.bmlSoftDeclineCtr = (this.bml.bmlSoftDeclineCtr || 0) + 1;
        if (this.bml.bmlSoftDeclineCtr < MAX_SOFT_DECLINES) {
            _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINESOFT');
            _uiRouter.$state.go('^.bmlapply');
        } else {
            _logger.$logger.info('checkout_fpti', {
                'ppc_status': 'bmlMaxAttempts'
            });
            _logger.$logger.info('APPLYFORBML_ACTION_BMLMAXATTEMPTS');
            this.bml.application_status = 'DECLINED';
            this.checkoutSession.creditOffer = false;
            this.checkoutSession.showDeclinePopup = true;

            _uiRouter.$state.go(this.reviewUrl);
        }
    };

    BMLStateHandler.prototype.handleAppStatusFundingInsExist = function handleAppStatusFundingInsExist(result) {
        _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINELINKEDTODIFFMEMBER');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlDeclineLinkedToDiffMember'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusFullApplyRequired = function handleAppStatusFullApplyRequired(result) {
        _logger.$logger.info('APPLYFORBML_FULLAPPLYREQUIRED');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'fullApplyRequired'
        });
        this.checkoutSession.creditOffer = false;
        this.bml.fullApplyRequired = true;
        this.checkoutSession.showDeclinePopup = true;

        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleBmlTransitions = function handleBmlTransitions(result) {
        var handler = this.handlers[result.application_status];
        if (!handler) {
            throw new Error('no registered handler for bml transition for application status ' + result.application_status);
        }
        return $.proxy(handler, this, result)();
    };

    BMLStateHandler.prototype.completeApplication = function completeApplication(application_id) {

        this.bmlComplete.application_id = application_id;
        this.bmlComplete.action('complete', {

            success: $.proxy(function (result) {
                _logger.$logger.info('COMPLETEBMLAPPLY_ACTION_BMLSUCCESS');
                var bml = this.bml;

                // Update the application_status & financial_instrument_id in bml model
                bml.setProperties({
                    financial_instrument_id: result.financial_instrument_id,
                    application_status: result.application_status
                });

                if (bml.phoneChanged && result && result.user_info && result.user_info.phones && result.user_info.phones.length > 0 && result.user_info.phones[0].id) {

                    var newPhoneVO = {
                        op: 'add',
                        path: '/payer_info',
                        value: {
                            phone: this.bmlApply.personalInformation.phone.telephone
                        }
                    };
                    this.patchPhone.save({
                        data: {
                            patch: newPhoneVO
                        },
                        success: $.proxy(function () {
                            delete bml.phoneChanged;
                            this.handleBmlTransitions(result);
                        }, this),
                        contingencies: {
                            DEFAULT: $.proxy(function handleContingency(name, contingency) {
                                _logger.$logger.info('BMLPATCHPHONE_CONTINGENCY', name);
                                this.handleBmlTransitions(result);
                            }, this)
                        }
                    });
                } else {
                    this.handleBmlTransitions(result);
                }
            }, this)
        });
    };

    BMLStateHandler.prototype.getDefaultBillingAddress = function getDefaultBillingAddress(billingAddresses) {
        var defaultBillingAddress = billingAddresses && billingAddresses.addresses;
        defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
            if (address && address['default'] === true) {
                return address;
            }
        });

        defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];
        return defaultBillingAddress;
    };

    BMLStateHandler.prototype.applyBML = function applyBML() {

        var defaultBillingAddress = this.getDefaultBillingAddress(this.billingAddresses);

        this.bml.action('apply', {
            data: {
                flow: {
                    nape: this.bml.nape,
                    fullApplyRequired: this.bml.fullApplyRequired
                },
                payer: {
                    email: this.checkoutSession.payer.email,
                    id: this.checkoutSession.payer.id,
                    phone: this.bmlApply.personalInformation.phone.telephone,
                    phone_type: this.bmlApply.personalInformation.phone.phoneType
                },
                billing_address: {
                    line1: defaultBillingAddress.line1,
                    line2: defaultBillingAddress.line2,
                    city: defaultBillingAddress.city,
                    state: defaultBillingAddress.state,
                    postal_code: defaultBillingAddress.postal_code,
                    country: defaultBillingAddress.country,
                    id: defaultBillingAddress.id
                },
                payment_info: {
                    total_transaction_amount: {
                        value: this.purchase.amounts.total.amount,
                        currency: this.purchase.amounts.total.currency_code
                    },
                    recipient: {
                        id: this.merchantId,
                        total_amount: {
                            value: this.purchase.amounts.total.amount,
                            currency: this.purchase.amounts.total.currency_code
                        },
                        business_name: this.merchant.brand_name,
                        type: 'PAYPAL_CORE',
                        multi_seller_indicator: false,
                        country_code: this.merchant.merchant_country
                    },
                    shipping_address: {
                        id: this.checkoutSession.shipping.id,
                        name: this.checkoutSession.shipping.name,
                        line1: this.checkoutSession.shipping.line1,
                        line2: this.checkoutSession.shipping.line2,
                        city: this.checkoutSession.shipping.city,
                        state: this.checkoutSession.shipping.state,
                        country_code: this.checkoutSession.shipping.country,
                        postal_code: this.checkoutSession.shipping.postal_code,
                        'default': this.checkoutSession.shipping['default']
                    },
                    name: {
                        first_name: this.auth.first_name,
                        last_name: this.auth.last_name
                    },
                    item_info: this.purchase.items
                },
                dobSsn: {
                    dobMonth: this.bmlApply.personalInformation.month,
                    dobDay: this.bmlApply.personalInformation.day,
                    dobYear: this.bmlApply.personalInformation.year,
                    nationalId: this.bmlApply.personalInformation.natId
                }
            },

            resultModel: this.bml,

            success: $.proxy(function (result) {
                this.handleBmlTransitions(result);
            }, this),

            contingencies: {
                DEFAULT: $.proxy(function handleContingency(name, contingency) {
                    this.bml.contingency = name;
                    this.checkoutSession.creditOffer = false;
                    this.checkoutSession.showDeclinePopup = true;
                    _uiRouter.$state.go(this.reviewUrl);
                }, this)
            }
        });
    };
    return BMLStateHandler;
}).directive('xoBmlDisplay', function () {
    return {
        template: _template2['default'],
        scope: {
            reviewUrl: '=?'
        },
        controller: ['$scope', function ($scope) {
            if (!_angular.$rootScope.bml && !_angular.$rootScope.bmlApply) {
                $scope.bml = new _bml.$BMLModel();
                $scope.bmlApply = new _bml.$ApplyForBMLModel();
            } else {
                $scope.bml = _angular.$rootScope.bml;
                $scope.bmlApply = _angular.$rootScope.bmlApply;
            }
            $scope.bmlComplete = new _bml.$BMLApplicationModel();
            _uiRouter.$state.go('^.bmlapply');
        }]
    };
});

_angular.$rootScope;

_uiRouter.$state;

_logger.$logger;

_bml.$BMLModel;

_bml.$ApplyForBMLModel;

_bml.$BMLApplicationModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display", "../node_modules/xo-credit-components/src/bml-display/directive.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/route.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BMLDisplay', function () {
    return _squid.$ComponentRoute.extend('BmlDisplay', {
        name: 'bmldisplay',
        directive: 'xo-bml-display',
        trackingData: {
            fptiState: 'ppc_display',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_display',
                    'pagename2': '%::ppc_display:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        titleContent: 'applyForBml.bmlApplyHeadline',
        children: [{
            name: '$BmlApplyRoute'
        }, {
            name: '$BmlTermsAndConditionsRoute'
        }, {
            name: '$BmlSignatureRoute'
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display", "../node_modules/xo-credit-components/src/bml-display/route.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-form-components/src/dob-nationalid/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-models/src/bml/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index5 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

var _directive = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlApplyPage', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', '$element', function ($scope, $element) {
            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                payee: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                billingAddresses: _index4.$BillingAddressesModel.instance(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
                creditOptions: _index3.$CreditInstallmentModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var defaultBillingAddress = $scope.billingAddresses && $scope.billingAddresses.addresses;

                defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
                    if (address && address['default'] === true) {
                        return address;
                    }
                });
                defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];

                if (defaultBillingAddress) {
                    $scope.bml.action('napeLookUp', {
                        data: {
                            payer: $scope.checkoutSession.payer,
                            billing_address: {
                                country: defaultBillingAddress.country,
                                line1: defaultBillingAddress.line1,
                                line2: defaultBillingAddress.line2,
                                city: defaultBillingAddress.city,
                                state: defaultBillingAddress.state,
                                postal_code: defaultBillingAddress.postal_code
                            }
                        },
                        success: function success(result) {
                            if (result && result.account_exists === true) {
                                $scope.bml.nape = 'napePotential';
                                $scope.bml.fullApplyRequired = false;
                            }
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT() {
                                // add a log here
                            }
                        }
                    });
                }

                if ($scope.billingAddresses && $scope.billingAddresses.addresses && $scope.billingAddresses.addresses.length > 0) {
                    $scope.billingAddresses.addresses.forEach(function (address) {
                        if (address['default']) {
                            $scope.address = billingAddressObject(address); // eslint-disable-line no-use-before-define
                            $scope.previousDefaultBillingAddress = address;
                        }
                    });
                }

                var bmlData = {
                    reviewUrl: $scope.$parent.reviewUrl,
                    bml: $scope.$parent.bml,
                    bmlApply: $scope.$parent.bmlApply,
                    bmlComplete: $scope.$parent.bmlComplete,
                    checkoutSession: $scope.checkoutSession,
                    auth: $scope.auth,
                    purchase: $scope.checkoutCart.purchase,
                    patchPhone: $scope.patchPhoneModel,
                    billingAddresses: $scope.billingAddresses,
                    merchant: $scope.checkoutAppData.merchant,
                    merchantId: $scope.payee.merchant.id
                };

                $scope.bmlStateHandler = new _directive.$BMLStateHandler(bmlData);

                if ($scope.checkoutSession.payer) {
                    $scope.bmlApply.personalInformation.phone.telephone = $scope.checkoutSession.payer.phone;
                    $scope.bmlApply.personalInformation.phone.phoneType = 'MOBILE';
                    // Set mobile as default to prevent unknown type.
                } else {
                    $scope.bmlFlags.PhoneAdd = true;
                }
            });

            var $el = $($element);

            function handleDobValidation() {
                var $fields = $('#dobSelect .dropdown select');

                $fields.addClass('backendError');
                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function triggerNextState() {
                _logger.$logger.info('APPLYFORBML_VIEW_SUBMIT');
                if ($scope.bml.nape === 'napePotential') {
                    $scope.bmlStateHandler.applyBML();
                } else {
                    $scope.checkoutSession.message = null;
                    $scope.bmlStateHandler.termsAndCondition();
                }
            }

            function isUserInputtedAddress(address) {
                return address.id === '0';
            }

            function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = $($el.find('[name="' + field.field + '"]'));
                            $field.addClass('backendError');
                        }
                    });
                }

                $scope.checkoutSession.message = {
                    type: 'error',
                    msgKeys: ['genericError.incontextGenericPageError']
                };

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function handlePhoneValidation() {
                var $field = $('.telephone');

                $field.addClass('backendError');
                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function billingAddressObject(address) {
                return new _index4.$BillingAddressModel({
                    line1: address.line1,
                    line2: address.line2,
                    city: address.city,
                    state: address.state,
                    postal_code: address.postal_code,
                    country: $scope.countryCode,
                    full_address: address.full_address,
                    id: '0'
                });
            }

            $scope.showPhone = function () {
                return $scope.checkoutSession.payer.phone && $scope.checkoutSession.payer.phone_type === 'WORK';
            };
            $scope.patchPhoneModel = new _index5.$PatchPhoneModel();
            $scope.patchPhoneModel.token = $scope.token;
            $scope.init = function () {
                $scope.checkoutSession.message = null;
                $scope.previousDefaultBillingAddress = {};
                $scope.bmlFlags = {};
                $scope.address = {};
                $scope.token = _angular.$rootScope.token;
                $scope.countryCode = _squid.$locale.country;
                $scope.validateAddress = new _index.$ValidateAddressModel();
                $scope.validatePhoneModel = new _index5.$ValidatePhoneModel();
                $scope.validatePhoneModel.token = $scope.token;
                $scope.bmlFlags.billingAddressUpdated = false;
                $scope.bmlFlags.AddressAdd = false;
                $scope.bmlFlags.AddressDisplay = true;
                $scope.bmlFlags.PhoneAdd = false;
                $scope.bmlFlags.ChangeLink = true;
                $scope.billingAddressUpdated = false;

                $('.paypalHeaderWrapper').addClass('paypalCredit');
                $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
                $('.paypalHeader').addClass('span14');
                $('.paypalHeader').removeClass('span24');

                if ($scope.bml && $scope.bml.application_status === 'SOFT_DECLINED') {
                    $scope.checkoutSession.message = {
                        type: 'warning',
                        msgKeys: ['applyForBml.bmlDeclineSoft']
                    };
                }
                _logger.$logger.info('APPLYFORBML_VIEW_RENDER');
            };

            $scope.redirectToReview = function () {
                $scope.bmlStateHandler.payInFullRedirect();
            };

            $scope.onContinue = function () {
                if ($scope.validateLegalAge()) {
                    if ($scope.bmlFlags.billingAddressUpdated) {
                        $scope.validateBillingAddress();
                    } else {
                        triggerNextState();
                    }
                }
            };

            $scope.validateLegalAge = function () {
                var dobMonth = $scope.bmlApply.personalInformation.month,
                    dobDay = $scope.bmlApply.personalInformation.day,
                    dobYear = $scope.bmlApply.personalInformation.year,
                    currentDate = new Date(),
                    currentMonth = currentDate.getMonth() + 1,
                    currentDay = currentDate.getDate(),
                    currentYear = currentDate.getFullYear(),
                    largestDOBYear = currentYear - 18; // Legal Age is 18

                var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || // eslint-disable-line no-extra-parens
                dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay; // eslint-disable-line no-extra-parens

                if (!isLegal) {
                    handleDobValidation();
                }

                return isLegal;
            };

            $scope.changeAddress = function () {
                $scope.bmlFlags.billingAddressUpdated = true;
                $scope.bml.phoneChanged = true;
                $scope.bmlFlags.AddressAdd = true;
                $scope.bmlFlags.AddressDisplay = false;
                $scope.bmlFlags.PhoneAdd = true;
                $scope.bmlFlags.ChangeLink = false;
            };

            $scope.changePlan = function () {
                _uiRouter.$state.go('checkout.chooseCreditOffer');
            };

            $scope.validateBillingAddress = function () {
                var newBilling = billingAddressObject($scope.address);
                newBilling['default'] = true;
                $scope.previousDefaultBillingAddress['default'] = false;
                $scope.validatePhoneModel.save({
                    data: {
                        telephone: $scope.bmlApply.personalInformation.phone.telephone,
                        phoneType: $scope.bmlApply.personalInformation.phone.phoneType
                    },
                    success: function success(result) {

                        if (result) {
                            newBilling.save({
                                data: $scope.billingAddress,

                                success: function success() {
                                    $scope.updateBillingAddress(newBilling);
                                },

                                validation: function validation(res) {
                                    handleValidation(res);
                                }
                            });
                        } else {
                            handlePhoneValidation(result);
                        }
                    },
                    validation: function validation(result) {
                        handlePhoneValidation(result);
                    }
                });
            };

            $scope.updateBillingAddress = function (newBillingAddress) {
                var addresses = $scope.billingAddresses.addresses;
                if (!isUserInputtedAddress(addresses[0])) {
                    addresses.unshift(newBillingAddress);
                } else {
                    addresses[0] = newBillingAddress;
                }
                triggerNextState();
            };

            $scope.init();
        }]
    };
});

_angular.$rootScope;

_squid.$locale;

_squid.$populate;

_uiRouter.$state;

_logger.$logger;

_index.$ValidateAddressModel;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_index3.$CreditInstallmentModel;

_index4.$BillingAddressesModel;

_index4.$BillingAddressModel;

_index5.$PatchPhoneModel;

_index5.$ValidatePhoneModel;

_directive.$BMLStateHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlApplyRoute', function () {

    return _squid.$ComponentRoute.extend('BmlApplyRoute', {

        name: 'bmlapply',
        trackingData: {
            fptiState: 'ppc_apply',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_apply',
                    'pagename2': '%::ppc_apply:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        directive: 'xo-bml-apply-page',
        titleContent: 'applyForBml.bmlApplyHeadline',

        children: []

    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply", "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/route.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"signupbml\" id=\"signupbml\" content>\n    <xo-title title-txt=\"{{content('signupBml.title')}}\" class=\"accessAid\"></xo-title>\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner\">\n\n            <div class=\"title\">\n                <xo-message message=\"checkoutSession.message\"></xo-message>\n            </div>\n\n            <!--Title-->\n            <div id=\"title\">\n                <h2 class=\"beta\">{{ content('applyForBml.bmlApplyHeadlineShort') }}</h2>\n                <p>{{ content('applyForBml.bmlApplyWithPayPal') }}</p>\n            </div>\n\n            <form id=\"userInfoForm\" name=\"userInfoForm\" ng-submit=\"userInfoForm.$valid && onContinue()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <!--Installment information-->\n                <div class=\"bmlRow\" ng-if=\"creditOptions.creditType\">\n                    <div class=\"billingAddressRow\">\n                        <h4 class=\"noBottom gamma sameLine\">{{ content('chooseCreditOption.paymentPlan') }}</h4>\n                        <a id=\"changePlanLink\" class=\"changeBillingAddress sameLine\" ng-click=\"changePlan()\">{{ content('common.change') }}</a>\n                    </div>\n\n                    <div class=\"installmentInfo\" ng-if=\"creditOptions.creditType==='INST'\">\n                        <p class=\"billingName\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: creditOptions.monthlyPayment})\"></p>\n                        <p class=\"installmentDescription\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: creditOptions.totalInterest, totalPayment: creditOptions.totalPayment})\"></p>\n                    </div>\n\n                    <div class=\"installmentInfo\" ng-if=\"creditOptions.creditType==='SAC'\">\n                        <p class=\"billingName\" ng-bind-html=\"htmlContent('applyForBml.bmlSACOfferDetail')\"></p>\n                    </div>\n                </div>\n\n                <!--Personal information-->\n                <div class=\"bmlRow\">\n                    <h4 class=\"piHeight gamma\">{{ content('applyForBml.personalInfo') }}\n                        <a class=\"verifyHelp\" id=\"verifyHelp\"></a>\n\n                        <xo-tooltip trigger=\"#verifyHelp\" show-event=\"click\">\n                            {{ content('applyForBml.ssnToolTip') }}\n                        </xo-tooltip>\n                    </h4>\n\n                    <div class=\"dobNatlIdGroup\">\n                        <xo-dob-nationalid pi=\"bmlApply.personalInformation\"></xo-dob-nationalid>\n                    </div>\n                </div>\n\n\n                <!--Billing Address-->\n                <div class=\"bmlRow\">\n                    <div class=\"billingAddressRow\">\n                        <h4 class=\"noBottom gamma sameLine\">{{ content('applyForBml.bmlApplyBillingAddress') }}</h4>\n                        <a id=\"changeAddressLink\" class=\"changeBillingAddress sameLine\" ng-show=\"bmlFlags.ChangeLink\" ng-click=\"changeAddress()\">{{ content('common.change') }}</a>\n                    </div>\n\n                    <div id=\"bmlGivenName\">\n                        <p class=\"billingName\">{{auth.first_name}}&nbsp{{auth.last_name}}</p>\n                    </div>\n\n                    <div id=\"bmlAddressDisplay\" class=\"billingAddressRow\" ng-show=\"bmlFlags.AddressDisplay\">\n                        <xo-address-display address=address country-code=countryCode></xo-address-display>\n                        <div id=\"bmlBillingPhone\" class=\"bmlBillingPhone adr\">{{bmlApply.personalInformation.phone.telephone}}</div>\n                    </div>\n\n                    <div id=\"bmlAddressAdd\" class=\"bmlMargin\" ng-show=\"bmlFlags.AddressAdd\">\n                        <xo-add-address country=countryCode address=\"address\" token=\"token\"></xo-add-address>\n                    </div>\n\n                    <div id=\"addPhone\" class=\"addPhone\" ng-show=\"bmlFlags.PhoneAdd\">\n                        <xo-phone-input token=\"token\" exclude=\"WORK\" phone=\"bmlApply.personalInformation.phone\"></xo-phone-input>\n                    </div>\n\n                </div>\n\n                <!--Agree and Continue-->\n                <p class=\"bmlSeeTerms\" bind-html-compile=\"htmlContent('applyForBml.bmlApplyESign')\"></p>\n\n                <div class=\"buttons\">\n                    <input type=\"submit\" track-submit='bml_apply' id=\"bmlAgreeAndContinue\" name=\"bmlAgreeAndContinue\"\n                           value=\"{{content('applyForBml.bmlApplyTermsSubmit')}}\" class=\"btn full\" ng-click=\"validated=true\" />\n                </div>\n\n            </form>\n\n            <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                <p class=\"bmlSeeTerms sameLine\">{{ content('applyForBml.notInterestedNoInstallments') }}</p>\n                <p class=\"bmlSeeTerms sameLine payInFullLink\" ng-bind-html=\"htmlContent('applyForBml.payInFull')\"\n                   ng-click=\"redirectToReview()\"></p>\n            </div>\n\n            <div id=\"bmlLender\">\n                <p class=\"bmlSeeTerms\">{{ content('base.bmlLender') }}</p>\n            </div>\n\n        </div>\n\n        <div class=\"span10 trayInner\" id=\"bmlApplyEdu\">\n            <h2 class=\"gamma\">{{ content('applyForBml.bmlApplyEduTitle') }}</h2>\n            <ul>\n                <li>{{ content('applyForBml.bmlApplyEduBullet1') }}</li>\n                <li>{{ content('applyForBml.bmlApplyEduBullet2') }}</li>\n                <li>{{ content('applyForBml.bmlApplyEduBullet3') }}</li>\n            </ul>\n            <p>{{ content('applyForBml.bmlApplyInterestTerms') }}</p>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlPopup', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token)
            }).then(function () {
                if ($scope.checkoutSession.showDeclinePopup) {
                    if (!_angular.$rootScope.bml) {
                        _angular.$rootScope.bml = new _bml.$BMLModel();
                    }
                    if (!$scope.bml) {
                        $scope.bml = _angular.$rootScope.bml;
                    }

                    $scope.bml.preferenceCheck = false;
                    $scope.bml.showModal = true;
                    $scope.bml.showModalBackdrop = true;

                    if ($scope.bml.applicationStatus() || $scope.bml.contingency) {
                        $scope.bml.showModalBackdrop = true;
                    }
                }
            });

            $scope.bmlSetPreferrence = function () {
                if ($scope.bml.preferenceCheck) {
                    $scope.bml.action('preference', {
                        data: {
                            financial_instrument_id: $scope.bml.financial_instrument_id
                        },
                        success: function success() {
                            _logger.$logger.info('COMPLETEBMLAPPLY_PREFERRED');
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['memberReview.bmlPreferredConfirmation']
                            };
                        }
                    });
                } else {
                    $scope.checkoutSession.message = {
                        type: 'success',
                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                    };
                }
                $scope.bml.showModal = false;
            };

            $scope.bmlClickContinue = function ($event) {
                $event.preventDefault();
                $scope.bml.showModalBackdrop = false;
                $scope.bml.showModal = false;
            };
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_logger.$logger;

_bml.$BMLModel;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"xoBmlPopup\" content>\n    <!-- BML Decision -->\n    <div ng-if=\"bml.application_status !== undefined || bml.contingency\">\n        <div ng-show=\"bml.showModal\" id=\"bmlModal\" style=\"display:block;\" class=\"modal bmlModal\" aria-labelledby=\"modal-title\" role=\"alertdialog\" tabindex=\"-1\">\n\n            <div ng-show=\"bml.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n            <div class=\"modal-wrap\">\n\n                <div ng-switch=\"bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\">\n                    <div ng-switch-when=\"true\">\n                        <span class=\"bmlLogoVert\"></span>\n                        <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSuccessHeader') }}</h2>\n\n                        <div ng-if=\"bml.nape == 'napePositive'\">\n                            <p>{{ content('memberReview.bmlNapeLinkSuccess')}}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value == 0\">\n                            <p>{{ content('memberReview.bmlApprovalMessage') }}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value > 0\">\n                            <p ng-bind-html=\"htmlContent('memberReview.bmlSuccessMessage', {creditLine: bml.credit_line.value})\"></p>\n                            <p>{{ content('memberReview.bmlSuccessMessageSend', {email: bml.user_info.email_address}) }}</p>\n                        </div>\n\n                        <form method=\"post\" name=\"confirm\" ng-submit=\"bmlSetPreferrence()\">\n                            <div class=\"checkbox\">\n                                <input type=\"checkbox\" ng-model=\"bml.preferenceCheck\" name=\"bmlPreferred\" id=\"bmlPreferredCheckbox\" class=\"chkbx\">\n                                <label for=\"bmlPreferredCheckbox\" class=\"chkbxLabel\">{{ content('memberReview.bmlSetPreferred')}}</label>\n                            </div>\n                            <input class=\"btn btn-submit full\" type=\"submit\" value=\"{{ content('memberReview.bmlContinue')}}\">\n                        </form>\n\n                    </div>\n                    <div ng-switch-default>\n                        <div ng-switch=\"bml.application_status\">\n                            <!-- bmlMaxAttempts -->\n                            <div ng-switch-when=\"SOFT_DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSorry')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- bmlDeclineLinkedToDiffMember -->\n                            <div ng-switch-when=\"FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.bmlAcctLinkedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.bmlAcctLinkedMsg')}}</p>\n                            </div>\n                            <!-- creditDeclineHard -->\n                            <div ng-switch-when=\"DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.hardDeclineHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- ??? creditPaymentNotAllowed -->\n                            <div ng-switch-when=\"CREDIT_PAYMENT_NOT_ALLOWED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditNotAllowedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditNotAllowedMsg')}}</p>\n                            </div>\n                            <!-- ??? creditEligibilityDeclined -->\n                            <div ng-switch-when=\"CREDIT_ELIGIBILITY_DECLINE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditEligibilityDeniedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditEligibilityDeniedMsg')}}</p>\n                            </div>\n                            <!-- ??? declineOtherCreditInstrumentExists -->\n                            <div ng-switch-when=\"FP_DECLINED_DUE_TO_CREDIT_IN_WALLET_RULE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.declineOtherCreditInstrumentExistsHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine1')}}</p>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine2\" merchantName=\"{bmlResult.merchantFullName}')}}</p>\n                            </div>\n                            <!-- systemError, bmlGenericError, invalidError -->\n                            <div ng-switch-default> <!-- ng-switch-when=\"UNKNOWN_DECISION\" -->\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.systemErrorHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.systemErrorMsg')}}</p>\n                            </div>\n                        </div>\n\n                        <!--\n                         && bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\n                        -->\n                        <div ng-if=\"bml.application_status !== undefined || bml.contingency\" >\n                            <div ng-if=\"locale.countryCode === 'DE'\">\n                                <p class=\"cancelUrl\">\n                                    <a href=\"{{cancel}}\" role=\"button\" class=\"btn full\">{{ content('common.returnToCart') }}</a>\n                                </p>\n                            </div>\n                            <div ng-if=\"locale.countryCode !== 'DE'\">\n                                <input class=\"btn btn-submit full buttonGroup button-spacing\" type=\"button\" id=\"continueBml\" value=\"{{ content('common.payWithPayPal') }}\" ng-click=\"bmlClickContinue($event)\" />\n                                <a href=\"{{cancel}}\" role=\"button\" class=\"btn btn-secondary full buttonGroup\" id=\"cancelLink\">\n                                    {{ merchant ? content('common.bmlCancelButtonLabel', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant') }}\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <!-- BML Decision -->\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/template.html");

var _template2 = _interopRequireDefault(_template);

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlSignaturePage', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {
                $scope.init = function () {
                    $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
                    $('.paypalHeaderWrapper').addClass('paypalCredit');
                    $('.paypalHeader').removeClass('span14');
                    $('.paypalHeader').addClass('span24');
                    $('.paypalHeader').addClass('headerBar');
                    $scope.token = _angular.$rootScope.token;
                    $scope.bmlSign = new _bml.$BMLApplicationModel();
                };

                $scope.onSubmit = function () {
                    var application_id = $scope.bml.application_id;
                    $scope.bmlSign.application_id = application_id;
                    $scope.bmlSign.action('sign', {
                        resultModel: $scope.bml,
                        success: function success(result) {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                };

                $scope.redirectToReview = function () {
                    _uiRouter.$state.go('checkout.review');
                };

                $scope.init();
            });
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_uiRouter.$state;

_auth.$AuthModel;

_bml.$BMLApplicationModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlSignatureRoute', function () {
    return _squid.$ComponentRoute.extend('BmlSignatureRoute', {

        name: 'bmlsignature',
        trackingData: {
            fptiState: 'ppc_signature',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_signature',
                    'pagename2': '%::ppc_signature:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        titleContent: 'consumerCreditInfo.applicationApprovedMessage',
        directive: 'xo-bml-signature-page',

        children: []

    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature", "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/route.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-signature/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"bmlSignature\" id=\"bmlSignature\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <xo-title title-txt=\"{{content('consumerCreditInfo.applicationApprovedMessage')}}\"></xo-title>\n            <form name=\"bmlSignatureForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"bmlSignatureForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n                <p class=\"content\">{{content('consumerCreditInfo.reviewSecciMessage')}}</p>\n\n                <div class=\"agree checkbox legal\" ng-class=\"{error: validated && !bmlSignatureForm.$valid}\">\n                    <input ng-model=\"fields.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" data-error-text=\"{{content('eConsent.eConsentError')}}\" xo-error-tooltip xo-validation='{\n                        \"validator\": \"isChecked\",\n                        \"options\": {\n                            \"el\": \"#agree\"\n                        }\n                    }' />\n                    <label id=\"confirmationMessage\" class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('consumerCreditInfo.secciReadConfirmationMessage')\"></label>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit='bml_signature' type=\"submit\" value=\"{{content('common.continueLabel')}}\"\n                           class=\"btn full\" ng-click=\"validated=true\" />\n                </div>\n\n                <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                    <p class=\"bmlSeeTerms sameLine\">{{ content('applyForBml.notInterestedNoInstallments') }}</p>\n                    <p class=\"bmlSeeTerms sameLine\" ng-bind-html=\"htmlContent('applyForBml.payInFull')\" ng-click=\"redirectToReview()\"></p>\n                </div>\n            </form>\n        </div>\n        <div class=\"span10 bmlMargin\">\n            <xo-value-props type=\"signature\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/template.html");

var _template2 = _interopRequireDefault(_template);

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _directive = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlTermsAndConditionsPage', function () {
    var linkFn = function linkFn(scope, element, attrs) {
        var $agreeButton = $('#bmlAgreeToTerms');

        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
            eventer = window[eventMethod],
            data,
            messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

        // Browsers that support postMessage
        if (window.postMessage) {
            /**
             * Event to listen for post messages sent from PayPal popup window.
             * Data from PayPal will contains return url and the localised content.
             */
            eventer(messageEvent, function (event) {
                data = angular.fromJson(event.data);
                if (data.action === 'scroll') {

                    if (data.toEnd && !scope.isMobile) {
                        scope.scrollComplete();
                    }
                } else if (data.action === 'setHeight' && scope.isMobile) {
                    $('.bmlTermsBody iframe').css('height', data.height + 20 + 'px');
                }
            }, false);
        }

        $agreeButton.click(function (event) {
            event.preventDefault();
            scope.handleAgreeToTermsClick();
        });
    };

    return {
        template: _template2['default'],
        link: linkFn,
        controller: ['$scope', function ($scope) {
            if ($scope.$parent && $scope.$parent.bml) {
                $scope.bml = $scope.$parent.bml;
                $scope.bmlApply = $scope.$parent.bmlApply;
                $scope.bmlComplete = $scope.$parent.bmlComplete;
            }

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                payee: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                $scope.patchPhoneModel = new _user.$PatchPhoneModel();
                $scope.patchPhoneModel.token = $scope.token;

                if ($scope.$parent && $scope.$parent.bml) {
                    var bmlData = {
                        reviewUrl: $scope.$parent.reviewUrl,
                        bml: $scope.bml,
                        bmlApply: $scope.bmlApply,
                        bmlComplete: $scope.bmlComplete,
                        checkoutSession: $scope.checkoutSession,
                        auth: $scope.auth,
                        purchase: $scope.checkoutCart.purchase,
                        patchPhone: $scope.patchPhoneModel,
                        billingAddresses: $scope.billingAddresses,
                        merchant: $scope.checkoutAppData.merchant,
                        merchantId: $scope.payee.merchant.id
                    };

                    $scope.bmlStateHandler = new _directive.$BMLStateHandler(bmlData);
                }
            });

            $scope.init = function () {
                $scope.token = _angular.$rootScope.token;
                $('.paypalHeaderWrapper').addClass('paypalCreditTnc');
                $('.paypalHeader').removeClass('span14');
                $('.paypalHeader').addClass('span24');
                $('.paypalHeader').addClass('headerBar');
                $('.footerWrapper').addClass('hide');
                $scope.isMobile = _index.$DeviceInfo.isMobile();
                $scope.isMiniBrowser = _angular.$rootScope.miniBrowser;
                $scope.bmlFlags = {
                    bmlFooterShow: true,
                    full: true,
                    xoFooter: true,
                    enableFooter: true,
                    showConfirmationModal: false,
                    showModalBackdrop: true
                };

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
                _logger.$logger.info('TERMSNCONDITIONS_VIEW_RENDER');
            };

            $scope.ppCreditTermsUrl = 'https://' + _squid.$meta.cdnHost + '/webstatic/checkout/hermes/html/PayPalCreditTerms_print.html';
            $scope.ppCreditTermsUrl_v2 = 'https://' + _squid.$meta.cdnHost + '/webstatic/checkout/hermes/html/PayPalCreditTerms_v2.html';

            $scope.handleAgreeToTermsClick = function () {
                this.showConfirmationModal();
                _logger.$logger.info('bmlAgreeToTerms', {});
            };

            $scope.showConfirmationModal = function (show) {
                show = angular.isUndefined(show) ? true : show;
                $scope.bmlFlags.showConfirmationModal = show;
            };

            $scope.agreeToTermsConfirmation = function (event) {
                event.preventDefault();

                _logger.$logger.info('bmlConfirmAgreeToTermsPopup', {});
                this.showConfirmationModal(false);
                this.onContinue();
            };

            $scope.cancelApplication = function (event) {
                event.preventDefault();
                _logger.$logger.info('bmlCancelApplication', {});
                $scope.bmlStateHandler.payInFullRedirect();
            };

            // when the esc key is pressed
            $('html').on('keyup', function (ev) {
                if (ev.which === 27) {
                    $scope.showConfirmationModal(false);
                }
            });

            $scope.onContinue = function () {
                _logger.$logger.info('BMLTERMSNCONDITIONS_VIEW_SUBMIT');
                $scope.bmlStateHandler.applyBML();
            };

            $scope.init();
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_squid.$meta;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_fi.$BillingAddressesModel;

_user.$PatchPhoneModel;

_directive.$BMLStateHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BmlTermsAndConditionsRoute', function () {

    return _squid.$ComponentRoute.extend('BmlTermsAndConditionsRoute', {

        name: 'bmltermsandconditions',
        trackingData: {
            fptiState: 'ppc_termsandconditions',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_termsandconditions',
                    'pagename2': '%::ppc_termsandconditions:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        directive: 'xo-bml-terms-and-conditions-page',
        titleContent: 'applyForBml.bmlApplyHeadline',

        children: []

    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions", "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"bmlTermsAndConditions\" id=\"bmlTermsAndConditions\" content>\n\n    <div ng-show=\"bmlFlags.showConfirmationModal\" id=\"creditConfirmation\" class=\"modal bmlModal\" role=\"alertdialog\" tabindex=\"-1\">\n\n        <div ng-show=\"bmlFlags.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n        <div class=\"modal-wrap\">\n\n            <div class=\"paypalHeaderWrapper paypalCredit\">\n                <div class=\"logo\">\n                    <span class=\"accessAid\">{{content('applyForBml.payPalCredit')}}</span>\n                </div>\n                <a class=\"close\" href=\"#\" ng-click=\"showConfirmationModal(false)\">\n                    {{content('applyForBml.close')}}\n                </a>\n            </div>\n\n            <div class=\"confirmationPopupContent\">\n                <h2>{{content('applyForBml.justToConfirm')}}</h2>\n                <ul>\n                    <li>\n                        {{content('applyForBml.confirmationPopupListItem1')}}\n                    </li>\n                    <li>\n                        {{content('applyForBml.confirmationPopupListItem2', { email: auth.email })}}\n                    </li>\n                </ul>\n                <form id=\"confirmAgreeToTerms\">\n                    <input ng-click=\"agreeToTermsConfirmation($event)\" id=\"confirmAgreeToTermsSubmit\"\n                        class=\"btn btn-submit full\" type=\"submit\" value=\"{{content('applyForBml.agreeApply')}}\">\n                </form>\n            </div>\n            <div class=\"cancelApplicationBlock\">\n                <a ng-click=\"cancelApplication($event)\" id=\"cancelCreditApplication\" href=\"#\">\n                    {{content('applyForBml.cancelApplication')}}\n                </a>\n            </div>\n        </div>\n    </div>\n\n\n    <xo-title title-txt=\"{{content('signupBml.title')}}\" class=\"accessAid\"></xo-title>\n    <div class=\"row-fluid justMember\">\n        <div class=\"trayInner\">\n            <xo-message message=\"checkoutSession.message\"></xo-message>\n\n            <div class=\"bmlTermsHeader\">\n                <h2 class=\"gamma zeta bmlTermsHead\">{{ content('applyForBml.agreementTermsTitle') }}</h2>\n                <p class=\"printContent\">\n                    <a href=\"{{ ppCreditTermsUrl }}\" xo-popup class=popup target=\"_blank\">\n                       <span ng-if= \"!isMobile\" >{{ content('applyForBml.printCopy') }} </span>\n                        <span ng-if=\"isMobile\">{{ content('applyForBml.download') }}</span>\n                    </a>\n                </p>\n            </div>\n\n            <div class=\"span24 trayInner\">\n\n                <div class=\"bmlTermsInnerWrap\">\n                    <div class=\"bmlTermsBody\" tabindex=\"-1\">\n                        <iframe id= \"tncFrame\" src=\"{{ ppCreditTermsUrl_v2 }}\"></iframe>\n                   </div>\n                </div>\n\n                <div class=\"bmlTermsFooter buttons\"\n                     ng-class=\"{'bmlTermsFooter buttons bmlFooterShow': bmlFlags.bmlFooterShow ,\n                                'bmlTermsFooter buttons enabled' : bmlFlags.enableFooter,\n                                'bmlTermsFooter buttons': !bmlFlags.bmlFooterShow || !bmlFlags.enableFooter}\">\n                    <div class=\"proceed\">\n                        <button id=\"bmlAgreeToTerms\" track-submit='ppc_agree_terms' class=\"btn bmlAgreeToTerms\"\n                                name=\"bmlAgreeApply\">{{content('applyForBml.agreeApply')}}</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _directive = __webpack_require__("../node_modules/xo-page-components/src/header/directive.js");

var _cycoExitFactory = __webpack_require__("../node_modules/xo-page-components/src/footer/cycoExitFactory.js");

__webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/faq/directive.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoChooseCreditOfferDirective', {
    tag: 'xo-choose-credit-offer',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            var authModel = _auth.$AuthModel.instance();
            var checkoutSession = _index2.$CheckoutSessionModel.instance(this.props.token);
            var shouldRetrieveSession =
            // See comment in route.js
            _uiRouter.$stateParams.populateSession ||
            // checkoutSession should be retrieved in Hermes as long as it is not a guest session
            authModel.logged_in;

            return {
                auth: authModel.retrieve()['catch'](_angular.noop),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve({
                    params: {
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })['catch'](_angular.noop),
                checkoutSession: shouldRetrieveSession ? checkoutSession.retrieve()['catch'](_angular.noop) : checkoutSession,
                payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                creditOptions: _index.$CreditInstallmentModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                flowEligibility: _index2.$FlowEligibilityModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        locale: function locale() {
            // see xo-landing/route.js in hermesnodeweb repo for locale override
            var locale = {
                merchantCountry: this.checkoutAppData.get('merchant.merchant_country'),
                buyerCountry: _squid.$locale.country
            };

            _logger.$logger.info('cyco_locale', locale);
            return locale;
        }
    },
    actions: {
        redirectToReview: function redirectToReview() {
            $('body').removeClass('CYCOPage');
            _directive.$SetHeaderText.setText('');
            this.creditDataModel.payInFull = true;
            _logger.$logger.info('checkout_fpti', {
                from: 'CHOOSE_CREDIT_OFFER',
                to: 'process_pay_in_full'
            });
            if (!this.models.auth.logged_in) {
                _uiRouter.$state.go('checkout.login');
            } else {
                _uiRouter.$state.go('checkout.review');
            }
        },
        toggleSacOffer: function toggleSacOffer(isExtended) {
            this.sacExtended = isExtended ? false : true;
        },
        toggleInstallmentOffer: function toggleInstallmentOffer(isExtended) {
            this.installmentExtended = isExtended ? false : true;
        },
        toggleFAQ: function toggleFAQ(index) {
            this.faqExtended[index] = !this.faqExtended[index];
        },
        toggleAllFAQ: function toggleAllFAQ() {
            this.allFaqExtended = !this.allFaqExtended;
            var newState = false; // closed

            if (this.allFaqExtended) {
                this.toggleText = (0, _squid.$renderContent)('FAQ.closeAllSections');
                newState = true; // opened
            } else {
                this.toggleText = (0, _squid.$renderContent)('FAQ.openAllSections');
                newState = false; // closed
            }

            for (var i in this.faqExtended) {
                this.faqExtended[i] = newState;
            }
        },
        getCreditFinancingCodes: function getCreditFinancingCodes() {
            var sacOffer = this.offers.getNiOffer();
            var financingCodes = '';

            if (this.creditOffers && this.installmentCount) {
                this.creditOffers.installment_options.forEach(function (installment) {
                    financingCodes += installment.financingCode;
                    financingCodes += ',';
                });
            }

            if (sacOffer) {
                financingCodes += sacOffer.financingCode;
            }

            return financingCodes;
        },
        getInstallmentContent: function getInstallmentContent() {
            var contentKey = 'chooseCreditOption.singleInstallmentDescription';

            if (this.installmentCount > 1) {
                if (this.creditOffers.installment_options.find(function (installment) {
                    return installment.apr === '0.00';
                })) {
                    contentKey = 'chooseCreditOption.installmentDescriptionAprZero';
                } else {
                    contentKey = 'chooseCreditOption.installmentDescription2';
                }
            }
            return contentKey;
        },
        handleRedirect: function handleRedirect() {
            var creditMemberType = this.isCreditInWallet ? 'existingMember' : 'newMember';
            var isBuyerSet = this.fundingInstruments;
            var isSignUpFlow = this.creditDataModel.isCreditSignup();
            var isChangeInstallment = this.creditDataModel.isChangeStatus();
            var is2ndButton = this.models.checkoutAppData.is_second_button_txn;

            var isBillingNoPurchase = this.checkoutCart.isBillingNoPurchase();

            $('body').removeClass('CYCOPage');
            _directive.$SetHeaderText.setText('');

            if (creditMemberType === 'existingMember') {
                // When user selects an offer, PPC should be set as the selected FI
                if (isBillingNoPurchase) {
                    var fpList = this.models.checkoutSession.get('futurePaymentInstruments');
                    var bml = fpList.find(function (fp) {
                        return fp.type === 'BILL_ME_LATER';
                    });

                    return this.models.checkoutSession.action('setStickyFI', {
                        data: {
                            instrument_id: bml.instrument_id
                        },
                        success: function success() {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                } else {
                    var fiList = this.models.checkoutSession.get('fundingOptions.instruments');
                    var fundingSource = _squid.$util.find(fiList, function (fi) {
                        return fi.name === 'BILL_ME_LATER';
                    });

                    return this.models.checkoutSession.fundingOptions.action('select', {
                        resultModel: this.models.checkoutSession,
                        data: {
                            planId: fundingSource.planId
                        },
                        success: function success(result) {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                }
            } else if (isBuyerSet || isSignUpFlow && isChangeInstallment || is2ndButton || this.locale.buyerCountry === 'DE') {
                _uiRouter.$state.go('checkout.redirectToCape');
            } else {
                _uiRouter.$state.go('checkout.login');
            }
        },
        onSelect: function onSelect(index) {
            var _this = this;

            this.creditDataModel.setSelectedCYCOOffer(true);

            if (index === 'CORE') {
                if (this.models.creditOptions && this.models.creditOptions.creditType) {
                    delete this.models.creditOptions.creditType;
                }
                _logger.$logger.info('checkout_fpti', { 'credit_type': 'CORE' });
                this.actions.handleRedirect();
            } else {
                var isPPCReuse = this.isCreditInWallet;
                var selectedOffer = index === 'SAC' ? this.creditOffers.sac_options : this.creditOffers.installment_options[index];
                var param = {
                    'financing_code': selectedOffer.financingCode,
                    'apr': selectedOffer.apr,
                    'term': selectedOffer.term,
                    'credit_type': selectedOffer.creditType,
                    'paypal_subsidy': selectedOffer.paypalSubsidy,
                    'credit_installment_integration_type': this.models.checkoutAppData.isSecondButton() ? 'SECOND_BUTTON' : undefined
                };

                if (index !== 'SAC') {
                    param.monthly_percentage_rate = selectedOffer.monthlyPercentageRate;
                    param.total_cost = selectedOffer.totalPayment.value;
                    param.total_interest = selectedOffer.totalInterest.value;
                    param.monthly_payment = selectedOffer.monthlyPayment.value;
                    param.currency = selectedOffer.monthlyPayment.currency;
                }

                return this.models.creditOptions.action('select', {
                    data: param,
                    success: function success() {
                        _logger.$logger.info('checkout_fpti', {
                            'is_ppc_reuse': isPPCReuse ? '1' : '0',
                            'credit_type': selectedOffer.creditType,
                            'financing_code_selected': selectedOffer.financingCode
                        });
                        _this.actions.handleRedirect();
                    }
                });
            }
        },
        showExitSurvey: function showExitSurvey() {
            _cycoExitFactory.$cycoExitFactory.showExitSurvey();
        }
    },
    lifecycle: {
        enter: function enter() {
            this.checkoutAppData = _index2.$CheckoutAppDataModel.instance(this.props.token);
            this.checkoutCart = _index2.$CheckoutCartModel.instance(this.props.token);
            this.creditDataModel = _index.$CreditDataModel.instance(this.props.token);
            this.faqExtended = [false, false, false];
            this.allFaqExtended = false;
            $('.paypalHeaderWrapper').addClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
            $('body').addClass('CYCOPage');
            _directive.$SetHeaderText.setText('chooseCreditOption.offerHeading');
            _cycoExitFactory.$cycoExitFactory.cycoEnter(this.checkoutAppData.get('merchant.merchant_country'));
        },
        exit: function exit() {
            _cycoExitFactory.$cycoExitFactory.cycoExit();
        },
        populate: function populate() {
            var _this2 = this;

            var self = this;
            var MIN_AMOUNT = '$99';

            if (this.locale.buyerCountry === 'GB') {
                MIN_AMOUNT = '£99';
            } else if (this.locale.buyerCountry === 'DE') {
                MIN_AMOUNT = '€99';
            }

            this.aprContent = _squid.$config.representativeExampleGB;

            this.offers = new _index.$CreditInstallmentOptionsModel({
                id: this.props.token,
                payee: this.models.payee,
                checkoutCart: this.models.checkoutCart,
                checkoutAppData: this.models.checkoutAppData,
                isMemberCredit: true
            });

            this.isBillingNoPurchase = this.checkoutCart.isBillingNoPurchase();

            if (this.isBillingNoPurchase) {
                this.fundingInstruments = this.models.checkoutSession.get('futurePaymentInstruments');
            } else {
                this.fundingInstruments = this.models.checkoutSession.get('fundingOptions.instruments');
            }

            if (this.models.auth.logged_in && this.fundingInstruments) {
                this.models.checkoutSession.retrieve();
            }

            if (this.isBillingNoPurchase) {
                this.isCreditInWallet = this.models.checkoutSession.get('futurePayment.isCreditInWallet');
            } else {
                this.isCreditInWallet = this.fundingInstruments && _squid.$util.some(this.fundingInstruments, function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            this.toggleText = (0, _squid.$renderContent)('FAQ.openAllSections');

            // Use templateVars when the content is required to fill in the properties from locale files.
            this.templateVars = {
                merchantName: this.models.checkoutAppData.get('merchant.brand_name'),
                amount: this.checkoutCart.get('purchase.amounts.total.amount_formatted'),
                minAmount: MIN_AMOUNT,
                seeTermsUrl: undefined
            };

            // Call SSOT to determine installment options
            this.offers.save({
                cache: true,
                success: function success(result) {
                    _this2.creditOffers = _this2.offers.getInstallmentOffers();
                    _this2.creditOfferDetails = _this2.creditOffers && _this2.creditOffers.installment_options;
                    _this2.installmentCount = _this2.offers.getInstallmentCount();
                    _this2.creditDataModel.setInstallmentCount(_this2.offers.getInstallmentCount());
                    var installmentOfferDetailsArray = _this2.creditOfferDetails ? _this2.creditOfferDetails.map(function (item) {
                        return item.financingCode;
                    }) : [];

                    var hasThreeMonthInstallment = _xoCreditBannerUtils.$xoCreditBannerUtils.hasThreeMonthInstallments(installmentOfferDetailsArray);

                    // Throw error if its a three month financing code on old CYCO page
                    if (hasThreeMonthInstallment) {
                        _logger.$logger.info('CYCO: ssot call returned three month financing code: ' + installmentOfferDetailsArray);
                        return _angular.$q.reject();
                    }

                    if (result && result.conversion_info && result.conversion_info.converted_transaction_amount) {
                        _logger.$logger.info('CYCO: Setting Cross Country cart_amount and cart_currency');
                        _this2.creditDataModel.setCartAmountAndCurrency({
                            cart_amount: result.conversion_info.converted_transaction_amount.value,
                            cart_currency: result.conversion_info.converted_transaction_amount.currency_code
                        });
                    }
                },
                error: function error(_error) {
                    _logger.$logger.info('CYCO: ssot call returned error: ' + _error);
                    return _angular.$q.reject(_error);
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('CYCO: ssot call returned contingency: ' + name);
                        return _angular.$q.reject(err);
                    }
                }
            }).then(function (results) {
                _this2.installmentsPresent = _this2.offers.getInstallmentOptionsPresent();

                // Logging when Both BA and EZP enabled
                if (_this2.models.checkoutCart.isBilling() && _this2.installmentsPresent) {
                    _logger.$logger.info('CYCO: Merchant ' + _this2.templateVars.merchantName + ' in ' + _this2.locale.merchantCountry + ' has both BA and EZP enabled');
                }

                _this2.installmentCount = _this2.offers.getInstallmentCount();
                _this2.templateVars.seeTermsUrl = _this2.creditOffers ? (0, _squid.$feature)('creditOfferSeeTermsUrl') + _this2.creditOffers.terms_param : undefined;

                if (_this2.creditOffers) {
                    _logger.$logger.info('checkout_fpti', {
                        'financing_code_offered': _this2.actions.getCreditFinancingCodes()
                    });
                }
                _this2.installmentContentKey = _this2.actions.getInstallmentContent();

                /**
                 * installmentSectionExtendedByDefault: Only applicable to GB and DE, this variable is true when by deafult
                 * we want installments section to be extended.
                 **/
                _this2.installmentSectionExtendedByDefault = (_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && _this2.models.checkoutAppData.is_second_button_txn;

                /**
                 * showInstallmentOfferOnly: Only applicable to GB and DE, this variable is true when installments
                 * are available and its second button flow.
                 * Intention behind it is to not confuse user when merchant is willing to provide installments.
                 * Product/business is reviewing this and we might start showing both NI and INST in this case.
                 **/
                _this2.showInstallmentOfferOnly = (_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && _this2.models.checkoutAppData.is_second_button_txn;

                /**
                 * showNIOfferOnly:
                 * US: showNIOfferOnly will always be false for US. In US there is no scenario to show only NI/SAC offer
                 * on CYCO. If its just NI/SAC offer for user, then CYCO page should not be shown in US.
                 * GB: showNIOfferOnly is true in GB when only NI offer is available. In this case, user is shown only NI
                 * offer on CYCO. This is just to show all the details again to user. Product/Business are
                 * exploring this scenario to probably skip showing CYCO in this case.
                 **/
                _this2.showNIOfferOnly = false;
                if ((_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && !_this2.models.checkoutAppData.is_second_button_txn && !(_this2.models.checkoutSession && _this2.models.checkoutSession.creditInstallmentOffer)) {
                    _this2.showNIOfferOnly = true;
                }

                /**
                 * showNoInterestSection:
                 * US: This should always be true for US.
                 * GB 1st button: This should be always true for 1st button scenarios.
                 * GB 2nd button: This should be false when installments are available, true otherwise.
                 * GB BA Flows: There is no merchant with both BA and INST configured. If that happens,
                 * there should be a story to update code as desired.
                 **/
                _this2.showNoInterestSection = _this2.locale.buyerCountry === 'DE' ? !_this2.showInstallmentOfferOnly : _this2.creditOffers && _this2.creditOffers.sac_options;

                // For converting SAC content to NI in US for Asset light
                // this.showNIInsteadOfSACInUS = this.locale.buyerCountry === 'US' && this.creditOffers.sac_options
                // && (this.creditOffers.sac_options.creditType === 'NI');

                // Dynamic APR in installment offer description
                var minOfferedAPR = 100;
                _this2.templateVars.minOfferedAPR = '0';
                if (_this2.installmentsPresent) {
                    _this2.creditOffers.installment_options.forEach(function (offer, key) {
                        var apr = parseFloat(offer.apr);

                        if (isNaN(apr)) {
                            this.incorrectAPR = true;
                        } else {
                            minOfferedAPR = apr < minOfferedAPR ? apr : minOfferedAPR;
                        }
                    });
                    _this2.templateVars.minOfferedAPR = String(minOfferedAPR);
                }
            })['catch'](function (error) {
                // if PPC 2nd button, redirect to generic error
                // else (if 1st button), redirect to review
                if (_this2.models.checkoutAppData.is_second_button_txn) {
                    _uiRouter.$state.go('checkout.genericError');
                } else {
                    _this2.models.checkoutSession.message = {
                        type: 'warning',
                        msgKeys: ['paymentMethod.cycoSsotWarning']
                    };
                    return self.actions.redirectToReview();
                }
            });
        }
    }

});


_uiRouter.$state;

_uiRouter.$stateParams;

_angular.$q;

_angular.noop;

_logger.$logger;

_auth.$AuthModel;

_squid.$Component;

_squid.$locale;

_squid.$util;

_squid.$feature;

_squid.$renderContent;

_squid.$config;

_index.$CreditInstallmentModel;

_index.$CreditDataModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutAppDataModel;

_index2.$FlowEligibilityModel;

_index.$CreditInstallmentOptionsModel;

_directive.$SetHeaderText;

_cycoExitFactory.$cycoExitFactory;

_xoCreditBannerUtils.$xoCreditBannerUtils;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/faq/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-credit-components/src/choose-credit-offer/faq/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {
    squid.module('xo-faq.directive', ['squid', 'xomodel.checkout']).directive('xoFaq', function () {
        return {
            template: template
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ChooseCreditOfferRoute = undefined;

__webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ChooseCreditOfferRoute = exports.$ChooseCreditOfferRoute = _squid.$ComponentRoute.extend('$ChooseCreditOfferRoute', {

    path: 'chooseCreditOffer',
    directive: 'xo-choose-credit-offer',
    titleContent: 'chooseCreditOffer.choose',
    query: [
    // This param is sent from external pages (ie. checkout lite) to indicate that the user started the transaction
    // already and that it's safe to retrieve the session. Session is needed to decide where to route after the
    // CYCO page is complete.
    'populateSession'],
    trackingData: {
        fptiState: 'choose_credit_offer',
        buzname: {
            fullpage: {
                pagename: '%::choose_credit_offer',
                pagename2: '%::choose_credit_offer:member:hermes:',
                version: 'member:%:'
            }
        }
    },
    auth: false,
    children: []
});

angular.value("$ChooseCreditOfferRoute", $ChooseCreditOfferRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/choose-credit-offer/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"creditoffer\" id=\"creditoffer\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"trayInner\">\n            <!--Title-->\n            <div ng-if=\"locale.buyerCountry === 'US'\" id=\"title\">\n                <h2 class=\"beta cycoHeader\">{{ content('chooseCreditOption.USOfferHeading')}}</h2>\n                <p class=\"theta mainDescription\"\n                ng-bind-html=\"htmlContent('chooseCreditOption.USOfferDescription', {merchantName: templateVars.merchantName})\"></p>\n            </div>\n\n            <div ng-if=\"locale.buyerCountry === 'GB'\" id=\"title\">\n                <h2 class=\"beta cycoHeader\">{{ content('chooseCreditOption.UKOfferHeading')}}</h2>\n                <p class=\"theta mainDescription\"\n                   ng-bind-html=\"htmlContent('chooseCreditOption.UKOfferDescription', {merchantName: templateVars.merchantName})\"></p>\n            </div>\n\n            <div class=\"sacOfferWrapper\" ng-if=\"showNIOfferOnly\">\n                <div id=\"sacOnlyOffer\" class=\"extendedSacCtaWrap pointer\" ng-click=\"actions.handleRedirect()\">\n                    <div class=\"trayInner\">\n                        <div class = \"extendedOfferContent\">\n                            <p class=\"offerTitle\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.NIOnlyHeading')}}</p>\n                            <p class=\"offerTitle\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferHeading')}}</p>\n                            <p class=\"ukOfferDescription\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.NIOnlyDescription')}}</p>\n                            <p class=\"ukOfferDescription\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferDescription')}}</p>\n                        </div>\n\n                        <div class=\"chooseOffer buttons\">\n                            <input type=\"submit\" value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-class=\"{reverseOrder:locale.buyerCountry === 'GB'}\" ng-if=\"!showNIOfferOnly\">\n                <div class=\"sacOfferWrapper\" ng-if=\"showNoInterestSection\">\n                    <div id=\"sacOffer\" class=\"sacCtaWrap pointer\" ng-class=\"{extended:sacExtended}\"\n                         track-link=\"more_info_sac\" ng-click=\"actions.toggleSacOffer(sacExtended)\">\n                        <div class=\"trayInner\">\n                            <p ng-if=\"!creditOffers.sac_options  && locale.buyerCountry === 'GB'\" class=\"offerTitle\">{{content('chooseCreditOption.UKNoOfferHeading')}}</p>\n                            <p ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'GB'\" class=\"offerTitle\">{{content('chooseCreditOption.UKNIHeading')}}</p>\n                            <p ng-if=\"locale.buyerCountry === 'US'\" class=\"offerTitle\">{{content('chooseCreditOption.USNIHeading')}}</p>\n                            <a link-button class=\"moreInfoLink sacLink\"\n                               ng-class=\"{noMargin:!creditOffers.sac_options}\"\n                               ng-if=\"!sacExtended\">{{ content('chooseCreditOption.moreInfo') }}\n                                <span class=\"frontArrow down\"></span>\n                            </a>\n                            <a link-button class=\"moreInfoLink\"\n                               ng-if=\"sacExtended\"  ng-class=\"{noMargin:!creditOffers.sac_options}\">{{ content('chooseCreditOption.close') }}\n                                <span class=\"frontArrow up\"></span>\n                            </a>\n                            <p ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'GB'\" class=\"offerSmallText\">{{content('chooseCreditOption.UKNIDescription')}}</p>\n                            <p ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'US'\" class=\"offerSmallText\">{{content('chooseCreditOption.USNIDescription')}}</p>\n                        </div>\n                    </div>\n                    <div id=\"extendedSacOffer\" class=\"extendedSacCtaWrap pointer\" ng-if=\"sacExtended\"\n                            ng-click=\"creditOffers.sac_options ? actions.onSelect('SAC') : actions.onSelect('CORE')\">\n                        <div class=\"seeTermsWrap\" ng-if=\"locale.buyerCountry === 'DE'\">\n                            <p class=\"terms\" ng-bind-html=\"htmlContent('chooseCreditOption.seeTermsSAC')\"></p>\n                        </div>\n                        <div class=\"trayInner\">\n                            <div class=\"extendedOfferContent\">\n                                <p class= \"ukOfferDescription\" ng-if=\"!creditOffers.sac_options  && locale.buyerCountry === 'GB'\">{{content('chooseCreditOption.UKNoOfferNote1')}}</p>\n                                <p class= \"ukOfferDescription\" ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'GB'\" ng-bind-html=\"htmlContent('chooseCreditOption.UKNINote1', {minAmount:templateVars.minAmount})\"></p>\n                                <p class= \"ukOfferDescription\" ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'US'\">{{content('chooseCreditOption.USNINote1')}}</p>\n                                <p ng-if=\"locale.buyerCountry !== 'US'\">{{content('chooseCreditOption.sacNote2')}}</p>\n                                <p class=\"terms\" ng-if=\"creditOffers.sac_options && locale.buyerCountry === 'US'\" bind-html-compile=\"htmlContent('chooseCreditOption.USNISeeTerms')\"></p>\n                            </div>\n                            <div class=\"chooseOffer buttons\" ng-if=\"creditOffers.sac_options\">\n                                <input id=\"sacOfferButton\" type=\"submit\" track-submit='choose_sac'\n                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                                <p ng-if=\"locale.buyerCountry === 'DE'\" class=\"smallText\"\n                                   ng-bind-html=\"htmlContent('chooseCreditOption.minimumAmt', {minAmount:templateVars.minAmount})\"></p>\n                            </div>\n                            <div ng-if=\"!creditOffers.sac_options\" class=\"chooseOffer buttons\">\n                                <input id=\"coreOfferButton\" type=\"submit\" track-submit='choose_core'\n                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n\n                <div class=\"installmentOfferWrapper\" ng-if=\"creditOffers.installment_options\">\n                    <div id=\"installmentOffer\" class=\"installmentCtaWrap\"\n                         ng-class=\"{extended: (installmentExtended || installmentSectionExtendedByDefault), pointer: true}\"\n                         track-link=\"more_info_installment\" ng-click=\"actions.toggleInstallmentOffer(installmentExtended)\">\n                        <div class=\"trayInner\">\n                            <p class=\"offerTitle\" ng-if=\"(locale.buyerCountry === 'GB')\" ng-bind-html=\"htmlContent('chooseCreditOption.UKInstallmentHeading', {amount:templateVars.amount})\"></p>\n                            <p class=\"offerTitle\" ng-if=\"(locale.buyerCountry === 'DE')\" ng-bind-html=\"htmlContent('chooseCreditOption.DEInstallmentHeading', {amount:templateVars.amount})\"></p>\n                            <p class=\"offerTitle\" ng-if=\"(locale.buyerCountry === 'US' && !incorrectAPR)\" ng-bind-html=\"htmlContent('chooseCreditOption.USInstallmentHeadingWithAPR', {apr:templateVars.minOfferedAPR})\"></p>\n                            <p class=\"offerTitle\" ng-if=\"(locale.buyerCountry === 'US' && incorrectAPR)\">{{content('chooseCreditOption.USInstallmentHeadingNoAPR')}}</p>\n\n                            <div class=\"expandableLinks\" ng-if=\"!installmentSectionExtendedByDefault\">\n                                <a link-button ng-if=\"installmentCount === 1 && !installmentExtended\"\n                                   class=\"moreInfoLink\">\n                                        {{ content('chooseCreditOption.moreInfo') }}\n                                    <span class=\"frontArrow down\"></span>\n                                </a>\n                                <a link-button ng-if=\"installmentCount > 1 && !installmentExtended\"\n                                   class=\"moreInfoLink\">\n                                        {{ content('chooseCreditOption.seeAllPlans') }}\n                                    <span class=\"frontArrow down\"></span>\n                                </a>\n                                <a link-button class=\"moreInfoLink\"\n                                   ng-if=\"installmentExtended || installmentSectionExtendedByDefault\">\n                                        {{ content('chooseCreditOption.close') }}\n                                    <span class=\"frontArrow up\"></span>\n                                </a>\n                            </div>\n                            <p class=\"offerSmallText\" ng-if=\"(locale.buyerCountry !== 'US')\"\n                               data-ng-bind-html=\"htmlContent(installmentContentKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term , apr: creditOffers.installment_options[installmentCount -1].apr})\"></p>\n                            <p class=\"offerSmallText\" ng-if=\"(locale.buyerCountry === 'US')\">{{content('chooseCreditOption.USInstallmentDescription')}}</p>\n                        </div>\n                    </div>\n                    <div id=\"extendedInstallmentOffer\" class=\"extendedInstallmentCtaWrap\" ng-if=\"installmentExtended || installmentSectionExtendedByDefault\">\n                        <div class=\"seeTermsWrap\" ng-if=\"installmentExtended && locale.buyerCountry !== 'GB' \">\n                            <p class=\"terms\"\n                               ng-bind-html=\"htmlContent('chooseCreditOption.seeTermsInstallment', {seeTermsUrl:templateVars.seeTermsUrl})\"></p>\n                        </div>\n                        <div class=\"row-fluid gceOffers\">\n                            <div class=\"span24\">\n                                <ul class=\"trayInner trayInnerDefault installmentOptionsB row-fluid\">\n                                    <li class=\"offer span6 pointer\" ng-repeat=\"installment in creditOffers.installment_options track by $index\"\n                                        ng-click=\"actions.onSelect($index)\" track-submit='choose_installment'>\n                                        <form>\n                                            <div ng-if=\"(locale.buyerCountry !== 'GB' && locale.buyerCountry !== 'DE')\"class=\"installmentPlanDetails\">\n                                                <ul class=\"subSections\">\n                                                    <li class=\"offerHeading1\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueMonths',{term: installment.term})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valuePerMonth',{ monthlyPayment: installment.monthlyPayment.formattedAmt})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\" ng-bind-html=\"\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueAPR',{apr: installment.apr})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueInterest', { interest: installment.totalInterest.formattedAmt})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueEveryMonth', {term: installment.term})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\">\n                                                        {{content('chooseCreditOption.valueTotalPayment')}}\n                                                    </li>\n                                                    <li class=\"theta\">\n                                                        <strong>{{installment.totalPayment.formattedAmt}}</strong></li>\n                                                    <li class=\"terms\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.seeTerms')\"></li>\n                                                </ul>\n                                            </div>\n                                            <div ng-if=\"(locale.buyerCountry === 'GB' || locale.buyerCountry === 'DE')\" class=\"installmentPlanDetails\">\n                                                <ul class=\"subSections\">\n                                                    <li class=\"offerHeading1\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valuePerMonth',{ monthlyPayment: installment.monthlyPayment.formattedAmt})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueMonths',{term: installment.term})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\" ng-bind-html=\"\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.promotionalRate')\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueAPR',{apr: installment.apr})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.interestRate')\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueInterest', { interest: installment.totalInterest.formattedAmt})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\">\n                                                        {{content('chooseCreditOption.valueTotalPayment')}}\n                                                    </li>\n                                                    <li class=\"theta\">\n                                                        <strong>{{installment.totalPayment.formattedAmt}}</strong></li>\n                                                    <li class=\"terms\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.seeTerms')\"></li>\n                                                </ul>\n                                            </div>\n\n                                            <div class=\"buttons\">\n                                                <input id=\"chooseInstallment\" type=\"submit\" track-submit='choose_installment'\n                                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\"\n                                                       class=\"btn\"/>\n                                                <p ng-if=\"locale.buyerCountry !== 'GB'\" class=\"smallText\"\n                                                   ng-bind-html=\"htmlContent('chooseCreditOption.minimumAmt', {minAmount:installment.minimumAmount})\"></p>\n                                            </div>\n\n                                        </form>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n\n            <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                <!-- US Credit Content -->\n                <p class=\"sameLine payInFullText\" ng-if=\"locale.buyerCountry === 'US'\" ng-bind-html=\"htmlContent('chooseCreditOption.USPayInFullText')\"></p>\n                <a link-button class=\"payInFullLink sameLine\" ng-if=\"locale.buyerCountry === 'US'\" ng-bind-html=\"htmlContent('chooseCreditOption.USPayInFullLink')\"\n                   ng-click=\"actions.showExitSurvey(); actions.redirectToReview();\"></a>\n\n                <!-- UK Credit Content -->\n                <p class=\"sameLine payInFullText\" ng-if=\"locale.buyerCountry === 'GB'\" ng-bind-html=\"htmlContent('chooseCreditOption.UKPayInFullText')\"></p>\n                <a link-button class=\"payInFullLink sameLine\" ng-if=\"locale.buyerCountry === 'GB'\" ng-bind-html=\"htmlContent('chooseCreditOption.UKPayInFullLink')\"\n                   ng-click=\"actions.redirectToReview()\"></a>\n            </div>\n\n            <div id=\"xoCreditExampleUk\" ng-if=\"locale.buyerCountry === 'GB'\">\n                <div class=\"representativeExample\">\n                <div class=\"creditWorks\">\n                <p class=\"creditWorksTitle\">{{content('chooseCreditOption.creditSampleHeader')}}</p>\n                <p class=\"creditWorksDescription\" ng-bind-html=\"htmlContent('chooseCreditOption.creditSamplePara', {minAmount:templateVars.minAmount})\"></p>\n                </div>\n                <p class=\"bmlLender\">{{aprContent.header}}</p>\n                <p class=\"bmlLender representativeExHeader\">{{aprContent.subHeader}}</p>\n                <ul class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n                    <li class=\"span6\">\n                        <p class=\"representativeExKey\">{{aprContent.purchaseRate}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{aprContent.purchaseRateValue}}</p>\n                    </li>\n                    <li class=\"span6\">\n                        <p class=\"representativeExKey\">{{aprContent.APR}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{aprContent.APRValue}}</p>\n                    </li>\n                    <li class=\"span6 last\">\n                        <p class=\"representativeExKey\">{{aprContent.creditLimit}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{aprContent.creditLimitValue}}</p>\n                    </li>\n                </ul>\n\n                <p class=\"faq\" ng-bind-html=\"htmlContent('chooseCreditOption.faqLink')\"></p>\n                </div>\n            </div>\n\n            <xo-faq ng-if=\"locale.buyerCountry === 'DE'\"></xo-faq>\n\n            <div id=\"bmlLender\">\n                <p ng-if=\"!isCreditInWallet && locale.buyerCountry === 'US'\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.USLenderDisclaimerText')}}</p>\n                <p ng-if=\"locale.buyerCountry === 'GB' && creditOffers.installment_options\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.UKLenderDisclaimerTextInst')}}</p>\n                <p ng-if=\"(locale.buyerCountry === 'GB' && !creditOffers.installment_options)\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.UKLenderDisclaimerTextNonInst')}}</p>\n            </div>\n        </div>\n    </div>\n    <div ui-view></div>\n    <div ng-if=\"locale.buyerCountry === 'DE'\" class=\"poweredBy\">\n        <div class=\"text\">{{ content('chooseCreditOption.poweredBy')}}</div>\n        <span class=\"poweredByFooterWrapper\">\n                <span id=\"paypalLogo\" class=\"logo\"></span>\n            </span>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/lib/personalizationManager.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.PERSONALIZATION_PHASES = undefined;
exports.personalizationManager = personalizationManager;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var PERSONALIZATION_PHASES = exports.PERSONALIZATION_PHASES = {
    'SHADOW': 'SHADOW',
    'RAMP': 'RAMP',
    'CONTROL': 'CONTROL',
    'RAMP_NO_FALLBACK': 'RAMP_NO_FALLBACK'
};

/**
 * Calls SSOT for UK flow and MORS/SearchAds for US flows
 * @param token
 * @param models
 * @param contentKeys
 * @returns {*}
 */
function callDefaultServiceAndMapBanner(token, models, contentKeys) {
    if (_squid.$locale.country.toUpperCase() === 'GB') {
        return _xoCreditBannerUtils.$xoCreditBannerUtils.callSsotAndMapBanner(token, models, contentKeys);
    }
}

/**
 * This is a generic manager for personalization.
 * Typically, personalization has 3 phases.
 * CONTROL: Calls and use ONLY banner returned from MORS/searchAds
 * SHADOW: Calls MORS/searchAds && MORS/discoverMessages, compares results and logs differences. But returns banner from MORS/searchAds to use in Hermes
 * RAMP: Calls and use ONLY banner returned from MORS/discoverMessage. If MORS fails, it will proceed to fallback routine (usually `callSsotAndMapBanner`)
 * RAMP_NO_FALLBACK: Same as RAMP, but if MORS call fails, it will not attempt fallback routine to resolve banner content
 * @param {string} phase
 * @param token
 * @param model
 * @param contentKeys
 * @returns {banner}
 */
function personalizationManager(phase, token, models, contentKeys) {
    switch (phase) {
        case PERSONALIZATION_PHASES.SHADOW:
            return _angular.$q.all([callDefaultServiceAndMapBanner(token, models, contentKeys), _xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(token, models)]).then(function (_ref) {
                var originalBanner = _ref[0],
                    discoverMessageBanner = _ref[1].banner;

                _xoCreditBannerUtils.$xoCreditBannerUtils.compareAdObjects(originalBanner, discoverMessageBanner);
                return originalBanner;
            });
        case PERSONALIZATION_PHASES.RAMP:
        case PERSONALIZATION_PHASES.RAMP_NO_FALLBACK:
            return _xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(token, models).then(function (_ref2) {
                var discoverMessageBanner = _ref2.banner;

                if (discoverMessageBanner) {
                    // return banner if it's defined
                    return discoverMessageBanner;
                }

                // US1247972: for UK x-currency, if MORs call fail, do NOT call SSOT and show NO banner
                if (_squid.$locale.country.toUpperCase() === 'GB') {
                    var currencyCode = models.checkoutCart.getCartCurrencyCode();
                    if (currencyCode && currencyCode !== 'GBP') {
                        return _angular.$q.when();
                    }
                }

                if (phase === PERSONALIZATION_PHASES.RAMP_NO_FALLBACK) {
                    // If the caller has specified RAMP_NO_FALLBACK, return here.
                    // No need to attempt the fallback routine to resolve the banner content
                    return _angular.$q.when();
                }

                // else call ssot
                return _xoCreditBannerUtils.$xoCreditBannerUtils.callSsotAndMapBanner(token, models, contentKeys);
            });
        default:
            return callDefaultServiceAndMapBanner(token, models, contentKeys).then(function (banner) {
                return banner;
            });
    }
}

_angular.$q;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var COUNTRY_CODE = exports.COUNTRY_CODE = {
    'GreatBritain': 'GB',
    'UnitedStates': 'US',
    'Germany': 'DE'
};

var CUSTOMER_TYPE = exports.CUSTOMER_TYPE = {
    REUSE: 'REUSE',
    ACQ: 'ACQ'
};

var BANNER_TYPE = exports.BANNER_TYPE = {
    PROMINENT: 'Prominent',
    PASSIVE: 'Passive'
};

var PERSONALIZATION_MESSAGE_PREFIX = exports.PERSONALIZATION_MESSAGE_PREFIX = 'PS-';
var DEFAULT_MESSAGE_PREFIX = exports.DEFAULT_MESSAGE_PREFIX = 'JS-';
var DEFAULT_MESSAGE = exports.DEFAULT_MESSAGE = 'default_banner';
var DEFAULT_MESSAGE_MSGID = exports.DEFAULT_MESSAGE_MSGID = '' + DEFAULT_MESSAGE_PREFIX + DEFAULT_MESSAGE;

var bannerTypes = exports.bannerTypes = {
    'ACQ': 'ACQ', // Standard acquisition banner
    'REUSE': 'REUSE', // Standard reuse banner
    'REUSE_FI': 'REUSE_FI', // Reuse text under PPC FI
    'NONE': 'NONE'
};

var bannerStyle = exports.bannerStyle = {
    'Prominent': 'Prominent'
};

var INSTALLMENT_OPTIONS_SORT = exports.INSTALLMENT_OPTIONS_SORT = {
    APR_ASCE: 'APR_ASCE',
    TERM_DESC: 'TERM_DESC'
};

/***/ }),

/***/ "../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditBannerUtils = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _xoCreditBannerConstants = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/constants.js");

var formatText = function formatText(inputTxt) {
    var amount = /\$\d*\.?\d+/g;
    var htmlTag = /(<([^>]+)>)/ig;
    return inputTxt.replace(amount, '{amount}').replace(htmlTag, '');
};

var buildOfferTextTemplate = function buildOfferTextTemplate(text1, text2) {
    if (angular.isString(text1) && angular.isString(text2)) {
        var t1 = formatText(text1);
        var t2 = formatText(text2);
        if (t1 !== '' && !t1.match(/(!|\.)$/g)) {
            t1 += '.';
        }
        return t1 + ' ' + t2;
    }
    return;
};

var $xoCreditBannerUtils = exports.$xoCreditBannerUtils = {
    getCreditInWallet: function getCreditInWallet(checkoutSession, isBANoPurchase) {
        if (!checkoutSession) {
            return false;
        }

        if (isBANoPurchase) {
            return checkoutSession.get('futurePayment.isCreditInWallet');
        } else {
            var plans = checkoutSession.getPlanList();
            if (plans) {
                return plans.find(function (fi) {
                    return fi && fi.primaryFs && fi.primaryFs.name === 'BILL_ME_LATER';
                });
            } else {
                return false;
            }
        }
    },
    hasThreeMonthInstallments: function hasThreeMonthInstallments(financingCode) {
        var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
        var hasThreeMonthInstallment = Boolean(financingCode.filter(function (value) {
            return threeMonthFinancingCodeArray.includes(value);
        }).length > 0);

        // Throw error if its a three month financing code on old CYCO page
        return hasThreeMonthInstallment ? true : false;
    },
    /**
     * Check to see if PayPal Credit is in wallet
     * If the current transaction is BA without purchase, it looks at checkoutSession.futurePayment.isCreditInWallet
     * Otherwise, it loops through funding options to find BILL_ME_LATER instrument
     * @param checkoutSession
     * @param isBANoPurchase
     * @returns {*}
     */
    isCreditInWallet: function isCreditInWallet(checkoutSession, isBANoPurchase) {
        return this.getCreditInWallet(checkoutSession, isBANoPurchase) ? true : false;
    },
    /**
     * Check if PPC is set as default FI for the transaction
     * For BA-NOP, it checks sticky instrument.
     * For other BA transactions, it looks for future payment instruments
     * For non-BA transactions, it checks funding option instead
     * @param checkoutSession
     * @param isBANoPurchase
     * @returns {*}
     */
    isCreditSelected: function isCreditSelected(checkoutSession, isBANoPurchase) {
        var creditInWallet = this.getCreditInWallet(checkoutSession, isBANoPurchase);

        if (!creditInWallet) {
            return false;
        }

        if (isBANoPurchase) {
            var stickyFI = checkoutSession.getSelectedStickyInstrument();
            return stickyFI.type === 'BILL_ME_LATER';
        } else {
            return creditInWallet.selected;
        }
    },
    /**
     * Call SSOT and return $CreditInstallmentOptionsModel to caller
     * @param token
     * @param payee
     * @param checkoutCart
     * @param checkoutAppData
     * @param silent
     * @returns {*}
     */
    executeSsotCall: function executeSsotCall(token, payee, checkoutCart, checkoutAppData) {
        var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

        var offers = new _index.$CreditInstallmentOptionsModel({
            id: token,
            payee: payee,
            checkoutCart: checkoutCart,
            checkoutAppData: checkoutAppData,
            isMemberCredit: true
        });

        return offers.save({
            silent: silent,
            cache: true,
            success: function success(result) {
                _logger.$logger.info('xo-credit-banner-utils: executeSsotCall succeeded');
                return offers;
            },
            error: function error(err) {
                _logger.$logger.error('xo-credit-banner-utils: executeSsotCall error', { error: err });
                return;
            },
            contingencies: {
                DEFAULT: function DEFAULT() {
                    _logger.$logger.info('xo-credit-banner-utils: executeSsotCall: GET_INSTALLMENT_CONTINGENCY');
                }
            }
        });
    },
    /**
     * Constructs the application context to be used in the executeMorsDiscoverMessageCall()
     * @param models
     * @returns Array of Object {name, value}
     */
    getApplicationContext: function getApplicationContext(models) {
        var applicationContext = [{
            name: 'transaction_amount',
            value: (models.checkoutCart.get('purchase.amounts.total.amount', 0) * 100).toFixed(0)
        }, {
            name: 'transaction_currency',
            value: models.checkoutCart.get('purchase.amounts.total.currency_code', '')
        }, {
            name: 'ppc_in_wallet',
            value: this.isCreditInWallet(models.checkoutSession, models.checkoutCart.isBillingNoPurchase())
        }, {
            name: 'ppc_default_fi',
            value: models.checkoutSession.get('plan.paypal_credit')
        }, {
            name: 'is_mobile',
            value: _index3.$DeviceInfo.isDevice()
        }, {
            name: 'installments_not_allowed',
            value: models.checkoutCart.isBilling()
        }, {
            name: 'is_ba_rt_no_purchase',
            value: models.checkoutCart.isBillingNoPurchase() && !models.checkoutCart.get('purchase.amounts.total.currency_code', '')
        }, {
            name: 'source_id',
            value: 'HERMESNODEWEB'
        }, {
            name: 'merchantId',
            value: models.payee.get('merchant.id')
        }];
        var ppcConversionInfo = models.checkoutSession.getPPCconversionInfo();
        if (ppcConversionInfo) {
            var ppcConversionRate = {
                name: 'currency_conversion_rate',
                value: ppcConversionInfo.to_amount
            };
            applicationContext.push(ppcConversionRate);
        }
        return applicationContext;
    },
    /**
     * Verify if the purchaseAmount is eligible for CORE offer
     * @param purchaseAmount
     * @returns {boolean}
     */
    isEligibleForCORE: function isEligibleForCORE(purchaseAmount) {
        var threshold = _checkout.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country];

        _logger.$logger.info('$xoCreditBannerUtils: purchaseAmount: ' + purchaseAmount + ', threshold: ' + threshold);

        return purchaseAmount < threshold;
    },

    /**
     * Calls $renderContent with all content keys for banner
     * Put all the dynamic content needs to be swapped out from bodyText or bodyText2 into props
     * @param keys
     * @param props
     * @returns {{ctaText: *, logo: *, bodyText: *, bodyText2: *, termsLink: *}}
     */
    renderContentByKey: function renderContentByKey(keys) {
        var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!keys) {
            return {};
        }
        return Object.assign({
            ctaText: (0, _squid.$renderContent)(keys.ctaText),
            logo: keys.logo,
            bodyText: (0, _squid.$renderContent)(keys.bodyText, props),
            bodyText2: (0, _squid.$renderContent)(keys.bodyText2, props),
            termsLink: keys.termsLink,
            termsText: (0, _squid.$renderContent)(keys.termsText, props),
            termsLinkText: (0, _squid.$renderContent)(keys.termsLinkText),
            statusText: (0, _squid.$renderContent)(keys.statusText).toString(),
            messageId: _xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID
        }, props);
    },

    /**
     *
     * Call SSOT and map SSOT response to a banner object
     * @param token
     * @param models
     * @returns {*}
        */
    callSsotAndMapBanner: function callSsotAndMapBanner(token, models, targetContentKey) {
        var _this = this;

        if (!token || !models.payee || !models.checkoutCart || !models.checkoutAppData || !models.checkoutSession || !targetContentKey) {
            _logger.$logger.error('$xoCreditBannerUtils callSsotAndMapBanner(): Invalid models arguement passed in');
            return _angular.$q.when();
        }

        var isBillingNoPurchase = models.checkoutCart.isBillingNoPurchase();
        var isReuse = this.isCreditInWallet(models.checkoutSession, isBillingNoPurchase);

        if (isBillingNoPurchase) {
            // Use CORE content if is billing agreement without purchase
            _logger.$logger.info('$xoCreditBannerUtils callSsotAndMapBanner(): BA-NOP, use CORE banner');
            return _angular.$q.when().then(function () {
                var model = _this.renderContentByKey(targetContentKey.core);
                model.offerType = _constants.CREDIT_TYPE.CORE;
                return model;
            });
        } else {
            return this.executeSsotCall(token, models.payee, models.checkoutCart, models.checkoutAppData).then(function (creditInstallmentOptionsModel) {

                var formattedCartAmount = models.checkoutCart.get('purchase.amounts.total.amount_formatted');
                var props = { cartAmount: formattedCartAmount };
                var model = void 0;

                if (!creditInstallmentOptionsModel) {
                    _logger.$logger.info('$xoCreditBannerUtils callSsotAndMapGBBanner(): No offer received from SSOT');
                    return _angular.$q.when().then(function () {
                        // If SSOT fails we want banner content for acq & reuse US and only UK reuse
                        if (_squid.$locale.country.toUpperCase() === 'GB' && isReuse || _squid.$locale.country.toUpperCase() === 'US') {
                            if (_squid.$locale.country.toUpperCase() === 'GB') {
                                props = {
                                    amount: models.checkoutCart.getPurchaseAmount()
                                };
                            }
                            if (_this.isEligibleForCORE(models.checkoutCart.getPurchaseAmount())) {
                                _logger.$logger.info('$xoCreditBannerUtils: CORE Offer');
                                model = _this.renderContentByKey(targetContentKey.core, props);
                                model.offerType = _constants.CREDIT_TYPE.CORE;
                                return model;
                            } else {
                                _logger.$logger.info('$xoCreditBannerUtils: NI Offer');
                                model = _this.renderContentByKey(targetContentKey.ni, props);
                                model.offerType = _constants.CREDIT_TYPE.NI;
                                return model;
                            }
                        }
                        return;
                    });
                }

                if (creditInstallmentOptionsModel.getInstallmentOptionsPresent()) {
                    _logger.$logger.info('$xoCreditBannerUtils callSsotAndMapBanner(): INST Offer');
                    var creditSharedInfoModel = _index.$CreditSharedInfoModel.instance();
                    creditSharedInfoModel.setInstallmentOfferPresent(true);

                    var installmentOffer = _squid.$locale.country.toUpperCase() === 'GB' ? creditInstallmentOptionsModel.getInstallmentOffers(_xoCreditBannerConstants.INSTALLMENT_OPTIONS_SORT.TERM_DESC) : creditInstallmentOptionsModel.getInstallmentOffers(_xoCreditBannerConstants.INSTALLMENT_OPTIONS_SORT.APR_ASCE);

                    if (_squid.$locale.country.toUpperCase() === 'GB') {
                        var monthly = installmentOffer.monthlyPayment && installmentOffer.monthlyPayment.formattedAmt;
                        var term = installmentOffer.term;
                        props = {
                            monthlyPayment: monthly,
                            term: term
                        };
                    }

                    if (_squid.$locale.country.toUpperCase() === 'DE') {
                        var cartAmount = models.checkoutCart.get('purchase.amounts.total.amount');
                        var cartAmountCurrency = models.checkoutCart.get('purchase.amounts.total.currency_code');
                        props = {
                            cartAmount: cartAmount,
                            cartCurrency: cartAmountCurrency,
                            financingCode: installmentOffer.financingCode,
                            apr: installmentOffer.apr,
                            nominalRate: installmentOffer.nominalRate,
                            ssotType: installmentOffer.creditType,
                            totalDue: installmentOffer.totalPayment.value,
                            totalDueCurrencyCode: installmentOffer.monthlyPayment.currency,
                            totalInterest: installmentOffer.totalInterest.value,
                            totalInterestCurrencyCode: installmentOffer.monthlyPayment.currency,
                            term: installmentOffer.term,
                            monthlyPayment: installmentOffer.monthlyPayment.value,
                            monthlyPaymentCurrencyCode: installmentOffer.monthlyPayment.currency,
                            totalInterestFormatted: installmentOffer.totalInterest.formattedAmt,
                            monthlyPercentageRate: installmentOffer.monthlyPercentageRate,
                            paypalSubsidy: installmentOffer.paypalSubsidy
                        };
                        creditSharedInfoModel.setInstallmentOffer(props);
                        creditSharedInfoModel.setInstallmentOfferFinancingDetails({
                            financing_code: installmentOffer.financingCode,
                            apr: installmentOffer.apr,
                            nominal_rate: installmentOffer.nominalRate,
                            credit_type: installmentOffer.creditType,
                            total_cost: installmentOffer.totalPayment.value,
                            total_interest: installmentOffer.totalInterest.value,
                            term: installmentOffer.term,
                            monthly_payment: installmentOffer.monthlyPayment.value,
                            currency: installmentOffer.monthlyPayment.currency,
                            monthly_percentage_rate: installmentOffer.monthlyPercentageRate,
                            paypal_subsidy: installmentOffer.paypalSubsidy
                        });
                    }

                    model = _this.renderContentByKey(targetContentKey.installment, props);
                    model.offerType = _constants.CREDIT_TYPE.INST;

                    if (_squid.$locale.country.toUpperCase() === 'US') {
                        // grab financing code for US search for 3M and update content
                        var installmentArray = creditInstallmentOptionsModel.getInstallmentOffers().installment_options;
                        var creditofferDetails = installmentArray.map(function (item) {
                            return item.financingCode;
                        });
                        var hasThreeMonthInstallment = _this.hasThreeMonthInstallments(creditofferDetails);
                        props = {
                            monthlyPayment: installmentOffer.monthlyPayment.formattedAmt
                        };
                        if (hasThreeMonthInstallment) {
                            model = _this.renderContentByKey(targetContentKey.threeMonthInst, props);
                            model.offerType = _constants.CREDIT_TYPE.INST;
                            model.hasThreeMonthOffer = true;
                        }
                    }
                    return model;
                } else if (creditInstallmentOptionsModel.getNiOfferPresent()) {
                    _logger.$logger.info('$xoCreditBannerUtils: NI Offer');
                    model = _this.renderContentByKey(targetContentKey.ni, props);
                    model.offerType = _constants.CREDIT_TYPE.NI;
                    return model;
                } else {
                    // if we don't see any (either EZP or NI) offer from SSOT, it's always CORE
                    _logger.$logger.info('$xoCreditBannerUtils: CORE Offer');
                    model = _this.renderContentByKey(targetContentKey.core, props);
                    model.offerType = _constants.CREDIT_TYPE.CORE;
                    return model;
                }
            });
        }
    },
    /**
     * Build Credit Offer FPTI Object
     * @param token
     * @param banner
     * @returns {*}
     */
    buildCreditOfferFptiObject: function buildCreditOfferFptiObject(token, banner) {
        var isSecondButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isReturnFromCape = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


        var Device = '';

        if (!_index3.$DeviceInfo.isDevice()) {
            Device = 'Desktop';
        } else if (_index3.$DeviceInfo.isTablet()) {
            Device = 'Tablet';
        } else {
            Device = 'Mobile';
        }
        var defaultValues = {
            'buyer_country': _squid.$locale.country,
            'locale': _squid.$locale.lang,
            'context_id': token,
            'context_type': 'EC-Token',
            'device_type': Device,
            'from': 'PERSONALIZATION',
            'to': 'PERSONALIZATION_CREDIT',
            'banner_type': banner.presentmentStyle + '-' + banner.presentmentType,
            'ppc_button_y_n': isSecondButton,
            'ppc_app_interaction': isReturnFromCape ? 'isReturnFromCape' : ''
        };
        var mapBannerToFptiProperties = {
            'visaActive': 'visa_active',
            'merchantUpstreamPresentment': 'merchant_presented_banner',
            'product': 'product_identifier',
            'offerCategory': 'offer_category',
            'offerType': 'credit_offer_type',
            // offerText1 and bodyText are mapped to the same FPTI attribute intentionally for backward compatibility
            // Should use bodyText during US refactor
            'offerText1': 'credit_offer_text',
            'bodyText': 'credit_offer_text',
            'offerTextTemplate': 'credit_offer_text',
            'incentiveOfferProgramId': 'incentive_offer_program_id',
            'incentiveOfferValue': 'incentive_offer_value',
            'propensity': 'model_propensity',
            'approvability': 'credit_user_approvability',
            'campaignId': 'caid',
            'currencyConversionRate': 'fx_conversion_to',
            'cartCurrency': 'currency_conversion_to_currency',
            'merchantListingCurrency': 'currency_conversion_from_currency',
            'cartAmount': 'currency_conversion_to_amount',
            'banner_suppression_type': 'banner_suppression_type',
            'payerId': 'sndr_payer_id'
        };
        var queryValues = {};

        for (var key in mapBannerToFptiProperties) {
            if (banner[key] !== null && typeof banner[key] !== 'undefined') {
                queryValues[mapBannerToFptiProperties[key]] = banner[key];
            }
        }

        var creditSharedInfo = _index.$CreditSharedInfoModel.instance();
        queryValues.funding_instrument_count = creditSharedInfo.getFiCount();
        queryValues.cart_show_amt = creditSharedInfo.getCartAmountVisible();

        return Object.assign({}, defaultValues, queryValues);
    },
    /**
     * Create root transaction for PS monitoring
     * @param message
     * @param banner
     * @param err
     * @param bannerType
     * @returns {*}
     */
    buildPSMonitoringObject: function buildPSMonitoringObject(token, message, banner, err) {
        var psMonitorObject = { token: token };
        psMonitorObject.m_chnl = 'Desktop';
        if (_index3.$DeviceInfo.isDevice()) {
            psMonitorObject.m_chnl = _index3.$DeviceInfo.isTablet() ? 'Tablet' : 'Mobile';
        }
        if (err) {
            psMonitorObject.m_err = err;
        } else {
            psMonitorObject.msgClass = message.presentmentStyle + '_' + message.presentmentType;
            psMonitorObject.message = message.offerType;
            psMonitorObject.m_udf1 = message.offerCategory;
            psMonitorObject.m_udf2 = message.visaActive;
            psMonitorObject.m_udf3 = message.merchantUpstreamPresentment;
            psMonitorObject.m_inptype = !!message.incentiveOfferProgramId;
        }
        if (banner) {
            psMonitorObject.m_prod_type = banner.showPassiveBanner;
            psMonitorObject.m_trdtype = !!banner.incentives;
            psMonitorObject.m_event = banner.offerType;
        }
        return psMonitorObject;
    },
    /**
     * Collect fallback banner info for FPTI logging when MORs call failed and SSOT call success
     * @param ssot_banner
     * @param isReuse
     * @returns {*}
     */
    collectFallbackBannerInfo: function collectFallbackBannerInfo(banner, isReuse, isProminent) {
        banner = banner || {};
        var resObj = {
            presentmentType: 'Banner',
            product: 'PPC',
            banner_suppression_type: 'default_banner',
            offerCategory: isReuse ? 'REUSE' : 'ACQ',
            presentmentStyle: isProminent ? _xoCreditBannerConstants.BANNER_TYPE.PROMINENT : _xoCreditBannerConstants.BANNER_TYPE.PASSIVE,
            offerType: banner.offerType,
            payerId: banner.payerId
        };
        var text1 = void 0,
            text2 = void 0;
        if (isReuse) {
            text1 = banner.bodyText && banner.bodyText.toSafeString();
            text2 = banner.bodyText2 && banner.bodyText2.toSafeString();
        } else {
            text1 = banner.ctaText && banner.ctaText.toSafeString();
            text2 = banner.bodyText && banner.bodyText.toSafeString();
        }
        resObj.offerTextTemplate = buildOfferTextTemplate(text1, text2);
        return resObj;
    },
    /**
     * Calculating number of funding instruments
     * FI count is used in FPTI logs after calling MORS/DiscoverMessage for both US and UK
     * @param models
     * @returns {number}
     */
    getFiCount: function getFiCount(checkoutSessionModel, isBillingNoPurchase) {
        var fundingInstruments = void 0;
        var isBalanceCoveringPurchase = false;

        if (!isBillingNoPurchase) {
            var plans = checkoutSessionModel.get('fundingOptions.plans');
            isBalanceCoveringPurchase = plans && plans.find(function (fi) {
                return fi && fi.primaryFs && !fi.secondaryFIs && fi.primaryFs.name === 'BALANCE';
            });
            fundingInstruments = checkoutSessionModel.get('fundingOptions.instruments');
        } else {
            fundingInstruments = checkoutSessionModel.get('futurePaymentInstruments');
        }

        var fiApplicableForThisTransaction = 0;

        if (fundingInstruments && fundingInstruments.length > 0) {
            fundingInstruments.forEach(function (fundingOption, index) {
                if (fundingOption.type !== 'BALANCE' || isBalanceCoveringPurchase) {
                    fiApplicableForThisTransaction++;
                }
            });
        }
        return fiApplicableForThisTransaction;
    },
    /**
     * Call MORS' /message-recommendation endpoint and return $CreditOfferModel to caller
     * @param token
     * @param models
     * @param silent
     * @returns $CreditOfferModel
     */
    executeMorsDiscoverMessagesCall: function executeMorsDiscoverMessagesCall(token, models, silent) {
        var application_context = this.getApplicationContext(models);

        var creditOfferModel = new _index2.$CreditOfferModel({
            id: token,
            locale: _squid.$locale,
            payer: models.checkoutSession.payer.id || '',
            payee: models.payee.merchant.id || '',
            touchpoint: 'PPC_HERMES_RYI',
            message_count: 10,
            application_context: application_context,
            MorsError: null
        });

        return creditOfferModel.save({
            silent: silent,
            cache: true,
            params: creditOfferModel.getCacheKey(),
            data: creditOfferModel.serialize(),
            success: function success(result) {
                _logger.$logger.info('xo-credit-banner-utils: executeMorsDiscoverMessagesCall Success');
                return creditOfferModel;
            },
            error: function error(_error) {
                _logger.$logger.error('xo-credit-banner-utils: executeMorsDiscoverMessagesCall Fail', { error: _error });
                creditOfferModel.MorsError = 'MORS_error_' + _error.message;
                return creditOfferModel;
            },
            contingencies: {
                DEFAULT: function DEFAULT(name) {
                    _logger.$logger.error('xo-credit-banner-utils: executeMorsDiscoverMessagesCall contingency', { contingency: name });
                    creditOfferModel.MorsError = 'MORS_contingency_' + name;
                    return creditOfferModel;
                }
            }
        });
    },
    /**
     * Call /message-recommendations & map the response to a banner object
     * @param token
     * @param models
     * @returns {*}
     */
    callDiscoverMessagesAndMapToBanner: function callDiscoverMessagesAndMapToBanner(token, models) {
        var _this2 = this;

        if (!token || !models.payee || !models.checkoutCart || !models.checkoutSession) {
            _logger.$logger.error('$xoCreditBannerUtils callDiscoverMessagesAndMapToBanner(): Invalid models arguement passed in');
            return _angular.$q.when();
        }

        return this.executeMorsDiscoverMessagesCall(token, models, true).then(function (creditOfferModel) {
            var banner = void 0,
                morsErr = void 0;
            if (creditOfferModel.hasBannerMessage()) {
                banner = {};
                var morsBanner = creditOfferModel.getBannerMessage().content.json;
                // Map to banner fields
                banner.messageId = '' + _xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX + morsBanner.MessageDescription;
                banner.ctaText = morsBanner.CTAText;
                banner.logo = morsBanner.Logo;
                banner.bodyText = morsBanner.OfferText1;
                banner.bodyText2 = morsBanner.OfferText2;
                banner.termsLink = morsBanner.TermsLink; // US only
                banner.termsLinkText = morsBanner.TermsLinkText; // US only
                banner.termsText = morsBanner.TermsText; // US only
                banner.termsText2 = morsBanner.TermsText2;
                banner.headlineText = morsBanner.HeadlineText; // US
                banner.or = 'or'; // for seperator Prominent US banner
                banner.cartAmount = morsBanner.CartAmount;
                banner.cartCurrency = morsBanner.CartAmountCurrencyCode;
                banner.offerCategory = morsBanner.OfferCategory;
                banner.offerType = morsBanner.OfferType;
                banner.product = morsBanner.Product;
                banner.presentmentStyle = morsBanner.PresentmentStyle;
                banner.presentmentType = morsBanner.PresentmentType;
                banner.campaignId = creditOfferModel.getBannerMessage().id;
                banner.financingCode = morsBanner.FinancingCode;
                banner.apr = morsBanner.Apr;
                banner.term = morsBanner.Term;
                banner.nominalRate = morsBanner.NominalInterestRate;
                banner.monthlyPayment = morsBanner.MonthlyPayment;
                banner.monthlyPaymentCurrencyCode = morsBanner.MonthlyPaymentCurrencyCode;
                banner.totalDue = morsBanner.TotalDue;
                banner.totalDueCurrencyCode = morsBanner.TotalDueCurrencyCode;
                banner.totalInterest = morsBanner.TotalInterest;
                banner.totalInterestCurrencyCode = morsBanner.TotalInterestCurrencyCode;
                banner.ssotType = morsBanner.SsotType;
                banner.statusText = morsBanner.StatusText;
                banner.taglineText = morsBanner.TaglineText;
                banner.visaActive = morsBanner.VisaActive; // US only
                banner.merchantUpstreamPresentment = morsBanner.MerchantUpstreamPresentment; // for FPTI log only
                banner.approvability = morsBanner.Approvability; // for FPTI log only
                banner.monthlyPercentageRate = morsBanner.MonthlyPercentageRate;
                banner.paypalSubsidy = morsBanner.PayPalSubsidy === 'true';
                banner.formattedInterestAmount = morsBanner.FormattedInterestAmount;
                banner.formattedMonthlyPayment = morsBanner.FormattedMonthlyPayment;
                banner.formattedTotalAmount = morsBanner.FormattedTotalAmount;
                banner.formattedCartAmount = morsBanner.FormattedCartAmount;

                if (morsBanner['Incentive-OfferProgramId']) {
                    banner.incentivesOffer = true;
                    banner.incentiveOfferProgramId = morsBanner['Incentive-OfferProgramId'];
                    banner.incentiveOfferValue = morsBanner['Incentive-OfferValue'];
                    banner.incentiveOfferCurrencyCode = morsBanner['Incentive-OfferCurrencyCode'];
                    banner.incentiveOfferProgramCode = morsBanner['Incentive-OfferProgramCode'];
                }

                if (morsBanner.CrossCurrencyTransaction === 'true' && morsBanner.CurrencyConversionRate && models.checkoutCart.get('purchase.amounts.total.currency_code')) {
                    banner.crossCurrencyTransaction = true;
                    banner.currencyConversionRate = morsBanner.CurrencyConversionRate;
                    banner.toTargetCurrency = morsBanner.CurrencyConversionRate + ' ' + models.checkoutCart.purchase.amounts.total.currency_code;
                    banner.fromUnitCurrency = '1 ' + morsBanner.CartAmountCurrencyCode;
                    banner.merchantListingCurrency = models.checkoutCart.purchase.amounts.total.currency_code;
                }

                // Address US1226988
                if (morsBanner.OfferType === 'EZP' || morsBanner.OfferType === 'PALA') {
                    _logger.$logger.info('$xoCreditBannerUtils callDiscoverMessagesAndMapToBanner(): EZP Offer');
                    var creditSharedInfoModel = _index.$CreditSharedInfoModel.instance();
                    creditSharedInfoModel.setInstallmentOffer(banner);
                    creditSharedInfoModel.setInstallmentOfferFinancingDetails({
                        financing_code: banner.financingCode,
                        apr: banner.apr,
                        nominal_rate: banner.nominalRate,
                        credit_type: banner.ssotType,
                        total_cost: banner.totalDue,
                        total_interest: banner.totalInterest,
                        term: banner.term,
                        monthly_payment: banner.monthlyPayment,
                        currency: banner.monthlyPaymentCurrencyCode,
                        monthly_percentage_rate: banner.monthlyPercentageRate,
                        paypal_subsidy: banner.paypalSubsidy
                    });
                    creditSharedInfoModel.setInstallmentOfferPresent(true);
                }

                // Banner color experiment
                if (morsBanner.BackgroundType && morsBanner.BackgroundParams) {
                    banner.bannerColorObj = _this2.bannerColorExp(morsBanner.BackgroundType, morsBanner.BackgroundParams);
                }

                banner.buyItemId = creditOfferModel.getBannerMessage().id;
                banner.cachePlacementCode = '210004';
                banner.placementCode = creditOfferModel.getTouchpointCode();
                banner.HeadlineText = morsBanner.HeadlineText;
                banner.OfferText1 = morsBanner.OfferText1;
                banner.OfferText2 = morsBanner.OfferText2;
                banner.TermsLink = morsBanner.TermsLink;
                banner.TermsText = morsBanner.TermsText;
                banner.TermsLinkText = morsBanner.TermsLinkText;
                banner.PPCinWallet = _this2.isCreditInWallet(models.checkoutSession, models.checkoutCart.isBillingNoPurchase());
            } else {
                morsErr = creditOfferModel.MorsError || 'MORS_empty_message';
            }
            return { banner: banner, morsErr: morsErr };
        });
    },
    /**
     * Compares the equivalency of banner objects `base` & `compare`
     * @param base
     * @param compare
     * @returns Object {expected, actual}
     */
    compareAdObjects: function compareAdObjects(base, compare) {
        _logger.$logger.info('Comparing ad objects', { base_ad: base, recommended_message: compare });
        var diff = [];
        var keysToIgnore = ['campaignId', 'buyItemId', 'placementCode', 'impressionUrl', 'clickUrl', 'client_elapsed', 'req_elapsed', 'messageId'];

        if (!base) {
            diff.push('base_ad is not present');
        } else if (!compare) {
            diff.push('recommended_message is not present');
        } else {
            Object.keys(base).forEach(function (key) {
                if (keysToIgnore.indexOf(key) === -1) {
                    if (!compare[key]) {
                        if (base[key].toString().length > 0) {
                            diff.push({
                                key: key,
                                expected: base[key].toString(),
                                actual: undefined
                            });
                        }
                    } else if (compare[key].toString() !== base[key].toString()) {
                        diff.push({
                            key: key,
                            expected: base[key].toString(),
                            actual: compare[key].toString()
                        });
                    }
                }
            });
        }

        if (diff.length !== 0) {
            _logger.$logger.warn('recommended_message_warning', diff);
        }
    },

    /**
     * Experiment of banner color
     * @param backgroundType
     * @param backgroundParams
     * @returns {*}
     */
    bannerColorExp: function bannerColorExp(backgroundType, backgroundParams) {
        var bannerColorObj = void 0;
        if (backgroundType === 'flat') {
            bannerColorObj = {
                'background': '' + backgroundParams.trim()
            };
        }
        return bannerColorObj;
    }
};

angular.value("$xoCreditBannerUtils", $xoCreditBannerUtils);
_angular.$q;

_logger.$logger;

_squid.$locale;

_squid.$renderContent;

_squid.$feature;

_index.$CreditSharedInfoModel;

_index.$CreditInstallmentOptionsModel;

_index2.$CreditOfferModel;

_checkout.$CreditOptionsModel;

_index3.$DeviceInfo;

_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX;

_xoCreditBannerConstants.BANNER_TYPE;

_xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID;

_xoCreditBannerConstants.INSTALLMENT_OPTIONS_SORT;

_constants.CREDIT_TYPE;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/pay-with-credit/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/pay-with-credit/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoPayWithCredit', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=?',
            doneFn: '=?'
        },
        controller: ['$scope', function ($scope) {
            var stateName = 'gce_pay_with_credit';

            (0, _squid.$populate)($scope, {
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                // For US and GB if txn amount is >= 99 or 150 resp show pay with credit option if credit in
                // wallet and is not the current funding option

                // required to avoid looging every digest cycle.
                // TODO: remove this when debounce is fixed for logger
                var offerShown = false;

                $scope.showPayWithCredit = function () {
                    if (!$scope.checkoutCart.get('purchase.amounts.total.amount')) {
                        offerShown = false;
                        return false;
                    }

                    var amount = parseFloat($scope.checkoutCart.purchase.amounts.total.amount);
                    var minAmount = _angular.$window.config.minCreditAmtNoInterest[_squid.$locale.country];
                    var hasCredit = $scope.checkoutSession.fundingOptions.hasCredit();
                    var fundingSource = $scope.checkoutSession.plan.sources;
                    var showOffer = _squid.$config.features.DEFAULT.showPayWithCreditOffer && !$scope.checkoutSession.plccOffer;

                    if (showOffer && minAmount && amount >= minAmount && hasCredit) {
                        for (var i in fundingSource) {
                            if (fundingSource[i].type === 'BILL_ME_LATER') {
                                offerShown = false;
                                return false;
                            }
                        }
                        if (!offerShown) {
                            _logger.$logger.info(stateName + '_offer_shown');
                        }
                        offerShown = true;
                        return true;
                    }
                    offerShown = false;
                    return false;
                };

                $scope.onSubmit = function () {
                    _logger.$logger.info(stateName + '_offer_clicked');
                    $scope.checkoutSession.message = null;

                    var instruments = $scope.checkoutSession && $scope.checkoutSession.fundingOptions && $scope.checkoutSession.fundingOptions.instruments;
                    var creditPlanId = void 0;

                    for (var i in instruments) {
                        if (instruments[i].type === 'CREDIT' && instruments[i].name === 'BILL_ME_LATER') {
                            creditPlanId = instruments[i].planId;
                        }
                    }

                    if (!creditPlanId) {
                        _logger.$logger.info(stateName + '_credit_planid_not_found');
                        return;
                    }

                    return $scope.checkoutSession.fundingOptions.action('select', {
                        resultModel: $scope.checkoutSession,
                        data: {
                            planId: creditPlanId
                        },
                        success: function success() {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                            _logger.$logger.info(stateName + '_success');
                        }
                    });
                };
            });
        }]
    };
});

_angular.$window;

_logger.$logger;

_squid.$config;

_squid.$locale;

_squid.$populate;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/pay-with-credit/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"pay-with-credit\" class=\"bmlCtaWrap\" ng-if=\"showPayWithCredit()\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div class=\"decreasedWidth noBottom\">\n            <p>{{ content('memberReview.switchToBml') }}</p>\n            <span class=\"disclaimer\" bind-html-compile=\"htmlContent('offers.seeBmlTerms')\"></span>\n        </div>\n        <a href=\"\" track-submit class=\"button-as-link edits\" ng-click=\"onSubmit()\">{{ content('common.select') }}</a>\n    </div>\n</div>\t"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/redirect-to-cape/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/redirect-to-cape/template.html");

var _template2 = _interopRequireDefault(_template);

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Consider all available query params for
 * base return url
 *
 * @param {*} url
 * @param {*} token
 * @returns
 */
var getReturnUrl = function getReturnUrl(url, token) {
    var params = _squid.$util.params();
    params = _squid.$util.extend(params, { token: token });
    return _squid.$util.buildURL(url, params);
};

/**
 * Include redirect_uri logic for cancel url
 *
 * @param {*} url
 * @param {*} token
 * @returns
 */
var getCancelUrl = function getCancelUrl(url, token) {
    var redirectUri = _squid.$util.param('redirect_uri');

    // "redirect_uri" as a query param overrides the cancel url in the checkout session
    if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && redirectUri) {

        return _squid.$util.buildURL(redirectUri, {
            opType: 'cancel',
            return_uri: url,
            token: token
        });
    }
    return url;
};

exports['default'] = _squid.$Component.extend('$xoRedirectToCapeDirective', {
    tag: 'xo-redirect-to-cape',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutCart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        experiments: function experiments(resolvers) {
            return resolvers.models.then(function (models) {
                var isOneTouchTreatment = function isOneTouchTreatment() {
                    if (models.auth.remembered) {
                        return (0, _squid.$elmo)('xo_us_ppc_onetouch', {
                            'ctx.COUNTRY': _squid.$locale.country
                        }, 'Trmt_xo_us_ppc_onetouch_.*', false, true).then(function (result) {
                            if (result && result.treatment_name) {
                                return result.treatment_name === 'Trmt_xo_us_ppc_onetouch_1';
                            } else {
                                return false;
                            }
                        });
                    }
                };

                return {
                    isOneTouchTreatment: isOneTouchTreatment()
                };
            });
        },
        checkoutLiteDeInstallmentsCheck: function checkoutLiteDeInstallmentsCheck(_ref) {
            var _this = this;

            var models = _ref.models;


            // Check if they came from Checkout Lite for DE installments.
            if (_squid.$locale.country !== 'DE' || !_squid.$util.param('fromLite')) {
                _logger.$logger.info('xolite_de_installments_check_not_DE_eligible');
                return;
            }
            return models.then(function (_ref2) {
                var auth = _ref2.auth,
                    checkoutCart = _ref2.checkoutCart,
                    checkoutPayee = _ref2.checkoutPayee,
                    checkoutAppData = _ref2.checkoutAppData;

                // This is a safety precaution. If not logged in, the checkout session call and the ssot call will probably not succeed.
                if (!auth.logged_in) {
                    _logger.$logger.info('xolite_de_installments_skip_no_auth');
                    return;
                }

                _logger.$logger.info('xolite_de_installments_check_running');
                var checkoutSession = _index3.$CheckoutSessionModel.instance(_this.props.token);
                return checkoutSession.retrieve().then(function () {
                    return _xoCreditBannerUtils.$xoCreditBannerUtils.callSsotAndMapBanner(_this.props.token, {
                        checkoutSession: checkoutSession,
                        checkoutCart: checkoutCart,
                        checkoutAppData: checkoutAppData,
                        payee: checkoutPayee
                    }, _constants.deContentKeys.acq).then(function (ad) {
                        if (ad) {
                            var financing_option_details = {
                                credit_type: ad.ssotType,
                                financing_code: ad.financingCode,
                                apr: ad.apr,
                                term: ad.term,
                                total_cost: ad.totalDue,
                                total_interest: ad.totalInterest,
                                monthly_payment: ad.monthlyPayment,
                                currency: ad.monthlyPaymentCurrencyCode,
                                nominal_rate: ad.nominalRate,
                                monthly_percentage_rate: ad.monthlyPercentageRate,
                                paypal_subsidy: ad.paypalSubsidy
                            };
                            _uiRouter.$stateParams.financing_option = financing_option_details;
                            return ad;
                        } else {
                            // what to do if ssot call fails?
                            return;
                        }
                    });
                });
            })['catch'](function (err) {
                _logger.$logger.warn('xolite_de_installments_check_failed', { error: err });
                return;
            });
        },


        // When falling back from Checkout Lite, the user may have seen an incentive offer, which is decided by MORS.
        // Incentives information needs to be passed along to CAPE through a mayfly payload, so here we call MORS if we detect that the user came from Checkout Lite.
        incentivesCheck: function incentivesCheck(_ref3) {
            var _this2 = this;

            var models = _ref3.models;

            var isSecondButtonFullPay = _squid.$util.param('fullPay') === 'true';
            var isSecondButtonPaylaterFromLite = _squid.$Class.get(window, 'xprops.originFundingSource') === 'paylater' && _squid.$util.param('fromLite');

            return models.then(function (_ref4) {
                var auth = _ref4.auth,
                    checkoutCart = _ref4.checkoutCart,
                    checkoutPayee = _ref4.checkoutPayee,
                    checkoutAppData = _ref4.checkoutAppData;

                // This is a safety precaution. If not logged in, the checkout session call and the MORS call will probably not succeed.
                if (!auth.logged_in) {
                    _logger.$logger.info('xolite_incentives_skip_no_auth');
                    return;
                }

                // Don't pass incentives if 2ndBtn and user did not cancel-back to RYI and user is not in GPL-2ndBtn/XO-Lite
                if (checkoutAppData.isSecondButton() && !isSecondButtonFullPay && !isSecondButtonPaylaterFromLite) {
                    _logger.$logger.info('xolite_incentives_skip_when_second_button_txn');
                    return;
                }

                _logger.$logger.info('xolite_incentives_check_running');

                // common method to retrieve incentive offer message details from MORS
                var xolite_incentives_check_mors_call_handler = function xolite_incentives_check_mors_call_handler(mors_models) {
                    return _xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(_this2.props.token, mors_models).then(function (_ref5) {
                        var result = _ref5.banner;

                        _angular.$rootScope.MORS = {};
                        // Result is read from the MORS object on rootscope in the lifecycle.populate function of this directive.
                        _angular.$rootScope.MORS[result.cacheId] = result;
                        return result;
                    });
                };

                var checkoutSession = _index3.$CheckoutSessionModel.instance(_this2.props.token);
                return checkoutSession.retrieve().then(function () {
                    return xolite_incentives_check_mors_call_handler({
                        checkoutSession: checkoutSession,
                        payee: checkoutPayee,
                        checkoutCart: checkoutCart
                    });
                })['catch'](function (err) {
                    if (err && err.message === 'NEED_CREDIT_CARD') {
                        // as we are only interested in the data contained in the xo-session to build the MORS
                        // request, we can safely ignore the 'NEED_CREDIT_CARD' contingency error that is being
                        // returned when user has no valid credit-cards in wallet;
                        // we will retrieve the xo-session data from the model instance itself and we will continue
                        // retrieving the incentive offer message details from MORS
                        _logger.$logger.warn('xolite_incentives_check_override_caught_error');
                        return xolite_incentives_check_mors_call_handler({
                            checkoutSession: checkoutSession,
                            payee: checkoutPayee,
                            checkoutCart: checkoutCart
                        });
                    } else {
                        throw err;
                    }
                });
            })['catch'](function (err) {
                _logger.$logger.warn('xolite_incentives_check_failed', { error: err });
                return;
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this3 = this;

            // eslint-disable-line max-statements
            var navigation = window.performance && window.performance.navigation || {};
            if (navigation.type === 2) {
                _logger.$logger.info('CAPE_redirect_on_history_traversal');
            }

            var checkoutSession = _index3.$CheckoutSessionModel.instance(this.props.token);
            var isPPCReuse = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditInWallet(checkoutSession, this.models.checkoutCart.isBillingNoPurchase());
            var isOnetouchULRedirect = this.models.auth.isOnetouchULRedirect();

            _logger.$logger.info('redirectToCape', { isOneTouchTreatment: this.experiments.isOneTouchTreatment, isPPCReuse: isPPCReuse, isOnetouchULRedirect: isOnetouchULRedirect, isRemembered: this.models.auth.remembered, isLoggedIn: this.models.auth.logged_in });
            if (this.models.auth.remembered && (!isPPCReuse || isOnetouchULRedirect)) {
                _logger.$logger.info('redirectToCape: go checkout.login');
                return this.models.auth.redirectToLogin('insufficientPermission', { ulClientKey: 'payWithPayPalCredit' });
            }
            _logger.$logger.info('redirectToCape: continue to CAPE');

            function getMORSCreditIncentiveCampaign(MORSCampaigns) {
                var creditIncentiveCampaign = null;

                Object.keys(MORSCampaigns).forEach(function (key) {
                    // A "credit incentive" campaign is one that contains
                    // the "incentiveOfferProgramId" property
                    if (MORSCampaigns[key] && MORSCampaigns[key].hasOwnProperty('incentiveOfferProgramId')) {
                        creditIncentiveCampaign = MORSCampaigns[key];
                    }
                });
                return creditIncentiveCampaign;
            }

            function createAuditData(creditIncentiveCampaign) {
                // As per credit.CommonComponentsSpecification/v2/credit_incentive_offer_info.json
                // specification
                var messages = [{
                    'credit_incentive_offer_descriptor': 'PID-' + creditIncentiveCampaign.placementCode,
                    'credit_incentive_offer_value': creditIncentiveCampaign.buyItemId
                }];

                // If there is an incentiveOfferProgramCode that comes back from MORS,
                // add it to the list of messages
                // (In addition to the PID-<placementCode> item)

                if (creditIncentiveCampaign.incentiveOfferProgramCode) {
                    messages.push({
                        'credit_incentive_offer_descriptor': 'incentive_offer_program_code',
                        'credit_incentive_offer_value': creditIncentiveCampaign.incentiveOfferProgramCode
                    });
                }

                return {
                    'credit_incentive_offer_messages': messages
                };
            }

            function createCreditIncentiveContextData(creditIncentiveCampaign) {
                return {
                    incentive_offer_program_id: creditIncentiveCampaign.incentiveOfferProgramId,
                    incentive_offer_value: creditIncentiveCampaign.incentiveOfferValue,
                    incentive_offer_currency_code: creditIncentiveCampaign.incentiveOfferCurrencyCode,
                    headline_text: creditIncentiveCampaign.headlineText,
                    offer_text_1: creditIncentiveCampaign.bodyText,
                    offer_text_2: creditIncentiveCampaign.bodyText2,
                    terms_link: creditIncentiveCampaign.termsLink,
                    terms_link_text: creditIncentiveCampaign.termsLinkText,
                    terms_text: creditIncentiveCampaign.termsText,
                    buy_item_id: creditIncentiveCampaign.campaignId,
                    audit_data: createAuditData(creditIncentiveCampaign)
                };
            }
            this.creditDataModel = _index2.$CreditDataModel.instance(this.props.token || _angular.$rootScope.token);
            var url = 'https://' + window.location.host + _squid.$config.urls.baseUrl;
            var returnUrl = getReturnUrl(url, this.props.token);
            var transactionType = this.models.checkoutAppData.is_second_button_txn ? 'SECOND_BUTTON' : 'HERMES';
            var isSignupFlow = this.models.auth.logged_in ? 'false' : 'true';
            var isRP = this.models.checkoutCart.get('billing.type') === 'RECURRING_PAYMENTS';
            var trafficSourceContent = '';
            var pageContext = 'Full-context';
            var flow = this.models.checkoutAppData.is_second_button_txn ? 'CHECKOUT_CREDIT_BUTTON' : 'CHECKOUT';
            this.buyerCountry = _squid.$locale.country.toUpperCase();
            this.currencyCode = this.models.checkoutCart.getCartCurrencyCode();
            var fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
            var fundingSource = fundingInstruments && _squid.$util.find(fundingInstruments, function (fi) {
                return fi.name === 'BILL_ME_LATER';
            });
            if (_angular.$rootScope.miniBrowser) {
                pageContext = 'Mb-context';
            } else if (_angular.$rootScope.isIFrame) {
                pageContext = 'In-context';
            }

            if (this.models.checkoutCart.isBillingNoPurchase()) {
                if (isRP) {
                    trafficSourceContent = 'BA_RP_WITHOUT_PURCHASE';
                } else {
                    trafficSourceContent = 'BA_RT_WITHOUT_PURCHASE';
                }
            } else if (this.models.checkoutCart.isBillingPurchase()) {
                if (isRP) {
                    trafficSourceContent = 'BA_RP_WITH_PURCHASE';
                } else {
                    trafficSourceContent = 'BA_RT_WITH_PURCHASE';
                }
            }

            var clientMetadataID = void 0;

            if (window.xprops && window.xprops.clientMetadataID) {
                clientMetadataID = window.xprops.clientMetadataID;
            } else if (_squid.$util.param('client-metadata-id')) {
                clientMetadataID = _squid.$util.param('client-metadata-id');
            } else {
                clientMetadataID = this.props.token;
            }

            var merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country');
            var capeData = {
                'flow_attributes': {
                    'channel': _index.$DeviceInfo.isMobile() ? 'MOBILE' : 'WEB',
                    'flow': flow,
                    'primary_actor': 'PAYPAL',
                    'tracking_id': this.props.token,
                    'business_case_variation': transactionType,
                    'credit_application_traffic_source': trafficSourceContent
                },
                'locale': _squid.$locale.lang + '_' + _squid.$locale.country,
                'cart_id': this.props.token,
                'fraudnet_id': clientMetadataID,
                'context-type': pageContext,
                'cal_correlation_id': _model.$CalDataModel.getCalCorrId(),
                // LU merchant will not be considered cross border for eBay-RM - fix to hide installments unavailable banner in CAPE acq
                'is_cross_border_with_installments': this.creditDataModel.isCrossBorder() && this.creditDataModel.hasSelectedCYCOOffer() && merchantCountry !== 'LU',
                'return_uris': {
                    'normal_return_uri': returnUrl + '&success=true',
                    'system_error_uri': returnUrl + '&success=false&isInternalServiceError=true',
                    'return_to_login_uri': returnUrl,
                    'full_pay_uri': this.models.auth.logged_in ? returnUrl + '&success=false&fullPay=true' : undefined,
                    'cancel_uri': getCancelUrl(this.models.checkoutAppData.urls.cancel_url, this.props.token),
                    'change_installments_uri': returnUrl + '&changeStatus=changeInstallment&creditSignup=' + isSignupFlow
                },
                'installment_count': this.creditDataModel.getInstallmentCount(),
                'show_cyco': _uiRouter.$stateParams && _uiRouter.$stateParams.showCapeCyco,
                'is_reuse': isPPCReuse,
                'financial_instrument_id': isPPCReuse ? fundingSource.id : ''
            };

            if (_uiRouter.$stateParams && _uiRouter.$stateParams.financing_option) {
                capeData.financing_option = _uiRouter.$stateParams.financing_option;
            }

            if (this.$root.MORS) {
                // There are MORS campaigns
                // Check to see if there are any "credit incentive" campaigns
                // which we need to notify CAPE of
                var creditIncentiveCampaign = getMORSCreditIncentiveCampaign(this.$root.MORS);

                if (creditIncentiveCampaign) {
                    capeData.credit_incentive = createCreditIncentiveContextData(creditIncentiveCampaign);
                }
            }

            return (0, _angular.$q)(function (resolve, reject) {
                var secondButtonCrossBorder = _this3.models.checkoutAppData.is_second_button_txn && _this3.creditDataModel.isCrossBorder();
                // To support ChecoutLite fallback, we need to check wehther $CreditDataModel.getCartAmountAndCurrency()
                // has the cart_acmount & cart_currency.
                var isGBCrossCurrency = _this3.buyerCountry === 'GB' && _this3.currencyCode !== 'GBP' && !_this3.creditDataModel.getCartAmountAndCurrency();

                if (!secondButtonCrossBorder && !isGBCrossCurrency) {
                    return resolve();
                }

                // Second Button / Cross Border
                var offers = new _index2.$CreditInstallmentOptionsModel({
                    id: _this3.props.token,
                    payee: _this3.models.checkoutPayee,
                    checkoutCart: _this3.models.checkoutCart,
                    checkoutAppData: _this3.models.checkoutAppData,
                    isMemberCredit: true
                });

                offers.save({
                    cache: false,
                    success: function success(result) {
                        capeData.installment_count = offers.getInstallmentCount();

                        if (result && result.conversion_info && result.conversion_info.converted_transaction_amount) {
                            _logger.$logger.info('redirectToCape: Setting Cross Country cart_amount and cart_currency');
                            _this3.creditDataModel.setCartAmountAndCurrency({
                                cart_amount: result.conversion_info.converted_transaction_amount.value,
                                cart_currency: result.conversion_info.converted_transaction_amount.currency_code
                            });
                        }

                        return resolve();
                    },
                    error: function error(_error) {
                        _logger.$logger.info('redirectToCape: ssot call returned error: ' + _error);
                        return reject(_error);
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('redirectToCape: ssot call returned contingency: ' + name);
                            return reject(err);
                        }
                    }
                });
            }).then(function () {
                Object.assign(capeData, _this3.creditDataModel.getCartAmountAndCurrency());
                var data = {
                    creditData: capeData,
                    newUserSignup: isSignupFlow
                };

                return _this3.creditDataModel.action('createCreditKey', {
                    data: data,
                    success: function success(res) {
                        var useMerchantCountry = false;

                        // For 2nd button and non-logged-in users -
                        // use the merchant_country as the flow when redirecting to CAPE
                        if (!_this3.models.auth.logged_in && _this3.models.checkoutAppData.is_second_button_txn) {
                            // If merchant country is unsupported, fallback to the buyer country (which in turn falls back to US)
                            if (!merchantCountry || _squid.$config.creditEligibleCountries.indexOf(merchantCountry) === -1) {
                                _logger.$logger.info('CAPE_use_buyer_country=' + _squid.$locale.country + ', for_locale_country=' + _squid.$locale.country + ', for_locale_lang=' + _squid.$locale.lang);
                            } else {
                                useMerchantCountry = true;
                                _logger.$logger.info('CAPE_use_merchant_country=' + merchantCountry + ', for_locale_country=' + _squid.$locale.country + ', for_locale_lang=' + _squid.$locale.lang);
                            }
                        }

                        var capeUrl = (0, _squid.$feature)('capeUrl', undefined, useMerchantCountry && merchantCountry) + res.capeKey + '&token=' + _this3.props.token;

                        if (_this3.creditDataModel.isChangeStatus()) {
                            capeUrl += '&status=changeInstallment';
                        }

                        var sdkMeta = _squid.$util.param('sdkMeta');
                        if (sdkMeta) {
                            capeUrl += '&sdkMeta=' + sdkMeta;
                        }

                        _this3.creditDataModel.setCapeRedirectUri(capeUrl);

                        var purchaseUnits = _this3.models.checkoutCart && _this3.models.checkoutCart.purchaseUnits;
                        var purchaseUnit = _angular2['default'].isArray(purchaseUnits) && purchaseUnits[0];
                        var currency = purchaseUnit && purchaseUnit.amount && purchaseUnit.amount.currency;

                        _logger.$logger.info('CAPE_locale_logging', {
                            brand_name: _this3.models.checkoutAppData.get('merchant.brand_name'),
                            merchant_id: _this3.models.checkoutPayee.getId(),
                            merchant_country: merchantCountry,
                            merchant_locale: _this3.models.checkoutAppData.get('merchant.merchant_locale'),
                            merchant_display_id: _this3.models.checkoutAppData.get('merchant.merchant_display_id'),
                            currency: currency,
                            user_locale: _squid.$locale.getLocaleCode()
                        });

                        _squid.$util.redirect(capeUrl, { replace: true });
                    }
                });
            });
        }
    }
});


_logger.$logger;

_auth.$AuthModel;

_model.$CalDataModel;

_index.$DeviceInfo;

_index2.$CreditDataModel;

_index2.$CreditInstallmentOptionsModel;

_squid.$Class;

_squid.$Component;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$feature;

_squid.$integration;

_squid.$elmo;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutSessionModel;

_uiRouter.$stateParams;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_constants.deContentKeys;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/redirect-to-cape/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$RedirectToCapeRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/redirect-to-cape/directive.js");

var $RedirectToCapeRoute = exports.$RedirectToCapeRoute = _squid.$ComponentRoute.extend('$RedirectToCapeRoute', {
    path: 'redirectToCape',
    directive: 'xo-redirect-to-cape',
    titleContent: 'redirectToCape',
    params: {
        financing_option: null,
        showCapeCyco: false
    },
    trackingData: {
        fptiState: 'redirect-to-cape',
        buzname: {
            'fullpage': {
                'pagename': '%::redirect-to-cape',
                'pagename2': '%::redirect-to-cape:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: false,
    auth: false,
    children: []
});

angular.value("$RedirectToCapeRoute", $RedirectToCapeRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/redirect-to-cape/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"capeRedirect\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/constants.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.deOfferEligibleCartAmount = exports.deContentKeys = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var domain = _squid.$meta.domain,
    cdnHost = _squid.$meta.cdnHost;
var deContentKeys = exports.deContentKeys = {
    reuse: {
        installment: {
            logo: 'https://' + cdnHost + '/webstatic/credit/img/pp-ratenzahlung-logo.png',
            bodyText: 'offers.deReuseBodyText',
            bodyText2: 'offers.deReuseBodyText2',
            termsText: 'offers.deReuseTermsText'
        }
    },
    acq: {
        installment: {
            logo: 'https://' + cdnHost + '/webstatic/credit/img/pp-ratenzahlung-logo.png',
            bodyText: 'offers.deBodyText',
            bodyText2: 'offers.deBodyText2',
            termsText: 'offers.deTermsText',
            termsLinkText: 'offers.deTermsLinkText',
            termsLink: 'https://www.' + domain + '/ppclander',
            statusText: 'offers.deStatusText'
        }
    }
};

var deOfferEligibleCartAmount = exports.deOfferEligibleCartAmount = {
    min: 99,
    max: 5000,
    currency: 'EUR'
};

_squid.$meta;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditOfferDEBanner = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _xoCreditBannerConstants = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _personalizationManager = __webpack_require__("../node_modules/xo-credit-components/src/lib/personalizationManager.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/styles.less");

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCreditOfferDEBanner = exports.$xoCreditOfferDEBanner = _squid.$Component.extend('$xoCreditOfferDEBanner', {
    tag: 'xo-credit-offer-de-banners',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        reusetext: {
            type: 'var',
            required: false
        },
        radio: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                creditSharedInfo: _index2.$CreditSharedInfoModel.instance()
            };
        },
        experiments: function experiments(resolvers) {}
    },
    actions: {
        clickTooltip: function clickTooltip(event) {
            // prevent click event on tooltip
            event.preventDefault();
        },
        handleModalClick: function handleModalClick(event) {
            // if click anywhere else except X button on modal, do nothing
            if (event.target.className !== 'close ng-scope') {
                event.preventDefault();
            }
        },
        closeModal: function closeModal() {
            this.showModal = false;
        },
        openModal: function openModal() {
            this.showModal = true;
        },
        selectAcqBml: function selectAcqBml() {
            var financing_option_details = {
                credit_type: this.banner.ssotType,
                financing_code: this.banner.financingCode,
                apr: this.banner.apr,
                term: this.banner.term,
                total_cost: this.banner.totalDue,
                monthly_payment: this.banner.monthlyPayment,
                currency: this.banner.monthlyPaymentCurrencyCode,
                nominal_rate: this.banner.nominalRate
            };
            return _uiRouter.$state.go('checkout.redirectToCape', { financing_option: financing_option_details });
        }
    },
    lifecycle: {
        enter: function enter() {
            // putting bannerTypes into scope so we can use bannerTypes.REUSE or bannerTypes.ACQ in template.html
            this.bannerTypes = _xoCreditBannerConstants.bannerTypes;
            this.displayBannerType = null;
        },
        populate: function populate() {
            var _this = this;

            var self = this;
            self.models.creditData = _index2.$CreditDataModel.instance(this.props.token);
            var isBillingNoPurchase = self.models.checkoutCart.isBillingNoPurchase();
            var isReuse = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditInWallet(self.models.checkoutSession, isBillingNoPurchase);
            var contentKeys = isReuse ? _constants.deContentKeys.reuse : _constants.deContentKeys.acq;
            var isSecondButton = self.models.checkoutAppData.isSecondButton();
            var creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
            var isCapeReturnKey = creditDataModel && creditDataModel.getCapeKey();

            var processBanner = function processBanner(banner) {
                if (banner) {
                    // use whatever banner returned from personalizationManager
                    self.banner = banner;

                    // stick cartAmount and cartCurrency into creditData so it's passed to CAPE
                    if (banner.cartAmount && banner.cartCurrency) {
                        self.models.creditData.setCartAmountAndCurrency({
                            cart_amount: banner.cartAmount,
                            cart_currency: banner.cartCurrency
                        });
                    }
                    // Send FPTI log
                    if (banner.messageId && !self.models.creditSharedInfo.getMorsFptiFiredFlag()) {
                        if (banner.messageId.indexOf(_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX) === 0) {
                            _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(self.props.token, banner, isSecondButton, isCapeReturnKey));
                        }

                        // Send FPTI log if the banner is from ssot and it's not already sent
                        if (banner.messageId.indexOf(_xoCreditBannerConstants.DEFAULT_MESSAGE_PREFIX) === 0) {
                            var bodyText = banner.bodyText;
                            var bodyText2 = banner.bodyText2;
                            var presentmentStyle = _xoCreditBannerConstants.bannerStyle.Prominent;
                            var presentmentType = isReuse ? _xoCreditBannerConstants.bannerTypes.REUSE : _xoCreditBannerConstants.bannerTypes.ACQ;
                            var bannerMessage = Object.assign({}, banner, { 'bodyText': bodyText + bodyText2 }, { 'banner_suppression_type': _xoCreditBannerConstants.DEFAULT_MESSAGE }, { 'presentmentStyle': presentmentStyle }, { 'presentmentType': presentmentType });
                            _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(_this.props.token, bannerMessage, isSecondButton, isCapeReturnKey));
                        }
                        self.models.creditSharedInfo.setMorsFptiFiredFlag(true);
                    }

                    if (self.props.reusetext) {
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.REUSE_FI;
                    } else {
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.ACQ;
                        self.bannerColor = self.banner.bannerColorObj;
                    }
                } else {
                    self.displayBannerType = _xoCreditBannerConstants.bannerTypes.NONE;
                }
            };

            this.$watch('models.checkoutCart.grossTotalAmount', function () {
                if (self.banner) {
                    (0, _personalizationManager.personalizationManager)(_personalizationManager.PERSONALIZATION_PHASES.RAMP_NO_FALLBACK, self.props.token, self.models, contentKeys).then(function (banner) {
                        processBanner(banner);
                    });
                }
            });

            (0, _personalizationManager.personalizationManager)(_personalizationManager.PERSONALIZATION_PHASES.RAMP_NO_FALLBACK, self.props.token, self.models, contentKeys).then(function (banner) {
                processBanner(banner);
            });
        }
    }
});

angular.value("$xoCreditOfferDEBanner", $xoCreditOfferDEBanner);
_angular.noop;

_auth.$AuthModel;

_squid.$Component;

_logger.$logger;

_uiRouter.$state;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_xoCreditBannerConstants.bannerStyle;

_xoCreditBannerConstants.bannerTypes;

_xoCreditBannerConstants.DEFAULT_MESSAGE;

_xoCreditBannerConstants.DEFAULT_MESSAGE_PREFIX;

_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX;

_index2.$CreditSharedInfoModel;

_index2.$CreditDataModel;

_personalizationManager.personalizationManager;

_personalizationManager.PERSONALIZATION_PHASES;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_constants.deContentKeys;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"ppcBannerDE\" content>\n    <input type=\"hidden\" data-test-id=\"ppcBannerDeMessageId\" value=\"{{banner.messageId}}\"/>\n\n    <!-- ACQ Banner-->\n    <div ng-if=\"displayBannerType === bannerTypes.ACQ\"  id=\"bmlAcqOfferInfo\">\n\n        <div ng-if=\"!props.radio\">\n            <a track-click=\"acquisition_offer_banner\" link-button ng-click=\"actions.selectAcqBml()\"\n               class=\"ctaLink\" ng-bind-html=\"banner.ctaText\"\n               data-test-id=\"ppcBannerUkApplyButton\"/>\n        </div>\n\n        <div id=\"installmentOfferT1\" class=\"fiTableLayout\" ng-style=\"bannerColor\">\n            <div class=\"row\">\n                <div class=\"cell\">\n                    <img ng-src=\"{{banner.logo}}\" alt=\"{{banner.logo}}\" />\n                </div>\n                <div class=\"cell contentCell\">\n                    <div class=\"mainOfferText\">\n                        {{banner.bodyText}} <div ng-if=\"banner.statusText && banner.statusText.length > 0\" class=\"statusIndicator\">{{banner.statusText}}</div>\n                    </div>\n                    <div class=\"offerDetails\">\n                        <p class=\"offerText2\">\n                            <span>{{banner.bodyText2}}</span><span id=\"icon\">&nbsp;<a ng-if=\"+banner.apr === 0\" class=\"infoIcon\" href=\"#\" ng-click=\"actions.openModal()\"></a></span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"termsAndConditions\">\n            <span ng-bind-html=\"banner.termsText\"/>\n            <span><a href=\"{{banner.termsLink}}\">{{banner.termsLinkText}}</a></span>\n        </div>\n\n        <xo-modal show=showModal show-close-button=\"true\" on-close=\"actions.closeModal\"  ng-click=\"actions.handleModalClick($event)\">\n            <div class=\"installmentSummary\">\n                <div class=\"summary-header\">\n                    <p ng-bind-html=\"htmlContent('paymentMethod.installmentMonthlyDue',{term: banner.term, monthlyPayment: banner.formattedMonthlyPayment})\"></p>\n                </div>\n                <div class=\"summary-box\">\n                    <p >{{content('paymentMethod.transactionAmount')}}\n                        <a class=\"infoIcon\" href=\"#\" id=\"eMoney\"></a>\n                        <span class=\"float-right\">\n                            {{banner.formattedCartAmount}}\n                        </span></p>\n                    <xo-tooltip trigger=\"#eMoney\" show-event=\"click\" ng-click=\"actions.clickTooltip($event)\">\n                        {{ content('paymentMethod.eMoney') }}\n                    </xo-tooltip>\n                    <p>{{content('paymentMethod.interestAmount')}}\n                        <span class=\"float-right\">\n                            {{banner.formattedInterestAmount}}\n                        </span></p>\n                    <hr />\n                    <p>{{content('paymentMethod.totalAmount')}}\n                        <span class=\"float-right totalAmount\">\n                            {{banner.formattedTotalAmount}}\n                        </span></p>\n                </div>\n                <div class=\"summary-footer\">\n                    <p class=\"lenderText\">{{content('paymentMethod.lednerText')}}</p>\n                    <p>{{content('paymentMethod.installmentAgreement')}}</p>\n                </div>\n            </div>\n        </xo-modal>\n    </div>\n\n    <!-- Reuse text under PPC FI -->\n    <div id=\"bmlReuseOfferInfo\" class=\"reuseTextFI\" ng-if=\"displayBannerType === bannerTypes.REUSE_FI\">\n        <div>{{banner.bodyText}}</div>\n        <div>{{banner.bodyText2}}</div>\n        <div>{{banner.termsText}}</div>\n        <div ng-if=\"banner.termsText2 && banner.termsText2.length > 0\">{{banner.termsText2}}</div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditOffer = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCreditOffer = exports.$xoCreditOffer = _index.$Component.extend('$xoCreditOfferBannersDirective', {
    tag: 'xo-credit-offer-banners',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        reusetext: {
            type: 'var',
            required: false
        },
        radio: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        }
    },
    lifecycle: {
        enter: function enter() {},
        populate: function populate() {
            var self = this;
            self.buyerCountry = _index.$locale.country;
            self.showCreditBanner = false;
            self.models.creditData = _index3.$CreditDataModel.instance(self.props.token);
            self.models.creditSharedInfo = _index3.$CreditSharedInfoModel.instance();

            var isUSCrossCurrency = (self.models.checkoutCart && self.models.checkoutCart.grossTotalAmount && self.models.checkoutCart.get('grossTotalAmount.currency') !== 'USD' && self.buyerCountry === 'US') === true;
            var isReturnFromCape = self.models.creditData && self.models.creditData.getCapeKey() && _index.$util.param('success') === 'true';

            // Hide representative example by default
            self.models.creditSharedInfo.setShowCreditExample(false);

            // Don't show credit banner if it's redirected from CAPE
            // or if it's US Cross Currency
            if (isReturnFromCape && !self.props.reusetext || isUSCrossCurrency) {
                return;
            }

            var isBillingNoPurchase = self.models.checkoutCart.isBillingNoPurchase();
            var isCreditSelected = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditSelected(self.models.checkoutSession, isBillingNoPurchase);
            // FI count is used in FPTI logs after calling MORS/DiscoverMessage for both US and UK
            self.models.creditSharedInfo.setFiCount(_xoCreditBannerUtils.$xoCreditBannerUtils.getFiCount(self.models.checkoutSession, isBillingNoPurchase));

            if (!isCreditSelected || self.props.reusetext) {
                // only show credit banner when PPC is not selected/no PPC
                self.showCreditBanner = true;
            }
        }
    }
});

angular.value("$xoCreditOffer", $xoCreditOffer);
_index.$Component;

_index.$locale;

_index.$util;

_index2.$CheckoutSessionModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index3.$CreditSharedInfoModel;

_index3.$CreditDataModel;

_auth.$AuthModel;

_xoCreditBannerUtils.$xoCreditBannerUtils;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditOfferGBBanner = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _xoCreditBannerConstants = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCreditOfferGBBanner = exports.$xoCreditOfferGBBanner = _squid.$Component.extend('$xoCreditOfferGBBanner', {
    tag: 'xo-credit-offer-gb-banners',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        reusetext: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        experiments: function experiments(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                _this.models.creditData = _index2.$CreditDataModel.instance(_this.props.token);
                _this.models.creditSharedInfo = _index2.$CreditSharedInfoModel.instance();

                var userAction = models.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && models.checkoutCart.get('purchase.items.length', 0) <= 0;
                return {
                    showCartAmount: (0, _pxp.$pxpCartAmt)(models.checkoutAppData.get('merchant.merchant_country'), models.payee.get('merchant.id'), noLineItemDetails, models.checkoutCart.isPurchase()).then(function (showAmount) {
                        models.creditSharedInfo.setCartAmountVisible(showAmount);
                    }),
                    // This will call for the new CYCO experiment
                    redirect_to_cape_cyco: (0, _squid.$elmo)('xo_gb_ppc_cape_cyco', {
                        'ctx.COUNTRY': models.checkoutAppData.get('merchant.merchant_country'),
                        'ctx.merchantID': models.payee.get('merchant.id')
                    }, 'Trmt_xo_gb_ppc_cape_cyco', false, true).then(function (result) {
                        if (result && result.treatment_name) {
                            return true;
                        } else {
                            return false;
                        }
                    })
                };
            });
        }
    },
    actions: {
        selectExistingBml: function selectExistingBml() {
            // This is called on UI when user clicks on "Select" link in reuse banner
            // might be sharable between country flows
            _logger.$logger.info('Select existing BML');
            var self = this;

            // FPTI tracking for when user clicks link for REUSE
            _logger.$logger.info('checkout_fpti', {
                'from': 'clickPPCReuse',
                'to': 'banner_click'
            });

            if (self.models.checkoutCart.isBillingNoPurchase()) {
                // if this is a BA-NOP transaction, set sticky FI and go to review page
                var fpList = self.models.checkoutSession.get('futurePaymentInstruments');
                var ppc = fpList.find(function (fp) {
                    return fp.type === 'BILL_ME_LATER';
                });
                self.models.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: ppc.instrument_id
                    },
                    success: function success(result) {
                        self.showReuseBannerFlag = false;
                        self.models.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                        };
                        _uiRouter.$state.go('checkout.review');
                    }
                });
            } else {
                // Anything other than BA-NOP, we set fundingOption for this transaction and go to the next page
                var _fpList = self.models.checkoutSession.get('fundingOptions.instruments');
                var fundingSource = _fpList.find(function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });

                self.models.checkoutSession.fundingOptions.action('select', {
                    resultModel: self.models.checkoutSession,
                    data: {
                        planId: fundingSource.planId
                    },
                    success: function success(result) {
                        // Do not show PPC banner after user selected PPC
                        self.showReuseBanner = false;

                        if (result) {
                            // Update the installments to support the user selecting a card that does not support installments.
                            self.models.checkoutSession.installments = result.installments;
                        }

                        // If selected fundingSource is CREDIT and there's installment offers present, we go to CYCO
                        if (fundingSource.type === 'CREDIT' && self.models.creditSharedInfo.hasInstallmentOffers()) {
                            if (self.models.creditSharedInfo.getRedirectToCapeCyco()) {
                                _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                            } else {
                                _uiRouter.$state.go('checkout.chooseCreditOffer');
                            }
                        } else {
                            // otherwise, we go to review page
                            if (!fundingSource.selected) {
                                self.models.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
                                };
                                if (self.models.checkoutSession.selectedInstallmentData && !self.models.checkoutSession.selectedInstallmentData.preventChange) {
                                    // Resetting selected installment data, if installment change is not explicitly prohibited.
                                    self.models.checkoutSession.selectedInstallmentData = undefined;
                                }
                            }
                            _uiRouter.$state.go('checkout.review');
                        }
                    }
                });
            }
        },
        selectAcqBml: function selectAcqBml() {
            var self = this;
            // this is called on UI when user clicks on "Apply" link in ACQ banner
            // if installment offers are present, go CYCO.
            // otherwise, go CAPE

            // FPTI tracking for when user clicks link for ACQ
            _logger.$logger.info('checkout_fpti', {
                'from': 'clickPPCAcq',
                'to': 'banner_click'
            });
            if (self.models.creditSharedInfo.hasInstallmentOffers()) {
                // get elmo experiment for 3M or new CYCO experiments
                if (self.models.creditSharedInfo.getRedirectToCapeCyco()) {
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            } else {
                _uiRouter.$state.go('checkout.redirectToCape');
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            // putting bannerTypes into scope so we can use bannerTypes.REUSE or bannerTypes.ACQ in template.html
            this.bannerTypes = _xoCreditBannerConstants.bannerTypes;
            this.displayBannerType = null;
        },
        populate: function populate() {
            var self = this;

            var isBillingNoPurchase = self.models.checkoutCart.isBillingNoPurchase();
            var isReuse = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditInWallet(self.models.checkoutSession, isBillingNoPurchase);
            var isSecondButton = self.models.checkoutAppData.isSecondButton();
            var creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
            var isCapeReturnKey = creditDataModel && creditDataModel.getCapeKey();

            if (self.experiments.redirect_to_cape_cyco) {
                // for the new cyco page in cape, user should go to CAPE based on the treatment value returned through elmo
                self.models.creditSharedInfo.setRedirectToCapeCyco(true);
            }

            self.displayBannerType = undefined;
            // putting bannerTypes into scope so we can use bannerTypes.REUSE or bannerTypes.ACQ in template.html
            self.bannerTypes = _xoCreditBannerConstants.bannerTypes;
            // personalizationManager(self.experiments.gb_personalization, self.props.token, self.models, contentKeys)
            _xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(this.props.token, this.models).then(function (_ref) {
                var banner = _ref.banner;

                if (banner) {
                    // use whatever banner returned from personalizationManager
                    self.banner = banner;

                    // stick cartAmount and cartCurrency into creditData so it's passed to CAPE
                    if (banner.cartAmount && banner.cartCurrency) {
                        self.models.creditData.setCartAmountAndCurrency({
                            cart_amount: banner.cartAmount,
                            cart_currency: banner.cartCurrency
                        });
                    }
                    if (self.props.reusetext) {
                        self.banner.presentmentStyle = 'WALLET';
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.REUSE_FI;
                    } else if (isReuse) {
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.REUSE;
                    } else {
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.ACQ;
                        self.bannerColor = self.banner.bannerColorObj;
                    }

                    // Send FPTI log if the banner is from personalization studio and it's not already sent
                    if (banner.messageId && (banner.messageId.indexOf(_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX) === 0 || banner.messageId.indexOf(_xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID) === 0) && !self.models.creditSharedInfo.getMorsFptiFiredFlag()) {
                        banner.payerId = self.models.checkoutSession.payer.id || '';
                        if (banner.messageId.indexOf(_xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID) === 0) {
                            banner = _xoCreditBannerUtils.$xoCreditBannerUtils.collectFallbackBannerInfo(banner, isReuse, true);
                        }
                        _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(self.props.token, banner, isSecondButton, isCapeReturnKey));
                        self.models.creditSharedInfo.setMorsFptiFiredFlag(true);
                        _logger.$logger.flush();
                    }
                } else {
                    // Address US1226993. But need to be tested
                    self.displayBannerType = _xoCreditBannerConstants.bannerTypes.NONE;
                }

                // show UK credit example whenever we show credit banner
                if (self.displayBannerType !== _xoCreditBannerConstants.bannerTypes.NONE) {
                    self.models.creditSharedInfo.setShowCreditExample(true);
                }
            });
        }
    }
});

angular.value("$xoCreditOfferGBBanner", $xoCreditOfferGBBanner);
_angular.noop;

_logger.$logger;

_uiRouter.$state;

_squid.$Component;

_squid.$elmo;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index2.$CreditSharedInfoModel;

_index2.$CreditDataModel;

_auth.$AuthModel;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX;

_xoCreditBannerConstants.bannerTypes;

_xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID;

_pxp.$pxpCartAmt;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"ppcBannerUK\" content>\n    <input type=\"hidden\" data-test-id=\"ppcBannerUkMessageId\" value=\"{{banner.messageId}}\"/>\n\n    <!-- ACQ Banner-->\n    <div id=\"installmentOfferT1\" class=\"bmlCtaWrap prominentBanner creditBanner purpleBanner\"\n         ng-if=\"displayBannerType === bannerTypes.ACQ\" ng-style=\"bannerColor\">\n        <div class=\"bmlCtaHeader\">\n            <span class=\"prominentBannerIcon\">\n                <img ng-src=\"{{banner.logo}}\" alt=\"{{banner.logo}}\" />\n            </span>\n            <span class=\"bmlApplyLink\">\n                <a track-click=\"acquisition_offer_banner\" link-button ng-click=\"actions.selectAcqBml()\"\n                   class=\"proceed apply_uk_credit\" ng-bind-html=\"banner.ctaText\"\n                   data-test-id=\"ppcBannerUkApplyButton\"/>\n            </span>\n        </div>\n        <p class=\"bmlAcqOfferTitle bannerLine\" ng-bind-html=\"banner.bodyText\"/>\n        <p class=\"bmlAcqOfferText bannerLine\" ng-bind-html=\"banner.bodyText2\"/>\n    </div>\n\n    <!-- Conversion info for banner - only show for ACQ -->\n    <div class=\"conversion\" data-test-id=\"ppcBannerCrossCurrencyRate\" ng-if=\"displayBannerType === bannerTypes.ACQ && banner.crossCurrencyTransaction\">\n        <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n        <span class=\"conversionRate\">&nbsp;{{content('paymentMethod.conversionRate', {currencyFrom: banner.fromUnitCurrency, currencyTo: banner.toTargetCurrency})}}</span>\n    </div>\n\n    <!-- Reuse banner -->\n    <div id=\"bmlExistingOffer\" class=\"bmlCtaWrap prominentBanner creditBanner\" ng-if=\"displayBannerType === bannerTypes.REUSE\">\n        <div class=\"bmlCtaHeader\">\n            <span class=\"prominentBannerIcon\">\n                <img ng-src=\"{{banner.logo}}\" alt=\"{{banner.logo}}\" />\n            </span>\n\n            <span class=\"bmlChangeLink bmlChangeLinkInBanner\">\n                <a track-link=\"reuse_offer_banner\" link-button ng-click=\"actions.selectExistingBml()\" class=\"proceed\" ng-bind-html=\"banner.ctaText\" />\n            </span>\n        </div>\n\n        <p class=\"bmlExistingOfferTitle bannerLine\" ng-bind-html=\"banner.bodyText\" />\n        <p class=\"bmlExistingOfferText bannerLine\" ng-bind-html=\"banner.bodyText2\" />\n    </div>\n\n    <!-- Reuse text under PPC FI -->\n    <div id=\"bmlReuseOfferInfo\" ng-if=\"displayBannerType === bannerTypes.REUSE_FI\">\n        <span class=\"offerInfo ng-binding ng-scope\" ng-bind-html=\"banner.bodyText2\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCreditExampleUkDirective', {
    tag: 'xo-credit-example-uk',
    template: _template2['default'],
    resolve: {
        experiments: function experiments() {
            var returnValue = {};

            return returnValue;
        }
    },
    lifecycle: {
        populate: function populate() {
            this.aprContent = _squid.$config.representativeExampleGB;
        }
    }
});


_squid.$Component;

_squid.$config;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"xoCreditExampleUk\" action=\"#\" method=\"POST\" >\n    <div class=\"representativeExample\">\n        <p class=\"disclaimer reviewMsg bmlLender\">{{aprContent.header}}</p>\n        <p class=\"disclaimer reviewMsg bmlLender\">{{aprContent.subHeader}}</p>\n        <table class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n            <tr class=\"span6\">\n                <td class=\"representativeExKey\">{{aprContent.purchaseRate}}</td>\n                <td class=\"representativeExampleAPRAmount\">{{aprContent.purchaseRateValue}}</td>\n            </tr>\n            <tr class=\"span6\">\n                <td class=\"representativeExKey\">{{aprContent.APR}}</td>\n                <td class=\"representativeExampleAPRAmount\">{{aprContent.APRValue}}</td>\n            </tr>\n            <tr class=\"span6 last\">\n                <td class=\"representativeExKey\">{{aprContent.creditLimit}}</td>\n                <td class=\"representativeExampleAPRAmount\">{{aprContent.creditLimitValue}}</td>\n            </tr>\n        </table>\n        <p class=\"disclaimer reviewMsg bmlLender\">{{aprContent.terms}}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"xoCreditOfferBanners\" ng-if=\"showCreditBanner\">\n    <div ng-if=\"buyerCountry === 'GB'\">\n        <xo-credit-offer-gb-banners token=\"token\" reusetext=\"reusetext\" />\n    </div>\n    <div ng-if=\"buyerCountry === 'DE'\">\n        <xo-credit-offer-de-banners token=\"token\" reusetext=\"reusetext\" radio=\"radio\"/>\n    </div>\n    <div ng-if=\"buyerCountry === 'US'\">\n        <xo-credit-offer-us-banners token=\"token\" reusetext=\"reusetext\"/>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/constants.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.usContentKeys = exports.reuseRadioBannerContent = exports.RYI_OR = exports.CREDIT_TYPE = exports.US_TERMS = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var domain = _squid.$meta.domain;
var US_TERMS = exports.US_TERMS = {
    acq: 'https://www.' + domain + '/ppclander',
    reuse: 'https://www.' + domain + '/ppclander',
    ezpTerms: 'https://www.' + domain + '/us/webapps/mpp/credit-easy-payments?country=US&mid=H7EV58FZX96U6&sign=3UGhAgFlRIVa7Pw-EJTs9g'
};

var CREDIT_TYPE = exports.CREDIT_TYPE = {
    CORE: 'CORE',
    NI: 'NI',
    INST: 'PALA',
    BA: 'BA'
};

var RYI_OR = exports.RYI_OR = 'or';

var reuseRadioBannerContent = exports.reuseRadioBannerContent = {

    // No purchase or 0 cart amount flow
    NoP: {
        bodyText: 'offers.assetLite.bmlExistingOfferAmountZeroDetails',
        termsLink: US_TERMS.reuse,
        termsLinkText: 'offers.seeTermsText'

    },
    CORE: {
        bodyText: 'offers.assetLite.bmlExistingOfferSmallDetails',
        termsLink: US_TERMS.reuse,
        termsLinkText: 'offers.seeTermsText'
    },
    BA: {
        bodyText: 'offers.assetLite.bmlExistingOfferSmallDetails',
        termsLink: US_TERMS.reuse,
        termsLinkText: 'offers.seeTermsText'
    },
    NI: {
        bodyText: 'offers.assetLite.bmlExistingOfferLargeDetails',
        termsLink: US_TERMS.reuse,
        termsLinkText: 'offers.seeTermsText'
    },
    INST: {
        bodyText: 'offers.assetLite.bmlExistingOfferEZPDetails',
        ctaText: 'offers.assetLite.cycoOfferBtn'
    },
    THREEMONTHINSTCORE: {
        bodyText: 'offers.assetLite.bmlExistingOfferthreeMonthEZPDetails',
        ctaText: 'offers.assetLite.cycoOffersThreeMonthCoreBtn'
    },
    THREEMONTHINSTNI: {
        bodyText: 'offers.assetLite.bmlExistingOfferthreeMonthEZPDetails',
        ctaText: 'offers.assetLite.cycoOfferBtn'
    },
    THREEMONTHINSTRETURN: {
        bodyText: 'offers.assetLite.bmlReturnOfferthreeMonthEZPDetails'
    }
};

var usContentKeys = exports.usContentKeys = {
    reuse: {
        core: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.bmlExistingOfferSmall',
            ctaText: 'offers.bmlOfferReuseCta',
            termsLinkText: 'offers.seeTermsText',
            termsLink: US_TERMS.reuse
        },
        ba_nop: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.bmlExistingOfferSmallDetails',
            ctaText: 'offers.bmlOfferReuseCta',
            termsLinkText: 'offers.seeTermsText',
            termsLink: US_TERMS.reuse
        },
        ni: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.bmlExistingOfferLarge',
            ctaText: 'offers.bmlOfferReuseCta',
            termsLinkText: 'offers.seeTermsText',
            termsLink: US_TERMS.reuse
        },
        installment: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.bmlExistingOfferEZP',
            ctaText: 'offers.assetLite.cycoOfferBtn',
            termsLink: US_TERMS.ezpTerms
        },
        threeMonthInst: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.threeMonthINSTDetails',
            ctaText: 'offers.assetLite.cycoOfferBtn',
            termsLink: US_TERMS.ezpTerms
        }
    },
    acq: {
        core: {
            bodyText2: 'offers.assetLite.bmlOfferPassiveDetails',
            bodyText: 'offers.bmlOfferPassiveCta',
            termsText: 'offers.subjectToApproval',
            termsLinkText: 'offers.seeTermsText',
            termsLink: US_TERMS.acq

        },
        ba_nop: {
            bodyText2: 'offers.assetLite.bmlOfferTitleWithAmountZero',
            bodyText: 'offers.bmlOfferPassiveCta',
            termsText: 'offers.subjectToApproval',
            termsLink: US_TERMS.acq,
            termsLinkText: 'offers.seeTermsText'

        },
        ni: {
            bodyText2: 'offers.assetLite.bmlOfferPassiveNIDetails',
            bodyText: 'offers.bmlOfferPassiveCta',
            termsText: 'offers.subjectToApproval',
            termsLink: US_TERMS.acq,
            termsLinkText: 'offers.seeTermsText'

        },
        installment: {
            bodyText2: 'offers.assetLite.bmlOfferPassiveEZPDetails',
            bodyText: 'offers.bmlOfferPassiveEZPCta',
            termsText: 'offers.subjectToApproval',
            termsLink: US_TERMS.ezpTerms
        },
        threeMonthInst: {
            bodyText2: 'offers.assetLite.threeMonthINSTDetails',
            bodyText: 'offers.assetLite.bmlOfferPassiveEZPCta',
            termsText: 'offers.subjectToApproval',
            termsLink: US_TERMS.ezpTerms,
            termsLinkText: 'offers.seeTermsText'
        }

    }
};

_squid.$meta;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditOfferUSBanner = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/styles.less");

var _xoCreditBannerConstants = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

var _utils = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/utils.js");

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/constants.js");

var _xoCreditBannerConstants2 = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCreditOfferUSBanner = exports.$xoCreditOfferUSBanner = _squid.$Component.extend('$xoCreditOfferUSBanner', {
    tag: 'xo-credit-offer-us-banners',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        reusetext: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                installmentOfferTypeModel: _index2.$CreditInstallmentModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        experiments: function experiments(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                var userAction = models.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && models.checkoutCart.get('purchase.items.length', 0) <= 0;
                _this.models.creditSharedInfo = _index2.$CreditSharedInfoModel.instance();

                return {
                    // this is shared between the two countries
                    showCartAmount: (0, _pxp.$pxpCartAmt)(models.checkoutAppData.get('merchant.merchant_country'), models.payee.get('merchant.id'), noLineItemDetails, models.checkoutCart.isPurchase()).then(function (showAmount) {
                        models.creditSharedInfo.setCartAmountVisible(showAmount);
                    }),
                    // This will call for the new CYCO experiment
                    redirect_to_cape_cyco: (0, _squid.$elmo)('xo_us_ppc_ezp', {
                        'ctx.COUNTRY': models.checkoutAppData.get('merchant.merchant_country'),
                        'ctx.merchantID': models.payee.get('merchant.id')
                    }, 'Trmt_xo_us_ppc_.*', false, true).then(function (result) {
                        if (result && result.treatment_name) {
                            return true;
                        } else {
                            return false;
                        }
                    })
                };
            });
        }
    },
    actions: {
        selectExistingBml: function selectExistingBml(offerType) {
            _logger.$logger.info('Select existing BML');
            var self = this;

            // FPTI tracking for when user clicks link for REUSE
            _logger.$logger.info('checkout_fpti', {
                'from': 'clickPPCReuse',
                'to': 'banner_click'
            });

            if (self.models.checkoutCart.isBillingNoPurchase()) {
                // if this is a BA-NOP transaction, set sticky FI and go to review page
                var fpList = self.models.checkoutSession.get('futurePaymentInstruments');
                var ppc = fpList.find(function (fp) {
                    return fp.type === 'BILL_ME_LATER';
                });
                this.models.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: ppc.instrument_id
                    },
                    success: function success(result) {
                        self.showReuseBannerFlag = false;
                        self.models.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                        };
                        _uiRouter.$state.go('checkout.review');
                    }
                });
            } else {

                // Anything other than BA-NOP, we set fundingOption for this transaction and go to the next page
                var _fpList = self.models.checkoutSession.get('fundingOptions.instruments');
                var fundingSource = _fpList.find(function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
                // If the user has to redirect to CYCO to choose an installment offer, we do not want
                // to select PPC as an FI in case the click "checkout with PayPal" on CYCO instead.
                if (fundingSource && offerType === _constants.CREDIT_TYPE.INST) {
                    // get financing code from MORS/SSOT
                    // get elmo experiment
                    if (self.models.creditSharedInfo.getRedirectToCapeCyco()) {
                        // add FPTI tracking here

                        _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                    } else {
                        _uiRouter.$state.go('checkout.chooseCreditOffer');
                    }
                } else {
                    // CORE and NI offers will select PPC because they skip CYCO
                    self.models.checkoutSession.fundingOptions.action('select', {
                        resultModel: self.models.checkoutSession,
                        data: {
                            planId: fundingSource.planId
                        },
                        success: function success(result) {
                            // Do not show PPC banner after user selected PPC
                            self.showReuseBanner = false;

                            if (result) {
                                // Update the installments to support the user selecting a card that does not support installments.
                                self.models.checkoutSession.installments = result.installments;
                            }

                            // If selected fundingSource is CREDIT and there's installment offers present, we go to CYCO
                            if (fundingSource.type === 'CREDIT' && self.models.creditSharedInfo.hasInstallmentOffers()) {
                                _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else {
                                // otherwise, we go to review page
                                if (!fundingSource.selected) {
                                    self.models.checkoutSession.message = {
                                        type: 'success',
                                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                                    };
                                    if (self.models.checkoutSession.selectedInstallmentData && !self.models.checkoutSession.selectedInstallmentData.preventChange) {
                                        // Resetting selected installment data, if installment change is not explicitly prohibited.
                                        self.models.checkoutSession.selectedInstallmentData = undefined;
                                    }
                                }
                                _uiRouter.$state.go('checkout.review');
                            }
                        }
                    });
                }
            }
        },
        selectAcqBml: function selectAcqBml() {
            // this is called on UI when user clicks on "Apply" link in ACQ banner
            // if installment offers are present, go CYCO.
            // otherwise, go CAPE

            // We now need to check our elmo experiment and the financing code to redirect to 
            // the new CYCO page in CAPE. 

            var self = this;

            // FPTI tracking for when user clicks link for ACQ
            _logger.$logger.info('checkout_fpti', {
                'from': 'clickPPCAcq',
                'to': 'banner_click'
            });

            if (self.models.creditSharedInfo.hasInstallmentOffers()) {
                // get elmo experiment for 3M or new CYCO experiments
                if (self.models.creditSharedInfo.getRedirectToCapeCyco()) {
                    // add FPTI tracking here 
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            } else {
                _uiRouter.$state.go('checkout.redirectToCape');
            }
        }
    },
    lifecycle: {
        populate: function populate() {
            var self = this;
            var cartAmount = self.models.checkoutCart.get('purchase.amounts.total.amount', 0);
            var baNOP = self.models.checkoutCart.isBillingNoPurchase();
            var isCreditInWallet = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditInWallet(self.models.checkoutSession, self.models.checkoutCart.isBillingNoPurchase());
            var customerType = isCreditInWallet ? _xoCreditBannerConstants.CUSTOMER_TYPE.REUSE : _xoCreditBannerConstants.CUSTOMER_TYPE.ACQ;
            var creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
            var isCapeReturnKey = creditDataModel && creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');
            var isSecondButton = self.models.checkoutAppData.isSecondButton();
            self.or = _constants.RYI_OR; // 'or' string for grey line to split banner from FI's

            if (self.experiments.redirect_to_cape_cyco) {
                // for the new cyco page in cape, user should go to CAPE based on the treatment value returned through elmo
                self.models.creditSharedInfo.setRedirectToCapeCyco(true);
            }

            this.$watch('models.checkoutCart.grossTotalAmount', function () {

                if (self.banner) {
                    _angular.$q.when(_xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(self.props.token, self.models)).then(function (_ref) {
                        var banner = _ref.banner;

                        if (banner) {
                            self.banner = banner;
                        }
                    });
                }
            });

            _angular.$q.when(_xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(self.props.token, self.models)).then(function (_ref2) {
                var banner = _ref2.banner,
                    morsErr = _ref2.morsErr;

                // Constants for template logic
                self.CREDIT_TYPE = _constants.CREDIT_TYPE;
                self.CUSTOMER_TYPE = _xoCreditBannerConstants.CUSTOMER_TYPE;
                self.bannerType = _xoCreditBannerConstants.BANNER_TYPE;
                if (banner) {
                    _logger.$logger.info('us-banner/directive.js: displaying content from MORS/PS response');

                    // banner fields gotten back from MORS
                    self.banner = banner;
                    self.displayBanner = banner.presentmentStyle;
                    self.banner.showPassiveBanner = self.displayBanner === _xoCreditBannerConstants.BANNER_TYPE.PASSIVE;
                    self.customer = banner.offerCategory;
                    self.banner.incentives = banner.incentivesOffer;

                    if (self.customer === _xoCreditBannerConstants.CUSTOMER_TYPE.REUSE) {
                        // Set up content for wallet banner
                        // We want to set the experiment in the template only for NI offers. 

                        // When customer selects NI on CYCO page we want to update the banner content on RYI
                        var niSelectedOnCYCO = self.models.installmentOfferTypeModel && self.models.installmentOfferTypeModel.creditType === _constants.CREDIT_TYPE.NI;
                        var offerSelected = self.models.installmentOfferTypeModel && self.models.installmentOfferTypeModel.creditType;

                        var offerType = (0, _utils.getCreditType)(niSelectedOnCYCO, banner.offerType, baNOP, cartAmount);

                        // Sets up redirect for REUSE customers which click link in Reuse Banner
                        if (offerType === _constants.CREDIT_TYPE.INST) {
                            self.models.creditSharedInfo.setInstallmentOfferPresent(true);
                        }
                        var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                        var hasThreeMonthInstallment = threeMonthFinancingCodeArray.includes(banner.financingCode);

                        self.reuseWalletBanner = (0, _utils.getReuseRadioBannerInfo)(offerType, cartAmount, hasThreeMonthInstallment, isCapeReturn, offerSelected);
                        self.reuseWalletBanner.offerType = offerType;
                        if (self.props.reusetext) {
                            self.banner.presentmentStyle = 'WALLET';
                        }
                    }

                    // Send FPTI log if the banner is from personalization studio and it's not already sent
                    if (banner.messageId && banner.messageId.indexOf(_xoCreditBannerConstants2.PERSONALIZATION_MESSAGE_PREFIX) === 0 && !self.models.creditSharedInfo.getMorsFptiFiredFlag()) {
                        banner.payerId = self.models.checkoutSession.payer.id || '';
                        _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(self.props.token, banner, isSecondButton, isCapeReturnKey));
                        _logger.$logger.createCalRootTxn(_xoCreditBannerUtils.$xoCreditBannerUtils.buildPSMonitoringObject(self.props.token, banner, self.banner, morsErr), 'hermes_personalization');
                        self.models.creditSharedInfo.setMorsFptiFiredFlag(true);
                        _logger.$logger.flush();
                    }
                } else {
                    // Fallback banners
                    var contentKeys = isCreditInWallet ? _constants.usContentKeys.reuse : _constants.usContentKeys.acq;
                    _logger.$logger.error('us-banner/directive.js: MORS call to PS failed, showing fallback banners');

                    // Call SSOT for special financing offers
                    _angular.$q.when(_xoCreditBannerUtils.$xoCreditBannerUtils.callSsotAndMapBanner(self.props.token, self.models, contentKeys)).then(function (ssot_banner) {
                        if (ssot_banner) {
                            self.banner = ssot_banner;

                            if (!self.experiments.redirect_to_cape_cyco && ssot_banner.hasThreeMonthOffer) {
                                // we receive a 3 month financing code from SSOT but user falls into treatment. We have to ignore the 
                                // offer and display and ALWAYS ON offer. We should remove this code once we are ramped to 100%
                                _logger.$logger.info('us-banner/directive.js: SSOT response with ' + (0, _squid.$feature)('threeMonthFinancingCode') + ' and elmo experiment: xo_us_ppc_ezp = ' + self.experiments.redirect_to_cape_cyco);

                                if (parseFloat(cartAmount) >= 99) {
                                    _logger.$logger.info('us-banner/directive.js: 3M fallback to NI Offer');
                                    self.banner = _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(contentKeys.ni, { cartAmount: cartAmount });
                                    self.banner.offerType = _constants.CREDIT_TYPE.NI;
                                    ssot_banner = self.banner; // set for reuse condition below 
                                } else {
                                    // if we don't see any (either EZP or NI) offer from SSOT, it's always CORE
                                    _logger.$logger.info('us-banner/directive.js: 3M fallback to CORE Offer');
                                    self.banner = _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(contentKeys.core, { cartAmount: cartAmount });
                                    self.banner.offerType = _constants.CREDIT_TYPE.CORE;
                                    ssot_banner = self.banner; // set for reuse condition below
                                }
                                self.models.creditSharedInfo.setInstallmentOfferPresent(false); // need this for redirect logic
                            }

                            self.displayBanner = _xoCreditBannerConstants.BANNER_TYPE.PASSIVE; // acquisition banner should be passive (will not impact reuse)
                            self.banner.showPassiveBanner = self.displayBanner === _xoCreditBannerConstants.BANNER_TYPE.PASSIVE;
                            self.customer = customerType;
                            self.banner.fallback = true;

                            // MORS call failed, this is fallback for REUSE banner in wallet
                            if (isCreditInWallet) {
                                _logger.$logger.info('us-banner/directive.js: Reuse customer wallet banner fallback');

                                // Set up content for wallet banner
                                // When customer selects NI on CYCO page we want to update the banner content on RYI
                                var _niSelectedOnCYCO = self.models.installmentOfferTypeModel && self.models.installmentOfferTypeModel.creditType === _constants.CREDIT_TYPE.NI;
                                var _offerSelected = self.models.installmentOfferTypeModel && self.models.installmentOfferTypeModel.creditType;

                                var _offerType = (0, _utils.getCreditType)(_niSelectedOnCYCO, ssot_banner.offerType, baNOP, cartAmount);

                                // Sets up redirect for REUSE customers which click link in Reuse Banner
                                if (_offerType === _constants.CREDIT_TYPE.INST) {
                                    self.models.creditSharedInfo.setInstallmentOfferPresent(true);
                                }
                                self.reuseWalletBanner = (0, _utils.getReuseRadioBannerInfo)(_offerType, cartAmount, ssot_banner.hasThreeMonthOffer, isCapeReturn, _offerSelected);
                                self.reuseWalletBanner.offerType = _offerType;
                                if (self.props.reusetext) {
                                    self.banner.presentmentStyle = 'WALLET';
                                }
                            }

                            // Send FPTI log if the banner is from personalization studio and it's not already sent
                            if (ssot_banner.messageId && ssot_banner.messageId.indexOf(_xoCreditBannerConstants2.DEFAULT_MESSAGE_PREFIX) === 0 && !self.models.creditSharedInfo.getMorsFptiFiredFlag()) {
                                ssot_banner.payerId = self.models.checkoutSession.payer.id || '';
                                _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(self.props.token, _xoCreditBannerUtils.$xoCreditBannerUtils.collectFallbackBannerInfo(self.banner, isCreditInWallet, isCreditInWallet), isSecondButton, isCapeReturnKey));

                                _logger.$logger.createCalRootTxn(_xoCreditBannerUtils.$xoCreditBannerUtils.buildPSMonitoringObject(self.props.token, banner, self.banner, morsErr), 'hermes_personalization');
                                self.models.creditSharedInfo.setMorsFptiFiredFlag(true);
                                _logger.$logger.flush();
                            }
                        } else {
                            // SSOT and always on offer failed to be set. 
                            _logger.$logger.error('us-banner/directive.js: callSSOTAndMapBanner() did not return banner content.');
                            self.banner = undefined;
                            _logger.$logger.createCalRootTxn(_xoCreditBannerUtils.$xoCreditBannerUtils.buildPSMonitoringObject(self.props.token, banner, self.banner, morsErr), 'hermes_personalization');
                        }
                    });
                }
            });
        }
    }
});

angular.value("$xoCreditOfferUSBanner", $xoCreditOfferUSBanner);
_angular.noop;

_angular.$q;

_logger.$logger;

_uiRouter.$state;

_squid.$Component;

_squid.$elmo;

_squid.$feature;

_squid.$util;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index2.$CreditDataModel;

_index2.$CreditSharedInfoModel;

_index2.$CreditInstallmentModel;

_auth.$AuthModel;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_pxp.$pxpCartAmt;

_xoCreditBannerConstants.BANNER_TYPE;

_xoCreditBannerConstants.CUSTOMER_TYPE;

_utils.getReuseRadioBannerInfo;

_utils.getCreditType;

_constants.CREDIT_TYPE;

_constants.usContentKeys;

_constants.RYI_OR;

_xoCreditBannerConstants2.PERSONALIZATION_MESSAGE_PREFIX;

_xoCreditBannerConstants2.DEFAULT_MESSAGE_PREFIX;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"usPPCBanners\">\n    <div ng-if=\"customer == CUSTOMER_TYPE.ACQ\">\n        <!-- ACQUISITON CUSTOMERS -->\n        <div id=\"bmlAcqOfferPassive\" class=\"payWithOption passiveBanner creditBanner\" ng-if=\"banner && displayBanner == bannerType.PASSIVE\">\n            <span class=\"plusicon\" ng-click=\"actions.selectAcqBml()\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\" tabindex=\"-1\"></span>\n            <div class=\"payWithOptionBody\">\n                <div class=\"payWithOptionIcon\" ng-click=\"actions.selectAcqBml()\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\" tabindex=\"-1\">\n                    <span class=\"fsIcon BILL_ME_LATER\" ng-if=\"banner.fallback\"></span>\n                    <img ng-src=\"{{banner.logo}}\" ng-if=\"!banner.fallback\" alt=\"{{htmlContent('paymentMethod.billmelater')}}\" />\n                </div>\n                <div class=\"payWithOptionContent\">\n                    <div><a href=\"#\" ng-click=\"actions.selectAcqBml()\" class=\"name proceed\" ng-bind-html=\"banner.bodyText\" track-link=\"acquisition_offer_banner_MORS\"\n                        data-test-id=\"passiveBannerApplyLink\"></a></div>\n                    <div><span class=\"payWithOptionDetails\" ng-bind-html=\"banner.bodyText2\"></span></div>\n                    <div>\n                        <span class=\"payWithOptionTerms\" ng-bind-html=\"banner.termsText\"></span>\n                        <a href=\"{{banner.termsLink}}\"\n                        class=\"popup payWithOptionTermsLink\"\n                        target='_blank'\n                        ng-bind-html=\"banner.termsLinkText\"\n                        track-link=\"acquisition_offer_banner_MORS_terms_link\"></a>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n\n        <div id=\"bmlAcqOfferProminent\" class=\"prominentBanner creditBanner\" ng-if=\"banner && displayBanner == bannerType.PROMINENT\">\n            <div class=\"prominentBannerSeparator\">\n                <span class=\"prominentBannerSeparatorLine\"></span>\n                <span class=\"prominentBannerSeparatorWord\" ng-bind-html=\"or\"></span>\n            </div>\n            <div class=\"bmlCtaWrap purpleBanner\" ng-style=\"banner.bannerColorObj\">\n                <div class=\"bmlCtaHeader\">\n                    <span class=\"prominentBannerIcon\">\n                        <span class=\"creditIcon\" ng-if=\"useFallbackBanner\"></span>\n                        <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" />\n                    </span>\n                    <span class=\"bmlApplyLink\">\n                        <a href=\"#\" ng-click=\"actions.selectAcqBml()\" class=\"proceed\" ng-bind-html=\"banner.ctaText\" track-link=\"acquisition_offer_banner_MORS\"\n                        data-test-id=\"ppcBannerApplyButton\"></a>\n                    </span>\n                </div>\n                <p class=\"bmlOfferTitle bannerLine\" ng-class=\"{'strongBmlOfferTitle': banner.incentives}\" ng-bind-html=\"banner.headlineText\"></p>\n                <p class=\"bmlOfferTitle bannerLine\" ng-class=\"{'strongBmlOfferTitle': banner.incentives}\" ng-bind-html=\"banner.bodyText\"></p>\n                <p id=\"bmlOfferTitleSecRow\" ng-if=\"banner.bodyText2\" class=\"bmlOfferTitle bannerLine\" ng-bind-html=\"banner.bodyText2\"></p>\n                <p class=\"offerSmallText bannerLine\">\n                    <span class=\"seeTermsLink ng-scope\" ng-bind-html=\"banner.termsText\"></span>\n                    <a href='{{banner.termsLink}}'\n                        class='popup bmlTermsLink'\n                        target='_blank'\n                        ng-bind-html=\"banner.termsLinkText\"\n                        track-link=\"acquisition_offer_banner_MORS_terms_link\"\n                        xo-popup></a>\n                </p>\n            </div>\n        </div>\n    </div>\n    <div ng-if=\"false\">\n        <!-- REUSE CUSTOMERS -->\n        <div ng-if=\"reusetext\">\n            <!-- Reuse text under FI's in wallet -->\n            <div id=\"bmlReuseOfferInfo\">\n                <div ng-if=\"reuseWalletBanner.offerType != CREDIT_TYPE.NI\">\n                    <span class=\"offerInfo ng-binding ng-scope\" ng-bind-html=\"reuseWalletBanner.bodyText\"></span>\n                    <span class=\"seeTermsLink ng-scope\">\n                        <a href='{{reuseWalletBanner.termsLink}}'\n                            class='popup bmlTermsLink' target='_blank'\n                            xo-popup>{{reuseWalletBanner.termsLinkText}}</a>\n                    </span>\n                    <span ng-if=\"reuseWalletBanner.offerType == CREDIT_TYPE.INST\" class=\"bmlChangeLink\">\n                        <a track-link=\"reuse_offer_banner_MORS\" link-button ng-click=\"actions.selectExistingBml(reuseWalletBanner.offerType); $event.stopPropagation();\" class=\"proceed\"\n                            ng-bind-html=\"reuseWalletBanner.ctaText\"></a>\n                    </span>\n                </div>\n                <div ng-class=\"checkMarkWrapper\" ng-if=\"reuseWalletBanner.offerType == CREDIT_TYPE.NI\">\n                    <div class=\"checkmark\">\n                        <span class=\"greenCheck\" />\n                        <span class=\"offerInfoCheck ng-binding ng-scope\">\n                                {{reuseWalletBanner.bodyText}}\n                                <a href='{{reuseWalletBanner.termsLink}}'\n                                class='popup seeTermsLink bmlTermsLink' target='_blank'\n                                xo-popup>{{reuseWalletBanner.termsLinkText}}</a>\n                        </span>\n                    </div>\n                    <div class=\"checkmark\">\n                        <span class=\"greenCheck\" />\n                        <span class=\"offerInfoCheck ng-binding ng-scope\" ng-bind-html=\"reuseWalletBanner.bodyText2\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"!reusetext\">\n            <!-- Reuse Prominent Banner content-->\n            <div id=\"bmlExistingOfferProminent\" class=\"prominentBanner creditBanner\" ng-if=\"!reuseText && banner\">\n                <div class=\"prominentBannerSeparator\">\n                    <span class=\"prominentBannerSeparatorLine\"></span>\n                    <span class=\"prominentBannerSeparatorWord\" ng-bind-html=\"or\"></span>\n                </div>\n                <div class=\"bmlCtaWrap\">\n                    <div class=\"bmlCtaHeader\">\n                        <span class=\"prominentBannerIcon\">\n                            <span class=\"creditIcon\" ng-if=\"banner.fallback\"></span>\n                            <img ng-src=\"{{banner.logo}}\" ng-if=\"!banner.fallback\" />\n                        </span>\n                        <span class=\"bmlChangeLink bmlChangeLinkInBanner\">\n                            <a track-link=\"reuse_offer_banner_MORS\" link-button ng-click=\"actions.selectExistingBml(banner.offerType)\" class=\"proceed\"\n                            data-test-id=\"ppcBannerApplyButton\" ng-bind-html=\"banner.ctaText\"></a>\n                        </span>\n                    </div>\n                    <p class=\"bmlExistingOfferTitle bannerLine\" ng-bind-html=\"banner.bodyText\"></p>\n                    <p class=\"bmlExistingOfferText bannerLine\"\n                            ng-bind-html=\"banner.bodyText2\"></p>\n                    <p class=\"seeTermsLink ng-scope bannerLine\">\n                        <a href='{{banner.termsLink}}'\n                            class='popup bmlTermsLink'\n                            target='_blank'\n                            ng-bind-html=\"banner.termsLinkText\"\n                            track-link=\"reuse_offer_banner_MORS_terms_link\"\n                            xo-popup></a>\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getReuseRadioBannerInfo = exports.getCreditType = undefined;

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/constants.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var alwaysOnOffer = function alwaysOnOffer(cartAmount) {
    // In case MORS fails we want to have an offer available based on cart amount
    if (cartAmount <= 99) {
        return _constants.CREDIT_TYPE.CORE;
    } else {
        return _constants.CREDIT_TYPE.NI;
    }
};

var getCreditType = exports.getCreditType = function getCreditType(niSelectedOnCyco, psBannerOfferType, isBaNOP, cartAmount) {
    // Check if there is an offer already selected
    // This is the scenario where user has EZP but selects SAC or NI
    var creditType = void 0;

    if (isBaNOP) {
        creditType = _constants.CREDIT_TYPE.BA;
    } else if (niSelectedOnCyco) {
        // NI selected from CYCO page (for wallet banner content change on RYI)
        creditType = _constants.CREDIT_TYPE.NI;
    } else if (psBannerOfferType) {
        // Check PS offer type
        creditType = psBannerOfferType;
    } else {
        return alwaysOnOffer(cartAmount);
    }
    _logger.$logger.info('us-banner/utils getCreditType(): showing user creditType of ', creditType);
    return creditType;
};

var getReuseRadioBannerInfo = exports.getReuseRadioBannerInfo = function getReuseRadioBannerInfo(creditType, amount, hasThreeMonthInstallment, isCapeReturn, offerSelected) {
    // No purchase or 0 cart amount flow
    if (!amount || amount === '') {
        return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.NoP);
    } else if (creditType === _constants.CREDIT_TYPE.CORE || creditType === _constants.CREDIT_TYPE.BA) {
        return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.CORE);
    } else if (creditType === _constants.CREDIT_TYPE.NI) {
        var banner = {};
        banner = _constants.reuseRadioBannerContent.NI;
        banner.bodyText2 = 'offers.assetLite.bmlOfferCheckMark2';
        banner = _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(banner);
        return banner;
    } else if (creditType === _constants.CREDIT_TYPE.INST) {
        if (hasThreeMonthInstallment) {
            if (isCapeReturn && offerSelected) {
                return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.THREEMONTHINSTRETURN);
            } else if (parseFloat(amount) >= 99) {
                return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.THREEMONTHINSTNI);
            } else {
                return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.THREEMONTHINSTCORE);
            }
        } else {
            return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.INST);
        }
    }
};

_xoCreditBannerUtils.$xoCreditBannerUtils;

_constants.reuseRadioBannerContent;

_constants.CREDIT_TYPE;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-offer-top-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-offer-top-banner/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoOfferTopBanner', {
    tag: 'xo-offer-top-banner',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.isTopBannerVisible = false;
        $scope.offerTopBanner = {};
        $scope.PPClogoBannerURL = 'https://' + _squid.$meta.cdnHost + '/webstatic/credit/img/PPClogo_banner.png';
        // this data comes from an $emit() call in:
        // xo-credit-components/src/offer/directive.js
        var unbind = _angular.$rootScope.$on('setOfferTopBanner', function (event, data) {
            $scope.offerTopBanner = data;
            $scope.isTopBannerVisible = true;
        });

        $scope.$on('$destroy', unbind);
    }]
});


_squid.$Component;

_squid.$meta;

_angular.$rootScope;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-offer-top-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div\n  ng-if=\"isTopBannerVisible\"\n  class=\"xo-offer-top-banner-container\"\n>\n  <div class=\"banner-container\">\n    <img\n      ng-src=\"{{ PPClogoBannerURL }}\"\n      width=\"52\"\n    />\n    <div class=\"body-text\">\n      <span ng-bind-html=\"offerTopBanner.banner.bodyText\"></span>\n    </div>\n    <div>\n      <a\n        href=\"#\"\n        class=\"apply-btn\"\n        ng-click=\"offerTopBanner.bml()\"\n        ng-bind-html=\"offerTopBanner.banner.ctaText\"\n      >\n      </a>\n    </div>\n    <div class=\"terms-container\">\n      <span ng-bind-html=\"offerTopBanner.banner.termsText\"></span>\n      <a\n        href=\"{{offerTopBanner.banner.termsLink}}\"\n        class=\"popup smallPopup bmlTermsLink\"\n        target=\"_blank\"\n        xo-popup\n        track-link=\"acquisition_offer_banner_MORS_terms_link\"\n        ng-bind-html=\"offerTopBanner.banner.termsLinkText\"\n      >\n      </a>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-device-info/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$DeviceInfo', function () {
    var userAgent = _angular.$window.navigator.userAgent;
    var standalone = _angular.$window.navigator.standalone;
    var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
    var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
    var IOS_PATTERN = /iP(hone|od|ad)/i;

    function getIntegrationContext(integrationKey) {
        // additonal context sent via partners in regards to integration
        var integrationContext = _squid.$meta.integrationCTX || {};

        return integrationContext[integrationKey];
    }

    // Supports iOS and Android. Updated / more accurate method of detecting webviews
    function isWebView() {
        var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;

        var ios = /iphone|ipod|ipad/i.test(ua);
        var android = /Android/i.test(ua);

        if (ios) {
            // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
            // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
            var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);

            if (!standalone && ios_uiwebview && !isSafariViewController()) {
                // uiwebview
                logWebView('iOS');
                return true;
            }
        } else if (android) {
            // not iOS, Android platform handling
            // Whitelist for x-requested-with header values for web view detection
            var allowedXRequestedWithRegexMap = {
                ajax: /XMLHttpRequest/i,
                baiduBrowser: /com.baidu.browser.inter/i,
                operaMini: /com.opera.mini.native/i,
                maxthon: /com.mx.browser/i,
                litterPenguinBrowser: /com.explore.web.browser/i
            };
            var xRequestedWithHeaderVal = _squid.$meta.requestHeaders['x-requested-with'];

            if (xRequestedWithHeaderVal) {
                // check if x-requested-with header val is in whitelist
                for (var key in allowedXRequestedWithRegexMap) {
                    if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
                        if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
                            return false;
                        }
                    }
                }
                logWebView('Android');
                return true;
            }
        }

        return false;

        function logWebView(device) {
            if (!logEnabled) {
                return;
            }
            // cal log
            _logger.$logger.info('WebView :: ' + device);
        }
    }

    /**
     * Check if the given the user-agent string is belongs to a device.
     */
    function isDevice() {
        if (_angular2['default'].isString(userAgent)) {
            return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
        }

        return false;
    }

    /**
     * Check if the given the user-agent string is belongs to a tablet.
     */
    function isTablet() {
        if (_angular2['default'].isString(userAgent)) {
            return TABLET_PATTERN.test(userAgent);
        }

        return false;
    }

    /**
     * Check if the given the user-agent string is belongs to a mobile
     */
    function isMobile() {
        return isDevice(userAgent) && !isTablet(userAgent);
    }

    /**
     * Get the mobile platform value given the user-agent string.
     */
    function getDevicePlatform() {
        if (_angular2['default'].isString(userAgent)) {
            var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);

            if (matched && matched.length > 0) {
                return matched[0];
            }
        }
    }

    /**
     * Check if the give user agent is from an app.
     */
    function isApp(uaString) {
        userAgent = uaString || userAgent;

        if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
            if (getDevicePlatform(userAgent) === 'Android') {
                return (/Version\/\d.\d/i.test(userAgent)
                );
            }

            return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
            );
        }

        return false;
    }

    function isSafariViewController() {
        if (getIntegrationContext('brainTreeIntegration') === 'SFVC') {
            return true;
        }
        if (_angular2['default'].isString(userAgent)) {
            var ios = /iphone|ipod|ipad/i.test(userAgent);

            return ios && _angular.$window.indexedDB && isApp();
        } else {
            return false;
        }
    }

    /**
     * Get the device capabilities
     */
    function getCapabilities() {
        var capabilities = {};
        var device = DEVICE_PATTERN.test(userAgent);
        var tablet = TABLET_PATTERN.test(userAgent);
        var app = isApp(userAgent);

        if (_angular2['default'].isString(userAgent)) {
            capabilities.isWireless = device || tablet;
            capabilities.isTablet = tablet;
            capabilities.isMobile = device && !tablet;
            capabilities.isDesktop = !device;
            capabilities.isApp = app;
        }
        return capabilities;
    }

    /**
     * Get various AppIntegrationType
     */
    function getAppIntegrationType() {
        var app_int_type = void 0;

        if (isDevice()) {
            if (isApp()) {
                if (isSafariViewController()) {
                    app_int_type = 'SFVC';
                } else {
                    app_int_type = 'WebView';
                }
            } else {
                app_int_type = 'Browser';
            }
        }
        return app_int_type;
    }

    function isSafariiOSBrowserView() {
        var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;

        var ios = IOS_PATTERN.test(ua);
        var safari = /safari/i.test(ua);
        var isIOSApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
        var isChromeOnIOS = /(.*?CriOS)/i.test(ua);
        var isFirefoxOnIOS = /(.*?FxiOS)/i.test(ua);
        var isSafariBrowserOnly = safari && !isChromeOnIOS && !isFirefoxOnIOS;

        return ios && !standalone && isSafariBrowserOnly && !isIOSApp;
    }

    function getiOSVersion() {
        var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;

        var ios = IOS_PATTERN.test(ua);

        if (ios) {
            var version = ua.match(/OS (\d+)_(\d+)/);
            return [parseInt(version[1], 10), parseInt(version[2], 10)];
        }
        return false;
    }

    return {
        isDevice: isDevice,
        isTablet: isTablet,
        isMobile: isMobile,
        isApp: isApp,
        isSafariViewController: isSafariViewController,
        getCapabilities: getCapabilities,
        getAppIntegrationType: getAppIntegrationType,
        isWebView: isWebView,
        isSafariiOSBrowserView: isSafariiOSBrowserView,
        getiOSVersion: getiOSVersion
    };
});

_squid.$meta;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-device-info/dist", "../node_modules/xo-device-info/dist/index.js"))

/***/ }),

/***/ "../node_modules/xo-form-components/src/add-tax-id/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/add-tax-id/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddTaxId', function () {
    return {
        scope: {
            token: '=?',
            finish: '=?'
        },
        template: _template2['default'],

        controller: ['$scope', '$element', function ($scope, $element) {

            function thenFunction() {
                var taxIdType = 'CPF';

                if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.cause === 'NEED_BUSINESS_TAX_INFO_TO_PAY') {
                    taxIdType = 'CNPJ';
                }
                var issuer = 'BR_' + taxIdType;

                $scope.subType = taxIdType;

                $scope.userInfo = _index2.$UserInfoModel.instance($scope.token);

                $scope.onSubmit = function () {
                    // Scrub the formatting when invoking the backend services.
                    var unformatted = ($scope.taxId || '').replace(/[^0-9]+/g, '');
                    var data = {
                        newDocId: {
                            type: 'TAX_ID',
                            subType: $scope.subType,
                            issuerCountry: 'BR',
                            issuer: issuer,
                            value: unformatted,
                            collectionPoint: 'UNKNOWN',
                            placeOfIssue: 'BR'
                        }
                    };

                    $scope.userInfo.action('addTaxId', {
                        data: data,

                        success: function success() {
                            var checkoutSession = _index.$CheckoutSessionModel.instance($scope.token);
                            var checkoutCart = _index.$CheckoutCartModel.instance($scope.token);

                            return checkoutSession.action('create', {
                                data: {
                                    baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                                },
                                success: function success() {
                                    // Clear the errors if create checkout session was successful
                                    $scope.checkoutSession.errorData = undefined;
                                    $scope.finish();
                                }
                            });
                        },

                        validation: function validation(validationData) {
                            var $el = $($element);
                            var $field = $($el.find('[name="' + validationData.field + '"]'));

                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                            $field.focus();
                        }
                    });
                };

                $scope.changeTaxId = function (newValue) {
                    var unformatted = (newValue || '').replace(/[^0-9]+/g, '');
                    var formatted = '';
                    var i = 0;

                    // For CPF we will format the output with dots and dashes like this:
                    // 999.999.999-99
                    if ($scope.subType === 'CPF') {
                        for (i = 0; i < unformatted.length; i++) {
                            if (i === 3 || i === 6) {
                                formatted = formatted + '.';
                            }
                            if (i === 9) {
                                formatted = formatted + '-';
                            }
                            formatted = formatted + unformatted.charAt(i);
                        }
                        $scope.taxId = formatted;
                        // For CNPJ we will format the output with dots, dashes, and slashes like this:
                        // 99.999.999/9999-99
                    } else if ($scope.subType === 'CNPJ') {
                        for (i = 0; i < unformatted.length; i++) {
                            if (i === 2 || i === 5) {
                                formatted = formatted + '.';
                            } else if (i === 8) {
                                formatted = formatted + '/';
                            } else if (i === 12) {
                                formatted = formatted + '-';
                            }
                            formatted = formatted + unformatted.charAt(i);
                        }
                        $scope.taxId = formatted;
                    } else {
                        $scope.taxId = unformatted;
                    }
                };
            }

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(thenFunction());
        }]
    };
});

_squid.$populate;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_index2.$UserInfoModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/add-tax-id/template.html":
/***/ (function(module, exports) {

module.exports = "<form id=\"taxIdForm\" name=\"taxIdForm\" class=\"taxIdForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <div ng-if=\"subType === 'CNPJ'\">\n            <h3 class=\"gamma noHead\">{{ content('addTaxId.addTaxIdCNPJ') }}</h3>\n            <p>{{ content('addTaxId.noteCNPJ') }}</p>\n\n            <div class=\"inputField confidential\" floating-label>\n                <input id=\"taxId\" name=\"taxId\" maxlength=\"18\" ng-model=\"$parent.taxId\"\n                       xo-error-tooltip required placeholder=\"{{ content('common.taxIdCNPJ_length') }}\"\n                       data-error-key=\"validation.validCNPJ\" ng-change=\"changeTaxId(taxId)\" />\n                <label for=\"taxId\">{{ content('addTaxId.cnpj') }}</label>\n            </div>\n        </div>\n\n        <div ng-if=\"subType === 'CPF'\">\n            <h3 class=\"gamma noHead\">{{ content('addTaxId.addTaxId') }}</h3>\n            <p>{{ content('addTaxId.note') }}</p>\n\n            <div class=\"inputField confidential\" floating-label>\n                <input id=\"taxId\" name=\"taxId\" maxlength=\"14\" ng-model=\"$parent.taxId\"\n                       xo-error-tooltip required placeholder=\"{{ content('common.taxId_length') }}\"\n                       data-error-key=\"validation.validCPF\" ng-change=\"changeTaxId(taxId)\" />\n                <label for=\"taxId\">{{ content('addTaxId.cpf') }}</label>\n            </div>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('addTaxId.save') }}\" class=\"btn full btn-large\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/dob-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('dobValidation', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attr, ctrl) {

            // init scope vars
            // age - above 18 yrs
            // validDate - months <= 12 and day <= 31 or based on month
            scope.isValidDate = true;
            scope.isValidAge = true;
            scope.isValid = false;
            scope.dobToolTip = 'hide';

            function isValidDate(year, month, day) {
                // dates like 02/31 33/33 should return false
                var date = new Date(year, month, day);

                var fullYear = date.getFullYear();
                var dateMonth = date.getMonth();
                var dateDay = date.getDate();

                // If birth year is in the future or before 1900, dob is invalid
                var now = new Date();

                if (fullYear > now.getFullYear() || fullYear < 1900) {
                    return false;
                }

                if (fullYear === parseInt(year, 10) && dateMonth === parseInt(month, 10) && dateDay === parseInt(day, 10)) {
                    return true;
                }
                return false;
            }

            function isOfLegalAge(birthDate) {
                // user should be of exact 18 years of age or older
                var tempDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());

                return tempDate <= new Date().setHours(0, 0, 0, 0);
            }

            /**
             * Parses input value to set corresponding day, month, year values for scope
             * @param {String} inputVal - the value to be parsed
             */
            function parseDob(inputVal) {
                var day;
                var month;
                var year;

                var sep = scope.dateSeparator();
                var partsArr = inputVal.split(sep);
                var first = partsArr[0];
                var sec = partsArr[1];
                var third = partsArr[2];

                if (scope.dateFormat() === 'DMY') {
                    day = first;
                    month = sec;
                    year = third;
                } else if (scope.dateFormat() === 'YMD') {
                    year = first;
                    month = sec;
                    day = third;
                } else {
                    month = first;
                    day = sec;
                    year = third;
                }

                // Validate only on entering the last digit of the dob
                var dayLen = ('' + day).length;
                var monLen = ('' + month).length;
                var yrLen = ('' + year).length;
                var validDay = dayLen === 1 || dayLen === 2;
                var validMon = monLen === 1 || monLen === 2;
                var validYr = yrLen === 4;
                var requirement = validDay && validMon && validYr;

                if (requirement) {
                    scope.isValidDate = isValidDate(year, month - 1, day);

                    scope.isValidAge = isOfLegalAge(new Date(year, month - 1, day));
                    scope.isValid = scope.isValidDate && scope.isValidAge;
                    scope.dobToolTip = scope.isValid ? 'hide' : 'show';

                    scope.user.dob_day = day;
                    scope.user.dob_month = month;
                    scope.user.dob_year = year;
                } else {
                    scope.isValid = false;
                }

                ctrl.$setValidity('dobText', scope.isValid);

                return inputVal;
            }

            /**
             * Validates the inputted DOB value
             * @param {string} ngModelValue - the to-be mutated input value
             * onComplete for mask listener - called when user copy/pastes DOB into the field
             */
            scope.dobValidator = function dobValidator(ngModelValue) {
                var input = element;
                var dateMask = scope.dateMask();

                input.mask(dateMask, {
                    translation: {
                        'Z': {
                            pattern: /[0-9]/, optional: true
                        },
                        '0': {
                            pattern: /[0-9]/, optional: false
                        }
                    },
                    onComplete: function onComplete(val) {
                        ngModelValue = val;
                        return parseDob(ngModelValue);
                    }
                });

                return parseDob(ngModelValue);
            };

            scope.dobTester = function dobTester(val) {
                return parseDob(val);
            };

            ctrl.$parsers.push(scope.dobValidator);
        }
    };
}).directive('xoDobInput', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            user: '=?'
        },
        controller: ['$scope', function ($scope) {

            // To support additional date separators, simply add separator to getDateSeparators function
            var DateManager = {
                dateSeparator: undefined,
                dateFormat: undefined,
                griffinDateEntry: undefined,

                _init_: function _init_() {
                    this.griffinDateEntry = _squid.$locale.metadata.dateEntry;
                    this.dateSeparator = this.getDateSeparator(this.griffinDateEntry);
                    this.dateFormat = undefined;
                    this.dateFormat = this.getDateFormat();
                    this.dateRegex = this.getDateRegex();
                    // dob validator depends on dateFormat function in $scope, so context is bound.
                    $scope.dateFormat = this.getDateFormat.bind(this);
                    $scope.dateSeparator = this.getDateSeparator.bind(this, this.griffinDateEntry);
                    $scope.dateMask = this.getDateMask.bind(this, this.dateSeparator);
                    this.getDobNumericCheck();
                },
                getDateFormat: function getDateFormat() {
                    // cache date format value, must be unset on init
                    if (this.dateFormat) {
                        return this.dateFormat;
                    }

                    var griffinDateFormat = _squid.$locale.metadata.dateFormat.toUpperCase();
                    var dateFormatComponents = griffinDateFormat.split(this.dateSeparator);

                    // Trim the white space in griffin dateFormat
                    // Eg: SK dateFormat is MM. DD. YYYY - here we need to strip spaces
                    dateFormatComponents = dateFormatComponents.map(function (str) {
                        return str.trim();
                    });

                    var dIdx = dateFormatComponents.indexOf('DD'),
                        mIdx = dateFormatComponents.indexOf('MM');

                    var formatComponentMap = this.getFormatComponentIdxMappings();

                    if (formatComponentMap['DMY'].day === dIdx && formatComponentMap['DMY'].month === mIdx) {
                        return 'DMY';
                    } else if (formatComponentMap['MDY'].day === dIdx && formatComponentMap['MDY'].month === mIdx) {
                        return 'MDY';
                    }
                    return 'YMD';
                },
                setDobTextPlaceHolder: function setDobTextPlaceHolder() {
                    $scope.dobTextPlaceholder = this.griffinDateEntry.toUpperCase();
                },
                dobTextKeyupHandler: function dobTextKeyupHandler(event) {
                    this.updateDobBindings(true);
                },
                getDobNumericCheck: function getDobNumericCheck() {
                    return (0, _squid.$elmo)('xo_xoon_numeric_keypad_expirydob', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_xoon_numeric_keypad_expirydob_test').then(function (result) {
                        if (result) {
                            $scope.dobTextInputType = 'tel';
                        }
                    });
                },
                /**
                 * Absolutely makes sure that dob input doesn't contain bad characters.
                 * Called on any chatacter input AND on locale change.
                 */
                updateDobBindings: function updateDobBindings(change) {
                    var cleanedDob = ($scope.dob.value || '').replace(this.dateRegex, '');

                    $scope.dob.value = cleanedDob;

                    // This way, our dob value is always formatted correctly.
                    if (change) {
                        $scope.dob.value = $('#dobText').val();
                    }
                },
                // Dynamically construct regex to only include date separator supported by country and nondigits
                getDateRegex: function getDateRegex() {
                    var escapedRegexChars = ['.', '$', '^', '{', '[', '(', '|', ')', '*', '+', '?', '\\'];
                    var sep = this.dateSeparator;
                    var assembledRegex = '[^0-9' + (escapedRegexChars.indexOf(sep) !== -1 ? '\\' + sep : sep) + ']';

                    return new RegExp(assembledRegex, 'gi');
                },
                getDateMask: function getDateMask(dateSeparator) {
                    var dateFormat = this.dateFormat;

                    if (dateFormat === 'DMY' || dateFormat === 'MDY') {
                        return '0Z' + dateSeparator + '0Z' + dateSeparator + '0000';
                    }

                    return '0000' + dateSeparator + '0Z' + dateSeparator + '0Z';
                },
                getDateSeparator: function getDateSeparator(dateEntry) {
                    var ret = '';

                    this.getDateSeparators().forEach(function (ele, iter) {
                        // eslint-disable-line
                        if (dateEntry.indexOf(ele) !== -1) {
                            ret = ele;
                        }
                    });
                    return ret;
                },
                // To add any additional date separators, simply add them to the returned array.
                getDateSeparators: function getDateSeparators() {
                    return ['-', '.', '/'];
                },
                // Handles changes in date component order or date separator change.
                updateDateInputForFormat: function updateDateInputForFormat(oldFormat, newFormat, oldSeparator) {
                    var curDateVal = $scope.dob.value || '';

                    // Clear dob input if date is incomplete so user can see updated placeholder
                    if (curDateVal.length < 8) {
                        $scope.dob.value = '';
                        return;
                    }

                    var formatComponentIdxMappings = this.getFormatComponentIdxMappings(),
                        oldFormatIdxMapping = formatComponentIdxMappings[oldFormat],
                        newFormatIdxMapping = formatComponentIdxMappings[newFormat];
                    var oldDateComponents = curDateVal.split(oldSeparator),
                        newDateComponents = ['', '', ''];

                    newDateComponents[newFormatIdxMapping.day] = oldDateComponents[oldFormatIdxMapping.day];
                    newDateComponents[newFormatIdxMapping.month] = oldDateComponents[oldFormatIdxMapping.month];
                    newDateComponents[newFormatIdxMapping.year] = oldDateComponents[oldFormatIdxMapping.year];
                    $scope.dob.value = newDateComponents.join(this.dateSeparator);
                },
                getFormatComponentIdxMappings: function getFormatComponentIdxMappings() {
                    return {
                        'DMY': {
                            'day': 0,
                            'month': 1,
                            'year': 2
                        },
                        'MDY': {
                            'day': 1,
                            'month': 0,
                            'year': 2
                        },
                        'YMD': {
                            'day': 2,
                            'month': 1,
                            'year': 0
                        }
                    };
                },
                prefillFetchedDob: function prefillFetchedDob() {
                    if ($scope.user && $scope.user.dob_day && $scope.user.dob_month && $scope.user.dob_year) {
                        if (!$scope.dob) {
                            $scope.dob = {};
                        }

                        if (this.dateFormat === 'DMY') {
                            $scope.dob.value = $scope.user.dob_day + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_year;
                        } else if (this.dateFormat === 'YMD') {
                            $scope.dob.value = $scope.user.dob_year + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day;
                        } else {
                            $scope.dob.value = $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day + this.dateSeparator + $scope.user.dob_year;
                        }
                    } else {
                        $scope.dob = {
                            value: ''
                        };
                    }
                }
            };

            DateManager._init_();
            DateManager.setDobTextPlaceHolder();
            DateManager.prefillFetchedDob();

            $scope.onDobTextKeyup = function (event) {
                DateManager.dobTextKeyupHandler(event);
            };

            $scope.$on('localeChange', function () {
                var oldDateFormat = DateManager.dateFormat;
                var oldSeparator = DateManager.dateSeparator;

                DateManager._init_();
                DateManager.updateDateInputForFormat(oldDateFormat, DateManager.dateFormat, oldSeparator);
                DateManager.updateDobBindings(false);
                DateManager.setDobTextPlaceHolder();
            });
        }]
    };
});

_squid.$locale;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"dobComp\" class=\"dobbank\" ng-class=\"{dobTXT: dobInputType()==='TXT'}\" content>\n    <div class=\"dobField full inputField last-child\" floating-label directionality>\n        <input ng-model=\"dob.value\"\n               name=\"dobText\"\n               id=\"dobText\"\n               value=\"\"\n               maxlength=\"10\"\n               autocapitalize=\"off\"\n               aria-required=\"true\"\n               autocomplete=\"off\"\n               placeholder=\"{{ dobTextPlaceholder }}\"\n               xo-error-tooltip\n               dob-validation\n               ng-keyup=\"onDobTextKeyup($event)\"\n               aria-describedby=\"dobHelp\"\n               type=\"{{ dobTextInputType }}\"\n               required />\n        <div ng-class=\"dobToolTip\">\n            <xo-tooltip trigger=\"#dobText\" show-event=\"keyup\" ng-class=\"dobToolTip\" id=\"dobToolTip\">\n                <div class=\"tip tipDesc dobToolTip\">\n                  <p class=\"tipInfoText restriction active\" ng-if=\"!isValidDate\">{{ content('scripts.validDate') }}</p>\n                  <p class=\"tipInfoText restriction active\" ng-if=\"isValidDate && !isValidAge\">{{ content('scripts.legalAge') }}</p>\n                </div>\n            </xo-tooltip>\n        </div>\n        <span id=\"dobHelp\" class=\"accessAid\">{{ dobTextPlaceholder }}</span>\n        <label id=\"dobLabel\" for=\"dobText\">{{ content('signup.accountCreationGuest.dobLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-nationalid/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/dob-nationalid/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoDobNationalid', function () {
    var padNumber = function padNumber(num) {
        return num.toString().replace(/^(\d)$/, '0$1');
    };
    /**
     * Create an array from a start and end number.
     * @param  {Number} start
     * @param  {Number} end
     * @return {Array}
     */
    var getRange = function getRange(start, end) {
        var arr = [];
        // decide how this array shall be sorted

        if (start < end) {
            for (; start <= end; start++) {
                arr.push(padNumber(start));
            }
        } else {
            for (; start >= end; start--) {
                arr.push(padNumber(start));
            }
        }
        return arr;
    };

    return {
        template: _template2['default'],
        scope: {
            pi: '=?'
        },

        controller: ['$scope', function ($scope) {

            $scope.init = function () {
                var thisYear = new Date().getFullYear();

                $scope.days = getRange(1, 31);
                $scope.months = getRange(1, 12);
                $scope.years = getRange(thisYear - 18, thisYear - 110);
            };
            $scope.init();
        }]
    };
});

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-nationalid/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"dobNationalId\" class=\"dobNatlIdGroup fieldGroup clearfix\" content>\n\n    <div id=\"dobSelect\" class=\"dob bankField restricted\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('applyForBml.bmlApplyDateOfBirth')}}</legend>\n\n            <div class=\"dropdown fidobMonth inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"pi.month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months track by $index\" value=\"{{month}}\" ng-selected=\"pi.month === '{{month}}'\">{{month}}</option>\n                </select>\n                <label for=\"dobMonth\">\n                    {{content('applyForBml.bmlApplyMM')}}\n                </label>\n            </div>\n\n            <div class=\"dropdown fidobDay inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobDay\" ng-model=\"pi.day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days track by $index\" value=\"{{day}}\" ng-selected=\"pi.day === '{{day}}'\">{{day}}</option>\n                </select>\n                <label for=\"dobDay\">\n                    {{content('applyForBml.bmlApplyDD')}}\n                </label>\n            </div>\n\n            <div class=\"dropdown fidobYear inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobYear\" ng-model=\"pi.year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years track by $index\" value=\"{{year}}\" ng-selected=\"pi.year === '{{year}}'\">{{year}}</option>\n                </select>\n                <label for=\"dobYear\">\n                    {{content('applyForBml.bmlApplyYYYY')}}\n                </label>\n            </div>\n\n        </fieldset>\n    </div>\n\n    <div class=\"inputField confidential nationalId\" floating-label>\n        <input ng-model=\"pi.natId\" name=\"nationalId\" id=\"nationalId\" value=\"\" pattern=\"\\d{4}\" maxlength=\"4\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('applyForBml.lastFour') }}\" xo-error-tooltip required />\n        <label for=\"nationalId\">{{ content('applyForBml.bmlApplyLast4SSN') }}</label>\n        <xo-tooltip trigger=\"#nationalId\" show-event=\"click\">\n            {{ content('applyForBml.bmlApplyToolTipSSN') }}\n        </xo-tooltip>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/emailInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/emailInput/styles.less");

var _template = __webpack_require__("../node_modules/xo-form-components/src/emailInput/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoEmailInput', {
    tag: 'xo-email-input',
    template: _template2['default'],
    props: {
        user: {
            type: 'var',
            required: false
        },
        disabled: {
            type: 'var',
            required: false
        },
        hideHelper: {
            type: 'var', // flow: Optional string, if "signup" then use the Signup tooltip
            required: false
        },
        flags: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            this.flags = this.flags ? this.flags : {};
        }
    }
});


_squid.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/emailInput/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/emailInput/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"inputField emailField confidential\" content floating-label directionality>\n    <input ng-model=\"user.email\" id=\"email\" name=\"email\" type=\"email\" value=\"\" autocapitalize=\"off\"\n           aria-required=\"false\" xo-validation='{ \"validator\": \"validEmail\" }' autocomplete=\"off\"\n           data-error-key='email.invalid'\n           track-focus-and-blur=\"email\"\n           ng-disabled=\"disabled\" xo-error-tooltip required />\n    <div class=\"emailHelper\" ng-if=\"!hideHelper\">\n        <a id=\"verifyHelp\"\n           class=\"verifyHelp\"\n           aria-label=\"{{ content('email.whyTooltip') }}\"\n           href=\"javascript:void(0)\">\n        </a>\n    </div>\n    <label for=\"email\">\n        {{ content('index.EmailLabel') }}\n    </label>\n    <xo-tooltip trigger=\"#verifyHelp\" ng-switch=\"flags.mode\" ng-if=\"!hideHelper\">\n        <div id=\"emailToolTipText\" class=\"tip tipDesc emailToolTip\">\n            <span data-type=\"signup_email_tooltip\" ng-switch-when=\"signup\">\n                {{ content('common.emailHelper') }}\n            </span>\n            <span data-type=\"guest_email_tooltip\" ng-switch-default>\n                {{ content('common.emailTooltipGuest') }}\n            </span>\n        </div>\n    </xo-tooltip>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.VALID_DIRECTION = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/language-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VALID_DIRECTION = exports.VALID_DIRECTION = ['top', 'bottom'];
var isValidDirection = function isValidDirection(n) {
    return VALID_DIRECTION.includes(n);
};

angular.module().directive('xoLanguageOptions', function () {
    return {
        template: _template2['default'],

        scope: {
            direction: '@?'
        },

        controller: ['$scope', function ($scope) {
            $scope.direction = isValidDirection($scope.direction) ? $scope.direction : 'bottom';
            $scope.showLanguages = false;

            function setLanguageVars() {
                $scope.localeModel = _squid.$locale;
                $scope.currentLanguage = $scope.localeModel.lang;
                $scope.currentCountry = $scope.localeModel.country;
                $scope.languageList = $scope.localeModel.metadata.languageLabel;
                $scope.supportedLanguages = _squid.$config.supportedCountries[$scope.currentCountry];
                $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
            }

            $scope.selectLanguage = function (language) {
                $scope.currentLanguage = language;
                _squid.$locale.chooseLang(language);
            };

            $scope.toggle = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.showLanguages = !$scope.showLanguages;
            };

            setLanguageVars();

            // Reset locale properties for languageToggle
            $scope.$on('localeChange', function () {
                setLanguageVars();
            });

            // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
            $scope.$on('clickBody', function ($event, target) {
                if ($(target).parents('.languageToggleDisplay div').length === 0) {
                    $scope.showLanguages = false;
                    $scope.$apply();
                }
            });
        }]
    };
});

_squid.$config;

_squid.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"{{ direction }}\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages track by $index\" lang=\"{{ lang }}\">\n                    <a track-link=\"language_change\" class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/name-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/name-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoNameInput', {
    tag: 'xo-name-input',

    template: _template2['default'],

    props: {
        attrPrefix: {
            required: false,
            type: 'var'
        },
        country: {
            required: false,
            type: 'str'
        },
        user: {
            required: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.metadata = _squid.$MetadataModel.create();

            var handleCountryChange = function handleCountryChange() {
                _this.metadata.choose(_this.country || _squid.$locale.country, _squid.$locale.lang);
            };

            this.$watch('country', handleCountryChange);
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$MetadataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/name-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fieldGroup name clearfix\" ng-class=\"country || locale.country\" content>\n    <div ng-if=\"metadata.nameEntry.layout\" ng-repeat=\"layoutItem in metadata.nameEntry.layout track by $index\">\n        <!-- First name -->\n        <div ng-if=\"layoutItem.$ === 'givenName'\">\n            <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" data-test-id=\"first-name-container\" floating-label disable-autoblur directionality>\n                <input ng-model=\"user.first_name\"\n                        id=\"firstName\"\n                        name=\"firstName\"\n                        prefix-attrs-with=\"{{attrPrefix}}\"\n                        value=\"\"\n                        pattern=\"(?!^\\d+$)^.+$\"\n                        autocapitalize=\"off\"\n                        aria-required=\"false\"\n                        autocomplete=\"off\"\n                        maxlength=\"100\"\n                        xo-error-tooltip\n                        track-focus-and-blur=\"firstName\"\n                        ng-required=\"{{layoutItem.required}}\"\n                        data-test-id=\"user.first_name\" />\n                <label for=\"firstName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                    {{content('common.firstName')}}\n                </label>\n            </div>\n        </div>\n\n        <!-- Last name -->\n        <div ng-if=\"layoutItem.$ === 'surname'\">\n            <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" data-test-id=\"last-name-container\" floating-label directionality>\n                <input ng-model=\"user.last_name\"\n                        id=\"lastName\"\n                        name=\"lastName\"\n                        prefix-attrs-with=\"{{attrPrefix}}\"\n                        value=\"\"\n                        pattern=\"(?!^\\d+$)^.+$\"\n                        autocapitalize=\"off\"\n                        aria-required=\"false\"\n                        autocomplete=\"off\"\n                        maxlength=\"100\"\n                        xo-error-tooltip\n                        track-focus-and-blur=\"lastName\"\n                        ng-required=\"{{layoutItem.required}}\"\n                        data-test-id=\"user.last_name\" />\n                <label for=\"lastName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                    {{content('common.lastName')}}\n                </label>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"!metadata.nameEntry.layout\">\n        <!-- First name -->\n        <div class=\"inputField half confidential\" floating-label disable-autoblur directionality>\n            <input ng-model=\"user.first_name\"\n                    id=\"firstName\"\n                    name=\"firstName\"\n                    prefix-attrs-with=\"{{attrPrefix}}\"\n                    value=\"\"\n                    pattern=\"(?!^\\d+$)^.+$\"\n                    autocapitalize=\"off\"\n                    aria-required=\"false\"\n                    autocomplete=\"off\"\n                    maxlength=\"100\"\n                    xo-error-tooltip\n                    ng-required=\"true\"\n                    track-focus-and-blur=\"firstName\"\n                    data-test-id=\"user.first_name\" />\n            <label for=\"firstName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                {{content('common.firstName')}}\n            </label>\n        </div>\n\n        <!-- Last name -->\n        <div class=\"inputField half confidential last-child\" floating-label directionality>\n            <input ng-model=\"user.last_name\"\n                    id=\"lastName\"\n                    name=\"lastName\"\n                    prefix-attrs-with=\"{{attrPrefix}}\"\n                    value=\"\"\n                    pattern=\"(?!^\\d+$)^.+$\"\n                    autocapitalize=\"off\"\n                    aria-required=\"false\"\n                    autocomplete=\"off\"\n                    maxlength=\"100\"\n                    xo-error-tooltip\n                    ng-required=\"true\"\n                    track-focus-and-blur=\"lastName\"\n                    data-test-id=\"user.last_name\" />\n            <label for=\"lastName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                {{content('common.lastName')}}\n            </label>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/national-id-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().directive('brIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {
            scope.cpfValidator = function cpfValidator(ngModelValue) {
                var value = ngModelValue.replace(/[^0-9]/gi, '');
                var len = value.length;

                if (len !== 11) {
                    ctrl.$setValidity('nationalId', false);
                    return ngModelValue;
                }

                var x = value.match(/\b(\d)\1+\b/);

                if (x) {
                    ctrl.$setValidity('nationalId', false);
                    return ngModelValue;
                }

                var v1 = 0;
                var v2 = 0;
                var dv1;
                var dv2;
                var i;
                var j;

                for (i = 0, j = 10; i < 9, j > 1; i++, j--) {
                    // eslint-disable-line no-sequences
                    v1 += j * +value[i];
                }

                v1 = v1 % 11;
                dv1 = 11 - v1 < 10 ? 11 - v1 : 0;

                for (i = 0, j = 11; i < 9, j > 2; i++, j--) {
                    // eslint-disable-line no-sequences
                    v2 += j * +value[i];
                }

                v2 += dv1 * 2;
                v2 = v2 % 11;
                dv2 = 11 - v2 < 10 ? 11 - v2 : 0;

                scope.isValid = dv1 === parseInt(value[9], 10) && dv2 === parseInt(value[10], 10);

                ctrl.$setValidity('nationalId', scope.isValid);

                return ngModelValue;
            };

            ctrl.$parsers.push(scope.cpfValidator);
        }
    };
}).directive('sgIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {
            scope.nricFinValidator = function nricFinValidator(ngModelValue) {
                var idType = scope.$parent.nationalIdModel.nationalId.type;

                if (idType === 'NATIONAL_ID') {
                    scope.isValid = false;

                    // Valid if first char is "S", "T", "F" or "G" and the rest 7 are digits followed by a letter.
                    if (ngModelValue.match(/^[SFTG]\d{7}[A-Z]$/)) {
                        scope.isValid = true;
                    }
                } else {
                    scope.isValid = true;
                }
                ctrl.$setValidity('nationalId', scope.isValid);
                return ngModelValue;
            };
            ctrl.$parsers.push(scope.nricFinValidator);
        }
    };
}).directive('ruIdValidations', function () {
    return {
        require: 'ngModel',

        link: function link(scope, element, attr, ctrl) {

            function validateSNILSChunk(sum, checksum) {
                if (sum < 100 && sum === checksum) {
                    return true;
                } else if ((sum === 100 || sum === 101) && checksum === 0) {
                    return true;
                } else if (sum > 101) {
                    var remainder = sum % 101;

                    return validateSNILSChunk(remainder, checksum);
                }

                return false;
            }

            function validateSNILS(value) {
                if (value.length === 11) {
                    if (Number(value) > 1001998) {
                        var snilsNumber = value.substring(0, 9);
                        var checksum = Number(value.substring(9));
                        var sum = 0;
                        var multiplier = 1;

                        for (var i = snilsNumber.length - 1; i >= 0; i--) {
                            sum = sum + Number(snilsNumber.charAt(i)) * multiplier;
                            multiplier++;
                        }

                        return validateSNILSChunk(sum, checksum);
                    }

                    return true;
                }

                return false;
            }

            function validateINNChecksum(value, factor, valueLength, match) {
                var n;
                var sumn = 0;

                for (var i = 0; i < valueLength; i++) {
                    sumn = sumn + Number(value[i]) * Number(factor[i]);
                }
                n = sumn % 11;
                n = n === 10 ? 0 : n;

                if (n !== Number(match)) {
                    return false;
                }

                return true;
            }

            function validateINN(value) {
                if (value.length === 12) {
                    var factor = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

                    if (!validateINNChecksum(value, factor, value.length - 2, value[10])) {
                        return false;
                    }

                    factor.unshift(3);

                    if (!validateINNChecksum(value, factor, value.length - 1, value[11])) {
                        return false;
                    }

                    return true;
                }

                return false;
            }

            function validateOMS(value) {
                if (value.length >= 11 && value.length <= 16) {
                    return true;
                }

                return false;
            }

            scope.idValidator = function idValidator(ngModelValue) {
                var value = ngModelValue.replace(/[^0-9]/gi, '');
                var secondaryType = scope.nationalIdModel.secondaryIdType;

                if (secondaryType === 'SNILS') {
                    scope.isValid = validateSNILS(value);
                } else if (secondaryType === 'INN') {
                    scope.isValid = validateINN(value);
                } else if (secondaryType === 'OMS') {
                    scope.isValid = validateOMS(value);
                }

                ctrl.$setValidity('secondaryId', scope.isValid);

                return ngModelValue;
            };

            ctrl.$parsers.push(scope.idValidator);
        }
    };
}).directive('xoNationalIdInput', function () {
    return {
        template: _template2['default'],
        scope: {
            user: '=?',
            country: '@?'
        },

        link: function link(scope, element, attr) {
            var passportMask = '0000000000';

            element.on('keyup', function (event) {
                if (scope.user.countryOfResidence === 'RU') {
                    $('#nationalId').mask(passportMask, {
                        'translation': {
                            0: { pattern: /[0-9]/ }
                        }
                    });
                } else {
                    $('#nationalId').unmask(passportMask);
                }
            });
        },

        controller: ['$scope', '$NationalIdModel', function ($scope, $NationalIdModel) {

            $scope.nationalIdModel = $NationalIdModel.instance(_angular.$rootScope.token);
            $scope.checkoutCart = _index.$CheckoutCartModel.instance(_angular.$rootScope.token);
            $scope.user = $scope.user || {};
            $scope.user.countryOfResidence = $scope.user.countryOfResidence || $scope.country;
            $scope.formattedValues = {};
            $scope.showNationalIdFields = false;

            if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.tax_id) {
                $scope.nationalIdModel.nationalId.value = $scope.checkoutCart.payer.tax_id;
            }

            $scope.countryChanged = function () {
                if ($scope.user.countryOfResidence === 'RU') {
                    $scope.showNationalIdFields = true;
                    $scope.minLengthNatId = 10;
                    $scope.maxLengthNatId = 10;
                } else {
                    $scope.showNationalIdFields = false;
                    $scope.minLengthNatId = 6;
                    $scope.maxLengthNatId = 15;
                }
            };

            $scope.cpfMasking = function (newValue) {
                if (newValue) {
                    var unformatted = newValue.replace(/[^0-9]/gi, '');
                    var formatted = [['', unformatted.slice(0, 3)], ['.', unformatted.slice(3, 6)], ['.', unformatted.slice(6, 9)], ['-', unformatted.slice(9)]].map(function (x) {
                        return x[1] && x[0] + x[1] || '';
                    }).join('');

                    $scope.formattedValues.nationalId = formatted;
                    $scope.nationalIdModel.nationalId.value = unformatted;
                } else {
                    $scope.nationalIdModel.nationalId.value = '';
                }
            };

            $scope.secondaryIdFormatting = function () {
                var $el = $('#idValue');

                if ($scope.nationalIdModel.secondaryIdType === 'SNILS' && $el.length > 0) {
                    var unformatted = $el.val().replace(/[^0-9]/gi, '');
                    var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3, 6)], ['-', unformatted.slice(6, 9)], [' ', unformatted.slice(9)]].map(function (x) {
                        return x[1] && x[0] + x[1] || '';
                    }).join('');

                    $scope.nationalIdModel.secondaryIdValue = formatted;
                }
            };

            $scope.secondaryIdChange = function () {
                var currentSecondaryId = $scope.secondaryIds[$scope.nationalIdModel.secondaryIdType];

                $scope.nationalIdModel.secondaryIdValue = '';
                $scope.maxLength = currentSecondaryId.length;
                $scope.minLength = currentSecondaryId.minlength ? currentSecondaryId.minlength : currentSecondaryId.length;

                $scope.maskCharLength = currentSecondaryId.maskCharLength ? currentSecondaryId.maskCharLength : 0;
            };

            $scope.sgIdChange = function () {
                $scope.nationalIdModel.nationalId.value = '';
            };

            function setLocalizedNatIDLabels() {
                $scope.nationalIds = {
                    'PASSPORT': { name: 'PASSPORT_NUMBER', value: _squid.$locale.content.addTaxId.passport }
                };

                // National ID is not shown for South Korea
                if (_squid.$locale.country !== 'KR') {
                    $scope.nationalIds.NATID = { name: 'NATIONAL_ID', value: _squid.$locale.content.addTaxId.natid };
                }

                // ID type change from “Driver’s License” to “TEMPORARY_NATIONAL_ID” for HK only,
                // other countries show "Driver’s License" in th national ID drop down
                if (_squid.$locale.country === 'HK' && (0, _squid.$feature)('driverLicenseToTempNationalID', false, _squid.$locale.country)) {
                    $scope.nationalIds.TNID = { name: 'TEMPORARY_NATIONAL_ID', value: _squid.$locale.content.addTaxId.tnid };
                } else {
                    $scope.nationalIds.DL = { name: 'DRIVERS_LICENSE', value: _squid.$locale.content.addTaxId.dl };
                }
            }

            function setLocalizedRUContent() {
                $scope.countries = _squid.$locale.metadata.territory;
                $scope.secondaryIds = {
                    'INN': { name: 'INN', value: _squid.$locale.content.addTaxId.INN, length: 12 },
                    'SNILS': { name: 'SNILS', value: _squid.$locale.content.addTaxId.SNILS, length: 14, maskCharLength: 3 }
                };
            }

            if (_squid.$locale.country === 'BR') {
                $scope.nationalIdModel.nationalId.type = 'TAX_ID';
                $scope.nationalIdModel.nationalId.subType = 'CPF';

                $scope.cpfMasking($scope.nationalIdModel.nationalId.value);
            } else if ($scope.country === 'RU') {
                setLocalizedRUContent();
                $scope.nationalIdModel.nationalId.type = 'PASSPORT';
                $scope.nationalIdModel.nationalId.subType = '';
                $scope.user.nativeName = $scope.user.nativeName || {};

                if (!$scope.nationalIdModel.secondaryIdType) {
                    $scope.nationalIdModel.secondaryIdType = $scope.secondaryIds.INN.name;
                }

                $scope.secondaryIdChange();

                $scope.countryChanged();
            } else if ($scope.country === 'KR') {
                $scope.nationalIds = {
                    'PASSPORT': { name: 'PASSPORT_NUMBER', value: _squid.$locale.content.addTaxId.passport },
                    'DL': { name: 'DRIVERS_LICENSE', value: _squid.$locale.content.addTaxId.dl }
                };
                $scope.nationalIdModel.nationalId.type = 'PASSPORT_NUMBER';
                $scope.nationalIdModel.nationalId.subType = '';
            } else {
                // Default behaviour - set to 3pl countries
                setLocalizedNatIDLabels();
                $scope.nationalIdModel.nationalId.type = 'NATIONAL_ID';
                $scope.nationalIdModel.nationalId.subType = '';
            }

            $scope.$on('contentChange', function () {
                setLocalizedNatIDLabels();

                if ($scope.country === 'RU') {
                    setLocalizedRUContent();
                }
            });
        }]
    };
}).factory('$NationalIdModel', function () {

    return _squid.$Model.extend('NationalIdModel', {

        init: function init() {
            this._super.init.apply(this);
            this.nationalId = this.nationalId || {};
        },

        serialize: function serialize() {
            return this.nationalId;
        }
    });
});

_angular.$rootScope;

_squid.$feature;

_squid.$locale;

_squid.$Model;

_index.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-form-components/src/national-id-input", "../node_modules/xo-form-components/src/national-id-input/directive.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/national-id-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"nationalIdFields\" class=\"clearfix\" content>\n    <div class=\"bankField restricted\">\n        <div ng-switch=\"country\">\n            <div ng-switch-when=\"SG\">\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            ng-change=\"sgIdChange()\"\n                            aria-required=\"true\">\n                        <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           valid-letters=\"data.validLetters\"\n                           sg-id-validations\n                           required/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n            </div>\n\n            <div ng-switch-when=\"BR\">\n\n                <div class=\"inputField confidential nationalId\" floating-label directionality>\n                    <input ng-model=\"formattedValues.nationalId\"\n                           name=\"nationalId\"\n                           id=\"nationalId\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           xo-error-tooltip\n                           br-id-validations\n                           maxlength=\"14\"\n                           ng-change=\"cpfMasking(formattedValues.nationalId)\"\n                           required/>\n                    <label for=\"nationalId\">{{content('addTaxId.cpf')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"KR\">\n\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            aria-required=\"false\">\n                        <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"false\"\n                           autocomplete=\"off\"/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"RU\">\n\n                <div class=\"nationalId\">\n                    <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"country\" ng-model=\"user.countryOfResidence\" id=\"country\"\n                                        aria-labelledby=\"countryLabel\" ng-change=\"countryChanged()\" xo-error-tooltip required>\n                            <option ng-repeat=\"country in countries track by $index\" value=\"{{country.code}}\" ng-selected=\"user.countryOfResidence === country.code\">{{country.name}}</option>\n                        </select>\n                        <label for=\"country\" id=\"countryLabel\">{{content('common.country')}}</label>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <xo-name-input user=\"user.nativeName\"></xo-name-input>\n\n                        <div class=\"inputField confidential full\" floating-label directionality>\n                            <input ng-model=\"user.nativeName.middle_name\"\n                                   name=\"middleName\"\n                                   id=\"middleName\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   required />\n                            <label for=\"middleName\" id=\"middleNameLabel\">{{content('common.middleName')}}</label>\n                        </div>\n                    </div>\n\n                    <div class=\"inputField full\" floating-label directionality>\n                        <input ng-model=\"nationalIdModel.nationalId.value\"\n                                name=\"nationalId\"\n                                id=\"nationalId\"\n                                value=\"\"\n                                autocapitalize=\"off\"\n                                aria-required=\"true\"\n                                autocomplete=\"off\"\n                                minlength=\"{{minLengthNatId}}\"\n                                maxlength=\"{{maxLengthNatId}}\"\n                                placeholder=\"{{user.countryOfResidence === 'RU' && content('addTaxId.passportRU') || content('addTaxId.passportEN')}}\"\n                                xo-validation='{\"validator\": \"validRUPassport\"}'\n                                xo-error-tooltip\n                                required />\n\n                        <label for=\"nationalId\">{{content('addTaxId.passport')}}</label>\n                    </div>\n\n                    <xo-dob-input user=\"user\"></xo-dob-input>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <legend class=\"fieldLegend\" for=\"additionalId\">{{content('addTaxId.additionalInfo')}}\n                            <div class=\"additionalIdHelper\">\n                                <a href=\"#\" id=\"verifyHelpAdditionalId\" alt=\"Why do we need this\" class=\"verifyHelp\"></a>\n                            </div>\n                            <div class=\"lineSpacing\">\n                                <xo-tooltip trigger=\"#verifyHelpAdditionalId\">\n                                    <div class=\"tip tipDesc\">\n                                        {{content('addTaxId.additionalInfoNote')}}\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                        </legend>\n\n                        <div id=\"additionalId\">\n                            <div class=\"dropdown inputField\" floating-label-dropdown>\n                                <select xo-dropdown name=\"idType\"\n                                        ng-model=\"nationalIdModel.secondaryIdType\"\n                                        id=\"idType\"\n                                        aria-label=\"{{ content('signup.accountCreationGuest.dobDay') }}\"\n                                        ng-change=\"secondaryIdChange()\"\n                                        aria-required=\"true\">\n                                    <option ng-repeat=\"items in secondaryIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.secondaryIdType === '{{items.name}}'\">{{items.value}}</option>\n                                </select>\n                                <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                            </div>\n\n                            <div class=\"inputField\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.secondaryIdValue\"\n                                       name=\"idValue\"\n                                       id=\"idValue\"\n                                       value=\"\"\n                                       maxlength=\"{{maxLength}}\"\n                                       minlength=\"{{minLength}}\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       placeholder=\"{{(maxLength - maskCharLength)}} {{content('addTaxId.digits')}}\"\n                                       required\n                                       ru-id-validations\n                                       ng-change=\"secondaryIdFormatting()\"/>\n                                <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-switch-default>\n              <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                  <select xo-dropdown name=\"idType\"\n                          ng-model=\"nationalIdModel.nationalId.type\"\n                          id=\"idType\"\n                          aria-required=\"true\">\n                      <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                  </select>\n                  <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n              </div>\n\n              <div class=\"inputField nationalIDValue\" floating-label directionality>\n                  <input ng-model=\"nationalIdModel.nationalId.value\"\n                         name=\"idValue\"\n                         id=\"idValue\"\n                         class=\"additionalIDBox\"\n                         value=\"\"\n                         autocapitalize=\"off\"\n                         aria-required=\"true\"\n                         autocomplete=\"off\"\n                         required/>\n                  <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n              </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddPhone', function () {
    return {
        template: _template2['default'],
        scope: {},
        controller: ['$scope', function ($scope) {

            $scope.showPhoneDisclosure = (0, _squid.$featureCountries)('showPhoneDisclosure').indexOf(_squid.$locale.country) > -1;
            $scope.phoneConsent = (0, _squid.$feature)('phoneConsent');
            $scope.consentContentKey = $scope.phoneConsent ? 'addPhone.phoneConsent' : 'addPhone.phoneDisclosure';
            $scope.errorMessage = {
                msgKeys: ['addPhone.addPhoneNumberConsent'],
                type: 'info'
            };

            $scope.userInfo = _index2.$UserInfoModel.instance(_angular.$rootScope.token);
            $scope.phone = {};

            var CONTENT_KEY = {
                INVALID_PHONE_NUMBER: 'validPhone'
            };

            var CONTENT_MAPPING = {
                numberError: CONTENT_KEY.INVALID_PHONE_NUMBER,
                typeError: CONTENT_KEY.INVALID_PHONE_NUMBER
            };

            var populateErrorMessage = function populateErrorMessage(name) {
                var contentKey = CONTENT_MAPPING[name];
                var msg = contentKey ? _squid.$locale.content.get('scripts.' + contentKey) : 'unresolved content for login error ' + name;

                $scope.errorMessage = {
                    msgs: [msg],
                    type: 'error'
                };
            };

            var validationErrorHandler = {
                numberError: populateErrorMessage,
                typeError: populateErrorMessage
            };

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {

                $scope.logout = function () {
                    _logger.$logger.info('not_you_logout');
                    $scope.auth.action('logout').then(function () {
                        _uiRouter.$state.go('checkout.login');
                    });
                };

                $scope.showNotYou = $scope.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && $scope.logout;

                $scope.onSubmit = function () {
                    if ($scope.phoneConsent) {
                        $scope.phone.consent = {
                            agreed: true,
                            contentId: _squid.$locale.country + ':' + _squid.$locale.lang + ':' + $scope.consentContentKey + ':' + (0, _squid.$contentVersion)()
                        };
                    }
                    $scope.userInfo.action('addPhone', {

                        data: $scope.phone,

                        success: function success(data) {
                            return _index.$CheckoutSessionModel.instance(_angular.$rootScope.token).action('create', {
                                success: function success() {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        },

                        contingencies: {
                            NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                                _angular.$location.path('/checkout/addCard');
                            },

                            EXPIRED_CREDIT_CARD: function EXPIRED_CREDIT_CARD() {
                                _angular.$location.path('/checkout/updateCard');
                            }
                        },

                        validation: function validation(data) {
                            angular.forEach(data, function (value, key) {
                                validationErrorHandler[key](key);
                            });
                        }
                    });
                };
            });
        }]
    };
});

_angular.$rootScope;

_angular.$location;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$util;

_squid.$featureCountries;

_squid.$contentVersion;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutSessionModel;

_index2.$UserInfoModel;

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/lib/territoriesByCode.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return {
        'AC': {
            'status': 'reserved',
            'phoneCountryCode': '247',
            'showCountryCodeList': false
        },
        'AD': {
            'status': 'assigned',
            'phoneCountryCode': '376',
            'showCountryCodeList': false
        },
        'AE': {
            'status': 'assigned',
            'phoneCountryCode': '971',
            'showCountryCodeList': false
        },
        'AF': {
            'status': 'assigned',
            'phoneCountryCode': '93',
            'showCountryCodeList': false
        },
        'AG': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AI': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AL': {
            'status': 'assigned',
            'phoneCountryCode': '355',
            'showCountryCodeList': false
        },
        'AM': {
            'status': 'assigned',
            'phoneCountryCode': '374',
            'showCountryCodeList': false
        },
        'AN': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'AO': {
            'status': 'assigned',
            'phoneCountryCode': '244',
            'showCountryCodeList': false
        },
        'AQ': {
            'status': 'assigned',
            'phoneCountryCode': '672',
            'showCountryCodeList': false
        },
        'AR': {
            'status': 'assigned',
            'phoneCountryCode': '54',
            'showCountryCodeList': false
        },
        'AS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AT': {
            'status': 'assigned',
            'phoneCountryCode': '43',
            'showCountryCodeList': true
        },
        'AU': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': true
        },
        'AW': {
            'status': 'assigned',
            'phoneCountryCode': '297',
            'showCountryCodeList': false
        },
        'AZ': {
            'status': 'assigned',
            'phoneCountryCode': '994',
            'showCountryCodeList': false
        },
        'BA': {
            'status': 'assigned',
            'phoneCountryCode': '387',
            'showCountryCodeList': false
        },
        'BB': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BD': {
            'status': 'assigned',
            'phoneCountryCode': '880',
            'showCountryCodeList': false
        },
        'BE': {
            'status': 'assigned',
            'phoneCountryCode': '32',
            'showCountryCodeList': true
        },
        'BF': {
            'status': 'assigned',
            'phoneCountryCode': '226',
            'showCountryCodeList': false
        },
        'BG': {
            'status': 'assigned',
            'phoneCountryCode': '359',
            'showCountryCodeList': false
        },
        'BH': {
            'status': 'assigned',
            'phoneCountryCode': '973',
            'showCountryCodeList': false
        },
        'BI': {
            'status': 'assigned',
            'phoneCountryCode': '257',
            'showCountryCodeList': false
        },
        'BJ': {
            'status': 'assigned',
            'phoneCountryCode': '229',
            'showCountryCodeList': false
        },
        'BL': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'BM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BN': {
            'status': 'assigned',
            'phoneCountryCode': '673',
            'showCountryCodeList': false
        },
        'BO': {
            'status': 'assigned',
            'phoneCountryCode': '591',
            'showCountryCodeList': false
        },
        'BQ': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'BR': {
            'status': 'assigned',
            'phoneCountryCode': '55',
            'showCountryCodeList': false
        },
        'BS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BT': {
            'status': 'assigned',
            'phoneCountryCode': '975',
            'showCountryCodeList': false
        },
        'BV': {
            'status': 'assigned'
        },
        'BW': {
            'status': 'assigned',
            'phoneCountryCode': '267',
            'showCountryCodeList': false
        },
        'BY': {
            'status': 'assigned',
            'phoneCountryCode': '375',
            'showCountryCodeList': false
        },
        'BZ': {
            'status': 'assigned',
            'phoneCountryCode': '501',
            'showCountryCodeList': false
        },
        'C2': {
            'status': 'assigned',
            'phoneCountryCode': '86',
            'showCountryCodeList': false
        },
        'CA': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'CC': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': false
        },
        'CD': {
            'status': 'assigned',
            'phoneCountryCode': '243',
            'showCountryCodeList': false
        },
        'CF': {
            'status': 'assigned',
            'phoneCountryCode': '236',
            'showCountryCodeList': false
        },
        'CG': {
            'status': 'assigned',
            'phoneCountryCode': '242',
            'showCountryCodeList': false
        },
        'CH': {
            'status': 'assigned',
            'phoneCountryCode': '41',
            'showCountryCodeList': true
        },
        'CI': {
            'status': 'assigned',
            'phoneCountryCode': '225',
            'showCountryCodeList': false
        },
        'CK': {
            'status': 'assigned',
            'phoneCountryCode': '682',
            'showCountryCodeList': false
        },
        'CL': {
            'status': 'assigned',
            'phoneCountryCode': '56',
            'showCountryCodeList': false
        },
        'CM': {
            'status': 'assigned',
            'phoneCountryCode': '237',
            'showCountryCodeList': false
        },
        'CN': {
            'status': 'assigned',
            'phoneCountryCode': '86',
            'showCountryCodeList': false
        },
        'CO': {
            'status': 'assigned',
            'phoneCountryCode': '57',
            'showCountryCodeList': false
        },
        'CR': {
            'status': 'assigned',
            'phoneCountryCode': '506',
            'showCountryCodeList': false
        },
        'CU': {
            'status': 'assigned',
            'phoneCountryCode': '53',
            'showCountryCodeList': false
        },
        'CV': {
            'status': 'assigned',
            'phoneCountryCode': '238',
            'showCountryCodeList': false
        },
        'CW': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'CX': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': false
        },
        'CY': {
            'status': 'assigned',
            'phoneCountryCode': '357',
            'showCountryCodeList': false
        },
        'CZ': {
            'status': 'assigned',
            'phoneCountryCode': '420',
            'showCountryCodeList': false
        },
        'DE': {
            'status': 'assigned',
            'phoneCountryCode': '49',
            'showCountryCodeList': false
        },
        'DJ': {
            'status': 'assigned',
            'phoneCountryCode': '253',
            'showCountryCodeList': false
        },
        'DK': {
            'status': 'assigned',
            'phoneCountryCode': '45',
            'showCountryCodeList': true
        },
        'DM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'DO': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'DZ': {
            'status': 'assigned',
            'phoneCountryCode': '213',
            'showCountryCodeList': false
        },
        'EC': {
            'status': 'assigned',
            'phoneCountryCode': '593',
            'showCountryCodeList': false
        },
        'EE': {
            'status': 'assigned',
            'phoneCountryCode': '372',
            'showCountryCodeList': false
        },
        'EG': {
            'status': 'assigned',
            'phoneCountryCode': '20',
            'showCountryCodeList': false
        },
        'EH': {
            'status': 'assigned',
            'phoneCountryCode': '212',
            'showCountryCodeList': false
        },
        'ER': {
            'status': 'assigned',
            'phoneCountryCode': '291',
            'showCountryCodeList': false
        },
        'ES': {
            'status': 'assigned',
            'phoneCountryCode': '34',
            'showCountryCodeList': false
        },
        'ET': {
            'status': 'assigned',
            'phoneCountryCode': '251',
            'showCountryCodeList': false
        },
        'FI': {
            'status': 'assigned',
            'phoneCountryCode': '358',
            'showCountryCodeList': false
        },
        'FJ': {
            'status': 'assigned',
            'phoneCountryCode': '679',
            'showCountryCodeList': false
        },
        'FK': {
            'status': 'assigned',
            'phoneCountryCode': '500',
            'showCountryCodeList': false
        },
        'FM': {
            'status': 'assigned',
            'phoneCountryCode': '691',
            'showCountryCodeList': false
        },
        'FO': {
            'status': 'assigned',
            'phoneCountryCode': '298',
            'showCountryCodeList': false
        },
        'FR': {
            'status': 'assigned',
            'phoneCountryCode': '33',
            'showCountryCodeList': false
        },
        'GA': {
            'status': 'assigned',
            'phoneCountryCode': '241',
            'showCountryCodeList': false
        },
        'GB': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'GD': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'GE': {
            'status': 'assigned',
            'phoneCountryCode': '995',
            'showCountryCodeList': false
        },
        'GF': {
            'status': 'assigned',
            'phoneCountryCode': '594',
            'showCountryCodeList': false
        },
        'GG': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'GH': {
            'status': 'assigned',
            'phoneCountryCode': '233',
            'showCountryCodeList': false
        },
        'GI': {
            'status': 'assigned',
            'phoneCountryCode': '350',
            'showCountryCodeList': false
        },
        'GL': {
            'status': 'assigned',
            'phoneCountryCode': '299',
            'showCountryCodeList': false
        },
        'GM': {
            'status': 'assigned',
            'phoneCountryCode': '220',
            'showCountryCodeList': false
        },
        'GN': {
            'status': 'assigned',
            'phoneCountryCode': '224',
            'showCountryCodeList': false
        },
        'GP': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'GQ': {
            'status': 'assigned',
            'phoneCountryCode': '240',
            'showCountryCodeList': false
        },
        'GR': {
            'status': 'assigned',
            'phoneCountryCode': '30',
            'showCountryCodeList': false
        },
        'GS': {
            'status': 'assigned',
            'phoneCountryCode': '500',
            'showCountryCodeList': false
        },
        'GT': {
            'status': 'assigned',
            'phoneCountryCode': '502',
            'showCountryCodeList': false
        },
        'GU': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'GW': {
            'status': 'assigned',
            'phoneCountryCode': '245',
            'showCountryCodeList': false
        },
        'GY': {
            'status': 'assigned',
            'phoneCountryCode': '592',
            'showCountryCodeList': false
        },
        'HK': {
            'status': 'assigned',
            'phoneCountryCode': '852',
            'showCountryCodeList': true
        },
        'HM': {
            'status': 'assigned'
        },
        'HN': {
            'status': 'assigned',
            'phoneCountryCode': '504',
            'showCountryCodeList': false
        },
        'HR': {
            'status': 'assigned',
            'phoneCountryCode': '385',
            'showCountryCodeList': false
        },
        'HT': {
            'status': 'assigned',
            'phoneCountryCode': '509',
            'showCountryCodeList': false
        },
        'HU': {
            'status': 'assigned',
            'phoneCountryCode': '36',
            'showCountryCodeList': false
        },
        'ID': {
            'status': 'assigned',
            'phoneCountryCode': '62',
            'showCountryCodeList': false
        },
        'IE': {
            'status': 'assigned',
            'phoneCountryCode': '353',
            'showCountryCodeList': false
        },
        'IL': {
            'status': 'assigned',
            'phoneCountryCode': '972',
            'showCountryCodeList': false
        },
        'IM': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'IN': {
            'status': 'assigned',
            'phoneCountryCode': '91',
            'showCountryCodeList': false
        },
        'IO': {
            'status': 'assigned',
            'phoneCountryCode': '246',
            'showCountryCodeList': false
        },
        'IQ': {
            'status': 'assigned',
            'phoneCountryCode': '964',
            'showCountryCodeList': false
        },
        'IR': {
            'status': 'assigned',
            'phoneCountryCode': '98',
            'showCountryCodeList': false
        },
        'IS': {
            'status': 'assigned',
            'phoneCountryCode': '354',
            'showCountryCodeList': false
        },
        'IT': {
            'status': 'assigned',
            'phoneCountryCode': '39',
            'showCountryCodeList': false
        },
        'JE': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'JM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'JO': {
            'status': 'assigned',
            'phoneCountryCode': '962',
            'showCountryCodeList': false
        },
        'JP': {
            'status': 'assigned',
            'phoneCountryCode': '81',
            'showCountryCodeList': false
        },
        'KE': {
            'status': 'assigned',
            'phoneCountryCode': '254',
            'showCountryCodeList': false
        },
        'KG': {
            'status': 'assigned',
            'phoneCountryCode': '996',
            'showCountryCodeList': false
        },
        'KH': {
            'status': 'assigned',
            'phoneCountryCode': '855',
            'showCountryCodeList': false
        },
        'KI': {
            'status': 'assigned',
            'phoneCountryCode': '686',
            'showCountryCodeList': false
        },
        'KM': {
            'status': 'assigned',
            'phoneCountryCode': '269',
            'showCountryCodeList': false
        },
        'KN': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'KP': {
            'status': 'assigned',
            'phoneCountryCode': '850',
            'showCountryCodeList': false
        },
        'KR': {
            'status': 'assigned',
            'phoneCountryCode': '82',
            'showCountryCodeList': false
        },
        'KW': {
            'status': 'assigned',
            'phoneCountryCode': '965',
            'showCountryCodeList': false
        },
        'KY': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'KZ': {
            'status': 'assigned',
            'phoneCountryCode': '7',
            'showCountryCodeList': false
        },
        'LA': {
            'status': 'assigned',
            'phoneCountryCode': '856',
            'showCountryCodeList': true
        },
        'LB': {
            'status': 'assigned',
            'phoneCountryCode': '961',
            'showCountryCodeList': false
        },
        'LC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'LI': {
            'status': 'assigned',
            'phoneCountryCode': '423',
            'showCountryCodeList': false
        },
        'LK': {
            'status': 'assigned',
            'phoneCountryCode': '94',
            'showCountryCodeList': false
        },
        'LR': {
            'status': 'assigned',
            'phoneCountryCode': '231',
            'showCountryCodeList': false
        },
        'LS': {
            'status': 'assigned',
            'phoneCountryCode': '266',
            'showCountryCodeList': false
        },
        'LT': {
            'status': 'assigned',
            'phoneCountryCode': '370',
            'showCountryCodeList': false
        },
        'LU': {
            'status': 'assigned',
            'phoneCountryCode': '352',
            'showCountryCodeList': false
        },
        'LV': {
            'status': 'assigned',
            'phoneCountryCode': '371',
            'showCountryCodeList': false
        },
        'LY': {
            'status': 'assigned',
            'phoneCountryCode': '218',
            'showCountryCodeList': false
        },
        'MA': {
            'status': 'assigned',
            'phoneCountryCode': '212',
            'showCountryCodeList': false
        },
        'MC': {
            'status': 'assigned',
            'phoneCountryCode': '377',
            'showCountryCodeList': false
        },
        'MD': {
            'status': 'assigned',
            'phoneCountryCode': '373',
            'showCountryCodeList': false
        },
        'ME': {
            'status': 'assigned',
            'phoneCountryCode': '382',
            'showCountryCodeList': false
        },
        'MF': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'MG': {
            'status': 'assigned',
            'phoneCountryCode': '261',
            'showCountryCodeList': false
        },
        'MH': {
            'status': 'assigned',
            'phoneCountryCode': '692',
            'showCountryCodeList': false
        },
        'MK': {
            'status': 'assigned',
            'phoneCountryCode': '389',
            'showCountryCodeList': false
        },
        'ML': {
            'status': 'assigned',
            'phoneCountryCode': '223',
            'showCountryCodeList': false
        },
        'MM': {
            'status': 'assigned',
            'phoneCountryCode': '95',
            'showCountryCodeList': false
        },
        'MN': {
            'status': 'assigned',
            'phoneCountryCode': '976',
            'showCountryCodeList': false
        },
        'MO': {
            'status': 'assigned',
            'phoneCountryCode': '853',
            'showCountryCodeList': false
        },
        'MP': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'MQ': {
            'status': 'assigned',
            'phoneCountryCode': '596',
            'showCountryCodeList': false
        },
        'MR': {
            'status': 'assigned',
            'phoneCountryCode': '222',
            'showCountryCodeList': false
        },
        'MS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'MT': {
            'status': 'assigned',
            'phoneCountryCode': '356',
            'showCountryCodeList': false
        },
        'MU': {
            'status': 'assigned',
            'phoneCountryCode': '230',
            'showCountryCodeList': false
        },
        'MV': {
            'status': 'assigned',
            'phoneCountryCode': '960',
            'showCountryCodeList': false
        },
        'MW': {
            'status': 'assigned',
            'phoneCountryCode': '265',
            'showCountryCodeList': false
        },
        'MX': {
            'status': 'assigned',
            'phoneCountryCode': '52',
            'showCountryCodeList': false
        },
        'MY': {
            'status': 'assigned',
            'phoneCountryCode': '60',
            'showCountryCodeList': false
        },
        'MZ': {
            'status': 'assigned',
            'phoneCountryCode': '258',
            'showCountryCodeList': false
        },
        'NA': {
            'status': 'assigned',
            'phoneCountryCode': '264',
            'showCountryCodeList': false
        },
        'NC': {
            'status': 'assigned',
            'phoneCountryCode': '687',
            'showCountryCodeList': false
        },
        'NE': {
            'status': 'assigned',
            'phoneCountryCode': '227',
            'showCountryCodeList': false
        },
        'NF': {
            'status': 'assigned',
            'phoneCountryCode': '672',
            'showCountryCodeList': false
        },
        'NG': {
            'status': 'assigned',
            'phoneCountryCode': '234',
            'showCountryCodeList': false
        },
        'NI': {
            'status': 'assigned',
            'phoneCountryCode': '505',
            'showCountryCodeList': false
        },
        'NL': {
            'status': 'assigned',
            'phoneCountryCode': '31',
            'showCountryCodeList': true
        },
        'NO': {
            'status': 'assigned',
            'phoneCountryCode': '47',
            'showCountryCodeList': true
        },
        'NP': {
            'status': 'assigned',
            'phoneCountryCode': '977',
            'showCountryCodeList': false
        },
        'NR': {
            'status': 'assigned',
            'phoneCountryCode': '674',
            'showCountryCodeList': false
        },
        'NU': {
            'status': 'assigned',
            'phoneCountryCode': '683',
            'showCountryCodeList': false
        },
        'NZ': {
            'status': 'assigned',
            'phoneCountryCode': '64',
            'showCountryCodeList': false
        },
        'OM': {
            'status': 'assigned',
            'phoneCountryCode': '968',
            'showCountryCodeList': false
        },
        'PA': {
            'status': 'assigned',
            'phoneCountryCode': '507',
            'showCountryCodeList': false
        },
        'PE': {
            'status': 'assigned',
            'phoneCountryCode': '51',
            'showCountryCodeList': false
        },
        'PF': {
            'status': 'assigned',
            'phoneCountryCode': '689',
            'showCountryCodeList': false
        },
        'PG': {
            'status': 'assigned',
            'phoneCountryCode': '675',
            'showCountryCodeList': false
        },
        'PH': {
            'status': 'assigned',
            'phoneCountryCode': '63',
            'showCountryCodeList': false
        },
        'PK': {
            'status': 'assigned',
            'phoneCountryCode': '92',
            'showCountryCodeList': false
        },
        'PL': {
            'status': 'assigned',
            'phoneCountryCode': '48',
            'showCountryCodeList': true
        },
        'PM': {
            'status': 'assigned',
            'phoneCountryCode': '508',
            'showCountryCodeList': false
        },
        'PN': {
            'status': 'assigned',
            'phoneCountryCode': '870',
            'showCountryCodeList': false
        },
        'PR': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'PS': {
            'status': 'assigned',
            'phoneCountryCode': '970',
            'showCountryCodeList': false
        },
        'PT': {
            'status': 'assigned',
            'phoneCountryCode': '351',
            'showCountryCodeList': false
        },
        'PW': {
            'status': 'assigned',
            'phoneCountryCode': '680',
            'showCountryCodeList': false
        },
        'PY': {
            'status': 'assigned',
            'phoneCountryCode': '595',
            'showCountryCodeList': false
        },
        'QA': {
            'status': 'assigned',
            'phoneCountryCode': '974',
            'showCountryCodeList': false
        },
        'RE': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'RO': {
            'status': 'assigned',
            'phoneCountryCode': '40',
            'showCountryCodeList': false
        },
        'RS': {
            'status': 'assigned',
            'phoneCountryCode': '381',
            'showCountryCodeList': false
        },
        'RU': {
            'status': 'assigned',
            'phoneCountryCode': '7',
            'showCountryCodeList': false
        },
        'RW': {
            'status': 'assigned',
            'phoneCountryCode': '250',
            'showCountryCodeList': false
        },
        'SA': {
            'status': 'assigned',
            'phoneCountryCode': '966',
            'showCountryCodeList': false
        },
        'SB': {
            'status': 'assigned',
            'phoneCountryCode': '677',
            'showCountryCodeList': false
        },
        'SC': {
            'status': 'assigned',
            'phoneCountryCode': '248',
            'showCountryCodeList': false
        },
        'SD': {
            'status': 'assigned',
            'phoneCountryCode': '249',
            'showCountryCodeList': false
        },
        'SE': {
            'status': 'assigned',
            'phoneCountryCode': '46',
            'showCountryCodeList': true
        },
        'SG': {
            'status': 'assigned',
            'phoneCountryCode': '65',
            'showCountryCodeList': true
        },
        'SH': {
            'status': 'assigned',
            'phoneCountryCode': '290',
            'showCountryCodeList': false
        },
        'SI': {
            'status': 'assigned',
            'phoneCountryCode': '386',
            'showCountryCodeList': false
        },
        'SJ': {
            'status': 'assigned',
            'phoneCountryCode': '47',
            'showCountryCodeList': false
        },
        'SK': {
            'status': 'assigned',
            'phoneCountryCode': '421',
            'showCountryCodeList': false
        },
        'SL': {
            'status': 'assigned',
            'phoneCountryCode': '232',
            'showCountryCodeList': false
        },
        'SM': {
            'status': 'assigned',
            'phoneCountryCode': '378',
            'showCountryCodeList': false
        },
        'SN': {
            'status': 'assigned',
            'phoneCountryCode': '221',
            'showCountryCodeList': false
        },
        'SO': {
            'status': 'assigned',
            'phoneCountryCode': '252',
            'showCountryCodeList': false
        },
        'SR': {
            'status': 'assigned',
            'phoneCountryCode': '597',
            'showCountryCodeList': false
        },
        'SS': {
            'status': 'assigned',
            'phoneCountryCode': '211',
            'showCountryCodeList': false
        },
        'ST': {
            'status': 'assigned',
            'phoneCountryCode': '239',
            'showCountryCodeList': false
        },
        'SV': {
            'status': 'assigned',
            'phoneCountryCode': '503',
            'showCountryCodeList': false
        },
        'SX': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'SY': {
            'status': 'assigned',
            'phoneCountryCode': '963',
            'showCountryCodeList': false
        },
        'SZ': {
            'status': 'assigned',
            'phoneCountryCode': '268',
            'showCountryCodeList': false
        },
        'TC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'TD': {
            'status': 'assigned',
            'phoneCountryCode': '235',
            'showCountryCodeList': false
        },
        'TF': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'TG': {
            'status': 'assigned',
            'phoneCountryCode': '228',
            'showCountryCodeList': false
        },
        'TH': {
            'status': 'assigned',
            'phoneCountryCode': '66',
            'showCountryCodeList': false
        },
        'TJ': {
            'status': 'assigned',
            'phoneCountryCode': '992',
            'showCountryCodeList': false
        },
        'TK': {
            'status': 'assigned',
            'phoneCountryCode': '690',
            'showCountryCodeList': false
        },
        'TL': {
            'status': 'assigned',
            'phoneCountryCode': '670',
            'showCountryCodeList': false
        },
        'TM': {
            'status': 'assigned',
            'phoneCountryCode': '993',
            'showCountryCodeList': false
        },
        'TN': {
            'status': 'assigned',
            'phoneCountryCode': '216',
            'showCountryCodeList': false
        },
        'TO': {
            'status': 'assigned',
            'phoneCountryCode': '676',
            'showCountryCodeList': false
        },
        'TR': {
            'status': 'assigned',
            'phoneCountryCode': '90',
            'showCountryCodeList': true
        },
        'TT': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'TV': {
            'status': 'assigned',
            'phoneCountryCode': '688',
            'showCountryCodeList': false
        },
        'TW': {
            'status': 'assigned',
            'phoneCountryCode': '886',
            'showCountryCodeList': true
        },
        'TZ': {
            'status': 'assigned',
            'phoneCountryCode': '255',
            'showCountryCodeList': false
        },
        'UA': {
            'status': 'assigned',
            'phoneCountryCode': '380',
            'showCountryCodeList': false
        },
        'UG': {
            'status': 'assigned',
            'phoneCountryCode': '256',
            'showCountryCodeList': false
        },
        'UM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'US': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false,
            'hideInOtherCountries': true
        },
        'UY': {
            'status': 'assigned',
            'phoneCountryCode': '598',
            'showCountryCodeList': false
        },
        'UZ': {
            'status': 'assigned',
            'phoneCountryCode': '998',
            'showCountryCodeList': false
        },
        'VA': {
            'status': 'assigned',
            'phoneCountryCode': '39',
            'showCountryCodeList': false
        },
        'VC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VE': {
            'status': 'assigned',
            'phoneCountryCode': '58',
            'showCountryCodeList': false
        },
        'VG': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VI': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VN': {
            'status': 'assigned',
            'phoneCountryCode': '84',
            'showCountryCodeList': false
        },
        'VU': {
            'status': 'assigned',
            'phoneCountryCode': '678',
            'showCountryCodeList': false
        },
        'WF': {
            'status': 'assigned',
            'phoneCountryCode': '681',
            'showCountryCodeList': false
        },
        'WS': {
            'status': 'assigned',
            'phoneCountryCode': '685',
            'showCountryCodeList': false
        },
        'YE': {
            'status': 'assigned',
            'phoneCountryCode': '967',
            'showCountryCodeList': false
        },
        'YT': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'ZA': {
            'status': 'assigned',
            'phoneCountryCode': '27',
            'showCountryCodeList': false
        },
        'ZM': {
            'status': 'assigned',
            'phoneCountryCode': '260',
            'showCountryCodeList': false
        },
        'ZW': {
            'status': 'assigned',
            'phoneCountryCode': '263',
            'showCountryCodeList': false
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPhoneInput', {
    tag: 'xo-phone-input',
    template: _template2['default'],

    props: {
        phone: {
            type: 'var',
            reqiured: false
        },

        showPhoneType: {
            type: 'var',
            optional: true,
            'default': true
        },

        hideWork: {
            type: 'var',
            optional: true,
            'default': false
        },

        token: {
            type: 'var',
            optional: true
        },

        exclude: {
            type: 'var',
            optional: true
        },

        hidePhoneType: {
            type: 'var',
            optional: true,
            'default': false
        },

        country: {
            type: 'var',
            optional: true
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var getTreatment = function getTreatment() {

                if ((0, _squid.$feature)('showNewPhoneDesign', false, _squid.$locale.country)) {
                    return true;
                }

                var throttle = void 0;

                if (_squid.$config['newPhoneDesignThrottle']) {

                    throttle = _squid.$config['newPhoneDesignThrottle']['DEFAULT'];

                    if (_squid.$config['newPhoneDesignThrottle'][_squid.$locale.country] >= 0) {
                        throttle = _squid.$config['newPhoneDesignThrottle'][_squid.$locale.country];
                    }
                }

                var id = _squid.$locale.country + _angular.$rootScope.token;

                return throttle !== undefined && (0, _squid.$experiment)('new_phone_design_exp', throttle, id, {}) ? true : false;
            };

            this.treatment = getTreatment();

            this.$watch('showPhoneType', function () {
                _this.hidePhoneType = _this.showPhoneType === false;
            }, true);
        }
    }

});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$experiment;

_squid.$config;

_squid.$feature;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInput/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-phone-input-a ng-if=\"!treatment\" token=\"token\" phone=\"phone\"\n                  show-phone-type=\"showPhoneType\" exclude=\"exclude\" country=\"country\"></xo-phone-input-a>\n<xo-phone-input-b ng-if=\"treatment\" phone=\"phone\" hide-phone-type=\"hidePhoneType\" show-phone-type=\"showPhoneType\"\n                  hide-work=\"hideWork\"></xo-phone-input-b>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");

var _territoriesByCode = __webpack_require__("../node_modules/xo-form-components/src/phone/lib/territoriesByCode.js");

var _territoriesByCode2 = _interopRequireDefault(_territoriesByCode);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/styles.less");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoPhoneInputA', function () {
    return {
        template: _template2['default'],
        scope: {
            phone: '=?',
            showPhoneType: '=?',
            exclude: '@?',
            country: '=?'
        },

        link: function link(scope, element, attr, controller) {
            element.on('keyup', function (event) {
                element.find('.telephone').mask(scope.mask, {
                    'translation': {
                        0: { pattern: /[0-9]/ }
                    }
                });
            });
        },

        controller: ['$scope', function ($scope) {
            $scope.locale = _squid.$locale;
            $scope.IntDialingCodes = _territoriesByCode2['default'];
            $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][_squid.$locale.country];
            $scope.showPhoneType = (0, _squid.$feature)('phoneType', true, $scope.country) && $scope.showPhoneType !== false;

            // dont display countries that are tagged with hideInOtherCountries flag in territoriesByCode.js.
            // if localeCountry and dropdown country are same ignore hideInOtherCountries and display the countrycode.
            $scope.hideCountry = function (dropdownCountry, hideInOtherCountries) {
                return _squid.$locale.country !== dropdownCountry && hideInOtherCountries;
            };

            $scope.phone = $scope.phone || {};
            $scope.phone.phoneType = $scope.phone.phoneType || 'Mobile';
            $scope.phone.IntDialingCountryCode = $scope.defaultCountryPhoneCode.phoneCountryCode;

            angular.extend($scope.phone, {
                phoneCountryCode: _squid.$locale.country
            });

            function getPhoneMask(phoneType, phoneEntry) {
                var defaultMask = '0000000000000000';
                var masks = phoneEntry && phoneEntry.masks;
                var mobileMask = masks && masks.MOBILE ? masks.MOBILE : defaultMask;
                var fixedLineMask = masks && masks.FIXED_LINE ? masks.FIXED_LINE : defaultMask;

                return phoneType === 'Mobile' ? mobileMask : fixedLineMask;
            }

            function getPhonePattern(phoneEntry) {
                var defaultPattern = '^[0-9]+$';
                var patterns = phoneEntry && phoneEntry.patterns;
                // less stric regex validation in place for now, just use general regex to match mobile AND fixed-line formats
                // for now we use less strict regex validation because we are not ready for this more strict validation

                if (patterns) {
                    return patterns.GENERAL ? patterns.GENERAL : defaultPattern;
                }
                return defaultPattern;

                // more strict regex validaiton based on phone type is found commented below
                // var ret;
                // switch ($scope.phone.phoneType) {
                //     case 'Mobile':
                //         ret = patterns.MOBILE;
                //         break;
                //     case 'Home':
                //     case 'Work':
                //         ret = patterns.FIXED_LINE;
                //         break;
                //     default:
                //         ret = patterns.GENERAL;
                //         break;
                // }
                // return ret ? ret : defaultPattern;
            }

            function populatePhoneMetadata() {
                if (!$scope.metadata || $scope.metadata.country !== _squid.$locale.metadata.country) {
                    $scope.metadata = angular.copy(_squid.$locale.metadata);
                }
                var phoneEntry = $scope.metadata.phoneEntry;

                $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
                $scope.pattern = getPhonePattern(phoneEntry);
            }

            populatePhoneMetadata();

            // Reset the phone number mask from according to the phone type
            $scope.phoneTypeChanged = function () {
                $scope.mask = getPhoneMask($scope.phone.phoneType, $scope.metadata.phoneEntry);
                $scope.pattern = getPhonePattern($scope.metadata.phoneEntry);
                $('.telephone').mask($scope.mask);
            };

            $scope.$watch('phone.phoneCountryCode', function (newValue) {
                $scope.phone.IntDialingCountryCode = _territoriesByCode2['default'][newValue].phoneCountryCode;
            });

            $scope.$on('localeChange', function () {
                $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][_squid.$locale.country];
                $scope.phone.phoneCountryCode = _squid.$locale.country;
                if (!$scope.metadata || $scope.metadata.country !== _squid.$locale.metadata.country) {
                    populatePhoneMetadata();
                    $('.telephone').mask($scope.mask);
                }
            });

            $scope.$watch('country', function (newVal) {
                if (newVal) {
                    $scope.defaultCountryPhoneCode = _territoriesByCode2['default'][$scope.country];
                    $scope.phone.phoneCountryCode = $scope.country;

                    if (!$scope.metadata || $scope.metadata.country !== $scope.country) {

                        $scope.metadata = _squid.$MetadataModel.create();
                        $scope.metadata.choose($scope.country, _squid.$locale.lang).then(function () {

                            var phoneEntry = $scope.metadata.phoneEntry;

                            $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
                            $scope.pattern = getPhonePattern(phoneEntry);

                            $('.telephone').mask($scope.mask);
                        });
                    }
                }
            });

            $scope.showWork = $scope.exclude === 'WORK';
        }]
    };
});

_squid.$feature;

_squid.$locale;

_squid.$MetadataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid fieldGroup clearfix\" ng-class=\"{countryCodeSelect: defaultCountryPhoneCode.showCountryCodeList === true}\" content>\n    <div id=\"phoneTypeContainer\" class=\"phoneTypeContainer dropdown confidential inputField half\" ng-cloak\n         ng-if=\"showPhoneType === true\" ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl'}\"\n         floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneType\" name=\"phoneType\" id=\"phoneType\" ng-change=\"phoneTypeChanged()\" xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!showWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n    <div id=\"phoneCodeContainer\" class=\"phoneCodeContainer dropdown confidential half last-child inputField\" ng-cloak\n         ng-if=\"defaultCountryPhoneCode.showCountryCodeList\" floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneCountryCode\" name=\"phoneCountryCode\" id=\"phoneCountryCode\" aria-required=\"true\" xo-error-tooltip required>\n            <option ng-repeat=\"(key, value) in IntDialingCodes track by $index\" value=\"{{key}}\" ng-if=\"!hideCountry(key, value.hideInOtherCountries)\" ng-selected=\"phone.phoneCountryCode === key\">{{value.phoneCountryCode}} ({{key}})</option>\n        </select>\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n    <div class=\"inputField confidential last-child\"\n         ng-class=\"{'half': showPhoneType || defaultCountryPhoneCode.showCountryCodeList, 'telephoneField': showPhoneType,\n         'telephoneFieldFull': !showPhoneType, 'rtlPhoneField': locale.metadata.directionality === 'rtl',\n         singleLineMobile: !showPhoneType && !defaultCountryPhoneCode.showCountryCodeList}\" floating-label directionality >\n\n        <input id=\"telephone\"\n               class=\"telephone\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               country-code=\"phone.phoneCountryCode\"\n               phone-pattern=\"{{pattern}}\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\">{{content('common.phone')}}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/styles.less");

__webpack_require__("../node_modules/xo-jquery-mask-plugin/dist/jquery.mask.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MOBILE = 'Mobile';
var KEYS = {
    ENTER: 13,
    UP: 38,
    DOWN: 40,
    TAB: 9,
    ESC: 27,
    A: 65,
    Z: 90,
    SPACE: 32
};

var query = '';
var queryTimer = null;

exports['default'] = _squid.$Component.extend('$xoPhoneInputB', {
    tag: 'xo-phone-input-b',
    template: _template2['default'],

    props: {
        phone: {
            type: 'var',
            required: false
        },

        hidePhoneType: {
            type: 'var',
            required: false
        },

        hideWork: {
            type: 'var',
            required: false,
            'default': false
        }
    },

    actions: {

        // return the phonePattern
        getPhonePattern: function getPhonePattern(phoneEntry) {
            var DEFAULT_PATTERN = '^[0-9]+$';
            var patterns = phoneEntry && phoneEntry.patterns;
            // less strict regex validation in place for now, just use general regex to match mobile AND fixed-line
            // formats
            // for now we use less strict regex validation because we are not ready for this more strict validation

            return patterns && patterns.GENERAL ? patterns.GENERAL : DEFAULT_PATTERN;
        },


        // return phoneMask based on phone Type
        getPhoneMask: function getPhoneMask(phoneType, phoneEntry) {
            var DEFAULT_MASK = '0000000000000000';
            var masks = phoneEntry && phoneEntry.masks;

            if (phoneType === MOBILE) {
                return masks && masks.MOBILE ? masks.MOBILE : DEFAULT_MASK;
            } else {
                return masks && masks.FIXED_LINE ? masks.FIXED_LINE : DEFAULT_MASK;
            }
        },


        // set the phone number mask and pattern
        updatePhoneMaskAndPattern: function updatePhoneMaskAndPattern() {
            // We need this check because in safari '13.1.3 iPhone XS' we see 'undefined is not an object'
            // error when country.x=CN and locale.x=en_CN in line 78 - this.metadata.localization.country
            if (this.metadata && this.metadata.localization) {
                var country = this.metadata.localization.country;
                // If phoneCountry does not match the country the metadata is from then
                // we set phoneEntry to a falsey value so the default pattern and mask are
                // used for the phone input.

                var phoneEntry = this.phoneCountry === country && this.metadata.phoneEntry;

                _logger.$logger.info('metadata_country_for_phone_mask_' + country);
                this.mask = this.actions.getPhoneMask(this.phone.phoneType, phoneEntry);
                this.pattern = this.actions.getPhonePattern(phoneEntry);
                this.actions.applyMaskOnPhoneInput();
            }
        },
        getPhoneDialingCode: function getPhoneDialingCode(territory, state) {
            var overrides = this.metadata.regionalOverrides;

            if (state && overrides && overrides.hasOwnProperty(state) && overrides[state].props.internationalDialingCode) {
                return overrides[state].props.internationalDialingCode;
            }

            return territory.internationalDialingCode;
        },


        // fetch the passed country's international dialing code
        updateDialingCodeAndCountry: function updateDialingCodeAndCountry() {
            var territory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var state = arguments[1];

            this.phoneCountry = territory.code;
            this.phone.phoneCountry = territory.code;
            this.phone.IntDialingCountryCode = this.actions.getPhoneDialingCode(territory, state);
            (0, _jquery2['default'])('.fixedCode').text('+' + this.phone.IntDialingCountryCode);
        },


        /* if user chooses a different dialing code -
         -. fetch the new country's metadata
         -. update phone Country and dialing code
         -. update the phone number mask and pattern (no explicit call as it happens when metadata updates)
         -. close the dropdown if open
         */
        updatePhoneFieldMetadata: function updatePhoneFieldMetadata() {
            var territory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var state = arguments[1];

            // create a local copy of metadata (only happens on initial load)
            if (!this.metadata) {
                this.metadata = _squid.$MetadataModel.instance(0, {
                    'noBroadcast': true
                });
            }

            this.metadata.choose(territory.code);

            this.actions.updateDialingCodeAndCountry(territory, state);
            // Whenever metadata is updated that is promise returns then the metadata listener will update the mask
            // and pattern so not calling it here. Moving on...

            // close the dropdown if open
            if (this.listVisible) {
                this.actions.collapseListAndFocusOnParent();
            }

            _logger.$logger.info('phone_country_code_updated', {
                territory: territory.code
            });
        },
        getTerritoryDataFromMetadata: function getTerritoryDataFromMetadata(country) {
            return _squid.$util.find(this.dialingCodeList, function (_ref) {
                var code = _ref.code;
                return code === country;
            });
        },


        // set the stage on first load or on locale change
        init: function init(country) {
            this.hidePhoneType = this.hidePhoneType || (0, _squid.$feature)('hidePhoneType', false, country);

            this.showDialingCodeContainer = (0, _squid.$feature)('showDialingCodeContainer', false, country);

            this.listVisible = false;

            // default the phone type to Mobile if not specified
            // Note: this.phone is not optional
            this.phone = this.phone || {};

            this.phone.phoneType = this.phone.phoneType || 'Mobile';

            // populate the dialing code list/options
            var _$locale$metadata = _squid.$locale.metadata,
                _$locale$metadata$ter = _$locale$metadata.territory,
                territory = _$locale$metadata$ter === undefined ? [] : _$locale$metadata$ter,
                _$locale$metadata$add = _$locale$metadata.additionalDialingCodes,
                additionalDialingCodes = _$locale$metadata$add === undefined ? [] : _$locale$metadata$add;
            var _$config$dialingCodeB = _squid.$config.dialingCodeBlacklist,
                dialingCodeBlacklist = _$config$dialingCodeB === undefined ? [] : _$config$dialingCodeB;

            // Merge dialing codes from supported countries with dialing codes from
            // assigned countries and then filtering countries that are blacklisted

            this.dialingCodeList = territory.concat(additionalDialingCodes).filter(function (_ref2) {
                var code = _ref2.code;
                return !dialingCodeBlacklist.includes(code);
            }).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            var territoryData = this.actions.getTerritoryDataFromMetadata(this.phone.phoneCountry || country);

            this.actions.updatePhoneFieldMetadata(territoryData);
        },


        // helper to show the options list and focus on the selected phone country option
        expandList: function expandList() {
            (0, _jquery2['default'])('.country-list').show();
            this.listVisible = true;
            (0, _jquery2['default'])('.country-list .country.selected').focus();
        },


        // helper to collapse the options
        collapseList: function collapseList() {
            this.listVisible = false;
            (0, _jquery2['default'])('.country-list').hide();
        },


        // helper to collapse the options and xfer focus back to the parent dropdown
        collapseListAndFocusOnParent: function collapseListAndFocusOnParent() {
            this.actions.collapseList();
            (0, _jquery2['default'])('#dialingCodeContainer div.selected-flag').focus();
        },


        // helper to toggle the dropdown list
        toggleList: function toggleList() {
            if (this.listVisible) {
                this.actions.collapseListAndFocusOnParent();
            } else {
                this.actions.expandList();
            }
        },


        // remove highlighting from other list items and highlight the given item
        highlightListItem: function highlightListItem(listItem) {
            (0, _jquery2['default'])('li.country').removeClass('highlight');
            listItem.addClass('highlight');
            listItem.focus();
        },

        // select the given item and update the phone field metadata
        selectListItem: function selectListItem(listItem) {
            var country = listItem.attr('data-country-code');
            var territory = this.actions.getTerritoryDataFromMetadata(country);

            this.actions.updatePhoneFieldMetadata(territory);
        },

        // find the first list item whose name starts with the query string
        searchForCountry: function searchForCountry(queryString) {
            for (var i = 0; i < this.dialingCodeList.length; i++) {
                if (this.actions.startsWith(this.dialingCodeList[i].name, queryString)) {

                    var listItem = (0, _jquery2['default'])('.country-list').find('[data-country-code="' + this.dialingCodeList[i].code + '"]');
                    // update highlighting and scroll

                    this.actions.highlightListItem(listItem);
                    break;
                }
            }
        },

        // check if (uppercase) string a starts with string b
        startsWith: function startsWith(a, b) {
            return a.substr(0, b.length).toUpperCase() === b;
        },

        // When Switching between double Byte -> Single Byte character
        // angular model is not properly updated by jquery-mask (PPPLMER-52127)
        // re-update the model with entered value.
        updateAngularModel: function updateAngularModel() {
            if (this.phone.ispreFill) {
                // We set the flag to false once the prefill is completed.
                // This helps to update angular model properly upon next keyUp()
                this.phone.ispreFill = false;
            } else {
                this.phone.telephone = this.$element.find('.telephone').val();
            }
        },

        // format the phone number
        applyMaskOnPhoneInput: function applyMaskOnPhoneInput() {
            // If `this.mask` is `undefined` and we try to mask this field
            // jQuery mask will throw a type error when it tries to access
            // `mask.length` during a for loop.
            if (!this.mask) {
                return;
            }

            this.actions.updateAngularModel();

            this.$element.find('.telephone').mask(this.mask, {
                'translation': {
                    0: { pattern: /[0-9]/ }
                }
            });
        },

        // highlight the event target
        handleListMouseover: function handleListMouseover($event) {
            this.actions.highlightListItem((0, _jquery2['default'])($event.target));
        },

        // expand the list when down arrow is pressed
        handleKeyboardInputForDropdown: function handleKeyboardInputForDropdown($event) {

            var key = $event.which;

            if (key === KEYS.DOWN || key === KEYS.UP || key === KEYS.SPACE) {
                $event.stopPropagation();
                $event.preventDefault();
                this.actions.expandList();
            } else {
                this.actions.collapseList();
            }
        },

        /*
         navigating list using the keyboard
         up, down, esc, enter and letter keys
         */
        handleKeyboardInputForList: function handleKeyboardInputForList($event) {
            var $listItems = (0, _jquery2['default'])('li.country');
            var key = $event.which;
            var $selected = (0, _jquery2['default'])($event.target);
            var $current = void 0;

            $event.stopPropagation();
            $event.preventDefault();

            // if user types in an input, focus on the first country starting with that query
            // upper case letters (since keyup/keydown only return upper case letters)
            if (key >= KEYS.A && key <= KEYS.Z) {
                if (queryTimer) {
                    _angular.$timeout.cancel(queryTimer);
                }

                query += String.fromCharCode(key);
                this.actions.searchForCountry(query);

                queryTimer = (0, _angular.$timeout)(function () {
                    query = '';
                }, 1e3);

                return;
            }

            // ignore other keys
            if (key !== KEYS.DOWN && key !== KEYS.UP && key !== KEYS.ENTER && key !== KEYS.ESC) {
                return;
            }

            // select the the new phone country when user hits enter
            if (key === KEYS.ENTER) {
                this.actions.selectListItem($selected);
                return;
            }

            // close the list if escape is pressed
            if (key === KEYS.ESC) {
                this.actions.collapseListAndFocusOnParent();
                return;
            }

            // highlight the next/prev element when arrow key is pressed
            if (key === KEYS.DOWN) // Down key
                {
                    if (!$selected.length || $selected.is(':last-child')) {
                        $current = $listItems.eq(0);
                    } else {
                        $current = $selected.next();
                    }
                }

            // Up key
            if (key === KEYS.UP) {
                if (!$selected.length || $selected.is(':first-child')) {
                    $current = $listItems.last();
                } else {
                    $current = $selected.prev();
                }
            }

            this.actions.highlightListItem($current);
        }
    },

    lifecycle: {
        enter: function enter() {
            this.actions.init(_squid.$locale.country);
        },
        populate: function populate() {
            var _this = this;

            this.$on('localeChange', function () {
                _this.actions.init(_squid.$locale.country);
            });

            // update the phone mask and pattern when metadata is changed
            this.$watch('metadata', function () {
                _this.actions.updatePhoneMaskAndPattern();
            }, true);

            // update the mask when .telephone val changes either programatically or via user action
            this.$watch('this.phone.telephone', function (newVal) {
                if (newVal) {
                    _this.$element.find('.telephone').val(newVal).trigger('input');
                }
            }, true);

            var addressChangeEvent = _angular.$rootScope.$on('billingAddressStateChange', function (e, address) {
                var territory = _this.actions.getTerritoryDataFromMetadata(_this.metadata.country);

                _this.actions.updatePhoneFieldMetadata(territory, address.state);
            });

            this.$on('$destroy', addressChangeEvent);

            // hide the dropdown list if a click occurs anywhere else on the page
            (0, _jquery2['default'])('*').on('click', function (event) {
                if (!(0, _jquery2['default'])('#dialingCodeContainer div.selected-flag').is((0, _jquery2['default'])(event.target))) {
                    _this.actions.collapseList();
                }
            });
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;

_squid.$MetadataModel;

_squid.$config;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid fieldGroup clearfix\" content>\n    <div ng-if=\"hidePhoneType !== true\"\n         id=\"phoneTypeContainer\"\n         class=\"phoneTypeContainer dropdown confidential inputField half\"\n         ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl', 'dialCodeVisible': showDialingCodeContainer}\"\n         ng-cloak\n         floating-label-dropdown >\n\n        <select xo-dropdown\n                ng-model=\"phone.phoneType\"\n                name=\"phoneType\"\n                id=\"phoneType\"\n                ng-change=\"actions.updatePhoneMaskAndPattern()\"\n                track-focus-and-blur=\"phoneType\"\n                xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!hideWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n\n    <div ng-if=\"showDialingCodeContainer\"\n         id=\"dialingCodeContainer\"\n         class=\"dialingCodeContainer dropdown confidential half last-child inputField intl-tel-input\"\n         ng-cloak\n         floating-label-dropdown>\n\n        <div class=\"flag-dropdown\">\n            <div tabindex=\"0\"\n                 class=\"selected-flag\"\n                 title=\"{{ phoneCountry + ' +'+this.phone.IntDialingCountryCode }}\"\n                 ng-keydown=\"actions.handleKeyboardInputForDropdown($event)\"\n                 ng-click=\"actions.toggleList()\">\n                <div class=\"iti-flag {{ phoneCountry | lowercase }}\" style=\"pointer-events: none\"></div>\n                <div class=\"arrow\" style=\"pointer-events: none\"></div>\n            </div>\n\n            <ul class=\"country-list hide\">\n                <li ng-repeat=\"(key, value) in dialingCodeList track by $index\"\n                    tabindex=\"-1\"\n                    class=\"country\"\n                    data-country-code=\"{{ value.code }}\"\n                    ng-class=\"{'selected': value.code === phoneCountry}\"\n                    ng-click=\"actions.updatePhoneFieldMetadata(value)\"\n                    ng-keydown=\"actions.handleKeyboardInputForList($event)\"\n                    ng-mouseover=\"actions.handleListMouseover($event)\">\n\n                    <div class=\"flag\" style=\"pointer-events: none\">\n                        <div class=\"iti-flag {{ value.code | lowercase }}\"/>\n                    </div>\n\n                    <span class=\"country-name\" style=\"pointer-events: none\">{{ value.name }}</span>\n\n                    <span class=\"dial-code\" style=\"pointer-events: none\">+{{ value.internationalDialingCode }}</span>\n                </li>\n            </ul>\n        </div>\n\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\" class=\"focus accessAid\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n\n    <div id=\"phoneNumberContainer\"\n         class=\"inputField confidential last-child phoneNumber\"\n         ng-class=\"{'half': !hidePhoneType,\n            'telephoneField': !hidePhoneType,\n            'telephoneFieldFull': hidePhoneType,\n            'rtlPhoneField': locale.metadata.directionality === 'rtl',\n            'dialCodeVisible': showDialingCodeContainer,\n            'singleLineMobile' : hidePhoneType}\"\n         floating-label\n         directionality >\n\n        <span class=\"fixedCode ltrOverride\" id=\"countryTelephoneCode\">+{{ phone.IntDialingCountryCode }}</span>\n        <input id=\"telephone\"\n               class=\"telephone\"\n               ng-class=\"{'digit1' : phone.IntDialingCountryCode.length === 1, 'digit2' : phone.IntDialingCountryCode.length === 2, 'digit3' : phone.IntDialingCountryCode.length === 3, 'digit4' : phone.IntDialingCountryCode.length === 4 }\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               data-mask=\"{{mask}}\"\n               ng-change=\"actions.applyMaskOnPhoneInput()\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               aria-labelledby=\"telephoneLabel countryTelephoneCode\"\n               country-code=\"phone.phoneCountryCode\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               ng-keyup=\"actions.applyMaskOnPhoneInput()\"\n               required\n               track-focus-and-blur=\"phone\"\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\" id=\"telephoneLabel\">{{content('common.phone')}}</label>\n    </div>\n\n\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

__webpack_require__("../node_modules/xo-form-components/src/phone/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddPhoneRoute', function () {

    return _squid.$ComponentRoute.extend('AddPhoneRoute', {

        name: 'addPhone',

        directive: 'xo-add-phone',

        titleContent: 'addPhone.addPhoneNumber',

        query: ['message'],

        trackingData: {
            templateName: 'addPhone.dust',
            fptiState: 'add_phone',
            pageGoal: 'Add Phone',
            buzname: {
                'fullpage': {
                    'pagename': '%::fullpage-add-phone',
                    'pagename2': '%::fullpage-add-phone:member:hermes:',
                    'version': 'member:%:'
                    // More page qualifiers come here...
                } }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-form-components/src/phone", "../node_modules/xo-form-components/src/phone/route.js"))

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addPhone\" id=\"addPhone\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-title title-txt=\"{{content('addPhone.addPhoneNumber')}}\"></xo-title>\n            <form name=\"addPhoneForm\" class=\"proceed\" content autocomplete=\"off\" ng-submit=\"addPhoneForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <xo-phone-input phone=\"phone\"></xo-phone-input>\n                <p class=\"disclaimer\" id=\"phoneDisclosure\" ng-if=\"showPhoneDisclosure\">\n                    <span data-ng-bind-html=\"htmlContent(consentContentKey)\"></span>\n                </p>\n                <input track-submit type=\"submit\" value=\"{{showPhoneDisclosure ? content('addPhone.agreeContinue') : content('common.continueLabel') }}\" class=\"btn full\" ng-click=\"validated=true\" />\n            </form>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-country/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/template.html");

var _template2 = _interopRequireDefault(_template);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSelectShippingCountry', {
    tag: 'xo-select-shipping-country',
    template: _template2['default'],
    props: {
        shippingAddress: {
            type: 'var',
            required: false
        },
        disableChangeShippingCountry: {
            type: 'var',
            required: false
        }
    },
    actions: {
        // Return the country list, with the selected address country at the top
        getList: function getList(address) {
            var defaultCountryCode = address && address.country || _squid.$locale.country;
            var countryList = _squid.$locale.metadata.territory;
            var isDefaultCountry = function isDefaultCountry(country) {
                return country.code === defaultCountryCode;
            };
            var defaultCountry = _squid.$util.find(countryList, isDefaultCountry);
            var res = countryList.filter(function (country) {
                return !isDefaultCountry(country);
            });

            res.unshift(defaultCountry);

            return res;
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.countryList = this.actions.getList(this.props.shippingAddress);

            this.$on('metadataChange', function () {
                _this.countryList = _this.actions.getList(_this.props.shippingAddress);
            });
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$util;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-country/template.html":
/***/ (function(module, exports) {

module.exports = "<span id=\"selectShippingCountry\" feature=\"changeShippingCountry\">\n    <div class=\"dropdown confidential country clearfix inputField\"\n         ng-class=\"{'disabled': props.disableChangeShippingCountry}\" content floating-label-dropdown>\n        <select xo-dropdown name=\"country\" ng-model=\"props.shippingAddress.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"country\" xo-error-tooltip required ng-disabled=\"props.disableChangeShippingCountry\">\n        </select>\n        <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n    </div>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-method/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/select-shipping-method/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/lib/ui.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var callbackShippingOptions = void 0,
    fallbackShippingOptions = void 0,
    callbackInsuranceOffered = void 0; // Import the decodeEntities angular filter

var defaultFallbackOptionIndex = void 0;

exports['default'] = _squid.$Component.extend('$xoSelectShippingMethod', {
    tag: 'xo-select-shipping-method',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        showShippingAddress: {
            type: 'var',
            required: false
        },
        errorHandlerHelper: {
            type: 'var',
            required: false
        },
        instantUpdateFeature: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                checkoutShippingAddresses: _index2.$CheckoutShippingAddressesModel.instance(this.props.token).retrieve(),
                creditDataModel: _credit.$CreditDataModel.instance(this.props.token),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        closeModal: function closeModal() {
            this.showModal = false;
        },
        openModal: function openModal() {
            this.showModal = true;
        },
        continueHandler: function continueHandler() {

            /**
             * Function responsible to patch Cart for
             * 1. Buyer select's a new shipping method.
             * 2. Buyer chooses to opt for insurance or chooses not to.
             */
            if (this.selectedMethod.current.index !== this.selectedMethod.previous.index || this.selectedMethod.current.insuranceSelected !== this.selectedMethod.previous.insuranceSelected) {

                var selectedMethodCharges = void 0,
                    taxAmtApplied = void 0,
                    insurance = void 0;

                selectedMethodCharges = this.response.charges[this.selectedMethod.current.index];
                taxAmtApplied = this.getTax(selectedMethodCharges);
                insurance = this.getInsurance(selectedMethodCharges);
                this.shippingAmtApplied = this.safeConvert(selectedMethodCharges.shipping_charge.shipping_amount.value);
                if (this.isInstantUpdateFlow) {
                    this.selectedMethod.showInsuranceAmount = this.selectedMethod.current.insuranceSelected;
                    this.insuranceApplied = insurance;
                    this.updateSelectedExternalCallbackOption(this.response.shipping_options_source, this.selectedMethod.previous.index, this.selectedMethod.current.index);
                    this.selectedMethod.previous.insuranceSelected = this.selectedMethod.current.insuranceSelected;
                }
                this.updateShippingTaxCharge(this.shippingAmtApplied, taxAmtApplied, selectedMethodCharges.shipping_charge.shipping_method_type, insurance);
                this.selectedShippingMethod = selectedMethodCharges.shipping_charge.shipping_method;
                this.selectedMethod.previous.index = this.selectedMethod.current.index;
            }

            this.actions.closeModal();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.selectedMethod = {
                current: {
                    index: 0,
                    insuranceSelected: false
                },
                previous: {
                    index: 0,
                    insuranceSelected: false
                },
                insuranceAvailable: false,
                showInsuranceAmount: false
            };

            // Initialization
            this.showModal = false;
            this.shippingInfoDisplay = 'noHighlight';
            this.addressChanged = false;

            var timer = void 0;

            this.previousCosts = {};

            // Function used to format amount based on currency code
            this.formatAmount = function (amount) {
                if (amount && amount.value) {
                    var amountToBeFormatted = (parseInt(amount.value.toString(), 10) / 100).toFixed(2);

                    if (amountToBeFormatted) {
                        return (0, _squid.formatCurrency)(amountToBeFormatted, _this.currencyCode);
                    }
                }
            };

            this.uncheckInsuranceCheckbox = function () {
                _this.selectedMethod.current.insuranceSelected = false;
            };

            this.showInsurance = function (selectedIndex) {
                return Number(_this.selectedMethod.current.index) === selectedIndex;
            };

            // Function to check if is insurance is offered for a shipping charge
            this.isInsuranceOfferedInCharge = function (charge) {
                return charge.shipping_charge.offer_insurance_option;
            };

            var responseHasShippingCharges = function responseHasShippingCharges() {
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].shipping_charge;
            };

            var responseHasTaxCharges = function responseHasTaxCharges() {
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].tax;
            };

            this.safeConvert = function (value) {
                value = Number(value);
                if (isNaN(value)) {
                    throw new Error(value + ' cannot be divided');
                }
                return value / 100;
            };

            /*
             This function is responsible to update the previously selected external callback option to newly selected one.
             */
            this.updateSelectedExternalCallbackOption = function (optionsSource, prevIndex, index) {
                if (optionsSource === 'CALLBACK' && callbackShippingOptions) {
                    if (!isNaN(prevIndex)) {
                        callbackShippingOptions[prevIndex].is_selected = false;
                    }
                    callbackShippingOptions[index].is_selected = true;
                } else if (optionsSource === 'FALLBACK' && fallbackShippingOptions) {
                    if (!isNaN(prevIndex)) {
                        fallbackShippingOptions[prevIndex].is_selected = false;
                    }
                    fallbackShippingOptions[index].is_selected = true;
                }
            };

            var highlight = function highlight(duration) {
                _this.shippingInfoDisplay = 'highlight';
                if (timer) {
                    _angular.$timeout.cancel(timer);
                }
                timer = (0, _angular.$timeout)(function () {
                    _this.shippingInfoDisplay = 'noHighlight';
                }, duration);
            };

            this.getTax = function (charge) {
                var tax = void 0;

                if (!_this.isInstantUpdateFlow && (_this.isBuyNow || _this.isCartUpload) && _this.cartAmounts.taxAmt >= 0) {
                    tax = _this.cartAmounts.taxAmt;
                }
                // tax calculation
                else {
                        charge = charge || responseHasTaxCharges() && _this.response.charges[0];
                        if (charge && charge.tax && charge.tax.total_tax) {
                            tax = _this.safeConvert(charge.tax.total_tax.value);
                        }
                    }
                return tax;
            };

            /**
             * Function to return the insurance from shipping charge.
             * 1. By default return insurance amount from the charge.
             * 2. In case insurance is offered and is not chosen , do not return the insurance amount.
             * @param charge - shipping charge
             * @param index - index of the shipping charge
             */
            this.getInsurance = function (charge) {
                if (charge && charge.shipping_charge && charge.shipping_charge.insurance_amount) {
                    if (charge.shipping_charge.offer_insurance_option && !_this.selectedMethod.current.insuranceSelected) {
                        return;
                    }
                    return _this.safeConvert(charge.shipping_charge.insurance_amount.value);
                }
            };

            var updatePreviousCosts = function updatePreviousCosts() {
                _this.previousCosts = {};
                if (_this.models.checkoutCart.purchase.amounts.shipping) {
                    _this.previousCosts.shippingAmount = _this.models.checkoutCart.purchase.amounts.shipping.amount;
                }
                if (_this.models.checkoutCart.purchase.amounts.tax) {
                    _this.previousCosts.taxAmount = _this.models.checkoutCart.purchase.amounts.tax.amount;
                }
            };

            var hasShippingCostChanged = function hasShippingCostChanged(newShipping) {
                if (newShipping !== undefined) {
                    return newShipping.amount !== _this.previousCosts.shippingAmount;
                }
                return newShipping !== _this.previousCosts.shippingAmount;
            };

            var hasTaxCostChanged = function hasTaxCostChanged(newTax) {
                if (newTax !== undefined) {
                    return newTax.amount !== _this.previousCosts.taxAmount;
                }
                return newTax !== _this.previousCosts.taxAmount;
            };

            var setToolTipMessage = function setToolTipMessage() {
                _this.models.checkoutSession.message.msgKeys = hasShippingCostChanged(_this.models.checkoutCart.purchase.amounts.shipping) || hasTaxCostChanged(_this.models.checkoutCart.purchase.amounts.tax) ? ['smallToolTip.addressShippingChargesUpdated'] : ['smallToolTip.onlyAddressUpdated'];
            };

            var addExternalCallBackOptionsToPatchRequest = function addExternalCallBackOptionsToPatchRequest(patchEntities) {
                var externalCallbackOptions = _this.models.checkoutCart.purchaseUnits[0].external_callback_options;

                if (_this.response.shipping_options_source === 'CALLBACK') {
                    externalCallbackOptions.callback_shipping_options = callbackShippingOptions;
                    externalCallbackOptions.callback_insurance_option_offered = callbackInsuranceOffered;
                } else if (_this.response.shipping_options_source === 'FALLBACK') {
                    externalCallbackOptions.fallback_shipping_options = fallbackShippingOptions;

                    // if callback shipping option failed, delete it as fallback is default now
                    // use case , say if buyer changes shipping address multiple times and the first attempt callback success
                    // and second attempt callback failed, as patchCart of first attempt updated checkout session we may endup in having
                    // both callback and fallback shipping option , and only one if possible (useful) from checkout session
                    // delete the callback as it is not always source of shipping charge
                    delete externalCallbackOptions.callback_shipping_options;
                }

                patchEntities.push({
                    field: 'externalCallbackOptions',
                    value: externalCallbackOptions
                });
            };

            var populatePatchShippingDetails = function populatePatchShippingDetails(patchEntities, shipMethod) {
                if (_this.isInstantUpdateFlow) {
                    addExternalCallBackOptionsToPatchRequest(patchEntities);
                } else {
                    patchEntities.push({
                        field: 'shippingMethod',
                        value: shipMethod ? _this.shippingMethods.getShippingMethodId(shipMethod) : ''
                    });
                }
            };

            var populatePatchAmountDetails = function populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts) {
                var newTotal = _this.cartAmounts.total;

                Object.keys(patchableAmountEntities).forEach(function (key) {
                    var detail = patchableAmountEntities[key];

                    if (!isNaN(detail.value)) {
                        detail.value = Number(detail.value);
                        amounts.details[key] = detail.value.toFixed(decimalDigits);
                    } else {
                        detail.value = 0;
                    }
                    newTotal += detail.valueInCart ? detail.value - detail.valueInCart : detail.value;
                });
                amounts.total = newTotal.toFixed(decimalDigits);
                Object.keys(constantAmountEntities).forEach(function (key) {
                    var detail = constantAmountEntities[key];

                    if (detail.valueInCart !== undefined) {
                        amounts.details[key] = detail.valueInCart.toFixed(decimalDigits);
                    }
                });
            };

            // Generates the request body to be used for patch Cart
            var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod, insuranceAmt) {
                // 1. amount values in the cart,
                // 2. shipping method (only in case of non instant update flows)
                // 3. external_callback_options (only in case of instant update flows)

                var currencyDigits = _squid.$locale.metadata && _squid.$locale.metadata.currency && _squid.$locale.metadata.currency.digits;
                var decimalDigits = currencyDigits && currencyDigits[_this.currencyCode];

                if (isNaN(decimalDigits)) {
                    decimalDigits = 2;
                }
                var patchEntities = [];
                var amounts = {
                    'currency': _this.currencyCode,
                    'details': {
                        'subtotal': _this.cartAmounts.subTotal.toFixed(decimalDigits)
                    }
                };
                var patchableAmountEntities = {
                    shipping: {
                        value: shippingAmt,
                        valueInCart: _this.cartAmounts.shippingAmt
                    },
                    tax: {
                        value: taxAmt,
                        valueInCart: _this.cartAmounts.taxAmt
                    },
                    insurance: {
                        value: insuranceAmt,
                        valueInCart: _this.cartAmounts.insuranceAmt
                    }
                };

                // amount details which are not affected by SnT response,
                // but still need to get included in the patch request if initially present
                var constantAmountEntities = {
                    handling_fee: {
                        valueInCart: _this.cartAmounts.handlingAmt
                    },
                    shipping_discount: {
                        valueInCart: _this.cartAmounts.shippingDiscountAmt
                    },
                    discount: {
                        valueInCart: _this.cartAmounts.discountAmt
                    }
                };

                populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts);

                patchEntities.push({
                    field: 'purchaseAmount',
                    value: amounts
                });

                populatePatchShippingDetails(patchEntities, shipMethod);

                return {
                    id: _this.token,
                    patchEntities: patchEntities
                };
            };

            this.updateShippingTaxCharge = function (shippingAmt, taxAmt, shipMethod, insurance) {
                _this.models.checkoutCart.action('patchCartData', {
                    data: getPatchReqData(shippingAmt, taxAmt, shipMethod, insurance),
                    success: function success(result) {
                        _this.models.checkoutSession.invalidate();
                        (0, _squid.$populate)(_this, {
                            checkoutSession: _index2.$CheckoutSessionModel.instance(_this.token)
                        }).then(function () {
                            // update checkout cart model with item information
                            // this is for displaying additional item information in cart
                            // any modification here need check in xo-page-component-> cart directive also
                            _this.models.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
                                item.details = {};

                                if (item.quantity > 1) {
                                    item.details.price = item.price.amount;
                                    item.details.quantity = (0, _squid.formatQuantity)(item.quantity);
                                }

                                if (item.description) {
                                    if (!item.name) {
                                        item.name = item.description;
                                    } else {
                                        item.details.description = item.description;
                                    }
                                }

                                // move options to detail section
                                if (item.item_option_selections) {
                                    item.details.hasSelections = true;
                                    item.details.item_option_selections = item.item_option_selections;
                                }

                                if (item.sku) {
                                    item.details.sku = item.sku;
                                }

                                item.hasDetails = Object.keys(item.details).length > 0;
                                item.details.hasMore = item.hasDetails || item.details.hasSelections;
                            });
                        }).then(function () {
                            highlight(4000);
                            if (_this.addressChanged) {
                                setToolTipMessage();
                                _this.addressChanged = false;
                            }
                            updatePreviousCosts();
                        });
                    }
                });
            };

            var populateCallbackShippingOptions = function populateCallbackShippingOptions() {
                var charges = _this.response && _this.response.charges;

                if (charges) {
                    callbackShippingOptions = charges.map(function (charge, index) {
                        var shippingCharge = charge.shipping_charge;
                        var taxCharge = charge.tax;
                        var option = {};

                        if (shippingCharge) {
                            option = {
                                method: shippingCharge.shipping_method,
                                amount: {
                                    value: _this.safeConvert(shippingCharge.shipping_amount.value),
                                    currency: shippingCharge.shipping_amount.currency_code
                                },
                                is_default: shippingCharge.default_method,
                                is_selected: false
                            };
                            if (shippingCharge.insurance_amount) {
                                option.insurance = {
                                    value: _this.safeConvert(shippingCharge.insurance_amount.value),
                                    currency: shippingCharge.insurance_amount.currency_code
                                };
                                callbackInsuranceOffered = shippingCharge.offer_insurance_option;
                            }
                            if (taxCharge) {
                                option.tax = {
                                    value: _this.safeConvert(taxCharge.total_tax.value),
                                    currency: taxCharge.total_tax.currency_code
                                };
                            }
                        }
                        return option;
                    });
                }
            };

            var setDefaultShippingMethod = function setDefaultShippingMethod() {
                _this.showShippingOptions = true;
                var chargesElement = void 0,
                    methodType = void 0,
                    taxAmtApplied = void 0,
                    insurance = void 0;

                for (var i = 0; i < _this.response.charges.length; i++) {
                    chargesElement = _this.response.charges[i];
                    if (chargesElement.shipping_charge.default_method) {
                        _this.selectedMethod.current.index = i;
                        _this.selectedMethod.previous.index = i;
                        insurance = _this.getInsurance(chargesElement);
                        if (_this.isInstantUpdateFlow) {
                            _this.updateSelectedExternalCallbackOption(_this.response.shipping_options_source, _this.selectedMethod.previous.index, _this.selectedMethod.current.index);
                        }
                        _this.selectedShippingMethod = chargesElement.shipping_charge.shipping_method;
                        methodType = chargesElement.shipping_charge.shipping_method_type;
                        _this.shippingAmtApplied = _this.safeConvert(chargesElement.shipping_charge.shipping_amount.value);

                        taxAmtApplied = _this.getTax(chargesElement);

                        insurance = _this.getInsurance(chargesElement);

                        break;
                    }
                }
                _this.updateShippingTaxCharge(_this.shippingAmtApplied, taxAmtApplied, methodType, insurance);
            };

            var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
                return applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;
            };

            // Find the charges of the default option and patch cart with corresponding values.
            var updateShippingTaxChargeWithDefaultOption = function updateShippingTaxChargeWithDefaultOption() {
                var defaultOption = void 0,
                    shippingAmt = void 0,
                    taxAmt = void 0,
                    insuranceAmt = void 0,
                    methodType = void 0;

                if (_this.response.shipping_options_source === 'FALLBACK' && !isNaN(defaultFallbackOptionIndex)) {
                    defaultOption = fallbackShippingOptions[defaultFallbackOptionIndex];
                }
                if (defaultOption) {
                    shippingAmt = defaultOption.amount && defaultOption.amount.value;
                    taxAmt = defaultOption.tax && defaultOption.tax.value;
                    insuranceAmt = defaultOption.insurance && defaultOption.insurance.value;
                    methodType = defaultOption.shipping_method_type || 'DEFAULT';
                }
                _this.updateShippingTaxCharge(shippingAmt, taxAmt, methodType, insuranceAmt);
            };

            /**
             Function to enable the link to select insurance's by the user if offered in charges
             */
            var enableUserToChooseInsuranceOptionsIfAvailable = function enableUserToChooseInsuranceOptionsIfAvailable() {
                var charges = _this.response && _this.response.charges;

                if (!charges) {
                    return;
                }
                for (var i = 0; i < charges.length; i++) {
                    if (_this.isInsuranceOfferedInCharge(charges[i])) {
                        _this.selectedMethod.insuranceAvailable = true;
                        _this.selectedMethod.showInsuranceAmount = false;
                        break;
                    }
                }
            };

            /*  Function which is responsible to process shipping tax response
             Use cases
             ---------
             1. (i) WPS: If response has shipping charges and shipping options are to be shown, set default shipping method else patch cart
             with shipping amount returned.
             (ii)Instant Update: If the shipping region is unsupported, display error message. Otherwise the above behavior applies.
             2. If no_shipping = 1
             (i) WPS:  If profile_override = true , apply shipping from button if it is not empty.
             (ii) Instant Update: Do not display the shipping options. Apply the default fallback(or callback) shipping option charges.
             3. Apply tax if applicable.
             */
            var processShippingAndTaxResponse = function processShippingAndTaxResponse() {

                var applicableShippingAmt = void 0,
                    applicableTaxAmt = void 0;

                if (_this.isInstantUpdateFlow) {
                    if (!_this.response.shipping_region_supported) {
                        _this.errorHandlerHelper.addPageError('shippingMethod.shippingRegionUnsupported', { merchant: _this.nonEmptyMerchantDisplayName });
                        _this.instantUpdateFeature.shippingRegionSupported = false;
                    }

                    if (_this.response.shipping_options_source === 'CALLBACK') {
                        populateCallbackShippingOptions();
                    }

                    enableUserToChooseInsuranceOptionsIfAvailable();

                    // no_shipping = 0
                    if (_this.showShippingAddress) {
                        if (responseHasShippingCharges()) {
                            setDefaultShippingMethod();
                        }
                    }
                    // no_shipping=1 in case of instant update api , hide the overlay, shipping and tax from default fallback or callback options should be applied
                    else {
                            _this.showShippingOptions = false;
                            updateShippingTaxChargeWithDefaultOption();
                        }
                    return;
                }

                // shipping calculation
                if (_this.showShippingAddress) {
                    if (responseHasShippingCharges()) {
                        if (_this.response.show_shipping_options) {
                            setDefaultShippingMethod(); // setDefaultShippingMethod takes care of both shipping and tax
                            return;
                        } else if (_this.response.charges[0].shipping_charge.shipping_amount) {
                            // if no shipping options , try to get the shipping amount if returned from SNTService
                            applicableShippingAmt = _this.safeConvert(_this.response.charges[0].shipping_charge.shipping_amount.value);
                        }
                    }
                }
                // when not instant update flow , no_shipping is 1, shipping is applied only when override is true and shipping is passed in button
                else if (_this.response.profile_override_allowed) {
                        if (_this.cartAmounts.shippingAmt !== undefined) {
                            applicableShippingAmt = _this.cartAmounts.shippingAmt;
                        }
                    }

                applicableTaxAmt = _this.getTax();

                if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
                    _this.updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt);
                }
            };

            var clearFallbackOptionsSelectionFlags = function clearFallbackOptionsSelectionFlags() {
                for (var i = 0; i < fallbackShippingOptions.length; i++) {
                    fallbackShippingOptions[i].is_selected = false;
                }
            };

            this.getShippingMethods = function () {
                _this.showShippingOptions = false;
                _this.selectedShippingMethod = '';
                _this.shippingAmtApplied = 0;
                _this.insuranceAmountOffered = 0;
                _this.response = {};

                // when no_shipping = 1, checkoutSession,shipping is undefined. Primary address is considered for SnT as per legacy
                var shippingAddress = _this.models.checkoutSession.shipping ? _this.models.checkoutSession.getShippingAddressMinimalDetails() : _this.models.checkoutShippingAddresses.getPrimaryShippingAddress();

                var sntRequest = {
                    'address': shippingAddress,
                    'cart_weight': _this.cartWeight,
                    'cart_handling': { value: _this.cartAmounts.handlingAmt, currency_code: _this.currencyCode },
                    'discount': _this.cartDiscount,
                    'item_list': _this.models.checkoutCart.purchase.items,
                    'tax_on_shipping_required': _this.showShippingAddress, //    tax on shipping is not applicable when no_shipping is 1
                    'merchant_id': _this.models.checkoutPayee.merchant.id,
                    'locale': _squid.$locale.content.lang + '_' + _squid.$locale.chosenCountry,
                    'currency_code': _this.currencyCode,
                    'id': _this.token
                };

                if (_this.isInstantUpdateFlow) {
                    _this.selectedMethod = {
                        current: {
                            index: 0,
                            insuranceSelected: false
                        },
                        previous: {
                            index: 0,
                            insuranceSelected: false
                        },
                        insuranceAvailable: false,
                        showInsuranceAmount: false
                    };
                    callbackShippingOptions = [];
                    callbackInsuranceOffered = false;
                    clearFallbackOptionsSelectionFlags();
                    _this.instantUpdateFeature.shippingRegionSupported = true;
                    _this.errorHandlerHelper.clearPageErrors();

                    if (_this.models.checkoutCart.purchaseUnits && _this.models.checkoutCart.purchaseUnits[0]) {
                        sntRequest.external_callback_options = _this.models.checkoutCart.purchaseUnits[0].external_callback_options;
                    }
                }

                _this.shippingMethods = new _index.$ShippingMethodModel(sntRequest);

                _logger.$logger.info('calculate_shipping_charges_call');
                _this.shippingMethods.save({
                    data: _this.shippingMethods,
                    success: function success(result) {
                        _this.response = result;
                        processShippingAndTaxResponse();
                    }
                });
            };
        },
        populate: function populate() {
            var _this2 = this;

            var set = function set(key, value) {
                if (value) {
                    _this2.cartAmounts[key] = Number(value.amount);
                }
            };

            function hasAddressChanged(newValue, oldValue, isInstantUpdateFlow) {
                // only these values determine if the shiptax service needs to be called again
                var countryZipStateCityChanged = newValue.country !== oldValue.country || newValue.state !== oldValue.state || newValue.city !== oldValue.city || newValue.postal_code !== oldValue.postal_code;

                if (!countryZipStateCityChanged && isInstantUpdateFlow) {
                    // For instant update flow any change of address variable must trigger a call to shiptax
                    var anyAddressFieldChanged = newValue.line1 !== oldValue.line1 || newValue.line2 !== oldValue.line2;

                    return anyAddressFieldChanged;
                }

                return countryZipStateCityChanged;
            }

            this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;

            var appDataFlags = this.models.checkoutAppData && this.models.checkoutAppData.flags;

            // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
            // then we need the value of merchantDisplayName to be 'The merchant' as it is the first word
            // in page level error below (look for place where nonEmptyMerchantDisplayName var is used)
            this.nonEmptyMerchantDisplayName = this.models.checkoutAppData && this.models.checkoutAppData.getMerchantDisplayName({
                nonEmptyReturnValue: true,
                isSentenceBeginning: true
            });

            this.isBuyNow = appDataFlags && appDataFlags.is_buy_now_flow;

            this.isCartUpload = appDataFlags && appDataFlags.is_cart_upload_flow;

            this.isInstantUpdateFlow = this.models.checkoutCart && this.models.checkoutCart.instantUpdateIntegration;

            if (this.isInstantUpdateFlow) {
                fallbackShippingOptions = this.models.checkoutCart.purchaseUnits[0].external_callback_options.fallback_shipping_options;
                if (fallbackShippingOptions) {
                    defaultFallbackOptionIndex = _squid.$util.findIndex(fallbackShippingOptions, function (option) {
                        return option.is_default;
                    });
                }
            }

            this.cartAmounts = {};
            set('shippingAmt', this.models.checkoutCart.purchase.amounts.shipping);
            set('taxAmt', this.models.checkoutCart.purchase.amounts.tax);
            set('subTotal', this.models.checkoutCart.purchase.amounts.subtotal);
            set('total', this.models.checkoutCart.purchase.amounts.total);
            set('handlingAmt', this.models.checkoutCart.purchase.amounts.handling_fee);
            set('insuranceAmt', this.models.checkoutCart.purchase.amounts.insurance);
            set('shippingDiscountAmt', this.models.checkoutCart.purchase.amounts.shipping_discount);
            set('discountAmt', this.models.checkoutCart.purchase.amounts.discount);
            this.previousCosts = {
                shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
                taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
            };

            if (this.models.checkoutCart.cartWeight) {
                this.cartWeight = {};
                if (this.models.checkoutCart.cartWeight.value) {
                    this.cartWeight.value = Number(this.models.checkoutCart.cartWeight.value).toFixed(2);
                }
                this.cartWeight.unit = this.models.checkoutCart.cartWeight.unit;
            }

            if (this.models.checkoutCart.purchase.amounts.discount) {
                this.cartDiscount = {
                    value: Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2),
                    currency_code: this.currencyCode
                };
            }

            if (this.showShippingAddress) {
                this.$watch('this.models.checkoutSession.shipping', function (newValue, oldValue) {
                    if (hasAddressChanged(newValue, oldValue, _this2.isInstantUpdateFlow)) {
                        _this2.addressChanged = true;
                        _this2.getShippingMethods();
                    }
                });
            }

            // if all the following conditions are true, we will be queuing the execution of
            // getShippingMethods once the credit-return-flow is completed. In details:
            // - is this the ReturnFromCape flow?
            // - was the credit application approved?
            // - is the return flow still running?
            // - this flow does not requires a change of Installments?
            var isCapeReturnInProgress = this.models.creditDataModel.getCapeKey() && _squid.$util.param('success') && !this.models.creditDataModel.isReturnFromCapeComplete() && !this.models.creditDataModel.isChangeStatus();
            if (isCapeReturnInProgress) {
                _logger.$logger.info('watching_return_from_cape_complete');
                this.$watch('this.models.creditDataModel.return_from_cape_complete', function (newValue, oldValue) {
                    if (newValue === true && oldValue === false) {
                        _this2.getShippingMethods();
                    }
                });
            } else {
                this.getShippingMethods();
            }
        }
    }
});


_angular.$timeout;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$util;

_squid.formatCurrency;

_squid.formatQuantity;

_index.$ShippingMethodModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutShippingAddressesModel;

_index2.$CheckoutAppDataModel;

_logger.$logger;

_credit.$CreditDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-method/template.html":
/***/ (function(module, exports) {

module.exports = "<span id=\"selectShippingMethod\" content>\n    <div id=\"selectShippingMethodContainer\" ng-if=\"showShippingOptions\">\n        <div id=\"storePickUpDetails\" ng-if=\"models.checkoutCart.isShippingMethodStorePickUp()\">\n            <hr class=\"lightHR\">\n            <div class=\"shipTo\">{{ content('shippingMethod.shipTo') }}</div>\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <div id=\"shippingInformation\">\n            <div id=\"methodCharges\" ng-class=\"shippingInfoDisplay\">\n                <span class=\"shippingText\">{{ content('shippingMethod.shipping') }}:</span>\n            <span>\n                <a id=\"shippingMethodCharge\" class=changeShippingMethod link-button aria-label=\"{{ content('shippingMethod.selectMethod')}}\"\n                    ng-click=\"actions.openModal()\" focus-when=\"!showModal\" focused-once-before>\n                    <span class=\"selectedShippingMethod\">{{selectedShippingMethod | decodeEntities}} - </span>\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"shippingAmtApplied\"></format-currency>\n                </a>\n            </span>\n            </div>\n            <div id=\"insuranceInfo\" ng-if=\"selectedMethod.insuranceAvailable\" ng-class=\"shippingInfoDisplay\">\n                <span class=\"insuranceText\">{{ content('shippingMethod.shippingInsurance') }}:</span>\n            <span>\n                <a id=\"insuranceNoneApplied\" ng-if=\"!selectedMethod.showInsuranceAmount\" class=changeInsurance href=\"#\" aria-label=\"{{ content('shippingMethod.insuranceNoneSelected') }}\" ng-click=\"actions.openModal()\">\n                    <span class=\"noInsuranceOption\"> {{ content('shippingMethod.insuranceNoneSelected')}}</span>\n                </a>\n                <a id=\"insuranceAmtOffered\" ng-if=\"selectedMethod.showInsuranceAmount\" class=changeInsurance href=\"#\" aria-label=\"{{ content('shippingMethod.shippingInsurance') }}\" ng-click=\"actions.openModal()\">\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"insuranceApplied\"></format-currency>\n                </a>\n            </span>\n            </div>\n        </div>\n        <xo-modal show=showModal show-close-button=\"true\" on-close=\"actions.closeModal\">\n            <div class=\"shippingMethodsContainer\">\n                <div>\n                    <div class=\"shippingOptions\">\n                        <span class=\"shippingHeader\" id=\"shippingHeader1\">{{ content('shippingMethod.selectMethod') }}</span>\n                        <span class=\"gamma\" id=\"shippingHeader2\">{{ content('shippingMethod.merchantOptions') }}</span>\n                        <br>\n                        <div>\n                            <div ng-repeat=\"charge in response.charges track by $index\">\n                                <div class=\"row-fluid radioButton\">\n                                    <input type=\"radio\" name=\"shippingMethodRadioButton\" id=\"{{$index}}\" value=\"{{$index}}\" ng-model=\"selectedMethod.current.index\" ng-change=\"isInstantUpdateFlow && uncheckInsuranceCheckbox()\"/>\n                                    <label class=\"noBottom\" for=\"{{$index}}\">\n                                            <span class=\"methodContents\">\n                                        <span>\n                                            <span>\n                                                <span class=\"methodName\">\n                                                    {{charge.shipping_charge.shipping_method | decodeEntities}} -\n                                                </span>\n                                                <span class=\"shippingCharge\">\n                                                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"charge.shipping_charge.shipping_amount.value / 100\"></format-currency>\n                                                </span>\n                                            </span>\n                                            <span class=\"deliveryTime\">\n                                                {{charge.shipping_charge.delivery_time}}\n                                            </span>\n                                            <span class=\"description animate-show\" ng-if=\"shippingMethods.isStorePickUp(charge.shipping_charge.shipping_method_type)\" ng-show=\"selectedMethod.current.index == $index\">\n                                                {{ content('shippingMethod.storeLocationInfo') }}\n                                            </span>\n                                        </span>\n                                        <span ng-if=\"charge.shipping_charge.offer_insurance_option\" ng-show=\"showInsurance($index)\" class=\"insuranceOfferedInOption checkbox\">\n                                            <input ng-model=\"selectedMethod.current.insuranceSelected\" type=\"checkbox\" id=\"insurance\" value=\"false\">\n                                            <label for=\"insurance\" ng-bind-html=\"htmlContent('shippingMethod.addShippingInsurance', { amount: formatAmount(charge.shipping_charge.insurance_amount) })\"></label>\n                                        </span>\n                                    </span>\n                                    </label>\n                                </div>\n                                <hr class=\"hr\" ng-if=\"!$last\">\n                            </div>\n                        </div>\n                        <input id=\"confirmShippingMethod\" type=\"button\" class=\"confirmation btn\" value=\"{{ content('shippingMethod.continue') }}\" ng-click=\"actions.continueHandler()\">\n                    </div>\n                </div>\n            </div>\n            <div class=\"logo\"></div>\n        </xo-modal>\n    </div>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _utilFunctions = __webpack_require__("../node_modules/xo-form-components/src/travel-rule/utilFunctions.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/travel-rule/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/travel-rule/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoTravelRule', {
    tag: 'xo-travel-rule',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        finish: {
            type: 'var',
            required: false
        },
        onUserInfoSuccess: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.token).retrieve()
            };
        }
    },

    actions: {
        submit: function submit() {
            var _this = this;

            var data = {};

            if (this.needPayerGovtId) {
                var chosenIdDetails = this.idTypes.find((0, _utilFunctions.findChosenId)(this.idData.type));

                // Scrub the formatting when invoking the backend services.
                var unformatted = (this.idData.value || '').replace(/[^0-9a-zA-Z]+/g, '');

                data.newDocId = {
                    type: chosenIdDetails.idType,
                    subType: chosenIdDetails.idSubtype,
                    issuerCountry: this.idData.country,
                    issuer: chosenIdDetails.idIssuer,
                    value: unformatted,
                    collectionPoint: 'UNKNOWN',
                    placeOfIssue: this.idData.country
                };
            }

            if (this.needPayerAddress) {
                var address = this.address;


                data.newAddress = {
                    address1: address.line1,
                    address2: address.line2,
                    city: address.city,
                    state: address.state,
                    zip: address.postal_code,
                    iso_country: 'US'
                };
            }

            var onUserInfoSuccess = this.onUserInfoSuccess || function () {
                var checkoutCart = _index2.$CheckoutCartModel.instance(_this.token);

                return _this.models.checkoutSession.action('create', {
                    data: {
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                    },
                    success: function success() {
                        // Clear the errors if create checkout session was successful
                        _this.models.checkoutSession.errorData = undefined;
                        _this.finish();
                    }
                });
            };

            this.userInfo.action('governmentId-address', {
                data: data,

                success: onUserInfoSuccess,

                validation: function validation(validationData) {
                    var $field = _this.$element.find('#data');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                    $field.focus();
                }
            });
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            var country = _index.$locale.getCountryCodeISO();

            this.country = country;
            this.address = { country: country };
            this.countryList = _index.$locale.metadata.territory;
            this.idTypes = (0, _utilFunctions.getIdTypes)(_index.$locale.content);
            this.idData = (0, _utilFunctions.getIdData)();

            this.idTypeChanged = function () {
                _this2.idData.country = 'US';
            };

            var checkoutSession = _index2.$CheckoutSessionModel.instance(this.token);
            var payerDetailsTypes = checkoutSession.get('errorData.resolution.data', []);

            if (payerDetailsTypes.includes('GOVERNMENT_ID')) {
                this.needPayerGovtId = true;
            }

            if (payerDetailsTypes.includes('STREET_ADDRESS')) {
                this.needPayerAddress = true;
            }

            this.userInfo = _index3.$UserInfoModel.instance(this.token);
        }
    }
});
// This component probably shouldn't be in xo-form-components, as xo-address-components depends on xo-form-components
// If below is included, the tests will error due to duplicate xo-form-components being loaded.
// import 'xo-address-components/src/add-address/directive';

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index3.$UserInfoModel;

_utilFunctions.findChosenId;

_utilFunctions.getIdData;

_utilFunctions.getIdTypes;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/template.html":
/***/ (function(module, exports) {

module.exports = "<form id=\"travelRuleForm\" name=\"travelRuleForm\" class=\"travelRuleForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <h3 class=\"gamma noHead\">{{ content('travelRule.travelRule') }}</h3>\n        <p>{{ content('travelRule.note') }}</p>\n\n        <div ng-if=\"needPayerGovtId\" class=\"govtId\">\n            <div class=\"dropdown idType inputField\" floating-label-dropdown>\n                <select xo-dropdown\n                        name=\"idType\"\n                        ng-model=\"idData.type\"\n                        id=\"idType\"\n                        ng-change=\"idTypeChanged()\"\n                        aria-required=\"true\">\n                    <option ng-repeat=\"item in idTypes track by $index\" value=\"{{item.name}}\" ng-selected=\"idData.type === '{{item.name}}'\">{{item.value}}</option>\n                </select>\n                <label for=\"idType\">{{content('travelRule.idType')}}</label>\n            </div>\n            <div></div>\n            <div class=\"inputField confidential\"\n                ng-switch on=\"idData.type\">\n                <div class=\"animate-switch\" ng-switch-when=\"SSN\">\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.ssnPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"TaxID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.taxIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.taxIdPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"EmployerID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.employerIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.employerIdPlaceHolder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"Passport\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.passportDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.passportPlaceholder') }}\"/>\n                    <div class=\"dropdown confidential country clearfix inputField\" content floating-label-dropdown>\n                        <select xo-dropdown name=\"passportCountry\" ng-model=\"idData.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"passportCountry\" aria-labelledby=\"countryLabel\" xo-error-tooltip required>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"AlienNumber\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.aNumberDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.aNumberPlaceholder') }}\"/>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"needPayerAddress\" class=\"address\">\n            <p>{{ content('travelRule.pleaseEnterStreetAddress') }}</p>\n            <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('travelRule.payButton') }}\" class=\"btn full btn-large\" validate-submit=\"actions.submit()\" />\n        </div>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/utilFunctions.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var findChosenId = exports.findChosenId = function findChosenId(id) {
    return function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            name = _ref.name;

        return name === id;
    };
};

var getIdTypes = exports.getIdTypes = function getIdTypes(content) {
    return [{
        name: 'SSN',
        value: content.get('travelRule.ssnDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'SSN',
        idIssuer: 'US_SSN'
    }, {
        name: 'TaxID',
        value: content.get('travelRule.taxIdDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'ITIN',
        idIssuer: 'US_ITIN'
    }, {
        name: 'EmployerID',
        value: content.get('travelRule.employerIdDropdownLabel'),
        idType: 'TAX_ID',
        idSubtype: 'TIN',
        idIssuer: 'US_TIN'
    }, {
        name: 'Passport',
        value: content.get('travelRule.passportDropdownLabel'),
        idType: 'PASSPORT',
        idIssuer: 'PASSPORT'
    }, {
        name: 'AlienNumber',
        value: content.get('travelRule.aNumberDropdownLabel'),
        idType: 'IMMGT_ID',
        idIssuer: 'IMMIGRATION'
    }];
};

var getIdData = exports.getIdData = function getIdData() {
    return {
        type: 'SSN',
        value: '',
        country: 'US'
    };
};

/***/ }),

/***/ "../node_modules/xo-form-components/src/zipcode/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/zipcode/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoZipcode', {
    tag: 'xo-zipcode',

    template: _template2['default'],

    props: {
        address: {
            reqiured: false,
            type: 'var'
        },
        attrPrefix: {
            required: false,
            type: 'var'
        },
        country: {
            required: false,
            type: 'str'
        },
        doneFn: {
            required: false,
            type: 'var'
        },
        keyPressFn: {
            required: false,
            type: 'var'
        },
        maxLength: {
            required: false,
            type: 'var'
        },
        postalCodeLabel: {
            required: false,
            type: 'var'
        },
        zipEntry: {
            required: false,
            type: 'var'
        },
        zipErrorKey: {
            required: false,
            type: 'str'
        },
        zipLabel: {
            required: false,
            type: 'str'
        },
        zipRequired: {
            reqiured: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            this.formatRegex = undefined;
            this.inputParams = (0, _squid.$feature)('zipcodeInputParams', undefined, this.country);

            if (this.inputParams) {
                this.minLength = this.inputParams.minLength;
                this.maxLength = this.inputParams.maxLength;

                if (this.inputParams.formatPattern) {
                    this.formatRegex = new RegExp(this.inputParams.formatPattern, 'g');
                }
            }

            this.formatZipWithDash = function (zipcode, index) {
                if (zipcode.length > index) {
                    zipcode = zipcode.slice(0, index) + '-' + zipcode.slice(index);
                }

                return zipcode;
            };
        }
    },

    actions: {
        changeZip: function changeZip(zipcode) {
            if (zipcode) {

                if (this.formatRegex) {
                    zipcode = zipcode.replace(this.formatRegex, '');
                }

                if (this.inputParams && this.inputParams.formatZip) {
                    zipcode = this.formatZipWithDash(zipcode, this.inputParams.minLength);
                }

                this.address.postal_code = zipcode;
            }
        },
        doneFunction: function doneFunction() {
            if (this.doneFn) {
                this.doneFn();
            }
        },
        keyPressHandler: function keyPressHandler(event) {
            if (this.keyPressFn) {
                this.keyPressFn(event);
            }
        }
    }
});


_squid.$Component;

_squid.$feature;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/zipcode/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"zipField\" data-test-id=\"zipField\" class=\"inputField confidential postalCode\" prefix-attrs-with=\"{{attrPrefix}}\" floating-label directionality content>\n    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" data-test-id=\"address.postal_code\"\n        track-focus-and-blur=\"postalCode\"\n        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" ng-change=\"actions.changeZip(address.postal_code)\" xo-validation='{\"validator\": \"validZip\"}'\n        minlength=\"{{minLength}}\" maxlength=\"{{maxLength}}\" ng-blur=\"actions.doneFunction()\" ng-keypress=\"actions.keyPressHandler($event)\"\n        data-error-key=\"{{zipErrorKey}}\" xo-error-tooltip ng-required=\"{{zipRequired}}\" prefix-attrs-with=\"{{attrPrefix}}\"/>\n    <label for=\"postalCode\" id=\"postalCodeLabel\" data-test-id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ zipLabel }}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-login-components/src/create-password/styles.less");

var _template = __webpack_require__("../node_modules/xo-login-components/src/create-password/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CONTENT_KEY_MAP = {
    ADD_CARD: {
        benefitsKey: 'passwordRecovery.stepUpBenefits',
        reasonKey: 'passwordRecovery.stepUpAddCard'
    },
    ADD_SHIPPING: {
        benefitsKey: 'passwordRecovery.stepUpBenefits',
        reasonKey: 'passwordRecovery.stepUpAddShipping'
    },
    APPLY_PPC: {
        benefitsKey: 'passwordRecovery.stepUpApplyPPCBenefits',
        reasonKey: 'passwordRecovery.stepUpApplyPPC'
    },
    GENERIC: {
        benefitsKey: 'passwordRecovery.stepUpGenericBenefits',
        reasonKey: 'passwordRecovery.stepUpGeneric'
    },
    NEW_PHONE: {
        reasonKey: 'passwordRecovery.stepUpNewPhone'
    },
    NEED_US_ADDRESS: {
        reasonKey: 'passwordRecovery.stepUpNeedUSAddress'
    },
    CARD_EXPIRED: {
        reasonKey: 'passwordRecovery.stepUpCardExpired'
    },
    MERCHANT_NOT_ACCEPT_AMEX: {
        reasonKey: 'passwordRecovery.stepUpMerchantNotAcceptAmex'
    },
    NEED_CREDIT_CARD: {
        reasonKey: 'passwordRecovery.stepUpContigencyAddCard'
    },
    PAYER_AUTHENTICATION_REQUIRED: {
        reasonKey: 'passwordRecovery.stepUpNewAddress'
    },
    BILLING_AGREEMENTS: {
        reasonKey: 'passwordRecovery.stepUpBillingAgreements'
    },
    GENERIC_CONTINGENCY: {
        reasonKey: 'passwordRecovery.stepUpContigencyGeneric'
    }
};

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryLandingDirective', {
    tag: 'xo-create-password',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        onContinue: {
            type: 'var',
            required: false
        },
        onCancel: {
            type: 'var',
            required: false
        },
        reason: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.contingencyName = this.reason && _squid.$util.camelToCapsUnderscore(this.reason) || 'GENERIC';
            this.getReasonKey = function () {
                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).reasonKey;
            };

            this.getBenefitsKey = function () {
                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).benefitsKey;
            };
            this.onSubmit = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'quick_security_check',
                    to: 'process_quick_security_check'
                });
                _this.onContinue();
            };
        }
    }
});


_squid.$Component;

_squid.$util;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"createPassword\" content>\n    <div class=\"heading\">{{content('passwordRecovery.quickSecurityCheck')}}</div>\n\n    <div class=\"msg\">{{content(getReasonKey())}}</div>\n\n    <div class=\"msg\">{{content(getBenefitsKey())}}</div>\n\n    <button class=\"btn full continueBtn\" ng-click=\"onSubmit()\">{{content('common.continueLabel')}}</button>\n    <div ng-if=\"onCancel\" class=\"cancelLink\"><a ng-click=\"onCancel($event)\">{{content('common.cancel')}}</a></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _utils = __webpack_require__("../node_modules/xo-login-components/src/dolphin/utils.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/dolphin/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/dolphin/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-dolphin',
    template: _template2['default'],
    actions: {
        startTimer: function startTimer() {
            var _this = this;

            _logger.$logger.info('xoDolphin_startTimer');
            // Set a 10 second timer to check if UL has loaded or not
            this.isTimerRunning = true;
            (0, _angular.$timeout)(function () {
                if (!_this.hasOverlayLoaded && _this.isTimerRunning) {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'overlay_timeout',
                        'context_id': _angular.$rootScope.token
                    });
                    _this.isTimerRunning = false;
                    _this.showSpinner = false;
                }
            }, this.timerDuration);
        },
        closeBanner: function closeBanner() {
            this.showBanner = false;
            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': 'close_banner',
                'context_id': _angular.$rootScope.token
            });
        },
        openOverlay: function openOverlay() {
            var _this2 = this;

            var onPostMessagesHandler = function onPostMessagesHandler(postMessage) {
                if (!angular.isObject(postMessage)) {
                    try {
                        postMessage = JSON.parse(postMessage);
                    } catch (e) {
                        _logger.$logger.info('xoDolphin_jsonParseFailed');
                    }
                }

                if (!postMessage || !postMessage.data || !postMessage.data.event) {
                    _logger.$logger.info('xoDolphin_invalidPostMessage');
                    return;
                }

                _this2.showSpinner = false;

                if (postMessage.data.event === 'phoneConfirmationLoaded') {
                    _this2.hasOverlayLoaded = true;
                    _angular.$rootScope.$emit('loaded');
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'overlay_loaded',
                        'context_id': _angular.$rootScope.token
                    });
                }

                if (postMessage.data.event === 'phoneConfirmationCompleted') {
                    _this2.isPhoneConfirmed = true;
                    // For auto triggered overlays (confirm3 & add3), the banner is hidden by default
                    // Unhide it once phone confirmation completes or SMS to complete it is sent out
                    if (_this2.toastParams.autoTriggeredOverlay) {
                        _logger.$logger.info('xoDolphin_showBannerOnAutoTriggeredOverlay');
                        _this2.showBanner = true;
                    }
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'successfully_confirmed',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'smsSent') {
                    // Set isPhoneConfirmed to true as user will complete the phone confirmation from sms
                    // hence from app point of view it s completed for the 'current' request
                    // Also, the experience is exactly the same (show success message)
                    _this2.isPhoneConfirmed = true;
                    _this2.successContent = _this2.toastParams.smsSentKey;
                    _this2.showBanner = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'sms_sent',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'phoneConfirmationError') {
                    _this2.hasOverlayLoaded = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'generic_error',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'close') {
                    _this2.hasOverlayLoaded = true;
                    _this2.actions.closeOverlay();
                }

                // One Touch WPS Post Messages
                if (postMessage.data.event === 'oneTouchWPSError') {
                    _this2.hasOverlayLoaded = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'error',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'oneTouchWPSViewLoaded') {
                    _this2.hasOverlayLoaded = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'view_loaded',
                        'context_id': _angular.$rootScope.token
                    });
                }

                if (postMessage.data.event === 'oneTouchWPSActivateButtonClicked') {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'activate',
                        'context_id': _angular.$rootScope.token
                    });
                }

                if (postMessage.data.event === 'oneTouchWPSSuccess') {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'success',
                        'context_id': _angular.$rootScope.token
                    });
                    (0, _angular.$timeout)(function () {
                        _this2.actions.closeOverlay();
                    }, 3000);
                }

                if (postMessage.data.event === 'oneTouchWPSNotNowClicked') {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'not_now',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }
            };

            (0, _angular.$timeout)(function () {
                _logger.$logger.info(_utils.flowName, {
                    'from': 'show_banner',
                    'to': 'show_overlay',
                    'context_id': _angular.$rootScope.token
                });

                _this2.$element.addClass('overlayOpen').promise().then(function () {
                    // Note: A second timeout is added here to avoid a race condition where the DOM is not yet available
                    // for the inject script to pick a targetElement for injecting the iframe.
                    (0, _angular.$timeout)(function () {
                        var variant = _this2.toastParams && _this2.toastParams.variant;
                        var options = (0, _utils.getInjectULBaseObject)(variant);

                        options.onPostMessage = onPostMessagesHandler;
                        if (!options.targetElement) {
                            _logger.$logger.info('xoDolphin_missingTargetElement');
                        }
                        // Since, One Touch interstitial has a spinnner with lock icon
                        // hidinng this spinnner for consistent experience
                        if (variant !== 'wpsOneTouchInterstitial') {
                            _this2.showSpinner = true;
                        }
                        if (window.PAYPAL && window.PAYPAL.unifiedLogin && options.targetElement) {
                            _logger.$logger.info('xoDolphin_injectIframe');
                            window.PAYPAL.unifiedLogin.inject(options);
                            _this2.actions.startTimer();
                        }
                    });
                });
            });
        },
        closeOverlay: function closeOverlay() {
            var _this3 = this;

            this.$element.removeClass('overlayOpen');
            this.isTimerRunning = false;
            this.showSpinner = false;
            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': 'overlay_closed',
                'context_id': _angular.$rootScope.token
            });
            (0, _angular.$timeout)(function () {
                _logger.$logger.info('xoDolphin_hideOverlay');
                _this3.showOverlay = false;
                _this3.hasOverlayLoaded = false;
            }, 300);
        }
    },
    lifecycle: {
        enter: function enter() {
            var ulToast = _squid.$util.param('ulToast') || _squid.$util.param('ulToastWpsDone');

            this.toastParams = ulToast && _utils.variantParams[ulToast];
            this.isPhoneConfirmed = false;
            this.hasOverlayLoaded = false;
            this.isTimerRunning = false;
            this.timerDuration = 10000;
        },
        populate: function populate() {
            var _this4 = this;

            if (!this.toastParams) {
                _logger.$logger.info('Missing or invalid toast param!');
                return;
            }

            this.showBanner = !this.toastParams.autoTriggeredOverlay;
            this.showOverlay = this.toastParams.autoTriggeredOverlay;
            this.bannerContent = this.toastParams.messageKey;
            this.successContent = this.toastParams.successKey;
            this.autoTriggeredOverlay = this.toastParams.autoTriggeredOverlay;
            this.variant = this.toastParams.variant;
            // DeviceInfo doesnt seem to have isDesktop, hence just avoiding the mobile use case
            this.fixedBanner = _index.$DeviceInfo.isMobile() ? '' : 'dolphinBannerFixed';

            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': this.toastParams.transitionName,
                'banner_type': this.toastParams.bannerType,
                'context_id': _angular.$rootScope.token
            });

            // Cannot use `$apply` as we need to wait for the entire digest cycle to complete
            (0, _angular.$timeout)(function () {
                if (_this4.autoTriggeredOverlay) {
                    _this4.actions.openOverlay();
                    return;
                }
                angular.element('#confirmPhoneBtn').on('click', function () {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'click_link',
                        'context_id': _angular.$rootScope.token
                    });
                    _this4.showOverlay = true;
                    // Allow overlay DOM to be added before animating it in
                    (0, _angular.$timeout)(_this4.actions.openOverlay, 150);
                });
                // Add a delay to open the overlay when it's A) auto trigger and B) Not WPS OR
                // Add a delay to open the overlay when it's A) auto trigger and B) WPS Done with One Touch variant
                // `ulToastWpsDone` will be added by UL only if it is indeed a WPS flow
            }, this.autoTriggeredOverlay && !_squid.$util.param('ulToastWpsDone') || this.autoTriggeredOverlay && _squid.$util.param('ulToastWpsDone') === 'wpsOneTouchInterstitial' ? 1800 : 0);
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.$util;

_logger.$logger;

_index.$DeviceInfo;

_utils.getInjectULBaseObject;

_utils.flowName;

_utils.variantParams;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"dolphinContainer\" ng-if=\"showBanner\">\n    <section class=\"dolphinBanner {{ fixedBanner }}\" content>\n        <div class=\"dolphinBannerContent {{ variant }}\" ng-if=\"!isPhoneConfirmed\" ng-bind-html=\"htmlContent(bannerContent)\"></div>\n        <div class=\"dolphinBannerContent\" ng-if=\"isPhoneConfirmed\">\n            <span class=\"dolphinBannerSuccessIcon\"></span>\n            <span class=\"dolphinBannerSuccessContent\">{{ content(successContent) }}</p>\n        </div>\n        <div class=\"dolphinBannerCloseIcon\" ng-click=\"actions.closeBanner()\"></div>\n    </section>\n</div>\n<section ng-if=\"showOverlay\" class=\"pageOverlay\">\n    <div ng-if=\"!autoTriggeredOverlay\" class=\"overlayMask\"></div>\n    <div ng-if=\"autoTriggeredOverlay\" class=\"overlayAutoTriggerMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"actions.closeOverlay()\"></a>\n                <div id=\"injectedULPhoneConfirmation\"></div>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n    <div ng-if=\"showSpinner\" class=\"spinner\">\n        <div class=\"spinWrap\">\n            <p class=\"loader\"></p>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getDolphinEligibility = exports.variantParams = exports.flowName = exports.getInjectULBaseObject = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _eligibility = __webpack_require__("../node_modules/xo-models/src/eligibility/index.js");

var getCreditInterstitialEligibility = function getCreditInterstitialEligibility() {
    // TODO: Refactor the usage of PXP result stored in rootScope once Credit team make a change to this
    var creditInterstitialPXPResult = _angular.$rootScope['creditInterstitialPXPResult'];
    var creditInterstitialControl = 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial_control';
    // If there is a value && it is not Control, then it's any of the treatments

    return creditInterstitialPXPResult && creditInterstitialPXPResult !== creditInterstitialControl;
};

var getInjectULBaseObject = exports.getInjectULBaseObject = function getInjectULBaseObject(variant) {
    var options = {
        config: {
            name: 'PPFrameRedirect',
            height: 577
        },
        queryParams: {
            intent: variant === 'add3' || variant === 'confirm3' || 'wpsOneTouchInterstitial' ? 'xoAutoTrigger' : 'xoToast',
            flowId: _angular.$rootScope.token,
            flowInfo: _uiRouter.$state.current && _uiRouter.$state.current.name,
            'country.x': _squid.$locale.country,
            'locale.x': _squid.$locale.getLocaleCode()
        },
        iframePathname: '/signin/phone-confirmation',
        targetElement: document.getElementById('injectedULPhoneConfirmation')
    };

    if (variant === 'wpsOneTouchInterstitial') {
        options.queryParams.flowName = 'wpsOneTouchInterstitial';
        options.iframePathname = '/signin/activate-one-touch';
    }
    return options;
};

var flowName = exports.flowName = 'ul_dolphin';

// A simple object to map all the properties specific to a particular variant
// Not creating a function & abstracting common things for the sake of simplicity
// Once the performance is measured, only 1 of the 4 variants will be left behind
// and this object will have only 2 props again.
// A variant prop is added to define the class name in the template
// The query param's value is not used directly to avoid XSS
var variantParams = exports.variantParams = {
    confirm: {
        messageKey: 'login.confirmPhone',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'short_text_link',
        // `variant` uses a hardcoded value for th ulToast query param
        // it is used later in the flow from here instead of the query param
        variant: 'confirm'
    },
    confirm1: {
        messageKey: 'login.confirmPhoneWithButton',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'short_text_button',
        variant: 'confirm1'
    },
    confirm2: {
        messageKey: 'login.confirmPhoneLongWithButton',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'long_text_button',
        variant: 'confirm2'
    },
    confirm3: {
        // There is no messageKey in this variant
        successKey: 'login.confirmPhoneSuccess',
        smsSentKey: 'login.smsSent',
        transitionName: 'confirm_phone',
        bannerType: 'auto_trigger',
        variant: 'confirm3',
        autoTriggeredOverlay: true
    },
    add: {
        messageKey: 'login.addPhone',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'short_text_link',
        variant: 'add'
    },
    add1: {
        messageKey: 'login.addPhoneWithButton',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'short_text_button',
        variant: 'add1'
    },
    add2: {
        messageKey: 'login.addPhoneLongWithButton',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'long_text_button',
        variant: 'add2'
    },
    add3: {
        // There is no messageKey in this variant
        successKey: 'login.addPhoneSuccess',
        smsSentKey: 'login.smsSent',
        transitionName: 'add_phone',
        bannerType: 'auto_trigger',
        variant: 'add3',
        autoTriggeredOverlay: true
    },
    wpsOneTouchInterstitial: {
        variant: 'wpsOneTouchInterstitial',
        autoTriggeredOverlay: true
    }
};

var getDolphinEligibility = exports.getDolphinEligibility = function getDolphinEligibility(stateName) {
    var isReviewOrFi = /checkout\.review|checkout\.selectFi/.test(stateName) && _squid.$util.param('ulToast');

    if (!isReviewOrFi) {
        _logger.$logger.info(flowName, {
            'from': 'dolphin_elg_chk',
            'to': 'process_dolphin_elg_chk',
            'eligibility_reason': 'not_ryp',
            'context_id': _angular.$rootScope.token
        });
        return _squid.$promise.resolve();
    }

    return _eligibility.$stickyCTA.instance().getEligibility()
    // Dolphin can be enabled only in case sticky & credit interstitial are not eligibile
    .then(function (isStickyEligible) {
        var eligibilityReason = 'no_sticky_or_credit';
        var isCreditInsterstialEligible = getCreditInterstitialEligibility();

        if (isCreditInsterstialEligible) {
            eligibilityReason = 'has_credit_interstitial';
        }

        if (isStickyEligible) {
            eligibilityReason = 'has_sticky';
        }

        _logger.$logger.info(flowName, {
            'from': 'dolphin_elg_chk',
            'to': 'process_dolphin_elg_chk',
            'eligibility_reason': eligibilityReason,
            'context_id': _angular.$rootScope.token
        });

        return !isStickyEligible && !isCreditInsterstialEligible;
    });
};

_angular.$rootScope;

_uiRouter.$state;

_squid.$locale;

_squid.$promise;

_squid.$util;

_logger.$logger;

_eligibility.$stickyCTA;

/***/ }),

/***/ "../node_modules/xo-login-components/src/fullpage-onetouch-upsell/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/ul-inline/dist/inject.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/fullpage-onetouch-upsell/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFullpageOnetouchUpsell', function () {

    return {
        template: _template2['default'],
        scope: {
            token: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.locale = _squid.$LocaleModel.instance();
            $scope.disableCloseButton = _index.$DeviceInfo.isDevice();
            var ulMeta = _squid.$config.ulMeta || {};
            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 5000;
            var ulTimeoutPromise = null;
            var styleSet = false;

            var fptiData = _kmliUpsell.$KmliUpsell.getFPTIAttributes();

            function deInitStyles() {
                $('#paypalLogo').show();
                $('.footer').show();
                $('.paypalHeaderWrapper.span14').attr('style', '');
                $('.row-fluid.paypalHeaderWrapper').show();
            }

            function closeInterstitial() {
                deInitStyles();
                _uiRouter.$state.go('checkout.review');
            }

            function failureHandler(reason) {
                _logger.$logger.info('KMLI_UPSELL_error_' + reason);
                closeInterstitial();
            }

            var startTimerTS;

            function startTimer(tag) {
                startTimerTS = Date.now();
                _logger.$logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
                    startTime: startTimerTS
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'prepare_' + tag
                });

                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    var stop_time = Date.now();
                    var time_taken = stop_time - startTimerTS;

                    _logger.$logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'process_timeout',
                        'int_error_code': 'ULLOGIN_TIMEOUT',
                        'int_error_description': 'ULLOGIN_TIMEOUT',
                        'error_source': 'unifiedloginnodeweb',
                        'error_type': 'soft_decline',
                        'page_load_time': time_taken
                    });
                    failureHandler('timedout');
                    _angular.$rootScope.$emit('loaded');
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                var stopTimerTS = Date.now();
                var timeTaken = stopTimerTS - startTimerTS;

                _logger.$logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
                    stopTimer: stopTimerTS,
                    page_load_time: timeTaken
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'process_' + tag,
                    'page_load_time': timeTaken
                });

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                }
            }

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'optin'
                };

                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            $scope.$on('$locationChangeStart', function (event, next, current) {
                if (styleSet) {
                    deInitStyles();
                }
            });

            $scope.hideModal = function (event) {
                if (event) {
                    event.preventDefault();
                }

                _logger.$logger.info('checkout_fpti', {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'decline',
                    'click_source': 'close_button'
                });

                closeInterstitial();
            };

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    $('#paypalLogo').hide();
                    $('.footer').hide();
                    $('.paypalHeaderWrapper.span14').attr('style', 'border:none;');
                    $('.row-fluid.paypalHeaderWrapper').hide();
                    styleSet = true;
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    _angular.$rootScope.$emit('loading');
                    startTimer(data.event);
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit();
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit({ errorCode: data.event });
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    stopTimer(data.event);
                    logSubmit({ errorCode: data.event });
                    _angular.$rootScope.$emit('loaded');
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
                    _logger.$logger.info('checkout_fpti', {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'decline',
                        'click_source': 'not_now_link'
                    });
                    closeInterstitial(data);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;

                    if (eventId) {
                        _logger.$logger.debug('KMLI_UPSELL_' + eventId, response);
                        var handler = ulEventHandlers[eventId];

                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function loadOneTouchUpsell() {
                _angular.$rootScope.$emit('loading');
                var options = {
                    targetElement: document.getElementById('injectedOneTouchInterstitial'),
                    queryParams: {
                        'stsRedirectUri': ulMeta.stsReturnUrl,
                        'country.x': $scope.locale.country,
                        'locale.x': $scope.locale.getLocaleCode(),
                        'flowId': $scope.token,
                        'correlationId': _model.$CalDataModel.getCalCorrId(),
                        'flowName': 'checkout'
                    },
                    iframePathname: '/signin/activate-one-touch',
                    onPostMessage: postMessageHandler
                };

                angular.extend(options.queryParams, _kmliUpsell.$KmliUpsell.getOptions());

                if (_squid.$config.deploy.isLocal()) {
                    options.origin = 'https://' + _squid.$meta.stage;
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    startTimer('initializeUpsell');
                    PAYPAL.unifiedLogin.inject(options);
                } else {
                    failureHandler('PAYPAL.unifiedLogin_undefined');
                }
            }

            loadOneTouchUpsell();
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$LocaleModel;

_squid.$meta;

_uiRouter.$state;

_logger.$logger;

_index.$DeviceInfo;

_model.$CalDataModel;

_kmliUpsell.$KmliUpsell;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/fullpage-onetouch-upsell/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$FullpageOnetouchUpsellRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-login-components/src/fullpage-onetouch-upsell/directive.js");

var $FullpageOnetouchUpsellRoute = exports.$FullpageOnetouchUpsellRoute = _squid.$ComponentRoute.extend('FullpageOnetouchUpsellRoute', {
    name: 'FullpageOnetouchUpsell',
    directive: 'xo-fullpage-onetouch-upsell',
    trackingData: {
        fptiState: 'fullpage-onetouch-upsell',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-onetouch-upsell',
                'pagename2': '%::fullpage-onetouch-upsell:member:hermes:',
                'version': 'member:%:'
            }
        }
    },

    children: []
});

angular.value("$FullpageOnetouchUpsellRoute", $FullpageOnetouchUpsellRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-login-components/src/fullpage-onetouch-upsell/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\">\n    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\"></a>\n    <div id=\"injectedOneTouchInterstitial\">\n    </div>\n</div>\n<div class=\"pushLogo\"></div>\n<div class=\"logo\"></div>\n\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/login-overlay/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-login-components/src/create-password/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/handler/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/password-recovery/directive.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login-overlay/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLoginOverlay', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            stateInfo: '=?',
            modalCallback: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.autoLogin = false;
            $scope.ulEligibility = true;
            $scope.auth = _auth.$AuthModel.instance();

            var stateInfo = {};
            var subFlowTitles = {
                addCard: 'loginAddCard',
                bank: 'loginAddBank',
                addShipping: 'loginAddAddress',
                deleteShipping: 'loginDeleteAddress',
                confirmUpop: 'loginConfirmUpop',
                redirectToCape: 'loginApplyCredit',
                sepaAgreement: 'riskyLoginSepa',
                DEFAULT: 'loginTitle'
            };

            function getFptiStateName() {
                if ($scope.createPassword) {
                    return 'quick_security_check';
                } else if ($scope.passwordRecovery) {
                    return 'password_recovery';
                } else {
                    return 'LOGIN_STEP_UP_AUTH';
                }
            }

            /**
             * Use iframe for risky login use case.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLoginViaIframe = function doRiskyLoginViaIframe(event, data) {
                _logger.$logger.debug('doRiskyLoginViaIframe');
                $scope.showOverlay = true;

                $('#wrapper #spinner').hide();

                stateInfo = data;

                var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');

                if (subFlowName) {
                    $scope.subFlowName = subFlowName;
                    $scope.subFlowTitleKey = 'login.' + subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;
                }

                $scope.createPassword = (0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less;
                $scope.passwordRecovery = false;
                if ($scope.createPassword) {
                    _logger.$logger.info('checkout_fpti', {
                        from: getFptiStateName(),
                        to: 'prepare_quick_security_check'
                    });
                } else {
                    _logger.$logger.info('checkout_fpti', {
                        from: getFptiStateName(),
                        to: 'prepare_login_step_up_AUTH'
                    });
                }

                (0, _angular.$timeout)(function () {
                    $element.addClass('overlayOpen');
                });
            };

            /**
             * Do a full page redirect to ul as landing for risky login use case.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLoginViaFullpageRedirect = function doRiskyLoginViaFullpageRedirect(event, data) {
                _logger.$logger.debug('doRiskyLoginViaFullpageRedirect');
                stateInfo = data;
                var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');
                var subFlowTitleKey = subFlowName && subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;

                return $scope.auth.redirectToLogin('insufficientPermission', {
                    ulClientKey: subFlowTitleKey
                });
            };

            /**
             * Decide to do fullpage or iframe risky login.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLogin = function doRiskyLogin(event, data) {
                var isCredit = _index.$CheckoutAppDataModel.instance($scope.token).isSecondButton();

                _logger.$logger.debug('doRiskyLogin');
                if (_squid.$config.fullPageRiskyLogin && !isCredit) {
                    return doRiskyLoginViaFullpageRedirect(event, data);
                } else {
                    return doRiskyLoginViaIframe(event, data);
                }
            };

            var cancelInsufficientPermission = _angular.$rootScope.$on('$insufficientPermission', doRiskyLogin);

            $scope.$on('$destroy', cancelInsufficientPermission);

            var hideOverlay = function hideOverlay() {
                $('#wrapper #spinner').attr('style', '');
                $element.removeClass('overlayOpen');
                return (0, _angular.$timeout)(function () {
                    $scope.showOverlay = false;
                }, 300);
            };

            function logCancel() {
                _logger.$logger.info('checkout_fpti', {
                    from: getFptiStateName(),
                    to: 'process_user_cancel'
                });
            }

            $scope.hideModal = function (event) {
                event.preventDefault();
                logCancel();
                hideOverlay();
                _uiRouter.$state.go(stateInfo.oldState);
            };

            $scope.onCreatePassword = function () {
                _angular.$rootScope.$emit('loading');
                $scope.passwordRecovery = true;
            };

            $scope.onPasswordRecoveryReady = function () {
                _angular.$rootScope.$emit('loaded');
                $scope.createPassword = false;
            };

            $scope.onCompletePasswordRecovery = function () {
                $scope.passwordRecovery = false;
            };

            $scope.onPasswordRecovery = function () {
                $scope.auth.password_less = false;
            };

            $scope.onSuccess = function () {
                var checkoutSession = _index.$CheckoutSessionModel.instance($scope.token);
                var checkoutCart = _index.$CheckoutCartModel.instance(_angular.$rootScope.token);

                return checkoutSession.action('create', {
                    data: {
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                    },
                    success: function success() {
                        if (stateInfo.pageOnOverlay) {
                            _uiRouter.$state.go(stateInfo.newState, { fromLoginOverlay: true });
                            $scope.showOverlay = false;
                        } else {
                            hideOverlay().then(function () {
                                _uiRouter.$state.go(stateInfo.newState);
                            });
                        }

                        _logger.$logger.info('checkout_fpti', {
                            from: getFptiStateName(),
                            to: 'process_login_step_up_AUTH'
                        });
                    }
                })['finally'](function () {
                    hideOverlay();
                });
            };
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$feature;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/login-overlay/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showOverlay\" class=\"pageOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section class=\"login\" id=\"login\">\n                    <xo-login-handler ng-if=\"!passwordRecovery && !createPassword\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\" ul-eligibility=\"ulEligibility\" sub-flow-title-key=\"subFlowTitleKey\" hideloginpp=\"true\"></xo-login-handler>\n                    <xo-create-password ng-if=\"createPassword\" token=\"token\" reason=\"subFlowName\" on-continue=\"onCreatePassword\" on-cancel=\"hideModal\"></xo-create-password>\n                    <xo-password-recovery ng-if=\"passwordRecovery\" token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onCompletePasswordRecovery\" on-cancel=\"onCancel\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLogin', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            doneFn: '=?',
            errorFn: '=?',
            clientId: '=?',
            redirectUri: '=?',
            scope: '=?',
            autoLogin: '=?',
            apsIntegration: '=?',
            batch: '=?',
            loginSubmit: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.locale = _squid.$locale;
            var lang = _squid.$locale.lang ? _squid.$locale.lang : 'en';
            var country = _squid.$locale.country ? _squid.$locale.country : 'US';
            var localeNVP = 'locale.x=' + lang.toLowerCase() + '_' + country.toUpperCase();
            var forgotPasswordUrl = 'https://www.' + _squid.$meta.domain + '/' + country.toLowerCase() + '/webapps/accountrecovery/passwordrecovery?' + localeNVP;
            var legacyForgotPasswordUrl = 'https://www.' + _squid.$meta.domain + '/' + country.toLowerCase() + '/merchantpaymentweb?cmd=_account-recovery&from=PayPal&' + localeNVP;
            var checkoutInputData = _user.$CheckoutInputDataModel.instance(_angular.$rootScope.token);
            var creditData = _credit.$CreditDataModel.instance(_angular.$rootScope.token);
            var apsRemMe = $scope.apsIntegration === 'apsIntegrationRM';
            var $passwordField = $element.find('[ng-model="auth.password"]');
            var fptiStateName = $scope.apsIntegration ? 'LOGIN_APS' : 'LOGIN';

            $scope.forgotPasswordUrl = (0, _squid.$feature)('newForgotPasswordSupported') ? forgotPasswordUrl : legacyForgotPasswordUrl;
            _fn.$fn.sendTypingSpeedPayload('Hermes');

            /* ******** Here goes the Remember User controls *************************** */

            // Show the RM consent section when
            // 1. feature is ON
            // 2. when its not a contingency flow
            // 3. eBay doesn't want to hide it explicitly

            if (checkoutInputData.rmEnabled(Boolean(_squid.$config.rememberMeFeatureEnabled)) && !checkoutInputData.hideRM()) {
                fptiStateName = 'LOGIN_RM';
                $scope.rememberMe = 'nonKmli';
            } else if (apsRemMe) {
                $scope.rememberMe = 'kmli';
            }
            $scope.rememberMeChkBox = {
                // Leave the consent box un-ticked by default
                agreed: false
            };

            // Show the RM details only if user clicks on 'learn more' link or clicks on Checkbox
            $scope.showRmMore = false;

            // Expand details when RM check-box is ticked and Remember the user
            $scope.toggleRMDetails = function () {
                $scope.showRmMore = $scope.rememberMeChkBox.agreed;
            };

            function setRememberUser() {
                if (checkoutInputData.rmEnabled(Boolean(_squid.$config.rememberMeFeatureEnabled))) {
                    if (checkoutInputData.hideRM() === 'true') {
                        // Feature is ON but consent box is hidden since hideRM param is true
                        // Do not remember user in this case
                        $scope.auth.rememberUser = false;
                    } else {
                        // RM is enabled and consent box displayed on login page
                        // Remember the user based on the consent of user
                        $scope.auth.rememberUser = $scope.rememberMeChkBox.agreed ? true : false;
                    }
                } else {
                    // Feature is wired off
                    // If RM is not enabled that means the control is with eBay and we should retain current behavior by remembering the user
                    $scope.auth.rememberUser = true;
                }
            }

            /* ************ Remember User Ends *************************************** */

            function showLoadingMessage() {
                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get(creditData.isRedirectFromCape() || creditData.isChangeStatus() ? 'base.processing' : 'base.loggingIn'));
            }

            function loginAction() {
                showLoadingMessage();
                var loginInput = {
                    user: {
                        email: $scope.auth.email,
                        password: $scope.auth.password
                    }
                };

                if ($scope.clientId) {
                    loginInput.client = {
                        redirect_uri: _squid.$config.app_redirect_uri,
                        client_id: _squid.$config.app_clientId || '',
                        target_client_id: _squid.$util.param('fromLipp') === 'true' ? $scope.clientId : _squid.$util.base64Decode($scope.clientId), // eslint-disable-line block-scoped-var,no-undef
                        scope: $scope.scope,
                        response_type: 'token id_token',
                        skip_oauth: false,
                        skip_consent: true
                    };
                } else if ($scope.apsIntegration) {
                    loginInput.client = {
                        remember_me: Boolean(apsRemMe && $scope.rememberMeChkBox.agreed)
                    };
                    loginInput.fastLogin = true;
                }

                // updated the product to decide the entry point
                loginInput.product = _angular.$rootScope.wps ? 'wps' : 'ec';

                // if risk_correlation_id (fraudNetId) is present in cart, then include it to req
                loginInput.fraudnet_id = $scope.checkoutCart.supplementary && $scope.checkoutCart.supplementary.risk_correlation_id;

                // add token (cart-id) in context for RL
                var adsClientContextData = { context_type: 'Cart-ID', context_id: $scope.token };

                loginInput['ads-client-context-data'] = adsClientContextData;
                $scope.auth.action('login', {
                    data: loginInput,
                    headers: {
                        'x-pp-ads-client-context-data': JSON.stringify(adsClientContextData)
                    },
                    success: function success(result) {
                        var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiStateName,
                            'to': transition_name
                        });

                        if (window.xprops && window.xprops.onAuth && $scope.auth.access_token) {
                            return window.xprops.onAuth({
                                accessToken: $scope.auth.access_token
                            }).then(function () {
                                return $scope.doneFn($scope.auth);
                            });
                        }
                        return $scope.doneFn($scope.auth);
                    },

                    contingencies: {
                        DEFAULT: function DEFAULT(name, contingency) {
                            var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
                            var error_source = $scope.apsIntegration ? 'aps' : 'userauth';

                            _logger.$logger.info('checkout_fpti', {
                                'from': fptiStateName,
                                'to': transition_name,
                                'int_error_description': contingency && contingency.message,
                                'error_type': 'soft_decline',
                                'error_source': error_source
                            });
                            $scope.auth.password = '';
                            $passwordField.focus();
                            return $scope.errorFn(name, contingency);
                        }
                    }
                });
            }

            $scope.$on('$destroy', function () {
                $scope.auth.password = '';
            });

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                if ($scope.auth.loggedIn()) {
                    if ($scope.autoLogin) {
                        showLoadingMessage();
                        if ($scope.auth.remembered) {
                            _logger.$logger.info('REMEMBERED_ACTIVE_SESSION');
                        } else {
                            _logger.$logger.info('ACTIVE_SESSION');
                        }
                        return $scope.doneFn($scope.auth);
                    }
                } else if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.email && !$scope.auth.timed_out) {
                    $scope.auth.email = $scope.checkoutCart.payer.email;
                }
                var transition_name = void 0;

                if (apsRemMe) {
                    transition_name = 'prepare_login_rm';
                } else if (creditData.isCreditTxn()) {
                    transition_name = 'prepare_login_ppc';
                } else {
                    transition_name = 'prepare_login';
                }

                var app_int_type = _dist.$DeviceInfo.getAppIntegrationType();

                _logger.$logger.info('checkout_fpti', {
                    'from': fptiStateName,
                    'to': transition_name,
                    'app_int_type': app_int_type
                });
                $scope.onSubmit = function () {
                    setRememberUser();
                    loginAction();
                };
            });
        }]
    };
});

_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_dist.$DeviceInfo;

_credit.$CreditDataModel;

_user.$CheckoutInputDataModel;

_index.$CheckoutCartModel;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$util;

_squid.$meta;

_fn.$fn;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/fn.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fn', function () {
    var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
    var fnCorrId;
    var fraudnetConfig = _squid.$config.fraudnet;
    var token = _angular.$rootScope.token || _squid.$meta.token;

    if (_squid.$meta.baToken) {
        _logger.$logger.info('BEAM_In_Hermes_Checkout');
        fnCorrId = _squid.$meta.baToken;
    } else if (_angular.$rootScope.fraudNetId) {
        fnCorrId = _angular.$rootScope.fraudNetId;
    } else {
        fnCorrId = _angular.$rootScope.token || _squid.$meta.token;
    }

    var options = {
        fnSessionId: fnCorrId,
        sourceId: fraudnetConfig && fraudnetConfig.sourceId || 'HERMES_SIGNIN',
        allowsCustomEvent: typeof CustomEvent !== 'undefined' && _angular2['default'].isFunction(CustomEvent)
    };

    function init() {

        _logger.$logger.info('FN_contexts', {
            'token': token,
            'fnSessionId': options.fnSessionId
        });

        // Todo: remove the conditional logic after all the boxes picked up latest config.
        if (_angular2['default'].isString(_squid.$config.urls.fraudnetUrl)) {
            options.fnUrl = _squid.$config.urls.fraudnetUrl;
        } else {
            options.fnUrl = _squid.$config.urls.fraudnetUrl && _squid.$config.urls.fraudnetUrl.passive;
        }

        _logger.$logger.info('FN_Initialised', {
            'allowsCustomEvent': options.allowsCustomEvent
        });
    }

    var enableFraudnet = function enableFraudnet() {
        var userAgent = _angular.$window.navigator.userAgent;

        // Disable for web view
        if (_index.$DeviceInfo.isApp()) {
            if (_angular.$window.enableFraudNetForMobileWebView) {
                _logger.$logger.info('Enable_FN_MobileApp_PXP_Decision');
                return true;
            }

            _logger.$logger.info('Disable_FN_Mobileapp');
            return false;
        } else if (userAgent.indexOf('EtsyInc') > -1) {
            _logger.$logger.info('Disable_FN_Etsy');
            return false;
        }
        _logger.$logger.info('Enable_FN');
        return true;
    };

    function injectScript(fnUrl) {
        var script = document.createElement('script');

        script.id = 'js-sync';
        script.src = fnUrl;
        document.body.appendChild(script);
    }

    function injectIframe(beaconOptions) {
        var iframe = document.createElement('iframe');
        var dom;
        var doc;
        var where;

        iframe.src = 'about:blank'; // eslint-disable-line no-script-url
        iframe.title = '';
        iframe.role = 'presentation';
        (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; display: none;';

        where = document.getElementsByTagName('script');
        where = where[where.length - 1];
        where.parentNode.insertBefore(iframe, where);

        try {
            doc = iframe.contentWindow.document;
        } catch (e) {
            dom = document.domain;
            iframe.src = 'javascript:var d=document.open();d.domain="' + dom + '";void(0);'; // eslint-disable-line no-script-url
            doc = iframe.contentWindow.document;
        }

        doc.open()._l = function () {
            var js = this.createElement('script');

            if (dom) {
                this.domain = dom;
            }
            js.id = 'js-iframe-async';
            js.src = beaconOptions.fnUrl;
            this.body.appendChild(js);
        };
        function listener() {
            doc._l();
        }
        if (iframe.addEventListener) {
            iframe.addEventListener('load', listener, false);
        } else if (iframe.attachEvent) {
            iframe.attachEvent('onload', listener);
        } else {
            doc.write('<body onload="document._l();">');
        }
        doc.close();
    }

    function _injectConfig(configOptions) {
        var script = document.getElementById('fconfig');

        if (script) {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        }

        script = document.createElement('script');
        script.id = 'fconfig';
        script.type = 'application/json';
        script.setAttribute('fncls', fncls);

        script.text = '{"f": "' + configOptions.fnSessionId + '", "s": "' + configOptions.sourceId + '", "cb": "fnCallback"}';
        document.body.appendChild(script);
    }

    /**
     * Loads the fraudnet beacons (triggers 2 image beacons to c.paypal.com and c6.paypal.com)
     *
     * Integration pattern ripped from the Fraudnet Integration guide:
     * https://confluence.paypal.com/display/RiskDataAcquisition/FraudNet+Client+System+Integration+Guide+3.0#FraudNetClientSystemIntegrationGuide3.0-IntegrationCode
     */
    function _loadBeacon(beaconOptions) {
        if (_index.$DeviceInfo.isApp() && _angular.$window.enableFraudNetForMobileWebView) {
            injectScript(beaconOptions.fnUrl);
        } else {
            injectIframe(beaconOptions);
        }
    }

    function trigger(scope) {

        var fnLoaded = !!_angular.$rootScope.fnLoaded;

        if (fnLoaded) {
            return false;
        }
        _logger.$logger.info('Trigger_FN');

        if (options.fnUrl) {
            if (enableFraudnet()) {
                _angular.$window.fnCallback = function () {
                    if (scope) {
                        scope.$emit('fnCallback');
                    }
                };
                _injectConfig(options);
                _loadBeacon(options);
                _angular.$rootScope.fnLoaded = true;
                return true;
            }
        }
        return false;
    }

    /**
     * send a payload to fraudnet for analysing typing speed
     * @param type
     */
    function sendTypingSpeedPayload(type) {

        var tsLoadPayload = {
            'detail': {
                'type': type
            }
        };

        if (type === 'Hermes') {
            tsLoadPayload.detail['fields'] = ['username', 'password'];
        }
        if (type === 'HermesUL') {
            tsLoadPayload.detail['frame'] = 'injectedUl';
            tsLoadPayload.detail['fields'] = ['email', 'password'];
        }

        if (type) {
            var event;

            if (options.allowsCustomEvent) {
                // document.createEvent deprecated
                _logger.$logger.info('fn_CustomEvent_type1');
                event = new CustomEvent('tsLoad', tsLoadPayload);
            } else {
                // IE does not support CustomEvent constructor
                try {
                    _logger.$logger.info('fn_CustomEvent_type2');
                    event = window.document.createEvent('CustomEvent');
                    event.initCustomEvent('tsLoad', true, true, tsLoadPayload.detail);
                } catch (err) {
                    _logger.$logger.info('fn_CustomEvent_None', {
                        'error': err
                    });
                }
            }
            if (event) {
                window.document.dispatchEvent(event);
                _logger.$logger.info('Dispatched_FN_TS_Payload_' + type);
            }
        }
    }

    return {
        init: init,
        trigger: trigger,
        sendTypingSpeedPayload: sendTypingSpeedPayload
    };
});

_squid.$config;

_squid.$meta;

_angular.$rootScope;

_angular.$window;

_logger.$logger;

_index.$DeviceInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-login-components/src/login", "../node_modules/xo-login-components/src/login/fn.js"))

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/handler/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _props = __webpack_require__("../node_modules/xo-login-components/src/login/props.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login/handler/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/unified-login/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLoginHandler', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            successCallback: '=?',
            contingencyCallback: '=?',
            autoLogin: '=?',
            ulEligibility: '=?',
            subFlowTitleKey: '=?',
            apsIntegration: '=?',
            batch: '=?',
            loginSubmit: '=?',
            logout: '=?',
            preAuth: '=?',
            hideloginpp: '=?',
            flowcontext: '=?',
            hideTitle: '=?'
        },

        controller: ['$scope', function ($scope) {
            // Login Contingency Handling
            var CONTENT_KEY = {
                INVALID_EMAIL_PASSWORD: 'invalidEmailPasswordPageError',
                ACCOUNT_LOCKED: 'accountLockedPageError',
                ACCOUNT_CLOSED: 'accountLockedPageError',
                INVALID_PHONE: 'invalidPhone',
                INVALID_PIN: 'invalidPin',
                INVALID_ACCESS_TOKEN: 'invalidAccessToken',
                TIMED_OUT: 'loginStatusTimedOut',
                CANNOT_PAY_SELF: 'cannotPaySelf',
                RISK_DECLINE: 'riskDeclinePageError',
                LOGIN_ADD_PHONE: 'loginAddPhone',
                LOGIN_PREFILLED_SHIPPING_ADDRESS: 'loginMerchantPassedAddress',
                LOGIN_CONTINGENCY: 'loginContingency',
                LOGIN_REACTIVATE: 'checkOneTouch',
                LOGIN_LEAVECHECKED: 'leaveOneTouchChecked',
                LOGIN_OT_GENERIC_ERROR: 'reactivateOneTouch',
                VENMO_GENERIC_ERROR: 'venmoGenericError'
            };

            var CONTENT_MAPPING = {
                INVALID_USER: { content: CONTENT_KEY.INVALID_EMAIL_PASSWORD, type: 'error' },
                INVALID_PHONE_PIN: { content: CONTENT_KEY.INVALID_PIN, type: 'error' },
                INVALID_ACCESS_TOKEN: { content: CONTENT_KEY.INVALID_ACCESS_TOKEN, type: 'error' },
                LOCKED_USER: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
                ACCOUNT_LOCKED: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
                CLOSED_USER: { content: CONTENT_KEY.ACCOUNT_CLOSED, type: 'error' },
                TIMED_OUT: { content: CONTENT_KEY.TIMED_OUT, type: 'error' },
                CANNOT_PAY_SELF: { content: CONTENT_KEY.CANNOT_PAY_SELF, type: 'error' },
                RISK_DECLINE: { content: CONTENT_KEY.RISK_DECLINE, type: 'error' },
                addPhone: { content: CONTENT_KEY.LOGIN_ADD_PHONE, type: 'error' },
                PAYER_AUTHENTICATION_REQUIRED: {
                    content: CONTENT_KEY.LOGIN_PREFILLED_SHIPPING_ADDRESS,
                    type: 'info'
                },
                LOGIN_CONTINGENCY: { content: CONTENT_KEY.LOGIN_CONTINGENCY, type: 'error' },
                ONETOUCH_REACTIVATE: { content: CONTENT_KEY.LOGIN_REACTIVATE, type: 'warning' },
                ONETOUCH_LEAVECHECKED: { content: CONTENT_KEY.LOGIN_LEAVECHECKED, type: 'warning' },
                ONETOUCH_GENERIC_ERROR: { content: CONTENT_KEY.LOGIN_OT_GENERIC_ERROR, type: 'warning' },
                VENMO_ERROR: { content: CONTENT_KEY.VENMO_GENERIC_ERROR, type: 'error' }
            };

            function populateMessage(name, type) {
                var contentKey = CONTENT_MAPPING[name];

                if (contentKey) {
                    $scope.message = {
                        msgKeys: ['login.' + contentKey.content],
                        type: type || contentKey.type
                    };
                } else {
                    _logger.$logger.debug('unresolved content for login ' + type + ' message ' + name + ' in xo-login page');
                }
            }

            function handleAuthChallengeFailure(urlParams) {
                if (urlParams.acRedirect === '2fa') {
                    var userLocale = urlParams['locale.test'];

                    if (userLocale) {
                        _squid.$locale.chosenLang = _squid.$localeHelper.normalizeLocale(userLocale).language;
                    }

                    if (urlParams.ulMethod === 'phone') {
                        _logger.$logger.debug('2FA_RETURNED_FAILED_PHONE');
                        populateMessage('INVALID_PHONE_PIN', 'error');
                    } else {
                        _logger.$logger.debug('2FA_RETURNED_FAILED_EMAIL');
                        populateMessage('INVALID_USER', 'error');
                    }
                } else if (urlParams.acRedirect === 'loginato') {
                    _logger.$logger.debug('LOGIN_ATO_RETURNED_FAILED');
                    _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                } else if (urlParams.acRedirect === 'safe') {
                    _logger.$logger.debug('SAFE_RETURNED_FAILED');
                    _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                }
            }

            function handleAuthChallengeSuccess(urlParams) {
                switch (urlParams.acRedirect) {
                    case '2fa':
                        _logger.$logger.debug('2FA_RETURNED_SUCCESS');
                        break;
                    case 'loginato':
                        _logger.$logger.debug('LOGIN_ATO_RETURNED_SUCCESS');
                        break;
                    case 'safe':
                        _logger.$logger.debug('SAFE_RETURNED_SUCCESS');
                        break;
                    default:
                    // do nothing
                }
                $scope.auth.is_auth_api_call = !urlParams.acRedirect;
            }

            $scope.onComplete = function (auth) {
                // Dont show the login contingency message once poma password recovery is enabled.
                if (!(0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                    populateMessage('LOGIN_CONTINGENCY', 'info');
                }

                if (_angular.$rootScope.contingency && _angular.$rootScope.contingency.message) {
                    populateMessage(_angular.$rootScope.contingency.message, 'error');
                } else {
                    if (!_squid.$util.param('langTgl')) {
                        //  for UL Landing
                        _squid.$locale.choose(auth.country, auth.language, false);
                    }
                    $scope.successCallback();
                }
            };

            // Make country and lang available to htmlContent for dynamically generating content
            $scope.locale = _squid.$locale;

            if (_uiRouter.$stateParams.targetPage) {
                if (_props.$loginProps.inList(_uiRouter.$stateParams.targetPage) && (0, _squid.$feature)('riskyLoginContingency')) {
                    var riskyLoginInfo = _props.$loginProps.mapInfo(_uiRouter.$stateParams.targetPage);

                    $scope.subFlowTitleKey = riskyLoginInfo.title;
                    $scope.contingencyDesc = riskyLoginInfo.subtitle;
                    $scope.hideloginpp = true;
                    $scope.postlogout = function () {
                        delete $scope.subFlowTitleKey;

                        if ($scope.contingencyDesc) {
                            delete $scope.contingencyDesc;
                        }

                        delete $scope.hideloginpp;
                        $scope.showLanguageDropdown = (0, _squid.$feature)('languageToggle');
                        $scope.logout();
                    };
                } else {
                    var errMessage = CONTENT_MAPPING[_uiRouter.$stateParams.targetPage] ? _uiRouter.$stateParams.targetPage : 'LOGIN_CONTINGENCY';
                    var type = errMessage.type ? errMessage.type : 'info';

                    populateMessage(errMessage, type);
                }
            }

            if (_auth.$AuthModel.instance().meta.invalidated) {
                populateMessage('TIMED_OUT', 'error');
            } else if (_auth.$AuthModel.instance().meta.selfPay) {
                populateMessage('CANNOT_PAY_SELF', 'error');
                _auth.$AuthModel.instance().meta.selfPay = false;
            }

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
            }).then(function () {
                // Land on create password info page in case poma user was routed to login, after the
                // initial login/auth.
                if ((0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less && !$scope.autoLogin) {
                    _uiRouter.$state.go('checkout.createPassword', { targetPage: _uiRouter.$stateParams.targetPage });
                    return;
                }

                var ULCallbacks = {
                    showErrorMessages: function showErrorMessages(errorCase) {
                        populateMessage(errorCase);
                        (0, _angular.$timeout)(function () {
                            $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                        });
                    },
                    toggleUnifiedLogin: function toggleUnifiedLogin(value) {
                        $scope.ulEligibility = value;
                        $scope.apsIntegration = true;
                        _angular.$rootScope.continueLoadingForUL = value;
                        (0, _angular.$timeout)(function () {
                            $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                        });
                    }
                };

                // redirect to UL if config says true and we have targetPage
                if (_squid.$config.fullPageRiskyLogin && _uiRouter.$stateParams.targetPage) {
                    if ($scope.checkoutAppData.isSecondButton()) {
                        _logger.$logger.debug('isSecondButton');
                    }
                    _logger.$logger.debug('doRiskyLoginViaRedirectToUL');
                    // delete scope variables to avoid UL iframe execution
                    delete $scope.ulEligibility;
                    delete $scope.apsIntegration;

                    var subFlowTitleKey = $scope.subFlowTitleKey && $scope.subFlowTitleKey.split('.')[1];

                    return $scope.auth.redirectToLogin('insufficientPermission', {
                        ulClientKey: subFlowTitleKey
                    });
                } else {
                    _logger.$logger.debug('shouldNotRiskyLoginViaiFrameInHermes');
                    $scope.ULCallback = function (name, value) {
                        var callback = ULCallbacks[name];

                        if (callback) {
                            callback(value);
                        }
                    };
                }

                if ($scope.auth.timed_out) {
                    populateMessage('TIMED_OUT', 'error');
                }

                if (!$scope.subFlowTitleKey) {
                    $scope.showLanguageDropdown = (0, _squid.$feature)('languageToggle');
                }

                var urlParams = _squid.$util.params();

                if (urlParams.acRedirect) {
                    // Returning from auth challenge
                    if (urlParams.failedBecause) {
                        handleAuthChallengeFailure(urlParams);
                    } else {
                        handleAuthChallengeSuccess(urlParams);
                    }
                }

                var getErrorDesc = function getErrorDesc(msg) {
                    return decodeURIComponent(msg);
                };

                var getErrorType = function getErrorType(msg) {
                    var errorNum = decodeURIComponent(msg).match(/\d+/g); // to extract the error type from the error msg

                    return errorNum ? errorNum : '';
                };

                var mapCodeToError = function mapCodeToError(code) {

                    var errorMap = {
                        '82016': 'RISK',
                        '82017': 'COMPLIANCE'
                    };

                    return errorMap[code];
                };

                if (_uiRouter.$stateParams.venmoError) {

                    if (_uiRouter.$stateParams.errorCode) {

                        var errorSource = mapCodeToError(_uiRouter.$stateParams.errorCode);

                        if (errorSource) {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_ENTRYPOINT',
                                to: 'process_checkout_login',
                                'int_error_code': _uiRouter.$stateParams.errorCode,
                                'int_error_description': _uiRouter.$stateParams.errorMessage ? getErrorDesc(_uiRouter.$stateParams.errorMessage) : '',
                                'error_type': _uiRouter.$stateParams.errorMessage ? getErrorType(_uiRouter.$stateParams.errorMessage) : '',
                                'error_source': errorSource
                            });
                        }
                    }

                    populateMessage('VENMO_ERROR', 'error');
                }

                var handleContingency = {
                    // Errors - Show Page Level Error
                    INVALID_USER: populateMessage,
                    LOCKED_USER: populateMessage,
                    ACCOUNT_LOCKED: populateMessage,
                    CLOSED_USER: populateMessage,
                    ONETOUCH_REACTIVATE: populateMessage,
                    ONETOUCH_LEAVECHECKED: populateMessage

                };

                $scope.onContingency = function (name, contingency, type) {
                    // eslint-disable-line no-shadow

                    _squid.$locale.choose($scope.auth.country, $scope.auth.language, false);

                    if (!handleContingency[name]) {
                        return $scope.contingencyCallback(name, contingency);
                    }

                    var message_type = type || 'error';

                    return handleContingency[name](name, message_type);
                };
            });
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$localeHelper;

_squid.$populate;

_squid.$util;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_props.$loginProps;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/handler/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"login\" id=\"loginSection\" content>\n    <xo-message message=\"message\"></xo-message>\n    <div class=\"pr row-fluid\" ng-class=\"{hasError: message}\" ng-hide=\"hideTitle\">\n        <xo-title class=\"xoTitle\" title-txt=\"{{content(subFlowTitleKey ? subFlowTitleKey : 'login.loginTitle')}}\" ng-class=\"{span17: showLanguageDropdown, riskyTitle: subFlowTitleKey}\"></xo-title>\n        <xo-language-options class=\"span7\" ng-if=\"showLanguageDropdown\"></xo-language-options>\n    </div>\n    <div class=\"inline-prop\" unless-feature=\"propValue\" ng-hide=\"hideloginpp\">\n        <p ng-bind-html=\"htmlContent('login.propValAlt', {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <div class=\"inline-prop\" ng-show= \"contingencyDesc\" ng-class=\"{riskySubtitle: contingencyDesc}\">\n        <p ng-bind-html=\"htmlContent(contingencyDesc, {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <xo-login ng-if=\"!ulEligibility\" token=token auth=auth done-fn=\"onComplete\" error-fn=\"onContingency\" auto-login=\"autoLogin\" aps-integration=\"apsIntegration\" batch=\"batch\" login-submit=\"loginSubmit\"></xo-login>\n    <xo-unified-login ng-if=\"ulEligibility\" token=token error-fn=\"onContingency\" parent-callback=\"ULCallback\" pre-auth=\"preAuth\" post-auth=\"onComplete\" auto-login=\"autoLogin\" flowcontext=\"flowcontext\" login-submit=\"loginSubmit\" logout-callback=\"postlogout\" ></xo-unified-login>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/kmliEligibility.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$KmliEligibility = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var scope = { eligibility: {} };
var ulMeta = _squid.$config.ulMeta || {};

var getPXPList = function getPXPList(country) {
    // returns a list of Pxp's that needs to be executed
    var countryCTX = { 'ctx.COUNTRY': country };
    var pxpExpId = ulMeta.pxpExpId;
    var pxpList = [(0, _squid.$pxp)(pxpExpId, countryCTX, 'xo_hermes_ul_timeout_treatment.*', false, true), (0, _squid.$pxp)(pxpExpId, countryCTX, 'xo_hermes_ul_preload_treatment', false, true)];

    return pxpList;
};

var routingReason = function routingReason() {
    // Check for conditions that deviates from the PXP eligibility
    // Reasons that deviates from control to treatment
    var isRememberedUser = scope.auth.refreshToken();

    if (scope.kmli === true) {
        return 'kmliMandated';
    } else if (isRememberedUser) {
        return 'rememberedUser';
    } else if (_squid.$util.param('ul') === '2') {
        return 'ulParam';
    } else if (_squid.$meta.corp && ulMeta.allowKMLIForInternalIP) {
        var merchantCountry = scope.checkoutAppData.merchant.merchant_country;

        if ((0, _squid.$feature)('enableOneTouchInternalIP', false, merchantCountry)) {
            return 'internalIP';
        }
    } else if (ulMeta.enableOneTouchByDefault) {
        return 'oneTouchByDefault';
    }
};

var compatibility = function compatibility(reasons) {
    // Check for compatibility/environment issues which impacts UL/KMLI overall
    // This should override previous decisions
    if (_index.$DeviceInfo.isApp()) {
        scope.kmliEligibility = false;
        reasons.push('Webview');
    } else if (!_squid.$util.cookiesEnabled()) {
        scope.kmliEligibility = false;
        reasons.push('cookiesDisabled');
    } else if (scope.auth.ota) {
        scope.kmliEligibility = false;
        reasons.push('otaDevice');
    }

    if (scope.forcedLogin === true) {
        scope.kmliEligibility = false;
        reasons.push('forcedLogin');
    }
    if (scope.logoutCallback) {
        scope.kmliEligibility = true;
        reasons.push('riskyLoginContingency');
    }
};

var isULpreload = function isULpreload(preloadULTreatments) {
    // const userAgent = $window.navigator.userAgent;
    // const isIE = !!userAgent.match(/MSIE|trident|edge/i);
    var isTreatment = Boolean(preloadULTreatments && preloadULTreatments.treatment_name);
    var forceUlss = _squid.$util.param('_ulss') === 'true';
    var preloadUL = forceUlss || isTreatment;

    return preloadUL;
};

var isUlAsLanding = function isUlAsLanding() {
    // markes
    var forceUlAsLanding = _squid.$util.param('ul') === 'landing';
    var ulAsLandingParam = _squid.$util.param('ulReturn') === 'true';

    // tried Ul as landing -> failed -> used iframe
    var failedAttempt = _squid.$util.param('lndgFailedBecause'); // eslint-disable-line no-unused-vars


    return forceUlAsLanding || ulAsLandingParam;
};

var getTimeoutLimit = function getTimeoutLimit(pxpTimeoutTrt) {
    var ulTimeoutLimit = void 0;
    var timeoutTrtFact = pxpTimeoutTrt && angular.isArray(pxpTimeoutTrt.factors);
    var pxpTimeoutVal = timeoutTrtFact && pxpTimeoutTrt.factors[0] && pxpTimeoutTrt.factors[0].value;

    if (pxpTimeoutVal) {
        ulTimeoutLimit = pxpTimeoutVal;
        _logger.$logger.info('pxp_timeout_treatment', { ulTimeoutLimit: ulTimeoutLimit });
    }
    return ulTimeoutLimit;
};

var $KmliEligibility = exports.$KmliEligibility = {
    init: function init(params) {
        if (scope.eligibility.treatment) {
            // do not init twice
            return _angular.$q.resolve(scope.eligibility);
        }
        _logger.$logger.debug('kmliEligibility_init');
        scope.forcedLogin = params && params.forcedLogin;
        scope.logoutCallback = params && params.logoutCallback;

        return (0, _squid.$populate)(scope, {
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token)
        }).then(function () {
            var country = scope.checkoutAppData.merchant.merchant_country;

            return _angular.$q.all(getPXPList(country)).then(function (result) {
                scope.eligibility.ulTimeoutLimit = getTimeoutLimit(result[0]);
                scope.eligibility.preloadUL = isULpreload(result[1]);
                scope.eligibility.safeEligibility = true;
                scope.eligibility.ulAsLanding = isUlAsLanding();
            });
        }).then(function () {
            // STEP1: kmli pxp ramped to 100%, so always kmli eligible
            scope.kmliEligibility = true;

            // STEP2: Push the eligible reasons from routingReason check.
            var reasons = []; // Reasons that deviates from control to treatment

            reasons.push('pxpFullyRamped');

            var reason = routingReason();

            if (reason) {
                scope.kmliEligibility = true;
                reasons.push(reason);
            }

            // STEP3: Check for compatibility/environment issues which impacts UL/KMLI overall
            compatibility(reasons);

            var routing_reason = reasons[reasons.length - 1];

            scope.eligibility.treatment = true;
            scope.eligibility.routingReason = routing_reason;
            scope.eligibility.deviatingReasons = reasons;
            scope.eligibility.kmliEligibility = scope.kmliEligibility;

            // STEP4: Instrument deterministically whether KMLI is shown to the user or not
            _logger.$logger.debug(scope.kmliEligibility ? 'KMLI_ELIGIBLE_USER' : 'KMLI_INELIGIBLE_USER', { userGroup: reasons, routing_reason: routing_reason });
            _logger.$logger.info('checkout_fpti', {
                'from': 'KMLI_ELG_CHK',
                'to': 'process_kmli_elg_chk',
                routing_reason: routing_reason
            });
            return scope.eligibility;
        });
    },
    eligible: function eligible() {
        return scope.eligibility;
    }
};

angular.value("$KmliEligibility", $KmliEligibility);
_angular.$q;

_angular.$rootScope;

_squid.$config;

_squid.$feature;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_squid.$util;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/props.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var RISKY_LOGIN_TITLE = {
    ECONSENT_REQUIRED: '',
    ELV_DECLINE: '',
    EXPIRED_CREDIT_CARD: 'login.riskyLoginUpdateCard',
    INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: '',
    NEED_CREDIT_CARD: 'login.riskyLoginAddCard',
    NEED_CREDIT_CARD_OR_BANK_ACCOUNT: 'login.riskyLoginAddFi',
    NEED_CONFIRMED_CARD: '',
    NEED_AUTHENTICATED_CARD: 'login.riskyLoginUpdateCard',
    NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShipping',
    PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhone',
    PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassed',
    SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepa',
    TAX_ID_REQUIRED: ''
};
var RISKY_LOGIN_SUBTITLE = {
    EXPIRED_CREDIT_CARD: 'login.riskyLoginExpiredCardST',
    NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShippingST',
    PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhoneST',
    SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepaST',
    PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassedST'
};

var $loginProps = exports.$loginProps = {
    mapInfo: function mapInfo(contingency) {
        var contingencyTitle = RISKY_LOGIN_TITLE[contingency] ? RISKY_LOGIN_TITLE[contingency] : 'login.loginContingency';
        var contingencySubTitle = RISKY_LOGIN_SUBTITLE[contingency];

        return { title: contingencyTitle, subtitle: contingencySubTitle };
    },

    inList: function inList(contingency) {
        return RISKY_LOGIN_TITLE.hasOwnProperty(contingency);
    }
};

angular.value("$loginProps", $loginProps);

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/template.html":
/***/ (function(module, exports) {

module.exports = "<form name=\"loginForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n    <div class=\"inputField emailField confidential\">\n        <label for=\"username\" class=\"focus accessAid\">\n            {{ content('index.EmailLabel') }}\n        </label>\n        <input ng-model=\"auth.email\" id=\"username\" name=\"username\" type=\"email\" ng-readonly=\"auth.emailReadOnly\" value=\"\"\n               autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\" placeholder=\"{{ content('index.EmailLabel') }}\" data-error-key=\"email.invalid\" xo-error-tooltip required autofocus/>\n    </div>\n\n    <div class=\"inputField passwordField confidential\">\n        <label for=\"password\" class=\"focus accessAid\">\n            {{ content('login.passwordLabel') }}\n        </label>\n        <input ng-model=\"auth.password\" id=\"password\" name=\"password\" type=\"password\" value=\"\" aria-required=\"true\" autocapitalize=\"off\" autocomplete=\"off\" placeholder=\"{{ content('login.passwordLabel') }}\" xo-error-tooltip required>\n    </div>\n\n    <div ng-switch class=\"checkbox\" id=\"rmSection\" on=\"rememberMe\">\n        <div ng-switch-when=\"nonKmli\" class=\"secondary\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\" ng-click=\"toggleRMDetails()\"/>\n            <label for=\"agree\">\n                {{content('rememberMe.remember')}}\n                <a ng-click=\"showRmMore=!showRmMore\">\n                    <span ng-bind=\"showRmMore ? content('rememberMe.close'): content('rememberMe.more')\"></span>\n                </a>\n            </label>\n            <ul id=\"rmLearnMore\" ng-show=\"showRmMore\">\n                <li>{{ content('rememberMe.skipLogin') }}</li>\n                <li>{{ content('rememberMe.toCancel') }}</li>\n                <li>{{ content('rememberMe.protectAccounts') }}</li>\n            </ul>\n        </div>\n        <div ng-switch-when=\"kmli\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\">\n            <label for=\"agree\" ng-bind=\"content('login.keepMeLoggedIn')\" class=\"kmliCheckboxLabel\"></label>\n            <div class=\"signupbml kmliHelpIcon\">\n                <a href=\"#\" id=\"verifyHelp\" class=\"verifyHelp\"><img alt=\"{{ content('login.kmliTooltipTitle') }}\" /></a>\n            </div>\n        </div>\n    </div>\n\n    <xo-tooltip trigger=\"#verifyHelp\" display-inline=\"true\">\n        <div class=\"keepMeLoginTerms\" id=\"keepMeLoginTerms\">\n            <p>{{ content('login.kmliTooltipLine1') }}</p>\n            <p>{{ content('login.kmliTooltipLine2') }}</p>\n            <p>{{ content('login.kmliTooltipLine3') }}</p>\n        </div>\n    </xo-tooltip>\n\n    <input track-submit type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn\" validate-submit=\"onSubmit()\" />\n\n    <div class=\"center mt10 secondary\" id=\"forgotPasswordSection\">\n        <a href=\"{{forgotPasswordUrl}}\" id=\"forgot_password_link\" target=\"_blank\" class=\"smallPopup\" xo-popup>\n            {{ content('common.forgotYourPassword') }}</a>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _ui2 = _interopRequireDefault(_ui);

var _ul = __webpack_require__("../node_modules/xo-login-components/src/unified-login/ul.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoOnetouchUpsell', function () {

    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            onComplete: '=?',
            disableCloseButton: '=?',
            ignoreBgClicks: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.oneTouchFlowName = _uiRouter.$stateParams.oneTouchFlowName;
            $scope.modalActive = false;
            $scope.locale = _squid.$LocaleModel.instance();
            $scope.disableCloseButton = $scope.disableCloseButton || _index.$DeviceInfo.isDevice();
            $scope.upsellOptInDisplayed = false;
            var ulMeta = _squid.$config.ulMeta || {};
            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 5000;
            var ulTimeoutPromise = null;

            var fptiData = _kmliUpsell.$KmliUpsell.getFPTIAttributes();

            if (!$scope.onComplete) {
                $scope.onComplete = function (params) {
                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
                        auth.isKmliSet = params && params.isKmliSet;
                        _uiRouter.$state.go('checkout.review');
                    });
                };
            }

            _kmliUpsell.$KmliUpsell.eligible().then(function (eligibility) {
                if (eligibility && eligibility.interstitial && eligibility.interstitial.color) {
                    $scope.color = eligibility.interstitial.color;
                    $scope.showUpsellBanner = eligibility.banner;
                }
            });

            function closeInterstitial(params) {
                $('#wrapper > xo-spinner').attr('style', '');
                $('body').removeClass('kmliUpsellActive');
                $element.removeClass('upsellOpen');
                $scope.onComplete(params);
            }

            function failureHandler(reason) {
                _logger.$logger.info('KMLI_UPSELL_error_' + reason);
                closeInterstitial();
            }

            var startTimerTS;

            function startTimer(tag) {
                startTimerTS = Date.now();
                _logger.$logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
                    startTime: startTimerTS
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'prepare_' + tag
                });

                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    var stop_time = Date.now();
                    var time_taken = stop_time - startTimerTS;

                    _logger.$logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'process_timeout',
                        'int_error_code': 'ULLOGIN_TIMEOUT',
                        'int_error_description': 'ULLOGIN_TIMEOUT',
                        'error_source': 'unifiedloginnodeweb',
                        'error_type': 'soft_decline',
                        'page_load_time': time_taken
                    });
                    failureHandler('timedout');
                    _angular.$rootScope.$emit('loaded');
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                var stopTimerTS = Date.now();
                var timeTaken = stopTimerTS - startTimerTS;

                _logger.$logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
                    stopTimer: stopTimerTS,
                    page_load_time: timeTaken
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'process_' + tag,
                    'page_load_time': timeTaken
                });

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                }
            }

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'optin'
                };

                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            $scope.hideModal = function (event) {
                if (event) {
                    event.preventDefault();
                } else if ($scope.ignoreBgClicks) {
                    return;
                }

                _logger.$logger.info('checkout_fpti', {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'decline',
                    'click_source': 'close_button'
                });

                closeInterstitial();
            };

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    $('#wrapper > xo-spinner').hide();
                    $('body').addClass('kmliUpsellActive');

                    // CSS transition to open upsell modal and set modal to trap focus after open
                    (0, _angular.$timeout)(function () {
                        $element.addClass('upsellOpen');
                        $element.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                            $scope.$apply(function () {
                                $scope.modalActive = true;
                                // Focus Continue button in iframe
                                $('#injectedOneTouchInterstitial').focus();

                                var escHandler = function escHandler(event) {
                                    if (event.keyCode === _ui2['default'].KEYS.ESC) {
                                        $scope.hideModal();
                                    }
                                };

                                // Add handler to iframe document, as events do not propagate past the iframe
                                $element.find('iframe').contents().on('keydown', escHandler);
                                $element.on('keydown', escHandler);
                            });
                        });
                    });
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    _angular.$rootScope.$emit('loading');
                    startTimer(data.event);
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit();
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit({ errorCode: data.event });
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    stopTimer(data.event);
                    logSubmit({ errorCode: data.event });
                    _angular.$rootScope.$emit('loaded');
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
                    _logger.$logger.info('checkout_fpti', {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'decline',
                        'click_source': 'not_now_link'
                    });
                    closeInterstitial(data);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;

                    if (eventId) {
                        _logger.$logger.debug('KMLI_UPSELL_' + eventId, response);
                        var handler = ulEventHandlers[eventId];

                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function upsellOptInDisplayed() {
                return _auth.$AuthModel.instance().retrieve().then(function (auth) {
                    if (auth.upsellOptInDisplayed) {
                        $scope.upsellOptInDisplayed = true;
                    }
                });
            }

            function loadOneTouchUpsell() {
                // eslint-disable-line no-unused-vars
                upsellOptInDisplayed().then(function () {
                    // If the optin upsell is already displayed, no need to display again.
                    if ($scope.upsellOptInDisplayed) {
                        $scope.onComplete();
                    } else {
                        _angular.$rootScope.$emit('loading');

                        var options = {
                            targetElement: document.getElementById('injectedOneTouchInterstitial'),
                            queryParams: {
                                'stsRedirectUri': ulMeta.stsReturnUrl,
                                'country.x': $scope.locale.country,
                                'locale.x': $scope.locale.getLocaleCode(),
                                'flowId': $scope.token,
                                'correlationId': _model.$CalDataModel.getCalCorrId(),
                                'flowName': $scope.oneTouchFlowName
                            },
                            iframePathname: '/signin/activate-one-touch',
                            onPostMessage: postMessageHandler
                        };

                        angular.extend(options.queryParams, _kmliUpsell.$KmliUpsell.getOptions());

                        if (_squid.$config.deploy.isLocal()) {
                            if (_squid.$meta.stage) {
                                options.origin = 'https://' + _squid.$meta.stage;
                            } else {
                                // if no stage url shows up then use any backup url for origin
                                options.origin = _squid.$config.onboarding.url.split('/webapps/')[0];
                            }
                        }

                        if (PAYPAL && PAYPAL.unifiedLogin) {
                            startTimer('initializeUpsell');
                            PAYPAL.unifiedLogin.inject(options);
                        } else {
                            failureHandler('PAYPAL.unifiedLogin_undefined');
                        }
                    }
                });
            }

            (0, _angular.$timeout)(function () {
                $element.addClass('upsellOpen');
            });

            $scope.optinOneTouch = function () {
                var flowName = 'checkoutInterstitial'; // login interstitial flow
                var fptiPayload = {
                    stateName: fptiData.stateName,
                    transInfix: 'process' + fptiData.transInfix + 'optin'
                };
                var silent = true;

                return _ul.$ul.optInToOneTouch($scope.token, _squid.$locale.country, _squid.$locale.getLocaleCode(), silent, fptiPayload, flowName).then(closeInterstitial({ isKmliSet: true }))['catch'](function (err) {
                    closeInterstitial({
                        isKmliSet: false,
                        error: err
                    });
                });
            };
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$locale;

_squid.$LocaleModel;

_squid.$meta;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_model.$CalDataModel;

_kmliUpsell.$KmliUpsell;

_auth.$AuthModel;

_ul.$ul;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$KmliUpsell = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _kmliEligibility = __webpack_require__("../node_modules/xo-login-components/src/login/kmliEligibility.js");

// Model Retrived
var idToken = void 0;
// models

var successfulLogin = void 0;
var isOneTouched = void 0;
var upsellOptInDisplayed = void 0; // eslint-disable-line no-unused-vars
var kmliEligible = void 0;
var walletTokenization = void 0;
var preloadUL = void 0;
var lastUpsellVersion = void 0; // eslint-disable-line no-unused-vars
var showReactivationInterstitial = void 0;
var kmliChecked = void 0; // Passed in init
var expPromise = void 0; // Promisified experience data
var scope = {};

var getKmliContentKey = function getKmliContentKey() {
    // NOTE: `xo_hermesnode_kmli_upsell` has been removed
    // and currently it's always returned `xo_hermesnode_kmli_content_t1`
    scope.oneTouchContentVersion = 1;
    return _angular.$q.resolve();
};

// Determine if the NMJ experience the user has is ineligible
var getIsNmj = function getIsNmj() {
    return _newMember.$NewMemberEligibility.instance().isNmj(scope.token);
};

var resolveEligibilityConditions = function resolveEligibilityConditions(params) {
    idToken = Boolean(scope.auth.idTokenPresent);
    successfulLogin = scope.auth.loggedIn();
    isOneTouched = scope.auth.loggedIn() && scope.auth.refreshToken();
    walletTokenization = scope.checkoutCart.isWalletTokenization() || scope.auth.remembered_partner_assertion; // android pay, apple pay, etc
    kmliChecked = Boolean(params.isKmliSet); // may not be OT but user has already opted in
    upsellOptInDisplayed = Boolean(scope.auth.upsellOptInDisplayed);
    lastUpsellVersion = scope.auth.ryiOptIn && scope.auth.ryiOptIn.interstitialDisplayed;
    showReactivationInterstitial = Boolean(params.showReactivationInterstitial);
    _logger.$logger.debug('kmliUpsell_resolveEligibilityConditions', { params: params });

    if (walletTokenization || preloadUL || scope.oneTouchContentVersion !== '3') {
        // do not trigger pxp for walletTokenization, ulpreload
        // Interstitial is only eligibile when the contentKey is set to treatment 3
        _logger.$logger.debug('kmliUpsell_init_ineligible');
    }
    return _angular.$q.resolve();
};

var $KmliUpsell = exports.$KmliUpsell = {
    init: function init(params) {
        scope.token = _angular.$rootScope.token;

        if (expPromise) {
            return; // do not init twice
        }
        _logger.$logger.debug('kmliUpsell_init', params);
        expPromise = _kmliEligibility.$KmliEligibility.init().then(function (KmliEligibility) {
            kmliEligible = Boolean(KmliEligibility.kmliEligibility) && !params.jwtBasedAssertion;
            preloadUL = Boolean(KmliEligibility.preloadUL);
            return (0, _squid.$populate)(scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance(scope.token),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(scope.token)
            });
        }).then(getKmliContentKey).then(function () {
            return resolveEligibilityConditions(params);
        });
    },
    // This should be called after checkout session is populated
    // Any data depending on the checkout session should be resolved here
    eligible: function eligible() {
        var eligibility = {};

        if (!expPromise) {
            _logger.$logger.debug('kmliUpsell_init_not_executed');
            return _angular.$q.resolve(eligibility);
        }
        return _angular.$q.all([expPromise, getIsNmj()]).then(function (result) {
            var experience = result[0];
            var isNmj = result[1];
            var eligibilityCriteria = {
                pxp: experience,
                profile_country: (0, _squid.$feature)('ryiOptIn'),
                isNotNmj: !isNmj
            };

            _logger.$logger.debug('kmliUpsell_eligiblityCheck', { eligibilityCriteria: eligibilityCriteria });

            var ineligibleReasons = _squid.$util.filter(Object.keys(eligibilityCriteria), function (key) {
                return !eligibilityCriteria[key];
            });
            var upsellFeatureEnabled = ineligibleReasons.length === 0;
            var regularLogin = kmliEligible && idToken;
            var autoLoginEnabled = isOneTouched || kmliChecked || scope.auth.remembered;

            eligibility.banner = upsellFeatureEnabled && (0, _squid.$feature)('optinToggle') && Boolean(isOneTouched || regularLogin);

            eligibility.interstitial = {
                eligible: upsellFeatureEnabled && !autoLoginEnabled && experience && experience.name && (experience.name.slice(-1) === '1' || experience.name.slice(-1) === '3') // use only treatment 1,3 for interstitial
                && experience.version,
                type: showReactivationInterstitial ? 'reactivation' : successfulLogin ? 'member' : '', // eslint-disable-line no-nested-ternary
                color: experience && experience.color,
                pxpVersion: experience && experience.pxpVersion
            };

            var elgStr = 'interstitial-' + eligibility.interstitial.eligible + '&toggle-';

            _logger.$logger.info('ryi_optin', {
                'from': 'ryi_optin_elg_chk',
                'to': 'process_ryi_optin_elg_chk',
                'eligibility_reason': upsellFeatureEnabled ? elgStr + 'eligible' : elgStr + 'ineligible_' + ineligibleReasons.join()
            });
            _logger.$logger.debug('kmliUpsell_eligibility', {
                eligibility: eligibility,
                experience: experience,
                cases: {
                    activeOT: isOneTouched,
                    regularLogin: regularLogin,
                    feature: upsellFeatureEnabled
                }
            });
            return eligibility;
        });
    },
    getOptions: function getOptions() {
        if (showReactivationInterstitial) {
            return {
                flowName: 'expiredUpsell'
            };
        }
    },
    getFPTIAttributes: function getFPTIAttributes() {
        if (showReactivationInterstitial) {
            return {
                stateName: 'KMLI_reactivation',
                transInfix: '_kmli_reactivation_'
            };
        } else {
            return {
                stateName: 'KMLI_UPSELL',
                transInfix: '_kmli_upsell_'
            };
        }
    }
};

angular.value("$KmliUpsell", $KmliUpsell);
_angular.$q;

_angular.$rootScope;

_squid.$feature;

_squid.$populate;

_squid.$util;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_newMember.$NewMemberEligibility;

_kmliEligibility.$KmliEligibility;

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$OneTouchUpsellRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/directive.js");

var $OneTouchUpsellRoute = exports.$OneTouchUpsellRoute = _squid.$ComponentRoute.extend('OneTouchUpsellRoute', {
    name: 'oneTouchUpsell',
    directive: 'xo-onetouch-upsell',
    trackingData: {
        fptiState: 'onetouch-upsell',
        buzname: {
            'fullpage': {
                'pagename': '%::onetouch-upsell',
                'pagename2': '%::onetouch-upsell:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    query: ['oneTouchFlowName'],
    children: []
});
angular.value("$OneTouchUpsellRoute", $OneTouchUpsellRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"kmliUpsell\" ng-class=\"{mobile: isDevice}\" content>\n    <div class=\"upsellMask_white\"></div>\n    <div class=\"upsellWrapper\" ng-class=\"{whiteWithBlur: color === 'white' , blackWithBlur: color === 'black'}\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\">\n        <div class=\"upsellContainer\">\n            <div ng-if=\"showUpsellBanner\" class=\"fill\"></div>\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\" ng-hide=\"disableCloseButton\" aria-label=\"{{content('common.back')}}\"></a>\n                <section class=\"login\" id=\"login\">\n                    <div class=\"promoHeading\" ng-bind-html=\"content('oneTouchUpsell.promoHeading')\"></div>\n                    <div class=\"promo\">\n                        <div class=\"icon password\"></div>\n                        <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText1')\"></div>\n                    </div>\n                    <div class=\"promo\">\n                        <div class=\"icon merchants\"></div>\n                        <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText2')\"></div>\n                    </div>\n                    <div class=\"promo\">\n                        <div class=\"icon secure\"></div>\n                        <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText3')\"></div>\n                    </div>\n                    <div class=\"buttons\">\n                        <input type=\"button\" value=\"{{content('common.activate')}}\" class=\"btn full\" ng-click=\"optinOneTouch()\">\n                        <div class=\"cancel\">\n                            <a href=\"#\" prevent-default ng-click=\"hideModal($event)\">{{content('common.noThanks')}}</a>\n                        </div>\n                    </div>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\" id=\"pp_min_logo\"></div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery-overlay/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/password-recovery-overlay/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryOverlayDirective', {
    tag: 'xo-password-recovery-overlay',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        cancel: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var auth = _auth.$AuthModel.instance();

            _angular.$rootScope.$emit('loading');

            var hideOverlay = function hideOverlay(callback) {
                $('#wrapper #spinner').attr('style', '');
                _this.$element.removeClass('overlayOpen');
                (0, _angular.$timeout)(function () {
                    return callback();
                }, 300);
            };

            this.hideModal = function (event) {
                event.preventDefault();
                hideOverlay(auth.password_less ? _this.cancel : _this.success);
            };

            this.onPasswordRecoveryReady = function () {
                (0, _angular.$timeout)(function () {
                    _angular.$rootScope.$emit('loaded');
                    _this.$element.addClass('overlayOpen');
                });
            };

            this.onContinue = function () {
                hideOverlay(_this.success);
            };

            this.onPasswordRecovery = function () {
                auth.password_less = false;
            };
        }
    }
});


_squid.$Component;

_angular.$rootScope;

_angular.$timeout;

_auth.$AuthModel;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery-overlay/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-login-components/src/password-recovery-overlay/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$xoPasswordRecoveryOverlayRoute', {
    path: 'passwordRecovery',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'password_recovery'
    },
    children: []
});


_squid.$Route;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery-overlay/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"pwrOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a track-link=\"user_cancel\" class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section id=\"pwrOverlay\">\n                    <xo-password-recovery token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onContinue\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/password-recovery/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryDirective', {
    tag: 'xo-password-recovery',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        onContinue: {
            type: 'var',
            required: false
        },
        onPasswordRecovery: {
            type: 'var',
            required: false
        },
        onLoad: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var PAYPAL = window.PAYPAL;

            this.loaded = false;
            var postMessageHandler = function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    switch (response.event) {
                        case 'render':
                            if (response.pageName === 'authflow/password-recovery/done') {
                                _this.onPasswordRecovery();
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'password_recovery',
                                    to: 'process_password_recovery'
                                });
                            } else if (response.pageName === 'authflow/password-recovery') {
                                _this.onLoad();
                                _this.loaded = true;
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'password_recovery',
                                    to: 'prepare_password_recovery'
                                });
                            } else {
                                // Do nothing
                            }
                            break;
                        case 'passwordSetSuccess':
                            _this.onContinue();
                            break;
                        default:
                            break;
                    }
                });
            };

            this.loadPasswordRecoveryFlow = function () {
                var isHermesInsideIframe = _squid.$util.isIFrame();

                if (isHermesInsideIframe) {
                    _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
                }
                var options = {
                    targetElement: document.getElementById('injectedPasswordRecovery'),
                    xhrRequest: isHermesInsideIframe,
                    iframePathname: '/authflow/password-recovery',
                    caller: 'secondaryIframe',
                    queryParams: {
                        'country.x': _squid.$locale.country,
                        'locale.x': _squid.$locale.getLocaleCode(),
                        'contextId': _this.token,
                        'correlationId': _model.$CalDataModel.getCalCorrId()
                    },
                    onPostMessage: postMessageHandler
                };

                if (_squid.$config.deploy.isLocal()) {
                    options.origin = 'https://' + _squid.$meta.stage;
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    PAYPAL.unifiedLogin.inject(options);
                }
            };

            (0, _angular.$timeout)(this.loadPasswordRecoveryFlow);
        }
    }
});


_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$meta;

_squid.$util;

_model.$CalDataModel;

_angular.$timeout;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"injectedPasswordRecovery\" ng-show=\"loaded\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _kmliEligibility = __webpack_require__("../node_modules/xo-login-components/src/login/kmliEligibility.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/unified-login/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoUnifiedLogin', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            redirectUri: '=?',
            parentCallback: '=?',
            doneFn: '=?',
            errorFn: '=?',
            autoLogin: '=?',
            promptlogin: '=?',
            logoutCallback: '=?',
            kmli: '=?',
            preAuth: '=?',
            postAuth: '=?',
            flowcontext: '=?'
        },
        controller: ['$scope', function ($scope) {
            var ulClientRedirect = _squid.$util.param('ulClientRedirect') || '';
            var redirect_reason_timeout = 'timeout';
            var PAYPAL = window.PAYPAL || {};
            var failureReasons = {
                timeout: 'TIMEDOUT',
                error: 'INTERNALERROR',
                blacklistedDevice: 'PLATFORM_NOT_SUPPORTED',
                fallback: 'FALLBACK'
            };
            var enteringTime = Date.now();
            var loginAttemptedMethod = '';
            var userSelectedLanguage = '';

            _logger.$logger.debug('ENTERING_LOADING_UL_IFRAME', { enteringTime: enteringTime });
            $scope.locale = _squid.$LocaleModel.instance();
            $scope.forcedLogin = !$scope.autoLogin; // change to true during forcedLogin scenario

            if (_uiRouter.$stateParams.source === 'NOT_YOU' || _uiRouter.$stateParams.source === 'FRESH_START') {
                $scope.forcedLogin = false;
            }

            var ulTimeoutLimit = 35000;
            var ulTimeoutPromise = null;
            var loadCnt = 0;

            if (ulClientRedirect === redirect_reason_timeout) {
                _logger.$logger.info('ulClientRedirect_timeout');
            }

            function setLoading(tag, isRT) {
                _angular.$rootScope.$emit('loading');
                if (isRT && !$scope.auth.loggedIn()) {
                    _angular.$rootScope.$emit('loadingMessage', {
                        heading: _squid.$locale.content.get('base.loggingIn'),
                        subHeading: _squid.$locale.content.get('login.rmSubHeading')
                    });
                }
                loadCnt++;
                _logger.$logger.debug('setLoading by ' + tag + ' cnt ' + loadCnt);
            }

            function setLoaded(tag) {
                if (loadCnt > 0) {
                    _angular.$rootScope.$emit('loaded');
                    loadCnt--;
                } else {
                    _logger.$logger.error('loadCnt_zero');
                }
                _logger.$logger.debug('setLoaded by ' + tag + ' cnt ' + loadCnt);
            }

            function fallback(product, reason, params) {
                throw new _squid.$FallbackError({
                    product: product || 'ux',
                    reason: reason,
                    params: params
                });
            }

            function appLoginHandler(status) {
                _logger.$logger.debug('ULLOGIN_' + status);
                _logger.$logger.info('checkout_fpti', { 'from': 'LOGIN', 'to': 'prepare_login' });
                fallback('ux', 'ul_server_error');
            }

            var startTimerTS = void 0;

            function startTimer(tag) {
                startTimerTS = Date.now();
                _logger.$logger.debug('startTimer by ' + tag, {
                    startTime: startTimerTS
                });
                _logger.$logger.info('checkout_fpti', {
                    'from': 'UL_Timer',
                    'to': 'prepare_' + tag
                });

                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    _logger.$logger.error('load_ul_timeout');
                    var stop_time = Date.now();
                    var time_taken = stop_time - startTimerTS;

                    _logger.$logger.info('checkout_fpti', {
                        'from': 'UL_Timer',
                        'to': 'process_timeout',
                        'int_error_code': 'ULLOGIN_TIMEOUT',
                        'int_error_description': 'ULLOGIN_TIMEOUT',
                        'error_source': 'unifiedloginnodeweb',
                        'error_type': 'soft_decline',
                        'page_load_time': time_taken
                    });
                    if (!_squid.$config.disableUlTimeout) {
                        fallback('ux', 'ul_load_timeout');
                    } else {
                        // remove after ulAsLanding risky login
                        var isRememberedUser = $scope.auth && $scope.auth.remembered;

                        // remove after ulAsLanding starts to support tokenexchange
                        var isTokenExchange = $scope.auth && $scope.auth.refreshToken() && !$scope.auth.accessToken();
                        // Do trigger for remebered user
                        // Do not trigger if already triggered before
                        // Do not trigger for RT to AT case

                        if (!ulClientRedirect && !isRememberedUser && !isTokenExchange) {
                            $scope.auth.redirectToLogin(redirect_reason_timeout);
                        }
                    }
                }, ulTimeoutLimit);
            }

            function stopTimer(tag, keepLoading) {
                var stopTimerTS = Date.now();
                var timeTaken = stopTimerTS - startTimerTS;

                _logger.$logger.debug('stopTimer by ' + tag, {
                    stopTimer: stopTimerTS,
                    page_load_time: timeTaken
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'UL_Timer',
                    'to': 'process_' + tag,
                    'page_load_time': timeTaken
                });

                if (!keepLoading) {
                    setLoaded('stopTimer');
                }

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                }
            }

            function logFptiData(fptiData, eventName) {
                var errorDescription = void 0;

                switch (eventName) {
                    case '2fa':
                        errorDescription = '2fa_required';
                        break;
                    case 'safeRequired':
                        errorDescription = 'SAFE_required';
                        break;
                    case 'stepupRequired':
                        errorDescription = 'Login_ATO_required';
                        break;
                    default:
                    // nothing to do here
                }
                _logger.$logger.info('checkout_fpti', {
                    'from': fptiData.fptiState,
                    'to': fptiData.fptiTransition,
                    'int_error_code': eventName,
                    'int_error_description': errorDescription,
                    'error_type': 'soft_decline',
                    'error_source': 'unifiedloginnodeweb'
                });
            }

            function buildRedirectURL(contingencyUrl, eventName) {
                var authChallengeUrl = contingencyUrl;
                var paramIndex = authChallengeUrl.indexOf('?');
                var urlParams = _squid.$util.params(authChallengeUrl.substring(paramIndex + 1));

                urlParams.returnUri = _squid.$config.ulMeta.authChallengeReturnUri;
                if (userSelectedLanguage) {
                    urlParams['locale.x'] = _squid.$locale.getLocaleCode();
                    urlParams['state'] += '&locale.test=' + _squid.$locale.getLocaleCode();
                }
                switch (eventName) {
                    case '2fa':
                        urlParams['state'] += '&acRedirect=2fa&ulMethod=' + loginAttemptedMethod;
                        break;
                    case 'safeRequired':
                        urlParams['state'] += '&acRedirect=safe';
                        break;
                    case 'stepupRequired':
                        urlParams['state'] += '&acRedirect=loginato';
                        break;
                    default:
                    // nothing to do here
                }
                var redirectUrl = _squid.$util.buildURL(authChallengeUrl.substring(0, paramIndex), urlParams);

                return redirectUrl;
            }

            if (!_squid.$config.ulMeta) {
                _logger.$logger.error('config_no_ulMeta');
            }

            var ulMeta = _squid.$config.ulMeta || {};

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                // if remebered user then update spinner text
                var isRememberedUser = $scope.auth.refreshToken();

                setLoading('loadUL', isRememberedUser);

                return _kmliEligibility.$KmliEligibility.init({
                    forcedLogin: $scope.forcedLogin,
                    logoutCallback: $scope.logoutCallback
                });
            }).then(function (eligibility) {
                ulTimeoutLimit = eligibility.ulTimeoutLimit ? eligibility.ulTimeoutLimit : ulTimeoutLimit;
                $scope.preloadUL = eligibility.preloadUL;
                $scope.safeEligibility = eligibility.safeEligibility;
                $scope.kmliEligibility = eligibility.kmliEligibility;

                if ($scope.preloadUL) {
                    _logger.$logger.debug('ULSS_CLIENT_PRELOAD_TREATMENT');
                    return (0, _squid.$populate)($scope, { ulSource: _auth.$ULoginModel.instance() });
                }

                if (!$scope.checkoutCart.isWalletTokenization() && !$scope.preloadUL) {
                    $scope.ryiOptin = false;
                }
                return _angular.$q.resolve(true);
            }).then(function () {
                var rememberMe = !$scope.auth.refreshToken() ? false : $scope.kmliEligibility; // UL needs 'rememberMe=true' for RT exchange
                var app_int_type = _index.$DeviceInfo.getAppIntegrationType();

                if ($scope.auth.refreshToken() && !$scope.forcedLogin) {
                    _logger.$logger.info('checkout_fpti', {
                        'from': 'LOGIN_UL_RM',
                        'to': 'prepare_login_ul_RM',
                        app_int_type: app_int_type
                    });
                }

                function getPostLoginFpti(data) {
                    var result = void 0;

                    if (data.event === 'tokenExchanged') {
                        // This is either OneTouch or JWT (Partner Integration).
                        if (data.authorizationToken === 'jwt_token') {
                            result = { fptiState: 'LOGIN_UL_JWT', fptiTransition: 'process_UL_JWT' };
                        } else {
                            result = { fptiState: 'LOGIN_UL_RM', fptiTransition: 'process_RT_AT_exch' };
                        }
                    } else {
                        var fptiTransitionName = data.keepMeLoggedIn === true ? 'process_login_UL_RM' : 'process_login_UL';
                        var ULState = rememberMe === true ? 'LOGIN_UL_RM' : 'LOGIN_UL';

                        result = { fptiState: ULState, fptiTransition: fptiTransitionName };
                    }

                    return result;
                }

                var cancelLocaleChange = void 0;

                function loginComplete(data) {
                    var jwtBasedAssertion = data.event === 'tokenExchanged' && data.authorizationToken === 'jwt_token';
                    var rtExchanged = data.event === 'tokenExchanged' && data.authorizationToken !== 'jwt_token';

                    _squid.$promise.run(function () {
                        // eslint-disable-line
                        $scope.auth.stepupAuthRequired = false;

                        stopTimer('loginComplete');

                        if (cancelLocaleChange) {
                            cancelLocaleChange();
                        }

                        $scope.auth.isKmliSet = data.keepMeLoggedIn || rtExchanged;
                        $scope.auth.rtExchanged = rtExchanged;

                        var fptiData = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiData.fptiState,
                            'to': fptiData.fptiTransition
                        });

                        if (window.xprops && window.xprops.onAuth && data && data.accessToken) {
                            return window.xprops.onAuth({
                                accessToken: data.accessToken
                            });
                        }
                    }).then(function () {
                        var upsellEligibilityData = { ulData: data };

                        // Doesn't exist in risky login case
                        if ($scope.preAuth) {
                            // Fires off eligibility + econsent + xosession in batch mode
                            $scope.preAuth();
                        }

                        if (data.event === 'tokenExchanged') {
                            if ((0, _squid.$feature)('rmSpinnerText') && !jwtBasedAssertion) {
                                _angular.$rootScope.$emit('loadingMessage', {
                                    heading: _squid.$locale.content.get('base.planning'),
                                    subHeading: _squid.$locale.content.get('login.rmSubHeading')
                                });
                            } else {
                                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('base.planning'));
                            }
                        }

                        return $scope.auth.reload({
                            resultModel: $scope.auth,
                            headers: {
                                'x-paypal-internal-euat': data.accessToken
                            },
                            batch: {
                                name: 'setbuyer',
                                id: 'securityCtx',
                                dependencies: []
                            },
                            success: function success() {
                                $scope.auth.is_auth_api_call = data.event === 'tokenExchanged';
                                angular.extend(upsellEligibilityData, {
                                    buyerCountry: $scope.auth.country,
                                    jwtBasedAssertion: jwtBasedAssertion,
                                    showReactivationInterstitial: $scope.showReactivationInterstitial
                                });
                                _kmliUpsell.$KmliUpsell.init(upsellEligibilityData);
                                $scope.postAuth($scope.auth);
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, contingency) {
                                    $scope.auth.password = '';
                                    $scope.errorFn(name, contingency);
                                }
                            }
                        });
                    });
                }

                var ulEventHandlers = {
                    'loginRendered': function loginRendered(data) {
                        var loadingCompletedTime = Date.now();

                        _logger.$logger.debug('ULLOGIN_FRAME_LOADED_SUCCESSFULLY', {
                            page_load_time: loadingCompletedTime - enteringTime
                        });

                        // Check if this is triggered by JWT assertion failure.
                        // If so, do FPTI instrumentation.
                        if (data.authorizationType === 'token' && data.authorizationToken === 'jwt_token') {
                            _logger.$logger.info('checkout_fpti', {
                                'from': 'LOGIN_UL_JWT',
                                'to': 'process_UL_JWT',
                                'int_error_code': 'unknown',
                                'int_error_description': 'JWT assertion failed',
                                'error_source': 'unifiedloginnodeweb',
                                'error_type': 'soft_decline'
                            });
                        }
                    },
                    'loginFullyLoaded': function loginFullyLoaded(data) {
                        stopTimer(data.event);

                        if ($scope.notYou) {
                            _angular.$rootScope.$emit('loaded');
                            delete $scope.notYou;
                            _logger.$logger.info('checkout_fpti', {
                                'from': 'LOGIN_UL_RM',
                                'to': 'prepare_login_ul'
                            });
                            _fn.$fn.sendTypingSpeedPayload('HermesUL');
                            return $scope.logoutCallback();
                        }

                        if (!_uiRouter.$state.current.trackingData) {
                            _uiRouter.$state.current.trackingData = { fptiState: 'ulLoginDefault' };
                        }
                        _uiRouter.$state.current.trackingData.pageQualifier = 'ulLogin';

                        var loadingCompletedTime = Date.now();
                        var timeTaken = loadingCompletedTime - enteringTime;

                        _logger.$logger.debug('ULLOGIN_LOADED_SUCCESSFULLY', {
                            page_load_time: timeTaken
                        });

                        if ($scope.preLoadedSource) {
                            _logger.$logger.debug('ULSS_CLIENT_LOADED_SUCCESSFULLY', {
                                page_load_time: timeTaken
                            });
                        }

                        var ULState = rememberMe === true && !$scope.logoutCallback ? 'LOGIN_UL_RM' : 'LOGIN_UL';

                        _logger.$logger.info('checkout_fpti', {
                            'from': ULState,
                            'to': 'prepare_iframe',
                            'page_load_time': timeTaken
                        });

                        var payload = {
                            'from': ULState,
                            'to': 'prepare_login_ul',
                            'app_int_type': app_int_type
                        };

                        if (_uiRouter.$stateParams.targetPage) {
                            angular.extend(payload, { 'int_error_code': _uiRouter.$stateParams.targetPage });
                        }

                        _logger.$logger.info('checkout_fpti', payload);
                        _fn.$fn.sendTypingSpeedPayload('HermesUL');
                        _logger.$logger.flush();
                    },
                    'loginEmailPasswordAttempted': function loginEmailPasswordAttempted() {
                        loginAttemptedMethod = 'email';
                    },
                    'loginPhonePinAttempted': function loginPhonePinAttempted() {
                        loginAttemptedMethod = 'phone';
                    },
                    'loginAttempted': function loginAttempted(data) {
                        setLoading(data.event);
                        _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('base.loggingIn'));
                        if (rememberMe === true) {
                            var kmliStatus = data.keepMeLoggedIn === true ? 'KMLI_CHECKED' : 'KMLI_UNCHECKED';

                            _logger.$logger.debug(kmliStatus);
                        }
                        startTimer(data.event);
                    },
                    'loginSuccess': loginComplete,
                    'tokenExchanged': function tokenExchanged(data) {
                        _logger.$logger.info('TOKEN_EXCHANGED', {
                            authorizationType: data.authorizationType,
                            authorizationToken: data.authorizationToken || ''
                        });
                        loginComplete(data);
                    },
                    'notYouLinkClicked': function notYouLinkClicked(data) {
                        _angular.$rootScope.$emit('loading');
                        $scope.notYou = true;
                        _logger.$logger.info('checkout_fpti', {
                            from: 'LOGIN_UL',
                            to: 'login_with_diff_user'
                        });
                        startTimer(data.event);
                    },
                    '2fa': function fa(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);
                        if (data.contingencyUrl) {
                            _logger.$logger.debug('ULLOGIN_TWO_FA_AUTH_REDIRECT');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('ULLOGIN_TWO_FA_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                        }
                    },
                    'safeRequired': function safeRequired(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);
                        if ($scope.safeEligibility && data.contingencyUrl) {
                            if (data.authorizationType && data.authorizationType === 'token') {
                                // for remembered user redirect to login instead of SAFE APP
                                _logger.$logger.debug('LOGIN_REDIRECTION_SAFE_RM_USER');
                                _uiRouter.$state.go('checkout.login', { targetPage: 'LOGIN_CONTINGENCY' });
                            }
                            _logger.$logger.debug('ULSAFE_REDIRECTION');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('ULSAFE_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                        }
                    },
                    'serverError': function serverError(data) {
                        stopTimer(data.event);
                        var error_code = 'INVALID_USER';
                        var error = {
                            type: 'pageError',
                            code: 500
                        };

                        // internalServerError, code: 500, take user to hermes login, no need for error message
                        switch (data.reason) {
                            case 'serverValidationError':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else if (loginAttemptedMethod === 'phone') {
                                    error_code = 'INVALID_PHONE_PIN';
                                    error.msg = _squid.$locale.content.get('login.invalidPin');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.invalidEmailPasswordPageError');
                                }
                                break;
                            case 'invalidUser':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                }
                                break;
                            case 'internalServerError':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.invalidEmailPasswordPageError');
                                }
                                _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                                return appLoginHandler(failureReasons.error);
                            case 'accountTemporaryLocked':
                            case 'accountPermanentlyLocked':
                                error.code = data.code;
                                error.msg = _squid.$locale.content.get('login.accountLockedPageError');
                                error_code = 'ACCOUNT_LOCKED';
                                break;
                            case 'riskDecline':
                                error.code = data.code;
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.riskDeclinePageError');
                                    error_code = 'RISK_DECLINE';
                                }
                                break;
                            default:
                            // Do nothing
                        }
                        var fptidata = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptidata.fptiState,
                            'to': fptidata.fptiTransition,
                            'int_error_code': data.code,
                            'int_error_description': data.reason,
                            'error_type': 'soft_decline',
                            'error_source': 'unifiedloginnodeweb'
                        });
                        _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                        $scope.parentCallback('showErrorMessages', error_code);
                    },
                    'client_validation_error': function client_validation_error(data) {
                        var error = {
                            type: 'pageError',
                            msg: _squid.$locale.content.get('login.invalidEmailPasswordPageError')
                        };
                        var fptidata = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptidata.fptiState,
                            'to': fptidata.fptiTransition,
                            'int_error_code': data.event,
                            'int_error_description': 'invalid_credentials',
                            'error_type': 'soft_decline',
                            'error_source': 'unifiedloginnodeweb'
                        });
                        _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                    },
                    'stepupRequired': function stepupRequired(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);

                        if (data.authorizationType && data.authorizationType === 'token') {
                            // for remembered user redirect to login instead of AuthChallenge APP
                            _logger.$logger.debug('LOGIN_ATO_RM_USER');

                            // doing nothing, ul will render the login page, we need to show warning on top though
                            var error_code = 'ONETOUCH_GENERIC_ERROR';
                        } else if (data.contingencyUrl) {
                            _logger.$logger.debug('LOGIN_ATO_USER');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('LOGIN_ATO_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                        }
                        // to show error message on login page
                        $scope.parentCallback('showErrorMessages', error_code); // eslint-disable-line block-scoped-var
                    },
                    'captcha': function captcha(data) {
                        var fptiData = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiData.fptiState,
                            'to': 'prepare_captcha'
                        });
                    },
                    'bodyClick': function bodyClick() {
                        _angular.$rootScope.$broadcast('clickBody');
                    },
                    'expiredRefreshToken': function expiredRefreshToken(data) {
                        var treatment = data.treatment;

                        _logger.$logger.info('EXPIRED_RT_' + treatment);
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'LOGIN_UL_RM',
                            'to': 'process_RT_AT_exch',
                            'int_error_code': 'expired_RT_Token',
                            'int_error_desc': treatment,
                            'error_source': 'unifiedloginnodeweb',
                            'error_type': 'soft_decline'
                        });

                        switch (treatment) {
                            case 'showInterstitial':
                                $scope.showReactivationInterstitial = true;
                                break;

                            case 'checkboxPreselectedWithNotification':
                                $scope.errorFn('ONETOUCH_LEAVECHECKED', {}, 'warning');
                                break;

                            case 'checkboxNotPreselectedWithNotification':
                                $scope.errorFn('ONETOUCH_REACTIVATE', {}, 'warning');
                                break;

                            case 'expiredRefreshTokenControl':
                                break;

                            default:
                                break;
                        }
                    }
                };

                function postMessageHandler(response) {
                    (0, _angular.$timeout)(function () {
                        _logger.$logger.info('ul_postmessaged_received', response);
                        var data = response.data || response.error;
                        var eventId = data && data.event;

                        if (eventId) {
                            _logger.$logger.debug('ULLOGIN_' + eventId, response);
                            var handler = ulEventHandlers[eventId];

                            if (handler) {
                                handler(data);
                            }
                        }
                    });
                }

                function loadUnifiedLogin(iframeCopy) {
                    var queryString = _squid.$util.queryStringSplice(_squid.$util.queryString(), {
                        'flow': '1-P',
                        'token': $scope.token
                    }, ['cmd']);
                    var isHermesInsideIframe = _squid.$util.isIFrame();

                    if (isHermesInsideIframe) {
                        _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
                    }

                    var options = {
                        targetElement: document.getElementById('injectedUnifiedLogin'),
                        xhrRequest: isHermesInsideIframe,
                        queryParams: {
                            'stsRedirectUri': ulMeta.stsReturnUrl,
                            'country.x': $scope.locale.country,
                            'locale.x': $scope.locale.getLocaleCode(),
                            'returnUri': ulMeta.ulReturnUri,
                            'state': queryString,
                            'flowId': $scope.token,
                            'correlationId': _model.$CalDataModel.getCalCorrId()
                        },
                        config: {
                            title: 'PayPal - ' + _squid.$locale.content.get('common.login')
                        },
                        onPostMessage: postMessageHandler
                    };

                    if (_squid.$meta.baToken) {
                        angular.extend(options.queryParams, { 'fn_dt': _squid.$meta.baToken });
                    }

                    if ($scope.forcedLogin) {
                        angular.extend(options.queryParams, { 'prompt': 'login' });
                    }

                    if ($scope.logoutCallback) {
                        angular.extend(options.queryParams, { 'showNotYou': true });
                    }

                    if (_uiRouter.$stateParams.source !== 'NOT_YOU') {
                        $scope.flowcontext = $scope.checkoutCart.flow_context;
                    } else {
                        $scope.flowcontext = $scope.checkoutCart.flow_context_without_email;
                    }

                    if ($scope.flowcontext) {
                        angular.extend(options.queryParams, { 'flowContextData': $scope.flowcontext });
                    }

                    if (_squid.$config.deploy.isLocal()) {
                        options.origin = 'https://' + _squid.$meta.stage;
                        if (!_squid.$meta.stage) {
                            // if no stage url shows up then use any backup url for origin
                            var backupURL = _squid.$config.onboarding.url.split('/webapps/')[0];

                            options.origin = backupURL;
                        }
                    }

                    // preload only for first time login attempts
                    if ($scope.preloadUL && $scope.ulSource && $scope.ulSource.src && !$scope.forcedLogin && _uiRouter.$stateParams.source !== 'NOT_YOU' && !userSelectedLanguage && rememberMe) {
                        _logger.$logger.debug('ULSS_CLIENT_PRELOAD_INJECT');
                        $scope.preLoadedSource = true;
                        options.preLoadedSource = decodeURI($scope.ulSource.src);
                    }

                    function ulInvoke() {
                        if (PAYPAL && PAYPAL.unifiedLogin) {
                            startTimer('ulInvoke');
                            if (!iframeCopy) {
                                PAYPAL.unifiedLogin.inject(options);
                            } else {
                                PAYPAL.unifiedLogin.copyPasteIframe({
                                    targetElement: document.getElementById('injectedUnifiedLogin'),
                                    onPostMessage: postMessageHandler
                                });
                            }
                        } else {
                            return appLoginHandler(failureReasons.fallback);
                        }
                    }

                    var jwtToken = _squid.$util.param('jwtToken');

                    if (jwtToken) {
                        options.queryParams.jwtToken = jwtToken;
                    }

                    if (rememberMe === true) {
                        options.queryParams.rememberMe = true;
                        // NOTE: `xo_hermesnode_kmli_upsell` has been ramped to 100%
                        // and it's always return `xo_hermesnode_kmli_content_t1`
                        options.queryParams.rememberMeContent = 1;
                    }
                    return ulInvoke();
                }

                var cancelAllLoaded = _angular.$rootScope.$on('allLoaded', function () {
                    cancelLocaleChange = $scope.$on('localeChange', function () {
                        userSelectedLanguage = _squid.$locale.lang;
                        setLoading('localeChange');
                        loadUnifiedLogin();
                    });
                    cancelAllLoaded();
                });

                $scope.$on('$destroy', cancelAllLoaded);
                loadUnifiedLogin(ulMeta.iframeCopy);
            });
        }]
    };
});

_angular.$q;

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$LocaleModel;

_squid.$meta;

_squid.$populate;

_squid.$util;

_squid.$promise;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_auth.$ULoginModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_fpti.$fpti;

_model.$CalDataModel;

_fn.$fn;

_kmliEligibility.$KmliEligibility;

_kmliUpsell.$KmliUpsell;

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/template.html":
/***/ (function(module, exports) {

module.exports = "<div>\n    <input id=\"email\" name=\"login_email\" type=\"email\" value=\"\" autocomplete=\"off\" placeholder=\"Email\" style=\"display:none\">\n    <input id=\"password\" name=\"login_password\" type=\"password\" value=\"\" placeholder=\"Password\" style=\"display:none\">\n    <div id=\"injectedUnifiedLogin\">\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/ul.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ul = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/ul-inline/dist/inject.js");

/**
 * Created by upigilam on 4/8/16.
 * UL handler is to exchange ST to RT exchanges.
 */

var $ul = exports.$ul = {

    optInToOneTouch: function optInToOneTouch(token, locale_country, locale_code, silent, fptiData, flowName) {

        return (0, _angular.$q)(function (resolve, reject) {

            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 10000;
            var ulTimeoutPromise = null;

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData && fptiData.stateName ? fptiData.stateName : 'poma_page',
                    'to': fptiData && fptiData.transInfix ? fptiData.transInfix : 'process_kmli_optin'
                };

                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            function failureHandler(reason) {
                logSubmit({ errorCode: reason });
                _logger.$logger.info('UL_Loading_error_' + reason);
                return reject(new Error('UL_Loading_error_' + reason));
            }

            function startTimer(tag) {
                _logger.$logger.info('UL_START_TIMER_' + tag);
                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    failureHandler('timed_out');
                    if (!silent) {
                        _angular.$rootScope.$emit('loaded');
                    }
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                if (!silent) {
                    _angular.$rootScope.$emit('loaded');
                }
                _logger.$logger.info('UL_STOP_TIMER_' + tag);

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                    ulTimeoutPromise = null;
                }
            }

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    logSubmit();
                    // UL will drop RT cookie and respond oneTouchInterstitialOptInSuccess postmessage.
                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
                        auth.refresh_token = true;
                    });
                    return resolve();
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    failureHandler(data.event);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    // removing the element - ulTargetAttribute from DOM, to avoid any other accidental
                    // actions on the element which is causing excess spinners later.
                    var child = document.getElementById('ulTargetAttribute');

                    child.parentNode.removeChild(child);
                    stopTimer(data.event);
                    failureHandler(data.event);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;

                    if (eventId) {
                        _logger.$logger.debug('UL' + eventId, response);
                        var handler = ulEventHandlers[eventId];

                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function loadOneTouchUpsell() {
                if (!silent) {
                    _angular.$rootScope.$emit('loading');
                }

                var ulTargetAttribute = document.createElement('div');

                ulTargetAttribute.setAttribute('id', 'ulTargetAttribute');

                // setting display to None leading FireFox hiding all the ul elements due to which body click doesn't work
                // ulTargetAttribute.style.display = "None";

                // Making 0px, it works for FF, Chrome, Safari
                ulTargetAttribute.style.width = '0px';
                ulTargetAttribute.style.margin = '0px';
                ulTargetAttribute.style.height = '0px';
                ulTargetAttribute.style.padding = '0px';

                document.body.appendChild(ulTargetAttribute);

                var options = {
                    targetElement: document.getElementById('ulTargetAttribute'),
                    queryParams: {
                        'country.x': locale_country,
                        'locale.x': locale_code,
                        'flowId': token,
                        'correlationId': _model.$CalDataModel.getCalCorrId(),
                        'flowName': flowName ? flowName : 'checkoutOnlyMember' // default is poma flow
                    },
                    iframePathname: '/signin/activate-one-touch',
                    onPostMessage: postMessageHandler
                };

                if (_config.$config.deploy.isLocal()) {
                    if (_config.$meta.stage) {
                        options.origin = 'https://' + _config.$meta.stage;
                    } else {
                        // if no stage url shows up then use any backup url for origin
                        options.origin = _config.$config.urls.onboarding.split('/webapps/')[0];
                    }
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    startTimer('initializeUl');
                    PAYPAL.unifiedLogin.inject(options);
                } else {
                    failureHandler('PAYPAL.unifiedLogin_undefined');
                }
            }

            loadOneTouchUpsell();
        });
    }
};

// Loads unifiedLogin key on to PAYPAL window object


angular.value("$ul", $ul);
_angular.$rootScope;

_angular.$q;

_angular.$timeout;

_logger.$logger;

_config.$config;

_config.$meta;

_model.$CalDataModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoBackupLabel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/backup-label/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/backup-label/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoBackupLabel = exports.$xoBackupLabel = _squid.$Component.extend('$xoBackupLabel', {
    tag: 'xo-backup-label',
    template: _template2['default'],
    props: {
        plan: {
            type: 'var',
            required: false
        },
        hasMask: {
            type: 'var',
            required: false
        }
    }
});

angular.value("$xoBackupLabel", $xoBackupLabel);
_squid.$Component;

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"backupFi\" class=\"backupContainer\" ng-class=\"{ hasMask: hasMask }\" content>\n    {{plan.backup.name}}\n    <span ng-if=\"!plan.isAuthRequired\">\n        <span ng-if=\"!props.hasMask\">x-{{plan.backup.last4}} {{ content('paymentMethod.backup') }}</span>\n        <span ng-if=\"props.hasMask\"><span class=\"cardMask\"><span/><span/><span/><span/></span>{{plan.backup.last4}} {{ content('paymentMethod.backup') }}</span>\n    </span>\n</div>"

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/billing-address/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/billing-address/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _squid.$registerDirective)('xo-billing-address', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            editUri: '=?'
        },
        lifecycle: {
            enter: function enter() {
                _logger.$logger.info('xo-billing-address_enter');
            }
        },
        controller: ['$scope', function ($scope) {
            var getBillingAddress = function getBillingAddress(cardId) {
                return (0, _squid.$populate)($scope, {
                    cardInfo: _fi.$CardInfoModel.instance(cardId)
                }).then(function () {
                    return $scope.cardInfo && $scope.cardInfo.billingAddress;
                });
            };

            var updateScopeData = function updateScopeData(checkoutSession) {
                $scope.selectedCardId = $scope.checkoutSession.plan.sources[0].instrument_id;
                return getBillingAddress($scope.selectedCardId).then(function (address) {
                    $scope.address = address;
                    $scope.line3 = address.city + ', ' + address.state + ' ' + address.postal_code;
                });
            };

            (0, _squid.$populate)($scope, {
                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.header = _squid.$locale.content.get('addCard.billingAddress');
                $scope.updateType = _squid.$locale.content.get('common.edit');
                return updateScopeData($scope.checkoutSession);
            }); // populate

            $scope.$watchCollection('checkoutSession', function (newVal) {
                if (newVal) {
                    // Clear the cached CardInfo so we can get the latest associated Billing Address
                    if ($scope.cardInfo) {
                        $scope.cardInfo.invalidate();
                    }
                }
                return updateScopeData($scope.checkoutSession);
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_squid.$registerDirective;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_fi.$CardInfoModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"billing-address-wrapper\" ng-model=\"checkoutSession\">\n    <div class=\"box-header\">\n        <div class=\"headerText\">{{header}}</div>\n    </div>\n    <div class=\"box-body\">\n        <span>{{address.line1}},</span>\n        <span ng-if=\"address.line2\">{{address.line2}},</span>\n        <span>{{line3}}</span>\n        <a track-link=\"edit_billing_address\" ui-sref=\"checkout.payWithCard.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: selectedCardId})\" class=\"addCardLink\" role=\"button\">\n            {{updateType}}\n        </a>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/card-backup/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/card-backup/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * xo-card-backup
 * Render a dropdown for user to select their backup instrument in case their card
 * gets declined
 * @params {String} token - token for models
 */
exports['default'] = _squid.$Component.extend('$CardBackupComponent', {
    tag: 'xo-card-backup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        // Since selected method means the user might have something different selected compared to the checkout session,
        // might need to have this passed in to filter out the plan
        selectedmethod: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()
            };
        }
    },
    actions: {
        getAllowedBackups: function getAllowedBackups() {
            var planList = this.models.checkoutSession.getPlanList() || [];
            var currentPlanId = this.props.selectedmethod ? this.props.selectedmethod.planId : planList[0].planId;

            return planList.filter(function (a) {
                return a.planId !== currentPlanId && a.primaryFs && a.primaryFs.type === 'CARD' && a.secondaryFIs === false;
            });
        },
        renderCover: function renderCover() {
            var backup = this.models.checkoutSession.cardBackup.getPlan();

            if (!backup) {
                return (0, _squid.$renderContent)('paymentMethod.chooseBackup');
            } else {
                return this.actions.renderOption(backup) + ' ' + (0, _squid.$renderContent)('paymentMethod.backup');
            }
        },
        renderOption: function renderOption(plan) {
            return this.models.fiMeta.getName(plan.primaryFs) + ' x-' + plan.primaryFs.lastDigits;
        },
        selectBackup: function selectBackup(plan) {
            var _this = this;

            var selectedmethodPlan = this.props.selectedmethod ? (this.models.checkoutSession.getPlanList() || []).find(function (p) {
                return p.planId === _this.props.selectedmethod.planId;
            }) : null;

            this.models.checkoutSession.cardBackup.setPlan(plan, selectedmethodPlan);
            this.actions.toggleDropdown();
        },
        toggleDropdown: function toggleDropdown() {
            var _this2 = this;

            this.showDropdown = !this.showDropdown;

            if (this.showDropdown) {
                (0, _angular.$timeout)(function () {
                    return _this2.actions.showDropdownUI();
                });
            }
        },

        // UI change - the box is right aligned, but need to position it so that
        // it doesn't overflow on the left
        showDropdownUI: function showDropdownUI(open) {
            var position = this.$element.find('.card-backup-dropdown').position();

            this.$element.find('.card-backup-options').css({
                right: position && position.left < 0 ? position.left : 0,
                visibility: 'visible'
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this3 = this;

            // Close the dropdown if focus leaves the menu
            _angular.$document.on('focusin.cardBackup', function (event) {
                if (_this3.showDropdown && !_this3.$element[0].contains(event.target)) {
                    _this3.showDropdown = false;
                }
            });
        },
        exit: function exit() {
            // Clean up the dropdown handler
            _angular.$document.off('focusin.cardBackup');
        }
    }
});


_angular.$document;

_angular.$timeout;

_squid.$Component;

_squid.$renderContent;

_checkout.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-backup\" content>\n    <div class=\"card-backup-head\">\n        <span class=\"common-icon info\"></span>\n        <a ng-click=\"actions.toggleDropdown()\"\n            class=\"card-backup-cover link-dotted\"\n            href=\"#\" select-button aria-expanded=\"{{showDropdown}}\" focus-when=\"!showDropdown\" focused-once-before>\n            {{actions.renderCover()}}\n            <span class=\"card-backup-expand common-icon expand\"></span>\n        </a>\n        <div ng-if=\"showDropdown\" class=\"card-backup-dropdown\" tabindex=\"-1\" select-box select-cancel=\"actions.toggleDropdown()\" form-autofocus>\n            <div class=\"arrow-top\"></div>\n            <div class=\"card-backup-options\">\n                <li ng-repeat=\"plan in actions.getAllowedBackups() track by $index\"\n                    class=\"card-backup-option secondary\">\n                    <a href=\"#\" link-button\n                        ng-click=\"actions.selectBackup(plan)\">\n                        {{actions.renderOption(plan)}}\n                    </a>\n                    <span ng-if=\"models.checkoutSession.cardBackup.getPlan() === plan\"\n                        class=\"common-icon check-blue\">\n                    </span>\n                </li>\n                <li class=\"card-backup-option secondary\">\n                    <a href=\"#\" link-button\n                        ng-click=\"actions.selectBackup(null)\">\n                        {{content('paymentMethod.noBackup')}}\n                    </a>\n                    <span ng-if=\"!models.checkoutSession.cardBackup.getPlan()\"\n                        class=\"common-icon check-blue\">\n                    </span>\n                </li>\n            </div>\n        </div>\n    </div>\n    <div class=\"card-backup-info secondary\">\n        {{content('paymentMethod.cardBackupDescription')}}\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoDonate', {
    tag: 'xo-donate',
    template: _template2['default'],
    props: {
        merchantName: {
            type: 'str',
            required: false
        }
    },
    actions: {
        showConsent: function showConsent() {
            this.showConsentBox = !this.showConsentBox;
            _factory.$GiveAtCheckoutFactory.set({ donateCheckboxSelected: this.showConsentBox });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.showConsentBox = false;
        },
        populate: function populate() {
            this.isWpsflow = _factory.$GiveAtCheckoutFactory.get().isWPSflow || false;
            this.charity = _factory.$GiveAtCheckoutFactory.get().charity || {};
            if (this.charity.amount && this.charity.currency) {
                this.formattedAmount = (0, _squid.formatCurrency)(this.charity.amount, this.charity.currency, false, 'Currency');
            }
            this.tracking = _factory.$GiveAtCheckoutFactory.get().tracking;
        }
    }
});


_squid.$Component;

_squid.formatCurrency;

_factory.$GiveAtCheckoutFactory;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

function parseMessage(mors) {
    if (!(mors && mors.data)) {
        return {};
    }
    var touchpoints = mors.data.touchpoint_messages || [];

    if (Array.isArray(touchpoints) && touchpoints.length > 0) {
        var messages = touchpoints[0].messages || [];

        var chosen = messages.filter(function (message) {
            return message.content && message.content.json && message.content.json.model_score;
        }).reduce(function (prev, curr) {
            return prev && prev.content.json.model_score > curr.content.json.model_score ? prev : curr;
        }, undefined);

        if (chosen) {
            var charity = chosen.content.json;
            var tracking = chosen.tracking_details;

            if (charity) {
                return { charity: charity, tracking: tracking };
            }
        }
    }
    return {};
}

/*
function parseUserType(charity) {
    if (charity && charity.user_type) {
        return charity.user_type;
    }
    const DONOR_MODELS = ['0', '1'];
    if (charity && charity.model_id) {
        return DONOR_MODELS.indexOf(charity.model_id) >= 0 ? 'DONOR' : 'NONDONOR';
    }
}
*/

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$GiveAtCheckoutFactory', function () {
    var state = {
        donateCheckboxSelected: false,
        eligible: false,
        charity: undefined,
        tracking: undefined,
        isWPSflow: undefined
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    var decideEligibility = function decideEligibility() {
        var models = {};

        return (0, _squid.$populate)(models, {
            checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
            payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
        }).then(function () {
            return _marketingoffer.$MessageDiscoverModel.instance().save({
                silent: true,
                data: {
                    'country_code': _squid.$locale.getCountryCodeISO(),
                    'language': _squid.$locale.getLocaleCode(),
                    'identity_context': [{
                        'type': 'PAYER_ID',
                        'value': models.checkoutSession.get('payer.id')
                    }, {
                        'type': 'MERCHANT_PAYER_ID',
                        'value': models.payee && models.payee.merchant && models.payee.merchant.id
                    }],
                    'recommendation_context': {
                        'touchpoint_details': [{
                            'code': 'hermes_gac_touchpoint',
                            'message_count': -1
                        }]
                    }
                },
                error: function error(err) {
                    return _squid.$promise.reject(err);
                }
            });
        }).then(function (mors) {
            var _parseMessage = parseMessage(mors),
                charity = _parseMessage.charity,
                tracking = _parseMessage.tracking;

            if (charity) {
                state.charity = charity;
                state.tracking = tracking;
                _logger.$logger.info('mors_eligibility', {
                    eligible: !!charity,
                    charityName: charity.name,
                    chaityLogo: charity.logo_url,
                    amount: charity.amount
                });

                return charity;
            }
        }).then(function (charity) {
            // we are now temporally return false to disable the experience to deprecate pxp call.
            // we will work on to bring it back post pxp decpredation.
            state.eligible = false;
            return false;
        })['catch'](function (err) {
            _logger.$logger.error('gac_eligibility', err);
            state.eligible = false;
            return state.eligible;
        });
    };

    return {
        get: get,
        set: set,
        decideEligibility: decideEligibility
    };
});

_angular.$rootScope;

_logger.$logger;

_squid.$util;

_squid.$populate;

_squid.$promise;

_squid.$locale;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutPayeeModel;

_marketingoffer.$MessageDiscoverModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/give-at-checkout", "../node_modules/xo-member-components/src/give-at-checkout/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"give-at-checkout\" ng-if=\"charity.name && charity.logo_url && formattedAmount\" content>\n    <div class=\"prominentGacSeparator\">\n        <span class=\"prominentGacSeparatorLine\"></span>\n    </div>\n    <div class=\"donate checkbox\">\n        <input type=\"checkbox\" class=\"donateCheckbox\" name=\"donate\" id=\"donate\" data-test-id=\"donate-checkbox\" ng-click=\"actions.showConsent()\"/>\n        <label data-test-id=\"donate-label\" class=\"donate-label\" for=\"donate\">\n            <div data-test-id=\"charity-logo\" class=\"charity-logo\"  ng-style=\"{ background: 'url(' + charity.logo_url + ') center center / contain no-repeat' }\"></div>\n            <div class=\"charity-content\">\n                <p class=\"charity-name\">{{content('donate.label', { amount: formattedAmount, charityName: charity.name})}}</p>\n                <p ng-if=\"charity.promo_message\" class=\"promo-msg\">{{ charity.promo_message }}</p>\n            </div>\n        </label>\n    </div>\n    <div class=\"donate-consent\" ng-if=\"showConsentBox\">\n        <div ng-if=\"!isWpsflow\">\n            <p class=\"title-ec\">\n                {{content('donate.ecFlowConsentLine1')}}\n            </p>\n            <p class=\"title\">\n                {{content('donate.ecFlowConsentLine2')}}\n            </p>\n            <p class=\"content\">\n                {{content('donate.ecFlowConsentLine3')}}\n            </p>\n        </div>\n        <div ng-if=\"isWpsflow\">\n            <p class=\"title-wps\">\n                {{content('donate.wpsFlowConsentLine1')}}\n            </p>\n            <p class=\"content\">\n                {{content('donate.wpsFlowConsentLine2')}}\n            </p>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoMsbOffer = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/msb-offer/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/msb-offer/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Component for rendering Merchant specific balance on the review page for multi fi
 * It renders on top of the list of the FI's
 * As far as we know - there can only be 1 msb applied per plan
 * and so each should have "incentive" attached
*/
var $xoMsbOffer = exports.$xoMsbOffer = _squid.$Component.extend('$xoMsbOffer', {
    tag: 'xo-msb-offer',
    template: _template2['default'],
    props: {
        /**
         * incentive field from FI object
         */
        msb: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var msb = this.props.msb;


            this.amount = (0, _squid.formatCurrency)(msb.amount.value, msb.amount.currency);
            this.minPurchaseAmount = msb.minPurchaseAmount;
        }
    }
});

angular.value("$xoMsbOffer", $xoMsbOffer);
_squid.$Component;

_squid.formatCurrency;

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <div class=\"msbOfferContainer\">\n        <div class=\"wrapper\">\n            <span class=\"fsIcon INCENTIVE\"></span>\n            <div class=\"fsdetails\">\n                <span class=\"name\">\n                    {{ content('paymentMethod.msbOffer') }}\n                </span>\n\n                <div class=\"msbHelpText secondary\">\n                    {{ content('paymentMethod.msbHelpText', {amount: amount})}}\n\n                    <a class=\"msbDetails\" id=\"msbOfferTooltipId\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                </div>\n\n            </div>\n\n        </div>\n    </div>\n    <xo-tooltip trigger=\"#msbOfferTooltipId\" show-event=\"click\" hide-event=\"click\" ng-click=\"$event.stopPropagation()\">\n        <div class=\"tip tipDesc\">\n            <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n            <div class=\"msbToolTipDescription\">\n                <p ng-if=\"minPurchaseAmount\">\n                    {{ content('paymentMethod.msbToolTipText', {amount: amount, minimumPurchase: minPurchaseAmount}) }}\n                </p>\n                <p ng-if=\"!minPurchaseAmount\">\n                    {{ content('paymentMethod.msbToolTipText2', {amount: amount}) }}\n                </p>\n            </div>\n        </div>\n    </xo-tooltip>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoNoBalance = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/no-balance/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/no-balance/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Banner with text messages that user have pending (not claimed yet) balance available,
 * but needs to go through verification steps on 8ball
 *
 * Used in the following pages:
 * 1. review page - hermesnodeweb/public/pages/xo-review
 * 2. add card contingency page - hermesnodeweb/public/pages/xo-add-card
 */
var $xoNoBalance = exports.$xoNoBalance = _squid.$Component.extend('$xoNoBalance', {
    tag: 'xo-no-balance-banner',
    template: _template2['default'],
    actions: {
        /**
         * event when clicking on info icon to show secondary message
         */
        onShowSecondaryMsg: function onShowSecondaryMsg($event) {
            $event.preventDefault();
            this.showSecondaryMsg = true;
            _logger.$logger.info('no_balance', {
                from: 'no_balance',
                to: 'no_balance_click_info'
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _$NoBalanceFactory$ge = _factory.$NoBalanceFactory.get(),
                showMsgWithAmount = _$NoBalanceFactory$ge.showMsgWithAmount,
                pendingBalances = _$NoBalanceFactory$ge.pendingBalances;

            if (showMsgWithAmount) {
                var balance1 = pendingBalances[0],
                    balance2 = pendingBalances[1];


                if (pendingBalances.length === 1) {
                    this.msg = (0, _squid.$renderContent)('noBalance.primaryMsgWithAmt', { amt: (0, _squid.formatCurrency)(balance1.value, balance1.currency) });
                } else {
                    this.msg = (0, _squid.$renderContent)('noBalance.primaryMsgWithMultiAmt', {
                        amt1: (0, _squid.formatCurrency)(balance1.value, balance1.currency),
                        amt2: (0, _squid.formatCurrency)(balance2.value, balance2.currency)
                    });
                }
            } else {
                this.msg = (0, _squid.$renderContent)('noBalance.primaryMsg');
            }
        }
    }
});

angular.value("$xoNoBalance", $xoNoBalance);
_squid.$Component;

_squid.$renderContent;

_squid.formatCurrency;

_logger.$logger;

_factory.$NoBalanceFactory;

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

/**
 * Money Waiting (no balance) factory
 * story with details - https://rally1.rallydev.com/#/42145958143/detail/userstory/243026109436
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$NoBalanceFactory', function () {

    /**
     * eligible - to show / hide xo-no-balance component
     * showMsgWithAmount - to show / hide message with amount
     * pendingBalances - list of pending(non claimed yet) balances amounts
     * isAlreadyShown - was banner already shown or not
     */
    var state = {
        eligible: false,
        showMsgWithAmount: false,
        pendingBalances: undefined,
        isAlreadyShown: false
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    /**
     * Decide to show / hide message with amount / amounts
     * @param {Object} pxpResult - pxp result
     * @param {Object} pendingBalances - array of pending (non claimed yet) balances
     */
    var shouldShowMsgWithAmount = function shouldShowMsgWithAmount(_ref) {
        var pendingBalances = _ref.pendingBalances;

        return pendingBalances.length > 0;
    };

    /**
     * req.user has noBalance flag in case there is pending balance availaible which is getting mapped to auth model
     * mapping - https://github.paypal.com/Checkout/xo-hercules/blob/master/apis/auth/outputMapper.js
     */
    var hasUserPendingBalance = function hasUserPendingBalance() {
        return _auth.$AuthModel.instance().no_balance;
    };

    /**
     * Mark as already shown, for example:
     * if user doesn't have any FI -> user will see "no balance" banner on Add Card Page.
     * And so after user adds cart successfully -> we should not show banner on review page
     */
    var markAsAlreadyShown = function markAsAlreadyShown() {
        state.isAlreadyShown = true;
        state.eligible = false;
    };

    /**
     * experiment is eligible in the following cases:
     * 1. user has `no_balance` flag as `true` - means there is pending balance that user can claim, but need to go through verification first on 8ball
     * 2. user has less than 3 balance accounts
     * 3. pxp returns treatment1 or treatment2
     */
    var decideEligibility = function decideEligibility() {
        if (state.isAlreadyShown) {
            return _squid.$promise.resolve({});
        }

        var isUserWithPendingBalance = hasUserPendingBalance();

        return _wallet.$WalletModel.instance(_angular.$rootScope.token).retrieve().then(function (wallet) {
            var pendingBalances = wallet.getAmountsOfBalances();
            var isNoBalanceEligible = isUserWithPendingBalance && pendingBalances.length > 0 && pendingBalances.length < 3;

            var balance1 = pendingBalances[0],
                balance2 = pendingBalances[1];


            _logger.$logger.info('no_balance', {
                from: 'no_balance',
                to: 'no_balance_eligibility',
                number_of_balances: pendingBalances.length,
                no_balance_eligible: isNoBalanceEligible,
                balance_amount1: balance1 && balance1.value,
                balance_currency1: balance1 && balance1.currency,
                balance_amount2: balance2 && balance2.value,
                balance_currency2: balance2 && balance2.currency
            });

            if (!isNoBalanceEligible) {
                return _squid.$promise.resolve({});
            }

            state.eligible = true;
            state.pendingBalances = pendingBalances;
            state.showMsgWithAmount = shouldShowMsgWithAmount({ pendingBalances: pendingBalances });

            return state;
        });
    };

    return {
        get: get,
        set: set,
        markAsAlreadyShown: markAsAlreadyShown,
        decideEligibility: decideEligibility,
        hasUserPendingBalance: hasUserPendingBalance
    };
});

_squid.$util;

_squid.$promise;

_logger.$logger;

_wallet.$WalletModel;

_auth.$AuthModel;

_angular.$rootScope;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/no-balance", "../node_modules/xo-member-components/src/no-balance/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"noBalanceContainer\">\n    <div class=\"primaryMsgWrapper\">\n        <a ng-click=\"actions.onShowSecondaryMsg($event)\" class=\"questionMark\"></a>\n        <div class=\"primaryMsg\">{{ msg }}</div>\n    </div>\n    <div ng-if=\"showSecondaryMsg\" class=\"secondaryMsg\">{{ content('noBalance.secondaryMsg') }}</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-preferred-checkbox',
    template: _template2['default'],
    props: {
        makeFiPreferred: {
            type: 'var',
            required: false
        },
        plan: {
            type: 'var',
            required: false
        },
        cardart: {
            type: 'var',
            required: false
        }
    },
    actions: {
        toggleModel: function toggleModel() {
            if (this.props.makeFiPreferred.selected) {
                this.props.makeFiPreferred.planId = this.props.plan.planId;
                this.props.makeFiPreferred.fiId = this.props.plan.primaryFs.type === 'BALANCE' ? this.props.plan.primaryFs.type : // Balance doesn't have an instrument id
                this.props.plan.primaryFs.id;
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('checkout_fpti', { 'pref_fi_option_shown': '1' });
        }
    }
});


_squid.$Component;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$PreferredCheckboxFactory', function () {
    var state = {
        eligible: false
    };

    /**
     * check choice eligibility based on:
     * 1. is billing or not
     */
    var getChoicePreferredCheckboxEligibility = function getChoicePreferredCheckboxEligibility(checkoutCart) {
        return _index.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
            var checkboxVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            return checkboxVariants.indexOf(variant) !== -1 && !checkoutCart.isBilling();
        });
    };

    /**
     * eligible if:
     *
     * 1. choice eligibility is successfull
     * 2. number of plans >= 1
     *
     * If there is only 1 plan, xo_hermes_single_preffered_checkbox pxp (https://engineering.paypalcorp.com/pxptoolstage/configuration?exptId=5480&version=1)
     * must return treatment
     *
    */
    var decideEligibility = function decideEligibility(_ref) {
        var plans = _ref.plans,
            checkoutCart = _ref.checkoutCart;

        if (!plans || plans.length === 0) {
            state.eligible = false;
            return;
        }

        return getChoicePreferredCheckboxEligibility(checkoutCart).then(function (choiceEligibility) {
            if (!choiceEligibility) {
                state.eligible = false;
                return;
            }

            _logger.$logger.info('preferred_checkbox_enabled');
            state.eligible = true;
            return;
        });
    };

    var isSinglePreferredCheckboxEligible = function isSinglePreferredCheckboxEligible(_ref2) {
        var plans = _ref2.plans;

        return plans && plans.length > 0 && state.eligible;
    };

    var showPreferredCheckbox = function showPreferredCheckbox(plan, fundingOptions) {
        return (plan.primaryFs.id || plan.primaryFs.type === 'BALANCE') && !fundingOptions.isPreferred(plan) && !(plan.primaryFs.type === 'CREDIT' && plan.primaryFs.name.includes('PAY_LATER_')) && !(_squid.$locale.country === 'DE' && plan.primaryFs.name === 'BILL_ME_LATER');
    };

    return {
        isSinglePreferredCheckboxEligible: isSinglePreferredCheckboxEligible,
        decideEligibility: decideEligibility,
        showPreferredCheckbox: showPreferredCheckbox
    };
});

_squid.$config;

_squid.$locale;

_logger.$logger;

_index.$ChoiceEligibility;

_angular.$rootScope;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/preferred-checkbox", "../node_modules/xo-member-components/src/preferred-checkbox/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"checkboxFiPreferred sCheckbox checkbox {{plan.primaryFs.name}}\" ng-class=\"{cardart: cardart}\" content>\n    <input type=\"checkbox\" ng-model=\"makeFiPreferred.selected\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" ng-change=\"actions.toggleModel()\" aria-describedby=\"backupFi\">\n    <label for=\"makeFiPreferred\">{{\n    \tcontent(\n    \t\t'memberReview.prefer_' + plan.primaryFs.type,\n    \t\t{ name: content('fsMappings.'+ plan.primaryFs.name) }\n    \t)\n\t}}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-address/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-review-address',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        makeAddrPreferred: {
            type: 'var',
            required: false
        },
        countryCode: {
            type: 'str',
            required: false
        },
        storePickUpSelected: {
            type: 'var',
            required: false
        },
        nmjExperience: {
            type: 'var',
            required: false
        },
        hideShipToHeader: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                auth: _index2.$AuthModel.instance().retrieve()['catch'](_angular.noop)
            };
        }
    },
    actions: {
        gotoShipping: function gotoShipping() {
            if (this.models.checkoutAppData.flags.allow_change_shipping) {
                _uiRouter.$state.go('checkout.review.sidebar.shipping');
            } else {
                this.cannotChangeShippingInfoMessages = true;
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var updateMakePreferredFlag = function updateMakePreferredFlag(flag) {
                if (_this.makeAddrPreferred) {
                    // Update the makeAddrPreferred.shown flag, for the caller to know about it.
                    _this.makeAddrPreferred.shown = flag;
                }
                return flag;
            };

            /**
             * Decision on whether to show Make Preferred Checkbox
             * @returns {boolean}
             */
            this.isMakePreferred = function () {
                if (_this.models.auth.remembered) {
                    return updateMakePreferredFlag(false);
                }

                if (_this.isPreferredShippingEnabled && !_this.models.checkoutSession.get('shipping.preferred_address') && !_this.models.checkoutSession.get('shipping.s2s_address')) {
                    return updateMakePreferredFlag(true);
                }
                return updateMakePreferredFlag(false);
            };
        },
        populate: function populate() {
            // countryCode is not available, hence we use the shipping.county to retrieve the feature flag.
            var shipping = this.models.checkoutSession && this.models.checkoutSession.shipping || {};

            this.isPreferredShippingEnabled = (0, _squid.$feature)('preferredShipping', false, shipping.country);
            this.isNmj = this.props.nmjExperience && (this.props.nmjExperience.one_page || this.props.nmjExperience.design_2 || this.props.nmjExperience.design_3);
        }
    }
});


_angular.noop;

_uiRouter.$state;

_squid.$Component;

_squid.$feature;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index2.$AuthModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"shippingForm\" class=\"shipping asideView\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div id=\"shippingAddress\">\n            <div ng-class=\"{editable:models.checkoutAppData.flags.allow_change_shipping}\" focusable=\"!cannotChangeShippingInfoMessages\" class=\"focusable\" select-button disable-role ng-click=\"actions.gotoShipping()\">\n                <h2 ng-show=\"!(storePickUpSelected || hideShipToHeader)\" class=\"noBottom gamma\">{{ content('shippingAddress.shipTo') }}</h2>\n                <div ng-show=\"storePickUpSelected\">\n                    <h2 class=\"noBottom gamma\">{{ content('shippingAddress.yourAddress') }}</h2>\n                    <span class=\"merchantReq\">{{ content('shippingAddress.merchantReq') }}</span>\n                </div>\n                <div class=\"addressDisplay\">\n                    <div ng-if='!(nmjExperience && (nmjExperience.design_2 || nmjExperience.design_3))'>\n                        <span class=\"given-name\" data-test-id=\"fullName\">{{models.checkoutSession.shipping.name}}</span>\n                        <span class=\"family-name\"></span>\n                        <xo-address-display address=models.checkoutSession.shipping country-code=countryCode></xo-address-display>\n                    </div>\n                    <div ng-if='nmjExperience && (nmjExperience.design_2 || nmjExperience.design_3)'>\n                        <span class=\"dropPin\" id=\"dropPin\"></span>\n                        <div class=\"nameAddress\">\n                            <span class=\"given-name\" data-test-id=\"fullName\">{{models.checkoutSession.shipping.name}}</span>\n                            <xo-address-display class=\"\" address=models.checkoutSession.shipping country-code=countryCode></xo-address-display>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <a ng-show='!isNmj' class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\" data-test-id=\"shipToChangeLink\" select-button focusable=\"!cannotChangeShippingInfoMessages\" ng-click=\"actions.gotoShipping()\" aria-label=\"{{ content('shippingAddress.label') }}\" focus-when-state=\"checkout.review.sidebar.shipping\" transitions-to=\"checkout.review\">\n                {{ content('common.change') }}\n                <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n            </a>\n        </div>\n    </div>\n    <div id=\"infoMessages\" class=\"msgPage msg-info shipNotification\" ng-if=\"cannotChangeShippingInfoMessages\">\n        <span class=\"icon\"></span>\n        <ul>\n            <li ng-if=\"models.checkoutAppData.useraction() === 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsgUserActionCommit', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n            <li ng-if=\"models.checkoutAppData.useraction() !== 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsg', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n        </ul>\n    </div>\n</div>\n\n<div class=\"reviewPreferredShipping sCheckbox checkbox\" ng-if=\"isMakePreferred()\">\n    <input type=\"checkbox\" ng-model=\"makeAddrPreferred.selected\" name=\"makePreferred\" id=\"makePreferred\" />\n    <label for=\"makePreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n</div>\n\n<div ng-if=\"isNmj\" class=\"multipleShipping addShipping\">\n    <a track-link=\"change_shipping\" ng-click=\"actions.gotoShipping()\" class=\"addAddressLink\" id=\"addAddressLink\" data-test-id=\"shipToChangeLink\" role=\"button\">\n        <span class=\"plusicon\"></span>\n        <p class=\"addOption\">\n            <span class=\"name\">{{content('addShipping.switchAddress')}}</span>\n        </p>\n    </a>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/cardicon/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/pay-with-credit/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-member-components/src/billing-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/card-backup/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/directive.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-member-components/src/show-more-fi/directive.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/factory.js");

var _factory3 = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

__webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/directive.js");

var _factory4 = __webpack_require__("../node_modules/xo-member-components/src/review-paywith/factory.js");

__webpack_require__("../node_modules/xo-member-components/src/msb-offer/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/backup-label/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-paywith/template.html");

var _template2 = _interopRequireDefault(_template);

var _factory5 = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/factory.js");

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/directive.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _factory6 = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// <pay-with-credit>
// accessibility directives
// <xo-cvv>
var ADD_CARD_URLS = {
    SIDEBAR_DEFAULT: {
        route: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard',
        label: 'fundingInstruments.addNewCard'
    },
    SIDEBAR_ADDCARD_WITH_ADDBANK: {
        route: 'checkout.review.sidebar.sidebarAddNew.bank.add',
        label: 'common.addNew'
    }
}; // billing address display
// PPC banners
// <xo-tooltip>

var BILL_PAY_CONSENT = 'billPayConsent';

(0, _angular.$registerDirective)('xo-review-paywith', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=?',
            showBmlPopup: '=?',
            installmentNotSelected: '=?',
            payButtonText: '=?',
            installment: '=?',
            padToggleFeature: '=?',
            selectedmethod: '=?',
            showBalanceRebranded: '=?',
            makeFiPreferred: '=?',
            selectFiVariant: '=?',
            nmjExperience: '=?',
            creditParentContext: '=?',
            choiceBalanceCheckboxState: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.locale = _squid.$locale;
            $scope.formatCurrency = _squid.formatCurrency;
            $scope.nmjMultiPage = $scope.nmjExperience && $scope.nmjExperience.multiPage;
            $scope.showMoreFiFactory = _factory.$ShowMoreFiFactory;
            $scope.smartAuthFactory = _factory4.$SmartAuthFactory;
            $scope.currencyConversionFactory = _factory5.$CurrencyConversionFactory;
            $scope.isCountryDE = _squid.$locale.country === 'DE';
            $scope.isCountryHU = _squid.$locale.country === 'HU';
            $scope.creditSharedInfo = _index3.$CreditSharedInfoModel.instance();

            // check for feature enabled in config/inc/ui.json for AU country
            // this feature is there only in country AU as of June 29th, 2015
            $scope.showUachFeatureDiscalimer = false;

            /**
             * isMultiFiPadEligible
             * Used to determine if we should combine plans to be able to show
             * a PAD toggle checkbox instead of 2 plans
             *
             * padToggleEnabled is used to control ramp per country using a combination of pxp
             * and a feature flag
             *
             * If the coutnry is included on the list of countires that should look at the pxp config
             * we check the pxp and then the feature flag to check if its enabled,
             *
             * If the country its not included in the list of countries that should check pxp
             * we just use the feature flag.
             *
             */
            var isMultiFiPadEligible = function isMultiFiPadEligible() {
                return $scope.isPadToggleFeatureApplicable() && $scope.padToggleEnabled;
            };

            var setPadStatus = function setPadStatus(state) {
                $scope.padToggleFeature.checkboxEnabled = state;
            };

            var getPadStatus = function getPadStatus() {
                return $scope.padToggleFeature.checkboxEnabled;
            };

            var getMultiFiPadCheckboxState = function getMultiFiPadCheckboxState(id) {
                return $scope.padToggleFeature.multiFiCheckboxStates[id];
            };

            // used for multiFi DE
            // update pad status which is used to show/hide "Pay after 14 Days" label as a text on a blue Pay button
            var setPadStatusForMultiFi = function setPadStatusForMultiFi(plan) {
                if ($scope.checkoutSession.fundingOptions.isPAD(plan) || $scope.checkoutSession.fundingOptions.isIACH(plan)) {
                    setPadStatus(getMultiFiPadCheckboxState(plan.primaryFs.id));
                } else {
                    setPadStatus(false);
                }
            };

            // TODO: remove after PAPS fix
            $scope.balanceWithRewards = function (fi) {
                return _factory3.$RewardsCheckboxFactory.hideAmount(fi);
            };

            $scope.hasRewards = function (plan) {
                return _factory3.$RewardsCheckboxFactory.isRewardsPlan(plan);
            };

            $scope.getRewardsContent = function (plan) {
                // Need a content mapper because content experience
                // changes based on type of rewards in plan.
                var contentKeys = _factory3.$RewardsCheckboxFactory.getContentKeys(plan);

                return contentKeys || {};
            };

            $scope.isSelected = function (plan) {
                if (!plan) {
                    return false;
                }
                var getID = function getID(obj) {
                    return obj.planId || obj.id;
                };
                var selection = $scope.selectedmethod ? $scope.selectedmethod : $scope.checkoutSession.plan;
                var result = getID(plan) === getID(selection);
                // When the user is on RYI after selectFI
                // selection logic is maintained by the session
                // and not by radio button clicks on $scope.selectedmethod

                return result;
            };

            $scope.$on('$destroy', function () {
                return _factory3.$RewardsCheckboxFactory.destroy();
            });

            $scope.showChangeFI = function () {
                return $scope.canChangeFI && !$scope.selectedmethod && !$scope.nmjExperience;
            };

            $scope.showCreditPlacement = function (fs) {
                return fs && !fs.is_pinless_debit && fs.name === 'PayPal Credit' || fs.primaryFs && fs.primaryFs.name === 'BILL_ME_LATER';
            };

            // This is set in xo-credit-components apart of an A/B test for PPC reuse radio button.
            // FOR PPC reuse customers with NI offer a special financing badge is shown for treatment 1.
            // TODO: If this is a winning experiment move over getter and setter to model.
            $scope.showSpecialFinancingBadge = function () {
                return _angular.$rootScope.specialFinancingBadge;
            };

            $scope.isGplFI = function (fs) {
                return fs.primaryFs && fs.primaryFs.type === 'CREDIT' && fs.primaryFs.name.includes('PAY_LATER_');
            };

            $scope.isGplDE = function (fs) {
                return fs.primaryFs && fs.primaryFs.type === 'CREDIT' && (fs.primaryFs.name === 'PAY_LATER_DE' || fs.primaryFs.name === 'PAY_LATER_PAY_IN_1_DE');
            };

            $scope.isDEInstallmentsFI = function (fs) {
                return $scope.isCountryDE && (fs.type === 'BILL_ME_LATER' || fs.primaryFs && fs.primaryFs.name === 'BILL_ME_LATER');
            };

            $scope.isDEInstallmentsOrGplFI = function (fs) {
                return $scope.isDEInstallmentsFI(fs) || $scope.isGplFI(fs);
            };

            $scope.ppcInstallmentContentReady = function () {
                return $scope.creditSharedInfo.hasInstallmentOffers() && $scope.creditSharedInfo.hasInstallmentOfferFinancingDetails();
            };

            $scope.showInstallmentDetailsSecondLine = function (fs) {
                if ($scope.isDEInstallmentsFI(fs)) {
                    if ($scope.installment.financing_details) {
                        return true;
                    }
                    return false;
                }
            };

            $scope.isDEInstallmentsOptionSelected = function () {
                var deInstallmentsPlanSelected = false;

                if ($scope.isCountryDE) {
                    var plans = $scope.checkoutSession.getPlanList();

                    if (plans) {
                        deInstallmentsPlanSelected = plans.filter(function (p) {
                            return p.primaryFs.type === 'CREDIT' && p.primaryFs.name === 'BILL_ME_LATER' && p.selected;
                        }).length > 0;
                    }
                }
                // If the DE installments plan is selected, restict "changeFI" & "Manage"
                if (deInstallmentsPlanSelected) {
                    $scope.canChangeFI = false;
                    $scope.selectedmethod = undefined;
                }
                return deInstallmentsPlanSelected;
            };

            $scope.showInstallmentsFiTitle = function () {
                return $scope.isCountryDE && !$scope.checkoutSession.fundingOptions.hasCredit() && $scope.ppcInstallmentContentReady();
            };

            $scope.getInstallmentsFiTitle = function () {
                if ($scope.creditSharedInfo.getInstallmentOffer() && $scope.creditSharedInfo.getInstallmentOffer().taglineText) {
                    // This tagline text will be localization already by Personalization platform
                    return $scope.creditSharedInfo.getInstallmentOffer().taglineText;
                }
                return $scope.content('memberReview.installmentsTitle');
            };

            $scope.isPadToggleFeatureApplicable = function () {
                return $scope.padToggleEnabled && $scope.padToggleFeature.applicable;
            };

            // for PAD eligible get combined plans
            $scope.getSortedPlans = function () {
                if (isMultiFiPadEligible()) {
                    return $scope.checkoutSession.fundingOptions.getPadAndIachCombinedPlans();
                } else {
                    return $scope.checkoutSession.getPlanList();
                }
            };

            $scope.showMultiFiPadToggle = function (plan) {
                var padToggle = false;

                if (isMultiFiPadEligible() && $scope.checkoutSession.fundingOptions.isPadToggleApplicableForFS(plan.planId) && plan.planId === $scope.selectedmethod.planId) {
                    padToggle = true;
                    setPadStatusForMultiFi(plan);
                }
                return padToggle;
            };

            $scope.showPadLabelForPadEligibleCountries = function (plan) {
                return $scope.checkoutSession.fundingOptions.isPAD(plan) || $scope.checkoutSession.fundingOptions.isIACHWithPad(plan) && $scope.padToggleEnabled && plan.planId !== $scope.selectedmethod.planId;
            };

            $scope.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.merchant && $scope.checkoutAppData.merchant.merchant_country === 'US';

                return $scope.payee && $scope.payee.isGambling() && isUSBuyer && isUSmerchant;
            };

            // get add card link state to display different versions based on country
            $scope.getAddCardLink = function () {
                var linkObj = ADD_CARD_URLS.SIDEBAR_DEFAULT;

                if ((0, _squid.$feature)('addBank')) {
                    linkObj = ADD_CARD_URLS.SIDEBAR_ADDCARD_WITH_ADDBANK;
                }

                var state = {
                    show: $scope.selectedmethod && !$scope.nmjExperience && !$scope.isUSGambling(),
                    route: linkObj.route,
                    label: $scope.content(linkObj.label)
                };

                return state;
            };

            var populateModels = function populateModels() {
                _index2['default'].instance($scope.token).fetch();
                return (0, _squid.$populate)($scope, {
                    checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
                    checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token),
                    payee: _checkout.$CheckoutPayeeModel.instance($scope.token),
                    showManageLink: _factory4.$SmartAuthFactory.disallowedManageLinkExp()
                });
            };

            var setShowAmount = function setShowAmount() {
                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                // are not available and purchase amount is not zero.
                var userAction = $scope.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

                return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                    $scope.showAmt = $scope.checkoutCart.get('payment_action') !== 'authorize' && showAmount;
                });
            };

            var setShowBalanceComprehensionBanner = function setShowBalanceComprehensionBanner() {
                $scope.showBalanceComprehensionBanner = false;
                var experimentCalled = Experiments.balanceComprehensionBannerExperiment.experimentCalled();

                if (experimentCalled) {
                    _logger.$logger.info('balanceComprehensionBannerExperiment_EXP_CALLED');
                    return _angular.$q.when();
                }
                return Experiments.balanceComprehensionBannerExperiment.getTreatment({
                    page: 'review',
                    cart: $scope.checkoutCart,
                    checkoutAppData: $scope.checkoutAppData,
                    checkoutSession: $scope.checkoutSession,
                    payee: $scope.payee
                }).then(function (result) {
                    $scope.showBalanceComprehensionBanner = result && result.treatment_name === 'Trmt_balance_banner_ramp_hermes_bottom';
                    if ($scope.showBalanceComprehensionBanner) {
                        $scope.balanceComprehensionBannerMessage = {
                            type: 'info',
                            msgs: [_squid.$locale.content.get('billingAgreement.paypalBalanceInfoBanner')]
                        };
                    }
                })['catch'](function () {
                    _logger.$logger.info('balanceComprehensionBannerExperiment_GET_TREATMENT_ERROR', { page: 'review' });
                    return _angular.$q.when();
                });
            };

            var setNegativeBalanceData = function setNegativeBalanceData() {
                var negBals = $scope.checkoutSession && $scope.checkoutSession.negBals;

                // re-order multiple currencies when first balance has different currency
                if (negBals && negBals[0].currency_code !== $scope.checkoutCart.purchase.amounts.currency_code) {
                    negBals = negBals.reverse();
                }
                $scope.negBals = negBals;
            };

            var setShowBillingAddress = function setShowBillingAddress() {
                if (!$scope.nmjMultiPage) {
                    return;
                }
                // only show billing address if the selected instrument is a Credit Card
                var selectedInstrument = $scope.checkoutSession.plan.sources && $scope.checkoutSession.plan.sources[0];

                if (selectedInstrument && selectedInstrument.type === 'PAYMENT_CARD') {
                    $scope.showBillingAddress = true;
                }
            };

            // Eligibility for displaying the new AS1/AS2 FX transaction (new 72 hours compliance)
            // See: https://github.paypal.com/Checkout-R/hermesnodeweb/issues/3750
            var showComplianceContent = function showComplianceContent() {
                if ((0, _squid.$feature)('temporaryComplianceDisable')) {
                    return false;
                }
                var paymentAction = $scope.checkoutCart.get('payment_action', '').toLowerCase();

                return ['authorize', 'order'].indexOf(paymentAction) > -1;
            };

            // Fallback if either current either $CheckoutCartModel.purchase.amounts.total.amount_formatted_number
            // or $CheckoutCartModel.purchase.amounts.total.currency_code is undefined, we will construct
            // the `value` and `currencyCode` from $CheckoutCartModel.grossTotalAmount
            var getTotalIssuerAmount = function getTotalIssuerAmount() {
                var _ref = $scope.checkoutCart && $scope.checkoutCart.get('grossTotalAmount', {}) || {},
                    value = _ref.value,
                    currencyCode = _ref.currency;

                return {
                    value: value,
                    currencyCode: currencyCode
                };
            };

            var getTotalAmount = function getTotalAmount() {
                var amount = {};

                amount.value = $scope.checkoutCart.get('purchase.amounts.total.amount_formatted_number', '');
                amount.currencyCode = $scope.checkoutCart.get('purchase.amounts.total.currency_code', '');

                if (!amount.value || !amount.currencyCode) {
                    amount = getTotalIssuerAmount();
                }

                return amount;
            };

            // Initialize currency conversion new content for HU and 72 hours compliance
            var initComplianceContent = function initComplianceContent() {
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    fromPayPal = _ref2.paypal,
                    fromCurrencyCode = _ref2.from_code,
                    totalConvertedAmount = _ref2.total_converted_amount,
                    toAmount = _ref2.to_amount_forex,
                    toCurrencyCode = _ref2.to_code;

                return {
                    fromPayPal: fromPayPal,
                    conversionRateLabel: fromPayPal ? (0, _squid.$renderContent)('currencyOptions.payPalConversionRate') : (0, _squid.$renderContent)('currencyOptions.issuerConversionRate'),
                    conversionRate: fromPayPal ? (0, _squid.$renderContent)('paymentMethod.conversionRate', {
                        currencyTo: toAmount + ' ' + toCurrencyCode,
                        currencyFrom: '1 ' + fromCurrencyCode
                    }) : '',
                    amount: fromPayPal ? { value: totalConvertedAmount } : getTotalAmount(),
                    chooseLink: fromPayPal ? (0, _squid.$renderContent)('currencyOptions.chooseIssuerRate') : (0, _squid.$renderContent)('currencyOptions.choosePayPalRate')
                };
            };

            // In case we still have the pxp treatment for displaying the sidebar currency conversion UI
            // instead of interstitial one, this adds the support for that UI view.
            $scope.$on('reloadCheckoutSession', function (event, data) {
                if (data && data.checkoutSession) {
                    var _ref3 = data.checkoutSession || {},
                        plan = _ref3.plan;

                    var _ref4 = plan || {},
                        _ref4$conversion = _ref4.conversion,
                        conversion = _ref4$conversion === undefined ? {} : _ref4$conversion;

                    $scope.complianceContent = conversion && initComplianceContent(conversion);
                }
            });

            // Callback for <xo-currency-conversion-overlay /> interstitial
            // when it's done updating checkoutSession
            $scope.onComplete = function (checkoutSession) {
                if (checkoutSession) {
                    var _ref5 = checkoutSession.plan || {},
                        _ref5$conversion = _ref5.conversion,
                        conversion = _ref5$conversion === undefined ? {} : _ref5$conversion;

                    $scope.complianceContent = conversion && initComplianceContent(conversion);
                }
            };

            $scope.setSelectedFiBufsDisclosureContent = function (plan) {
                var isSelected = plan.planId === $scope.selectedmethod.planId;
                var primary = plan && plan.primaryFs;
                var backup = plan.backup;
                var conversion = plan.conversion;
                var content = (0, _squid.$renderContent)('bufs.nonCurrencyConversion', {
                    backupName: backup && backup.name,
                    backupLast4: backup && backup.last4
                });
                var eligible = isSelected && primary && backup && !conversion && content;

                if (eligible) {
                    $scope.bufsDisclosureText = content;
                    $scope.hideBackupLabel = true; // Do not show backup if there is a disclosure
                    return true;
                } else {
                    $scope.bufsDisclosureText = '';
                    return false;
                }
            };

            $scope.setBufsDisclosureContent = function () {
                var _ref6 = $scope.checkoutSession || {},
                    _ref6$plan = _ref6.plan,
                    plan = _ref6$plan === undefined ? {} : _ref6$plan;

                var primary = plan && plan.sources && plan.sources[0];
                var backup = plan.backup;
                var conversion = plan.conversion;
                var CONSTANTS = {
                    'BANK_ACCOUNT': 'bank',
                    'BALANCE': 'balance',
                    'American Express': 'amex',
                    'Discover': 'discover'
                };
                var type = primary && CONSTANTS[primary.type]; // Only show disclosure where applicable
                var fi = backup && CONSTANTS[backup.name] || 'default';
                var formatedAmount = $scope.checkoutCart.get('purchase.amounts.total', {}).amount_formatted_currency;

                if (primary && backup && !(0, _squid.$feature)('temporaryComplianceDisable')) {
                    var content = '';

                    if (conversion && type) {
                        // Card providers may have different content during currency conversion
                        content = (0, _squid.$renderContent)('bufs.' + type + '.' + fi, {
                            backupName: backup && backup.name,
                            backupLast4: backup && backup.last4,
                            cartAmount: formatedAmount,
                            conversionToCode: conversion.to_code
                        });
                    } else if (!conversion) {
                        // Content is the same for all providers without currency conversion
                        content = (0, _squid.$renderContent)('bufs.nonCurrencyConversion', {
                            backupName: backup && backup.name,
                            backupLast4: backup && backup.last4
                        });
                    }
                    if (content) {
                        $scope.bufsDisclosureText = content;
                        $scope.hideBackupLabel = true; // Do not show backup if there is a disclosure
                    }
                    return true;
                } else {
                    $scope.bufsDisclosureText = '';
                    $scope.hideBackupLabel = false;
                    return false;
                }
            };

            var setCurrencyConversion = function setCurrencyConversion() {
                var _ref7 = $scope.checkoutSession || {},
                    _ref7$plan = _ref7.plan,
                    plan = _ref7$plan === undefined ? {} : _ref7$plan;

                var _plan$conversion = plan.conversion,
                    conversion = _plan$conversion === undefined ? {} : _plan$conversion;
                // Determine whether is AS1/AS2 type of transaction
                // 72 hours compliance content only applies to AS1/AS2

                $scope.displayASContent = showComplianceContent();

                if (conversion) {
                    $scope.toTargetCurrency = conversion.to_amount_forex + ' ' + conversion.to_code;
                    $scope.fromUnitCurrency = '1 ' + conversion.from_code;
                }

                $scope.complianceContent = conversion && initComplianceContent(conversion);
            };

            var setMultiFiPadCheckboxState = function setMultiFiPadCheckboxState(id, state) {
                $scope.padToggleFeature.multiFiCheckboxStates[id] = state;
            };

            $scope.getPadStatus = getPadStatus;

            var logFptiForPadToggle = function logFptiForPadToggle(status) {
                _logger.$logger.info('checkout_fpti', {
                    'pad_toggle_status': 'padToggle' + status
                });
            };

            // for PAD checking the corresponding IACH bank is preferred or not
            // only MEFT and IACH subtypes can have isPreferred as true
            $scope.showPreferredLabelForMultiFi = function (plan) {
                var preferred = $scope.checkoutSession.fundingOptions.isPreferred(plan);

                return $scope.makeFiPreferred && preferred && !$scope.checkoutSession.fundingOptions.isMEFT(plan);
            };

            $scope.showPreferredLabelForSingleFi = function (fs) {
                var plans = $scope.checkoutSession.get('fundingOptions.plans') || [];
                var filteredPlans = plans.filter(function (plan) {
                    return plan.planId === fs.id && plan.primaryFs && plan.primaryFs.id === fs.instrument_id;
                });

                if (filteredPlans.length > 0) {
                    return $scope.checkoutSession.fundingOptions.isPreferred(filteredPlans[0]) && $scope.showPreferredLabel;
                } else {
                    return false;
                }
            };

            // show / hide preferred checkbox for multi fi use case
            $scope.showPreferredCheckboxForMultiFi = function (plan) {
                if ($scope.checkoutCart.referenceCheckout) {
                    return false;
                }
                var preferred = $scope.checkoutSession.fundingOptions.isPreferred(plan);

                return $scope.makeFiPreferred && plan.planId === $scope.selectedmethod.planId && !preferred;
            };

            // Decide whether multiple FI or single FI section should be shown, based on choice experiment criteria
            var initPadToggleFeatureParams = function initPadToggleFeatureParams() {
                $scope.padToggleFeature.applicable = $scope.checkoutSession.fundingOptions.isPadToggleApplicable();
                setPadStatus($scope.padToggleFeature.applicable && $scope.checkoutSession.plan.isPAD() ? true : false);
                var sortedPlans = $scope.getSortedPlans();

                // sortedPlans (fundingOptions.plans) is undefined for BA no purchase case
                if (sortedPlans) {
                    sortedPlans.forEach(function (plan) {
                        if ($scope.checkoutSession.fundingOptions.isPAD(plan)) {
                            setMultiFiPadCheckboxState(plan.primaryFs.id, true);
                        }
                    });
                }
                $scope.padToggleFeature.defaultPlan = $scope.checkoutSession.plan.isPAD();
            };

            // Decide whether multiple FI or single FI section should be shown, based on choice experiment criteria
            $scope.showMultipleFi = function () {

                if ($scope.isDEInstallmentsOptionSelected()) {
                    return false;
                }

                // if currency conversion in plan, disable multiFI
                var isCurrencyConversionInPlan = $scope.checkoutSession && $scope.checkoutSession.plan && $scope.checkoutSession.plan.conversion;

                if (isCurrencyConversionInPlan) {
                    // make the selectedMethod as undefined to avoid showing manage link and to show change link
                    // manage link won't allow buyer to change the FI
                    $scope.selectedmethod = undefined;
                    return false;
                }

                var length = $scope.selectedmethod && $scope.getSortedPlans() && $scope.getSortedPlans().length || 0;

                // If the PPC Acquisition Banner experiment is treatment 1, add banner as an "FI"
                if ($scope.installment && $scope.installment.showPPCAcquisitionRadioButton) {
                    length++;
                }

                return length > 1;
            };

            var setPadToggleEligbiility = function setPadToggleEligbiility() {
                if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    return Experiments.padToggleFeatureSupported().then(function (result) {
                        $scope.padToggleEnabled = result;
                    });
                } else {
                    $scope.padToggleEnabled = false;
                }
            };

            return populateModels().then(function () {
                return _angular.$q.all([_factory4.$SmartAuthFactory.noBalanceExp(), _factory4.$SmartAuthFactory.disallowedBalanceExp(), _factory4.$SmartAuthFactory.subscriptionNoBalanceLegalTextExp()]);
            }).then(function (experiencesResultsArray) {
                var noBalanceExp = experiencesResultsArray[0],
                    disallowedBalanceExp = experiencesResultsArray[1],
                    subscriptionNoBalanceLegaTextExp = experiencesResultsArray[2];

                $scope.disallowedBalance = disallowedBalanceExp.enabled && $scope.checkoutSession.isBalanceDisallowed();

                // Some users won't be eligible for using PayPal Balance
                // We control that by NoBalance experiment in Treatment 1 && user.no_balance === true
                $scope.noBalance = noBalanceExp.enabled && _factory6.$NoBalanceFactory.hasUserPendingBalance();
                $scope.subscriptionNoBalanceLegaText = subscriptionNoBalanceLegaTextExp.enabled;

                var sortedPlans = $scope.getSortedPlans();

                _fiMessages.$fiMessages.isDeclinedCard($scope.checkoutSession);

                return _angular.$q.all([setShowAmount(), setNegativeBalanceData(), setShowBillingAddress(), setCurrencyConversion(), _factory.$ShowMoreFiFactory.decideEligibility({
                    plans: sortedPlans
                }), _factory2.$PreferredCheckboxFactory.decideEligibility({
                    plans: sortedPlans,
                    checkoutCart: $scope.checkoutCart
                }), setPadToggleEligbiility(), _factory3.$RewardsCheckboxFactory.buildCache(), setShowBalanceComprehensionBanner()]).then(function () {
                    if (sortedPlans) {
                        _factory.$ShowMoreFiFactory.init(sortedPlans);
                    }

                    var plans = $scope.checkoutSession.get('fundingOptions.plans') || [];
                    var merchant = $scope.checkoutAppData.merchant;
                    var instrumentsDisallowed = $scope.checkoutSession.get('fundingOptions.disallowedInstruments');
                    var lengthOfDisallowed = instrumentsDisallowed && instrumentsDisallowed.length;

                    $scope.buyerEmail = $scope.checkoutSession.get('payer.email') || '';
                    $scope.isOptionalVaulting = $scope.checkoutCart.billing && $scope.checkoutCart.billing.save_paypal_as_option && _squid.$config.baOptOutEnabledCountries.indexOf(_squid.$locale.country) > -1;
                    var disallowedInPlan = lengthOfDisallowed && instrumentsDisallowed.filter(function (disallowed) {
                        var isBalanceDisallowed = disallowed.type === 'BALANCE' || disallowed.type === 'REWARDS';
                        var isFIinPrimary = plans.find(function (plan) {
                            return plan.primaryFs.id === disallowed.id;
                        });
                        //  for cases where pinlessDebit is disallowed but other form of card transactions are allowed on the card

                        return isBalanceDisallowed || isFIinPrimary;
                    }).length === lengthOfDisallowed;

                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
                    $scope.billPayIntegratorName = $scope.checkoutCart.partnerDetail && $scope.checkoutCart.partnerDetail.businessName;
                    if ($scope.showManageLink && $scope.showManageLink === 'Trmt_xo_hermes_display_disallowed_fi_1') {
                        if (lengthOfDisallowed) {
                            $scope.hideManageLink = disallowedInPlan;
                        } else {
                            $scope.hideManageLink = true;
                        }
                    }

                    _logger.$logger.info('checkout_fpti', {
                        from: 'REVIEW',
                        to: 'prepare_review',
                        mng_wallet_lnk: !$scope.hideManageLink
                    });

                    // add FPTI tracking for CVV field
                    var cvvData = $scope.checkoutSession.cvvData;

                    if (cvvData && !cvvData.lastAddedCard) {
                        _logger.$logger.info('checkout_fpti', {
                            'iscvvshown': 'true'
                        });
                    }

                    var isBilling = $scope.checkoutCart.isBilling();
                    var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
                    var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.merchant.id) > -1;
                    var stickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
                    var isWpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();
                    var isWpsAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();
                    var isWpsInstallmentPlan = $scope.checkoutAppData.is_wps_installmentplan_flow();

                    // Hide 'change' link for sticky disabled merchants
                    $scope.showPayMerchantWithPayPal = isBillingNoPurchase && (disableStickyForMerchant || !stickyInstrument);

                    // Hide 'Pay With' header for NMJ multiple step experience
                    $scope.showPayWithText = !$scope.nmjMultiPage && !$scope.showPayMerchantWithPayPal;
                    $scope.showPreferredLabel = $scope.selectFiVariant && $scope.makeFiPreferred && $scope.checkoutSession.getPlanList() && $scope.checkoutSession.getPlanList().length > 1;

                    var checkoutPlan = $scope.checkoutSession.plan;

                    $scope.canChangeFI = true;
                    if ($scope.showPayMerchantWithPayPal || checkoutPlan.isMSB() || $scope.nmjMultiPage) {
                        $scope.canChangeFI = false;
                    } else if (checkoutPlan.isBalance() && !(0, _squid.$feature)('choiceExperiment')) {
                        // Show the change link always for US, where planning is finished ramping choice.
                        // For other countries, keep old checks until we're sure planning has ramped choice changes there.
                        $scope.canChangeFI = $scope.checkoutSession.plan.hasConversion() || $scope.checkoutSession.fundingOptions.hasECheck() || $scope.checkoutSession.fundingOptions.hasCredit() || Boolean($scope.checkoutSession.getDisallowedPreferred()) || Boolean($scope.checkoutSession.fundingOptions.getPreferred());
                    }

                    // @TODO: Seems we need to check if multiple balances within same plan (primaryFS && secondaryFIs)
                    $scope.hasMultipleBalances = plans && plans.filter(function (p) {
                        return p.primaryFs.type === 'BALANCE';
                    }).length > 1;

                    $scope.gotoWallet = function () {
                        // For choice variant, go to manage wallet instead. Always available
                        if ($scope.selectedmethod) {
                            return _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
                        }

                        if ($scope.canChangeFI) {
                            return _uiRouter.$state.go('checkout.review.sidebar.wallet', { padToggleFeature: $scope.padToggleFeature });
                        }
                    };

                    $scope.bmlSeeTerms = function () {
                        $scope.showBmlPopup();
                    };

                    var currentPlanId = $scope.checkoutSession.plan.id;

                    $scope.isSplitPaymentWithBalanceAndIachPlan = false;

                    if ($scope.padToggleEnabled) {
                        initPadToggleFeatureParams();
                    }

                    // page section changes to show pad toggle tooltip properly
                    if ($scope.padToggleEnabled && $scope.padToggleFeature.applicable) {
                        var checkoutPageSection = angular.element(document.getElementById('sliding-area'));

                        checkoutPageSection.css('overflow', 'visible');
                    }

                    $scope.showPadToggle = function () {
                        var padToggle = false;

                        if ($scope.padToggleEnabled && $scope.padToggleFeature.applicable) {
                            var padToggleForFS = $scope.checkoutSession.fundingOptions.isPadToggleApplicableForFS($scope.checkoutSession.plan.id);
                            var isPadPlan = $scope.checkoutSession.plan.isPAD();

                            $scope.isIachPlan = $scope.checkoutSession.plan.isIACH();
                            if ($scope.isIachPlan && !$scope.isSplitPaymentWithBalanceAndIachPlan) {
                                $scope.isSplitPaymentWithBalanceAndIachPlan = $scope.checkoutSession.plan.isSplitPaymentWithBalanceAndIach();
                            }

                            $scope.padToggleFeature.showCheckbox = padToggleForFS && (isPadPlan || $scope.isIachPlan);

                            if (!padToggleForFS) {
                                setPadStatus(false);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            } else if (currentPlanId !== $scope.checkoutSession.plan.id && !isPadPlan) {
                                setPadStatus(false);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            } else if (currentPlanId !== $scope.checkoutSession.plan.id && isPadPlan) {
                                setPadStatus(true);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            }

                            if ($scope.padToggleFeature.showCheckbox) {
                                padToggle = true;

                                // padToggle is false when split balance and `choice` balance checkbox is selected by user
                                var checkboxBalanceChecked = $scope.choiceBalanceCheckboxState && $scope.choiceBalanceCheckboxState.checkbox;

                                if ($scope.isSplitPaymentWithBalanceAndIachPlan && checkboxBalanceChecked) {
                                    padToggle = false;
                                }
                            }
                        }
                        return padToggle;
                    };

                    $scope.getPadFsContent = function (fs) {
                        return $scope.isPadToggleFeatureApplicable() ? $scope.content('paymentMethod.padToggleFs', { bank: fs.name, last4: fs.last4 }) : $scope.content('paymentMethod.padFs', { bank: fs.name, date: fs.hop_date, last4: fs.last4 });
                    };

                    $scope.updatePlan = function (planId) {
                        currentPlanId = planId;

                        $scope.checkoutSession.fundingOptions.action('select', {
                            data: {
                                planId: planId
                            },
                            success: function success(result) {
                                $scope.checkoutSession.populate(result);
                                if (result) {
                                    // Update the installments to support the user selecting a card that does not support installments.
                                    $scope.checkoutSession.installments = result.installments;
                                }
                            }
                        });
                    };

                    function getBankInstrumentId() {
                        var instrumentId = void 0;

                        if ($scope.isSplitPaymentWithBalanceAndIachPlan) {
                            var iachSource = $scope.checkoutSession.plan.sources.find(function (source) {
                                return source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER';
                            });

                            instrumentId = iachSource && iachSource.instrument_id;
                        } else if ($scope.isIachPlan) {
                            instrumentId = $scope.checkoutSession.plan.sources[0].instrument_id;
                        }
                        return instrumentId;
                    }

                    $scope.multiFiPadToggleCheckboxEvent = function (plan) {
                        setPadStatusForMultiFi(plan);

                        // if pad checkbox is checked for the selected plan
                        if (getMultiFiPadCheckboxState(plan.primaryFs.id)) {
                            logFptiForPadToggle('On');
                        } else {
                            logFptiForPadToggle('Off');
                        }
                    };

                    $scope.padToggleCheckboxEvent = function () {
                        var planId = void 0;

                        // For choice multi FI experience, we want to keep this in sync since this is read on clicking 'Continue' in RYI page
                        // Skip the rest of it though. Doesn't apply for the multiFi variant
                        if ($scope.selectedmethod) {
                            var plan = $scope.checkoutSession.fundingOptions.plans[0];

                            $scope.padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id] = getPadStatus();
                            return $scope.multiFiPadToggleCheckboxEvent(plan);
                        }

                        // if getPadStatus() === true, that means we're currently selecting a PAD plan
                        if (getPadStatus()) {
                            var bankInstrumentId = getBankInstrumentId();

                            planId = $scope.checkoutSession.fundingOptions.getBankPadPlanIdByInstrumentId(bankInstrumentId, 'IACH');
                            logFptiForPadToggle('On');
                        } else {
                            // otherwise we have to find the corresponding IACH plan
                            var padInstrumentId = $scope.checkoutSession.plan.sources[0].instrument_id;

                            planId = $scope.checkoutSession.fundingOptions.getBankPadPlanIdByInstrumentId(padInstrumentId, 'PAD');

                            // when a user intentionally un-check the PayPal balance from choice view
                            var isChoiceBalanceUnchecked = $scope.choiceBalanceCheckboxState.checkbox !== undefined && $scope.choiceBalanceCheckboxState.checkbox === false;

                            if (isChoiceBalanceUnchecked) {
                                // find a IACH plan without a balance
                                var iachPlanWithoutBalance = $scope.checkoutSession.fundingOptions.plans.find(function (p) {
                                    return (p.primaryFs && p.primaryFs.id) === padInstrumentId && $scope.checkoutSession.fundingOptions.isIACH(p) && !p.secondaryFIs;
                                });

                                if (iachPlanWithoutBalance) {
                                    planId = iachPlanWithoutBalance.planId;
                                }
                            }
                            logFptiForPadToggle('Off');
                        }

                        return $scope.updatePlan(planId);
                    };

                    var processAllLoadedPadToggle = function processAllLoadedPadToggle() {
                        if ($scope.padToggleEnabled && $scope.showPadToggle()) {
                            // To remove focus from checkbox so that focus style is not applied
                            if (getPadStatus()) {
                                var section = document.querySelector('#padToggleHelp');

                                if (section) {
                                    section.focus();
                                    section.blur();
                                }
                            }
                            // fpti logging
                            if (!$scope.padToggleFeature.fptiLogged) {
                                if (getPadStatus()) {
                                    _logger.$logger.info('pad_toggle_on_feature_shown');
                                    logFptiForPadToggle('OnShown');
                                } else {
                                    _logger.$logger.info('pad_toggle_off_feature_shown');
                                    logFptiForPadToggle('OffShown');
                                }

                                $scope.padToggleFeature.fptiLogged = true;
                            }
                        }
                    };

                    var handleAllLoadedForPadToggle = _angular.$rootScope.$on('allLoaded', processAllLoadedPadToggle);

                    $scope.$on('$destroy', handleAllLoadedForPadToggle);

                    var stickyEligible = isBilling && !disableStickyForMerchant;

                    // save sticky decision - to be used in the app and other components
                    _squid.$config.features.DEFAULT.enableStickyFunding = stickyEligible;
                    $scope.getPlanList = function (n) {
                        // with purchase - always use plan
                        var sources = $scope.checkoutSession.plan.sources || [];
                        var planList = stickyEligible && isBillingNoPurchase ? $scope.checkoutSession.getSelectedStickyInstrument() && [$scope.checkoutSession.getSelectedStickyInstrument()] : sources.filter(function (instrument) {
                            return instrument.type !== 'REWARDS';
                        });

                        $scope.showUachFeatureDiscalimer = false;

                        // required to display direct debit agreement to AU buyers with unconfirmed bank as payment mode
                        angular.forEach(planList, function (plan) {
                            // display uach - direct debit agreement for AU as of July 1st, 2015
                            if (plan && plan.type === 'BANK_ACCOUNT' && plan.unconfirmed_bank && (0, _squid.$feature)('directDebitAgreement', false, plan.country_code)) {
                                $scope.showUachFeatureDiscalimer = true;
                            }
                        });

                        if (!n) {
                            return planList;
                        } else {
                            return planList.slice(0, n);
                        }
                    };

                    $scope.showBackupPlan = function (plan) {
                        return plan.backup && !(stickyEligible && isBillingNoPurchase) && !$scope.hideBackupLabel;
                    };

                    var isRP = void 0;
                    var isSubscriptionsV1 = void 0;

                    if (isBilling) {
                        isRP = $scope.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
                        isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();
                    }

                    $scope.showRpBaText = isRP || isWpsSubscription;
                    $scope.showInstallmentPlanBaText = $scope.checkoutCart.isBilling() && isWpsInstallmentPlan;
                    $scope.showSubscriptionsV1BaText = isSubscriptionsV1 || isWpsAutobilling;

                    // Show expanded Variant of Text
                    $scope.showExpandedText = function () {
                        $scope.isExpandedAgreementText = true;
                    };

                    // CIB BA text in case of BalanceComprehensionBanner has no expanded or collapsed variant
                    if (_squid.$locale.country === 'US' || _squid.$locale.country === 'IN' || Experiments.balanceComprehensionBannerExperiment.bannerDisplayed()) {
                        $scope.isExpandedAgreementText = true;
                    }

                    $scope.showMibBAText = function () {
                        return $scope.checkoutCart.isBilling() && !$scope.isCIB && !$scope.showRpBaText && !isWpsInstallmentPlan && !isWpsAutobilling && !isSubscriptionsV1 && !$scope.isOptionalVaulting;
                    };

                    $scope.getBAContent = function () {
                        var consentCode = $scope.checkoutCart.billing.consent_code;
                        var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';
                        var stickyFI = $scope.checkoutSession.getSelectedStickyInstrument();
                        var stickyOrNoStickyText = stickyEligible && stickyFI ? 'FiSticky' : 'NoFiSticky';
                        var expandedOrCollapsedText = $scope.isExpandedAgreementText === true ? 'Expanded' : 'Collapsed';
                        var isIndiaDomestic = _squid.$locale.country === 'IN' && _squid.$locale.country === $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                        var indiaDomestic = isIndiaDomestic ? 'Domestic' : '';
                        var isPaymentServiceActApplied = _squid.$locale.country === 'SG'; // Singapore Payment Service Act
                        var isBillPayConsent = consentCode === BILL_PAY_CONSENT; // Validation for billpay model 3 flow
                        var contentKey = void 0;

                        if (consentCode) {
                            if (isBillPayConsent) {
                                contentKey = 'enterpriseAgreement.' + consentCode + 'MIBWith' + (stickyEligible && stickyFI ? '' : 'No') + 'BalanceChoice';
                            } else {
                                contentKey = 'enterpriseAgreement.' + consentCode + (stickyEligible && stickyFI ? '' : 'No') + 'FiStickyConsent';
                            }
                        } else if ($scope.noBalance || $scope.disallowedBalance) {
                            return 'billingAgreement.noBalanceMemberAgreement';
                        } else {
                            contentKey = 'billingAgreement.';

                            $scope.isCIB = $scope.checkoutCart.billing.type === 'CHANNEL_INITIATED_BILLING';

                            if ($scope.isCIB) {
                                if (Experiments.balanceComprehensionBannerExperiment.bannerDisplayed() && !isIndiaDomestic) {
                                    contentKey = 'enterpriseAgreement.prepaidCIB' + stickyOrNoStickyText + 'Consent';
                                } else {
                                    contentKey += 'memberAgreementCib' + stickyOrNoStickyText + useraction + expandedOrCollapsedText;
                                }
                            } else if (Experiments.balanceComprehensionBannerExperiment.bannerDisplayed() && !isIndiaDomestic) {
                                contentKey = 'billingAgreement.memberAgreementMibWithBalanceUsageInfo';
                            } else {
                                contentKey += 'memberAgreement' + stickyOrNoStickyText + indiaDomestic + useraction;
                            }
                            // content change for review page start
                            if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                                if ($scope.isCIB) {
                                    contentKey = 'billingAgreement.rtCib';
                                } else if ($scope.checkoutAppData.isMerchantCountry('IN')) {
                                    if ($scope.checkoutCart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow()) {
                                        contentKey = 'billingAgreement.rp';
                                    } else {
                                        contentKey = 'billingAgreement.rt';
                                    }
                                } else {
                                    contentKey = 'billingAgreement.rp';
                                }
                            }
                            // Below condition must be at the bottom to overwrite above key specific to the singapore psa compliance.
                            if (isPaymentServiceActApplied && $scope.checkoutCart.isBilling()) {
                                var billingType = $scope.isCIB ? 'Cib' : 'Mib';

                                contentKey = 'billingAgreement.memberAgreement' + billingType + 'SG' + useraction;
                            }
                            // content change for review page end
                        }
                        var showBAContent = $scope.checkoutCart.billing && !$scope.showRpBaText && !$scope.showSubscriptionsV1BaText;

                        if (showBAContent && !_squid.$locale.content.get(contentKey)) {
                            _logger.$logger.error('BA consent not displayed', { contentKey: contentKey });
                            _uiRouter.$state.go('checkout.genericError');
                        }
                        return contentKey;
                    };

                    $scope.getRPContent = function () {
                        if ($scope.noBalance || $scope.disallowedBalance || $scope.subscriptionNoBalanceLegaText) {
                            return 'billingAgreement.noBalanceMemberAgreement';
                        }

                        var contentKey = 'billingAgreement.';
                        var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';

                        if (stickyEligible && $scope.checkoutSession.getSelectedStickyInstrument()) {
                            contentKey += 'rpAgreementFiSticky' + useraction;
                        } else {
                            contentKey += 'rpAgreementNoFiSticky' + useraction;
                        }

                        if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                            if ($scope.checkoutCart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow()) {
                                contentKey = 'billingAgreement.rp';
                            }
                        }

                        var showRPContent = $scope.checkoutCart.billing && $scope.showRpBaText;

                        if (showRPContent && !_squid.$locale.content.get(contentKey)) {
                            _logger.$logger.error('RP consent not displayed', { contentKey: contentKey });
                            _uiRouter.$state.go('checkout.genericError');
                        }
                        return contentKey;
                    };

                    $scope.getSubscriptionsV1BaText = function () {
                        if ($scope.noBalance || $scope.disallowedBalance || $scope.subscriptionNoBalanceLegaText) {
                            return 'billingAgreement.noBalanceMemberAgreement';
                        }

                        var contentKey = 'billingAgreement.';
                        var hasStickyFI = stickyEligible && $scope.checkoutSession.getSelectedStickyInstrument();
                        var stickyOrNoStickyText = hasStickyFI ? 'FiSticky' : 'NoFiSticky';
                        var isIndiaDomestic = _squid.$locale.country === 'IN' && _squid.$locale.country === $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                        var indiaDomestic = isIndiaDomestic ? 'Domestic' : '';
                        var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';

                        contentKey += 'memberAgreement' + stickyOrNoStickyText + indiaDomestic + useraction;

                        if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                            if ($scope.checkoutCart.isSubscriptionsV1()) {
                                contentKey = 'billingAgreement.rp';
                            }
                        }
                        var showSubscriptionsV1Content = $scope.checkoutCart.billing && $scope.showSubscriptionsV1BaText;

                        if (showSubscriptionsV1Content && !_squid.$locale.content.get(contentKey)) {
                            _logger.$logger.error('subscriptions V1 consent not displayed', { contentKey: contentKey });
                            _uiRouter.$state.go('checkout.genericError');
                        }
                        return contentKey;
                    };

                    $scope.getStickyFiName = function () {
                        var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrumentForDisclaimer();

                        return stickyEligible && selectedStickyInstrument;
                    };

                    $scope.getStickyFiLast4 = function () {
                        var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();

                        return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.last4 && 'x-' + selectedStickyInstrument.last4;
                    };

                    // Choice Experiment
                    // Preferred checkbox for single FI variants should only be shown if:
                    $scope.showSinglePreferred = function () {
                        return _factory2.$PreferredCheckboxFactory.isSinglePreferredCheckboxEligible({ plans: $scope.getSortedPlans() });
                    };

                    $scope.showPreferredCheckbox = function (plan) {
                        if ($scope.checkoutCart.referenceCheckout) {
                            return false;
                        }
                        return _factory2.$PreferredCheckboxFactory.showPreferredCheckbox(plan, $scope.checkoutSession.fundingOptions);
                    };

                    // Update selectedmethod to call update on checkout session later
                    $scope.updateFS = function (fundingsource, index) {
                        $scope.selectedmethod.planId = fundingsource.planId;
                        $scope.selectedmethod.index = index;

                        if ($scope.makeFiPreferred) {
                            $scope.makeFiPreferred.selected = false;
                        }

                        $scope.checkoutSession.cardBackup.resetIfDoesNotApply(fundingsource);
                        setPadStatusForMultiFi(fundingsource);

                        // update the fundingoptions with the selected FI so user checks out with the
                        // right FI on RYI page.
                        var prevSelectedPlan = $scope.checkoutSession.fundingOptions.instruments.find(function (fi) {
                            return fi.selected === true;
                        });

                        // the DE member flow uses a dummy FI inside the RYI page not listed
                        // inside $scope.checkoutSession.fundingOptions.instruments;
                        // prevSelectedPlan will be undefined in that case
                        $scope.checkoutSession.fundingOptions.instruments.forEach(function (fi) {
                            if (fi.planId === fundingsource.planId) {
                                fi.selected = true;
                            } else if (prevSelectedPlan && fi.planId === prevSelectedPlan.planId) {
                                fi.selected = false;
                            }
                        });
                    };

                    $scope.isBillingNoCards = function () {
                        if ($scope.checkoutCart.isBillingNoPurchase()) {
                            var emptyPlan = $scope.checkoutSession.futurePaymentInstruments && $scope.checkoutSession.futurePaymentInstruments.length === 0;

                            if ($scope.checkoutAppData.flags.allow_billing_agreement_without_bufs && emptyPlan) {
                                $scope.canChangeFI = false;
                                $scope.showEmptyPlanHeader = true;
                                _logger.$logger.info('BA_nocards_toggle_on_and_empty_plan');
                                return true;
                            }
                        }
                        return false;
                    };

                    $scope.showPPCAcquisitionRadioButton = function () {
                        return $scope.installment && $scope.installment.showPPCAcquisitionRadioButton;
                    };

                    $scope.selectApplyForPPC = function () {
                        return $scope.updateFS({
                            planId: 'applyForPPCRadio'
                        });
                    };

                    $scope.showConversionOptions = function () {
                        if (_factory5.$CurrencyConversionFactory.getConversionOverlayFlag()) {
                            _angular.$rootScope.$broadcast('$showConversionOverlay');
                        } else {
                            return _uiRouter.$state.go('checkout.review.sidebar.currencyConversion');
                        }
                    };
                });
            });
        }]
    };
});

_logger.$logger;

_pxp.$pxpCartAmt;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutPayeeModel;

_fiMessages.$fiMessages;

_squid.formatCurrency;

_squid.$config;

_squid.$feature;

_squid.$populate;

_squid.$locale;

_squid.$renderContent;

_uiRouter.$state;

_angular.$registerDirective;

_angular.$rootScope;

_angular.$q;

_factory.$ShowMoreFiFactory;

_factory2.$PreferredCheckboxFactory;

_factory3.$RewardsCheckboxFactory;

_factory4.$SmartAuthFactory;

_factory5.$CurrencyConversionFactory;

_index3.$CreditSharedInfoModel;

_factory6.$NoBalanceFactory;

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SmartAuthFactory', function () {

    var isAuthRequired = function isAuthRequired(fs) {
        return fs.constraint;
    };

    var getConstraintAmount = function getConstraintAmount(fs) {
        var constraint = fs.constraint;

        return (0, _squid.formatCurrency)(constraint.amount.value, constraint.amount.currency, false);
    };

    var disallowedManageLinkExp = function disallowedManageLinkExp() {
        return (0, _squid.$elmo)('xo_hermes_display_disallowed_fi', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermes_display_disallowed_fi_1').then(function (result) {
            return result && result.treatment_name;
        });
    };

    // Experiment that controls if user can or cannot use PayPal Balance as an FI
    // We use it to display the correct consent texts
    var noBalanceExp = function noBalanceExp() {
        return (0, _squid.$elmo)('xo_hermes_no_balance_agreement', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_no_balance_agreement_1').then(function (result) {
            return { enabled: Boolean(result && result.treatment_name) };
        });
    };

    // Experiment that controls if user has the disallowed balance use case
    // where the same consent content as no balance will be displayed
    var disallowedBalanceExp = function disallowedBalanceExp() {
        return (0, _squid.$elmo)('xo_hermesnodeweb_disallowed_balance', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_FEATURE_HERMES_DISALLOWED_BALANCE').then(function (result) {
            return { enabled: Boolean(result && result.treatment_name) };
        });
    };

    var subscriptionNoBalanceLegalTextExp = function subscriptionNoBalanceLegalTextExp() {
        return (0, _squid.$elmo)('xo_hermes_subs_no_balance_legal_text', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_subs_no_balance_legal_text').then(function (result) {
            return { enabled: Boolean(result && result.treatment_name) };
        });
    };

    return {
        isAuthRequired: isAuthRequired,
        getConstraintAmount: getConstraintAmount,
        disallowedManageLinkExp: disallowedManageLinkExp,
        disallowedBalanceExp: disallowedBalanceExp,
        noBalanceExp: noBalanceExp,
        subscriptionNoBalanceLegalTextExp: subscriptionNoBalanceLegalTextExp
    };
});

_squid.formatCurrency;

_squid.$elmo;

_squid.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/review-paywith", "../node_modules/xo-member-components/src/review-paywith/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView\" content>\n    <div class=\"trayInner trayInnerDefault\" ng-class=\"{installments:(checkoutSession.installments.length > 1)}\">\n        <div id=\"paymentMethod\">\n            <div ng-click=\"gotoWallet()\" ng-if=\"!showMultipleFi() && !isBillingNoCards()\" focusable=\"canChangeFI || selectedmethod\" ng-class=\"{editable:canChangeFI || selectedmethod}\" class=\"focusable singleFi\">\n                <h2 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"isPadToggleFeatureApplicable()\">\n                        {{ content('paymentMethod.payWith') }}\n                    </span>\n                    <span ng-if=\"!isPadToggleFeatureApplicable()\">\n                        <span ng-if=\"checkoutSession.plan.isPAD()\">\n                        {{ content('paymentMethod.payAfter') }}\n                        </span>\n                        <span ng-if=\"!checkoutSession.plan.isPAD()\">\n                            <span ng-if=\"showPayMerchantWithPayPal\">\n                                {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                            </span>\n                            <span ng-if=\"showPayWithText\">\n                                {{ content('paymentMethod.payWith') }}\n                            </span>\n                        </span>\n                    </span>\n                </h2>\n                <experience flag='!cardart' class='noCardArt'>\n                    <ul class=\"charges\" data-test-id=\"fundingInstruments\">\n                        <li ng-repeat=\"fs in getPlanList() track by $index\" class=\"clearfix fs\" data-test-id=\"listedFIElement\" ng-if=\"fs.amount.doubleValue !== 0\">\n                            <div ng-class=\"['method', fs.type, fs.sub_type, fs.card_type]\">\n                                <!-- xo-fi-icon fi=\"fs\" class-name=\"fsIcons\"></xo-fi-icon -->\n                                <span class=\"fsIcons\" ng-class=\"{'BILL_ME_LATER_DE': isDEInstallmentsFI(fs)}\" ng-if=\"!fs.is_pinless_debit\"></span>\n                                <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                                <span class=\"name\">\n                                    <span ng-if=\"fs.type === 'PPCREDIT'\">\n                                        {{ content('paymentMethod.billmelater') }}\n                                    </span>\n                                    <span ng-if=\"fs.sub_type === 'DELAYED_TRANSFER' && !isPadToggleFeatureApplicable()\" ng-bind-html=\"htmlContent('paymentMethod.padFs', {bank: fs.name, date: fs.hop_date, last4: fs.last4})\">\n                                    </span>\n                                    <span ng-if=\"fs.sub_type === 'DELAYED_TRANSFER' && isPadToggleFeatureApplicable()\" ng-bind-html=\"htmlContent('paymentMethod.padToggleFs', {bank: fs.name, last4: fs.last4})\">\n                                    </span>\n                                    <span ng-if=\"fs.type === 'INCENTIVE'\">\n                                        {{ content('paymentMethod.msbOffer') }}\n                                    </span>\n                                    <span class=\"forceRTL\" data-test-id=\"balanceFI\" ng-if=\"fs.type === 'BALANCE'\">\n                                        {{ content(!showBalanceRebranded ? 'paymentMethod.paypalBalance' : 'paymentMethod.paypalBalanceRebranded') }}\n                                    </span>\n                                    <span ng-if=\"fs.type === 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                        {{ content('fsMappings.PAYPAL_EXTRAS_MASTERCARD') }}\n                                    </span>\n                                    <span ng-if=\"fs.type !== 'PPCREDIT' && fs.type !== 'INCENTIVE' && fs.type !== 'BALANCE' && fs.sub_type !== 'DELAYED_TRANSFER' && fs.type !== 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                        <span class=\"fsNamePinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                            {{ content('paymentMethod.pinlessDebit') }}\n                                        </span>\n                                        <span ng-if=\"isDEInstallmentsFI(fs)\">\n                                            {{ content('fsMappings.PAYPAL_INSTALLMENTS') }}\n                                        </span>\n                                        <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit && !isDEInstallmentsFI(fs)\">\n                                            {{fs.name}}\n                                        </span>\n                                        <div ng-if=\"showInstallmentDetailsSecondLine(fs)\" class=\"fsInstallmentDetails\">\n                                            {{ content('paymentMethod.installmentDetails',\n                                                    {\n                                                        amount: formatCurrency(installment.financing_details.total_cost, installment.financing_details.currency),\n                                                        term: installment.financing_details.term\n                                                    })\n                                            }}\n                                        </div>\n                                        <span ng-if=\"fs.type === 'ECHECK'\">{{ content('paymentMethod.eCheck') }}</span>\n                                        <span class=\"fsLastDigitsPinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                            {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                        </span>\n                                        <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                            {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                        </span>\n                                        <span ng-if=\"countryCode === 'DE'\">\n                                            <span ng-if=\"fs.sub_type === 'MEFT'\">\n                                                {{ content('paymentMethod.meft') }}\n                                            </span>\n                                            <span ng-if=\"fs.sub_type === 'IACH'\">\n                                                {{ content('paymentMethod.iach') }}\n                                            </span>\n                                            <span ng-if=\"fs.sub_type === 'INSTANT_TRANSFER' && fs.type === 'BANK'\">\n                                                {{ content('paymentMethod.instantTransfer') }}\n                                            </span>\n                                        </span>\n                                    </span>\n                                    <span ng-if=\"showPreferredLabelForSingleFi(fs)\" class=\"preferredLabel\">\n                                        <br>\n                                        {{ content('memberReview.preferred') }}\n                                    </span>\n                                    <div ng-if=\"fs.isBillingPreferred\" class=\"billingPreferredLabel\">{{ content('fundingInstruments.billingPreferredFi', {merchantName: merchant}) }}</div>\n                                    <span ng-if=\"fs.gotDeclined\" class=\"gotDeclinedMessage\">\n                                        {{ content('wallet.processorDeclinedCard') }}\n                                    </span>\n                                </span>\n                                <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(checkoutSession.plan)\">\n                                    <div ng-if=\"!isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).secondLineText\"></span>\n                                    </div>\n                                    <div ng-if=\"isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).rewardsAvailble\"></span>\n                                    </div>\n                                </div>\n                                <span ng-if=\"showCreditPlacement(fs)\">\n                                    <xo-credit-offer-banners token=\"token\" reusetext='true'/>\n                                </span>\n                                <p class=\"msbHelpText secondary\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                    {{ content('paymentMethod.msbHelpText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)})}}\n\n                                    <a class=\"msbDetails\" id=\"msb_{{$index}}\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                                </p>\n\n                                <xo-tooltip ng-if=\"fs.type === 'INCENTIVE'\" trigger=\"#msb_{{$index}}\" show-event=\"click\" hide-event=\"mouseleave\" ng-click=\"$event.stopPropagation()\">\n                                    <div class=\"tip tipDesc\">\n                                        <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n                                        <div class=\"msbToolTipDescription\">\n                                            <p ng-if=\"fs.minPurchaseAmount\">\n                                                {{ content('paymentMethod.msbToolTipText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code), minimumPurchase:fs.minPurchaseAmount})\n                                                }}\n                                            </p>\n                                            <p ng-if=\"!fs.minPurchaseAmount\">\n                                                {{ content('paymentMethod.msbToolTipText2', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)}) }}\n                                            </p>\n                                            <p>\n                                            </p>\n                                        </div>\n                                    </div>\n                                </xo-tooltip>\n\n                                <xo-tooltip class=\"tip tipHint padHelpToolTip\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\"\n                                            trigger=\"#padHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                    <div class=\"tipText tipHintText\">\n                                        <p class=\"padHeader\">\n                                            {{content('paymentMethod.padHelpTxt')}}\n                                        </p>\n                                        <ul class=\"bul\">\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList1', {date: fs.hop_date, country: locale.country, lang: locale.lang})\"></span>\n                                            </li>\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList2', {country: locale.country, lang: locale.lang})\"></span>\n                                            </li>\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList3')\"></span>\n                                            </li>\n                                        </ul>\n                                        <p>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padTnc', {country: locale.country, lang: locale.lang})\"></span>\n                                        </p>\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                            <span ng-if=\"showAmt && !(checkoutSession.installments.length > 1) && !isDEInstallmentsFI(fs)\" class=\"methodAmount\">\n                                <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                            </span>\n                            <span ng-if=\"isDEInstallmentsFI(fs) && showInstallmentDetailsSecondLine(fs)\">\n                                <span class=\"monthlyAmountFormatted\"><format-currency code=\"installment.financing_details.currency\" amount=\"installment.financing_details.monthly_payment\"></format-currency></span>\n                                <span class=\"installmentsIntervalText\">{{content('paymentMethod.monthlyInterval')}}*</span>\n                            </span>\n                            <div ng-if=\"smartAuthFactory.isAuthRequired(fs)\" class=\"smartauthbanner\">\n                                <div class=\"smartauthinfobanner\"><span class=\"smartauthinfologo\" ></span></div>\n                                <div class=\"smartauthtext\" ng-bind-html=\"htmlContent('billingAgreement.smartDollarAuthText', {amountInPayerCurrency: smartAuthFactory.getConstraintAmount(fs)})\"></div>\n                            </div>\n                        </li>\n                        <li class=\"singleFiBackupComponent\" ng-if=\"showBackupPlan(checkoutSession.plan)\">\n                            <xo-backup-label plan=\"checkoutSession.plan\"></xo-backup-label>\n                        </li>\n                        <li ng-if=\"showSinglePreferred() && showPreferredCheckbox(checkoutSession.fundingOptions.plans[0])\" stop-propagation tabindex=\"-1\">\n                            <xo-preferred-checkbox\n                                make-fi-preferred=\"makeFiPreferred\"\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                cardart=\"false\">\n                            </xo-preferred-checkbox>\n                        </li>\n                        <li stop-propagation\n                            ng-if=\"hasRewards(checkoutSession.fundingOptions.plans[0])\">\n                            <!-- Choice use case -->\n                            <xo-rewards-checkbox\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                selectedmethod= \"selectedmethod\"\n                                cardart=\"false\">\n                            </xo-rewards-checkbox>\n                        </li>\n                        <li ng-if=\"(checkoutSession.installments.length > 1)\" ng-click=\"$event.stopPropagation()\">\n                            <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallments btn btn-secondary\" ng-class=\"{getInstallmentsError: installmentNotSelected && !checkoutSession.selectedInstallmentData}\">\n                                <span ng-if=\"checkoutSession.selectedInstallmentData\">{{checkoutSession.selectedInstallmentData.term}}X {{content('paymentMethod.of')}} {{checkoutSession.selectedInstallmentData.monthly_payment.formatted_value}}</span>\n                                <span ng-if=\"!checkoutSession.selectedInstallmentData\">{{content('paymentMethod.changeInstallmentLink') }}</span>\n                                <span class=\"raq\"></span>\n                            </a>\n                        </li>\n                        <li ng-repeat=\"fs in checkoutSession.plan.sources track by $index\" class=\"clearfix\" ng-if=\"fs.sub_type === 'ECHECK' || (countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER')\">\n                            <span class=\"disclaimer\" ng-if=\"fs.sub_type === 'ECHECK'\">\n                                {{ content('paymentMethod.eCheckDescription') }}\n                            </span>\n                            <span class=\"disclaimer\" ng-if=\"countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER'\">\n                                <a id=\"pad_details\">{{ content('paymentMethod.payAfterDeliveryDetails') }}</a>\n                                <xo-tooltip trigger=\"#pad_details\" on-events=\"click\">\n                                    <div class=\"tip tipDesc\">\n                                        {{ content('paymentMethod.padHelpTxt', {date: fs.HOPDate}) }}\n                                        {{ content('paymentMethod.padHelpTxtList') }}\n                                    </div>\n                                </xo-tooltip>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt && negBals\" class=\"nbr-line fsicon-margin\">\n                            <span ng-bind-html=\"content('memberReview.nbrMerchantCut', { merchantName: merchant })\"></span>&rlm;:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\" amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt\" ng-repeat=\"nb in negBals track by $index\" class=\"nbr-line fsicon-margin\">\n                            {{ content('memberReview.nbrPaypalCut') }}:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"nb.currency_code\" amount=\"nb.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"checkoutSession.cvvData && !checkoutSession.cvvData.lastAddedCard\" class=\"clearfix reviewEnterCvvContainer\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div class=\"reviewEnterCvv\">\n                                <span class=\"enterCvvPrompt\">{{ content('memberReview.enterCSC') }}</span>\n                                <xo-cvv card=\"checkoutSession.cvvData\" show-label=\"false\"></xo-cvv>\n                            </div>\n                        </li>\n\n                        <li id=\"currencyConversion\" class=\"conversion\" ng-if=\"checkoutSession.plan.conversion\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal && !isCountryHU\">\n                                <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n                                <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                            </div>\n\n                              <!-- New compliance content for country Hungary (HU)  -->\n                            <div ng-if=\"checkoutSession.plan.conversion && isCountryHU\" class=\"compliance-container\">\n                                <div class=\"align-left\">\n                                    <p class=\"conversionRateLabel\" ng-class=\"{bold: complianceContent.fromPayPal}\" ng-if=\"complianceContent.conversionRateLabel\" ng-bind-html=\"complianceContent.conversionRateLabel\"></p>\n                                    <p class=\"conversionRate\" ng-if=\"complianceContent.conversionRate\">{{ complianceContent.conversionRate }}</p>\n                                    <a class=\"chooseLink\"\n                                        ng-if=\"checkoutSession.plan.conversion.changeable\" ng-click=\"showConversionOptions()\"\n                                        focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                        ng-bind=\"complianceContent.chooseLink\">\n                                    </a>\n                                </div>\n                                <div class=\"align-right\">\n                                    <strong ng-if=\"complianceContent.amount.value\">{{ complianceContent.amount.value }}</strong>\n                                    <span ng-if=\"complianceContent.amount.currencyCode\">{{ complianceContent.amount.currencyCode }}</span>\n                                </div>\n                            </div>\n\n                            <div ng-if=\"!checkoutSession.plan.conversion.paypal && !isCountryHU\" class=\"conversionIssuerDisclaimer\">\n                                {{content('currencyOptions.issuerFeesDisclaimer')}}\n                            </div>\n\n                            <a id=\"conversionLink\" ng-if=\"checkoutSession.plan.conversion.changeable && !isCountryHU\" ng-click=\"showConversionOptions()\"\n                                focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                ng-bind=\"content('currencyOptions.viewConversion')\">\n                            </a>\n\n                            <!-- 72 hours FX compliance content for AS1/AS2  -->\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal && displayASContent\">\n                                <p class=\"foreignExchangeRate\">\n                                    {{content('currencyOptions.foreignExchangeRate')}}\n                                </p>\n                                <a class=\"why\" ng-click=\"isCollapsed = !isCollapsed\" role=\"button\">\n                                    {{content('currencyOptions.why72hours')}}\n                                    <span class=\"icon\" ng-class=\"{down: !isCollapsed, up: isCollapsed}\"></span>\n                                </a>\n                                <p class=\"reason\" ng-show=\"isCollapsed\">\n                                    {{content('currencyOptions.reason72hours')}}\n                                </p>\n                            </div>\n                            <div ng-if=\"setBufsDisclosureContent()\" class=\"bufs-disclosure\" ng-bind-html=\"bufsDisclosureText\"></div>\n                        </li>\n                    </ul>\n                </experience>\n\n                <experience flag='cardart' class='cardArt'>\n                    <div class=\"charges\">\n                        <li ng-repeat=\"fs in getPlanList() track by $index\" class=\"clearfix fs\" ng-if=\"fs.amount.doubleValue !== 0\">\n                            <xo-fi-panel fi=\"fs\"\n                                show-amount=\"showAmt && !(checkoutSession.installments.length > 1) && !balanceWithRewards(fs)\"\n                                name-override=\"\n                                    (fs.sub_type === 'DELAYED_TRANSFER' && getPadFsContent(fs)) ||\n                                    (showBalanceRebranded && fs.type === 'BALANCE' && content('paymentMethod.paypalBalanceRebranded'))\"\n                                show-currency-code=\"plan.primaryFs.type === 'BALANCE' && hasMultipleBalances\"\n                                >\n                                <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(checkoutSession.plan)\">\n                                    <div ng-if=\"!isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).secondLineText\"></span>\n                                    </div>\n                                    <div ng-if=\"isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).rewardsAvailble\"></span>\n                                    </div>\n                                </div>\n                                <!-- See Terms link on the review page of hermes -->\n                                <span ng-if=\"showCreditPlacement(fs)\">\n                                    <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n                                </span>\n\n                                <p class=\"msbHelpText secondary\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                    {{ content('paymentMethod.msbHelpText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)})}}\n                                    <a class=\"msbDetails\" id=\"msb_{{$index}}\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                                </p>\n\n                                <xo-backup-label\n                                    ng-if=\"fs.type === 'BANK_ACCOUNT' && showBackupPlan(checkoutSession.plan)\"\n                                    plan=\"checkoutSession.plan\"\n                                    has-mask=\"true\"\n                                >\n                                </xo-backup-label>\n\n                                <div ng-if=\"fs.is_preferred && makeFiPreferred\">\n                                    <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                </div>\n                                <div ng-if=\"fs.gotDeclined\" class=\"gotDeclinedMessage\">\n                                    <span>{{ content('wallet.processorDeclinedCard') }}</span>\n                                </div>\n                            </xo-fi-panel>\n                            <xo-tooltip ng-if=\"fs.type === 'INCENTIVE'\" trigger=\"#msb_{{$index}}\" show-event=\"click\" hide-event=\"click\" ng-click=\"$event.stopPropagation()\">\n                                <div class=\"tip tipDesc\">\n                                    <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n                                    <div class=\"msbToolTipDescription\">\n                                        <p ng-if=\"fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code), minimumPurchase:fs.minPurchaseAmount}) }}\n                                        </p>\n                                        <p ng-if=\"!fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText2', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)}) }}\n                                        </p>\n                                        <p>\n                                        </p>\n                                    </div>\n                                </div>\n                            </xo-tooltip>\n                            <xo-tooltip class=\"tip tipHint padHelpToolTip\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\"\n                                        trigger=\"#padHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                <div class=\"tipText tipHintText\">\n                                    <p class=\"padHeader\">\n                                        {{content('paymentMethod.padHelpTxt')}}\n                                    </p>\n                                    <ul class=\"bul\">\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList1', {date: fs.hop_date, country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList2', {country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList3')\"></span>\n                                        </li>\n                                    </ul>\n                                    <p>\n                                        <span ng-bind-html=\"htmlContent('paymentMethod.padTnc', {country: locale.country, lang: locale.lang})\"></span>\n                                    </p>\n                                </div>\n                            </xo-tooltip>\n                            <div ng-if=\"smartAuthFactory.isAuthRequired(fs)\" class=\"smartauthbanner\">\n                                <div class=\"smartauthinfobanner\"><span class=\"smartauthinfologo\" ></span></div>\n                                <div class=\"smartauthtext\" ng-bind-html=\"htmlContent('billingAgreement.smartDollarAuthText', {amountInPayerCurrency: smartAuthFactory.getConstraintAmount(fs)})\"></div>\n                            </div>\n                        </li>\n                        <div ng-if=\"showSinglePreferred() && showPreferredCheckbox(checkoutSession.fundingOptions.plans[0])\" stop-propagation tabindex=\"-1\">\n                            <xo-preferred-checkbox\n                                make-fi-preferred=\"makeFiPreferred\"\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                cardart=\"true\">\n                            </xo-preferred-checkbox>\n                        </div>\n                        <xo-rewards-checkbox stop-propagation\n                                             ng-if=\"hasRewards(checkoutSession.fundingOptions.plans[0])\"\n                                             plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                             selectedmethod= \"selectedmethod\"\n                                             cardart=\"true\">\n                        </xo-rewards-checkbox>\n                        <div ng-if=\"(checkoutSession.installments.length > 1)\" ng-click=\"$event.stopPropagation()\">\n                            <div ng-if=\"!installmentNotSelected || checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallments btn btn-secondary\">\n                                    <span ng-if=\"checkoutSession.selectedInstallmentData\">{{checkoutSession.selectedInstallmentData.term}}X {{content('paymentMethod.of')}} {{checkoutSession.selectedInstallmentData.monthly_payment.formatted_value}}</span>\n                                    <span ng-if=\"!checkoutSession.selectedInstallmentData\">{{content('paymentMethod.changeInstallmentLink') }}</span>\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n\n                            <div ng-if=\"installmentNotSelected && !checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallmentsError btn btn-secondary\">\n                                    {{content('paymentMethod.changeInstallmentLink') }}\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n                        </div>\n                        <li ng-if=\"showAmt && negBals\" class=\"nbr-line fsicon-margin\">\n                            <span ng-bind-html=\"content('memberReview.nbrMerchantCut', { merchantName: merchant })\"></span>:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\" amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt\" ng-repeat=\"nb in negBals track by $index\" class=\"nbr-line fsicon-margin\">\n                            {{ content('memberReview.nbrPaypalCut') }}:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"nb.currency_code\" amount=\"nb.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"checkoutSession.cvvData && !checkoutSession.cvvData.lastAddedCard\" class=\"clearfix reviewEnterCvvContainer\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div class=\"reviewEnterCvv\">\n                                <span class=\"enterCvvPrompt\">{{ content('memberReview.enterCSC') }}</span>\n                                <xo-cvv card=\"checkoutSession.cvvData\" show-label=\"false\"></xo-cvv>\n                            </div>\n                        </li>\n\n                        <li id=\"currencyConversion\" class=\"conversion\" ng-if=\"checkoutSession.plan.conversion\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal && !isCountryHU\">\n                                <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n                                <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                            </div>\n\n                             <!-- New compliance content for country Hungary (HU)  -->\n                            <div ng-if=\"checkoutSession.plan.conversion && isCountryHU\" class=\"compliance-container\">\n                                <div class=\"align-left\">\n                                    <p class=\"conversionRateLabel\" ng-class=\"{bold: complianceContent.fromPayPal}\" ng-if=\"complianceContent.conversionRateLabel\" ng-bind-html=\"complianceContent.conversionRateLabel\"></p>\n                                    <p class=\"conversionRate\" ng-if=\"complianceContent.conversionRate\">{{ complianceContent.conversionRate }}</p>\n                                    <a class=\"chooseLink\"\n                                        ng-if=\"checkoutSession.plan.conversion.changeable\" ng-click=\"showConversionOptions()\"\n                                        focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                        ng-bind=\"complianceContent.chooseLink\">\n                                    </a>\n                                </div>\n                                <div class=\"align-right\">\n                                    <strong ng-if=\"complianceContent.amount.value\">{{ complianceContent.amount.value }}</strong>\n                                    <span ng-if=\"complianceContent.amount.currencyCode\">{{ complianceContent.amount.currencyCode }}</span>\n                                </div>\n                            </div>\n\n                            <div ng-if=\"!checkoutSession.plan.conversion.paypal && !isCountryHU\" class=\"conversionIssuerDisclaimer\">\n                                {{content('currencyOptions.issuerFeesDisclaimer')}}\n                            </div>\n\n                            <a id=\"conversionLink\" ng-if=\"checkoutSession.plan.conversion.changeable && !isCountryHU\" ng-click=\"showConversionOptions()\"\n                                focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                ng-bind=\"content('currencyOptions.viewConversion')\">\n                            </a>\n\n                            <!-- 72 hours FX compliance content for AS1/AS2  -->\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal && displayASContent\">\n                                <p class=\"foreignExchangeRate\">\n                                    {{content('currencyOptions.foreignExchangeRate')}}\n                                </p>\n                                <a class=\"why\" ng-click=\"isCollapsed = !isCollapsed\" role=\"button\">\n                                    {{content('currencyOptions.why72hours')}}\n                                    <span class=\"icon\" ng-class=\"{down: !isCollapsed, up: isCollapsed}\"></span>\n                                </a>\n                                <p class=\"reason\" ng-show=\"isCollapsed\">\n                                    {{content('currencyOptions.reason72hours')}}\n                                </p>\n                            </div>\n                            <div ng-if=\"setBufsDisclosureContent()\" class=\"bufs-disclosure\" ng-bind-html=\"bufsDisclosureText\"></div>\n                        </li>\n                    </div>\n                </experience>\n            </div>\n\n            <div ng-if=\"showMultipleFi()\" ng-class=\"{editable:canChangeFI}\" class=\"multipleFi focusable\">\n                <h2 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"checkoutSession.plan.isPAD() && !padToggleEnabled\">\n                        {{ content('paymentMethod.payAfter') }}\n                    </span>\n                    <span ng-if=\"!checkoutSession.plan.isPAD() || padToggleEnabled\">\n                        <span ng-if=\"showPayMerchantWithPayPal\">\n                            {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                        </span>\n                        <span ng-if=\"showPayWithText\">\n                            {{ content('paymentMethod.payWith') }}\n                        </span>\n                    </span>\n                </h2>\n\n                <div ng-if=\"checkoutSession.fundingOptions.getMsbByPlanId(selectedmethod.planId)\" class=\"msbOffer\">\n                    <xo-msb-offer msb=\"checkoutSession.fundingOptions.getMsbByPlanId(selectedmethod.planId)\"></xo-msb-offer>\n                </div>\n\n                <ul class=\"charges\" data-test-id=\"fundingInstruments\">\n                        <!--List of Plans-->\n                    <li ng-hide=\"showMoreFiFactory.shouldHideFiEntry($index)\" role=\"presentation\" class=\"fundingsource\" data-test-id=\"listedFIElement\" ng-repeat=\"plan in getSortedPlans() track by plan.planId\">\n                        <experience flag='!cardart'>\n                            <div class=\"row-fluid radioButton\">\n                                <input type=\"radio\" id=\"{{plan.planId}}\" name=\"selectedFI\" data-test-id=\"selectFIRadioButton\" value=\"{{plan.planId}}\" ng-model=\"selectedmethod.planId\" ng-click=\"updateFS(plan, $index)\"\n                                    ng-keydown=\"showMoreFiFactory.selectFiOnKeyDown($event, $index)\" />\n                                <label class=\"noBottom multiFiLabelContainer\" for=\"{{plan.planId}}\">\n                                    <div ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length && plan.primaryFs.subtype !== 'PAD'\">\n                                        <div class=\"fsdetails\" ng-class=\"[plan.secondaryFIs[0].type]\">\n                                            <span class=\"fsIcon\" ng-class=\"[plan.secondaryFIs[0].type, plan.secondaryFIs[0].name]\"></span>\n                                            <span class=\"fsName\">{{content('fsMappings.'+ plan.secondaryFIs[0].name) || plan.secondaryFIs[0].name}}</span>\n                                            <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                            <span class=\"amount\" ng-if=\"plan.secondaryFIs.length === 1 && plan.secondaryFIs[0].amount\">{{plan.secondaryFIs[0].amount.amount_formatted}}</span>\n                                        </div>\n                                    </div>\n                                    <div ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\">\n                                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                                        <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name, {'BILL_ME_LATER_DE': isDEInstallmentsFI(plan)}]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                                        <div class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                            <div ng-switch=\"plan.primaryFs.subtype\">\n                                                <div class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                                    <div ng-if=\"!padToggleEnabled\">\n                                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span>\n                                                        <br>\n                                                    </div>\n                                                    <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE\">{{content('fundingInstruments.iach')}}</div>\n                                                </div>\n                                                <div ng-switch-default>\n                                                    <span class=\"fsName\" data-test-id=\"primaryFsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                                    <!--<span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\" ng-bind-html=\"content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name + '&#8207;').toString()\"></span>-->\n                                                    <span class=\"fsName\" data-test-id=\"primaryFsName\" ng-if=\"!plan.primaryFs.isPinlessDebit && (!isDEInstallmentsOrGplFI(plan) || isGplDE(plan))\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                                    <span class=\"fsName\" data-test-id=\"gplPrimaryFsName\" ng-if=\"isGplFI(plan) && !isGplDE(plan)\">{{content('paymentMethod.globalPayLater')}}</span>\n                                                    <span class=\"lastdigits\" data-test-id=\"primaryFsDigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</div>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</div>\n                                                    <span class=\"fsName\" ng-if=\"isDEInstallmentsFI(plan)\">{{content('fsMappings.PAYPAL_INSTALLMENTS')}}</span>\n                                                        <div class=\"method short\" ng-if=\"isDEInstallmentsFI(plan)\">\n                                                            <div class=\"fsInstallmentDetails\">\n                                                                <div>{{ content('paymentMethod.installmentDetails',\n                                                                        {\n                                                                        amount: formatCurrency(installment.financing_details.total_cost, installment.financing_details.currency),\n                                                                        term: installment.financing_details.term\n                                                                        })\n                                                                    }}\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                                    <div ng-if=\"plan.primaryFs.isBillingPreferred\" class=\"billingPreferredLabel\">{{ content('fundingInstruments.billingPreferredFi', {merchantName: merchantName}) }}</div>\n                                                </div>\n                                            </div>\n                                            <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(plan)\">\n                                                <div ng-if=\"!isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).secondLineText\"></span>\n                                                </div>\n                                                <div ng-if=\"isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).rewardsAvailble\"></span>\n                                                </div>\n                                            </div>\n                                            <div ng-if=\"showPreferredLabelForMultiFi(plan)\">\n                                                <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                            </div>\n                                            <div ng-if=\"plan.gotDeclined\" class=\"gotDeclinedMessage\">\n                                                <span>{{ content('wallet.processorDeclinedCard') }}</span>\n                                            </div>\n                                            <div class=\"padLabel\" ng-if=\"showPadLabelForPadEligibleCountries(plan)\">\n                                                <span ng-if=\"plan.planId !== selectedmethod.planId\">\n                                                    <span>{{content('memberReview.padLabel_2')}}</span>\n                                                </span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </label>\n                            </div>\n                            <div class=\"fsSubdetails\">\n                                <span ng-if=\"showCreditPlacement(plan)\">\n                                    <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n                                </span>\n                                <xo-preferred-checkbox\n                                    ng-if=\"showPreferredCheckboxForMultiFi(plan) && showPreferredCheckbox(plan)\"\n                                    make-fi-preferred=\"makeFiPreferred\"\n                                    plan=\"plan\"\n                                    cardart=\"false\">\n                                </xo-preferred-checkbox>\n                                <xo-rewards-checkbox\n                                    ng-if=\"hasRewards(plan)\"\n                                    plan=\"plan\"\n                                    selectedmethod= \"selectedmethod\"\n                                    cardart=\"false\">\n                                </xo-rewards-checkbox>\n                                <div class=\"multiFiBackupComponent\"\n                                    ng-if=\"plan.planId === selectedmethod.planId && showBackupPlan(plan)\">\n                                    <xo-backup-label\n                                        plan=\"plan\">\n                                    </xo-backup-label>\n                                </div>\n                                <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                    {{ content('paymentMethod.eCheckDescription') }}\n                                </div>\n\n                                <div class=\"padToggle padToggleMultiFi sCheckbox checkbox\" ng-if=\"showMultiFiPadToggle(plan)\">\n                                    <input type=\"checkbox\" ng-checked=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" ng-change=\"multiFiPadToggleCheckboxEvent(plan)\" ng-model=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" id=\"padToggle\" name=\"padToggle\"\n                                            ng-true-value=\"true\" ng-false-value=\"false\"/>\n                                            <label for=\"padToggle\" id=\"padToggleLabel\" class=\"padToggleSectionTitle\">{{ content('paymentMethod.padToggleTitle') }}</label>\n                                    <div id=\"padToggleOnSection\" class=\"padToggleSection\" ng-if=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\">\n                                        <p id=\"padToggleOnText\" class=\"padToggleSectionOnInfoText\">\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnInfoText', {date: checkoutSession.fundingOptions.getPadPlanHopDate(plan), lang: locale.lang, country: locale.country})\"></span>\n                                        </p>\n                                        <xo-tooltip ng-if=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                            <div class=\"padToggleHelpToolTip\">\n                                                <p class=\"padToggleHelpToolTipHeader\">\n                                                    {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                                                </p>\n                                                <p class=\"padToggleHelpToolTipText\">\n                                                    <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                                                </p>\n                                            </div>\n                                        </xo-tooltip>\n                                    </div>\n                                    <div class=\"padToggleSection\" ng-if=\"!padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\">\n                                        <p class=\"padToggleSectionOffInfoText\">\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOffInfoText', {lang: locale.lang, country: locale.country})\"></span>\n                                        </p>\n                                        <xo-tooltip trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                            <div class=\"padToggleHelpToolTip\">\n                                                <p class=\"padToggleHelpToolTipHeader\">\n                                                    {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                                                </p>\n                                                <p class=\"padToggleHelpToolTipText\">\n                                                    <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                                                </p>\n                                            </div>\n                                        </xo-tooltip>\n                                    </div>\n                                </div>\n                            </div>\n                        </experience>\n\n                        <experience flag='cardart'>\n                            <div class=\"row-fluid radioButton fsPanelRadioWrapper\">\n                                <input type=\"radio\" id=\"{{plan.planId}}\" name=\"selectedFI\" data-test-id=\"selectFIRadioButton\" value=\"{{plan.planId}}\" ng-model=\"selectedmethod.planId\" ng-click=\"updateFS(plan, $index)\"\n                                ng-keydown=\"showMoreFiFactory.selectFiOnKeyDown($event, $index)\" />\n                                <label class=\"noBottom\" for=\"{{plan.planId}}\">\n                                    <div class=\"positionDecoupler\">\n                                        <xo-fi-panel\n                                            fi=\"plan.primaryFs\"\n                                            name-override=\"\n                                                (isGplFI(plan) && content('paymentMethod.globalPayLater')) ||\n                                                (showBalanceRebranded && plan.primaryFs.type === 'BALANCE' && content('paymentMethod.paypalBalanceRebranded'))\"\n                                            show-currency-code=\"plan.primaryFs.type === 'BALANCE' && hasMultipleBalances\"\n                                        >\n                                            <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(plan)\">\n                                                <div ng-if=\"!isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).secondLineText\"></span>\n                                                </div>\n                                                <div ng-if=\"isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).rewardsAvailble\"></span>\n                                                </div>\n                                            </div>\n                                            <span ng-if=\"showCreditPlacement(plan)\">\n                                                <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n                                            </span>\n\n                                            <xo-backup-label\n                                                ng-if=\"plan.planId === selectedmethod.planId && showBackupPlan(plan)\"\n                                                plan=\"plan\"\n                                                has-mask=\"true\"\n                                                >\n                                            </xo-backup-label>\n\n                                            <xo-preferred-checkbox\n                                                ng-if=\"makeFiPreferred && plan.planId === selectedmethod.planId && showPreferredCheckbox(plan)\"\n                                                make-fi-preferred=\"makeFiPreferred\"\n                                                plan=\"plan\"\n                                                cardart=\"true\">\n                                            </xo-preferred-checkbox>\n\n                                            <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                                {{ content('paymentMethod.eCheckDescription') }}\n                                            </div>\n                                            <div ng-if=\"plan.primaryFs.isPreferred && makeFiPreferred\">\n                                                <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                            </div>\n                                            <div ng-if=\"plan.gotDeclined\" class=\"gotDeclinedMessage\">\n                                                <span>{{ content('wallet.processorDeclinedCard') }}</span>\n                                            </div>\n                                            <div>\n                                                <xo-rewards-checkbox\n                                                    ng-if=\"hasRewards(plan)\"\n                                                    plan=\"plan\"\n                                                    selectedmethod= \"selectedmethod\"\n                                                    cardart=\"true\">\n                                                </xo-rewards-checkbox>\n                                            </div>\n                                            <div ng-if=\"setSelectedFiBufsDisclosureContent(plan)\" class=\"bufs-disclosure\" ng-bind-html=\"bufsDisclosureText\"></div>\n                                        </xo-fi-panel>\n                                    </div>\n                                </label>\n                            </div>\n                        </experience>\n                    </li>\n                    <li role=\"presentation\" class=\"fundingsource\" ng-if=\"showPPCAcquisitionRadioButton()\" data-test-id=\"de-ppc-offer\">\n                        <div ng-show=\"ppcInstallmentContentReady()\">\n                            <h2 class=\"paymentsHeader zeta\" ng-bind-html=\"getInstallmentsFiTitle()\" data-test-id=\"showInstallmentFiTitle\"></h2>\n                            <div class=\"row-fluid radioButton\">\n                                <input type=\"radio\" id=\"applyForPPCRadio\" name=\"selectedFI\" value=\"applyForPPCRadio\" ng-click=\"selectApplyForPPC()\"/>\n                                <label class=\"noBottom\" for=\"applyForPPCRadio\">\n                                    <xo-credit-offer-banners token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"\n                                        selectedmethod=\"selectedmethod\" radio=\"true\" parent-context=\"creditParentContext\">\n                                    </xo-credit-offer-banners>\n                                </label>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n\n            <xo-show-more-fi-link ng-if=\"showMoreFiFactory.isFiNeverExpanded()\"></xo-show-more-fi-link>\n\n            <div ng-if=\"checkoutSession.cardBackup.isAllowed()\">\n                <xo-card-backup token=\"token\" selectedmethod=\"selectedmethod\"></xo-card-backup>\n            </div>\n\n            <!-- Show billing address associated to the selected card-->\n            <div ng-if=\"showBillingAddress\" class=\"charges\" ng-model=\"checkoutSession\">\n                <div id=\"billingAddressDisplay\">\n                    <xo-billing-address token=\"token\" edit-uri=\"\"></xo-billing-address>\n                </div>\n            </div>\n\n            <div class=\"padToggle sCheckbox checkbox\" ng-if=\"showPadToggle() && !showMultipleFi()\">\n                <input type=\"checkbox\" ng-checked=\"getPadStatus()\" ng-change=\"padToggleCheckboxEvent()\" ng-model=\"padToggleFeature.checkboxEnabled\" id=\"padToggle\" name=\"padToggle\"\n                        ng-true-value=\"true\" ng-false-value=\"false\"/>\n                <label for=\"padToggle\" id=\"padToggleLabel\" class=\"padToggleSectionTitle\">{{ content('paymentMethod.padToggleTitle') }}</label>\n                <div id=\"padToggleOnSection\" class=\"padToggleSection\" ng-if=\"getPadStatus()\">\n                    <p id=\"padToggleOnText\" class=\"padToggleSectionOnInfoText\">\n                        <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnInfoText', {date: checkoutSession.plan.sources[0].hop_date, lang: locale.lang, country: locale.country})\"></span>\n                    </p>\n                    <xo-tooltip ng-if=\"getPadStatus()\" trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                        <div class=\"padToggleHelpToolTip\">\n                            <p class=\"padToggleHelpToolTipHeader\">\n                                {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                            </p>\n                            <p class=\"padToggleHelpToolTipText\">\n                                <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                            </p>\n                        </div>\n                    </xo-tooltip>\n                    <div class=\"padToggleSectionOnBalanceText\" ng-if=\"isSplitPaymentWithBalanceAndIachPlan\">\n                        <div>\n                            <span class=\"balanceMsgIcon\"/>\n                        </div>\n                        <div class=\"balanceMsg\">\n                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnBalanceText')\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"padToggleSection\" ng-if=\"!getPadStatus()\">\n                    <p class=\"padToggleSectionOffInfoText\">\n                        <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOffInfoText', {lang: locale.lang, country: locale.country})\"></span>\n                    </p>\n                    <xo-tooltip trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                        <div class=\"padToggleHelpToolTip\">\n                            <p class=\"padToggleHelpToolTipHeader\">\n                                {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                            </p>\n                            <p class=\"padToggleHelpToolTipText\">\n                                <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                            </p>\n                        </div>\n                    </xo-tooltip>\n                </div>\n            </div>\n\n            <div ng-if=\"getAddCardLink().show\" class=\"multipleFi addCard\">\n                <a track-link=\"add_card\" ui-sref=\"{{getAddCardLink().route}}\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{getAddCardLink().label}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <!-- For single step nmj, openup wallet page in the sidebar against the review page -->\n            <div ng-if=\"nmjExperience && !nmjExperience.multiPage\" class=\"multipleFi switchCard\">\n                <a track-link=\"view_wallet\" ui-sref=\"checkout.review.sidebar.wallet\" class=\"addCardLink\" role=\"button\" data-test-id=\"walletLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{content('addCard.switchCard')}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <!-- For multi step nmj, openup add card page in the sidebar against the pay-with-card page -->\n            <div ng-if=\"nmjExperience && nmjExperience.multiPage\" class=\"multipleFi switchCard\">\n                <a track-link=\"add_card\" ui-sref=\"checkout.payWithCard.sidebar.sidebarAddCard.addCardFlow.addCard\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{content('addCard.switchCard')}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <h2 class=\"noBottom paymentsHeader zeta\" ng-if=\"showEmptyPlanHeader\">\n                <span>\n                    {{ content('paymentMethod.emptyPlanHeader') }}\n                </span>\n            </h2>\n            <div ng-if=\"showBalanceComprehensionBanner\" data-test-id=\"ppBalanceBanner\" class=\"ppBalanceBanner\">\n                <xo-message message=\"balanceComprehensionBannerMessage\"></xo-message>\n            </div>\n            <div class=\"cibBillingTxt secondary\" ng-if=\"checkoutCart.isBilling() && isCIB && !showRpBaText && !showSubscriptionsV1BaText && !isOptionalVaulting\">\n                <span class=\"cibTextBox\" id=\"cibConsent\" data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getBAContent(), { buyerEmail: buyerEmail, merchantName: merchant,\n                    partner: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\">\n                </span>\n                <span data-test-id=\"CIBShowMore\" ng-if=\"!isExpandedAgreementText\">...\n                <a href=\"javascript:void(0);\" class=\"textLink\"\n                    ng-click=\"showExpandedText()\"\n                    onclick=\"return false;\">{{content('billingAgreement.memberAgreementCibShowMore')}}</a>\n                    </span>\n            </div>\n\n            <!-- Disclaimer on the review page -->\n            <p id=\"baAgreement\" data-test-id=\"baAgreement\"  class=\"billingTxt secondary\" test-data-id=\"baAgreement\" ng-if=\"showMibBAText()\">\n                <span id=\"mibConsent\" data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getBAContent(), { billPayIntegratorName: billPayIntegratorName, buyerEmail: buyerEmail, merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <p id=\"rpAgreement\" class=\"billingTxt secondary\" test-data-id=\"rpAgreement\" ng-if=\"checkoutCart.isBilling() && showRpBaText\">\n                <span id=\"rpConsent\" data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getRPContent(), { buyerEmail: buyerEmail, merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n\t\t\t<p id=\"installmentPlan\" class=\"billingTxt secondary\" ng-if=\"showInstallmentPlanBaText\">\n                <span data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent('billingAgreement.memberAgreementInstallmentPlan', { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <p id=\"subscriptionsV1Agreement\" class=\"billingTxt secondary\" test-data-id=\"subscriptionsV1Agreement\" ng-if=\"checkoutCart.isBilling() && showSubscriptionsV1BaText\">\n                <span id=\"subscriptionsV1Consent\" data-test-id=\"BAContent\"\n                      data-ng-bind-html=\"htmlContent(getSubscriptionsV1BaText(), { buyerEmail: buyerEmail, merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <div class=\"payWithCredit\">\n                <xo-pay-with-credit token=\"token\"></xo-pay-with-credit>\n            </div>\n\n            <!-- AU only direct debit agreement message for a AU buyer with unconfirmed bank -->\n            <p bind-html-compile=\"htmlContent('paymentMethod.directDebitAgreement', { payButtonText: payButtonText })\" ng-if=\"showUachFeatureDiscalimer\"\n                class=\"disclaimer directDebitAgreement\"></p>\n\n            <a ng-if=\"showChangeFI()\" ui-sref=\"checkout.review.sidebar.wallet\" class=\"edits changePayment\"\n                select-button aria-label=\"{{ content('paymentMethod.label') }}\" focus-when-state=\"checkout.review.sidebar.wallet\" transitions-to=\"checkout.review\">\n                {{ locale.country === 'BR' ? content('common.changePayment') : content('common.change') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n\n            <a ng-if=\"selectedmethod && !nmjExperience && !hideManageLink\" ui-sref=\"checkout.review.sidebar.sidebarManageWallet\" class=\"edits changePayment\"\n                select-button focus-when-state=\"checkout.review.sidebar.sidebarManageWallet\" transitions-to=\"checkout.review\">\n                {{ content('asideHeader.manage') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n\n            <div class=\"installmentsFirstPaymentNotice\" ng-if=\"isDEInstallmentsOptionSelected() && installment.financing_details\">\n                <span>{{content('memberReview.bmlFirstPaymentDueText',{days: '30'})}}</span>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"bfx-overlay\">\n    <xo-currency-conversion-overlay token=\"token\" ng-if=\"checkoutSession.plan.conversion\" done-fn=\"onComplete\"></xo-currency-conversion-overlay>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-topup/styles.less");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-topup/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoReviewTopup', {
    tag: 'xo-review-topup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        flags: {
            // flags.sepaAgree is set to true when the Sepa Mandate checkbox is checked by user
            type: 'var',
            required: false
        },
        showBalanceFlow: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();

            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve()['catch'](_angular.noop),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    actions: {
        gotoTopupFunding: function gotoTopupFunding() {
            _uiRouter.$state.go('checkout.review.sidepage.topupFunding');
        },
        closeModal: function closeModal() {
            this.showSepaModal = false;
        },
        openModal: function openModal() {
            this.showSepaModal = true;
        },

        /**
         * This function is refered in the signupTerms.agreeSepaTermsV2 content which has a link to open the Sepa page.
         */
        openSepa: function openSepa() {
            var sepaModel = _fi.$SepaModel.instance();

            this.sepa = {};
            var that = this;

            sepaModel.action('sepaDirectMandate', {
                resultModel: this.sepa,
                data: {
                    bank: {
                        id: this.models.checkoutSession.sepa_mandate.bankId
                    }
                },
                success: function success() {
                    that.actions.openModal();
                }
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.showSepaModal = false;
            this.formatCurrency = _squid.formatCurrency;
            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };
        },
        populate: function populate() {
            var _this = this;

            /**
             * Identify the preferred fs from the matching instrument_id
             */
            this.identifyPreferred = function (preferred, userSelectedFundingSource, fundingSources) {
                if (!preferred || !preferred.instrument_id) {
                    // Preferred does not have an instrument_id, hence pick the userSelectedFundingSource
                    return userSelectedFundingSource;
                } else if (!preferred.name) {
                    // Preferred has an instrument_id but does not have the full details, so map the corresponding element
                    return _squid.$util.find(fundingSources, function (fs) {
                        return fs.instrument_id === preferred.instrument_id;
                    });
                }
                return preferred;
            };

            /**
             * PatchXO api call for tokenization flows
             */
            this.tokenizationPatchXO = function (instrumentId) {
                return _this.models.checkoutSession.action('setTopupFI', {
                    data: {
                        instrument_id: instrumentId
                    }
                });
            };

            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                walletPreferences = _models.walletPreferences,
                tokenizedFundingCapabilitiesModel = _models.tokenizedFundingCapabilitiesModel;
            var topupFundingSources = checkoutSession.topupFundingSources,
                futurePaymentInstruments = checkoutSession.futurePaymentInstruments;
            // Topup does not have userSelectedFundingSource during the initial CreateXO api call

            var userSelectedFundingSource = checkoutSession.userSelectedFundingSource || topupFundingSources && topupFundingSources[0] || {};

            // Set the FI preferred currency
            walletPreferences.currency = tokenizedFundingCapabilitiesModel.getCurrency();

            if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                // Reset the users walletPreferences.direct to an empty object in an Topup flow.
                walletPreferences.direct = {};
                // Identify the preferred topup instrument
                walletPreferences.topup.fundingSource = this.identifyPreferred(walletPreferences.topup.fundingSource, userSelectedFundingSource, topupFundingSources);

                // topup amount is fixed to single value
                walletPreferences.topup.amount = _squid.$config.topup.topupAmounts[0];
                walletPreferences.topup.currency = _squid.$config.topup.currency;
            } else if (tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()) {
                // Reset the users walletPreferences.topup to an empty object in an Direct funding flow.
                walletPreferences.topup = {};
                // futurePaymentInstruments could have balance in it
                walletPreferences.direct.fundingSource = this.identifyPreferred(walletPreferences.direct.fundingSource, userSelectedFundingSource, futurePaymentInstruments);
            }

            if (walletPreferences.getPreferred().instrument_id !== userSelectedFundingSource.instrument_id && userSelectedFundingSource.instrument_id !== null) {
                /**
                 * instrumet_id not in sync with XO, hence make a patchXO api call.
                 * Use Case:
                 * When there are 2 banks (B1, B2) in the user account, and the user had linked his PayPal account in his Google wallet, with B2 as the preferred instrument.
                 * User then tries to link his PayPal account in a different Google wallet.
                 * - PAPS CreateXO api always returns the 1st direct funding instrument (i.e. B1) as the userSelectedFundingSource, and the contingency would be resolved for it.
                 * - But wallet preference for the user will return B2.
                 * - Since we need to show B2 to the user, we will update PAPS with B2 using the PatchXO api call.
                 */
                this.tokenizationPatchXO(walletPreferences.getPreferred().instrument_id);
            }

            if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                this.fundingLabel = (0, _squid.$renderContent)('review.topupFundingLabel');
            } else {
                this.fundingLabel = (0, _squid.$renderContent)('review.paymentMethod');
            }

            /**
             * Checks whether Sepa manadate agreement needs to be shown to the user or not
             */
            this.isSepaMandateRequired = function () {
                if (this.models.checkoutSession.sepa_mandate) {
                    return true;
                }
            };
        }
    }
});


_angular.noop;

_uiRouter.$state;

_squid.$Component;

_squid.$config;

_squid.formatCurrency;

_squid.$util;

_squid.$renderContent;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;

_fi.$SepaModel;

_app.$TokenizedFundingCapabilitiesModel;

_auth.$AuthModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"reviewTopup\" ng-class=\"{reviewDirectFunding: models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()}\" content>\n    <div class=\"topupAmountContainer listItem\" ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled() && models.walletPreferences.topup.amount && models.walletPreferences.topup.currency\">\n        <span class=\"label\">{{content('review.topupAmountLabel')}}</span>\n        <format-currency class=\"listItemValue\" code=\"models.walletPreferences.topup.currency\"\n                         amount=\"models.walletPreferences.topup.amount\"\n                         currency-style=\"Currency\"></format-currency>\n    </div>\n    <div class=\"clearfix topupFundingContainer listItem\" ng-click=\"actions.gotoTopupFunding()\">\n        <div>\n            <span class=\"label\" >{{ fundingLabel }}</span>\n            <div class=\"listItemValue\">\n                <span class=\"walletIcons\" ng-class=\"[models.walletPreferences.getPreferred().type,\n                                                    instrumentIconId(models.walletPreferences.getPreferred().name),\n                                                    models.walletPreferences.getPreferred().card_type]\"></span>\n\n                <span ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n                    <!-- Show the card name and last4 digits in the same line -->\n                    <span class=\"fsname\">{{models.walletPreferences.getPreferred().name}}</span>\n                    <span class=\"fsLast4\">&nbsp;x-{{models.walletPreferences.getPreferred().last4}}</span>\n                </span>\n                <span ng-if=\"models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()\" class=\"fsname\">\n                    <!-- Show the bank name and last4 digits in different lines -->\n                    <div class=\"bankname\">{{models.walletPreferences.getPreferred().name}}</div>\n                    <div>••••{{models.walletPreferences.getPreferred().last4}}</div>\n                </span>\n\n                <a ui-sref=\"checkout.review.sidepage.topupFunding\" class=\"edits changePayment\" select-button focus-when-state=\"checkout.review.sidepage.topupFunding\" transitions-to=\"checkout.review\">\n                    <span class=\"frontArrow goTray\"></span>\n                </a>\n            </div>\n        </div>\n        <div class=\"listItemDisclaimer\" ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n            <span class=\"disclaimer\">{{content(showBalanceFlow ? 'review.topupFundingSourceInfoPPBalance' : 'review.topupFundingSourceInfo')}}</span>\n        </div>\n    </div>\n    <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"isSepaMandateRequired()\">\n        <input ng-model=\"flags.sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\"/>\n        <label class=\"noBottom agreeTerms\" for=\"sepaAgree\" bind-html-compile=\"htmlContent('sepa.agreeSepaTerms')\"></label>\n    </div>\n\n    <xo-modal show=showSepaModal show-close-button=\"true\" on-close=\"actions.closeModal\">\n        <section id=\"sepaMandateContingency\" class=\"sepaMandate\" content>\n            <div class=\"row-fluid\">\n                <div class=\"centerTray\">\n                    <div class=\"trayInner trayInnerDefault loggingIn\">\n                            <h2 class=\"zeta\">{{content('directDebitAgreement.ddFullAgreementTitle')}}</h2>\n                            <p>{{content('DEMemberGuest.ddAgreementPara1')}}</p>\n                            <div class=\"row-fluid sepaInfo\">\n                                <div class=\"span\">\n                                    <strong>{{content('DEMemberGuest.accountCarrier')}}</strong>\n                                    <p>\n                                        <span>{{sepa.user.name}}</span>\n                                        <br/>{{sepa.user.address.line1}}\n                                        <br/>{{sepa.user.address.line2}}\n                                        <br/> {{sepa.user.address.city}}, {{sepa.user.address.postal_code}}\n                                        <br/>{{sepa.user.address.country}}\n                                    </p>\n                                </div>\n                                <div class=\"span bankDetails\">\n                                    <p>\n                                        <strong>{{content('DEMemberGuest.IBAN')}}</strong>\n                                    </p>\n                                    {{sepa.bank.iban_number}}\n                                    <p class=\"marginTop\">\n                                        <strong>{{content('DEMemberGuest.bankName')}}</strong>\n                                    </p>\n                                    {{sepa.bank.bank_name}}\n                                    <p class=\"marginTop\">\n                                        <strong>{{content('DEMemberGuest.bic')}}</strong>\n                                    </p>\n                                    {{sepa.bank.bic}}\n                                </div>\n                            </div>\n\n                            <input track-submit id=\"sepaSubmit\" type=\"submit\" value=\"{{ content('header.close') }}\" class=\"btn full\" ng-click=\"actions.closeModal()\" />\n\n                            <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n                    </div>\n                </div>\n            </div>\n        </section>\n    </xo-modal>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// eslint-disable-line no-unused-vars
// for ui-validate directive
exports['default'] = _squid.$Component.extend({
    tag: 'xo-rewards-checkbox',
    template: _template2['default'],
    props: {
        selectedmethod: {
            type: 'var',
            required: false
        },
        plan: {
            type: 'var',
            required: false
        },
        cardart: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                choiceVariant: _choice.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token)
            };
        }
    },
    actions: {
        open: function open() {
            this.rewards.interstitialValue = this.rewards.value; // Set initial value to be the same as regular
            this.showOverlay = true;
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};

            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'prepare_update_rewards_amount',
                'rewards_type': this.contentkeys.issuerName,
                'fi_id': rewardsAssociatedIds.cardID
            });
        },
        close: function close() {
            this.showOverlay = false;
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};

            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'process_cancellation',
                'rewards_type': this.contentkeys.issuerName,
                'fi_id': rewardsAssociatedIds.cardID
            });
        },
        toggle: function toggle() {
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};

            if (this.state.selected) {
                _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                    selected: true,
                    plan: this.plan,
                    selectedmethod: this.selectedmethod,
                    isReplan: false
                });
                _logger.$logger.info('pay_with_rewards', {
                    'from': 'FUNDING_OPTION_SELECTION',
                    'to': 'process_funding_option_selection',
                    'rewards_type': this.contentkeys.issuerName,
                    'fi_id': rewardsAssociatedIds.cardID
                });
            } else {
                // set done to false if user disables checkbox
                this.done = false;
                _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                    selected: false,
                    plan: this.plan,
                    selectedmethod: this.selectedmethod,
                    isReplan: false
                });
            }
        },
        submit: function submit() {
            var _this = this;

            _logger.$logger.info('PayWithRewards_interstitial_submit');
            var loaded = this.rewards && this.rewards.rewardsPayload && this.rewards.rewardsPayload.rewardsAssociatedIds && this.rewards.value;

            if (!loaded) {
                // should not actually be needed
                return false;
            }

            if (!_factory.$RewardsCheckboxFactory.isRewardsTypeChangeable(this.rewards.rewardsPayload.issuerDetails.rewardsType)) {
                this.showOverlay = false;
                return;
            }

            var ctx = this.getContext();
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};
            var value = this.rewards.interstitialValue;

            _factory.$RewardsCheckboxFactory.submitRewards(this.models.checkoutSession, ctx.currency_code, rewardsAssociatedIds.planID, rewardsAssociatedIds.rewardsID, value).then(function (data) {
                var isFail = typeof data === 'boolean' && data === false;
                var iRewardsPlan = _this.models.checkoutSession.plan.sources.length > 1; // TODO: maybe a better way to de this check ?

                _this.state.selected = !isFail && iRewardsPlan;
                if (!isFail) {
                    _this.rewards.value = _this.rewards.interstitialValue;

                    _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                        selected: true,
                        plan: _this.plan,
                        selectedmethod: _this.selectedmethod,
                        isReplan: true
                    });
                    _logger.$logger.info('pay_with_rewards', {
                        'from': 'UPDATE_REWARDS_INTERSTITIAL',
                        'to': 'process_update_rewards_amount',
                        'rewards_type': ctx.issuerData.issuerName,
                        'rewards_amt': value,
                        'fi_id': rewardsAssociatedIds.cardID
                    });
                }
                _this.done = _this.done || !isFail; // TODO: check if already selected ?
            })['finally'](function () {
                // TODO: error handler
                _this.showOverlay = false;
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.state = {
                selected: false
            };
            this.done = false;
            this.rewards = this.rewards || {
                // TODO: remove after moving logic to use selectedmethod
                // as opposed to separate var
                // placeholder var until cleanup/removal
                value: '',
                interstitialValue: '',
                planid: '',
                rewardsPayload: {},
                type: ''
            };
            this.form_error = false;

            _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                selected: false,
                plan: this.plan,
                selectedmethod: this.selectedmethod,
                isReplan: false
            });
        },
        populate: function populate() {
            this.showOverlay = false;
            this.plan = this.plan || this.props.plan || this.models.checkoutSession.plan;
            // TODO: Consider a mapper of sorts here for the payload
            this.rewards.rewardsPayload = _factory.$RewardsCheckboxFactory.getRewardDetails(this.plan);
            this.contentkeys = _factory.$RewardsCheckboxFactory.getContentKeys(this.plan, this.rewards.rewardsPayload);
            this.rewards.type = this.contentkeys.type; // type is a predefined key // recheck later

            var rewardsPayload = this.rewards && this.rewards.rewardsPayload && this.rewards.rewardsPayload.rewardsPayload || {};

            this.rewards.value = this.rewards.interstitialValue = (0, _utils.getInitialRewardsValue)(this.models, rewardsPayload);
            this.fullOverlay = this.rewards.type === 'statement-credit';
        }
    },
    controller: ['$scope', function ($scope) {

        $scope.getContext = function () {
            var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // TODO: first destructor and then get rid of it
            // need to refactor base payload first
            var rewardsDetails = $scope.rewards && $scope.rewards.rewardsPayload || {};
            var issuerData = rewardsDetails && rewardsDetails.issuerDetails || {};
            var constraint = rewardsDetails && rewardsDetails.rewardsPayload && rewardsDetails.rewardsPayload.rewards_constraint;
            var currency_code = $scope.models.checkoutCart.purchase && $scope.models.checkoutCart.purchase.amounts && $scope.models.checkoutCart.purchase.amounts.total.currency_code;

            return _squid.$util.extend({
                issuerData: issuerData, constraint: constraint, currency_code: currency_code,
                rewards_type: issuerData.rewardsType,
                conversion_metadata: rewardsDetails.rewardsPayload && rewardsDetails.rewardsPayload.conversion_metadata
            }, ctx);
        };

        $scope.showCheckbox = function () {
            var result = _factory.$RewardsCheckboxFactory.showCheckbox($scope.plan, $scope.selectedmethod, $scope.models.choiceVariant);

            return result;
        };

        $scope.valueValidator = function (data) {
            /**
             * Cases:
             * 1) less than max usable
             * 2) less than equal to cart
             * 3) should be a number
             * 4) 2 digit decimal place
             * 5) should be greater than min value
             */
            var constraint = $scope.getContext().constraint;

            if (!constraint || !constraint.maximum_usable) {
                // safe check to see if constraint is populated
                return true;
            }
            var rawValue = data || $scope.rewards && $scope.rewards.interstitialValue;
            var value = (0, _utils.toNumber)(rawValue);
            var maxUsable = (0, _utils.toNumber)(constraint.maximum_usable.value);

            $scope.minAllowed = (0, _utils.toNumber)(constraint.minimum_spend.value);
            var cartAmount = (0, _utils.toNumber)($scope.models.checkoutCart.purchase.amounts.total.amount, 2);
            var exists = value && maxUsable;
            var hasMax2DigitDecimal = /^\d+(\.\d{1,2})?$/i;
            var errorMap = [['default', !exists], ['default', isNaN(value)], ['default', !hasMax2DigitDecimal.test(rawValue)], ['minimum', value < $scope.minAllowed], ['moreThanAvailable', value > maxUsable && value <= cartAmount], ['moreThanPurchase', value > cartAmount]];
            var errorList = errorMap.find(function (testcase) {
                return testcase[1];
            });

            if (errorList) {
                // TODO: Make into debug or remove once rewards is stable.
                _logger.$logger.info('PayWithRewards_client_validation_error_' + errorList[0]);
            }
            $scope.form_error = errorList && errorList[0] || false;
            return !$scope.form_error;
        };

        $scope.useAmountContent = function () {
            /**
             * Final interstitial value to checkbox.
             *
             * cashback : currency -> currency
             * points : currency -> reward(currency)
             * miles : currency -> reward(currency)
             * statement-credit : currency -> currency
             */
            var ctx = $scope.getContext();
            var currency_symbol = (0, _squid.getCurrencySymbol)(ctx.currency_code);

            // inputType === 'currency' (cashback, chase)
            var rewardAmount = (0, _utils.toCommaSeparatedString)($scope.rewards.value, $scope.getContext({
                conversion_type: 'REWARDS_TO_AMOUNT'
            }));
            var currencyAmount = '';

            // inputType === 'rewards' (points, miles)
            if ((0, _utils.conversionDetails)(ctx.issuerData.rewardsType).inputType === 'rewards') {
                rewardAmount = (0, _utils.convert)('AMOUNT_TO_REWARDS', $scope.rewards.value, ctx, true);
                currencyAmount = (0, _utils.toCommaSeparatedString)($scope.rewards.value, $scope.getContext({
                    conversion_type: 'REWARDS_TO_AMOUNT'
                }));
            }

            return (0, _squid.$renderContent)('rewards.useAmount.' + ctx.issuerData.contentKey, {
                rewardAmount: rewardAmount,
                currency_symbol: currency_symbol,
                currencyAmount: currencyAmount
            });
        };

        $scope.formOutputContent = function () {
            var ctx = $scope.getContext();
            var rewardPoints = (0, _utils.convert)('AMOUNT_TO_REWARDS', $scope.rewards.interstitialValue, ctx, true);

            return (0, _squid.$renderContent)('rewards.formResultLabel.' + ctx.issuerData.contentKey, {
                rewardPoints: rewardPoints
            });
        };
    }]
});


_squid.$Component;

_squid.$renderContent;

_squid.getCurrencySymbol;

_squid.$util;

_logger.$logger;

_angular.$rootScope;

_angular.noop;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_choice.$ChoiceEligibility;

_factory.$RewardsCheckboxFactory;

_utils.toNumber;

_utils.toCommaSeparatedString;

_utils.getInitialRewardsValue;

_utils.convert;

_utils.conversionDetails;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

// eslint-disable-line no-unused-vars

/**
 * TODO: Somehow try to move some of this constant
 * mapping logic to some facade layer.
 */
var REWARD_CODE_MAPPINGS = {
    'DLR': {
        issuerName: 'discover',
        rewardsType: 'cashback',
        contentKey: 'discover.cashback',
        rewardsEnabled: true
    },
    'MIL': {
        issuerName: 'discover',
        rewardsType: 'miles',
        contentKey: 'discover.miles',
        rewardsEnabled: true
    },
    'TYP': {
        issuerName: 'citi',
        rewardsType: 'points',
        contentKey: 'citi',
        rewardsEnabled: true
    },
    'LPTS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase',
        rewardsEnabled: false
    },
    'WPTS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase',
        rewardsEnabled: false
    },
    'USD': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase',
        rewardsEnabled: false
    },
    'MLS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase',
        rewardsEnabled: false
    },
    'AMEX': {
        issuerName: 'amex',
        rewardsType: 'points',
        contentKey: 'amex',
        rewardsEnabled: true
    },
    'DEFAULT': {
        // This should never really be used.
        issuerName: 'default',
        rewardsType: 'points',
        contentKey: 'default',
        rewardsEnabled: true
    }
};

/**
 *  Given a rewards instrument
 *  Returns all ids and keys we need to link rewards
 *  to different plans and instruments
 *
 * @param {*} instrument
 * @returns
 */
var rewardsAssociatedIds = function rewardsAssociatedIds(instrument) {
    var rewardsPayload = instrument.rewards || {};
    var related_card = rewardsPayload && rewardsPayload.related_card;
    var cardID = related_card && related_card.id;
    var rewardsID = instrument.id;
    var planID = instrument.planId;

    return {
        rewardsID: rewardsID,
        cardID: cardID,
        planID: planID
    };
};

/**
 * Returns all issuer related info required to render
 * custom experience for different reward programs
 *
 * @param {*} instrument
 * @returns
 */
var issuerDetails = function issuerDetails(instrument) {
    var rewardsPayload = instrument.rewards || {};
    var available_incentive = rewardsPayload && rewardsPayload.available_incentive;
    var rewards_currency_code = available_incentive.rewards_code;

    // set `rewards_currency_code` to 'DEFAULT' if we don't get a supported `rewards_code`
    if (!rewards_currency_code || !Object.keys(REWARD_CODE_MAPPINGS).includes(rewards_currency_code)) {
        rewards_currency_code = 'DEFAULT';
        _logger.$logger.info('PayWithRewards_use_default_issuer_data');
    }

    // This is a temporary fix until a rewards currency code is returned for Amex.
    // `redemption_type` is the type of redemption for the rewards. For now, `STATEMENT_CREDIT_WITH_AMOUNT_CHOICE` will
    // only be returned for Amex, but in the future there might be other programs that use it as well.
    //
    // TODO: Use the Amex rewards_code when planning adds it in
    if (!rewards_currency_code && rewardsPayload.redemption_type === 'STATEMENT_CREDIT_WITH_AMOUNT_CHOICE') {
        rewards_currency_code = 'AMEX';
    }

    var issuerData = available_incentive && REWARD_CODE_MAPPINGS[rewards_currency_code];
    var issuerName = issuerData.issuerName,
        rewardsType = issuerData.rewardsType,
        contentKey = issuerData.contentKey;

    var rewardPoints = available_incentive && available_incentive.value;
    var rewardMonetaryValue = available_incentive && available_incentive.monetary_value && available_incentive.monetary_value.value;

    // Convert strings to numeric values
    rewardPoints = (0, _utils.toNumber)(rewardPoints);
    rewardMonetaryValue = (0, _utils.toNumber)(rewardMonetaryValue);

    return {
        rewards_currency_code: rewards_currency_code,
        rewardPoints: rewardPoints,
        rewardMonetaryValue: rewardMonetaryValue,
        rewardsType: rewardsType,
        issuerName: issuerName,
        contentKey: contentKey
    };
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$RewardsCheckboxFactory', function () {

    var rewardsCache = {};
    var models = {};
    var cancelSessionWatcher = void 0; // holds the deactivator function

    var checkboxSelection = {
        planId: null,
        rewardsChosenPlan: null
    };

    var buildCache = function buildCache() {
        /**
         * TODO:
         * Consider developing a focus around fi as opposed to plans
         * once you proved stability in rewards move it out and expand to
         * all FI not just rewards. The case we need to confirm is plan refreshes.
         * 1) If we are starting a cache then how does cache management work with the
         * different plan refresh cases?
         * 2) How can we leverage the xo-models cache infrastructure ?
        */
        var isFeatureEnabled = (0, _squid.$feature)('payWithRewards');

        if (isFeatureEnabled && !cancelSessionWatcher) {
            cancelSessionWatcher = _squid.$event.on('checkoutSessionChange', function (event) {
                // For SNT in WPS there is a plan refresh upon RYI render.
                refreshCache();
            });
        }

        (0, _squid.$populate)(models, {
            checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token)
        }).then(function () {
            var _models$checkoutSessi = models.checkoutSession.fundingOptions.instruments,
                instruments = _models$checkoutSessi === undefined ? [] : _models$checkoutSessi;


            if (isFeatureEnabled) {
                _squid.$util.forEach(instruments, function (instrument) {
                    var payload = {};
                    var rewardsPayload = instrument.rewards || {};
                    var available_incentive = rewardsPayload && rewardsPayload.available_incentive || {};
                    var rewards_currency_code = available_incentive.rewards_code;

                    // only add FI to `rewardsCache` if it's of type `REWARDS`
                    // and we're supporting its `rewards_currency_code`
                    if (instrument.type === 'REWARDS' && Object.keys(REWARD_CODE_MAPPINGS).includes(rewards_currency_code) && REWARD_CODE_MAPPINGS[rewards_currency_code].rewardsEnabled) {
                        payload.rewardsAssociatedIds = rewardsAssociatedIds(instrument);
                        payload.issuerDetails = issuerDetails(instrument);
                        payload.rewardsPayload = rewardsPayload;
                        // TODO: DO we still need to hold on to raw payload ?
                        // move to store only whats needed approach
                        var cardID = payload.rewardsAssociatedIds.cardID; // set focus on card as opposed to rewards/plans

                        rewardsCache[cardID] = payload;
                        _logger.$logger.info('PayWithRewards_instrument_check', {
                            'fi_id': cardID
                        });
                    }
                });
            }
        })['finally'](function () {
            // instrumentation here
        });
    };

    var refreshCache = function refreshCache() {
        // TODO: Consider this when handling
        // plan refresh use case
        rewardsCache = {};
        buildCache();
    };

    var destroy = function destroy() {
        if (cancelSessionWatcher) {
            cancelSessionWatcher();
        }
    };

    /**
     * Checks to see if the current session
     * has any rewards FI in any plan.
     *
     * @returns Boolean
     */
    var rewardsFound = function rewardsFound() {
        return Object.keys(rewardsCache).length > 0;
    };

    /**
     * Returns a string representing rewards fi's
     * with issuer name.
     * Sample: "CC-T2RX5VBELRL7C_discover:CC-ZKQBGHWZQECYJ:chase"
     *
     * @returns String
     */
    var toString = function toString() {
        var result = '';

        _squid.$util.forEach(rewardsCache, function (instrument, instrument_id) {
            var issuerData = instrument.issuerDetails;
            var issuerName = issuerData.issuerName;

            if (instrument_id && issuerName) {
                result = result ? result + ':' + instrument_id + '_' + issuerName : instrument_id + '_' + issuerName;
            }
        });
        return result;
    };

    /**
     * Checks if the FI has a rewards
     * instrument attached
     *
     * @param {*} fi
     * @returns
     */
    var isRewardsFi = function isRewardsFi(fi) {
        // const isCard = fi.type === 'CARD';
        var result = Boolean(rewardsCache[fi.instrument_id]);

        return result;
    };

    /**
     * Checks if the primary FI associated
     * with the plan has rewards
     *
     * @param {*} plan
     * @returns
     */
    var isRewardsPlan = function isRewardsPlan(plan) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var isBalanceSelected = (0, _utils.isPayPalBalanceSelected)(plan);
        var isRewards = isRewardsFi(fi);
        // balance and rewards are incompatible
        // if balance then do not use rewards
        // Should we check for balance as part of isRewards check
        // or separate?

        return isRewards && !isBalanceSelected;
    };

    /**
     * Returns if the rewards has a changeable amount, based on the provided type
     */
    var isRewardsTypeChangeable = function isRewardsTypeChangeable(type) {
        return type !== 'statement-credit';
    };

    var getRewardDetails = function getRewardDetails(plan) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var result = isRewardsFi(fi) && rewardsCache[fi.instrument_id];

        return result;
    };

    var getRewardsPlanFromFi = function getRewardsPlanFromFi(fi) {
        var fiDetails = rewardsCache[fi.instrument_id] || {};
        var planID = fiDetails.rewardsAssociatedIds && fiDetails.rewardsAssociatedIds.planID;

        return (0, _utils.getPlanFromId)(planID);
    };

    var ifRewardsThenUpdatePlan = function ifRewardsThenUpdatePlan(currentPlanId, selectedmethod, checkoutSession) {

        // Given an Id
        // get plan object.
        // check if plan object contains rewards

        // ------------------------------------
        // -----> handle these before the plan comes into this function
        // check if plan is selected (2 cases)
        // 1st check if plan is user selected
        // --- We need this to give precedence to checkbox which wont trigger replan
        // 2nd check if plan is session selected
        // -- if we have a replan or initial plan already selecting rewards then honor it.
        // ------------------------------------
        var isRewardsChosen = selectedmethod ? selectedmethod.rewardsChosenPlan : // multiple FI selection
        checkboxSelection.rewardsChosenPlan; // single FI selection
        var selectedPlan = (0, _utils.getPlanFromId)(checkoutSession, selectedmethod ? selectedmethod.planId : currentPlanId);
        var rewardsEligible = isRewardsPlan(selectedPlan);

        if (!rewardsEligible) {
            return currentPlanId;
        }

        var result = (0, _utils.matchPlanFromConstraints)({
            checkoutSession: checkoutSession,
            instrumentId: (0, _utils.getInstrumentID)(selectedPlan),
            // For now, we never want balance with this method.
            balance: false,
            rewards: isRewardsChosen
        });

        return result && (0, _utils.getPlanID)(result);
    };

    var showCheckbox = function showCheckbox(plan, fiSelectionContext, choiceVariant) {
        var isChoiceVariant = Boolean(choiceVariant === '6');
        var isMultiFi = Boolean(plan && plan.primaryFs); // TODO: fails for selectFI use case
        var usingPayPalBalance = Boolean(plan && plan.secondaryFIs);
        var uiSelectedPlanId = plan && (0, _utils.getPlanID)(plan);
        var clickSelectedPlanId = fiSelectionContext && fiSelectionContext.planId;
        // Differentiating between uiSelection vs clickSelection to avoid the case
        // when this function gets triggered due to digest while the user has clicked
        // on a different fi. Do not show checkbox for this case. Would cause flickering.
        var isRewards = isRewardsPlan(plan);
        var disregardClickSelection = isChoiceVariant || !isMultiFi;
        var isSelected = uiSelectedPlanId && uiSelectedPlanId === clickSelectedPlanId || disregardClickSelection;

        var result = isSelected && isRewards && !usingPayPalBalance;

        return result;
    };

    /**
     * When session has balance and
     * fi has rewards then hide amount.
     * TODO: consider removing this after PAPS fix
     *
     * @param {*} fi
     * @returns
     */
    var hideAmount = function hideAmount(fi) {

        if (!fi) {
            return false;
        }
        var isRewards = isRewardsFi(fi);

        return isRewards;

        /**
         * TODO commenting the below code as patch on changing the rewards amount
         * is not updating the amount getting charged from other funding source
         * until symphony fix this, hiding the amount
         */

        // const { checkoutSession = {} } = models;
        // const { instruments = [] } = checkoutSession.fundingOptions;
        // const sessionHasBalance = instruments.some(instrument => instrument.type === 'BALANCE');
        //
        // return (isRewards && sessionHasBalance);

        // end of TODO
    };

    var setCheckboxSelectionForPlan = function setCheckboxSelectionForPlan(_ref) {
        var selected = _ref.selected,
            plan = _ref.plan,
            selectedmethod = _ref.selectedmethod,
            isReplan = _ref.isReplan;

        if (selectedmethod) {
            if (selected) {
                (0, _utils.setSelectedPlan)(plan, selectedmethod, isReplan);
            } else {
                (0, _utils.clearSelectedPlan)(plan, selectedmethod);
            }
        } else {
            var planId = (0, _utils.getPlanID)(plan);

            checkboxSelection.planId = planId;
            checkboxSelection.rewardsChosenPlan = selected ? planId : null;
        }
    };

    var getContentKeys = function getContentKeys(plan, rewardsPayload) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var last4Digits = fi && fi.lastDigits;
        var rewardsDetails = rewardsPayload || getRewardDetails(plan);
        var issuerData = rewardsDetails && rewardsDetails.issuerDetails || {};
        var currency_code = fi && fi.amount && fi.amount.currency_code;
        var rewardPoints = (0, _utils.toCommaSeparatedString)(issuerData.rewardPoints, {
            conversion_metadata: rewardsDetails.conversion_metadata,
            conversion_type: 'AMOUNT_TO_REWARDS',
            rewards_type: issuerData.rewardsType,
            currency_code: currency_code
        });
        var rewardMonetaryValue = (0, _utils.toCommaSeparatedString)(issuerData.rewardMonetaryValue, {
            conversion_metadata: rewardsDetails.conversion_metadata,
            conversion_type: 'REWARDS_TO_AMOUNT',
            rewards_type: issuerData.rewardsType,
            currency_code: currency_code
        });
        var currency_symbol = (0, _squid.getCurrencySymbol)(currency_code);
        var getString = function getString(key) {
            return (0, _squid.$renderContent)(key + '.' + issuerData.contentKey, {
                issuerName: issuerData.issuerName,
                last4Digits: last4Digits,
                rewardPoints: rewardPoints,
                rewardAmount: rewardMonetaryValue,
                currency_symbol: currency_symbol
            });
        };
        var map = {
            header: getString('rewards.header'),
            rewardsAvailble: getString('rewards.rewardsAvailble'),
            subText: getString('rewards.subText'),
            policy: getString('rewards.policy'),
            secondLineText: getString('rewards.secondLineText'),
            chargeAmount: getString('rewards.chargeAmount'),
            changeAmount: getString('rewards.changeAmount'),
            formInputLabel: getString('rewards.formInputLabel'),
            formResultLabel: getString('rewards.formResultLabel'),
            // TODO: use dynamic amount
            // useAmount:$renderContent(`rewards.useAmount.${issuerData.contentKey}`, {
            //     rewardAmount: '919191',
            //     currencyUnit: '$',
            //     currencyAmount: '9999'
            // }),
            enterValidAmount: (0, _squid.$renderContent)('rewards.enterValidAmount.default'),
            type: issuerData.rewardsType,
            overlayButton: (0, _squid.$renderContent)(isRewardsTypeChangeable(issuerData.rewardsType) ? 'common.save' : 'common.OK'),
            issuerName: issuerData.issuerName,
            value: {
                rewardPoints: rewardPoints, // Amount in rewards
                rewardAmount: rewardMonetaryValue // Amount in currency
            }
        };

        return map;
    };

    /**
     * Do a select call and an update call in sequence.
     * Consider batching this later
     *
     * @param {*} checkoutSession
     * @param {*} currency_code
     * @param {*} planID
     * @param {*} rewardsID
     * @param {*} value
     * @returns
     */
    var submitRewards = function submitRewards(checkoutSession, currency_code, planID, rewardsID, value) {
        var payload = {
            type: 'REWARDS',
            value: value,
            currency: currency_code,
            id: rewardsID
        };

        var errorHandler = function errorHandler(name, err, action, type) {
            // TODO: Get rid of this or discuss better handling with product
            // Do we really need 2 handlers? once we have decided the kind of errors
            // that get thrown then pick one type of handler contingency or error

            checkoutSession.message = {
                type: 'error',
                msgKeys: ['paymentMethod.cycoSsotWarning']
            };
            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'process_planning_response',
                'int_error_code': err,
                'int_error_description': action + '-' + type,
                'error_source': 'paymentapiplatformserv'
            });
            return _squid.$promise.reject(err);
        };

        return checkoutSession.fundingOptions.action('select', {
            resultModel: checkoutSession,
            data: {
                planId: planID
            },
            success: function success(result) {
                checkoutSession.populate(result);
            },
            contingencies: {
                DEFAULT: function DEFAULT(name, err) {
                    return errorHandler(name, err, 'select', 'contingency');
                }
            },
            error: function error(name, err) {
                return errorHandler(name, err, 'select', 'error');
            }
        }).then(function () {
            return checkoutSession.fundingOptions.action('patch', {
                resultModel: checkoutSession,
                data: payload,
                success: function success(result) {
                    checkoutSession.message = {
                        type: 'success',
                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                    };
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        return errorHandler(name, err, 'patch', 'contingency');
                    }
                },
                error: function error(name, err) {
                    return errorHandler(name, err, 'patch', 'error');
                }

            });
        });
    };

    return {
        buildCache: buildCache,
        refreshCache: refreshCache,
        destroy: destroy,
        rewardsFound: rewardsFound,
        toString: toString,
        isRewardsPlan: isRewardsPlan,
        isRewardsFi: isRewardsFi,
        isRewardsTypeChangeable: isRewardsTypeChangeable,
        getRewardsPlanFromFi: getRewardsPlanFromFi,
        getRewardDetails: getRewardDetails,
        getContentKeys: getContentKeys,
        showCheckbox: showCheckbox,
        hideAmount: hideAmount,
        setCheckboxSelectionForPlan: setCheckboxSelectionForPlan,
        ifRewardsThenUpdatePlan: ifRewardsThenUpdatePlan,
        submitRewards: submitRewards
    };
});

_squid.$util;

_squid.$renderContent;

_squid.$populate;

_squid.$feature;

_squid.$promise;

_squid.$event;

_squid.getCurrencySymbol;

_angular.$rootScope;

_checkout.$CheckoutSessionModel;

_utils.getPlanID;

_utils.getInstrumentID;

_utils.getPrimaryFI;

_utils.getPlanFromId;

_utils.toNumber;

_utils.toCommaSeparatedString;

_utils.isPayPalBalanceSelected;

_utils.setSelectedPlan;

_utils.clearSelectedPlan;

_utils.matchPlanFromConstraints;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/rewards-checkbox", "../node_modules/xo-member-components/src/rewards-checkbox/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showCheckbox()\" class=\"sCheckbox checkbox\" content>\n    <div class=\"postSelection checkboxPayWithRewards\" ng-class=\"{cardart: cardart, singleFi: singleFi}\">\n        <input type=\"checkbox\" ng-model=\"state.selected\" name=\"rewardsSelection\" id=\"rewardsSelection\" ng-change=\"actions.toggle()\" data-test-id=\"rewards-checkbox\">\n        <label for=\"rewardsSelection\">\n            <span ng-bind-html=\"useAmountContent()\"></span>\n            <a ng-click=\"actions.open()\" link-button class=\"changeAmount\" data-test-id=\"rewards-change-amount\">\n                {{contentkeys.changeAmount}}\n            </a>\n        </label>\n        <div class=\"remainderDisclosure\" ng-if=\"(state.selected || done)\">\n            {{contentkeys.chargeAmount}}\n        </div>\n    </div>\n    <section class=\"rewards-overlay\" ng-class=\"{ 'full-overlay': fullOverlay }\">\n        <xo-modal show=\"showOverlay\"\n                on-close=\"actions.close\"\n                show-close-button=\"true\"\n                enable-close-on-escape=\"true\"\n                override-default-container=\"true\">\n            <div id=\"rewardsInterstitial\" data-test-id=\"rewards-overlay\">\n                <span ng-class=\"{chasePay: rewards.type==='statement-credit'}\">\n                    <h2 class=\"rewardsHeader alpha\">\n                        <span ng-bind-html=\"contentkeys.header\"></span>\n                    </h2>\n                    <div class=\"rewardsAvailble\">\n                        <span ng-bind-html=\"contentkeys.rewardsAvailble\"></span>\n                    </div>\n                </span>\n\n                <div class=\"rewardsForms\">\n                    <div ng-if=\"rewards.type && rewards.type!=='statement-credit'\"\n                        class=\"{{rewards.type}}\">\n                        <!-- TODO: find a better way instead of mapping type directly to class -->\n                        <!-- ng-class=\"{{rewards.type}}\" is not class=\"points\" -->\n\n                        <span class='leftSide'>\n                            <span class='currencyUnit' ng-bind-html=\"contentkeys.formInputLabel\"></span>\n                            <input class='Field' value=\"\"\n                                ng-model=\"rewards.interstitialValue\"\n                                ui-validate=\"'valueValidator($value)'\"\n                                data-test-id=\"rewards-change-input\"\n                                />\n                        </span>\n                        <span class='rightSide'>\n                            <span class='equalSign' ng-if=\"rewards.type!=='cashback'\">=</span>\n                            <span class='rewardUnit' ng-bind-html=\"formOutputContent()\"></span>\n                        </span>\n                    </div>\n                    <div class=\"formText\"\n                         ng-class=\"{subText: rewards.type!=='', fullText: rewards.type===''}\">\n                        <div ng-class=\"{formError: form_error}\"\n                            ng-switch=\"form_error\">\n                            <div ng-switch-when=\"false\"> {{contentkeys.subText}}</div>\n                            <div ng-switch-when=\"default\"> {{content('rewards.enterValidAmount.default')}}</div>\n                            <div ng-switch-when=\"minimum\"> {{content('rewards.enterValidAmount.minimum', { value: minAllowed })}}</div>\n                            <div ng-switch-when=\"moreThanAvailable\"> {{content('rewards.enterValidAmount.moreThanAvailable')}}</div>\n                            <div ng-switch-when=\"moreThanPurchase\"> {{content('rewards.enterValidAmount.moreThanPurchase')}}</div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"rewardsFooter\">\n                    <div class=\"disclaimer\">\n                        <span ng-bind-html=\"contentkeys.policy\"></span>\n                    </div>\n                    <div id=\"button\" class=\"buttons submit\">\n                        <input track-submit\n                            type=\"submit\"\n                            ng-value=\"contentkeys.overlayButton\"\n                            class=\"btn full confirmButton continueButton\"\n                            ng-disabled=\"form_error\"\n                            ng-click=\"actions.submit()\"\n                            data-test-id=\"rewards-change-submit\"\n                            />\n                    </div>\n                </div>\n            </div>\n        </xo-modal>\n    </section>\n</div>\n    \n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.matchPlanFromConstraints = exports.getSelectedPlan = exports.isPayPalBalanceSelected = exports.getInitialRewardsValue = exports.getPlanFromId = exports.getPrimaryFI = exports.clearSelectedPlan = exports.setSelectedPlan = exports.isPayNow = exports.convert = exports.convertValue = exports.toCommaSeparatedString = exports.toNumber = exports.sanitizeNumber = exports.conversionDetails = exports.getInstrumentID = exports.getPlanID = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

// eslint-disable-line no-unused-vars

/**
 *  fundingOptions has plan.planId
 *  checkoutSession has plan.id
 *
 * @param {*} plan
 */
var getPlanID = exports.getPlanID = function getPlanID(plan) {
    if (!plan) {
        return plan;
    }
    return plan.planId || plan.id;
};

/**
 * getInstrumentId
 * @param {Object} plan Any type of plan
 * @retursn {String} Instrument ID of primary fs
 */
var getInstrumentID = exports.getInstrumentID = function getInstrumentID(plan) {
    return plan.sources ? plan.sources[plan.sources.length - 1].instrument_id : plan.primaryFs.id;
};

/**
 * Returns an object containing input
 * and output details about the conversion
 *
 * @param {*} rewards_type
 * @param {*} conversion_type
 * @returns {}
 */
var conversionDetails = exports.conversionDetails = function conversionDetails(rewards_type, conversion_type) {
    var result = {};

    if (rewards_type) {
        var rewardsInCurrency = rewards_type === 'cashback'
        // TODO: Consider replacing rewardsInCurrency with monetary flag from PSS.
        // As of now not receiving it from PAPS.
        ;

        result.inputType = rewardsInCurrency ? 'currency' : 'rewards';
        if (conversion_type) {
            var useCurrency = conversion_type === 'REWARDS_TO_AMOUNT' || rewardsInCurrency && conversion_type === 'AMOUNT_TO_REWARDS';

            result.outputType = useCurrency ? 'currency' : 'rewards';
            result.skipConversion = result.inputType === result.outputType;
        }
    }
    return result;
};

/**
 * sanatizes undefined, NAN numbers
 * does rounding and limits
 *
 * @param {*} value
 * @param {*} limit
 * @param {*} rounding
 * @returns
 */
var sanitizeNumber = exports.sanitizeNumber = function sanitizeNumber(value, limit, rounding) {
    var isString = value && typeof value === 'string';
    var hasComma = isString && value.indexOf(',') >= 0;

    if (!value || hasComma) {
        /** 
         * Avoid accidental double sanitization
         * TODO: figure out how to prevent double 
         * sanitization in the first place
        */
        return !value ? '0' : value;
    }

    var num = Number(value);

    num = isNaN(num) || !num ? 0 : num;
    num = rounding === 1 ? Math.round(num) : num;
    num = limit ? num.toFixed(limit) : num;
    num = isString ? num : Number(num);
    /** 
     * if you get a string return a string
     * required for 1.20 or decimal/currency use case
     * since toFixed return a string
    */

    return num;
};

/**
 * Given a string return a number
 *
 * @param {*} str
 * @param {number} [limit=2]
 * @param {number} [rounding=0]
 * @returns
 */
var toNumber = exports.toNumber = function toNumber(value) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var num = typeof value === 'string' ? parseFloat(value) : value;

    return sanitizeNumber(num, limit, rounding);
};

/**
 * extract the required decimal precision from rewards
 *
 * @param {*} conversion_metadata
 * @param {*} key
 * @returns
 */
var getPrecision = function getPrecision(conversion_metadata, key) {
    var decimal_precision = {};

    _squid.$util.forEach(conversion_metadata.decimal_precisions, function (ele) {
        decimal_precision[ele.conversion_type] = toNumber(ele.length, 0);
    });
    return decimal_precision[key] || 0;
};

/**
 * extract the required rounding details from rewards
 *
 * @param {*} conversion_metadata
 * @param {*} key
 * @returns
 */
var getRounding = function getRounding(conversion_metadata, key) {
    var rounding_modes = {};
    var mapper = {
        'UNNECESSARY': 0,
        'HALF_UP': 1
        // More may be added over time
    };

    _squid.$util.forEach(conversion_metadata.rounding_modes, function (ele) {
        rounding_modes[ele.conversion_type] = ele.value;
    });
    var value = rounding_modes[key] || 'UNNECESSARY';

    return mapper[value];
};

var toCommaSeparatedString = exports.toCommaSeparatedString = function toCommaSeparatedString(value) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!value) {
        return '';
    }
    var currency_code = ctx.currency_code,
        _ctx$conversion_metad = ctx.conversion_metadata,
        conversion_metadata = _ctx$conversion_metad === undefined ? {} : _ctx$conversion_metad,
        conversion_type = ctx.conversion_type,
        rewards_type = ctx.rewards_type;

    var locale_code = _squid.$locale.lang + '-' + _squid.$locale.country;
    var useCurrency = conversionDetails(rewards_type, conversion_type).outputType === 'currency';
    var precision = getPrecision(conversion_metadata, conversion_type);
    var rounding = getRounding(conversion_metadata, conversion_type);
    var num = toNumber(value, '', rounding);
    var result = '';

    if (useCurrency) {
        result = (0, _squid.formatCurrency)(value, currency_code, false, 'AmountOnlyStyle');
        result = sanitizeNumber(result, 2, 0);
    } else {
        result = num.toLocaleString(locale_code, {
            useGrouping: true, // may only need for certain countries.
            minimumFractionDigits: precision
        });
        result = sanitizeNumber(result);
    }

    return result;
};

/**
 * Conversion math logic.
 * use precision and rounding from the rewards payload
 * to preform conversion to & from rewards
 *
 * @param {*} amount
 * @param {*} conversion_type
 * @param {*} conversionData
 * @returns
 */
var convertValue = exports.convertValue = function convertValue(amount, conversion_type, conversionData) {
    var result = '';

    if (!amount || !conversion_type || !conversionData) {
        return result;
    }
    var precision = getPrecision(conversionData, conversion_type);
    var rounding = getRounding(conversionData, conversion_type);
    // Use 4 decimal places or more for factor multiplication.
    // We need this to maintain decimal precision during calculation.
    var factor = toNumber(conversionData.conversion_factor, 4);

    // convert from rewards to points and vice-versa
    result = conversion_type === 'AMOUNT_TO_REWARDS' ? amount * 1.0 / factor : amount * factor;
    // Choose final precision based on downstream requirements
    var res = toNumber(result, precision, rounding);

    return res;
};

/**
 * Conversion business logic.
 * It decides when to convert and when not to and
 * finally returns the appropriate formated value.
 *
 * @param {*} conversion_type
 * @param {*} amount
 * @param {*} [ctx={}]
 * @returns
 */
var convert = exports.convert = function convert(conversion_type, amount) {
    var ctx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!amount || !conversion_type) {
        return '';
    }
    var _ctx$conversion_metad2 = ctx.conversion_metadata,
        conversion_metadata = _ctx$conversion_metad2 === undefined ? {} : _ctx$conversion_metad2,
        _ctx$issuerData = ctx.issuerData,
        issuerData = _ctx$issuerData === undefined ? {} : _ctx$issuerData,
        currency_code = ctx.currency_code;

    var skip = !force && conversionDetails(issuerData.rewardsType, conversion_type).skipConversion;
    var converted = skip ? toNumber(amount) : convertValue(amount, conversion_type, conversion_metadata);

    converted = toCommaSeparatedString(converted, {
        rewards_type: issuerData.rewardsType,
        conversion_metadata: conversion_metadata,
        conversion_type: conversion_type,
        currency_code: currency_code
    });
    return converted;
};

/**
 * Checks for paynow vs continue usecase
 * TODO: expand and move logic to $CheckoutAppDataModel
 *
 * @param {*} checkoutAppData
 * @returns Boolean
 */
var isPayNow = exports.isPayNow = function isPayNow(checkoutAppData) {
    var isWPS = checkoutAppData.is_wps_flow();
    var userAction = checkoutAppData.useraction();

    return !!(!isWPS && userAction === 'commit');
};

/**
 * UI related operations to be performed on select.
 *
 * @param {*} plan
 * @param {*} selectedmethod
 * @param {*} isReplan
 */
var setSelectedPlan = exports.setSelectedPlan = function setSelectedPlan(plan, selectedmethod, isReplan) {
    // use applyAsync in order to wait for all plans to be updated and etc.
    // Wait for the radio buttons to have all the latest plan ids in its scope
    if (selectedmethod) {
        _angular.$rootScope.$applyAsync(function () {
            selectedmethod.planId = getPlanID(plan); // force UI selected method to use non-reward plan.
            selectedmethod.index = isReplan ? 0 : selectedmethod.index; // reset index on replan
            selectedmethod.rewardsChosenPlan = getPlanID(plan);
        });
    }
};

/**
 * UI related operations to be performed on de-select.
 *
 * @param {*} plan
 * @param {*} selectedmethod
 */
var clearSelectedPlan = exports.clearSelectedPlan = function clearSelectedPlan(plan, selectedmethod) {
    var hasPlanSelected = selectedmethod && selectedmethod.rewardsChosenPlan === getPlanID(plan);

    if (hasPlanSelected) {
        delete selectedmethod.rewardsChosenPlan;
    }
};

/**
 * Returns the primaryFI for multi-fi use case
 * else returns the first FI for single FI use case
 *
 * @param {*} plan
 * @returns {*} fiPayload
 */
var getPrimaryFI = exports.getPrimaryFI = function getPrimaryFI(plan) {
    // TODO: return '' instead of {}
    if (!plan || !getPlanID(plan)) {
        return {};
    }
    var firstPlanFi = plan && plan.sources && plan.sources[plan.sources.length - 1];
    var fi = plan && plan.primaryFs || firstPlanFi || {};

    fi.instrument_id = fi.instrument_id || fi.id;
    return fi;
};

/**
 *  Given a planId it returns a complete plan object
 *
 * @param {*} checkoutSession
 * @param {*} planId
 * @returns
 */
var getPlanFromId = exports.getPlanFromId = function getPlanFromId(checkoutSession, planId) {
    var matchingPlans = _squid.$util.filter(checkoutSession.fundingOptions.plans, function (plan) {
        if (getPlanID(plan) === planId) {
            return plan;
        }
    });

    return matchingPlans && matchingPlans.length > 0 ? matchingPlans[0] : '';
};

/**
 * Returns the initial value to use considering
 * cart amount and rewards availability
 *
 * @param {*} models
 * @param {*} rewardsPayload
 * @returns
 */
var getInitialRewardsValue = exports.getInitialRewardsValue = function getInitialRewardsValue(models, rewardsPayload) {
    // TODO: Consider relying only on PAPS amount for initial value.
    // It would help with page refresh use case.
    var constraint = rewardsPayload.rewards_constraint;
    var grossTotal = toNumber(models.checkoutCart.purchase.amounts.total.amount, 2);

    if (!constraint.maximum_usable) {
        return grossTotal;
    }
    var maximumUsuableRewards = toNumber(constraint.maximum_usable.value);
    var initialValue = grossTotal < maximumUsuableRewards ? grossTotal : maximumUsuableRewards;

    return initialValue;
};

/**
 *  Checks if the plan has PayPal balance in it
 *
 * @param {*} plan
 */
var isPayPalBalanceSelected = exports.isPayPalBalanceSelected = function isPayPalBalanceSelected() {
    var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // TODO: should default initialize to {} or error handle ?
    var sources = plan.sources || plan.secondaryFIs || [];

    return sources.some(function (source) {
        return source.type === 'BALANCE';
    });
};

/**
 * Return the current selected plan id.
 * Prioritize clickSelectedPlanID
 * over sessionSelectedPlanID
 *
 * @param {*} selectedmethod
 * @param {*} checkoutSession
 * @returns {*} planID
 */
var getSelectedPlan = exports.getSelectedPlan = function getSelectedPlan(selectedmethod, checkoutSession) {
    var clickSelectedPlanID = selectedmethod && selectedmethod.planId;
    var sessionSelectedPlan = checkoutSession && checkoutSession.plan || {};
    var sessionSelectedPlanID = getPlanID(sessionSelectedPlan);
    var selectionID = selectedmethod ? clickSelectedPlanID // Radio checkbox selection
    : sessionSelectedPlanID; // selectFI use-case, session selection

    return selectionID;
};

/**
 * Given some contraints and a checkoutSession, return the plan that matches exactly
 * TODO: HANDLE BALANCE PROPERLY
 * @param {String} instrumentId
 * @param {String} balance The currency code of the balance to be used
 * @param {Boolean} rewards Whether to use the rewards plan or not
 * @returns {String} planId of the plan to select
 */
var matchPlanFromConstraints = exports.matchPlanFromConstraints = function matchPlanFromConstraints(_ref) {
    var instrumentId = _ref.instrumentId,
        balance = _ref.balance,
        rewards = _ref.rewards,
        checkoutSession = _ref.checkoutSession;

    return checkoutSession.get('fundingOptions.plans', []).find(function (plan) {
        var idMatches = plan.primaryFs.id === instrumentId;
        var planHasBalance = plan.secondaryFIs && plan.secondaryFIs.length;
        var balanceMatches = balance && planHasBalance || !balance && !planHasBalance;
        var rewardsMatches = rewards && plan.rewards || !rewards && !plan.rewards;

        if (!idMatches || !balanceMatches || !rewardsMatches) {
            return false;
        }

        return plan;
    });
};

_angular.$rootScope;

_squid.$util;

_squid.$locale;

_squid.formatCurrency;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/add-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            sidebar: '=?',
            update: '=?',
            renderBillingAddCheckbox: '=?',
            shippingChangeFeature: '=?',
            backUri: '=?'
        },
        controller: function controller() {}
    };
});

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddShippingRoute = undefined;

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/route.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js");

var $AddShippingRoute = exports.$AddShippingRoute = _squid.$ComponentRoute.extend('$AddShippingRoute', {
    name: 'addShipping',
    directive: 'xo-add-shipping',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        fptiState: 'add_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address',
                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    loginRequired: true,
    children: [{
        name: '$AddressNormalizationRoute',
        attributes: {
            id: 'token',
            sidebar: 'sidebar',
            address: 'address',
            'done-fn': 'uponNormalization'
        }
    }]
});

angular.value("$AddShippingRoute", $AddShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/add-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" shipping-change-feature=\"shippingChangeFeature\" render-billing-add-checkbox=\"renderBillingAddCheckbox\" back-uri=\"backUri\" done-uri=\"backUri\"></xo-shipping-address>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/delete-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/delete-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoDeleteShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sidebar: '=?'
        },
        controller: ['$scope', function ($scope) {
            var contingencyMapping = {
                RISK_CHECK_FAILED: 'deleteShipping.genericError',
                ADDRESS_ALREADY_REMOVED: 'deleteShipping.genericError',
                ADDRESS_CANNOT_REMOVE_PRIMARY: 'deleteShipping.primaryOrBillingAddress',
                ADDRESS_CANNOT_REMOVE_BILLING: 'deleteShipping.primaryOrBillingAddress',
                ADDRESS_CANNOT_REMOVE_SELECTED: 'deleteShipping.selectedAddress',
                ACCOUNT_NEGATIVE_BALANCE: 'deleteShipping.genericError',
                ADDRESS_CANNOT_REMOVE: 'deleteShipping.genericError'
            };

            function isPrimaryOrSelected(address) {
                return address.primary_address || address.default_address;
            }

            function removeAddress(address) {
                $('#deleteShipping .address' + address.idx).addClass('collapse');
                (0, _angular.$timeout)(function () {
                    $scope.checkoutShippingAddresses.addresses = $scope.checkoutShippingAddresses.addresses.filter(function (item) {
                        return item.id !== address.id;
                    });
                    $scope.$broadcast('addressUpdated');
                }, 600);
            }

            (0, _squid.$populate)($scope, {
                checkoutShippingAddresses: _index.$CheckoutShippingAddressesModel.instance($scope.token)
            }).then(function () {
                $scope.checkoutShippingAddresses.addresses.forEach(function (address, index) {
                    address.showDelete = address.isDeletable = !isPrimaryOrSelected(address);
                    address.idx = index;
                });
                $scope.$broadcast('addressUpdated');
            });

            $scope.backUrl = 'checkout.review.sidebar.shipping';

            // Return on modal cancel
            $scope.goBack = function () {
                _uiRouter.$state.go($scope.backUrl);
            };

            // Needed the three variables for animating buttons slide in/out
            $scope.onDelete = function (address) {
                address.showConfirm = true;
                $scope.checkoutShippingAddresses.addresses.forEach(function (item) {
                    if (item.deleteClicked) {
                        $('#deleteShipping .address' + item.idx + ' .address').removeClass('slide');
                        $('#deleteShipping .address' + item.idx + ' .confirm').removeClass('slidein');
                        item.showDelete = true;
                        (0, _angular.$timeout)(function () {
                            item.deleteClicked = false;
                            item.showConfirm = false;
                            $('#deleteShipping .address' + item.idx + ' .delete:not(.confirm)').removeClass('slideOut');
                        }, 500);
                    }
                });

                address.deleteClicked = true;
                $('#deleteShipping .address' + address.idx + ' .delete:not(.confirm)').addClass('slideOut');
                (0, _angular.$timeout)(function () {
                    $('#deleteShipping .address' + address.idx + ' .confirm').addClass('slidein');
                    $('#deleteShipping .address' + address.idx + ' .address').addClass('slide');
                    address.showDelete = false;
                });
                // Focus the confirm link when it comes into view after the css animation
                (0, _angular.$timeout)(function () {
                    $('#deleteShipping .address' + address.idx + ' .confirmBtn').focus();
                }, 500);
            };

            $scope.showDelete = function (address) {
                return address.isDeletable && address.showDelete;
            };

            $scope.showConfirmDelete = function (address) {
                return address.isDeletable && address.showConfirm;
            };

            $scope.showInfoMsgIcon = function (address) {
                return isPrimaryOrSelected(address);
            };

            $scope.toggleInfoMessage = function (address) {
                if (address.default_address) {
                    address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_SELECTED;
                } else if (address.primary_address) {
                    address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_PRIMARY;
                }
                // Toggle the info message
                (0, _angular.$timeout)(function () {
                    var msg = angular.element('#deleteShipping .address' + address.idx + ' .msg-inline');
                    // eslint-disable-next-line no-unused-expressions

                    if (msg.hasClass('expand')) {
                        msg.removeClass('expand');
                        address.contingencyInfoMsgKey = '';
                    } else {
                        msg.addClass('expand');
                    }
                });
            };

            $scope.onConfirmDelete = function (address) {
                return address.action('delete', {
                    success: function success() {
                        return removeAddress(address);
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            if (name === 'ADDRESS_ALREADY_REMOVED') {
                                removeAddress(address);
                                return;
                            }

                            address.isDeletable = false;
                            address.contingencyErrorMsgKey = contingencyMapping[name] || contingencyMapping.ADDRESS_CANNOT_REMOVE;
                            $('#deleteShipping .address' + address.idx + ' .address').removeClass('slide');
                            $('#deleteShipping .address' + address.idx + ' .address').addClass('slideFast');
                            (0, _angular.$timeout)(function () {
                                $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
                            }, 500);
                        }
                    }
                });
            };

            // Provide watch value for modal-box and select-box to recalculate keyboard behavior based on number of infoMsgIcons and confirmLinks
            $scope.numModalElements = function () {
                if (!$scope.checkoutShippingAddresses.addresses) {
                    return 0;
                }
                // Track messages by index, if they have flags active, seeing which flags they have active
                return $scope.checkoutShippingAddresses.addresses.reduce(function (sum, address, index) {
                    var item = $scope.showInfoMsgIcon(address) || $scope.showConfirmDelete(address) ? index + 1 : 0;

                    return sum + item;
                }, 0);
            };
        }]
    };
});

_angular.$timeout;

_squid.$populate;

_uiRouter.$state;

_index.$CheckoutShippingAddressesModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/delete-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$DeleteShippingRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/delete-shipping/directive.js");

var $DeleteShippingRoute = exports.$DeleteShippingRoute = _squid.$ComponentRoute.extend('$DeleteShippingRoute', {
    name: 'deleteShipping',
    directive: 'xo-delete-shipping',
    titleContent: 'asideHeader.deleteShipping',
    trackingData: {
        fptiState: 'delete_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::delete_shipping',
                'pagename2': '%::delete_shipping:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$DeleteShippingRoute", $DeleteShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/delete-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"{'aside': sidebar, 'fullpage': !sidebar}\" id=\"deleteShipping\" modal-box=\"numModalElements()\" modal-cancel=\"goBack()\">\n        <xo-aside-header heading='asideHeader.deleteShipping' back-url=\"{{backUrl}}\"></xo-aside-header>\n\n        <div class=\"asideContent showAll\" xo-tray-height content>\n            <ul class=\"items\" focus-when focus-refresh-on=\"'addressUpdated'\">\n                <li ng-repeat=\"address in checkoutShippingAddresses.addresses track by $index\" role=\"presentation\" class=\"item address{{address.idx}}\">\n                    <div class=\"itemInner\">\n                        <div class=\"address\" ng-class=\"{'notDeletable': !address.isDeletable}\">\n                            <span class=\"display fullName\">{{address.recipient_name}}</span>\n                            <xo-address-display address=address country-code=countryCode show-preferred=\"true\"></xo-address-display>\n                        </div>\n                        <div>\n                            <span class=\"msgIcon\"\n                               ng-if=\"showInfoMsgIcon(address)\"\n                               ng-click=\"toggleInfoMessage(address)\"\n                               aria-label=\"{{'More Info for ' + address.line1 +'...'}}\"\n                               aria-expanded=\"{{address.contingencyInfoMsgKey ? true : false}}\">\n                            </span>\n                        </div>\n                        <div ng-if=\"address.isDeletable\">\n                            <div class=\"delete\" ng-if=\"showDelete(address)\">\n                                <a track-link=\"address_delete\"\n                                   href=\"\"\n                                   ng-click=\"onDelete(address)\"\n                                   class=\"deleteBtn\"\n                                   aria-label=\"{{content('deleteShipping.delete') +' address: '+ address.line1 +'...'}}\">\n                                    <span>{{content('deleteShipping.delete')}}</span>\n                                </a>\n                            </div>\n                            <div class=\"delete confirm\" ng-if=\"showConfirmDelete(address)\">\n                                <a track-link=\"address_delete_confirm\"\n                                   href=\"\" ng-click=\"onConfirmDelete(address)\"\n                                   class=\"confirmBtn focusableIcon\"\n                                   aria-label=\"{{content('deleteShipping.confirm') +' address delete: '+ address.line1 +'...'}}\">\n                                    <span>{{content('deleteShipping.confirm')}}</span>\n                                </a>\n                            </div>\n                        </div>\n                        <div class=\"msg-inline\" ng-if=\"address.contingencyInfoMsgKey\">\n                            <div class=\"msg-inlineInner\" tabindex=\"-1\" focus-when=\"address.contingencyInfoMsgKey\">\n                                <span>{{content(address.contingencyInfoMsgKey)}}</span>\n                            </div>\n                        </div>\n                        <div class=\"msg-inline msg-error\" ng-if=\"address.contingencyErrorMsgKey\">\n                            <div class=\"msg-inlineInner\" tabindex=\"-1\" focus-when=\"address.contingencyErrorMsgKey\">\n                                <span class=\"icon\"></span>\n                                <div class=\"content\">{{content(address.contingencyErrorMsgKey)}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/xo-member-components/src/select-shipping/select-shipping/directive.js"), __webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/directive.js"), __webpack_require__("../node_modules/xo-member-components/src/select-shipping/delete-shipping/directive.js"), __webpack_require__("../node_modules/xo-member-components/src/select-shipping/update-shipping/directive.js"), __webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/select-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/select-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSelectShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            doneFn: '=?',
            backUri: '=?',
            shippingChangeFeature: '=?'
        },
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                checkoutShippingAddresses: _index.$CheckoutShippingAddressesModel.create($scope.token)
            }).then(function () {
                // Do not remove error message in review page when user does not change shipping address
                if (!($scope.checkoutSession.get('message.type') === 'error')) {
                    $scope.checkoutSession.message = null;
                }
                $scope.deleteShipping = function () {
                    if ($scope.backUri === 'checkout.shipTo') {
                        return false;
                    }
                    return $scope.checkoutShippingAddresses.addresses.some(function (address) {
                        return !(address.primary_address || address.default_address);
                    });
                };
            });

            $scope.onSelect = function (address) {
                if (!address.disable_for_transaction) {
                    address.action('select', {
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressUpdated']
                            };
                            $scope.checkoutShippingAddresses.invalidate();

                            if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.callOnShippingChange) {
                                $scope.shippingChangeFeature.callOnShippingChange(function () {
                                    $scope.doneFn(address);
                                });
                            } else {
                                $scope.doneFn(address);
                            }
                        }
                    });
                }
            };

            $scope.locale = _squid.$locale;
            $scope.addLink = function () {
                if ($scope.backUri === 'checkout.shipTo') {
                    return 'checkout.shipTo.sidebar.addShipping';
                }
                return 'checkout.review.sidebar.addShipping';
            };

            // Construct message object for block non-domestic shipping alert
            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
            var countryName = (0, _squid.$renderContent)('countryList.' + merchantCountry);
            var infoMessage = (0, _squid.$renderContent)('selectShipping.blockNonDomesticShippingInfo', {
                shippingCountry: countryName
            });

            $scope.blkNonDomesticShippingMsg = {
                msgs: [infoMessage],
                type: 'desc'
            };
        }]
    };
});

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index.$CheckoutShippingAddressesModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/select-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"selectShipping\" content modal-box modal-refresh-on=\"'populated'\" modal-cancel=\"doneFn()\">\n    <xo-aside-header ng-if=\"deleteShipping()\" hdrtype='tall' heading='asideHeader.selectShipping'\n                     sub-header-left-link='checkout.review.sidebar.addShipping'\n                     sub-header-left=\"asideHeader.add\"\n                     sub-header-left-icon=\"true\"\n                     sub-header-right-link='checkout.review.sidebar.deleteShipping'\n                     sub-header-right=\"asideHeader.delete\"\n                     sub-header-right-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header hdrtype='tall' heading='asideHeader.selectShipping'\n                     ng-if=\"!deleteShipping()\"\n                     back-url=\"{{backUri}}\"\n                     sub-header-left-link=\"{{addLink()}}\"\n                     sub-header-left=\"asideHeader.add\"\n                     sub-header-left-icon=\"true\"></xo-aside-header>\n\n    <div class=\"asideContent showAll\" xo-tray-height>\n        <ul class=\"items\" select-box=\"checkoutShippingAddresses.addresses\" select-allow-tab-escape>\n            <li ng-repeat=\"address in checkoutShippingAddresses.addresses track by $index\"\n                role=\"presentation\"\n                class=\"address trayInner trayInnerDefault\"\n                ng-class=\"{selectable: !address.default_address, disabled: address.disable_for_transaction}\">\n\n                <xo-message ng-if=\"address.disable_for_transaction\" message=\"blkNonDomesticShippingMsg\"\n                            class=\"shippingBlk\"></xo-message>\n\n                <a track-submit href=\"\" ng-click=\"onSelect(address)\" class=\"shippingBlk\" select-option=\"address.default_address\" focus-when=\"address.default_address\" role=\"option\" ng-attr-aria-selected=\"{{ address.default_address ? 'true' : undefined }}\">\n                    <span class=\"display fullName\">{{address.recipient_name}}</span>\n                    <xo-address-display address=address country-code=countryCode\n                                        show-preferred=\"true\"></xo-address-display>\n                    <span class=\"checkIcon\" ng-if=\"address.default_address\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoShippingAddress', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            sidebar: '=?',
            update: '=?',
            renderBillingAddCheckbox: '=?',
            backUri: '=?',
            doneUri: '=?',
            shippingChangeFeature: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            if (!$scope.sidebar) {
                $scope.pageTitle = (0, _squid.$renderContent)('addShipping.addAddress');
            }
            $scope.backUri = $scope.backUri || 'checkout.review.sidebar.shipping';
            $scope.heading = $scope.update ? 'addressNormalization.update' : 'asideHeader.addShipping';
            $scope.buttonLabel = function () {
                if (!$scope.sidebar || $scope.address.country === 'BR' && !$scope.prefilled) {
                    return (0, _squid.$renderContent)('common.continueLabel');
                } else {
                    return (0, _squid.$renderContent)('common.save');
                }
            };
            $scope.address = {
                country: _squid.$locale.getCountryCodeISO()
            };
            $scope.isShipping = true;
            $scope.normalize = function () {
                return (0, _squid.$feature)('addressNormalization') && (0, _squid.$feature)('shippingAddressNormalization') && $scope.address.country === _squid.$locale.country // Should be domestic address
                && !$scope.normalized;
            };

            $scope.showshipping = true;
            $scope.country = _squid.$locale.country;
            $scope.recipient = {
                first_name: '',
                last_name: ''
            };

            var $el = $($element);

            function focusFirstError() {
                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            }

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                var contingencyPrefilledAddress = void 0;

                if ((0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry)) {

                    $scope.disableChangeShippingCountry = $scope.checkoutAppData.get('flags.block_non_domestic_shipping', false);

                    if ($scope.disableChangeShippingCountry) {

                        $scope.address.country = merchantCountry;

                        contingencyPrefilledAddress = $scope.checkoutSession.get('errorData.resolution.data', null);
                        if (!$scope.sidebar && contingencyPrefilledAddress) {
                            angular.extend($scope.address, {
                                line1: contingencyPrefilledAddress.line1,
                                line2: contingencyPrefilledAddress.line2,
                                city: contingencyPrefilledAddress.city,
                                state: contingencyPrefilledAddress.state,
                                postal_code: contingencyPrefilledAddress.postal_code
                            });
                        }

                        _logger.$logger.info('member_block_non_domestic_shipping', {
                            block_non_domestic_shipping: $scope.disableChangeShippingCountry,
                            sidebar: $scope.sidebar
                        });

                        var countryName = (0, _squid.$renderContent)('shippingCountry.' + merchantCountry);
                        var infoMessage = (0, _squid.$renderContent)('largeScreenPayment.blockNonDomesticShippingAlert', {
                            shippingCountry: countryName
                        });

                        $scope.message = {
                            msgs: [infoMessage],
                            type: 'warning'
                        };
                    }
                }

                $scope.prefill = function () {
                    $scope.prefillAddress = new _index.$PrefillAddressModel({
                        id: $scope.token,
                        address: {
                            country: _squid.$locale.country,
                            postal_code: $scope.address.postal_code
                        }
                    });

                    $scope.prefillAddress.save({
                        data: $scope.prefillAddress,
                        success: function success(result) {
                            if (result) {
                                $scope.address = result;
                            }
                            $scope.prefilled = true;
                            $scope.address.first_name = $scope.recipient.first_name;
                            $scope.address.last_name = $scope.recipient.last_name;

                            (0, _angular.$timeout)(function () {
                                var value = $scope.address.state;
                                var $option = $el.find('[value="' + value + '"]');

                                $option.prop('selected', 'selected');
                                $option.trigger('change');

                                value = $option.attr('label');
                                focusFirstError();
                            }, 1000);
                        }
                    });
                };

                if ($scope.update) {
                    if ($scope.checkoutSession.shipping.name) {
                        var name = $scope.checkoutSession.shipping.name.trim();
                        var index = name.indexOf(' ');

                        $scope.recipient.first_name = name.substr(0, index);
                        $scope.recipient.last_name = name.substr(index + 1);
                    }
                    $scope.address.postal_code = $scope.checkoutSession.get('shipping.postal_code', '');
                    $scope.prefill();
                }

                function handleValidation(res) {
                    if (res && res.fields && res.fields.length) {
                        res.fields.forEach(function (field) {
                            if (field.field) {
                                var $field = $($el.find('[ng-model="address.' + field.field + '"]'));

                                if ($field.length === 0 && field.field === 'zip') {
                                    $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                                }
                                $field.addClass('backendError');
                                $field.attr('aria-invalid', true);
                            }
                        });
                        focusFirstError();
                    }
                }

                $scope.cancelFn = function () {
                    _uiRouter.$state.go('checkout.review.sidebar.shipping');
                };

                $scope.onSubmit = function () {
                    if ($scope.address.country === 'BR' && $scope.address.country === _squid.$locale.country && !$scope.prefilled) {
                        return $scope.prefill();
                    }

                    if ($scope.normalize()) {
                        $scope.showshipping = false;
                        _uiRouter.$state.go('.addressNormalization');
                    } else {
                        $scope.submitAddress();
                    }
                };

                $scope.removeValidation = function () {
                    $el.find('form').removeClass('validated');
                };

                function prefilledAddressUnchanged(prefilledAddress, addressToSubmit) {

                    function lowercaseEquals(str1, str2) {
                        return angular.lowercase(str1) === angular.lowercase(str2);
                    }

                    return lowercaseEquals(prefilledAddress.recipient_name, addressToSubmit.recipient_name) && lowercaseEquals(prefilledAddress.line1, addressToSubmit.line1) && lowercaseEquals(prefilledAddress.line2, addressToSubmit.line2) && lowercaseEquals(prefilledAddress.city, addressToSubmit.city) && lowercaseEquals(prefilledAddress.state, addressToSubmit.state) && lowercaseEquals(prefilledAddress.postal_code, addressToSubmit.postal_code) && lowercaseEquals(prefilledAddress.country_code, addressToSubmit.country);
                }

                function callOnShippingChange(callback) {
                    if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.callOnShippingChange) {
                        $scope.shippingChangeFeature.callOnShippingChange(callback);
                    } else {
                        callback();
                    }
                }

                function updateAddress(payload) {
                    $scope.checkoutSession.shipping.action('update', {
                        data: payload,
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressAdded']
                            };

                            callOnShippingChange(function () {
                                return $scope.doneFn(result);
                            });
                        },
                        validation: function validation(res) {
                            handleValidation(res);
                        }
                    });
                }

                function addAddress(payload) {
                    // make sure this param is not passed as behavior from symphony is erratic.
                    delete payload.address_id;
                    $scope.shippingAddress = _index2.$ShippingAddressModel.create($scope.token, payload);
                    $scope.shippingAddress.save({
                        data: payload,
                        resultModel: $scope.checkoutSession,
                        success: function success(result) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['smallToolTip.addressAdded']
                            };

                            callOnShippingChange(function () {
                                return $scope.doneFn($scope.address.isBA ? payload : null);
                            });
                        },
                        validation: function validation(res) {
                            handleValidation(res);
                        },
                        contingencies: {
                            'SHIPPING_ADDRESS_INVALID': function SHIPPING_ADDRESS_INVALID() {
                                $scope.message = {
                                    type: 'error',
                                    msgKeys: ['shippingAddress.errorInfo']
                                };
                            }
                        }
                    });
                }

                $scope.submitAddress = function () {
                    if ($scope.address.preferred_address) {
                        _logger.$logger.info('addAddrPreferred.selected', {});
                    }

                    var country = $scope.address.country;
                    // keep this for compatibility
                    var recipient_name = $scope.address.first_name + ' ' + $scope.address.last_name;

                    if ((0, _squid.$feature)('nameFormat', country, country) === 'LastFirst') {
                        recipient_name = $scope.address.last_name + ' ' + $scope.address.first_name;
                    }

                    var data = {
                        recipient_name: recipient_name,
                        first_name: $scope.address.first_name,
                        last_name: $scope.address.last_name,
                        line1: $scope.address.line1,
                        line2: $scope.address.line2,
                        city: $scope.address.city,
                        state: $scope.address.state,
                        postal_code: $scope.address.postal_code,
                        country: country,
                        normalization_status: $scope.address.normalization_status,
                        preferred_address: $scope.address.preferred_address,
                        default_address: true
                    };

                    if (contingencyPrefilledAddress && prefilledAddressUnchanged(contingencyPrefilledAddress, data)) {
                        data.address_id = contingencyPrefilledAddress.id;
                    }
                    // Update is used for the address normalization flow.
                    data.address_id = data.address_id ? data.address_id : $scope.checkoutSession.get('shipping.id');
                    if ($scope.update && data.address_id) {
                        updateAddress(data);
                    } else {
                        addAddress(data);
                    }
                };

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $scope.normalized = false;
                        $scope.showshipping = true;
                        _uiRouter.$state.go('^');
                    } else {
                        $scope.address = normalizedAddress;
                        $scope.normalized = true;
                        $scope.address.first_name = $scope.recipient.first_name;
                        $scope.address.last_name = $scope.recipient.last_name;
                        $scope.submitAddress();
                    }
                };
            });
        }]
    };
});

_angular.$timeout;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_uiRouter.$state;

_logger.$logger;

_index.$PrefillAddressModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutSessionModel;

_index2.$ShippingAddressModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/shipping-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"{'aside': sidebar, 'fullpage': !sidebar}\" id=\"addShipping\" modal-box modal-refresh-on=\"'metadataChange'\" modal-cancel=\"cancelFn()\">\n    <div ng-if=\"showshipping\">\n    <xo-aside-header ng-if=\"sidebar\" back-url=\"{{backUri}}\" heading=\"{{heading}}\"></xo-aside-header>\n\n    <div class=\"container\" ng-class=\"{'asideContent': sidebar}\" xo-tray-height>\n\n        <xo-message ng-if=\"message\" message=\"message\"></xo-message>\n        <h1 class=\"gamma\" ng-if=\"pageTitle\">{{ pageTitle }}</h1>\n\n        <div ng-if=\"update\" content>\n            <p class=\"theta\">{{ content('addressNormalization.updateIntro') }}</p>\n        </div>\n\n            <form id=\"shippingAddressForm\" name=\"shippingAddressForm\" class=\"asideView addressForm\"\n                  content novalidate form-autofocus>\n\n                <div ng-if=\"!update\">\n                    <xo-select-shipping-country shipping-address=\"address\"\n                                                disable-change-shipping-country=\"disableChangeShippingCountry\"\n                                                token=\"token\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n                </div>\n\n                <div ng-if=\"prefilled || address.country!=='BR'\">\n                    <xo-add-address country=\"address.country\" address=\"address\" is-shipping=\"true\"\n                                    token=\"token\" render-billing-add-checkbox=\"renderBillingAddCheckbox\"></xo-add-address>\n                </div>\n\n                <div ng-if=\"!prefilled && address.country==='BR'\">\n                    <xo-name-input user=\"recipient\"></xo-name-input>\n                    <xo-zipcode country=\"{{address.country}}\" address=\"address\" zip-label=\"{{content('common.cep')}}\"\n                                zip-error-key=\"common.valueInvalid\"></xo-zipcode>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"proceedButton\" data-test-id=\"saveShippingAddr\"\n                           type=\"submit\" value=\"{{buttonLabel()}}\" class=\"btn full\"  validate-submit=\"onSubmit()\"/>\n                </div>\n\n            </form>\n        </div>\n\n    </div>\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/update-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/select-shipping/update-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoUpdateShipping', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            sidebar: '=?'
        },
        controller: function controller() {}
    };
});

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/update-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UpdateShippingRoute = undefined;

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/update-shipping/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/route.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/shipping-address/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $UpdateShippingRoute = exports.$UpdateShippingRoute = _squid.$ComponentRoute.extend('$UpdateShippingRoute', {
    name: 'updateShipping',
    directive: 'xo-update-shipping',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        fptiState: 'update_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::update_shipping',
                'pagename2': '%::update_shipping:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: [{
        name: '$AddressNormalizationRoute',
        attributes: {
            id: 'token',
            sidebar: 'sidebar',
            address: 'address',
            'done-fn': 'uponNormalization'
        }
    }]
});

angular.value("$UpdateShippingRoute", $UpdateShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-member-components/src/select-shipping/update-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" update=\"true\"></xo-shipping-address>"

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoShowMoreFiLink = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-ui-components/src/link/directive.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoShowMoreFiLink = exports.$xoShowMoreFiLink = _squid.$Component.extend('$xoShowMoreFiLink', {
    tag: 'xo-show-more-fi-link',
    template: _template2['default'],
    actions: {
        showMore: function showMore() {
            _factory.$ShowMoreFiFactory.set({ isShowMoreBtnClicked: true });
            _logger.$logger.info('checkout_fpti', {
                from: '3fi',
                to: 'process_3fi'
            });
        }
    },
    lifecycle: {
        enter: function enter() {}
    }
});

angular.value("$xoShowMoreFiLink", $xoShowMoreFiLink);
_squid.$Component;

_logger.$logger;

_factory.$ShowMoreFiFactory;

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _index = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$ShowMoreFiFactory', function () {
    var state = {
        isTooManyFi: false,
        isShowMoreBtnClicked: false,
        eligible: false
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    // max number of FI to be shown by default
    // if user has <= 4 -- all 4 FI will be shown
    // if user has > 4 -- 3 FI will be shown
    var MAX_FI_NUMBER = 4;

    // condition to determine if there are too many FI's
    // to hide them and display "Show More" link
    var isTooManyFi = function isTooManyFi() {
        var planList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        return planList.length > MAX_FI_NUMBER;
    };

    // when logout -> reset flag
    _angular.$rootScope.$on('logout', function (event, args) {
        state.isShowMoreBtnClicked = false;
    });

    // returns true if:
    // 1) there are too many FI's
    // 2) "Show more" link was not clicked yet
    var isFiNeverExpanded = function isFiNeverExpanded() {
        return !state.isShowMoreBtnClicked && state.isTooManyFi;
    };

    var init = function init(planList) {
        if (!state.eligible) {
            return;
        }
        state.isTooManyFi = isTooManyFi(planList);
        if (isFiNeverExpanded()) {
            _logger.$logger.info('checkout_fpti', {
                from: '3fi',
                to: 'prepare_3fi'
            });
        }
    };

    // eligible if:
    // 1. multi fi
    // 2. 3fi pxp returns treatment
    var decideEligibility = function decideEligibility(_ref) {
        var plans = _ref.plans;

        if (!isTooManyFi(plans)) {
            return;
        }

        return _index.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
            var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

            if (multipleFiVariants.indexOf(variant) !== -1) {
                _logger.$logger.info('show_more_fi_true_choice_eligibility');
                state.eligible = true;
            }
        });
    };

    // used to show / hide individual fi entry of the plan list
    // index - selected radio box index starting from 0
    var shouldHideFiEntry = function shouldHideFiEntry(index) {
        return isFiNeverExpanded() && index + 1 > MAX_FI_NUMBER - 1;
    };

    // event handler for accessibility
    // if current index is 0 and user press UP - expand FI's
    // if current index is one which goes before the last visible one
    var selectFiOnKeyDown = function selectFiOnKeyDown(event, index) {
        if (index === 0 && event.keyCode === _ui.KEYS.UP || index + 1 >= MAX_FI_NUMBER - 2 && event.keyCode === _ui.KEYS.DOWN) {
            state.isShowMoreBtnClicked = true;
        }
    };

    return {
        get: get,
        set: set,
        init: init,
        isFiNeverExpanded: isFiNeverExpanded,
        decideEligibility: decideEligibility,
        shouldHideFiEntry: shouldHideFiEntry,
        selectFiOnKeyDown: selectFiOnKeyDown
    };
});

_angular.$rootScope;

_squid.$util;

_squid.$config;

_logger.$logger;

_ui.KEYS;

_index.$ChoiceEligibility;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/show-more-fi", "../node_modules/xo-member-components/src/show-more-fi/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-link content label=\"{{ content('common.showMoreFi') }}\" on-click=\"actions.showMore\" left-icon=\"caret-down\"></xo-link>"

/***/ }),

/***/ "../node_modules/xo-member-components/src/vaulting/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.authorize = exports.checkVaultingEligibility = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

/**
 *  checks if the current user is eligible
 *  for vaulting based on PXP
 *
 * @returns {Promise} Represents current vaulting treatment
 */
var checkPxp = function checkPxp() {
    return (0, _squid.$elmo)('xo_hermes_vaulting', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermes_vaulting_1').then(function (result) {
        return result && result.treatment_name;
    });
};

/**
 *  Checks weather a specific set of use cases are enabled/disabled.
 *
 * @returns {Object} Represents list of eligibility flags
 */
// eslint-disable-line no-unused-vars
var getEligibility = function getEligibility() {
    var token = _angular.$rootScope.token;
    var models = {};

    return (0, _squid.$populate)(models, {
        auth: _auth.$AuthModel.instance(),
        checkoutCart: _index.$CheckoutCartModel.instance(token),
        checkoutSession: _index.$CheckoutSessionModel.instance(token),
        checkoutAppData: _index.$CheckoutAppDataModel.instance(token)
    }).then(function () {
        var hasBackupFunding = models.checkoutSession.cardBackup && models.checkoutSession.cardBackup.getPlan() && models.checkoutSession.cardBackup.getPlan().planId;

        return {
            billing: models.checkoutCart.isBilling(),
            invoice: models.checkoutAppData.get('flags.is_invoice_flow'),
            upop: models.checkoutSession.unconfirmed_upop,
            walletTokenization: models.checkoutCart.isWalletTokenization(),
            threeDS: models.checkoutSession.resolve_3ds,
            sepa: models.checkoutSession.get('sepa_mandate.bankId'),
            negativeBalance: models.checkoutSession.negBals,
            poma: models.auth.password_less,
            isXoonUpopRedirect: _squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon',
            miniBrowser: _angular.$rootScope.miniBrowser,
            secondButtonCredit: models.checkoutAppData.isSecondButton(),
            hasBackupFunding: hasBackupFunding
        };
    });
};

/**
 * Checks to see whether the current vaulting experience is eligible.
 * return  the current experience based flow and pxp
 *
 * @returns {Promise} Represents current vaulting experience
 */
var checkVaultingEligibility = exports.checkVaultingEligibility = function checkVaultingEligibility() {
    var isCorp = _squid.$meta.corp;
    var isVaultFlow = _squid.$util.param('vault');

    if (isCorp && isVaultFlow === 'true') {
        _logger.$logger.info('xo_hermes_vaulting_eligibility_forced', {
            isCorp: isCorp, isVaultFlow: isVaultFlow
        });
        return _squid.$promise.resolve(isVaultFlow);
    }
    return getEligibility().then(function (eligibility) {
        // Define an explicit check since it makes the eligibility more easier to reference
        var decision = !eligibility.billing && !eligibility.invoice && !eligibility.upop && !eligibility.walletTokenization && !eligibility.threeDS && !eligibility.sepa && !eligibility.negativeBalance && !eligibility.poma && !eligibility.isXoonUpopRedirect && !eligibility.miniBrowser && !eligibility.secondButtonCredit && !eligibility.hasBackupFunding;

        _logger.$logger.info('xo_hermes_vaulting_eligibility', {
            eligibility: eligibility,
            decision: decision
        });
        return decision ? checkPxp() : _squid.$promise.resolve('');
    });
};

/**
 * Given an error use cases handles logging
 * and functionality
 *
 * @param {*} name of error
 * @param {*} err Error object
 * @param {*} type 'contingency' or 'error'
 */
var errorHandler = function errorHandler(name, err, type) {
    _logger.$logger.info('xo_hermes_vaulting_authorize_' + type, { name: name });
    throw err;
};

/**
 * Performs an authorize on checkout and returns a response
 *
 * @param {*} checkoutSession
 * @param {*} checkoutAppData
 * @returns {String} Representing next state
 */
var authorize = exports.authorize = function authorize(checkoutSession, checkoutAppData) {
    _logger.$logger.info('xo_hermes_vaulting_authorize_attempt');
    _angular.$rootScope.$emit('loadingMessage', 'Vaulting through checkout.');
    var cardBackup = checkoutSession.cardBackup && checkoutSession.cardBackup.getPlan();

    return checkoutSession.action('authorize', {
        data: {
            alternateFundingOptionId: cardBackup && cardBackup.planId
        },
        success: function success(result) {
            _logger.$logger.info('xo_hermes_vaulting_authorize_success');
            if (!window.xchild && checkoutAppData.doec_on_approve()) {
                return 'checkout.pay';
            }
            return 'checkout.end';
        },
        contingencies: function contingencies(name, err) {
            return errorHandler(name, err, 'contingency');
        },
        error: function error(name, err) {
            return errorHandler(name, err, 'error');
        }
    });
};
_angular.$rootScope;

_logger.$logger;

_squid.$locale;

_squid.$util;

_squid.$elmo;

_squid.$promise;

_squid.$populate;

_squid.$meta;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/address/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ResidentialAddressModel = exports.$ValidateAddressModel = exports.$PrefillAddressModel = exports.$AddressNormalizationModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var $AddressNormalizationModel = exports.$AddressNormalizationModel = _squid.$Model.extend('$AddressNormalizationModel', {
    api: new _squid.$Api({
        uri: '/api/address/normalize'
    })
});

var $PrefillAddressModel = exports.$PrefillAddressModel = _squid.$Model.extend('$PrefillAddressModel', {
    api: new _squid.$Api({
        uri: '/api/address/prefill'
    })
});

var $ValidateAddressModel = exports.$ValidateAddressModel = _squid.$Model.extend('$ValidateAddressModel', {
    api: new _squid.$Api({
        uri: '/api/address/validate'
    })
});

var $ResidentialAddressModel = exports.$ResidentialAddressModel = _squid.$Model.extend('$ResidentialAddressModel', {
    format: function format() {

        var langConfig = (_fi.BILLING_ADDRESS_FORMAT[_squid.$locale.country] || {})[_squid.$locale.lang] || {};

        var comma = angular.isUndefined(langConfig[',']) ? _fi.BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
        var space = angular.isUndefined(langConfig[' ']) ? _fi.BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];

        return _squid.$util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + _squid.$util.filter([this.postal_code]);
    },

    serialize: function serialize() {
        return {
            line1: this.line1 && this.line1.trim(),
            line2: this.line2 && this.line2.trim(),
            city: this.city && this.city.trim(),
            state: this.state && this.state.trim(),
            postal_code: this.postal_code && this.postal_code.trim(),
            normalization_status: this.normalization_status,
            country: this.country
        };
    }
});

angular.value("$AddressNormalizationModel", $AddressNormalizationModel);
angular.value("$PrefillAddressModel", $PrefillAddressModel);
angular.value("$ValidateAddressModel", $ValidateAddressModel);
angular.value("$ResidentialAddressModel", $ResidentialAddressModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$locale;

_fi.BILLING_ADDRESS_FORMAT;

/***/ }),

/***/ "../node_modules/xo-models/src/app/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPBlacklist = exports.$TokenizedWalletMsbOfferModel = exports.$TokenizedWalletPinModel = exports.$TokenizedFundingCapabilitiesModel = exports.$TokenizedWalletInfoModel = exports.$TokenizedWalletEligibilityModel = exports.$MessengerIntegrationDataModel = exports.$AppDataModel = exports.$LocaleConfigModel = exports.$PXPModel = exports.$TeslaFlowIdModel = undefined;

var _brandNames, _msbDisclaimerLinks;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $TeslaFlowIdModel = exports.$TeslaFlowIdModel = _squid.$Model.extend('$TeslaFlowIdModel', {
    api: new _squid.$Api({
        uri: '/api/teslaFlowId/:id'
    })
});

var $PXPModel = exports.$PXPModel = _squid.$Model.extend('$PXPModel', {
    api: new _squid.$Api({
        uri: '/api/pxp/:id'
    })
});

var $LocaleConfigModel = exports.$LocaleConfigModel = _squid.$Model.extend('$LocaleConfigModel', {
    api: new _squid.$Api({
        uri: '/api/localeConfig'
    })
});

var $AppDataModel = exports.$AppDataModel = _squid.$Model.extend('$AppDataModel', {
    api: new _squid.$Api({
        uri: '/api/app'
    }),

    isMobile: function isMobile() {
        return this.platform === 'mobile';
    }
});

var $MessengerIntegrationDataModel = exports.$MessengerIntegrationDataModel = _squid.$Model.extend('$MessengerIntegrationDataModel', {
    api: new _squid.$Api({
        uri: '/api/messenger'
    })
});

var $TokenizedWalletEligibilityModel = exports.$TokenizedWalletEligibilityModel = _squid.$Model.extend('$TokenizedWalletEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/eligibility/tokenizedWallet/:id'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    isEligible: function isEligible() {
        return this.eligible;
    }
});

var subjectTypes = {
    SAMSUNG_PAY: 'Samsung',
    ANDROID_PAY: 'google'
};

var brandNames = (_brandNames = {}, _brandNames[subjectTypes.SAMSUNG_PAY] = 'Samsung Pay', _brandNames[subjectTypes.ANDROID_PAY] = 'Google Pay', _brandNames);

/**
 * disclaimer links used on the *pay review page
 */
var disclaimerLinks = function disclaimerLinks(country) {
    var _ref;

    return _ref = {}, _ref[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppsamsungpay-tnc', _ref[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppandroidpay-tnc', _ref;
};

// disclaimer links used on Msb offer popup
var msbDisclaimerLinks = (_msbDisclaimerLinks = {}, _msbDisclaimerLinks[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/us/smarthelp/article/samsung-pay-terms-and-conditions-faq3863', _msbDisclaimerLinks[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/us/smarthelp/article/google-pay-terms-and-conditions-faq3862', _msbDisclaimerLinks);

/**
 * this model populates data from tokenized wallet mayfly object
 * (see xo-hermes-app/apis/tokenizedWalletInfo) which contains:
 *
 * - wallet_id (used for both Samsung Pay and Android Pay)
 * - external_device_id (used for Samsung Pay only)
 * - subject (used for both Samsung Pay and Android Pay)
 *
 * Note: model is being populated in xo-preload on the server (see config.json)
 */

var $TokenizedWalletInfoModel = exports.$TokenizedWalletInfoModel = _squid.$Model.extend('$TokenizedWalletInfoModel', {

    api: new _squid.$Api({
        uri: '/api/info/tokenizedWallet/:id'
    }),

    isAndroidPay: function isAndroidPay() {
        return this.subject === subjectTypes.ANDROID_PAY;
    },

    isSamsungPay: function isSamsungPay() {
        return this.subject === subjectTypes.SAMSUNG_PAY;
    },

    getSubject: function getSubject() {
        return this.subject || subjectTypes.ANDROID_PAY;
    },

    // until we use mayfly for android pay - fallback to Android Pay
    brandName: function brandName() {
        return brandNames[this.subject] || brandNames[subjectTypes.ANDROID_PAY];
    },

    // until we use mayfly for android pay - fallback to Android Pay
    getDisclaimerLink: function getDisclaimerLink() {
        var country = _squid.$locale.country.toLowerCase();

        return disclaimerLinks(country)[this.subject] || disclaimerLinks(country)[subjectTypes.ANDROID_PAY];
    },

    // get Msb terms and conditions link based on the subject
    getMsbDisclaimerLink: function getMsbDisclaimerLink() {
        return msbDisclaimerLinks[this.subject] || msbDisclaimerLinks[subjectTypes.ANDROID_PAY];
    }
});

var $TokenizedFundingCapabilitiesModel = exports.$TokenizedFundingCapabilitiesModel = _squid.$Model.extend('$TokenizedFundingCapabilitiesModel', {
    api: new _squid.$Api({
        uri: '/api/capabilities/tokenizedWallet/:id'
    }),
    invalidateOnLogout: true,

    isDirectFundingEnabled: function isDirectFundingEnabled() {
        return this.directFundingEnabled;
    },

    isTopupEnabled: function isTopupEnabled() {
        return this.topupFundingEnabled;
    },
    getProductName: function getProductName() {
        return this.name;
    },

    getCurrency: function getCurrency() {
        return this.issuingCurrency;
    },

    getContingencies: function getContingencies() {
        return this.contingencies;
    },

    getTopupAmountChoices: function getTopupAmountChoices() {
        return this.topUpAmountChoices;
    }
});

var $TokenizedWalletPinModel = exports.$TokenizedWalletPinModel = _squid.$Model.extend('$TokenizedWalletPinModel', {
    api: new _squid.$Api({
        uri: '/api/pin/tokenizedWallet/:id'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    getPinOrigin: function getPinOrigin() {
        return this.pinOrigin;
    },
    getSuggestedPin: function getSuggestedPin() {
        return this.suggestedPin;
    },
    getSuggestedKey: function getSuggestedKey() {
        return this.suggestedKey;
    },
    getPinId: function getPinId() {
        return this.pinId;
    },
    isPinIdPresent: function isPinIdPresent() {
        return !!this.pinId;
    },
    isSetupEligible: function isSetupEligible() {
        return this.pinOrigin === 'UNSET' || this.pinOrigin === 'SYSTEM';
    }
});

var $TokenizedWalletMsbOfferModel = exports.$TokenizedWalletMsbOfferModel = _squid.$Model.extend('$TokenizedWalletMsbOfferModel', {
    api: new _squid.$Api({
        uri: '/api/msb/tokenizedWallet/:id'
    }),
    invalidateOnLogout: true
});

var $PXPBlacklist = exports.$PXPBlacklist = {
    isMerchantBlacklisted: function isMerchantBlacklisted(merchantId) {
        return _squid.$config.pxpBlacklist && _squid.$config.pxpBlacklist.merchant && _squid.$config.pxpBlacklist.merchant.indexOf(merchantId) !== -1;
    }
};

angular.value("$TeslaFlowIdModel", $TeslaFlowIdModel);
angular.value("$PXPModel", $PXPModel);
angular.value("$LocaleConfigModel", $LocaleConfigModel);
angular.value("$AppDataModel", $AppDataModel);
angular.value("$MessengerIntegrationDataModel", $MessengerIntegrationDataModel);
angular.value("$TokenizedWalletEligibilityModel", $TokenizedWalletEligibilityModel);
angular.value("$TokenizedWalletInfoModel", $TokenizedWalletInfoModel);
angular.value("$TokenizedFundingCapabilitiesModel", $TokenizedFundingCapabilitiesModel);
angular.value("$TokenizedWalletPinModel", $TokenizedWalletPinModel);
angular.value("$TokenizedWalletMsbOfferModel", $TokenizedWalletMsbOfferModel);
angular.value("$PXPBlacklist", $PXPBlacklist);
_squid.$config;

_squid.$locale;

_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/auth/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ULoginModel = exports.$AuthModel = exports.$AuthApi = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var $AuthApi = exports.$AuthApi = _squid.$Model.extend('$AuthApi', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    })
});

var $AuthModel = exports.$AuthModel = _squid.$Model.extend('$AuthModel', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    loggedIn: function loggedIn() {
        return this.logged_in;
    },

    isOnetouchULRedirect: function isOnetouchULRedirect() {
        return this.is_onetouch_ul_redirect;
    },

    visitorId: function visitorId() {
        return this.visitor_id;
    },

    accessToken: function accessToken() {
        return this.access_token;
    },

    accessTokenPresent: function accessTokenPresent() {
        return this.access_token_present;
    },

    refreshToken: function refreshToken() {
        return this.refresh_token;
    },

    rememberedOT: function rememberedOT() {
        return this.remembered && this.remembered_device_token;
    },

    isSessionTimeout: function isSessionTimeout() {
        return this.meta && this.meta.invalidated;
    },

    clearCookies: function clearCookies() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return this.action('clearCookies', { data: data });
    },

    isFBSkipLogin: function isFBSkipLogin() {
        /* Facebook pass the code generated in checkout URL , check for to determine it as FB Skip Login
         * if both OneTouch cookie present and if code passed by FB, login usually happens using OneTouch
         * as both are having auth state as remembered, we may look for rememberedOT as it is having remembered_device_token
         * for OneTouch identifier to differentiate both logins
         * auth_claims for OneTouch is DEVICE_TOKEN
         */
        return this.remembered && _squid.$util.param('code') && !this.rememberedOT();
    },

    showNotYou: function showNotYou() {
        var isAuthApiCall = this.is_auth_api_call;
        var isConsumerApp = _squid.$util.param('source') === 'consumerApp';
        var redirectToHermesOn3DSDecline = _squid.$util.param('redirectToHermesOn3DSDecline');
        var isUlReturnLoggedIn = _squid.$util.param('ulReturn') && this.auth_state === 'LOGGEDIN';

        // for Tokenized Venice integraion (Google Pay Venice / Samsung Pay Venice) - `not you` link should be hidden.
        // `TokenizedWalletInfoModel` is always populated in xo-preload (even for error cases - it will be just empty)
        // so we don't need to retrieve the model
        var tokenizedWalletInfo = _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token);
        var isNotVeniceTokenizedIntegration = function isNotVeniceTokenizedIntegration() {
            return !tokenizedWalletInfo || tokenizedWalletInfo && !tokenizedWalletInfo.is_venice_integration;
        };
        var isGuestVenmoAcct = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token) && this.auth_state === 'IDENTIFIED';

        // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)
        return (isAuthApiCall || this.isFBSkipLogin()) && !isConsumerApp && !redirectToHermesOn3DSDecline && !isUlReturnLoggedIn && !this.disallow_login_switch && isNotVeniceTokenizedIntegration() && !isGuestVenmoAcct;
    },

    logout: function logout() {
        _squid.$Model.bulkInvalidate('invalidateOnLogout');
        _angular.$rootScope.$broadcast('logout');
        return this.action('logout');
    },

    /**
     * Perform a logout and then redirect.
     * @param reason - used to log reason why a redirect was trigged.
     */
    logoutAndRedirect: function logoutAndRedirect() {
        var _this = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'logout';

        var logoutFrom = this.get('tenant', 'PAYPAL');

        return this.logout().then(function () {
            return _this.redirectToLogin(reason, { logoutFrom: logoutFrom });
        });
    },

    // redirect to UL as landing through xo-landing-router
    // so first it hits hermes app and then redirects to UL
    redirectToLogin: function redirectToLogin(reason, ctx) {
        if (!reason) {
            return false;
        }
        // current query parameters
        var qs = _squid.$util.queryString() || '';
        var params = { 'ulClientRedirect': reason };

        params = _squid.$util.extend(params, ctx); // update params with context that may be sent

        // insert "ulClientRedirect" param and remove "ul", "ulReturn"
        var updatedQs = _squid.$util.queryStringSplice(qs, params, ['ul', 'ulReturn']);

        // base url should not be hardcoded to "/webapps/hermes" due to other use cases such as
        // 1. * Pay (Android Pay / Samsung Pay) -- uses /agreements/setup to exchange BA token to EC token
        var ulAsLandingUrl = _squid.$util.paypalURL('' + window.location.pathname + updatedQs);

        _logger.$logger.info('redirecting_to_ulAsLanding');
        return _squid.$util.redirect(ulAsLandingUrl);
    }

});

var $ULoginModel = exports.$ULoginModel = _squid.$Model.extend('$ULoginModel', {
    api: new _squid.$Api({
        uri: '/api/auth/ulogin',
        postAttempts: 1,
        cache: false
    })
});

angular.value("$AuthApi", $AuthApi);
angular.value("$AuthModel", $AuthModel);
angular.value("$ULoginModel", $ULoginModel);
_angular.$rootScope;

_squid.$Model;

_squid.$Api;

_squid.$util;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-models/src/bml/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$BMLApplicationModel = exports.$BMLModel = exports.$ApplyForBMLModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ApplyForBMLModel = exports.$ApplyForBMLModel = _squid.$Model.extend('$ApplyForBMLModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/cart',
        cache: true
    }),

    personalInformation: {
        day: '',
        month: '',
        year: '',
        natId: '',
        phone: {
            telephone: '',
            phoneType: ''
        }
    },

    billingAdrress: {
        phoneType: '',
        phoneNumber: ''
    }
});

var $BMLModel = exports.$BMLModel = _squid.$Model.extend('$BMLModel', {
    api: new _squid.$Api({
        uri: '/api/bml',
        cache: false
    }),

    applicationStatus: function applicationStatus() {
        return this.application_status;
    },

    applicationId: function applicationId() {
        return this.application_id;
    }
});

var $BMLApplicationModel = exports.$BMLApplicationModel = _squid.$Model.extend('$BMLApplicationModel', {
    api: new _squid.$Api({
        uri: '/api/bml/:application_id',
        cache: false
    })
});

angular.value("$ApplyForBMLModel", $ApplyForBMLModel);
angular.value("$BMLModel", $BMLModel);
angular.value("$BMLApplicationModel", $BMLApplicationModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$CheckoutSessionModel = exports.$CardBackupModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.serializeInstallmentsOptionsData = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _processorDecline = __webpack_require__("../node_modules/xo-models/src/processorDecline/index.js");

var _utils = __webpack_require__("../node_modules/xo-models/src/checkout/lib/utils.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/cart',
        cache: true
    }),

    isPurchase: function isPurchase() {
        return Boolean(this.purchase);
    },

    getCartCurrencyCode: function getCartCurrencyCode() {
        return _squid.$util.getProperty(this, 'purchase.amounts.total.currency_code');
    },

    // NOTE returns undefined if this is not a purchase or there is some other error
    getPurchaseAmount: function getPurchaseAmount() {
        if (!this.isPurchase()) {
            return;
        }
        var purchaseAmount = _squid.$util.getProperty(this, 'purchase.amounts.total.amount');
        var purchaseAmountFloat = parseFloat(purchaseAmount);

        return purchaseAmountFloat || undefined;
    },

    isBilling: function isBilling() {
        return Boolean(this.billing);
    },

    isReferenceTransaction: function isReferenceTransaction() {
        if (this.isBilling() && this.billing.type) {
            var isChannelInitiatedBilling = this.billing.type === 'CHANNEL_INITIATED_BILLING';
            var isMerchantInitiatedBilling = this.billing.type === 'MERCHANT_INITIATED_BILLING';
            var isMerchantInitiatedSingleBilling = this.billing.type === 'MERCHANT_INITIATED_SINGLE_BILLING';

            // isReferenceTransaction() function will return true , if any of isChannelInitiatedBilling , isMerchantInitiatedBilling ,  isMerchantInitiatedSingleBilling is true
            return isChannelInitiatedBilling || isMerchantInitiatedBilling || isMerchantInitiatedSingleBilling;
        }
        return false;
    },

    isConsumerCountry: function isConsumerCountry(country) {
        return _squid.$locale.country === country;
    },

    isRecurringPayment: function isRecurringPayment() {
        if (this.isBilling() && this.billing.type) {
            return this.billing.type === 'RECURRING_PAYMENTS';
        }
        return false;
    },

    isChargePatternImmediateOrDeferred: function isChargePatternImmediateOrDeferred() {
        return ['IMMEDIATE', 'DEFERRED'].includes(this.billing.charge_pattern);
    },

    isSubscriptionsV1: function isSubscriptionsV1() {
        return this.isBilling() && this.billing.type === 'SUBSCRIPTIONS_V1';
    },

    getBaToken: function getBaToken() {
        return this.isBilling() && this.billing.ba_token;
    },

    isBillingPurchase: function isBillingPurchase() {
        return this.isPurchase() && this.isBilling();
    },

    isBillingNoPurchase: function isBillingNoPurchase() {
        return this.isBilling() && !this.isPurchase();
    },

    getBillingDescription: function getBillingDescription() {
        return this.billing && this.billing.description;
    },

    isMultiSellerPurchase: function isMultiSellerPurchase() {
        return this.purchaseUnits && this.purchaseUnits.length > 1;
    },

    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
        return this.isPurchase() && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
    },

    isWalletTokenization: function isWalletTokenization() {
        return this.isBilling() && this.billing.intent === 'TOKENIZED_WALLET';
    },

    getExternalCallbackOptions: function getExternalCallbackOptions() {
        return this.purchaseUnits && this.purchaseUnits[0] && this.purchaseUnits[0].external_callback_options;
    }
});

var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/appData'
    }),

    useraction: function useraction() {
        // user_action from session takes precedence over CGI param.
        var incontext_integration = window.xchild && window.xchild.props.commit ? 'commit' : false;
        var rest_integration = this.flags && this.flags.user_action === 'PAY' ? 'commit' : false;

        return rest_integration || incontext_integration || _squid.$util.param('useraction');
    },

    is_wps_flow: function is_wps_flow() {
        return this.flags && this.flags.is_wps_flow;
    },

    isMerchantCountry: function isMerchantCountry(country) {
        return this.merchant.merchant_country === country;
    },

    is_snt_supported: function is_snt_supported() {
        return this.flags && this.flags.is_snt_supported;
    },

    is_snt_enabled: function is_snt_enabled() {
        return this.flags && this.flags.is_snt_enabled;
    },

    is_autoreturn_enabled: function is_autoreturn_enabled() {
        return this.merchant_preferences && this.merchant_preferences.auto_return && this.merchant_preferences.auto_return.enabled;
    },

    is_pdt_enabled: function is_pdt_enabled() {
        return this.merchant_preferences && this.merchant_preferences.pdt && this.merchant_preferences.pdt.enabled;
    },

    doec_on_approve: function doec_on_approve() {
        return this.flags && this.flags.doec_on_approve;
    },

    is_wps_subscription_flow: function is_wps_subscription_flow() {
        return this.flags && this.flags.is_wps_subscription_flow;
    },

    isWpsAutobillingFlow: function isWpsAutobillingFlow() {
        return this.flags && this.flags.is_wps_autobilling_flow;
    },

    is_wps_installmentplan_flow: function is_wps_installmentplan_flow() {
        return this.flags && this.flags.is_wps_installmentplan_flow;
    },

    /*
     * Returns a string or undefined value
     * nonEmptyReturnValue - if true, then always return non empty string
     * isSentenceBeginning - if true, and merchant brand_name and merchant_name is undefined
     *              then returns 'The merchant'. If false, returns 'the merchant'
     * NOTE: We should not return merchant_email for any reason as it is a PII
     */
    getMerchantDisplayName: function getMerchantDisplayName() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            nonEmptyReturnValue = _ref.nonEmptyReturnValue,
            isSentenceBeginning = _ref.isSentenceBeginning,
            getContent = _ref.getContent;

        var merchantName = this.merchant.brand_name || this.merchant.merchant_name;

        if (nonEmptyReturnValue) {
            var contentKey = isSentenceBeginning ? 'common.Themerchant' : 'common.themerchant';
            var merchantAltName = getContent ? getContent(contentKey) : _squid.$locale.content.get(contentKey);

            return merchantName || merchantAltName;
        }

        return merchantName;
    },

    isInvoiceFlow: function isInvoiceFlow() {
        return Boolean(this.flags && this.flags.is_invoice_flow);
    },


    // Returns true if flow should be treated as a second button (PP Credit) transaction
    isSecondButton: function isSecondButton() {
        return this.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';
    }
});

var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {
    formatLast4: function formatLast4() {
        var last4;

        if (this.last4) {
            last4 = this.last4;

            if (!this.parent.isAuthRequired) {
                last4 = 'x-' + last4;
            }
        }

        return last4;
    }
});

var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/fundingOptions',
        postAttempts: 2
    }),

    onPopulate: function onPopulate() {
        var self = this;

        angular.forEach(this.plans, function (plan) {
            if (plan.primaryFs && plan.primaryFs.type === 'BANK' && (plan.primaryFs.subtype === 'IACH' || plan.primaryFs.subtype === 'PAD')) {
                Object.defineProperty(plan.primaryFs, plan.primaryFs.subtype === 'IACH' ? 'padPlanId' : 'iachPlanId', {
                    enumerable: true,
                    configurable: false,
                    writeable: false,
                    value: self.getBankPlanIdByInstrumentId(plan.primaryFs.id, plan.primaryFs.subtype === 'IACH' ? 'PAD' : 'IACH')
                });
            }
        });
    },

    eachPlan: function eachPlan(method, context) {
        angular.forEach(this.plans, method, this);
    },

    hasECheck: function hasECheck() {
        var _instruments = this.instruments,
            instruments = _instruments === undefined ? [] : _instruments;


        return instruments.some(function (instr) {
            return instr.type === 'ECHECK' || instr.subtype === 'ECHECK';
        });
    },

    hasCredit: function hasCredit() {
        var _instruments2 = this.instruments,
            instruments = _instruments2 === undefined ? [] : _instruments2;


        return instruments.some(function (instrument) {
            return instrument.type === 'CREDIT';
        });
    },

    getBankPlanIdByInstrumentId: function getBankPlanIdByInstrumentId(id, subType) {
        var fundingInstrument = _squid.$util.find(this.plans, function (plan) {
            return plan.primaryFs && plan.primaryFs.type === 'BANK' && plan.primaryFs.id === id && plan.primaryFs.subtype === subType;
        });

        return fundingInstrument && fundingInstrument.planId;
    },

    // get IACH and PAD banks combined by plan.primaryFs.id
    // order matters, so if IACH comes first then PAD is filtered and vise versa
    getPadAndIachCombinedPlans: function getPadAndIachCombinedPlans() {
        var _this = this;

        var plans = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.plans;

        if (!plans) {
            return [];
        }
        var planIds = {};

        plans.forEach(function (plan) {
            var planId = plan.planId,
                primaryFs = plan.primaryFs;


            if (_this.isIACH(plan) && !planIds[planId]) {
                planIds[primaryFs.padPlanId] = true;
            }
            if (_this.isPAD(plan) && !planIds[planId]) {
                planIds[primaryFs.iachPlanId] = true;
            }
        });

        return plans.filter(function (plan) {
            return !planIds[plan.planId];
        });
    },

    // get plan by planId
    getPlanByPlanId: function getPlanByPlanId(id) {
        var plan = _squid.$util.find(this.plans, function (p) {
            return p.primaryFs && p.planId === id;
        });

        return plan;
    },

    getPlanSubType: function getPlanSubType() {
        var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _plan$primaryFs = plan.primaryFs;
        _plan$primaryFs = _plan$primaryFs === undefined ? {} : _plan$primaryFs;
        var subtype = _plan$primaryFs.subtype;


        return subtype;
    },


    // is plan PAD bank (bank is charged after some delay)
    isPAD: function isPAD(plan) {
        return this.getPlanSubType(plan) === 'PAD';
    },


    // is plan IACH bank (instant transfer)
    isIACH: function isIACH(plan) {
        return this.getPlanSubType(plan) === 'IACH';
    },


    // is plan MEFT bank
    isMEFT: function isMEFT(plan) {
        return this.getPlanSubType(plan) === 'MEFT';
    },


    // is plan IACH bank (instant transfer)
    isIACHWithPad: function isIACHWithPad(plan) {
        return this.isIACH(plan) && plan.primaryFs.padPlanId;
    },

    // is plan PayPal Credit (a.k.a BILL_ME_LATER)
    isPayPalCredit: function isPayPalCredit(plan) {
        return plan && plan.primaryFs.type === 'CREDIT' && plan.primaryFs.name === 'BILL_ME_LATER';
    },


    // get PAD hop date (when bank will be charged) based on selected plan and PAD toggle state
    getPadPlanHopDate: function getPadPlanHopDate(plan) {
        if (this.isIACH(plan)) {
            var padPlan = this.getPlanByPlanId(plan.primaryFs.padPlanId);

            if (padPlan) {
                return padPlan.primaryFs.hop_date;
            }
        } else {
            return plan.primaryFs.hop_date;
        }
    },

    // get PAD or IACH plan id based on selected plan and PAD toggle state
    getPadOrIachPlanIdBySelectedPlan: function getPadOrIachPlanIdBySelectedPlan(_ref2) {
        var plan = _ref2.plan,
            isPadToggleSelected = _ref2.isPadToggleSelected;

        if (!plan || !plan.primaryFs) {
            return;
        }

        var _plan$primaryFs2 = plan.primaryFs,
            padPlanId = _plan$primaryFs2.padPlanId,
            iachPlanId = _plan$primaryFs2.iachPlanId,
            planId = plan.planId;


        if (isPadToggleSelected) {
            return this.isPAD(plan) ? planId : padPlanId;
        } else {
            return this.isIACH(plan) ? planId : iachPlanId;
        }
    },

    getBankPadPlanIdByInstrumentId: function getBankPadPlanIdByInstrumentId(fsId, fsSubtype) {
        var bankPadPlan = _squid.$util.find(this.plans, function () {
            var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _plan$primaryFs3 = plan.primaryFs;
            _plan$primaryFs3 = _plan$primaryFs3 === undefined ? {} : _plan$primaryFs3;
            var id = _plan$primaryFs3.id,
                type = _plan$primaryFs3.type,
                subtype = _plan$primaryFs3.subtype;


            return id === fsId && type === 'BANK' && subtype === fsSubtype;
        });

        if (!bankPadPlan) {
            return;
        }

        var _bankPadPlan$primaryF = bankPadPlan.primaryFs;
        _bankPadPlan$primaryF = _bankPadPlan$primaryF === undefined ? {} : _bankPadPlan$primaryF;
        var subtype = _bankPadPlan$primaryF.subtype,
            padPlanId = _bankPadPlan$primaryF.padPlanId,
            iachPlanId = _bankPadPlan$primaryF.iachPlanId;


        return subtype === 'IACH' ? padPlanId : iachPlanId;
    },


    isPadToggleApplicable: function isPadToggleApplicable() {
        var padToggleApplicable = false;

        this.eachPlan(function (plan) {
            if (!padToggleApplicable && plan.primaryFs && plan.primaryFs.type === 'BANK') {
                if (plan.primaryFs.subtype === 'IACH' && plan.primaryFs.hasOwnProperty('padPlanId')) {
                    padToggleApplicable = plan.primaryFs.padPlanId ? true : false;
                } else if (plan.primaryFs.subtype === 'PAD' && plan.primaryFs.hasOwnProperty('iachPlanId')) {
                    padToggleApplicable = plan.primaryFs.iachPlanId ? true : false;
                }
            }
        }, this);

        return padToggleApplicable;
    },

    isPadToggleApplicableForFS: function isPadToggleApplicableForFS(planId) {
        var padToggleApplicable = false;
        var selectedPlan = _squid.$util.find(this.plans, function (plan) {
            return plan.planId === planId;
        });

        if (selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.type === 'BANK' && (selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId)) {
            padToggleApplicable = true;
        }

        return padToggleApplicable;
    },

    getPreferred: function getPreferred() {
        var _this2 = this;

        return _squid.$util.find(this.plans, function (plan) {
            return _this2.isPreferred(plan);
        });
    },

    isPreferred: function isPreferred() {
        var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (this.isPAD(plan)) {
            // if the current plan is PAD -> find corresponding IACH plan to see if it's preferred
            var iachPlan = this.getPlanByPlanId(plan.primaryFs.iachPlanId) || {};
            var _iachPlan$primaryFs = iachPlan.primaryFs;
            _iachPlan$primaryFs = _iachPlan$primaryFs === undefined ? {} : _iachPlan$primaryFs;

            var _iachPlan$primaryFs$i = _iachPlan$primaryFs.isPreferred,
                _isPreferred = _iachPlan$primaryFs$i === undefined ? false : _iachPlan$primaryFs$i;

            return _isPreferred;
        }

        var _plan$primaryFs4 = plan.primaryFs;
        _plan$primaryFs4 = _plan$primaryFs4 === undefined ? {} : _plan$primaryFs4;
        var _plan$primaryFs4$isPr = _plan$primaryFs4.isPreferred,
            isPreferred = _plan$primaryFs4$isPr === undefined ? false : _plan$primaryFs4$isPr;


        return isPreferred;
    },

    // get Merchant specific balance by plan id
    getMsbByPlanId: function getMsbByPlanId(planId) {
        var plan = this.getPlanByPlanId(planId);

        return plan && plan.incentive;
    },

    /**
     * Avoid plans that are not meant for display on the UI.
     * - Hide Rewards
     */
    getDisplayPlans: function getDisplayPlans() {
        // return type should be undefined in no plans
        // for billing agreement use case
        return this.plans ? this.plans.filter(function (plan) {
            return !plan.rewards;
        }) : this.plans;
    },
    /**
     * Avoid instruments that are not meant for display on the UI.
     * - Hide Rewards
     */
    getDisplayInstruments: function getDisplayInstruments() {
        var _instruments3 = this.instruments,
            instruments = _instruments3 === undefined ? [] : _instruments3;


        return instruments.filter(function (instrument) {
            return instrument.type !== 'REWARDS';
        });
    }
});

// Map the data needed for the installmentsOptions endpoint
var serializeInstallmentsOptionsData = exports.serializeInstallmentsOptionsData = function serializeInstallmentsOptionsData(_ref3) {
    var merchant_country = _ref3.checkoutAppData.merchant.merchant_country,
        checkoutCart = _ref3.checkoutCart,
        country = _ref3.country,
        id = _ref3.payee.merchant.id,
        isMemberCredit = _ref3.isMemberCredit,
        cc = _ref3.cc;

    var payload = {
        checkoutAppData: {
            merchant: {
                merchant_country: merchant_country
            }
        },
        checkoutCart: {},
        country: country,
        payee: {
            merchant: {
                id: id
            }
        },
        isMemberCredit: isMemberCredit,
        cc: cc
    };

    if (checkoutCart.purchase && checkoutCart.purchase.amounts) {
        var _checkoutCart$purchas = checkoutCart.purchase.amounts.total,
            amount = _checkoutCart$purchas.amount,
            currency_code = _checkoutCart$purchas.currency_code;


        payload.checkoutCart.purchase = {
            amounts: {
                total: {
                    amount: amount,
                    currency_code: currency_code
                }
            }
        };
    }

    return payload;
};

var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/installmentOptions/',
        postAttempts: 2
    }),

    save: function save(options) {
        options.data = serializeInstallmentsOptionsData(options.data);

        return this._super.save.call(this, options);
    }
});

var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/flowEligibility'
    })
});

var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:parent.id/shipping/:id'
    })
});

var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping/add'
    }),

    serialize: function serialize() {
        return {
            first_name: this.first_name,
            last_name: this.last_name,
            recipient_name: this.recipient_name,
            line1: this.line1,
            line2: this.line2,
            city: this.city,
            state: this.state,
            postal_code: this.postal_code,
            country: this.country
        };
    }
});

var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/payee'
    }),

    getId: function getId() {
        return this.merchant && this.merchant.id;
    },

    isGambling: function isGambling() {
        return this.merchant && this.merchant.isGambling;
    },

    isOnBaNoStickyList: function isOnBaNoStickyList() {
        var merchantId = this.getId();

        return merchantId && _squid.$config.disableMerchantForStickyBA && _squid.$config.disableMerchantForStickyBA.indexOf(merchantId) > -1;
    }
});

var creditOptionsModel = {
    largeEligibleAmount: {
        US: 99,
        GB: 150
    }
};

// keeping sacEligibleAmount available for backwards compat, largeEligibleAmount preferred
creditOptionsModel.sacEligibleAmount = creditOptionsModel.largeEligibleAmount;

var $CreditOptionsModel = exports.$CreditOptionsModel = creditOptionsModel;

var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
    },

    getPreferredShippingAddress: function getPreferredShippingAddress() {
        var preferredAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.preferred_address) {
                    preferredAddress = {
                        line1: address.line1,
                        line2: address.line2,
                        city: address.city,
                        state: address.state,
                        postal_code: address.postal_code,
                        country_code: address.country_code
                    };

                    break;
                }
            }
        }
        return preferredAddress;
    },

    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
        var primaryAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.primary_address) {
                    primaryAddress = {
                        line1: address.line1,
                        line2: address.line2,
                        city: address.city,
                        state: address.state,
                        postal_code: address.postal_code,
                        country_code: address.country_code
                    };

                    break;
                }
            }
        }
        return primaryAddress;
    }
});

var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {
    onPopulate: function onPopulate() {
        this.sources = this.children($FundingSourceModel, this.sources);
    },

    eachSource: function eachSource(method, context) {
        angular.forEach(this.sources, method, this);
    },

    hasFundingMethodType: function hasFundingMethodType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.sub_type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    isPAD: function isPAD() {
        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
    },

    isIACH: function isIACH() {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER') {
                found = true;
            }
        }, this);

        return found;
    },

    isSplitBalance: function isSplitBalance() {
        return this.sources && this.sources.length > 1 && this.hasFundingMethodType('BALANCE');
    },

    isSplitPaymentWithBalanceAndIach: function isSplitPaymentWithBalanceAndIach() {
        return this.isSplitBalance() && this.isIACH();
    },

    isMSB: function isMSB() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
    },

    isBalance: function isBalance() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
    },

    hasConversion: function hasConversion() {
        return this.conversion !== null && _typeof(this.conversion) === 'object';
    }
});

var $CardBackupModel = exports.$CardBackupModel = _squid.$Model.extend('$CardBackupModel', {
    onPopulate: function onPopulate() {
        if (!this.get('parent.meta.populated')) {
            return;
        }

        // If plan IDs change, we need to reevaluate the correct backup plan id
        this.resetIfDoesNotApply();
        this.reevaluateEligibility();
    },


    /**
     * getCardBackupInstrument
     * Get the user's last selection for card backup, if still eligible
     * @returns {Object|undefined} the plan of the user's last selection, or undefined otherwise
     */
    getPlan: function getPlan() {
        if (!this.isAllowed()) {
            return;
        }

        return this.plan;
    },


    /**
     * setCardBackupInstrument
     * Save the user's selection for backup. Tied to the currently selected plan
     * @param {Object} plan - the plan to use as the backup
     * @param {Object} [forPlan] - if needed, the plan to compare against. prefer not to pass it in
     */
    setPlan: function setPlan(plan, forPlan) {
        this.plan = plan;
        this.forPlan = forPlan || this.getCheckoutSessionPlan();
    },
    isAllowed: function isAllowed() {
        var _forPlan = this.forPlan;
        _forPlan = _forPlan === undefined ? {} : _forPlan;
        var _forPlan$primaryFs = _forPlan.primaryFs;
        _forPlan$primaryFs = _forPlan$primaryFs === undefined ? {} : _forPlan$primaryFs;
        var type = _forPlan$primaryFs.type,
            secondaryFIs = _forPlan.secondaryFIs;


        if (type !== 'CARD' || secondaryFIs !== false) {
            return false;
        }
        return this.allowCardBackup;
    },
    getCheckoutSessionPlan: function getCheckoutSessionPlan() {
        return this.get('parent.fundingOptions.plans.0');
    },
    reevaluateEligibility: function reevaluateEligibility() {
        var _this3 = this;

        (0, _processorDecline.getProcessorDeclineRetryEligibility)(this.id, this.parent).then(function (eligibility) {
            _this3.allowCardBackup = eligibility;

            return eligibility;
        });
    },
    reset: function reset(forPlan) {
        this.setPlan(undefined, forPlan);
    },

    /**
     * resetIfDoesNotApply
     * resets the selected backup for card if no longer valid based on user's choice
     * matches the plan ID if still valid but plan IDs change
     * @param {String} [plan] - current checkout session funding options plan user has selected
     */
    resetIfDoesNotApply: function resetIfDoesNotApply(plan) {
        if (!plan) {
            plan = this.getCheckoutSessionPlan();
        }

        var getKey = function getKey(p) {
            return p && p.primaryFs && p.primaryFs.id;
        };
        var planKey = getKey(plan);
        var forKey = getKey(this.forPlan);

        if (!planKey || planKey !== forKey) {
            return this.reset(plan);
        }

        // Since planIds may change, if backup is still valid then find the new plan
        var plans = this.get('parent.fundingOptions.plans') || [];
        var currentPlanKey = getKey(this.plan);
        var newPlan = currentPlanKey && plans.find(function (p) {
            return getKey(p) === currentPlanKey;
        });

        // If, for whatever reason, the old instrument isn't in the new plans, we'll reset
        if (currentPlanKey && !newPlan) {
            return this.reset(plan);
        }

        this.forPlan = plan;
        this.plan = newPlan;
    }
});

var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/session',
        postAttempts: 2
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
    smartDollarAuthFailed: false, // initial value for smartDollar authorization check

    onPopulate: function onPopulate() {
        try {
            // Initialize plan, shipping, and funding options
            this.plan = new $CheckoutPlanModel(this.plan);
            this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
            this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);

            var wallet = _wallet.$WalletModel.instance(_squid.$meta.token);

            // Ensure wallet and fundingOptions exist before proceeding
            if (wallet && this.fundingOptions && this.fundingOptions.parent && this.fundingOptions.parent.selectedFuturePaymentInstrument) {
                var instrumentId = this.fundingOptions.parent.selectedFuturePaymentInstrument.instrument_id;

                var allAccounts = {
                    bank_accounts: wallet.bank_accounts || [],
                    card_accounts: wallet.card_accounts || [],
                    credit_accounts: wallet.credit_accounts || []
                };

                var matchingCategory = null;
                var matchingWallet = null;

                // Iterate over all account categories to find the matching object
                Object.keys(allAccounts).forEach(function (category) {
                    var found = allAccounts[category].find(function (account) {
                        return account.id === instrumentId;
                    });

                    if (found) {
                        matchingWallet = found;
                        matchingCategory = category;
                    }
                });

                if (matchingWallet) {
                    console.log('Matching Wallet Object found in ' + matchingCategory + ':', matchingWallet);
                    this.selectedWallet = matchingWallet; // Use selectedFuturePaymentInstrument
                } else {
                    console.log('No matching wallet found for instrument ID:', instrumentId);
                    this.selectedWallet = this.fundingOptions.parent.selectedFuturePaymentInstrument;
                }
            } else {
                console.log('selectedFuturePaymentInstrument does not exist, fallback to default logic.');

                // Default fallback logic: select the first eligible funding option
                var _allAccounts = {
                    bank_accounts: wallet ? wallet.bank_accounts || [] : [],
                    card_accounts: wallet ? wallet.card_accounts || [] : [],
                    credit_accounts: wallet ? wallet.credit_accounts || [] : []
                };

                var firstBank = _allAccounts.bank_accounts[0];
                var firstCard = _allAccounts.card_accounts[0];
                var firstCredit = _allAccounts.credit_accounts[0];

                if (this.selectedWallet) {
                    console.log('Selected first available wallet:', this.selectedWallet);

                    // Prioritize accounts in the order: bank > card > credit
                    this.selectedWallet = firstBank || firstCard || firstCredit;
                }
            }
        } catch (e) {
            console.error('Error in onPopulate:', e);
            this.selectedWallet = null; // Reset to null if an error occurs
        }

        // Reevaluate the eligibility for allowing backup with cards.
        this.cardBackup = this.child($CardBackupModel, this.cardBackup || {});
        // Emit a session change event for apps to react accordingly
        _squid.$event.emit('checkoutSessionChange');
    },

    /**
     * Finds the plan in billing cases that the user is intending to use as the sticky FI.
     * @return {Object} the instrument representation from futurePaymentInstruments
     */
    getSelectedStickyInstrument: function getSelectedStickyInstrument() {
        // This method doesn't apply for non-billing cases
        if (!this.futurePaymentInstruments) {
            return;
        }

        // For BA no purchase cases (no plan), use either
        // 1. selectedFuturePaymentInstrument (we've made and persisted a selection)
        // 2. first of futurePaymentInstruments (we haven't made a selection and need to save it later)
        if (!(this.plan && this.plan.sources)) {
            return this.selectedFuturePaymentInstrument || this.futurePaymentInstruments[0];
        }

        // Otherwise, if we have a plan list (ie. this is a purchase case),
        // we'll always want to take the currently selected plan,
        // as selectedFuturePaymentInstrument may not be updated to the user's current plan
        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
            return fi.instrument_id ? fi.instrument_id : undefined;
        });

        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
            return fi.instrument_id === selectedInstrumentId;
        });

        return stickyInstrument;
    },

    /**
     * Retrieves the selected sticky financial instrument for the disclaimer.
     * @return {Object} The instrument representation from futurePaymentInstruments.
     */
    getSelectedStickyInstrumentForDisclaimer: function getSelectedStickyInstrumentForDisclaimer() {
        var fiMetaInstance = _index2['default'].instance(_squid.$meta.token);

        return Object.keys(this.selectedWallet || {}).length ? fiMetaInstance.getName(this.selectedWallet) : this.getSelectedStickyInstrument() && this.getSelectedStickyInstrument().name;
    },


    getPlanList: function getPlanList() {
        // Only show plans that need to be shown.
        return this.fundingOptions && this.fundingOptions.getDisplayPlans();
    },

    // returns true if more than one plan uses BALANCE as the primary FI
    isMultipleBalancePlan: function isMultipleBalancePlan() {
        var matchingBalancePlans = 0;

        return this.fundingOptions && this.fundingOptions.plans && this.fundingOptions.plans.some(function (plan) {
            // if BALANCE is the primary FI...
            if (plan.primaryFs.name === 'BALANCE') {
                // increment number of balance plans found
                matchingBalancePlans++;
            }
            // exit once we have more than one balance plan
            return matchingBalancePlans > 1;
        });
    },

    getDisallowedInstruments: function getDisallowedInstruments() {
        if (this.fundingOptions && this.fundingOptions.disallowedInstruments && angular.isArray(this.fundingOptions.disallowedInstruments)) {
            var filteredDisallowedInstruments = this.fundingOptions.disallowedInstruments.filter(function (instrument) {
                if (instrument.type === 'CARD' && instrument.declineReason === 'unsupportedDueToExpiration') {
                    return (0, _utils.filterCardWithinLastNMonths)(instrument, (0, _squid.$feature)('expirePeriod'));
                }
                return true;
            });

            this.fundingOptions.disallowedInstruments = filteredDisallowedInstruments;
        }
        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
    },

    getDisallowedPreferred: function getDisallowedPreferred() {
        var disallowedInstrument = this.getDisallowedInstruments();

        // find only the disallowed instrument that has been marked as preferred.
        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
            return fi.isPreferred;
        });

        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
        // we do not show it in the disallowed section.
        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
            var instrumentID = plan.primaryFs && plan.primaryFs.id;

            if (instrumentID && disallowedInstrument.id) {
                return instrumentID === disallowedInstrument.id;
            } else {
                return false;
            }
        });

        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
    },

    isBalanceDisallowed: function isBalanceDisallowed() {
        var disallowedInstruments = this.getDisallowedInstruments();

        return disallowedInstruments && disallowedInstruments.some(function (fi) {
            return fi.type === 'BALANCE';
        });
    },

    expiredInstruments: function expiredInstruments() {
        var expiredInstruments = [];
        var disallowedPreferred = this.getDisallowedPreferred();
        var disallowedInstruments = this.getDisallowedInstruments();

        if (disallowedPreferred) {
            expiredInstruments.push(disallowedPreferred);
        }

        _squid.$util.forEach(disallowedInstruments, function (instrument) {
            if (instrument.type === 'CARD' && !instrument.isPreferred && instrument.declineReason === 'unsupportedDueToExpiration') {
                expiredInstruments.push(instrument);
            }
        });

        return expiredInstruments;
    },

    preferredExpiredInstruments: function preferredExpiredInstruments() {
        var disallowedPreferred = this.getDisallowedPreferred();

        if (disallowedPreferred && disallowedPreferred.type === 'CARD' && disallowedPreferred.isPreferred && disallowedPreferred.declineReason === 'unsupportedDueToExpiration') {
            return true;
        }

        return false;
    },

    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
        return {
            line1: this.shipping.line1,
            line2: this.shipping.line2,
            city: this.shipping.city,
            state: this.shipping.state,
            postal_code: this.shipping.postal_code,
            country_code: this.shipping.country
        };
    },

    getPPCconversionInfo: function getPPCconversionInfo() {
        var ppcFi = void 0;

        if (this.fundingOptions && this.fundingOptions.instruments) {
            ppcFi = this.fundingOptions.instruments.find(function (fi) {
                return fi.type === 'CREDIT' && fi.name === 'BILL_ME_LATER';
            });
        }
        if (ppcFi && ppcFi.currency_conversion) {
            return Object.assign({}, ppcFi.currency_conversion);
        }
        return null;
    }
});

angular.value("$CheckoutCartModel", $CheckoutCartModel);
angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
angular.value("$FundingSourceModel", $FundingSourceModel);
angular.value("$FundingOptionsModel", $FundingOptionsModel);
angular.value("serializeInstallmentsOptionsData", serializeInstallmentsOptionsData);
angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
angular.value("$ShippingAddressModel", $ShippingAddressModel);
angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
angular.value("$CreditOptionsModel", $CreditOptionsModel);
angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
angular.value("$CardBackupModel", $CardBackupModel);
angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
_squid.$Class;

_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$event;

_squid.$feature;

_processorDecline.getProcessorDeclineRetryEligibility;

_utils.filterCardWithinLastNMonths;

_wallet.$WalletModel;

_squid.$meta;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/lib/utils.js":
/***/ (function(module, exports) {



exports.__esModule = true;
/**
* @param {Date} d1
* @param {Date} d2
* @returns {number}
*/
var monthDiff = function monthDiff(d1, d2) {
    var months = void 0;

    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth() + 1;
    return months <= 0 ? 0 : months;
};

/**
* @param {Object} fi - A funding instrument
* @param {boolean} expiredPeriod - feature boolean flag from config.json
* @returns {boolean}
*/
var filterCardWithinLastNMonths = function filterCardWithinLastNMonths(fi, expirePeriod) {
    var expire_year = fi.expire_year,
        expire_month = fi.expire_month;


    var expiryDate = new Date(expire_year + '-' + expire_month + '-01');

    var monthDifference = monthDiff(expiryDate, new Date());

    return monthDifference !== 0 && monthDifference <= expirePeriod;
};

exports.filterCardWithinLastNMonths = filterCardWithinLastNMonths;

/***/ }),

/***/ "../node_modules/xo-models/src/checkoutIncentive/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GetPSBOffersModel = exports.$GetOfferProgramModel = exports.$CreateOfferModel = exports.$EvaluateCheckoutOfferEligibilityModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $EvaluateCheckoutOfferEligibilityModel = exports.$EvaluateCheckoutOfferEligibilityModel = _squid.$Model.extend('$EvaluateCheckoutOfferEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/evaluate-eligibility',
        postAttempts: 1
    }),

    isEligible: function isEligible() {
        return Boolean(this.eligible);
    },
    getCurrencyCode: function getCurrencyCode() {
        return this.currency_code;
    },
    getOfferProgramCode: function getOfferProgramCode() {
        return this.offer_program_code;
    },
    getOfferProgramID: function getOfferProgramID() {
        return this.offer_program_id;
    },


    // This is of the form $5.00
    getOfferValue: function getOfferValue() {
        return this.offer_value;
    }
});

var $CreateOfferModel = exports.$CreateOfferModel = _squid.$Model.extend('$CreateOfferModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/new',
        postAttempts: 1
    }),

    createdOffer: function createdOffer() {
        return Boolean(this.offer_id);
    },
    getOfferAmountLowestDenom: function getOfferAmountLowestDenom() {
        if (!this.createdOffer() || !this.computation_rules) {
            return;
        }

        return _squid.$util.getProperty(this.computation_rules[0], 'offer_value.value');
    },
    getTxnMinimumLowestDenom: function getTxnMinimumLowestDenom() {
        if (!this.createdOffer()) {
            return;
        }

        return _squid.$util.getProperty(this, 'offer_program_info.applicability_rule.cart_rule.min_cart_total');
    }
});

var $GetOfferProgramModel = exports.$GetOfferProgramModel = _squid.$Model.extend('$GetOfferProgramModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/program'
    }),

    getOfferCurrencyCode: function getOfferCurrencyCode() {
        return _squid.$util.getProperty(this, 'currency_code');
    },


    // NOTE this is in the lowest denominator of the currency
    // For example, $5.00 USD would be returned as 500
    getOfferValueLowestDenom: function getOfferValueLowestDenom() {
        return _squid.$util.getProperty(this.computation_rules[0], 'offer_value.value') || 0;
    },
    getMinCartTotalLowestDenom: function getMinCartTotalLowestDenom() {
        return _squid.$util.getProperty(this, 'applicability_rule.cart_rule.min_cart_total') || 0;
    },
    isUserInApplicableCountry: function isUserInApplicableCountry(userCountry) {
        if (!userCountry) {
            return false;
        }

        var applicableCountries = _squid.$util.getProperty(this, 'applicability_rule.user_rule.user_countries') || [];

        return applicableCountries ? applicableCountries.indexOf(userCountry) >= 0 : false;
    }
});

var $GetPSBOffersModel = exports.$GetPSBOffersModel = _squid.$Model.extend('$GetPSBOffersModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/offers'
    }),

    // If an offer is returned in the resource_list, it is active; in this
    // case we do not want to give the user another incentive
    hasActiveOffer: function hasActiveOffer() {
        return Boolean(this.resource_list && this.resource_list.length);
    },


    // Check if the user has an offer belonging to this specific offer program
    hasActiveCheckoutIncentive: function hasActiveCheckoutIncentive(offer_program_id) {
        return offer_program_id && this.hasActiveOffer() && this.resource_list.some(function (offer) {
            return offer.offer_program_id === offer_program_id;
        });
    },


    // Check if the user has an offer with the passed in redemption code
    // NOTE this is necessary because planning does not return which program
    // an incentive is from if the incentive is being used in the transaction.
    // The only identifier is the redemption code
    hasOfferWithRedemptionCode: function hasOfferWithRedemptionCode(redemption_code) {
        return redemption_code && this.hasActiveOffer() && this.resource_list.some(function (offer) {
            return offer.redemption_code === redemption_code;
        });
    }
});

angular.value("$EvaluateCheckoutOfferEligibilityModel", $EvaluateCheckoutOfferEligibilityModel);
angular.value("$CreateOfferModel", $CreateOfferModel);
angular.value("$GetOfferProgramModel", $GetOfferProgramModel);
angular.value("$GetPSBOffersModel", $GetPSBOffersModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/choice/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ChoiceEligibility = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

// Variants:
// control
// 5 - If any choice treatment, do 5 unless 5 is ineligible
// 6 - If any choice treatment, do 6 if 5 is ineligible and 6 is eligible

var checkPPCInstallments = function checkPPCInstallments(token, _ref) {
    var checkoutSessionModel = _ref.checkoutSessionModel,
        checkoutPayeeModel = _ref.checkoutPayeeModel,
        checkoutCartModel = _ref.checkoutCartModel,
        checkoutAppDataModel = _ref.checkoutAppDataModel;

    // Check for installments - has credit in wallet, has credit offer in checkout session, and has installment options
    if (checkoutSessionModel.fundingOptions.hasCredit() && checkoutSessionModel.creditInstallmentOffer && (0, _squid.$feature)('creditInstallmentOffers')) {
        var installmentOptions = _checkout.$InstallmentOptionsModel.instance(token);

        return installmentOptions.save({
            cache: true, // Cache response for selectFi page or wherever needed
            data: {
                payee: checkoutPayeeModel,
                checkoutCart: checkoutCartModel,
                checkoutAppData: checkoutAppDataModel,
                isMemberCredit: true
            },
            success: function success(result) {
                var offers = result.installments && result.installments[0];
                var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                var installmentOfferDetails = offers && offers.installment_options;

                var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                var installmentOfferDetailsArray = installmentOfferDetails ? installmentOfferDetails.map(function (item) {
                    return item.financingCode;
                }) : [];
                var hasThreeMonthInstallment = Boolean(installmentOfferDetailsArray.filter(function (value) {
                    return threeMonthFinancingCodeArray.includes(value);
                }).length > 0);

                // For regular installments, we do not show choice. returns true;
                // For 3mo Installments, we want to show choice. return false;
                return hasInstallments && !hasThreeMonthInstallment;
            },
            contingencies: {
                DEFAULT: function DEFAULT(message) {
                    // Assume is eligible if contingency
                    _logger.$logger.info('installments_contingency', {
                        message: message
                    });
                    return false;
                }
            },
            error: function error(err) {
                _logger.$logger.info('installments_error', err);
                return false;
            }
        });
    } else {
        return _squid.$promise.resolve(false);
    }
};

// Main logic to decide choice eligibility
var decideEligibility = function decideEligibility(token, _ref2) {
    var authModel = _ref2.authModel,
        checkoutCartModel = _ref2.checkoutCartModel,
        checkoutSessionModel = _ref2.checkoutSessionModel,
        checkoutAppDataModel = _ref2.checkoutAppDataModel,
        checkoutPayeeModel = _ref2.checkoutPayeeModel;
    var fundingOptions = checkoutSessionModel.fundingOptions;

    var plans = checkoutSessionModel.get('fundingOptions.plans');

    // Reasons for a transaction to be ineligible:
    //  - is billing
    //  - is split balance
    //  - balance covers full transaction but does not have preferred set
    //  - has PAD
    //  - is second button (and not in 2nd button elmo)
    //  - is not US
    //  - has currency conversion
    //  - is not a merchant account
    //  - is a Third Party transaction (Venmo, Baidu, etc...)

    // Check to see if any plans include split balance
    var splitBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.secondaryFIs;
    });
    var billing = checkoutCartModel.isBilling();
    var PAD = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.subtype === 'PAD';
    });
    var secondButton = checkoutAppDataModel.is_second_button_txn;
    var hasMerchantCountryChoice = (0, _squid.$feature)('choiceExperiment', false, checkoutAppDataModel.merchant.merchant_country);
    var fullBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.type === 'BALANCE';
    });
    var hasPreferred = fundingOptions && fundingOptions.getPreferred();
    var isNotMerchantAccount = authModel.account_type !== 2;
    var isNotAndroidPay = !checkoutCartModel.isWalletTokenization();
    var isNotFbBaFlow = !_squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
    var isThirdPartyWalletTransaction = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
    var isNotGambling = !checkoutPayeeModel.isGambling();
    var isNotBaDisableStickyForMerchant = !(checkoutCartModel.isBillingNoPurchase() && checkoutPayeeModel.isOnBaNoStickyList());
    var involvedCurrencies = {};
    var currency_code = checkoutCartModel.get('purchase.amounts.total.currency_code');

    if (currency_code && plans) {
        involvedCurrencies[checkoutCartModel.purchase.amounts.total.currency_code] = 1;
        plans.forEach(function (option) {
            involvedCurrencies[option.primaryFs.amount.currency_code] = 1;
        });
    }

    var singleCurrency = Object.keys(involvedCurrencies).length <= 1;

    // checking if pad in funding plans
    var padToggleFeatureCheck = PAD ? Experiments.padToggleFeatureSupported() : _squid.$promise.resolve(false);

    // Check the choice variant.
    // User must be eligible to see a variant
    var _$config$choiceExperi = _squid.$config.choiceExperiment;
    _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
    var _$config$choiceExperi2 = _$config$choiceExperi.ignored;
    _$config$choiceExperi2 = _$config$choiceExperi2 === undefined ? {} : _$config$choiceExperi2;
    var _$config$choiceExperi3 = _$config$choiceExperi2.multipleFi,
        multipleFiIgnored = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3,
        _$config$choiceExperi4 = _$config$choiceExperi2.selectFi,
        selectFiIgnored = _$config$choiceExperi4 === undefined ? [] : _$config$choiceExperi4;


    var merchantCountry = checkoutAppDataModel.merchant && checkoutAppDataModel.merchant.merchant_country;

    var getUlTreatmentRegex = function getUlTreatmentRegex(country) {
        switch (country) {
            case 'US':
                return 'Trmt_xo_us_ppc_2nd_btn_choice_.';
            case 'GB':
                return 'Trmt_xo_gb_ppc_2nd_btn_choice_.';
            default:
                return '';
        }
    };

    var getElmo = function getElmo() {
        if (secondButton) {
            if (merchantCountry === 'US') {
                return 'already_ramped';
            }
            return (0, _squid.$elmo)('xo_ppc_2nd_btn_choice', { 'ctx.COUNTRY': merchantCountry }, getUlTreatmentRegex(merchantCountry), false, true);
        } else {
            return 'not_second_button';
        }
    };

    var logAndReturnChoice = function logAndReturnChoice() {
        _logger.$logger.info('choice_experiment_eligible', {
            variant: '5'
        });

        _logger.$logger.info('checkout_fpti', {
            from: 'CHOICE_ELG_CHK',
            to: 'process_choice_elg_chk',
            eligibility_reason: 'eligible'
        });

        return '5';
    };

    // hard code the isChoiceOnCAPECYCOReturn to false as this exp is no longer used and there in an issue of
    // delay in review page render
    return _squid.$promise.all([getElmo(), padToggleFeatureCheck, false]).then(function (_ref3) {
        var secondButtonChoiceVariant = _ref3[0],
            isPadToggleFeatureSupported = _ref3[1],
            isChoiceOnCAPECYCOReturn = _ref3[2];

        // Check transaction eligibility
        var eligibilityCriteria = {
            noBilling: !billing,
            noSplitBalance: !splitBalance,
            balanceWithPreferred: !(fullBalance && !hasPreferred),
            noPAD: !PAD || isPadToggleFeatureSupported,
            secondButtonVariant: secondButtonChoiceVariant,
            hasMerchantCountryChoice: hasMerchantCountryChoice,
            singleCurrency: singleCurrency,
            noMerchant: isNotMerchantAccount,
            noAndroidPay: isNotAndroidPay,
            isNotFbBaFlow: isNotFbBaFlow,
            noThirdPartyWalletTransactions: !isThirdPartyWalletTransaction,
            isNotGambling: isNotGambling,
            isNotBaDisableStickyForMerchant: isNotBaDisableStickyForMerchant
        };
        // First check to see if transaction is eligible for choice at all.
        // Base eligibility check follows the selectFi eligibility
        var choiceIneligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
            return selectFiIgnored.indexOf(key) === -1 && !eligibilityCriteria[key];
        });

        var transactionEligible = choiceIneligibleReasons.length === 0;

        if (!transactionEligible) {
            _logger.$logger.info('choice_experiment_ineligible', {
                failed: choiceIneligibleReasons.join()
            });

            _logger.$logger.info('checkout_fpti', {
                from: 'CHOICE_ELG_CHK',
                to: 'process_choice_elg_chk',
                eligibility_reason: 'ineligible-' + choiceIneligibleReasons.join()
            });

            return 'control';
        }

        if (isChoiceOnCAPECYCOReturn) {
            _logger.$logger.info('xo_ppc_choice_on_cape_cyco_return_treatment');
            return logAndReturnChoice();
        }

        // If eligible for choice, check if transaction is eligible for multipleFi variant
        return checkPPCInstallments(token, {
            checkoutCartModel: checkoutCartModel,
            checkoutSessionModel: checkoutSessionModel,
            checkoutAppDataModel: checkoutAppDataModel,
            checkoutPayeeModel: checkoutPayeeModel
        }).then(function (hasPPCInstallments) {
            var validCountryForMultipleFi =
            // IN requires CVV collection, multipleFi variant does not have yet
            _squid.$locale.country !== 'IN';
            var hasInstallments = plans && plans.some(function (plan) {
                return plan.installments;
            });

            /**
             * read the cvvData from checkoutSession to decide multiple FI variant
             * if we have cvvData make it as ineligible
             * Risk is going to throw cvv contingency for transaction for any country buyer
             * and CVV user input is not there in multiFI variant - resulted in buyer approve the FI
             * without entering CVV - make it as ineligible and singleFI experience asks for CVV
             */
            var cvvData = checkoutSessionModel.get('cvvData');
            var isCvvRequired = cvvData && Object.keys(cvvData).length > 0;

            var multipleFiEligibility = (0, _angular.extend)({
                // Have not built method to select PPC installments for multipleFi
                creditInstallments: !hasPPCInstallments,
                validCountryForMultipleFi: validCountryForMultipleFi,
                noInstallments: !hasInstallments,
                noCvvRequired: !isCvvRequired
            }, eligibilityCriteria);
            var multipleFiIneligibleReasons = Object.keys(multipleFiEligibility).filter(function (criteria) {
                return multipleFiIgnored.indexOf(criteria) === -1 && !multipleFiEligibility[criteria];
            }).join();
            var multipleFiEligible = multipleFiIneligibleReasons.length === 0;

            if (!multipleFiEligible) {
                _logger.$logger.info('choice_experiment_var5_ineligible', {
                    failed: multipleFiIneligibleReasons
                });

                _logger.$logger.info('checkout_fpti', {
                    from: 'CHOICE_ELG_CHK',
                    to: 'process_choice_elg_chk',
                    eligibility_reason: 'ineligible_6-' + multipleFiIneligibleReasons
                });

                return '6';
            }

            return logAndReturnChoice();
        });
    });
};

var promiseControl = _squid.$promise.resolve('control');

var $ChoiceEligibility = exports.$ChoiceEligibility = _squid.$Model.extend('$ChoiceEligibility', {
    getVariant: function getVariant(token) {
        var _this = this;

        if (!(0, _squid.$feature)('choiceExperiment')) {
            return promiseControl;
        }
        var models = {};

        return (0, _squid.$populate)(models, {
            authModel: _auth.$AuthModel.instance(),
            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
        }).then(function () {
            // If user logged in is the same, we can skip the decision making logic
            if (_this.variant && models.authModel.buyer_id === _this.buyerId) {
                return _this.variant;
            }

            _this.variant = decideEligibility(token, models);
            _this.buyerId = models.authModel.buyer_id;

            return _this.variant;
        });
    }
});

angular.value("$ChoiceEligibility", $ChoiceEligibility);
_angular.extend;

_squid.$Model;

_squid.$elmo;

_squid.$promise;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$integration;

_squid.$locale;

_logger.$logger;

_auth.$AuthModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$InstallmentOptionsModel;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-models/src/consent/consent.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ConsentModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var $ConsentModel = exports.$ConsentModel = _squid.$Model.extend('$ConsentModel', {
    api: new _squid.$Api({
        uri: '/api/consent',
        cache: false,
        postAttempts: 2
    }),

    onPopulate: function onPopulate() {
        if (!this.meta || !this.meta.populated) {
            // Data didn't fetch yet, just populate afterwards
            return;
        }

        if (!this.policy_info || !this.policy_info.status) {
            _logger.$logger.info('consent_serv_no_data_found');
            return;
        }

        this.activeUrl = this.policy_info.active_url;
        this.upcomingUrl = this.policy_info.upcoming_url;
        this.majorVersion = this.policy_info.major_version;
        this.minorVersion = this.policy_info.minor_version;
        this.status = this.policy_info.status;
    },
    getActiveUrl: function getActiveUrl() {
        return this.activeUrl;
    },
    getUpcomingUrl: function getUpcomingUrl() {
        return this.upcomingUrl;
    },
    getMajorVersion: function getMajorVersion() {
        return this.majorVersion;
    },
    getMinorVersion: function getMinorVersion() {
        return this.minorVersion;
    },
    getStatus: function getStatus() {
        return this.status;
    }
});

angular.value("$ConsentModel", $ConsentModel);
_squid.$Model;

_squid.$Api;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/consent/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _consent = __webpack_require__("../node_modules/xo-models/src/consent/consent.js");

Object.keys(_consent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _consent[key];
    }
  });
});

var _userAgreementConsent = __webpack_require__("../node_modules/xo-models/src/consent/userAgreementConsent.js");

Object.keys(_userAgreementConsent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _userAgreementConsent[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/xo-models/src/consent/userAgreementConsent.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UserAgreementConsentModel = undefined;

var _consent = __webpack_require__("../node_modules/xo-models/src/consent/consent.js");

var CONSENT_USER_AGREEMENT_DEFAULT = {
    activeUrl: '/webapps/mpp/ua/useragreement-full',
    upcomingUrl: '/webapps/mpp/ua/upcoming-policies-full',
    majorVersion: '3',
    minorVersion: '2',
    status: 'PENDING'
};

var $UserAgreementConsentModel = exports.$UserAgreementConsentModel = _consent.$ConsentModel.extend('$UserAgreementConsentModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties(CONSENT_USER_AGREEMENT_DEFAULT);
    }
});

angular.value("$UserAgreementConsentModel", $UserAgreementConsentModel);
_consent.$ConsentModel;

/***/ }),

/***/ "../node_modules/xo-models/src/credit/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CreditSharedInfoModel = exports.$CreditInstallmentOptionsModel = exports.$CreditInstallmentModel = exports.$CreditDataModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var $CreditDataModel = exports.$CreditDataModel = _squid.$Model.extend('$CreditDataModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties({
            flow_type: _squid.$util.param('flow'),
            cape_key: _squid.$util.param('key'),
            cape_success: _squid.$util.param('success'),
            credit_signup: _squid.$util.param('creditSignup'),
            userAction: _squid.$util.param('action'),
            merchantAction: _squid.$util.param('merchantAction'),
            credit_login_failure: false,
            is_cross_border: false,
            has_selected_cyco: false,
            return_from_cape_complete: false,
            cape_service_error: _squid.$util.param('isInternalServiceError'),
            cape_redirect_uri: '',
            change_installment: _squid.$util.param('changeStatus'),
            nextState: '',
            cart_amount: null,
            cart_currency: null,
            installment_count: 0
        });
    },

    api: new _squid.$Api({
        uri: '/api/credit/:id/creditData',
        postAttempts: 2
    }),

    isCreditSignup: function isCreditSignup() {
        return this.credit_signup && this.credit_signup === 'true';
    },

    setCapeRedirectUri: function setCapeRedirectUri(input) {
        this.cape_redirect_uri = input;
    },

    getCapeRedirectUri: function getCapeRedirectUri() {
        return this.cape_redirect_uri;
    },

    getMerchantAction: function getMerchantAction() {
        return this.merchantAction || '';
    },

    setCreditSignup: function setCreditSignup(input) {
        this.credit_signup = input;
    },

    getCapeKey: function getCapeKey() {
        return this.cape_key;
    },

    getFlow: function getFlow() {
        if (this.userAction === 'addCredit') {
            return 'credit';
        }
        return this.flow_type;
    },
    setFlow: function setFlow(flowType) {
        this.flow_type = flowType;
    },

    setNextState: function setNextState(nextState) {
        this.nextState = nextState;
    },

    isCapeSuccess: function isCapeSuccess() {
        return this.cape_success && this.cape_success === 'true';
    },

    isCreditTxn: function isCreditTxn() {
        return this.flow_type && this.flow_type === 'credit' || this.userAction && this.userAction === 'addCredit';
    },

    setCreditLoginFailure: function setCreditLoginFailure(input) {
        this.credit_login_failure = input;
    },

    getCreditLoginFailure: function getCreditLoginFailure() {
        return this.credit_login_failure;
    },

    isCapeReturn: function isCapeReturn() {
        return this.flow_type && this.flow_type === 'capeReturn';
    },

    isCapeInternalServiceError: function isCapeInternalServiceError() {
        return this.cape_service_error && this.cape_service_error === 'true';
    },

    getNextState: function getNextState() {
        return this.nextState;
    },

    isChangeStatus: function isChangeStatus() {
        return this.change_installment === 'changeInstallment';
    },

    isRedirectFromCape: function isRedirectFromCape() {
        return Boolean(this.cape_key && this.cape_success === 'true' || _squid.$util.param('applyCredit'));
    },

    isReturnFromCapeComplete: function isReturnFromCapeComplete() {
        return this.return_from_cape_complete;
    },

    setReturnFromCapeComplete: function setReturnFromCapeComplete(returnFromCapeComplete) {
        this.return_from_cape_complete = returnFromCapeComplete;
    },

    // User has selected a financing offer on the CYCO page
    setSelectedCYCOOffer: function setSelectedCYCOOffer(hasOffer) {
        this.has_selected_cyco = hasOffer;
    },

    hasSelectedCYCOOffer: function hasSelectedCYCOOffer() {
        return this.has_selected_cyco;
    },

    // Cross border is when the merchant and buyer countries mismatch
    setCrossBorder: function setCrossBorder(value) {
        this.is_cross_border = value;
    },

    isCrossBorder: function isCrossBorder() {
        return this.is_cross_border;
    },

    // Cross currency: getCartAmountAndCurrency and setCartAmountAndCurrency
    getCartAmountAndCurrency: function getCartAmountAndCurrency() {
        if (this.cart_amount && this.cart_currency) {
            return {
                cart_amount: this.cart_amount,
                cart_currency: this.cart_currency
            };
        }
    },

    setCartAmountAndCurrency: function setCartAmountAndCurrency(cartData) {
        this.cart_amount = cartData && cartData.cart_amount;
        this.cart_currency = cartData && cartData.cart_currency;
    },

    getInstallmentCount: function getInstallmentCount() {
        return this.installment_count;
    },

    setInstallmentCount: function setInstallmentCount(count) {
        this.installment_count = count;
    }
});

var $CreditInstallmentModel = exports.$CreditInstallmentModel = _squid.$Model.extend('$CreditInstallmentModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/creditOptions/'
    })
});

var $CreditInstallmentOptionsModel = exports.$CreditInstallmentOptionsModel = _squid.$Model.extend('$CreditInstallmentOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/installmentOptions/',
        postAttempts: 2
    }),

    init: function init() {
        this.setProperties({
            installmentOffers: [],
            installmentCount: 0,
            installmentOptionsPresent: false,
            niOffer: [],
            niOfferPresent: false
        });
        this.meta = {
            populated: false
        };
    },

    onPopulate: function onPopulate() {
        if (this.installments && this.installments[0]) {
            this.storeInstallments();
        } else {
            _logger.$logger.log('No installments offer');
        }
    },

    storeInstallments: function storeInstallments() {

        this.installmentOffers = this.installments && this.installments[0];
        this.installmentCount = this.installmentOffers.installment_options && this.installmentOffers.installment_options.length;
        this.installmentOptionsPresent = this.installmentCount > 0;
        this.niOfferPresent = this.installmentOffers.sac_options && this.installmentOffers.sac_options.creditType;
        this.niOffer = this.niOfferPresent && this.installmentOffers.sac_options;
    },

    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.cacheParam) {
            this.cacheParam.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },

    getInstallmentOptionsPresent: function getInstallmentOptionsPresent() {
        return this.installmentOptionsPresent;
    },

    getInstallmentOffers: function getInstallmentOffers(param) {
        if (typeof param === 'undefined') {
            return this.installmentOffers;
        } else {
            if (!this.installmentOffers || !this.installmentOffers.installment_options) {
                return;
            }
            if (typeof param === 'string') {
                switch (param) {
                    case 'APR_ASCE':
                        return this.installmentOffers.installment_options.sort(function (a, b) {
                            return +a.apr - +b.apr;
                        })[0];
                    case 'TERM_DESC':
                        return this.installmentOffers.installment_options.sort(function (a, b) {
                            return +b.term - +a.term;
                        })[0];
                    default:
                        return this.installmentOffers.installment_options[0];
                }
            } else {
                return this.installmentOffers.installment_options[param];
            }
        }
    },

    getInstallmentCount: function getInstallmentCount() {
        return this.installmentCount;
    },

    getNiOffer: function getNiOffer() {
        return this.niOffer;
    },

    getNiOfferPresent: function getNiOfferPresent() {
        return this.niOfferPresent;
    },

    serialize: function serialize() {
        var data = {
            payee: this.payee,
            checkoutCart: this.checkoutCart,
            checkoutAppData: this.checkoutAppData,
            isMemberCredit: true
        };

        return (0, _checkout.serializeInstallmentsOptionsData)(data);
    },
    save: function save(options) {
        options.data = this.serialize();

        return this._super.save.call(this, options);
    }
});

var $CreditSharedInfoModel = exports.$CreditSharedInfoModel = _squid.$Model.extend('$CreditSharedInfoModel', {

    init: function init() {
        this.setProperties({
            installmentOfferPresent: false,
            installmentOffer: null,
            installmentOfferFinancingDetails: null,
            showCreditExample: false,
            fiCount: 0,
            morsDiscoverMessageFPTIFired: false,
            cartAmountVisible: false,
            redirectToCapeCyco: false
        });
        this._super.init.apply(this);
    },
    setInstallmentOfferPresent: function setInstallmentOfferPresent(installmentOfferPresent) {
        this.installmentOfferPresent = installmentOfferPresent;
    },
    hasInstallmentOffers: function hasInstallmentOffers() {
        return this.installmentOfferPresent;
    },
    setInstallmentOffer: function setInstallmentOffer(installmentOffer) {
        this.installmentOffer = installmentOffer;
    },
    getInstallmentOffer: function getInstallmentOffer() {
        return this.installmentOffer;
    },
    setInstallmentOfferFinancingDetails: function setInstallmentOfferFinancingDetails(installmentOfferFinancingDetails) {
        this.installmentOfferFinancingDetails = installmentOfferFinancingDetails;
    },
    hasInstallmentOfferFinancingDetails: function hasInstallmentOfferFinancingDetails() {
        return !!this.installmentOfferFinancingDetails;
    },
    getInstallmentOfferFinancingDetails: function getInstallmentOfferFinancingDetails() {
        return this.installmentOfferFinancingDetails;
    },
    setShowCreditExample: function setShowCreditExample(shouldShowCreditExample) {
        this.showCreditExample = shouldShowCreditExample;
    },
    shouldShowCreditExample: function shouldShowCreditExample() {
        return this.showCreditExample;
    },
    setFiCount: function setFiCount(count) {
        this.fiCount = parseInt(count, 10);
    },
    getFiCount: function getFiCount() {
        return this.fiCount;
    },
    getMorsFptiFiredFlag: function getMorsFptiFiredFlag() {
        return this.morsDiscoverMessageFPTIFired;
    },
    setMorsFptiFiredFlag: function setMorsFptiFiredFlag(alreadyFired) {
        this.morsDiscoverMessageFPTIFired = alreadyFired;
    },
    getCartAmountVisible: function getCartAmountVisible() {
        return this.cartAmountVisible;
    },
    setCartAmountVisible: function setCartAmountVisible(visible) {
        this.cartAmountVisible = visible;
    },
    setRedirectToCapeCyco: function setRedirectToCapeCyco(flag) {
        this.redirectToCapeCyco = flag;
    },
    getRedirectToCapeCyco: function getRedirectToCapeCyco() {
        return this.redirectToCapeCyco;
    }
});

angular.value("$CreditDataModel", $CreditDataModel);
angular.value("$CreditInstallmentModel", $CreditInstallmentModel);
angular.value("$CreditInstallmentOptionsModel", $CreditInstallmentOptionsModel);
angular.value("$CreditSharedInfoModel", $CreditSharedInfoModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_logger.$logger;

_checkout.serializeInstallmentsOptionsData;

/***/ }),

/***/ "../node_modules/xo-models/src/donation/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GiveAtCheckoutModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $GiveAtCheckoutModel = exports.$GiveAtCheckoutModel = _squid.$Model.extend('$GiveAtCheckoutModel', {
    api: new _squid.$Api({
        uri: '/api/donation',
        postAttempts: 2
    })
});

angular.value("$GiveAtCheckoutModel", $GiveAtCheckoutModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/eligibility/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$stickyCTA = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var checkEligibility = function checkEligibility() {
    var token = _angular.$rootScope.token;
    var models = {};

    return _squid.$promise.all([(0, _squid.$populate)(models, {
        checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
        checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
        checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
    }), _gdprCookieBanner.$GDPRCookieBannerModel.instance().hasBanner()]).then(function () {
        // Device Checks
        var userAgent = _angular.$window.navigator.userAgent;
        var isIE = !!userAgent.match(/MSIE|trident|edge/i);
        var isMobile = _index.$DeviceInfo.isMobile();
        var miniBrowser = _angular.$rootScope.miniBrowser;
        var isValidTraffic = isMobile || miniBrowser;
        var isSmallScreen = _angular.$window.innerWidth <= 600;

        // Flow Checks
        var billing = models.checkoutCartModel.isBilling();
        var invoice = models.checkoutAppDataModel.get('flags.is_invoice_flow');
        var upop = models.checkoutSessionModel.unconfirmed_upop;
        var gpdr = _gdprCookieBanner.$GDPRCookieBannerModel.instance().shown();

        // Feature checks
        var eligibleCountry = (0, _squid.$feature)('stickyCTA');
        var ineligibilityConditions = {
            isIE: isIE,
            upop: upop,
            invoice: invoice,
            gpdr: gpdr,
            billing: billing,
            isNotSmallScreen: !isSmallScreen,
            isNotValidTraffic: !isValidTraffic,
            isNotEligibleCountry: !eligibleCountry
        };

        var decision = isValidTraffic && eligibleCountry && isSmallScreen && !billing && !invoice && !upop && !isIE && !gpdr;

        var ineligibilityReasons = Object.keys(ineligibilityConditions).filter(function (key) {
            return ineligibilityConditions[key];
        });
        var eligibility_reason = 'eligible';

        if (ineligibilityReasons.length > 0 || !decision) {
            eligibility_reason = 'ineligible-' + ineligibilityReasons.join(',');
        }
        _logger.$logger.info('checkout_fpti', {
            from: 'sticky_cta',
            to: 'process_eligibility_check',
            eligibility_reason: eligibility_reason
        });

        return decision;
    });
};

var checkPxp = function checkPxp() {
    var _$CheckoutAppDataMode = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
        merchant = _$CheckoutAppDataMode.merchant;

    var country = merchant && merchant.merchant_country;

    return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_sticky_cta_(.*)', false, true).then(function (treatment) {
        if (treatment) {
            var test = /xo_hermesnode_sticky_cta_(.*)/g;
            var name = treatment && treatment.treatment_name;
            var treatmentTest = test.exec(name);
            var treatmentName = treatmentTest.length > 1 && treatmentTest[1];

            _logger.$logger.info('checkout_fpti', {
                from: 'sticky_cta',
                to: 'process_pxp_check',
                eligibility_reason: treatmentName
            });
            return treatmentName;
        }
        return '';
    });
};

var mapper = function mapper(eligibility, treatment) {
    var variant = {
        'treatmentA': 'bottom',
        'treatmentB': 'top',
        'control': '',
        'DEFAULT': ''
    };
    var result = variant[treatment] || variant.DEFAULT;

    _logger.$logger.info('checkout_fpti', {
        from: 'sticky_cta',
        to: 'process_variant_check',
        eligibility_reason: result || 'ineligible'
    });
    return result;
};

/**
 * To be replaced by $EligibilityClass.
 * Following new EligibilityClass pattern.
*/
var $stickyCTA = exports.$stickyCTA = _squid.$Model.extend('$stickyCTA', {
    getEligibility: function getEligibility() {
        return checkEligibility().then(function (eligibility) {
            if (eligibility) {
                return checkPxp().then(function (treatment) {
                    return mapper(eligibility, treatment);
                });
            } else {
                return '';
            }
        });
    }
});

angular.value("$stickyCTA", $stickyCTA);
_angular.$rootScope;

_angular.$window;

_logger.$logger;

_squid.$Model;

_squid.$populate;

_squid.$pxp;

_squid.$feature;

_squid.$promise;

_index.$DeviceInfo;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_gdprCookieBanner.$GDPRCookieBannerModel;

/***/ }),

/***/ "../node_modules/xo-models/src/experiments/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.baNoCardAddCardLinkExperiment = exports.balanceComprehensionBannerExperiment = exports.isBalanceComprehensionBannerExpEligible = exports.deInstallmentIsRamped = exports.padToggleWalletSupported = exports.padToggleFeatureSupported = exports.PAD_CHECKBOX_SUPPORTED_ELMO_ENABLED_COUNTRIES = exports.PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = exports.PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = ['Trmt_xo_hermesnode_pad_2_ui'];
var PAD_CHECKBOX_SUPPORTED_ELMO_ENABLED_COUNTRIES = exports.PAD_CHECKBOX_SUPPORTED_ELMO_ENABLED_COUNTRIES = ['AU', 'CA', 'GB', 'ES', 'FR', 'NL'];

/*
    * Returns the feature configuration
    *
    * If the country its part of the countries in the list of pxp enabled countries
    * we will check first if the treatment its enabled before calling the feature.
    *
    * if the treatment its not enabled we will return false for this feature.
    *
    * otherwise we will just return whatever is configured on the feature
*/
var _getPad2Feature = function _getPad2Feature(feature) {
    var country = _squid.$locale.country;


    if (PAD_CHECKBOX_SUPPORTED_ELMO_ENABLED_COUNTRIES.includes(country)) {
        // if the contry is any of the allowed countries we want to check that the experiment its enabled before returning the config values
        return (0, _squid.$elmo)('xo_hermesnode_pad_2_ui', { 'ctx.country': _squid.$locale.country, res: 'pad_2_ui' }, PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS.join('|')).then(function (elmoResponse) {
            // If the elmo has a valid treatment then enable based on the configs
            // this will enable to enable/disable the new pad experience with an experiment and configs
            if (elmoResponse) {
                return (0, _squid.$feature)(feature, false, country);
            }
            return false;
        });
    }
    return _squid.$promise.resolve((0, _squid.$feature)(feature, false, country));
};

var padToggleFeatureSupported = exports.padToggleFeatureSupported = function padToggleFeatureSupported() {
    return _getPad2Feature('padToggleFeatureSupported');
};

var padToggleWalletSupported = exports.padToggleWalletSupported = function padToggleWalletSupported() {
    return _getPad2Feature('padToggleWalletSupported');
};

var deInstallmentIsRamped = exports.deInstallmentIsRamped = function deInstallmentIsRamped() {
    return (0, _squid.$elmo)('xo_de_ppc_radio_banner', { 'ctx.COUNTRY': 'DE' }, 'Trmt_xo_de_ppc_radio_banner', false, true).then(function (res) {
        var treatmentName = res && res.treatment_name;

        return treatmentName === 'Trmt_xo_de_ppc_radio_banner';
    });
};

var balanceComprehensionBannerExperimentCalled = false;
var balanceComprehensionBannerDisplayed = false;

var isBalanceComprehensionBannerExpEligible = exports.isBalanceComprehensionBannerExpEligible = function isBalanceComprehensionBannerExpEligible(_ref) {
    var cart = _ref.cart,
        checkoutSession = _ref.checkoutSession,
        checkoutAppData = _ref.checkoutAppData;

    var expEligibleBillingTypes = ['MERCHANT_INITIATED_BILLING', 'MERCHANT_INITIATED_SINGLE_BILLING', 'CHANNEL_INITIATED_BILLING'];
    var isBillingNoPurchase = cart.isBillingNoPurchase();
    var isEmptyPlan = checkoutSession.futurePaymentInstruments && checkoutSession.futurePaymentInstruments.length === 0;
    var allowBaWithoutBufs = checkoutAppData.flags && checkoutAppData.flags.allow_billing_agreement_without_bufs;
    var isBANoCardFlow = isBillingNoPurchase && isEmptyPlan && allowBaWithoutBufs;
    var billingType = cart.billing && cart.billing.type;

    if (isBillingNoPurchase && !isBANoCardFlow && expEligibleBillingTypes.indexOf(billingType) > -1) {
        return _user.$UserEligibleToHoldBalanceModel.instance().retrieve().then(function (res) {
            var eligibleToHoldBalance = res && res.eligibleToHoldBalance;

            _logger.$logger.info('balanceComprehensionBannerExperiment_CIP_STATUS', { eligibleToHoldBalance: eligibleToHoldBalance });
            return eligibleToHoldBalance;
        })['catch'](function () {
            _logger.$logger.info('balanceComprehensionBannerExperiment_CIP_CHECK_ERROR');
            return false;
        });
    }
    return _angular.$q.when(false);
};
var balanceComprehensionBannerExperiment = exports.balanceComprehensionBannerExperiment = {
    getTreatment: function getTreatment(_ref2) {
        var page = _ref2.page,
            cart = _ref2.cart,
            checkoutAppData = _ref2.checkoutAppData,
            checkoutSession = _ref2.checkoutSession,
            payee = _ref2.payee;

        return isBalanceComprehensionBannerExpEligible({
            cart: cart,
            checkoutAppData: checkoutAppData,
            checkoutSession: checkoutSession
        }).then(function (eligible) {
            if (!eligible) {
                return _angular.$q.when();
            }
            var fiCount = checkoutSession.futurePaymentInstruments && checkoutSession.futurePaymentInstruments.length;

            if (page === 'review' && fiCount !== 1) {
                _logger.$logger.info('balanceComprehensionBannerExperiment_SKIP', { page: page, fiCount: fiCount });
                return _angular.$q.when();
            }
            balanceComprehensionBannerExperimentCalled = true;
            var billingType = cart.billing.type;
            var merchantId = payee.get('merchant.id');
            var merchantCountry = checkoutAppData.get('merchant.merchant_country');

            return (0, _squid.$elmo)('balance_banner_ramp_hermes', {
                'ctx.buyerCountry': _squid.$locale.country,
                'ctx.landingPage': page,
                'ctx.merchantId': merchantId,
                'ctx.merchantCountry': merchantCountry,
                'ctx.billingType': billingType,
                'ctx.fiCount': fiCount }, 'Trmt_balance_banner_ramp_hermes_.*', false, false).then(function (res) {
                balanceComprehensionBannerDisplayed = res && (res.treatment_name === 'Trmt_balance_banner_ramp_hermes_top' || res.treatment_name === 'Trmt_balance_banner_ramp_hermes_bottom');
                _logger.$logger.info('balanceComprehensionBannerExperiment', { treatment: res && res.treatment_name, page: page });
                return res;
            })['catch'](function (e) {
                _logger.$logger.info('balanceComprehensionBannerExperiment_ELMO_ERROR', { page: page });
                return _angular.$q.when();
            });
        })['catch'](function (e) {
            _logger.$logger.info('balanceComprehensionBannerExperiment_IS_ELIGIBLE_CHECK_ERROR', { page: page });
            return _angular.$q.when();
        });
    },
    experimentCalled: function experimentCalled() {
        return balanceComprehensionBannerExperimentCalled;
    },
    bannerDisplayed: function bannerDisplayed() {
        return balanceComprehensionBannerDisplayed;
    }
};

/*
 * Experimentation for showing add card link in Billing No Card Flows
 * ELMO: https://admin.paypalinc.com/elmo/experiment/101657
 */
var baNoCardAddCardLinkExpCalled = false;

var baNoCardAddCardLinkExperiment = exports.baNoCardAddCardLinkExperiment = {
    // Fetches the treatment response from ELMO for BA No Card Add Card Link experiment
    getTreatment: function getTreatment(_ref3) {
        var billingType = _ref3.billingType,
            merchantCountry = _ref3.merchantCountry,
            merchantId = _ref3.merchantId;

        baNoCardAddCardLinkExpCalled = true;
        return (0, _squid.$elmo)('rt_opt_banocard_addcard_link', {
            'ctx.buyerCountry': _squid.$locale.country,
            'ctx.billingType': billingType,
            'ctx.client': 'hermes',
            'ctx.merchantCountry': merchantCountry,
            'ctx.merchantId': merchantId
        }, 'Trmt_rt_opt_banocard_addcard_link', false, false).then(function (res) {
            _logger.$logger.info('baNoCardAddCardLinkExperiment', { treatment: res && res.treatment_name });
            return res;
        })['catch'](function (e) {
            _logger.$logger.info('baNoCardAddCardLinkExperiment_ELMO_ERROR');
            return _angular.$q.when();
        });
    },
    // Returns if the BA No Card Add Card Link experiment was already called in the flow
    experimentCalled: function experimentCalled() {
        return baNoCardAddCardLinkExpCalled;
    }
};

_squid.$feature;

_squid.$locale;

_squid.$promise;

_squid.$elmo;

_user.$UserEligibleToHoldBalanceModel;

_angular.$q;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CardInfoModel = exports.$WalletInstrumentNameMapping = exports.$WalletPreferences = exports.$ResolveOTP = exports.$CardConfirmationModel = exports.$Resolve3DS = exports.$CardTypeFromBinModel = exports.$BillingAddressesModel = exports.$CurrencyConversionModel = exports.$BillingAddressModel = exports.$AddBillingAddressModel = exports.$DeleteCardModel = exports.$SepaModel = exports.$PreferredFi = exports.$AddBankModel = exports.$BankModel = exports.$CardTypesModel = exports.$UnavailableCardModel = exports.$AddCardModel = exports.$CardModel = exports.BILLING_ADDRESS_FORMAT = undefined;

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var BILLING_ADDRESS_FORMAT = exports.BILLING_ADDRESS_FORMAT = {
    DEFAULT: {
        ',': ', ',
        ' ': ' '
    },
    IL: {
        he: {
            ',': '‏, ‏',
            ' ': '‏ ‏'
        }
    }
};

var $CardModel = exports.$CardModel = _squid.$Model.extend('$CardModel', {
    serialize: function serialize() {
        return {
            type: this.type,
            number: this.number.replace(/[^\d]+/g, ''),
            security_code: this.security_code,
            expiry_month: this.expiry_month && _squid.$util.pad(this.expiry_month, 2),
            expiry_year: this.expiry_year,
            issue_number: this.issue_number ? this.issue_number : undefined,
            start_month: this.start_month ? _squid.$util.pad(this.start_month, 2) : undefined,
            start_year: this.start_year ? this.start_year : undefined
        };
    },

    last4: function last4() {
        var cardNumber = this.number;

        return cardNumber.substr(cardNumber.length - 4);
    },

    isExisting: function isExisting() {
        return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
    }
});

var $AddCardModel = exports.$AddCardModel = _squid.$Model.extend('$AddCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id?'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.card = new $CardModel();
    },

    serialize: function serialize() {
        var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;

        return {
            cardType: this.cardType ? this.cardType : 'creditCard',
            sponsor_id: this.sponsor_id,
            preference: this.preference,
            user: this.user,
            card: this.card.serialize(),
            address: id ? {
                id: id
            } : this.address.serialize()
        };
    },

    clearId: function clearId() {
        delete this.id;
    }
});

var $UnavailableCardModel = exports.$UnavailableCardModel = _squid.$Model.extend('$UnavailableCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/unavailable/card?addFIContingency'
    })
});

var $CardTypesModel = exports.$CardTypesModel = _squid.$Model.extend('$CardTypesModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/types?country=:country&token=:token'
    }),

    retrieve: function retrieve() {
        return this._super.retrieve.apply(this, arguments).then(function (result) {
            this.disallowedCards = (0, _squid.$feature)('disallowedCards', undefined, this.country);
            // override disallowed cards with card types config list based on country
            if (this.disallowedCards) {
                result.disallowed = this.disallowedCards.cardTypes;
            }
            return result;
        });
    },

    supportedNames: function supportedNames() {
        if (typeof this.allowed === 'undefined') {
            return;
        }

        return this.allowed.map(function (type) {
            return _squid.$locale.content.cardTypes[type];
        });
    },

    unsupportedNames: function unsupportedNames() {
        if (typeof this.disallowed === 'undefined') {
            return;
        }

        return this.disallowed.map(function (type) {
            return _squid.$locale.content.cardTypes[type];
        });
    }
});

var $BankModel = exports.$BankModel = _squid.$Model.extend('$BankModel', {
    init: function init() {
        this._super.init.apply(this);
        this.bank_account_number = '';
        this.bank_routing_number = '';
        this.iban_number = '';
    },

    serialize: function serialize() {
        var data = {};

        if (this.bank_account_number) {
            data.bank_account_number = this.bank_account_number;
        }
        if (this.bank_routing_number) {
            data.bank_routing_number = this.bank_routing_number;
        }
        if (this.iban_number) {
            data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
        }
        return data;
    }
});

var $AddBankModel = exports.$AddBankModel = _squid.$Model.extend('$AddBankModel', {
    api: new _squid.$Api({
        uri: '/api/fi/bank'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.user = this.user || {
            first_name: '',
            dob_day: '',
            dob_month: '',
            dob_year: '',
            currency_code: '',
            country: ''
        };
        this.bank = this.bank || new $BankModel();
        this.address = this.address || {};
        this.creditorDetails = this.creditorDetails || {};
        this.fiDetails = this.fiDetails || {};
    },

    getBankData: function getBankData() {
        var data = {};

        // Set user info
        data.user = this.user;

        // Set bank info
        var bank = {};

        this.bank = this.bank || {};

        if (this.candidate_id) {
            data.candidate_id = this.candidate_id;
        }

        if (this.bank.bank_account_number) {
            bank.bank_account_number = this.bank.bank_account_number;
        }

        if (this.bank.bank_routing_number) {
            bank.bank_routing_number = this.bank.bank_routing_number;
        }

        if (this.bank.iban_number) {
            bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
        }
        data.bank = bank;

        // Set address info
        if (this.address) {
            data.address = {
                line1: this.address.line1,
                line2: this.address.line2,
                city: this.address.city,
                country: this.address.country,
                postal_code: this.address.postal_code
            };
        }

        return data;
    }
});

var $PreferredFi = exports.$PreferredFi = _squid.$Model.extend('$PreferredFi', {
    api: new _squid.$Api({
        uri: '/api/fi/preferred'
    }),

    init: function init() {
        this._super.init.apply(this);

        // Get the type of device to send to FI for logging
        function getUiChannel() {
            var capabilities = _index.$DeviceInfo.getCapabilities();

            if (capabilities.isTablet) {
                return 'Tablet';
            } else if (capabilities.isMobile) {
                return 'Mobile';
            } else if (capabilities.isDesktop) {
                return 'Desktop';
            } else if (capabilities.isApp) {
                return 'App';
            } else {
                return null;
            }
        }

        this.uiChannel = getUiChannel();
    },

    serialize: function serialize() {
        return {
            preferred: this.preferred,
            uiChannel: this.uiChannel
        };
    }
});

var $SepaModel = exports.$SepaModel = _squid.$Model.extend('$SepaModel', {
    api: new _squid.$Api({
        uri: '/api/fi/bank'
    })
});

var $DeleteCardModel = exports.$DeleteCardModel = _squid.$Model.extend('$DeleteCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id/delete'
    })
});

var $AddBillingAddressModel = exports.$AddBillingAddressModel = _squid.$Model.extend('$AddBillingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/fi/:instrumentid/addbillingaddress'
    })
});

var $BillingAddressModel = exports.$BillingAddressModel = _squid.$Model.extend('$BillingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/fi/billingaddress/validate'
    }),

    format: function format() {

        var langConfig = (BILLING_ADDRESS_FORMAT[_squid.$locale.country] || {})[_squid.$locale.lang] || {};

        var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
        var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];

        return _squid.$util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + _squid.$util.filter([this.postal_code]);
    },

    serialize: function serialize() {
        return {
            line1: this.line1 && this.line1.trim(),
            line2: this.line2 && this.line2.trim(),
            city: this.city && this.city.trim(),
            state: this.state && this.state.trim(),
            postal_code: this.postal_code && this.postal_code.trim(),
            normalization_status: this.normalization_status,
            country: this.country
        };
    }
});

var $CurrencyConversionModel = exports.$CurrencyConversionModel = _squid.$Model.extend('$CurrencyConversionModel', {
    api: new _squid.$Api({
        uri: '/api/fi/currencyConversion'
    })
});

var $BillingAddressesModel = exports.$BillingAddressesModel = _squid.$Model.extend('$BillingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/fi/billingaddress'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($BillingAddressModel, this.addresses);
    }
});

var $CardTypeFromBinModel = exports.$CardTypeFromBinModel = _squid.$Model.extend('$CardTypeFromBinModel', {
    api: new _squid.$Api({
        uri: '/api/fi/cardTypeFromBin'
    })
});

var $Resolve3DS = exports.$Resolve3DS = _squid.$Model.extend('$Resolve3DS', {
    api: new _squid.$Api({
        uri: '/api/fi/3ds/:id'
    })
});

var $CardConfirmationModel = exports.$CardConfirmationModel = _squid.$Model.extend('$CardConfirmationModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id/confirmations'
    })
});

var $ResolveOTP = exports.$ResolveOTP = _squid.$Model.extend('$ResolveOTP', {
    api: new _squid.$Api({
        uri: '/api/fi/otp/:id'
    })
});

var $WalletPreferences = exports.$WalletPreferences = _squid.$Model.extend('$WalletPreferences', {
    api: new _squid.$Api({
        uri: '/api/fi/wallet/preferences'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    init: function init() {
        this._super.init.apply(this);
        this.topup = {};
        this.direct = {};
    },

    serialize: function serialize() {
        var data = {};

        if (this.topup.amount) {
            var _topup = this.topup,
                amount = _topup.amount,
                _topup$fundingSource = _topup.fundingSource;
            _topup$fundingSource = _topup$fundingSource === undefined ? {} : _topup$fundingSource;
            var instrument_id = _topup$fundingSource.instrument_id;

            // Set the Topup funding instrument in the wallet preference api, which will be used by future Topup transactions

            data.topup = {
                amount: amount,
                instrument_id: instrument_id,
                autoload_minimum_threshold: _squid.$config.topup.autoload_minimum_threshold
            };
        } else {
            var _direct$fundingSource = this.direct.fundingSource;
            _direct$fundingSource = _direct$fundingSource === undefined ? {} : _direct$fundingSource;
            var _instrument_id = _direct$fundingSource.instrument_id;

            // Set the Direct funding instrument in the wallet preference api, which will be used by future Direct funding transactions

            data.direct = {
                instrument_id: _instrument_id,
                currency_code: this.currency
            };
        }
        return data;
    },

    /**
        * Return the preferred topup/direct fundingsource.
        * Originally values of topup & direct are from the FI wallet preferences api, which gets assigned during the init() call.
        * Values can be changed in the Review and the Wallet pages.
        */
    getPreferred: function getPreferred() {
        if (this.topup.fundingSource && this.topup.fundingSource.instrument_id) {
            // xo-hermes-fi will always return topup.fundingSource even when there is no preferred topup instrument, hence making the additional check here.
            return this.topup.fundingSource;
        } else {
            return this.direct.fundingSource || {};
        }
    }
});

var $WalletInstrumentNameMapping = exports.$WalletInstrumentNameMapping = _squid.$Model.extend('$WalletInstrumentNameMapping', {
    init: function init() {
        this._super.init.apply(this);
        this.INSTRUMENT_MAP = {
            AMSOUTH: /AMSOUTH,/,
            BOFA: /BANK OF AMERICA/,
            CAPITAL: /CAPITAL/,
            CHASE: /CHASE/,
            CITI: /CITIBANK/,
            FIFTHTHIRD: /FIFTH THIRD BANK/,
            HUNTINGTON: /HUNTINGTON/,
            INGDIRECT: /ING DIRECT/,
            NATIONALCITY: /NATIONAL CITY/,
            PNC: /PNC/,
            REGIONS: /REGIONS/,
            SUNTRUST: /SUNTRUST/,
            TDWATERHOUSE: /TD WATERHOUSE/,
            USAA: /USAA/,
            USBANK: /US BANK/,
            VISA: /VISA/,
            WAMUTUAL: /WASHINGTON MUTUAL/,
            WELLSFARGO: /WELLS FARGO/
        };
        this.INSTRUMENT_NAMES = Object.keys(this.INSTRUMENT_MAP);
    },

    getInstrumentNameNormalized: function getInstrumentNameNormalized(fsName) {
        var _this = this;

        if (!fsName) {
            return;
        }

        fsName = fsName.toUpperCase();

        return _squid.$util.find(this.INSTRUMENT_NAMES, function (instName) {
            if (_this.INSTRUMENT_MAP[instName].test(fsName)) {
                return true;
            }
            return false;
        });
    }
});

var $CardInfoModel = exports.$CardInfoModel = _squid.$Model.extend('$CardInfoModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id'
    })
});

angular.value("BILLING_ADDRESS_FORMAT", BILLING_ADDRESS_FORMAT);
angular.value("$CardModel", $CardModel);
angular.value("$AddCardModel", $AddCardModel);
angular.value("$UnavailableCardModel", $UnavailableCardModel);
angular.value("$CardTypesModel", $CardTypesModel);
angular.value("$BankModel", $BankModel);
angular.value("$AddBankModel", $AddBankModel);
angular.value("$PreferredFi", $PreferredFi);
angular.value("$SepaModel", $SepaModel);
angular.value("$DeleteCardModel", $DeleteCardModel);
angular.value("$AddBillingAddressModel", $AddBillingAddressModel);
angular.value("$BillingAddressModel", $BillingAddressModel);
angular.value("$CurrencyConversionModel", $CurrencyConversionModel);
angular.value("$BillingAddressesModel", $BillingAddressesModel);
angular.value("$CardTypeFromBinModel", $CardTypeFromBinModel);
angular.value("$Resolve3DS", $Resolve3DS);
angular.value("$CardConfirmationModel", $CardConfirmationModel);
angular.value("$ResolveOTP", $ResolveOTP);
angular.value("$WalletPreferences", $WalletPreferences);
angular.value("$WalletInstrumentNameMapping", $WalletInstrumentNameMapping);
angular.value("$CardInfoModel", $CardInfoModel);
_index.$DeviceInfo;

_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

_squid.$feature;

_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var issuerDeclineExperimentMap = exports.issuerDeclineExperimentMap = {
    Trmt_xo_hermesnodeweb_issuer_decline_1: {
        memberPreferredIssuer: 'payment.processorDeclineBlacklistFIPreferredIssuer',
        memberPreferredNoIssuer: 'payment.processorDeclineBlacklistFIPreferredNoIssuer',
        memberNoPreferredIssuer: 'payment.processorDeclineBlacklistFINoPreferredIssuer',
        memberNoPreferredNoIssuer: 'payment.processorDeclineBlacklistFINoPreferredNoIssuer',
        memberNoFIPreferredIssuer: 'payment.processorDeclineBlacklistNoFIPreferredIssuer',
        memberNoFIPreferredNoIssuer: 'payment.processorDeclineBlacklistNoFIPreferredNoIssuer',
        memberNoFINoPreferredIssuer: 'payment.processorDeclineBlacklistNoFINoPreferredIssuer',
        memberNoFINoPreferredNoIssuer: 'payment.processorDeclineBlacklistNoFINoPreferredNoIssuer',
        type: 'info'
    }
};

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/fiApis.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$fiApis = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var $fiApis = exports.$fiApis = {
    patchCvv: function patchCvv(checkoutSession) {
        var cvvData = checkoutSession.get('cvvData');

        if (cvvData) {
            return checkoutSession.action('patchCvv', {
                data: {
                    id: cvvData.id,
                    cvv: cvvData.security_code,
                    type: cvvData.type,
                    number: cvvData.number
                }
            });
        }

        return _angular.$q.when();
    }
};

angular.value("$fiApis", $fiApis);
_angular.$q;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/fiMessages.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _constants = __webpack_require__("../node_modules/xo-models/src/fi/lib/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fiMessages', function () {
    function getContentKeys(hasFi) {
        if (hasFi) {
            return {
                member: 'payment.processorDeclineMember',
                generic: 'payment.processorDeclineMemberGeneric',
                buyerCredit: 'payment.processorDeclineMemberBuyerCredit'
            };
        } else {
            return {
                member: 'payment.processorDeclineMemberNoFI',
                generic: 'payment.processorDeclineMemberNoFIGeneric',
                buyerCredit: 'payment.processorDeclineMemberBuyerCreditNoFI'
            };
        }
    }

    // Temporary solution until PAPS returns CCID in the declined instrument
    var getIssuerName = function getIssuerName(_ref) {
        var _ref$instrument = _ref.instrument,
            instrument = _ref$instrument === undefined ? {} : _ref$instrument,
            _ref$disallowedInstru = _ref.disallowedInstruments,
            disallowedInstruments = _ref$disallowedInstru === undefined ? [] : _ref$disallowedInstru,
            _ref$cardAccounts = _ref.cardAccounts,
            cardAccounts = _ref$cardAccounts === undefined ? [] : _ref$cardAccounts;

        var last4 = instrument && instrument.last4 ? instrument.last4 : '';
        var search = disallowedInstruments.find(function (disallowedInstrument) {
            return disallowedInstrument.lastDigits === last4;
        });

        if (search) {
            var id = search.id;

            var cardAccount = cardAccounts.find(function (card) {
                return card.id.replace('-', '') === id;
            });

            if (cardAccount) {
                // Will need to eventually deprecate to the Wallet Model to manage this
                var issuerName = cardAccount.issuer && cardAccount.issuer.filtered_issuer_name ? cardAccount.issuer.filtered_issuer_name : '';

                return issuerName;
            }
        }
        return '';
    };

    function isDeclinedCard(checkoutSession) {
        var planInstruments = checkoutSession.fundingOptions.plans;
        var declinedInstruments = checkoutSession.declinedInstruments;
        var fiInstruments = checkoutSession.fundingOptions.instruments;

        if (declinedInstruments && declinedInstruments.length === 1) {
            var singlePlan = checkoutSession.plan;

            planInstruments.forEach(function (plan) {
                if (plan.primaryFs.lastDigits === declinedInstruments[0].last4 && plan.primaryFs.name.toLowerCase() === declinedInstruments[0].card_type.toLowerCase()) {
                    plan.gotDeclined = true;
                    plan.message = 'wallet.processorDeclinedCard';
                }
            });

            fiInstruments.forEach(function (fi) {
                if (fi.lastDigits === declinedInstruments[0].last4 && fi.name.toLowerCase() === declinedInstruments[0].card_type.toLowerCase()) {
                    fi.gotDeclined = true;
                    fi.message = 'wallet.processorDeclinedCard';
                }
            });

            if (singlePlan && singlePlan.sources && singlePlan.sources.length === 1 && singlePlan.sources[0].last4 === declinedInstruments[0].last4) {
                checkoutSession.plan.sources[0].gotDeclined = true;
            }
        }
    }

    function preferredDeclined(checkoutSession, declinedInstruments) {
        var planInstruments = checkoutSession.fundingOptions.plans;
        var isPreferredDeclined = false;

        if (declinedInstruments) {
            planInstruments.forEach(function (plan) {
                if (plan.primaryFs.lastDigits === declinedInstruments.last4 && plan.primaryFs.isPreferred) {
                    isPreferredDeclined = true;
                }
            });
        }
        return isPreferredDeclined;
    }

    function noFIexperience(checkoutSession, declinedInstruments) {
        var plansLength = checkoutSession.fundingOptions.plans.length;
        var declinedLength = declinedInstruments.length;

        return plansLength === 1 && declinedLength === 1;
    }

    var ADD_CARD_URLS = {
        SIDEBAR_DEFAULT: {
            route: '#checkout/review/sidebar/sidebarAddCard/addCardFlow/addCard'
        }
    };

    function processorDeclinedMsg(checkoutSession, hasFi) {
        var experiment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var authSession = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var wallet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var informalName = arguments[5];

        var declinedInstruments = checkoutSession.get('declinedInstruments', []);

        if (_angular2['default'].isArray(declinedInstruments) && declinedInstruments.length) {
            var msg = void 0;
            var type = 'warning';
            var keepMsg = false;
            var instrument = declinedInstruments[0];
            var contentKeys = getContentKeys(hasFi);

            if (instrument.type === 'PAYMENT_CARD') {
                if (instrument.card_type && instrument.last4) {
                    _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'member' });
                    var experimentMap = _constants.issuerDeclineExperimentMap[experiment];

                    if (experimentMap && authSession && wallet) {
                        var card_accounts = wallet.card_accounts;

                        var preferredCard = preferredDeclined(checkoutSession, instrument);
                        var noFImessages = noFIexperience(checkoutSession, declinedInstruments);
                        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);
                        var issuer = getIssuerName({
                            instrument: instrument,
                            disallowedInstruments: disallowedInstruments,
                            cardAccounts: card_accounts
                        });
                        var linkObj = ADD_CARD_URLS.SIDEBAR_DEFAULT;
                        var errorMsg = contentKeys.generic;

                        errorMsg = noFImessages && preferredCard && issuer ? experimentMap.memberNoFIPreferredIssuer : errorMsg;
                        errorMsg = noFImessages && preferredCard && !issuer ? experimentMap.memberNoFIPreferredNoIssuer : errorMsg;
                        errorMsg = noFImessages && !preferredCard && issuer ? experimentMap.memberNoFINoPreferredIssuer : errorMsg;
                        errorMsg = noFImessages && !preferredCard && !issuer ? experimentMap.memberNoFINoPreferredNoIssuer : errorMsg;
                        errorMsg = !noFImessages && preferredCard && issuer ? experimentMap.memberPreferredIssuer : errorMsg;
                        errorMsg = !noFImessages && preferredCard && !issuer ? experimentMap.memberPreferredNoIssuer : errorMsg;
                        errorMsg = !noFImessages && !preferredCard && issuer ? experimentMap.memberNoPreferredIssuer : errorMsg;
                        errorMsg = !noFImessages && !preferredCard && !issuer ? experimentMap.memberNoPreferredNoIssuer : errorMsg;

                        type = experimentMap.type;
                        msg = (0, _squid.$renderContent)(errorMsg, {
                            name: informalName,
                            type: instrument.card_type,
                            issuer: issuer,
                            addCardhref: linkObj.route,
                            number: instrument.last4
                        });
                        keepMsg = true;
                    } else {
                        msg = (0, _squid.$renderContent)(contentKeys.member, {
                            type: instrument.card_type,
                            number: instrument.last4
                        });
                        checkoutSession.set('declinedInstruments', null);
                    }
                } else {
                    _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'generic' });
                    msg = (0, _squid.$renderContent)(contentKeys.generic);
                    checkoutSession.set('declinedInstruments', null);
                }
            } else {
                _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'buyerCredit' });
                msg = (0, _squid.$renderContent)(contentKeys.buyerCredit);
                checkoutSession.set('declinedInstruments', null);
            }

            return {
                type: type,
                msg: msg,
                keepMsg: keepMsg
            };
        }
    }

    function getXoonRedirectAddCardMsg(unavailableCard, message) {
        if (!unavailableCard) {
            _logger.$logger.info(message['msgKey'] + '_card_empty');
            return {
                type: 'info',
                msg: (0, _squid.$renderContent)('creditcard.noFIContingency')
            };
        }

        var msg = (0, _squid.$renderContent)(message['msgKey']);
        var type = message['type'];
        var showDetails = message['showDetails'];

        if (showDetails) {
            var cardType = (0, _squid.$renderContent)('cardTypes.' + unavailableCard.cardType);
            var lastDigits = unavailableCard.lastDigits;

            if (cardType && cardType.toString() && lastDigits) {
                msg = (0, _squid.$renderContent)(message['msgKey'], {
                    cardType: cardType,
                    last4: lastDigits
                });
            } else {
                msg = (0, _squid.$renderContent)('creditcard.noFIContingency');
                type = 'info';
                _logger.$logger.info(message['msgKey'] + '_detail_missing');
            }
        }

        _logger.$logger.info(message['msgKey'], { type: unavailableCard.cardType, msgType: type, msgRendered: msg ? true : false });
        return {
            type: type ? type : 'info',
            msg: msg ? msg : (0, _squid.$renderContent)('creditcard.noFIContingency')
        };
    }

    function getAddCardControlMsg(checkoutSession) {
        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);

        if (disallowedInstruments && disallowedInstruments.length === 1) {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'single_disallowed_FI_addcard_control_msg'
            });
        } else if (disallowedInstruments && disallowedInstruments.length > 1) {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'multi_disallowed_FI_addcard_control_msg'
            });
        } else {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'has_no_disallowed_FI_addcard_control_msg'
            });
        }

        if (checkoutSession.isCreditDisallowedForMerchant) {
            return;
        }

        return {
            msg: (0, _squid.$renderContent)('creditcard.noFIContingency'),
            type: 'info'
        };
    }

    function getAddCardMsg(unavailableCard, _ref2, checkoutSession) {
        var retry = _ref2.retry,
            avsRetry = _ref2.avsRetry,
            redirectFromXoon = _ref2.redirectFromXoon;

        if (retry && redirectFromXoon) {
            var message = {
                msgKey: 'addFiError.declinedRetryWithCardDetails',
                type: 'warning',
                showDetails: true
            };

            return getXoonRedirectAddCardMsg(unavailableCard, message);
        } else if (redirectFromXoon && avsRetry) {
            var _message = {
                msgKey: 'addFiError.declinedWithBilling',
                type: 'warning',
                showDetails: true
            };

            return getXoonRedirectAddCardMsg(unavailableCard, _message);
        } else if (redirectFromXoon && !retry && !avsRetry) {
            var _message2 = {
                msgKey: 'creditcard.noFIContingency',
                type: 'info',
                showDetails: false
            };

            return getXoonRedirectAddCardMsg(unavailableCard, _message2);
        }
        return getAddCardControlMsg(checkoutSession);
    }

    function getAddCardTreatmentMsg(checkoutSession) {
        var msg = void 0;
        var type = void 0;
        var title = void 0;
        var cardList = void 0;
        var lastCard = void 0;
        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);

        disallowedInstruments = disallowedInstruments.filter(function (instrument) {
            return instrument.type && instrument.type !== 'REWARDS' && instrument.type !== 'BALANCE';
        });

        if (disallowedInstruments && disallowedInstruments.length === 1) {
            cardList = disallowedInstruments[0].lastDigits ? disallowedInstruments[0].name + '-' + disallowedInstruments[0].lastDigits : disallowedInstruments[0].name;
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'single_disallowed_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasSingleDisallowedFi', { cardList: cardList });
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.hasDisallowedAddCardTitle');
        } else if (disallowedInstruments && disallowedInstruments.length > 1) {
            cardList = '';

            for (var i = 0; i < disallowedInstruments.length; i++) {
                if (i === disallowedInstruments.length - 1) {
                    lastCard = disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits : disallowedInstruments[i].name;
                } else if (i === disallowedInstruments.length - 2) {
                    cardList += disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits : disallowedInstruments[i].name;
                } else {
                    cardList += disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits + ', ' : disallowedInstruments[i].name + ', ';
                }
            }

            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'multi_disallowed_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasMultipleDisallowedFi', { cardList: cardList, lastCard: lastCard });
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.hasDisallowedAddCardTitle');
        } else {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'has_no_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasNoDisallowedFi');
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.noDisallowedAddCardTitle');
            if (checkoutSession.isCreditDisallowedForMerchant) {
                return;
            }
        }

        return {
            msg: msg,
            type: type,
            title: title
        };
    }

    // User with only banks in disallowed list with message indicating the same
    function getAddBankTreatmentMsg() {
        return {
            msg: (0, _squid.$renderContent)('bank.disallowedAddCard'),
            type: 'normal'
        };
    }

    // Add card contingency for the case where card fails preauth; Show message which indicates that card failed pre-auth
    function getPreAuthTreatmentMsg() {
        var preAuthDisallowed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var disallowedInstrument = preAuthDisallowed[0];


        return {
            msg: (0, _squid.$renderContent)('creditCard.preAuthNoIssuer', {
                cardType: disallowedInstrument && disallowedInstrument.name || '',
                last4: disallowedInstrument && disallowedInstrument.lastDigits || 'xxxx'
            }),
            type: 'info'
        };
    }

    function getGamblingMsg() {
        return {
            type: 'error',
            msg: (0, _squid.$renderContent)('genericError.creditCardIneligible')
        };
    }

    return {
        isDeclinedCard: isDeclinedCard,
        processorDeclinedMsg: processorDeclinedMsg,
        getGamblingMsg: getGamblingMsg,
        getAddCardTreatmentMsg: getAddCardTreatmentMsg,
        getAddCardControlMsg: getAddCardControlMsg,
        getAddCardMsg: getAddCardMsg,
        getAddBankTreatmentMsg: getAddBankTreatmentMsg,
        getPreAuthTreatmentMsg: getPreAuthTreatmentMsg
    };
});

_squid.$renderContent;

_logger.$logger;

_constants.issuerDeclineExperimentMap;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-models/src/fi/lib", "../node_modules/xo-models/src/fi/lib/fiMessages.js"))

/***/ }),

/***/ "../node_modules/xo-models/src/fiMeta/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

var _dist = __webpack_require__("../node_modules/squid/dist/index.js");

var PADSUBTYPE = 'DELAYED_TRANSFER';
var MEFTSUBTYPE = 'MEFT';
var IACHSUBTYPE = 'IACH';
var ECHECKSUBTYPE = 'ECHECK';

// any mappings to normalize fi name
var NAME_MAPPINGS = {
    'MERCHANT_SPECIFIC_BALANCE': 'INCENTIVE'
};

// eslint-disable-next-line no-confusing-arrow
var allFis = function allFis(plan) {
    return plan.secondaryFIs ? [plan.primaryFs].concat(plan.secondaryFIs) : [plan.primaryFs];
};

var isSubType = function isSubType(subtype) {
    return function (fi) {
        return fi.subtype === subtype || fi.sub_type === subtype;
    };
};

var capFirst = function capFirst(product) {
    return product && product.charAt(0).toUpperCase() + product.slice(1).toLowerCase();
};

exports['default'] = _squid.$Model.extend('$FiMetaModel', {
    invalidateOnLogout: true,

    onInvalidate: function onInvalidate() {
        if (this.session) {
            delete this.session;
        }
        if (this.wallet) {
            delete this.wallet;
        }
    },
    fetch: function fetch() {
        var _this = this;

        if (_squid.$config.disableCardArt) {
            return _squid.$promise.resolve(this);
        } else {
            return _squid.$promise.all({
                session: _checkout.$CheckoutSessionModel.instance(this.id).retrieve(),
                wallet: _wallet.$WalletModel.instance(this.id).retrieve()
            }).then(function (r) {
                return _squid.$util.extend(_this, r);
            });
        }
    },
    cardArtEnabled: function cardArtEnabled() {
        if ((0, _squid.$feature)('cardArtEnabled', false)) {
            // return true if feature config enabled for countries and have wallet
            return this.wallet && true;
        }

        return false;
    },
    getCardArt: function getCardArt(fi) {
        return this.wallet && this.cardArtEnabled() && this.wallet.getCardArt(fi);
    },
    plans: function plans() {
        return this.session.fundingOptions.plans;
    },
    hasPadPlan: function hasPadPlan() {
        return this.plans().map(allFis).some(function (fis) {
            return fis.some(isSubType(PADSUBTYPE));
        });
    },
    type: function type(fi) {
        if (fi.type === 'CREDIT' || fi.type === 'BILL_ME_LATER') {
            return 'CREDIT';
        } else {
            return fi.type;
        }
    },
    getName: function getName(fi) {
        if (fi.isPinlessDebit || fi.is_pinless_debit) {
            return (0, _dist.$renderContent)('fsMappings.PINLESSDEBIT');
        }

        // Normalize fs name for content key lookup
        var name = NAME_MAPPINGS[fi.name] || fi.name;

        return this.wallet && this.wallet.getCustomName(fi) || (0, _dist.$renderContent)('fsMappings.' + name).toString() || name;
    },
    getAmount: function getAmount(fi) {
        return fi.amount;
    },
    getCurrencyCode: function getCurrencyCode(fi) {
        return fi.amount.currency_code;
    },
    getAllCurrencyCodes: function getAllCurrencyCodes(plan) {
        return allFis(plan).map(this.getCurrencyCode);
    },
    getCardMask: function getCardMask(fi) {
        var mask = this.wallet && this.wallet.getCardMask(fi);

        if (!mask.before) {
            mask.before = capFirst(fi.productClass);
        }
        if (!mask.after) {
            mask.after = fi.lastDigits || fi.last4;
        }
        return mask;
    },
    isPinlessDebit: function isPinlessDebit(fi) {
        return fi.is_pinless_debit || fi.isPinlessDebit;
    },
    isPad: function isPad(fi) {
        return isSubType(PADSUBTYPE)(fi) || isSubType('PAD')(fi);
    },
    isMeft: function isMeft(fi) {
        return isSubType(MEFTSUBTYPE)(fi);
    },
    isIach: function isIach(fi) {
        return isSubType(IACHSUBTYPE)(fi);
    },
    isEcheck: function isEcheck(fi) {
        return isSubType(ECHECKSUBTYPE)(fi);
    },
    getEditDisallowedContentKey: function getEditDisallowedContentKey(fi) {
        if (!fi) {
            return;
        }
        if (fi.editDisallowedMsg) {
            return 'wallet.' + fi.editDisallowedMsg;
        } else if (this.wallet.isLinkedCard(fi)) {
            return 'wallet.editDisallowedPayment';
        }
    }
});


_squid.$Model;

_squid.$promise;

_squid.$util;

_squid.$config;

_squid.$feature;

_checkout.$CheckoutSessionModel;

_wallet.$WalletModel;

_dist.$renderContent;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-models/src/gdprCookieBanner/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GDPRCookieBannerModel = exports.isGdprValid = exports.testGdprBannerCookie = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var testGdprBannerCookie = exports.testGdprBannerCookie = function testGdprBannerCookie(cookies) {
    return (/(^|;\s*)cookie_prefs=/.test(cookies)
    );
};

var isGdprValid = exports.isGdprValid = function isGdprValid() {
    if (_squid.$util.param('forceGDPR')) {
        return true;
    }

    var country = _squid.$locale.country;

    return _squid.$util.getProperty(_squid.$config, 'GDPR.cookieBanner', { 'default': false }) && _squid.$util.getProperty(_squid.$config, 'GDPR.countries', { 'default': [] }).indexOf(country) > -1;
};

var $GDPRCookieBannerModel = exports.$GDPRCookieBannerModel = _squid.$Model.extend('$GDPRCookieBannerModel', {
    api: new _squid.$Api({
        uri: '/api/cookieBanner'
    }),

    /**
     * Handles the logic for when to fetch the banner and when to return
     * Don't repeat the call for same country
     * Don't return the banner if not PXP check
     * @returns {Promise} resolves an object
     */
    getBanner: function getBanner() {
        var _this = this;

        // API is cached on country. Return current result if already present
        if (this.lastResult && this.lastCountry === _squid.$locale.country && this.lastLang === _squid.$locale.lang) {
            return this.lastResult;
        }

        // Invalidate the model to make a fresh call
        this.invalidate();

        // Log if the user has cookie indicating a previous interaction with the cookie banner
        if (testGdprBannerCookie(document.cookie)) {
            _logger.$logger.info('checkout_fpti', {
                from: 'GDPR_banner',
                to: 'GDPR_banner_has_cookie'
            });
        }

        // Cache the result promise and params
        this.lastCountry = _squid.$locale.country;
        this.lastLang = _squid.$locale.lang;
        this.lastResult = this.retrieve().then(function (res) {
            var html = res.html,
                css = res.css,
                js = res.js;


            if (!html || !js || !css) {
                _logger.$logger.info('gdpr_response_missing_props', {
                    html: !!html,
                    js: !!js,
                    css: !!css
                });
                _this.reset();
                return;
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'GDPR_banner',
                to: 'GDPR_banner_shown'
            });

            return { html: html, css: css, js: js };
        });

        return this.lastResult;
    },
    reset: function reset() {
        this.html = '';
        this.css = '';
        this.js = '';
    },
    shown: function shown() {
        return !!this.html;
    },

    // Check if a banner was shown in the flow.
    // SOME EDGE CASES:
    //   Will not update when the user clicks to accept the banner, and it closes
    //   Will update if retrieve is called with a new country and blank data is returned
    hasBanner: function hasBanner() {
        var _this2 = this;

        // check config flag
        // check if already populated
        // make call again and let regular logic populate html
        // return boolean

        if (!isGdprValid()) {
            return _squid.$promise.resolve(false);
        }
        if (this.html) {
            return _squid.$promise.resolve(this.shown());
        }
        return this.getBanner().then(function () {
            return _this2.shown();
        });
    }
});

angular.value("testGdprBannerCookie", testGdprBannerCookie);
angular.value("isGdprValid", isGdprValid);
angular.value("$GDPRCookieBannerModel", $GDPRCookieBannerModel);
_squid.$Model;

_squid.$Api;

_squid.$locale;

_squid.$config;

_squid.$util;

_squid.$promise;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/inventory/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$InventoryModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $InventoryModel = exports.$InventoryModel = _squid.$Model.extend('$InventoryModel', {
    api: new _squid.$Api({
        uri: '/api/catalog/:id/item/',
        postAttempts: 2,
        cache: true
    }),

    setInvetoryItems: function setInvetoryItems(inventoryItems) {
        this.inventoryItems = inventoryItems;
    },

    getInventoryItems: function getInventoryItems() {
        return this.inventoryItems;
    }
});

angular.value("$InventoryModel", $InventoryModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/marketingoffer/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CreditOfferModel = exports.$MemberSegmentModel = exports.$fireMORSBeacon = exports.$MessageDiscoverModel = exports.$MarketingOfferModel = undefined;

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $MarketingOfferModel = exports.$MarketingOfferModel = _squid.$Model.extend('$MarketingOfferModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offer/search-ads',
        postAttempts: 1,
        cache: true
    }),
    init: function init() {
        this.setProperties({ ads: [] });
        this.meta = { populated: false };
    },
    onPopulate: function onPopulate() {
        var _this = this;

        if (this.targetPlacements && this.targetPlacements[0]) {
            var targetAd = this.ads.find(function (ad) {
                return ad.valid && ad.campaign.adunit_id === _this.targetPlacements[0].placement_code;
            });

            this.ad = undefined;
            if (targetAd) {
                var ad = {};
                var nvpContent = targetAd && targetAd.content && targetAd.content.nvp;

                nvpContent.forEach(function (obj) {
                    ad[obj.name] = obj.value;
                });
                ad['impressionUrl'] = targetAd && targetAd.tracking && targetAd.tracking.impression_url;
                ad['clickUrl'] = targetAd && targetAd.tracking && targetAd.tracking.click_url;
                ad['campaignId'] = targetAd && targetAd.campaign && targetAd.campaign.campaign_id;
                ad['buyItemId'] = targetAd && targetAd.campaign && targetAd.campaign.buy_item_id;
                ad['placementCode'] = targetAd && targetAd.campaign && targetAd.campaign.adunit_id;
                this.ad = ad;
            }
        }
    },
    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.cacheParam) {
            this.cacheParam.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },
    serialize: function serialize() {
        return {
            'site': this.site,
            'locale': this.locale,
            'si': this.si,
            'visit_id': _uuid2['default'].v4(),
            'page': this.page,
            'epu': this.payer,
            'pu_type': this.puType || 'ANONYMOUS',
            'country_code': this.countryCode,
            'payment_context': {
                'total_transaction_amount': this.totalTransactionAmount,
                'total_shipping_amount': this.totalShippingAmount,
                'business_case': 'NONE',
                'business_case_variation': '',
                'validate_existing_offer': 'false',
                'payment_units': [{
                    'transaction_amount': this.totalTransactionAmount,
                    'transaction_id': '',
                    'encrypted_transaction_id': '',
                    'activity_id': '',
                    'payee': {
                        'pu_type': 'BUSINESS',
                        'country_code': this.countryCode,
                        'epu': this.payee,
                        'pu': ''
                    }
                }]
            },
            'target_placements': this.targetPlacements,
            'wallet_instruments': this.walletInstruments,
            'addl_property_installments_not_allowed': this.installmentsNotAllowed
        };
    },
    getTargetAd: function getTargetAd() {
        return this.ad;
    },
    isAdFound: function isAdFound() {
        if (this.ad) {
            for (var property in this.ad) {
                if (this.ad.hasOwnProperty(property)) {
                    return true;
                }
            }
        }
        return false;
    }
});

var $MessageDiscoverModel = exports.$MessageDiscoverModel = _squid.$Model.extend('$MessageDiscoverModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offer/discover-messages',
        postAttempts: 1
    })
});

var $fireMORSBeacon = exports.$fireMORSBeacon = {
    fireBeacon: function fireBeacon(uri) {
        var img = document.createElement('img');

        img.setAttribute('src', uri);
        document.body.appendChild(img);
        return;
    }
};

var $MemberSegmentModel = exports.$MemberSegmentModel = _squid.$Model.extend('$MemberSegmentModel', {
    api: new _squid.$Api({
        uri: '/api/segment/memberSegment',
        postAttempts: 1
    }),
    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
    getMemberSegment: function getMemberSegment() {
        return this.memberSegment;
    },
    getCreditOffer: function getCreditOffer() {
        return this.creditOffer;
    },
    isNewMember: function isNewMember() {
        return this.memberSegment === 'NEW_MEMBER' || this.memberSegment === 'YOUNG_MEMBER';
    },
    isExistingMember: function isExistingMember() {
        return this.memberSegment === 'EXISTING_MEMBER';
    },
    // Member Segments that are eligble for the New Experience
    isEligibleForExperimentation: function isEligibleForExperimentation() {
        var eligibleMemberSegments = _squid.$config.memberSegments;

        return eligibleMemberSegments.indexOf(this.memberSegment) > -1;
    }
});

var $CreditOfferModel = exports.$CreditOfferModel = $MessageDiscoverModel.extend('$CreditOfferModel', {
    init: function init() {
        this.setProperties({
            bannerMessages: []
        });
    },
    populate: function populate(result) {
        var _this2 = this;

        if (result && result.touchpoint_messages) {
            var touchpoint_messages = result.touchpoint_messages.find(function (element) {
                return element.touchpoint_code === _this2.touchpoint;
            });

            this.storeMessages(touchpoint_messages);
        }
    },
    storeMessages: function storeMessages(touchpoint_messages) {
        if (touchpoint_messages) {
            this.viewName = touchpoint_messages.view_name;

            if (touchpoint_messages.messages) {
                var messages = touchpoint_messages.messages;

                for (var i = 0; i < touchpoint_messages.messages.length; i++) {
                    var presentmentType = messages[i].content.json.PresentmentType;

                    if (presentmentType === 'Banner') {
                        this.bannerMessages.push(messages[i]);
                    }
                }
            }
        }
    },
    getBannerCount: function getBannerCount() {
        return this.bannerMessages.length;
    },
    hasBannerMessage: function hasBannerMessage() {
        return this.getBannerCount() > 0;
    },
    getTouchpointCode: function getTouchpointCode() {
        return this.touchpoint;
    },
    getBannerMessage: function getBannerMessage(i) {
        i = !i ? 0 : i;

        if (this.getBannerCount() > i) {
            return this.bannerMessages[i];
        }
        return null;
    },
    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.application_context) {
            this.application_context.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },
    serialize: function serialize() {
        return {
            'country_code': this.locale.country,
            'language': this.locale.lang + '_' + this.locale.country,
            'identity_context': [{
                'type': 'PAYER_ID',
                'value': this.payer
            }, {
                'type': 'MERCHANT_PAYER_ID',
                'value': this.payee
            }],
            'recommendation_context': {
                'view_names': this.view_names ? this.view_names : [],
                'touchpoint_details': [{
                    'code': this.touchpoint,
                    'message_count': this.message_count ? this.message_count : 1
                }]
            },
            'application_context': this.application_context
        };
    }
});

angular.value("$MarketingOfferModel", $MarketingOfferModel);
angular.value("$MessageDiscoverModel", $MessageDiscoverModel);
angular.value("$fireMORSBeacon", $fireMORSBeacon);
angular.value("$MemberSegmentModel", $MemberSegmentModel);
angular.value("$CreditOfferModel", $CreditOfferModel);
_squid.$Model;

_squid.$Api;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/newMember/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$NewMemberEligibility = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _shippingMethod = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var control = 'control';
var ineligible = 'ineligible';
var one_page = 'one_page';
var design_2 = 'design_2';
var design_3 = 'design_3';

var TREATMENT_PATTERNS = {
    CONTROL: /xo_hermes_\w*_member_control/,
    ONE_PAGE: /xo_hermes_\w*_member_treatment_1/,
    DESIGN_2: /xo_hermes_\w*_member_treatment_3/,
    DESIGN_3: /xo_hermes_\w*_member_treatment_4/
};

var mapTreatment = function mapTreatment(treatment) {
    if (!treatment) {
        return;
    }

    if (TREATMENT_PATTERNS.ONE_PAGE.test(treatment)) {
        return one_page;
    }

    if (TREATMENT_PATTERNS.DESIGN_2.test(treatment)) {
        return design_2;
    }

    if (TREATMENT_PATTERNS.DESIGN_3.test(treatment)) {
        return design_3;
    }
};

var getSegmentParameters = function getSegmentParameters(token) {
    var models = {};

    return (0, _squid.$populate)(models, {
        checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token),
        checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
        checkoutCartModel: _checkout.$CheckoutCartModel.instance(token)
    }).then(function () {
        var data = {
            page: 'HERMES_RYI_PAGE',
            site: 'HERMES_RYI_PAGE',
            locale: _squid.$locale.lang + '_' + _squid.$locale.country,
            puType: 'PERSONAL',
            visit_id: token,
            si: token,
            payment_context: {
                business_case: 'NONE',
                business_case_variation: '',
                validate_existing_offer: 'false',
                total_transaction_amount: {
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                    value: Math.round(models.checkoutCartModel.get('purchase.amounts.total.amount', 0) * 100)
                },
                total_shipping_amount: {
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                    value: Math.round(models.checkoutCartModel.get('purchase.amounts.shipping.amount', 0) * 100)
                },
                payment_units: [{
                    transaction_amount: {
                        currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                        value: Math.round(models.checkoutCartModel.get('purchase.amounts.total.amount', 0) * 100)
                    },
                    transaction_id: '',
                    encrypted_transaction_id: '',
                    activity_id: '',
                    payee: {
                        pu_type: 'BUSINESS',
                        country_code: models.checkoutAppDataModel.get('merchant.merchant_country') || '',
                        epu: models.checkoutPayeeModel.merchant.id || '',
                        pu: ''
                    }
                }]
            },
            target_placements: [{
                placement_code: '210005',
                presentation_types: ['decision']
            }]
        };

        return data;
    });
};

var isMemberSegmentEligible = function isMemberSegmentEligible(token) {
    var memberSegmentModel = _marketingoffer.$MemberSegmentModel.instance();
    var memberSegment = memberSegmentModel.getMemberSegment();

    if (memberSegment !== undefined) {
        return _squid.$promise.resolve(memberSegmentModel.isEligibleForExperimentation());
    }

    return getSegmentParameters(token).then(function (data) {
        memberSegmentModel.invalidate();
        return memberSegmentModel.save({
            silent: true,
            data: data,
            contingencies: {
                DEFAULT: function DEFAULT(name, err) {
                    return;
                }
            }
        }).then(function () {
            return memberSegmentModel.isEligibleForExperimentation();
        })['catch'](function () {
            return false;
        });
    });
};

var eligibility = function eligibility(token, _ref) {
    var authModel = _ref.authModel,
        checkoutSessionModel = _ref.checkoutSessionModel,
        checkoutAppDataModel = _ref.checkoutAppDataModel,
        checkoutCartModel = _ref.checkoutCartModel,
        checkoutPayeeModel = _ref.checkoutPayeeModel,
        shippingRuleSummaryModel = _ref.shippingRuleSummaryModel;
    var plan = checkoutSessionModel.plan,
        negBalances = checkoutSessionModel.negBalances;

    var plans = checkoutSessionModel.get('fundingOptions.plans');

    // Ineligible reasons:
    // - multiple plans
    // - negative balance
    // - billing agreement
    // - third Party wallet (Baidu, Venmo, etc..)
    // - shipping and tax
    // - second button
    // - Android Pay
    // - Gambling
    // - Default funding source is not card
    var isMultiplePlans = plans && plans.length > 1;
    var isNegativeBalance = negBalances && negBalances.length !== 0;
    var isBilling = checkoutCartModel.isBilling();
    var isThirdParty = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
    var isShippingRulesEnabled = shippingRuleSummaryModel && shippingRuleSummaryModel.isSnTEnabled;
    if (_squid.$config.readRulesSummaryFromAppData === true || _squid.$config.readRulesSummaryFromAppData === 'true') {
        isShippingRulesEnabled = _squid.$integration.getConfig('SHOW_SHIPPING_METHOD') && checkoutAppDataModel.flags.is_snt_enabled;
    }
    var isSecondButton = checkoutAppDataModel.is_second_button_txn;
    var isAPay = checkoutCartModel.isWalletTokenization();
    var isGambling = checkoutPayeeModel.isGambling();
    var isHideShipping = checkoutAppDataModel.flags.hide_shipping_address || !checkoutAppDataModel.flags.shipping_address_required;

    // Default funding source needs to be card for now.
    var isSupportedDefaultFundingSource = plan && plan.sources && plan.sources.length === 1 && plan.sources[0].type === 'PAYMENT_CARD';

    var eligibilityCriteria = {
        noMultiplePlans: !isMultiplePlans,
        noNegativeBalance: !isNegativeBalance,
        noBilling: !isBilling,
        noThirdParty: !isThirdParty,
        noSnT: !isShippingRulesEnabled,
        noSecondButton: !isSecondButton,
        noAPay: !isAPay,
        noGambling: !isGambling,
        noSupportedDefaultFundingSource: isSupportedDefaultFundingSource,
        noHideShipping: !isHideShipping
    };

    var ineligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
        return !eligibilityCriteria[key];
    });
    var transactionEligible = ineligibleReasons.length === 0;

    if (!transactionEligible) {
        var reasons = ineligibleReasons.join(':');

        _logger.$logger.info('checkout_ftpi', {
            from: 'new_member_eligibility',
            to: 'process_new_member_eligibility',
            eligibility_reason: reasons
        });
        for (var _iterator = ineligibleReasons, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref2 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref2 = _i.value;
            }

            var reason = _ref2;

            _logger.$logger.info('new_member_experience_ineligible_' + reason);
        }
        return _squid.$promise.resolve(ineligible);
    }

    // Check member segment
    return isMemberSegmentEligible(token).then(function (eligibleMember) {
        if (!eligibleMember) {
            _logger.$logger.info('new_member_experience_ineligible_member_segment');
            return ineligible;
        }

        // if merchant is on blacklist...
        if (_app.$PXPBlacklist.isMerchantBlacklisted(checkoutPayeeModel.get('merchant.id'))) {
            _logger.$logger.info('new_member_experience_ineligible_merchant_blacklisted');
            return control;
        }

        var memberSegmentModel = _marketingoffer.$MemberSegmentModel.instance();
        var memberSegment = memberSegmentModel.getMemberSegment();

        _logger.$logger.info('new_member_experience_eligible_' + memberSegment);

        return (0, _squid.$pxp)('xo_hermes_new_member_journey', {
            'uid': authModel.buyer_id,
            'ctx.COUNTRY': authModel.country,
            'ctx.SEGMENT': memberSegment }, 'xo_hermes_(\\w*)_member_treatment_(\\d)|xo_hermes_(\\w*)_member_control', false, true).then(function (t) {
            if (t) {
                var r = mapTreatment(t.treatment_name);

                return r || control;
            } else {
                return control;
            }
        });
    });
};

var snt = function snt(models, token) {
    if (_squid.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
        return (0, _squid.$populate)(models, {
            shippingRuleSummaryModel: _shippingMethod.$ShippingRuleSummaryModel.instance(token).retrieve({
                params: {
                    merchant_id: models.checkoutPayeeModel.get('merchant.id'),
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code')
                }
            })
        });
    } else {
        models.shippingRuleSummaryModel = {};
        return _squid.$promise.resolve();
    }
};

var $NewMemberEligibility = exports.$NewMemberEligibility = _squid.$Model.extend('$NewMemberEligibility', {
    getVariant: function getVariant(token) {
        var _this = this;

        if (!(0, _squid.$feature)('newMemberExperience')) {
            return _squid.$promise.resolve(ineligible);
        }

        if (_squid.$meta.corp) {
            var nmexp = _squid.$util.param('nmj_exp');

            if (nmexp === '1') {
                return _squid.$promise.resolve(one_page);
            } else if (nmexp === '2') {
                return _squid.$promise.resolve(design_2);
            } else if (nmexp === '3') {
                return _squid.$promise.resolve(design_3);
            } else if (nmexp === '0') {
                return _squid.$promise.resolve(control);
            }
        }

        var models = {};

        return (0, _squid.$populate)(models, {
            authModel: _auth.$AuthModel.instance(),
            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token),
            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token)
        }).then(function () {
            return snt(models, token);
        }).then(function () {
            // Rerun eligibility if user has changed.
            if (_this.variant && models.authModel.buyer_id === _this.buyerId) {
                return _this.variant;
            }

            _this.buyerId = models.authModel.buyer_id;
            return eligibility(token, models).then(function (variant) {
                _this.variant = variant;
                return variant;
            });
        });
    },

    isNmj: function isNmj(token) {
        return this.getVariant(token).then(function (variant) {
            if (variant && (variant === 'one_page' || variant === 'design_2' || variant === 'design_3')) {
                return true;
            } else {
                return false;
            }
        });
    },

    nmjShowGreyHeader: function nmjShowGreyHeader(token) {
        return this.getVariant(token).then(function (variant) {
            if (variant && (variant === 'design_2' || variant === 'design_3')) {
                return true;
            } else {
                return false;
            }
        });
    },

    getMemberSegmentParameters: function getMemberSegmentParameters(token) {
        return getSegmentParameters(token);
    }
});

angular.value("$NewMemberEligibility", $NewMemberEligibility);
_squid.$Model;

_squid.$promise;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$pxp;

_squid.$locale;

_squid.$meta;

_squid.$util;

_squid.$integration;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_shippingMethod.$ShippingRuleSummaryModel;

_app.$PXPBlacklist;

_marketingoffer.$MemberSegmentModel;

_thirdPartyInfo.thirdPartyExperience;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/processorDecline/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getProcessorDeclineRetryEligibility = getProcessorDeclineRetryEligibility;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var INELIGIBLE = _squid.$promise.resolve(false);
var lastBuyerId = null;

// Check eligibility for processor decline retry feature
// First checks if feature eligibility is met, then PXP eligibility is met
function getProcessorDeclineRetryEligibility(token, checkoutSession) {
    if (!(0, _squid.$feature)('cardBackup')) {
        return INELIGIBLE;
    }

    // TODO: Refactor the eligibility rules to a set of common rules
    var models = {};

    return (0, _squid.$populate)(models, {
        auth: _auth.$AuthModel.instance(),
        checkoutCart: _checkout.$CheckoutCartModel.instance(token),
        checkoutPayee: _checkout.$CheckoutPayeeModel.instance(token),
        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token)
    }).then(function () {
        var checkoutCart = models.checkoutCart,
            checkoutPayee = models.checkoutPayee,
            checkoutAppData = models.checkoutAppData;

        var plans = checkoutSession.get('fundingOptions.plans', []);
        var moreThanOneCard = plans.filter(function (fi) {
            return fi.primaryFs.type === 'CARD';
        }).length < 2;

        // exclude rewards from the eligibility list
        var hasRewards = plans.filter(function (fi) {
            return fi && fi.rewards !== undefined;
        }).length > 0;

        // See https://engineering.paypalcorp.com/confluence/display/HellsKitchen/Hermes+Processor+Decline+Retry for eligibility reasons
        var isGambling = checkoutPayee.isGambling();
        var isBilling = checkoutCart.isBilling();
        // We're only sure that Sale transactions will go onto the new payments stack, for now
        var isNotSale = checkoutCart.get('payment_action') !== 'sale';
        var isThirdParty = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
        // Exclude all WPS products
        var isWpsOrInvoice = checkoutAppData.get('flags.is_wps_flow') || checkoutAppData.get('flags.is_invoice_flow');
        // We will need to confirm functionality for this before we can enable for this feature
        var isMultiSellerPurchase = checkoutCart.isMultiSellerPurchase();
        var hasInstallments = checkoutSession.installments && checkoutSession.installments.length > 1;
        var involvedCurrencies = plans.reduce(function (currencies, plan) {
            currencies[plan.primaryFs.amount.currency_code] = 1;
            return currencies;
        }, {});
        // Buyer promo email routing through checkoutserv, downstream does not support
        var hasBuyerPromoEmail = checkoutAppData.get('flags.display_buyer_email_promotional_opt_in');

        if (checkoutCart.get('purchase.amounts.total.currency_code')) {
            involvedCurrencies[checkoutCart.purchase.amounts.total.currency_code] = 1;
        }

        var ineligibilityCriteria = {
            isGambling: isGambling,
            moreThanOneCard: moreThanOneCard,
            hasRewards: hasRewards,
            isBilling: isBilling,
            isNotSale: isNotSale,
            isThirdParty: isThirdParty,
            isWpsOrInvoice: isWpsOrInvoice,
            isMultiSellerPurchase: isMultiSellerPurchase,
            hasInstallments: hasInstallments,
            currencyConversion: Object.keys(involvedCurrencies).length > 1,
            hasBuyerPromoEmail: hasBuyerPromoEmail
        };
        var ineligibleReasons = Object.keys(ineligibilityCriteria).filter(function (key) {
            return ineligibilityCriteria[key];
        });
        var eligible = ineligibleReasons.length === 0;

        // Logging for FPTI
        _logger.$logger.info('checkout_fpti', {
            from: 'processor_decline_retry',
            // This logs whether user is eligible by Hermes criteria
            to: 'processor_decline_retry_' + (eligible ? 'eligible' : 'ineligible')
        });

        if (!eligible) {
            // This logs the overall result of the eligibility check
            _logger.$logger.info('processor_decline_retry_ineligible', {
                reasons: ineligibleReasons.join()
            });
        }

        return eligible;
    }).then(function (featureEligible) {
        // BuyerId is needed to make sure pxp is reloaded if a new user logs in.
        // Refactor: Make this a common pxp model that is invalidated on logout
        var buyerId = models.auth.buyerId;

        var sameBuyer = buyerId === lastBuyerId;

        lastBuyerId = buyerId;

        if (!featureEligible) {
            return false;
        }

        // Only run the PXP if the feature is eligible, as requested from analytics
        return (0, _squid.$pxp)('xo_hermes_processor_decline_retry', {}, 'xo_hermes_processor_decline_retry_treatment', sameBuyer ? false : true, true).then(function (pxpRes) {
            if (!pxpRes) {
                _logger.$logger.info('processor_decline_retry_ineligible', {
                    pxpIneligible: true
                });
            }

            return !!pxpRes;
        });
    }).then(function (eligibleWithPxp) {
        if (eligibleWithPxp) {
            _logger.$logger.info('processor_decline_retry_eligible');
        }
        return eligibleWithPxp;
    });
}

_squid.$feature;

_squid.$populate;

_squid.$promise;

_squid.$pxp;

_logger.$logger;

_thirdPartyInfo.thirdPartyExperience;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutAppDataModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/profilemanagement/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MerchantPreferenceModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $MerchantPreferenceModel = exports.$MerchantPreferenceModel = _squid.$Model.extend('$MerchantPreferenceModel', {
    init: function init() {
        this._super.init.apply(this);

        this.setProperties({
            rm: _squid.$util.param('rm'), // Return Method
            return_url: _squid.$util.param('return'),
            auto_return: {
                enabled: false
            },
            pdt: {
                enabled: false
            }
        });
    },


    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: '/api/profilemanagement/:id/getMerchantPreferences'
    }),

    autoReturn: function autoReturn() {
        return this.auto_return.enabled;
    },
    pdtEnabled: function pdtEnabled() {
        return this.pdt && this.pdt.enabled;
    },
    returnUrl: function returnUrl() {
        return this.return_url || this.auto_return.url;
    },


    /**
     * 0 – redirect using GET method ( default behavior )
     * 1 – redirect using the GET method, but no payment variables are included
     * 2 – redirect using the POST method, and include all payment variables
     */
    returnMethod: function returnMethod() {
        if (this.rm === '2') {
            return this.pdtEnabled() ? 'GET' : 'POST';
        }

        return 'GET';
    },
    returnMethodSupported: function returnMethodSupported() {
        return this.returnMethod() === 'GET';
    },


    /**
     * Determines if payment details need to be sent back to the merchant.
     * @returns {boolean}
     */
    postPaymentData: function postPaymentData() {
        return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
    },


    // charset of merchant having in profile
    charSet: function charSet() {
        return this.charset;
    }
});

angular.value("$MerchantPreferenceModel", $MerchantPreferenceModel);
_squid.$Model;

_squid.$Api;

_squid.$config;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/shippingMethod/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingRuleSummaryModel = exports.$ShippingMethodModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ShippingMethodModel = exports.$ShippingMethodModel = _squid.$Model.extend('$ShippingMethodModel', {
    api: new _squid.$Api({
        uri: '/api/shippingtax/charges'
    }),

    getShippingMethodId: function getShippingMethodId(shippingMethodType) {
        var shippingMethodsMap = {
            DEFAULT: '0',
            AIR_SERVICE: '1',
            ECONOMY: '2',
            EXPEDITED_AIR_SERVICE: '3',
            EXPEDITED_FLAT_RATE_SHIPPING: '4',
            EXPRESS: '5',
            EXPRESS_DOMESTIC: '6',
            FREE_SHIPPING: '7',
            GROUND: '8',
            GLOBAL_PRIORITY: '9',
            INTERNATIONAL_ECONOMY: '10',
            INTERNATIONAL_EXPEDITED: '11',
            INTERNATIONAL_EXPRESS: '12',
            INTERNATIONAL_EXPRESS_AIR: '13',
            INTERNATIONAL_PRIORITY_AIR: '14',
            NEXT_DAY: '15',
            NEXT_DAY_AIR: '16',
            NEXT_DAY_AIR_ECONOMY: '17',
            ONE_DAY_SHIPPING: '18',
            OVERNIGHT: '19',
            OVERNIGHT_FLAT_RATE_SHIPPING: '20',
            PICKUP: '21',
            PRIORITY: '22',
            RUSH_DELIVERY: '23',
            STANDARD_DOMESTIC: '24',
            STANDARD_EXPEDITED: '25',
            STANDARD_FLAT_RATE_SHIPPING: '26',
            STANDARD_INTERNATIONAL: '27',
            STANDARD_SHIPPING: '28',
            STORE_PICKUP: '29',
            TWO_DAY_SHIPPING: '30',
            WORLDWIDE_SHIPPING: '31',
            TWO_DAY_AIR: '32'
        };

        return shippingMethodsMap[shippingMethodType];
    },

    isStorePickUp: function isStorePickUp(shipping_method_type) {
        return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
    }
});

var $ShippingRuleSummaryModel = exports.$ShippingRuleSummaryModel = _squid.$Model.extend('$ShippingRuleSummaryModel', {
    api: new _squid.$Api({
        uri: '/api/shippingtax/:id/rulesSummary'
    })
});

angular.value("$ShippingMethodModel", $ShippingMethodModel);
angular.value("$ShippingRuleSummaryModel", $ShippingRuleSummaryModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/shoppingcart/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShoppingCartModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ShoppingCartModel = exports.$ShoppingCartModel = _squid.$Model.extend('$ShoppingCartModel', {
    api: new _squid.$Api({
        uri: '/api/shoppingcart/:id',
        postAttempts: 2,
        cache: false
    })
});

angular.value("$ShoppingCartModel", $ShoppingCartModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/subscription/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SubscriptionsV1Model = exports.$SubscriptionModel = exports.$CreateBAModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $CreateBAModel = exports.$CreateBAModel = _squid.$Model.extend('$CreateBAModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt',
        postAttempts: 3
    })
});

var $SubscriptionModel = exports.$SubscriptionModel = _squid.$Model.extend('$SubscriptionModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt/:id',
        postAttempts: 3,
        cache: true
    })
});

var $SubscriptionsV1Model = exports.$SubscriptionsV1Model = _squid.$Model.extend('$SubscriptionsV1Model', {
    api: new _squid.$Api({
        uri: '/api/billagmt/subscriptions/v1/:id',
        cache: true
    })
});

angular.value("$CreateBAModel", $CreateBAModel);
angular.value("$SubscriptionModel", $SubscriptionModel);
angular.value("$SubscriptionsV1Model", $SubscriptionsV1Model);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/switchPaymentsApiServ/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$switch3DSAuthenticateModel = exports.$switch3DSLookUpModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $switch3DSLookUpModel = exports.$switch3DSLookUpModel = _squid.$Model.extend('$switch3DSLookUpModel', {
    api: new _squid.$Api({
        uri: '/api/switch/threeDSLookUp'
    })
});

var $switch3DSAuthenticateModel = exports.$switch3DSAuthenticateModel = _squid.$Model.extend('$switch3DSAuthenticateModel', {
    api: new _squid.$Api({
        uri: '/api/switch/threeDSAuthenticate'
    })
});

angular.value("$switch3DSLookUpModel", $switch3DSLookUpModel);
angular.value("$switch3DSAuthenticateModel", $switch3DSAuthenticateModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/thirdPartyWallet/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThirdPartyOnboard = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ThirdPartyOnboard = exports.$ThirdPartyOnboard = _squid.$Model.extend('$ThirdPartyOnboard', {
    api: new _squid.$Api({
        uri: '/api/third-party',
        cache: true
    })
});

angular.value("$ThirdPartyOnboard", $ThirdPartyOnboard);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/threeDS/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThreeDSJWTModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ThreeDSJWTModel = exports.$ThreeDSJWTModel = _squid.$Model.extend('$ThreeDSJWTModel', {
    api: new _squid.$Api({
        uri: '/api/fi/threeds'
    }),

    init: function init() {
        this._super.init.apply(this);
    },

    serialize: function serialize() {
        var data = {
            referenceId: this.referenceId,
            cardBin: this.cardBin,
            cardType: this.cardType,
            jwtIssuer: this.jwtInfo.jwtIssuer,
            jwtOrgUnitId: this.jwtInfo.jwtOrgUnitId,
            returnUrl: this.returnUrl,
            redirectUrl: this.redirectUrl,
            transactionId: this.transactionId,
            paymentAuthenticationRequest: this.paymentAuthenticationRequest,
            authenticationProvider: this.authenticationProvider
        };

        return data;
    }
});

angular.value("$ThreeDSJWTModel", $ThreeDSJWTModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/user/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UserEligibleToHoldBalanceModel = exports.$UserProductSubscriptionModel = exports.$AuthConsentModel = exports.$UserPhotoModel = exports.$EConsentModel = exports.$WaxUserModel = exports.$PatchPhoneModel = exports.$AddKYCModel = exports.$ValidatePhoneModel = exports.$UserInfoModel = exports.$CheckoutInputDataModel = exports.$CheckoutClientDataModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $CheckoutClientDataModel = exports.$CheckoutClientDataModel = _squid.$Model.extend('$CheckoutClientDataModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/clientData'
    }),

    merchantIdentityData: function merchantIdentityData() {
        return {
            email: this.email,
            brand_name: this.display_name,
            logo_uri: this.logo_uri,
            identity_uri: this.identity_uri
        };
    },

    validateClient: function validateClient() {
        if (this.partner_id && this.identity_uri) {
            return {
                success: true
            };
        } else {
            return {
                success: false,
                error: 'invalid_client'
            };
        }
    },
    validateRedirectUri: function validateRedirectUri(redirectUrl) {
        if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
            return {
                success: true
            };
        } else {
            return {
                success: false,
                error: 'invalid_redirect_url'
            };
        }
    }
});

var ACTION = {
    login: 'login',
    resolve: 'resolve',
    addCard: 'addCard',
    addBank: 'addBank',
    changeCurrencyConv: 'changeCurrencyConv',
    signup: 'signup',
    mandate: 'mandate',
    addCredit: 'addCredit',
    ulReturn: 'ulReturn',
    creditReturn: 'creditReturn',
    guestCurrencyConversion: 'guestCurrencyConversion',
    guestAuthentication: 'guestAuthentication',
    compliance: 'compliance'
};

var $CheckoutInputDataModel = exports.$CheckoutInputDataModel = _squid.$Model.extend('$CheckoutInputDataModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties({
            client_id: _squid.$util.param('client_id'),
            action: _squid.$util.param('action'),
            redirect_uri: _squid.$util.param('redirect_uri'),
            scope: _squid.$util.param('scope'),
            state: _squid.$util.param('state'),
            flow: _squid.$util.param('flow'),
            payer_id: _squid.$util.param('payer_id'),
            mandate_reference_number: _squid.$util.param('mandate_reference_number'),
            funding_option_id: _squid.$util.param('funding_option_id'),
            locale: _squid.$util.param('locale'),
            logout: _squid.$util.param('logout'),
            refresh_parent: _squid.$util.param('refresh_parent'),
            escape_hatch: _squid.$util.param('escape_hatch'),
            failedBecause: _squid.$util.param('failedBecause'),
            redirectReferrer: _squid.$util.param('redirectReferrer'),
            id_token: _squid.$util.param('prox_id'),
            nonce: _squid.$util.param('nonce'),
            hide_rm: _squid.$util.param('hideRM'),
            payloadEnc: _squid.$util.param('payloadEnc'),
            xcancel: _squid.$util.param('x-cancel'),
            xsuccess: _squid.$util.param('x-success')
        });
    },

    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: '/api/user/:id/payerId'
    }),

    isEbayTxn: function isEbayTxn() {
        return Boolean(this.client_id);
    },

    validAction: function validAction() {
        var actions = {
            login: 'login',
            resolve: 'resolve',
            addCard: 'addCard',
            addBank: 'addBank',
            changeCurrencyConv: 'changeCurrencyConv',
            signup: 'signup',
            mandate: 'mandate',
            addCredit: 'addCredit',
            ulReturn: 'ulReturn',
            creditReturn: 'creditReturn',
            guestCurrencyConversion: 'guestCurrencyConversion',
            guestAuthentication: 'guestAuthentication',
            compliance: 'compliance'
        };

        return actions.hasOwnProperty(this.action);
    },

    showRYP: function showRYP() {
        return !this.isEbayTxn();
    },

    requiresOAuth: function requiresOAuth() {
        return this.action === ACTION.login || this.action === ACTION.signup;
    },

    requiresRedirectUri: function requiresRedirectUri() {
        return this.action === ACTION.mandate || !this.requiresOAuth();
    },

    validRedirectUri: function validRedirectUri() {
        if (this.requiresRedirectUri()) {
            return Boolean(this.redirect_uri);
        }
        return true;
    },

    validate: function validate() {
        var error;
        var success = true;

        if (this.isEbayTxn()) {
            if (!this.validAction()) {
                success = false;
                error = 'invalid_action';
            } else if (!this.validRedirectUri()) {
                success = false;
                error = 'invalid_redirect_uri';
            }
        }

        return {
            success: success,
            error: error
        };
    },

    errorUrl: function errorUrl(err, errorDesc) {
        var url = this.redirect_uri;

        url += url && url.indexOf('?') < 0 ? '?' : '&';
        url += 'state=' + encodeURIComponent(this.state);

        if (err) {
            url += '&error=' + err;
        }
        if (errorDesc) {
            url += '&error_description=' + errorDesc;
        }

        return url;
    },

    successUrl: function successUrl(code) {
        var url = this.redirect_uri;

        url += url && url.indexOf('?') < 0 ? '?' : '&';
        url += 'state=' + encodeURIComponent(this.state);

        url += '&code=' + code;

        return url;
    },

    rmEnabled: function rmEnabled(featureEnabled) {
        return featureEnabled && this.action === ACTION.login;
    },

    hideRM: function hideRM() {
        return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
    }
});

var $UserInfoModel = exports.$UserInfoModel = _squid.$Model.extend('$UserInfoModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/session'
    })
});

var $ValidatePhoneModel = exports.$ValidatePhoneModel = _squid.$Model.extend('$ValidatePhoneModel', {
    api: new _squid.$Api({
        uri: '/api/user/:token/session/validatePhone',
        cache: false
    })
});

var $AddKYCModel = exports.$AddKYCModel = _squid.$Model.extend('$AddKYCModel', {
    api: new _squid.$Api({
        uri: '/api/user/:token/session/addKYC'
    })
});

var $PatchPhoneModel = exports.$PatchPhoneModel = _squid.$Model.extend('$PatchPhoneModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:token/session/patch',
        cache: false
    })
});

var $WaxUserModel = exports.$WaxUserModel = _squid.$Model.extend('$WaxUserModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/waxUser'
    })
});

var $EConsentModel = exports.$EConsentModel = _squid.$Model.extend('$EConsentModel', {
    api: new _squid.$Api({
        uri: '/api/user/eConsent'
    }),

    invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});

var $UserPhotoModel = exports.$UserPhotoModel = _squid.$Model.extend('$UserPhotoModel', {
    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: 'api/user/photo'
    }),

    invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});

var $AuthConsentModel = exports.$AuthConsentModel = _squid.$Model.extend('$AuthConsentModel', {
    api: new _squid.$Api({
        uri: '/api/user/authConsent'
    })
});

var $UserProductSubscriptionModel = exports.$UserProductSubscriptionModel = _squid.$Model.extend('$UserProductSubscriptionModel', {
    api: new _squid.$Api({
        uri: '/api/user/productSubscription'
    })
});

var $UserEligibleToHoldBalanceModel = exports.$UserEligibleToHoldBalanceModel = _squid.$Model.extend('$UserEligibleToHoldBalanceModel', {
    api: new _squid.$Api({
        uri: '/api/user/eligibleToHoldBalance'
    })
});

angular.value("$CheckoutClientDataModel", $CheckoutClientDataModel);
angular.value("$CheckoutInputDataModel", $CheckoutInputDataModel);
angular.value("$UserInfoModel", $UserInfoModel);
angular.value("$ValidatePhoneModel", $ValidatePhoneModel);
angular.value("$AddKYCModel", $AddKYCModel);
angular.value("$PatchPhoneModel", $PatchPhoneModel);
angular.value("$WaxUserModel", $WaxUserModel);
angular.value("$EConsentModel", $EConsentModel);
angular.value("$UserPhotoModel", $UserPhotoModel);
angular.value("$AuthConsentModel", $AuthConsentModel);
angular.value("$UserProductSubscriptionModel", $UserProductSubscriptionModel);
angular.value("$UserEligibleToHoldBalanceModel", $UserEligibleToHoldBalanceModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/wallet/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$WalletModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _instrument = __webpack_require__("../node_modules/xo-models/src/wallet/instrument.js");

// ID https://engineering.paypalcorp.com/confluence/display/PayPalMediaService/Image+Request+Metadata+Data
var imageSizeId = '0';

var normalize = function normalize(instId) {
    return instId && instId.replace(/-/g, '');
};

var imageTypes = ['png', 'jpg', 'gif', 'bmp'];
var imageType = function imageType(mimeType) {
    return _squid.$util.find(imageTypes, function (t) {
        return mimeType.indexOf(t) !== -1;
    }) || 'png';
};

// Network types to check for linked cards
var NETWORK_TYPES = {
    CHASE: 'CHASENET'
};

function capFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function getLinkedCapability(cardData) {
    return cardData.fs.capabilities.find(function (cap) {
        return cap.name === 'TOKEN';
    });
}

var $WalletModel = exports.$WalletModel = _squid.$Model.extend('$WalletModel', {
    invalidateOnLogout: true,
    api: new _squid.$Api({
        uri: '/api/fi/wallet/wallet'
    }),

    getId: function getId(fs) {
        return normalize(fs.instrument_id || fs.id);
    },

    getCardMask: function getCardMask(fs) {
        var rep = this.getWalletRepresentation(fs);

        if (!rep) {
            return { mask: true };
        }

        var selector = rep.type === 'card' ? 'product_class' : 'type';
        var renderedType = void 0;

        if (rep.fs[selector] === 'UNKNOWN' || !rep.fs[selector]) {
            renderedType = '';
        } else {
            renderedType = capFirst(rep.fs[selector]) + ' ';
        }

        return {
            before: renderedType,
            mask: true,
            after: rep.fs.last_nchars || rep.fs.last_nchars_card_number || ''
        };
    },

    /**
     * Returns the wallet API data for a FI given a funding source from the checkoutSession model
     * @returns {Instrument|BankInstrument|null}
     */
    getWalletRepresentation: function getWalletRepresentation(fs) {
        if (!fs) {
            return null;
        }

        if (fs.type === 'BALANCE') {
            var currency = fs.amount && fs.amount.currency_code;

            if (currency) {
                var bal = this.balance_accounts.find(function (b) {
                    return b.currency_code === currency;
                });

                if (bal) {
                    return new _instrument.Instrument({ type: 'balance', fs: bal });
                }
            }
            return null;
        }

        return this.getById(this.getId(fs));
    },


    /**
     * Returns the wallet API data for a FI based on the id provided
     * @returns {Instrument|BankInstrument|null} - the model of the FI, if found
     */
    getById: function getById(id) {
        if (!id) {
            return null;
        }

        return this.getCardById(id) || this.getBankById(id) || this.getCreditById(id) || null;
    },


    /**
     * Return the wallet API data for a FI of a card id provided
     * @returns {Instrument}
     */
    getCardById: function getCardById(id) {
        var card = _squid.$util.find(this.card_accounts, function (c) {
            return normalize(c.id) === id;
        });

        return card && new _instrument.Instrument({
            type: 'card',
            fs: card
        });
    },


    /**
     * Return the wallet API data for a FI of a card id provided
     * @returns {Instrument}
     */
    getCreditById: function getCreditById(id) {
        var creditCards = _squid.$util.find(this.credit_accounts, function (c) {
            return normalize(c.id) === id;
        });

        return creditCards && new _instrument.Instrument({
            type: 'credit',
            fs: creditCards
        });
    },


    /**
     * Return the wallet API data for a FI of a bank id provided
     * @returns {BankInstrument}
     */
    getBankById: function getBankById(id) {
        var bank = _squid.$util.find(this.bank_accounts, function (b) {
            return normalize(b.id) === id;
        });

        return bank && new _instrument.BankInstrument({
            type: 'bank',
            fs: bank
        });
    },


    getCustomName: function getCustomName(fs) {
        try {
            var rep = this.getWalletRepresentation(fs);

            if (!rep || !rep.type) {
                return '';
            }

            var type = rep.type.toLowerCase();

            if (type === 'credit' && rep.fs && rep.fs.credit_product_descriptor) {
                return rep.fs.credit_product_descriptor;
            }

            if (type === 'card' && rep.fs && rep.fs.issuer && rep.fs.issuer.issuer_product_description) {
                return rep.fs.issuer.issuer_product_description;
            }

            return '';
        } catch (e) {
            console.error('getCustomNameError', e);
            return '';
        }
    },

    getCardArt: function getCardArt(fs) {
        try {
            if (!fs || !fs.type) {
                console.error('Invalid input: fs is missing or does not have a type.', fs);
                return null;
            }

            var type = fs.type.toLowerCase();

            var cardId = this.getId(fs);

            var card = void 0,
                propertyPath = void 0;

            if (type === 'card') {
                card = this.getCardById(cardId);
                console.debug('Retrieved Card:', card);

                if (card && card.fs && card.fs.card_art_details && card.fs.card_art_details.card_art) {
                    propertyPath = card.fs.card_art_details.card_art.primary_content;
                }
            } else if (type === 'credit' || type === 'txn_card_bml') {
                card = this.getCreditById(cardId);
                console.debug('Retrieved Credit:', card);

                if (card && card.fs && card.fs.art_details) {
                    propertyPath = card.fs.art_details.primary_content;
                }
            }

            if (!propertyPath) {
                console.error('propertyPath is missing:', propertyPath);
                return null;
            }

            var base = propertyPath.base_cdn_link_path || propertyPath.base_cdnlink_path;

            console.debug('Base CDN Link Path:', base);

            if (!base) {
                console.error('Base CDN link path is missing.');
                return null;
            }

            return base + imageSizeId + '.' + imageType(propertyPath.original_mime_type);
        } catch (e) {
            console.error('getCardArtError', e);
            return null;
        }
    },

    /**
     * retrieve list of total balances (each currency is a separate balance account)
     * Notes:
     * 1. Skip balances with '0' amount
     * 2. Since wallet returns amount in "cents" - convert it to "dollars".
     *    For us it's safe to divide by 100 as PayPal doesn't support currencies with more than 2 decimal points.
     *    For those currencies with no decimal points - wallet adds two zeros, e.g
     *        in case of JPY - 1 JPY will be sent as 100 to the response
     */
    getAmountsOfBalances: function getAmountsOfBalances() {
        var balances = [];

        this.get('balance_accounts', []).forEach(function (balanceAccount) {
            var _balanceAccount$sub_b = balanceAccount.sub_balances.find(function (subBalance) {
                return subBalance.type === 'TOTAL_BALANCE';
            }),
                amount = _balanceAccount$sub_b.amount;

            if (amount.value !== '0') {
                balances.push({
                    value: Number(amount.value) / 100,
                    currency: amount.currency
                });
            }
        });

        return balances;
    },

    isLinkedCard: function isLinkedCard(fi) {
        var id = this.getId(fi);
        var card = this.getCardById(id);
        var hasLinkedCapability = card && !!getLinkedCapability(card);

        return hasLinkedCapability;
    },


    /**
     * Check if the given CI passed is a ChasePay linked card, which means it was added by linking to their Chase account
     */
    isChaseLinkedCard: function isChaseLinkedCard(fi) {
        var id = this.getId(fi);
        var card = this.getCardById(id);
        var linkedCapability = card && getLinkedCapability(card);

        if (!linkedCapability) {
            return false;
        }

        return linkedCapability.network_contingencies.some(function (networkInfo) {
            return networkInfo.network === NETWORK_TYPES.CHASE;
        });
    }
});

angular.value("$WalletModel", $WalletModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_instrument.Instrument;

_instrument.BankInstrument;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-models/src/wallet/instrument.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.BankInstrument = exports.Instrument = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

/*
 * Base model for wallet instrument data, to be used as a fallback if more specific
 * model does not exist
 */
var Instrument = exports.Instrument = _squid.$Class.extend('Instrument', {
    getName: _squid.$util.noop,
    getLastChars: _squid.$util.noop
});

var BankInstrument = exports.BankInstrument = Instrument.extend({
    getName: function getName() {
        return this.get('fs.issuer.name');
    },
    getLastChars: function getLastChars() {
        return this.get('fs.last_nchars');
    }
});

_squid.$util;

_squid.$Class;

/***/ }),

/***/ "../node_modules/xo-page-components/src/aside-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _template = __webpack_require__("../node_modules/xo-page-components/src/aside-header/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoAsideHeader', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            hdrtype: '@?',
            heading: '@?',
            subHead: '@?',
            addLink: '@?',
            backUrl: '@?',
            closeUrl: '@?',
            hidex: '@?',
            headerLeftLink: '=?',
            headerLeft: '@?',
            headerLeftIcon: '@?',
            headerRightLink: '=?',
            headerRight: '@?',
            headerRightIcon: '@?',
            subHeaderLeftLink: '@?',
            subHeaderLeft: '@?',
            subHeaderLeftIcon: '@?',
            subHeaderRightLink: '@?',
            subHeaderRight: '@?',
            subHeaderRightIcon: '@?',
            showDualFi: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            (0, _angular.$timeout)(function () {
                // Explicitly select `x` button and `<` buttons from manage wallet
                // and add card pages
                // See: https://engineering.paypalcorp.com/jira/browse/PPPLMER-64007
                // See: https://engineering.paypalcorp.com/jira/browse/PPPLMER-64008
                $element.find('a.focusableIcon').focus();
            });

            if (_angular2['default'].isUndefined($scope.closeUrl)) {
                $scope.closeUrl = 'checkout.review';
            }

            if ($scope.addLink) {
                $scope.subHeaderRight = 'asideHeader.add';
                $scope.subHeaderRightLink = $scope.addLink;
            }

            $scope.onClickLink = function (event, target, showDualFi) {
                event.preventDefault();
                if (showDualFi) {
                    $scope.showFiOptions = true;
                } else if (_angular2['default'].isFunction(target)) {
                    target();
                } else {
                    _uiRouter.$state.go(target);
                }
            };
        }]
    };
});

_uiRouter.$state;

/***/ }),

/***/ "../node_modules/xo-page-components/src/aside-header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"header noButtons\" tabindex=\"-1\" ng-class=\"[hdrtype]\" content>\n    <div class=\"primaryHeader\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content(heading) }}</h1>\n        <a link-button ui-sref=\"{{backUrl}}\" class=\"backArrow focusableIcon goTray\" ng-if=\"backUrl\" aria-label=\"Back button\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerLeftLink)\" class=\"left focusableIcon\" ng-if=\"headerLeftLink\">\n            <span ng-if=\"headerLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{closeUrl}}\" class=\"close focusableIcon\" ng-if=\"!backUrl && !hidex\" aria-label=\"Back button\"\n           data-test-id=\"closeAsideWallet\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerRightLink)\" class=\"right focusableIcon\" ng-if=\"headerRightLink\">\n            <span ng-if=\"headerRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerRight) }}</span>\n        </a>\n    </div>\n\n    <div class=\"subHeader\" ng-class=\"{'addOptions': !subHeaderLeftLink}\" ng-if=\"subHeaderLeftLink || subHeaderRightLink\">\n        <h2 class=\"subheading gamma\" ng-if=\"!subHeaderLeftLink\">{{ content(subHead) }}</h2>\n        <a link-button ui-sref=\"{{subHeaderLeftLink}}\" ng-click=\"onClickLink($event, subHeaderLeftLink, showDualFi)\" ng-if=\"subHeaderLeftLink\" id=\"leftLink\" class=\"left\" data-test-id=\"sideBarAddLink\">\n            <span ng-if=\"subHeaderLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"leftText\">{{ content(subHeaderLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{subHeaderRightLink}}\" ng-class=\"{'addLink': !subHeaderLeftLink}\"  ng-click=\"onClickLink($event, subHeaderRightLink)\" ng-if=\"subHeaderRightLink\" id=\"rightLink\" class=\"right\">\n            <span ng-if=\"subHeaderRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"rightText\">{{ content(subHeaderRight) }}</span>\n        </a>\n    </div>\n</div>\n<div class=\"fundingInstrumentList\" id=\"fundingInstrumentList\" ng-if=\"showFiOptions\">\n    <ul>\n        <li class=\"bank\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddBank.bank.add\" id=\"addBank\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addBank')}}</span>\n            </a>\n        </li>\n        <li class=\"cards\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard\" id=\"addCC\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addCC')}}</span>\n            </a>\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/autobilling-terms/autobillingTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _wpsAutobilling = __webpack_require__("../node_modules/xo-page-components/src/constants/wpsAutobilling.js");

/**
 * Wrapper for calling formatCurreny fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
    arguments[0] = arguments[0].toFixed(2);
    return _squid.formatCurrency.apply(undefined, arguments);
}

function mapBaResponse(baResponseData) {
    var mappedAutobillingDetails = {};
    var plan = baResponseData && baResponseData.plan;
    var payment_definition = plan && plan.payment_definitions && plan.payment_definitions[0];
    var mappedTerms = [];

    mappedAutobillingDetails.currencyCode = plan && plan.currency_code;

    if (payment_definition) {

        var eachMappedTerm = {
            amount: payment_definition.amount && payment_definition.amount.value / 100,
            billPeriod: _wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD,
            periodType: _wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD_TYPE,
            billFrequency: _wpsAutobilling.WPS_AUTOBILING_BILLING_FREQUENCY,
            totalCycles: _wpsAutobilling.WPS_AUTOBILING_BILLING_CYCLE
        };

        if (!mappedAutobillingDetails.currencyCode) {
            mappedAutobillingDetails.currencyCode = payment_definition.amount && payment_definition.amount.currency;
        }

        mappedTerms.push(eachMappedTerm);
        mappedAutobillingDetails.autobillingTerms = mappedTerms;
    }

    return mappedAutobillingDetails;
}

/**
 * Prepare and return a autobilling terms
 * @param baResponseData
 * @returns {Object} Containing Autobilling Terms Text
 */
function getTermsText(baResponseData) {
    var autoBillingDetails = mapBaResponse(baResponseData);
    var termText = void 0;
    var templatePlaceholderData = {
        amount: getFormattedCurrency(+autoBillingDetails.autobillingTerms[0].amount, autoBillingDetails.currencyCode, false)
    };

    termText = _squid.Content.get(_wpsAutobilling.CONTENT_KEY, templatePlaceholderData) && _squid.Content.get(_wpsAutobilling.CONTENT_KEY, templatePlaceholderData).toString();
    return termText;
}

/**
 * Retrieve item details
 */
function getItemOptions(baResponseData) {
    var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];

    return itemDetails.options || [];
}

/**
 * Retrieve item name
 */
function getItemName(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var _baResponseData$items = baResponseData.items;
    _baResponseData$items = _baResponseData$items === undefined ? [] : _baResponseData$items;
    var _baResponseData$items2 = _baResponseData$items[0];
    _baResponseData$items2 = _baResponseData$items2 === undefined ? {} : _baResponseData$items2;
    var name = _baResponseData$items2.name;


    return name;
}

module.exports = {
    getItemOptions: getItemOptions,
    getItemName: getItemName,
    getTermsText: getTermsText
};

_squid.formatCurrency;

_squid.Content;

_wpsAutobilling.CONTENT_KEY;

_wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD;

_wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD_TYPE;

_wpsAutobilling.WPS_AUTOBILING_BILLING_FREQUENCY;

_wpsAutobilling.WPS_AUTOBILING_BILLING_CYCLE;

/***/ }),

/***/ "../node_modules/xo-page-components/src/autobilling-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _autobillingTerms = __webpack_require__("../node_modules/xo-page-components/src/autobilling-terms/autobillingTerms.js");

var _autobillingTerms2 = _interopRequireDefault(_autobillingTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getItemOptions: _autobillingTerms2['default'].getItemOptions,
    getItemName: _autobillingTerms2['default'].getItemName,
    getTermsText: _autobillingTerms2['default'].getTermsText
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _autobillingTerms = __webpack_require__("../node_modules/xo-page-components/src/autobilling-terms/index.js");

var _autobillingTerms2 = _interopRequireDefault(_autobillingTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$autobilling', {
    tag: 'autobilling',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                autobillingData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            this.itemName = _autobillingTerms2['default'].getItemName(this.models.autobillingData);
            this.itemOptions = _autobillingTerms2['default'].getItemOptions(this.models.autobillingData);
            this.getTermsText = function () {
                return _autobillingTerms2['default'].getTermsText(_this.models.autobillingData);
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_index.$SubscriptionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"autobillingTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"autobillingDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\" data-test-id=\"autobilling-minicart-heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <span class=\"item-name\" data-test-id=\"autobilling-minicart-itemname\">{{itemName}}</span>\n                <div class=\"item-option\">\n                    <div ng-repeat=\"option in itemOptions track by $index\">{{option.name}}:\n                        {{option.selection}}\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"autobill-terms-text\" role=\"gridcell\">\n            <h4 class=\"heading\" data-test-id=\"autobilling-minicart-termsTitle\">{{content('wpsSubscription.message.terms')}}:\n            </h4>\n            <div class=\"content\" data-test-id=\"autobilling-minicart-termsText\">\n                <span class=\"term-line\" ng-bind-html=\"getTermsText()\"></span>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('cartWrapper', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            showAmt: '=?',
            showArrow: '=?',
            token: '=?',
            baToken: '=?'
        },
        controller: ['$scope', function ($scope) {
            _squid.$util.assert($scope.token, 'Expected token');

            (0, _squid.$populate)($scope, {
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                if ($scope.checkoutCart.isSubscriptionsV1()) {
                    $scope.showAmt = true;

                    (0, _squid.$populate)($scope, {
                        subscriptionsV1Data: _index2.$SubscriptionsV1Model.instance($scope.baToken)
                    }).then(function () {
                        var planReview = $scope.subscriptionsV1Data.planReview;

                        var plan = planReview.new_plan || planReview.current_plan;

                        $scope.subscriptionAmount = _subscriptionTerms2['default'].getFormattedAmount(_subscriptionTerms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.total_amount.value'));
                        $scope.currencyCode = _squid.$util.getProperty(plan, 'initial_payment_info.total_amount.currency_code');
                    })['catch'](_angular.noop);
                }

                if ($scope.checkoutCart.purchase) {
                    $scope.currencyCode = $scope.checkoutCart.purchase.amounts.total.currency_code;
                }

                $scope.getAmount = function () {
                    if ($scope.checkoutCart.isSubscriptionsV1()) {
                        return $scope.subscriptionAmount;
                    } else if ($scope.checkoutCart.purchase) {
                        return $scope.checkoutCart.purchase.amounts.total.amount;
                    }
                };
            });
        }]
    };
});

_angular.noop;

_squid.$populate;

_squid.$util;

_index.$CheckoutCartModel;

_index2.$SubscriptionsV1Model;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/template.html":
/***/ (function(module, exports) {

module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt && getAmount()\">\n            <format-currency class=\"formatCurrency\" code=\"currencyCode\"\n                             amount=\"getAmount()\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _sanitizeCaja = __webpack_require__("../node_modules/sanitize-caja/index.js");

var _sanitizeCaja2 = _interopRequireDefault(_sanitizeCaja);

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/lib/ui.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable max-statements */

angular.module().directive('xoCart', function () {
    return {
        template: _template2['default'],
        restrict: 'E',

        scope: {
            showCartTotal: '=?',
            renderCartContainer: '=?',
            overrideShowDetails: '=?',
            detailsExpanded: '=?',
            token: '=?'
        },

        controller: ['$scope', function ($scope) {

            _squid.$util.assert($scope.token, 'Expected token');

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                payee: _index.$CheckoutPayeeModel.instance($scope.token)
            }).then(function loadCartData() {
                // eslint-disable-line

                var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
                var cartDesc = (0, _sanitizeCaja2['default'])($scope.checkoutCart.get('purchase.description'));

                $scope.note = (0, _sanitizeCaja2['default'])($scope.checkoutCart.get('note'));

                // resolve string in descriptions array since the only element may be `null`
                // TODO: fix backend to return a string, to avoid this conditional
                if (cartDesc && angular.isString(cartDesc[0])) {
                    cartDesc = cartDesc[0];
                } else {
                    cartDesc = '';
                }

                $scope.desc = cartDesc;
                $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
                var showCartDetails = !$scope.checkoutAppData.flags.hide_cart_details;
                var notMultiSellerPurchase = !$scope.checkoutCart.isMultiSellerPurchase();
                // Always Render minicart for wps subscription .
                var wpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();
                var wpsAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();
                var wpsInstallmentPlan = $scope.checkoutAppData.is_wps_installmentplan_flow();
                var isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();

                $scope.wpsSubscription = wpsSubscription;
                $scope.wpsInstallmentPlan = wpsInstallmentPlan;
                $scope.isSubscriptionsV1 = isSubscriptionsV1;
                $scope.wpsAutobilling = wpsAutobilling;

                // We need non empty value for merchantDisplayName in #merchant-name tag of installmentPlan	
                $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
                    nonEmptyReturnValue: true,
                    isSentenceBeginning: true
                });

                var wpsBillingFlow = wpsSubscription || wpsInstallmentPlan || isSubscriptionsV1 || wpsAutobilling;
                var cartDetails = showCartDetails && (cartDesc || $scope.overrideShowDetails || $scope.hasItems || $scope.note) && notMultiSellerPurchase;

                $scope.showArrow = wpsBillingFlow || cartDetails;

                // add details to render to the checkoutCart items
                $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
                    item.details = {};

                    if (item.quantity > 1) {
                        item.details.price = item.price.amount;
                        item.details.quantity = (0, _squid.formatQuantity)(item.quantity);
                    }

                    if (item.description) {
                        if (!item.name) {
                            item.name = item.description;
                        } else {
                            item.details.description = item.description;
                        }
                    }

                    // move options to detail section
                    if (item.item_option_selections) {
                        item.details.hasSelections = true;
                        item.details.item_option_selections = item.item_option_selections;
                    }

                    if (item.sku) {
                        item.details.sku = item.sku;
                    }

                    item.hasDetails = Object.keys(item.details).length > 0;
                    item.details.hasMore = item.hasDetails || item.details.hasSelections;
                });

                // Mapping of field name as recieved by API to corresponding property key
                $scope.amountHeaders = {
                    'total': 'header.total',
                    'subtotal': 'header.itemTotal',
                    'tax': 'header.tax',
                    'shipping': 'header.shipping',
                    'insurance': 'header.insurance',
                    'handling_fee': 'header.handling',
                    'shipping_discount': 'header.shippingDiscount',
                    'description': 'header.description',
                    'discount': 'header.discount',
                    'checkout': 'header.checkout'
                };

                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                // are not available and purchase amount is not zero.
                var userAction = $scope.userAction = $scope.checkoutAppData.useraction();

                var purchase = $scope.checkoutCart.purchase;
                var total = purchase && purchase.amounts && purchase.amounts.total;

                $scope.isCartTextTotalOrSubTotal = userAction === 'commit' || $scope.showCartTotal === true ? 'header.total' : 'header.subTotal';

                var isWPSBilling = $scope.checkoutAppData.is_wps_subscription_flow() || $scope.checkoutAppData.is_wps_installmentplan_flow() || $scope.checkoutCart.isSubscriptionsV1() || $scope.checkoutAppData.isWpsAutobillingFlow();

                //  Replacing the show cart decision using Elmo experiment by this piece of code simulating
                //  Weasley behavior where if the amount exists just showed. Also added the conditions
                //  isPurchase from the pxp call and the extra conditions for subtotal from showCartDecision 
                //  https://github.paypal.com/Checkout/xo-page-components/blob/master/src/cart/lib/showCartDecision.js#L10-L12
                //  https://github.paypal.com/Checkout/xo-page-components/blob/master/src/cart/lib/pxp.js#L6-L36   
                $scope.showAmt = $scope.checkoutCart.isPurchase() && total && total.amount !== '0';
                $scope.showCartSubTotal = $scope.checkoutCart.isPurchase() && total && !isWPSBilling; //  checking for  isWpsSubscriptionFlow & isWpsInstallmentPlan & isWpsAutobillingFlow
                $scope.showAmountInCartIcon = $scope.checkoutCart.isPurchase() && total && total.amount !== '0';
            }).then(function handleCartOpenClose() {
                // the cart is only automatically open under the following criteria:
                // 1. the cart has a 'note to buyer' ($scope.note is defined)
                // 2. the cart was not previously automatically opened before
                // 3. the state has transitioned to checkout.review or checkout.guest
                // OR `detailsExpanded` is passed as true to the component
                function decideShowCart(currentState) {
                    var falsePositive = /^checkout\.(selectFi)$/.test(currentState) && /^checkout\.(review|guest)$/.test($scope.openedAlready);
                    var notOpened = !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState);
                    var canShow = notOpened || falsePositive;

                    if ($scope.note && canShow || $scope.detailsExpanded) {
                        $scope.openedAlready = currentState; // may have been undefined before
                        return true;
                    }

                    return false;
                }

                $scope.showCartItem = function (breakdown) {
                    return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
                };

                $scope.showCart = decideShowCart(_uiRouter.$state.current.name);

                // TODO: Must we really couple this so tightly with the state transition names?
                var openCartListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
                    $scope.showCart = decideShowCart(toState.name);
                });

                $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy

                $scope.toggleCart = function ($event) {
                    $scope.showCart = !$scope.showCart;
                    $event.preventDefault();
                };

                $scope.closeCart = function ($event) {
                    $scope.showCart = false;
                    // for accessible autofocus on cart toggle link button
                    $scope.$broadcast('cart-closed');
                    if ($event) {
                        $event.preventDefault();
                    }
                };

                $scope.$on('clickBody', function ($event, target) {
                    if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
                        $scope.closeCart($event);
                        $scope.$apply();
                    }
                });

                // this listener / broadcast allows accessibility components to scan and focus inside the cart
                // when the cart is displayed
                $scope.$watch('showCart', function (showCart) {
                    if (showCart) {
                        $scope.$broadcast('cart-updated');
                    }
                });
            }).then(function handleEllipsisIssues() {
                // NOTE: the scattered broadcasts of "cart-updated" events are mostly
                // to allow the accessibility directives modal-box and focus-when to
                // know when to recalculate keyboard behavior / focus
                $scope.toolongTracker = {};

                // this function is invoked by the onEllipsis directive that tracks
                // if the item name won't fit within the restricted space.
                $scope.toolong = function (idx) {
                    $scope.toolongTracker[idx] = true;
                    $scope.$broadcast('cart-updated');
                };

                $scope.showMore = function (idx, type) {
                    // there are 2 types of more, "floating" when the name is too long
                    // and "inline" when the name can fit, but there are additional details.
                    //
                    // Show a more if the item
                    // 1. has an expanded state
                    // 2. is not already expanded
                    // 3. if it is appropriate to show that type.
                    var itemIsTooLong = $scope.toolongTracker[idx];
                    var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';

                    return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
                };

                $scope.expandedIndex = -1; // initially, none of the line items are expanded
                $scope.isExpanded = function isExpanded(idx) {
                    return idx === $scope.expandedIndex;
                };
                $scope.hasExpandedState = function hasExpandedState(idx) {
                    // A line item is exandable if
                    // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
                    // 2. there are details (attached to purchase.items in the cart)
                    // 3. there is item number (sku) in the item
                    var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
                    var nameTooLong = $scope.toolongTracker[idx];

                    return nameTooLong || item.hasDetails || item.sku;
                };
                $scope.expand = function expand(idx) {
                    $scope.expandedIndex = idx;
                    $scope.$broadcast('cart-updated');
                };
                $scope.collapse = function collapse() {
                    $scope.expandedIndex = -1;
                    $scope.$broadcast('cart-updated');
                };

                // Set default focus on cart first element "more" link
                $scope.focusElementCssSelector = 'a.more';

                // Change the focus element as user clicks on elements
                $scope.$watch('expandedIndex', function (expandedIndex) {
                    if (expandedIndex === -1) {
                        $scope.focusElementCssSelector = 'a.more';
                    } else {
                        // If any "more" link or item is clicked in cart, then
                        // set focus to itemNameContainer
                        $scope.focusElementCssSelector = '.itemNameContainer.expanded';
                    }
                });

                $scope.$emit('dataLoaded');
            });
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_squid.$util;

_squid.formatQuantity;

_uiRouter.$state;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _installmentplanTerms = __webpack_require__("../node_modules/xo-page-components/src/installmentplan-terms/index.js");

var _installmentplanTerms2 = _interopRequireDefault(_installmentplanTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$installmentplan', {
    tag: 'installmentplan',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        },
        merchantName: {
            type: 'var',
            optional: false
        }
    },

    resolve: {
        models: function models() {
            return {
                installmentPlanData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {

            var installmentData = _installmentplanTerms2['default'].getInstallmentPlanData(this.models.installmentPlanData);

            this.itemName = _installmentplanTerms2['default'].getItemName(this.models.installmentPlanData);
            this.total = installmentData.formattedTotalAmount;
            this.getFirstAmount = function () {
                return installmentData.formattedFirstAmount;
            };
            this.getTermsText = function () {
                return installmentData.termsText;
            };
            this.getAmountText = function () {
                return installmentData.amountText;
            };
            this.getDisplayTotal = function () {
                return installmentData.displayTotal;
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_index.$SubscriptionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"installmentPlanTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"installmentPlanDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsInstallmentPlan.message.installmentPlanDetails')}}:</h4>\n            <div class=\"content\">\n                <span class=\"item-name\">{{itemName}}</span>\n            </div>\n        </div>\n\n        <div class=\"installmentTermsText\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsInstallmentPlan.message.billCycle')}}:\n            </h4>\n            <div class=\"bill-cycle\">\n                <div class=\"bill-cycle-term\">\n                    <div class=\"term-line\" ng-repeat=\"term in getTermsText() track by $index\">{{term}}</div>\n                </div>\n                <div class=\"bill-cycle-amount\">\n                    <div class=\"amount-line\" ng-repeat=\"amount in getAmountText() track by $index\">{{amount}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"installmentTermsText\" role=\"gridcell\" ng-if=\"getDisplayTotal()\">\n            <div class=\"display-total\">\n                <div class=\"bill-cycle-term\">\n                    <div class=\"term-line\" >{{content('wpsInstallmentPlan.message.total')}}:</div>\n                </div>\n                <div class=\"bill-cycle-amount\">\n                    <div class=\"amount-line\">{{total}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"installmentPlanLegal\">\n            <div class=\"content\">\n                <div class=\"legal-text\">{{content('wpsInstallmentPlan.message.installmentPlanLegalText')}}</div>\n                <div class=\"legal-info\">{{content('wpsInstallmentPlan.message.installmentPlanLegalTextSuggestion', {merchantName})}}</div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('itemDetails', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            details: '=?',
            sku: '=?',
            currencyCode: '=?',
            onClickLess: '&?'
        },
        controller: function controller() {/* dumb component */}
    };
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/template.html":
/***/ (function(module, exports) {

module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul focusable content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} <span class=\"item-quantity\">{{ details.quantity }}</span></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections track by $index\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> <span class=\"item-description\">{{ details.description }}</span>\n    </div>\n  </li>\n</ul>\n<a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/decode_entities.js":
/***/ (function(module, exports) {



/**
 * Takes a string with HTML entities within and renders it as the unicode
 * characters they represent. This is done by leveraging the browser to
 * perform this transformation internally. InnerText is chosen as the output
 * so as to kill any HTML itself that was supplied.
 *
 * @param {Element} element any HTML element supporting innerText and
 * innerHTML. Preferably one not connected to the DOM or visible in any way.
 * @param {String} input a String containing HTML entities that need to be
 * decoded and HTML stripped.
 * @return {String} the same string with HTML tags removed and entities
 * decoded.
 */

exports.__esModule = true;
exports.decodeEntities = decodeEntities;
exports['default'] = decodeEntitiesAngularFilter;
function decodeEntities(element, input) {
    // Escape opening tags on vulnerable tags
    input = input.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link|source|video|audio|details|input|image|object|track|select)/ig, '&lt;$1$2');
    element.innerHTML = input;
    return element.textContent;
}

function decodeEntitiesAngularFilter() {
    // A constant key that can be used to find the element
    var ENTITY_ELEM = '__xpc_entitydecoder__';

    // Create the element if this is the first time this is called
    if (!window[ENTITY_ELEM]) {
        window[ENTITY_ELEM] = document.createElement('p');
    }

    // Retrieve the converter element rather than create one every
    // time. Angular may call this filter many times repeatedly and
    // we should make a small effort to optimize the process
    var converter = window[ENTITY_ELEM];

    /**
     * Takes a string with HTML entities within and renders it as the unicode
     * characters they represent. This is done by leveraging the browser to
     * perform this transformation internally. InnerText is chosen as the output
     * so as to kill any HTML itself that was supplied.
     *
     * @param {String} input a String containing HTML entities that need to be
     * decoded and HTML stripped.
     * @return {String} the same string with HTML tags removed and entities
     * decoded.
     */
    return decodeEntities.bind(null, converter);
}

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/pxp.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$pxpCartAmt', function () {
    return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
        if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
            var pageName = 'xo_hermes_no_line_item_details';
            var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
            var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';

            return _angular.$q.all([(0, _squid.$pxp)(pageName, {
                'ctx.merchantID': merchantId,
                uid: merchantId
            }, showAmtBlacklistTreatment, false, true), (0, _squid.$pxp)(pageName, {
                'ctx.merchantID': merchantId,
                uid: merchantId
            }, showAmtTreatment, false, true)]).then(function (results) {
                var showAmtBlacklist = results[0];
                var showAmt = results[1];

                if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
                    return true;
                }

                if (showAmt && showAmt.treatment_name === showAmtTreatment) {
                    return true;
                }

                return false; // default to hide
            });
        }

        return _angular.$q.when(!noLineItemDetails && isPurchase);
    };
});

_squid.$pxp;

_angular.$q;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/cart/lib", "../node_modules/xo-page-components/src/cart/lib/pxp.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/ui.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _decode_entities = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/decode_entities.js");

var _decode_entities2 = _interopRequireDefault(_decode_entities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Register entity decoding filter in Angular
_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);

// if an element has an ellipsis text-overflow in effect (it must already have
// the appropriate css styling) then invoke the function that is passed to the directive
function getVisibleWidth(elem) {
    var elemRect = elem.getBoundingClientRect();

    // cross browser, returns decimals for ultra-precision
    return elemRect.right - elemRect.left;
}

function getNaturalWidth(elem) {
    var old = {
        overflow: elem.style.overflow,
        width: elem.style.width,
        display: elem.style.display
    };
    var result = void 0;

    elem.style.overflow = 'visible';
    elem.style.width = 'auto';
    elem.style.display = 'inline-block';
    result = getVisibleWidth(elem);
    elem.style.overflow = old.overflow;
    elem.style.width = old.width;
    elem.style.display = old.display;

    return result;
}

// pre-determine approach to reading styles
var getStyle = _angular.$window.getComputedStyle ? function (elem, style) {
    return _angular.$window.getComputedStyle(elem)[style];
} // modern browsers
: function (elem, style) {
    return elem.currentStyle[style];
}; // IE

function hasEllipsis(elem) {
    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';

    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
        return getVisibleWidth(elem) < getNaturalWidth(elem);
    }

    return false;
}

(0, _squid.$registerDirective)('onEllipsis', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function invokeSubscriber() {
                (0, _angular.$parse)(attrs.onEllipsis)(scope);
                scope.$apply();
            }

            (0, _angular.$timeout)(function () {
                if (hasEllipsis(element[0])) {
                    invokeSubscriber();
                }
            });
        }
    };
});

// Makes an element examine the outerHeight of its siblings
// and the max-height of its parent, then sets a max-height for itself
// so that everything fits within the limits of the parent. Note that it assumes
// no other sibling also has dynamic-maxheight.
(0, _squid.$registerDirective)('dynamicMaxheight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function resizeContainer() {
                var $element = (0, _jquery2['default'])(element);
                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
                var siblings = $element.siblings().filter(function () {
                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');

                    return pos !== 'fixed' && pos !== 'absolute';
                }).map(function getOuterHeights() {
                    return (0, _jquery2['default'])(this).outerHeight();
                });
                var siblingsHeight = 0;
                var i = void 0;

                for (i = 0; i < siblings.length; i += 1) {
                    siblingsHeight += siblings[i];
                }

                var spaceAvailable = parentHeight - siblingsHeight;

                if (!isNaN(spaceAvailable)) {
                    $element.css('max-height', spaceAvailable + 'px');
                }
            }

            // if an expression is provided, it is used as an event to listen for and recalculate the height
            if (attrs.dynamicMaxheight) {
                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
            }

            (0, _angular.$timeout)(resizeContainer);
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$timeout;

_angular.$filterProvider;

_angular.$window;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/subscription/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$subscription', {
    tag: 'subscription',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                subscriptionData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            this.itemName = _subscriptionTerms2['default'].getItemName(this.models.subscriptionData);
            this.itemOptions = _subscriptionTerms2['default'].getItemOptions(this.models.subscriptionData);

            this.getFirstAmount = function () {
                return _subscriptionTerms2['default'].getFormattedFirstAmount(_this.models.subscriptionData);
            };

            this.getTermsText = function () {
                return _subscriptionTerms2['default'].getTermsText(_this.models.subscriptionData);
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_index.$SubscriptionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <span class=\"item-name\">{{itemName}}</span>\n                <div class=\"item-option\">\n                    <div ng-repeat=\"option in itemOptions track by $index\">{{option.name}}:\n                        {{option.selection}}\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"subs-terms-text\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.terms')}}:\n            </h4>\n            <div class=\"content\">\n                <span class=\"term-line\" ng-repeat=\"term in getTermsText() track by $index\">{{term}}</span>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.firstAmount')}}</h4>\n            <div ng-bind-html=\"getFirstAmount()\" class=\"content\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionV1Terms = __webpack_require__("../node_modules/xo-page-components/src/subscriptionV1-terms/index.js");

var _subscriptionV1Terms2 = _interopRequireDefault(_subscriptionV1Terms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$SubscriptionsV1', {
    tag: 'subscriptions-v1',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                subscriptionData: _index.$SubscriptionsV1Model.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _models$subscriptionD = this.models.subscriptionData,
                planReview = _models$subscriptionD.planReview,
                billingAgreementCart = _models$subscriptionD.billingAgreementCart;

            var plan = planReview.new_plan || planReview.current_plan;
            var itemAmount = _squid.$util.getProperty(plan, 'initial_payment_info.first_payment.value');
            var isItemAmountPresent = _subscriptionV1Terms2['default'].isNumericValue(itemAmount);
            var currencyCode = _squid.$util.getProperty(plan, 'initial_payment_info.total_amount.currency_code');

            this.termsText = _subscriptionV1Terms2['default'].getTermsText(plan);
            this.isAutoRenew = billingAgreementCart.auto_renewal !== 'false';
            this.startDate = billingAgreementCart.start_time_formatted;
            this.itemName = _squid.$util.getProperty(plan, 'plan.name');
            var taxPercentage = _subscriptionV1Terms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.taxPercentage');
            var taxAmount = _squid.$util.getProperty(plan, 'initial_payment_info.tax_amount');
            var taxAmountFormatted = taxAmount && _subscriptionV1Terms2['default'].getFormattedAmount(taxAmount.value, taxAmount.currency_code);

            this.taxDisclaimer = _subscriptionV1Terms2['default'].getTaxDisclaimer(taxPercentage, taxAmountFormatted);
            this.itemPrice = isItemAmountPresent && _subscriptionV1Terms2['default'].getFormattedAmount(itemAmount, currencyCode);

            this.quantity = plan.plan.quantity_supported && billingAgreementCart.quantity;
            this.shipping = _subscriptionV1Terms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.shipping_amount.value');
            this.shippingAmount = _subscriptionV1Terms2['default'].getFormattedAmount(this.shipping, currencyCode);
            this.setupFee = _subscriptionV1Terms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.setup_fee.value');
            this.setupFeeAmount = _subscriptionV1Terms2['default'].getFormattedAmount(this.setupFee, currencyCode);

            var totalAmount = _subscriptionV1Terms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.total_amount.value');

            this.totalAmount = _subscriptionV1Terms2['default'].getFormattedAmount(totalAmount, currencyCode);
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$util;

_index.$SubscriptionsV1Model;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <div class=\"item-option\">\n                    <div ng-repeat=\"terms in termsText track by $index\">\n                        {{terms}}\n                    </div>\n                    <div ng-if=\"isAutoRenew\" class=\"subscription-terms\">{{content('subscriptions.message.renewsUntilCancelled')}}</div>\n                    <div class=\"start-date\" ng-if=\"startDate\"> {{content('subscriptions.message.startDate')}} {{ startDate }}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"landing-page-item-details-container\">\n            <div class=\"item-details-row\">\n                <div class=\"item-details-left\" ng-class=\"{'tax-indicator-after': taxDisclaimer}\">{{ itemName }} </div>\n                <div class=\"item-details-right\" ng-if=\"itemPrice\"> {{ itemPrice }}</div>\n            </div>\n            <div class=\"item-details-row label-color\" ng-if=\"quantity\">\n                <div class=\"item-details-left\">{{ content('header.quantity') }} {{ quantity }}</div>\n                <div class=\"item-details-right\"></div>\n            </div>\n            <div class=\"item-details-row\" ng-if=\"shipping\">\n                <div class=\"item-details-left\">{{ content('header.shipping') }}</div>\n                <div class=\"item-details-right\">{{ shippingAmount }}</div>\n            </div>\n\n            <div class=\"item-details-row\" ng-if=\"setupFee\">\n                <div class=\"item-details-left\" ng-class=\"{'tax-indicator-after': taxDisclaimer}\">{{ content('subscriptions.message.setupFee') }}</div>\n                <div class=\"item-details-right\">{{ setupFeeAmount }}</div>\n            </div>\n\n            <div class=\"item-details-row margin-top-30\" ng-if=\"taxDisclaimer\">\n                <div class=\"item-details-left label-color tax-indicator-before\" data-test-id=\"tax-disclaimer\">\n                    {{ taxDisclaimer }}\n                </div>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\" >{{content('header.total')}}</h4>\n            <div class=\"content\">{{ totalAmount }}</div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                          token=\"token\" ba-token=\"checkoutCart.getBaToken()\"\n            ></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" id=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"focusElementCssSelector\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h2 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h2>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <subscription ng-if=\"wpsSubscription\"\n                              ba-token=\"checkoutCart.getBaToken()\"\n                              merchant-id=\"payee.getId()\">\n                </subscription>\n\n                <autobilling ng-if=\"wpsAutobilling\"\n                              ba-token=\"checkoutCart.getBaToken()\"\n                              merchant-id=\"payee.getId()\">\n                </autobilling>\n\n                <installmentplan ng-if=\"wpsInstallmentPlan\"\n                              ba-token=\"checkoutCart.getBaToken()\" merchant-id=\"payee.getId()\" merchant-name=\"nonEmptyMerchantDisplayName\"></installmentplan>\n\n                <subscriptions-v1 ng-if=\"isSubscriptionsV1\"\n                                  ba-token=\"checkoutCart.getBaToken()\"\n                                  merchant-id=\"payee.getId()\">\n                </subscriptions-v1>\n\n                <div ng-if=\"!(wpsSubscription) \" dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <div ng-if=\"!(wpsInstallmentPlan)\">\n                        <div ng-if=\"!(autobilling)\">\n                            <ul class=\"detail-items\" ng-if=\"hasItems\">\n                                <li ng-repeat=\"item in checkoutCart.purchase.items track by $index\" class=\"items\">\n\n                                    <div focusable class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                        <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                        <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                                    </div>\n                                    <span class=\"itemPrice\">\n                                        <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                                    </span>\n                                    <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                                </li>\n                            </ul>\n\n                            <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                                <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                                    <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts track by $index\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                        <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                        <span class=\"itemPrice\">\n                                            <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                        </span>\n                                    </li>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"!(wpsInstallmentPlan)\">\n                <div class=\"subTotal\" ng-if=\"showCartSubTotal\">\n                    <span class=\"itemNameContainer\">{{ content(isCartTextTotalOrSubTotal) }}</span>\n                        <span class=\"itemPrice\">\n                            <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                            amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"(wpsInstallmentPlan && (showAmt && hasItems))\">\n                    <span class=\"itemNameContainer\">{{ content(amountHeaders['checkout']) }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/constants/fbMessenger.js":
/***/ (function(module, exports) {



/* Constants for FB messenger related components */
module.exports = {
    OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
    OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
    FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
    MOBILE_CHANNEL: 'MOBILE',
    WEB_CHANNEL: 'WEB',
    FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
    FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
    FB_PROD_APP_ID: '1084613224964631',
    FB_PROD_PAGE_ID: {
        US: '55982004572',
        AU: '171522459698178',
        CA: '164660263560926',
        GB: '167465479930420',
        HK: '575224445931086',
        JP: '252040838174046',
        NZ: '171522459698178',
        PH: '1895483750701842',
        SG: '1405303076421245',
        IL: '369238992488',
        CZ: '199396843578121',
        DE: '109838022384872',
        AT: '109838022384872',
        CH: '109838022384872',
        FR: '124143236317',
        IT: '198366693576785',
        BR: '170288122998781',
        ES: '244240615638886',
        MX: '42433532610',
        ZA: '388473619362',
        NL: '105370782861413',
        DK: '133211860117553',
        SE: '121404111292725',
        RU: '275216545856555',
        PL: '244706038980513',
        NO: '304581546592510',
        GR: '704200349634422',
        IN: '347199669139259',
        AE: '402374783229274',
        BH: '402374783229274',
        DZ: '402374783229274',
        EG: '402374783229274',
        JO: '402374783229274',
        KW: '402374783229274',
        MA: '402374783229274',
        OM: '402374783229274',
        QA: '402374783229274',
        SA: '402374783229274',
        TN: '402374783229274',
        YE: '402374783229274',
        AR: '474276366001351',
        CL: '474276366001351',
        CO: '474276366001351',
        CR: '474276366001351',
        DO: '474276366001351',
        EC: '474276366001351',
        PE: '474276366001351',
        UY: '474276366001351',
        VE: '474276366001351'
    }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/constants/wpsAutobilling.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var CONTENT_KEY = exports.CONTENT_KEY = 'wpsSubscription.message.termsText';
var WPS_AUTOBILING_BILLING_PERIOD = exports.WPS_AUTOBILING_BILLING_PERIOD = 'MONTH';
var WPS_AUTOBILING_BILLING_PERIOD_TYPE = exports.WPS_AUTOBILING_BILLING_PERIOD_TYPE = 'REGULAR';
var WPS_AUTOBILING_BILLING_FREQUENCY = exports.WPS_AUTOBILING_BILLING_FREQUENCY = 1;
var WPS_AUTOBILING_BILLING_CYCLE = exports.WPS_AUTOBILING_BILLING_CYCLE = 'Infinity';

/***/ }),

/***/ "../node_modules/xo-page-components/src/cpa-disclaimer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCpaDisclaimerComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cpa-disclaimer/template.html");

var _template2 = _interopRequireDefault(_template);

var _factory = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTH_TYPE = {
    PARTIAL: 'PARTIAL',
    FULL: 'FULL'
};

var $xoCpaDisclaimerComponent = exports.$xoCpaDisclaimerComponent = _squid.$Component.extend('$xoCpaDisclaimer', {
    tag: 'xo-cpa-disclaimer',
    template: _template2['default'],
    props: {
        selectedmethod: {
            type: 'var',
            required: false
        },
        primaryplan: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.token = _angular.$rootScope.token;
            this.showReviewLaterText = false;
        },
        populate: function populate() {
            var _this = this;

            var useraction = this.models.checkoutAppData.useraction() && this.models.checkoutAppData.useraction().toLowerCase();
            var buttonLabelIsPay = !!(useraction === 'commit' || _squid.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW'));
            var getPlanId = function getPlanId(obj) {
                return obj.planId || obj.id;
            };
            var getDefaultPlanId = function getDefaultPlanId() {
                return _this.models.checkoutSession.plan.id || [];
            };
            var getPlan = function getPlan(planId) {
                var plans = _this.models.checkoutSession.get('fundingOptions.plans') || [];
                var plan = plans.filter(function (p) {
                    return getPlanId(p) === planId;
                });

                return plan && plan.length > 0 ? plan[0] : null;
            };
            var resetContent = function resetContent() {
                _this.msg1 = '';
                _this.msg2 = '';
                _this.fullAuthMoreInfoLine1 = '';
                _this.fullAuthMoreInfoLine2 = '';
            };
            var decidePlanSelection = function decidePlanSelection() {
                var defaultPlan = _this.models.checkoutSession.get('plan.sources') && _this.models.checkoutSession.get('plan.sources')[0];
                var hasRewards = _factory.$RewardsCheckboxFactory.isRewardsPlan(_this.models.checkoutSession.plan);
                var selectedMethodPlanId = (0, _utils.getSelectedPlan)(_this.selectedmethod, _this.models.checkoutSession);

                if (!_this.selectedmethod && !hasRewards) {
                    return '';
                }

                selectedMethodPlanId = _factory.$RewardsCheckboxFactory.ifRewardsThenUpdatePlan(selectedMethodPlanId, _this.selectedmethod, _this.models.checkoutSession);

                // If the plan is already selected, we don't need to duplicate the call
                if (selectedMethodPlanId === (defaultPlan && defaultPlan.id)) {
                    return '';
                }

                // This is handled in onPay
                if (selectedMethodPlanId === 'applyForPPCRadio') {
                    return '';
                }
                return selectedMethodPlanId;
            };
            var updateContent = function updateContent(selectedPlan) {
                // eslint-disable-line
                resetContent();
                // If User's selected FI is not available then we get the
                // default FI Plan to display content.
                selectedPlan = selectedPlan || getPlan(getDefaultPlanId());

                var pre_authorization_instruction = selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.pre_authorization_instruction;
                /**
                 * In the PPC CPA initiative, due to constraints in the backend, Risk layer sends PPC preAuthorization data to all member checkout flows, including hermes.
                 * However, hermes is not a part of the PPC PCA. Thus, we are disabling CPA disclaimer if user selects PPC
                 */
                var isPPCReuse = selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.name === 'BILL_ME_LATER';

                if (pre_authorization_instruction && pre_authorization_instruction.amount && !isPPCReuse) {
                    var type = pre_authorization_instruction.type,
                        _pre_authorization_in = pre_authorization_instruction.amount,
                        value = _pre_authorization_in.value,
                        currency_code = _pre_authorization_in.currency_code;


                    var oneDollarAuthContinue = type === AUTH_TYPE.PARTIAL && useraction !== 'commit';
                    var oneDollarPayNow = type === AUTH_TYPE.PARTIAL && useraction === 'commit';
                    var fullAuth = type === AUTH_TYPE.FULL && useraction !== 'commit';
                    var authAmount = value && (0, _squid.formatCurrency)(value, currency_code);
                    var merchantName = _this.models.checkoutAppData && _this.models.checkoutAppData.get('merchant.brand_name');
                    var _models$checkoutSessi = _this.models.checkoutSession.payer;
                    _models$checkoutSessi = _models$checkoutSessi === undefined ? {} : _models$checkoutSessi;
                    var payerId = _models$checkoutSessi.id;

                    var msg_id = '';

                    if (fullAuth) {
                        msg_id = 'disclaimer.reviewOrderBeforePurchaseWithMerchantName, disclaimer.fullAuthInformation';
                        _this.msg1 = !buttonLabelIsPay && (0, _squid.$renderContent)('disclaimer.reviewOrderBeforePurchaseWithMerchantName', {
                            merchantName: merchantName
                        });
                        _this.msg2 = !buttonLabelIsPay && (0, _squid.$renderContent)('disclaimer.fullAuthInformation', {
                            merchantName: merchantName,
                            amt: authAmount
                        });
                        _this.fullAuthMoreInfoLine1 = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine1', { merchantName: merchantName });
                        _this.fullAuthMoreInfoLine2 = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine2', { merchantName: merchantName });
                    }
                    if (oneDollarAuthContinue) {
                        msg_id = 'disclaimer.reviewOrderBeforePurchaseWithMerchantName, disclaimer.oneDollarAuthRequired';
                        _this.msg1 = (0, _squid.$renderContent)('disclaimer.reviewOrderBeforePurchaseWithMerchantName', {
                            merchantName: merchantName
                        });
                        _this.msg2 = (0, _squid.$renderContent)('disclaimer.oneDollarAuthRequired', {
                            merchantName: merchantName,
                            amt: authAmount
                        });
                    }
                    if (oneDollarPayNow) {
                        msg_id = 'disclaimer.reviewOrderBeforePurchaseWithMerchantName, disclaimer.oneDollarAuthRequiredPayNow';
                        _this.msg1 = (0, _squid.$renderContent)('disclaimer.oneDollarAuthRequiredPayNow', {
                            amt: authAmount
                        });
                        _this.msg2 = undefined;
                    }
                    _this.showReviewLaterText = true;

                    _logger.$logger.info('checkout_fpti', {
                        from: 'REVIEW',
                        to: 'prepare_review',
                        ryp_button_text: useraction === 'commit' ? 'PayNow' : 'Continue',
                        client_epoch_ts: Date.now(),
                        msg_id: msg_id,
                        amt: authAmount.split(/\s+/)[0],
                        currency_code: authAmount.split(/\s+/)[1],
                        auth_type: type,
                        buyer_id: payerId
                    });
                } else {
                    if (_this.models.checkoutCart.isSubscriptionsV1()) {
                        _this.showReviewLaterText = useraction !== 'commit';
                        return;
                    }
                    if (useraction !== 'commit' && !_squid.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW') && _this.models.checkoutCart.isBillingNoPurchase()) {
                        _logger.$logger.info('billing_no_purchase_use_case');
                        _this.showReviewLaterText = false;
                    }
                    if (_this.showReviewLaterText) {
                        _this.msg1 = buttonLabelIsPay ? '' : (0, _squid.$renderContent)('common.reviewLater');
                    }
                }
            };

            this.$watch('selectedmethod', function (newPlan) {
                if (!newPlan) {
                    return;
                }
                updateContent(newPlan);
            });

            updateContent(this.selectedmethod);

            this.$watch('selectedmethod.planId', function (newVal) {
                if (!newVal) {
                    return;
                }
                return updateContent(getPlan(decidePlanSelection()));
            });

            this.$watch('selectedmethod.rewardsChosenPlan', function () {
                return updateContent(getPlan(decidePlanSelection()));
            });

            this.$watch('primaryplan', function (newPlan) {
                if (!newPlan) {
                    return;
                }
                return updateContent(newPlan);
            });
        }
    }
});

angular.value("$xoCpaDisclaimerComponent", $xoCpaDisclaimerComponent);
_angular.$rootScope;

_angular.noop;

_squid.$Component;

_squid.formatCurrency;

_squid.$renderContent;

_squid.$integration;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_logger.$logger;

_factory.$RewardsCheckboxFactory;

_utils.getSelectedPlan;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cpa-disclaimer/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"reviewLaterContainer disclaimer\" data-test-id=\"reviewLaterContainer\" ng-if=\"showReviewLaterText\">\n    <p ng-if=\"msg1\">\n        <span>{{msg1}}</span>\n    </p>\n    <p ng-if=\"msg2\">\n        <span>{{msg2}}</span>\n    </p>\n    <div id=\"moreInfoContainer\" data-testid=\"disclaimer-more-info-container\" ng-show=\"fullAuthMoreInfoLine1 || fullAuthMoreInfoLine2 \">\n        <p>{{ fullAuthMoreInfoLine1 }} </p>\n        <p>{{ fullAuthMoreInfoLine2 }} </p>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/decline-notification/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoDeclineNotificationComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/decline-notification/template.html");

var _template2 = _interopRequireDefault(_template);

var _errorMap = __webpack_require__("../node_modules/xo-page-components/src/decline-notification/errorMap.js");

__webpack_require__("../node_modules/xo-page-components/src/decline-notification/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoDeclineNotificationComponent = exports.$xoDeclineNotificationComponent = _squid.$Component.extend('$xoDeclineNotification', {
    tag: 'xo-decline-notification',
    template: _template2['default'],
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.token = _angular.$rootScope.token;
            this.showDeclineNotification = false;
            this.formattedName = '';
            this.declinedFiType = '';
            this.showActionLink = false;
        },
        populate: function populate() {
            // eslint-disable-line
            this.useraction = this.models.checkoutAppData.useraction() && this.models.checkoutAppData.useraction().toLowerCase();

            var formatType = function formatType(name, type) {
                if (type === 'CREDIT') {
                    // Unforunately, CREDIT is a type that is used for types that
                    // should not show marketing text, such as PAYPAL_SMART_CONNECT
                    if (name === 'PAYPAL_SMART_CONNECT') {
                        return null;
                    }
                }

                // All other known FIs have a second line that displays a type descriptor
                var secondLineDescriptor = (0, _squid.$renderContent)('fsMappings.' + type);

                if (secondLineDescriptor) {
                    return secondLineDescriptor;
                }
                // Unknown FI type, don't show type descriptor
                return null;
            };
            var declinedInstruments = this.models.checkoutSession.declinedInstruments;

            if (declinedInstruments && declinedInstruments.length) {
                this.declinedInstrument = declinedInstruments[0];
                var _declinedInstruments$ = declinedInstruments[0],
                    normalized_processor_response = _declinedInstruments$.normalized_processor_response,
                    id = _declinedInstruments$.id,
                    last4 = _declinedInstruments$.last4,
                    type = _declinedInstruments$.type,
                    card_type = _declinedInstruments$.card_type,
                    decline_type = _declinedInstruments$.decline_type;
                var _models$checkoutSessi = this.models.checkoutSession.payer;
                _models$checkoutSessi = _models$checkoutSessi === undefined ? {} : _models$checkoutSessi;
                var payerId = _models$checkoutSessi.id;

                // only show the tile message if the decline type is PRE Auth

                if (decline_type === 'PREAUTH') {
                    var plans = this.models.checkoutSession.get('fundingOptions.plans', []);

                    this.declineContent = (0, _squid.$renderContent)((0, _errorMap.mapDeclineContent)(normalized_processor_response));
                    var declineActionLink = (0, _errorMap.mapDeclineAction)(normalized_processor_response);
                    var actionContentKey = void 0;
                    var linkAction = void 0;
                    var testId = void 0;

                    /* When the decline code is either of the following, that indicates updating the card number. So we show the update link.
                        'EXPIRED_CARD':
                        'INVALID_ACCOUNT':
                        'LOST_OR_STOLEN':
                        'HOLD_CALL_CENTER':
                        'PICKUP_CARD_SPECIAL_CONDITIONS':
                        'ACCOUNT_NOT_FOUND':
                        'INVALID_OR_RESTRICTED_CARD'
                     */

                    if (plans && plans.length > 0 && declineActionLink === _errorMap.DECLINE_ACTION.UPDATE) {
                        actionContentKey = 'issuerDecline.updateLink';
                        linkAction = this.actions.onUpdateClick.bind(this);
                        testId = '';
                        this.showActionLink = true;
                    } else if (declineActionLink === _errorMap.DECLINE_ACTION.RETRY) {
                        // Retry - When the card decline is actionable,
                        // like 'INSUFFICIENT_FUNDS'or 'AMOUNT_EXCEEDED', call issuer and resolve it,
                        // provide the user an option to retry card.
                        actionContentKey = 'issuerDecline.genericActionLink';
                        linkAction = this.actions.onRetryClick.bind(this);
                        testId = 'notification-retry-container';
                        this.showActionLink = true;
                    }

                    // For BAD_GAMING processor response we dont display Retry Link to user as there
                    // is no recovery availble.
                    // User story - https://rally1.rallydev.com/#/255547370892d/detail/userstory/331732135948
                    if (normalized_processor_response === 'BAD_GAMING') {
                        this.showActionLink = false;
                    }

                    this.declineAction = {
                        linkContent: (0, _squid.$renderContent)(actionContentKey),
                        linkAction: linkAction,
                        testId: testId
                    };

                    this.lastDigits = last4;
                    this.formattedName = (0, _squid.$renderContent)('fsMappings.' + card_type.toUpperCase());
                    this.declinedFiType = formatType(card_type, type);

                    _logger.$logger.info('checkout_fpti', {
                        from: 'REVIEW',
                        to: 'prepare_declined_fi',
                        buyer_id: payerId,
                        ryp_button_text: this.useraction === 'commit' ? 'PayNow' : 'Continue',
                        client_epoch_ts: Date.now(),
                        fi_id: id,
                        card_brand: card_type,
                        card_type: type,
                        user_action: normalized_processor_response === 'BAD_GAMING' ? 'NULL' : declineActionLink,
                        int_error_code: normalized_processor_response,
                        ext_error_desc: (0, _errorMap.mapDeclineContent)(normalized_processor_response)
                    });

                    this.showDeclineNotification = true;
                }
            }
        }
    },
    actions: {
        /* Handler, when user click update link
           we redirect to Add card sidebar screen.
        */
        onUpdateClick: function onUpdateClick(event) {
            if (event) {
                event.preventDefault();
            }
            var _models$checkoutSessi2 = this.models.checkoutSession.payer;
            _models$checkoutSessi2 = _models$checkoutSessi2 === undefined ? {} : _models$checkoutSessi2;
            var payerId = _models$checkoutSessi2.id;


            _logger.$logger.info('checkout_fpti', {
                from: 'REVIEW',
                to: 'process_declined_fi',
                buyer_id: payerId,
                ryp_button_text: this.useraction === 'commit' ? 'PayNow' : 'Continue',
                client_epoch_ts: Date.now(),
                fi_id: this.declinedInstrument.id,
                card_brand: this.declinedInstrument.card_type,
                card_type: this.declinedInstrument.type,
                user_action: _errorMap.DECLINE_ACTION.UPDATE,
                int_error_code: this.declinedInstrument.normalized_processor_response
            });

            // Remove this tile and redirect to Add Card Flow.
            this.showDeclineNotification = false;
            _uiRouter.$state.go('checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard', {
                doneUri: 'checkout.review',
                updateCardCPA: true
            });
        },


        /* Handler, when user click Retry link
           we make a PAPS call to Remove the funding constraints and get the checkoutSession,
           and redirect to review page.
        */
        onRetryClick: function onRetryClick(event) {
            var _this = this;

            if (event) {
                event.preventDefault();
            }
            var _models$checkoutSessi3 = this.models.checkoutSession.payer;
            _models$checkoutSessi3 = _models$checkoutSessi3 === undefined ? {} : _models$checkoutSessi3;
            var payerId = _models$checkoutSessi3.id;


            _logger.$logger.info('checkout_fpti', {
                from: 'REVIEW',
                to: 'process_declined_fi',
                buyer_id: payerId,
                ryp_button_text: this.useraction === 'commit' ? 'PayNow' : 'Continue',
                client_epoch_ts: Date.now(),
                fi_id: this.declinedInstrument.id,
                card_brand: this.declinedInstrument.card_type,
                card_type: this.declinedInstrument.type,
                user_action: _errorMap.DECLINE_ACTION.UPDATE,
                int_error_code: this.declinedInstrument.normalized_processor_response
            });

            this.models.checkoutSession.set('declinedInstruments', null);

            return this.models.checkoutSession.action('removeFundingConstraint', {
                data: {
                    id: this.declinedInstrument.id
                },
                success: function success(preAuthResponse) {
                    if (_this.$parent.cancelUpdateListener) {
                        _this.$parent.cancelUpdateListener();
                    }
                    _uiRouter.$state.go('checkout.review', {}, { reload: true });
                },
                contingencies: {
                    DEFAULT: function DEFAULT() {
                        var _this2 = this;

                        // Replan and reload XO-REVIEW
                        this.models.checkoutSession.invalidate();
                        this.models.checkoutSession.smartDollarAuthFailed = true;
                        if (this.models.checkoutSession.selectedFuturePaymentInstrument) {
                            // Invalidate the saved FI selection to avoid display of stale selection on review page.
                            delete this.models.checkoutSession.selectedFuturePaymentInstrument;
                        }
                        this.models.checkoutSession.retrieve({
                            success: function success() {
                                _this2.models.checkoutSession.smartDollarAuthFailed = false;
                                if (_this2.$parent.cancelUpdateListener) {
                                    _this2.$parent.cancelUpdateListener();
                                }
                                _uiRouter.$state.go('checkout.review', {}, { reload: true });
                            }
                        });
                    }
                }
            });
        }
    }

});

angular.value("$xoDeclineNotificationComponent", $xoDeclineNotificationComponent);
_uiRouter.$state;

_angular.$rootScope;

_angular.noop;

_squid.$Component;

_squid.$renderContent;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_logger.$logger;

_errorMap.mapDeclineAction;

_errorMap.mapDeclineContent;

_errorMap.DECLINE_ACTION;

/***/ }),

/***/ "../node_modules/xo-page-components/src/decline-notification/errorMap.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var DECLINE_ACTION = exports.DECLINE_ACTION = {
    UPDATE: 'UPDATE',
    RETRY: 'RETRY'
};

var mapDeclineContent = exports.mapDeclineContent = function mapDeclineContent(normalizedResponse) {
    switch (normalizedResponse) {
        case 'INSUFFICIENT_FUNDS':
        case 'AMOUNT_EXCEEDED':
            return 'issuerDecline.insufficientFunds';
        case 'EXPIRED_CARD':
        case 'INVALID_ACCOUNT':
        case 'LOST_OR_STOLEN':
        case 'HOLD_CALL_CENTER':
        case 'PICKUP_CARD_SPECIAL_CONDITIONS':
        case 'ACCOUNT_NOT_FOUND':
        case 'INVALID_OR_RESTRICTED_CARD':
            return 'issuerDecline.expiredCard';
        case 'BAD_GAMING':
            return 'issuerDecline.internalDeclineReview';
        default:
            return 'issuerDecline.genericDecline';
    }
};

var mapDeclineAction = exports.mapDeclineAction = function mapDeclineAction(normalizedResponse) {
    switch (normalizedResponse) {
        case 'EXPIRED_CARD':
        case 'INVALID_ACCOUNT':
        case 'LOST_OR_STOLEN':
        case 'HOLD_CALL_CENTER':
        case 'PICKUP_CARD_SPECIAL_CONDITIONS':
        case 'ACCOUNT_NOT_FOUND':
        case 'INVALID_OR_RESTRICTED_CARD':
            return DECLINE_ACTION.UPDATE;
        case 'INSUFFICIENT_FUNDS':
        case 'AMOUNT_EXCEEDED':
        default:
            return DECLINE_ACTION.RETRY;
    }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/decline-notification/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/decline-notification/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"decline-notification-container\">\n    <div class=\"tile\" data-testid=\"declinedFi-notification-container\" ng-if=\"showDeclineNotification\">\n        <div class=\"header\">\n            <div class=\"iconContainer\">\n                <span class=\"infoIcon\" data-testid=\"declinedFi-notification-icon-container\"></span>\n            </div>\n            <div class=\"content\" data-testid=\"declinedFi-notification-content-container\">\n                {{declineContent}}\n            </div>\n            <div class=\"actionDecline\" data-testid=\"declinedFi-notification-action-container\">\n                <a ng-if=\"showActionLink\" class=\"link\" href=\"\" ng-click=declineAction.linkAction() data-testid=\"{{declineAction.testId}}\">\n                    <span class=\"textContent\">{{declineAction.linkContent}}</span>\n                </a>\n            </div>\n        </div>\n        <div class=\"fi\">\n            <div class=\"image\">\n                <xo-fi-icon fi=\"declinedInstrument\" class-name=\"fsIcon\"></xo-fi-icon>\n            </div>\n\n            <div class=\"content\" data-testid=\"declinedFi-content\">\n                <div class=\"description\">\n                    <span class=\"primary\">{{formattedName}}</span>\n                </div>\n                <div class=\"typeDisplay\">\n                    <p class=\"details\" data-testid=\"declinedFi-type\">\n                        &nbsp;{{declinedFiType}}\n                    </p>\n                    <span ng-if=\"lastDigits\" class=\"lastDigits\">\n                        &nbsp;&bull;&bull;&bull;&bull;&nbsp;{{lastDigits}}&nbsp;\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _index3 = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js");

var _index4 = _interopRequireDefault(_index3);

var _template = __webpack_require__("../node_modules/xo-page-components/src/done/template.html");

var _template2 = _interopRequireDefault(_template);

var _sanitizeCaja = __webpack_require__("../node_modules/sanitize-caja/index.js");

var _sanitizeCaja2 = _interopRequireDefault(_sanitizeCaja);

__webpack_require__("../node_modules/xo-login-components/src/dolphin/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTORETURN_TIMEOUT = 5000;
// If the user returns into checkout, it causes errors since the checkout
// session is not what we'd expect it to look like. Rather than proofing our
// code against this, we will attempt to prevent navigation instead.
// Any valid routes should be added here
var WHITELISTED_ROUTES = ['checkout.end'];

(0, _angular.$registerDirective)('xo-done', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            $scope.isGuestSignup = _angular.$rootScope.mode && _angular.$rootScope.mode === 'signup';
            $scope.locale = _squid.$locale;
            $scope.wpsVirtualCardRedirectUrl = _squid.$config.urls.wpsVirtualCardRedirectUrl;

            function addPageMessage(code) {
                var CONTENT_KEY_MAPPING = {
                    NO_UPGRADE: 'accountUpgradeFailed'
                };

                if (code && CONTENT_KEY_MAPPING[code]) {
                    $scope.errorMessage = {
                        msgs: [_squid.$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
                        type: 'warning'
                    };
                }
            }

            function isThirdPartyFlow() {
                return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token);
            }

            function postMerchantSettingsRead() {
                // Set content key based on device
                $scope.autoReturnContentKey = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
                $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';

                // control the virtual card banner for WPS using config
                if (_squid.$config.wpsVirtualCardBanner) {
                    _logger.$logger.info('virtual_card_upsell_enabled');

                    // if merchant not enabled auto return and buyer from US
                    if (!$scope.isAutoReturn && (0, _squid.$feature)('wpsUpsellVirtualCard')) {
                        _logger.$logger.info('virtual_card_eligible');
                        $scope.showVirualCardBanner = true;
                    } else {
                        _logger.$logger.info('virtual_card_upsell_ineligible');
                    }
                } else {
                    _logger.$logger.info('virtual_card_upsell_disabled');
                }

                if (_uiRouter.$stateParams.code) {
                    addPageMessage(_uiRouter.$stateParams.code);
                }
                var amount = $scope.checkoutSession.transactionDetails.amount.total;
                var code = $scope.checkoutSession.transactionDetails.amount.currency;

                $scope.formattedAmount = (0, _squid.formatCurrency)(amount, code);
                var itemList = $scope.checkoutSession.itemsList;

                itemList.forEach(function (item) {
                    item.quantity = (0, _squid.formatQuantity)(item.quantity);
                });
            }

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance($scope.token),
                payee: _index2.$CheckoutPayeeModel.instance($scope.token),
                auth: _auth.$AuthModel.instance($scope.token)
            }).then(function () {

                // populate fpti payload about facebook skip login
                if ($scope.auth.isFBSkipLogin()) {
                    _logger.$logger.info('checkout_fpti', {
                        'design': 'facebook_onetouch'
                    });
                }

                // We need merchant display name (which can be undefined) to display in
                // merchant details section of the page
                $scope.merchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName();
                // We need non empty value for merchantDisplayName in #merchant-text tag
                $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
                    nonEmptyReturnValue: true
                });

                $scope.sanitizedMerchantBrandName = (0, _sanitizeCaja2['default'])($scope.checkoutAppData.merchant.brand_name);
                /** 
                 * Caja Sanitization required to prevent XSS inserted through the return URL. 
                 * For more information, see Jira ticket: https://paypal.atlassian.net/browse/LI-28757
                 * Additional santization is required to prevent XSS attack leveraging bind-html-compile directive.
                 * For more information, see Jira ticket: https://paypal.atlassian.net/browse/LI-46460
                 */
                $scope.sanitizedReturnUrl = (0, _sanitizeCaja2['default'])($scope.checkoutAppData.urls.return_url).replace(/bind-html-compile="(.*?)"/gm, '');

                if (_squid.$config.readMerchantPreferencesFromAppData === true || _squid.$config.readMerchantPreferencesFromAppData === 'true') {
                    $scope.isAutoReturn = $scope.checkoutAppData.merchant_preferences && $scope.checkoutAppData.merchant_preferences.auto_return && $scope.checkoutAppData.merchant_preferences.auto_return.enabled;
                    _logger.$logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
                        return_url: $scope.sanitizedReturnUrl || 'not_available'
                    });
                    postMerchantSettingsRead();
                    return;
                } else {
                    return (0, _squid.$populate)($scope, {
                        merchantPreferenceModel: _profilemanagement.$MerchantPreferenceModel.instance($scope.payee.merchant.id)
                    }).then(function () {
                        // Show auto return page when feature is enabled by merchant and txn
                        $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();
                        _logger.$logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
                            return_url: $scope.sanitizedReturnUrl || 'not_available',
                            autoreturn_url: $scope.merchantPreferenceModel.returnUrl() || 'not_available'
                        });
                        postMerchantSettingsRead();
                    });
                }
            }).then(function () {
                var pxpContext = _index4['default'].getMessengerPXPContext();

                _logger.$logger.info('pxp_xo_wps_fb_messenger_plugin ', pxpContext);

                // Skipping FB messenger experience if Venmo flow detected as this is only for PayPal users
                // Also not loading if merchant auto return is enabled

                if (!$scope.isAutoReturn && !isThirdPartyFlow()) {
                    if (_index4['default'].isDolphinEligibleOnWpsDone(_uiRouter.$state.current && _uiRouter.$state.current.name)) {
                        _logger.$logger.info('ul_dolphin', {
                            'from': 'dolphin_elg_chk',
                            'to': 'process_dolphin_elg_chk',
                            'eligibility_reason': 'wps_done_flow',
                            'context_id': _angular.$rootScope.token
                        });
                        $scope.isDolphinEligibleOnWpsDone = true;
                    } else {
                        var country = _squid.$locale.country;
                        var _$scope$checkoutSessi = $scope.checkoutSession.payer;
                        _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
                        var payerId = _$scope$checkoutSessi.id;


                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_SUCCESS',
                            eligibility_reason: 'messenger'
                        });
                        $scope.pxpMessengerIntegrationEnabled = true;
                    }
                }

                (0, _jquery2['default'])('#outerWrapper').addClass('xo-done');

                $scope.expansion = false;
                $scope.toggle = function () {
                    if ($scope.expansion === false) {
                        $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
                        $scope.expansion = true;
                    } else {
                        $scope.expansion = false;
                    }
                    return $scope.expansion;
                };

                $scope.autoReturnStatementClick = function (event) {
                    event.preventDefault();
                    if (event.target && event.target.nodeName === 'A') {
                        _logger.$logger.info('autoreturn_statement_clicked');
                        $scope.returnToMerchant();
                    }
                };

                if ($scope.isAutoReturn) {
                    _logger.$logger.info('autoreturn_to_merchant');
                    (0, _angular.$timeout)($scope.returnToMerchant, AUTORETURN_TIMEOUT);
                }
            });

            $scope.$on('localeChange', function () {
                if (_uiRouter.$stateParams.code) {
                    addPageMessage(_uiRouter.$stateParams.code);
                }
            });

            $scope.returnToMerchant = function () {
                _logger.$logger.info('return_to_merchant_clicked');
                return _uiRouter.$state.go('checkout.end');
            };

            var onExitListeners = function onExitListeners() {
                var removeClassListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, newState, newParams, oldState) {
                    if (oldState.name === 'checkout.done') {
                        (0, _jquery2['default'])('#outerWrapper').removeClass('xo-done');
                    }
                });
                var preventBackListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState) {
                    if (!~WHITELISTED_ROUTES.indexOf(newState.name)) {
                        _logger.$logger.info('done_page_prevent_routing', {
                            to: newState.name
                        });
                        event.preventDefault();
                        preventBackListener();

                        return _uiRouter.$state.go('checkout.genericError', {
                            code: 'PAYMENT_ALREADY_DONE'
                        });
                    }
                });

                return function () {
                    removeClassListener();
                    preventBackListener();
                };
            };

            $scope.$on('$destroy', onExitListeners());
        }]
    };
});

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_angular.$registerDirective;

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$feature;

_squid.formatCurrency;

_squid.formatQuantity;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_profilemanagement.$MerchantPreferenceModel;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$DoneRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-page-components/src/done/directive.js");

var $DoneRoute = exports.$DoneRoute = _squid.$ComponentRoute.extend('DoneRoute', {
    name: 'done',
    directive: 'xo-done',
    titleContent: 'done.paymentCompleted',
    query: ['code'],
    trackingData: {
        fptiState: 'done_page',
        templateName: 'memberDone.dust',
        pageGoal: 'Payment Done Receipt',
        trackStateExit: true,
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-done',
                'pagename2': '%::fullpage-done:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: []
});

angular.value("$DoneRoute", $DoneRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"xo-done-content\" content>\n    <xo-dolphin ng-if=\"isDolphinEligibleOnWpsDone\"></xo-dolphin>\n    <div ng-click=\"toggle()\" class=\"splash-receipt\" tabindex=\"-1\">\n        <div class=\"receipt basics\">\n            <div class=\"done\" id=\"circle\"></div>\n            <div id=\"paid-text\" bind-html-compile=\"htmlContent(guestSignupKey, {amt: formattedAmount})\"/>\n            <div id=\"merchant-text\">{{ content('done.payment_target', { merchantName: nonEmptyMerchantDisplayName }) }}</div>\n            <a id=\"details-text\" link-button href=\"#\" aria-expanded=\"{{expansion}}\">{{content('paymentMethod.msbDetails')}}</a>\n        </div>\n        <div class=\"details-expand\" ng-class=\"{ expansion : expansion}\" ng-style=\"expansion && {'max-height': maxHeight}\"\n            tabindex=\"-1\" focus-when=\"expansion\">\n            <div class=\"grouping\" ng-repeat=\"item in checkoutSession.itemsList track by $index\">\n                <div class=\"row\">\n                    <span class=\"ltrOverride\" directionality><span ng-if=\"item.quantity\">{{item.quantity}} x </span>{{item.name}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\" amount=\"item.price\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"item.sku\" class=\"item-number-container\">\n                    <span>\n                        <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ item.sku }}</span>\n                    </span>\n                </div>\n                <div ng-if=\"item.item_option_selections\" class=\"item-selections\">\n                    <span class=\"item-selection\" ng-repeat=\"selection in item.item_option_selections track by $index\">\n                        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n                        <span class=\"item-selection-value\">{{ selection.select }}</span>\n                    </span>\n                </div>\n            </div>\n            <div class=\"grouping\">\n                <div ng-if=\"checkoutSession.transactionDetails.amount.subtotal\" class=\"row\">\n                    <span>{{content('header.subTotal')}}</span>\n                     <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.subtotal\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.tax\" class=\"row\">\n                    <span>{{content('header.tax')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.tax\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.shipping\" class=\"row\">\n                    <span>{{content('header.shipping')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.shipping\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.insurance\" class=\"row\">\n                    <span>{{content('header.insurance')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.insurance\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.handling_fee\" class=\"row\">\n                    <span>{{content('header.handling')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.handling_fee\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.discount\" class=\"row\">\n                    <span>{{content('header.discount')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.discount\">\n                        </format-currency>\n                    </span>\n                </div>\n            </div>\n            <div class=\"row totalAmount\">\n                <b>\n                    <span>{{content('base.totalLabel')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.total\">\n                        </format-currency>\n                    </span>\n                </b>\n            </div>\n        </div>\n        <div id=\"details-button\">\n            <span ng-hide=\"!expansion\" class=\"arrow collapse\"></span>\n            <span ng-hide=\"expansion\" class=\"arrow expand\"></span>\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"checkoutSession.transactionDetails.reason_code === 'REGULATORY_REVIEW'\">\n        <div class=\"alert\" role=\"alert\">\n            {{content('done.temporarily_pending')}}\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"!isAutoReturn\">\n        <xo-message message=\"errorMessage\"></xo-message>\n\n        <div id=\"messenger-ba-integration\" ng-if=\"pxpMessengerIntegrationEnabled\">\n          <div id=\"messenger-ba-integration-content\" style=\"display:none\">\n            <div class=\"text\">{{ content('messenger.integration') }}</div>\n          </div>\n          <div id=\"ba-integration-content\" style=\"display:none\">\n            <div class=\"receipt title\">{{ content('messenger.linkedTitle') }}</div>\n            <div class=\"text\">{{ content('messenger.linkedSubtitle') }}</div>\n          </div>\n          <div id=\"stm-upsell-content\" class=\"text\">{{ content('messenger.upsell') }}</div>\n          <xo-messenger-plugin plugin-type=\"STM\" token=\"token\"></xo-messenger-plugin>\n        </div>\n\n        <h2 ng-if=\"checkoutSession.plan.sources.length > 0\" class=\"receipt title\">{{content('done.paidWith')}}</h2>\n        <div ng-repeat=\"item in checkoutSession.plan.sources track by $index\">\n            <div class=\"row clearfix\">\n                <span class=\"money-source\" ng-if=\"!ppBalanceRebrandedExperiment || !ppBalanceRebrandedExperiment.enabled || item.type !== 'BALANCE'\">{{content('fsMappings.'+item.type) || item.name}} <span ng-if=\"item.last4\">x-</span>{{item.last4}}</span>\n                <span class=\"money-source\" ng-if=\"ppBalanceRebrandedExperiment && ppBalanceRebrandedExperiment.enabled && item.type === 'BALANCE'\">{{content('paymentMethod.paypalBalanceRebranded')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"item.amount.currency_code\"\n                                         amount=\"item.amount.amount\">\n                        </format-currency>\n                </span>\n            </div>\n        </div>\n        <div ng-if=\"checkoutSession.transactionDetails.soft_descriptor\" class=\"secondary receipt statement\">{{content('done.transactionInformation', {merchantName: checkoutSession.transactionDetails.soft_descriptor})}}\n        </div>\n        <h2 ng-if=\"checkoutSession.shipping\" class=\"receipt title\">{{content('done.shippedTo')}}</h2>\n        <div class=\"text\" ng-if=\"!checkoutCart.isShippingMethodStorePickUp()\">\n            <div ng-if=\"checkoutSession.shipping.name\">{{checkoutSession.shipping.name}}</div>\n            <ul class=\"multilineAddressList\">\n                <li ng-repeat=\"item in checkoutSession.shipping.full_address_multiline track by $index\" directionality-text=\"item\">{{item}}</li>\n            </ul>\n            <div><span>{{content('countryList.'+checkoutSession.shipping.country)}}</span></div>\n        </div>\n        <div class=\"text\" ng-if=\"checkoutCart.isShippingMethodStorePickUp()\">\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <h2 class=\"receipt title\">{{content('done.purchaseDetails')}}</h2>\n        <div id=\"receiptNumber\"> {{content('done.receiptNumber')}} {{checkoutSession.transactionDetails.receipt_id}}</div>\n        <div class=\"text\">\n            <div>{{content('done.confirmation')}}</div>\n            <div id=\"buyerEmail\">{{checkoutSession.payer.email}}</div>\n        </div>\n\n        <div ng-if=\"merchantDisplayName || checkoutAppData.merchant.phone\">\n            <h2 text-align=\"left\" class=\"receipt title\">{{content('done.merchantDetails')}}</h2>\n            <div class=\"text\" id=\"merchantInfoSection\">\n                <div ng-if=\"merchantDisplayName\"><span directionality-text=\"merchantDisplayName\">{{ merchantDisplayName }}</span></div>\n                <div ng-if=\"checkoutAppData.merchant.phone\">{{checkoutAppData.merchant.phone}}</div>\n            </div>\n        </div>\n\n        <div ng-if=\"checkoutAppData.urls.return_url\" id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{content('common.returnToDefaultMerchant')}}\" id=\"merchantReturnBtn\"\n                   class=\"btn btn-secondary full submit receipt ng-binding ng-scope\" ng-click=\"returnToMerchant()\" />\n        </div>\n    </div>\n    <div class=\"essentials autoReturnSection\" ng-if=\"isAutoReturn\">\n        <div>{{content('done.paymentCompleted')}}</div>\n        <div ng-click=\"autoReturnStatementClick($event)\" data-test-id=\"autoreturn-link\" bind-html-compile=\"htmlContent(autoReturnContentKey, {merchantName: sanitizedMerchantBrandName, autoReturnUrl: sanitizedReturnUrl})\"/>\n    </div>\n\n    <div class=\"blockContainer\" ng-if=\"showVirualCardBanner\">\n        <div class=\"keyImage\"></div>\n        <div class=\"textContainer\">\n            <p class=\"headingText\">{{content('done.virtualCardBanner')}}</p>\n            <a href=\"{{wpsVirtualCardRedirectUrl}}\" class=\"btn payButtonKey\" target=\"_blank\">{{content('done.virtualCardLabel')}}</a>\n        </div>\n    <div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/cycoExitFactory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var POPUP_WIDTH = 560;
var POPUP_HEIGHT = 550;

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$cycoExitFactory', function () {
    // exported factory functions go in this object
    var factory = {};

    // state variables
    var onCycoPage = false;
    var shouldShowPopup = false;
    var cycoInitTime = Date.now();

    // This function should be called when we enter the cyco page.
    // It will make an elmo call, and set the `shouldShowPopup` variable based on
    // whether or not you are in the control or treatment experience. It will also
    // set the `onCycoPage` to true.
    factory.cycoEnter = function (merchantCountry) {
        onCycoPage = true;
        cycoInitTime = Date.now();
        return (0, _squid.$elmo)('xo_hermes_cyco_cancel_feedback', { 'ctx.COUNTRY': merchantCountry }, 'Trmt_xo_hermes_cyco_cancel_feedback_.*', false, true).then(function (res) {
            var treatmentName = res && res.treatment_name;

            _logger.$logger.info('checkout_fpti', {
                'xo_hermes_cyco_cancel_feedback': treatmentName ? treatmentName : 'Ctrl_xo_hermes_cyco_cancel_feedback'
            });
            shouldShowPopup = treatmentName ? true : false;
        })['catch'](_angular.noop);
    };

    // This function should be called when we exit the cyco page.
    // It will reset the `onCycoPage` and `shouldShowPopup` variables to false.
    factory.cycoExit = function () {
        onCycoPage = false;
        shouldShowPopup = false;
    };

    // We call this function in the footer, and on certain links on the
    // xo-credit-component CYCO page
    factory.showExitSurvey = function () {
        var exitSurveyShown = false;

        try {
            // we only show the opinionlab exit survey if we are on the cyco page, 
            // and in the correct treatment
            if (onCycoPage && shouldShowPopup) {
                var _sW = window.screen.width;
                var _sH = window.screen.height;
                var countryCode = ('' + _squid.$locale.country).toLowerCase();
                var languageCode = ('' + _squid.$locale.lang).toLowerCase();
                var userGuid = _squid.$util.getProperty(window.meta, 'userGuid') || 'Unknown';
                var customVars = {
                    guid: userGuid,
                    tealeafId: userGuid,
                    fptiPageGroup: 'main:ec:hermes::choose_credit_offer:member:hermes:',
                    fptiPagename: 'main:ec:hermes::choose_credit_offer:member:hermes:',
                    rlogId: _squid.$util.getProperty(window.meta, 'rlogId') || 'Unknown',
                    calc: _squid.$util.getProperty(window.meta, 'correlationId') || 'Unknown',
                    merchantId: _squid.$util.getProperty(window.meta, 'checkoutCTX.merchant_id') || 'Unknown',
                    token: _squid.$util.getProperty(window.meta, 'token') || 'Unknown',
                    countryCode: countryCode,
                    languageCode: languageCode
                };
                var showCycoOpinionUrl = _squid.$util.buildURL('https://secure.opinionlab.com/ccc01/comment_card.asp', {
                    width: _sW,
                    height: _sH,
                    referer: 'https://surveys.paypal.com/' + countryCode + '/' + languageCode + '/CycoPageExit',
                    prev: document.referrer,
                    time1: cycoInitTime,
                    time2: Date.now(),
                    currentURL: document.location.href,
                    type: 'Popup',
                    custom_var: userGuid,
                    customVars: JSON.stringify(customVars)
                });

                _logger.$logger.info('checkout_fpti', {
                    from: 'elmo_showCycoOpinionUrl',
                    to: showCycoOpinionUrl
                });
                window.open(showCycoOpinionUrl, 'comments', 'width=' + POPUP_WIDTH + ',height=' + POPUP_HEIGHT + ',screenX=' + (_sW - POPUP_WIDTH) / 2 + ',screenY=' + (_sH - POPUP_HEIGHT) / 2 + ',top=' + (_sH - POPUP_HEIGHT) / 2 + ',left=' + (_sW - POPUP_WIDTH) / 2 + ',resizable=yes,copyhistory=yes,scrollbars=no');
                exitSurveyShown = true;
            }
        } catch (err) {
            _logger.$logger.error('choose-credit-offer: showCycoOpinion error', { error: err });
        }
        return exitSurveyShown;
    };

    return factory;
});

_logger.$logger;

_squid.$locale;

_squid.$util;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/footer", "../node_modules/xo-page-components/src/footer/cycoExitFactory.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index5 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _footerMap = __webpack_require__("../node_modules/xo-page-components/src/footer/footerMap.js");

var _footerMap2 = _interopRequireDefault(_footerMap);

var _opinionlab = __webpack_require__("../node_modules/xo-page-components/src/footer/opinionlab.js");

var _opinionlab2 = _interopRequireDefault(_opinionlab);

var _template = __webpack_require__("../node_modules/xo-page-components/src/footer/template.html");

var _template2 = _interopRequireDefault(_template);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _cycoExitFactory = __webpack_require__("../node_modules/xo-page-components/src/footer/cycoExitFactory.js");

var _factory = __webpack_require__("../node_modules/xo-page-components/src/footer/factory.js");

__webpack_require__("../node_modules/xo-page-components/src/footer/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFooter', function () {
    return {
        template: _template2['default'],
        restrict: 'EA',
        scope: {
            token: '=?',
            escapeHatchIncontext: '=?',
            cancel: '@?',
            merchant: '@?',
            languageSwitch: '=?',
            showVenmoLegalLinks: '=?',
            policyInformationContentKey: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.isIFrame = _squid.$util.isIFrame();
            if ($scope.escapeHatchIncontext) {
                $scope.showEscapeHatch = $scope.isIFrame;
            }
            $scope.locale = _squid.$locale;
            $scope.proxSignUpFlow = _index4.$CheckoutInputDataModel.instance($scope.token).isEbayTxn();
            $scope.year = new Date().getFullYear();

            // Determine if country belongs to a region to serve correct footer links
            var getRegion = function getRegion(country) {
                var regions = _squid.$config.regions;

                for (var region in regions) {
                    if (regions[region].indexOf(country) > -1) {
                        return region;
                    }
                }
                return false;
            };

            function isDESecondButtonFlow() {
                return $scope.locale.country === 'DE' && $scope.checkoutAppData && $scope.checkoutAppData.is_second_button_txn;
            }

            $scope.getPolicyInformationContentKey = function () {
                return $scope.policyInformationContentKey;
            };

            $scope.footerLinks = function () {
                if (_factory.$footerFactory.isApac()) {
                    return _footerMap2['default'].APAC;
                }

                // It is a product requirement that for the DE CYCO page, Hermes only show the footer links
                // that were available in Aries
                if (isDESecondButtonFlow()) {
                    return _footerMap2['default']['DESecondButton'];
                }

                return _footerMap2['default'][$scope.locale.country] || _footerMap2['default'][getRegion($scope.locale.country)] || _footerMap2['default'].DEFAULT;
            };

            $scope.showPolicyInfo = function () {
                return _factory.$footerFactory.isApac() || _factory.$footerFactory.is3PL() || $scope.locale.country === 'AU';
            };

            $scope.cancelRedirect = function ($event) {
                $event.preventDefault();

                // if a user is on the CYCO page, we show an opinionlab exit survey based on
                // whether or not they are in the xo_hermes_cyco_cancel_feedback elmo treatment.
                var surveyShown = _cycoExitFactory.$cycoExitFactory.showExitSurvey();

                _logger.$logger.info('cyco_exit_surveyShown_' + Boolean(surveyShown));

                var cancelUri = $scope.cancel;
                var redirectUri = _squid.$util.param('redirect_uri');

                if (window.xprops && window.xprops.onCancel && !cancelUri) {
                    return window.xprops.onCancel({
                        orderID: $scope.token
                    });
                }

                // "redirect_uri" as a query param overrides the cancel url in the checkout session
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && redirectUri) {

                    cancelUri = _squid.$util.buildURL(redirectUri, {
                        opType: 'cancel',
                        return_uri: $scope.cancel,
                        token: $scope.token
                    });
                }

                _index5.$ReturnToMerchant.goTo(cancelUri);
            };

            if ($scope.token) {
                (0, _squid.$populate)($scope, {
                    checkoutAppData: _index3.$CheckoutAppDataModel.instance($scope.token),
                    checkoutPayee: _index3.$CheckoutPayeeModel.instance($scope.token),
                    checkoutCart: _index3.$CheckoutCartModel.instance($scope.token),
                    auth: _index2.$AuthModel.instance()
                }).then(function () {
                    return _factory.$footerFactory.decidePolicyInformationContentKey($scope.auth);
                }).then(function (policyInformationContentKey) {
                    $scope.policyInformationContentKey = policyInformationContentKey;
                    var payee = $scope.checkoutPayee;

                    if (payee && payee.merchant && payee.merchant.id) {
                        var hcl = _squid.$config.hideCancelLinkForMerchant;

                        var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;

                        if (shouldHide) {
                            $scope.hideCancel = true;
                        }
                    }
                    $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
                    var billingData = $scope.checkoutCart.billing || {};

                    if (billingData.intent === 'VAULT') {
                        var originalCancelUrl = $scope.checkoutAppData.urls.original_urls.cancel_url;
                        var vaultCancelParams = {
                            approval_token_id: billingData.vault_approval_token_id,
                            approval_session_id: billingData.vault_approval_session_id
                        };

                        $scope.cancel = originalCancelUrl ? _squid.$util.buildURL(originalCancelUrl, vaultCancelParams) : originalCancelUrl;
                    }
                    $scope.merchant = $scope.checkoutAppData.getMerchantDisplayName();
                });
            }

            var cancelShowModal = _angular.$rootScope.$on('showModal', function (event, ctx) {
                var url = ctx && ctx.popupUrl;

                _logger.$logger.info('show_popup_modal', { url: url, ua: _angular.$window.navigator.userAgent });
                $scope.popupUrl = _angular.$sce.trustAsResourceUrl(url);
                $scope.show = true;
                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
            });

            // for webkit webview (wkwebview) on ios devices, we need to open footer
            // policies/terms links in a modal window as wkwebview blocks anchor tags
            // with target _blank from loading
            $scope.openLinkInModalIfWebview = function (event) {
                // if webview then open the link in a modal window
                if (_index.$DeviceInfo.isWebView()) {
                    event.preventDefault();
                    var url = event.target.href;

                    _logger.$logger.info('show_popup_modal_footer_links', { url: url });
                    $scope.popupUrl = _angular.$sce.trustAsResourceUrl(url);
                    // As this code is only for webviews, we are going fullscreen
                    // with css class - fullsize-modal
                    $scope.fullsizeModal = true;
                    $scope.show = true;
                }
            };

            $scope.hideModal = function () {
                _logger.$logger.info('hide_popup_modal');
                $scope.show = false;
                $scope.fullsizeModal = false;
            };

            $scope.$on('localeChange', function () {
                _factory.$footerFactory.decidePolicyInformationContentKey($scope.auth).then(function (policyInformationContentKey) {
                    $scope.policyInformationContentKey = policyInformationContentKey;
                });
            });
            $scope.$on('$destroy', cancelShowModal);

            $scope.showOL = function showOL(event) {
                event.preventDefault();

                var placeholder = 'main:ec:hermes';
                var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
                var data = {
                    opVars: {
                        rlogId: _angular.$window.meta.rlogId || '',
                        page: page || window.location.hash,
                        csci: 'Unknown',
                        calc: _angular.$window.meta.correlationId,
                        custId: 'Unknown',
                        merchantId: 'Unknown',
                        token: $scope.token || 'Unknown'
                    },
                    locale: {
                        country: _squid.$locale.country,
                        languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
                    }
                };

                (0, _opinionlab2['default'])(data);
            };

            $scope.hideReturnCancelUrl = function () {
                if (window.xprops && window.xprops.onCancel) {
                    return false;
                }

                if (!$scope.cancel) {
                    return true;
                }

                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.done') {
                    return true;
                }

                return false;
            };

            $scope.showVenmoLinks = function () {
                // if on payWithSelection State, always show it, else we choose whatever 'checkout' directive says.
                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
                    return true;
                }
                return !!$scope.showVenmoLegalLinks;
            };

            $scope.showPaypalLinks = function () {
                // will force Paypal Links if on payWithSelection state. Hide paypal links if we explicitly request venmo Links
                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
                    return true;
                }
                return !$scope.showVenmoLegalLinks;
            };
        }]
    };
});

_uiRouter.$state;

_angular.$window;

_angular.$rootScope;

_angular.$sce;

_squid.$config;

_squid.$util;

_squid.$locale;

_squid.$populate;

_squid.$integration;

_index.$DeviceInfo;

_index2.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutCartModel;

_index4.$CheckoutInputDataModel;

_index5.$ReturnToMerchant;

_logger.$logger;

_cycoExitFactory.$cycoExitFactory;

_factory.$footerFactory;

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$footerFactory', function () {
    function isIndiaLegalEntity(auth) {
        // for PayPal India domestic launch legal entity should be 84
        // update footer with indian policy for this case
        return auth && auth.logged_in && auth.legalEntity === 84 || _squid.$locale.country === 'IN';
    }

    function is3PL() {
        return _squid.$config.threePLCountries && _squid.$config.threePLCountries.indexOf(_squid.$locale.country.toUpperCase()) > -1;
    }

    function isApac() {
        return _squid.$config.apacCountries && _squid.$config.apacCountries.indexOf(_squid.$locale.country) > -1;
    };

    function decidePolicyInformationContentKey(auth) {
        return (0, _squid.$elmo)('xo_legacy_3pl_issued_license_update', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_legacy_3pl_issued_license_update_1').then(function (result) {
            var enabled = Boolean(result && result.treatment_name);

            if (enabled) {
                return 'footer.issued3plLicensePH';
            }

            if (isIndiaLegalEntity(auth)) {
                return 'footer.4plpolicyInformation';
            }

            if (is3PL()) {
                // Ramped to 100% since July 2023. Previous key footer.3plPolicyInformation is now replaced
                // Elmos have been removed and now we will always see the new key:
                // Key footer.issued3plLicense states that the legal license is already issued and live.
                return 'footer.issued3plLicense';
            }

            return 'footer.policyInformation';
        });
    }

    return {
        decidePolicyInformationContentKey: decidePolicyInformationContentKey,
        is3PL: is3PL,
        isApac: isApac
    };
});

_squid.$config;

_squid.$locale;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/footer", "../node_modules/xo-page-components/src/footer/factory.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/footerMap.js":
/***/ (function(module, exports, __webpack_require__) {



!(module.exports = {
    CA: [{
        id: 'policy',
        content: 'footer.policiesCA'
    }, {
        id: 'terms',
        content: 'footer.termsCA'
    }, {
        id: 'privacy',
        content: 'footer.privacyCA'
    }],

    BE: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DE: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'legal',
        content: 'footer.DELegal'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }, {
        id: 'paymentdesc',
        content: 'footer.DEKeyPaymentDesc'
    }],

    ES: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    FR: [{
        id: 'legal',
        content: 'footer.FRLegal'
    }, {
        id: 'useragreement',
        content: 'footer.FRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.FRPrivacy'
    }],

    IT: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    NL: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    IE: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    APAC: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EMEA: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EM: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    LATAM: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    AU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    AT: [{
        id: 'imprint',
        content: 'footer.ATImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    CH: [{
        id: 'imprint',
        content: 'footer.CHImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    DK: [{
        id: 'useragreement',
        content: 'footer.DKUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    SE: [{
        id: 'useragreement',
        content: 'footer.SEUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    PL: [{
        id: 'useragreement',
        content: 'footer.PLUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    NO: [{
        id: 'useragreement',
        content: 'footer.NOUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    TR: [{
        id: 'useragreement',
        content: 'footer.TRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    BR: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    MX: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    RU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DESecondButton: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }],

    DEFAULT: [{
        id: 'policy',
        content: 'footer.policies',
        venmoContent: 'footer.venmo_policies'
    }, {
        id: 'terms',
        content: 'footer.terms',
        venmoContent: 'footer.venmo_terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy',
        venmoContent: 'footer.venmo_privacy'
    }]
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/opinionlab.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var _doc = document;
    var _w = window;
    var _tm = new Date().getTime();
    var _sH = screen.height;
    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
    var _sW = screen.width;

    function popUp(opinionlabURL) {
        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
    }

    function updateCustomVars(data) {

        var opVars = data.opVars;
        var locale = data.locale;

        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';

        return customVar;
    }

    function _fC(_u) {
        var _sp = '%3A\\/\\/';
        var _rp = '%3A//';
        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
        var _aA = _aT.split(',');

        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
        }
        return _u;
    }

    return function (locale) {

        var custom_var = updateCustomVars(locale);

        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;

        popUp(opinionlabURL);
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/template.html":
/***/ (function(module, exports) {

module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" ng-class=\"{APAC: isApac()}\">\n        <p ng-if=\"!hideCancel\" id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a track-link=\"cancel_and_return_to_merchant\" href=\"{{cancel || '#'}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n               <span ng-bind-html=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\" ng-if=\"showPaypalLinks()\">\n                <li ng-click=\"openLinkInModalIfWebview($event)\" ng-repeat=\"link in footerLinks() track by $index\" id =\"footer_{{link.id}}\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n            </ul>\n            <ul class=\"footerLinks\" ng-if=\"showVenmoLinks()\">\n                <li ng-click=\"openLinkInModalIfWebview($event)\" ng-repeat=\"link in footerLinks() track by $index\" id =\"venmoFooter_{{link.id}}\" bind-html-compile=\"htmlContent(link.venmoContent, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options direction=\"top\" ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-bind-html=\"htmlContent(getPolicyInformationContentKey(), {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal\n        ng-attr-id=\"{{(fullsizeModal ? 'fullsize' : 'responsive') + '-modal'}}\"\n        ng-if=\"show\" show=\"show\" enable-mobile-interstitial=\"true\"\n        show-close-button=\"true\" on-close=\"hideModal\" override-default-container=\"fullsizeModal\">\n        <div class=\"popupModalContainer\">\n            <iframe src=\"{{popupUrl}}\" class=\"popupModal\" frameborder=\"0\"></iframe>\n        </div>\n    </xo-modal>\n</footer>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$gdprCookieBannerComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * General Data Protection Regulation (GDPR) defines standards on how personal data is collected, processed, transferred and disposed.
 * Affected Countries: All "GDPR" countries: Please check config.json for country list.
 * Wiki: https://github.paypal.com/Checkout-R/xoonboardingnodeweb/wiki/GDPR:-Feature,-Integration-documentation
 */
var $gdprCookieBannerComponent = exports.$gdprCookieBannerComponent = _squid.$Component.extend('$gdprCookieBanner', {
    tag: 'xo-gdpr-cookie-banner',
    template: _template2['default'],
    actions: {
        // Fetch the GDPR banner, append to DOM if available
        refreshGDPR: function refreshGDPR() {
            var _this = this;

            var gdprModel = _gdprCookieBanner.$GDPRCookieBannerModel.instance();

            return gdprModel.getBanner().then(function () {
                var banner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                // Run cleanup once we know the result, to prevent screen flash
                _this.actions.cleanup();

                var html = banner.html,
                    css = banner.css,
                    js = banner.js;


                if (!html || !css || !js) {
                    return;
                }

                var div = angular.element(html);
                var style = angular.element(css);
                var script = angular.element(js);

                // setting nonce value from client app if provided,
                if (_squid.$meta && _squid.$meta.nonce) {
                    script.attr('nonce', _squid.$meta.nonce);
                }

                var el = _this.$element.find('#gdpr-cookie-banner-outerwrap');

                el.append(style);
                el.append(div);
                el.append(script);

                if (!(0, _angular.isFunction)(window.bindGdprEvents)) {
                    _logger.$logger.error('gdpr_banner_bindGdprEvents_not_defined');
                    return;
                }

                // TODO: Remove this class add when cookie banner script is fixed to add this class properly
                angular.element(document.body).addClass('gdprCookieBanner-acceptedAll');

                window.bindGdprEvents();
            });
        },

        // Clear out the banner container to remove the old elements
        cleanup: function cleanup() {
            var el = this.$element.find('#gdpr-cookie-banner-outerwrap');

            el.empty();
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            this.actions.refreshGDPR();

            // On "localeChange" we are re-fetching data.
            this.$on('localeChange', function () {
                _this2.actions.refreshGDPR();
            });
        }
    }
});

angular.value("$gdprCookieBannerComponent", $gdprCookieBannerComponent);
_squid.$Component;

_squid.$meta;

_angular.isFunction;

_gdprCookieBanner.$GDPRCookieBannerModel;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"gdpr-cookie-banner-outerwrap\"></div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SetHeaderText = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/header/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/header/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var headerText = '';

var $SetHeaderText = exports.$SetHeaderText = {
    setText: function setText(text) {
        headerText = text;
        _angular.$rootScope.$emit('update_header_text', text);
    },
    getText: function getText() {
        return headerText;
    },
    subscribe: function subscribe($scope, callback) {
        var handler = _angular.$rootScope.$on('update_header_text', callback);

        $scope.$on('$destroy', handler);
    }
};

angular.module().directive('xoHeader', function () {
    return {
        template: _template2['default'],
        scope: {
            showCartTotal: '=?',
            renderCartContainer: '=?',
            token: '=?',
            isUnbranded: '=?',
            unbrandedTitle: '=?',
            unbrandedSubTitle: '=?',
            languageSwitch: '=?',
            redirectiframe: '=?',
            redirectLightbox: '=?',
            isVenmoFlow: '=?'
        },
        controller: ['$scope', function ($scope) {
            var _ref = window.xprops || {},
                _ref$experience = _ref.experience,
                experience = _ref$experience === undefined ? { facebook: false } : _ref$experience;

            // Callback-integrated merchants should have a breakdown available in their flow


            $scope.enableCartBreakdown = Boolean(window.xprops && window.xprops.onShippingChange);

            $scope.isFacebookBAIntegration = experience.facebook;
            $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
            $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
            $scope.subTitle = (0, _squid.$renderContent)($scope.unbrandedSubTitle);
            $SetHeaderText.subscribe($scope, function (event, text) {
                $scope.unbrandedTitle = text;
                $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
            });
        }]
    };
});

angular.value("$SetHeaderText", $SetHeaderText);
_angular.$rootScope;

_squid.$integration;

_squid.$renderContent;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch && languageSwitch.show }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n        <div id=\"mobileMerchantHeader\">\n            <xo-merchant-header token=\"token\" disable-id=\"true\"></xo-merchant-header>\n        </div>\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\">{{title}}</span>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && !isVenmoFlow\" id=\"paypalLogo\" class=\"logo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && isVenmoFlow\" class=\"venmoLogo\"><span class=\"accessAid\">Venmo Checkout</span></div>\n        <div ng-if=\"isFacebookBAIntegration\" class=\"ng-scope facebookPayPalHeader\">\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/paypal_monogram_logo.png\" class=\"facebookPayPalHeader-logo\" alt=\"PayPal\">\n            <span class=\"facebookPayPalHeader-separator\"></span>\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/facebook_logo.svg\" class=\"facebookPayPalHeader-logo\" alt=\"Facebook\">\n        </div>\n        <div ng-if=\"!isFacebookBAIntegration && isMessengerBAIntegration\">\n            <div ng-if=\"isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_mobile_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n            <div ng-if=\"!isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n        </div>\n\n        <xo-cart\n            token=\"token\"\n            override-show-details=\"enableCartBreakdown\"\n            show-cart-total=\"showCartTotal\"\n            render-cart-container=\"renderCartContainer\"\n        ></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/installmentplan-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _installmentPlanTerms = __webpack_require__("../node_modules/xo-page-components/src/installmentplan-terms/installmentPlanTerms.js");

var _installmentPlanTerms2 = _interopRequireDefault(_installmentPlanTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getItemName: _installmentPlanTerms2['default'].getItemName,
    getInstallmentPlanData: _installmentPlanTerms2['default'].getInstallmentPlanData
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/installmentplan-terms/installmentPlanTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _require = __webpack_require__("../node_modules/lodash/lodash.js"),
    get = _require.get;

var BILL_PERIOD_DAY = 'DAY';
var BILL_PERIOD_WEEK = 'WEEK';
var BILL_PERIOD_MONTH = 'MONTH';
var REGULAR_INSTALLMENTPLAN = 'REGULAR';

/**
 * Plural time unit
 *  True: time unit will be one of: days, weeks, months, years
 *  False: time unit will be one of: day, week, month, year
 * @type {boolean}
 */
var pluralTimeUnit = false;

/**
 * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
 *  e.g. Then 2$ for next 4 months
 *  otherwise statement will be
 *  2$ for next 4 months
 * @type {boolean}
 */
var hasPriorTerm = false;

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
    return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @returns {string}
 */
function computeTimeUnit(billPeriod) {
    var timeUnit = void 0;

    switch (billPeriod) {
        case BILL_PERIOD_DAY:
            timeUnit = pluralTimeUnit ? 'days' : 'day';
            break;
        case BILL_PERIOD_WEEK:
            timeUnit = pluralTimeUnit ? 'weeks' : 'week';
            break;
        case BILL_PERIOD_MONTH:
            timeUnit = pluralTimeUnit ? 'months' : 'month';
            break;
        default:
            timeUnit = '';
    }

    return localizedContent('wpsInstallmentPlan.label.' + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amount, currencyCode) {
    return (0, _squid.formatCurrency)(amount, currencyCode, false);
}

/**
 * Computes and returns content key for regular installmentPlan
 * There can be 5 variations of regular installmentPlan content
 * @param totalCycles
 * @returns {string}  Content Key for 2nd trial, which must be prepended by wpsInstallmentPlan.message
 */
function computeRegularInstallmentPlanKey(totalCycles, isTerms) {

    var key = 'regularInstallmentPlanPeriod';

    if (hasPriorTerm) {
        // Content starts with Then {amount} for ......
        key += '.withPriorTerms';
    } else {
        // Content does NOT starts with Then
        key += '.noPriorTerms';
    }

    if (pluralTimeUnit) {
        // Content has: {amount} for each 2 days/weeks/months/years
        key += '.plural';
    } else {
        // Content has: {amount} for each day/week/month/year
        key += '.singular';
    }

    switch (+totalCycles) {
        case 0:
        case 1:
            // Text will look like $20.00 USD for the next 2 months
            // Content does NOT end with: for 3 installments
            key += isTerms ? '.nonRecurring' : '.nonRecurringAmount';
            break;
        case Infinity:
            // Content ends with: for each 2 months OR for each month
            // Content will look like $30.00 USD for each week
            key += isTerms ? '.recurringInfinite' : '.recurringInfiniteAmount';
            break;
        default:
            // Content ends with: for 3 installments
            // Content will look like $100.00 USD for each 2 months, for 3 installments
            key += isTerms ? '.recurring' : '.recurringAmount';
    }
    return key;
}

/**
 * Prepares and returns an individual term text string
 * @param installmentPlanTerms
 * @param index
 * @param currencyCode
 * @returns {string}
 */
function prepareIndividualTermAmountText(installmentPlanTerms, index, currencyCode, isTerms) {

    var amount = +installmentPlanTerms[index].amount,
        billPeriod = installmentPlanTerms[index].billPeriod,
        periodType = installmentPlanTerms[index].periodType,
        billFrequency = +installmentPlanTerms[index].billFrequency,
        totalCycles = +installmentPlanTerms[index].totalCycles;
    var contentKey = void 0;

    hasPriorTerm = index > 0;
    pluralTimeUnit = billFrequency > 1;

    if (periodType === REGULAR_INSTALLMENTPLAN) {
        contentKey = computeRegularInstallmentPlanKey(totalCycles, isTerms);
    }
    contentKey = 'wpsInstallmentPlan.message.' + contentKey;
    var templatePlaceholderData = {
        amount: computeAmount(amount, currencyCode),
        timePeriod: billFrequency,
        timeUnit: computeTimeUnit(billPeriod),
        installmentCount: totalCycles

    };

    return localizedContent(contentKey, templatePlaceholderData);
}

function getItemName(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var _baResponseData$items = baResponseData.items;
    _baResponseData$items = _baResponseData$items === undefined ? [] : _baResponseData$items;
    var _baResponseData$items2 = _baResponseData$items[0];
    _baResponseData$items2 = _baResponseData$items2 === undefined ? {} : _baResponseData$items2;
    var name = _baResponseData$items2.name;


    return name;
}

function getInstallmentPlanData(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var installmentPlanDetails = {};
    var plan = baResponseData && baResponseData.plan;
    var allTerms = plan && plan.payment_definitions;
    var effectiveDate = baResponseData && baResponseData.effective_date;
    var supplementaryData = get(baResponseData.plan.metadata, 'supplementary_data');
    var displayTotal = supplementaryData.find(function (item) {
        return item.name === 'display_total';
    });
    var currencyCode = plan && plan.currency_code;
    var firstAmount = allTerms[0].amount;
    var totalAmount = allTerms.reduce(function (accumulator, currentVal) {
        return accumulator + currentVal.amount * currentVal.totalCycles;
    }, 0);
    var formattedTotalAmount = (0, _squid.formatCurrency)(totalAmount, currencyCode, false);
    var formattedFirstAmount = (0, _squid.formatCurrency)(firstAmount, currencyCode, false);
    var termsText = [];

    for (var i = 0; i < allTerms.length; i++) {
        termsText.push(prepareIndividualTermAmountText(allTerms, i, currencyCode, true)); // Passing 'true' flag for Terms
    }
    var amountText = [];

    for (var _i = 0; _i < allTerms.length; _i++) {
        amountText.push(prepareIndividualTermAmountText(allTerms, _i, currencyCode, false)); // Passing 'false' flag for Amount
    }

    installmentPlanDetails.displayTotal = displayTotal.value === 'true';
    installmentPlanDetails.effectiveDate = effectiveDate;
    installmentPlanDetails.currencyCode = currencyCode;
    installmentPlanDetails.formattedTotalAmount = formattedTotalAmount;
    installmentPlanDetails.formattedFirstAmount = formattedFirstAmount;
    installmentPlanDetails.termsText = termsText;
    installmentPlanDetails.amountText = amountText;
    return installmentPlanDetails;
}

module.exports = {
    getItemName: getItemName,
    getInstallmentPlanData: getInstallmentPlanData
};

_squid.formatCurrency;

_squid.Content;

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/marketingOffers/template.html");

var _template2 = _interopRequireDefault(_template);

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoMarketingOffers', function () {
    return {
        template: _template2['default'],
        scope: {
            placementCode: '=?',
            titleTxtProperty: '=?',
            subtitleProperty: '=?',
            token: '=?',
            pageName: '=?',
            backgroundImage: '=?',
            xoTitleTag: '@?',
            xoTitleClass: '@?'
        },
        controller: ['$scope', '$element', '$sce', function ($scope, $element, $sce) {
            var morsOfferFlag = $scope.placementCode === '202003' && (0, _squid.$feature)('morsValuePropOffers');
            var populateObj = void 0;

            if (morsOfferFlag) {
                populateObj = {
                    checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                    checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                    payee: _index.$CheckoutPayeeModel.instance($scope.token),
                    auth: _auth.$AuthModel.instance()
                };
            } else {
                populateObj = {
                    checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
                };
            }
            (0, _squid.$populate)($scope, populateObj).then(function () {
                $scope.locale = _squid.$locale;
                $scope.token = _angular.$rootScope.token;
                function setDefaultValues() {
                    $scope.ad = {
                        Title: (0, _squid.$renderContent)($scope.titleTxtProperty),
                        Body: (0, _squid.$renderContent)($scope.subtitleProperty),
                        backgroundImage: $scope.backgroundImage
                    };
                }

                $scope.$watch('ad.backgroundImage', function (imageUrl) {
                    if (imageUrl) {
                        var url = imageUrl;
                        var propImg = angular.element($element[0].querySelector('div.prop-img'));
                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                        if (isRetina && url) {
                            var index = url.lastIndexOf('.'); // index at which file extension start

                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        } else {
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        }
                    }
                });

                if ($scope.placementCode === '202002') {
                    $scope.pu_type = 'ANONYMOUS';
                    $scope.presentation_types = ['CompositeText'];
                } else if ($scope.placementCode === '202003') {
                    $scope.className = 'props';
                    $scope.pu_type = 'PERSONAL';
                    $scope.presentation_types = ['GenericComposite'];
                    $scope.chooseAd = true;
                } else {
                    setDefaultValues();
                }

                //  serve ads only if country is US and lang is en and based on placementcode
                if ($scope.chooseAd && _squid.$locale.country === 'US' && _squid.$locale.lang === 'en' && $scope.placementCode && (0, _squid.$feature)('morsValuePropOffers')) {
                    $scope.marketingOfferData = new _marketingoffer.$MarketingOfferModel({
                        countryCode: $scope.locale.country,
                        page: $scope.pageName,
                        puType: $scope.pu_type,
                        locale: _squid.$locale.lang + '_' + _squid.$locale.country,
                        totalTransactionAmount: {
                            'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                            // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                            // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                            'value': Math.round($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100)
                        },
                        totalShippingAmount: {
                            'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                            // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                            // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                            'value': Math.round($scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100)
                        },
                        payee: morsOfferFlag ? $scope.payee.merchant.id : '',
                        payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
                        si: morsOfferFlag ? $scope.checkoutSession.id : '',
                        visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
                        targetPlacements: [{
                            'placement_code': $scope.placementCode,
                            'presentation_types': $scope.presentation_types
                        }]
                    });

                    return _marketingoffer.$MarketingOfferModel.instance($scope.token).save({
                        silent: true,
                        data: $scope.marketingOfferData.serialize(),
                        // Ignore all errors from this api, by passing transientError as true
                        transientError: true,
                        success: function success(result) {
                            var ads_arr = result && result.ads || [];
                            var adFound = false;

                            // MORS could serve multiple ads for a given page. Iterate to get the
                            // correct one based on the ad placement_id
                            ads_arr.forEach(function (ad) {
                                var adunit_id = ad.campaign.adunit_id;

                                if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
                                    adFound = true;
                                    $scope.ad = {};
                                    var content = ad.content.nvp;

                                    content.forEach(function (obj) {
                                        $scope.ad[obj.name] = obj.value;
                                    });
                                    $scope.ad['impressionUrl'] = ad.tracking.impression_url;
                                    $scope.ad['clickUrl'] = ad.tracking.click_url;
                                }
                            });

                            if (adFound) {
                                $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
                                // $scope.ad.Title does not need to be assigned. for 202001, 202002,
                                // and 202003 placement_ids as this will already be assigned.

                                // notify MORS of successful rendering by firing the impressionurl
                                // beacon and by setting the click url to be fired for future
                                // conversion.
                                // setting the placement_id helps to differentiate between multiple ads
                                // displayed on the same page

                                _logger.$logger.info('MORS_ad_displayed');
                                _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);

                                _angular.$rootScope.$broadcast('MORSDisplayed', {
                                    clickUrl: $scope.ad.clickUrl,
                                    placementId: $scope.placementCode
                                });
                            } else {
                                _logger.$logger.info('MORS_ad_not_found');
                                setDefaultValues();
                                _angular.$rootScope.$broadcast('MORSNotDisplayed');
                            }
                        },

                        error: function error(err) {
                            setDefaultValues();
                            _logger.$logger.error('MORS_api_failure', { error: err });
                        }
                    });
                } else {
                    setDefaultValues();
                    _angular.$rootScope.$broadcast('MORSNotDisplayed');
                }
                $scope.$on('localeChange', function () {
                    setDefaultValues();
                });
            });
        }]
    };
});

_angular.$rootScope;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_marketingoffer.$MarketingOfferModel;

_marketingoffer.$fireMORSBeacon;

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\" tag-name=\"{{ xoTitleTag }}\" class-name=\"{{ xoTitleClass }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index3 = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js");

var _index4 = _interopRequireDefault(_index3);

var _template = __webpack_require__("../node_modules/xo-page-components/src/merchant-header/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoMerchantHeaderDirective', {
    tag: 'xo-merchant-header',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        merchant: {
            type: 'var',
            required: false
        },
        disableId: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
                };
            }
        }
    },
    lifecycle: {
        populate: function populate() {
            var _ref = this.models || {},
                checkoutAppData = _ref.checkoutAppData;

            if (checkoutAppData) {
                // get Merchant display name - can be undefined in which case we have an empty header
                this.merchantDisplayName = checkoutAppData.getMerchantDisplayName();

                if (this.props.token && !_index2.$CheckoutInputDataModel.instance(this.props.token).isEbayTxn()) {
                    this.merchant = checkoutAppData.merchant;
                }
                this.escapedMerchantName = _index4['default'].escapeTags(this.merchantDisplayName || this.merchant.brand_name);
            }
        }
    }
});


(0, _squid.$registerDirective)('xoMerchantImageResize', function () {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            element.bind('load', function () {
                var MAX_WIDTH = 780;
                var MAX_HEIGHT = 60;

                if (this.width > MAX_WIDTH) {
                    var ratio = MAX_WIDTH / this.width;
                    var height = this.height * ratio;

                    this.width = MAX_WIDTH;
                    this.height = height > MAX_HEIGHT ? MAX_HEIGHT : height;
                }
                if (this.height > MAX_HEIGHT) {
                    var _ratio = MAX_HEIGHT / this.height;
                    var width = this.width * _ratio;

                    this.height = MAX_HEIGHT;
                    this.width = width > MAX_WIDTH ? MAX_WIDTH : width;
                }
            });
        }
    };
});

_angular.noop;

_squid.$Component;

_squid.$registerDirective;

_index.$CheckoutAppDataModel;

_index2.$CheckoutInputDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/template.html":
/***/ (function(module, exports) {

module.exports = "<header role=\"banner\">\n    <div ng-attr-id=\"{{ props.disableId ? '' : 'header' }}\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" directionality-text=\"escapedMerchantName\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n                {{ escapedMerchantName }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ escapedMerchantName }}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/messenger-plugin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/messenger-plugin/template.html");

var _template2 = _interopRequireDefault(_template);

var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoMessengerPluginDirective', {
    tag: 'xo-messenger-plugin',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        pluginType: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                messengerIntegration: _index3.$MessengerIntegrationDataModel.instance().retrieve()['catch'](_angular.noop)
            };
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
            var lang = _squid.$locale.lang,
                country = _squid.$locale.country;
            var _props = this.props,
                pluginType = _props.pluginType,
                token = _props.token;
            var _models = this.models,
                _models$checkoutSessi = _models.checkoutSession,
                checkoutSession = _models$checkoutSessi === undefined ? {} : _models$checkoutSessi,
                _models$messengerInte = _models.messengerIntegration,
                messengerIntegration = _models$messengerInte === undefined ? {} : _models$messengerInte;

            // BA was offered to user or not

            var fbBAShownFlag = _squid.$util.localStorageEnabled() && window.localStorage.getItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG);

            // Added following flags to override usual behaviour to enable internal testing by FB and PYPL teams

            var _ref = window.xprops || {},
                _ref$experience = _ref.experience;

            _ref$experience = _ref$experience === undefined ? {} : _ref$experience;
            var override_fbpp_repeat = _ref$experience.override_fbpp_repeat;

            var overrideRepeatUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_REPEAT_FLAG) || override_fbpp_repeat;

            var isChatEnabled = messengerIntegration.isChatEnabled,
                emailHash = messengerIntegration.emailHash,
                nameHash = messengerIntegration.nameHash,
                dataRefJWT = messengerIntegration.dataRefJWT;
            var _checkoutSession$paye = checkoutSession.payer;
            _checkoutSession$paye = _checkoutSession$paye === undefined ? {} : _checkoutSession$paye;
            var payerId = _checkoutSession$paye.id,
                _checkoutSession$tran = checkoutSession.transactionDetails,
                transactionDetails = _checkoutSession$tran === undefined ? {} : _checkoutSession$tran;

            var txnId = transactionDetails.receipt_id || transactionDetails.id || '';

            _logger.$logger.info('Messenger_plugin_props', { pluginType: pluginType, isMobile: isMobile });
            _logger.$logger.info('Messenger_plugin_data', messengerIntegration);

            // if 'isChatEnabled' variable is enabled, it means that user has already onboarded to
            // the messenger feature, so don't trigger messenger onboarding for that user again
            if (!overrideRepeatUserFlag && (isChatEnabled || fbBAShownFlag === 'true' && pluginType === 'STM')) {
                _logger.$logger.info('UNP_chat_prefernce_is_already_enabled');
                _logger.$logger.info('checkout_fpti', {
                    buyer_country: country,
                    buyer_id: payerId,
                    design: 'fbmessenger',
                    from: 'XO_REVIEW',
                    to: 'process_XO_success',
                    eligibility_reason: 'chat_pref_enabled'
                });
                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                (0, _jquery2['default'])('#stm-upsell-content').hide();
                return;
            }

            // set all the needed props for the template to render (basically anything attached to `this`)
            // Messenger plugin – comparare this user ID hash with FB user
            this.identityMatchVal = JSON.stringify({
                email_hash: emailHash,
                name_hash: nameHash
            });
            this.dataRefVal = dataRefJWT + '_txnID_' + txnId + '_plugin_' + pluginType + '_token_' + token + '_locale_' + lang + '_' + country;
            this.originVal = window.location.origin;
            this.pageIdVal = _squid.$config.deploy.isLive() ? _fbMessenger2['default'].FB_PROD_PAGE_ID[country] : _fbMessenger2['default'].FB_TEST_PAGE_ID;

            if (pluginType === 'CHECKBOX') {
                this.uuidVal = payerId + '_' + _uuid2['default'].v1(); // the `user_ref`, which includes the user's payer ID

                if (_squid.$util.sessionStorageEnabled()) {
                    window.sessionStorage.setItem('checkboxUUIDVal', this.uuidVal);
                }
            }

            // load the correct SDK based on the user's locale
            // it'll fallback to en_US if the locale isn't supported by facebook
            _squid.$dom.loadScript('facebook-jssdk', 'https://www.paypalobjects.com/fbjs/' + lang + '_' + country + '/sdk.js').then(function () {
                if (window.FB) {
                    _this.fbAsyncInit();

                    // NOTE: uncomment to test on stage and localhost
                    // this.cbSTMPlugin({
                    //     event: 'identity_match',
                    //     ref: this.dataRefVal,
                    //     result: 'match'
                    // });
                }
            })['catch'](function (err) {
                // just log that script is not loaded
                // messenger is an optional service which should not block payment done page rendering
                return _logger.$logger.info('fb_messenger_load_script_error', { error: err && err.message });
            });

            this.cbSTMPlugin = function (evt) {
                if (pluginType === 'STM') {
                    if (evt.event === 'rendered') {
                        _logger.$logger.info('STM_plugin_rendered');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_rendering_plugin',
                            eligibility_reason: 'plugin_rendered'
                        });
                    }

                    if (evt.event === 'identity_match' && evt.result === 'match') {
                        _logger.$logger.info('FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_identity_matching',
                            eligibility_reason: 'identity_matched'
                        });

                        _this.dataRefVal = evt.ref;

                        _jquery2['default'].ajax({
                            url: isMobile ? _fbMessenger2['default'].FB_USER_API_MOBILE_URL : _fbMessenger2['default'].FB_USER_API_URL,
                            xhrFields: { withCredentials: true }
                        }).always(function () {
                            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                _ref2$responseText = _ref2.responseText,
                                responseText = _ref2$responseText === undefined ? '' : _ref2$responseText;

                            var json = responseText.substring(responseText.indexOf('{'));
                            var data = JSON.parse(json);

                            _logger.$logger.info('callFBToGetBAToken_call', data);
                            messengerIntegration.action('callFBToGetBAToken', {
                                data: { userIdentifier: data.user_identifier },
                                success: function success() {
                                    var getBAResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                    var isSuccessful = getBAResponse.success,
                                        batoken = getBAResponse.batoken;


                                    if (isSuccessful) {
                                        _logger.$logger.info('BAToken_from_FB', {
                                            batoken: batoken
                                        });

                                        var fbBAToken = batoken;
                                        var xoJSData = void 0;

                                        if (_squid.$config.deploy.isLocal()) {
                                            xoJSData = {
                                                'data-env': 'local',
                                                'data-stage': 'msmaster',
                                                'data-no-bridge': ''
                                            };

                                            // Generate new FB Channel BA and update while testing, BA gets invalidated in few hours
                                            fbBAToken = 'BA-5UD039368V581733E';
                                        } else if (_squid.$config.deploy.isStage() || _squid.$config.deploy.isSandbox()) {
                                            xoJSData = {
                                                'data-env': 'sandbox',
                                                'data-no-bridge': ''
                                            };
                                        } else {
                                            xoJSData = {
                                                'data-env': 'production',
                                                'data-no-bridge': ''
                                            };
                                        }

                                        var launchBAFlow = function launchBAFlow() {
                                            _logger.$logger.info('Launch_BA_flow_with_token', { fbBAToken: fbBAToken });
                                            _logger.$logger.info('checkout_fpti', {
                                                buyer_country: country,
                                                buyer_id: payerId,
                                                design: 'fbmessenger',
                                                from: 'XO_REVIEW',
                                                to: 'prepare_billing_agreement',
                                                eligibility_reason: 'identity_matched',
                                                click_source: 'pay_now',
                                                ba_token: fbBAToken
                                            });

                                            window.paypal.Checkout.contexts.iframe = true;
                                            if (_squid.$util.localStorageEnabled()) {
                                                window.localStorage.setItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG, 'true');
                                            }
                                            window.paypal.Checkout.render({
                                                experience: {
                                                    messenger: true,
                                                    override_fbpp_repeat: overrideRepeatUserFlag
                                                },
                                                payment: function payment() {
                                                    return fbBAToken;
                                                },

                                                onAuthorize: function onAuthorize() {
                                                    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                                        baToken = _ref3.billingToken;

                                                    _logger.$logger.info('User_accepted_FB_BA');

                                                    var isUnchecked = _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxPluginState') === 'unchecked';
                                                    var eligibility_reason = isUnchecked ? 'checkbox_plugin_unchecked' : 'checkbox_plugin_checked';

                                                    if (isUnchecked) {
                                                        _logger.$logger.info('user_not_accepted_messenger_notifications');
                                                        (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                                                        (0, _jquery2['default'])('#stm-upsell-content').hide();
                                                        (0, _jquery2['default'])('#ba-integration-content').show();
                                                    } else {
                                                        _logger.$logger.info('user_accepted_checkbox_messenger_notifications');
                                                        (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                                                        (0, _jquery2['default'])('#stm-upsell-content').hide();
                                                        (0, _jquery2['default'])('#messenger-ba-integration-content').show();
                                                    }
                                                    _logger.$logger.info('checkout_fpti', {
                                                        buyer_country: country,
                                                        buyer_id: payerId,
                                                        design: 'fbmessenger',
                                                        from: 'BILLING_AGREEMENT',
                                                        to: 'process_billing_agreement',
                                                        eligibility_reason: eligibility_reason,
                                                        click_source: 'agree_continue',
                                                        ba_token: fbBAToken
                                                    });

                                                    _this.confirmCheckboxPluginOptIn();
                                                    messengerIntegration.action('notifyFBOntBAAuthorize', {
                                                        data: { baToken: baToken },
                                                        success: function success() {
                                                            var authorizeResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                                                            if (authorizeResponse.success) {
                                                                _logger.$logger.info('notifyFBOntBAAuthorize_call_success!');
                                                            } else {
                                                                _logger.$logger.info('notifyFBOntBAAuthorize_call_failure!');
                                                                _logger.$logger.info('checkout_fpti', {
                                                                    buyer_country: country,
                                                                    buyer_id: payerId,
                                                                    design: 'fbmessenger',
                                                                    int_error_code: '500',
                                                                    int_error_description: JSON.stringify(authorizeResponse),
                                                                    error_type: 'failure',
                                                                    error_source: 'notifyFBOntBAAuthorize'
                                                                });
                                                            }
                                                        }
                                                    });

                                                    _logger.$logger.info('checkout_fpti', {
                                                        buyer_country: country,
                                                        buyer_id: payerId,
                                                        design: 'fbmessenger',
                                                        from: 'BILLING_AGREEMENT',
                                                        to: 'prepare_billing_agreement_success',
                                                        eligibility_reason: eligibility_reason,
                                                        click_source: 'return_to_merchant',
                                                        ba_token: fbBAToken
                                                    });
                                                }
                                            });
                                        };

                                        if (window.paypal) {
                                            _logger.$logger.info('xo_JS_is_already_present');
                                            launchBAFlow();
                                        } else {
                                            _squid.$dom.loadScript('xo-js', 'https://www.paypalobjects.com/api/checkout.js', 0, xoJSData).then(function () {
                                                _logger.$logger.info('xo_JS_got_loaded');
                                                launchBAFlow();
                                            });
                                        }
                                    } else {
                                        _logger.$logger.info('callFBToGetBAToken_call_failure!');
                                        _logger.$logger.info('checkout_fpti', {
                                            buyer_country: country,
                                            buyer_id: payerId,
                                            design: 'fbmessenger',
                                            int_error_code: '500',
                                            int_error_description: JSON.stringify(getBAResponse),
                                            error_type: 'failure',
                                            error_source: 'callFBToGetBAToken'
                                        });
                                    }
                                }
                            });
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'no_match') {
                        _logger.$logger.info('No_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_XO_success',
                            eligibility_reason: 'identity_not_matched',
                            click_source: 'pay_now'
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'no_logged_in_user') {
                        _logger.$logger.info('No_loggedin_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_XO_success',
                            eligibility_reason: 'logged_out',
                            click_source: 'pay_now'
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'failure') {
                        _logger.$logger.info('Fail_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            int_error_code: '500',
                            int_error_description: JSON.stringify(evt),
                            error_type: 'failure',
                            error_source: 'identity_match'
                        });
                    } else if (evt.event === 'clicked') {
                        _logger.$logger.info('user_accepted_STM_messenger_notifications');
                    }
                }
            };

            this.fbAsyncInit = function () {
                _logger.$logger.info('Initializing_FB_scripts');
                window.FB.init({
                    appId: _fbMessenger2['default'].FB_PROD_APP_ID,
                    xfbml: true,
                    version: 'v7.0'
                });

                // Subscribe to STM
                window.FB.Event.subscribe('send_to_messenger', _this.cbSTMPlugin);

                // Subscribe to CHECKBOX
                window.FB.Event.subscribe('messenger_checkbox', function (evt) {
                    _logger.$logger.info('messenger_checkbox_event', evt);
                    if (evt.event === 'checkbox') {
                        if (_squid.$util.sessionStorageEnabled()) {
                            window.sessionStorage.setItem('checkboxPluginState', evt.state);
                        }
                        _logger.$logger.info('checkbox_plugin_state_' + evt.state);
                    }
                });
            };

            this.confirmCheckboxPluginOptIn = function () {
                _logger.$logger.info('MessengerCheckboxPluginUserConfirmation_event_to_fb', {
                    uuidVal: _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxUUIDVal') || '',
                    pageIdVal: _this.pageIdVal,
                    dataRefVal: _this.dataRefVal
                });
                window.FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
                    page_id: _this.pageIdVal,
                    app_id: _fbMessenger2['default'].FB_PROD_APP_ID,
                    ref: _this.dataRefVal,
                    user_ref: _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxUUIDVal') || ''
                });
            };
        },
        exit: function exit() {
            _logger.$logger.info('Messenger_plugin_EXIT_event');
        }
    }
});


_angular.noop;

_logger.$logger;

_squid.$Component;

_squid.$dom;

_squid.$util;

_squid.$config;

_squid.$locale;

_index.$DeviceInfo;

_index2.$CheckoutSessionModel;

_index3.$MessengerIntegrationDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/messenger-plugin/template.html":
/***/ (function(module, exports) {

module.exports = "<messenger-plugin content>\n  <div id=\"messenger-plugin\" ng-value=\"props.pluginType\">\n    <div\n      class=\"fb-send-to-messenger\"\n      origin=\"{{originVal}}\"\n      identity_match=\"{{identityMatchVal}}\"\n      messenger_app_id=\"1084613224964631\"\n      page_id=\"{{pageIdVal}}\"\n      data-ref=\"{{dataRefVal}}\"\n      color=\"blue\"\n      size=\"xlarge\"\n      ng-if=\"(props.pluginType == 'STM')\"\n    ></div>\n\n    <div\n      class=\"fb-messenger-checkbox\"\n      origin=\"{{originVal}}\"\n      page_id=\"{{pageIdVal}}\"\n      messenger_app_id=\"1084613224964631\"\n      pixel_id=\"329481497393670\"\n      ref=\"{{dataRefVal}}\"\n      user_ref=\"{{uuidVal}}\"\n      allow_login=\"true\"\n      size=\"xlarge\"\n      ng-if=\"(props.pluginType == 'CHECKBOX')\"\n    ></div>\n  </div>\n</messenger-plugin>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoNotYouComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/notYou/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/notYou/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoNotYouComponent = exports.$xoNotYouComponent = _squid.$Component.extend('$xoNotYou', {
    tag: 'xo-not-you',
    template: _template2['default'],
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve(),
                appData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(),
                cart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve(),
                venmoTransactionElig: _venmoModels.$VenmoTransactionEligibility.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },
    actions: {
        onClick: function onClick() {
            this.actions.logout();
        },
        logout: function logout() {
            var _this = this;

            _logger.$logger.info('not_you_logout');
            if (window.xchild && _squid.$util.isIFrame() && window.paypal && !window.paypal.isWebView()) {
                window.xchild.hide();

                var url = window.location.href.split('#')[0];
                var xprops = _squid.$util.extend({}, window.xprops);

                xprops.url = url;
                xprops.payment = function () {
                    return _this.models.auth.logout().then(function () {
                        return _angular.$rootScope.token;
                    });
                };

                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
            }

            this.models.auth.logoutAndRedirect('NOT_YOU');
        },
        getMessage: function getMessage() {
            // if Venmo Eligible and not currently Venmo flow...
            if (this.models.venmoTransactionElig.venmo && !this.isVenmoExperience) {
                // do you prefer Venmo?
                return _squid.$locale.content.get('memberReview.preferToPayWithVenmo');
            }

            // if there's a Paypal One Touch cookie present and we're currently in a venmo flow
            if (this.models.auth.refresh_token && this.isVenmoExperience) {
                // do you prefer Paypal?
                return _squid.$locale.content.get('memberReview.preferToPayWithPaypal');
            }

            // not you?
            return _squid.$locale.content.get('memberReview.notYou');
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            this.token = _angular.$rootScope.token;
            this.isVenmoExperience = _thirdPartyInfo.thirdPartyExperience.getExperience(this.token) === 'VENMO_EXPERIENCE';
            this.message = this.actions.getMessage();

            // if we reload page because of locale change, reload the content using updated locale
            this.$on('localeChange', function () {
                _this2.message = _this2.actions.getMessage();
            });
        }
    }
});

angular.value("$xoNotYouComponent", $xoNotYouComponent);
_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_squid.$Component;

_squid.$util;

_squid.$locale;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_venmoModels.$VenmoTransactionEligibility;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/template.html":
/***/ (function(module, exports) {

module.exports = "<a content track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.onClick()\">{{ this.message }}</a>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/returnParams/index.js":
/***/ (function(module, exports, __webpack_require__) {



var addValidParam = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js").addValidParam;

function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
    var params = {};
    var customData = checkoutCart.get('purchase.custom');

    if (returnToMerchantMethod === 'POST') {
        // TODO: find out why we get postbackData as undefined
        // UPDATE: couldn't reproduce an issue on the stage for now
        if (checkoutSession.postbackData) {
            params = checkoutSession.postbackData;
        }
    } else {
        var transactionDetail = checkoutSession.transactionDetails;

        if (transactionDetail) {
            addValidParam(params, 'tx', transactionDetail.id);
            addValidParam(params, 'st', transactionDetail.state);

            if (transactionDetail.amount) {
                addValidParam(params, 'amt', transactionDetail.amount.total);
                addValidParam(params, 'cc', transactionDetail.amount.currency);
            }
        }

        // Cart uploads can have more than one item so we don't add any in return URL
        if (!is_cart_upload_flow) {
            var itemDetail = checkoutSession.get('itemsList.0');

            if (itemDetail) {
                addValidParam(params, 'item_name', itemDetail.name);
                addValidParam(params, 'item_number', itemDetail.sku);
            }
        }

        addValidParam(params, 'cm', customData);
    }
    return params;
}

/**
 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
 * please refer https://github.paypal.com/NodeXOShared/xo-hermes-checkout/blob/master/apis/session/postBackDataMapper.js
 * to know more details about post back data

 * @param {Object (angular model)} cart model
 * @param {Object (angular model)} session model
 * @param {String} http method, either "POST" or "GET"
 * @param {String} feature type (WPS only for now)
 * @param {Boolean} flag that indicates if it's a cart upload or not
 * @returns {object} params to pass back to the merchant
*/
module.exports = {
    $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
        if (feature === 'WPS') {
            return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
        }
        return {};
    }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getFirstAmount: _subscriptionTerms2['default'].getFirstAmount,
    getFormattedFirstAmount: _subscriptionTerms2['default'].getFormattedFirstAmount,
    getFormattedAmount: _subscriptionTerms2['default'].getFormattedAmount,
    getItemOptions: _subscriptionTerms2['default'].getItemOptions,
    getItemName: _subscriptionTerms2['default'].getItemName,
    getCurrencyCode: _subscriptionTerms2['default'].getCurrencyCode,
    getTermsText: _subscriptionTerms2['default'].getTermsText,
    getEffectiveDate: _subscriptionTerms2['default'].getEffectiveDate,
    getNumericValueNonZero: _subscriptionTerms2['default'].getNumericValueNonZero,
    isNumericValue: _subscriptionTerms2['default'].isNumericValue
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var BILL_PERIOD_DAY = 'DAY';
var BILL_PERIOD_WEEK = 'WEEK';
var BILL_PERIOD_MONTH = 'MONTH';
var BILL_PERIOD_YEAR = 'YEAR';
var TRIAL_SUBSCRIPTION = 'TRIAL';
var REGULAR_SUBSCRIPTION = 'REGULAR';
var INFINITE_CYCLES = 'INFINITE';

/**
 * Plural time unit
 *  True: time unit will be one of: days, weeks, months, years
 *  False: time unit will be one of: day, week, month, year
 * @type {boolean}
 */
var pluralTimeUnit = false;

/**
 * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
 *  e.g. Then 2$ for next 4 months
 *  otherwise statement will be
 *  2$ for next 4 months
 * @type {boolean}
 */
var hasPriorTerm = false;

/**
 * Wrapper for calling formatCurrent fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
    arguments[0] = arguments[0].toFixed(2);
    return _squid.formatCurrency.apply(undefined, arguments);
}

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
    return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @returns {string}
 */
function computeTimeUnit(billPeriod) {
    var timeUnit = void 0;

    switch (billPeriod) {
        case BILL_PERIOD_DAY:
            timeUnit = pluralTimeUnit ? 'days' : 'day';
            break;
        case BILL_PERIOD_WEEK:
            timeUnit = pluralTimeUnit ? 'weeks' : 'week';
            break;
        case BILL_PERIOD_MONTH:
            timeUnit = pluralTimeUnit ? 'months' : 'month';
            break;
        case BILL_PERIOD_YEAR:
            timeUnit = pluralTimeUnit ? 'years' : 'year';
            break;
        default:
            timeUnit = '';
    }

    return localizedContent('wpsSubscription.label.' + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amount, currencyCode) {
    if (amount === 0) {
        return localizedContent('wpsSubscription.label.free');
    } else {
        return getFormattedCurrency(amount, currencyCode, false);
    }
}

/**
 * This method computes first trial key
 * @returns {string} Content Key for 1st trial, which must be prepended by wpsSubscription.message
 */
function computeFirstTrialKey() {
    if (pluralTimeUnit) {
        // {amount} for the first {timePeriod} {timeUnit}
        return 'firstTrialPeriod.plural';
    } else {
        // {amount} for the first {timeUnit}
        return 'firstTrialPeriod.singular';
    }
}

/**
 * This method computes content key for 2nd trial
 * @returns {string} Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeSecondTrialKey() {
    if (pluralTimeUnit) {
        // Then {amount} for the next {timePeriod} {timeUnit}
        return 'secondTrialPeriod.plural';
    } else {
        // Then {amount} for the next {timeUnit}
        return 'secondTrialPeriod.singular';
    }
}

/**
 * Computes and returns content key for regular subscription
 * There can be 12 variations of regular subscription content
 * @param totalCycles
 * @returns {string}  Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeRegularSubscriptionKey(totalCycles) {
    var key = 'regularSubscriptionPeriod';

    if (hasPriorTerm) {
        // Content starts with Then {amount} for ......
        key += '.withPriorTerms';
    } else {
        // Content does NOT starts with Then
        key += '.noPriorTerms';
    }

    if (pluralTimeUnit) {
        // Content has: {amount} for each 2 days/weeks/months/years
        key += '.plural';
    } else {
        // Content has: {amount} for each day/week/month/year
        key += '.singular';
    }

    switch (+totalCycles) {
        case 0:
        case 1:
            // Text will look like $20.00 USD for the next 2 months
            // Content does NOT end with: for 3 installments
            key += '.nonRecurring';
            break;
        case Infinity:
            // Content ends with: for each 2 months OR for each month
            // Content will look like $30.00 USD for each week
            key += '.recurringInfinite';
            break;
        default:
            // Content ends with: for 3 installments
            // Content will look like $100.00 USD for each 2 months, for 3 installments
            key += '.recurring';
    }
    return key;
}

/**
 * Prepares and returns an individual term text string
 * @param subscriptionTerms
 * @param index
 * @param currencyCode
 * @returns {string}
 */
function prepareIndividualTermText(subscriptionTerms, index, currencyCode) {
    var amount = +subscriptionTerms[index].amount,
        billPeriod = subscriptionTerms[index].billPeriod,
        periodType = subscriptionTerms[index].periodType,
        billFrequency = +subscriptionTerms[index].billFrequency,
        totalCycles = +subscriptionTerms[index].totalCycles;
    var contentKey = void 0;

    hasPriorTerm = index > 0;
    pluralTimeUnit = billFrequency > 1;

    if (periodType === TRIAL_SUBSCRIPTION) {
        if (index === 0) {
            // First Trial
            contentKey = computeFirstTrialKey();
        } else if (index === 1) {
            // Second Trial
            contentKey = computeSecondTrialKey();
        }
    } else if (periodType === REGULAR_SUBSCRIPTION) {
        contentKey = computeRegularSubscriptionKey(totalCycles);
    }
    contentKey = 'wpsSubscription.message.' + contentKey;
    var templatePlaceholderData = {
        amount: computeAmount(amount, currencyCode),
        timePeriod: billFrequency,
        timeUnit: computeTimeUnit(billPeriod),
        installmentCount: totalCycles
    };

    return localizedContent(contentKey, templatePlaceholderData);
}

function mapBaResponse(baResponseData) {
    var mappedSubscriptionDetails = {};
    var plan = baResponseData && baResponseData.plan;
    var allTerms = plan && plan.payment_definitions;
    var mappedTerms = [];
    var firstTrialAmount = null;
    var regularAmount = void 0;

    mappedSubscriptionDetails.currencyCode = plan && plan.currency_code;

    if (allTerms) {
        allTerms.forEach(function (eachTerm) {
            var totalCycles = eachTerm.duration === INFINITE_CYCLES ? Infinity : eachTerm.cycles;
            var eachMappedTerm = {
                amount: eachTerm.amount && eachTerm.amount.value / 100,
                billPeriod: eachTerm.frequency,
                periodType: eachTerm.type,
                billFrequency: eachTerm.frequency_interval,
                totalCycles: totalCycles
            };

            if (!mappedSubscriptionDetails.currencyCode) {
                // V1 Subscriptions: Pick currency code from any of the amounts.
                mappedSubscriptionDetails.currencyCode = eachTerm.amount && eachTerm.amount.currency_code;
            }

            if (eachTerm.type === TRIAL_SUBSCRIPTION && eachTerm.index === '1') {
                firstTrialAmount = eachMappedTerm.amount;
            } else if (eachTerm.type === REGULAR_SUBSCRIPTION) {
                regularAmount = eachMappedTerm.amount;
            }
            mappedTerms.push(eachMappedTerm);
        });

        // firstTrialAmount can be zero for free trial, null for no trial
        // and valid value if there is trial amount
        mappedSubscriptionDetails.firstAmount = firstTrialAmount !== null ? firstTrialAmount : regularAmount;
        mappedSubscriptionDetails.subscriptionTerms = mappedTerms;
    }

    return mappedSubscriptionDetails;
}

/**
 * Prepare and return a subscription terms
 * @param baResponseData
 * @returns {Object} Containing Subscription Terms Text
 */
function getTermsText(baResponseData) {
    var subscriptionDetails = mapBaResponse(baResponseData);
    var subscriptionTerms = subscriptionDetails.subscriptionTerms;
    var currencyCode = subscriptionDetails.currencyCode;
    var termTextList = [];

    for (var i = 0, len = subscriptionTerms.length; i < len; i++) {
        termTextList.push(prepareIndividualTermText(subscriptionTerms, i, currencyCode));
    }
    return termTextList;
}

/**
 * Returns a un formatted first amount from ba response
 */
function getFirstAmount(baResponseData) {
    var subscriptionDetails = mapBaResponse(baResponseData);

    return subscriptionDetails.firstAmount;
}

/**
 * Returns the currency code
 */
function getCurrencyCode(baResponseData) {
    var plan = baResponseData && baResponseData.plan;

    return plan && plan.currency_code;
}

/**
 * Returns a formatted first amount from ba response data
 */
function getFormattedFirstAmount(baResponseData) {
    var amount = getFirstAmount(baResponseData);
    var currencyCode = getCurrencyCode(baResponseData);

    return getFormattedCurrency(amount, currencyCode, false);
}

/**
 * Retrieve item details
 */
function getItemOptions(baResponseData) {
    var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];

    return itemDetails.options;
}

/**
 * Retrieve item name
 */
function getItemName(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var _baResponseData$items = baResponseData.items;
    _baResponseData$items = _baResponseData$items === undefined ? [] : _baResponseData$items;
    var _baResponseData$items2 = _baResponseData$items[0];
    _baResponseData$items2 = _baResponseData$items2 === undefined ? {} : _baResponseData$items2;
    var name = _baResponseData$items2.name;


    return name;
}

function getEffectiveDate(baResponseData) {
    return baResponseData && baResponseData.effective_date;
}

function getFormattedAmount(amount, currencyCode) {
    var formattedAmount = amount / 100;

    return currencyCode ? getFormattedCurrency(formattedAmount, currencyCode, false) : formattedAmount.toFixed(2);
}

function getNumericValueNonZero(obj, path) {
    var data = parseFloat(_squid.$util.getProperty(obj, path));

    return !isNaN(data) && data > 0 && data;
}

function isNumericValue(value) {
    var data = parseInt(value, 10);

    return !isNaN(data) && data >= 0;
}

module.exports = {
    getFirstAmount: getFirstAmount,
    getFormattedFirstAmount: getFormattedFirstAmount,
    getFormattedAmount: getFormattedAmount,
    getItemOptions: getItemOptions,
    getItemName: getItemName,
    getCurrencyCode: getCurrencyCode,
    getTermsText: getTermsText,
    getEffectiveDate: getEffectiveDate,
    getNumericValueNonZero: getNumericValueNonZero,
    isNumericValue: isNumericValue
};

_squid.formatCurrency;

_squid.Content;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscriptionV1-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _subscriptionV1Terms = __webpack_require__("../node_modules/xo-page-components/src/subscriptionV1-terms/subscriptionV1Terms.js");

var _subscriptionV1Terms2 = _interopRequireDefault(_subscriptionV1Terms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getFormattedAmount: _subscriptionV1Terms2['default'].getFormattedAmount,
    getTermsText: _subscriptionV1Terms2['default'].getTermsText,
    getNumericValueNonZero: _subscriptionV1Terms2['default'].getNumericValueNonZero,
    isNumericValue: _subscriptionV1Terms2['default'].isNumericValue,
    getTaxDisclaimer: _subscriptionV1Terms2['default'].getTaxDisclaimer
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscriptionV1-terms/subscriptionV1Terms.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getTermsText = getTermsText;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var INTERVAL_UNIT_DAY = 'DAY'; /**
                                * This file contains the computation of terms from billing cycles object in planReview data
                                */

var INTERVAL_UNIT_WEEK = 'WEEK';
var INTERVAL_UNIT_MONTH = 'MONTH';
var INTERVAL_UNIT_YEAR = 'YEAR';

/**
 * Wrapper for calling formatCurreny fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
    arguments[0] = arguments[0].toFixed(2);
    return _squid.formatCurrency.apply(undefined, arguments);
}

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
    return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @param pluralTimeUnit
 * @returns {string}
 */
function computeTimeUnit(billPeriod, pluralTimeUnit) {

    var timeUnit = void 0;

    // eslint-disable-next-line default-case
    switch (billPeriod) {
        case INTERVAL_UNIT_DAY:
            timeUnit = pluralTimeUnit ? 'days' : 'day';
            break;
        case INTERVAL_UNIT_WEEK:
            timeUnit = pluralTimeUnit ? 'weeks' : 'week';
            break;
        case INTERVAL_UNIT_MONTH:
            timeUnit = pluralTimeUnit ? 'months' : 'month';
            break;
        case INTERVAL_UNIT_YEAR:
            timeUnit = pluralTimeUnit ? 'years' : 'year';
            break;
    }

    return localizedContent('wpsSubscription.label.' + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amountValue, currencyCode) {
    if (amountValue === 0) {
        return localizedContent('wpsSubscription.label.free');
    } else {
        return getFormattedCurrency(amountValue, currencyCode, false);
    }
}

/**
 * Computes and returns content key for subscription terms
 * There can be 12 variations of subscription content
 * @param totalCycles
 * @param hasPriorTerm
 * @param pluralTimeUnit
 * @returns {string}  Content Key which must be prepended by wpsSubscription.message
 */
function computeSubscriptionKey(totalCycles, hasPriorTerm, pluralTimeUnit) {

    var key = 'regularSubscriptionPeriod';

    /**
     * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
     * @type {boolean}
     */
    if (hasPriorTerm) {
        // Content starts with Then, e.g. Then 2$ for next 4 months
        key += '.withPriorTerms';
    } else {
        // Content does NOT starts with Then
        // Content looks like 2$ for next 4 months
        key += '.noPriorTerms';
    }

    /**
     * Plural time unit
     * @type {boolean}
     */
    if (pluralTimeUnit) {
        // Content has: {amount} for each 2 days/weeks/months/years
        key += '.plural';
    } else {
        // Content has: {amount} for each day/week/month/year
        key += '.singular';
    }

    switch (+totalCycles) {
        case 0:
            // Content ends with: for each 2 months OR for each month
            // Content will look like $30.00 USD for each week
            key += '.recurringInfinite';
            break;
        case 1:
            // Text will look like $20.00 USD for 2 months
            // Content does NOT end with: for 3 installments
            key += '.nonRecurring';
            break;
        default:
            // Content ends with: for 3 installments
            // Content will look like $100.00 USD for each 2 months, for 3 installments
            key += '.recurring';
    }
    return key;
}

/**
 * Prepares and returns an individual term text string
 * @param billingCycle
 * @param index
 * @returns {string}
 */
function prepareIndividualTermText(billingCycle, index) {
    var amount = billingCycle.pricing_scheme.fixed_price;
    var amountValue = amount.value / 100;
    var currencyCode = amount.currency_code;
    var billPeriod = billingCycle.frequency.interval_unit;
    var billFrequency = billingCycle.frequency.interval_count;
    var totalCycles = billingCycle.total_cycles;

    var pluralTimeUnit = billFrequency > 1;
    var hasPriorTerm = index > 0;

    var computedContentKey = computeSubscriptionKey(totalCycles, hasPriorTerm, pluralTimeUnit);
    var contentKey = 'wpsSubscription.message.' + computedContentKey;

    var templatePlaceholderData = {
        amount: computeAmount(amountValue, currencyCode),
        timePeriod: billFrequency,
        timeUnit: computeTimeUnit(billPeriod, pluralTimeUnit),
        installmentCount: totalCycles
    };

    return localizedContent(contentKey, templatePlaceholderData);
}

/**
 * Prepare and return a subscription terms
 * @param plan data from planReview
 * @returns {Array} Subscription Terms Text
 */
function getTermsText(planResponse) {
    var termTextList = [];
    var billingCycles = _squid.$util.getProperty(planResponse, 'plan.billing_cycles');

    billingCycles.forEach(function (billingCycle, index) {
        termTextList.push(prepareIndividualTermText(billingCycle, index));
    });
    return termTextList;
}

function getFormattedAmount(amount, currencyCode) {
    var formattedAmount = amount / 100;

    return currencyCode ? getFormattedCurrency(formattedAmount, currencyCode, false) : formattedAmount.toFixed(2);
}

function getNumericValueNonZero(obj, path) {
    var data = parseFloat(_squid.$util.getProperty(obj, path));

    return !isNaN(data) && data > 0 && data;
}

function isNumericValue(value) {
    var data = parseInt(value, 10);

    return !isNaN(data) && data >= 0;
}

function getTaxDisclaimer(taxPercentage, taxAmount) {
    if (taxPercentage) {
        return localizedContent('subscriptions.message.includesTax', { tax: taxPercentage });
    } else if (taxAmount) {
        return localizedContent('subscriptions.message.includesTaxAmount', { tax: taxAmount });
    }
    return '';
}

module.exports = {
    getFormattedAmount: getFormattedAmount,
    getTermsText: getTermsText,
    getNumericValueNonZero: getNumericValueNonZero,
    isNumericValue: isNumericValue,
    getTaxDisclaimer: getTaxDisclaimer
};

_squid.formatCurrency;

_squid.Content;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-page-components/src/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    /**
     * add non empty key, value to the object
     * @param {Object} object where to add new key, value
     * @param {String} key
     * @param {Any type} value, can not be empty
     * @returns {void}
     */
    addValidParam: function addValidParam(obj, key, val) {
        if (!obj) {
            return;
        }
        if (typeof key === 'string' && key && val !== undefined && val !== null) {
            obj[key] = val;
        }
    },

    // Get PXP context for Messenger feature
    getMessengerPXPContext: function getMessengerPXPContext() {
        var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
        var overrideMobileUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_MOBILE_FLAG);
        var channelVal = isMobile ? _fbMessenger2['default'].MOBILE_CHANNEL : _fbMessenger2['default'].WEB_CHANNEL;
        var pxpContext = {
            'ctx.COUNTRY': _squid.$locale.country,
            'ctx.CHANNEL': overrideMobileUserFlag ? _fbMessenger2['default'].WEB_CHANNEL : channelVal,
            'ctx.LANGUAGE': _squid.$locale.lang + '_' + _squid.$locale.country
        };

        return pxpContext;
    },

    isDolphinEligibleOnWpsDone: function isDolphinEligibleOnWpsDone(stateName) {
        return (/checkout\.done/.test(stateName) && !!_squid.$util.param('ulToastWpsDone')
        );
    },

    /**
     * Escape opening tags on vulnerable tags
     * @param {String} merchantName
     * @returns {Boolean}
     */
    escapeTags: function escapeTags() {
        var merchantName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        return merchantName.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link|source|video)/ig, '&lt;$1$2');
    }
}; /* eslint-disable angular/typecheck-string */


_squid.$util;

_squid.$locale;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/value-props/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-value-props.directive', ['squid']).directive('xoValueProps', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                type: '@?',
                title: '@?',
                text: '@?',
                textContent: '@?',
                imageUrl: '@?'
            },
            link: function link(scope, element, attrs) {
                if (angular.isString(attrs.imageUrl)) {
                    // Only do this when image-url is defined so that we do not affect default behavior. These image-url
                    // are configured through pxp tool for factor based experiments, hence they should all should adhere
                    // to standard size i.e. 150X150 pixels.
                    attrs.$observe('imageUrl', function (imageUrl) {
                        var url = imageUrl;
                        var propImg = angular.element(element[0].querySelector('div.prop-img'));
                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                        if (isRetina) {
                            var index = url.lastIndexOf('.'); // index at which file extension start

                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'background-size': '150px 150px',
                                'margin-top': '0px'
                            });
                        } else {
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        }
                    });
                }
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/formatReturnContent.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.formatReturnContent = formatReturnContent;
var MAX_MERCHANT_NAME_LENGTH = exports.MAX_MERCHANT_NAME_LENGTH = 15;

function formatReturnContent($renderContent, merchantName) {
    if (merchantName && merchantName.length < MAX_MERCHANT_NAME_LENGTH) {
        return $renderContent('common.returnToMerchant', { merchantName: merchantName });
    }

    return $renderContent('common.returnToDefaultMerchant');
}

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

Object.defineProperty(exports, '$ReturnToMerchant', {
  enumerable: true,
  get: function get() {
    return _util.$ReturnToMerchant;
  }
});

var _formatReturnContent = __webpack_require__("../node_modules/xo-return-to-merchant/dist/formatReturnContent.js");

Object.defineProperty(exports, 'formatReturnContent', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.formatReturnContent;
  }
});
Object.defineProperty(exports, 'MAX_MERCHANT_NAME_LENGTH', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.MAX_MERCHANT_NAME_LENGTH;
  }
});

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ReturnToMerchant = undefined;
exports.goTo = goTo;
exports.postToMerchant = postToMerchant;
exports.postTo = postTo;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goTo(url, forceRedirect) {
    _logger.$logger.info('goTo', { url: url, forceRedirect: forceRedirect });

    if (!url) {
        return;
    }

    // prevent xss attacks
    if ((0, _squid.isUnsafeRedirect)(url)) {
        _logger.$logger.error('unsafe_redirect_url', {
            url: url
        });
        throw new Error('Unsafe redirect url: ' + url);
    }

    _logger.$logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
        url: url
    });

    // if V4 in-context integration, we'll terminate and call the close handler.
    if (window.xchild) {
        _logger.$logger.done();
        _angular.$rootScope.$emit('loading');

        var _paymentToken = _angular.$rootScope.token;
        var cart = _index2.$CheckoutCartModel.instance(_paymentToken);
        var appData = _index2.$CheckoutAppDataModel.instance(_paymentToken);
        var orderID = _paymentToken;
        var intent = cart.payment_action;
        var billingToken = cart.billing && cart.billing.ba_token;
        var paymentID = appData.payment_id;
        var cancelUrl = url;

        return window.xprops.onCancel({
            paymentToken: _paymentToken,
            billingToken: billingToken,
            orderID: orderID,
            paymentID: paymentID,
            intent: intent,
            cancelUrl: cancelUrl
        });
    }

    var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
    var isNativeXo = _squid.$util.param('native_xo') && _squid.$util.param('native_xo') === '1';
    // if isDevice, NOT an HTTP url, and NOT a Native Checkout Transaction
    var showPaymentSuccess = Boolean(_index.$DeviceInfo.isDevice() && !isHTTPUrl && !isNativeXo);

    _logger.$logger.info('showPaymentSuccess', {
        isDevice: _index.$DeviceInfo.isDevice(),
        isHTTPUrl: isHTTPUrl,
        isNativeXo: isNativeXo
    });

    if (showPaymentSuccess) {
        _logger.$logger.info('showPaymentSuccessRedirect', {
            url: url
        });

        _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
        };

        // wait until state change is done and then redirect
        // for some reason, in case of webview (invoice flow) and code split
        // when user is redirecting to the return url - dynamic chunk fails to load
        // which triggers reload of the previous page
        return _uiRouter.$state.go('checkout.genericMessage', {
            code: 'PAYMENT_SUCCESS',
            returnUrl: url
        })['catch'](function (err) {
            _logger.$logger.info('app_redirect_to_merchant_generic_message_error', {
                error: err && err.message
            });
        })['finally'](function () {
            _angular.$window.location = url;
        });
    }

    if (forceRedirect) {
        _logger.$logger.info('forceRedirect', {
            url: url
        });

        _squid.$util.redirect(url);
    } else {
        var isVZeroIframe = Boolean(_angular.$rootScope.partnerIntegration) && _squid.$util.isIFrame();

        if (isVZeroIframe) {
            _logger.$logger.info('VZeroIframeRedirect');
            _squid.$util.redirect(url, { redirectImmediateParent: true });
        }

        // If we are not in minibrowser, do a hard redirect
        else if (_angular.$rootScope.partnerIntegration || !_angular.$rootScope.miniBrowser && !_squid.$util.isIFrame()) {
                _logger.$logger.info('redirectFlowType', {
                    partnerIntegration: _angular.$rootScope.partnerIntegration,
                    miniBrower: _angular.$rootScope.miniBrowser,
                    iframe: _squid.$util.isIFrame()
                });

                _squid.$util.redirect(url);
            } else {

                // Construct a message to send to the parent
                var result = this.postToMerchant({
                    operation: 'return_to_merchant',
                    returnUrl: url,
                    updateParent: true
                });

                // Otherwise we have no choice but to return to the merchant
                if (!result) {
                    _logger.$logger.info('postFalseHardRedirect');
                    _squid.$util.redirect(url);
                }
            }
    }

    var paymentToken = _angular.$rootScope.token;
    var payee = _index2.$CheckoutPayeeModel.instance(paymentToken);
    var merchantId = payee.get('merchant.id');

    var userStatus = function userStatus() {
        _logger.$logger.info('redirected_user_still_on_page_second_checkpoint', { merchantId: merchantId });

        if (!_squid.$config.deploy.isLocal()) {
            // If user is still present on this screen, redirect buyer to generic message page when merchant is whitelisted.
            // some merchants want the spinner to be displayed until they take necessary action at their end.
            // These merchants can be put in black list and we can do ramp as well for rest of the merchants if PO wants it.
            (0, _squid.$elmo)('show_end_of_flow', { uid: merchantId }, 'Trmt_show_end_of_flow').then(function (elmoResult) {
                if (elmoResult && elmoResult.treatment_name) {
                    _angular.$rootScope.allowStateChangeAfterRedirect = true;
                    _angular.$rootScope.$emit('loaded');
                    _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
                    };

                    return _uiRouter.$state.go('checkout.genericMessage', {
                        code: 'PAYMENT_SUCCESS_REDIRECT_FAILED',
                        returnUrl: url
                    })['catch'](function (err) {
                        _logger.$logger.info('app_redirect_to_merchant_generic_message_error', {
                            error: err && err.message
                        });
                    });
                }
            })['catch'](function (err) {
                // In case elmo call fails, just log and do not do any action.
                _logger.$logger.error('elmo_call_failed', {
                    error: err.stack || err.toString()
                });
            });
        }
    };

    var timeout = _squid.$config.idleTimeoutPostRedirectSuccess;

    (0, _angular.$timeout)(function () {
        _logger.$logger.info('redirected_user_still_on_page_first_checkpoint');
        (0, _angular.$timeout)(userStatus, timeout);
    }, timeout);
}

function postToMerchant(msg) {

    try {
        msg = _angular2['default'].toJson(msg, 0);

        // If we are not in IE, attempt to send a postMessage
        if (_angular.$window.opener && (_angular.$window.navigator.userAgent.match(/edge/i) || _angular.$window.opener.postMessage && !_angular.$window.navigator.userAgent.match(/msie|trident/i))) {
            _angular.$window.opener.postMessage(msg, '*');
            _logger.$logger.info('minibrowser_postmessage');
            return true;
        }
        // Otherwise, attempt to send a message through the iframe bridge
        var bridge = _angular.$window.opener && _angular.$window.opener.frames && _angular.$window.opener.frames.length && _angular.$window.opener.frames.PayPalBridge;

        if (bridge && bridge.returnToParent) {
            bridge.returnToParent(msg);
            _logger.$logger.info('minibrowser_bridgemessage');
            return true;
        }

        _logger.$logger.warn('minibrowser_nopostback');
    } catch (err) {
        _logger.$logger.error('minibrowser_postback_error', {
            error: err.stack || err.toString()
        });
    }

    return false;
}

function postTo(url, msg) {
    // prevent xss attacks
    if (url && (0, _squid.isUnsafeRedirect)(url)) {
        _logger.$logger.error('unsafe_redirect_url', {
            url: url
        });
        throw new Error('Unsafe redirect url: ' + url);
    }

    var form = document.createElement('form');

    form.method = 'POST';
    form.action = url;
    form.className = 'hide';

    for (var key in msg) {
        var input = document.createElement('input');

        input.name = key;
        input.value = msg[key];
        form.appendChild(input);
    }

    _angular.$window.document.body.appendChild(form);
    form.submit();
    _logger.$logger.info('web_postmessage');
    return true;
}

var $ReturnToMerchant = exports.$ReturnToMerchant = {
    goTo: goTo,
    postToMerchant: postToMerchant,
    postTo: postTo
};

_angular2['default'].value("goTo", goTo);
_angular2['default'].value("postToMerchant", postToMerchant);
_angular2['default'].value("postTo", postTo);
_angular2['default'].value("$ReturnToMerchant", $ReturnToMerchant);
_index.$DeviceInfo;

_logger.$logger;

_uiRouter.$state;

_squid.$util;

_squid.$config;

_squid.$elmo;

_squid.isUnsafeRedirect;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutPayeeModel;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/factory.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingChangeFactory = $ShippingChangeFactory;

var _util = __webpack_require__("../node_modules/xo-shipping-change/src/util.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function $ShippingChangeFactory(_ref) {
    var checkoutAppData = _ref.checkoutAppData,
        checkoutCart = _ref.checkoutCart;

    return {
        getCartTotal: function getCartTotal() {
            return (0, _util.getCartTotal)(checkoutCart);
        },
        getPayload: function getPayload(shippingAddress) {
            var paymentID = checkoutAppData.get('payment_id');
            var orderID = checkoutAppData.get('id');

            return (0, _util.getPayload)({ orderID: orderID, paymentID: paymentID, shippingAddress: shippingAddress, checkoutCart: checkoutCart });
        },
        updateCart: function updateCart() {
            return (0, _util.updateCart)(checkoutCart);
        },
        callOnShippingChange: function callOnShippingChange(payload) {
            var allowChangeShipping = checkoutAppData.get('flags.allow_change_shipping', false);

            if (!allowChangeShipping) {
                return (0, _squid.$promise)({
                    cartHasChanged: false,
                    rejected: false
                });
            }

            return (0, _util.callOnShippingChange)({ payload: payload, checkoutCart: checkoutCart });
        }
    };
}

angular.value("$ShippingChangeFactory", $ShippingChangeFactory);
_util.getCartTotal;

_util.getPayload;

_util.updateCart;

_util.callOnShippingChange;

_squid.$promise;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/outputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.payloadOutputMapper = exports.amountOutputMapper = exports.breakdownOutputMapper = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var breakdownOutputMapper = exports.breakdownOutputMapper = function breakdownOutputMapper() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        subtotal = _ref.subtotal,
        item_total = _ref.item_total,
        shipping = _ref.shipping,
        handling = _ref.handling,
        tax = _ref.tax,
        tax_total = _ref.tax_total,
        insurance = _ref.insurance,
        shipping_discount = _ref.shipping_discount,
        discount = _ref.discount;

    var breakdown = {
        item_total: subtotal || item_total,
        tax_total: tax || tax_total,
        handling: handling,
        shipping: shipping,
        insurance: insurance,
        discount: discount,
        shipping_discount: shipping_discount
    };

    return Object.keys(breakdown).reduce(function (newBreakdown, item) {
        var _$util$extend;

        if (!breakdown[item]) {
            return newBreakdown;
        }

        return _squid.$util.extend(newBreakdown, (_$util$extend = {}, _$util$extend[item] = amountOutputMapper(breakdown[item]), _$util$extend));
    }, {});
};

var amountOutputMapper = exports.amountOutputMapper = function amountOutputMapper() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        amount = _ref2.amount,
        value = _ref2.value,
        currency = _ref2.currency,
        currency_code = _ref2.currency_code,
        breakdown = _ref2.breakdown;

    var fullAmount = {
        value: amount || value,
        currency_code: currency || currency_code
    };

    return breakdown ? _squid.$util.extend(fullAmount, {
        breakdown: breakdownOutputMapper(breakdown)
    }) : fullAmount;
};

var shippingAddressMapper = function shippingAddressMapper() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        city = _ref3.city,
        state = _ref3.state,
        country_code = _ref3.country_code,
        postal_code = _ref3.postal_code;

    return {
        city: city,
        state: state,
        country_code: country_code,
        postal_code: postal_code
    };
};

var shippingOptionMapper = function shippingOptionMapper() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref4.id,
        label = _ref4.label,
        type = _ref4.type,
        amount = _ref4.amount,
        selected = _ref4.selected;

    if (!id) {
        return undefined;
    }
    return {
        id: id,
        type: type,
        label: label,
        amount: amountOutputMapper(amount),
        selected: selected
    };
};

var payloadOutputMapper = exports.payloadOutputMapper = function payloadOutputMapper(_ref5) {
    var orderID = _ref5.orderID,
        paymentID = _ref5.paymentID,
        shipping_address = _ref5.shipping_address,
        amount = _ref5.amount,
        selected_shipping_option = _ref5.selected_shipping_option;
    return {
        orderID: orderID,
        paymentID: paymentID,
        paymentToken: orderID,
        selected_shipping_option: shippingOptionMapper(selected_shipping_option),
        shipping_address: shippingAddressMapper(shipping_address),
        amount: amountOutputMapper(amount)
    };
};

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCartTotal = getCartTotal;
exports.getPayload = getPayload;
exports.updateCart = updateCart;
exports.callOnShippingChange = callOnShippingChange;

var _xoShippingOptions = __webpack_require__("../node_modules/xo-shipping-options/src/index.js");

var _outputMapper = __webpack_require__("../node_modules/xo-shipping-change/src/outputMapper.js");

function getCartTotal(cart) {
    var isPurchaseTransaction = cart && cart.get('purchase');

    if (isPurchaseTransaction) {
        var breakdown = Object.keys(cart.get('purchase.amounts')).reduce(function (acc, value) {
            if (value !== 'total') {
                acc[value] = (0, _outputMapper.amountOutputMapper)(cart.get('purchase.amounts.' + value));
            }

            return acc;
        }, {});

        return {
            currency_code: cart.get('purchase.amounts.total.currency_code'),
            value: cart.get('purchase.amounts.total.amount'),
            breakdown: breakdown
        };
    }

    return {
        currency_code: '',
        value: '0.00',
        breakdown: {}
    };
}

function getPayload() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        orderID = _ref.orderID,
        paymentID = _ref.paymentID,
        _ref$shippingAddress = _ref.shippingAddress,
        shippingAddress = _ref$shippingAddress === undefined ? {} : _ref$shippingAddress,
        checkoutCart = _ref.checkoutCart;

    var city = shippingAddress.city,
        state = shippingAddress.state,
        country = shippingAddress.country,
        postal_code = shippingAddress.postal_code;

    var amount = checkoutCart ? getCartTotal(checkoutCart) : {};

    var shippingChangePayload = {
        orderID: orderID,
        paymentID: paymentID,
        shipping_address: {
            city: city,
            state: state,
            country_code: country,
            postal_code: postal_code
        },
        selected_shipping_option: undefined,
        amount: amount
    };

    return (0, _xoShippingOptions.getSelectedShippingOption)(orderID).then(function (option) {
        shippingChangePayload.selected_shipping_option = option;
    }).then(function () {
        return (0, _outputMapper.payloadOutputMapper)(shippingChangePayload);
    });
}

function updateCart(cart) {
    cart.invalidate();
    cart.api.cache = false;

    return cart.reload().then(function () {
        return getCartTotal(cart);
    });
}

function callOnShippingChange() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        payload = _ref2.payload,
        checkoutCart = _ref2.checkoutCart;

    var rejected = false;
    var shippingOptionsChanged = false;
    var shippingOptions = void 0;

    var shippingChangeActions = {
        reject: function reject() {
            rejected = true;
        }
    };

    var cartTotal = getCartTotal(checkoutCart);

    var changedShippingOptions = function changedShippingOptions() {
        var oldOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var newOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        if (oldOptions.length !== newOptions.length) {
            return true;
        }

        return Boolean(newOptions.filter(function (key) {
            return JSON.stringify(newOptions[key]) !== JSON.stringify(oldOptions[key]);
        }).length);
    };

    return (0, _xoShippingOptions.getShippingOptions)(payload.orderID).then(function (options) {
        return shippingOptions = options;
    }).then(function () {
        return window.xprops.onShippingChange((0, _outputMapper.payloadOutputMapper)(payload), shippingChangeActions);
    }).then(function () {
        return (0, _xoShippingOptions.getShippingOptions)(payload.orderID);
    }).then(function (options) {
        shippingOptionsChanged = changedShippingOptions(shippingOptions, options);
    }).then(function () {
        return updateCart(checkoutCart);
    }).then(function (total) {
        var newCartTotal = getCartTotal(checkoutCart);
        var cartHasChanged = cartTotal.currency_code !== newCartTotal.currency_code || cartTotal.value !== newCartTotal.value;

        return {
            cartHasChanged: cartHasChanged || shippingOptionsChanged,
            rejected: rejected
        };
    });
}

_xoShippingOptions.getSelectedShippingOption;

_xoShippingOptions.getShippingOptions;

_outputMapper.amountOutputMapper;

_outputMapper.payloadOutputMapper;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _TYPE_CONTENT_MAPPING, _TAB_CONTENT_MAPPING;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tabs/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/select-simple/directive.js");

var _template = __webpack_require__("../node_modules/xo-shipping-options/src/component/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-shipping-options/src/component/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SHIPPING_TYPE = {
    SHIPPING: 'SHIPPING',
    PICKUP: 'PICKUP'
};

var TYPE_CONTENT_MAPPING = (_TYPE_CONTENT_MAPPING = {}, _TYPE_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING] = 'shipping.shipHome', _TYPE_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP] = 'shipping.shipStore', _TYPE_CONTENT_MAPPING);

var TAB_CONTENT_MAPPING = (_TAB_CONTENT_MAPPING = {}, _TAB_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING] = 'shipping.shipItTab', _TAB_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP] = 'shipping.pickItUp', _TAB_CONTENT_MAPPING);

exports['default'] = _squid.$Component.extend('$xoShippingOptionsComponent', {
    tag: 'xo-shipping-options',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        methods: {
            type: 'var',
            required: true
        },
        selectedMethod: {
            type: 'var',
            required: false
        },
        onSelect: {
            type: 'var',
            required: false
        },
        onClickEdit: {
            type: 'var',
            required: false
        },
        updateFinished: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        }
    },

    actions: {
        // Takes the buyer to the change-shipping page
        gotoShipping: function gotoShipping() {
            if (!this.canChangeShipping) {
                return;
            }

            if (typeof this.onClickEdit === 'function') {
                return this.onClickEdit();
            }

            _uiRouter.$state.go('checkout.review.sidebar.shipping');
        },
        setTab: function setTab(tab) {
            this.actions.setStateTo(tab.id);
        },
        getTabs: function getTabs() {
            if (!this.methods || !this.methods.length) {
                return [];
            }

            var hasShipping = Boolean(this.methods.filter(function (method) {
                return method.type === SHIPPING_TYPE.SHIPPING;
            }).length);
            var hasPickup = Boolean(this.methods.filter(function (method) {
                return method.type === SHIPPING_TYPE.PICKUP;
            }).length);

            var shippingTab = {
                id: SHIPPING_TYPE.SHIPPING,
                label: (0, _squid.$renderContent)(TAB_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING]).toString()
            };

            var pickupTab = {
                id: SHIPPING_TYPE.PICKUP,
                label: (0, _squid.$renderContent)(TAB_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP]).toString()
            };

            return [hasShipping && shippingTab, hasPickup && pickupTab].filter(function (tab) {
                return tab;
            });
        },


        // Switches the active tab (pickup or shipping)
        // Auto-selects method if it's the only item, or auto-selects if it was pre-selected
        // Will not auto-select if second param is false
        setStateTo: function setStateTo(state) {
            var _this = this;

            var autoSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


            this.state = state;

            var getSelectedTab = function getSelectedTab() {
                return _this.tabs.filter(function (tab) {
                    return tab.id === _this.state;
                }).pop();
            };

            this.selectedTab = getSelectedTab();

            if (!this.methods || !this.methods.length || !this.selectedTab || !autoSelect) {
                return;
            }

            var hasMultiShippingMethods = this.shippingMethods && this.shippingMethods.length > 1;
            var hasMultiPickupMethods = this.pickupMethods && this.pickupMethods.length > 1;

            if (state === SHIPPING_TYPE.SHIPPING) {
                // adding the check for this.selectedMethod ensures that if this.selectedShippingMethod
                // is stale it doesn't continue.
                if (this.selectedShippingMethod && this.selectedMethod) {
                    _logger.$logger.info('selected_shipping_method', {
                        shippingMethod: this.selectedShippingMethod,
                        selectedMethod: this.selectedMethod
                    });
                    return this.actions.selectShippingMethod(this.selectedShippingMethod);
                } else if (hasMultiShippingMethods) {
                    this.showMissingShippingOptionMessage = true;
                    this.showMissingPickupOptionMessage = true;
                    this.missingShippingOptionMessage = {
                        msgKeys: ['shippingMethod.shippingMethodWarning'],
                        type: 'warning'
                    };

                    // the second two parameters of onSelect only apply to hermes and trigger a change
                    // in the application to stop the payNow function

                    this.onSelect(null, this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
                }

                if (this.shippingMethods && this.shippingMethods.length === 1) {
                    return this.actions.selectShippingMethod(this.shippingMethods[0]);
                }
            }

            if (state === SHIPPING_TYPE.PICKUP) {
                // adding the check for this.selectedMethod ensures that if this.selectedPickupMethod
                // is stale it doesn't continue.
                if (this.selectedPickupMethod && this.selectedMethod) {
                    _logger.$logger.info('selected_pickup_method', {
                        shippingMethod: this.selectedPickupMethod,
                        selectedMethod: this.selectedMethod
                    });
                    return this.actions.selectShippingMethod(this.selectedPickupMethod);
                } else if (hasMultiPickupMethods) {
                    this.showMissingPickupOptionMessage = true;
                    this.showMissingShippingOptionMessage = true;
                    this.missingPickupOptionMessage = {
                        msgKeys: ['shippingMethod.pickupMethodWarning'],
                        type: 'warning'
                    };

                    // the second two parameters of onSelect only apply to hermes and trigger a change
                    // in the application to stop the payNow function

                    this.onSelect(null, this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
                }

                if (this.pickupMethods && this.pickupMethods.length === 1) {
                    return this.actions.selectShippingMethod(this.pickupMethods[0]);
                }
            }
        },


        // Set the local selected pickup/shipping method, then call the
        // callback passed via props with the method
        selectShippingMethod: function selectShippingMethod(selected) {
            var _this2 = this;

            var callCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


            var getShippingMethodByID = function getShippingMethodByID(id) {
                if (!id) {
                    return false;
                }

                return _this2.methods.find(function (method) {
                    return method.id === id;
                });
            };

            var shippingMethod = getShippingMethodByID(selected && selected.id);

            if (shippingMethod === undefined) {
                this.selectedPickupMethod = false;
                this.selectedShippingMethod = false;
                return this.onSelect(null);
            }

            this.selectedMethod = shippingMethod;

            if (!this.state !== selected.type) {
                this.actions.setStateTo(SHIPPING_TYPE[selected.type], false);
            }

            if (shippingMethod.type === SHIPPING_TYPE.SHIPPING) {
                this.showMissingShippingOptionMessage = false;
                this.showMissingPickupOptionMessage = false;
                this.selectedShippingMethod = this.formatShippingMethod(shippingMethod);
            } else if (shippingMethod.type === SHIPPING_TYPE.PICKUP) {
                this.showMissingShippingOptionMessage = false;
                this.showMissingPickupOptionMessage = false;
                this.selectedPickupMethod = this.formatShippingMethod(shippingMethod);
            } else {
                this.state = SHIPPING_TYPE.SHIPPING;
            }

            if (callCallback) {
                this.onSelect((0, _angular.extend)({}, shippingMethod), this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
            } else {
                this.onSelect(null, false, false);
            }
        },


        // Helper to map shipping methods passed by the props and
        // select only the ones that fit the 'type'.
        mapShippingMethodsByType: function mapShippingMethodsByType() {
            var _this3 = this;

            var shippingMethods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var type = arguments[1];

            return shippingMethods.filter(function (shippingMethod) {
                return SHIPPING_TYPE[shippingMethod.type] === type;
            }).map(function (shippingMethod) {
                return _this3.formatShippingMethod(shippingMethod);
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            this.formatShippingMethod = function (method) {
                if (!method || (0, _angular.equals)(method, {})) {
                    return false;
                }

                var getFormattedLabel = function getFormattedLabel() {
                    if (!method.amount || parseFloat(method.amount.value) <= 0) {
                        return method.label;
                    }

                    var amountFormatted = (0, _squid.formatCurrency)(method.amount.value, method.amount.currency_code || method.amount.currency);

                    return (0, _squid.$renderContent)('shipping.customLabelAndAmount', {
                        amount: amountFormatted,
                        label: method.label
                    }).toString();
                };

                return (0, _angular.extend)({}, method, {
                    label: getFormattedLabel()
                });
            };

            // Dropdown active flag
            this.isPickupDropdownActive = false;
            this.isShippingDropdownActive = false;

            // Initiate the shipWarning messages
            this.showMissingPickupOptionMessage = false;
            this.showMissingShippingOptionMessage = false;

            this.isPickup = function () {
                return _this4.state === SHIPPING_TYPE.PICKUP;
            };
            this.isShipping = function () {
                return _this4.state === SHIPPING_TYPE.SHIPPING;
            };

            this.pickupLabel = (0, _squid.$renderContent)(TYPE_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP]).toString();
            this.shippingLabel = (0, _squid.$renderContent)(TYPE_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING]).toString();

            this.selectedPickupMethod = false; // eslint-disable-line no-unused-expressions
            this.selectedShippingMethod = false; // eslint-disable-line no-unused-expressions


            this.formatShippingMethods = function () {

                if (!_this4.methods) {
                    return;
                }

                _logger.$logger.info('new_shipping_methods_propagated', {
                    'new_shipping_methods': _this4.methods
                });

                var relaventSelected = !_this4.selectedMethod || !_this4.selectedMethod.label ? false : !!_this4.methods.find(function (option) {
                    return option.label === _this4.selectedMethod.label && option.id === _this4.selectedMethod.id;
                });

                if (!relaventSelected) {
                    _this4.selectedMethod = null;
                }

                _this4.pickupMethods = _this4.actions.mapShippingMethodsByType(_this4.methods, SHIPPING_TYPE.PICKUP);
                _this4.shippingMethods = _this4.actions.mapShippingMethodsByType(_this4.methods, SHIPPING_TYPE.SHIPPING);

                _this4.tabs = _this4.actions.getTabs();

                // We'll render dual tabs ONLY when there are TWO Shipping types sent by the merchant
                _this4.renderTabs = Boolean(_this4.tabs.length > 1);

                if (_this4.selectedMethod) {
                    _this4.actions.selectShippingMethod(_this4.selectedMethod, false);
                    _this4.selectedMethod = null;
                } else if (_this4.methods && _this4.methods.length) {
                    var assigned = _this4.methods.find(function (_ref) {
                        var selected = _ref.selected;
                        return selected;
                    });

                    if (!assigned) {
                        _this4.state = _this4.shippingMethods.length ? SHIPPING_TYPE.SHIPPING : SHIPPING_TYPE.PICKUP;
                    } else {
                        _this4.actions.setStateTo(assigned.type);
                        if (!_this4.selectedMethod) {
                            _this4.actions.selectShippingMethod(assigned, false);
                        }
                    }
                }

                if (typeof _this4.updateFinished === 'function') {
                    _this4.updateFinished(_this4.methods);
                }
            };

            // this.formatShippingMethods();

            this.$watch('methods', function () {
                _this4.formatShippingMethods();
            });

            // when clicking outside the dropdown
            this.$on('clickBody', function () {
                _this4.isPickupDropdownActive = false;
                _this4.isShippingDropdownActive = false;
            });
        },
        populate: function populate() {
            var allowChangeShipping = this.models.checkoutAppData.get('flags.allow_change_shipping');

            // Only allow buyer to change shipping address if allowed
            this.canChangeShipping = typeof this.onClickEdit === 'function' || allowChangeShipping;
            this.showShippingAddress = Boolean(!this.models.checkoutAppData.flags.hide_shipping_address && this.models.checkoutSession && this.models.checkoutSession.shipping);
        }
    }
});


_angular.noop;

_angular.extend;

_angular.equals;

_uiRouter.$state;

_squid.$Component;

_squid.$renderContent;

_squid.formatCurrency;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"shippingOptionsForm\" content>\n    <xo-ui-tabs\n        ng-if=\"renderTabs\"\n        on-select=\"actions.setTab\"\n        selected-tab=\"selectedTab\"\n        tabs=\"tabs\"\n    ></xo-ui-tabs>\n\n    <!-- Shipping Tab -->\n    <div ng-if=\"isShipping()\">\n\n        <!--Address display section-->\n        <div\n            ng-if=\"showShippingAddress\"\n            id=\"shippingAddress\"\n            class=\"address focusable\"\n            ng-class=\"{ noTop: !renderTabs, editable:canChangeShipping}\"\n            focusable=\"canChangeShipping\"\n            select-button ng-click=\"actions.gotoShipping()\">\n            <span class=\"given-name\">{{models.checkoutSession.shipping.name}}</span>\n            <xo-address-display\n                token=\"token\"\n                address=\"models.checkoutSession.shipping\"\n            ></xo-address-display>\n            <a\n                ng-if=\"canChangeShipping\"\n                class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\"\n                data-test-id=\"shipToChangeLink\"\n                select-button focusable=\"!cannotChangeShippingInfoMessages\"\n                ng-click=\"actions.gotoShipping()\"\n                aria-label=\"{{ content('shippingAddress.label') }}\"\n                focus-when-state=\"checkout.review.sidebar.shipping\"\n                transitions-to=\"checkout.review\">\n                {{ content('common.change') }}\n                <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n            </a>\n        </div>\n\n        <div ng-if=\"!models.checkoutSession.shipping\">\n            <p class=\"optionTypeInfo\" ng-class=\"{ noTop: !renderTabs }\" ng-bind-html=\"content('shippingMethod.guestMerchantOptions')\">\n        </div>\n\n        <div class=\"missing-message\">\n            <xo-message ng-if=\"showMissingShippingOptionMessage\" message=\"missingShippingOptionMessage\"></xo-message>\n        </div>\n\n        <xo-ui-select-simple\n            ng-if=\"shippingMethods.length > 1\"\n            default-text=\"content('shipping.selectShippingMethod').toString()\"\n            label=\"shippingLabel\"\n            options=\"shippingMethods\"\n            selected-option=\"selectedShippingMethod\"\n            on-select=\"actions.selectShippingMethod\"\n        ></xo-ui-select-simple>\n\n        <div ng-if=\"shippingMethods.length === 1 && selectedShippingMethod\">\n            <p class=\"optionSelected\" ng-bind-html=\"selectedShippingMethod.label\">\n        </div>\n    </div>\n\n    <!-- Pick Up Tab -->\n    <div ng-if=\"isPickup()\" class=\"pickupSelection\">\n\n        <div>\n            <p class=\"optionTypeInfo\" ng-class=\"{ noTop: !renderTabs }\" ng-bind-html=\"content('shippingMethod.guestMerchantOptions')\">\n        </div>\n\n        <div class=\"missing-message\">\n            <xo-message class=\"missing-message\" ng-if=\"showMissingPickupOptionMessage\" message=\"missingPickupOptionMessage\"></xo-message>\n        </div>\n\n        <xo-ui-select-simple\n            ng-if=\"pickupMethods.length > 1\"\n            default-text=\"content('shipping.selectPickUpLocation').toString()\"\n            label=\"pickupLabel\"\n            options=\"pickupMethods\"\n            selected-option=\"selectedPickupMethod\"\n            on-select=\"actions.selectShippingMethod\">\n        </xo-ui-select-simple>\n\n        <div ng-if=\"pickupMethods.length === 1 && selectedPickupMethod\">\n            <p class=\"optionSelected\" ng-bind-html=\"selectedPickupMethod.label\">\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _directive = __webpack_require__("../node_modules/xo-shipping-options/src/component/directive.js");

Object.defineProperty(exports, '$xoShippingOptions', {
  enumerable: true,
  get: function get() {
    return _directive.$xoShippingOptions;
  }
});

var _lib = __webpack_require__("../node_modules/xo-shipping-options/src/lib/index.js");

Object.keys(_lib).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lib[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/api.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.selectShippingOption = exports.getSelectedShippingOption = exports.getShippingOptions = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _cart = __webpack_require__("../node_modules/xo-shipping-options/src/lib/cart.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

/*
    Shipping Option API

    For now, this is strictly client-side and comes from the
    incontext flow.
*/

var getShippingOptions = exports.getShippingOptions = function getShippingOptions(token) {
    var checkoutCart = _checkout.$CheckoutCartModel.instance(token);

    return checkoutCart.reload().then(function () {
        var shippingOptions = checkoutCart.get('purchaseUnits.0.item_list.shipping_options');

        if (shippingOptions && shippingOptions.length) {
            _logger.$logger.info('shipping_options_from_cart', shippingOptions);
        } else {
            _logger.$logger.info('no_shipping_options_from_cart');
            return;
        }

        return shippingOptions.map(function (options) {
            return {
                id: options.id,
                type: options.type,
                amount: options.amount,
                label: options.label,
                selected: options.selected
            };
        });
    });
};

var getSelectedShippingOption = exports.getSelectedShippingOption = function getSelectedShippingOption(token) {
    return getShippingOptions(token).then(function (shippingOptions) {
        if (!shippingOptions || !shippingOptions.length) {
            return undefined;
        }

        var selectedShippingOption = shippingOptions.filter(function (option) {
            return option.selected;
        }).pop();

        if (selectedShippingOption) {
            _logger.$logger.info('selected_shipping_option_from_cart', selectedShippingOption);
            return selectedShippingOption;
        } else {
            _logger.$logger.info('no_shipping_option_from_cart');
        }
    });
};

var buildAmountPatchEntity = function buildAmountPatchEntity(amount, token) {
    return {
        field: 'purchaseAmount',
        value: (0, _cart.retotalCart)(token, !!amount && !!amount.value ? amount.value : '0.00')
    };
};

var selectShippingOption = exports.selectShippingOption = function selectShippingOption(token, option) {
    var checkoutCart = _checkout.$CheckoutCartModel.instance(token);
    var checkoutSession = _checkout.$CheckoutSessionModel.instance(token);

    return checkoutCart.retrieve().then(function () {
        return getShippingOptions(token);
    }).then(function (shippingOptions) {

        var newShippingOptions = shippingOptions.map(function (newOption) {
            return _squid.$util.extend(newOption, {
                selected: option.id === newOption.id
            });
        });

        var shippingOptionsPatch = {
            field: 'shippingOptions',
            value: newShippingOptions
        };

        var cartAmountPatch = buildAmountPatchEntity(option.amount, token);

        // add cartAmountPatch to the patchEntities array if option.amount is not null
        return checkoutCart.action('patchCartData', {
            data: {
                id: token,
                patchEntities: [shippingOptionsPatch, cartAmountPatch]
            }
        }).then(function (result) {
            return checkoutSession.reload().then(function () {
                return result;
            });
        });
    });
};

_squid.$util;

_logger.$logger;

_cart.retotalCart;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/cart.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.retotalCart = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

// Re-totals the cart with new shipping costs.
//
// @param token: PAY token/Cart ID
// @param shippingAmount: String float amount (Ex: '15.00')
// @returns amount: Amount object with new total and breakdown

var retotalCart = exports.retotalCart = function retotalCart(token, shippingAmount) {
    var checkoutCart = _checkout.$CheckoutCartModel.instance(token);
    var currencyCode = checkoutCart.grossTotalAmount.currency;
    var currencyDigits = _squid.$locale.metadata && _squid.$locale.metadata.currency && _squid.$locale.metadata.currency.digits;
    var decimalDigits = isNaN(currencyDigits && currencyDigits[currencyCode]) ? 2 : currencyDigits && currencyDigits[currencyCode];

    // Takes an integer/string and formats as a float
    var formatAmount = function formatAmount(amount) {
        return parseFloat(amount).toFixed(decimalDigits);
    };

    // Sums all of the arguments
    var sumAmounts = function sumAmounts() {
        for (var _len = arguments.length, amounts = Array(_len), _key = 0; _key < _len; _key++) {
            amounts[_key] = arguments[_key];
        }

        return amounts.reduce(function (total, amount) {
            return formatAmount(parseFloat(total) + parseFloat(amount));
        }, '0');
    };

    // Sums up all of the amount details (except the total)
    var sumDetails = function sumDetails(details) {
        var blacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        return Object.keys(details).reduce(function (value, detail) {
            var detailValue = details[detail];

            if (blacklist.indexOf(detail) !== -1) {
                return value;
            }
            switch (detail) {
                case 'shipping_discount':
                case 'discount':
                    return sumAmounts(formatAmount(parseFloat(detailValue) * -1), value);
                default:
                    return sumAmounts(details[detail], value);
            }
        }, '0');
    };

    // Simplifies the checkout cart amounts with just a simple key-value { detail: cost } format
    var oldTotal = checkoutCart.get('purchase.amounts.total.amount', formatAmount(0));

    var oldDetails = Object.keys(checkoutCart.get('purchase.amounts', {})).reduce(function (details, name) {
        var _extend;

        var amount = checkoutCart.get('purchase.amounts.' + name + '.amount', formatAmount(0));

        return name === 'total' ? details : (0, _angular.extend)({}, details, (_extend = {}, _extend[name] = amount, _extend));
    }, {});

    // Create a new amount details object with new shipping cost, and subtotal (if it was left out)
    var newDetails = (0, _angular.extend)({}, oldDetails, {
        shipping: formatAmount(shippingAmount),
        subtotal: formatAmount(parseFloat(oldTotal) - parseFloat(sumDetails(oldDetails, ['subtotal', 'total'])))
    });

    // Sum up all of the new amount details for the new total
    var newTotal = sumDetails(newDetails, ['total']);

    return {
        currency: currencyCode,
        total: newTotal,
        details: newDetails
    };
};

_squid.$locale;

_angular.extend;

_checkout.$CheckoutCartModel;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _api = __webpack_require__("../node_modules/xo-shipping-options/src/lib/api.js");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _cart = __webpack_require__("../node_modules/xo-shipping-options/src/lib/cart.js");

Object.keys(_cart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cart[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/xo-styles/dist/lib/toggle.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/styles.less");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoReviewPayWithBaiduComponent', {
    tag: 'xo-review-paywith-baidu',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var checkoutSession = this.models.checkoutSession;


            this.showAmt = true;
            this.defaultFs = checkoutSession.get('plan.sources');
        }
    }
});


_angular.noop;

_squid.$Component;

_checkout.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView pwBaidu\" content>\n    <div class=\"trayInner trayInnerDefault\" >\n        <div id=\"paymentMethod\">\n\n            <h4 class=\"noBottom paymentsHeader zeta\">\n                <span>\n                    {{ content('paymentMethod.payWith') }}\n                </span>\n            </h4>\n            <div class=\"charges\">\n                <div ng-repeat=\"fs in defaultFs\" class=\"clearfix fs\">\n                    <div ng-class=\"['method', 'EXTERNAL_WALLET']\">\n                        <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                        <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                         <span class=\"name\" ng-if=\"fs.type === 'EXTERNAL_WALLET'\">\n                             {{ content('paymentMethod.baiduWallet') }}\n                         </span>\n                    </div>\n                    <span ng-if=\"showAmt\" class=\"methodAmount\">\n                        <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/styles.less");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
    tag: 'xo-review-paywith-venmo',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            var _this = this;

            return _auth.$AuthModel.instance().retrieve().then(function (auth) {

                if (auth.get('tenant') === 'VENMO') {
                    return {
                        venmoUser: _venmoModels.$VenmoUserModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutSession: _checkout.$CheckoutSessionModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutCart: _checkout.$CheckoutCartModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        payee: _checkout.$CheckoutPayeeModel.instance(_this.token).retrieve()['catch'](_angular.noop)
                    };
                } else {
                    return {
                        venmo: _venmoModels.$VenmoOnboardModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutSession: _checkout.$CheckoutSessionModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutCart: _checkout.$CheckoutCartModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        payee: _checkout.$CheckoutPayeeModel.instance(_this.token).retrieve()['catch'](_angular.noop)
                    };
                }
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            var _models = this.models,
                payee = _models.payee,
                venmo = _models.venmo,
                venmoUser = _models.venmoUser,
                checkoutCart = _models.checkoutCart,
                checkoutAppData = _models.checkoutAppData,
                checkoutSession = _models.checkoutSession;

            this.isBillingAgreementsEnabled = Boolean(checkoutCart.get('billing'));
            this.merchantName = checkoutAppData.get('merchant.brand_name') || checkoutAppData.get('merchant.merchant_name') || 'the merchant';
            this.intentNotSale = checkoutCart.get('payment_action') !== 'sale';
            var getAmount = function getAmount() {
                return checkoutSession.get('plan.sources.0.amount');
            };
            var mapperFS = {
                BALANCE: function BALANCE(fs) {
                    return {
                        type: fs.funding_mode || fs.fundingMode,
                        amount: getAmount()
                    };
                },
                PAYMENT_CARD: function PAYMENT_CARD(fs) {
                    return {
                        type: fs.funding_mode || fs.fundingMode,
                        card_type: fs.payment_card && fs.payment_card.type || fs.fundingName,
                        sub_type: 'INSTANT_TRANSFER',
                        name: fs.payment_card && fs.payment_card.type || fs.fundingName,
                        last4: fs.payment_card && fs.payment_card.number || fs.fundingNumber,
                        amount: getAmount()
                    };
                },
                BANK_ACCOUNT: function BANK_ACCOUNT(fs) {
                    return {
                        type: fs.funding_mode || fs.fundingMode,
                        sub_type: 'INSTANT_TRANSFER',
                        name: fs.bank_account && fs.bank_account.bank_name || fs.fundingName,
                        last4: fs.bank_account && fs.bank_account.account_number || fs.fundingNumber,
                        amount: getAmount()
                    };
                }
            };

            function determineShowAmt() {
                var userAction = checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && checkoutCart.get('purchase.items.length') === 0;

                return (0, _pxp.$pxpCartAmt)(checkoutAppData.get('merchant.merchant_country'), payee.get('merchant.id'), noLineItemDetails, checkoutCart.isPurchase()).then(function (showAmount) {
                    return checkoutCart.get('payment_action') !== 'authorize' && showAmount;
                });
            }

            function getPlanList() {
                var defaultFS = venmo && venmo.get('funding_sources.default_option') || venmoUser && venmoUser.get('funding_sources.defaultOption');
                var defaultFundingMode = defaultFS && (defaultFS.funding_mode || defaultFS.fundingMode);

                if (defaultFundingMode && mapperFS[defaultFundingMode]) {
                    return [mapperFS[defaultFundingMode](defaultFS)];
                } else {
                    return checkoutSession.get('plan.sources');
                }
            }

            function getBackup() {
                var backup = venmo && venmo.get('funding_sources.alternate_option') || venmoUser && venmoUser.get('funding_sources.alternateOption');
                var backupFundingMode = backup && (backup.funding_mode || backup.fundingMode);

                if (backupFundingMode && mapperFS[backupFundingMode]) {
                    return mapperFS[backupFundingMode](backup);
                }
            }

            this.venmoUser = '@' + (venmo && venmo.get('username') || venmoUser && venmoUser.get('username'));
            determineShowAmt().then(function (shouldShowAmt) {
                _this2.showAmt = shouldShowAmt;
            });
            this.defaultFs = getPlanList();
            this.backupFs = getBackup();
        }
    }
});


_angular.noop;

_squid.$Component;

_venmoModels.$VenmoOnboardModel;

_venmoModels.$VenmoUserModel;

_pxp.$pxpCartAmt;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_auth.$AuthModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView pwVenmo\" content>\n    <div class=\"trayInner trayInnerDefault\" >\n        <div id=\"paymentMethod\">\n\n            <h4 class=\"noBottom paymentsHeader zeta\">\n                <span>\n                    {{ content('paymentMethod.payWith') }}\n                </span>\n            </h4>\n            <ul class=\"charges\">\n                <li ng-repeat=\"fs in defaultFs\" class=\"clearfix fs\">\n                    <div ng-class=\"['method', 'BALANCE']\">\n                        <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                        <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                        <span class=\"name\" ng-if=\"fs.type === 'BALANCE'\">\n                             {{ content('paymentMethod.venmoBalance') }}\n                         </span>\n                        <span class=\"name\" ng-if=\"fs.type !== 'BALANCE'\">\n                            <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit\">\n                                {{fs.name}}\n                            </span>\n                            <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                            </span>\n                        </span>\n                    </div>\n                    <span ng-if=\"showAmt\" class=\"methodAmount\">\n                        <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                    </span>\n                    <span class=\"venmoUsername\">\n                        {{venmoUser}}\n                    </span>\n                </li>\n            </ul>\n\n            <div ng-if=\"isBillingAgreementsEnabled\">\n                <div class=\"backup\">\n                    <p bind-html-compile=\"htmlContent('paymentMethod.venmoBillingAgreement', {merchant: merchantName})\"></p>\n                </div>\n            </div>\n\n            <div ng-if=\"!isBillingAgreementsEnabled\">\n\n                <div class=\"backup\">\n                    <p bind-html-compile=\"htmlContent('paymentMethod.venmoAbrigedLearnMore')\"></p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.thirdPartyExperience = exports.venmoExperience = exports.thirdPartyInfo = undefined;
exports.redirect = redirect;
exports.getUserAgent = getUserAgent;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _sessionStorage = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js");

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// TODO: Check how the cookie should be read/set (through meta? if read on server side)
var PWV_COOKIE = 'pwv';
var BA = 'BILLING_AGREEMENT';

var cancelLogoutEventListener = _angular.$rootScope.$on('logout', function (event, args) {

    // disable venmo models when ready
    var token = _angular.$rootScope.token;

    _venmoModels.$VenmoUserModel.instance(token).invalidate();
    _venmoModels.$VenmoOnboardModel.instance(token).invalidate();
    thirdPartyExperience.resetThirdPartyExperience();
});

_angular.$rootScope.$on('$destroy', cancelLogoutEventListener);

var readCookie = function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0, len = ca.length; i < len; i++) {
        var c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};

var thirdPartyInfo = exports.thirdPartyInfo = {
    /**
     * @name isThirdPartyEligible
     * @returns {Promise}
     */
    isThirdPartyEligible: function isThirdPartyEligible() {
        var _this = this;

        return this.isBaiduEligible().then(function (baiduEligibility) {
            return _this.isVenmoEligible() || baiduEligibility;
        });
    },


    /**
     * @name isBaiduEligible
     * @returns {Promise}
     */
    isBaiduEligible: function isBaiduEligible() {
        return _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token, {
            params: {
                geolocation: _squid.$meta.geolocation
            }
        }).retrieve().then(function (eligibility) {
            _logger.$logger.info('baidu_eligibility', eligibility);
            return eligibility.baiduWallet;
        });
    },


    /**
     * @name isVenmoEligible
     * @description Handler to call to determine if user can use Venmo
     * @returns {Boolean}
     */
    isVenmoEligible: function isVenmoEligible() {
        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var merchantCountry = appData.get('merchant.merchant_country');
        var isProcessorDeclined = appData.get('flags.processor_declined');
        var isInvoice = appData.get('flags.is_invoice_flow');
        var isBillingAgreement = cart.isBilling();
        var isMobile = _index.$DeviceInfo.isDevice();
        var isVenmoCookie = this.isVenmoCookiePresent();
        var isSFAuthenticationSession = _squid.$util.param('bt_int_type') === '2';
        var isMSPTransaction = cart.isMultiSellerPurchase();
        var eligibilityParams = {
            isMobile: isMobile,
            isVenmoCookie: isVenmoCookie,
            isNotInvoice: !isInvoice,
            isNotProcessorDeclined: !isProcessorDeclined,
            isNotBillingAgreement: !isBillingAgreement,
            isUSMerchant: merchantCountry === 'US',
            isNotSFAuthenticationSession: !isSFAuthenticationSession,
            isNotMSPTransaction: !isMSPTransaction
        };

        var venmoEligibility = Object.keys(eligibilityParams).filter(function (param) {
            return !eligibilityParams[param];
        });
        venmoEligibility = venmoEligibility && venmoEligibility.length > 0 ? 'ineligible:' + venmoEligibility.join() : 'eligible';

        _logger.$logger.info('venmo_eligibility', venmoEligibility);

        _logger.$logger.info('checkout_fpti', {
            'is_venmo_cookie': isVenmoCookie ? '1' : '0',
            'eligibility_reason': venmoEligibility
        });

        return Boolean(venmoEligibility === 'eligible');
    },


    /**
     * @name isVenmoCookiePresent
     * @returns {Boolean}
     */
    isVenmoCookiePresent: function isVenmoCookiePresent() {
        var cookieValue = readCookie(PWV_COOKIE);

        return Boolean(cookieValue);
    },


    /**
     * @name buildVenmoURL
     * @description Build the venmo URL scheme
     * @returns {String}
     */
    buildVenmoURL: function buildVenmoURL() {
        // SCHEME needs to change according to old or new experience
        // const linkType = venmoUrlSchemeType();
        var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL['universal'];
        var VENMO_ROUTE = '#/checkout/venmo';
        var LOGIN_ROUTE = '#/checkout/login?venmoError=true';
        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);

        var token = void 0;
        var total = void 0;
        var currency = void 0;
        var intent = void 0;

        // Send BA token when it's BA without Purchase
        if (cartModel.get('billing.ba_token') && cartModel.get('purchase.amounts.total.amount', '0') === '0') {
            token = cartModel.get('billing.ba_token');
        } else {
            // Send EC token when it's BA without purchase.
            token = _angular.$rootScope.token;
        }

        // For BA: setting billing agreement as payment_action explicitly, not relying on payment action returned in cart
        intent = cartModel.billing ? BA : cartModel.payment_action;

        // total cannot be undefined, outdated venmo app clients will crash otherwise
        total = cartModel.get('purchase.amounts.total.amount', '0');
        currency = cartModel.get('purchase.amounts.total.currency_code', 'none');

        var params = (0, _angular.$httpParamSerializer)({
            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
            'ua': _angular.$window.navigator.userAgent,
            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
            'token': token,
            total: total,
            currency: currency, // can be undefined for BA w/o purchase
            intent: intent
        });

        return SCHEME + '?' + params;
    }
};

var venmoExperienceKey = 'VENMO_EXPERIENCE';

// Get whether a token is marked as Venmo experience.
var venmoExperience = exports.venmoExperience = {
    set: function set(token) {
        var sessionStorage = (0, _sessionStorage2['default'])();

        sessionStorage.setItem(venmoExperienceKey, token);
    },
    get: function get(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
        sessionStorage.getItem(venmoExperienceKey) === token) {
            return true;
        } else {
            this.set(null);
            return false;
        }
    }
};

var allowedThirdPartyExperiences = {
    VENMO: 'VENMO_EXPERIENCE',
    BAIDU: 'BAIDU_EXPERIENCE'
};

var THIRD_PARTY_NAMESPSACE = 'THIRD_PARTY_EXPERIENCE';

var thirdPartyExperience = exports.thirdPartyExperience = {
    setAsVenmoExperience: function setAsVenmoExperience(token) {
        var _JSON$stringify;

        var sessionStorage = (0, _sessionStorage2['default'])();
        var payload = JSON.stringify((_JSON$stringify = {}, _JSON$stringify[token] = allowedThirdPartyExperiences['VENMO'], _JSON$stringify));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    setAsBaiduExperience: function setAsBaiduExperience(token) {
        var _JSON$stringify2;

        var sessionStorage = (0, _sessionStorage2['default'])();
        var payload = JSON.stringify((_JSON$stringify2 = {}, _JSON$stringify2[token] = allowedThirdPartyExperiences['BAIDU'], _JSON$stringify2));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    isThirdPartyExperience: function isThirdPartyExperience(token) {
        var availableExperiences = [];

        for (var key in allowedThirdPartyExperiences) {
            availableExperiences.push(allowedThirdPartyExperiences[key]);
        }

        var currentExperience = this.getExperience(token);

        return Boolean(availableExperiences.indexOf(currentExperience) > -1);
    },
    getExperience: function getExperience(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        // if logged in, and guest, we return the experience if any
        if (auth.logged_in && auth.guest && sessionStorage.getItem(THIRD_PARTY_NAMESPSACE)) {
            var payload = JSON.parse(sessionStorage.getItem(THIRD_PARTY_NAMESPSACE) || '');

            return payload && payload[token] || 'MEMBER_EXPERIENCE';
        } else if (auth.logged_in && auth.tenant === 'VENMO') {
            return allowedThirdPartyExperiences['VENMO'];
        } else {
            // If not logged in, we reset the third party experience
            this.resetThirdPartyExperience();
            return 'MEMBER_EXPERIENCE';
        }
    },
    resetThirdPartyExperience: function resetThirdPartyExperience() {
        var sessionStorage = (0, _sessionStorage2['default'])();

        sessionStorage.removeItem(THIRD_PARTY_NAMESPSACE);
    }
};

// used to trigger app switches and flush the logs before doing so
function redirect(url) {
    return _logger.$logger.flush().then(function () {
        _angular.$window.location.replace(url);
    });
}

// fetching browser's user agent.
function getUserAgent() {
    return _angular.$window.navigator.userAgent;
}

_squid.$config;

_squid.$util;

_squid.$meta;

_logger.$logger;

_auth.$AuthModel;

_index.$DeviceInfo;

_angular.$rootScope;

_angular.$window;

_angular.$location;

_angular.$httpParamSerializer;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$FlowEligibilityModel;

_venmoModels.$VenmoOnboardModel;

_venmoModels.$VenmoUserModel;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports['default'] = getSessionStorage;
var store = {};

// Polyfill for sessionStorage if not available. Simple variable store

function getSessionStorage() {
    try {

        window['sessionStorage'].setItem('__feature_test__', '0');
        window['sessionStorage'].removeItem('__feature_test__');
        return window.sessionStorage;
    } catch (err) {
        return {
            getItem: function getItem(key) {
                if (arguments < 1) {
                    throw new Error('1 argument required');
                }
                return store[key];
            },
            setItem: function setItem(key, val) {
                if (arguments < 2) {
                    throw new Error('2 arguments required');
                }
                store[key] = val;
            },
            removeItem: function removeItem(key) {

                delete store[key];
            }
        };
    }
}
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-billing/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-billing/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-third-party-components/src/venmo-billing/style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$VenmoAddBilling', {
    tag: 'venmo-add-billing',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        },
        sidebar: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.country = _squid.$locale.getCountryCodeISO();
            this.billing = true;
            this.address = this.address || { country: this.country };
        },
        populate: function populate() {
            var $el = (0, _jquery2['default'])(this.$element);
            var handleValidation = function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = (0, _jquery2['default'])($el.find('[name="' + field.field + '"]'));

                            if ($field.length === 0 && field.field === 'zip') {
                                $field = (0, _jquery2['default'])($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                            }
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                        }
                    });
                }

                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            };

            this.done = function () {
                this.goto('checkout.review');
            };

            this.error = function () {
                this.goto('checkout.login', { venmoError: true });
            };

            this.onSubmit = function () {
                this.validateAddress();
            };

            this.validateAddress = function () {
                var self = this;
                var newBilling = new _index.$BillingAddressModel({
                    line1: this.address.line1,
                    line2: this.address.line2,
                    city: this.address.city,
                    state: this.address.state,
                    postal_code: this.address.postal_code,
                    country: this.country,
                    id: '0'
                });

                newBilling.save({
                    success: function success() {
                        if (self && self.models && self.models.checkoutSession && self.models.checkoutSession.plan && self.models.checkoutSession.plan.sources && self.models.checkoutSession.plan.sources['0'] && self.models.checkoutSession.plan.sources['0'].instrument_id) {
                            // if there's a checkout plan
                            var instrumentID = self.models.checkoutSession.plan.sources['0'].instrument_id;

                            self.saveBillingAddressAndReturn(instrumentID);
                        } else if (self.models.checkoutSession.getSelectedStickyInstrument()) {
                            // if there's a Billing Agreement without purchase
                            var _instrumentID = self.models.checkoutSession.getSelectedStickyInstrument().instrument_id;

                            self.saveBillingAddressAndReturn(_instrumentID);
                        } else {
                            // if no instrument, we should error out
                            self.error();
                        }
                    },
                    validation: function validation(res) {
                        handleValidation(res);
                    },
                    error: function error(err) {
                        _logger.$logger.error('venmoBillingAddressValidateError', err);
                        self.error();
                    }
                });
            };

            this.saveBillingAddressAndReturn = function (instrumentID) {
                var self = this;
                var add = {
                    newAddress: {
                        address1: this.address.line1,
                        address2: this.address.line2,
                        city: this.address.city,
                        state: this.address.state,
                        zip: this.address.postal_code,
                        isoCountry: this.country
                    }
                };
                var billingAddress = new _index.$AddBillingAddressModel({ instrumentid: instrumentID });

                billingAddress.save({
                    data: add,
                    success: function success() {
                        _logger.$logger.info(['venmo-billing directive', 'Billing Address', 'added'].join('::'));
                        // Fix: Need to have a better solution
                        _logger.$logger.info(['venmo-billing directive', 'Calling checkout session again'].join('::'));

                        var sessionModel = _checkout.$CheckoutSessionModel.instance(self.token);
                        var cartModel = _checkout.$CheckoutCartModel.instance(self.token);
                        var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(self.token);

                        sessionModel.action('create', {
                            data: {
                                fraudnet_id: cartModel.supplementary && cartModel.supplementary.risk_correlation_id,
                                baToken: cartModel.billing && cartModel.billing.ba_token,
                                user_selected_funding_source: {
                                    dcvv: venmoOnboardModel.dcvv,
                                    product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                                },
                                is_skip_gfo: true
                            },
                            success: function success() {
                                self.done();
                            }
                        });
                    },
                    validation: function validation(err) {
                        _logger.$logger.error('venmoBillingAddressValidationError', err);
                        self.error();
                    },
                    error: function error(err) {
                        _logger.$logger.error('venmoAddBillingAddressError', err);
                        self.error();
                    }
                });
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_venmoModels.$VenmoOnboardModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_index.$BillingAddressModel;

_index.$AddBillingAddressModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-billing/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-billing/directive.js");

var _directive2 = _interopRequireDefault(_directive);

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$VenmoAddBillingRoute', {
    path: 'addBilling',
    directive: _directive2['default'],
    titleContent: 'addBillingAddress.title',

    trackingData: {
        fptiState: 'edit_billing'
    },
    loginRequired: true
});


_squid.$Route;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-billing/style.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-billing/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addBillingAddress\" ng-if=\"billing\" modal-box=\"address\">\n\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar && !debitCardFlow\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <input track-submit  type=\"submit\" id=\"proceedButton-venmoBA\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-info-gather/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/emailInput/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-info-gather/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-third-party-components/src/venmo-info-gather/style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$VenmoInfoGather', {
    tag: 'venmo-info-gather',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: false
        },
        sidebar: {
            type: 'var',
            optional: false
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this = this;

            this.actions.clearFieldErrors();
            this.actions.validateAddress().then(function (validations) {
                var billing = validations[0],
                    shipping = validations[1];
                var _buyerInfo = _this.buyerInfo,
                    user = _buyerInfo.user,
                    billingAddress = _buyerInfo.billingAddress,
                    shippingAddress = _buyerInfo.shippingAddress,
                    shipToBilling = _buyerInfo.shipToBilling;


                if (shipToBilling && billing === 'success') {
                    // Add the address as Billing AND Shipping Address

                    var addVenmoSupplements = new _venmoModels.$VenmoSupplementaryInfo({
                        user: user,
                        billing: billingAddress,
                        shipToBilling: shipToBilling
                    });

                    addVenmoSupplements.save({
                        success: function success() {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_OT_BILLING',
                                to: 'process_billing'
                            });

                            // Need to re-run the last route now that contingency has been resolved
                            _uiRouter.$state.go('^', {}, { reload: true });
                        },
                        error: function error() {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_OT_BILLING',
                                to: 'process_billing',
                                int_error_desc: 'unable to save address',
                                error_source: 'hermesnodeweb'
                            });

                            _this.goto('checkout.login');
                        }
                    });
                } else if (billing === 'success' && shipping === 'success') {
                    // Add the addresses as Billing and Shipping accordingly and separatley
                    var _addVenmoSupplements = new _venmoModels.$VenmoSupplementaryInfo({
                        user: user,
                        billing: billingAddress,
                        shipping: shippingAddress,
                        shipToBilling: shipToBilling
                    });

                    _addVenmoSupplements.save({
                        success: function success() {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_OT_BILLING',
                                to: 'process_billing'
                            });

                            // Need to re-run the last route now that contingency has been resolved
                            _uiRouter.$state.go('^', {}, { reload: true });
                        },
                        error: function error() {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_OT_BILLING',
                                to: 'process_billing',
                                int_error_desc: 'unable to save address',
                                error_source: 'hermesnodeweb'
                            });

                            _this.goto('checkout.login');
                        }
                    });
                } else {
                    // nothing to do here.. validations need to be resolved.
                }
            });
        },
        clearFieldErrors: function clearFieldErrors() {
            (0, _jquery2['default'])('#venmoInfoCollect .backendError').removeAttr('aria-invalid').removeClass('backendError');
        },
        validateAddress: function validateAddress() {
            var _this2 = this;

            var _buyerInfo2 = this.buyerInfo,
                billingAddress = _buyerInfo2.billingAddress,
                shippingAddress = _buyerInfo2.shippingAddress;

            var validationPromises = [];

            // create models
            var billingAddressValidate = new _index.$BillingAddressModel(billingAddress);

            var shippingAddressValidate = new _index.$BillingAddressModel(shippingAddress);

            // insert validation promises in array
            validationPromises.push(billingAddressValidate.save({
                success: function success(validateRes) {
                    return 'success';
                },
                validation: function validation(res) {
                    _this2.actions.handleValidation(res, '.billing');
                },
                error: function error(err) {
                    _logger.$logger.info('VENMO_BILLING_ADDRESS_VALIDATION', err);
                    _this2.goto('checkout.login', { venmoError: true });
                }
            }));

            // add the shipping promise if flag is NOT ship to billing address
            if (!this.buyerInfo.shipToBilling) {

                validationPromises.push(shippingAddressValidate.save({
                    success: function success(validateRes) {
                        return 'success';
                    },
                    validation: function validation(res) {
                        _this2.actions.handleValidation(res, '.shipping');
                    },
                    error: function error(err) {
                        _logger.$logger.info('VENMO_SHIPPING_ADDRESS_VALIDATION', err);
                        _this2.goto('checkout.login', { venmoError: true });
                    }
                }));
            }

            // resolve validation promises
            return _angular.$q.all(validationPromises);
        },
        handleValidation: function handleValidation(res, classIdentifier) {

            var $el = (0, _jquery2['default'])(this.$element);

            if (res && res.fields && res.fields.length) {
                res.fields.forEach(function (field) {
                    if (field.field) {
                        var $field = (0, _jquery2['default'])($el.find(classIdentifier + ' [name="\' + field.field + \'"]'));

                        if ($field.length === 0 && field.field === 'zip') {
                            $field = (0, _jquery2['default'])($el.find(classIdentifier + ' [ng-model="address.postal_code"], [ng-model="zipCode"]'));
                        }

                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    }
                });
            }

            $el.find('form').find('.backendError, .ng-invalid').first().focus();
        }
    },

    lifecycle: {
        enter: function enter() {

            this.buyerInfo = {
                user: {},
                shippingAddress: {
                    country: _squid.$locale.country
                },
                billingAddress: {
                    country: _squid.$locale.country
                },
                shipToBilling: true // is our Billing Address also our Shipping Address?
            };
        }
    }
});


_angular.$q;

_squid.$Component;

_squid.$locale;

_uiRouter.$state;

_logger.$logger;

_venmoModels.$VenmoSupplementaryInfo;

_index.$BillingAddressModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-info-gather/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-info-gather/directive.js");

var _directive2 = _interopRequireDefault(_directive);

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$VenmoInformationGatherRoute', {
    path: 'infoGather',
    directive: _directive2['default'],
    titleContent: 'addBillingAddress.title',

    trackingData: {
        fptiState: 'venmo_ot_billing'
    }
}); // change to your directive

_squid.$Route;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-info-gather/style.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-info-gather/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"review\" content tabindex=-1 role=\"presentation\">\n    <div class=\"venmoInfoCollect row-fluid\" id=\"venmoInfoCollect\">\n        <div class=\"trayInner reviewSections\">\n            <h1 class=\"alpha\">{{ \"Please enter the following details\" }}</h1>\n            <p class=\"subTitle\">{{ \"It seems this is your first time checking out with your Venmo Account. We'll need a few more details to get you started 😄🎈🎉 \" }} </p>\n\n\n            <form id=\"buyerInformationForm\" name=\"buyerInformationForm\" class=\"\" content novalidate form-autofocus>\n                <!--Billing Section-->\n                <div class=\"billing\">\n                    <h2 class=\"gamma\">{{ \"Billing Address\" }}</h2>\n                    <xo-message ng-if=\"billingMessage\" message=\"billingMessage\"></xo-message>\n\n                    <xo-select-shipping-country shipping-address=\"buyerInfo.billingAddress\"\n                                                token=\"token\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n\n                    <xo-name-input  user=\"buyerInfo.user\" country=\"{{buyerInfo.billingAddress.country}}\"></xo-name-input>\n\n                    <xo-add-address address=\"buyerInfo.billingAddress\" country=\"buyerInfo.billingAddress.country\"></xo-add-address>\n\n                    <div class=\"row-fluid checkbox shipToBillingContainer\">\n                        <input ng-model=\"buyerInfo.shipToBilling\" type=\"checkbox\" name=\"shipToBilling\" id=\"shipToBilling\" class=\"shipToBilling\"/>\n                        <label class=\"noBottom\" for=\"shipToBilling\" ng-bind-html=\"'Ship to my billing address'\"></label> <!--Remove this hardcoded comment-->\n                    </div>\n                </div>\n                <!--Billing Section-->\n\n\n                <!--Shipping Section-->\n                <div ng-if=\"!buyerInfo.shipToBilling\" class=\"shipping\">\n\n                    <h2 class=\"gamma\">{{ \"Shipping Address\" }}</h2>\n\n                    <xo-message ng-if=\"shippingMessage\" message=\"shippingMessage\"></xo-message>\n\n                    <xo-select-shipping-country shipping-address=\"buyerInfo.shippingAddress\"\n                                                token=\"token\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n\n                    <xo-add-address address=\"buyerInfo.shippingAddress\" country=\"buyerInfo.shippingAddress.country\"></xo-add-address>\n                </div>\n\n                <!--Shipping Section-->\n\n\n\n\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{content('memberReview.continueLabel')}}\" class=\"btn full\"  validate-submit=\"actions.onSubmit()\"/>\n                </div>\n\n\n            </form>\n\n        </div>\n    </div>\n</section>\n\n\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-models/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$VenmoTransactionEligibility = exports.$VenmoSupplementaryInfo = exports.$VenmoUserModel = exports.$VenmoOnboardModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $VenmoOnboardModel = exports.$VenmoOnboardModel = _squid.$Model.extend('$VenmoOnboardModel', {
    api: new _squid.$Api({
        uri: '/api/venmo/onboard'
    })
});

var $VenmoUserModel = exports.$VenmoUserModel = _squid.$Model.extend('$VenmoUserModel', {
    api: new _squid.$Api({
        uri: '/api/venmo/user'
    })
});

var $VenmoSupplementaryInfo = exports.$VenmoSupplementaryInfo = _squid.$Model.extend('$VenmoSupplementaryInfo', {
    api: new _squid.$Api({
        uri: '/api/venmo/address'
    }),

    serialize: function serialize() {

        return {
            user: {
                first_name: this.user && this.user.first_name && this.user.first_name.trim(),
                last_name: this.user && this.user.last_name && this.user.last_name.trim()
            },
            billing: {
                line1: this.billing && this.billing.line1 && this.billing.line1.trim(),
                line2: this.billing && this.billing.line2 && this.billing.line2.trim(),
                city: this.billing && this.billing.city && this.billing.city.trim(),
                state: this.billing && this.billing.state && this.billing.state.trim(),
                postal_code: this.billing && this.billing.postal_code && this.billing.postal_code.trim(),
                normalization_status: this.billing && this.billing.normalization_status && this.billing.normalization_status.trim(),
                country: this.billing && this.billing.country && this.billing.country.trim()
            },
            shipping: {
                line1: this.shipping && this.shipping.line1 && this.shipping.line1.trim(),
                line2: this.shipping && this.shipping.line2 && this.shipping.line2.trim(),
                city: this.shipping && this.shipping.city && this.shipping.city.trim(),
                state: this.shipping && this.shipping.state && this.shipping.state.trim(),
                postal_code: this.shipping && this.shipping.postal_code && this.shipping.postal_code.trim(),
                normalization_status: this.shipping && this.shipping.normalization_status && this.shipping.normalization_status.trim(),
                country: this.shipping && this.shipping.country && this.shipping.country.trim()
            },
            shipToBilling: this.shipToBilling
        };
    }
});

var $VenmoTransactionEligibility = exports.$VenmoTransactionEligibility = _squid.$Model.extend('$VenmoTransactionEligibility', {
    api: new _squid.$Api({
        uri: '/api/venmo/:id/eligibility'
    })
});

angular.value("$VenmoOnboardModel", $VenmoOnboardModel);
angular.value("$VenmoUserModel", $VenmoUserModel);
angular.value("$VenmoSupplementaryInfo", $VenmoSupplementaryInfo);
angular.value("$VenmoTransactionEligibility", $VenmoTransactionEligibility);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-stepUp/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("../node_modules/xo-third-party-components/src/venmo-stepUp/styles.less");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-stepUp/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoVenmoStepUpOverlay', {
    tag: 'xo-venmo-stepup-overlay',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        stateInfo: {
            type: 'var',
            required: false
        },
        modalCallback: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var _this = this;

            return _auth.$AuthModel.instance().retrieve().then(function (auth) {
                if (auth.get('tenant') === 'VENMO') {
                    return {
                        auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                        venmoUser: _venmoModels.$VenmoUserModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        payee: _index.$CheckoutPayeeModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        cart: _index.$CheckoutCartModel.instance(_this.token).retrieve()['catch'](_angular.noop)
                    };
                } else {
                    return {};
                }
            });
        }
    },

    actions: {
        logCancel: function logCancel() {
            _logger.$logger.info('checkout_fpti', {
                from: 'VENMO_STEP_UP_AUTH',
                to: 'process_user_cancel'
            });
        },
        hideOverlay: function hideOverlay() {
            (0, _jquery2['default'])('#wrapper #spinner').attr('style', '');
            this.$element.removeClass('overlayOpen');
            var self = this;
            return (0, _angular.$timeout)(function () {
                self.showOverlay = false;
            }, 300);
        },
        hideModal: function hideModal(event) {
            event.preventDefault();
            this.actions.logCancel();
            this.actions.hideOverlay();
            _uiRouter.$state.go(this.stateInfo.oldState);
        },
        triggerModal: function triggerModal(event, data) {

            _logger.$logger.info('checkout_fpti', {
                from: 'VENMO_STEP_UP_AUTH',
                to: 'prepare_venmo_step_up',
                challenge_reason: 'add-shipping'
            });

            _logger.$logger.debug('doVenmoRiskyAppSwitchModal');
            this.showOverlay = true;

            this.stateInfo = data;

            if (this.stateInfo.newState === 'checkout.review.sidebar.addShipping') {
                this.contingencyReason = 'ADD_SHIPPING';
            } else {
                this.contingencyReason = 'PAYMENT_VERIFICATION_REQUIRED';
            }

            (0, _jquery2['default'])('#wrapper #spinner').hide();

            var $element = this.$element;

            (0, _angular.$timeout)(function () {
                $element.addClass('overlayOpen');
                _angular.$rootScope.$emit('allLoaded');
            });
        },
        continueWithVenmo: function continueWithVenmo() {
            var _models = this.models,
                venmoUser = _models.venmoUser,
                payee = _models.payee,
                cart = _models.cart;

            var ext_id = venmoUser.get('externalId');
            var reason = this.contingencyReason;
            var token = cart.get('billing.ba_token') ? cart.get('billing.ba_token') : this.token;
            var intent = cart.billing ? 'BILLING_AGREEMENT' : cart.payment_action;
            var total = cart.get('purchase.amounts.total.amount', '0');
            var currency = cart.get('purchase.amounts.total.currency_code', 'none');

            var NEW_STATE = this.stateInfo.newState;

            var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL['universal'];
            var LANDING_ROUTE = '#/checkout/venmoAuth?nextState=' + NEW_STATE;
            var ERROR_ROUTE = '#/checkout/login?venmoError=true';

            var params = (0, _angular.$httpParamSerializer)({
                'x-success': _angular.$location.absUrl().replace(/#.*$/, LANDING_ROUTE),
                'x-failure': _angular.$location.absUrl().replace(/#.*$/, ERROR_ROUTE),
                ua: (0, _thirdPartyInfo.getUserAgent)(),
                merchant_id: payee.getId(),
                token: token,
                intent: intent,
                total: total,
                currency: currency,
                ext_id: ext_id,
                reason: reason
            });

            this.actions.hideOverlay();

            _logger.$logger.info('venmo-stepUp-appswitch', { url: SCHEME + '?' + params });

            _logger.$logger.info('checkout_fpti', {
                from: 'VENMO_STEP_UP_AUTH',
                to: 'process_user_appswitch'
            });

            // app-switching
            (0, _thirdPartyInfo.redirect)(SCHEME + '?' + params);
        }
    },

    lifecycle: {
        populate: function populate() {

            var cancelInsufficientPermission = _angular.$rootScope.$on('$insufficientPermissionVenmoOT', this.actions.triggerModal);

            this.$on('$destroy', cancelInsufficientPermission);
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_angular.$httpParamSerializer;

_angular.$location;

_angular.noop;

_squid.$config;

_squid.$Component;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_venmoModels.$VenmoUserModel;

_thirdPartyInfo.redirect;

_thirdPartyInfo.getUserAgent;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-stepUp/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-stepUp/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showOverlay\" class=\"pageOverlay\" ng-class=\"{mobile: isDevice}\" content>\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <section class=\"login\" id=\"stepUp\">\n                    <span class=\"venmoLogo\"></span>\n                    <p class=\"statement\" ng-bind-html=\"htmlContent('memberReview.stepUpStatement')\">Log in to your Venmo account</p> <!-- Action to be taken -->\n                    <p class=\"userTask\" ng-if=\"contingencyReason === 'ADD_SHIPPING'\" ng-bind-html=\"htmlContent('memberReview.stepUpAddAddress')\"></p> <!-- To accomplish what? -->\n                    <p class=\"userTask\" ng-if=\"contingencyReason !== 'ADD_SHIPPING'\" ng-bind-html=\"htmlContent('memberReview.stepUpGeneral')\"></p>\n                    <a track-link=\"choose_venmo_stepup\" id=\"proceedStepUp\" class=\"btn venmoBtn full\" link-button ng-click=\"actions.continueWithVenmo()\">{{content('landing.venmoButton')}}</a>\n\n                    <div class=\"cancel\" ng-if=\"contingencyReason === 'ADD_SHIPPING'\">\n                        <a href=\"#\" id=\"cancelStepUp\" ng-click=\"actions.hideModal($event)\" track-link=\"choose_cancel_stepup\" ng-bind-html=\"htmlContent('buttons.cancel')\"></a>\n                    </div>\n                </section>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-title/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _template = __webpack_require__("../node_modules/xo-title/dist/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoTitle', [function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            titleTxt: '@?',
            className: '@?',
            tagName: '@?'
        },
        link: function link($scope, $element) {
            if ($scope.tagName) {
                var newEl = document.createElement($scope.tagName || 'h1');

                newEl.className = $scope.className || 'alpha';
                newEl.textContent = '{{ titleTxt }}';
                (0, _angular.$compile)(newEl)($scope);
                $element.empty().append(newEl);
            }
        }
    };
}]);

/***/ }),

/***/ "../node_modules/xo-title/dist/template.html":
/***/ (function(module, exports) {

module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"

/***/ }),

/***/ "../node_modules/xo-tracking/dist/builder.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$FptiBuilder', function () {
    /**
     *  Build the front-end FPTI event from three data sources
     *      1. the per-product configuration
     *      2. the buzname defined per-route
     *      3. the additional attributes that only available at a specific checkpoint
     *
     */

    return _squid.$Class.extend('FptiBuilder', {

        resolvePageQualifier: function resolvePageQualifier(trackingData) {
            // The pages can populated pageQualifier to override the default one
            this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
            // because 'fullpage' has been widely embedded into routes
            // we had better to keep it as a place holder
            : 'fullpage'; // update later if it's in-context
        },

        build: function build() {

            if (!this.trackingData && !this.error) {
                // do nothing if neither page nor error tracking
                return this;
            }

            this.resolvePageQualifier(this.trackingData);

            this._dataObj = new _model.$FptiDataModel().decorate('base', this.baseData).decorate('buzname', this.trackingData, this.pageQualifier, undefined, this.productOverride).decorate('templateName', this.trackingData, this.pageQualifier).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', (0, _squid.$getLatestCorrelationID)()).decorate('uuid', _model.$CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).decorate('comp', this.comp).getDataObject(this.isInContext);

            return this;
        },

        toString: function toString() {
            var dataAry = [];

            _angular2['default'].forEach(this._dataObj, function (v, k) {
                dataAry.push(k + '=' + v);
            });

            return dataAry.join('&');
        }
    });
});

_squid.$getLatestCorrelationID;

_squid.$Class;

_model.$FptiDataModel;

_model.$CalDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/builder.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/button.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$ButtonTrackingService', function () {
    var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
    var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
    var _alreadyFired = false;

    function _strToElements(str) {
        var elements = {};

        if (str && str.length) {
            str.split('&').forEach(function (param) {
                var nvp = param.split('=');

                elements[nvp[0]] = nvp[1];
            });
        }
        return elements;
    }

    function _fireButtonTrackingBeacon(elements) {
        var url = _beaconUrl;
        var xoData = {};

        function buildParam(param, value) {
            var p = '&' + param + '=' + (value ? value : 'null');

            return p;
        }

        function getGUIID(ts) {
            return _strToElements(ts).vr;
        }

        function addToDocument(uri) {
            var img = document.createElement('img');

            img.setAttribute('src', uri);
            document.body.appendChild(img);
        }

        // Get some params from FPTI data.
        _beaconParams.forEach(function (param) {
            url += buildParam(param, elements[param]);
        });

        // Build the rest of the params.
        url += buildParam('fpti', getGUIID(_squid.$cookies && _squid.$cookies.ts));
        url += buildParam('WWW_AKA_MVT_BUTTONS', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_BUTTONS);
        url += buildParam('WWW_AKA_MVT_ID', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_ID);
        url += buildParam('ip', _squid.$meta && _squid.$meta.ipaddress);

        if (_angular.$rootScope.token) {
            (0, _squid.$populate)(xoData, {
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                appData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                url += buildParam('mrid', xoData.payee && xoData.payee.getId());
                url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
                addToDocument(url);
            });
        } else {
            url += buildParam('mrid', null);
            url += buildParam('calf', null);
            addToDocument(url);
        }
    }

    return {
        fireBeacon: function fireBeacon(fptiData) {
            if (!_alreadyFired && fptiData) {
                var elements = _strToElements(fptiData);

                // Fire the beacon if this is a page render.
                if (elements.page) {
                    _alreadyFired = true;
                    return _fireButtonTrackingBeacon(elements);
                }
            }
        },
        resetAlreadyFired: function resetAlreadyFired() {
            _alreadyFired = false;
        }
    };
});

_angular.$rootScope;

_squid.$meta;

_squid.$cookies;

_squid.$populate;

_index.$CheckoutAppDataModel;

_index.$CheckoutPayeeModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/button.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module('tracking.directive', ['ui.router']).directive('trackSubmit', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('mousedown', function (event) {
                var transition = attr && attr.trackSubmit;
                var trackSubmit = {
                    currentRoute: _uiRouter.$state.current,
                    transition: transition,
                    errors: []
                };

                _angular2['default'].forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
                    var elem = $(el);
                    var elementId = elem.attr('id');
                    var elementName = elem.attr('name');
                    var errorKey = elem.attr('data-error-key');
                    var errorText = elem.has('required') ? 'required' : 'no error key';
                    var fieldName = elementId ? elementId : elementName;

                    if (!fieldName) {
                        var elementModel = elem.attr('ng-model');

                        fieldName = elementModel ? elementModel : 'unnamed-field';
                    }

                    trackSubmit.errors.push({
                        fieldName: fieldName,
                        errorMessage: errorKey ? errorKey : errorText
                    });
                });

                _angular.$rootScope.$broadcast('trackSubmit', trackSubmit);
            });
        }
    };
}).directive('trackLink', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('mousedown', function (event) {
                var state = attr && attr.trackLink;

                if (state) {
                    var trackLink = {
                        currentRoute: _uiRouter.$state.current,
                        transition: state
                    };

                    _angular.$rootScope.$broadcast('trackLink', trackLink);
                }
            });
        }
    };
}).directive('trackClick', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('click', function (event) {
                var state = attr && attr.trackClick;

                if (state) {
                    var trackClick = {
                        currentRoute: _uiRouter.$state.current,
                        transition: state
                    };
                    _angular.$rootScope.$broadcast('trackClick', trackClick);
                }
            });
        }
    };
}).directive('trackInput', function () {
    /*
    * Track an input tag with track-input attribute
    * you can use the value of track-input attribute as
    * a tracking attr Eg.: track-input="xo_guest_yes"
    */
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('click', function (event) {
                var state = void 0;

                if (event.target.type === 'checkbox') {
                    if (event.target.checked) {
                        state = attr && attr.trackInput + '_CHECKED';
                    } else {
                        state = attr && attr.trackInput + '_UNCHECKED';
                    }
                } else {
                    state = attr && attr.trackInput;
                }

                var trackInput = {
                    currentRoute: _uiRouter.$state.current,
                    page: 'main:ec:hermes::fullpage-billing:guest:aries:'
                };

                if (state) {
                    trackInput.transition = state;
                }

                _angular.$rootScope.$broadcast('trackInput', trackInput);
            });
        }
    };
}).directive('trackFocusAndBlur', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            var isAddressField = function isAddressField(s) {
                return (/^billing|^shipping/.test(s)
                );
            };
            ['blur', 'focus'].forEach(function (eventName) {
                element.on(eventName, function (event) {
                    if (document.body.className.includes('loading')) {
                        // Angular fires this event while the page is still loading.
                        // This is a hacky way of preventing this but this ask is time-sensitive
                        // and this is an app we are deprecating.
                        return;
                    }

                    var id = event.target.id;

                    var attrName = attr && attr.name;
                    var fieldName = isAddressField(id) ? id : attrName;
                    var data = {
                        from: 'billing',
                        to: 'process_field_' + eventName,
                        field_name: fieldName
                    };

                    // The tags `selectedvalue` and `user_filled` were pulled
                    // from `go/fptigov` as keys that are already indexed.
                    var elType = event.target.type;
                    if (elType === 'checkbox' || elType === 'radio') {
                        data.selectedvalue = event.target.checked;
                    } else {
                        data.user_filled = Boolean(event.target.value);
                    }

                    _angular.$rootScope.$broadcast('trackFocusAndBlur', data);
                });
            });
        }
    };
});

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/fpti.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fpti', function () {
    var _beaconUrl = void 0;

    // Logic to switch between production/staging urls. This way we don't pollute live logs,
    // and we are able to test on stage using the fpti log viewing tool.
    if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
        _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
    } else {
        _beaconUrl = _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
    }

    return {
        // Get all the tracking data defined at the page level
        getPageTrackingData: function getPageTrackingData(route) {
            route = route || {};

            var trackingData = route.trackingData || {};
            var routeParent = route.parent;

            trackingData.token = _angular.$rootScope.token;

            while (routeParent) {
                trackingData = _angular2['default'].merge({}, routeParent.trackingData || {}, trackingData);
                routeParent = routeParent.parent;
            }
            return trackingData;
        },

        setupDataString: function setupDataString(route, err, data) {
            var trackingData = this.getPageTrackingData(route);
            var PAYPAL = window && window.PAYPAL;

            var fptiData = void 0;

            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
                PAYPAL.core = PAYPAL.core || {};

                var payload = {
                    baseData: window.meta.fpti,
                    trackingData: trackingData,
                    error: err,
                    isInContext: _angular.$rootScope.miniBrowser
                };

                _angular2['default'].extend(payload, data || {});
                fptiData = new _builder.$FptiBuilder(payload).build().toString();

                // FPTI client side tracking only if we have template
                if (route && route.template && _angular2['default'].isFunction(PAYPAL.analytics.setup)) {
                    PAYPAL.core.pta = PAYPAL.analytics.setup({
                        data: fptiData,
                        url: _beaconUrl
                    });
                }
            }
            return fptiData;
        }
    };
}).factory('$fptiError', function () {
    function stringifyErrorMessage(msg) {
        return encodeURIComponent(_angular2['default'].isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
        : (_angular2['default'].toJson(msg) || 'undefined').substring(0, 128));
    }

    return _squid.$Error.extend({
        construct: function construct(err) {
            if (!err) {
                return;
            }
            this.type = err.type;
            this.field = err.field;
            this.msg = stringifyErrorMessage(err.message || err.error);
            this.code = err.code || err.cause;
        }
    });
});

_squid.$config;

_squid.$Error;

_builder.$FptiBuilder;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/fpti.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * xo-tracking encapsulates all the details about instrumentation
 * and only register event listeners during bootstrap
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/xo-tracking/dist/listener.js"), __webpack_require__("../node_modules/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {

    // Declare the dependency to register the listeners
    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-tracking/dist/listener.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, console) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");

var _button = __webpack_require__("../node_modules/xo-tracking/dist/button.js");

var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    // eslint-disable-line max-statements
    var token = window.meta.token;
    // logAppName is the appname from meta.js. if the logAppName is not defined, default it to 'appNameNotDefined'.
    var appName = _squid.$meta.logAppName || 'appNameNotDefined';
    var addTrackingData = function addTrackingData(object) {
        return _squid.$util.extend(object, {
            dc: _squid.$meta.dc,
            az: _squid.$meta.az,
            cust: _index.$AuthModel.instance().buyer_id || '',
            comp: appName
        });
    };
    var cplSettings = _squid.$config.enableCPL;
    var passesCplThrottle = cplSettings && (typeof cplSettings.throttle === 'undefined' || (0, _squid.$experiment)('cpl_tracking', cplSettings.throttle, token));
    var cplEnabled = passesCplThrottle || _squid.$util.params().forceEnableCPL;

    function logTransition(state) {
        return !(state.trackingData && state.trackingData.suppressTransitionLog);
    }

    function logStateExit(state) {
        return state.trackingData && state.trackingData.trackStateExit;
    }

    function getBeaconUrl() {
        // Logic to switch between production/staging urls. This way we don't pollute live logs,
        // and we are able to test on stage using the fpti log viewing tool.
        return _squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage() ? 'https://tracking.qa.paypal.com/webapps/tracking/ts' // stage url
        : _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
    }

    /*
    * Triggers pa.js recordClick with custom parameters
    */
    function fptiCustomRecordClick(route, customData) {
        var analyticsInstance, fptiData, fptiDataObj;
        var PAYPAL = window.PAYPAL;

        if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
            PAYPAL.core = PAYPAL.core || {};

            analyticsInstance = new PAYPAL.analytics.Analytics();

            fptiData = new _builder.$FptiBuilder({
                trackingData: route.trackingData,
                isInContext: _angular.$rootScope.miniBrowser,
                comp: appName
                // ... Other flow data pass-in here to resolve page qualifier
            }).build();

            // Grab the fpti data object and extend with custom params
            // The fpti data obj should include pxp params as well
            fptiDataObj = fptiData._dataObj;
            $.extend(fptiDataObj, customData);

            analyticsInstance.setRequestData(fptiDataObj);
            analyticsInstance.recordClick({
                url: getBeaconUrl()
            });
        }
    }

    _angular.$rootScope.$on('trackInput', function (event, trackInput) {
        if (!trackInput) {
            return;
        }
        var customData = {
            link: trackInput && trackInput.transition,
            page: trackInput && trackInput.page
        };

        fptiCustomRecordClick(trackInput.currentRoute, customData);
    });

    _angular.$rootScope.$on('trackFocusAndBlur', function (event, data) {
        _logger.$logger.info('checkout_fpti', data);
    });

    _angular.$rootScope.$on('trackClick', function (event, trackClick) {
        if (!trackClick) {
            return;
        }
        var customData = {
            link: trackClick && trackClick.transition
        };

        fptiCustomRecordClick(trackClick.currentRoute, customData);
    });

    _angular.$rootScope.$on('trackSubmit', function (event, trackSubmit) {
        if (!trackSubmit) {
            return;
        }
        var currentRoute = trackSubmit && trackSubmit.currentRoute;
        var routeName = currentRoute ? currentRoute.name : 'noRoute';

        _logger.$logger.info('track_submit', {
            route_name: routeName
            // ID stuff here later
        });

        if (logTransition(currentRoute)) {
            routeName = routeName.replace(/\./g, '_');
            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
            var transition = trackSubmit.transition || state;

            _logger.$logger.info(routeName + '_exit', {
                fptiState: state,
                fptiTransition: transition
            });
        }

        if (trackSubmit.errors && trackSubmit.errors.length) {
            var fptiFieldErrors = JSON.stringify(trackSubmit.errors);

            _logger.$logger.info('checkout_fpti', {
                form_field_errors: fptiFieldErrors
            });
        }

        var errors = trackSubmit.errors;

        if (_angular2['default'].isArray(errors)) {
            errors.forEach(function (err) {
                _logger.$logger.debug('track_submit_error', err);
                if (_fpti.$fpti) {
                    _fpti.$fpti.setupDataString(currentRoute, new _fpti.$fptiError({
                        type: 'fieldError',
                        field: err.fieldName,
                        code: err.errorMessage
                    }));
                }
            });

            if (errors.length) {
                _logger.$logger.flush(true);
            }
        }
    });

    _angular.$rootScope.$on('unhandled_error', function (event, exception) {
        if (_fpti.$fpti) {
            _fpti.$fpti.setupDataString(exception.currentRoute, new _fpti.$fptiError({
                type: 'pageError',
                message: exception.message,
                code: exception.cause
            }));
        }
    });

    _angular.$rootScope.$on('trackLink', function (event, trackLink) {
        if (!trackLink) {
            return;
        }

        var currentRoute = trackLink.currentRoute;
        var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
        var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;

        _logger.$logger.info(routeName + '_exit', {
            fptiState: state,
            fptiTransition: trackLink.transition
        });
    });

    _angular.$rootScope.$on('$transition', function (event, data) {
        (0, _angular.$timeout)(function () {
            if (_fpti.$fpti) {
                var fptiData = _fpti.$fpti.setupDataString(data.toState, null, addTrackingData({
                    transition_time: data.duration
                }));

                // This seems to conflict with CPL data, so don't fire if CPL
                if (!cplEnabled) {
                    // Fire and forget button tracking beacon.
                    _button.$ButtonTrackingService.fireBeacon(fptiData);
                }
            }
        });
    });

    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        var from = fromState && fromState.name.replace(/\./g, '_');
        var to = toState && toState.name.replace(/\./g, '_');

        if (from && logTransition(fromState) && logStateExit(fromState)) {
            var trackingData = fromState.trackingData && fromState.trackingData || {};

            _logger.$logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
        }

        _logger.$logger.info('state_change', {
            from: from || 'start',
            to: to || 'end'
        });

        // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
        if (toState.template) {
            _model.$CalDataModel.generateMetaIds();
        }

        _angular.$rootScope.currentState = to;

        if (to && logTransition(toState)) {
            _logger.$logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
        }
    });

    _angular.$rootScope.$on('page_loaded', function (event, from, to) {
        if (from !== 'checkout_init') {
            return;
        }
        var key = _model.$FptiConstants.stateName[to] || 'review';
        var landing_page = _model.$FptiConstants.landing_page[key];

        _logger.$logger.info('landing_page', {
            'from': landing_page,
            'to': 'process_page_loaded',
            fpti_landing_page: landing_page
        });
    });

    _angular.$rootScope.$on('page_reloaded', function () {
        _logger.$logger.flush(true);
        _model.$CalDataModel.generateMetaIds();
    });

    _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
        var to = toState.name.replace(/\./g, '_');

        if (toState.hasResolver && to) {
            _logger.$logger.info(to + '_load');
        } else if (to) {
            _logger.$logger.info(to + '_rendering');
        }
    });

    _angular.$rootScope.$on('addrDiff', function (event, addrDiff) {
        if (!addrDiff) {
            return;
        }
        _logger.$logger.info('checkout_fpti' + addrDiff);
    });

    function getHash(url) {
        if (!url || !~url.indexOf('#')) {
            // eslint-disable-line no-bitwise
            return;
        }

        url = url.split('#');
        return url[url.length - 1];
    }

    var oldHash = window.location.hash;

    window.addEventListener('hashchange', function (event) {
        _logger.$logger.info('hashchange', {
            from: getHash(event.oldURL || oldHash),
            to: getHash(event.newURL || window.location.hash)
        });

        if (!_squid.$loader.isLoading()) {
            _logger.$logger.flush();
        }

        oldHash = window.location.hash;
    });

    $(document).on('click', function (event) {
        if (event && event.target && event.target.tagName) {
            var name = event.target.tagName.toLowerCase();

            if (event.target.id) {
                name += '#' + event.target.id;
            } else if (event.target.attributes && event.target.attributes['ng-model']) {
                name += ':' + event.target.attributes['ng-model'].value;
            } else if (event.target.className) {
                name += '.' + event.target.className.split(' ').join('.');
            }

            _logger.$logger.info('click', { el: name });
        }
    });

    if (cplEnabled) {
        window.fptiserverurl = getBeaconUrl();

        var firstInvocation = true;
        var trackPageStart = function trackPageStart() {
            if (firstInvocation) {
                firstInvocation = false;
                return;
            }
            try {
                window.PAYPAL.analytics.startCPLTracking();
            } catch (e) {
                console.log('error starting cpl tracking ' + e);
            }
        };

        var firstDone = true;
        var trackDone = function trackDone(beaconData) {
            window.PAYPAL.analytics.endCPLTracking({
                pageData: addTrackingData(beaconData),
                inferStart: firstDone
            });
            firstDone = false;
        };

        var currentRoute = null;

        _angular.$rootScope.$on('startLoad', function () {
            return trackPageStart();
        });
        _angular.$rootScope.$on('$stateChangeSuccess', function (e, route) {
            currentRoute = route;
        });

        _angular.$rootScope.$on('allLoaded', function () {
            try {
                var buildParams = {
                    productOverride: window.fptiProductOverride,
                    trackingData: _fpti.$fpti.getPageTrackingData(currentRoute)
                };
                var legacyFptiData = new _builder.$FptiBuilder(buildParams).build()._dataObj;
                var product = window.fptiProductOverride || 'ec';

                legacyFptiData.pgrp = 'main:' + product + ':hermes';
                legacyFptiData.flid = token;
                trackDone(legacyFptiData);
            } catch (e) {
                console.log('error tracking CPL data ' + e);
            }
        });
    }
});

_index.$AuthModel;

_squid.$util;

_squid.$meta;

_squid.$config;

_squid.$experiment;

_squid.$loader;

_logger.$logger;

_model.$CalDataModel;

_model.$FptiConstants;

_builder.$FptiBuilder;

_button.$ButtonTrackingService;

_fpti.$fpti;

_fpti.$fptiError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular); /* eslint-disable angular/di */


_angular2['default'].module().constant('$FptiConstants', {
    // The prototype of buzname data object
    buznameMap: {
        flowgatename: {
            placeHolder: '',
            fptiKey: 'fltp'
        },
        'flowname': {
            placeHolder: 'ec:hermes:',
            fptiKey: 'flnm'
        },
        'hier1': {
            placeHolder: 'main_ec_hermes_',
            fptiKey: 'shir'
        },
        'inout': {
            placeHolder: 'inout',
            fptiKey: 'lgin'
        },
        'pagename': {
            placeHolder: 'main:ec:hermes',
            fptiKey: 'pgrp'
        },
        'pagename2': {
            placeHolder: 'main:ec:hermes',
            fptiKey: 'page'
        },
        'version': {
            placeHolder: 'hermes',
            fptiKey: 'vers'
        }
    },
    // Full list of FPTI keys indexed by readable names
    // This mapping can also be served as default decorator
    fptiKeys: {
        'businessType': 'bztp',
        'correlationId': 'calc', // CalDataModel
        'cust': 'cust',
        'errorCode': 'eccd',
        'fieldError': 'erfd',
        'flowgatename': 'fltp', // buzname
        'flowname': 'flnm', // buzname
        'loggedIn': 'lgin', // buzname
        'merchantId': 'mrid',
        'merchantType': 'mbtp',
        'pageError': 'erpg',
        'pageGoal': 'goal', // route
        'pageGroup': 'pgrp', // buzname
        'pageName': 'page', // buzname
        'pageQualifer': 'qual', // buzname
        'pageStartTime': 'pgst', // FptiBuilder
        'pageTechnologyFlag': 'pgtf', // productConfig
        'paymentFlowId': 'pfid',
        'rLogId': 'teal',
        'sessionId': 'fpti',
        'siteHierarchy': 'shir', // buzname
        'sourceCi': 's', // productConfig
        'tealeaf': 'teal',
        'templateName': 'tmpl', // route
        'transition_time': 'transition_time',
        'uuid': 'csci', // CalDataModel
        'version': 'vers', // buzname
        'visitorId': 'vid',
        'ecToken': 'fltk', // metadata
        'pxpExpSelected': 'xe',
        'pxpTreatementSelected': 'xt',
        'pxpQualifiedTreatment': 'qt',
        'pxpContextId': 'qc',
        'dc': 'dc',
        'az': 'az',
        'comp': 'comp'
    },
    landing_page: {
        login: 'LOGIN',
        econsent: 'eConsent',
        review: 'Review',
        error_page: 'error_page',
        add_card: 'add_card',
        add_bank: 'add_bank',
        billing: 'billing',
        done_page: 'done_page',
        shoppingCart: 'shoppingCart',
        emptyCart: 'emptyCart',
        soldout: 'soldout',
        openButton: 'openButton'
    },
    stateName: {
        checkout_login: 'login',
        checkout_genericError: 'error_page',
        checkout_fastlogin: 'login',
        checkout_econsent: 'econsent',
        checkout_review: 'review',
        checkout_pageAddCard_addCardFlow_addCard: 'add_card',
        checkout_updateCard_addCardFlow_addCard: 'add_card',
        checkout_pageAddFi_bank_add: 'add_bank',
        guest: 'billing',
        checkout_done: 'done_page',
        checkout_guest: 'billing',
        checkout_signup: 'billing',
        guestupgrade_genericError: 'error_page',
        checkout_multistepsignup_multistepsignupaddcard: 'billing',
        checkout_shoppingCart: 'shoppingCart',
        checkout_emptyCart: 'emptyCart',
        checkout_soldout: 'soldout',
        checkout_openButton: 'openButton'
    }
}).factory('$FptiDataModel', ['$FptiConstants', function ($FptiConstants) {
    var productConfig = {};

    // TODO to read from config.json
    productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
    productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';

    /**
     * Utilizing Decorator pattern to allow defining additional logic for specific keys
     */
    return _squid.$Class.extend('FptiDataModel', {
        init: function init() {
            this._dataObj = _angular2['default'].extend({}, productConfig);
            this._decoratorList = [];
        },
        decorators: {
            buzname: function buzname(trackingData, pageQualifier, isInContext, productOverride) {
                if (!trackingData) {
                    return;
                }

                var buzname = trackingData.buzname;

                if (!buzname) {
                    return;
                }

                var buznameDiff = buzname[pageQualifier];

                if (!buznameDiff) {
                    return;
                }

                var dataObj = this._dataObj;
                var buznameMap = $FptiConstants.buznameMap;
                // read app specific place holder from config
                var placeHolderConfig = _squid.$config && _squid.$config.fpti && _squid.$config.fpti.buznameEntryPlaceHolder;

                Object.keys(buznameMap).forEach(function (key) {
                    var buznameEntry = buznameMap[key];
                    var fptiKey = buznameEntry.fptiKey;
                    var placeHolder = buznameEntry.placeHolder;

                    if (buznameDiff[key]) {
                        if (placeHolderConfig && placeHolderConfig[key]) {
                            placeHolder = placeHolderConfig[key];
                        }

                        if (productOverride) {
                            var _placeHolder$split = placeHolder.split(':'),
                                main = _placeHolder$split[0],
                                hermes = _placeHolder$split[2];

                            placeHolder = main + ':' + productOverride + ':' + hermes;
                        }

                        dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
                    } else {
                        dataObj[fptiKey] = placeHolder;
                    }
                });
                dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
            },

            base: function base(_base) {
                if (_base) {
                    for (var key in _base) {
                        if (!this._dataObj[key]) {
                            this._dataObj[key] = _base[key];
                        }
                    }
                }
            },

            locale: function locale(_locale) {
                if (_locale && _locale.country) {
                    this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
                }
            },

            pxptrackingdata: function pxptrackingdata(pxpData) {
                var qt = [];
                var qc = [];
                var xe = [];
                var xt = [];

                _squid.$util.some(pxpData, function (trackInfo) {
                    var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');

                    if (match) {
                        qt.push(match[1]);
                    }

                    match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
                    if (match) {
                        qc.push(match[1]);
                    }

                    _squid.$util.some(trackInfo.treatments, function (treatment) {
                        xe.push(treatment.experiment_id);
                        xt.push(treatment.treatment_id);
                    });
                });

                this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
            },

            templateName: function templateName(trackingData, pageQualifier, isInContext) {
                if (trackingData && trackingData.templateName) {
                    var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');

                    this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
                }
            },

            fieldError: function fieldError(err) {
                if (err && err.type === 'fieldError') {
                    this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
                    this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                }
            },

            pageError: function pageError(err) {
                if (err && err.type === 'pageError') {

                    this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
                    this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                }
            }

        },
        decorate: function decorate(name) {
            this._decoratorList.push({
                name: name,
                params: Array.prototype.slice.call(arguments, 1)
            });
            return this;
        },
        getDataObject: function getDataObject(isInContext) {
            var i;
            var decorator;

            for (i = 0; i < this._decoratorList.length; i++) {
                decorator = this._decoratorList[i];
                if (!decorator) {
                    continue;
                }
                var name = decorator.name;
                var params = decorator.params;

                if (_angular2['default'].isFunction(this.decorators[name])) {
                    // Invoke the decorator and pass in the parameter list
                    this.decorators[name].apply(this, params);
                } else {
                    var fptiKey = $FptiConstants.fptiKeys[name];

                    // If the fptiKey is defined and value is present, add the k-v pair
                    if (fptiKey && params && params.length > 0) {
                        this._dataObj[fptiKey] = params[0];
                    }
                }
            }

            // 'fullpage' was widely used as default key in page routs definition
            // finally replace it here if it's incontext
            var dataObj = this._dataObj;

            if (isInContext) {
                Object.keys(dataObj).forEach(function (k) {
                    if (_angular2['default'].isString(dataObj[k])) {
                        // some values can be number
                        dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
                    }
                });
            }

            return this._dataObj;
        }
    });
}]).factory('$CalDataModel', function () {
    var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';

    function _generateCorrelationId() {
        var uidRandomArr = (_uuid2['default'].v4() || uuid_v4_mask).split('-');
        var uidTime = (_uuid2['default'].v1() || uuid_v1_mask).split('-');

        return uidTime[0] + uidRandomArr[0].substr(0, 5);
    }

    function _generateUUID() {
        return (_uuid2['default'].v4() || uuid_v4_mask).replace(/-/g, '');
    }

    var CalModel = _squid.$Model.extend({
        _calCorrId: _generateCorrelationId(),
        _uuid: _generateUUID(),

        generateCalCorrId: function generateCalCorrId() {
            this._calCorrId = _generateCorrelationId();
        },
        generateUUID: function generateUUID() {
            this._uuid = _generateUUID();
        },
        generateMetaIds: function generateMetaIds() {
            this.generateCalCorrId();
            this.generateUUID();
        },

        getCalCorrId: function getCalCorrId() {
            return this._calCorrId;
        },

        getUUID: function getUUID() {
            return this._uuid;
        }
    });

    return new CalModel();
});

_squid.$Model;

_squid.$Class;

_squid.$util;

_squid.$config;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/model.js"))

/***/ }),

/***/ "../node_modules/xo-tray-height/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

/** Name:  Tray height helper */
angular.module().directive('xoTrayHeight', function () {
    return {
        restrict: 'A',
        link: function link($scope, element, attrs) {
            // Check to see if we can use the safer full height approach
            // or if we need to fallback to calculating the height using
            // math and relying on the "right" timing.
            var topClass = 'xo-sidebar-wrapper';
            var topSelector = '.' + topClass;
            var topElem = document.querySelector(topSelector);
            var inScope = topElem && topElem.querySelector('[xo-tray-height]');
            var useNewFlow = topElem && inScope;

            /**
             * NOTE:
             * The following code, despite being the "new" flow, is still
             * a stopgap solution until such time as the markup and or
             * CSS undergo an overhaul. It relies on the more stable
             * cascading relative/absolute positioning and 100% height
             * *and* the fact that the code is an instance of xo-tray-height
             * within the xo-sidebar-wrapper.
             */
            function calculate() {
                var curElem = element[0];

                while (!~curElem.className.indexOf(topClass)) {
                    var style = getComputedStyle(curElem, null);

                    if (style.position !== 'absolute') {
                        curElem.style.position = 'relative';
                    }
                    curElem.style.height = '100%';
                    curElem = curElem.parentNode;
                }
            }

            /**
             * NOTE:
             * The following DEPRECATED version of the calculate method
             * relies on calculating the heights using math. This heavy
             * handed approach is fine if it is called at the right times
             * and often enough; however, this criteria is hard to achieve.
             *
             * A markup and styles overhaul is recommended to do away with
             * both of these methods.
             */
            function deprecatedCalculate() {
                // DEPRECATED
                _logger.$logger.warn('xo-tray-height-fallback', {
                    message: 'Using the fallback sidebar height calculation. ' + 'height may not be 100%. You should not be here!'
                });
                var height;
                var headerHeight;
                var mainHeight;
                var trayMinheight = 400;
                var asideContentHeight;
                var $aside = $(element).parents('aside:visible');
                var $asideContent = $aside.find('.asideContent');

                if (!$aside || !$asideContent) {
                    return;
                }

                // Updates the tray height to the section height
                headerHeight = $aside.find('.header').outerHeight(true);
                mainHeight = $('#main').outerHeight(true);

                height = mainHeight - headerHeight;
                asideContentHeight = $asideContent.outerHeight(true);
                if ($scope.miniBrowser) {
                    $aside.find('.aside').css('height', '534px');
                    var minHeight = 534 - headerHeight;

                    $asideContent.css('height', minHeight);
                } else if (asideContentHeight > height) {
                    $asideContent.css('height', height);
                    $aside.find('aside:visible').addClass('hasScroll');
                } else {
                    height = height > trayMinheight ? height : trayMinheight;
                    $asideContent.css('height', height);
                    $aside.removeClass('hasScroll');
                }
            }

            if (useNewFlow) {
                calculate();
            } else {
                (0, _angular.$timeout)(deprecatedCalculate, 1);

                $scope.$on('SidebarError', function () {
                    deprecatedCalculate();
                });
            }
        }
    };
});

/* grab the logger so we can warn about being in the fallback mode */


_angular.$timeout;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Adds role='button' and tabindex='0' to anchor elements
// so that it is keyboard navigable and recognized by screen
// readers as a button.
//
// As anchors without href do not fire their click event
// automatically on a Space or ENTER key, this directive forces
// that functionality.
//
// If something is assigned to the link-button attribute, then
// it is used as an aria-label.
(0, _squid.$registerDirective)('link-button', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
            var $element = (0, _jquery2['default'])(element);

            $element.attr('role', 'button');
            $element.attr('tabindex', '0');
            if (ariaLabel) {
                $element.attr('aria-label', ariaLabel);
            }
            $element.on('keydown', function (event) {
                // do nothing if there is an alt or ctrl key as well
                if (!(event.altKey || event.ctrlKey)) {
                    switch (event.keyCode) {
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            element[0].click();
                            return false;
                        default:
                            break;
                    }
                }
                return true;
            });
        }
    };
});

// this directive gives an element characteristics of a native
// select element in terms of keyboard navigation. It becomes reachable
// via the tab key, reflects screenreader characteristics and
// can be activated by any of the DOWN, SPACE or ENTER KEYS.
(0, _squid.$registerDirective)('select-button', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var $element = (0, _jquery2['default'])(element);
            if (!attrs.hasOwnProperty('disableRole')) {
                $element.attr('role', 'button');
            }

            $element.attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
                // do nothing if there is an alt or ctrl key as well
                if (!(event.altKey || event.ctrlKey)) {
                    switch (event.keyCode) {
                        case _ui.KEYS.DOWN:
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            element[0].click();
                            return false;
                        default:
                            break;
                    }
                }
                return true;
            });
        }
    };
});

// this directive makes a container with links act as if it were a select dropdown
// in terms of keyboard accessibility. The following characteristics are implemented:
//
// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
// * ESC cancels and closes the dropdown
// * SPACE or ENTER select an option
// * You cannot TAB out of a dropdown until you select or cancel
//
// in addition, the following extra characteristics are implemented
//
// * The TAB (and SHIFT-TAB) key will also function to move between options
// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
//
// How to use:
// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
//    The expression is run whenever the ESC key is pressed.
// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
//    tabs to escape the select-box element.
(0, _squid.$registerDirective)('select-box', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);

            function escapeToggle() {
                if (attrs.selectCancel) {
                    (0, _angular.$parse)(attrs.selectCancel)(scope);
                    scope.$apply();
                }
            }

            element.attr('role', 'menu');

            element.on('keydown.selectBox', function (event) {
                var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
                var $origin = (0, _jquery2['default'])(event.target);

                if (!(event.altKey || event.ctrlKey)) {
                    var index = $allTabbable.index($origin);

                    switch (event.keyCode) {
                        case _ui.KEYS.TAB:
                            if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
                                // Enable default behavior to escape select-box
                                escapeToggle();
                                break;
                            } else if (event.shiftKey) {
                                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
                            } else {
                                index = (index + 1) % $allTabbable.length;
                            }
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.DOWN:
                        case _ui.KEYS.RIGHT:
                            index = (index + 1) % $allTabbable.length;
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.UP:
                        case _ui.KEYS.LEFT:
                            index = (index - 1 + $allTabbable.length) % $allTabbable.length;
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            $origin.click();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.ESC:
                            escapeToggle();
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    };
});

// similar to select-box, this directive restrains tabbing within a container
// to the container itself.
//
// 1. modal-cancel is the equivalent of select-cancel from select-box, and
// should define a cancellation / ESC function.
(0, _squid.$registerDirective)('modal-box', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function escapeToggle() {
                (0, _angular.$parse)(attrs.modalCancel)(scope);
                scope.$apply();
            }

            // Gets the index of the element that should be focused after pressing Tab
            function getNextIndex($element, $elements, shift) {
                if (shift) {
                    return ($elements.index($element) - 1 + $elements.length) % $elements.length;
                } else {
                    return ($elements.index($element) + 1) % $elements.length;
                }
            }

            if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
                element.on('keydown.modalBox', function (event) {
                    var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
                    var $origin = (0, _jquery2['default'])(event.target);

                    if (!(event.altKey || event.ctrlKey)) {
                        switch (event.keyCode) {
                            case _ui.KEYS.TAB:
                                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
                                $allTabbable.eq(index).focus();
                                event.preventDefault();
                                event.stopPropagation();
                                break;
                            case _ui.KEYS.ESC:
                                escapeToggle();
                                event.preventDefault();
                                event.stopPropagation();
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        }
    };
});

// A simple version of modal that doesn't rely on controlling keyboard behavior
// as strictly. Should be used in cases where tab items are not as easily accessible
// via JS (ie. iframes)
// Redirects focus to container when focusin event fired on element not in container
(0, _squid.$registerDirective)('simple-modal', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.attr('tabindex', '-1');

            var cancelFn;
            if (attrs.modalCancel) {
                cancelFn = function cancelFn() {
                    (0, _angular.$parse)(attrs.modalCancel)(scope);
                    scope.$apply();
                };
            }

            function registerModal() {
                (0, _jquery2['default'])(document).on('focusin.simple-modal', function (event) {
                    if (!element[0].contains(event.target)) {
                        event.stopPropagation();
                        element.focus();
                    }
                });
                if (cancelFn) {
                    (0, _jquery2['default'])(document).on('click.simple-modal', function (event) {
                        if (!element[0].contains(event.target)) {
                            deregisterModal();
                            cancelFn();
                        }
                    });
                }
            }

            function deregisterModal() {
                (0, _jquery2['default'])(document).off('focusin.simple-modal');
                (0, _jquery2['default'])(document).off('click.simple-modal');
            }

            // Watch the expression provided to simpleModal and add modal behavior when
            // expression result changes to truthy
            if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
                scope.$watch(attrs['simpleModal'], function (newVal) {
                    if (newVal) {
                        registerModal();
                    } else {
                        deregisterModal();
                    }
                });
            } else {
                registerModal();
            }

            scope.$on('$destroy', deregisterModal);
        }
    };
});

// this directive gives an element characteristics of a native
// option element in terms of aria attributes. It must be used
// as a child of a selectBox for proper keyboard behavior as it
// disables default tabbing behavior.
//
// The expression provided to the directive is used to set the
// aria-selected attribute when the expression evaluates to true.
(0, _squid.$registerDirective)('select-option', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            (0, _jquery2['default'])(element).attr('role', 'menuitem');
            if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
                (0, _jquery2['default'])(element).attr('aria-selected', 'true');
            }
        }
    };
});

// adapted from http://stackoverflow.com/a/24416690
// This directive makes the element focused when the expression
// provided _changes_ to true.
//
// In order to avoid conflicts with autofocus when a page first loads,
// adding the focused-once-before attribute will enable the expression
// only if it has been focused on before.
//
// * if the element itself is not focusable, then it will locate the first focusable
// element within it.
// * if the additional attribute focus-element is provided, it is wrapped
// as a jQuery element (could be selector string or actual element) and focused on
// it will be parsed when the focus-when attribute is true
// * if the attribute focus-on is provided, then the focus-when attribute is ignored and
// the directive listens to the event specified by focus-on
(0, _squid.$registerDirective)('focus-when', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {

            function locateAndFocus(active) {
                (0, _angular.$timeout)(function () {
                    if (active) {
                        // deal with figuring out which element to focus on
                        var $elementToFocus = (0, _jquery2['default'])(); // start with "monad" to make life easier
                        var directiveElementFocusable = (0, _ui.focusable)(element[0]);

                        // this works by fallthrough. it will try each one
                        // in succession until an element is found
                        if (attrs.focusElement) {
                            // scenario 1 - specific element provided
                            $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
                        }

                        if ($elementToFocus.length === 0 && !directiveElementFocusable) {
                            // scenario 2 - element with directive is not focusable
                            $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
                        }

                        // default / scenario 3 - no valid targets specified or found
                        if ($elementToFocus.length === 0) {
                            $elementToFocus = (0, _jquery2['default'])(element);
                        }

                        $elementToFocus.first().focus();
                    }
                });
            }

            var active = true;

            if ('focusedOnceBefore' in attrs) {
                active = false;
                (0, _jquery2['default'])(element).on('focus', function () {
                    active = true;
                });
            }

            if (attrs.focusRefreshOn) {
                scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
                    locateAndFocus(active);
                });
            } else {
                scope.$watch(attrs.focusWhen, function (val) {
                    locateAndFocus(active && val);
                });
            }
        }
    };
});

// angularUI router specific - listens to a specific transition
// defined in two attributes, focusWhenState (this directive) and TransitionsTo
var FOCUS_EVENT_NAME = 'accessible-focus';
(0, _squid.$registerDirective)('focus-when-state', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var startState = attrs.focusWhenState;
            var endState = attrs.transitionsTo;
            var transitionMessage = startState + ' > ' + endState;
            var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (fromState.name === startState && toState.name === endState) {
                    scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
                }
            });

            scope.$on(FOCUS_EVENT_NAME, function (event, message) {
                if (message === transitionMessage) {
                    (0, _angular.$timeout)(function () {
                        return element[0].focus();
                    });
                }
            });

            // see http://stackoverflow.com/a/27016855
            scope.$on('$destroy', unregisterEventFn);
        }
    };
});

// Listens for the next state transition and focuses an element provided by selector
// Use with links where focus is needed to return to a specific element after the transition
(0, _squid.$registerDirective)('focus-after-transition', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.on('click', function () {
                var focusSelector = attrs['focusAfterTransition'];
                var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    cancel();
                    (0, _angular.$timeout)(function () {
                        (0, _jquery2['default'])(focusSelector).focus();
                    });
                });
            });
        }
    };
});

// focuses on the first focusable element on a container containing form elements
(0, _squid.$registerDirective)('form-autofocus', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            // wait for the entire DOM to settle down first
            (0, _angular.$timeout)(function () {
                var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
                if ($allFocusable.length > 0) {
                    $allFocusable.first().focus();
                }
            });
        }
    };
});

// Change element to be focusable and tabbable or unfocusable if it is
// not typically a focusable element by removing the tabindex attribute.
(0, _squid.$registerDirective)('focusable', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function setFocusable(value) {
                if (value) {
                    element.attr('tabindex', 0);
                } else {
                    element.removeAttr('tabindex');
                }
            }

            if (attrs.focusable) {
                scope.$watch(attrs.focusable, function (newVal) {
                    if (newVal) {
                        setFocusable(true);
                    } else {
                        setFocusable(false);
                    }
                });
            } else {
                setFocusable(true);
            }
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$timeout;

_angular.$rootScope;

_angular.isDefined;

_ui.KEYS;

_ui.focusable;

_ui.tabbable;

_ui.findAll;

_ui.filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/ui.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var KEYS = {
    TAB: 0x09,
    ENTER: 0x0D,
    ESC: 0x1B,
    SPACE: 0x20,
    LEFT: 0x25,
    UP: 0x26,
    RIGHT: 0x27,
    DOWN: 0x28
};

function visible(element) {
    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
        return _jquery2['default'].css(this, 'visibility') === 'hidden';
    }).length;
}

// ripped from http://stackoverflow.com/a/7668761
/* istanbul ignore next */
function focusable(element) {
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
    var map;
    var mapName;
    var img;

    if (nodeName === 'area') {
        map = element.parentNode;
        mapName = map.name;
        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
            return false;
        }
        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
        return !!img && visible(img);
    }
    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
    // the element and all of its ancestors must be visible
    visible(element);
}

/* istanbul ignore next */
function tabbable(element) {
    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
    var isTabIndexNaN = isNaN(tabIndex);

    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}

function filterAll(elements, filterFn) {
    return (0, _jquery2['default'])(elements).filter(function () {
        return filterFn(this);
    });
}

function findAll(container, filterFn) {
    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
}

exports.KEYS = KEYS;
exports.visible = visible;
exports.focusable = focusable;
exports.tabbable = tabbable;
exports.findAll = findAll;
exports.filterAll = filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/address-box/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/address-box/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/address-box/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _squid.$registerDirective)('xo-address-box', function () {
    return {
        template: _template2['default'],
        scope: {
            header: '=?',
            fullname: '=?',
            addresses: '=?',
            changeFn: '=?'
        },
        lifecycle: {
            enter: function enter() {
                _logger.$logger.info('xo-address-box_enter');
            }
        },
        controller: ['$scope', function ($scope) {
            var addressList = $scope.addresses && $scope.addresses.addresses || [];

            $scope.address = addressList[0] || {};
            $scope.line3 = $scope.address.city + ', ' + $scope.address.state + ' ' + $scope.address.postal_code;
            $scope.updateType = addressList.length > 1 ? _squid.$locale.content.get('common.change') : _squid.$locale.content.get('common.edit');
            $scope.updateFn = function () {
                return $scope.changeFn($scope.updateType);
            };
            $scope.fullname = $scope.fullname;
            if ($scope.fullname) {
                $scope.name = $scope.fullname.first_name + ' ' + $scope.fullname.last_name;
            }
        }]
    };
});

_squid.$registerDirective;

_squid.$locale;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/address-box/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/address-box/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"address-box-wrapper\">\n\n    <div class=\"box-header\">\n        <div class=\"headerText\">{{header}}</div>\n        <div class=\"updateButton\">\n            <a ng-click=\"updateFn()\">{{updateType}}</a>\n        </div>\n    </div>\n    <div class=\"box-body\">\n        <p ng-if=\"name\">{{name}}</p>\n        <p>{{address.line1}}</p>\n        <p>{{address.line2}}</p>\n        <p>{{line3}}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoBanner', {
    tag: 'xo-banner',
    template: _template2['default'],
    transclude: true,
    props: {
        isNmj: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        // Need buyer_id from $AuthModel first to get the URL for the user profile photo
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()
            };
        },
        userPhoto: function userPhoto(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    photoData: _index.$UserPhotoModel.instance(models.auth.buyer_id).retrieve({
                        params: {
                            'min_size': 45
                        }
                    })['catch'](function (error) {
                        _logger.$logger.info('error_retrieve_user_photo');
                        return {};
                    })
                };
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var avatarElement = this.$element.find('#banner-picture');
            var auth = this.models.auth;
            var photoData = this.userPhoto.photoData;

            // Currently only showing initials for New Member Journey
            var showInitials = auth.first_name && auth.last_name && this.props.isNmj;

            if (avatarElement && auth.buyer_id) {
                // The "phantom" avatar image is displayed by default via CSS
                // background-image property. If the request for a user's
                // profile photo returns a URL, the background-image property
                // is replaced with that URL.

                // Show user photo for avatar
                if (photoData && photoData.photo_url) {
                    avatarElement.css('background-image', 'url("' + photoData.photo_url + '")');
                    _logger.$logger.info('xoBanner_user');
                }

                // No user photo: show user initials instead of phantom image
                if (!photoData.photo_url && showInitials) {
                    avatarElement.addClass('initials');
                    this.initials = '' + auth.first_name[0] + auth.last_name[0];
                    _logger.$logger.info('xoBanner_initials');
                }
            } else {
                // Leave the phantom avatar as the background image
                _logger.$logger.info('xoBanner_default');
            }
        }
    }
});


_squid.$Component;

_auth.$AuthModel;

_index.$UserPhotoModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\">{{ initials }}</div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCardLoader = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/styles.less");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/card-loader/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoCardLoader', {
    tag: 'xo-card-loader',
    template: _template2['default'],
    props: {
        message: {
            type: 'str',
            required: false
        },
        state: {
            type: 'var',
            required: false
        },
        auth: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            this.ellipsis = function () {
                var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                var MAX_EMAIL_LEN = 30;
                var MAX_DOMAIN_LEN = 20;
                var MAX_USERNAME_LEN = MAX_EMAIL_LEN - MAX_DOMAIN_LEN;

                if (email.length <= MAX_EMAIL_LEN) {
                    return email;
                }

                var userNameLength = email.indexOf('@');
                var domainLength = email.length - userNameLength;

                if (userNameLength > MAX_USERNAME_LEN && domainLength > MAX_DOMAIN_LEN) {
                    return email.replace(new RegExp('(.{' + (MAX_USERNAME_LEN - 3) + '}).*(@.{' + (MAX_DOMAIN_LEN - 4) + '}).*'), '$1...$2...');
                } else if (userNameLength > MAX_USERNAME_LEN) {
                    return email.replace(new RegExp('(.{' + (MAX_EMAIL_LEN - domainLength - 3) + '}).*(@.*)'), '$1...$2');
                } else {
                    return email.replace(new RegExp('(.{' + (MAX_EMAIL_LEN - 3) + '}).*'), '$1...');
                }
            };
        }
    }
});

angular.value("$xoCardLoader", $xoCardLoader);
_squid.$Component;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"virtual_card\">\n    <div id=\"card_header\">\n        <div id=\"card_logo\"></div>\n    </div>\n    <div id=\"card_footer\">\n        <div class=\"card_user\" ng-if=\"auth.loggedIn()\">{{ellipsis(auth.email)}}</div>\n    </div>\n    <div id=\"slider\" class=\"{{state}}\"></div>\n</div>\n<div id=\"virtual_card_message\">{{message}}</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/cardicon/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoFiIcon = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

var _template = __webpack_require__("../node_modules/xo-ui-components/src/cardicon/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoFiIcon = exports.$xoFiIcon = _squid.$Component.extend('xoFiIcon', {
    tag: 'xo-fi-icon',
    wrapperType: 'span',
    template: _template2['default'],
    transclude: true,
    props: {
        fi: {
            type: 'var',
            required: false
        },
        className: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                fiMeta: _index2['default'].instance(_angular.$rootScope.token).fetch()
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            var updateCardArt = function updateCardArt() {
                _this.retrievedCardArt = _this.models.fiMeta.getCardArt(_this.props.fi);

                if (_this.retrievedCardArt) {
                    _this.cardStyle = {
                        'background-image': 'url(' + _this.retrievedCardArt + ')',
                        'background-size': 'contain',
                        'background-position': 'initial'
                    };
                }
            };

            this.$watch('props.fi', updateCardArt);
        }
    }
});

angular.value("$xoFiIcon", $xoFiIcon);
_squid.$Component;

_angular.$rootScope;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/cardicon/template.html":
/***/ (function(module, exports) {

module.exports = "<span ng-if=\"retrievedCardArt\">\n    <span class=\"standardCardIcon fsIcon fsIcons img-retina\" ng-class=\"className\" ng-style=\"cardStyle\"></span>\n</span>\n<span ng-if=\"!retrievedCardArt\">\n    <div ng-if=\"models.fiMeta.isPinlessDebit(fi)\" class=\"standardCardIcon pinlessGlyphIcon icon icon-card-half-solid\"></div>\n    <div ng-if=\"!models.fiMeta.isPinlessDebit(fi)\" class=\"standardCardIcon fsIcon fsIcons img-retina\" ng-class=\"[fi.type, fi.card_type, fi.name, className]\" ng-transclude>\n    </div>\n</span>\n\n\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/styles.less");

/**
 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
 *
 * Add directionality to the container html div element of a input field.
 * <div directionality><input type=text ng-model="user.name"></div>
 */
(0, _squid.$registerDirective)('directionality', function () {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            var currentWatchDeregister = void 0;
            var input = element.find('input');

            if (!input.length) {
                listenForInputRendered();
                return;
            }

            // If the input has not yet been rendered inside the container, listen for dom node inserted
            // then, if the node inserted is an input, we will use that element and init the directionality
            // listeners. The first input rendered is the one that will be captured by this directive.
            function listenForInputRendered() {
                element.bind('DOMNodeInserted', checkDOMNodeInserted);

                function checkDOMNodeInserted(event) {
                    if (event && event.target && event.target.tagName === 'INPUT') {
                        element.unbind('DOMNodeInserted', checkDOMNodeInserted);
                        input = angular.element(event.target);
                        init();
                    }
                }
            }

            function setDirectionality(value) {
                if (value) {
                    // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
                    element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
                } else {
                    element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
                }
            }

            function jqueryOnKeyupHandler(event) {
                setDirectionality(event.target.value);
            }

            // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
            function resetDirectionalityListener() {
                // remove directionality listeners that were set on prior locale
                input.unbind('keyup', jqueryOnKeyupHandler);
                if (currentWatchDeregister) {
                    currentWatchDeregister();
                }

                // set new directionality listeners for the current locale if 'rtl'
                if (document.documentElement.getAttribute('dir') === 'rtl') {
                    (0, _angular.$timeout)(function () {
                        // Watch ng-model on input to set directionality if it contains RTL char
                        currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
                            setDirectionality(value);
                        });
                        // jQuery listener for cases where ng-model is not populated until post validation
                        input.on('keyup', jqueryOnKeyupHandler);
                    });
                }
            }

            function init() {
                resetDirectionalityListener();
                scope.$on('localeChange', function () {
                    resetDirectionalityListener();
                });
            }

            init();
        }
    };
});

/**
 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
 * or dir="ltr" attribute to the html element.
 *
 * Add directionality-text="<<model>>" to the div or span or any element containing text.
 * <span directionality-text="user.name"><{{user.name}}</span>
 */
(0, _squid.$registerDirective)('directionality-text', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            if (document.documentElement.getAttribute('dir') === 'rtl') {
                var $element = $(element);

                (0, _angular.$timeout)(function () {
                    if (attrs.directionalityText) {
                        scope.$watch(attrs.directionalityText, function () {
                            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
                        });
                    } else {
                        $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
                    }
                });
            }
        }
    };
});

_squid.$util;

_squid.$registerDirective;

_angular.$document;

_angular.$parse;

_angular.$timeout;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/dropdown-multiline/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {
    squid.module('xo-dropdown-multiline.directive', ['squid']).directive('xoDropdownMultiline', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function link($scope, $select, attrs, ngModel) {
                var isListVisible = false;
                var listCreated = false;

                $select = $($select);

                var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
                var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
                var $list = void 0;

                function updateCover() {
                    $timeout(function () {
                        $span.find('span span').html($select.find('[selected]').text().replace(/\\n/gi, '<br>').trim());
                    }, 10);
                }

                function createList($options) {
                    if ($options.length < 2) {
                        return;
                    }

                    function getModel() {
                        var modelName = void 0;
                        var model = void 0;
                        var subParts = void 0;

                        if ($select.attr('ng-options')) {
                            modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
                        } else {
                            var $option = $($select.find('[ng-repeat]')[0]);

                            modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
                        }

                        // This is to handle cases like card.billingAddress
                        if (modelName.indexOf('.') !== -1) {
                            subParts = modelName.split('.');
                            model = $scope;

                            for (var i = 0; i < subParts.length; i++) {
                                model = model[subParts[i]];
                            }
                        } else {
                            // And this is to handle straightforward model names
                            model = $scope[modelName];
                        }

                        return model;
                    }

                    function hideList(event) {
                        $list.hide();
                        $container.append($list);
                        isListVisible = false;
                        $container.removeClass('open');
                    }

                    function positionList() {
                        $list.css('left', $container.offset().left + 'px');
                        $list.css('top', $container.offset().top + $container.height() + 'px');
                        $list.css('width', $container.width() + 'px');
                    }

                    function setFocusOnSelected() {
                        var $selected = $select.find('[selected]');

                        if ($selected.length) {
                            var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');

                            $item.focus();
                        } else {
                            $list.find('li')[0].focus();
                        }
                    }

                    function showList() {
                        $('body').append($list);
                        $container.addClass('open');
                        $list.show();
                        positionList();
                        isListVisible = true;
                        setFocusOnSelected();
                    }

                    function processContainerKeypress(event) {
                        var keyCode = event && event.keyCode;

                        if (keyCode === 13 || keyCode === 40) {
                            // enter or down arrow
                            if (!isListVisible) {
                                showList();
                            } else {
                                hideList();
                                $container.focus();
                            }
                        } else if (keyCode === 27) {
                            // escape
                            if (isListVisible) {
                                hideList();
                                $container.focus();
                            }
                        }
                    }

                    if ($list) {
                        $list.remove();
                    }

                    $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');

                    Array.prototype.forEach.call($options, function (option) {
                        var $option = $(option);
                        var value = $option.attr('value');
                        var text = option.innerHTML.replace(/\\n/gi, '<br>');

                        if (text.indexOf('content(') !== -1) {
                            text = $scope.content(text.substring(text.indexOf('(\'') + 2, text.indexOf('\')')));
                        }

                        var html = '<li tabindex="0"';

                        if (value !== $option.text()) {
                            html = html + ' data-value="' + value + '"';
                        }
                        html = html + '>' + text + '</li>';
                        $list.append($(html));
                    });

                    $container.append($list);
                    $list.hide();

                    $($list.find('li')).click(function (event) {
                        var $target = $(event.target);
                        var value = $target.data('value');

                        if (typeof value !== 'undefined') {
                            $select.find('option').removeAttr('selected');
                            $select.find('option[value="' + value + '"]').attr('selected', 'selected');
                            $select.find('option').removeProp('selected');
                            $select.find('option[value="' + value + '"]').prop('selected', 'selected');
                        } else {
                            value = $target.html().replace(/\/<br\/>/gi, '\\n');
                            $select.val(value);
                        }

                        if ($select.attr('ng-model')) {
                            if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
                                /* This parses the 'ng-options' directive and returns the options model.
                                For example: If you have: ng-options='opt as opt.label for opt in options'
                                Here it will parse this attribute and return 'options */
                                var model = getModel();

                                ngModel.$setViewValue(model[value]);
                            } else {
                                ngModel.$setViewValue(value);
                            }
                        }
                        updateCover();
                        hideList();
                    });

                    var $innerContainer = $container.find('.innerContainer');

                    $container.click(function () {
                        if (isListVisible) {
                            hideList();
                            $container.focus();
                        } else {
                            showList();
                        }
                    });

                    $container.keydown(function (event) {
                        return processContainerKeypress(event);
                    });
                    $innerContainer.keydown(function (event) {
                        return processContainerKeypress(event);
                    });

                    $list.find('li').keydown(function (event) {
                        var keyCode = event && event.keyCode;
                        var $target = $(event.target);

                        if (keyCode === 13) {
                            // enter
                            $target.click();
                            event.stopPropagation();
                        } else if (keyCode === 27) {
                            // escape
                            if (isListVisible) {
                                hideList();
                                $container.focus();
                                event.stopPropagation();
                            }
                        } else if (keyCode === 40) {
                            // down arrow
                            if (!$target.is(':last-of-type')) {
                                $target.next().focus();
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        } else if (keyCode === 38) {
                            // up arrow
                            if (!$target.is(':first-of-type')) {
                                $target.prev().focus();
                            }
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    });

                    $(window).resize(function () {
                        if (isListVisible) {
                            positionList();
                        }
                    });

                    $(window).bind('hashchange', function () {
                        if (isListVisible) {
                            hideList();
                        }
                    });

                    $(document).click(function (event) {
                        var $target = $(event.target);

                        if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
                            hideList();
                        }
                    });

                    $container.blur(function (event) {
                        // The setTimeout here is to ensure activeElement is set before our function executes
                        $timeout(function () {
                            var $newTarget = $(event.explicitOriginalTarget || document.activeElement);

                            if (!($.contains($container.get()[0], $newTarget.get()[0]) || $.contains($list.get()[0], $newTarget.get()[0]))) {
                                hideList(event);
                            }
                        }, 1);
                    });

                    listCreated = true;
                    updateCover();
                }

                function render() {
                    var options = $select.find('option');

                    if (!listCreated) {
                        createList(options);
                    }
                }

                $select.wrap($container);
                $container = $select.parent();

                // Change class names to enable styling of hover/focus states
                $select.bind('mouseenter focus', function () {
                    return $span.addClass('active');
                });
                // Change class names to enable styling of hover/focus states
                $select.bind('mouseleave blur', function () {
                    return $span.removeClass('active');
                });
                $select.after($span);
                $select.addClass('replaced');
                $select.attr('tabindex', '-1');

                if (attrs['default']) {
                    var defaultOption = document.createElement('option');

                    defaultOption.innerText = attrs['default'];
                    $select.append(defaultOption);
                }

                if ($select.attr('ng-options')) {
                    $scope.$watch(attrs.ngModel, function () {
                        render();
                    });
                } else {
                    $timeout(function () {
                        return $scope.$broadcast('pageRendered');
                    });
                }

                $scope.$on('pageRendered', function () {
                    return render();
                });
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/dropdown/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {
    $.fn.dropdown = function () {
        console.warn('Dropdown deprecated');
    };
    squid.module('xo-dropdown.directive', ['squid']).directive('xoDropdown', ['$parse', '$window', '$timeout', '$util', '$compile', function ($parse, $window, $timeout, $util, $compile) {
        var userAgent = ($window.navigator || {}).userAgent;
        var isWinOS = Boolean(userAgent.match(/\(win/i));

        return {
            restrict: 'A',
            scope: {
                dropdownTextBindVar: '=?'
            },
            link: function link($scope, $element, attrs) {
                var $parentScope = $scope.$parent;
                var $select = $($element);
                // TODO: This html should be refactored out into a template.
                var $span = $('<span class="custom-select" aria-hidden="true"><span><span></span></span></span>');
                var selectInitialValue = '';
                var ngChange = '';

                $select.parent().addClass('custom-select-container');
                // Change class names to enable styling of hover/focus states
                $select.bind('mouseenter', function () {
                    return $span.addClass('active');
                });
                $select.bind('mouseleave', function () {
                    return $span.removeClass('active');
                });
                // Change class names to enable styling of hover/focus states
                $select.bind('focus', function () {
                    selectInitialValue = $parse(attrs.ngModel)($parentScope);
                    $span.addClass('active');
                });

                function executeSelectChange() {
                    // setTimeout here is to ensure activeElement is set before our function executes
                    $timeout(function () {
                        var val = $parse(attrs.ngModel)($parentScope);

                        if (selectInitialValue !== val) {
                            if (ngChange) {
                                ngChange($parentScope);
                            }
                            selectInitialValue = val;
                        }
                    }, 5);
                }

                if (isWinOS) {
                    if (attrs['ngChange']) {
                        ngChange = $parse(attrs.ngChange);
                        attrs['ngChange'] = '';
                    }

                    $select.bind('blur', function () {
                        executeSelectChange();
                        $span.removeClass('active');
                    });
                    $select.bind('click', function () {
                        return executeSelectChange();
                    });
                } else {
                    $select.bind('blur', function () {
                        return $span.removeClass('active');
                    });
                }

                $select.after($span);
                $select.addClass('replaced');

                if (attrs['default']) {
                    var defaultOption = document.createElement('option');

                    defaultOption.innerText = attrs['default'];
                    $select.append(defaultOption);
                }

                var match = (attrs.ngOptions || '').match(/in ([\w\.]+)/);
                // Text Update Method 1(new): ng-bind on variable passed in directive and that is updated in parent/sibling scope
                if (angular.isDefined($scope.dropdownTextBindVar)) {
                    var selectTextElement = $span.find('span span');

                    if (selectTextElement.length) {
                        $(selectTextElement).attr('ng-bind', 'dropdownTextBindVar');
                        $(selectTextElement).html($compile(selectTextElement[0])($scope));
                    }

                    $scope.$watch('dropdownTextBindVar', function (newVal) {
                        if (document.documentElement.getAttribute('dir') === 'rtl') {
                            $span.toggleClass('ltrOverride', !$util.hasRTL(newVal));
                        }
                    });
                }
                // Text Update Method 2(old): jQuery text update on various conditions (not as reliable for me, ran into timing edge cases)
                else {
                        var updateCover = function updateCover() {
                            $timeout(function () {
                                var text = $select.find(':selected').text().trim();

                                $span.find('span span').text(text);
                                if (document.documentElement.getAttribute('dir') === 'rtl') {
                                    $span.toggleClass('ltrOverride', !$util.hasRTL(text));
                                }
                            }, 5);
                        };

                        $parentScope.$watch(attrs.ngModel, updateCover);
                        $scope.$on('contentChange', updateCover);
                        if (match) {
                            $parentScope.$watch(match[1], updateCover);
                        }
                        // Update cover on arrow key press, for case where menu is not open
                        // but user is interacting with dropdown (eg. Firefox)
                        $select.bind('keyup', function (event) {
                            // Arrow keys are 37 - 40
                            if (event.which >= 37 || event.which <= 40) {
                                updateCover();
                            }
                        });
                    }

                toggleOptionsLTROverride();
                if (match) {
                    $parentScope.$watch(match[1], function (newVal) {
                        toggleOptionsLTROverride();
                    });
                }

                function toggleOptionsLTROverride() {
                    if (document.documentElement.getAttribute('dir') === 'rtl') {
                        $timeout(function () {
                            var options = $select.find('option');

                            for (var i = 0; i < options.length; i++) {
                                $(options.get(i)).toggleClass('ltrOverride', !$util.hasRTL(options.get(i).text));
                            }
                        });
                    }
                }
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/error-tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angularAria = __webpack_require__("../node_modules/angular-aria/angular-aria.min.js");

// Configure angular aria.
// Note that aria configuration applies globally
_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
    bindRoleForClick: false,

    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
    // These attributes should only be set once the form is submitted, to match what
    // visually what we display
    ariaInvalid: false,
    ariaRequired: false,
    // Removing aria-hidden attribute for hidden elements
    ariaHidden: false
});

(0, _squid.$registerDirective)('xo-error-tooltip', function () {
    return {
        restrict: 'A',
        require: ['?^form', '?ngModel'],
        link: function link(scope, element, attrs, ctrls) {
            var formCtrl = ctrls[0],
                modelCtrl = ctrls[1];


            function shouldBeRequired() {
                if (formCtrl) {
                    // If input is a checkbox and has error-text or error-key, show the error text instead of the required text.
                    // error-text is a legacy thing for backward compatibility, we can get rid of this once all teams
                    // adopt error-key in all input tags
                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && (attrs.errorText || attrs.errorKey));

                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
                } else {
                    return modelCtrl.$error.required;
                }
            }

            function shouldBeInvalid() {
                if (formCtrl) {
                    return formCtrl.$submitted && modelCtrl.$invalid;
                } else {
                    return modelCtrl.$invalid;
                }
            }

            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
            function formatSpaceSplitString(str, id, add) {
                var strArray = void 0;

                if (str) {
                    strArray = str.split(' ');
                } else {
                    strArray = [];
                }

                var idIndex = strArray.indexOf(id);

                if (~idIndex && !add) {
                    strArray.splice(idIndex, 1);
                } else if (!~idIndex && add) {
                    strArray.push(id);
                }

                return strArray.join(' ');
            }

            // Add tooltip behavior after DOM settles
            (0, _angular.$timeout)(function () {
                var generateId = function generateId() {
                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
                };
                var requiredId = generateId();
                var invalidId = generateId();
                var requiredError = void 0;
                var invalidError = void 0;

                if (attrs.errorKey) {
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">{{content("' + attrs.errorKey + '")}}</div>')(scope);
                    element.after(invalidError);
                } else if (attrs.errorText) {
                    // errorText if case is for backward compatibility, we can get rid of this once
                    // all teams adopt error-key in all input tags for tooltip message display
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
                    element.after(invalidError);
                }

                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
                    element.addClass('hasErrorTooltipRequired');
                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
                    element.after(requiredError);
                    element.removeAttr('aria-required');
                }

                function setAriaAttributes() {
                    var addTooltips = {
                        required: false,
                        invalid: false
                    };

                    // Do not associate "Required" error with aria-describedby
                    // because this should already be read out either by "required"
                    // attribute or "aria-required"=true, and only associate "Invalid"
                    // error if "Required" is not showing to match visuals
                    if (shouldBeRequired()) {
                        addTooltips.required = true;
                    } else if (shouldBeInvalid()) {
                        addTooltips.invalid = true;
                    }

                    var describedby = element.attr('aria-describedby');

                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
                    element.attr('aria-describedby', describedby);
                }

                scope.$watch(shouldBeRequired, function (newVal) {
                    setAriaAttributes();
                });
                scope.$watch(shouldBeInvalid, function (newVal) {
                    element.attr('aria-invalid', newVal);
                    setAriaAttributes();
                });

                // Set scroll so that the error message is in view when element receives focus
                element.on('focus', function (event) {
                    var windowBot = $(window).scrollTop() + $(window).height();
                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;

                    if (windowBot < Math.max(requiredBot, invalidBot)) {
                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
                    }
                });
            });
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$compile;

_angular.$timeout;

_angularAria.$ariaProvider;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("../node_modules/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {

    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', [function () {
        return {
            template: template,

            restrict: 'E',

            scope: {
                redirectiframe: '=?',
                redirectLightbox: '=?'
            },

            controller: ['$scope', '$rootScope', '$populate', '$CheckoutInputDataModel', '$window', '$CheckoutAppDataModel', '$util', '$injector', '$logger', function ($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger) {

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                }).then(function () {
                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;

                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
                    $scope.isIFrame = $util.isIFrame();

                    $scope.closeFrame = function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        if (window.xchild) {
                            if (window.xprops.onCancel) {
                                return window.xprops.onCancel({
                                    token: $scope.token,
                                    cancelUrl: cancel_url
                                });
                            } else {
                                return window.xchild.close();
                            }
                        }

                        if ($scope.redirectLightbox) {
                            var result = _index.$ReturnToMerchant.postToMerchant({
                                operation: 'return_to_merchant',
                                returnUrl: cancel_url,
                                updateParent: true
                            });

                            // Otherwise we have no choice but to return to the merchant
                            if (!result) {
                                $util.redirect(cancel_url);
                            }

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else if ($scope.redirectiframe) {
                            $window.location.replace(cancel_url);

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else {

                            var iFrameFlow = $injector.get('$IFrameFlow');

                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');

                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');

                            if ($scope.auth && $scope.auth.code) {
                                url += '&code=' + $scope.auth.code;
                            }

                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
                        }
                        $scope.$emit('exitFrame');
                    };
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_index.$ReturnToMerchant;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {

    squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', [function () {
        return {
            template: template,

            restrict: 'E',

            controller: ['$scope', '$rootScope', '$window', '$util', '$logger', function ($scope, $rootScope, $window, $util, $logger) {
                $scope.isIFrame = $util.isIFrame();
                $scope.closeFrame = function (event) {
                    var url = $window.location.href && $window.location.href.split('#')[0] || '';

                    if (url.indexOf('proxflow') > -1) {
                        url = url.replace('proxflow', 'webapps/helios');
                    }

                    url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';

                    if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
                        $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
                    } else {
                        $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
                    }

                    $window.top.location = url;
                    $scope.$emit('exitFrame');
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/experience/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ExperienceComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/experience/template.html");

var _template2 = _interopRequireDefault(_template);

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ExperienceComponent = exports.$ExperienceComponent = _squid.$Component.extend('ExperienceComponent', {
    tag: 'experience',
    template: _template2['default'],
    transclude: true,
    props: {
        flag: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                // temporary until experience layer develops, which should do all of this logic via flag config (something like `experienceConfig.get('flag')`)
                fiMeta: _fiMeta2['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var negate = this.props.flag[0] === '!';
            var fiMeta = this.models.fiMeta;

            // lies

            this.renderExperience = fiMeta && fiMeta.cardArtEnabled();

            if (negate) {
                this.renderExperience = !this.renderExperience;
            }
        }
    }
});

angular.value("$ExperienceComponent", $ExperienceComponent);
_squid.$Component;

_angular.$rootScope;

_angular.noop;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/experience/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-style=\"style\">\n    <ng-transclude ng-if=\"renderExperience\"></ng-transclude>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-fi-panel/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoExpiredFiPanel', {
    tag: 'xo-expired-fi-panel',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        fi: {
            type: 'var',
            required: false
        }
    }
});


_squid.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-fi-panel/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$ExpiredFiPanelFactory', [function () {

    var disallowedContentMap = {
        'INSTRUMENT_VERIFICATION_FAILED': 'wallet.disallowedDueToPreAuth',
        'unsupportedGeneric': 'wallet.unsupportedDueToRisk',
        'unsupportedByProduct': 'wallet.unsupportedDueToReceiverPreference',
        'unsupportedDueToExpiration': 'wallet.unsupportedDueToExpiration'
    };
    var disallowedExp = {
        resourceName: 'xo_preauth_disallowed_instruments',
        control: 'xo_preauth_disallowed_instruments_control',
        disallowedFi: 'xo_preauth_disallowed_instruments_disallowed_fi',
        preAuth: 'xo_preauth_disallowed_instruments_preauth'
    };

    var getPxpResult = function getPxpResult(models) {
        var schedule = models.cart && models.cart.isBilling() ? 'BILLING' : 'ONE_TIME_PAYMENT';
        var approval_type = models.cart && models.cart.isPurchase() ? 'PURCHASE' : 'NOT_PURCHASE';
        var solution = _squid.$integration.isFlow('WPS') ? 'WEBSITE_PAYMENTS_STANDARD' : 'EXPRESS_CHECKOUT';

        return (0, _squid.$elmo)(disallowedExp.resourceName, { 'ctx.country': _squid.$locale.country, 'ctx.flow': 'HERMES', 'ctx.schedule': schedule, 'ctx.approval_type': approval_type, 'ctx.solution': solution }, disallowedExp.resourceName + '(.*)').then(function (result) {
            return result && result.treatment_name;
        });
    };

    var filterInstrumentsFromDisallowed = function filterInstrumentsFromDisallowed(instrument, fundingOptions) {
        var match = fundingOptions.find(function (fundingInstrument) {
            return fundingInstrument.id === instrument.id;
        });
        return match === undefined;
    };

    var disallowedDueToPreAuth = function disallowedDueToPreAuth(disallowedFi, fundingOptions) {
        return disallowedFi.filter(function (i) {
            return i.declineReason === 'INSTRUMENT_VERIFICATION_FAILED' && i.isPreferred !== true && filterInstrumentsFromDisallowed(i, fundingOptions);
        });
    };

    var disallowedDueToOther = function disallowedDueToOther(disallowedFi, fundingOptions) {
        return disallowedFi.filter(function (i) {
            return i.type && i.type !== 'REWARDS' && i.declineReason !== 'INSTRUMENT_VERIFICATION_FAILED' && i.isPreferred !== true && filterInstrumentsFromDisallowed(i, fundingOptions);
        });
    };

    var mapDisallowedContent = function mapDisallowedContent(disallowed, token) {
        if (disallowed.type === 'CARD') {
            disallowed.message = disallowedContentMap[disallowed.declineReason] ? disallowedContentMap[disallowed.declineReason] : disallowedContentMap['unsupportedGeneric'];
            logInstrumentToFpti(disallowed, token);
            return disallowed;
        } else {
            disallowed.message = disallowedContentMap['unsupportedGeneric'];
            logInstrumentToFpti(disallowed, token);
            return disallowed;
        }
    };

    var logInstrumentToFpti = function logInstrumentToFpti(instrument, token) {
        var fptiPayload = {
            'from': 'POST_PLANNING',
            'to': 'exception_disallowed_fi',
            'context_type': _squid.$integration.isFlow('WPS') ? 'WEBSITE_PAYMENTS_STANDARD' : 'EXPRESS_CHECKOUT',
            'context_id': token,
            'fi_id': instrument.id,
            'disallowed_reason': instrument.declineReason,
            'message': instrument.message
        };
        _logger.$logger.info('checkout_fpti', fptiPayload);
    };

    var getAllInstruments = function getAllInstruments(models) {
        var instruments = [].concat(models.checkoutSession.get('fundingOptions').getDisplayInstruments());
        var token = models.checkoutSession.get('id');

        return getPxpResult(models).then(function (result) {
            if (result === disallowedExp.control) {
                return _squid.$promise.resolve(instruments);
            } else if (result === disallowedExp.disallowedFi || result === disallowedExp.preAuth) {
                var disallowedFi = models.checkoutSession.getDisallowedInstruments();

                if (!disallowedFi) {
                    return _squid.$promise.resolve(instruments);
                }
                var fundingOption = models.checkoutSession.get('fundingOptions.instruments');
                var disallowedPreAuth = disallowedDueToPreAuth(disallowedFi, fundingOption);
                var disallowedPreferred = models.checkoutSession.getDisallowedPreferred();
                var disallowedOther = disallowedDueToOther(disallowedFi, fundingOption);

                if (disallowedPreferred) {
                    instruments.push(mapDisallowedContent(disallowedPreferred, token));
                }
                if (disallowedPreAuth && disallowedPreAuth.length) {
                    _squid.$util.forEach(disallowedPreAuth, function (instrument) {
                        instruments.push(mapDisallowedContent(instrument, token));
                    });
                }
                if (disallowedOther && disallowedOther.length) {
                    _squid.$util.forEach(disallowedOther, function (instrument) {
                        instruments.push(mapDisallowedContent(instrument, token));
                    });
                }
            }
            return _squid.$promise.resolve(instruments);
        });
    };

    return {
        getPxpResult: getPxpResult,
        getAllInstruments: getAllInstruments,
        disallowedExp: disallowedExp
    };
}]);

_squid.$util;

_squid.$locale;

_squid.$promise;

_squid.$elmo;

_squid.$integration;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-ui-components/src/expired-fi-panel", "../node_modules/xo-ui-components/src/expired-fi-panel/factory.js"))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-fi-panel/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-fi-panel/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"disallowedFiPanel\" ng-if=\"fi.declineReason || fi.gotDeclined\" content>\n    <span ng-if=\"fi.isPreferred\" class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n    <span class=\"message\">{{ content(fi.message) }}</span>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/expired-message/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/expired-message/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoExpiredMessage', {
    tag: 'xo-expired-message',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
        // TODO: currently `xo_hermes_preferred_expired_msg_review_page` pxp has been turned off
        // however, AuthRate team plans to turn back this experiment after moratorium
        // Also, please see uncomment similar logic from Hermesnodeweb (public/pages/xo-review)
        // experiments() {
        //     return {
        //         showPreferredExpiredMsg: $ExpiredMsgFactory.getPreferredExpiredPxpResult()
        //     };
        // }

    },
    actions: {
        goToManageWallet: function goToManageWallet(fiID) {
            if (fiID) {
                _logger.$logger.info('update_expired_preferred');
                _uiRouter.$state.go('checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard', {
                    planId: fiID,
                    doneUri: 'checkout.review'
                });
            } else {
                _logger.$logger.info('manage_expired_cards');
                _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
            }
        }
    },

    lifecycle: {
        populate: function populate() {
            // if (this.experiments.showPreferredExpiredMsg === 'xo_hermes_preferred_expired_msg_review_page_treatment') {
            //     this.preferredExpired = this.models.checkoutSession.getDisallowedPreferred();
            // }
        }
    }
});


_uiRouter.$state;

_squid.$Component;

_logger.$logger;

_index.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"preferredExpired\" id=\"notifications\" content>\n    <div class=\"msgPage msg-info\">\n        <span class=\"icon\"></span>\n        <ul>\n            <li>\n                <span ng-bind-html=\"htmlContent('creditcard.preferredExpired', {cardType: preferredExpired.displayName, last4:\n                    preferredExpired.lastDigits})\" ></span><span>\n                    <a id=\"updatePreferredExpired\" track-submit=\"update_preferred_expired\" href\n                       ng-click=\"actions.goToManageWallet(preferredExpired.id)\">{{content('creditcard.updateItNow')}}</a></span>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/fi-panel/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/styles.less");

__webpack_require__("../node_modules/xo-ui-components/src/cardicon/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Pulling out props to iterate over keys
var PROPS = {
    fi: {
        required: false,
        type: 'var'
    },
    plan: {
        required: false,
        type: 'var'
    },
    // Specifically override name
    nameOverride: {
        required: false,
        type: 'var'
    },
    // Ignore different rendering for PAD
    ignorePad: {
        required: false,
        type: 'var'
    },
    // Dont render extra details
    sparse: {
        required: false,
        type: 'var'
    },
    // Requires fi to be passed in
    showAmount: {
        required: false,
        type: 'var'
    },
    // Requires fi to be passed in
    showCurrencyCode: {
        required: false,
        type: 'var'
    },
    // Requires plan to be passed in
    showAllCurrencyCodes: {
        required: false,
        type: 'var'
    }
};

exports['default'] = _squid.$Component.extend('xoFiPanel', {
    tag: 'xo-fi-panel',
    template: _template2['default'],
    transclude: true,
    props: PROPS,
    resolve: {
        models: function models() {
            return {
                fiMeta: _fiMeta2['default'].instance(_angular.$rootScope.token).fetch(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            render.call(this);
            // Props on scope is not iterable, so creating a group to watch from the definition
            this.$watchGroup(Object.keys(PROPS).map(function (p) {
                return 'props.' + p;
            }), function () {
                return render.call(_this);
            });
        }
    }
});

// TODO: figure out pad rendering

function render() {
    var _props = this.props,
        fi = _props.fi,
        plan = _props.plan,
        sparse = _props.sparse,
        showAmount = _props.showAmount,
        showCurrencyCode = _props.showCurrencyCode,
        showAllCurrencyCodes = _props.showAllCurrencyCodes,
        nameOverride = _props.nameOverride,
        ignorePad = _props.ignorePad;
    var _models = this.models,
        fiMeta = _models.fiMeta,
        checkoutAppData = _models.checkoutAppData;

    var merchant = checkoutAppData && checkoutAppData.merchant;
    merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

    this.name = nameOverride || fiMeta.getName(fi);

    var amount = void 0;
    var currencyCodes = void 0;
    var sld = {};
    var secondLineType = void 0;

    if (showAmount) {
        amount = fiMeta.getAmount(fi);
    } else if (showAllCurrencyCodes) {
        currencyCodes = fiMeta.getAllCurrencyCodes(plan).join(', ');
    } else if (showCurrencyCode) {
        currencyCodes = fiMeta.getCurrencyCode(fi);
    }

    if (!nameOverride && fiMeta.isPad(fi) && !ignorePad) {
        secondLineType = 'pad';

        var mask = fiMeta.getCardMask(fi);

        _squid.$util.extend(sld, mask);
    } else if (fi) {
        // Try to render a card mask
        var _mask = fiMeta.getCardMask(fi);

        if (_mask.before || _mask.after) {
            secondLineType = 'mask';
            _squid.$util.extend(sld, _mask);

            if (!sparse) {
                // MEFT/IACH info is only relevant in DE
                if (_squid.$locale.country === 'DE' && fiMeta.isMeft(fi)) {
                    sld.meft = true;
                } else if (_squid.$locale.country === 'DE' && (
                // HACK: when ignorePad name, pretend this is Iach
                fiMeta.isIach(fi) || ignorePad)) {
                    sld.iach = true;
                } else if (fiMeta.isEcheck(fi)) {
                    sld.echeck = true;
                } else if (fiMeta.wallet.isChaseLinkedCard(fi)) {
                    sld.chasePay = true;
                }
            }
        }
    }

    _squid.$util.extend(this, {
        amount: amount,
        currencyCodes: currencyCodes,
        secondLineData: sld,
        secondLineType: secondLineType,
        merchant: merchant
    });
}

_angular.$rootScope;

_squid.$Component;

_squid.$util;

_squid.$locale;

_checkout.$CheckoutAppDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/template.html":
/***/ (function(module, exports) {

module.exports = "<div angular class=\"fsPanel\" content ng-class=\"[fi.type]\">\n    <div class=\"fsdetails fsPanelLeft\">\n        <xo-fi-icon fi=\"fi\" class-name=\"fsIcon\"></xo-fi-icon>\n    </div>\n    <div class=\"fsPanelRight\">\n        <div ng-class=\"{doubleheight: !secondLineType}\">\n            <span ng-if=\"secondLineType === 'pad'\" class=\"fsPanelName\" data-test-id=\"fiName\">{{content('fundingInstruments.pad')}}</span>\n            <span ng-if=\"secondLineType !== 'pad'\" class=\"fsPanelName\" data-test-id=\"fiName\" ng-bind-html=\"name\"></span>&rlm; <span ng-if=\"currencyCodes\">({{currencyCodes}})</span>\n            <span ng-if=\"amount\" class=\"methodAmount\">\n                <span class=\"amountFormatted\">\n                    <format-currency\n                    code=\"amount.currency_code\"\n                    amount=\"amount.amount\"></format-currency>\n                </span>\n            </span>\n        </div>\n        <div ng-if=\"secondLineType\" class=\"fsPanelSecondLine\">\n            <div ng-switch=\"secondLineType\">\n                <div ng-switch-when=\"pad\">\n                    {{name}}\n                    <span class=\"cardMask\"><span/><span/><span/><span/></span>\n                    {{secondLineData.after}}\n                </div>\n                <div ng-switch-when=\"mask\">\n                    <span ng-if=\"secondLineData.chasePay\" class=\"chasePayLogo\">\n                        <span class=\"fsIcon CHASEPAY\"><span class=\"accessAid\">Chase Pay</span></span> |\n                    </span>\n                    <span ng-if=\"fi.type !== 'CREDIT'\">\n                        {{secondLineData.before}}\n                        <span class=\"cardMask\"><span/><span/><span/><span/></span>\n                        {{secondLineData.after}}\n                    </span>\n\n                    <span ng-if=\"secondLineData.meft\">\n                        {{content('fundingInstruments.meft')}}\n                    </span>\n                    <span ng-if=\"secondLineData.iach\">\n                        {{content('fundingInstruments.iach')}}\n                    </span>\n                    <span ng-if=\"secondLineData.echeck\">\n                        {{content('fundingInstruments.eCheck')}}\n                    </span>\n                </div>\n            </div>\n        </div>\n        <div class=\"fsPanelIsBillingPreferred\" ng-if=\"fi.isBillingPreferred\">{{content('fundingInstruments.billingPreferredFi', { merchantName: merchant })}}</div>\n        <div class=\"fsPanelChildren\" ng-transclude></div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/floating-label/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/floating-label/styles.less");

var treatmentType = void 0;
var newLocale = void 0;
var oldLocale = void 0;

function getTreatment() {
    if (treatmentType !== undefined) {
        return treatmentType;
    }
    if ((0, _squid.$feature)('floatingLabels')) {
        return true;
    }
    var token = _angular.$rootScope.token;
    var throttle = _squid.$config['floatingLabelLocales'] && _squid.$config['floatingLabelLocales'][_squid.$locale.country] && _squid.$config['floatingLabelLocales'][_squid.$locale.country][_squid.$locale.lang];
    var id = _squid.$locale.lang + '_' + _squid.$locale.country + token;

    treatmentType = throttle && (0, _squid.$experiment)('floating_label_exp', throttle, id, {}) ? true : false;
    return treatmentType;
}

(0, _squid.$registerDirective)('floating-label', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$on('localeChange', function () {
                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;

                if (oldLocale !== newLocale) {
                    treatmentType = undefined;
                    oldLocale = newLocale;
                }
                scope.showFloatingLabels = getTreatment();
            });

            (0, _angular.$timeout)(function () {
                scope.showFloatingLabels = getTreatment();

                scope.$watch('showFloatingLabels', function (val) {
                    // remove else block after experimentation is complete
                    if (val) {
                        element.addClass('floatingLabel');
                        element.removeClass('noFloatingLabel');
                    } else {
                        element.removeClass('floatingLabel');
                        element.addClass('noFloatingLabel');
                    }
                });

                var input = element.find('input');

                if (input.attr('placeholder')) {
                    input.addClass('hasPlaceholder');
                }

                // To hide the placeholder labels for pre-populated input fields
                scope.$watch(input.attr('ng-model'), function (value) {
                    input.toggleClass('focused', !!value);
                });

                // We're using this as an alternative to watching 'ng-model' since this properly triggers the focused CSS property on email input.
                input.on('keyup', function (event) {
                    var val = event.target.value;

                    input.toggleClass('focused', !!val);
                });

                input.on('focus blur click', function (event) {
                    if (scope.showFloatingLabels) {
                        input.toggleClass('focused', event.type === 'focus' || this.value.length > 0);
                    }
                });

                if (!('disableAutoblur' in attrs)) {
                    input.trigger('blur');
                }
            });
        }
    };
});

(0, _squid.$registerDirective)('floating-label-dropdown', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$on('localeChange', function () {
                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;

                if (oldLocale !== newLocale) {
                    treatmentType = undefined;
                    oldLocale = newLocale;
                }
                scope.showFloatingLabels = getTreatment();
            });

            (0, _angular.$timeout)(function () {
                scope.showFloatingLabels = getTreatment();
                scope.$watch('showFloatingLabels', function (val) {
                    // remove else block after experimentation is complete
                    if (val) {
                        element.addClass('floatingLabel');
                        element.removeClass('noFloatingLabel');
                    } else {
                        element.removeClass('floatingLabel');
                        element.addClass('noFloatingLabel');
                    }
                });

                var select = element.find('select');
                var label = element.find('label');
                var flSpan = element.find('.custom-select span span');

                select.on('change mouseenter mouseleave blur', function (event) {
                    var value = event.currentTarget.value;

                    select.toggleClass('focused', event.type === 'change' || value.length > 0);
                    flSpan.toggleClass('noValue', value.length < 1);
                    label.toggleClass('hide', value.length < 1);
                }).trigger('mouseleave');
            });
        }
    };
});

_angular.$timeout;

_angular.$rootScope;

_squid.$locale;

_squid.$experiment;

_squid.$config;

_squid.$feature;

_squid.$registerDirective;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/floating-label/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index2 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/generic-error/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/generic-error/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TITLE_KEY_MAPPING = {
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleTitle',
    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
    GAMER_LOGIN_OUT_OF_COUNTRY: 'sorry',
    GAMER_RESIDENCE_OUT_OF_COUNTRY: 'sorry',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleMemberDCF',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
    PAYEE_ACCOUNT_LOCKED_OR_CLOSED: 'payeeAccountLockedOrClosedTitle',
    PAYER_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    PAYER_COUNTRY_NOT_ENABLED: 'payerCountryNotAllowedTitle',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
    RETRY: 'sorry',
    SENDING_LIMIT_EXCEEDED: 'genericErrorMessageTitle',
    STUDENT_ACCOUNT: 'studentAccountTitle',
    TRANSACTION_REFUSED: 'transactionRefusedTitle',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleSignupDCF',
    CREDIT_CARD_AUTH_FAILED: 'smartDollarAuthFailedMsg'
};

var CONTENT_KEY_MAPPING = {
    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
    AGREEMENT_ALREADY_CREATED: 'agreementAlreadyCreated',
    // TODO: rename to a common one, e.g TOKENIZED_WALLET_ELIGIBILITY_ERROR later
    ANDROID_PAY_ALREADY_PROVISIONED: 'tokenizedWalletAlreadyProvisioned',
    ANDROID_PAY_ELIGIBILITY_ERROR: 'tokenizedWalletGenericError',
    // end of TODO
    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
    BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleMessage',
    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
    DEFAULT_TOKENIZED_WALLET_ERROR: 'tokenizedWalletGenericError',
    DEFAULT: 'genericError',
    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
    DUPLICATE_INVOICE_ID: 'duplicateInvoiceId',
    EINVALIDCSRF_JWT_EXPIRED: 'csrfTokenExpired',
    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
    GAMER_ACCOUNT_UNVERIFIED: 'accountUnverified',
    GAMER_INELIGIBLE: 'transactionRefusedTitle',
    GAMER_FI_INELIGIBLE: 'fiIneligible',
    GAMER_FI_UNCONFIRMED: 'fiUnconfirmed',
    GAMER_INVALID_ACCOUNT_TYPE: 'invalidAccountType',
    GAMER_LOGIN_OUT_OF_COUNTRY: 'unauthorizedCountryLogin',
    GAMER_NO_VALID_FUNDING_INSTRUMENT: 'fiIneligible',
    GAMER_RESIDENCE_OUT_OF_COUNTRY: 'unauthorizedCountryAccountRegistered',
    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountMemberDCF',
    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
    PAYEE_ACCOUNT_LOCKED_OR_CLOSED: 'payeeAccountLockedOrClosed',
    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
    PAYER_CANNOT_PAY: 'paymentDeniedError',
    PAYER_CANNOT_MAKE_PAYMENT: 'paymentDeniedError1',
    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
    PAYMENT_DENIED: 'paymentDeniedError',
    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
    RESTRICTED_USER: 'buyerRestrictedError',
    RETRY: 'thingsNotWorking',
    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
    STUDENT_ACCOUNT: 'studentAccountMessage',
    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
    TRANSACTION_REFUSED: 'transactionRefusedMessage',
    CREDIT_CARD_AUTH_FAILED: 'transactionRefusedMessage',
    UNSUPPORTED_COUNTRY: 'unsupportedCountry',
    UNSUPPORTED_DUE_TO_RECEIVER_PREFERENCE: 'unsupportedReceiverPreferences',
    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountSignupDCF'
};

// pass merchantName attribute, if undefined, then suffix 'Default' to key
var renderContentWithMerchantName = function renderContentWithMerchantName(key) {
    var merchantNameFromProps = this.props.merchant;

    // we may not get merchantName as props, look for models also
    var merchantNameFromModels = void 0;

    if (this.models && this.models.checkoutAppData && this.models.checkoutAppData.merchant) {
        var merchant = this.models.checkoutAppData.merchant;

        merchantNameFromModels = merchant.brand_name || merchant.merchant_name;
    }

    var merchantName = merchantNameFromProps || merchantNameFromModels;

    if (merchantName) {
        return (0, _squid.$renderContent)(key, { merchantName: merchantName });
    }

    return (0, _squid.$renderContent)(key + 'Default');
};

var renderContentWithWalletTokenizationName = function renderContentWithWalletTokenizationName(key) {
    var brandName = this.models.tokenizedWalletInfoModel.brandName();

    return (0, _squid.$renderContent)(key, { type: brandName });
};

var renderContentWithCountryAndLang = function renderContentWithCountryAndLang(key) {
    return (0, _squid.$renderContent)(key, { lang: _squid.$locale.lang, country: _squid.$locale.country });
};

// handle non-standard merchant error title strings
var TITLE_KEY_HANDLER = {
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

// handle non-standard merchant error content strings
var CONTENT_KEY_HANDLER = {
    AGREEMENT_ALREADY_CREATED: renderContentWithMerchantName,
    ANDROID_PAY_ALREADY_PROVISIONED: renderContentWithWalletTokenizationName,
    DEFAULT_TOKENIZED_WALLET_ERROR: renderContentWithWalletTokenizationName,
    DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
    HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
    PAYER_CANNOT_MAKE_PAYMENT: renderContentWithCountryAndLang
};

var SHOW_LOGOUT_LINK_CODES = ['HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF', 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED', 'ANDROID_PAY_ALREADY_PROVISIONED', 'GAMER_INVALID_ACCOUNT_TYPE'];

var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'VENMO_ERROR_WITH_CANCEL_URL'];

var RETRY_LINK = ['EINVALIDCSRF_JWT_EXPIRED', 'GUEST_CHECKOUT_NOT_ALLOWED', 'RETRY'];

var TRANSACTION_REFUSED_BA_TITLE_MSG = {
    BA_NO_PURCHASE: 'transactionRefusedBAnoPurchaseTitle',
    BA_WITH_PURCHASE: 'transactionRefusedBAPurchaseTitle'
};

/* eslint-disable fasec/no-unsafe-regex */
var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');

exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {
    tag: 'xo-generic-error',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        logout: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        },
        cancelUrl: {
            type: 'str',
            required: false
        },
        merchant: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    cart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](angular.noop),
                    auth: _index.$AuthModel.instance().retrieve()['catch'](angular.noop),
                    tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve()['catch'](angular.noop)
                };
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                event.preventDefault();
            });

            this.$on('$destroy', cancelPreventStateChange);

            var self = this;

            // to not break other application's error integration, we'll still support base64 decoded code parameters
            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
            } else {
                self.errorCode = _uiRouter.$stateParams.code;
            }

            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;

            _angular.$rootScope.allowUnload = true;
            self.cancelLink = self.props.cancelUrl;
            self.checkAccountLink = _squid.$config.urls.myAccountUrl;

            // PAYER_CANNOT_MAKE_PAYMENT is a key for treatment group
            // corresponding to control group that passes PAYER_CANNOT_PAY
            // we pass this.treatment as ng-if case for showing html element
            // for treatment or control group selectively
            self.treatment = self.errorCode === 'PAYER_CANNOT_MAKE_PAYMENT';

            self.checkAccountRedirect = function () {
                _logger.$logger.info('redirectto_account');
                _squid.$util.redirect(self.checkAccountLink);
            };

            self.cancelRedirect = function () {
                var redirectUrl = self.cancelLink;

                if (_angular.$rootScope.partnerIntegration) {
                    _logger.$logger.info('genericerror_partner_integration');
                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
                }

                _index2.$ReturnToMerchant.goTo(redirectUrl);
            };

            self.retryCheckout = function () {
                _squid.$util.reload();
            };

            self.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

            self.loggingOut = function ($event) {
                $event.preventDefault();
                cancelPreventStateChange();
                self.props.logout();
            };

            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
            // Cancel link should be shown for "Credit Ineligible" page for DE
            if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
                (0, _jquery2['default'])('#defaultCancelLink').hide();
            }
            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');

            self.$on('$destroy', function (event) {
                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
                if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
                    (0, _jquery2['default'])('#defaultCancelLink').show();
                }
                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
            });

            // Returns the title string, based on custom key handler
            self.getTitle = function () {
                var key = self.titleKey;

                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
                }
                return (0, _squid.$renderContent)(key);
            };

            // Returns the content string, based on custom key handler
            self.getContent = function () {
                var key = self.contentKey;

                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
                }
                return (0, _squid.$renderContent)(key);
            };

            // Returns the cancel button label, based on presence of brand/merchant name
            self.getCancelLabel = function () {
                if (self.walletTokenization) {
                    var brandName = _this.models.tokenizedWalletInfoModel.brandName();

                    return (0, _squid.$renderContent)('common.backToTokenizedWalletB', { type: brandName });
                } else {
                    var merchantName = _this.props.merchant;

                    return (0, _index2.formatReturnContent)(_squid.$renderContent, merchantName);
                }
            };

            this.personalizedBanner = {
                show: false
            };

            _logger.$logger.info('checkout_fpti', {
                landing_page: 'error_page',
                int_error_code: '1',
                int_error_description: _uiRouter.$stateParams.code
            });
        },
        populate: function populate() {
            var _models = this.models,
                checkoutAppData = _models.checkoutAppData,
                checkoutPayee = _models.checkoutPayee,
                cart = _models.cart,
                auth = _models.auth;


            this.walletTokenization = cart && cart.isWalletTokenization();
            this.personalizedBanner.show = auth && auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');

            if (checkoutAppData) {
                this.cancelLink = checkoutAppData.urls.cancel_url;
            }

            if (checkoutPayee) {
                var merchant = checkoutPayee.merchant;


                if (merchant.id && !this.hideCancelLink) {
                    var hcl = _squid.$config.hideCancelLinkForMerchant;

                    var shouldHide = hcl && hcl.indexOf(merchant.id) !== -1;

                    if (shouldHide) {
                        this.hideCancelLink = true;
                    }
                }
            }

            if (auth) {
                this.showLogoutLink = _squid.$util.param('source') !== 'consumerApp' && this.props.logout && SHOW_LOGOUT_LINK_CODES.indexOf(this.errorCode) > -1 && !auth.disallow_login_switch; // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)

                this.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: auth.first_name,
                    last_name: auth.last_name
                }) || auth.email;
            }

            // Map error code for Android Pay
            if (this.walletTokenization) {
                // For Android Pay, map all errors to generic Android Pay error except for
                // ANDROID_PAY_ALREADY_PROVISIONED
                if (this.errorCode !== 'ANDROID_PAY_ALREADY_PROVISIONED') {
                    this.errorCode = 'DEFAULT_TOKENIZED_WALLET_ERROR';
                }
            }

            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];

            if (titleKey) {
                if (titleKey === 'transactionRefusedTitle' && cart && cart.isBillingNoPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_NO_PURCHASE'];
                } else if (titleKey === 'transactionRefusedTitle' && cart && cart.isBillingPurchase()) {
                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_WITH_PURCHASE'];
                } else {
                    this.titleKey = 'genericError.' + titleKey;
                }
            }

            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;

            this.contentKey = 'genericError.' + contentKey;
        }
    }
});


_angular.$rootScope;

_uiRouter.$stateParams;

_logger.$logger;

_index.$AuthModel;

_app.$TokenizedWalletInfoModel;

_index2.$ReturnToMerchant;

_index2.formatReturnContent;

_squid.$Component;

_squid.$util;

_squid.$renderContent;

_squid.$config;

_squid.formatNameInformal;

_squid.$integration;

_squid.$feature;

_squid.$locale;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"genericError\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n\n        <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal, lastName: models.auth.last_name, firstName: models.auth.first_name}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </xo-banner>\n        <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('creditcard.hi', {userName: formattedNameInformal}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </div>\n\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{ getTitle() }}\n        </div>\n        <div class=\"message\"\n            ng-if=\"contentKey\"\n            ng-bind-html=\"getContent()\">\n        </div>\n        <p ng-if=\"retryLink\">\n            <a link-button prevent-default ng-click=\"retryCheckout()\" id=\"retryLink\" class=\"btn full\" role=\"button\">\n                {{ content('genericError.tryAgain') }}\n            </a>\n        </p>\n        <p class=\"topButton\" ng-if=\"checkAccountLink && treatment\">\n            <a prevent-default ng-click=\"checkAccountRedirect()\" id=\"checkAccountLink\" class=\"btn full\" role=\"button\">\n                {{ content('common.checkYourAccount') }}\n            </a>\n        </p>\n        <p class=\"cancelLink\" ng-if=\"cancelLink && !hideCancelLink\" ng-class=\"[{'topButton': !treatment}]\">\n            <a prevent-default ng-click=\"cancelRedirect()\" id=\"cancelLink\" ng-class=\"[{'btn full ': !treatment}, {'btn-secondary': retryLink}, {'cancelMessage': treatment}]\" role=\"button\" >\n                {{ getCancelLabel() }}\n            </a>\n        </p>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/generic-message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, squid, template) {

    return angular.module('xo-generic-message.directive', ['squid']).directive('xoGenericMessage', ['$rootScope', function ($rootScope) {

        return {
            template: template,

            scope: {
                token: '=?'
            },

            controller: ['$scope', '$rootScope', '$stateParams', '$state', '$logger', '$CheckoutAppDataModel', '$DeviceInfo', '$window', '$populate', function ($scope, $rootScope, // eslint-disable-line no-shadow
            $stateParams, $state, $logger, $CheckoutAppDataModel, $DeviceInfo, $window, $populate) {

                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    event.preventDefault();
                });

                $('.paypalHeaderWrapper').hide();
                $('.footerWrapper').addClass('genericMessage');

                var titleKeyMapping = {
                    PAYMENT_SUCCESS: 'paymentSuccessTitle',
                    PAYMENT_SUCCESS_REDIRECT_FAILED: 'paymentSuccessTitle',
                    DEFAULT: 'paymentSuccessTitle'
                };

                $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;
                $scope.disableReturnToMerchantButton = false;

                var contentKeyMapping = {
                    PAYMENT_SUCCESS: 'paymentSuccessMessage',
                    PAYMENT_SUCCESS_REDIRECT_FAILED: 'paymentSuccessMessage',
                    DEFAULT: 'paymentSuccessMessage'
                };

                var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];

                if (contentKey) {
                    $scope.contentKey = 'genericMessage.' + contentKey;
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance($scope.token),
                    cart: _index.$CheckoutCartModel.instance($scope.token)
                }).then(function () {
                    var merchant = $scope.checkoutAppData.merchant;

                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

                    var _$stateParams$returnU = $stateParams.returnUrl,
                        returnUrl = _$stateParams$returnU === undefined ? $scope.checkoutAppData.urls.return_url : _$stateParams$returnU;

                    var redirectTimedout = Boolean($stateParams.code === 'PAYMENT_SUCCESS_REDIRECT_FAILED');
                    var enableSuccessReturnButton = Boolean($DeviceInfo.isDevice() && !redirectTimedout);

                    if (enableSuccessReturnButton) {
                        $scope.enableSuccessReturnUrl = true;
                        var contentWithButtonKeyMapping = {
                            PAYMENT_SUCCESS: 'successMessage',
                            DEFAULT: 'paymentSuccessMessage'
                        };
                        var contentWithButtonKey = $stateParams.code && contentWithButtonKeyMapping[$stateParams.code];

                        // hard coding it to returnButton, double checkout before changing this that content exists in genericMessage properties
                        $scope.returnButtonLabel = (0, _squid.$renderContent)('genericMessage.returnButton');
                        if (contentWithButtonKey) {
                            $logger.info('generic_message_page_content_with_button_key');
                            $scope.contentKey = '';
                        }

                        var walletTokenization = $scope.cart && $scope.cart.isWalletTokenization();

                        if (walletTokenization) {
                            var brandName = $scope.tokenizedWalletInfoModel.brandName();

                            $scope.returnButtonLabel = (0, _squid.$renderContent)('common.backToTokenizedWalletB', { type: brandName });
                        }
                        $scope.goToMerchant = function () {
                            $logger.info('checkout_fpti', {
                                'from': 'POST_3DS',
                                'to': 'checkout_end',
                                'message': 'REDIRECT_TO_MERCHANT_ON_BUTTON_CLICK',
                                'returnUrl': returnUrl
                            });
                            // eslint-disable-next-line no-empty-function
                            $window.onunload = $window.onbeforeunload = function () {};
                            $scope.disableReturnToMerchantButton = true;
                            setTimeout(function () {
                                $scope.disableReturnToMerchantButton = false;
                            }, 15000); // Re-enable button after 15 seconds
                            _squid.$util.redirect(returnUrl);
                        };
                    }
                });

                $scope.$on('$destroy', function (event) {
                    $('.paypalHeaderWrapper').show();
                    $('.footerWrapper').removeClass('genericMessage');
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_app.$TokenizedWalletInfoModel;

_index.$CheckoutCartModel;

_squid.$renderContent;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/link/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/link/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoLink', {
    tag: 'xo-link',
    template: _template2['default'],
    props: {
        onClick: {
            type: 'var',
            required: false
        },
        leftIcon: {
            type: 'str',
            required: false
        },
        rightIcon: {
            type: 'str',
            required: false
        },
        goTo: {
            type: 'str',
            required: false
        },
        label: {
            type: 'str',
            required: false
        }
    },

    actions: {
        onClick: function onClick(event) {
            var _props = this.props,
                onClick = _props.onClick,
                goTo = _props.goTo;


            if (onClick) {
                onClick(event);
            }

            if (goTo) {
                _uiRouter.$state.go(goTo);
            }
        }
    }
});


_squid.$Component;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/template.html":
/***/ (function(module, exports) {

module.exports = "<a class=\"common-link\" ng-click=\"actions.onClick($event)\" href='' role=\"button\">\n    <span ng-if=\"props.leftIcon\" class=\"icon left-icon {{props.leftIcon}}\"></span><span>{{props.label}}</span><span ng-if=\"props.rightIcon\" class=\"icon right-icon {{props.rightIcon}}\"></span>\n</a>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-message.directive', ['squid']).directive('xoMessage', ['$timeout', '$loader', '$rootScope', function ($timeout, $loader, $rootScope) {
        return {
            scope: {
                message: '=?', // Expected type - {msgs: [], type: "info|error|success|warning"}
                isgreyheader: '=?'
            },
            template: template,
            link: function link(scope, element, attrs) {

                // Hide and show the alerts so that messages can be registered by
                // screen reader even if they are repeats. Uses $timeout to
                // wait for DOM before showing alerts again.
                var toggleAlert = function toggleAlert() {
                    var $alert = element.find('ul');
                    $alert.detach();
                    $timeout(function () {
                        element.find('#pageLevelErrors').append($alert);
                    });
                };

                // Toggle the alert whenever message changes by removing it and reappending it
                // to the DOM. Should fire even if message
                // is changed to the same, as assumes that the message should be reapplied.
                var cancel;
                scope.$watchCollection('message', function () {
                    if ($loader.isLoading() && !cancel) {
                        // If loading, toggle the alert after all loading calls have been made.
                        // This is so that the alert can be read by screen reader after focus
                        cancel = $rootScope.$on('allLoaded', function () {
                            cancel();
                            toggleAlert();

                            cancel = null;
                        });
                    } else {
                        toggleAlert();
                    }
                });

                scope.$on('$destroy', function () {
                    if (cancel) {
                        cancel();
                    }
                });
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/mobile-pin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/mobile-pin/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/mobile-pin/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// wrapper class which looks like password black dot
var PASSWORD_DOT_CLASS = 'passwordDot';

// wrapper class which looks like an empty grey dot
var DEFAULT_DOT_CLASS = 'defaultDot';

// delay after which input becomes a password dot, so user can see what number was entered for 1 sec
var DELAY = 600;

// back key code
var BACK_KEY = 0x8;

// check if entered pin combination is valid
var isPinValid = function isPinValid(value) {
    var onlyNumbers = /^\d{4}$/i;
    var consecutiveDigits = /^0123|1234|2345|3456|4567|5678|6789$/i;
    var commonPattern = /^0246|1357|2468|3579$/i;
    var repeatingDigits = /^([0-9])\1*$/i;
    return onlyNumbers.test(value) && !consecutiveDigits.test(value) && !commonPattern.test(value) && !repeatingDigits.test(value);
};

// check if entered input value is number before proceeding to the next input
var isKeyValid = function isKeyValid(val) {
    return (/^\d{1}/.test(val)
    );
};

// get wrapper of input element
var getWrapperElement = function getWrapperElement(el) {
    return angular.element(el).parent();
};

/**
 * This component is for setting PIN number for in-store purchases in tokenized flows (e.g Google Pay / Samsung Pay)
 * It's used in Hermes -> pages/xo-pin-setup
 * After Pin is set -> done callback is being called
 * and pin is getting saved in $TokenizedWalletPinModel and on the xo-review page there is POST API call to save it in the database (see '/api/pin/tokenizedWallet/:id')
 */
exports['default'] = _squid.$Component.extend('$xoMobilePin', {
    tag: 'xo-mobile-pin',
    template: _template2['default'],
    props: {
        /**
         * callback function passed from xo-pin-setup page in Hermes
         * which is being called when all 4 pin numbers are set
         * (even after first attempt or if it's a too simple combination)
         *
         */
        done: {
            type: 'var',
            required: false
        }
    },

    actions: {
        /**
         * Every time key is released we need to check if all 4 digits are set and so call done function
         * otherwise move cursor to the right if entered value is a number
         */
        releaseKey: function releaseKey(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            if (eventObj && eventObj.keyCode === BACK_KEY) {
                return;
            }
            var currEle = document.getElementById(currID);
            var currentValue = this.pinvalue[currID];

            if (this.isDone()) {
                currEle.blur();
                var pin = this.getPin();
                this.props.done(pin);
            }
            if (isKeyValid(currentValue)) {
                this.moveCursor(currID, 'right', false);
            }
        },

        /**
         * Every time key is pressed check if it was a back key
         * if yes -> move cursor to the left to the previous input
         */
        pressedKey: function pressedKey(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;

            if (eventObj && eventObj.keyCode === BACK_KEY) {
                this.moveCursor(currID, 'left', true);
            }
        },

        /**
         * Every time input is focused:
         * 1. reset input value and store value
         * 2. remove password dot class and default dot class from the parent wrapper
         */
        onFocus: function onFocus(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            var currEle = document.getElementById(currID);

            this.pinvalue[currID] = '';
            currEle.value = '';

            getWrapperElement(currEle).removeClass(PASSWORD_DOT_CLASS);
            getWrapperElement(currEle).removeClass(DEFAULT_DOT_CLASS);
        },

        /**
         * Every time input is unfocused:
         * 1. if current value is empty -> add default dot class to the parent wrapper
         * 2. otherwise add password dot class to the parent wrapper with a delay so user can see an entered value
         */
        onBlur: function onBlur(eventObj) {
            var currID = eventObj && eventObj.currentTarget.id;
            var currentValue = eventObj && eventObj.currentTarget.value;
            var currEle = document.getElementById(currID);
            if (!currentValue) {
                getWrapperElement(currEle).addClass(DEFAULT_DOT_CLASS);
            }
            if (!this.doingReset && currentValue) {
                (0, _angular.$timeout)(function () {
                    getWrapperElement(currEle).addClass(PASSWORD_DOT_CLASS);
                    currEle.value = '';
                }, DELAY);
            }
        },

        /**
         * since we have pseudo classes to render password dot / default dot on top of the inout ->
         * make sure element under the dot is focused every time there is a click
         */
        onWrapperClick: function onWrapperClick(eventObj) {
            angular.element(eventObj.currentTarget).find('input').focus();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            // store of pin values
            this.pinvalue = {};
            this.doingReset = false;
            this.fields = ['field1', 'field2', 'field3', 'field4'];

            // get pin result and check if pin is too simple
            this.getPin = function () {
                var result = { value: '', error: '' };
                _this.fields.forEach(function (fieldName) {
                    result.value = result.value + String(_this.pinvalue[fieldName]);
                });
                result.error = isPinValid(result.value) ? '' : 'pin_too_simple';
                return result;
            };

            // check if all input values are set and valid
            this.isDone = function () {
                return _squid.$util.every(Object.keys(_this.pinvalue), function (key) {
                    var inputVal = _this.pinvalue[key];

                    return isKeyValid(inputVal);
                });
            };

            // move cursor to the left or right based on direction
            this.moveCursor = function (currID, direction, clearCurrent) {
                var currentIndex = _this.fields.indexOf(currID);
                var currEle = document.getElementById(currID);
                if (clearCurrent) {
                    currEle.value = '';
                    _this.pinvalue[currID] = '';
                }

                var nextIndex = void 0;
                if (direction === 'left') {
                    nextIndex = currentIndex > 0 ? currentIndex - 1 : 0;
                }
                if (direction === 'right') {
                    nextIndex = currentIndex < _this.fields.length - 1 ? currentIndex + 1 : _this.fields.length - 1;
                }

                var nextID = _this.fields[nextIndex];
                if (nextID !== currID) {
                    var nextEle = document.getElementById(nextID);
                    nextEle.focus();
                } else {
                    // if user enters value into the last input - unfocus it to prevent entering more
                    currEle.blur();
                }
            };

            // reset all inputs / store and set focus on first element
            this.reset = function () {
                _this.fields.forEach(function (fieldName) {
                    _this.pinvalue[fieldName] = '';
                    var currentElement = document.getElementById(fieldName);

                    getWrapperElement(currentElement).removeClass(PASSWORD_DOT_CLASS);
                    getWrapperElement(currentElement).addClass(DEFAULT_DOT_CLASS);
                });
                // set focus to first elemnt
                var firstInput = document.getElementById(_this.fields[0]);

                if (firstInput) {
                    firstInput.focus();
                }
                _this.doingReset = false;
            };
        },
        populate: function populate() {
            var _this2 = this;

            this.reset();
            this.$on('resetPin', function () {
                _this2.doingReset = true;
                (0, _angular.$timeout)(function () {
                    return _this2.reset();
                }, DELAY);
            });
        }
    }
});


_squid.$Component;

_squid.$util;

_angular.$timeout;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/mobile-pin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/mobile-pin/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"mobilePin\">\n        <div class=\"numpin-wrapper\" ng-click=\"actions.onWrapperClick($event)\">\n                <input type=\"number\" inputmode=\"numeric\" pattern=\"[0-9]\" maxlength=1 id=\"field1\" autofocus=\"autofocus\" class=\"numpin\" ng-keyup=\"actions.releaseKey($event)\"\n                        ng-keydown=\"actions.pressedKey($event)\" ng-model=\"pinvalue.field1\" ng-blur=\"actions.onBlur($event)\" ng-focus=\"actions.onFocus($event)\"\n                />\n        </div>\n        <div class=\"numpin-wrapper\" ng-click=\"actions.onWrapperClick($event)\">\n                <input type=\"number\" inputmode=\"numeric\" pattern=\"[0-9]\" maxlength=1 id=\"field2\" class=\"numpin\" ng-keyup=\"actions.releaseKey($event)\"\n                        ng-keydown=\"actions.pressedKey($event)\" ng-model=\"pinvalue.field2\" ng-blur=\"actions.onBlur($event)\" ng-focus=\"actions.onFocus($event)\"\n                />\n        </div>\n        <div class=\"numpin-wrapper\" ng-click=\"actions.onWrapperClick($event)\">\n                <input type=\"number\" inputmode=\"numeric\" pattern=\"[0-9]\" maxlength=1 id=\"field3\" class=\"numpin\" ng-keyup=\"actions.releaseKey($event)\"\n                        ng-keydown=\"actions.pressedKey($event)\" ng-model=\"pinvalue.field3\" ng-blur=\"actions.onBlur($event)\" ng-focus=\"actions.onFocus($event)\"\n                />\n        </div>\n        <div class=\"numpin-wrapper\" ng-click=\"actions.onWrapperClick($event)\">\n                <input type=\"number\" inputmode=\"numeric\" pattern=\"[0-9]\" maxlength=1 id=\"field4\" class=\"numpin\" ng-keyup=\"actions.releaseKey($event)\"\n                        ng-keydown=\"actions.pressedKey($event)\" ng-model=\"pinvalue.field4\" ng-blur=\"actions.onBlur($event)\" ng-focus=\"actions.onFocus($event)\"\n                />\n        </div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/modal/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Directives used in the template
(0, _squid.$registerDirective)('xoModal', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            show: '=?',
            showCloseButton: '=?',
            enableCloseOnEscape: '=?',
            onClose: '=?',
            enableMobileInterstitial: '@?',
            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
        },
        controller: ['$scope', function ($scope) {
            $scope.animate = false; // Don't animate until triggered
            $scope.showOverlay = $scope.show;

            var escapeKeyHandler = function escapeKeyHandler($event) {
                if ($event.keyCode === 27) {
                    // Escape key maps to keycode 27
                    $scope.hideModal();
                }
            };

            if ($scope.enableCloseOnEscape) {
                // Handle escape button as close button click
                $(document).bind('keyup', escapeKeyHandler);
            }

            $scope.hideModal = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.show = false;
                $(document).unbind('keyup', escapeKeyHandler);
                if ($scope.onClose) {
                    $scope.onClose();
                }
            };
        }],

        link: function link($scope, elem, attrs) {
            // HACK: without this check, the modal slides down/fades out upon it being rendered
            $scope.$watch('show', function (newVal, oldVal) {
                if (oldVal !== newVal) {
                    // When the show prop changes
                    $scope.animate = true; // Ensure the modal is animated
                }
            });
        }
    };
});

_squid.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-wrapper\" ng-class=\"{'animate': animate}\" ng-show='show' content>\n\t<div class=\"modal-overlay\"></div>\n\t<div class=\"modal-dialog\" ng-class=\"{'mobile-interstitial': enableMobileInterstitial}\" modal-box modal-cancel=\"hideModal()\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\" tabindex=\"-1\" focus-when=\"show\">\n\t\t\t<div ng-transclude>\n\t\t\t</div>\n\t\t\t<a link-button ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close modal-x-link\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/popup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid) {

    squid.module('xo-popup.directive', ['squid']).directive('xoPopup', ['$window', '$util', function ($window, $util) {
        return {
            restrict: 'A',

            link: function link(scope, element, attr) {

                element.on('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var config = {
                        popupUrl: attr.href,
                        popupWindowName: 'popup',
                        width: 835,
                        height: 500,

                        popupWindowFeatures: {
                            location: 1,
                            status: 1,
                            scrollbars: 1,
                            resizable: 1,
                            toolbar: 0,
                            menubar: 0
                        }
                    };

                    scope.trackExternalLink(attr.id || 'external_link');

                    var isOneTouch = $util.param('isOneTouch');

                    if (/PLAYSTATION|iPadApp/i.test($window.navigator.userAgent) && isOneTouch !== '1') {
                        scope.$emit('showModal', config);
                        return false;
                    }

                    if ($(element).hasClass('smallPopup')) {
                        config.width = 385;
                    }

                    var left = 0;
                    var top = 0;

                    if (window.outerWidth) {
                        left = Math.round((window.outerWidth - config.width) / 2) + window.screenX;
                        top = Math.round((window.outerHeight - config.height) / 2) + window.screenY;
                    } else if (window.screen.width) {
                        left = Math.round((window.screen.width - config.width) / 2);
                        top = Math.round((window.screen.height - config.height) / 2);
                    }

                    var features = Object.keys(config.popupWindowFeatures).map(function (k) {
                        return k + '=' + config.popupWindowFeatures[k];
                    }).join(',');

                    // put together WindowFeatures, since, window.open needs it as a string
                    features += ',width=' + config.width + ',height=' + config.height + ',left=' + left + ',top=' + top;

                    var popup = $window.open(config.popupUrl, config.popupWindowName, features);

                    if (popup.focus) {
                        popup.focus();
                    }
                });
            },

            controller: ['$scope', '$logger', function ($scope, $logger) {
                $scope.trackExternalLink = function (linkName) {
                    $logger.info(linkName);
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

exports['default'] = (0, _squid.$registerDirective)('prefix-attrs-with', function () {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            var prefix = attrs.prefixAttrsWith;

            if (prefix && prefix.length) {
                ['id', 'for', 'name'].forEach(function (attrName) {
                    var base = attrs[attrName];

                    if (base) {
                        elem.attr(attrName, _squid.$util.dasherizeToCamel(prefix + '-' + base));
                    }
                });
            }
        }
    };
});


_squid.$util;

_squid.$registerDirective;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/select-simple/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/select-simple/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * xo-ui-select-simple
 * Full directive/template for the dropdown UI component (http://paypal-ui/components/forms/dropdowns)
 *
 * props:
 *  - options: Array<Option> ([{id: 1, label: 'Foo'}, {id: 2, label: 'Bar'}])
 *  - onSelect: Function, gets called when an option is selected
 *  - selectedOption: Option ({id: 1, label: 'Red'})
 *  - label: String, will add a floating label to the text box if passed
 *  - defaultText: String, placeholder text before an option is selected
*/

exports['default'] = _squid.$Component.extend('$xoUiSelectSimpleComponent', {
    tag: 'xo-ui-select-simple',
    template: _template2['default'],
    props: {
        options: {
            type: 'var',
            required: true
        },
        selectedOption: {
            type: 'var',
            required: false
        },
        label: {
            type: 'var',
            required: false
        },
        defaultText: {
            type: 'var',
            required: false
        },
        onSelect: {
            type: 'var',
            required: false
        }
    },
    actions: {
        selectOption: function selectOption(option) {
            var hasOnSelectedCallback = typeof this.onSelect === 'function';
            var isNotSelected = !this.checkSameOption(this.selectedOption, option);

            if (hasOnSelectedCallback && isNotSelected) {
                this.onSelect(option);
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.focused = false;

            this.checkSameOption = function () {
                var option1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var option2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                return option1.id === option2.id && option1.label === option2.label;
            };

            var isValidSelected = function isValidSelected() {
                var inOptions = function inOptions() {
                    return Boolean(_this.options.filter(function (option) {
                        return _this.checkSameOption(_this.selectedOption, option);
                    }).length);
                };

                return _this.selectedOption && inOptions();
            };

            var updateComputedOption = function updateComputedOption() {
                _this.hasLabel = Boolean(_this.label && _this.label.length && _this.selectedOption);

                if (isValidSelected()) {
                    _this.compSelectedOption = (0, _angular.extend)({}, _this.selectedOption);
                    return;
                } else {
                    _this.compSelectedOption = undefined;
                    _this.actions.selectOption(_this.compSelectedOption);
                }
            };

            this.$watch('selectedOption', updateComputedOption);
        }
    }
});


_squid.$Component;

_angular.extend;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/template.html":
/***/ (function(module, exports) {

module.exports = "<div\n    ng-class=\"{ floatingLabel: hasLabel }\"\n    class=\"uiSelectSimple dropdown inputField\"\n    ng-mouseenter=\"active = true\"\n    ng-mouseleave=\"active = false\">\n    <div class=\"custom-select-container\">\n        <select\n            ng-model=\"compSelectedOption\"\n            ng-click=\"focused = !focused\"\n            ng-change=\"actions.selectOption(compSelectedOption)\"\n            ng-options=\"option.label for option in options track by option.id\"\n            ng-class=\"{ focused: focused || selectedOption }\"\n            class=\"replaced\">\n            <option value=\"\" disabled selected>{{ defaultText }}</option>\n        </select>\n        <span\n            ng-class=\"{ active: active }\"\n            class=\"custom-select\" aria-hidden=\"true\">\n            <span><span>{{ compSelectedOption ? compSelectedOption.label : '' }}</span></span>\n        </span>\n        <label ng-if=\"(label && selectedOption)\" class=\"floatingLabelLabel\">{{ label }}</label>\n        <label ng-if=\"!selectedOption\" class=\"defaultTextLabel\">{{ defaultText }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner-button/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {
    return angular.module('xo-spinner-button.directive', []).directive('xoSpinnerButton', [function () {
        return {
            template: template,
            scope: {
                token: '=?',
                track: '@?',
                onClick: '=?',
                buttonText: '@?',
                isProcessing: '=?',
                validate: '=?'
            },
            controller: ['$scope', function ($scope) {

                $scope.submit = function () {
                    if ($scope.onClick) {
                        $scope.onClick();
                    } else {
                        $scope.validate = true;
                    }
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _sanitizeCaja = __webpack_require__("../node_modules/sanitize-caja/index.js");

var _sanitizeCaja2 = _interopRequireDefault(_sanitizeCaja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {
    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', [function () {
        return {
            scope: {},
            template: template,
            controller: ['$scope', '$element', '$rootScope', '$locale', '$logger', '$loader', '$timeout', function ($scope, $element, $rootScope, $locale, $logger, $loader, $timeout) {
                var $body = angular.element(document.getElementsByTagName('body'));
                var $priorActiveElement = $();
                var $capturedElement = $();
                var $header = $('header');
                var $slidingArea = $('#main');
                var $footer = $('footer');

                /**
                 * This hides page content from any screen readers.
                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
                 *
                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
                 * At the very least, let's cache these selectors :|
                 */
                function hidePageContentFromScreenReader(toggle) {
                    $body.attr('aria-busy', toggle);
                    $header.attr('aria-busy', toggle);
                    $slidingArea.attr('aria-busy', toggle);
                    $footer.attr('aria-busy', toggle);
                }

                function preventDefault(event) {
                    var _event$target = event.target;
                    _event$target = _event$target === undefined ? {} : _event$target;
                    var targetId = _event$target.id;

                    // Only call preventDefault if the target is not a captcha input.
                    // If the target is a captcha input we don't want to prevent the
                    // user from entering the captcha code.

                    if (targetId !== 'captchaCode') {
                        event.preventDefault();
                    }
                }

                function captureFocus(event) {
                    if (!$element.has(event.target).length) {
                        $capturedElement = $(event.target);
                    }
                }

                function setLoadingMessage(message) {
                    if (angular.isObject(message)) {
                        $scope.message = message.heading;
                        $scope.subMessage = message.subHeading;
                        $('#spinnerMessage').css('font-size', '17.5px');
                        $('#spinnerMessage').html((0, _sanitizeCaja2['default'])(message.heading));
                        $('#spinnerSubHeading').html((0, _sanitizeCaja2['default'])(message.subHeading));
                    } else {
                        $scope.message = message;
                        $scope.subMessage = null;
                        $('#spinnerMessage').html(message);
                    }
                }

                function showSpinner() {
                    $scope.loading = true;
                    $logger.info('show_loading_spinner');
                    $body.addClass('loading');

                    // remember what was previously focused
                    $priorActiveElement = $(':focus');

                    $(':input, a').blur();

                    hidePageContentFromScreenReader(true);

                    if ($loader.firstLoad()) {
                        setLoadingMessage($locale.content.get('base.processing'));
                    }

                    // focus on the message so that screen readers will let the user know the page is loading
                    $(document).on('keydown', preventDefault);
                    $(document).on('focusin', captureFocus);
                    $timeout(function () {
                        $('#spinner-message').focus().attr('alt', $scope.message || $locale.content.get('base.processing'));
                    });
                }

                function hideSpinner() {
                    $scope.loading = false;
                    $logger.info('hide_loading_spinner');
                    $('#preloaderSpinner').hide();
                    $body.removeClass('loading');
                    $(document).off('keydown', preventDefault);
                    $(document).off('focusin', captureFocus);

                    hidePageContentFromScreenReader(false);

                    // Focus captured element if focus was given to an element while spinner was active.
                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
                        $capturedElement.focus();
                        // Focus element that had focus before if it is still within the document
                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
                        $priorActiveElement.focus();
                    } else {
                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
                        // the element last clicked, rather than top of page.
                        $slidingArea.focus();
                    }
                    $priorActiveElement = $();
                    $capturedElement = $();
                }

                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);

                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
                    setLoadingMessage(text);
                });

                $scope.$on('$destroy', function () {
                    hideSpinner();
                    cancelStartLoad();
                    cancelAllLoaded();
                    cancelSetLoadingMessage();
                });

                if ($loader.isLoading()) {
                    showSpinner();
                }
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/styles.less");

var _utils = __webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoStickyCta', {
    tag: 'xo-sticky-cta',
    template: _template2['default'],
    transclude: true,
    props: {
        eligibility: {
            type: 'var',
            required: false
        }
    },
    resolve: {},
    lifecycle: {
        populate: function populate() {
            _logger.$logger.info('xoStickyCta_populate_' + this.eligibility);
            if (!this.eligibility) {
                return;
            }
            var position = this.eligibility;
            var stickyContent = document.getElementById('sticky-content');
            var stickyPlaceholder = document.getElementById('sticky-placeholder-' + position);
            var foundContentDom = Boolean(stickyContent);
            var placeholderIsVisible = (0, _utils.isInViewport)(stickyPlaceholder);

            angular.element(stickyContent).addClass('sticky-' + position + '-off');

            _logger.$logger.info('xoStickyCta_init', {
                foundContentDom: foundContentDom,
                placeholderIsVisible: placeholderIsVisible,
                position: position
            });

            /**
             * TODO: Replace sticky logic with 'position:sticky' only when
             * there is greater browser compatibility. It is more seamless.
             * When using 'position:sticky' revert 'overflow:hidden' else sticky is not possible.
             * angular.element(document.getElementById('sliding-area')).css('overflow', 'inherit');
            */

            /**
             * Current Logic: if the stickyContent DOM is found in html then
             * - if placeholder is visible on screen -> fix the DOM position to its regular position
             * - if placeholder is not visible on screen -> we make the DOM float
            */

            var isFloating = false;

            var bindHandler = function bindHandler(event) {
                isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                    isFloating: isFloating,
                    position: position,
                    currentState: _angular.$rootScope.currentState
                });
            };

            var stateHandler = function stateHandler(event, toState, toParams, fromState) {
                /**
                 * TODO:
                 * try to use something like .trayOpen -> great grand child .sticky via css
                 * this is required for cases when overlay or sidebar is opened.
                */
                var review = 'checkout.review';
                var to = toState && toState.name;
                var from = fromState && fromState.name;

                var conflict = from === to;
                var leaving = !conflict && from === review;
                var entering = !conflict && to === review;

                if (leaving) {
                    isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                        force: 'off',
                        position: position
                    });
                }
                if (entering) {
                    isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                        isFloating: isFloating,
                        position: position,
                        currentState: _angular.$rootScope.currentState
                    });
                }

                _logger.$logger.info('xoStickyCta_stateChangeSuccess', { to: to, from: from, isFloating: isFloating });
            };

            angular.element(_angular.$window).bind('scroll', bindHandler).bind('resize', bindHandler);
            // .bind('orientationchange', bindHandler); // TODO

            var stateChangeListener = _angular.$rootScope.$on('$stateChangeSuccess', stateHandler);

            this.$on('$destroy', function () {
                _logger.$logger.info('xoStickyCta_destroy');
                angular.element(_angular.$window).unbind('scroll', bindHandler) // remove only the handlers used in this element
                // .bind('orientationchange', bindHandler) // TODO
                .unbind('resize', bindHandler); // remove only the handlers used in this element
                stateChangeListener();
            });
        }
    }
});


_squid.$Component;

_logger.$logger;

_angular.$window;

_angular.$rootScope;

_utils.isInViewport;

_utils.stickyHandler;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"sticky-wrapper\">\n    <div id=\"sticky-placeholder-top\"></div>\n    <div id=\"sticky-content\" ng-transclude></div>\n    <div id=\"sticky-placeholder-bottom\"></div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/utils.js":
/***/ (function(module, exports) {



exports.__esModule = true;
/**
 * Checks if provided element is currently visible.
 * 
 * @param {any} element: Reference to DOM object
 * @returns {Boolean}
 */
var isInViewport = exports.isInViewport = function isInViewport(element) {
    var bounding = element.getBoundingClientRect();

    return (
        // check if element is bellow top most pixel
        // check if element is on the right of left most pixel
        // check if element is above the lowest pixel on screen
        // check if element is on the left of the right most pixel
        bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

/**
 * Make the element provided sticky
 * 
 * @param {any} placeholder: Reference to placeholder DOM object
 * @param {any} element: Reference to DOM object
 * @param {string} position: where the element is located ('top', 'bottom').
 */
var makeSticky = exports.makeSticky = function makeSticky(placeholder, element, position) {
    var elementHeight = element.offsetHeight;

    angular.element(element).addClass('sticky').addClass('sticky-' + position).removeClass('sticky-' + position + '-off');
    angular.element(placeholder).css('height', elementHeight);
    return true;
};

/**
 * Make the element provided fixed to regular location
 * 
 * @param {any} placeholder: Reference to placeholder DOM object
 * @param {any} element: Reference to DOM object
 * @param {string} position: where the element is located ('top', 'bottom').
 */
var removeSticky = exports.removeSticky = function removeSticky(placeholder, element, position) {
    angular.element(element).removeClass('sticky').removeClass('sticky-' + position).addClass('sticky-' + position + '-off');
    angular.element(placeholder).css('height', '');
    return false;
};

/**
 * Decides when to enable or disable sticky effect on DOM
 * 
 * @param {any} stickyPlaceholder: Reference to DOM object
 * @param {any} stickyContent: Reference to DOM object 
 * @param {any} context: context related to current state of DOM
 * @returns {Boolean}: Updated state of DOM
 */
var stickyHandler = exports.stickyHandler = function stickyHandler(stickyPlaceholder, stickyContent, context) {
    var position = context.position,
        force = context.force,
        currentState = context.currentState,
        isFloating = context.isFloating;


    if (force === 'off') {
        return removeSticky(stickyPlaceholder, stickyContent, position);
    }

    var alreadyFloating = isInViewport(stickyPlaceholder) && isFloating;
    var canEnable = !isInViewport(stickyPlaceholder) && !isFloating && currentState === 'checkout_review';

    if (alreadyFloating) {
        return removeSticky(stickyPlaceholder, stickyContent, position);
    } else if (canEnable) {
        return makeSticky(stickyPlaceholder, stickyContent, position);
    } else {
        return isFloating;
    }
};

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/tabs/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/tabs/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * THIS IS A WIP
 * At this point, only pass 2 tabs!
 *
 * xo-ui-tabs
 * props:
 *  - tabs: Array<Tab> ([{id: 1, label: content('string')}, {id: 2, label: content('otherString')}])
 *  - onSelect: Function, gets called when a tab is selected
 *  - selectedTab: Tab ({id: 1, label: content('string')})
 */

exports['default'] = _squid.$Component.extend('$xoUiTabsComponent', {
    tag: 'xo-ui-tabs',
    template: _template2['default'],
    props: {
        tabs: {
            type: 'var',
            required: true
        },
        onSelect: {
            type: 'var',
            required: false
        },
        selectedTab: {
            type: 'var',
            required: false
        }
    },
    actions: {
        getTabIsActive: function getTabIsActive(tab) {
            return this.compSelectedTab && tab.id === this.compSelectedTab.id;
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var isValidSelected = function isValidSelected() {
                var inTabs = function inTabs() {
                    return Boolean(_this.tabs.filter(function (tab) {
                        return _this.selectedTab.id === tab.id && _this.selectedTab.label === tab.label;
                    }).length);
                };

                return _this.selectedTab && inTabs();
            };

            var updateComputedSelected = function updateComputedSelected() {
                if (_this.tabs.length <= 1) {
                    return;
                }

                if (isValidSelected()) {
                    _this.compSelectedTab = (0, _angular.extend)({}, _this.selectedTab);
                    return;
                } else {
                    _this.compSelectedTab = (0, _angular.extend)({}, _this.tabs[0]);
                    _this.onSelect(_this.compSelectedTab);
                }
            };

            this.$watch('selectedTab', updateComputedSelected);
        }
    }
});


_squid.$Component;

_angular.extend;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"tabs.length > 1\" class=\"tabContainer\">\n    <div class=\"tab\"\n        ng-repeat=\"tab in tabs\"\n        ng-class=\"{ active: actions.getTabIsActive(tab) }\"\n        ng-click=\"!actions.getTabIsActive(tab) && onSelect(tab)\"\n        ng-bind-html=\"tab.label\"></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/tooltip/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDefaultShowEvent($el) {
    return $el.is('a') || $el.is('button') ? 'click' : 'focus';
}

// Modify the aria-describedby property to include the id when showing the element so contents are properly read
function addDescribedById($el, id) {
    var describedByIds = $el.attr('aria-describedby') ? $el.attr('aria-describedby').split(' ') : [];

    if (!~describedByIds.indexOf(id)) {
        describedByIds.push(id);
    }

    $el.attr('aria-describedby', describedByIds.join(' '));
}

// Modify the aria-describedby attribute to remove the id when hiding the element so contents are no longer read
function removeDescribedById($el, id) {
    var describedByIds = $el.attr('aria-describedby') || '';

    $el.attr('aria-describedby', describedByIds.split(' ').filter(function (existingId) {
        return existingId !== id;
    }).join(' '));
}

var isMouseTypeEvent = function isMouseTypeEvent(type) {
    return (/mouse/.test(type)
    );
};

function debounceOnMouseTrigger(type, fn) {
    var isMouseType = isMouseTypeEvent(type);

    return function () {
        var _arguments = arguments;

        if (isMouseType) {
            (0, _angular.$timeout)(function () {
                return fn.apply(null, _arguments);
            }, 250);
        } else {
            fn.apply(null, arguments);
        }
    };
}

exports['default'] = _squid.$Component.extend('xoTooltip', {
    tag: 'xo-tooltip',
    template: _template2['default'],
    transclude: true,
    props: {
        trigger: {
            type: 'str',
            required: false
        },
        showEvent: {
            type: 'str',
            required: false
        },
        hideEvent: {
            type: 'str',
            required: false
        },
        displayInline: {
            type: 'var',
            required: false
        },
        align: {
            type: 'str',
            required: false
        }
    },
    lifecycle: {
        populate: function populate() {
            var $element = this.$element,
                trigger = this.trigger;

            var $trigger = $(trigger);
            var toolTip = $element.find('.toolTip');
            var toolTipID = this.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
            var isMouseOver = false;

            /**
             * Toggle the show/hide state of the tooltip
             */
            var toggle = function toggle(event) {
                if (toolTip.length && toolTip.is(':visible')) {
                    close(event);
                } else {
                    show(event);
                }
            };

            /**
             * Show the tooltip, if not already shown.
             */
            var show = function show(event) {
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                addDescribedById($trigger, toolTipID);

                // Show the tooltip and position the page scroll to include the element on page
                $element.show();
                toolTip.slideDown({
                    progress: function progress() {
                        var windowBot = $(window).scrollTop() + $(window).height();
                        var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
                        if (toolTipBot > windowBot) {
                            $(window).scrollTop(toolTipBot - $(window).height());
                        }
                    }
                });
            };

            /**
             * Hide the tooltip
             */
            var close = function close(event) {
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                if (!isMouseOver) {
                    if (toolTip.length && toolTip.is(':visible')) {
                        toolTip.slideUp(100, function () {
                            $element.hide();
                        });
                    } else {
                        $element.hide();
                    }

                    removeDescribedById($trigger, toolTipID);
                }
            };

            /**
             * Setting up the DOM behavior for this component
             */
            // Set defaults for showEvent and hideEvent if not provided
            this.showEvent = this.showEvent || getDefaultShowEvent($element);
            this.hideEvent = this.hideEvent || 'blur';

            var SHOW_EVENT = this.showEvent + '.toolTip';
            var HIDE_EVENT = this.hideEvent + '.toolTip';

            // Initially hide the tooltip
            $element.hide();

            // If tooltip is clicked, don't bubble up and trigger parent handlers
            $element.on('click', function (event) {
                return event.stopPropagation();
            });

            // If the tooltip contains an element with a "close" class, treat it as a close button
            $element.on('click', '.close', close);

            // Track whether the mouse is on the tooltip or not
            $element.on('mouseover', function () {
                isMouseOver = true;
            });
            $element.on('mouseleave', function () {
                isMouseOver = false;
            });

            // Clicking anywhere on the document not on the tooltip will close the tooltip.
            // Event is not passed so that other actions are not prevented
            $(document).on('click.toolTip', function (e) {
                // Needed because when the trigger is clicked, this click handler will also be fired.
                // So without this check the tooltip will open due to the trigger click and then this
                // document event handler would immediately close it
                if (!$trigger.is(e.target)) {
                    close();
                } else {
                    show();
                }
            });

            // Register the handlers to show and hide the tooltip
            if (this.showEvent === this.hideEvent) {
                $trigger.on(SHOW_EVENT, toggle);
                $element.on(SHOW_EVENT, toggle);
            } else {
                $trigger.on(SHOW_EVENT, show);
                $trigger.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
                // Also allow close event to happen on the tooltip itself, for mouse type events
                $element.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
            }

            // Clean up external listeners on exit
            this.$on('$destroy', function () {
                $(document).off('click.toolTip');
                $trigger.off(SHOW_EVENT);
                $trigger.off(HIDE_EVENT);
                close();
            });
        }
    }
});


_angular.$timeout;

_squid.$Component;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCardLoader = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _popupHandler = __webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/popupHandler.js");

var _popupHandler2 = _interopRequireDefault(_popupHandler);

var _template = __webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoAssistBanner', {
    tag: 'xo-assist-banner',
    template: _template2['default'],
    props: {
        header: {
            type: 'var',
            required: false
        },
        body: {
            type: 'var',
            required: false
        },
        hideHighlight: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('xo-assist-banner_enter');
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('xo-assist-banner:controller');
        $scope.token = _angular.$rootScope.token;
        $scope.showFeedback = function () {
            return !_index.$DeviceInfo.isDevice();
        };
        $scope.showOL = function (event) {
            event.preventDefault();
            var placeholder = 'main:ec:hermes';
            var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
            var data = {
                opVars: {
                    rlogId: _angular.$window.meta.rlogId || '',
                    page: page || window.location.hash,
                    csci: 'Unknown',
                    calc: _angular.$window.meta.correlationId,
                    custId: 'Unknown',
                    merchantId: 'Unknown',
                    token: $scope.token || 'Unknown'
                },
                locale: {
                    country: _squid.$locale.country,
                    languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
                }
            };

            (0, _popupHandler2['default'])(data);
        };
    }]
});

angular.value("$xoCardLoader", $xoCardLoader);
_uiRouter.$state;

_squid.$Component;

_squid.$locale;

_angular.$rootScope;

_angular.$window;

_logger.$logger;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/popupHandler.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var _doc = document;
    var _w = window;
    var _tm = new Date().getTime();
    var _sH = screen.height;
    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
    var _sW = screen.width;

    function popUp(opinionlabURL) {
        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
    }

    function updateCustomVars(data) {

        var opVars = data.opVars;
        var locale = data.locale;

        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
        return customVar;
    }

    function _fC(_u) {
        var _sp = '%3A\\/\\/';
        var _rp = '%3A//';
        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
        var _aA = _aT.split(',');

        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
        }
        return _u;
    }

    return function (locale) {

        var custom_var = updateCustomVars(locale);

        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
        popUp(opinionlabURL);
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"assist-banner-wrapper\">\n    <div ng-if=\"!hideHighlight\" class=\"banner-highlight-bar\"></div>\n    <div class=\"banner-header\">\n        <p>{{header}}</p>\n    </div>\n    <div class=\"banner-body\">\n        <p ng-bind-html=\"body\"></p>\n    </div>\n    <div class=\"banner-feedback\" ng-if=\"showFeedback()\">\n         <span>{{ content('common.haveFeedback') }}</span>\n         <a href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{ content('common.letUsKnow') }}</a>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-validation/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoValidation', function () {
    return {
        template: '',
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elem, attr, ngModel) {
            var validationUtil = {
                // because IE8 doesnt have String.prototype.trim()
                trim: function trim(value) {
                    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

                    return value.replace(rtrim, '');
                },


                /**
                 * Generic function that runs a given input against
                 * a given regular expression
                 *
                 * @param {String} value input to test
                 * @param {String/RegExp} regex Regular expression to test against
                 * @returns {Boolean} matches or does not match given pattern
                 */
                valid: function valid(value, regex) {
                    if (this.empty(value)) {
                        return false;
                    }

                    if (_angular2['default'].isString(regex)) {
                        regex = new RegExp(regex);
                    }

                    return regex ? regex.test(value) : true;
                },


                // returns whether empty or not
                empty: function empty(value) {
                    if (!value) {
                        return true;
                    }

                    // IE8 and below doesn't have native .trim()
                    return !this.trim(value);
                },


                // returns whether alphabetic or not
                alphabetic: function alphabetic(value) {
                    return this.valid(value, /[A-Za-z]+$/);
                },


                // returns whether numeric or not
                numeric: function numeric(value) {
                    var NUMERIC_REGEX = new RegExp('^[0-9]+$');

                    return this.valid(value, NUMERIC_REGEX);
                },
                validBankAccount: function validBankAccount(value) {
                    if (!scope.showIBAN) {
                        return this.numeric(value);
                    }

                    return true;
                },
                validRouting: function validRouting(value) {
                    if (!scope.showIBAN) {
                        return this.valid(value, /^\d{8}$/);
                    }
                    return true;
                },
                validIBANCode: function validIBANCode(value) {
                    if (scope.showIBAN) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
                    }
                    return true;
                },
                validIBAN: function validIBAN(value) {
                    if (scope.showIBAN) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^DE\d{20}$/);
                    }

                    return true;
                },
                validIBANCountry: function validIBANCountry(value) {
                    value = value && value.replace(/ +/g, '');
                    return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
                },


                // @Deprecated: This function is deprecated.
                // first two letters are the country code the rest are the bank account numbers max length 32
                validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
                    value = value && value.replace(/ +/g, '');
                    return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
                },
                validLast4: function validLast4(value) {
                    // @TODO - Unsafe regular expression, need to fix.
                    var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex

                    return this.valid(value, LAST_4);
                },
                validStreet: function validStreet(value) {
                    return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
                },


                // Validating phone format with metadata from griffin
                validPhone: function validPhone(value) {
                    var regex = scope.pattern;

                    /*
                        * User can enter phone format in various manner according to griffin mask
                        * (00) 0000-0000
                        * 00 000 0000
                        * Since the griffin pattern only validates against numbers, need to trim the input
                        * to only validate the numbers
                        */
                    value = value && value.replace(/[^0-9]/gi, '');
                    return this.valid(value, regex);
                },
                validDobYear: function validDobYear(value) {
                    return value !== 'YYYY';
                },
                validDobDay: function validDobDay(value) {
                    return value !== 'DD';
                },
                validDobMonth: function validDobMonth(value) {
                    return value !== 'MM';
                },
                validPoBox: function validPoBox(value) {
                    // @TODO - Unsafe regular expression, need to fix.
                    var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex

                    if (boxRE.test(value)) {
                        return true;
                    }

                    return false;
                },
                validAddressSansPoBox: function validAddressSansPoBox(value) {
                    var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
                    var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;

                    if (boxRE.test(value) || cassRE.test(value)) {
                        return false;
                    }
                    return true;
                },
                validEmailOrPhone: function validEmailOrPhone(value) {
                    if (!value) {
                        return false;
                    }

                    return this.validEmail(value) || this.validPhone(value);
                },
                validEmail: function validEmail(value) {
                    if (!value) {
                        return false;
                    }
                    var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
                    // @TODO - Unsafe regular expression, need to fix.
                    var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line

                    return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
                },
                highAscii: function highAscii(value) {
                    var trimmedValue = this.trim(value);
                    // @TODO - Unsafe regular expression, need to fix.
                    var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex

                    return this.valid(trimmedValue, HIGH_ASCII_REGEX);
                },


                // expected format: MM/DD/YYYY
                validDate: function validDate(value) {
                    var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                    var dArr = value.split('/');
                    var d = new Date(value);
                    var isValid = false;

                    if (re.test(value)) {
                        isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
                    }

                    return isValid;
                },


                /* Expects value and state. state can be "past" or "future".
                    NOTE: This function validates only month and year, not day!
                    Please use validDate() if you need to validate the whole date. */
                validDateWithoutDay: function validDateWithoutDay(value, options) {
                    // eslint-disable-line max-statements
                    var state = options.state;

                    value = value.replace(/\s/g, '');

                    if (value === '') {
                        return true;
                    }

                    var split = value.split('/');
                    var month = split[0];
                    var year = split[1];
                    var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
                    var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
                    var validYear = true;
                    var validMonth = true;

                    if (value.length < 5) {
                        return false;
                    }

                    if (!this.validDobMonth(month)) {
                        return false;
                    }

                    month = parseInt(month, 10);
                    year = parseInt(year, 10);

                    if (state === 'past') {
                        validYear = year <= currentYear;
                        if (!validYear) {
                            return false;
                        }
                        if (year === currentYear) {
                            validMonth = month <= currentMonth;
                        }
                    } else if (state === 'future') {
                        validYear = year >= currentYear;
                        if (!validYear) {
                            return false;
                        }
                        if (year === currentYear) {
                            validMonth = month >= currentMonth;
                        }
                    }

                    if (!validYear || !validMonth) {
                        return false;
                    }

                    return true;
                },


                // formats to MM/DD/YYYY
                mmddyyyy: function mmddyyyy(day, month, year) {
                    if (year.length < 4) {
                        year = '20' + year;
                    }

                    return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
                },


                // formats to YY-MMM-DDDD
                yyyymmdd: function yyyymmdd(day, month, year) {
                    if (year.length < 4) {
                        year = '20' + year;
                    }

                    return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
                },


                // pads a number to two digits
                twoDigits: function twoDigits(value) {
                    return value < 10 ? '0' + value : '' + value;
                },


                // expects YYYY-MM-DD
                legalAge: function legalAge(value) {
                    if (this.empty(value)) {
                        return false;
                    }

                    var dateParts = value.split('-'); // expecting YYYY-MM-DD
                    var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
                    var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
                    var validBD = new Date(new Date() - 18 * yr);

                    return validBD >= birthDate;
                },
                validZip: function validZip(value, options) {

                    var postalCodeRegex = {
                        // TODO: Once this is removed from the xo-add-address template, we can remove it...
                        GB: /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
                        /**
                         * Note: These are "nice to have".
                         * Once we add support for these countries, we can remove these.
                         */
                        BA: /^\d{5}$/,
                        CY: /^\d{4}$/,
                        EE: /^\d{5}$/,
                        HR: /^\d{5}$/,
                        LU: /^\d{4}$/,
                        LV: /^\d{4}$/,
                        MT: /^\d{3,4}$/,
                        SI: /^\d{4}$/,
                        SK: /^[0-9]{3}[\s][0-9]{2}$/,
                        NZ: /^\d{4}$/,
                        LT: /^\d{5}$/,
                        BG: /^\d{4}$/,
                        CZ: /^\d{5}$/,
                        GR: /^\d{3}[\s]\d{2}$/,
                        HU: /^\d{4}$/,
                        MX: /^\d{5}$/
                    };

                    var country = options && options.country;
                    var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
                    var isRequired = scope.zipEntry && scope.zipEntry.required;

                    if (!isRequired && this.empty(value)) {
                        return true;
                    }

                    // If there is no regex, or it's not populated yet...
                    if (!regex || _angular2['default'].isString(regex) && regex.indexOf('validationPattern') > -1) {
                        return !this.empty(value);
                    }

                    value = value && value.toUpperCase();

                    if (_angular2['default'].isString(regex)) {
                        if (regex.charAt(0) !== '^') {
                            regex = '^' + regex;
                        }
                        if (regex.charAt(regex.length - 1) !== '$') {
                            regex += '$';
                        }
                    }

                    return this.valid(value, regex);
                },
                validExpiry: function validExpiry(value, options) {
                    var $monthEl = (0, _jquery2['default'])('[ng-model="card.expiry_month"]');
                    var $yearEl = (0, _jquery2['default'])('[ng-model="card.expiry_year"]');
                    var month = $monthEl.val();
                    var year = $yearEl.val();
                    var isValid = false;
                    var monthElName = 'card.expiry_month';
                    var yearElName = 'card.expiry_year';
                    var cardType = options.cardType;

                    if (month) {
                        month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                    }

                    if (year) {
                        year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                    }

                    if (month && year) {
                        isValid = this.validExpires(month, year);
                    }

                    var formName = $monthEl.closest('form').attr('id');
                    var form = scope[formName] || scope.$parent[formName];
                    var monthFieldName = monthElName;
                    var yearFieldName = yearElName;

                    if (monthFieldName.indexOf('.') !== -1) {
                        monthFieldName = monthFieldName.split('.')[1];
                    }

                    if (yearFieldName.indexOf('.') !== -1) {
                        yearFieldName = yearFieldName.split('.')[1];
                    }

                    var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];

                    if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
                        isValid = true;
                    }

                    if (form) {
                        form[monthFieldName].$setValidity('validExpiry', isValid);
                        form[yearFieldName].$setValidity('validExpiry', isValid);
                    }

                    return isValid;
                },
                validExpires: function validExpires(month, year) {
                    var date = new Date();
                    var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
                    var currentMonth;

                    if (year < currentYear) {
                        return false;
                    } else if (year > currentYear) {
                        return this.validDobMonth(month);
                    }

                    // account for display date vs. system date
                    currentMonth = date.getMonth() + 1;
                    return this.validDobMonth(month) && month >= currentMonth;
                },
                startDate: function startDate(value, options) {
                    var valueOptions = {
                        cardType: scope.card.type
                    };

                    valueOptions[elem.attr('id')] = value;

                    return this.setStartDateValidity(valueOptions);
                },


                setExpiryValidity: function setExpiryValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var cardType = options.cardType || '';
                    var expiryValidity = this.validExpiry(null, {
                        cardType: cardType
                    });

                    return expiryValidity;
                },

                // start date validation for Maestro card
                setStartDateValidity: function setStartDateValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var cardType = options.cardType || '';
                    var startDateValidity = true;
                    var $monthEl = (0, _jquery2['default'])('#startmonth');
                    var $yearEl = (0, _jquery2['default'])('#startyear');
                    var month = $monthEl.val();
                    var year = $yearEl.val();

                    if (cardType === 'MAESTRO') {
                        if (!month || !year) {
                            startDateValidity = false;
                        }
                    }

                    var formName = $monthEl.closest('form').attr('id'),
                        form = scope[formName] || scope.$parent[formName];

                    if (form) {
                        form.startmonth.$setValidity('startDate', startDateValidity);
                        form.startyear.$setValidity('startDate', startDateValidity);
                    }

                    return startDateValidity;
                },
                dobField: function dobField(value, options) {
                    var valueOptions = {};
                    var fieldMap = {
                        dobDayCC: 'day',
                        dobMonthCC: 'month',
                        dobYearCC: 'year'
                    };

                    valueOptions.cardType = scope.card.type;
                    valueOptions[fieldMap[elem.attr('id')]] = value;

                    return this.setDOBValidity(valueOptions);
                },
                setDOBValidity: function setDOBValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
                    var dobValidity = true;

                    var $monthEl = (0, _jquery2['default'])('#dobMonthCC');
                    var $dayEl = (0, _jquery2['default'])('#dobDayCC');
                    var $yearEl = (0, _jquery2['default'])('#dobYearCC');

                    var month = options.month || $monthEl.val();
                    var year = options.year || $yearEl.val();
                    var day = options.day || $dayEl.val();

                    if (month) {
                        month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                    }

                    if (day) {
                        day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
                    }

                    if (year) {
                        year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                    }

                    var cardType = options.cardType;

                    if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
                        if (!month || !year || !day) {
                            dobValidity = false;
                            // invalidate if < 18 y/o.
                        } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
                            dobValidity = false;
                        } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
                            dobValidity = false;
                        }
                    }

                    var formName = $monthEl.closest('form').attr('id');
                    var form = scope[formName] || scope.$parent[formName];

                    if (form) {
                        form.dobMonthCC.$setValidity('dobField', dobValidity);
                        form.dobDayCC.$setValidity('dobField', dobValidity);
                        form.dobYearCC.$setValidity('dobField', dobValidity);
                    }

                    return dobValidity;
                },
                validName: function validName(value) {
                    return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
                },
                isChecked: function isChecked(value, options) {
                    // $.is does not exist in $
                    // eslint-disable-line angular/ng_angularelement
                    var $el = (0, _jquery2['default'])(options.el);

                    return $el.is(':checked');
                },
                validRUPassport: function validRUPassport(value, options) {
                    if (scope.user.countryOfResidence === 'RU') {
                        return this.valid(value, /^\d{10}$/);
                    }
                    return true;
                }
            };

            var customValidator = function customValidator(value) {
                var ruleJson = _angular2['default'].fromJson(elem.attr('xo-validation'));
                var validator = ruleJson.validator;
                var options = ruleJson.options;

                ngModel.$setValidity(validator, validationUtil[validator](value, options));

                return value;
            };

            ngModel.$parsers.unshift(customValidator);
            ngModel.$formatters.unshift(customValidator);
        }
    };
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/3ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/3ds/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xo3ds', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            data: '=?',
            onComplete3dsHandler: '=?'
        },
        controller: ['$scope', function ($scope) {
            var resolve3DS = _index2.$Resolve3DS.instance($scope.token);
            var checkoutAppData = _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
            var _$locale$country = _squid.$locale.country,
                country = _$locale$country === undefined ? 'DEFAULT' : _$locale$country;

            var isIos = _dist.$DeviceInfo.getiOSVersion();
            var timeout3DSConfig = _squid.$config.timeout3DS || { 'DEFAULT': 30000 };
            var lightBoxTimeout = isIos && country === 'IN' ? 0 : timeout3DSConfig[country] || timeout3DSConfig['DEFAULT'];

            $scope.termUrl = '' + window.location.origin + _squid.$config.urls.baseUrl + '/process3DS';
            $scope.data = $scope.data || {};

            function show3DSLightBox() {
                if ($scope.show3DS) {
                    var lightbox = angular.element(document.getElementById('light-box'));

                    lightbox.addClass('open');
                    $scope.show3DS = false;
                    _angular.$rootScope.$emit('loaded');
                }
            }

            function shouldUpdatePaymentExperience() {
                var merchantCountry = checkoutAppData.get('merchant.merchant_country', 'US');

                return !(_squid.$config.features[country] && _squid.$config.features[country].mandatory3dsWithMerchantCountries && _squid.$config.features[country].mandatory3dsWithMerchantCountries.includes(merchantCountry));
            }

            function handleInitFailure(message) {
                // Since init3DS call failed. We disable the feature and proceed to checkout.
                var updateAction = shouldUpdatePaymentExperience() ? checkoutAppData.action('updatePaymentExperience', {
                    data: {
                        payment_experience: 'HERMESNODE',
                        '3d_secure_authentication_supported': false
                    },
                    silent: true,
                    transientError: true
                }) : _squid.$promise.resolve();

                updateAction.then(function () {
                    _logger.$logger.info('checkout_fpti', {
                        from: '3DS_CHALLENGE',
                        to: 'process_3ds_challenge',
                        'int_error_description': message,
                        'error_type': 'soft_decline',
                        'error_source': 'fiLifecycle'
                    });
                    $scope.onComplete3dsHandler('success');
                });
            }

            function init3DSApi() {
                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('threeDS.processing'));

                //  3DS - New values to support latest PG
                var _$scope$data = $scope.data,
                    cardVerificationCode = _$scope$data.card_verification_code,
                    supportedPaymentExperiences = _$scope$data.paymentExperience,
                    channelType = _$scope$data.channelType,
                    isMiniBrowser = _$scope$data.isMiniBrowser,
                    isRedirectTreatment = _$scope$data.isRedirectTreatment,
                    process3dsReturnQueryParams = _$scope$data.process3dsReturnQueryParams;


                return resolve3DS.action('init3DS', {
                    data: {
                        cc_id: $scope.data.cc_id,
                        flow_id: $scope.data.flow_id,
                        merchant_id: $scope.data.merchant_id,
                        merchant_country: $scope.data.merchant_country_code,
                        currency: $scope.data.transaction_amount_currency,
                        transaction_amount: $scope.data.transaction_amount_value,
                        channel: channelType,
                        card_verification_code: cardVerificationCode,
                        supported_payment_experiences: supportedPaymentExperiences,
                        isMiniBrowser: isMiniBrowser
                    },
                    success: function success(response) {
                        if (response.status === 'SUCCESS' && response.acsUrl) {
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'prepare_3ds_challenge'
                            });
                            $scope.acsUrl = response.acsUrl;
                            $scope.acsMethod = response.acsMethod || 'POST';
                            $scope.acsPaReq = response.acsPaReq;
                            $scope.redirectRequestParameters = response.redirectRequestParameters;

                            $scope.paymentExperience = response.paymentExperience || (isRedirectTreatment ? 'REDIRECT' : 'IFRAME');

                            var target = 'threeDSFrame';

                            if ($scope.paymentExperience === 'REDIRECT') {
                                var complete3DSQuery = process3dsReturnQueryParams;

                                $scope.termUrl = '' + window.location.origin + _squid.$config.urls.baseUrl + '/process3DSRedirect?' + complete3DSQuery;
                                target = '_self';
                            }

                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_PAYMENT_EXPERIENCE',
                                to: 'prepare_paymentExperience_' + $scope.paymentExperience
                            });

                            _logger.$logger.info('3DS_PAYMENT_EXPERIENCE_' + $scope.paymentExperience, {
                                response_paymentExperience: response.paymentExperience,
                                elmo_isRedirectTreatment: isRedirectTreatment,
                                paymentExperience: $scope.paymentExperience
                            });

                            var form = $('<form/>', {
                                action: $scope.acsUrl,
                                method: $scope.acsMethod,
                                id: 'iFrameForm',
                                target: target
                            });

                            if ($scope.redirectRequestParameters && $scope.redirectRequestParameters.length > 0) {
                                $scope.redirectRequestParameters.forEach(function (item) {
                                    form.append($('<input/>', {
                                        type: 'hidden',
                                        name: item.key,
                                        value: item.value === 'PAYPAL_RETURN_URL' ? $scope.termUrl : item.value
                                    }));
                                });
                            } else if ($scope.acsPaReq) {
                                form.append($('<input/>', {
                                    type: 'hidden',
                                    name: 'TermUrl',
                                    value: $scope.termUrl
                                }));
                                form.append($('<input/>', {
                                    type: 'hidden',
                                    name: 'PaReq',
                                    value: $scope.acsPaReq
                                }));
                            }

                            $('#lightBoxAcsWrapper').append(form);
                            $('#iFrameForm').submit();

                            // wait for 3DS page to load with a timeout

                            // The $scope.show3DS in the line below is set true when the 3DS modal is eligible to be shown to user when the
                            // bank page loads in its iframe, i.e., after init3DS success
                            $scope.show3DS = true;
                            _angular.$rootScope.$emit('loading');
                            _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('threeDS.processing'));
                            (0, _angular.$timeout)(function () {
                                if ($scope.show3DS) {
                                    _logger.$logger.info('checkout_fpti', {
                                        from: '3DS_CHALLENGE',
                                        to: '3DS_CHALLENGE',
                                        'int_error_description': 'load_3ds_issuer_page_content_timeout',
                                        'error_type': 'soft_decline',
                                        'error_source': 'fiLifecycle'
                                    });
                                }
                                show3DSLightBox();
                            }, lightBoxTimeout);
                        } else {
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge',
                                'int_error_description': 'acsUrl_not_presented_on_init',
                                'error_type': 'soft_decline',
                                'error_source': 'fiLifecycle'
                            });

                            // When there is no 3DS challenge page to be shown, we return success to the caller
                            $scope.onComplete3dsHandler('success');
                        }
                    },
                    error: function error() {
                        handleInitFailure('unknown_error_on_init3DS');
                    },
                    validation: function validation() {
                        handleInitFailure('validation_error_on_init3DS');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT() {
                            handleInitFailure('contingency_presented_on_init3DS');
                        }
                    }
                });
            }

            function complete3DSApi(paRes) {
                return resolve3DS.action('complete3DS', {
                    data: {
                        third_party_response: paRes,
                        cc_id: $scope.data.cc_id,
                        flow_id: $scope.data.flow_id
                    },
                    success: function success(response) {
                        var status = void 0;

                        if (response.status === 'SUCCESS') {
                            status = 'success';

                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge'
                            });
                        } else {
                            status = 'decline';
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge',
                                'int_error_description': 'complete3DS_decline',
                                'error_type': 'soft_decline',
                                'error_source': 'fiLifecycle'
                            });
                        }
                        $scope.onComplete3dsHandler(status);
                    }
                });
            }

            $scope.close3DSFrame = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: '3DS_CHALLENGE',
                    to: 'process_user_close'
                });
                _logger.$logger.flush();

                var lightbox = angular.element(document.getElementById('light-box'));

                lightbox.removeClass('open');

                (0, _angular.$timeout)(function () {
                    var lightboxMask = angular.element(document.getElementById('mask'));

                    lightboxMask.remove();
                    $scope.onComplete3dsHandler('close');
                }, 200);
            };

            init3DSApi();

            $scope.complete3DS = function (paRes) {
                complete3DSApi(paRes);
            };

            _angular.$window.complete3DSFrame = function (paRes) {
                $scope.complete3DS(paRes);
            };

            $scope.on3DSPageLoad = show3DSLightBox;
            _angular.$window.on3DSPageLoad = $scope.on3DSPageLoad;

            // when the esc key is pressed
            $('html').on('keyup', function (ev) {
                if (ev.which === 27) {
                    $scope.close3DSFrame();
                }
            });
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_angular.$window;

_squid.$config;

_squid.$locale;

_squid.$promise;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index2.$Resolve3DS;

_dist.$DeviceInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/3ds/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"light-box-3ds\" class=\"light-box-3ds\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <a class=\"close\" ng-click=\"close3DSFrame()\" href=\"#\">&nbsp;</a>\n                    <p class=\"light-box-header\">\n                        {{ content('threeDS.iFrameTitle') }}\n                    </p>\n                    <iframe name=\"threeDSFrame\" src=\"\" class=\"light-box-iframe\" onload=\"window.on3DSPageLoad && on3DSPageLoad()\"></iframe>\n                </div>\n\n                <div class=\"logo\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/addbank/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/addbank/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBank', function () {
    return {
        template: _template2['default'],
        scope: {
            parentCallbacks: '=?',
            errorMessage: '=?',
            bank: '=?',
            sidebar: '=?',
            hideparenthead: '=?',
            message: '=?',
            pageLevel: '=?',
            showSetPreferredFi: '=?',
            showCancel: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.model = $scope.bank || new _index.$AddBankModel({
                id: 123
            });
            $scope.locale = _squid.$locale;
            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = false;
            }
            $scope.onSubmit = function () {
                if ($scope.pageLevel) {
                    $scope.pageLevel.message = null;
                }

                var data = $scope.model.getBankData();

                function mapValidationErrors(err) {
                    var fields = err && err.fields || [];

                    fields.forEach(function (fieldError) {
                        if (fieldError && fieldError.property) {
                            fieldError.field = fieldError.property;
                        }
                    });
                    return {
                        fields: fields
                    };
                }

                return $scope.model.action('validate', {
                    data: data,
                    resultModel: {},
                    success: function success(successData) {
                        $scope.model.creditorDetails = successData.creditorDetails;
                        $scope.model.fiDetails = successData.fiDetails;
                        $scope.parentCallbacks.addBankDone($scope.model);
                        if ($scope.showSetPreferredFi && $('#makeFiPreferred').is(':checked')) {
                            $scope.parentCallbacks.setBankPrefer(true);
                        }
                    },
                    contingencies: {
                        VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, contingencyData) {
                            $scope.errorMessage = _util.$fiErrorUtil.addPageErrors(contingencyData, 'bank');
                            _util.$fiErrorUtil.addFieldErrors(contingencyData, $element, 'model.');
                        }
                    },
                    validation: function validation(res) {
                        return _util.$fiErrorUtil.addFieldErrors(mapValidationErrors(res), $element, 'model.');
                    }
                });
            };

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                billingAddresses: _index.$BillingAddressesModel.instance()
            }).then(function () {
                $scope.model.address = $scope.billingAddresses.addresses && $scope.billingAddresses.addresses[0];
                $scope.model.user.first_name = $scope.auth.first_name;
                $scope.model.user.last_name = $scope.auth.last_name;
                $scope.model.user.country = $scope.model.address && $scope.model.address.country;
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_auth.$AuthModel;

_index.$AddBankModel;

_index.$BillingAddressesModel;

_util.$fiErrorUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/addbank/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/addbank/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOAddBankRoute', function () {
    return _squid.$ComponentRoute.extend('AddRoute', {
        name: 'add',
        titleContent: 'asideHeader.addBank',
        directive: 'xo-add-bank',
        trackingData: {
            fptiState: 'add_bank'
        },
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-bank/addbank", "../node_modules/xo-wallet-components/src/add-bank/addbank/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/addbank/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header back-url=\"checkout.review.sidebar.wallet\" heading='asideHeader.addBank' ng-if=\"sidebar && locale.country !== 'DE'\"></xo-aside-header>\n<xo-message message=\"errorMessage\"></xo-message>\n<div class=\"container\" ng-class=\"{asideContent: sidebar}\" xo-tray-height>\n\t<form id=\"bankForm\" name=\"bankForm\" method=\"post\" class=\"asideProceed formSmall\" novalidate=\"novalidate\">\n        <div id=\"bankFields\" class=\"clearfix\" content>\n            <div id=\"name\" class=\"fieldGroup clearfix\">\n                <div class=\"inputField  half confidential firstname\">\n                    <label for=\"firstName\" class=\"focus accessAid\">\n                        {{ content('common.firstName') }}\n                    </label>\n                    <input ng-model=\"model.user.first_name\" name=\"firstName\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('common.firstName') }}\" xo-error-tooltip required />\n                </div>\n\n                <div class=\"inputField half last-child confidential lastname\">\n                    <label for=\"lastName\" class=\"focus accessAid\">\n                        {{ content('common.lastName') }}\n                    </label>\n                    <input ng-readonly=\"model.user.last_name\" ng-model=\"model.user.last_name\" name=\"lastName\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('common.lastName') }}\" xo-error-tooltip required />\n                </div>\n            </div>\n\n            <xo-bank-input user=\"model.user\" bank=\"model.bank\"></xo-bank-input>\n\n            <div ng-if=\"showSetPreferredFi\" id=\"setPreference\">\n                <div class=\"checkbox\">\n                    <input type=\"checkbox\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" />\n                    <label for=\"makeFiPreferred\">{{ content('addCard.makeFiPreferred') }}</label>\n                </div>\n                <div class=\"legal infoTxt\">{{content('addCard.makeFiPreferredLegal')}}\n                    <span id=\"setPreferredFiLearnMore\" bind-html-compile=\"htmlContent('addCard.learnMore')\"></span>\n                </div>\n            </div>\n\n            <p class=\"infoTxt secondary \" data-ng-bind-html=\"htmlContent( 'bank.addBankDisclaimer') \"></p>\n\n            <div class=\"buttons\">\n                <input track-submit id=\"proceedButton\" type=\"submit\" value=\"{{ content('common.continuetext') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n            </div>\n\n            <div class=\"center\" ng-if=\"showCancel\">\n                <a link-button prevent-default href=\"#\" ng-click=\"parentCallbacks.cancel(sidebar ? 'checkout.reivew.sidebar.wallet' : '')\">{{ content('common.cancel') }}</a>\n            </div>\n        </div>\n    </form>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/bank-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBankInput', function () {
    return {
        template: _template2['default'],
        scope: {
            user: '=?',
            bank: '=?'
        },
        /* auto formatting the user entered IBAN input */
        link: function link(scope, element, attr) {
            var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';

            element.on('keyup', function (event) {

                $('#ibanNumber').mask(IBANMask, {
                    'translation': {
                        0: { pattern: /[A-Za-z0-9]/ }
                    }
                });
            });
        },

        controller: ['$scope', function ($scope) {
            $scope.showIBAN = true;

            var days = [];
            var months = [];
            var years = [];

            var i;

            for (i = 1; i <= 31; i += 1) {
                var d = i < 10 ? '0' + i : i.toString();

                days.push(d);
            }

            for (i = 1; i <= 12; i += 1) {
                var m = i < 10 ? '0' + i : i.toString();

                months.push(m);
            }

            var year = new Date().getFullYear();

            for (i = year - 17; i >= year - 100; i -= 1) {
                years.push(i);
            }

            $scope.days = days;
            $scope.months = months;
            $scope.years = years;

            $scope.toggleIBAN = function () {
                $scope.showIBAN = !$scope.showIBAN;
            };
        }]
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/bank-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"bankFields\" content>\n    <div class=\"bban\" ng-if=\"!showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterBBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadIBAN')}}</a>\n        </p>\n\n        <div class=\"inputField restricted\">\n            <label for=\"bankAccountNumber\" class=\"accessAid nolap\">\n                {{content('DEMemberGuest.account')}}\n            </label>\n            <input id=\"bankAccountNumber\" name=\"bankAccountNumber\" type=\"text\" value=\"\" ng-model=\"bank.bank_account_number\" placeholder=\"{{content('DEMemberGuest.accountPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"10\" aria-required=\"true\"\n                   xo-validation='{\n                \"validator\": \"validBankAccount\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-text=\"{{content('scripts.validNumber')}}\" xo-error-tooltip />\n        </div>\n\n        <div class=\"inputField restricted\">\n            <label for=\"blz\" class=\"accessAid nolap\">\n                {{content('DEMemberGuest.sort')}}\n            </label>\n            <input id=\"blz\" name=\"blz\" type=\"text\" value=\"\" ng-model=\"bank.bank_routing_number\" placeholder=\"{{content('DEMemberGuest.sortPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"8\" aria-required=\"true\"  xo-validation='{\n                \"validator\": \"validRouting\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-text=\"{{content('scripts.validNumber')}}\" xo-error-tooltip />\n        </div>\n    </div>\n    <div class=\"iban\" ng-if=\"showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterIBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadBBAN')}}</a>\n        </p>\n        <div class=\"inputField restricted\">\n            <label for=\"ibanNumber\" class=\"accessAid nolap\">\n                {{content('bank.iban')}}\n            </label>\n            <input id=\"ibanNumber\" name=\"ibanNumber\" type=\"text\" value=\"\" placeholder=\"{{content('bank.IBANPlaceholder')}}\" autocomplete=\"off\" maxlength=\"42\" aria-required=\"true\" ng-model=\"bank.iban_number\"\n            data-error-text=\"{{content('scripts.validIBAN')}}\" xo-error-tooltip />\n        </div>\n    </div>\n\n    <div id=\"dobBank\" class=\"dobbank\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('DEMemberGuest.dob')}}</legend>\n\n            <div class=\"dropdown fidobDay\">\n                <select xo-dropdown name=\"dobDay\" ng-model=\"user.dob_day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days track by $index\" value=\"{{day}}\" ng-selected=\"user.dob_day === '{{day}}'\">{{day}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobMonth\">\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"user.dob_month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months track by $index\" value=\"{{month}}\" ng-selected=\"user.dob_month === '{{month}}'\">{{month}}</option>\n                </select>\n            </div>\n            \n            <div class=\"dropdown fidobYear\">\n                <select xo-dropdown name=\"dobYear\" ng-model=\"user.dob_year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years track by $index\" value=\"{{year}}\" ng-selected=\"user.dob_year === '{{year}}'\">{{year}}</option>\n                </select>\n            </div>\n        </fieldset>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/template.html");

var _template2 = _interopRequireDefault(_template);

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBankFlow', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            parentCallbacks: '=?',
            sidebar: '=?',
            hideparenthead: '=?',
            pageLevel: '=?',
            showSetPreferredFi: '=?',
            showCancel: '=?'
        },

        controller: ['$scope', '$element', function ($scope, $element) {

            function handleContingency(name, result) {

                $scope.errorMessage = _util.$fiErrorUtil.addPageErrors(result, 'bank');
                _util.$fiErrorUtil.addFieldErrors(result, $element, 'model.');
                _uiRouter.$state.go('^.add');
            }

            function updateFundingOptions() {
                $scope.checkoutSession.fundingOptions.action('update', {

                    resultModel: $scope.checkoutSession,

                    data: {
                        planId: $scope.bankId
                    },
                    success: function success(result) {

                        $scope.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                        };
                        $scope.parentCallbacks.done();
                    },
                    contingencies: {
                        ADD_BANK_CONTINGENCY: handleContingency
                    }

                });
            }

            $scope.setBankPrefer = false;

            $scope.callbacks = {
                addBankDone: function addBankDone(bank) {
                    $scope.bank = bank;
                    _uiRouter.$state.go('^.sepa');
                },
                setBankPrefer: function setBankPrefer(bSetBank) {
                    $scope.setBankPrefer = bSetBank;
                },

                sepaDone: function sepaDone() {

                    (0, _squid.$populate)($scope, {
                        checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                        cart: _index.$CheckoutCartModel.instance($scope.token)
                    }).then(function () {

                        $scope.locale = _squid.$locale;

                        var addBankReq = $scope.bank.getBankData();

                        $scope.bank.action('add', {

                            data: addBankReq,

                            resultModel: {},

                            success: function success(data) {

                                $scope.bankId = data.id;

                                // setPreferredFI checkbox is checked
                                if ($scope.setBankPrefer) {

                                    _logger.$logger.info('set_preferredFI_checked');

                                    // set preferred FI before updating
                                    var preferredFi = new _fi.$PreferredFi({
                                        preferred: [$scope.bankId]
                                    });

                                    preferredFi.save({
                                        success: function success() {
                                            _logger.$logger.info('SET_PREFERREDFI_SUCCESS', { preferred: [$scope.bankId] });
                                        },
                                        transientError: true,
                                        error: function error(err) {
                                            // log the error but fails silently because card is added
                                            _logger.$logger.error('SET_PREFERREDFI_ERROR', { error: err });
                                        },
                                        contingencies: {
                                            DEFAULT: function DEFAULT(name, contingency) {
                                                _logger.$logger.info('SET_PREFERREDFI_CONTINGENCY', name);
                                            }
                                        }
                                    });
                                }

                                // Sepa Mandate
                                var sepaStatus = data.sepaStatus;

                                if (sepaStatus === 'AUTHORIZED') {
                                    return updateFundingOptions();
                                }
                                $scope.bank.action('sepaAccept', {

                                    data: {
                                        bank: {
                                            id: data.id
                                        }
                                    },

                                    resultModel: {},

                                    success: updateFundingOptions,
                                    contingencies: {
                                        DEFAULT: handleContingency
                                    }

                                });
                            },

                            contingencies: {
                                ADD_BANK_CONTINGENCY: handleContingency
                            }

                        });
                    });
                },

                cancel: $scope.parentCallbacks.cancel
            };
        }]
    };
});

_squid.$locale;

_squid.$populate;

_uiRouter.$state;

_logger.$logger;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_util.$fiErrorUtil;

_fi.$PreferredFi;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/addbank/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/sepa/route.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddBankFlowRoute', function () {

    return _squid.$ComponentRoute.extend('BankRoute', {
        name: 'bank',
        directive: 'xo-add-bank-flow',
        titleContent: 'asideHeader.addBank',
        children: [{
            name: '$XOAddBankRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                'error-message': 'errorMessage',
                bank: 'bank',
                sidebar: 'sidebar',
                hideparenthead: 'hideparenthead',
                'page-level': 'pageLevel',
                'show-set-preferred-fi': 'showSetPreferredFi',
                'show-cancel': 'showCancel'
            }
        }, {
            name: '$XOSepaRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                model: 'bank',
                sidebar: 'sidebar',
                hideparenthead: 'hideparenthead'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-bank", "../node_modules/xo-wallet-components/src/add-bank/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/sepa/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepa', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            parentCallbacks: '=?',
            model: '=?',
            sidebar: '=?',
            hideparenthead: '=?'
        },
        controller: ['$scope', function ($scope) {

            if (!$scope.model) {
                return _uiRouter.$state.go('^.add');
            }

            $('body').addClass('pageSepaMandate');

            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaMandate');
            });

            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = true;
            }

            function getDate() {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; // January is 0!

                var yyyy = today.getFullYear();

                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                return dd + '.' + mm + '.' + yyyy;
            }

            $scope.date = getDate();
            $scope.onSubmit = function () {
                $scope.parentCallbacks.sepaDone();
            };
        }],

        link: function link($scope, element, attrs) {
            (0, _angular.$timeout)(function () {
                $(element).find('.asideContent').height($('#main').height() - $('#tray').find('.header').height() + 10);
            }, 10);
        }
    };
});

_angular.$timeout;

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/sepa/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/sepa/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaRoute', function () {

    return _squid.$ComponentRoute.extend('SepaRoute', {

        name: 'sepa',
        directive: 'xo-sepa',
        titleContent: 'DEMemberGuest.sepaTitle',
        trackingData: {
            fptiState: 'sepa_mandate',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_mandate',
                    'pagename2': '%::sepa_mandate:member:hermes:',
                    'version': 'member:%:'
                }
            }

        },
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-bank/sepa", "../node_modules/xo-wallet-components/src/add-bank/sepa/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/sepa/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"sepaMandate\">\n<xo-aside-header back-url=\"^.add\" heading='DEMemberGuest.ddAgreementHead' ng-if=\"sidebar\"></xo-aside-header>\n<h1 class=\"gamma noHead\" ng-if=\"!sidebar\">{{ content('DEMemberGuest.ddAgreementHead') }}</h1>\n<div class=\"container\" ng-class=\"{asideContent: sidebar}\" content>\n    <form ng-submit=\"onSubmit()\" id=\"sepaMandateForm\" method=\"post\" class=\"asideProceed formSmall\"\n          novalidate=\"novalidate\">\n            <div class=\"sepaText\">\n                <p>{{ content('DEMemberGuest.ddAgreementPara1') }}</p>\n                <div class=\"sepaDetails\">\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.accountCarrier')}} </span>\n                            <span class=\"col2\">\n                                <span>{{model.user.first_name}}</span>\n                                <span>{{model.user.last_name}}</span>\n                                <br/>{{model.address.line1}}\n                                <br/>{{model.address.line2}}\n                                <br/>{{model.address.postal_code}} {{model.address.city}}\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.IBAN')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.piAccountNumber}}</span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.bankName')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.isssuerDetails.name}}</span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.bic')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.bic}}</span>\n                        </p>\n                    </div>\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.creditor')}}</span>\n                            <span class=\"col2\">\n                                <span>{{model.creditorDetails.creditorName}}</span>\n                                <br/><span class=\"confidential streets street-address\">{{model.creditorDetails.address.address1}}</span>\n                                <br/><span class=\"confidential postal-code\">{{model.creditorDetails.address.zip}}</span>\n                                    <span class=\"confidential locality\">{{model.creditorDetails.address.city}}</span>\n                                    <span class=\"confidential country adr-break\">{{model.creditorDetails.address.isoCountry}}</span>\n\n                            </span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.creditorId')}}</span>\n                            <span class=\"col2 creditorId\">{{model.creditorDetails.creditorId}}</span>\n                        </p>\n                    </div>\n                </div>\n                <p class=\"secondary\">{{content('DEMemberGuest.ddAgreementPara2WithoutLink')}}</p>\n\n                <p class=\"help\">{{date}}, {{model.address.city}}, {{content('DEMemberGuest.country'+model.address.country)}}</p>\n            </div>\n\n                <div class=\"buttons\">\n                    <input id=\"proceedButton\" type=\"submit\" value=\"{{ content('DEMemberGuest.agreeBtn') }}\"\n                           class=\"btn full \" ng-click=\"validated=true \"/>\n                    <a id=\"cancelBtn\" ui-sref=\"^.add\" class=\"btn full btn-secondary goTray\"\n                       role=\"button\">\n                        {{content('DEMemberGuest.cancelBtn')}}\n                    </a>\n                </div>\n\n    </form>\n\n</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view></div>"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCep', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sidebar: '=?',
            prefillAddress: '=?',
            doneFn: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.country = _squid.$locale.country;
            $scope.address = {};
            $scope.onSubmit = function () {
                $scope.prefillAddress.address = {
                    country: _squid.$locale.country,
                    postal_code: $scope.address.postal_code
                };
                return $scope.prefillAddress.save({
                    data: $scope.prefillAddress,
                    success: function success(result) {
                        $scope.prefillAddress.address = result;
                        $scope.doneFn();
                    }
                });
            };
        }]
    };
});

_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCepRoute', function () {
    return _squid.$ComponentRoute.extend('AddCepRoute', {
        name: 'addCep',
        directive: 'xo-add-cep',
        titleContent: 'addBillingAddress.title',
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addCep", "../node_modules/xo-wallet-components/src/add-card/addCep/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n<h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n<form id=\"cepForm\" name=\"cepForm\" class=\"asideView addressForm\" content novalidate>\n    <div class=\"trayInner container\">\n        <xo-zipcode id=\"zipcode\" country=\"{{country}}\" address=\"address\" zip-label=\"{{content('common.cep')}}\"\n                    zip-error-key=\"common.valueInvalid\"></xo-zipcode>\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\"\n                   value=\"{{ content('common.continueLabel') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _address = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBilling', function () {
    return {
        template: _template2['default'],
        scope: {
            auth: '=?',
            token: '=?',
            doneFn: '=?',
            parentCallbacks: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            billingaddressupdated: '=?',
            prefillAddress: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            var country = _squid.$locale.getCountryCodeISO();

            $scope.billing = true; // to denote its billing address page still
            $scope.normalize = (0, _squid.$feature)('addressNormalization');
            $scope.country = country;
            var $el = $($element);

            if ($scope.showmeftsection) {
                $scope.showmeftsection.toggle = false;
            }

            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = true;
            }

            function isUserInputtedAddress(address) {
                return address && address.id === '0';
            }

            // Label fields has having error if needed to, and focus the first error if needed
            function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = $($el.find('[name="' + field.field + '"]'));

                            if ($field.length === 0 && field.field === 'zip') {
                                $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                            }
                            $field.addClass('backendError');
                            $field.attr('aria-invalid', true);
                        }
                    });
                }

                $el.find('form').find('.backendError, .ng-invalid').first().focus();
            }

            var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;

            if (prefilledAddress) {
                $scope.prefilled = true;
            }

            $scope.address = $scope.address || prefilledAddress || { country: country };

            var editFlow = function editFlow() {
                _logger.$logger.info('xo-billing_editFlow_check', {
                    'flow_type': _uiRouter.$stateParams.flow_type
                });
                if (_uiRouter.$stateParams.flow_type === 'edit') {
                    $scope.address = $scope.billingAddresses.addresses[0];
                }
            };

            (0, _squid.$populate)($scope, {
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                flowEligibility: _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                })
            }).then(function () {
                editFlow();
                $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                $scope.cancelFn = function () {
                    $scope.done();
                };

                $scope.done = function (target) {
                    var el = $('.tokenization #sidepageAddCard');

                    if (el) {
                        el.removeClass('slideLeft');
                    }
                    target = target || '^.addCard';
                    _uiRouter.$state.go(target);
                };

                $scope.onSubmit = function () {
                    $scope.updateAddress();
                };

                $scope.prefill = function () {
                    $scope.address.country = $scope.country;
                    $scope.prefillAddress = new _address.$PrefillAddressModel({
                        id: $scope.token,
                        address: $scope.address
                    });

                    return $scope.prefillAddress.save({
                        data: $scope.prefillAddress,
                        success: function success(result) {
                            $scope.address = result;
                            $scope.prefilled = true;
                            $scope.showAddressFields = true;

                            (0, _angular.$timeout)(function () {
                                var value = $scope.address && $scope.address.state;
                                var $option = $el.find('[value="' + value + '"]');

                                $option.prop('selected', 'selected');
                                $option.trigger('change');
                                value = $option.attr('label');
                            }, 500);
                        }
                    });
                };

                $scope.updateAddress = function () {
                    var newBilling = new _fi.$BillingAddressModel({
                        line1: $scope.address.line1,
                        line2: $scope.address.line2,
                        city: $scope.address.city,
                        state: $scope.address.state,
                        postal_code: $scope.address.postal_code,
                        normalization_status: $scope.address.normalization_status,
                        country: country,
                        id: '0'
                    });

                    return newBilling.save({
                        data: $scope.billingAddress,
                        success: function success() {
                            if ($scope.normalize) {
                                // set to false so that html related to billing address is hidden when child is shown
                                $scope.billing = false;
                                $scope.address.full_address = newBilling.full_address;
                                _uiRouter.$state.go('.addressNormalization');
                            } else {
                                $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
                            }
                        },
                        validation: function validation(res) {
                            return handleValidation(res);
                        }
                    });
                };

                $scope.uponNormalization = function (normalizedAddress, isBack) {
                    if (isBack) {
                        $scope.billing = true;
                        _uiRouter.$state.go('^');
                    } else {
                        $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
                    }
                };

                $scope.updateBillingAddressAndReturn = function (target, address) {
                    var newBillingAddress = void 0;

                    if (address && address instanceof _fi.$BillingAddressModel) {
                        newBillingAddress = address;
                    } else {
                        newBillingAddress = new _fi.$BillingAddressModel({
                            line1: address.line1,
                            line2: address.line2,
                            city: address.city,
                            state: address.state,
                            postal_code: address.postal_code,
                            normalization_status: address.normalization_status,
                            country: address.country || $scope.country,
                            full_address: address.full_address || $scope.address.full_address,
                            id: '0'
                        });
                    }

                    var addresses = $scope.billingAddresses && $scope.billingAddresses.addresses;

                    if (!isUserInputtedAddress(addresses[0])) {
                        addresses.unshift(newBillingAddress);
                    } else {
                        addresses[0] = newBillingAddress;
                    }
                    $scope.billingaddressupdated.value = true;
                    $scope.done(target);
                };

                // page transition after the page is loaded
                var el = $('.tokenization #sidepageAddCard');

                if (el) {
                    el.addClass('slideLeft');
                }
            });
        }]
    };
});

_angular.$timeout;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_address.$PrefillAddressModel;

_checkout.$FlowEligibilityModel;

_fi.$BillingAddressesModel;

_fi.$BillingAddressModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-normalization/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddBillingRoute', function () {
    return _squid.$ComponentRoute.extend('AddBillingRoute', {
        name: 'addBilling',
        directive: 'xo-add-billing',
        titleContent: 'addBillingAddress.title',
        query: ['flow_type'],
        trackingData: {
            fptiState: 'edit_billing'
        },
        loginRequired: true,
        children: [{
            name: '$AddressNormalizationRoute',
            attributes: {
                id: 'token',
                sidebar: 'sidebar',
                address: 'address',
                'done-fn': 'uponNormalization'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addbilling", "../node_modules/xo-wallet-components/src/add-card/addbilling/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addBillingAddress\" ng-if=\"billing\" modal-box=\"address\" modal-cancel=\"cancelFn()\">\n    <xo-aside-header heading='asideHeader.addBillingAddress' ng-if=\"debitCardFlow\"\n                     hidex=\"true\"\n                     header-left-link=\"done\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar && !debitCardFlow\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <a ng-hide=\"sidebar || debitCardFlow\" id=\"backButton\" ui-sref=\"^.addCard\" class=\"btn btn-secondary\" role=\"button\">{{ content('common.back') }}</a>\n                <input ng-if=\"country==='BR' && !prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"prefill()\" />\n                <input track-submit ng-if=\"country!=='BR' || prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _checkoutIncentive = __webpack_require__("../node_modules/xo-models/src/checkoutIncentive/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/address-box/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/three-ds/directive.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

var _factory = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCard', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            done: '=?',
            messagetitle: '=?',
            message: '=?',
            pagetitle: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            billingaddressupdated: '=?',
            cardmodel: '=?',
            parentCallbacks: '=?',
            selectedPromotionCardType: '=?',
            promotion: '=?',
            pageLevel: '=?',
            logout: '=?',
            phone: '=?',
            manageCardFlow: '=?',
            showBalanceFlow: '=?',
            showCancel: '=?',
            showSetPreferredFi: '=?',
            onSuccess: '=?',
            backUri: '=?',
            showIncentive: '=?',
            incentiveAmount: '=?',
            updateCardCpa: '=?',
            cause: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {

            $scope.isCPAEligible = $scope.cause === 'cpa';
            $scope.address_box = {
                changeFn: function changeFn(type) {
                    _logger.$logger.info('xo-address-box_changeFn - ' + type);
                    _uiRouter.$state.go('^.addBilling', {
                        flow_type: 'edit'
                    });
                }
            };

            // Ensure no incentive-related actions are taken unless
            // explicityly passed 'true' from the xo-add-card page
            // Also ensure there are no duplicate titles
            $scope.showIncentive = Boolean($scope.showIncentive);
            var isNoBalanceEligible = _factory2.$NoBalanceFactory.get().eligible;

            $scope.showPageTitle = Boolean($scope.pagetitle && !($scope.isNmjDesign2 || $scope.isNmjDesign3) && !isNoBalanceEligible);
            $scope.showMessageTitle = Boolean($scope.messagetitle);
            $scope.showMessageBanner = !$scope.sidebar && !$scope.showIncentive && !isNoBalanceEligible;
            $scope.showNoBalanceHeaderAndNoFiContingency = isNoBalanceEligible && _uiRouter.$stateParams.message === 'NEED_CREDIT_CARD';

            (0, _squid.$populate)($scope, {
                cart: _index2.$CheckoutCartModel.instance($scope.token),
                auth: _auth.$AuthModel.instance(),
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token).retrieve({
                    contingencies: {
                        NEED_CREDIT_CARD: angular.noop,
                        EXPIRED_CREDIT_CARD: angular.noop
                    }
                }),
                flowEligibility: _index2.$FlowEligibilityModel.instance($scope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                }),
                tokenizedWalletInfoModel: _index.$TokenizedWalletInfoModel.instance($scope.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token).retrieve()
            }).then(function () {
                if ($scope.auth) {
                    $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                        first_name: $scope.auth.first_name,
                        last_name: $scope.auth.last_name
                    }) || $scope.auth.email;
                }

                $scope.isIndiaAndBilling = _squid.$locale.country === 'IN' && $scope.cart.isBilling() && $scope.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN';

                var isCreditDisallowedForMerchant = $scope.checkoutSession && $scope.checkoutSession.isCreditDisallowedForMerchant;

                if (!$scope.sidebar && isCreditDisallowedForMerchant) {
                    $scope.pagetitle = _squid.$locale.content.get('addCard.addBankDebitCard');
                    $scope.showPageTitle = true;
                }

                $scope.headingTextKey = function () {
                    if ($scope.updateCardCpa) {
                        return 'addCard.updateCardCPA';
                    } else if (isCreditDisallowedForMerchant) {
                        return 'addCard.addBankDebitCard';
                    } else if ($scope.cart.isConsumerCountry('IN') && $scope.cart.isBilling()) {

                        if ($scope.cart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow()) {
                            return 'asideHeader.not.immediate.addCreditCard';
                        } else if ($scope.cart.isReferenceTransaction()) {

                            if ($scope.checkoutAppData.isMerchantCountry('IN')) {
                                if ($scope.cart.isChargePatternImmediateOrDeferred()) {
                                    return 'asideHeader.immediate.addCard';
                                } else {
                                    return 'asideHeader.not.immediate.addCreditCard';
                                }
                            } else {
                                return 'asideHeader.not.immediate.addCreditCard';
                            }
                        }
                    }

                    return 'asideHeader.addCard';
                };

                _newMember.$NewMemberEligibility.instance().getVariant($scope.token).then(function (variant) {
                    $scope.isNmj = !$scope.sidebar && variant && (variant === 'one_page' || variant === 'design_2' || variant === 'design_3');
                    $scope.isNmjDesign1 = !$scope.sidebar && variant && variant === 'one_page';
                    $scope.isNmjDesign2 = !$scope.sidebar && variant && variant === 'design_2';
                    $scope.isNmjDesign3 = !$scope.sidebar && variant && variant === 'design_3';

                    $scope.isGreyHeader = $scope.isNmjDesign2 || $scope.isNmjDesign3;

                    if ($scope.isGreyHeader && $scope.message && $scope.message.msgs[0] && $scope.message.msgs[0].key === 'creditcard.errorExpiredCard') {
                        $scope.message.msgs = null;
                        $scope.isExpiredCard = true;
                    }

                    if ($scope.isNmj) {
                        // Set Up AddBank Link
                        $scope.disallowedInstruments = $scope.checkoutSession.get('fundingOptions').get('disallowedInstruments');
                        var hasDisallowedBank = $scope.disallowedInstruments && $scope.disallowedInstruments.some(function (fi) {
                            return fi.type === 'BANK';
                        });

                        $scope.showAddBank = (0, _squid.$feature)('enableExternalAddBank') && (!hasDisallowedBank || !$scope.disallowedInstruments);
                        $scope.addBankUri = '/webapps/hermes/add-bank?token=' + $scope.token;
                        _logger.$logger.info('external_addbank_' + ($scope.showAddBank ? 'enabled' : 'disabled'));
                    }

                    if ($scope.isNmjDesign1) {

                        var contentKey = {
                            header: '',
                            body: ''
                        };

                        if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1) {
                            contentKey.header = 'addCard.assistHeaderHasDisallowedFi';
                            contentKey.body = 'addCard.assistBodySingleDisallowedFi';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1) {
                            contentKey.header = 'addCard.assistHeaderHasDisallowedFi';
                            contentKey.body = 'addCard.assistBodyMultiDisallowedFi';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_addcard_msg'
                            });
                        } else {
                            contentKey.header = 'addCard.assistHeader';
                            contentKey.body = 'addCard.assistBody';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_addcard_msg'
                            });
                        }

                        $scope.contentKey = contentKey;
                    }

                    if ($scope.isNmjDesign2 || $scope.isNmjDesign3) {
                        var headerMsg = void 0;
                        var userName = $scope.auth.first_name ? $scope.auth.first_name : $scope.auth.email;

                        if ($scope.isExpiredCard) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgExpiredCard', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_expired_card_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1 && $scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasDisallowedShowBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_show_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1 && !$scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasDisallowedHideBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_hide_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1 && $scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasMultiDisallowedShowBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_show_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1 && !$scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasMultiDisallowedHideBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_hide_addbank_link_addcard_msg'
                            });
                        } else if ($scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgNoFiShowAddBank', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_show_addbank_link_addcard_msg'
                            });
                        } else {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgNoFiHideAddBank', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_hide_addbank_link_addcard_msg'
                            });
                        }
                        $scope.headerMsg = headerMsg;
                    }
                });

                return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                    var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

                    if (multipleFiVariants.indexOf(variant) !== -1) {
                        $scope.showMultipleFI = true;
                    }
                });
            }).then(function () {

                var logObj = {
                    'from': 'ADD_CARD',
                    'to': 'prepare_ADD_CARD',
                    'context_id': $scope.token,
                    'contingency_type': _uiRouter.$stateParams.message ? 'system_intiated' : 'user_intiated'
                };

                if ($scope.cart.isWalletTokenization()) {
                    Object.assign(logObj, {
                        'context_type': 'BA-Token',
                        'ba_token': _squid.$meta.baToken
                    });
                }

                _logger.$logger.info('checkout_fpti', logObj);

                $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                if ($scope.showmeftsection) {
                    $scope.showmeftsection.toggle = true;
                }

                if ($scope.hideparenthead) {
                    $scope.hideparenthead.toggle = false;
                }

                $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();

                var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;

                if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
                    _uiRouter.$state.go('^.selectCard');
                }

                $scope.showplcc = type === 'plcc';
                $scope.country = _squid.$locale.country;

                $scope.showNotYou = $scope.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp';

                $scope.showHiMsg = Boolean($scope.messagetitle);

                $scope.cardmodel.cardType = 'creditCard';

                if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
                    $scope.cardmodel.cardType = 'privateLabel';
                    $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
                }

                $scope.cardmodel.user = {
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                };

                $scope.cardmodel.address = $scope.billingAddresses.addresses[0];

                if ($scope.billingaddressupdated.value) {
                    $scope.billingaddressupdated = {
                        msgs: [_squid.$locale.content.get('editCard.newAddressAdded')],
                        type: 'success',
                        value: true
                    };
                }

                $scope.showSidebarBackArrow = $scope.sidebar && !$scope.debitCardFlow && !$scope.checkoutSession.plccOffer && !$scope.cardmodel.card.isExisting();
                $scope.backUri = $scope.backUri || ($scope.showMultipleFI ? 'checkout.review' : 'checkout.review.sidebar.wallet');
                $scope.manageCardFlowBackUri = $scope.backUri || ($scope.showMultipeFI ? 'checkout.review.sidebar.sidebarManageWallet' : 'checkout.review.sidebar.wallet');
                _factory.$AddCardFactory.shouldDisplayAddressBox($scope.isNmjDesign1, $scope.cardmodel, false).then(function (result) {
                    $scope.displayAddressBox = result;
                });

                $scope.gotoBilling = function (address) {
                    if ($scope.pageLevel) {
                        $scope.pageLevel.message = null;
                    }
                    if (!address) {
                        if (_squid.$locale.country === 'BR') {
                            $scope.parentCallbacks.showCep();
                        } else {
                            // page transition
                            var el = $('.tokenization #sidepageAddCard');

                            if (el) {
                                el.addClass('slideLeft');
                            }
                            _uiRouter.$state.go('^.addBilling');
                        }
                    }
                };

                $scope.isUPOP = function () {
                    /*
                     * we do have a BIN lookup for C2 country to FIMS
                     * if that fails
                     *   a) buyer selects card type from dropdown and it could be CUP
                     *   b) and we are not going to get isUpop from FIMS , but C2 CUP is always upop card
                     * if that success
                     *   a) card can be of type VISA or CUP for dual cards
                     *   b) and we need to show dropdown for buyer to choose the card, eventhough we default to VISA
                     *   c) even though VISA selected , it is UPOP card
                     * if that success
                     *   a) card be of type CUP and AMEX for dual cards
                     *   b) we don't show dropdown but default to CUP
                     *   c) here both CUP and UPOP is true
                     *
                     * so checking either CUP or UPOP (for VISA)
                     * and yes only for OTP enabled country (C2 for now)
                     */
                    var needOTPForAddCard = (0, _squid.$feature)('needOTPForAddCard');
                    var isCUP = $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
                    var isUpop = $scope.cardmodel.card && $scope.cardmodel.card.isUpop;

                    return needOTPForAddCard && isCUP && isUpop;
                };

                $scope.isUpdateDebitCard = function () {
                    return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
                };

                $scope.flag = function (field) {
                    // pass country to decide card for a country
                    return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field, _squid.$locale.country);
                };

                $scope.buttonText = function () {
                    if ($scope.updateCardCpa) {
                        return 'creditcard.updateBtn';
                    }
                    if ($scope.debitCardFlow) {
                        return 'creditcard.saveBtn';
                    }

                    var contentString = 'creditcard.addBtn';

                    if ($scope.cardmodel.card.isExisting()) {
                        contentString = 'creditcard.updateBtn';
                    } else if ($scope.isUPOP()) {
                        contentString = 'creditcard.continuetext';
                    }
                    return contentString;
                };

                $scope.cardTypeChanged = function () {
                    $scope.phone.phoneType = $scope.flag('phoneType');
                };

                function addErrorMessage(contentKey) {
                    if (contentKey) {
                        contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
                        var message = _squid.$locale.content.get('creditcard.' + contentKey);

                        $scope.message.msgs.push(message);
                    }
                }

                function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
                    var errorData = void 0;

                    if (result.errorCodes) {
                        errorData = result;
                    } else {
                        errorData = {
                            errorCodes: result && [result['0']]
                        };
                    }
                    $scope.message = _util.$fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                }

                var handleFIContingency = function handleFIContingency(contingency, body) {
                    var contingencyName = body.contingencyName,
                        errorDetails = body.errorDetails;

                    var errorProperty = void 0;
                    var invalidModels = [];
                    var defaultError = 'INTERNAL_ERROR';

                    if ($scope.sidebar) {
                        $scope.$emit('SidebarError');
                    }

                    // for certain contingencies the error message is specific to the type of Checkout flow
                    switch (contingencyName) {
                        case 'CARD_BRAND_NOT_SUPPORTED':
                        case 'CARD_NOT_ALLOWED':
                        case 'CARD_NUMBER_WITH_BAD_BIN':
                        case 'CUP_CARD_NOT_ALLOWED':
                            var flowType = _squid.$config.checkoutFlowType;

                            errorProperty = contingencyName + '_' + flowType;
                            break;
                        case 'VALIDATION_ERROR':
                            defaultError = 'VALIDATION_ERROR_GENERIC';

                            // highlight the fields mentioned in the validation_error response as invalid
                            var _$fiErrorUtil$mapVali = _util.$fiErrorUtil.mapValidationErrorToModel(errorDetails.invalidFields);

                            errorProperty = _$fiErrorUtil$mapVali.errorProperty;
                            invalidModels = _$fiErrorUtil$mapVali.invalidModels;
                            _util.$fiErrorUtil.highlightInvalidFields(invalidModels, $element);
                            break;
                        default:
                            errorProperty = contingencyName;
                            break;
                    }

                    $scope.billingaddressupdated.value = false;
                    $scope.message = _util.$fiErrorUtil.addPageErrorByErrorName('addCardFIErrors', errorProperty, defaultError);

                    var fpti_payload = {
                        'from': 'ADD_CARD',
                        'to': 'process_ADD_CARD',
                        'context_id': $scope.token,
                        'int_error_code': errorProperty,
                        'int_error_description': errorDetails,
                        'error_source': 'filifecycleserv'
                    };

                    if ($scope.cart.isWalletTokenization()) {
                        Object.assign(fpti_payload, {
                            'context_type': 'BA-Token',
                            'ba_token': _squid.$meta.baToken
                        });
                    }

                    _logger.$logger.info('checkout_fpti', fpti_payload);

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }

                    if (errorDetails && errorDetails.invalidFields && errorDetails.invalidFields[0] === 'BILLING_ADDRESS') {
                        return _factory.$AddCardFactory.shouldDisplayAddressBox($scope.isNmjDesign1, $scope.cardmodel, true).then(function (result) {
                            $scope.displayAddressBox = result;
                        });
                    }
                };

                $scope.cancelFn = function () {
                    // Use callback provided by parent route if there
                    if ($scope.parentCallbacks.cancel) {
                        return $scope.parentCallbacks.cancel();
                    }

                    // For multiple FI variant, route back to review page
                    if ($scope.showMultipleFI) {
                        if ($scope.manageCardFlow) {
                            return _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
                        }
                        return _uiRouter.$state.go('checkout.review');
                    }

                    if ($scope.sidebar) {
                        if (!$scope.checkoutSession.plccOffer) {
                            return _uiRouter.$state.go('checkout.review.sidebar.wallet');
                        } else {
                            return _uiRouter.$state.go('^.selectCard');
                        }
                    }
                    $scope.done();
                };

                function initiateOTP() {
                    var resolveOTP = new _fi.$ResolveOTP({ id: $scope.cardmodel.id });

                    return resolveOTP.action('init', {
                        data: {
                            phone: {
                                country_code: $scope.phone.IntDialingCountryCode,
                                number: $scope.phone.telephone
                            }
                        },
                        resultModel: {},
                        success: function success() {
                            return _uiRouter.$state.go('.confirmUpop');
                        },
                        error: function error() {
                            return handleContingencies({}, 'confirmUpop', 'declineMessage');
                        },
                        contingencies: {
                            INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                                // prop for last 4 digits of card in error message
                                var prop = {
                                    number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
                                };

                                handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
                                _util.$fiErrorUtil.addFieldErrors(result, $element);
                            },
                            DEFAULT: function DEFAULT() {
                                return handleContingencies({}, 'confirmUpop', 'declineMessage');
                            }
                        }
                    });
                }

                function handleCheckoutSession(result, isNewCard) {
                    if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
                        delete $scope.checkoutSession.plccOffer;
                    }

                    delete $scope.checkoutSession.errorData;

                    var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
                    var numberAdded = void 0;
                    var cardTypeAdded = void 0;

                    if (cardAdded) {
                        numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
                        cardTypeAdded = cardAdded.type;
                    }

                    var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
                    var cvvData = $scope.checkoutSession && $scope.checkoutSession.cvvData;
                    var last4ToUse = void 0;
                    var cardTypeToUse = void 0;

                    if (cvvData) {
                        last4ToUse = cvvData.number;
                        cardTypeToUse = cvvData.type;
                    }

                    if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
                        $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));
                        $scope.checkoutSession.set('cvvData.lastAddedCard', true);
                    }

                    var updateCardSidebarMessage = (0, _squid.$renderContent)('wallet.cardUpdated', {
                        type: cardTypeAdded,
                        number: last4Added
                    });
                    var updateCardPageMessage = (0, _squid.$renderContent)('smallToolTip.cardUpdated');
                    var addCardMessage = (0, _squid.$renderContent)($scope.updateCardCpa ? 'addCard.updateCardCPASuccess' : 'smallToolTip.cardAdded');
                    var msgs = [addCardMessage];
                    var createdOffer = Boolean($scope.createOfferModel && $scope.createOfferModel.createdOffer());

                    if (createdOffer) {
                        var createdOfferMessage = (0, _squid.$renderContent)('smallToolTip.incentiveCreated', {
                            incentiveAmount: $scope.incentiveAmount
                        });

                        msgs = [createdOfferMessage];
                    } else if (!isNewCard) {
                        msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
                    }

                    $scope.checkoutSession.message = {
                        type: 'success',
                        msgs: msgs
                    };
                    // in case user saw No Balance banner and added card successfully - prevent showing the same banner on the review page
                    _factory2.$NoBalanceFactory.markAsAlreadyShown();
                    $scope.done();
                }

                var is3DSRequried = function is3DSRequried(result) {
                    return result && result.confirmation && result.confirmation.is3DSrequired || false;
                };

                var initiate3DS = function initiate3DS(data) {
                    var confirmation = data && data.confirmation && data.confirmation.three_ds_confirmation_details;

                    var supplement = confirmation.supplemental_data_details;

                    $scope.threeDSData = {
                        cardBin: supplement.bank_identification_number,
                        networkLogo: supplement.network_logo,
                        ddsUrl: supplement.device_data_collection_url,
                        jwtInfo: {
                            jwtIssuer: supplement.jwt_issuer,
                            jwtOrgUnitId: supplement.jwt_org_unit_id,
                            jwtDuration: supplement.jwt_duration
                        },
                        initiate3dsData: {
                            fundingId: $scope.cardmodel.id,
                            confirmationMethod: 'ONLINE_SECURE_AUTHENTICATION',
                            bypassConfirmationProcess: false,
                            referenceId: confirmation.reference_id,
                            cvv: $scope.cardmodel.get('card.security_code')
                        },
                        integrationType: 'ADD_CARD'
                    };
                    $scope.showThreedsPopup = true;
                };

                $scope.hideModal = function () {
                    $scope.oncomplete3ds('USER_CANCELED');
                };

                // call on submit and on resolving contingency 3ds
                // default threeDSStatus as false, this is required to pass the addCard 3DS resolution data to symphony,
                // symphony will then inform about the status to risk to avoid 3DS contingency again during planning
                var onCardSaveSuccess = function onCardSaveSuccess() {
                    var threeDSStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    var isNewCard = $scope.isNewCard;

                    if ($scope.cart.isWalletTokenization()) {
                        var fpti_payload = {
                            'from': 'ADD_DEBIT_CARD',
                            'to': 'process_ADD_debit_card',
                            'context_id': $scope.token,
                            'context_type': 'BA-Token',
                            'ba_token': _squid.$meta.baToken,
                            'fi_id': $scope.cardmodel.id
                        };
                        var handleNotifyChangeContingency = function handleNotifyChangeContingency(name) {
                            fpti_payload.int_error_desc = name + '_addedButCannotUse';
                            fpti_payload.error_source = 'paymentapiplatformserv';
                            fpti_payload.int_error_code = name;
                            _logger.$logger.info('tokenized_wallet', fpti_payload);
                            if ($scope.message) {
                                $scope.message.msgs = [];
                                $scope.message.type = 'info';
                            }
                            addErrorMessage('addedButCannotUse');
                        };

                        $scope.checkoutSession.fundingOptions.action('notifyChange', {
                            resultModel: $scope.checkoutSession,
                            data: {
                                planId: $scope.cardmodel.id,
                                operation: 'ADDED'
                            },
                            success: function success(result) {
                                _logger.$logger.info('tokenized_wallet', fpti_payload);
                                handleCheckoutSession(result, isNewCard);
                            },
                            contingencies: {
                                NOTIFY_CHANGE_FUNDING_CONTINGENCY: handleNotifyChangeContingency
                            }
                        });
                    } else {
                        var _fpti_payload = {
                            'from': 'ADD_CARD',
                            'to': 'process_ADD_CARD',
                            'context_id': $scope.token,
                            'context_type': _squid.$integration.isFlow('WPS') ? 'WPS-token' : 'EC-token',
                            'fi_id': $scope.cardmodel.id
                        };

                        _logger.$logger.info('checkout_fpti', _fpti_payload);

                        return _angular.$q.when().then(function () {
                            // setPreferredFI checkbox is checked
                            if ($scope.showSetPreferredFi && $('#makeFiPreferred').is(':checked')) {
                                _logger.$logger.info('set_preferredFI_checked');

                                // set preferred FI before updating
                                var preferredFi = new _fi.$PreferredFi({
                                    preferred: [$scope.cardmodel.id]
                                });

                                return preferredFi.save({
                                    success: function success() {
                                        _logger.$logger.info('SET_PREFERREDFI_SUCCESS', {
                                            preferred: [$scope.cardmodel.id]
                                        });
                                    },
                                    transientError: true,
                                    error: function error(err) {
                                        return _logger.$logger.error('SET_PREFERREDFI_ERROR', { error: err });
                                    }, // log the error but fails silently because card is added
                                    contingencies: {
                                        DEFAULT: function DEFAULT(name, contingency) {
                                            return _logger.$logger.info('SET_PREFERREDFI_CONTINGENCY', name);
                                        }
                                    }
                                });
                            }
                        }).then(function () {
                            return (0, _angular.$q)(function (resolve, reject) {
                                if ($scope.showIncentive) {
                                    var fptiData = {
                                        from: 'FI_addCardAccount',
                                        to: 'process_FI_addCardAccount_incentive',
                                        add_incentive: 0,
                                        context_id: $scope.token,
                                        add_incentive_reason: ''
                                    };

                                    (0, _squid.$populate)($scope, {
                                        evaluateCheckoutOfferEligibilityModel: _checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel.instance().retrieve(),
                                        getOfferProgramModel: _checkoutIncentive.$GetOfferProgramModel.instance().retrieve()
                                    }).then(function () {
                                        var createOfferData = {
                                            payer_id: $scope.auth.buyer_id,
                                            offer_program_id: $scope.evaluateCheckoutOfferEligibilityModel.getOfferProgramID(),
                                            value_issued: $scope.getOfferProgramModel.getOfferValueLowestDenom(),
                                            currency_code: $scope.evaluateCheckoutOfferEligibilityModel.getCurrencyCode()
                                        };

                                        $scope.createOfferModel = _checkoutIncentive.$CreateOfferModel.instance();

                                        return $scope.createOfferModel.save({
                                            data: createOfferData,
                                            success: function success() {
                                                if ($scope.createOfferModel.createdOffer()) {
                                                    fptiData.incentive_added = 1;
                                                    _logger.$logger.info('checkout_fpti', fptiData);
                                                    resolve('Incentive created');
                                                } else {
                                                    fptiData.add_incentive_reason = 'Offerserv_User_Not_Eligible';
                                                    _logger.$logger.info('checkout_fpti', fptiData);
                                                    resolve('Incentive not created');
                                                }
                                            },
                                            validation: function validation(_validation) {
                                                fptiData.add_incentive_reason = 'Validation_Error';
                                                _logger.$logger.info('checkout_fpti', fptiData);
                                                resolve('Validation error encountered creating incentive');
                                            },
                                            contingencies: {
                                                DEFAULT: function DEFAULT(msg, contingency) {
                                                    fptiData.add_incentive_reason = msg;
                                                    _logger.$logger.info('checkout_fpti', fptiData);
                                                    resolve('Contingency encountered creating incentive');
                                                }
                                            },
                                            error: function error() {
                                                fptiData.add_incentive_reason = 'Offerserv_Error';
                                                _logger.$logger.info('checkout_fpti', fptiData);
                                                resolve('Error encountered creating incentive');
                                            }
                                        });
                                    });
                                } else {
                                    resolve('Not eligible for incentive');
                                }
                            });
                        }).then(function () {
                            if ($scope.isUPOP()) {
                                initiateOTP();
                            } else {
                                return $scope.checkoutSession.fundingOptions.action('update', {
                                    resultModel: $scope.checkoutSession,
                                    data: {
                                        planId: $scope.cardmodel.id,
                                        threeDSResolved: threeDSStatus
                                    },
                                    success: function success(result) {
                                        return handleCheckoutSession(result, isNewCard);
                                    }
                                });
                            }
                        });
                    }
                };

                /**
                 threeDS.usercanceled=Confirmation canceled. Try again later or choose another way to pay.
                 threeDS.authentionFailed=Your Bank wasn’t able to confirm your {cardType}-{last4}. Try a different card or contact your card issuer.
                 threeDS.lookupFailed=Your card issuer wasn’t able to confirm your card. Try again later or choose another way to pay.
                 threeDS.systemError=Sorry, we weren’t able to add this card. Try a different card or contact your card issuer.
                 */
                $scope.oncomplete3ds = function (status) {
                    $scope.showThreedsPopup = false;
                    if (status === _constants.STATUS_SUCCESS) {
                        onCardSaveSuccess(true);
                    } else if (status === _constants.STATUS_API_ERROR || status === _constants.STATUS_DECLINE) {
                        var key = 'threeDS.memberDecline';
                        var card4 = $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4();
                        var cardType = $scope.cardmodel && $scope.cardmodel.card.type;

                        $scope.message = {
                            type: 'warning',
                            msgs: []
                        };

                        $scope.message.msgs.push((0, _squid.$renderContent)(key, {
                            cardType: cardType,
                            last4: card4
                        }));
                    }
                };

                $scope.onSubmit = function () {
                    if ($scope.pageLevel) {
                        $scope.pageLevel.message = null;
                    }
                    $scope.isNewCard = !$scope.cardmodel.card.isExisting();

                    if ($scope.isNewCard) {
                        delete $scope.cardmodel.id;
                    }

                    if ($('#plccAgree').is(':checked')) {
                        $scope.cardmodel.preference = true;
                    }

                    // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
                    if ($scope.isUPOP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {

                        initiateOTP();
                    } else {
                        $scope.cardmodel.save({
                            success: function success(result) {
                                if (is3DSRequried(result)) {
                                    initiate3DS(result);
                                } else {
                                    onCardSaveSuccess();
                                }
                            },
                            contingencies: {
                                DEFAULT: handleFIContingency
                            },
                            error: function error() {
                                return handleContingencies({}, 'creditcard', 'errorInternalError');
                            }
                        });
                    }
                };
            });
        }]
    };
});

_angular.$q;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$renderContent;

_squid.$util;

_squid.formatNameInformal;

_squid.$integration;

_auth.$AuthModel;

_choice.$ChoiceEligibility;

_newMember.$NewMemberEligibility;

_index.$TokenizedWalletInfoModel;

_fi.$BillingAddressesModel;

_fi.$PreferredFi;

_fi.$ResolveOTP;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutSessionModel;

_index2.$FlowEligibilityModel;

_checkoutIncentive.$CreateOfferModel;

_checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel;

_checkoutIncentive.$GetOfferProgramModel;

_util.$fiErrorUtil;

_cardMetaData.$CardMetaData;

_factory.$AddCardFactory;

_factory2.$NoBalanceFactory;

_constants.STATUS_SUCCESS;

_constants.STATUS_API_ERROR;

_constants.STATUS_DECLINE;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardFactory', function () {
    var shouldDisplayAddressBox = function shouldDisplayAddressBox(isNmjDesign1, cardModel, invalidfield) {
        var avsRetry = _squid.$util.param('avsRetry') || invalidfield;
        var redirectFromXoon = _squid.$util.param('redirectToHermes') ? '1' : '0';

        if (!cardModel || !cardModel.address) {
            return _squid.$promise.resolve(false);
        }
        if (isNmjDesign1) {
            return _squid.$promise.resolve(true);
        }
        if (avsRetry) {
            return (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': _squid.$locale.country, 'ctx.XOON_REDIRECT': redirectFromXoon, 'ctx.AVS': avsRetry }, 'xo_hermes_addcard_msg_xoon_redirect_avs_address_box', false, true).then(function (result) {
                return result && result.treatment_name;
            });
        }
        return _squid.$promise.resolve(false);
    };

    var getCheckoutIncentivePxpResult = function getCheckoutIncentivePxpResult() {
        return (0, _squid.$pxp)('xo_hermes_checkout_incentive', {}, '(xo_hermes_checkout_incentive_)(.*)', false, true).then(function (result) {
            return result && result.treatment_name;
        });
    };

    var getIssuerDeclineElmoResult = function getIssuerDeclineElmoResult() {
        return (0, _squid.$elmo)('xo_hermesnodeweb_issuer_decline', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermesnodeweb_issuer_decline_1').then(function (result) {
            return result && result.treatment_name;
        });
    };

    return {
        shouldDisplayAddressBox: shouldDisplayAddressBox,
        getCheckoutIncentivePxpResult: getCheckoutIncentivePxpResult,
        getIssuerDeclineElmoResult: getIssuerDeclineElmoResult
    };
});

_squid.$locale;

_squid.$promise;

_squid.$pxp;

_squid.$util;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addcard", "../node_modules/xo-wallet-components/src/add-card/addcard/factory.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _route = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

var _route2 = _interopRequireDefault(_route);

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardRoute', function () {
    return _squid.$ComponentRoute.extend('AddCardRoute', {
        name: 'addCard',
        directive: 'xo-add-card',
        titleContent: 'asideHeader.addCard',

        trackingData: {
            fptiState: 'add_or_update_cc'
        },
        loginRequired: true,
        children: [{
            route: _route2['default'],
            attributes: {
                token: 'token',
                phone: 'phone',
                cardmodel: 'cardmodel',
                'on-success': 'onSuccess',
                'show-incentive': 'showIncentive',
                'incentive-amount': 'incentiveAmount'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addcard", "../node_modules/xo-wallet-components/src/add-card/addcard/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/template.html":
/***/ (function(module, exports) {

module.exports = "\n<div content modal-box=\"!!sidebar\" modal-cancel=\"cancelFn()\" xo-tray-height class=wallet>\n    <xo-aside-header back-url=\"{{backUri}}\" heading=\"{{ headingTextKey() }}\" ng-if=\"showSidebarBackArrow\"></xo-aside-header>\n    <div class=\"header noButtons\" ng-if=\"manageCardFlow\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content('asideHeader.updateCard', {type: cardmodel.card.name, number: cardmodel.card.lastDigits}) }}</h1>\n        <a link-button ui-sref=\"{{manageCardFlowBackUri}}\" class=\"backArrow goTray\">\n            <span class=\"accessAid\">{{ content('common.back') }}</span>\n        </a>\n    </div>\n    <xo-aside-header back-url=\"^.selectCard\" heading='asideHeader.selectCard' ng-if=\"sidebar && checkoutSession.plccOffer\"></xo-aside-header>\n    <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showHiMsg\">\n        {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n            <span ng-if=\"showNotYou\">\n                <xo-not-you></xo-not-you>\n            </span>\n    </p>\n    <h1 class=\"gamma\" ng-if=\"messagetitle\">{{ messagetitle }}</h1>\n    <div class=\"reviews\" ng-if=\"isNmjDesign1\">\n        <xo-banner is-nmj=\"isNmjDesign1\" class=\"nmjDesign1Banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                <span ng-if=\"isNmjDesign1\">{{ content('memberReview.hiUser_welcome', {userName: formattedNameInformal}) }}</span>\n                <span ng-if=\"showNotYou\">\n                    <xo-not-you></xo-not-you>\n                </span>\n            </p>\n        </xo-banner>\n        <xo-assist-banner header=\"content(contentKey.header)\" body=\"content(contentKey.body)\">\n        </xo-assist-banner>\n    </div>\n    <div class=\"greyHeader\" ng-if=\"isNmjDesign2 || isNmjDesign3\">\n        <xo-banner is-nmj=\"isNmjDesign2 || isNmjDesign3\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                <span ng-if=\"isNmjDesign2 || isNmjDesign3\">{{ headerMsg }}</span>\n                <span ng-if=\"showNotYou\" class=\"greyHeaderNotYou\">\n                    <xo-not-you></xo-not-you>\n                </span>\n            </p>\n        </xo-banner>\n    </div>\n    <div ng-if=\"showAddBank && isNmjDesign1\" class=\"addBankLink BANK_ACCOUNT\">\n        <a track-link=\"add_bank\" href=\"{{addBankUri}}\" role=\"button\">\n            <span class=\"fsIcons\"></span>\n            <span class=\"name\">{{ content('addCard.addBank') }}</span>\n        </a>\n    </div>\n\n    <xo-message message=\"message\" isGreyHeader=\"isGreyHeader\" ng-if=\"showMessageBanner\"></xo-message>\n\n    <xo-decline-notification ng-if=\"isCPAEligible\" />\n    <h1 class=\"gamma\" ng-if=\"showPageTitle\">{{ pagetitle }}</h1>\n\n    <!-- For No balance experiment show Add Card header and No Fi contingency text message instead of the xo-message alert -->\n    <div ng-if=\"showNoBalanceHeaderAndNoFiContingency\">\n        <h1 class=\"alpha noBalanceAddCardHeader\">{{ content('asideHeader.selectCard') }}</h1>\n        <p class=\"noBalanceAddCardMsg\">{{ content('creditcard.noFIContingency') }}</p>\n    </div>\n\n    <div ng-class=\"{true: 'sidebar'}[asideContent]\" xo-tray-height>\n        <form id=\"creditCardForm\" name=\"creditCardForm\" class=\"addCard asideView asideContent\" content form-autofocus novalidate>\n            <div class=\"trayInner container\">\n                <p id=\"addCardDebitCardFlow\" ng-if=\"debitCardFlow && !isUpdateDebitCard() && !showBalanceFlow\">\n                    {{ content('addCard.commonAddTopupDebitCard', { type: tokenizedWalletInfoModel.brandName() }) }}\n                </p>\n                <p id=\"addCardDebitCardFlow\" ng-if=\"debitCardFlow && !isUpdateDebitCard() && showBalanceFlow\">\n                    {{ content('addCard.commonAddTopupDebitCardPPBalance', { type: tokenizedWalletInfoModel.brandName() }) }}\n                </p>\n                <xo-message message=\"message\" ng-if=\"sidebar\"></xo-message>\n                <xo-message id=\"billingAddressUpdatedMsg\" ng-if=\"billingaddressupdated.value\" message=\"billingaddressupdated\"></xo-message>\n                <xo-name-input user=\"cardmodel.user\" country=\"{{country}}\"></xo-name-input>\n\n                <xo-credit-card token=\"token\" card=\"cardmodel.card\" user=\"cardmodel.user\"\n                                selected-promotion-card-type=\"selectedPromotionCardType\"\n                                card-type-changed=\"cardTypeChanged\" promotion=\"promotion\"\n                                manage-card-flow=\"manageCardFlow\"></xo-credit-card>\n\n                <xo-address-box ng-if=\"displayAddressBox\"\n                                header=\"content('addCard.billingAddress')\"\n                                fullname=\"cardmodel.user\"\n                                addresses=\"billingAddresses\"\n                                change-fn=\"address_box.changeFn\">\n                </xo-address-box>\n\n                <div ng-if=\"!displayAddressBox && flag('fields.address')\" id=\"billingAddress\" class=\"dropdown billingAddress confidential\">\n                    <label for=\"billingAddressDropdown\" class=\"billingAddressLabel\">\n                        {{ content(\"addressBook.billingAddress\") }}\n                        <a href=\"\" link-button ng-click=\"gotoBilling()\" class=\"addNewBillingAddress\" data-test-id=\"addBillingLink\" aria-label=\"{{ content('addCard.addNewBillingAddress') }}\">{{ content(\"addressBook.add\") }}</a>\n                    </label>\n                    <div class=\"dropdown billingAddress nullable\">\n                        <select xo-dropdown default=\"{{content('addCard.addNewBillingAddress')}}\" ng-model=\"cardmodel.address\"\n                                ng-change=\"gotoBilling(cardmodel.address)\"\n                                ng-options=\"address.full_address for address in billingAddresses.addresses\"\n                                name=\"billingAddress\" id=\"billingAddressDropdown\" required>\n                        </select>\n                    </div>\n                </div>\n\n                <div ng-if=\"flag('fields.phone')\">\n                    <div class=\"otpVerification\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></div>\n                    <xo-phone-input token=\"token\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n                </div>\n\n                <div ng-if=\"showAddBank && (isNmjDesign2 || isNmjDesign3)\" class=\"addBankLink BANK_ACCOUNT\">\n                    <a track-link=\"add_bank\" href=\"{{addBankUri}}\" role=\"button\">\n                        <span class=\"fsIcons\"></span>\n                        <span class=\"name\">{{ content('addCard.linkBank') }}</span>\n                        <span class=\"linkBankArrow\"></span>\n                    </a>\n                </div>\n\n                <div ng-if=\"showplcc\">\n                    <div class=\"plccAgree checkbox\">\n                        <input type=\"checkbox\" checked=\"true\" name=\"plccAgree\" id=\"plccAgree\" />\n                        <label class=\"noBottom\" for=\"plccAgree\">{{content('addCard.plccPreferMethod', { merchant: promotion.name})}}</label>\n                    </div>\n                    <div class=\"legal\">{{content('addCard.plccLegal', { merchant: promotion.name})}}</div>\n                </div>\n\n                <div ng-if=\"showSetPreferredFi\">\n                    <div class=\"checkbox\">\n                        <input type=\"checkbox\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" />\n                        <label for=\"makeFiPreferred\">{{ content('addCard.makeFiPreferred') }}</label>\n                    </div>\n                    <div class=\"legal infoTxt\">{{content('addCard.makeFiPreferredLegal')}}\n                        <span id=\"setPreferredFiLearnMore\" bind-html-compile=\"htmlContent('addCard.learnMore')\"></span>\n                    </div>\n                </div>\n\n                <div class=\"buttons\">\n                    <input track-submit=\"{{cardmodel.card.isExisting() ? 'update_cc' : 'add_cc' }}\" type=\"submit\" value=\"{{ content(buttonText()) }}\" id=\"proceedButton\" data-test-id=\"addCardButton\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n                </div>\n\n                <div ng-if=\"showCancel && !(isNmjDesign2 || isNmjDesign3)\" class=\"linkButton\">\n                    <a link-button prevent-default href=\"#\" data-test-id=\"cancelButton\" ng-click=\"parentCallbacks.cancel()\">{{content('common.cancel')}}</a>\n                </div>\n            </div>\n        </form>\n    </div>\n    <!-- 3ds 2.0 -->\n    <xo-modal\n    ng-if=\"showThreedsPopup\"\n    show=\"showThreedsPopup\"\n    enable-mobile-interstitial=\"true\"\n    show-close-button=\"true\"\n    on-close=\"hideModal\"\n    override-default-container=\"true\">\n        <xo-three-ds\n            ng-if=\"showThreedsPopup\"\n            token=\"token\"\n            reference-id=\"threeDSData.initiate3dsData.referenceId\"\n            jwt-info=\"threeDSData.jwtInfo\"\n            card-bin=\"threeDSData.cardBin\"\n            network-logo=\"threeDSData.networkLogo\"\n            ddc-url=\"threeDSData.ddcUrl\"\n            init-threeds-data=\"threeDSData.initiate3dsData\"\n            on-complete=\"oncomplete3ds\"\n            integration-type=\"threeDSData.integrationType\"\n            show-threeds-popup=\"showThreedsPopup\">\n        </xo-three-ds>\n    </xo-modal>\n    <!-- 3ds 2.0 -->\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoCardExpiryDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
    tag: 'xo-card-expiry',
    template: _template2['default'],
    props: {
        expiryMonth: {
            type: 'var',
            required: false
        },
        expiryYear: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var format = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);
            var regexPattern = format === 'MMYY' ? /(0\d|1[0-2])\/(\d{2})/ : /(0\d|1[0-2])\/(\d{4})/;

            var init = function init() {
                if (_this.expiryMonth && _this.expiryYear) {
                    _this.expiryDate = format === 'MMYY' ? _this.expiryMonth + '/' + _this.expiryYear.substring(2, 4) : _this.expiryMonth + '/' + _this.expiryYear;
                }
            };

            init();
            this.$watch('[expiryMonth, expiryYear]', function (expiryInfo) {
                if (expiryInfo && expiryInfo[0] && expiryInfo[1]) {
                    _this.expiryMonth = expiryInfo[0];
                    _this.expiryYear = expiryInfo[1];
                    init();
                }
            });

            $('#expiry_value').mask(format === 'MMYY' ? '00/00' : '00/0000');

            this.validate = function (expiryDate) {
                if (!expiryDate) {
                    return false;
                }

                var regexMatch = regexPattern.exec(expiryDate);

                if (!regexMatch) {
                    return false;
                }

                var today = new Date();
                var currentYear = today.getFullYear();
                var expMonth = Number(regexMatch[1]);
                var expYear = Number(regexMatch[2]);

                if (format === 'MMYY') {
                    // convert year from YY to YYYY format e.g currentYear = 2017, expYear = 20,
                    // result should be (2020) = (2017 - 17 + 20)
                    expYear = currentYear - currentYear % 100 + expYear;
                }

                var expDate = new Date(expYear, expMonth - 1);

                if (expDate < today) {
                    return false;
                }

                _this.expiryYear = expYear.toString();

                // expiryMonth need to have leading 0 for single digit month
                _this.expiryMonth = expMonth < 10 ? '0' + expMonth : expMonth.toString();

                return true;
            };
        }
    }
});

angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardExpiry/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"expirationField inputField\" id=\"expirationField\" directionality content>\n    <label class=\"expires\" for=\"expiry_value\">{{ content('creditcard.expiresLabel') }}</label>\n    <div class=\"inputField\" directionality>\n        <input ng-model=\"expiryDate\"\n               name=\"expiry_value\"\n               id=\"expiry_value\"\n               data-test-id=\"ccExpiryInput\"\n               value=\"\"\n               maxlength=\"{{maxlength}}\"\n               autocapitalize=\"off\"\n               aria-describedby=\"expiryHelp\"\n               autocomplete=\"off\"\n               ui-validate=\"'validate($value)'\"\n               placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n               data-error-text=\"{{content('validation.validExpirationDate')}}\"\n               xo-error-tooltip\n               required />\n        <span id=\"expiryHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardIssueDate/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoCardIssueDateDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardIssueDate/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardIssueDateDirective = exports.$xoCardIssueDateDirective = _squid.$Component.extend('$xoCardIssueDateDirective', {
    tag: 'xo-card-issue-date',
    template: _template2['default'],
    props: {
        issueMonth: {
            type: 'var',
            required: false
        },
        issueYear: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.dateFormat = (0, _squid.$feature)('ccIssueDateDateFormat', 'MMYY', _squid.$locale.country);

            if (this.dateFormat === 'MMYY') {
                this.maxlength = 5;
                this.mask = '99/99';
            } else if (this.dateFormat === 'MMYYYY') {
                this.maxlength = 7;
                this.mask = '99/9999';
            }

            this.formatIssueDate = function (event) {
                var key = event.keyCode || event.charCode;
                var $el = $(event.target);
                var val = $el.val().replace(/[^0-9\/]/gi, '');
                var strokes = val.length;

                // Ignore delete keys
                if (key === 8 || key === 46) {
                    return;
                }

                // after two characters add a slash char
                if (strokes === 2) {
                    val += '/';
                }

                _this.issueDate = val;
                $el.mask(_this.mask);
            };

            var currentYear = new Date().getFullYear();
            var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
                return ('0' + num).substr(-2);
            });
            var validYears = _squid.$util.map(_squid.$util.range(currentYear - 10, currentYear + 1), function (y) {
                return y.toString();
            });

            this.validate = function (issueDate) {
                if (!issueDate) {
                    return;
                }

                var month = void 0,
                    year = void 0,
                    unformatted = void 0;
                var isValid = false;

                unformatted = issueDate.replace(/[^0-9]/gi, '');
                if (unformatted.length > 3) {
                    month = unformatted.substring(0, 2);
                    if (_this.dateFormat === 'MMYY') {
                        year = currentYear.toString().substring(0, 2) + unformatted.substring(2, 4);
                    } else if (_this.dateFormat === 'MMYYYY') {
                        year = unformatted.substring(2, 6);
                    }

                    isValid = validMonths.indexOf(month) > -1 && validYears.indexOf(year) > -1;

                    if (isValid) {
                        var date = new Date(year, parseInt(month, 10) - 1);
                        var today = new Date();

                        isValid = date < today;
                    }
                }

                _this.issueYear = year;
                _this.issueMonth = month;

                return isValid;
            };
        }
    }
});

angular.value("$xoCardIssueDateDirective", $xoCardIssueDateDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardIssueDate/template.html":
/***/ (function(module, exports) {

module.exports = "<div content directionality>\n    <input ng-model=\"issueDate\"\n           name=\"issue_date_value\"\n           id=\"issue_date_value\"\n           value=\"\"\n           maxlength=\"{{maxlength}}\"\n           autocapitalize=\"off\"\n           aria-describedby=\"issueHelp\"\n           autocomplete=\"off\"\n           ui-validate=\"'validate($value)'\"\n           ng-keyup=\"formatIssueDate($event)\"\n           placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n           data-error-text=\"{{content('validation.validIssueDate')}}\"\n           xo-error-tooltip\n           required />\n    <span id=\"issueHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CardMetaData = undefined;

var _LIBRARY_TO_TYPE_MAP;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _creditCardType = __webpack_require__("../node_modules/credit-card-type/dist/index.js");

var _creditCardType2 = _interopRequireDefault(_creditCardType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DEFAULT_TYPE = {
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12],
    lengths: [16],
    niceType: 'Unknown',
    patterns: [],
    type: 'DEFAULT'
};

// Add additional supported card types
// TODO: Provide patterns for these types
_creditCardType2['default'].addCard({
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
    niceType: 'Carte Bancaire',
    patterns: [],
    type: 'cb-nationale'
});

_creditCardType2['default'].addCard({
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12, 16],
    lengths: [19],
    niceType: 'Carte Aurore',
    patterns: [],
    type: 'cetelem'
});

_creditCardType2['default'].addCard({
    code: {
        name: '',
        size: 0
    },
    gaps: [4, 8, 12, 16],
    lengths: [17],
    niceType: 'Cofinoga ou Privilège',
    patterns: [],
    type: 'cofinoga'
});

_creditCardType2['default'].addCard({
    code: {
        name: '',
        size: 0
    },
    gaps: [4, 8],
    lengths: [8, 9],
    niceType: '4 étoiles',
    patterns: [],
    type: 'cofidis'
});

var LIBRARY_TO_TYPE_MAP = (_LIBRARY_TO_TYPE_MAP = {}, _LIBRARY_TO_TYPE_MAP[_creditCardType.types.AMERICAN_EXPRESS] = 'AMEX', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.DINERS_CLUB] = 'DINERSCLUB', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.DISCOVER] = 'DISCOVER', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.ELO] = 'ELO', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.HIPER] = 'HIPER', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.HIPERCARD] = 'HIPERCARD', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.JCB] = 'JCB', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.MASTERCARD] = 'MASTERCARD', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.MAESTRO] = 'MAESTRO', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.UNIONPAY] = 'CUP', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.VISA] = 'VISA', _LIBRARY_TO_TYPE_MAP['cb-nationale'] = 'CBNATIONALE', _LIBRARY_TO_TYPE_MAP.cetelem = 'CETELEM', _LIBRARY_TO_TYPE_MAP.cofidis = 'COFIDIS', _LIBRARY_TO_TYPE_MAP.cofinoga = 'COFINOGA', _LIBRARY_TO_TYPE_MAP);

// Invert LIBRARY_TO_TYPE_MAP to enable to opposite lookup in constant time
var TYPE_TO_LIBRARY_MAP = Object.entries(LIBRARY_TO_TYPE_MAP).reduce(function (inverted, pair) {
    inverted[pair[1]] = pair[0];
    return inverted;
}, {});

/**
 * Detect the card type of the passed partial or full card number.
 * Returns null (no match) if the detected card type is not in allowedTypes.
 * 
 * @param {Array} allowedTypes Array of allowed card types
 * @param {String} number Partial or full card number
 */
function detectCardType(allowedTypes, number) {
    var matches = (0, _creditCardType2['default'])(number);
    var metadata = _angular2['default'].isArray(matches) && matches[0];

    if (metadata) {
        var cardType = LIBRARY_TO_TYPE_MAP[metadata.type];

        if (allowedTypes.indexOf(cardType) > -1) {
            return cardType;
        }
    }

    return null;
}

/**
 * Determine the input fields to show for the passed cardType.
 * 
 * @param {String} cardType The card type (e.g. VISA, AMEX, or MASTERCARD)
 * @param {String} productType The card product type (e.g. 'DEBIT' or 'CREDIT')
 * @param {String} country The user's country code
 */
function getCardFields(cardType, productType, country) {
    var isDebit = ['DEBIT', 'DEBITCARD'].indexOf(productType) > -1;
    var isCupC2 = cardType === 'CUP' && country === 'C2';
    var isCupC2Debit = isCupC2 && isDebit;

    return {
        issue: cardType === 'SWITCH',
        expiry: ['PLCC', 'COFIDIS'].indexOf(cardType) === -1 && !isCupC2Debit,
        cvv: ['PLCC', 'COFIDIS', 'COFINOGA'].indexOf(cardType) === -1 && !isCupC2Debit,
        dob: ['CETELEM', 'COFIDIS', 'COFINOGA'].indexOf(cardType) > -1,
        phone: isCupC2,
        address: !(cardType === 'PLCC' || isCupC2)
    };
}

var $CardMetaData = exports.$CardMetaData = {
    /**
     * Get part of the card type metadata for a particular card.
     * 
     * This function is now essentially a shim between the old hardcoded
     * card metadata object and the credit-card-type library. Field lookups
     * could be more efficient, but this maintains the existing API.
     * 
     * @param {Object} card Card object
     * @param {String} field Requested field (e.g. 'luhn' or 'fields.cvv')
     * @param {String} country The user's country code
     */
    getMetaData: function getMetaData(card, field, country) {
        var tokens = field.split('.');
        var prop = tokens[0];
        var attr = tokens[1];

        if (prop === 'phoneType') {
            // This was always 'Mobile' in the old metadata object
            return 'Mobile';
        }

        // Some cards can run on two networks, e.g. Visa + UnionPay
        var cardType = card && card.type;
        var dualType = card && card.dualType;

        if (prop === 'luhn') {
            // Cofidis cards do not use the Luhn check
            return cardType !== 'COFIDIS';
        }

        if (prop === 'fields') {
            var cardFields = getCardFields(cardType, card.productType, country);

            // Return only the requested field
            return attr ? cardFields[attr] : cardFields;
        }

        // For dual-brand cards, the card number will conform to the cobranded
        // network's format instead of the UnionPay format
        var cardFormatType = dualType && dualType !== 'CUP' ? dualType : cardType;
        var mapped = TYPE_TO_LIBRARY_MAP[cardFormatType];
        var metadata = mapped ? (0, _creditCardType.getTypeInfo)(mapped) : DEFAULT_TYPE;

        if (prop === 'spaces') {
            return attr ? metadata.gaps[attr] : metadata.gaps;
        }

        if (prop === 'length') {
            var lengths = {
                cvv: metadata.code && metadata.code.size,
                min: Math.min.apply(null, metadata.lengths),
                max: Math.max.apply(null, metadata.lengths)
            };

            // Return only the requested field
            return attr ? lengths[attr] : lengths;
        }

        // Unknown field
        return null;
    },


    /**
     * Get the card type of the passed partial or full card number.
     * 
     * @param {Array} allowedTypes Array of allowed card types
     * @param {String} number Partial or full card number
     */
    getCardType: function getCardType(allowedTypes, number) {
        var cardType = {};

        if (_angular2['default'].isArray(allowedTypes) && number) {
            cardType.type = detectCardType(allowedTypes, number);
        }
        return cardType;
    }
};

_angular2['default'].value("$CardMetaData", $CardMetaData);

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardIssueDate/directive.js");

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/dob/directive.js");

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('scrollToTop', function () {
    return {
        link: function link(scope, element, attr) {
            $(element).on('focus', function () {
                if ($('#mxCardTitle').is(':visible')) {
                    $('#creditCardForm').scrollTop($(element).offset().top);
                }
            });
        }
    };
}).directive('xoCreditCard', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=?',
            card: '=?',
            user: '=?',
            selectedPromotionCardType: '=?',
            promotion: '=?',
            cardTypeChanged: '=?',
            cardNumberChanged: '=?',
            manageCardFlow: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.cardLengthValid = function (number) {
                if ($scope.card && $scope.card.isExisting()) {
                    return true;
                }

                number = (number || '').replace(/[^0-9]+/g, '');

                return number.length >= $scope.flag('length.min') && number.length <= $scope.flag('length.max');
            };

            // Use the Luhn algorithm to validate the check digit (i.e., last digit) of the card number
            $scope.cardLuhnValid = function (input) {
                if (!$scope.flag('luhn')) {
                    return true;
                }

                if ($scope.card && $scope.card.isExisting()) {
                    return true;
                }

                input = (input || '').replace(/[^0-9]+/g, '');

                var numdigits = input.length;
                var parity = numdigits % 2;
                var sum = 0;
                var i = 0;
                var digit = void 0;

                for (; i < numdigits; i++) {
                    digit = parseInt(input.charAt(i), 10);

                    if (i % 2 === parity) {
                        digit *= 2;
                    }

                    if (digit > 9) {
                        digit -= 9;
                    }

                    sum += digit;
                }

                // In non-production envs, JAWS will generate card numbers using a modified Luhn algorithm that increments the check digit by 1
                var isJawsCardLuhnValid = !_squid.$config.deploy.isLive() && sum % 10 === 1;

                return sum % 10 === 0 || isJawsCardLuhnValid;
            };

            $scope.cardProductValid = function () {
                return $scope.debitCardFlow ? $scope.card.productType === 'DEBIT' : true;
            };

            $scope.isPlcc = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type === 'plcc';

            $scope.flag = function (field) {
                if ($scope.isPlcc && !$scope.card.type) {
                    $scope.card.type = 'PLCC';
                }
                // passing country to differentiate CUP for C2 and ROW
                return _cardMetaData.$CardMetaData.getMetaData($scope.card, field, _squid.$locale.country);
            };

            $scope.maxLength = function () {
                if ($scope.card && $scope.card.isExisting()) {
                    return 30;
                }

                return $scope.flag('length.max') + $scope.flag('spaces.length');
            };

            (0, _squid.$populate)($scope, {
                flowEligibility: _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                })
            }).then(function () {
                $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                $scope.locale = _squid.$locale;
                $scope.country = $scope.locale.country;
                var cardTypeServiceCall = (0, _squid.$feature)('cardTypeServiceCallRequired', false, $scope.country);

                // For APay provisioning flow, we use service call once we have the minimum number of digits
                // for the card.
                $scope.tokenizedWalletCardTypeServiceCall = false;

                var isUnsupportedCard = void 0;
                var lastVerifiedBin = '';
                var lastRequestedBin = void 0; // bin requested to service to fetch card type and pending response.

                $scope.mxDebitCards = ['BANAMEX', 'BANCOARFACA', 'BBVA', 'BANORTE', 'HSBC', 'INBURSA', 'SANTANDER'];

                if ($scope.card && $scope.card.number) {
                    $scope.unformattedCardNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
                }

                $scope.showMXCardLogos = function () {
                    return _squid.$locale.country === 'MX';
                };

                (0, _squid.$populate)($scope, {
                    cardTypes: _fi.$CardTypesModel.instance($scope.token + ':' + _squid.$locale.country, {
                        token: $scope.token,
                        country: _squid.$locale.country
                    })
                }).then(function () {
                    var scanCardExperimentEligibility = function scanCardExperimentEligibility() {
                        if (!_index.$DeviceInfo.isSafariiOSBrowserView()) {
                            return _squid.$promise.resolve(false);
                        }
                        // Scan credit card feature is only available in iosVersion 8+
                        if (_index.$DeviceInfo.isSafariiOSBrowserView() && _index.$DeviceInfo.getiOSVersion()[0] < 8) {
                            return _squid.$promise.resolve(false);
                        }

                        return (0, _squid.$elmo)('xo_hermes_addcard_camera_icon_member', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermes_addcard_camera_icon_member_show');
                    };

                    scanCardExperimentEligibility().then(function (result) {
                        $scope.showScanCardExperiment = result || false;
                    });

                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
                    var forceDropDown = false;

                    $scope.supportedCardNamesCommaSeparated = $scope.cardTypes.supportedNames().join(', ');

                    $scope.$on('localeChange', function () {
                        $scope.cardTypes = _fi.$CardTypesModel.instance($scope.token + ':' + _squid.$locale.country, {
                            token: $scope.token,
                            country: _squid.$locale.country
                        });

                        $scope.cardTypes.retrieve().then(function () {
                            if ($scope.card.type && $scope.cardTypes.allowed.indexOf($scope.card.type) === -1) {
                                delete $scope.card.type;
                                forceDropDown = false;
                                $scope.changeCardNumber(true);
                            }
                        });

                        $scope.country = _squid.$locale.country;
                    });

                    $scope.cvvShown = function () {
                        if ($scope.card.type === 'CETELEM' && $scope.locale.country === 'FR') {
                            return false;
                        }

                        if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
                            return false;
                        }

                        if ($scope.isPlcc && $scope.card.type) {
                            return true;
                        }

                        return $scope.flag('fields.cvv');
                    };

                    $scope.expiryShown = function () {
                        if ($scope.isPlcc && $scope.card.type) {
                            return true;
                        }
                        if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
                            return false;
                        }

                        return $scope.flag('fields.expiry');
                    };

                    $scope.enableDropDown = function () {
                        // for VISA CUP dual card, force show dropdown for buyer to choose card type
                        return Boolean(['ES', 'FR', 'GB', 'IT'].indexOf($scope.locale.country) > -1) || forceDropDown || $scope.card && $scope.card.type === 'VISA' && $scope.card && $scope.card.dualType === 'CUP';
                    };

                    $scope.showDropDown = function () {
                        if ($scope.enableDropDown()) {
                            return true;
                        }

                        if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 4 && !(cardTypeServiceCall || $scope.tokenizedWalletCardTypeServiceCall) && !$scope.isPlcc) {
                            return true;
                        }

                        if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 7 && (cardTypeServiceCall || $scope.tokenizedWalletCardTypeServiceCall) && isUnsupportedCard) {
                            return true;
                        }

                        return false;
                    };

                    $scope.showAcceptedCardLogos = function () {
                        return !$scope.showDropDown() && (0, _squid.$feature)('showAcceptedCardLogos', false, $scope.country);
                    };

                    $scope.getCardTypeByNumber = function (types, number) {
                        if ($scope.isPlcc && number.length > 6 || !$scope.isPlcc) {
                            return _cardMetaData.$CardMetaData.getCardType(types, number);
                        }
                    };

                    function formatCardNumber(number) {
                        var spaces = $scope.flag('spaces');
                        var formatted = [];

                        for (var i = 0; i < number.length; i++) {
                            if (spaces.indexOf(i) > -1) {
                                formatted.push(' ');
                            }

                            formatted.push(number.charAt(i));
                        }

                        number = formatted.join('');
                        return number;
                    }

                    $scope.$watch('card.type', function () {
                        if ($scope.cardTypeChanged) {
                            $scope.cardTypeChanged();
                        }
                    });

                    /**
                     * Hit Callback(unformatted cc no) when user gets out of the cardNumber field.
                     */
                    $scope.ccOnBlur = function () {
                        if ($scope.cardNumberChanged) {
                            $scope.cardNumberChanged($scope.unformattedCardNumber);
                        }
                    };

                    // e.g for a dual brand = ['CUP' ,'VISA'], select VISA or CUP based
                    // on regex defined for card type. If not regex was defined, pick one
                    // of the allowed card type.
                    function selectCardTypeForDualBrands(result) {
                        var dualCardTypes = (0, _squid.$feature)('dualCardTypes', {});
                        var match = void 0;

                        Object.keys(dualCardTypes).some(function (key) {
                            // eslint-disable-next-line array-callback-return
                            return result.some(function (cardType) {
                                if (cardType.type === key) {
                                    match = key;
                                    return true;
                                }
                            });
                        });

                        if (match) {
                            var regex = new RegExp(dualCardTypes[match]);
                            var selected = _squid.$util.find(result, function (cardType) {
                                if (regex.test(cardType.type)) {
                                    return true;
                                }
                            });

                            // if selected card based on regexp is CUP
                            // then we can test for AMEX as subtype (a dualType card)
                            if (selected && selected.type === 'CUP') {
                                _squid.$util.some(result, function (cardType) {
                                    if (/^AMEX$/.test(cardType.type)) {
                                        selected.dualType = cardType.type;
                                        return true;
                                    }
                                });
                            }

                            // if selected card based on regexp is VISA
                            // then we can test for CUP as subtype (a dualType card)
                            if (selected && selected.type === 'VISA') {
                                _squid.$util.some(result, function (cardType) {
                                    if (/^CUP$/.test(cardType.type)) {
                                        selected.dualType = cardType.type;
                                        return true;
                                    }
                                });
                            }

                            return selected;
                        } else {
                            return _squid.$util.find(result, function (cardType) {
                                return $scope.cardTypes.allowed.indexOf(cardType.type) > -1;
                            });
                        }
                    }

                    function selectCardType(result) {
                        if (angular.isArray(result)) {
                            if (result.length >= 2) {
                                result = selectCardTypeForDualBrands(result);
                            } else {
                                result = result[0];
                            }
                        }

                        return result || {};
                    }

                    function clearCardType() {
                        $scope.card.type = '';
                        $scope.card.dualType = '';
                        $scope.card.productType = '';
                    }

                    function getCardTypeByNumberServiceCall(number) {
                        if (number.length >= 6) {
                            var bin = number;

                            // Don't limit to 6 digits for APay flow as some cards require more than 6 digit
                            // BIN to detect if it is a debit card.
                            if (!$scope.debitCardFlow) {
                                bin = bin.slice(0, 6);
                            }

                            if (lastVerifiedBin) {
                                if (lastVerifiedBin.bin === bin) {
                                    $scope.card.type = lastVerifiedBin.type;
                                    $scope.card.dualType = lastVerifiedBin.dualType;
                                    $scope.card.productType = lastVerifiedBin.productType;
                                    return;
                                }
                                // For APay flow, if product type has been identified,
                                // we don't need to make another call
                                else if ($scope.debitCardFlow && bin.startsWith(lastVerifiedBin.bin) && lastVerifiedBin.productType) {
                                        $scope.card.type = lastVerifiedBin.type;
                                        $scope.card.dualType = lastVerifiedBin.dualType;
                                        $scope.card.productType = lastVerifiedBin.productType;
                                        return;
                                    }
                            }

                            // For APay, if there is a pending request, then do nothing.
                            if (isUnsupportedCard === bin || bin === lastRequestedBin || $scope.debitCardFlow && lastRequestedBin) {
                                return;
                            }

                            lastRequestedBin = bin;

                            _fi.$CardTypeFromBinModel.instance().save({
                                data: {
                                    user_country: $scope.country,
                                    bin: bin
                                },
                                silent: true,
                                success: function success(result) {
                                    result = selectCardType(result);
                                    var type = result.type;

                                    lastRequestedBin = undefined;

                                    var disallowedCard = false;

                                    if ($scope.cardTypes.allowed.indexOf(type) === -1) {
                                        disallowedCard = true;
                                    }

                                    // if we get upop in the response from BIN lookup
                                    // set into the cardModel to trigger OTP
                                    // this should not only be set if dropdown is not shown
                                    $scope.card.isUpop = result.isUpop;

                                    if (disallowedCard) {
                                        clearCardType();
                                        isUnsupportedCard = bin;
                                        $scope.allowedCardsTooltip = true;
                                        return;
                                    }

                                    isUnsupportedCard = undefined;
                                    forceDropDown = false;
                                    if (!$scope.showDropDown()) {
                                        $scope.card.type = type;
                                        $scope.card.dualType = result.dualType;
                                        $scope.card.productType = result.productType;
                                    }

                                    lastVerifiedBin = {
                                        bin: bin,
                                        type: type,
                                        dualType: result.dualType,
                                        productType: result.productType
                                    };

                                    // This logic is to handle copy paste case when all numbers are entered at once
                                    if ($scope.card.type && number.length >= $scope.flag('length.min')) {
                                        if (/android/i.test(navigator.userAgent)) {
                                            return;
                                        }

                                        var ccNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());

                                        if (ccNumber.indexOf(number) >= 0) {
                                            $scope.card.number = formatCardNumber(ccNumber);
                                        }
                                    }

                                    return;
                                },
                                contingencies: {
                                    GET_FI_ISSUER_DETAILS_ERR: function GET_FI_ISSUER_DETAILS_ERR(name, result) {
                                        clearCardType();
                                        isUnsupportedCard = bin;
                                        lastRequestedBin = undefined;
                                    }
                                },
                                error: function error() {
                                    clearCardType();
                                    isUnsupportedCard = bin;
                                    lastRequestedBin = undefined;
                                }
                            });
                        } else {
                            isUnsupportedCard = undefined;
                            lastRequestedBin = undefined;
                            forceDropDown = false;
                            clearCardType();
                        }
                    }

                    $scope.getAllowedCardTypeByNumber = function (number) {
                        return $scope.getCardTypeByNumber($scope.cardTypes.allowed, number);
                    };

                    $scope.getDisallowedCardTypeByNumber = function (number) {
                        return $scope.getCardTypeByNumber($scope.cardTypes.disallowed, number);
                    };

                    $scope.enableAddMode = function () {
                        if ($scope.card.isExisting()) {
                            $scope.card.number = '';
                        }
                    };

                    $scope.changeType = function () {
                        forceDropDown = true;

                        $scope.changeCardNumber(true);

                        // Blank out unsupported fields

                        if (!$scope.flag('fields.expiry')) {
                            delete $scope.card.expiry_month;
                            delete $scope.card.expiry_year;
                        }

                        if (!$scope.flag('fields.issue')) {
                            delete $scope.card.start_month;
                            delete $scope.card.start_year;
                            delete $scope.card.issue_number;
                        }

                        if (!$scope.flag('fields.dob')) {
                            delete $scope.card.dob_day;
                            delete $scope.card.dob_month;
                            delete $scope.card.dob_year;
                        }

                        if (!$scope.flag('fields.cvv')) {
                            delete $scope.card.security_code;
                        }
                    };

                    $scope.changeCardNumber = function (isCardTypeChanged) {
                        // If buyer tries to modify an update card number. We remove the whole string
                        // so buyer can add a card instead.
                        $scope.enableAddMode();
                        $scope.allowedCardsTooltip = false;
                        var regex = /[０-９]/;

                        if ((0, _squid.$feature)('disableFullWidthCharacters') && regex.test($scope.card.number)) {
                            _logger.$logger.info('checkout_fpti', {
                                'is_fullwidth_character': true
                            });
                        }

                        var number = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
                        var formattedNumber = void 0;

                        $scope.unformattedCardNumber = number;

                        // Attempt to determine the card type
                        var cardType = void 0;

                        if ($scope.debitCardFlow) {
                            if (number.length >= $scope.flag('length.min')) {
                                $scope.tokenizedWalletCardTypeServiceCall = true;
                            } else {
                                $scope.tokenizedWalletCardTypeServiceCall = false;
                                lastVerifiedBin = '';
                            }
                        }

                        if (cardTypeServiceCall || $scope.tokenizedWalletCardTypeServiceCall) {
                            if (!isCardTypeChanged) {
                                getCardTypeByNumberServiceCall(number);
                            }

                            if (isUnsupportedCard) {
                                $scope.allowedCardsTooltip = true;
                            }
                        } else {
                            if (!isCardTypeChanged) {
                                // Hide dropdown and trigger bin matching when the cc number is < 4 digits
                                if (number.length < 4) {
                                    forceDropDown = false;
                                }

                                if (!$scope.enableDropDown()) {
                                    cardType = $scope.getAllowedCardTypeByNumber(number);
                                    $scope.card.type = cardType.type;
                                    $scope.card.subType = cardType.subType;
                                }
                            }

                            if ($scope.isPlcc && $scope.card.type) {
                                $scope.cvvShown();
                                $scope.expiryShown();
                            }

                            if (!$scope.card.type && !$scope.isPlcc && (number.length >= 4 || $scope.getDisallowedCardTypeByNumber(number).type)) {
                                $scope.allowedCardsTooltip = true;
                            }
                        }

                        /*
                        * PPPLMER-1563 commented out to fix this bug
                        if (/android/i.test(navigator.userAgent)) {
                            return;
                        }
                        */
                        // Format the card number
                        formattedNumber = formatCardNumber(number);

                        // If the card is already formatted correctly, we can leave the user to continue in peace.
                        if ($scope.card.number === formattedNumber) {
                            return;
                        }

                        // Wait for the user's input to be reflected on the page (necessary for safari 5 otherwise selectionStart is incorrect)
                        (0, _angular.$timeout)(function () {
                            // re-formatting the number, since the card type may not have resolved before the first call
                            $scope.card.number = formatCardNumber(number);
                            // Save the current cursor positions
                            var ccField = document.getElementById('cc');

                            if (!ccField) {
                                return;
                            }

                            var inputLength = ccField.value.length;
                            var cursorStart = ccField.selectionStart;

                            // Wait for the formatted card to be reflected on the page
                            (0, _angular.$timeout)(function () {
                                // If the cursor was at the end of the input field, keep it at the end
                                if (cursorStart === inputLength) {
                                    ccField.selectionStart = ccField.selectionEnd = ccField.value.length;
                                    // Otherwise place the cursor to the position it was in before we replaced with the formatted number
                                } else {
                                    ccField.selectionStart = ccField.selectionEnd = cursorStart;
                                }
                            });
                        });
                    };
                });
            });
        }]
    };
});

_angular.$timeout;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$util;

_logger.$logger;

_checkout.$FlowEligibilityModel;

_fi.$CardTypeFromBinModel;

_fi.$CardTypesModel;

_cardMetaData.$CardMetaData;

_index.$DeviceInfo;

_squid.$promise;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/creditcard-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"creditCardInput\" content>\n    <!-- These two hidden fields are added to avoid autofill issue by chome for password and login field -->\n    <input style=\"display:none\">\n    <input type=\"password\" style=\"display:none\">\n\n    <div class=\"cardIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showAcceptedCardLogos()\">\n        <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed track by $index\">\n            <div class=\"cardIcon {{cardType}}\"></div>\n        </div>\n        <div ng-if=\"showScanCardExperiment\" class=\"icons\"><div class=\"secureIcon lockIcon\"></div></div>\n    </div>\n\n    <div class=\"debitAndCreditIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showMXCardLogos()\">\n        <p id=\"mxCardTitle\" class=\"cardIconTitle\">{{content('creditcard.cardIconTitle')}} </p>\n        <div class=\"cardIconsSection\">\n            <div class=\"mxCardIconGroup\">\n                <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed track by $index\">\n                    <div class=\"cardIcon {{cardType}}\"></div>\n                </div>\n            </div>\n            <div ng-if=\"showScanCardExperiment\" class=\"icons\"><div class=\"secureIcon lockIcon\"></div></div>\n            <br>\n            <div class=\"icons\" ng-repeat=\"cardType in mxDebitCards track by $index\">\n                <div class=\"debitcardIcon {{cardType}}\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isPlcc\" class=\"plccCardNumberTitle\" >{{content('addCard.plccAddCard', { merchant: promotion.name})}}</div>\n\n    <div class=\"dropdown cardType confidential nullable\" ng-if=\"!manageCardFlow && showDropDown()\">\n        <label for=\"cardType\" id=\"cardTypeLabel\" class=\"accessAid\">{{ content('creditcard.typeLabel') }}</label>\n        <select xo-dropdown name=\"cardType\" ng-model=\"card.type\" ng-change=\"changeType()\" ng-required=\"true\"\n                ng-options=\"cardType as content('cardTypes.' + cardType) for cardType in cardTypes.allowed track by cardType\"\n                id=\"cardType\" aria-labelledby=\"cardTypeLabel\" data-show-card-type=\"false\">\n            <option value=\"\" selected>{{ content('creditcard.typeLabel') }}</option>\n        </select>\n    </div>\n\n    <div ng-if=\"!manageCardFlow\" class=\"inputField confidential cardNumber creditCardField\" directionality>\n        <label for=\"cc\" class=\"focus accessAid\">\n            {{ showScanCardExperiment ? content('creditcard.scanCardNumber') : content('creditcard.cardNumber') }}\n        </label>\n\n        <input type=\"tel\" ui-validate=\"{luhn: 'cardLuhnValid($value)', len: 'cardLengthValid($value)', prodType: 'cardProductValid($value)'}\"\n                ui-validate-watch=\"'card.type'\"\n                ng-model=\"card.number\" name=\"cardNumber\" id=\"cc\" data-test-id=\"ccNumberInput\" value=\"\" ng-change=\"changeCardNumber(false)\"\n                ng-blur=\"ccOnBlur()\"\n                maxlength=\"{{maxLength()}}\" data-number=\"{{unformattedCardNumber}}\"\n                autocapitalize=\"off\" data-country=\"{{ locale.country }}\" autocomplete=\"off\"\n                placeholder=\"{{ showScanCardExperiment ? content('creditcard.scanCardNumber') : content('creditcard.cardNumber') }}\"\n                ng-pattern=\"/.*/\"\n                pattern=\"[0-9]*\"\n                scroll-to-top\n                data-error-text=\"{{content(debitCardFlow ? 'validation.validDebitCard' : 'validation.validCreditCard')}}\" xo-error-tooltip />\n\n        <xo-tooltip trigger=\"#cc\" ng-if=\"allowedCardsTooltip\" show-event=\"keyup\">\n            <div class=\"tip tipDesc tipCreditCard\">\n                {{ !debitCardFlow ? content('creditcard.acceptableCards') : content('creditcard.acceptDebitCardOnly') }}\n                <span class=\"acceptedCards\" ng-if=\"!debitCardFlow\">\n                    {{supportedCardNamesCommaSeparated}}\n                </span>\n            </div>\n        </xo-tooltip>\n\n        <span ng-if=\"card.type\" class=\"creditCard {{card.type}} {{card.subType}}\" aria-label=\"{{card.type}}\" id=\"creditCard\" role=\"img\">{{card.type}}</span>\n    </div>\n\n    <!-- Issue no and start date for maestro cards -->\n    <div id=\"cardIssueInfo\" data-cardspecific=\"true\" class=\"fieldGroup clearfix\" ng-if=\"flag('fields.issue')\">\n        <div>\n            <div class=\"startDate inputField invisiField half confidential\">\n                <label class=\"starts nolap\" for=\"startmonth\">{{ content('creditcard.startDate') }}</label>\n                <xo-card-issue-date issue-month=\"card.start_month\" issue-year=\"card.start_year\"></xo-card-issue-date>\n            </div>\n\n            <div class=\"issueNo inputField half last-child confidential last-child\">\n                <input id=\"issueNo\" name=\"issueNo\" placeholder=\"{{content('creditcard.issueNoLabel')}}\" type=\"text\" ng-model=\"card.issue_number\" autocapitalize=\"off\" autocomplete=\"off\" maxlength=\"2\" ng-pattern=\"/^[0-9]+$/\" pattern=\"[0-9]*\"/>\n\n                <xo-tooltip trigger=\"#issueNo\">\n                    <div class=\"tip tipDesc tipIssueNo\">\n                        {{ content('creditcard.issueNoLabelToolTip') }}\n                    </div>\n                </xo-tooltip>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"expiryShown() || cvvShown()\">\n        <xo-card-expiry ng-if=\"expiryShown()\" expiry-month=\"card.expiry_month\" expiry-year=\"card.expiry_year\"></xo-card-expiry>\n        <xo-cvv ng-if=\"cvvShown()\" card=\"card\" show-label=\"true\"></xo-cvv>\n    </div>\n\n    <!-- DOB fields for Country specific cards -->\n    <xo-dob-card-input ng-if=\"flag('fields.dob')\" user=\"user\"></xo-dob-card-input>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoCvvDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
    tag: 'xo-cvv',
    template: _template2['default'],

    props: {
        card: {
            type: 'var',
            required: false
        },
        showLabel: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            // A boolean message to update the masking property of cvv when the pre-filling happens
            this.$on('maskCVV', function ($event, isMasked) {
                _this.maskCVV = isMasked;
            });
            this.onCVVClick = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'REVIEW',
                    to: 'process_cvv_clicked',
                    message: 'CVV Field Clicked'
                });
                _logger.$logger.flush();
            };
            this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
            this.cvvLength = function () {
                // passing country to differentiate CUP for C2 and ROW
                return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv', _squid.$locale.country);
            };
            this.cvvRequired = function () {
                return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
            };
            this.onCVVChange = function ($event) {
                /**
                 * Focus the call to action (CTA) button.
                 * Useful when it is getting hidden/overlapped in the smaller devices. 
                 */

                var cvvLength = _this.cvvLength();
                var security_code = _this.props.card.security_code;


                if (security_code && security_code.length === cvvLength) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'REVIEW',
                        to: 'process_cvv_changed',
                        message: 'Focus the continue button on valid CVV field'
                    });
                    // Focus the CTA button.
                    $('form #confirmButtonTop').focus();
                }
            };
        }
    }
});

angular.value("$xoCvvDirective", $xoCvvDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_logger.$logger;

_cardMetaData.$CardMetaData;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"inputField cvvField\" id=\"cvvField\" directionality>\n    <label ng-if=\"showLabel\" class=\"cvv nolap\" for=\"cvv\">{{ content('creditcard.cscLabel') }}</label>\n\n    <div class=\"cvvSecurityCode inputField\" directionality>\n        <input type=\"{{maskCVV ? 'password' : 'tel'}}\" id=\"cvv\" data-test-id=\"ccCvvInput\" name=\"cvv\" ng-model=\"card.security_code\"\n               aria-describedby=\"securityCodeHelp\"\n               ng-keyup=\"onCVVChange($event)\"\n               ng-click=\"onCVVClick()\"\n               ng-pattern=\"/^[0-9]{1,4}$/\" ng-minlength=\"cvvLength()\" maxlength=\"{{cvvLength()}}\"\n               placeholder=\"{{cvvLength() === 3 ? content('creditcard.threeDigits') : content('creditcard.fourDigits')}}\"\n               ng-required=\"cvvRequired()\" ng-class=\"{'four': cvvLength() === 4}\" autocomplete=\"off\"\n               data-error-text=\"{{content('validation.validCSC')}}\" xo-error-tooltip />\n\n        <span id=\"securityCode\" class=\"creditCard\" role=\"img\" ng-class=\"{'four': cvvLength() === 4}\"\n              aria-label=\"{{cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')}}\">\n        </span>\n        <span id=\"securityCodeHelp\" class=\"accessAid\" ng-bind=\"cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCardFlow', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            parentCallbacks: '=?',
            messagetitle: '=?',
            message: '=?',
            pagetitle: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            promotion: '=?',
            pageLevel: '=?',
            logout: '=?',
            phone: '=?',
            fundingid: '=?',
            showBalanceFlow: '=?',
            showCancel: '=?',
            showSetPreferredFi: '=?',
            onSuccess: '=?',
            backUri: '=?',
            showIncentive: '=?',
            incentiveAmount: '=?',
            cardmodel: '=?',
            updateCardCpa: '=?',
            cause: '=?'
        },

        controller: ['$scope', function ($scope) {

            $scope.addCCDone = function () {
                $scope.parentCallbacks.finish();
            };

            $scope.callbacks = {
                done: $scope.parentCallbacks.finish,
                cancel: $scope.parentCallbacks.cancel,
                showCep: function showCep() {
                    $scope.prefillAddress = new _index.$PrefillAddressModel({
                        id: $scope.token
                    });

                    _uiRouter.$state.go('^.addCep');
                },

                cardTypeSelected: function cardTypeSelected(type) {
                    $scope.selectedPromotionCardType = {
                        type: type
                    };
                    _uiRouter.$state.go('^.addCard');
                }
            };

            $scope.cepDone = function () {
                _uiRouter.$state.go('^.addBilling');
            };

            $scope.selectedPromotionCardType = {
                type: $scope.promotion && $scope.promotion.type
            };

            if ($scope.promotion) {
                $scope.promotion.type = null;
            }

            $scope.billingaddressupdated = {
                value: false
            };

            $scope.phone = {
                hide_type: true
            };

            if (!$scope.cardmodel) {
                $scope.cardmodel = new _index3.$AddCardModel({
                    card: new _index3.$CardModel()
                });
            }

            (0, _squid.$populate)($scope, {
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token).retrieve({
                    contingencies: {
                        NEED_CREDIT_CARD: angular.noop,
                        EXPIRED_CREDIT_CARD: angular.noop
                    }
                })
            }).then(function () {

                if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
                    var card = $scope.checkoutSession.errorData.resolution.data;

                    if (card.fundingId && card.fi && card.fi.type) {
                        $scope.cardmodel.id = card.fundingId;
                        $scope.cardmodel.card = new _index3.$CardModel({
                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                            type: card.fi.type.toUpperCase(),
                            productType: card.fi.productType
                        });
                    }
                }
                if ($scope.fundingid) {
                    var fundingSource = _squid.$util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
                        if (funding && funding.id === $scope.fundingid) {
                            return funding;
                        }
                    });

                    if (!fundingSource) {
                        fundingSource = _squid.$util.find($scope.checkoutSession.fundingOptions.disallowedInstruments, function (funding) {
                            if (funding && funding.id === $scope.fundingid) {
                                return funding;
                            }
                        });
                    }

                    if (fundingSource) {
                        $scope.cardmodel.id = fundingSource.id;
                        $scope.cardmodel.card = new _index3.$CardModel({
                            number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
                            lastDigits: fundingSource.lastDigits,
                            type: fundingSource.name.toUpperCase(),
                            name: (0, _squid.$renderContent)('fsMappings.' + fundingSource.name)
                        });
                    }
                }
            });
        }]
    };
});

_squid.$populate;

_squid.$renderContent;

_squid.$util;

_uiRouter.$state;

_index.$PrefillAddressModel;

_index2.$CheckoutSessionModel;

_index3.$AddCardModel;

_index3.$CardModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/dob/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/dob/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoDobCardInputDirective', {
    tag: 'xo-dob-card-input',
    template: _template2['default'],

    props: {
        user: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            function pad() {
                var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

                return function (num) {
                    return (new Array(length + 1).join('0') + num).substr(-length);
                };
            }

            var year = new Date().getFullYear();

            this.days = _squid.$util.map(_squid.$util.range(1, 32), pad());
            this.months = _squid.$util.map(_squid.$util.range(1, 13), pad());
            this.years = _squid.$util.map(_squid.$util.range(year - 100, year), pad(4)).reverse();
        }
    }
});


_squid.$Component;

_squid.$util;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/dob/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\">\n    <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n    <div class=\"dropdown fidobDay nullable\">\n        <select xo-dropdown name=\"dobDayCC\" id=\"dobDayCC\" ng-model=\"user.dob_day\"\n                ng-options=\"day for day in days track by day\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobMonth nullable\">\n        <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"user.dob_month\"\n                ng-options=\"month for month in months track by month\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobYear nullable\">\n        <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"user.dob_year\"\n                ng-options=\"year for year in years track by year\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n        </select>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

Object.keys(_cardMetaData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cardMetaData[key];
    }
  });
});

var _directive2 = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

Object.keys(_directive2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive2[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardFlowRoute', function () {

    return _squid.$ComponentRoute.extend('CardRoute', {

        name: 'addCardFlow',
        directive: 'xo-add-card-flow',
        titleContent: 'asideHeader.addCard',
        children: [{
            name: '$AddCardRoute',
            attributes: {
                token: 'token',
                cardmodel: 'cardmodel',
                done: 'addCCDone',
                messagetitle: 'messagetitle',
                message: 'message',
                pagetitle: 'pagetitle',
                sidebar: 'sidebar',
                showmeftsection: 'showmeftsection',
                hideparenthead: 'hideparenthead',
                billingaddressupdated: 'billingaddressupdated',
                isupdatecard: 'isupdatecard',
                'parent-callbacks': 'callbacks',
                'selected-promotion-card-type': 'selectedPromotionCardType',
                promotion: 'promotion',
                'page-level': 'pageLevel',
                logout: 'logout',
                phone: 'phone',
                'show-balance-flow': 'showBalanceFlow',
                'show-cancel': 'showCancel',
                'show-set-preferred-fi': 'showSetPreferredFi',
                'on-success': 'onSuccess',
                'back-uri': 'backUri',
                'show-incentive': 'showIncentive',
                'incentive-amount': 'incentiveAmount',
                'update-card-cpa': 'updateCardCpa',
                cause: 'cause'
            }

        }, {
            name: '$SelectCardRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                message: 'message',
                pagetitle: 'pagetitle',
                sidebar: 'sidebar',
                'selected-promotion-card-type': 'selectedPromotionCardType',
                promotion: 'promotion'
            }
        }, {
            name: '$AddBillingRoute',
            attributes: {
                token: 'token',
                sidebar: 'sidebar',
                showmeftsection: 'showmeftsection',
                'parent-callbacks': 'callbacks',
                hideparenthead: 'hideparenthead',
                billingaddressupdated: 'billingaddressupdated',
                'prefill-address': 'prefillAddress'
            }
        }, {
            name: '$AddCepRoute',
            attributes: {
                token: 'token',
                sidebar: 'sidebar',
                'done-fn': 'cepDone',
                'prefill-address': 'prefillAddress'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card", "../node_modules/xo-wallet-components/src/add-card/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSelectCard', function () {
    return {
        template: _template2['default'],

        scope: {
            parentCallbacks: '=?',
            token: '=?',
            promotion: '=?'
        },

        controller: ['$scope', function ($scope) {

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.selectCardType = function (type) {
                    // card type is either 'cc' or 'plcc'
                    $scope.parentCallbacks.cardTypeSelected(type);
                };
            });
        }]
    };
});

_squid.$populate;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SelectCardRoute', function () {
    return _squid.$ComponentRoute.extend('SelectCardRoute', {

        name: 'selectCard',
        directive: 'xo-select-card',
        titleContent: 'asideHeader.selectCard',
        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/selectcard", "../node_modules/xo-wallet-components/src/add-card/selectcard/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"selectCardType\">\n\t<xo-aside-header hdrtype='tall' heading='asideHeader.selectCard' sub-head='asideHeader.fundingInstrumentsSubHead' back-url=\"checkout.review.sidebar.wallet\"></xo-aside-header>\n\n\t<div class=\"asideContent fundingCards\" id=\"selectFundingType\" content>\n\t\t<div class=\"allCards\">\n\t\t\t<ul class=\"allFundingInstrumentsList clearfix\">\n\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('cc')\">\n\t\t\t\t\t\t<span class=\"fsIcon\"></span>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">Debit or Credit Card</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('plcc')\">\n\t\t\t\t\t\t<img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">{{content('addCard.plccAddCard', { merchant: promotion.name})}}</span>\n\t\t\t\t\t\t\t<span class=\"secondary\">{{content('addCard.plccSelectIncentive')}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view></div>"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/confirm/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner-button/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/confirm/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VERIFICATION_CODE_COUNTDOWN_IN_SECS = 180; // 3 minutes
var RESEND_CODE_LINK_TIMEOUT_MILLI_SECS = 60000; // 1 minute
var ONE_MINUTE_IN_SECS = 60;

exports['default'] = _squid.$Component.extend('$xoConfirmOtpDirective', {
    tag: 'xo-confirm-otp',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardmodel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        message: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },
    actions: {
        addMessage: function addMessage(type, contentKey) {
            if (contentKey) {
                this.message({
                    msgKeys: [_angular2['default'].isArray(contentKey) ? contentKey[0] : contentKey],
                    type: type || 'error'
                });
            }
        },
        stopConfirmCodeTimer: function stopConfirmCodeTimer() {
            if (this.confirmCodeTimer) {
                _angular.$interval.cancel(this.confirmCodeTimer);
            }
            this.countdown = 0;
        },
        stopResendCodeTimer: function stopResendCodeTimer() {
            if (this.resendCodeTimer) {
                _angular.$timeout.cancel(this.resendCodeTimer);
            }
            this.showResendLink = false;
        },
        updateCountdown: function updateCountdown() {
            if (this.countdown > 0) {
                this.countdown--;
                this.timer = Math.floor(this.countdown / ONE_MINUTE_IN_SECS) + ':' + ('0' + this.countdown % ONE_MINUTE_IN_SECS).slice(-2);
            } else {
                if (!this.isConfirmProcessing) {
                    this.actions.addMessage('warning', 'confirmUpop.codeExpired');
                }
                this.actions.stopConfirmCodeTimer();
                this.actions.stopResendCodeTimer();
            }
        },
        startCountdown: function startCountdown(resetTimer) {
            var _this = this;

            if (resetTimer) {
                this.actions.stopConfirmCodeTimer();
                this.countdown = VERIFICATION_CODE_COUNTDOWN_IN_SECS;
                this.actions.updateCountdown();
                this.confirmCodeTimer = (0, _angular.$interval)(this.actions.updateCountdown, 1000);
            }

            this.actions.stopResendCodeTimer();
            this.showResendLink = false;
            this.resendCodeTimer = (0, _angular.$timeout)(function () {
                _this.showResendLink = true;
            }, RESEND_CODE_LINK_TIMEOUT_MILLI_SECS);
            this.actions.addMessage('success', 'confirmUpop.codeSent');
        },
        processed: function processed() {
            if (!this.countdown && this.isConfirmProcessing) {
                this.actions.addMessage('warning', 'confirmUpop.codeExpired');
            }
            this.isProcessing = this.isConfirmProcessing = false;
        },
        handleContingencies: function handleContingencies() {
            var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var prop = arguments[1];

            var errorData = void 0;

            if (result.errorCodes) {
                errorData = result;
            } else {
                errorData = {
                    errorCodes: [result['0'] || 'ISSUER_DECLINE']
                };
            }

            this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));

            if (window.scrollTo) {
                window.scrollTo(0, 0);
            }
        },
        sendNewCode: function sendNewCode() {
            // reset the code field.
            if (this.cardmodel && this.cardmodel.card) {
                this.cardmodel.card.otp_code = '';
            }
            this.actions.resendCode(true);
        },
        resendCode: function resendCode(resetTimer) {
            var _this2 = this;

            this.isProcessing = true;
            this.resolveOTP.action('init', {
                silent: true,
                data: {
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    }
                },
                resultModel: {},
                success: function success() {
                    _this2.actions.startCountdown(resetTimer);
                },
                error: function error() {
                    _this2.actions.handleContingencies();
                },
                contingencies: {
                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this2.cardLast4
                        };

                        _this2.actions.handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this2.$element);
                    },
                    DEFAULT: function DEFAULT() {
                        _this2.actions.handleContingencies();
                    }
                }
            })['finally'](this.actions.processed);
        },
        confirmOTP: function confirmOTP() {
            var _this3 = this;

            this.isProcessing = this.isConfirmProcessing = true;

            this.resolveOTP.action('complete', {
                silent: true,
                data: {
                    code: this.cardmodel.card.otp_code,
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    },
                    card_data: {
                        expiration_time: {
                            month: this.cardmodel.card.expiry_month,
                            year: this.cardmodel.card.expiry_year
                        },
                        card_verification_code: this.cardmodel.card.security_code
                    }
                },
                success: this.onSuccess,
                error: function error() {
                    _this3.actions.handleContingencies({}, 'confirmUpop');
                    _this3.actions.processed();
                },
                contingencies: {
                    COMPLETE_OTP_CONTINGENCY: function COMPLETE_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this3.cardLast4
                        };

                        _this3.actions.handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this3.$element);
                        _this3.actions.processed();
                    }
                }
            })['catch'](function () {
                _this3.actions.handleContingencies();
                _this3.actions.processed();
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            this.resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });
            this.isProcessing = this.showResendLink = false;
            this.cardLast4 = this.cardmodel.card.number.slice(-4);
            this.phoneLast4 = this.phone && this.phone.telephone && this.phone.telephone.slice(-4);
            this.actions.startCountdown(true);

            this.$watch('isProcessing', function (isProcessing) {
                if (isProcessing) {
                    _this4.$element.addClass('processing');
                } else {
                    _this4.$element.removeClass('processing');
                }
            });
            $('#upopConfirmation .modalContainer').focus();
        }
    }
});


_squid.$Component;

_util.$fiErrorUtil;

_index.$ResolveOTP;

_index2.$CheckoutSessionModel;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/confirm/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"confirmOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent('confirmUpop.verificationCodeMsg', {phoneLastFour: phoneLast4})\"></div>\n\n    <div class=\"timer\">\n        <span class=\"left\">{{content('confirmUpop.timeRemaining')}}</span>\n        <span class=\"timeLeft\">{{timer}} {{content('confirmUpop.minutes')}}</span>\n        <a link-button class=\"resendLink right focusableIcon\" href=\"\" ng-if=\"showResendLink\" ng-click=\"actions.resendCode(false)\">{{content('confirmUpop.resendCode')}}</a>\n    </div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.confirmOTP()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"confirmFields\" ng-show=\"countdown || isConfirmProcessing\">\n            <div class=\"inputField confidential\">\n                <input id=\"otp_code\"\n                       class=\"otp_code\"\n                       type=\"tel\"\n                       ng-model=\"cardmodel.card.otp_code\"\n                       name=\"otp_code\"\n                       value=\"\"\n                       placeholder=\"{{ content('confirmUpop.verificationCodeHint') }}\"\n                       autocapitalize=\"off\"\n                       autocomplete=\"off\"\n                       aria-required=\"false\"\n                       required\n                       scroll-to-top\n                       data-error-text=\"{{ content('confirmUpop.fieldInvalidOTP') }}\"\n                       xo-error-tooltip/>\n\n            </div>\n            <xo-spinner-button track='confirm_otp_code' token=\"token\" validate=\"validated\"\n                               is-processing=\"isProcessing\" button-text=\"common.confirm\"></xo-spinner-button>\n        </div>\n    </form>\n    <div class=\"sendNewOtp\">\n        <xo-spinner-button ng-if=\"!countdown && !isConfirmProcessing\" track='resend_otp_code' token=\"token\" on-click=\"actions.sendNewCode\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnResendCode\"></xo-spinner-button>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _addCard = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/init/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/confirm/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/styles.less");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoConfirmUpopDirective', {
    tag: 'xo-confirm-upop',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardmodel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        onCancel: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            // Card model should be required. However, because this is a route, a user could potentially refresh the page and land on this directive.
            // So, we need to check if parent directive has passed in cardmodel and return if not
            if (!this.cardmodel) {
                _logger.$logger.warn('card_model_missing');
                return this.goto('^'); // Return to parent route
            }

            this.phone = this.props.phone || {};

            var cardNumber = this.cardmodel.card && this.cardmodel.card.number;

            this.cardLast4 = cardNumber && cardNumber.slice(-4);
            this.fromLoginOverlay = _uiRouter.$stateParams.fromLoginOverlay;

            (0, _angular.$timeout)(function () {
                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').addClass('upopOpen');
                if (_this.fromLoginOverlay) {
                    (0, _angular.$timeout)(function () {
                        (0, _jquery2['default'])('#upopConfirmation .modalWrapper').addClass('modalWrapperAnimation');
                    });
                }
            });

            var hideModal = function hideModal() {
                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').removeClass('upopOpen');
            };

            var done = function done(handler, target) {
                hideModal();
                (0, _angular.$timeout)(function () {
                    return handler ? handler() : _this.goto(target);
                }, 200);
            };

            var _success = function _success() {
                done(_this.props.onSuccess, 'checkout.review');
            };

            this.closeModal = function (event) {
                if (event) {
                    event.preventDefault();
                }

                done(_this.props.onCancel, '^');
            };

            this.initSuccess = function () {
                _this.collectOtpInput = false;
            };

            this.confirmed = function () {
                if (_this.props.onSuccess) {
                    return _success();
                }

                return _this.models.checkoutSession.fundingOptions.action('update', {
                    resultModel: _this.models.checkoutSession,
                    silent: true,
                    data: {
                        planId: _this.cardmodel.id
                    },
                    success: function success() {
                        if (_this.models.checkoutSession.cvvData) {
                            _this.models.checkoutSession.set('cvvData.security_code', _this.cardmodel.get('card.security_code'));
                        }
                        var isNewCard = !_this.cardmodel.card.isExisting();
                        var msg = isNewCard ? ['smallToolTip.cardAddedConfirmed'] : ['smallToolTip.cardConfirmed'];

                        _this.models.checkoutSession.message = {
                            type: 'success',
                            msgKeys: msg
                        };
                        _success();
                    }
                });
            };

            this.flag = function (field) {
                // passing country to differentiate CUP for C2 and ROW
                return _addCard.$CardMetaData.getMetaData(_this.cardmodel.card, field, _squid.$locale.country);
            };

            this.setMessage = function (message) {
                _this.message = message;
            };

            this.collectOtpInput = this.flag('fields.expiry') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.cvv') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.phone') && !(this.phone && this.phone.telephone);
        }
    }
});


_angular.$timeout;

_squid.$Component;

_squid.$locale;

_uiRouter.$stateParams;

_addCard.$CardMetaData;

_logger.$logger;

_index.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/init/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner-button/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/init/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoInitOtpDirective', {
    tag: 'xo-init-otp',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        phone: {
            type: 'var',
            required: false
        },
        cardmodel: {
            type: 'var',
            required: false
        },
        onSuccess: {
            type: 'var',
            required: false
        },
        flag: {
            type: 'var',
            required: false
        },
        message: {
            type: 'var',
            required: false
        }
    },
    actions: {
        initOtp: function initOtp() {
            var _this = this;

            var handleContingencies = function handleContingencies() {
                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var prop = arguments[1];

                var errorData = void 0;

                if (result.errorCodes) {
                    errorData = result;
                } else {
                    errorData = {
                        errorCodes: [result['0'] || 'ISSUER_DECLINE']
                    };
                }

                _this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            };

            this.isProcessing = true;

            var resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });

            resolveOTP.action('init', {
                silent: true,
                data: {
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    }
                },
                resultModel: {},
                success: function success() {
                    _this.onSuccess();
                },

                error: function error() {
                    handleContingencies();
                },

                contingencies: {
                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this.cardmodel.card.number.slice(-4)
                        };

                        handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this.$element);
                    },
                    DEFAULT: function DEFAULT() {
                        handleContingencies();
                    }
                }
            })['finally'](function () {
                _this.isProcessing = false;
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.$watch('isProcessing', function (isProcessing) {
                if (isProcessing) {
                    _this2.$element.addClass('processing');
                } else {
                    _this2.$element.removeClass('processing');
                }
            });
            $('#upopConfirmation .modalContainer').focus();
        }
    }
});


_squid.$Component;

_util.$fiErrorUtil;

_index.$ResolveOTP;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/init/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"initOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent(flag('fields.expiry') ? 'confirmUpop.creditInitOtp' : 'confirmUpop.debitInitOtp')\"></div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.initOtp()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n        <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"flag('fields.expiry') || flag('fields.cvv')\">\n            <xo-card-expiry ng-if=\"flag('fields.expiry')\" expiry-month=\"cardmodel.card.expiry_month\" expiry-year=\"cardmodel.card.expiry_year\"></xo-card-expiry>\n            <xo-cvv ng-if=\"flag('fields.cvv')\" card=\"cardmodel.card\" show-label=\"true\"></xo-cvv>\n        </div>\n        <xo-phone-input token=\"token\" ng-if=\"flag('fields.phone')\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n\n        <xo-spinner-button track='init_otp_code' token=\"token\" validate=\"validated\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnsendOtpCode\"></xo-spinner-button>\n    </form>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoConfirmUpopRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoConfirmUpopRoute = exports.$xoConfirmUpopRoute = _index.$Route.extend('$xoConfirmUpopRoute', {
    path: 'confirmUpop',
    directive: _directive2['default'],
    titleContent: 'confirmUpop.confirm',
    trackingData: {
        fptiState: 'confirm_upop'
    },
    query: ['fromLoginOverlay'],
    loginRequired: true,
    pageOnOverlay: true,
    children: []
});

exports['default'] = $xoConfirmUpopRoute;

angular.value("$xoConfirmUpopRoute", $xoConfirmUpopRoute);
_index.$Route;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"upopConfirmation\">\n    <div class=\"upopConfirm\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper\" modal-box modal-cancel=\"closeModal()\" ng-class=\"{'modalWrapperAnimation': !fromLoginOverlay}\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <a link-button track-submit=\"{{collectOtpInput ? 'close_otp_init' : 'close_otp_confirm'}}\" class=\"close focusableIcon\" href=\"#\" ng-click=\"closeModal($event)\"></a>\n                <xo-message message=\"message\"></xo-message>\n                <div class=\"heading\" ng-bind-html=\"htmlContent('confirmUpop.heading', {acctLastFour: cardLast4})\"></div>\n\n                <xo-init-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" cardmodel=\"cardmodel\" on-success=\"initSuccess\" flag=\"flag\" ng-if=\"collectOtpInput\"></xo-init-otp>\n                <xo-confirm-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" cardmodel=\"cardmodel\" on-success=\"confirmed\" ng-if=\"!collectOtpInput\"></xo-confirm-otp>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _factory = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/factory.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/utils.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionOverlayDirective', {
    tag: 'xo-currency-conversion-overlay',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        doneFn: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutInputDataModel: _index2.$CheckoutInputDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    actions: {
        onSubmit: function onSubmit() {
            var _this = this;

            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                checkoutInputData = _models.checkoutInputData,
                ppconversion = _models.ppconversion;

            var fundingOptionId = checkoutInputData && checkoutInputData.funding_option_id;
            var plan = checkoutSession.plan;


            this.showOverlay = false;
            var _conversion = this.conversion,
                from_code = _conversion.from_code,
                to_code = _conversion.to_code,
                paypal = _conversion.paypal;

            var selectedConversionType = (0, _utils.mapConversionType)(ppconversion);
            var planConversionType = (0, _utils.mapConversionType)(paypal);

            if (selectedConversionType === planConversionType) {
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'cancel_currency_conversion',
                        currency_conversion_from_curr: from_code,
                        currency_conversion_to_curr: to_code
                    } });
                // stop
                return;
            }

            var data = {
                conversionType: selectedConversionType,
                planId: fundingOptionId || plan.id
            };

            if (data.planId) {
                checkoutSession.fundingOptions.action('updateConversion', {
                    data: data,
                    success: function success(result) {
                        if (data.planId !== plan.id) {
                            // don't need to reload checkoutSession after updating the conversion of the backup funding option
                            return _this.props.doneFn(result);
                        }

                        (0, _utils.logCurrencyConversion)({ options: {
                                to: 'process_currency_conversion',
                                currency_conversion_type: selectedConversionType,
                                is_conversion_shown: 1,
                                currency_conversion_from_curr: _this.conversion.from_code,
                                currency_conversion_to_curr: _this.conversion.to_code
                            } });

                        return checkoutSession.reload({
                            success: function success() {
                                // Conversion object needs to be mapped again as checkoutSession is reloaded
                                var _ref = checkoutSession || {},
                                    _ref$plan = _ref.plan,
                                    plan = _ref$plan === undefined ? {} : _ref$plan; // eslint-disable-line no-shadow
                                // Using let here since the conversion object may get reassigned at line 86 due to certain conditions


                                var _plan$conversion = plan.conversion,
                                    conversion = _plan$conversion === undefined ? {} : _plan$conversion;


                                _this.conversion = conversion;

                                if (!ppconversion) {
                                    if (conversion.paypal) {
                                        _logger.$logger.info('currency_conversion_not_honored');
                                    } else {
                                        // To avoid a situation if the conversion object is not returned in the response
                                        conversion = plan.conversion || {
                                            changeable: true,
                                            paypal: false
                                        };
                                    }

                                    if (!conversion.from || !conversion.to) {
                                        _logger.$logger.info('currency_conversion_rate_missing');
                                    }
                                }

                                return _this.props.doneFn(result);
                            }
                        })['catch'](function () {
                            _logger.$logger.error('checkout_session_reload_failed');
                        });
                    }
                })['catch'](function () {
                    _logger.$logger.error('update_conversion_failed');
                });
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.showOverlay = false;

            // Close overlay function
            this.closeOverlay = function () {
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'cancel_currency_conversion',
                        currency_conversion_from_curr: _this2.conversion.from_code,
                        currency_conversion_to_curr: _this2.conversion.to_code
                    } });
                _this2.showOverlay = false;
            };

            // Event listener to open the overlay
            var showConversionOverlay = _angular.$rootScope.$on('$showConversionOverlay', function () {
                _this2.isConversionOverlayRateContent = _factory.$CurrencyConversionFactory.isConversionOverlayRateContent();
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'prepare_currency_conversion',
                        currency_conversion_type: _this2.conversion.paypal ? 'PAYPAL' : 'VENDOR',
                        is_conversion_shown: 1,
                        currency_conversion_from_curr: _this2.conversion.from_code,
                        currency_conversion_to_curr: _this2.conversion.to_code
                    } });
                _this2.showOverlay = true;
            });

            this.$on('$destroy', showConversionOverlay);
        },
        populate: function populate() {
            var _models2 = this.models,
                checkoutSession = _models2.checkoutSession,
                cart = _models2.cart;


            this.conversion = checkoutSession.plan.conversion;
            // If there is conversion, populate scope with properties that will be rendered in UI
            if (this.conversion) {
                var conversion = this.conversion;

                this.isConversionOverlayRateContent = false;
                this.models.ppconversion = !!conversion.paypal;
                this.cartAmount = cart.purchase && cart.purchase.amounts.total.amount_formatted_currency;
                this.payPalAmount = conversion.total_converted_amount;
                this.toTargetCurrency = conversion.to_amount_forex + ' ' + conversion.to_code;
                this.fromUnitCurrency = '1 ' + checkoutSession.plan.conversion.from_code;
            }
        }
    }
});


_squid.$Component;

_angular.$rootScope;

_angular.noop;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index2.$CheckoutInputDataModel;

_factory.$CurrencyConversionFactory;

_logger.$logger;

_utils.mapConversionType;

_utils.logCurrencyConversion;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-modal show=\"showOverlay\" on-close=\"closeOverlay\" show-close-button=\"true\" enable-close-on-escape=\"true\" enable-mobile-interstitial=\"true\" override-default-container=\"true\">\n        <div class=\"logo\"></div>\n        <!-- Rate variation overlay template  -->\n        <div id=\"conversion-overlay\" content ng-if=\"isConversionOverlayRateContent\">\n            <h3>{{content('currencyOptions.bfxConversionHeaderRateInterstitial')}}</h3>\n            <div class=\"radioButton rate\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"paypal-conversion\" ng-value=\"true\"/>\n                <label for=\"paypal-conversion\" class=\"text-label left-label\">{{content('currencyOptions.bfxConversionPayPalLabelRate')}}</label>\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"vendor-conversion\" ng-value=\"false\"/>\n                <label for=\"vendor-conversion\" class=\"text-label right-label\">{{content('currencyOptions.bfxConversionIssuerLabelRate')}}</label>\n            </div>\n            <div class=\"total-amount\" ng-if=\"models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionPayPalTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{payPalAmount}}</span>\n            </div>\n            <div class=\"total-amount\" ng-if=\"!models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionIssuerTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{cartAmount}}</span>\n            </div>\n            <div class=\"paypal-conversion-msg\" ng-if=\"models.ppconversion\">\n                <p class=\"conversion-rate\">\n                    <b>\n                        {{content('currencyOptions.bfxConversionPayPalRate') + ' '}}\n                        <span>{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                    </b>\n                </p>\n                <p class=\"conversion-text\">{{content('currencyOptions.bfxConversionPayPalSpreadDisclosureMember')}}</p>\n            </div>\n            <div class=\"vendor-conversion-msg\" ng-if=\"!models.ppconversion\">\n                <p>{{content('currencyOptions.bfxConversionIssuerDisclosure')}}</p>\n            </div>\n            <button type=\"button\" class=\"btn full\" ng-click=\"actions.onSubmit()\">\n                {{content('common.continuetext')}}\n            </button>\n        </div>\n\n        <!-- Currency variation overlay template  -->\n        <div id=\"conversion-overlay\" content ng-if=\"!isConversionOverlayRateContent\">\n            <h3>{{content('currencyOptions.bfxConversionHeaderCurrency')}}</h3>\n            <div class=\"radioButton currency\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"paypal-conversion\" ng-value=\"true\"/>\n                <label for=\"paypal-conversion\" class=\"text-label left-label\">{{conversion.from_code}}</label>\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"vendor-conversion\" ng-value=\"false\"/>\n                <label for=\"vendor-conversion\" class=\"text-label right-label\">{{conversion.to_code}}</label>\n            </div>\n            <div class=\"total-amount\" ng-if=\"models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionPayPalTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{payPalAmount}}</span>\n            </div>\n            <div class=\"total-amount\" ng-if=\"!models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionIssuerTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{cartAmount}}</span>\n            </div>\n            <div class=\"paypal-conversion-msg\" ng-if=\"models.ppconversion\">\n                <p class=\"conversion-rate\">\n                    <b>\n                        {{content('currencyOptions.bfxConversionPayPalRate') + ' '}}\n                        <span>{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                    </b>\n                </p>\n                <p class=\"conversion-text\">{{content('currencyOptions.bfxConversionPayPalSpreadDisclosureMember')}}</p>\n            </div>\n            <div class=\"vendor-conversion-msg\" ng-if=\"!models.ppconversion\">\n                <p>{{content('currencyOptions.bfxConversionIssuerDisclosure')}}</p>\n            </div>\n            <button type=\"button\" class=\"btn full\" ng-click=\"actions.onSubmit()\">\n                {{content('common.payInCurrencyLabel', {currency: models.ppconversion ? conversion.from_code : conversion.to_code})}}\n            </button>\n        </div>\n    </xo-modal>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.logCurrencyConversion = exports.mapConversionType = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var DEFAULT_LOGGING_OPTIONS = {
    from: 'CURRENCY_CONVERSION'
};

var mapConversionType = exports.mapConversionType = function mapConversionType(type) {
    return type ? 'PAYPAL' : 'VENDOR';
};

var logCurrencyConversion = exports.logCurrencyConversion = function logCurrencyConversion(_ref) {
    var _ref$name = _ref.name,
        name = _ref$name === undefined ? 'currency_conversion' : _ref$name,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;

    // ES lint does not support the spread operator syntax which throws parsing error on its encounter
    var logOptions = Object.assign({}, DEFAULT_LOGGING_OPTIONS, options);

    _logger.$logger.info(name, logOptions);
};
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _factory = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/factory.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionDirective', {
    tag: 'xo-currency-conversion',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        doneFn: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
            };
        },
        conversion: function conversion(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                var fundingOptionId = _this.checkoutInputData.funding_option_id;

                if (!fundingOptionId || fundingOptionId === models.checkoutSession.plan.id) {
                    return models.checkoutSession.plan.conversion || {};
                }

                return models.checkoutSession.fundingOptions.action('getConversion', {
                    data: {
                        planId: fundingOptionId
                    },
                    success: function success(result) {
                        return result;
                    }
                });
            });
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this2 = this;

            var checkoutSession = this.models.checkoutSession;


            function mapConversionType(type) {
                return type ? 'PAYPAL' : 'VENDOR';
            }

            var selectedConversionType = mapConversionType(this.models.ppconversion);
            var planConversionType = mapConversionType(this.conversion.paypal);

            if (selectedConversionType === planConversionType) {
                this.props.doneFn();
                _logger.$logger.info('currency_conversion', {
                    from: 'CURRENCY_CONVERSION',
                    to: 'cancel_currency_conversion'
                });
                return;
            }

            _logger.$logger.info('currency_conversion', {
                from: 'CURRENCY_CONVERSION',
                to: 'process_currency_conversion',
                conversion_selected: selectedConversionType
            });

            var payload = {
                conversionType: selectedConversionType,
                planId: this.checkoutInputData.funding_option_id || checkoutSession.plan.id
            };

            if (payload.planId) {
                return checkoutSession.fundingOptions.action('updateConversion', {
                    data: payload,
                    success: function success(result) {
                        if (payload.planId !== checkoutSession.plan.id) {
                            // don't need to reload checkoutSession after updating the conversion of the backup funding option
                            return _this2.props.doneFn(result);
                        }
                        return checkoutSession.reload({
                            success: function success() {
                                var conversion = checkoutSession.plan.conversion || {};

                                if (!_this2.models.ppconversion) {
                                    if (conversion.paypal) {
                                        _logger.$logger.info('currency_conversion_not_honored', {
                                            type: _this2.models.ppconversion,
                                            from: conversion.from,
                                            to: conversion.to,
                                            changeable: conversion.changeable
                                        });
                                    } else {
                                        checkoutSession.plan.conversion = checkoutSession.plan.conversion || {
                                            changeable: true,
                                            paypal: false
                                        };

                                        if (!checkoutSession.plan.conversion.from || !checkoutSession.plan.conversion.to) {
                                            _logger.$logger.info('currency_conversion_rate_missing');
                                        }
                                    }
                                }
                                return _this2.props.doneFn(result);
                            }
                        });
                    }
                });
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            this.checkoutInputData = _index2.$CheckoutInputDataModel.instance(this.props.token);
        },
        populate: function populate() {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                cart = _models.cart;


            this.models.ppconversion = !!this.conversion.paypal;
            this.paypalConversionTotal = _factory.$CurrencyConversionFactory.getPayPalConversionTotal(checkoutSession, this.conversion);
            this.cardIssuerData = _factory.$CurrencyConversionFactory.getCardIssuerData(checkoutSession, this.conversion, cart);
            this.toTargetCurrency = this.conversion.to_amount_forex + ' ' + this.conversion.to_code;
            this.fromUnitCurrency = '1 ' + this.conversion.from_code;

            _logger.$logger.info('currency_conversion', {
                from: 'CURRENCY_CONVERSION',
                to: 'prepare_currency_conversion',
                conversion_type: this.conversion.paypal ? 'PAYPAL' : 'VENDOR',
                is_conversion_shown: 1
            });
        }
    }
});


_squid.$Component;

_logger.$logger;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index2.$CheckoutInputDataModel;

_factory.$CurrencyConversionFactory;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$CurrencyConversionFactory', function () {
    var showConversionOverlay = false; // Phase 2 flag that determines to show overlay or sidebar for currency conversion selection
    var showConversionOverlayRateContent = false; // Phase 2 flag that determines rate or currency variant for currency conversion overlay content

    /**
     * get content data for card issuer radio box container
     *
     * @param {Object} checkoutSession - $CheckoutSessionModel model
     * @param {Object} conversion - $CheckoutSessionModel conversion obj
     * @param {Object} cartModel - $CheckoutCartModel model
     */
    var getCardIssuerData = function getCardIssuerData(checkoutSession, conversion, cart) {
        var plan = checkoutSession.plan;
        var isSplitBalance = plan.isSplitBalance();
        var showConvertIssuerSplitBalContent = false;
        var disclaimer = void 0;
        var label = void 0;

        if (isSplitBalance) {
            // if there is BALANCE source with the same "currency_code" as "cart total amount"
            // then we should NOT show Split balance content because Planning will not exclude this Balance from the plan after replan
            showConvertIssuerSplitBalContent = !plan.sources.some(function (source) {
                return source.get('type') === 'BALANCE' && source.get('amount.currency_code') === cart.get('purchase.amounts.total.currency_code');
            });
        }

        if (showConvertIssuerSplitBalContent) {
            label = (0, _squid.$renderContent)('currencyOptions.convertIssuerSplitBal');
            disclaimer = (0, _squid.$renderContent)('currencyOptions.issuerFinalAmountSplitBal', {
                amt: cart.get('purchase.amounts.total.amount_formatted_currency')
            });
        } else {
            label = (0, _squid.$renderContent)('currencyOptions.convertIssuer');
            disclaimer = '<b>' + (0, _squid.$renderContent)('currencyOptions.amount') + '</b> ' + (0, _squid.$renderContent)('currencyOptions.issuerFinalAmount');
        }

        return {
            label: label,
            disclaimer: disclaimer
        };
    };

    /**
     * Calculate conversion total only when:
     * 1. for PayPal rate
     * 2. there is only one plan source available (for multi source use cases, e.g Card + Balance we don't want to calc total for now)
     *
     * @param {Object} checkoutSession - $CheckoutSessionModel model
     * @param {Object} conversion - $CheckoutSessionModel conversion obj
     * @returns {String} Returns total formatted amount
     */
    var getPayPalConversionTotal = function getPayPalConversionTotal(checkoutSession, conversion) {
        var sources = checkoutSession.get('plan.sources');

        if (!conversion.paypal || sources && sources.length > 1) {
            return;
        }

        return checkoutSession.get('plan.sources.0.amount.amount_formatted_currency');
    };

    /**
     * @returns {Boolean} - Flag that confirms config enabled for overlay
     */
    var getConversionOverlayFlag = function getConversionOverlayFlag() {
        if ((0, _squid.$feature)('showConversionOverlay', false)) {
            showConversionOverlay = true;
        }

        return showConversionOverlay;
    };

    /**
     * Get the currency conversion overlay content flag to determinte to render right content
     * @returns {Boolean} - Flag that confirms PXP treatment to show currency conversion overlay
     */
    var isConversionOverlayRateContent = function isConversionOverlayRateContent() {
        return showConversionOverlayRateContent;
    };

    return {
        getCardIssuerData: getCardIssuerData,
        getPayPalConversionTotal: getPayPalConversionTotal,
        getConversionOverlayFlag: getConversionOverlayFlag,
        isConversionOverlayRateContent: isConversionOverlayRateContent
    };
});

_squid.$renderContent;

_squid.$feature;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/currency-conversion", "../node_modules/xo-wallet-components/src/currency-conversion/factory.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion/template.html":
/***/ (function(module, exports) {

module.exports = "<form method=\"post\" class=\"curr_conv asideProceed formSmall\" novalidate=\"novalidate\" ng-submit=\"actions.onSubmit()\" content form-autofocus>\n    <ul class=\"conversionoptions\">\n        <li>\n            <div class=\"radioButton\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"conversionPayPal\" ng-value=\"true\"/>\n                <label for=\"conversionPayPal\">{{content('currencyOptions.convertPayPal')}}</label>\n            </div>\n            <div class=\"conversion\">\n                <div ng-if=\"conversion.from && conversion.to\" class=\"dccDetails\">\n                    <p>\n                        <span><b>{{content('currencyOptions.exchangeRate')}}</b></span>\n                        <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                    </p>\n                    <p ng-if=\"content('currencyOptions.conversionSecondary')\" class=\"conversionFeeDisclaimer\" ng-bind=\"content('currencyOptions.conversionSecondary')\"></p>\n                </div>\n                <p ng-if=\"conversion.date\" class=\"conversionDate\">{{content('currencyOptions.conversionDate', {date: conversion.date})}}</p>\n                <p ng-if=\"content('currencyOptions.textConversionFeeUALink')\" class=\"conversionFeeUALink\" data-ng-bind-html=\"htmlContent('currencyOptions.textConversionFeeUALink')\"></p>\n                <p ng-if=\"paypalConversionTotal\" class=\"conversionAmount\"><b>{{content('currencyOptions.amount')}}</b> {{paypalConversionTotal}}</p>\n                <p ng-if=\"content('currencyOptions.rateDisclaimerPayPal')\" class=\"conversionDisclaimer\">{{content('currencyOptions.rateDisclaimerPayPal')}}</p>\n            </div>\n        </li>\n        <li>\n            <div class=\"radioButton\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"conversionVendor\" ng-value=\"false\"/>\n                <label for=\"conversionVendor\">{{ cardIssuerData.label }}</label>\n            </div>\n            <div class=\"conversion\">\n                <p bind-html-compile=\"cardIssuerData.disclaimer\"></p>\n                <p ng-if=\"content('currencyOptions.rateDisclaimerIssuer')\" class=\"conversionDisclaimer\">{{content('currencyOptions.rateDisclaimerIssuer')}}</p>\n            </div>\n        </li>\n        <li ng-if=\"content('currencyOptions.rateDisclaimerCommon')\" class=\"commonDisclaimer\">{{content('currencyOptions.rateDisclaimerCommon')}}</li>\n    </ul>\n    <div class=\"buttons\">\n        <input id=\"proceedButton\" type=\"submit\" value=\"{{content('buttons.agree')}}\" class=\"btn full\">\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-contingency-list/contingencies.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var contingencyList = {
        INSTRUMENT_COUNT_EXCEEDED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_LIMIT_EXCEEDED: 'errorInstrumentCountExceeded',
        INSTRUMENT_COUNT_LIMIT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
        INSTRUMENT_UNAVAILABLE: 'errorInstrumentUnavailable',
        INSTRUMENT_REFUSED_DUE_TO_MAX_LIMIT: 'errorInstrumentRefused',
        INSTRUMENT_REFUSED_DUE_TO_MAX_SHARED_INSTRUMENT_LIMIT: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
        INSTRUMENT_SHARING_LIMIT_EXCEEDED: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
        INSTRUMENT_ALREADY_EXISTS: 'errorInstrumentAlreadyExists',
        INSTRUMENT_BILLING_ADDRESS_NOT_ACCEPTED: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_ADDRESS1: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_CITY: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_COUNTRY: 'errorInstrumentBillingAddressNotAccepted',
        BILLING_DIFFERENT_COUNTRY: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        INSTRUMENT_UPDATE_NO_CHANGE: 'errorInstrumentUpdateNoChange',
        INSTRUMENT_DUPLICATE_LIMIT_REACHED: 'errorInstrumentRefused',
        NOT_ELIGIBLE_TO_EDIT_CARD: 'notEligibleToEditCard',
        INTERNAL_ERROR: 'errorInternalError',
        INSTRUMENT_REFUSED: 'errorInstrumentRefused',
        INSTRUMENT_INTERNATIONAL: 'errorIssuerRejectIntl',
        REJECT_REFUSED: ['errorIssuerReject', 'errorInstrumentRefused'],
        PAYPAL_DEBIT_CARD_REFUSED: ['errorPaypalDebitRefused', 'errorGeneral'],
        PAYPAL_CREDIT_CARD_REFUSED: ['errorPaypalCreditRefused', 'errorGeneral'],
        PAYPAL_CARD_REFUSED: ['errorPaypalRefused', 'errorGeneral'],
        EXCESSIVE_REJECTIONS: ['errorExcessiveRejectGuest', 'errorInstrumentRefused'],
        CC_INVALID_CSC: ['errorCheckDigits', 'errorGeneral'],
        INVALID_EXPIRATION_DATE: 'errorInvalidExpirationDate',
        CHECK_DIGITS_NOT_PRESENT: ['errorCheckDigitsNotPresent', 'errorGeneral'],
        REJECT_UNKNOWN: ['errorIssuerReject', 'errorInstrumentRefused'],
        SETTLEMENT_DENIED: 'errorInstrumentRefused',
        MAX_AMOUNT_EXCEEDED: ['errorMaxAmountExceeded', 'errorInstrumentRefused'],
        ISSUER_ERROR: ['errorIssuerDenied', 'errorInstrumentRefused'],
        MISSING_FIELD: ['errorInvalidData', 'errorGeneral'],
        INVALID_PARAMETERS: ['errorInvalidData', 'errorGeneral'],
        INVALID_DATA: ['errorInvalidData', 'errorGeneral'],
        INVALID_ACCOUNT: ['errorInvalidAccount', 'errorGeneral'],
        INVALID_INSTRUMENT_ID: ['errorInvalidAccount', 'errorGeneral'],
        ACCOUNT_RESTRICTED: ['errorAccountRestricted', 'errorGeneral'],
        ISSUER_RESTRICTED: ['errorIssuerReject', 'errorGeneral'],
        ISSUER_REJECTED: ['errorIssuerReject', 'errorGeneral'],
        ADDRESS_MISMATCH: 'errorInstrumentBillingAddressNotMatch',
        CHECK_DIGITS_NOT_PROC: ['errorCheckDigitsNotPresent', 'errorGeneral'],
        CHECK_DIGITS_UNSUPPORTED: ['errorCheckDigits', 'errorGeneral'],
        CHECK_DIGITS_UNAVAILABLE: ['errorCheckDigits', 'errorGeneral'],
        BILL_ADDR_UNAVAILABLE: ['errorInstrumentBillingAddressUnavailable', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNSUPPORTED: ['errorInstrumentBillingAddressUnsupported', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_UNAVAILABLE_GLOBAL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        BILL_ADDR_NOT_ALLOWED: ['errorInstrumentBillingAddressNotAccepted', 'errorAddressNotAllowed'],
        BILL_ADDR_UNAVAILABLE_INTL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
        INSTRUMENT_DISABLED: 'errorInstrumentRefused',
        PI_TYPE_NOT_SUPPORTED: 'errorInvalidCCNumberOrType_global',
        REJECT_AMEX_ADULT: ['errorAmexAdult', 'errorGeneral'],
        INVALID_BANK_ROUTING_NUMBER: 'invalidRoutingNumber',
        BANK_ROUTING_NUMBER_IS_EMPTY: 'invalidPINumber',
        INVALID_BANK_ACCOUNT_NUMBER: 'invalidPINumber',
        BANK_ACCOUNT_NUMBER_IS_EMPTY: 'invalidPINumber',
        INVALID_BANK_IBAN: 'invalidPINumber',
        INVALID_IBAN_CODE: 'invalidPINumber',
        INVALID_BANK_IBAN_CONVERSION_ERROR: 'invalidPINumber',
        INVALID_BENEFICIARY_FIRST_NAME: 'errorInvalidFirstName',
        INVALID_BENEFICIARY_NAME: 'errorInvalidFirstName',
        INVALID_BANK_BENEFICIARY_NUMBER: 'errorGeneral',
        INVALID_BANK_ADDRESS: 'errorGeneral',
        INVALID_CARD_NUMBER: 'errorInvalidCCNumberOrType',
        INVALID_CARD_TYPE: 'errorInvalidCCNumberOrType',
        INVALID_SECURITY_CODE: 'errorInvalidCSC',
        INVALID_FIRST_NAME: 'errorInvalidFirstName',
        INVALID_LAST_NAME: 'errorInvalidLastName',
        INVALID_EXPIRY: 'errorInvalidExpirationDate',
        INVALID_PHONE: 'errorInvalidPhone',
        BANK_ADDRESS_IS_EMPTY: 'errorGeneral',
        INVALID_BANK_BRANCH_NUMBER: 'errorGeneral',
        ADD_REFUSED_DUE_TO_EXCEEDING_MAX_DUPLICATE_INSTRUMENT_LIMIT: 'errorInstrumentUnavailable',
        EMPTY_DATA: 'errorGeneral',
        ISSUER_DECLINE: 'errorIssuerReject',
        WRONG_CONFIRMATION_VALUES: 'wrongConfirmationValue',
        CONFIRMATION_RESEND_COUNT_EXCEEDED: 'resendValExceeded',
        FREQUENT_REQUEST_VERIFICATION_CODE: 'frequentVerificationCodeReq',
        TRANSACTION_TIMEOUT: 'transactionTimeout',
        NOT_CONFIRMED: 'notConfirmed',
        CONTACT_CARD_ISSUER_TO_VERIFY: 'issuerVerify',
        CARD_NOT_ACTIVATED_FOR_UPOP: 'cardNotActivatedUpop',
        RESTRICTED_CARD: 'cardRestricted',
        INVALID_ONE_TIME_PASSWORD: 'errorInvalidOtpCode',
        DUPLICATED_TRANSACTION: 'duplicateTransaction'

    };

    return contingencyList;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-contingency-list/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _contingencies = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/contingencies.js");

var _contingencies2 = _interopRequireDefault(_contingencies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// FI error fields and xo frontend models map
var FIELD_TO_MODEL_MAPPING = {
    ACTOR: [],
    BILLING_ADDRESS: ['cardmodel.address'],
    BIN: ['card.type', 'card.number'],
    CARD: ['card.type', 'card.number'],
    CUP_CARD: ['card.type', 'card.number'],
    CVV: ['card.security_code'],
    DOB: ['dob.value', 'user.dob_day', 'user.dob_month', 'user.dob_year'],
    EXPIRY: ['expiryDate', 'card.expiry_month', 'card.expiry_year']
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$fiErrorUtil', function () {
    return {
        addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {
            // error handling for filifecycle and fimanagement.
            if (!errorData.errorCodes) {
                errorData.errorCodes = errorData && [errorData['0']];
            }

            var messages = [];

            if (errorData.errorCodes && errorData.errorCodes.length) {
                errorData.errorCodes.forEach(function (errorCode) {
                    var contentKey = _contingencies2['default'][errorCode] || defaultKey || 'errorGeneral';
                    var message = void 0;

                    if (angular.isArray(contentKey)) {
                        for (var i = 0; i < contentKey.length; i++) {
                            message = (0, _squid.$renderContent)(contentBundle + '.' + contentKey[i], prop);
                            if (message) {
                                break;
                            }
                        }
                    } else {
                        message = (0, _squid.$renderContent)(contentBundle + '.' + contentKey, prop);
                    }
                    messages.push(message);
                });
            } else {
                messages.push((0, _squid.$renderContent)(contentBundle + '.' + 'errorGeneral', prop));
            }

            return {
                msgs: messages,
                type: 'error'
            };
        },

        highlightInvalidFields: function highlightInvalidFields(invalidFields, $element) {
            for (var _iterator = invalidFields, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var model = _ref;

                var $field = $($element).find('[ng-model="' + model + '"]');

                $field.addClass('backendError');
                $field.attr('aria-invalid', true);
            }

            $($element).find('.backendError').first().focus();
        },

        mapValidationErrorToModel: function mapValidationErrorToModel() {
            var invalidFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var errorProperty = 'VALIDATION_ERROR_';

            // if there is only one invalid field then fetch the corresponding error message else return the
            // generic validation error message
            if (invalidFields.length === 1) {
                return {
                    invalidModels: FIELD_TO_MODEL_MAPPING[invalidFields[0]],
                    errorProperty: errorProperty + invalidFields[0]
                };
            }
            return {
                invalidModels: [],
                errorProperty: errorProperty + 'GENERIC'
            };
        },

        addPageErrorByErrorName: function addPageErrorByErrorName(contentBundle, prop) {
            var defaultKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'INTERNAL_ERROR';

            var message = (0, _squid.$renderContent)(contentBundle + '.' + prop);

            if (!message || !message.toString()) {
                // log content not found
                _logger.$logger.error('fi_content_missing', {
                    prop: prop
                });
                message = (0, _squid.$renderContent)(contentBundle + '.' + defaultKey);
            }

            return {
                msgs: [message],
                type: 'error'
            };
        },

        /**
         * Highlight the Error Fields by ng-model
         * @param errorData
         * @param element
         * @param modelPrefix
         */
        addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {
            if (errorData.fields && errorData.fields.length) {
                errorData.fields.forEach(function (field) {
                    var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                });
            }
            $(element).find('.backendError:first').focus();
        },

        /**
         * Highlight the Error Fields by element name
         * @param errorData
         * @param element
         * @param modelPrefix
         */
        addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {
            if (errorData.fields && errorData.fields.length) {
                errorData.fields.forEach(function (field) {
                    var fieldName = void 0;

                    if (modelPrefix && field.field && field.field.length > 0) {
                        // Add prefix with CamelCase of field name
                        fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
                    } else {
                        fieldName = field.field;
                    }
                    var $field = $(element).find('[name="' + fieldName + '"]');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                });
            }
            $(element).find('.backendError:first').focus();
        }
    };
});

_squid.$renderContent;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/fi-contingency-list", "../node_modules/xo-wallet-components/src/fi-contingency-list/util.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-logos/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/fi-logos/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFiLogos', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?'
        },
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                cardTypes: _fi.$CardTypesModel.instance($scope.token + ':' + _squid.$locale.country, {
                    token: $scope.token,
                    country: _squid.$locale.country
                })
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_fi.$CardTypesModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-logos/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fiIconsGroup\">\n    <div class=\"cardIconsGroup\">\n        <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed track by $index\">\n            <div class = \"cardIcon {{cardType}}\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/installment-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoInstallmentOptions', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            doneFn: '=?',
            cardNumber: '=?'
        },

        controller: ['$scope', function ($scope) {

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance()
            }).then(function () {

                if ($scope.auth.logged_in) {

                    // Installment support for authenticated user
                    (0, _squid.$populate)($scope, {
                        checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                    }).then(function () {
                        $scope.cardInfo = $scope.checkoutSession.plan.sources[0];
                        $scope.installments = $scope.checkoutSession.installments;
                    });
                } else {
                    // Installment support added for not authenticated user, e.g. BR signup flow
                    var installmentsModel = _checkout.$InstallmentOptionsModel.instance($scope.token);

                    installmentsModel.save({
                        data: {
                            cc: $scope.cardNumber,
                            payee: _checkout.$CheckoutPayeeModel.instance($scope.token),
                            checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
                            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token)
                        },

                        success: function success(result) {
                            $scope.cardInfo = result.cardInfo;
                            $scope.installments = result.installment_options;
                        }
                    });
                }
            });

            $scope.onSelect = function (index) {
                var selectedInstallmentData = $scope.installments[index];

                $scope.installmentsModel = _checkout.$InstallmentOptionsModel.instance($scope.token);

                var param = {
                    term: selectedInstallmentData.term,
                    payment_value: selectedInstallmentData.monthly_payment.value,
                    payment_currency: selectedInstallmentData.monthly_payment.currency
                };

                if (selectedInstallmentData.total_cost) {
                    param.total_cost_value = selectedInstallmentData.total_cost.value;
                    param.total_cost_currency = selectedInstallmentData.total_cost.currency;
                }

                if (selectedInstallmentData.discount_amount) {
                    param.discount_value = selectedInstallmentData.discount_amount.value;
                    param.discount_currency = selectedInstallmentData.monthly_payment.currency;
                }

                if (selectedInstallmentData.discount_percentage) {
                    param.discount_percentage = selectedInstallmentData.discount_percentage;
                }

                return $scope.installmentsModel.action('select', {
                    data: param,

                    success: function success(result) {
                        if ($scope.auth.logged_in) {
                            $scope.checkoutSession.selectedInstallmentData = selectedInstallmentData;
                        }
                        $scope.doneFn(result);
                    }
                });
            };
        }]
    };
});

_squid.$populate;

_auth.$AuthModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_checkout.$InstallmentOptionsModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/installment-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"aside installmentOptions\" ng-class=\"{true: 'signupflow'}[!auth.logged_in]\" >\n    <div class=\"cardInfo\" ng-if=\"cardInfo\">\n        <span class=\"ccard {{cardInfo.card_type}}\" id=\"creditCard\" role=\"img\" aria-label=\"{{cardInfo.name}}\"></span> {{cardInfo.name}} x-{{cardInfo.last4}}&nbsp;<span class=\"installmentText\" ng-if=\"installments\">{{content('installments.upto')}}&nbsp;{{installments.length}}x</span>\n    </div>\n    <ul class=\"asideContent items\" ng-if=\"installments\">\n        <li class=\"installment\" ng-repeat=\"installment in installments track by $index\" ng-click=\"onSelect($index)\" track-submit>\n            <div class=\"term\">\n                <span>{{installment.term}}x {{content('installments.of')}}&nbsp;</span>\n            </div>\n            <div class=\"display\">\n                <span>{{installment.monthly_payment.formatted_value}}</span>\n                <div class=\"confidential total\">\n                    <span>{{content('installments.total')}}: {{installment.total}}</span>\n                    <span class=\"save\" ng-if=\"installment.discount_amount\">\n                        {{content('installments.save')}} {{installment.discount_amount.formatted_value}}\n                    </span>\n                </div>\n            </div>\n\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoMemberSepa', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.sepa = _fi.$SepaModel.instance({ id: 123 });
            $scope.callbacks = {
                sepaAccept: function sepaAccept() {
                    (0, _squid.$populate)($scope, {
                        checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                        checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                    }).then(function () {
                        return $scope.sepa.action('sepaAccept', {
                            data: {
                                bank: {
                                    id: $scope.sepa.bankId
                                }
                            },
                            success: function success() {
                                $scope.parentCallbacks.success($scope.sepa);
                            }
                        });
                    });
                }
            };
        }]
    };
});

_squid.$populate;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_fi.$SepaModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/route.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$MemberSepaRoute', function () {

    return _squid.$ComponentRoute.extend('MemberSepaRoute', {

        name: 'membersepa',

        directive: 'xo-member-sepa',
        titleContent: 'directDebitAgreement.sepaTitle',

        children: [{
            name: '$XOSepaAgreementRoute',
            attributes: {
                token: 'token',
                sepa: 'sepa',
                'parent-callbacks': 'callbacks'
            }
        }, {
            name: '$XOSepaMandateRoute',
            attributes: {
                token: 'token',
                sepa: 'sepa',
                'parent-callbacks': 'callbacks'
            }
        }]
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/member-sepa", "../node_modules/xo-wallet-components/src/member-sepa/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepaAgreement', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sepa: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $('body').addClass('pageSepaAgreementContingency');

            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaAgreementContingency');
            });

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.sepa.bankId = $scope.checkoutSession.sepa_mandate.bankId;
                $scope.sepa.action('sepaDirectMandate', {
                    resultModel: $scope.sepa,
                    data: {
                        bank: {
                            id: $scope.sepa.bankId
                        }
                    },
                    success: function success() {
                        $scope.onSubmit = function () {
                            $scope.parentCallbacks.sepaAccept();
                        };
                    }
                });
            });
        }]
    };
});

_squid.$populate;

_index.$CheckoutSessionModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaAgreementRoute', function () {
    return _squid.$ComponentRoute.extend('XOSepaAgreementRoute', {
        name: 'sepaAgreement',

        directive: 'xo-sepa-agreement',
        titleContent: 'directDebitAgreement.sepaTitle',

        trackingData: {
            fptiState: 'sepa_agreement',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_agreement',
                    'pagename2': '%::sepa_agreement:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement", "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"sepaAgreementContingency\" content>\n    <div class=\"row-fluid\">\n        <div class=\"centerTray\">\n            <div class=\"trayInner trayInnerDefault loggingIn\">\n                <form ng-submit=\"onSubmit()\" method=\"post\" class=\"proceed ddAgreementForm\" id=\"payment_form\" novalidate>\n                    <h2 class=\"zeta\">{{content('directDebitAgreement.sepaTitle')}}</h2>\n\n                    <p ng-bind-html =\"content('directDebitAgreement.ddAgreementPara1')\"></p>\n                    <p>\n\n                        <span\n                                bind-html-compile=\"htmlContent('directDebitAgreement.ddAgreementPara2',{bankName:sepa.bank.bank_name, bankNumber:sepa.bank.bank_id, href: '^.sepaMandate'})\">\n                        </span>\n\n                    </p>\n\n                    <div class=\"buttons\">\n                        <input track-submit ng-if=\"model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndPay')}}\"  class=\"btn\" />\n                        <input track-submit ng-if=\"!model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndContinue')}}\" class=\"btn\" />\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepaMandate', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sepa: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $('body').addClass('pageSepaMandateContingency');
            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaMandateContingency');
            });
            $scope.onSubmit = function () {
                $scope.parentCallbacks.sepaAccept();
            };
        }]
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/directive.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$XOSepaMandateRoute', function () {

    return _squid.$ComponentRoute.extend('XOSepaMandateRoute', {
        name: 'sepaMandate',

        directive: 'xo-sepa-mandate',
        titleContent: 'directDebitAgreement.ddFullAgreementTitle',

        trackingData: {
            fptiState: 'sepa_mandate',
            buzname: {
                'fullpage': {
                    'pagename': '%::sepa_mandate',
                    'pagename2': '%::sepa_mandate:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },

        loginRequired: true,

        children: []
    });
});

_squid.$ComponentRoute;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate", "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"sepaMandateContingency\" content>\n    <div class=\"row-fluid\">\n        <div class=\"centerTray\">\n            <div class=\"trayInner trayInnerDefault loggingIn\">\n                <form ng-submit=\"onSubmit()\" method=\"post\" class=\"proceed\" id=\"payment_form\" novalidate>\n                    <h2 class=\"zeta\">{{content('directDebitAgreement.ddFullAgreementTitle')}}</h2>\n                    <p>{{content('DEMemberGuest.ddAgreementPara1')}}</p>\n                    <div class=\"row-fluid sepaInfo\">\n                        <div class=\"span\">\n                            <strong>{{content('DEMemberGuest.accountCarrier')}}</strong>\n                            <p>\n                                <span>{{sepa.user.name}}</span>\n                                <br/>{{sepa.user.address.line1}}\n                                <br/>{{sepa.user.address.line2}}\n                                <br/> {{sepa.user.address.city}}, {{sepa.user.address.postal_code}}\n                                <br/>{{sepa.user.address.country}}\n                            </p>\n                        </div>\n                        <div class=\"span bankDetails\">\n                            <p>\n                                <strong>{{content('DEMemberGuest.IBAN')}}</strong>\n                            </p>\n                            {{sepa.bank.iban_number}}\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.bankName')}}</strong>\n                            </p>\n                            {{sepa.bank.bank_name}}\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.bic')}}</strong>\n                            </p>\n                            {{sepa.bank.bic}}\n                        </div>\n                        <div class=\"span\">\n                            <p>\n                                <strong>{{content('DEMemberGuest.creditor')}}</strong>\n                            </p>\n                            {{sepa.creditor.name}}\n                            <p></p>\n                            <div class=\"adr\">\n                                <div class=\"confidential streets street-address darker\">\n                                    {{sepa.creditor.address.line1}}\n                                </div>\n\n                            <div class=\"confidential\">\n                                <span class=\"postal-code\">{{sepa.creditor.address.postal_code}}</span>\n                                <span class=\"locality\">{{sepa.creditor.address.country}}</span>\n                            </div>\n                            </div>\n                            <p></p>\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.creditorId')}}</strong>\n                            </p>\n                            {{sepa.creditor.id}}\n                        </div>\n                    </div>\n                    <p>\n                        <span ng-if=\"model.useraction.commit\" ng-bind-html=\"htmlContent('directDebitAgreement.ddAgreementPara2AcceptPay')\"></span>\n                        <span ng-if=\"!model.useraction.commit\" ng-bind-html=\"htmlContent('directDebitAgreement.ddAgreementPara2AcceptContinue')\"></span>\n                    </p>\n                    <p class=\"dateLocationMarker\">{{sepa.date}},{{sepa.user.address.city}},{{content('countryList.DE')}}</p>\n                    <div class=\"buttons\">\n                        <input track-submit ng-if=\"model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndPay')}}\"  class=\"btn\" />\n                        <input track-submit ng-if=\"!model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndContinue')}}\" class=\"btn\" />\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/member-sepa/template.html":
/***/ (function(module, exports) {

module.exports = "<ui-view></ui-view>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds-ddc/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds-ddc/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThreeDsDdcDirective', {
    tag: 'xo-three-ds-ddc',
    template: _template2['default'],
    props: {
        jwt: {
            type: 'var',
            required: true
        },
        ddcUrl: {
            type: 'var',
            required: true
        },
        doneCallback: {
            type: 'var',
            required: true
        }
    },
    resolve: {
        experiments: function experiments() {
            return {
                ddcTreatment: (0, _squid.$elmo)('three_ds_ddc', { 'ctx.COUNTRY': _squid.$locale.country }, 'three_ds_ddc_trmt(.*)')
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            _squid.$config.cardinalcommerce = _squid.$config.cardinalcommerce || {};
        },
        populate: function populate() {
            var _this = this;

            var startTime = Date.now();

            var ddcCompleted = function ddcCompleted() {
                var elapsedMs = Date.now() - startTime;

                _logger.$logger.info('threeds_v2', {
                    from: '3DS_DDC',
                    to: '3DS_DDC_DONE',
                    duration: elapsedMs,
                    ddc_end_time: Date.now(),
                    context_id: _angular.$rootScope.token
                });

                _this.doneCallback();
            };

            function fireAndForget() {
                // no wait
                return ddcCompleted();
            }

            function waitDdcForFixedTime() {
                // Prioritize app config over hardcoded value for timeout
                (0, _angular.$timeout)(function () {
                    return ddcCompleted();
                }, _squid.$config.cardinalcommerce.ddcShortCircuitTime || 1000);
            }

            function waitDdcResponse() {
                window.addEventListener('message', function (event) {
                    // add ddcOrigin - "https://centinelapisbox.cardinalcommerce.com:50486/"" into app config.json
                    // This domain changes with every environment. This origin value will be the CentinelAPI domain
                    // event message sample
                    // {MessageType:  "profile.completed",   SessionId : "0_57f063fd-659a-4779-b45b-9e456fdb7935", Status: true}
                    _logger.$logger.info('3DS_DDC_MESSAGE_EVENT_LISTENER_TRIGGERED');
                    if (event.origin === _squid.$config.cardinalcommerce.ddcOrigin) {
                        var data = JSON.parse(event.data);

                        if (data !== undefined && data.Status) {
                            return ddcCompleted();
                        }
                    }
                }, false);
            }

            _logger.$logger.info('3DS_INIT_DDC_TRIGGERED');

            $('#threedsDdcIframeForm').submit();

            var ddcTreatmentName = this.experiments && this.experiments.ddcTreatment && this.experiments.ddcTreatment.treatment_name;

            if (!ddcTreatmentName) {
                // default
                _logger.$logger.info('3DS_DDC_FIRE_FORGET_EMPTY_TRMT');
                return fireAndForget();
            }

            if (ddcTreatmentName === 'three_ds_ddc_trmt1') {
                _logger.$logger.info('3DS_DDC_TRMT1');
                return fireAndForget();
            }

            if (ddcTreatmentName === 'three_ds_ddc_trmt2') {
                _logger.$logger.info('3DS_DDC_TRMT2');
                return waitDdcForFixedTime();
            }

            if (ddcTreatmentName === 'three_ds_ddc_trmt3') {
                _logger.$logger.info('3DS_DDC_TRMT3');
                return waitDdcResponse();
            }
        }
    },
    actions: {
        trustSrc: function trustSrc(url) {
            return _angular.$sce.trustAsResourceUrl(url);
        }
    }
});


_angular.$sce;

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$Component;

_squid.$elmo;

_squid.$locale;

_logger.$logger;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds-ddc/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"ddcUrl && jwt\">\n    <!-- this form uses iframe to post data because of target attribute -->\n    <form id=\"threedsDdcIframeForm\" name=\"threedsDdcIframeForm\" action=\"{{actions.trustSrc(ddcUrl)}}\" target=\"threedsDdcIframe\" method=\"post\">\n        <input type=\"hidden\" name=\"JWT\" value=\"{{jwt}}\" />\n    </form>\n    <!-- sandbox is appSec recommendation to grant limited permissions to cardinal -->\n    <iframe name=\"threedsDdcIframe\" height=\"1\" width=\"1\" style=\"display:none\" sandbox=\"allow-forms allow-pointer-lock allow-scripts allow-same-origin\">\n    </iframe>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/apis.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.authenticate3DS = exports.initThreeds = exports.getJwt = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/threeDS/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/switchPaymentsApiServ/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

var getJwt = function getJwt(payload) {

    var threeDSJWTModel = new _index.$ThreeDSJWTModel(payload);

    return threeDSJWTModel.action('jwt', {
        // hide the loading spinner
        silent: true,
        data: threeDSJWTModel.serialize(),
        success: function success(result) {
            _logger.$logger.info('3DS_JWT_SUCCESS');
            return result;
        },
        validation: function validation() {
            _logger.$logger.info('threeds_v2', {
                context_id: _angular.$rootScope.token,
                int_error_description: 'JWT_SERVICE_VALIDATION_ERROR'
            });
        },
        error: function error() {
            _logger.$logger.info('threeds_v2', {
                context_id: _angular.$rootScope.token,
                int_error_description: 'JWT_SERVICE_ERROR'
            });
        }
    });
};

var initThreeds = function initThreeds(integrationType, fundingId, payload, callback) {
    var request = {
        data: payload,
        resultModel: {},
        success: function success(result) {
            callback(_constants.STATUS_SUCCESS, result);
        },
        error: function error(err) {
            _logger.$logger.warn('INIT_3DS_UKNOWN_ERROR', {
                reason: 'init 3ds unknown error',
                error: err
            });

            _logger.$logger.info('checkout_fpti', {
                error_source: 'LOOKUP',
                error_type: 'LOOKUP_API_ERROR',
                context_id: _angular.$rootScope.token,
                int_error_description: 'INIT_3DS_UNKNOW_ERROR'
            });

            callback(_constants.STATUS_API_ERROR, err);
        },
        contingencies: {
            DEFAULT: function DEFAULT(contingency) {
                _logger.$logger.warn('INIT_3DS_UKNOWN_CONTIGENCY', {
                    reason: 'init 3ds unknown contingency',
                    error: contingency
                });

                _logger.$logger.info('checkout_fpti', {
                    context_id: _angular.$rootScope.token,
                    error_source: 'LOOKUP',
                    error_type: 'LOOKUP_RESP_ERROR',
                    int_error_description: 'INIT_3DS_ERROR'
                });

                // Do not update the session and return to merchant for IDEMPOTENCY_FAILUREs.
                if (contingency && contingency !== 'IDEMPOTENCY_FAILURE') {
                    callback(_constants.STATUS_API_ERROR, contingency);
                }
            }
        }
    };

    // hide the loading spinner
    request.silent = true;
    if (integrationType === _constants.ADD_CARD_INTEGRATION) {
        var cardConfirmationModel = new _index2.$CardConfirmationModel({ id: fundingId });

        delete request.data.fundingId;
        return cardConfirmationModel.save(request);
    } else {
        return _index3.$switch3DSLookUpModel.instance().save(request);
    }
};

var completeThreeds = function completeThreeds(integrationType, fundingId, request) {
    // hide the loading spinner
    request.silent = true;

    _logger.$logger.info('3DS_TRIGGER_AUTHENTICATE_CALL_' + integrationType + '_INTEGRATION');

    if (integrationType === _constants.ADD_CARD_INTEGRATION) {
        var cardConfirmationModel = new _index2.$CardConfirmationModel({ id: fundingId });

        return cardConfirmationModel.action('update', request);
    } else {
        return _index3.$switch3DSAuthenticateModel.instance().save(request);
    }
};

var authenticate3DS = function authenticate3DS(intType, request, onComplete, initThreedsResponse) {
    var fundingId = request.initThreedsData && request.initThreedsData.fundingId;

    return completeThreeds(intType, fundingId, {
        data: request,
        success: function success(response) {
            var status = _constants.RESPONSE_STATUS_MAPPER[response.status || response.threeDSStatus];
            var onCompleteData = {
                threeDSTransactionId: response.threeDSTransactionId,
                enrollmentStatus: response.enrollmentStatus,
                lookup: initThreedsResponse,
                threeDSStatus: response.threeDSStatus,
                threeDSEcommerceIndicator: response.threeDSEcommerceIndicator,
                signatureVerificationStatus: response.signatureVerificationStatus,
                cavv: response.cavv,
                liabilityShift: response.liabilityShift,
                threeDSVersion: response.threeDSVersion,
                threeDSUcafIndicator: response.threeDSUcafIndicator,
                authenticationThreeDSStatus: response.authenticationThreeDSStatus,
                threeDsAuthenticationReason: response.threeDsAuthenticationReason,
                cardBrandProcessed: response.cardBrandProcessed,
                accessControlServerTransactionId: response.accessControlServerTransactionId,
                authenticationType: response.authenticationType,
                cavvAlgorithm: response.cavvAlgorithm,
                directoryServerTransactionId: response.dsTransactionId,
                paypalAcquiringBin: response.paypalAcquiringBin,
                paypalAcquiringMid: response.paypalAcquiringMid,
                paresStatus: response.paresStatus,
                skipThreeDSEnforcement: response.skipThreeDSEnforcement,
                ucafIndicator: response.ucafIndicator,
                xid: response.xid
            };

            _logger.$logger.info('3DS_AUTHENTICATE_API_SUCCESS');
            if (status === 'FAILED') {
                _logger.$logger.info('checkout_fpti', {
                    context_id: _angular.$rootScope.token,
                    int_error_description: 'AUTHENTICATE_3DS_STATUS_DECLINE',
                    declined_reason: 'AUTH_DECLINE'
                });
            }
            // Send the status and response data with threeDSTransactionId as separate params, Similar to init api calls
            // what are all the possible status's retuned by Switch?
            // can we assume status is success when status is decline?
            onComplete(status === 'FAILED' ? _constants.STATUS_DECLINE : status, onCompleteData);
        },
        error: function error(err) {
            _logger.$logger.info('3DS_AUTHENTICATE_ERROR', err);
            _logger.$logger.info('checkout_fpti', {
                context_id: _angular.$rootScope.token,
                int_error_description: 'AUTHENTICATE_3DS_ERROR',
                error_source: 'AUTHENTICATE',
                error_type: 'AUTH_API_ERROR'
            });
            onComplete(_constants.STATUS_API_ERROR);
        },
        contingencies: {
            DEFAULT: function DEFAULT(contingency) {
                _logger.$logger.info('threeds_addcard_update_confirmation_contingency', contingency);
                _logger.$logger.info('checkout_fpti', {
                    context_id: _angular.$rootScope.token,
                    error_source: 'AUTHENTICATE',
                    error_type: 'AUTH_RESP_ERROR',
                    int_error_description: 'AUTHENTICATE_3DS_ERROR'
                });
                onComplete(_constants.STATUS_API_ERROR);
            }
        }
    });
};

exports.getJwt = getJwt;
exports.initThreeds = initThreeds;
exports.authenticate3DS = authenticate3DS;


_angular.$rootScope;

_index.$ThreeDSJWTModel;

_index2.$CardConfirmationModel;

_index3.$switch3DSLookUpModel;

_index3.$switch3DSAuthenticateModel;

_logger.$logger;

_constants.RESPONSE_STATUS_MAPPER;

_constants.ADD_CARD_INTEGRATION;

_constants.STATUS_API_ERROR;

_constants.STATUS_SUCCESS;

_constants.STATUS_DECLINE;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var ADD_CARD_INTEGRATION = 'ADD_CARD';
var TRANSACTION_INTEGRATION = 'TRANSACTION';
var INIT_3DS_RESPONSE_STATUS = ['FAILED', 'SUCCESS', 'CHALLENGE_REQUIRED', 'DECLINED'];

var RESPONSE_STATUS_MAPPER = {
    CHALLENGE_REQUIRED: 'STEPUP',
    FAILED: 'FAILED',
    SUCCESS: 'SUCCESS',
    DECLINED: 'FAILED',
    STEPUP: 'STEPUP'
};

var STATUS_SUCCESS = 'SUCCESS';
// API errors like 500, api not found etc.
var STATUS_API_ERROR = 'FAILURE';
// API responds with 200 but the status is set to FAILURE in response
var STATUS_DECLINE = 'DECLINE';

var CARD_TYPE_TO_NETWORK_LOGO = {
    AMEX: 'https://pics.paypal.com/00/p/NTk0ZGE4MTUtMzk5Ni00OTQ3LTlkMjctNjY5ZWY3MTBlYTEz/image_',
    VISA: 'https://pics.paypal.com/00/p/NmE4M2FmNWItODBlYi00MWIwLTgxODEtZDU3ZjAzZDI1NmJm/image_',
    MASTERCARD: 'https://pics.paypal.com/00/p/OGIxNWYzYzktMjEyMC00ZDBkLWE0YWUtOWQyMTRjNTM5ZTE2/image_'
};

var getWindowSizeMapping = function getWindowSizeMapping() {
    var returnObj = {};

    returnObj[ADD_CARD_INTEGRATION] = {
        MOBILE: '250X400',
        COMPUTER: '500X600',
        TABLET: '500X600',
        UNKNOWN: '500X600'
    };

    returnObj[TRANSACTION_INTEGRATION] = {
        MOBILE: '_250_x_400',
        COMPUTER: '_500_x_600',
        TABLET: '_500_x_600',
        UNKNOWN: '_500_x_600'
    };

    return returnObj;
};

var WINDOW_SIZE = getWindowSizeMapping();

exports.ADD_CARD_INTEGRATION = ADD_CARD_INTEGRATION;
exports.CARD_TYPE_TO_NETWORK_LOGO = CARD_TYPE_TO_NETWORK_LOGO;
exports.TRANSACTION_INTEGRATION = TRANSACTION_INTEGRATION;
exports.INIT_3DS_RESPONSE_STATUS = INIT_3DS_RESPONSE_STATUS;
exports.RESPONSE_STATUS_MAPPER = RESPONSE_STATUS_MAPPER;
exports.STATUS_API_ERROR = STATUS_API_ERROR;
exports.STATUS_SUCCESS = STATUS_SUCCESS;
exports.STATUS_DECLINE = STATUS_DECLINE;
exports.WINDOW_SIZE = WINDOW_SIZE;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-wallet-components/src/three-ds/styles.less");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/template.html");

var _template2 = _interopRequireDefault(_template);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/utils.js");

var _outputMapper = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/outputMapper.js");

var _inputMapper = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/inputMapper.js");

var _apis = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/apis.js");

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

__webpack_require__("../node_modules/xo-wallet-components/src/three-ds-ddc/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThreeDs', {
    tag: 'xo-three-ds',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        referenceId: {
            type: 'var',
            required: true
        },
        jwtInfo: {
            type: 'var',
            required: true
        },
        networkLogo: {
            type: 'var',
            required: true
        },
        cardBin: {
            type: 'var',
            required: true
        },
        ddcUrl: {
            type: 'var',
            required: true
        },
        // Default value is zero
        networkLogoSizeId: {
            type: 'var',
            required: false
        },
        integrationType: {
            type: 'var',
            required: false
        },
        initThreedsData: {
            type: 'var',
            required: false
        },
        onComplete: {
            type: 'var',
            required: false
        },
        cardBrand: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.networkLogoSizeId = this.networkLogoSizeId || 0;
            this.challengeOn = false;
            this.spinnerMessageKey = (0, _utils.getLoadingSpinnerMessageKey)();

            this.networkLogo = this.networkLogo || {};

            // networkLogo information is available even before this
            // this directive render is triggered, so lets get it ready in enter fn
            var imageExtension = (this.networkLogo.original_mime_type || 'image/png').split('/')[1];

            // data validation
            if (!this.jwtInfo.jwtIssuer || !this.jwtInfo.jwtOrgUnitId) {
                _logger.$logger.error('3DS_JWTINFO_INVALID', this.jwtInfo);
                return this.onComplete(_constants.STATUS_API_ERROR);
            }

            // If network logo is missing in api response then load it from static urls
            if (!this.networkLogo.base_cdn_link_path) {
                _logger.$logger.info('3DS_NETWORK_LOGO_MISSING_IN_CONTINGENCY_DATA', {
                    cardBrand: this.cardBrand
                });
                this.networkLogo = {
                    base_cdn_link_path: _constants.CARD_TYPE_TO_NETWORK_LOGO[this.cardBrand] || ''
                };
            }

            _logger.$logger.info('3DS_NETWORK_LOGO_DISPLAY_PARAMS', {
                baseCdnLinkPath: this.networkLogo.base_cdn_link_path,
                imageExtension: imageExtension,
                networkLogoSizeId: this.networkLogoSizeId
            });

            this.networkLogoBackgroundStyle = {
                'background-image': 'url("' + this.networkLogo.base_cdn_link_path + this.networkLogoSizeId + '.' + imageExtension + '")'
            };
            this.showNetworkLogo = !!this.networkLogo.base_cdn_link_path;

            // Spinner messages
            var index = 0;
            var loadMessages = function loadMessages() {
                // keep the index to last message 'threeDS.preLoadCaution' so that after
                // cardinal iframe is hidden, we show a generic message to user
                if (index > 2) {
                    index = 2;
                    _angular.$interval.cancel(_this.loaderInterval);
                }
                _this.spinnerMessageKey = (0, _utils.getLoadingSpinnerMessageKey)(index);
                index++;
            };

            // loading spinner message changes every 3 seconds and then sticks to the last message
            this.loaderInterval = (0, _angular.$interval)(function () {
                loadMessages(index);
            }, 3000);

            // Setup a callback function on window object
            // This fn is called when cardinal returns to our app after successful OTP validation
            // cardinalToken is the ecToken we have in the url
            _angular.$window.completeThreedsFrame = function (cardinalResponse) {
                var cardinalTransactionId = void 0;

                // cardinalResponse.MD is also available which nothing but EC/WPS token
                cardinalTransactionId = cardinalResponse.TransactionId;
                _logger.$logger.info('threeds_v2', {
                    from: '3DS_CHALLENGE',
                    to: '3DS_CHALLENGE_END',
                    challenge_end_time: Date.now(),
                    context_id: _angular.$rootScope.token,
                    '3ds_ref_id': _this.referenceId,
                    '3ds_authenticate_id': cardinalTransactionId
                });
                // call onComplete with failure status if transactionId is missing in
                // cardinal response before/after stepup iframe is shown to user
                // NOTE: if invalid data is passed to cardinal iframe, then cardinal
                // calls returnUrl without showing the OTP screen
                if (!cardinalTransactionId) {
                    _this.challengeOn = false;
                    _this.onComplete(_constants.STATUS_DECLINE);
                    // no need to call authenticate in case of failure
                    return;
                }

                _this.challengeOn = false;

                // FI Request
                var fiReq = {
                    token: _angular.$rootScope.token,
                    referenceId: _this.referenceId,
                    initThreedsData: _this.initThreedsData,
                    initThreedsResponse: _this.initThreedsResponse,
                    transactionId: cardinalTransactionId,
                    confirmationId: _this.initThreedsResponse.confirmationId,
                    confirmationStatus: 'CONFIRMED',
                    confirmationMethod: _this.initThreedsData.confirmationMethod,
                    cvv: _this.initThreedsData.cvv
                };
                // Switch Request
                var switchReq = {
                    threeDsServerTransactionId: cardinalTransactionId,
                    authenticatePayload: _this.lookUpPayload,
                    amount: _this.amount,
                    logResolve: _this.initThreedsData.logResolve,
                    paymentAuthenticationRequest: _this.initThreedsResponse.payload,
                    productDetails: _this.initThreedsData.productDetails
                };
                _logger.$logger.info('SWITCH_REQUEST_AMOUNT', Object.assign({}, _this.amount));
                var request = _this.integrationType === _constants.ADD_CARD_INTEGRATION ? fiReq : switchReq;

                (0, _apis.authenticate3DS)(_this.integrationType, request, _this.onComplete, _this.initThreedsResponse);
            };

            // watch for id "threedsIframeForm" to be present in dom to trigger
            // cardinal iframe display
            this.$watch(function () {
                return $('#threedsIframeForm').length;
            }, function (newVal) {
                if (_this.challengeOn && newVal === 1) {
                    $('#threedsIframeForm').submit();
                }
            });
        },
        populate: function populate() {
            var _this2 = this;

            // Iframe window message
            this.onstepupPageLoad = function () {
                _logger.$logger.info('threeds_v2', {
                    from: '3DS_CHALLENGE',
                    to: '3DS_CHALLENGE_PAGE_LOADED',
                    challenge_time: Date.now(),
                    context_id: _angular.$rootScope.token,
                    '3ds_ref_id': _this2.referenceId
                });
                _logger.$logger.flush(true);
            };

            this.onstepupPageError = function () {
                _logger.$logger.info('threeds_v2', {
                    from: '3DS_CHALLENGE',
                    to: '3DS_CHALLENGE_PAGE_ERRORED',
                    challenge_time: Date.now(),
                    context_id: _angular.$rootScope.token,
                    '3ds_ref_id': _this2.referenceId
                });
                _logger.$logger.flush(true);
            };

            // Show challenge iframe
            this.showChallengeIframe = function (stepupUrl, stepupJwt) {
                // set all variables required for challenge iframe
                _this2.stepupUrl = stepupUrl;
                _this2.stepupJwt = stepupJwt;

                // render challenge page
                _this2.showNetworkLogo = false;
                _this2.challengeOn = true;
                _angular.$window.onstepupPageLoad = _this2.onstepupPageLoad;
                _angular.$window.onstepupPageError = _this2.onstepupPageError;
            };

            return (0, _apis.getJwt)({
                referenceId: this.referenceId,
                cardBin: this.cardBin,
                jwtInfo: this.jwtInfo
            }).then(function (result) {
                _logger.$logger.info('threeds_v2', {
                    from: '3DS_DDC',
                    to: '3DS_DDC_START',
                    ddc_start_time: Date.now(),
                    context_id: _angular.$rootScope.token,
                    '3ds_ref_id': _this2.referenceId
                });

                // set jwt and triggerDDC before showing the networkLogo modal window
                _this2.jwt = result;
                _this2.triggerDDC = true;
            })['catch'](function (err) {
                _logger.$logger.warn('3DS_GET_JWT_ERROR', { message: err.message, stack: err.stack });
                _this2.actions.ddcDoneCallback();
            });
        }
    },
    actions: {
        ddcDoneCallback: function ddcDoneCallback() {
            var request = (0, _inputMapper.get3DSLooksRequest)(this.integrationType, this.initThreedsData);
            // Need this variable to send in switch authenticate call

            this.lookUpPayload = request.lookUpPayload;
            this.amount = request.amount;
            _logger.$logger.info('3DS_Lookup_Request_Amount', Object.assign({}, this.amount));
            _logger.$logger.info('threeds_v2', {
                from: '3DS_LOOKUP',
                to: '3DS_LOOKUP_START',
                lookup_start_time: Date.now(),
                context_id: _angular.$rootScope.token,
                '3ds_ref_id': this.referenceId
            });

            // upon completion, initThreedsCallback is called
            (0, _apis.initThreeds)(this.integrationType, this.initThreedsData.fundingId, request, this.actions.initThreedsCallback);
        },
        initThreedsCallback: function initThreedsCallback(status, response) {
            var _this3 = this;

            if (status === _constants.STATUS_API_ERROR) {
                _logger.$logger.info('3DS_INIT_FAILED_CALLING_ONCOMPLETE_CALLBACK');
                _logger.$logger.flush(true);
                this.onComplete(_constants.STATUS_API_ERROR);
                return;
            }
            this.initThreedsResponse = (0, _outputMapper.initThreedsResponseMapper)(response, this.integrationType);
            var threedsResponse = {
                threeDSTransactionId: this.initThreedsResponse.threeDSTransactionId,
                lookup: this.initThreedsResponse
            };
            if (this.initThreedsData.unbrandedPaymentIndicator && this.initThreedsData.sendCardinalTransactionId && this.initThreedsResponse.status === 'STEPUP') {
                _angular.$window.cardinalTransactionIdForAcsTimeOut = this.initThreedsResponse.threeDsProcessorTraceNumber || this.initThreedsResponse.threeDSTransactionId;
                if (_angular.$window.callUpdateTimerFromXOWallets) {
                    _angular.$window.callUpdateTimerFromXOWallets();
                }
            }
            // load the iframe when stepUpUrl and status is STEPUP
            if (this.initThreedsResponse.status === 'STEPUP' && this.initThreedsResponse.stepUpUrl) {
                var jwtreq = (0, _inputMapper.challengeJwtInputMapper)(this.referenceId, this.jwtInfo, this.initThreedsResponse);

                var stepUpUrl = this.initThreedsResponse.stepUpUrl;

                (0, _apis.getJwt)(jwtreq).then(function (jwtResponse) {
                    _logger.$logger.info('threeds_v2', {
                        from: '3DS_CHALLENGE',
                        to: '3DS_CHALLENGE_START',
                        challenge_start_time: Date.now(),
                        context_id: _angular.$rootScope.token,
                        '3ds_ref_id': _this3.referenceId
                    });
                    _logger.$logger.info('SHOW_IFRAME_STEPUP_URL_AND_JWT_CARDINAL_REQUEST', {
                        'stepupUrl': stepUpUrl,
                        'jwtResponse': jwtResponse,
                        token: _angular.$rootScope.token
                    });
                    _logger.$logger.flush(true);
                    _this3.showChallengeIframe(stepUpUrl, jwtResponse);
                })['catch'](function (err) {
                    // todo: do we need to decline for getJwt call?
                    _logger.$logger.warn('GET_JWT_STEPUP_UNKNOWN_ERROR', {
                        reason: 'get jwt failed before loading stepupurl',
                        error: err
                    });
                    _this3.onComplete(_constants.STATUS_API_ERROR);
                });
            } else if (this.initThreedsResponse.status === 'SUCCESS') {
                _logger.$logger.info('INIT_3DS_STATUS_SUCCESS_NO_ACS_URL');

                this.onComplete(_constants.STATUS_SUCCESS, threedsResponse);
            } else if (this.initThreedsResponse.status === 'FAILED') {
                _logger.$logger.info('INIT_3DS_STATUS_FAILED');
                _logger.$logger.info('checkout_fpti', {
                    context_id: _angular.$rootScope.token,
                    declined_reason: 'LOOKUP_DECLINE'
                });

                this.onComplete(_constants.STATUS_DECLINE, threedsResponse);
            } else {
                // all other cases
                delete response.cavv; // do not log cavv
                _logger.$logger.info('3DS_INIT_FAILED_CALLING_ONCOMPLETE_CALLBACK', { response: response });
                this.onComplete(_constants.STATUS_API_ERROR);
            }
        },
        trustSrc: function trustSrc(url) {
            return _angular.$sce.trustAsResourceUrl(url);
        }
    }
});


_angular.$sce;

_angular.$window;

_angular.$interval;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_utils.getLoadingSpinnerMessageKey;

_outputMapper.initThreedsResponseMapper;

_inputMapper.get3DSLooksRequest;

_inputMapper.challengeJwtInputMapper;

_apis.getJwt;

_apis.initThreeds;

_apis.authenticate3DS;

_constants.ADD_CARD_INTEGRATION;

_constants.CARD_TYPE_TO_NETWORK_LOGO;

_constants.STATUS_API_ERROR;

_constants.STATUS_SUCCESS;

_constants.STATUS_DECLINE;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/inputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.challengeJwtInputMapper = exports.get3DSLooksRequest = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/utils.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var get3DSLooksRequest = function get3DSLooksRequest(integrationType, payLoad) {

    if (integrationType === 'ADD_CARD') {
        var request = Object.assign({}, payLoad);

        delete request.fundingId;
        request.senderContext = (0, _utils.getSenderContext)();
        return request;
    }

    var browserInfo = (0, _utils.getBrowserDetails)(integrationType);

    var threeDSContingencySource = payLoad.threeDSContingencySource,
        threeDSContingencyReason = payLoad.threeDSContingencyReason,
        merchantCategoryCode = payLoad.merchant_category_code;


    var billingAddress = Object.assign({}, payLoad.billing_address);

    billingAddress.country = billingAddress.country_code;
    billingAddress.postalCode = billingAddress.postal_code;

    // xobuyernodeserv doesn't like these variables. since schema doesnt support them.
    delete billingAddress.country_code;
    delete billingAddress.postal_code;
    delete billingAddress.is_partial;

    var lookUpPayload = {
        threeDSReferenceId: payLoad.referenceId,
        flowId: 'HERMES',
        billingAddress: billingAddress,
        encryptedCardNumber: payLoad.number_encrypted,
        creditCardId: payLoad.creditCardId,
        cardUsage: payLoad.card_product_class,
        expirationMonth: payLoad.expire_month,
        expirationYear: payLoad.expire_year,
        cardTransactionCharacteristics: 'PRE_AUTH',
        threeDSContingencySource: threeDSContingencySource,
        threeDSContingencyReason: threeDSContingencyReason,
        merchantCategoryCode: merchantCategoryCode,
        unbrandedPaymentIndicator: payLoad.unbrandedPaymentIndicator
    };

    if (!billingAddress.country) {
        // don't send billingAddress without country
        delete lookUpPayload.billingAddress;
    }
    _logger.$logger.info('threeds_lookup_payload_amount', Object.assign({}, payLoad.amount));
    return {
        lookUpPayload: lookUpPayload,
        amount: payLoad.amount,
        browserInfo: browserInfo,
        logResolve: payLoad.logResolve,
        productDetails: payLoad.productDetails,
        partnerDetails: payLoad.partnerDetails
    };
};

var challengeJwtInputMapper = function challengeJwtInputMapper(referenceId, jwtInfo, initThreedsResponse) {
    return {
        jwtInfo: jwtInfo,
        referenceId: referenceId,
        returnUrl: _angular.$window.location.origin + _squid.$config.urls.baseUrl + '/processThreedsConfirmation',
        redirectUrl: initThreedsResponse.redirectUrl,
        /**
         * for switch api call  we need to read the processor trace number and to get used in challenge jwt
         * for FI api we need to use transaction id, but transaction id is returned from both the apis
         * so look for processor trace number in response , if exists use that  if not go for transaction id
         * so that it will not break FI api call and switch api is also happy.
         */
        transactionId: initThreedsResponse.threeDsProcessorTraceNumber || initThreedsResponse.threeDSTransactionId,
        paymentAuthenticationRequest: initThreedsResponse.payload
    };
};

exports.get3DSLooksRequest = get3DSLooksRequest;
exports.challengeJwtInputMapper = challengeJwtInputMapper;


_squid.$config;

_angular.$window;

_utils.getSenderContext;

_utils.getBrowserDetails;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/outputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.initThreedsResponseMapper = undefined;

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

var initThreedsResponseMapper = function initThreedsResponseMapper(response, integrationType) {
    // FI response mapper
    if (integrationType === _constants.ADD_CARD_INTEGRATION) {
        // possible response.status values - STEPUP FAILED SUCCESS
        return {
            status: _constants.RESPONSE_STATUS_MAPPER[response.status],
            redirectUrl: response.redirectUrl && response.redirectUrl.href, // acs is redirect url - which needs to be in jwt payload
            stepUpUrl: response.stepUpUrl && response.stepUpUrl.href, // redirect is step up which is used for loading iframe
            threeDSTransactionId: response.transactionId,
            payload: response.payload,
            confirmationId: response.confirmationId
        };
    }

    // switch response mapper
    if (_constants.INIT_3DS_RESPONSE_STATUS.indexOf(response.threeDSStatus) > -1) {
        return {
            status: _constants.RESPONSE_STATUS_MAPPER[response.threeDSStatus],
            redirectUrl: response.acsURL && response.acsURL.href, // acs is redirect url - which needs to be in jwt payload
            stepUpUrl: response.redirectURL && response.redirectURL.href, // redirect is step up which is used for loading iframe
            threeDSTransactionId: response.transactionId,
            payload: response.paymentAuthenticationRequest,
            confirmationId: response.threeDsServerTransactionId,
            threeDsProcessorTraceNumber: response.threeDsProcessorTraceNumber,
            liabilityShift: response.liabilityShift,
            signatureVerificationStatus: response.signatureVerificationStatus,
            cardBrandProcessed: response.cardBrandProcessed,
            threeDSEcommerceIndicator: response.threeDSEcommerceIndicator,
            threeDSUcafIndicator: response.threeDSUcafIndicator,
            cavv: response.cavv,
            enrollmentStatus: response.enrollmentStatus,
            threeDsAuthenticationReason: response.threeDsAuthenticationReason,
            accessControlServerTransactionId: response.accessControlServerTransactionId,
            authenticationThreeDSStatus: response.authenticationThreeDSStatus,
            authenticationType: response.authenticationType,
            cavvAlgorithm: response.cavvAlgorithm,
            directoryServerTransactionId: response.dsTransactionId,
            paypalAcquiringBin: response.paypalAcquiringBin,
            paypalAcquiringMid: response.paypalAcquiringMid,
            paresStatus: response.paresStatus,
            skipThreeDSEnforcement: response.skipThreeDSEnforcement,
            ucafIndicator: response.ucafIndicator,
            xid: response.xid
        };
    }

    return {};
};

exports.initThreedsResponseMapper = initThreedsResponseMapper;


_constants.ADD_CARD_INTEGRATION;

_constants.INIT_3DS_RESPONSE_STATUS;

_constants.RESPONSE_STATUS_MAPPER;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"threeDSContainer\" content>\n    <div class=\"threeDSModalContainer\" id=\"iframeContainer\">\n        <div class=\"logo\"></div>\n        <div ng-class=\"{ 'showNetworkLogo': showNetworkLogo }\" ng-if=\"!challengeOn\">\n            <div class=\"staticSpinner\">\n                <div class=\"spinWrap\">\n                    <p class=\"spinnerImage\"></p>\n                    <p class=\"loader\"></p>\n                </div>\n                <p class=\"loadingMessage\">\n                    <span  ng-bind-html=\"htmlContent(spinnerMessageKey)\"></span>...\n                </p>\n            </div>\n            <div class=\"networkLogo\">\n                <span class=\"{{'sizeId_' + networkLogoSizeId}}\" ng-style=\"networkLogoBackgroundStyle\"></span>\n            </div>\n        </div>\n        <div class=\"cardinalIframeContainer\" ng-if=\"challengeOn\">\n            <h3 class=\"infoHeader\" ng-bind-html=\"htmlContent('threeDS.iFrameTitle')\"></h3>\n            <!-- this form uses iframe to post data because of target attribute -->\n            <form id=\"threedsIframeForm\" name=\"threedsIframeForm\" action=\"{{actions.trustSrc(stepupUrl)}}\" target=\"threedsIframeV2\" method=\"post\">\n                <input type=\"hidden\" name=\"JWT\" value=\"{{stepupJwt}}\" />\n                <input type=\"hidden\" name=\"MD\" value=\"{{token}}\" />\n            </form>\n            <!-- sandbox is appSec recommendation to grant limited permissions to cardinal -->\n            <iframe id=\"threedsIframeV2\" name=\"threedsIframeV2\" frameborder=\"0\" sandbox=\"allow-forms allow-pointer-lock allow-scripts allow-same-origin\" onload=\"window.onstepupPageLoad && onstepupPageLoad()\" onerror=\"window.onstepupPageError && onstepupPageError()\" ></iframe>\n        </div>\n    </div>\n    <xo-three-ds-ddc\n        ng-if=\"triggerDDC\"\n        jwt=\"jwt\"\n        ddc-url=\"ddcUrl\"\n        done-callback=\"actions.ddcDoneCallback\">\n    </xo-three-ds-ddc>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getLoadingSpinnerMessageKey = exports.getBrowserDetails = exports.getSenderContext = undefined;

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var getPaymentMode = function getPaymentMode(capabilities) {
    var mode = 'UNKNOWN';

    if (capabilities.isDesktop) {
        mode = 'COMPUTER';
    } else if (capabilities.isTablet) {
        mode = 'TABLET';
    } else if (capabilities.isMobile) {
        mode = 'MOBILE';
    }
    return mode;
};

var getBrowserDetails = function getBrowserDetails() {
    var integrationType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.ADD_CARD_INTEGRATION;

    var paymentMode = getPaymentMode(_index.$DeviceInfo.getCapabilities());
    var windowSize = void 0;

    // TODO: revisit this code once cardinal fix their code to make sure
    // the iframe content is responsive
    // Mobile - for all mobile devices hardcode size to smallest one
    // Desktop - hardcode size to 500x600 as our modal window is 560x600
    // NOTE: with cardinal fix, mobile will be FULL_PAGE and
    //       other devices will be 500x600
    windowSize = _constants.WINDOW_SIZE[integrationType] && _constants.WINDOW_SIZE[integrationType][paymentMode];

    _logger.$logger.info('3DS_V2_WINDOW_SIZE_' + windowSize);

    return {
        windowSize: windowSize || 'FULL_PAGE',
        javaEnabled: window.navigator && window.navigator.javaEnabled(),
        language: window.navigator && window.navigator.language && angular.isString(window.navigator.language) && window.navigator.language.split('-')[0],
        colorDepth: window.screen && window.screen.colorDepth,
        screenHeight: window.innerHeight,
        screenWidth: window.innerWidth,
        userAgent: window.navigator && window.navigator.userAgent,
        timeZoneOffset: new Date().getTimezoneOffset()
    };
};

var getSenderContext = function getSenderContext() {
    var senderContext = {
        browserDetails: getBrowserDetails(),
        paymentMode: getPaymentMode(_index.$DeviceInfo.getCapabilities()),
        deviceChannel: 'BROWSER'
    };

    return senderContext;
};

var getLoadingSpinnerMessageKey = function getLoadingSpinnerMessageKey(index) {
    var messageKeys = ['threeDS.preLoadContactIssuer', 'threeDS.preLoadWaitMessage', 'threeDS.preLoadCaution'];

    // if index === 0 then the default return statement
    // returns messageKeys[0]
    if (index && index > 0 && index < messageKeys.length) {
        return messageKeys[index];
    }

    return messageKeys[0];
};

exports.getSenderContext = getSenderContext;
exports.getBrowserDetails = getBrowserDetails;
exports.getLoadingSpinnerMessageKey = getLoadingSpinnerMessageKey;


_index.$DeviceInfo;

_constants.ADD_CARD_INTEGRATION;

_constants.WINDOW_SIZE;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-amount/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-amount/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-amount/styles.less");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTopupAmountDirective', {
    tag: 'xo-topup-amount',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve(),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        selectAmount: function selectAmount(amount) {
            this.models.walletPreferences.topup.amount = amount;
            this.success();
        }
    },

    lifecycle: {
        enter: function enter() {
            this.topupAmounts = _squid.$config.topup.topupAmounts;
            this.locale = _squid.$locale;
        },
        populate: function populate() {
            if (this.models.walletPreferences.topup.amount && this.topupAmounts.indexOf(this.models.walletPreferences.topup.amount) === -1) {
                this.topupAmounts.push(this.models.walletPreferences.topup.amount);
                this.topupAmounts.sort(function (a, b) {
                    return parseInt(a, 10) - parseInt(b, 10);
                });
            }
        }
    }
});


_squid.$Component;

_squid.$config;

_squid.$locale;

_fi.$WalletPreferences;

_app.$TokenizedWalletInfoModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-amount/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTopupAmountRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-amount/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTopupAmountRoute = exports.$xoTopupAmountRoute = _index.$Route.extend('$xoTopupAmountRoute', {
    path: 'topupAmount',
    directive: _directive2['default'],
    children: []
});

exports['default'] = $xoTopupAmountRoute;

angular.value("$xoTopupAmountRoute", $xoTopupAmountRoute);
_index.$Route;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-amount/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-amount/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"topupAmountList\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.topupAmount'\n                     hidex=\"true\"\n                     header-left=\"common.back\"\n                     header-left-link=\"success\"\n                     header-left-icon=\"true\"></xo-aside-header>\n    <div class=\"content\">\n        <div tabindex=\"-1\" focus-when=\"true\">{{ content(\"topup.commonTopupAmountDesc\", { type: this.models.tokenizedWalletInfoModel.brandName() } ) }}</div>\n        <ul>\n            <li ng-repeat=\"amount in topupAmounts track by $index\">\n                <a class=\"listItem\" ng-click=\"actions.selectAmount(amount)\" focusable>\n                    <format-currency class=\"formatCurrency amount\" code=\"models.walletPreferences.topup.currency\"\n                                     amount=\"amount\"\n                                     currency-style=\"Currency\"></format-currency>\n                    <span class=\"checkIcon\" ng-if=\"amount === models.walletPreferences.topup.amount\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-funding/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-funding/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-funding/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTopupFundingDirective', {
    tag: 'xo-topup-funding',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();

            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve(),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                })
            };
        }
    },

    actions: {
        selectFundingSource: function selectFundingSource(id) {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                walletPreferences = _models.walletPreferences,
                tokenizedFundingCapabilitiesModel = _models.tokenizedFundingCapabilitiesModel;


            if (walletPreferences.getPreferred().instrument_id !== id) {
                if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                    // Extract the matching topup instrument_id for a given id
                    walletPreferences.topup.fundingSource = _squid.$util.find(checkoutSession.topupFundingSources, function (fs) {
                        return fs.instrument_id === id;
                    });
                } else {
                    // Extract the matching direct_funding instrument_id for a given id
                    walletPreferences.direct.fundingSource = _squid.$util.find(checkoutSession.futurePaymentInstruments, function (fs) {
                        return fs.instrument_id === id;
                    });
                }

                // PatchXO api call for tokenization flows when instrument is changed from Wallet page
                this.models.checkoutSession.action('setTopupFI', {
                    data: {
                        instrument_id: id
                    }
                });
            }
            this.props.success();
        },
        addCard: function addCard() {
            _uiRouter.$state.go('.sidepageAddCard.addCardFlow.addCard');
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.addCardCallbacks = {
                finish: function finish() {
                    if (_this.models.checkoutSession.selectedTopupFundingSource) {
                        _this.models.walletPreferences.topup.fundingSource = _this.models.checkoutSession.selectedTopupFundingSource;
                    }
                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
                    (0, _angular.$timeout)(function () {
                        return _uiRouter.$state.go('checkout.review');
                    }, 300);
                },
                cancel: function cancel() {
                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
                    (0, _angular.$timeout)(function () {
                        return _uiRouter.$state.go('^.^.^');
                    }, 300);
                }
            };

            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };

            /**
             * Get the list of funding sources to display in the wallet page
             */
            this.fundingSourcesList = function () {
                var _models2 = this.models,
                    tokenizedFundingCapabilitiesModel = _models2.tokenizedFundingCapabilitiesModel,
                    checkoutSession = _models2.checkoutSession;
                var topupFundingSources = checkoutSession.topupFundingSources,
                    futurePaymentInstruments = checkoutSession.futurePaymentInstruments;


                if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                    return topupFundingSources;
                } else {
                    // Filter only the Bank accounts for direct funding
                    return futurePaymentInstruments.filter(function (instrument) {
                        return instrument.type === 'BANK';
                    });
                }
            };
        },

        populate: function populate() {
            $('#topupFundingList').css('height', function () {
                return window.innerHeight || document.documentElement && document.documentElement.clientHeight;
            });
        }
    }
});


_angular.$timeout;

_uiRouter.$state;

_squid.$Component;

_squid.$locale;

_squid.$util;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedFundingCapabilitiesModel;

_auth.$AuthModel;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-funding/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTopupFundingRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-funding/directive.js");

var _directive2 = _interopRequireDefault(_directive);

__webpack_require__("./pages/xo-sidepage-add-card/route.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTopupFundingRoute = exports.$xoTopupFundingRoute = _index.$Route.extend('$xoTopupFundingRoute', {
    path: 'topupFunding',
    directive: _directive2['default'],
    children: [{
        name: '$SidepageAddCardRoute',
        attributes: {
            token: 'token',
            callbacks: 'addCardCallbacks'
        }
    }]
});

exports['default'] = $xoTopupFundingRoute;

angular.value("$xoTopupFundingRoute", $xoTopupFundingRoute);
_index.$Route;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-funding/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/topup-funding/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"topupFundingList\" class=\"aside\" modal-box content>\n    <xo-aside-header ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\" heading='asideHeader.topupFunding'\n                     hidex=\"true\"\n                     header-left-link=\"success\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"\n                     header-right=\"fundingInstruments.addDebitCard=\"\n                     header-right-link=\"'checkout.review.sidepage.topupFunding.sidepageAddCard.addCardFlow.addCard'\"\n                     header-right-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header ng-if=\"!models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\" heading='asideHeader.paymentMethod'\n                     hidex=\"true\"\n                     header-left-link=\"success\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"></xo-aside-header>\n\n    <div class=\"content\">\n        <div tabindex=\"-1\" focus-when=\"true\">{{ content(\"tokenization.chooseOptionToPay\", { type: this.models.tokenizedWalletInfoModel.brandName() }) }}</div>\n        <ul>\n            <li ng-repeat=\"fundingSource in fundingSourcesList() track by $index\" focusable>\n                <a class=\"listItem noLink\" ng-click=\"actions.selectFundingSource(fundingSource.instrument_id)\">\n                    <span class=\"walletIcons\" ng-class=\"[fundingSource.type,\n                                                        instrumentIconId(fundingSource.name),\n                                                        fundingSource.card_type]\"></span>\n                    <div class=\"fsItem\">\n                        <div>{{fundingSource.name}}</div>\n                        <div>••••{{fundingSource.last4}}</div>\n                        <span class=\"checkIcon\" ng-if=\"fundingSource.instrument_id === models.walletPreferences.getPreferred().instrument_id\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en' && fundingSource.instrument_id === models.walletPreferences.getPreferred().instrument_id\">Selected</span>\n                    </span>\n                    </div>\n                </a>\n            </li>\n            <li ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n                <a href=\"#\" prevent-default link-button ng-click=\"actions.addCard()\" class=\"submit listItem addccLink\">\n                    <span class=\"icon\"></span>\n                    <span class=\"description\">{{content('fundingInstruments.addDebitCard')}}</span>\n                </a>\n            </li>\n            <li ng-if=\"!models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n                <div class=\"disclaimer\">{{content('tokenization.onlyConfirmedBanksShown', {type: models.tokenizedWalletInfoModel.brandName()} )}}</div>\n            </li>\n        </ul>\n    </div>\n</section>\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/update-pin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-ui-components/src/mobile-pin/directive.js");

var _index = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/topup/update-pin/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/topup/update-pin/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoUpdatePinDirective', {
    tag: 'xo-update-pin',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('tokenized_wallet', {
                'from': 'PINSETUP',
                'to': 'PREPARE_PINSETUP'
            });
        }
    },

    controller: function controller($scope) {

        var currentPin = '';

        $scope.madeAttempt = false;
        $scope.pinError = '';
        $scope.pinChanged = false;

        function done(pinValue) {
            _index.$TokenizedWalletPinModel.instance(_angular.$rootScope.token).retrieve().then(function (WalletPinModel) {
                WalletPinModel.userPin = pinValue;
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'PINSETUP',
                    'to': 'PROCESS_PINSETUP'
                });
                (0, _angular.$timeout)(function () {
                    return _uiRouter.$state.go('checkout.review');
                }, 1500);
            });
        }

        $scope.pinComplete = function (result) {

            var value = result && result.value;

            if (result && result.error === 'pin_too_simple') {
                $scope.pinError = 'toEasy';
                $scope.madeAttempt = false;
                currentPin = '';
                $scope.$broadcast('resetPin');
                return;
            }

            $scope.pinChanged = $scope.madeAttempt && currentPin === value;
            $scope.pinError = $scope.madeAttempt && !$scope.pinChanged ? 'missMatch' : '';
            currentPin = $scope.madeAttempt ? '' : value; // reset old pin if already made an attempt
            $scope.madeAttempt = !$scope.madeAttempt; // flip flag

            if (!$scope.pinChanged) {
                $scope.$broadcast('resetPin');
            } else {
                done(value);
            }
        };
    }
});


_angular.$timeout;

_uiRouter.$state;

_squid.$Component;

_logger.$logger;

_index.$TokenizedWalletPinModel;

_angular.$rootScope;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/update-pin/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoUpdatePinRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/topup/update-pin/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoUpdatePinRoute = exports.$xoUpdatePinRoute = _index.$Route.extend('$xoUpdatePinRoute', {
    path: 'updatePin',
    directive: _directive2['default'],
    children: []
});
exports['default'] = $xoUpdatePinRoute;

angular.value("$xoUpdatePinRoute", $xoUpdatePinRoute);
_index.$Route;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/update-pin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/topup/update-pin/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"updatePin\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.inStorePin'\n                    hidex=\"true\"\n                    header-left=\"common.back\"\n                    header-left-link=\"success\"\n                    header-left-icon=\"true\"></xo-aside-header>\n    <div class=\"pinError\" ng-if=\"pinError\">\n        <div class=\"errorIcon\"></div>\n        <div class=\"errorText\">\n            <span ng-if=\"pinError==='missMatch'\">{{content('review.pinMissMatch')}}</span>\n            <span ng-if=\"pinError==='toEasy'\">{{content('review.pinEasy')}}</span>\n        </div>\n    </div>\n    <div class=\"content\">\n        <div class=\"pinUpdate\" ng-if=\"!pinChanged\">\n            <xo-mobile-pin done=\"pinComplete\"></xo-mobile-pin>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && !madeAttempt\">{{content('review.pinFirstEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && madeAttempt\">{{content('review.pinSecondEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"pinMissMatch\">{{content('review.pinBadEntry')}}</div>\n            <div class=\"secondarySubtext\">{{content('review.pinSubText')}}</div>\n        </div>\n        <div class=\"pinSuccess\" ng-if=\"pinChanged\">\n            <div class=\"successGif\"></div>\n            <div class=\"successText\">{{content('review.pinChanged')}}</div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-webpack-config/polyfills.js":
/***/ (function(module, exports, __webpack_require__) {

// array
__webpack_require__("../node_modules/core-js/fn/array/find.js");
__webpack_require__("../node_modules/core-js/fn/array/includes.js");

// string
__webpack_require__("../node_modules/core-js/fn/string/includes.js");


// object
__webpack_require__("../node_modules/core-js/fn/object/entries.js");
__webpack_require__("../node_modules/core-js/fn/object/values.js");
__webpack_require__("../node_modules/core-js/fn/object/assign.js");




/***/ }),

/***/ "./css/app.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./js/app.js":
/***/ (function(module, exports, __webpack_require__) {



var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _middleware = __webpack_require__("./js/lib/middleware.js");

var _route = __webpack_require__("./pages/xo-checkout/route.js");

var _route2 = _interopRequireDefault(_route);

var _metricLogger = __webpack_require__("./js/lib/metricLogger.js");

__webpack_require__("./css/app.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_logger.$logger.info('app_bootstrap', {
    hash: window.location.hash
});

(0, _metricLogger.metricCounter)('app_bootstrap', {
    hash: window.location.hash
});

var logHashChangeMetrics = function logHashChangeMetrics() {
    (0, _metricLogger.metricCounter)('app_hashchange', { hash: window.location.hash });
};

window.addEventListener('hashchange', logHashChangeMetrics);

var xoCheckoutRoute = new _route2['default']();

xoCheckoutRoute.bootstrap('checkout.landing', _middleware.$Middleware);

window.bootstrap = true;

_logger.$logger;

_middleware.$Middleware;

_metricLogger.metricCounter;

/***/ }),

/***/ "./js/bootstrap.js":
/***/ (function(module, exports, __webpack_require__) {



var _constants = __webpack_require__("./js/lib/constants.js");

// set public path for chunks on the fly
// more details - https://webpack.js.org/guides/public-path/#on-the-fly
// without it - webpack doesn't know how to resolve path for assets stored in webpack -> output (.build/js)
// in development: staticUrl will be /webapps/hermes/static in case of Hermes
// in production: staticUrl will be pointing to CDN, e.g https://www.paypalobjects.com/web/res/6e6/9af00bdfc93477f08ba3fe44e9589
__webpack_require__.p = window.meta.staticUrl + '/'; // eslint-disable-line no-undef


window.main = true;

// Angular 1.6.9 adds a `!` as a hash prefix to the url by default.
// This is different behavior than Angular 1.4.7 which didn't add
// a hash prefix. The code snippet below will prevent the hash prefix
// from being added so that after the Angular 1.6.9 upgrade the url
// hash will remain the same.
// Angular 1.4.7: http://.../xoonboarding?token=EC-9CC38595EA0236714#/checkout/signup
// Angular 1.6.9 with out setting the `hashPrefix` to an empty string:
// http://.../xoonboarding?token=EC-9CC38595EA0236714#!/checkout/signup
angular.module('app').config(['$locationProvider', '$compileProvider', function ($locationProvider, $compileProvider) {
    $locationProvider.hashPrefix('');

    // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1767
    // If you want to debug an application with angular related information in
    // production environemnt, simply open up your console, and type `angular.reloadWithDebugInfo()`
    // and waits for your current page to reload
    if (true) {
        $compileProvider.debugInfoEnabled(false);
    }
    $compileProvider.aHrefSanitizationWhitelist(_constants.constants.regex.protocolsWithDeeplink);
    $compileProvider.cssClassDirectivesEnabled(false); // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1892
    $compileProvider.commentDirectivesEnabled(false); // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1863
}]);

if (!window.prefetch) {
    window.beacon('info', ['angular_bootstrap_start']);
    angular.bootstrap(document.getElementById('angular_app_container'), ['app']);
    window.beacon('info', ['angular_bootstrap_end']);
    if (window.appPerformanceEvents) {
        // TimeToFrameworkEnd: The moment client has finished bootstrapping framework.
        window.appPerformanceEvents.TimeToFrameworkEnd = parseInt(window.performance.now(), 10);
        window.beacon('info', ['APP_PERFORMANCE_EVENTS'], window.appPerformanceEvents);
    }
    __webpack_require__("./js/app.js");
}

_constants.constants;

/***/ }),

/***/ "./js/lib/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var constants = exports.constants = {
    regex: {
        safeProtocols: '^\s*(https?|s?ftp|mailto|tel|file):',
        protocolsWithDeeplink: '^\s*(https?|s?ftp|mailto|tel|file|com\.[a-z]+(\.[a-z]+)*):'
    }
};

/***/ }),

/***/ "./js/lib/contingency.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("./pages/services/shared-util/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$contingencyHandler', function () {
    function showGenericError(code) {
        return function () {

            if (code === 'PAYER_CANNOT_PAY') {
                _uiRouter.$state.go('checkout.genericError', {
                    code: window.btoa('PAYER_CANNOT_MAKE_PAYMENT')
                });
            } else {
                _uiRouter.$state.go('checkout.genericError', {
                    code: code ? window.btoa(code) : code
                });
            }
        };
    }

    function route(path) {
        return function () {
            _uiRouter.$state.go(path, { message: arguments[0] });
        };
    }

    function forbidden(err) {
        throw new _squid.$Forbidden(err);
    }

    function fallback(product) {
        return function (err) {
            throw new _squid.$FallbackError({
                reason: err,
                product: product
            });
        };
    }

    function addMissingTokens(urlQuery) {
        var payload = {
            'token': _angular.$rootScope.token || _squid.$meta.token
        };

        if (_squid.$meta.baToken) {
            payload.ba_token = _squid.$meta.baToken;
        }
        return _squid.$util.queryStringSplice(urlQuery, payload);
    }

    function balanceUsageExperiment() {
        return (0, _squid.$elmo)('paypal:isdc:products:balance:usage:us', {
            'filters.Country': _squid.$locale.country
        }, 'Trmt_balance_usage_us_products').then(function (result) {
            return { enabled: Boolean(result && result.treatment_name) };
        });
    }

    function handleStepupAuth(code, authModel, step_up_context) {
        authModel.stepupAuthRequired = true;
        var areCookiesDisabled = !_squid.$util.cookiesEnabled();

        var reasons = {
            VERIFY_USER_IDENTITY: 'step_up_auth_needed',
            PAYER_AUTHENTICATION_REQUIRED: 'login_required'
        };

        // if stepup context from planning
        if (step_up_context && !_angular2['default'].isObject(step_up_context)) {
            // just a log statement
            if (authModel.remembered) {
                _logger.$logger.debug('PLANNING_STEP_UP_REMEMBERED_USER');
            } else {
                _logger.$logger.debug('PLANNING_STEP_UP_LOGIN_USER');
            }

            var authChallengeNodeUrl = void 0;
            var authParams = {
                stepupContext: step_up_context,
                stsReturnUrl: _squid.$config.ulMeta.stsReturnUrl,
                returnUri: _squid.$config.ulMeta.authChallengeReturnUri + addMissingTokens(_angular.$window.location.search) + '&atoSuccess',
                locale: _squid.$locale.lang,
                flowId: 'xo',
                flowContext: 'funding'
            };

            // if cookies are disabled, we'll redirect to /hermes/stepup along with cookies and step up parameters and
            // internally redirect to ANW
            if (areCookiesDisabled) {
                _logger.$logger.info('STEP_UP_COOKIES_DISABLED');

                var xcookies = JSON.stringify(_squid.$meta.headers['x-cookies']);

                authChallengeNodeUrl = _squid.$config.urls.stepUpAuth;
                authParams.acnw_dep = 'xo';

                // since cookies are disabled, we'll encode them as part of the query params for memcookies to handle
                authParams.meta = JSON.stringify({
                    'x-cookies': xcookies,
                    'x-cookies-hash': _squid.$meta.headers['x-cookies-hash']
                });

                authChallengeNodeUrl = _squid.$util.buildURL(authChallengeNodeUrl, authParams);

                _squid.$util.redirect(authChallengeNodeUrl);
                return;
            }

            // app config to control the auth flow redirection
            // migrate from authchallengenodeweb to authnodeweb
            if (_squid.$config.migrateAuthFlowToANW) {
                _logger.$logger.debug('AUTHFLOW_REDIRECTION_TO_ANW');
                authChallengeNodeUrl = _squid.$config.urls.authNodeWebUrl;
                // need to send one additional param for ANW migration used to ramp at auth app level
                authParams.acnw_dep = 'xo';
            } else {
                _logger.$logger.debug('AUTHFLOW_REDIRECTION_TO_ACNW');
                authChallengeNodeUrl = _squid.$config.urls.authChallengeNodeWebUrl;
            }

            authChallengeNodeUrl = _squid.$util.buildURL(authChallengeNodeUrl, authParams);

            if (authChallengeNodeUrl) {
                _squid.$util.redirect(authChallengeNodeUrl);
            }
        } else {
            _logger.$logger.debug('PLANNING_STEP_UP_WITHOUT_CONTEXT');
            throw new _squid.$FallbackError({
                reason: reasons[code],
                product: 'ux'
            });
        }
    }

    return function (contingency) {
        // Leave a footprint here. The subsequent state where log how it goes..
        var subscriptionDetails = _index2.$SharedUtil.getSubscriptionDetails(_angular.$rootScope && _angular.$rootScope.token);
        var logSubscriptionEvent = _index2.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);
        logSubscriptionEvent({
            from: 'contingency_triggered',
            contingency_type: contingency.message || 'unknown'
        });
        _logger.$logger.warn('contingency_handler', _extends({}, contingency || {}, subscriptionDetails || {}));
        if (subscriptionDetails && subscriptionDetails.subscriptionType) {
            _logger.$logger.warn('CONTINGENCY_' + (contingency.message || 'UNKNOWN') + '_cntry=' + (_squid.$locale.country || 'UNKNOWN'), _extends({}, contingency || {}, subscriptionDetails || {}));
        }

        return contingency.handle({
            // Route
            ECONSENT_REQUIRED: route('checkout.econsent'),
            TRAVEL_RULE_ID_REQUIRED: route('checkout.travelRule'),
            INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: route('checkout.pageAddCardMeft.addCardFlow.addCard'),
            ELV_DECLINE: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_CREDIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_CONFIRMED_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_AUTHENTICATED_CARD: route('checkout.updateCard.addCardFlow.addCard'),
            NEED_CREDIT_CARD_OR_BANK_ACCOUNT: route('checkout.pageAddFi.bank.add'),
            EXPIRED_CREDIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
            NEGATIVE_BALANCE_RECOVERY: function NEGATIVE_BALANCE_RECOVERY(message, data) {
                var redirectXoLiteUrl = (0, _squid.$getRedirectUrl)('redirectXoLite', {
                    token: _angular.$rootScope.token
                });

                _logger.$logger.info('REDIRECT_TO_CHECKOUT_LITE', {
                    url: redirectXoLiteUrl,
                    reason: 'NEGATIVE_BALANCE_RECOVERY'
                });

                return _squid.$util.redirect(redirectXoLiteUrl);
            },
            PHONE_NUMBER_REQUIRED: route('checkout.addPhone'),
            SEPA_MANDATE_ACCEPTANCE_NEEDED: route('checkout.review'),
            TAX_ID_REQUIRED: route('checkout.addTaxId'),
            NEED_SHIPPING_ADDRESS: route('checkout.pageAddShipping.addShipping'),
            GAMER_VOLUNTARY_DISQUALIFICATION: route('checkout.gamblingBlockEnabled'),
            GAMER_VOLUNTARY_DISQUALIFICATION_COOL_OFF: route('checkout.gamblingBlockCoolOffPeriod'),
            NEED_DEBIT_CARD: function NEED_DEBIT_CARD() {
                var checkoutCart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
                return balanceUsageExperiment().then(function (_ref) {
                    var balanceUsageEnabled = _ref.enabled;

                    if (checkoutCart.isWalletTokenization() && balanceUsageEnabled) {
                        _uiRouter.$state.go('checkout.tokenizationInfo', {}, {
                            reload: true
                        });
                        return;
                    }
                    _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                });
            },
            EXPIRED_DEBIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),

            PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED() {
                _uiRouter.$state.go('checkout.login', {
                    targetPage: 'PAYER_AUTHENTICATION_REQUIRED'
                });
            },

            // Generic Error Pages
            RESTRICTED_USER: showGenericError('RESTRICTED_USER'),
            PAYER_ACCOUNT_RESTRICTED: showGenericError('RESTRICTED_USER'),
            PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
            PAYMENT_ALREADY_DONE: showGenericError('PAYMENT_ALREADY_DONE'),
            DUPLICATE_INVOICE_ID: showGenericError('DUPLICATE_INVOICE_ID'),
            PAYMENT_DENIED: showGenericError('PAYMENT_DENIED'),
            PAYEE_ACCOUNT_RESTRICTED: showGenericError('PAYEE_ACCOUNT_LOCKED_OR_CLOSED'),
            INVALID_RESOURCE_ID: showGenericError('INVALID_RESOURCE_ID'),
            EXPIRED_SESSION: showGenericError('EXPIRED_SESSION'),
            PAYER_CANNOT_PAY: showGenericError('PAYER_CANNOT_PAY'),
            TRANSACTION_RECEIVING_LIMIT_EXCEEDED: showGenericError('PAYER_CANNOT_PAY'),
            PAYER_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_COUNTRY_NOT_ALLOWED'),
            PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
            PAYER_COUNTRY_NOT_ENABLED: showGenericError('PAYER_COUNTRY_NOT_ENABLED'),
            PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_LOGIN_COUNTRY_NOT_ALLOWED'),
            GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError('GAMING_FUNDING_SOURCE_VALIDATION_FAILED'),
            COMPLIANCE_VIOLATION: showGenericError('COMPLIANCE_VIOLATION'),
            DOMESTIC_TRANSACTION_REQUIRED: showGenericError('DOMESTIC_TRANSACTION_REQUIRED'),
            INTERNAL_SERVICE_ERROR: showGenericError('TRANSACTION_REFUSED'),
            NEGATIVE_BALANCE_TRANSACTION_REFUSED: showGenericError('NEGATIVE_BALANCE_TRANSACTION_REFUSED'),
            ACCOUNT_CANNOT_BE_FETCHED: showGenericError('ACCOUNT_CANNOT_BE_FETCHED'),
            BAD_RESPONSE: showGenericError('DEFAULT'),
            TRANSACTION_REFUSED_LEGACY_FALLBACK: showGenericError('TRANSACTION_REFUSED'),
            RISK_DENIED: showGenericError('TRANSACTION_REFUSED'),
            UNSUPPORTED_COUNTRY: showGenericError('UNSUPPORTED_COUNTRY'),
            AGREEMENT_ALREADY_CREATED: showGenericError('AGREEMENT_ALREADY_CREATED'),
            PAYMENT_NOT_APPROVED_FOR_EXECUTION: showGenericError('DEFAULT'),
            PAYER_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('DEFAULT'),
            WALLET_PREFERENCE_SET_ERROR: showGenericError('DEFAULT'),
            ISSUANCE_PIN_SERVICE_ERROR: showGenericError('DEFAULT'),
            SENDING_LIMIT_EXCEEDED: showGenericError('SENDING_LIMIT_EXCEEDED'),
            PAYEE_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('PAYEE_ACCOUNT_LOCKED_OR_CLOSED'),
            UNSUPPORTED_PAYEE_CURRENCY: showGenericError('UNSUPPORTED_PAYEE_CURRENCY'),
            PAYMENT_CANNOT_BE_INITIATED: showGenericError('DEFAULT'),
            PERMISSION_DENIED: showGenericError('DEFAULT'),
            INVALID_TOKEN: showGenericError('DEFAULT'),
            INVALID_FUNDING_OPTION: showGenericError('DEFAULT'),
            VALIDATION_ERROR: showGenericError('DEFAULT'),
            SHIPPING_ADDRESS_INVALID: showGenericError('DEFAULT'),
            INVALID_ARGUMENT: showGenericError('DEFAULT'),
            CREDIT_PAYMENT_NOT_ALLOWED: showGenericError('DEFAULT'),
            MALFORMED_REQUEST: showGenericError('DEFAULT'),
            TWOFA_INACTIVE: showGenericError('DEFAULT'),
            ERROR: showGenericError('DEFAULT'),
            ISSUER_DECLINE: showGenericError('DEFAULT'),
            UNSUPPORTED_CUP_SECURECARD: showGenericError('DEFAULT'),
            STUDENT_ACCOUNT: showGenericError('STUDENT_ACCOUNT'),
            UAL_ISSUANCE_UPDATE_SCOPE_ERROR: showGenericError('DEFAULT'),
            // Forbidden
            BUYER_NOT_SET: forbidden,

            // Other
            TRANSACTION_REFUSED: function TRANSACTION_REFUSED(message, data) {
                var clearedRT = data.clearedRT;

                if (clearedRT) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CONTINGENCY',
                        to: 'process_fallback',
                        routing_reason: 'TRANSACTION_REFUSED'
                    });
                }

                // always go to generic error page, even if logout fails
                _index.$AuthModel.instance().logout()['finally'](showGenericError('TRANSACTION_REFUSED'));
            },

            PAYER_INVALID_FOR_PAYMENT: function PAYER_INVALID_FOR_PAYMENT() {
                // Payer is not same payer checkout session was created for.
                return _index.$AuthModel.instance().logout()['finally'](function () {
                    return _uiRouter.$state.go('checkout.login', {}, {
                        reload: true
                    });
                });
            },

            CANNOT_PAY_SELF: function CANNOT_PAY_SELF() {
                _index.$AuthModel.instance().meta.selfPay = true;
                _angular.$rootScope.contingency = {};
                _angular.$rootScope.contingency.message = 'CANNOT_PAY_SELF';

                return _index.$AuthModel.instance().logout()['finally'](function () {
                    return _uiRouter.$state.go(_uiRouter.$state.current, {}, {
                        reload: true
                    });
                });
            },

            VERIFY_USER_IDENTITY: function VERIFY_USER_IDENTITY(message, data) {
                var clearedRT = data.clearedRT;

                if (clearedRT) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CONTINGENCY',
                        to: 'process_fallback',
                        routing_reason: 'VERIFY_USER_IDENTITY'
                    });
                }

                return handleStepupAuth('VERIFY_USER_IDENTITY', _index.$AuthModel.instance(), data.step_up_context);
            },

            LOGIN_CONTINGENCY: function LOGIN_CONTINGENCY() {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    return _miniBrowser.$miniBrowser.frameBust(_angular.$rootScope.token);
                }

                return fallback('ux');
            },

            DEFAULT: function logUnhandledContingency() {
                _logger.$logger.warn('ui_unhandled_contingency_' + this.message);
                throw new _squid.$FallbackError({
                    reason: 'unhandled_contingency',
                    product: 'ux'
                });
            }
        });
    };
});

_uiRouter.$state;

_logger.$logger;

_squid.$config;

_squid.$FallbackError;

_squid.$Forbidden;

_squid.$locale;

_squid.$meta;

_squid.$util;

_squid.$getRedirectUrl;

_squid.$elmo;

_integration.$integration;

_miniBrowser.$miniBrowser;

_index.$AuthModel;

_checkout.$CheckoutCartModel;

_index2.$SharedUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/contingency.js"))

/***/ }),

/***/ "./js/lib/cplIntegration.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

try {
    var token = window.meta.token;

    _angular.$q.all([_checkout.$CheckoutAppDataModel.instance(token).retrieve(), _checkout.$CheckoutCartModel.instance(token).retrieve()]).then(function (_ref) {
        var appData = _ref[0],
            cart = _ref[1];

        if (appData.is_wps_flow()) {
            window.fptiProductOverride = 'wps';
        } else if (cart.isBilling()) {
            window.fptiProductOverride = 'billing';
        }
    })['catch'](function (e) {
        console.error(e);
    });
} catch (e) {
    console.error(e);
}

_angular.$q;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./js/lib/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$forbiddenHandler = $forbiddenHandler;
exports.$exceptionHandler = $exceptionHandler;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fallback = __webpack_require__("./js/lib/fallback.js");

var _contingency = __webpack_require__("./js/lib/contingency.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

// ui-router rejects $state.go promises if the navigation is cancelled.
var uiRouterTransitionErrors = ['transition prevented', 'transition aborted', 'transition superseded'];

function canBeSafelyIgnored(err) {
    return err instanceof _squid.$ShortCircuit || uiRouterTransitionErrors.includes(err.message);
}

function constructEventName(toState, fromState) {
    var from = fromState.name.replace(/\./g, '_') || 'start';
    var to = toState.name.replace(/\./g, '_') || 'end';

    return 'state_change_' + from + '_to_' + to;
}

function constructErrorPayload(_ref) {
    var err = _ref.err,
        message = _ref.message,
        cause = _ref.cause;

    var payload = {
        error: err.stack || err.toString(),
        message: message || err.message,
        cause: cause && cause.toString(),
        state: _uiRouter.$state.current.name,
        url: window.location.toString()
    };

    angular.extend(payload, err.payload || {});

    return payload;
}

function $forbiddenHandler(err) {
    _logger.$logger.warn('forbidden_handler');
    if (!err.transient) {
        _index.$AuthModel.instance().invalidate();

        if (_angular.$rootScope.paymentComplete) {
            throw new _squid.$Contingency('PAYMENT_ALREADY_DONE');
        }

        _uiRouter.$state.go('checkout.login');
    }
}

function handleThirdPartyErrors(err, cause) {
    var errType = (err && err.constructor && err.constructor.name || 'error').toLowerCase();
    var experience = _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);
    var errName = 'ui_' + experience.toLowerCase() + '_' + errType;
    var payload = constructErrorPayload({ err: err, cause: cause });

    _logger.$logger.error(errName, payload);
    _index.$AuthModel.instance().logout();
    _thirdPartyInfo.thirdPartyExperience.resetThirdPartyExperience();

    if (experience === 'VENMO_EXPERIENCE') {
        _uiRouter.$state.go('checkout.login', { venmoError: true });
    }

    if (experience === 'BAIDU_EXPERIENCE') {
        _uiRouter.$state.go('checkout.login', { baiduError: true });
    }
}

function isThirdPartyFlow() {
    return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token);
}

var ERROR_HANDLERS = [{
    type: _squid.$FallbackError,
    handler: _fallback.$fallbackErrorHandler
}, {
    type: _squid.$Contingency,
    handler: _contingency.$contingencyHandler
}, {
    type: _squid.$Forbidden,
    handler: $forbiddenHandler
}];

function $exceptionHandler(err, cause) {
    if (canBeSafelyIgnored(err)) {
        if (err.message) {
            _logger.$logger.info(err.message);
        }
        return true;
    }

    if (_angular.$rootScope.ERROR_STATE) {
        if (_angular.$rootScope.ERROR_PREVENTED) {
            throw err;
        }

        return;
    }

    if (isThirdPartyFlow()) {
        if (err instanceof _squid.$Forbidden) {
            // forbidden errors should take you to login page
            return $forbiddenHandler(err);
        } else {
            return handleThirdPartyErrors(err, cause);
        }
    }

    var handled = _squid.$util.some(ERROR_HANDLERS, function (errorHandler) {
        if (err instanceof errorHandler.type) {
            errorHandler.handler(err);

            return true;
        }
    });

    if (handled) {
        return;
    } else if (!err.transient) {
        _angular.$rootScope.ERROR_STATE = err;
    }

    var errType = (err.constructor.name || 'error').toLowerCase();
    var errName = 'ui_unhandled_' + errType;
    var errMsg = err.message || '';

    if (errMsg.indexOf('infdig') > -1) {
        errName = 'infinite_digest';
    } else if (errMsg.indexOf('inprog') > -1) {
        errName = 'digest_inprog';
    } else if (errMsg.indexOf('badparse') > -1) {
        errName = 'sanitize_badparse';
    } else if (errMsg.match(/^[\w_]+$/)) {
        errName = 'ui_unhandled_' + errMsg;
    }

    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
            errName = 'ui_unhandled_framework_error';
        }
    }

    if (err.transient) {
        errName += '_transient';
    }

    var payload = constructErrorPayload({ err: err, message: errMsg, cause: cause });

    _logger.$logger.error(errName, payload);
    _logger.$logger.error('build_' + _squid.$meta.buildId + '_' + errName, payload); // release vs live traffic separation

    // emit the error object for subscribers like xo-tracking
    var event = _angular.$rootScope.$emit('unhandled_error', {
        err: err,
        route: (_uiRouter.$state || {}).current,
        message: payload.error,
        code: payload.cause
    });

    if (event.defaultPrevented) {
        _angular.$rootScope.ERROR_PREVENTED = true;
        throw err;
    } else if (!err.transient) {
        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
            reason: errName
        }));
    }
}

_angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
    // Set prevent default to avoid angular UI router to keep looping back to same state
    event.preventDefault();
    $exceptionHandler(err, constructEventName(toState, fromState));
});

_angular.$rootScope.$on('$windowError', function (event, details) {
    _logger.$logger.error('window_error', details, {
        unique: true
    });
});

angular.value("$forbiddenHandler", $forbiddenHandler);
angular.value("$exceptionHandlerLazy", $exceptionHandler);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_index.$AuthModel;

_squid.$util;

_squid.$FallbackError;

_squid.$Forbidden;

_squid.$ShortCircuit;

_squid.$Contingency;

_squid.$meta;

_fallback.$fallbackErrorHandler;

_contingency.$contingencyHandler;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "./js/lib/fallback.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _icFallback = __webpack_require__("./js/lib/icFallback.js");

var _integration = __webpack_require__("./js/lib/integration.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fallbackErrorHandler', function () {
    return function (err) {
        var reason = err && err.reason;
        var entry_point = err && err.entryPoint;
        var params = err && err.params;
        var model = {};
        var product = err && err.product;
        var isWpsSubscription = void 0;
        var isWpsInstallmentPlan = void 0;

        function getFallbackUrl(urlParams, waType) {
            if (_angular.$rootScope.wps || _angular.$rootScope.invoice) {
                return (0, _squid.$populate)(model, {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(_squid.$meta.token)
                }).then(function () {
                    // defaulting for now to ensure backward compatibility
                    var base = _squid.$config.urls.fallbackUrl['buyNow'];

                    if (model.checkoutAppData.flags.is_cart_upload_flow || waType === 'CartUpload' || waType === 'AddToCart' || model.checkoutAppData.flags.is_shopping_cart_flow || waType === 'ShoppingCart') {
                        base = _squid.$config.urls.fallbackUrl['cartUpload'];
                    }

                    if (model.checkoutAppData.flags.is_invoice_flow) {
                        urlParams.id = model.checkoutAppData.invoice_id;
                        base = _squid.$config.urls.fallbackUrl['invoice'];
                    }

                    if (isWpsSubscription) {
                        base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
                    }

                    if (isWpsInstallmentPlan) {
                        base = _squid.$config.urls.fallbackUrl['wpsInstallmentPlan'];
                    }

                    return _squid.$util.paypalURL(base, urlParams);
                });
            } else {
                return _angular.$q.when().then(function () {
                    var base = _squid.$config.urls.fallbackUrl[product];

                    return _squid.$util.paypalURL(base, urlParams);
                });
            }
        }

        function showGenericErrorPage(errorReason) {
            if (_angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_genericErrorPage');
            }

            var code = errorReason || reason;

            code = code ? window.btoa(code) : code;

            _uiRouter.$state.go('checkout.genericError', {
                code: code
            });
        }

        function handleFallbackRedirect(url, wpsParams) {
            if (!_squid.$config.fallbackEnabled && !entry_point) {
                return _logger.$log.warn('Fallback inhibited by config', url);
            }

            if (_squid.$config.deploy.isLocal() && !entry_point) {
                return _logger.$log.warn('Fallback inhibited in local mode.', url);
            }

            _logger.$logger.log(product ? 'info' : 'error', 'fallback', {
                reason: reason,
                product: product,
                entry_point: entry_point,
                error_desc: reason,
                from: _angular.$rootScope.currentState || 'fallback',
                to: product ? 'process_fallback_' + product : 'process_fallback'
            });

            _logger.$logger.info('fallback_reason_' + reason, {
                reason: reason
            });
            _logger.$logger.info('build_' + _squid.$meta.buildId + '_fallback_reason_' + reason); // release vs live traffic separation

            if (window.xchild) {
                if (window.opener) {
                    return (0, _icFallback.$incontextFallback)(window, url);
                }

                return _uiRouter.$state.go('checkout.framebust', { action: 'fallback', url: url });
            }

            _angular.$rootScope.$emit('loading');

            if (product === 'ux') {
                // Otherwise we can make a decision based on whether we're in the minibrowser or not
                return _angular.$rootScope.wps && !_angular.$rootScope.invoice ? _util.$ReturnToMerchant.postTo(url, wpsParams) : _util.$ReturnToMerchant.goTo(url);
            }

            // Force Error Page for Aries traffic
            return showGenericErrorPage('DEFAULT');
        }

        function doFallback() {
            _squid.$util.assert(reason, 'expected fallback reason');

            product = product || 'ux';

            var urlParams = params || {};

            _angular2['default'].extend(urlParams, {
                token: _squid.$meta.token,
                fallback: 1,
                reason: reason,
                landing: entry_point,
                useraction: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token).useraction()
            });

            if (_angular.$rootScope.partnerIntegration) {
                urlParams.incontext = '1';
                urlParams.nolegacy = '1';
            } else if (_angular.$rootScope.miniBrowser) {
                urlParams.incontext = '1';
            }

            var wpsParams = void 0;

            if (_angular.$rootScope.wps) {
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
                _logger.$logger.info('wps_fallback', {
                    token: _squid.$meta.token,
                    reason: reason
                });
                _logger.$logger.info('wps_fallback_reason_' + reason, {
                    reason: reason
                });
                _logger.$logger.info('build_' + _squid.$meta.buildId + '_wps_fallback_reason_' + reason); // release vs live traffic separation
            }

            var waType = wpsParams && wpsParams.wa_type;

            return getFallbackUrl(urlParams, waType).then(function (url) {
                // Fallback whitelist error reason in config to determine if we should fallback or instead redirect to generic error page.
                var fallbackWhitelist = _squid.$config.fallbackWhitelist;
                var whitelist = fallbackWhitelist && fallbackWhitelist.whitelisted || [];

                // if error reason not in fallback whitelist, try auto-retry
                if (whitelist && whitelist.indexOf(reason) === -1) {
                    var AUTORELOAD_LIMIT = 1; // can be increased later
                    // get auto reload count from params - if present
                    var autoReloadCount = parseInt(_squid.$util.param('arc'), 10);

                    // if falsy (NaN or 0)...
                    if (!autoReloadCount) {
                        // start at zero
                        autoReloadCount = 0;
                    }
                    // if we haven't reloaded _enough_ yet...
                    if (autoReloadCount < AUTORELOAD_LIMIT) {
                        // bump count
                        autoReloadCount++;
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'error_auto_reload',
                            'to': 'restart_hermes_app',
                            'int_error_code': reason
                        });

                        // pass params, so url is augmented
                        _squid.$util.replace({ arc: autoReloadCount });
                    } else {
                        // If auto reload didn't fix the error - redirect to error page with retry option
                        var RETRY_KEY = 'retry_page_shown';
                        var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
                        var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
                        var destination = 'RETRY';
                        var transition_name = 'show_retry_page';

                        // Reset if there's an invalid value for timesSeen for some reason
                        if (!timesSeen || timesSeen < 0) {
                            timesSeen = 0;
                        }

                        // Only try to go to retry page if we're within retry attempts
                        if (timesSeen < RETRY_PAGE_LIMIT) {
                            timesSeen++;
                            sessionStorage.setItem(RETRY_KEY, timesSeen);
                        } else {
                            destination = 'DEFAULT';
                            transition_name = 'show_error_page';
                        }

                        _logger.$logger.info('checkout_fpti', {
                            'from': 'error_auto_reload',
                            'to': transition_name,
                            'enable_refresh_prompt': reason,
                            'int_error_code': reason
                        });
                        return showGenericErrorPage(destination);
                    }
                } else {
                    _logger.$logger.info('fallback_reason_whitelisted', {
                        reason: reason,
                        product: product
                    });
                    handleFallbackRedirect(url, wpsParams);
                }
            });
        }

        if (product === 'error') {
            _logger.$logger.error(reason, {
                url: window.location.href
            });

            var _$config$urls = _squid.$config.urls,
                baseUrl = _$config$urls.baseUrl,
                errorUrl = _$config$urls.errorUrl;


            return _squid.$util.redirect(baseUrl + errorUrl);
        }

        if (_integration.$integration.getConfig('ERROR_AFTER_PAYMENT') && _angular.$rootScope.paymentComplete) {
            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
            _logger.$logger.info('wps_error_after_payment', {
                reason: reason
            });

            return showGenericErrorPage('PAYMENT_ALREADY_DONE');
        }

        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        var isBeamIntegration = _squid.$meta.baToken && beamPattern.test(_squid.$meta.baToken);
        var cartExchangeFailed = isBeamIntegration && beamPattern.test(_squid.$meta.token);

        if (cartExchangeFailed) {
            product = 'ux';
        }

        // For Beam Integration - always show generic Error when cart exchange fails.
        // On successful Cart Exchange - disable fallback until MPWEB supports BA token support.
        if (product === 'ux' && isBeamIntegration && cartExchangeFailed) {
            return showGenericErrorPage();
        }

        return (0, _squid.$populate)(model, {
            checkoutCart: _index.$CheckoutCartModel.instance(_squid.$meta.token),
            checkoutAppData: _index.$CheckoutAppDataModel.instance(_squid.$meta.token)
        }).then(function () {
            isWpsSubscription = model.checkoutAppData.is_wps_subscription_flow();
            isWpsInstallmentPlan = model.checkoutAppData.is_wps_installmentplan_flow();
            var merchantCountry = model.checkoutAppData.merchant.merchant_country;
            var isSecondButtonTxn = model.checkoutAppData.is_second_button_txn;

            // No fallback for Tokenized_Wallet usecases
            if (model.checkoutCart.isWalletTokenization()) {
                return showGenericErrorPage();
            }

            // No fallback for DE second button transactions
            if (merchantCountry === 'DE' && isSecondButtonTxn) {
                return showGenericErrorPage();
            }

            // Do not fallback if appdata flag dictates no fallback
            if (model.checkoutAppData.flags.disable_legacy_fallback) {
                _logger.$logger.error('fallback_inhibited_for_xo_order_tokens');
                return showGenericErrorPage();
            }

            // V.zero - fallback resize before do actual fallback
            if (product === 'ux' && _angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_UX');
                _angular.$window.resizeTo(screen.availWidth, screen.availHeight);
            }

            // default do fallback (not actually fallback) - check doFallback() to understand it better
            return doFallback();
        })['catch'](showGenericErrorPage);
    };
});

_uiRouter.$state;

_logger.$log;

_logger.$logger;

_squid.$config;

_squid.$meta;

_squid.$populate;

_squid.$util;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_util.$ReturnToMerchant;

_icFallback.$incontextFallback;

_integration.$integration;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/fallback.js"))

/***/ }),

/***/ "./js/lib/icFallback.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$incontextFallback = $incontextFallback;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

function $incontextFallback(win, url) {
    _angular.$rootScope.$emit('loading');
    window.onbeforeunload = function () {};
    window.onunload = function () {};

    var parent = window.opener || window.parent;

    if (!window.xprops || !window.xprops.fallback) {
        parent.location = url;
        win.close();
        return;
    }

    try {
        var frame = void 0;

        try {
            if (typeof parent.onLegacyFallback === 'function') {
                frame = parent;
            }
        } catch (err) {
            // pass
        }

        if (!frame) {
            for (var i = 0, ii = parent.frames.length; i < ii; i++) {
                try {
                    if (typeof parent.frames[i].onLegacyFallback === 'function') {
                        frame = parent.frames[i];
                        break;
                    }
                } catch (err) {
                    // pass
                }
            }
        }

        if (!frame) {
            parent.location = url;
            win.close();
            return;
        }

        frame.onLegacyFallback(win);

        window.addEventListener('unload', function () {
            var width = 970;
            var height = 900;
            var left = void 0;
            var top = void 0;

            if (window.outerWidth) {
                left = Math.round((window.outerWidth - width) / 2) + window.screenX;
                top = Math.round((window.outerHeight - height) / 2) + window.screenY;
            } else if (window.screen.width) {
                left = Math.round((window.screen.width - width) / 2);
                top = Math.round((window.screen.height - height) / 2);
            }

            window.resizeTo(width, height);
            window.moveTo(left, top);
        });

        win.location = url;
    } catch (err) {
        parent.location = url;
        win.close();
    }

    window.xprops.fallback(url);
}

angular.value("$incontextFallback", $incontextFallback);
_angular.$rootScope;

/***/ }),

/***/ "./js/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _error = __webpack_require__("./js/lib/error.js");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _fallback = __webpack_require__("./js/lib/fallback.js");

Object.keys(_fallback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fallback[key];
    }
  });
});

var _contingency = __webpack_require__("./js/lib/contingency.js");

Object.keys(_contingency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contingency[key];
    }
  });
});

var _metaBuilder = __webpack_require__("./js/lib/metaBuilder.js");

Object.keys(_metaBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _metaBuilder[key];
    }
  });
});

var _middleware = __webpack_require__("./js/lib/middleware.js");

Object.keys(_middleware).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _middleware[key];
    }
  });
});

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

Object.keys(_miniBrowser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _miniBrowser[key];
    }
  });
});

var _security = __webpack_require__("./js/lib/security.js");

Object.keys(_security).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _security[key];
    }
  });
});

var _stateChangeListener = __webpack_require__("./js/lib/stateChangeListener.js");

Object.keys(_stateChangeListener).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _stateChangeListener[key];
    }
  });
});

var _cplIntegration = __webpack_require__("./js/lib/cplIntegration.js");

Object.keys(_cplIntegration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cplIntegration[key];
    }
  });
});

/***/ }),

/***/ "./js/lib/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;

var _$DEFAULT, _$CONTEXT$FULLPAGE, _$CONTEXT$LIGHTBOX, _$integration$init;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

Object.defineProperty(exports, '$integration', {
    enumerable: true,
    get: function get() {
        return _squid.$integration;
    }
});
Object.defineProperty(exports, '$CONTEXT', {
    enumerable: true,
    get: function get() {
        return _squid.$CONTEXT;
    }
});
var $FLOWS = exports.$FLOWS = {

    // Regular end-to-end checkout flow with one entry and one exit point
    CHECKOUT: 'CHECKOUT',

    // Partner flow [ TODO: FACTOR THIS OUT ]
    PARTNER: 'PARTNER',

    // Incontext lightbox flow
    INCONTEXT_LIGHTBOX: 'INCONTEXT_LIGHTBOX',

    // Incontext popup flow
    INCONTEXT_POPUP: 'INCONTEXT_POPUP',

    // Native checkout flow
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT',

    // Messenger Integration flow
    MESSENGER_BA_INTEGRATION: 'MESSENGER_BA_INTEGRATION',

    // WPS flow
    WPS: 'WPS',

    // WPS Subscription flow
    WPS_SUBSCRIPTION: 'WPS_SUBSCRIPTION',

    // WPS Autobilling flow
    WPS_AUTOBILLING: 'WPS_AUTOBILLING',

    //  WPS INSTALLMENTPLAN
    WPS_INSTALLMENTPLAN: 'WPS_INSTALLMENTPLAN'
};

_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {

    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,
    ALLOW_ONETOUCH_TOKEN_EXCHANGE: false,
    ALLOW_PAYER_ID_RETURN_PARAM: true,
    DONE_PAGE: false,
    FALLBACK: true,
    REDIRECT_TOP: true,
    REDIRECT_QUERY_PARAM: false,
    POST_MESSAGE_PARENT: false
}, _$DEFAULT[$FLOWS.PARTNER] = {

    FALLBACK: false,
    REDIRECT_TOP: false,
    POST_MESSAGE_PARENT: false
}, _$DEFAULT[$FLOWS.INCONTEXT_LIGHTBOX] = {

    ALLOW_ONETOUCH_TOKEN_EXCHANGE: true,
    POST_MESSAGE_PARENT: true
}, _$DEFAULT[$FLOWS.INCONTEXT_POPUP] = {

    POST_MESSAGE_PARENT: true
}, _$DEFAULT[$FLOWS.WPS] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: true,
    ERROR_AFTER_PAYMENT: true,
    POPULATE_MERCHANT_PREFERENCES: true,
    RETURN_METHOD_BASED_ON_MERCHANT_PREFS: true,
    RETURN_URL_FROM_MERCHANT_PREFS: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: true
}, _$DEFAULT[$FLOWS.WPS_SUBSCRIPTION] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: false,
    ERROR_AFTER_PAYMENT: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: false
}, _$DEFAULT[$FLOWS.WPS_AUTOBILLING] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: false,
    ERROR_AFTER_PAYMENT: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: false
}, _$DEFAULT[$FLOWS.WPS_INSTALLMENTPLAN] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: false,
    ERROR_AFTER_PAYMENT: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: false
}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {

    CAN_FRAMEBUST: false,
    CAN_FALLBACK_TO_POPUP: false,
    CAN_CLOSE_SELF: false

}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
    REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE[$FLOWS.PARTNER] = {
    REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = (_$CONTEXT$LIGHTBOX = {

    ALLOW_AUTH: false,
    ALLOW_COLLECT_DATA: false,

    CAN_FRAMEBUST: true,
    CAN_FALLBACK_TO_POPUP: true,
    CAN_CLOSE_SELF: false,

    RETURN_FROM_DATA_COLLECTION_POPUP: false,

    REDIRECT_TOP: false

}, _$CONTEXT$LIGHTBOX[$FLOWS.MESSENGER_BA_INTEGRATION] = {

    IS_MESSENGER_BA_INTEGRATION: true

}, _$CONTEXT$LIGHTBOX[$FLOWS.PARTNER] = {

    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,
    CAN_FALLBACK_TO_POPUP: false,
    POST_MESSAGE_PARENT: false
}, _$CONTEXT$LIGHTBOX), _$integration$init[_squid.$CONTEXT.POPUP] = {
    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,

    CAN_FRAMEBUST: true,
    CAN_FALLBACK_TO_POPUP: true,
    CAN_CLOSE_SELF: false
}, _$integration$init));

angular.value("$FLOWS", $FLOWS);
_squid.$integration;

_squid.$DEFAULT;

_squid.$CONTEXT;

/***/ }),

/***/ "./js/lib/metaBuilder.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$metaBuilder = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function buildMeta() {
    return {
        token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
        calc: _model.$CalDataModel.getCalCorrId(),
        csci: _model.$CalDataModel.getUUID(),
        locale: {
            country: _squid.$locale && _squid.$locale.country,
            language: _squid.$locale && _squid.$locale.lang
        },
        state: 'ui_' + (_angular.$rootScope.currentState || 'checkout_init'),
        app_name: 'hermesnodeweb',
        baToken: _squid.$meta.baToken
    };
}

function buildContext() {
    return {
        locale: {
            country: _squid.$locale && _squid.$locale.country,
            language: _squid.$locale && _squid.$locale.lang
        }
    };
}

_squid.$Api.registerMetaBuilder(buildMeta);

var $metaBuilder = exports.$metaBuilder = {
    build: buildMeta,
    buildContext: buildContext
};

angular.value("$metaBuilder", $metaBuilder);
_angular.$rootScope;

_model.$CalDataModel;

_squid.$util;

_squid.$meta;

_squid.$Api;

_squid.$locale;

_squid.$config;

/***/ }),

/***/ "./js/lib/metadata.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getClientMetadataID = getClientMetadataID;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function getClientMetadataID(defaultID) {
    if (window.xprops && window.xprops.clientMetadataID) {
        return window.xprops.clientMetadataID;
    } else if (_squid.$util.param('client-metadata-id')) {
        return _squid.$util.param('client-metadata-id');
    } else {
        return defaultID;
    }
}

_squid.$util;

/***/ }),

/***/ "./js/lib/metricLogger.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.metricCounter = undefined;

var _beaverLogger = __webpack_require__("../node_modules/@krakenjs/beaver-logger/dist/beaver-logger.js");

var logger = new _beaverLogger.Logger({
    url: location.host.indexOf('localhost') >= 0 ? 'https://www.msmaster.qa.paypal.com/xoplatform/logger/api/logger' : '/xoplatform/logger/api/logger',
    prefix: 'hermesnodeweb',
    metricNamespacePrefix: 'pp.xo.hermes',
    flushInterval: 10000
});

var metricCounter = exports.metricCounter = function metricCounter(event) {
    var dimensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    logger.metricCounter({ namespace: 'custom', event: event, dimensions: dimensions });
};

_beaverLogger.Logger;

/***/ }),

/***/ "./js/lib/middleware.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _constants = __webpack_require__("./js/lib/constants.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

__webpack_require__("./js/lib/stateChangeListener.js");

var _metadata = __webpack_require__("./js/lib/metadata.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var getDeviceAndNetworkInfo = function getDeviceAndNetworkInfo() {
    var netInfo = navigator && navigator.connection || {};
    var memory = navigator && navigator.deviceMemory;
    return {
        type: netInfo.type, // Network type that browser uses
        effectiveType: netInfo.effectiveType, // 2g, 3g, wifi , etc
        downlink: netInfo.downlink, // Effective bandwidth estimate
        downlinkMax: netInfo.downlinkMax, // Upper bound on the downlink speed of the first network hop
        roundTripTime: netInfo.rtt, // Effective round-trip time estimate
        saveData: netInfo.saveData, // user has requested a reduced data usage mode,
        memory: memory // .5= 512Mib, 1=1024Mib, ...
    };
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Middleware', function () {
    return [function angularDebug() {
        window.root = _angular.$rootScope;
        window.injector = _angular2['default'].element(document.body).injector();

        /**
         * Config experiment to overwrite the $apply method and use $eval instead of $apply if it would throw a digest inprog error.
         * This is mainly to address a Firefox bug with angular digest and timeouts, where timeouts can interrupt normal execution flow under certain circumstances
         * Bug described here: https://github.com/angular/angular.js/issues/10083
         *
         * Can remove as a config option if this is a stable change
         */
        if (_squid.$config.safeApply) {
            _logger.$logger.info('overwriting_angular_apply');
            var proto = Object.getPrototypeOf && Object.getPrototypeOf(_angular.$rootScope);

            if (!proto) {
                _logger.$logger.warn('overwriting_angular_apply_failed', {
                    reason: 'failed_to_get_prototype'
                });
            } else {
                var originalApply = proto.$apply;
                // If this gets used so many times, something is probably wrong so use original apply instead
                var skipAttempts = 10;

                proto.$apply = function (fn) {
                    if (skipAttempts && (_angular.$rootScope.$$phase === '$digest' || _angular.$rootScope.$$phase === '$apply')) {
                        skipAttempts--;

                        _logger.$logger.warn('inprog_error_skipped', {
                            stack: new Error().stack
                        });

                        this.$eval(fn);
                    } else {
                        originalApply.call(this, fn);
                    }
                };
            }
        }
    }, function waitForToken() {
        if (_squid.$util.isIFrame() && !_squid.$util.param('token') && !_squid.$meta.token) {
            return (0, _angular.$q)(function (resolve, reject) {
                _logger.$logger.info('await_token');

                window.addEventListener('message', function (event) {
                    var originNotValid = !event.origin || !event.origin.match(/paypal.com/);
                    var message = JSON.parse(event.data);

                    if (originNotValid || message.operation !== 'pass_token') {
                        return;
                    }

                    var token = message.token;

                    _logger.$logger.info('passed_token', { token: token });
                    _squid.$meta.token = token;

                    var $preloadApi = new _squid.$Api({ uri: 'preload' });

                    $preloadApi.retrieve({
                        params: { token: token }
                    }).then(function (response) {
                        $preloadApi.setTransientCache(response.data);
                        resolve();
                    })['catch'](reject);
                }, false);
            });
        }
    }, function checkToken() {
        var pattern = /^EC-[0-9A-Z]{17}$/;
        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        // wps token are not preceeded with 'EC-'
        var wpsPattern = /^[0-9A-Z]{17}$/;
        var urlToken = (_squid.$util.param('token') || '').trim().slice(0, 20);
        var bodyToken = (_squid.$meta.token || '').trim().slice(0, 20);

        if (pattern.test(urlToken)) {
            _angular.$rootScope.token = urlToken;
        } else if (pattern.test(bodyToken)) {
            _angular.$rootScope.token = bodyToken;
        } else if (wpsPattern.test(urlToken)) {
            _logger.$logger.info('isWpsPattern');
            _angular.$rootScope.token = urlToken;
        } else if (wpsPattern.test(bodyToken)) {
            _logger.$logger.info('isWpsPattern');
            _angular.$rootScope.token = bodyToken;
        } else if (beamPattern.test(urlToken)) {
            _angular.$rootScope.token = urlToken;
            _logger.$logger.info('cart_exchange_failed', {
                token: _angular.$rootScope.token
            });
        } else if (beamPattern.test(bodyToken)) {
            _angular.$rootScope.token = bodyToken;
            _logger.$logger.info('cart_exchange_failed', {
                token: _angular.$rootScope.token
            });
        } else {
            return _angular.$q.reject(new _squid.$FallbackError({
                reason: 'no_token',
                product: 'error'
            }));
        }
    },

    // Hermes does not handle paylater buttons; if one gets to this point on the client-side, we want treat it as a credit second button
    // Replace window.xprops.fundingSource with 'credit' so that the rest of the client-side treats it as a credit second button transaction
    function remapPaylaterButtonToCredit() {
        if (window.xprops && window.xprops.fundingSource === 'paylater') {
            window.xprops.originFundingSource = 'paylater';
            window.xprops.fundingSource = 'credit';
        }
    }, function resolveLocale() {
        var models = {};

        return (0, _squid.$populate)(models, {
            appData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            cart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token)
        })['finally'](function () {
            return _squid.$locale.retrieve({
                params: {
                    ipCountry: _squid.$meta.ipcountry,
                    localeTestUrlParam: _squid.$util.param('locale.test'),
                    checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
                    merchantCountry: models.appData.get('merchant.merchant_country'),
                    checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
                    countryParam: _squid.$util.param('country.x'),
                    localeParam: _squid.$util.param('locale.x')
                }
            });
        });
    }, function fraudentInit() {
        return _fn.$fn.init();
    }, function setupIntegration() {
        return _miniBrowser.$miniBrowser.init(_angular.$rootScope.token);
    }, function frameBust() {

        if (!_integration.$integration.getConfig('CAN_FRAMEBUST')) {
            return;
        }

        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return;
        }

        return _miniBrowser.$miniBrowser.frameBust(_angular.$rootScope.token);
    }, function tokenExchange() {

        _logger.$logger.info('tokenExchange', {
            allow_onetouch_token_exchange: _integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE'),
            isPartnerIntegration: _angular.$rootScope.isPartnerIntegration,
            isIFrame: _squid.$util.isIFrame()
        });

        if (!_integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE')) {
            return;
        }

        if (_angular.$rootScope.isPartnerIntegration || !_squid.$util.isIFrame()) {
            return;
        }

        var auth = _index2.$AuthModel.instance();

        return auth.retrieve().then(function () {

            _logger.$logger.info('tokenExchange_auth', {
                logged_in: auth.logged_in,
                remembered: auth.remembered,
                refresh_token: auth.refresh_token,
                isOneTouchRequired: auth.logged_in || auth.remembered || !auth.refresh_token
            });

            if (auth.logged_in || auth.remembered || !auth.refresh_token) {
                return;
            }

            return auth.action('onetouch');
        });
    }, function xcomponent() {
        if (window.xchild) {
            window.paypalCheckout = window.xchild;
        }

        if (window.xprops && window.xprops.init) {
            return _angular.$q.all([_index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(), _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve()]).then(function (_ref) {
                var checkoutAppData = _ref[0],
                    checkoutPayee = _ref[1];

                return window.xprops.init({
                    paymentToken: _angular.$rootScope.token,
                    merchantID: checkoutPayee.merchant.id,
                    cancelUrl: checkoutAppData.urls.cancel_url
                });
            });
        }
    }, function xcomponentAuth() {
        if (window.xprops && window.xprops.onAuth) {
            var auth = _index2.$AuthModel.instance();

            return auth.retrieve().then(function () {
                if (auth.access_token && (auth.logged_in || auth.remembered)) {
                    return window.xprops.onAuth({
                        accessToken: auth.access_token
                    });
                }
            });
        }
    }, function logPage() {
        _logger.$logger.info('featureConfigTestValue-' + _squid.$meta.featureConfigTestValue);
        _logger.$logger.info('href', {
            href: window.location.href,
            windowName: _angular.$window.name && _angular.$window.name.slice(0, 100)
        });

        var match = document.cookie.toString().match(/ectoken=([^;]+)/);

        if (match && match[1] === _angular.$rootScope.token) {
            _logger.$logger.info('returning_user_same_token');
        } else if (match && match[1] !== _angular.$rootScope.token) {
            _logger.$logger.info('returning_user_diff_token');
        } else {
            _logger.$logger.info('non_returning_user');
        }

        document.cookie = 'ectoken=' + _angular.$rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';

        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {
            var navigationType = {
                0: 'regular',
                1: 'reload',
                2: 'back_forward'
            }[window.performance.navigation.type];

            if (navigationType) {
                _logger.$logger.info('navigation_' + navigationType);
            }
        }
    }, function handleTagManager() {
        // ****** Tag Manager Code Start Here ***********
        window.dataLayer = {
            // Two letter country code of the current page's content
            contentCountry: _squid.$locale.country.toLowerCase(),
            // Two letter locale
            contentLanguage: _squid.$locale.lang.toLowerCase()
        };

        var tagManagerUrl = 'https://' + _squid.$meta.cdnHost + _squid.$config.urls.tagProdUrl;

        // Based on the environment, Tag Manager end point can be changed.
        // For now the local and stage end points are same.
        if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
            tagManagerUrl = _squid.$config.urls.tagStageUrl;
        }

        // Load bootstrap.js asynchronously
        (function (i, s, o, g, r, a, m) {
            i['tagManagerObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            };
            i[r].l = 1 * new Date();
            a = s.createElement(o);
            m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', tagManagerUrl, 'tagManager');
    }, function logoutGuest() {
        var appData = _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token);

        return _index2.$AuthModel.instance().retrieve().then(function (auth) {
            // For DE 2nd button transactions, guest accounts are allowed on return flow
            if (appData.get('merchant.merchant_country') === 'DE' && (appData.get('is_second_button_txn') || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit')) {
                if (_credit.$CreditDataModel.instance(_angular.$rootScope.token).getCapeKey()) {
                    return;
                } else {
                    return auth.action('logout');
                }
            }

            // if venmo transaction, we'll log the buyer back in by sending them back to the venmo app
            if (_thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token)) {
                _thirdPartyInfo.thirdPartyExperience.resetThirdPartyExperience(); // removing token from experience flag
                _logger.$logger.info('venmo_login_retry');
            }

            if (auth.guest) {
                _logger.$logger.info('guest_logout');
                return auth.logoutAndRedirect('guest_logout');
            }
        });
    }, function checkProcessorDecline() {
        return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            if (appData.flags.processor_declined) {
                _logger.$logger.info('processor_decline_transaction');
                var authModel = _index2.$AuthModel.instance();

                if (authModel.auth_state === 'IDENTIFIED' && !_squid.$util.param('redirectToHermes')) {
                    // guest
                    return (0, _squid.$dispatch)('xoon', {
                        token: _angular.$rootScope.token,
                        hermesXoonRedirect: true
                    }, {
                        fromState: 'checkout_init',
                        toState: 'guest',
                        'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
                        'country.x': _squid.$locale.country
                    });
                }

                return;
            }
        });
    }, function logStart() {
        var networkAndDeviceData = getDeviceAndNetworkInfo();

        return _squid.$promise.hash({
            isMiniBrowser: _miniBrowser.$miniBrowser.isMiniBrowser(),
            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration(_angular.$rootScope.token),
            isIframe: _miniBrowser.$miniBrowser.isFramed()
        }).then(function (flags) {
            var app_int_type = _index.$DeviceInfo.getAppIntegrationType();

            _logger.$logger.info('app_start_design', {
                'from': 'client_middleware',
                'to': 'process_app_start_design',
                is_directintegration: flags.isDirectIntegration ? 1 : 0,
                is_incontext: flags.isMiniBrowser || flags.isIframe ? 1 : 0,
                app_int_type: app_int_type,
                'screen_width': _angular.$window.innerWidth,
                'screen_height': _angular.$window.innerHeight,
                'device_memory': networkAndDeviceData.memory,
                'network_type': networkAndDeviceData.type,
                'network_effectiveType': networkAndDeviceData.effectiveType,
                'network_downlink': networkAndDeviceData.downlink,
                'network_downlinkMax': networkAndDeviceData.downlinkMax,
                'network_roundTripTime': networkAndDeviceData.roundTripTime,
                'network_saveData': networkAndDeviceData.saveData
            });
        });
    }, function logPerformance() {
        if (window.enablePerformance) {
            var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];
            var timing = {};

            _angular2['default'].forEach(keys, function (key) {
                timing[key] = parseInt(window.performance.timing[key], 10) || 0;
            });

            var offset = timing.connectEnd - timing.navigationStart;

            if (timing.connectEnd && window.clientStartTime) {
                _angular2['default'].forEach(timing, function (time, name) {
                    if (time && _angular2['default'].isNumber(time)) {
                        _logger.$logger.info('timing_' + name, {
                            client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
                            req_elapsed: time - timing.connectEnd
                        });
                    }
                });
            }

            _logger.$logger.info('timing', timing);

            if (window.performance.memory) {
                _logger.$logger.info('memory', window.performance.memory);
            }

            if (window.performance.navigation) {
                _logger.$logger.info('navigation', window.performance.navigation);
            }

            if (window.performance.getEntries) {
                var logged = [];
                var logResources = function logResources() {
                    _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
                        if (!resource || !resource.name) {
                            return;
                        }

                        if (logged.indexOf(resource.name) === -1) {
                            logged.push(resource.name);
                        } else {
                            return;
                        }

                        if (resource.initiatorType) {
                            _logger.$logger.info(resource.initiatorType, resource);
                        }
                    });
                };

                logResources();
                setInterval(logResources, 500);
            }

            if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
                _logger.$logger.info('js_init', {
                    client_elapsed: 0,
                    req_elapsed: window.clientStartTime - offset
                });
            }
        } else {
            _logger.$logger.info('no_performance_data');
        }
    }, function logAuthState() {
        return _index2.$AuthModel.instance().retrieve().then(function (auth) {
            if (auth.logged_in) {
                _logger.$logger.info('user_logged_in');
            } else if (auth.remembered) {
                _logger.$logger.info('user_remembered');
            } else {
                _logger.$logger.info('user_not_logged_in');
            }
        });
    },

    // check for access token in the hash.
    function checkAccessToken() {
        if (window.xprops && window.xprops.accessToken) {
            return window.xprops.accessToken().then(function (accessToken) {
                _squid.$Api.addHeader('x-paypal-internal-euat', accessToken);
                return _index2.$AuthModel.instance().reload();
            });
        }

        var euat = _squid.$util.param('euat');

        if (euat) {
            var accessToken = euat === '1' ? window.location.hash.substr(2) : euat;

            if (accessToken) {
                _logger.$logger.info(euat === '1' ? 'access_token_from_hash' : 'access_token_from_param', {
                    access_token: accessToken
                });

                /* if (euat === '1') {
                    window.location.hash = '';
                } */

                var authModel = _index2.$AuthModel.instance();

                authModel.access_token = accessToken;

                if (window.xprops && window.xprops.onAuth) {
                    window.xprops.onAuth({ accessToken: accessToken });
                }
            }
        }
    },

    // check for FraudNet for Mobile View
    function enableFraudNetForMobileWebView() {
        if (_index.$DeviceInfo.isApp()) {
            _logger.$logger.info('force_fraudnet_for_mobile_webview');
            _angular.$window.enableFraudNetForMobileWebView = true;
        }
    },

    // Logs if service workers are enabled
    function isServiceWorkerSupported() {
        if ('serviceWorker' in navigator) {
            _logger.$logger.info('service_worker_supported');
        } else {
            _logger.$logger.info('service_worker_not_supported');
        }
    }, function forceCookiesDisabled() {
        if (_index.$DeviceInfo.isApp()) {
            return _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve().then(function (payee) {
                if (~_squid.$config.forceCookiesDisabled.indexOf(payee.merchant.id)) {
                    _logger.$logger.info('force_cookies_disabled');
                    _squid.$Api.forceCookiesDisabled = true;
                }
            });
        }
    }, function checkFramed() {
        if (_squid.$util.isIFrame()) {
            // Set this as "framed" mode (X icon, escape hatch, etc.)
            document.documentElement.className += ' framed';
        }
    }, function loginViaEuat() {
        // log in user via euat prior to rendering login screen.
        if (_squid.$util.param('euat') === '1') {
            var auth = _index2.$AuthModel.instance();

            if (auth.accessToken() && !auth.loggedIn()) {
                return auth.reload({
                    headers: {
                        'x-paypal-internal-euat': auth.accessToken()
                    },
                    resultModel: auth,
                    success: function success() {
                        return delete auth.access_token;
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new _squid.$FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            }
        }
    }, function checkForSDK() {
        var isSDKintegration = window.name && window.name.indexOf('xcomponent__ppcheckout') === 0 || window.name.indexOf('zoid__ppcheckout') === 0 || _squid.$util.param('xcomponent') || _squid.$util.param('zoid');

        var sdkLoaded = window.paypal && window.xprops && window.paypal.Checkout && window.paypal.Checkout.isChild();

        if (isSDKintegration && !sdkLoaded) {
            throw new Error('Checkout loaded in an SDK integration, but no xprops found. Maybe the sdk script failed to load in the child window.');
        }
    }, function setFraudnetID() {
        _angular.$rootScope.fraudNetId = (0, _metadata.getClientMetadataID)(_angular.$rootScope.fraudNetId);
    }, function urlFormatCheck() {
        // To verify the kind of urls being used for cancel and return.
        // Deeplink and universal urls have potential to affect integration
        // we need to log the use cases to keep track.
        return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            var urls = appData.urls || {};
            // 'regular' being false implies we have a non-standard format.
            var regular = new RegExp(_constants.constants.regex.safeProtocols, 'g');
            // 'modifed' is to check whether our new regex can catch all use cases.
            var modifed = new RegExp(_constants.constants.regex.protocolsWithDeeplink, 'g');
            _logger.$logger.info('url_pattern_test', {
                cancel_url: {
                    regular: regular.test(urls.cancel_url),
                    modifed: modifed.test(urls.cancel_url)
                },
                return_url: {
                    regular: regular.test(urls.return_url),
                    modifed: modifed.test(urls.return_url)
                }
            });
        });
    }, function shouldRedirectToUL() {
        var isNoLegacy = _squid.$util.param('nolegacy');
        var isFramed = _integration.$integration.isIFrame();

        // if we have 'nolegacy' query param AND we render in iframe
        if (isNoLegacy && isFramed) {
            _logger.$logger.info('is_nolegacy_iframe');

            return _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve().then(function (payee) {
                var merchantID = payee.merchant.id;

                // we load experiment
                return (0, _squid.$elmo)('hermes_nolegacy_framebust', { uid: merchantID }, 'Trmt_FEATURE_NOLEGACYFRAMEBUST_HERMES').then(function (result) {
                    // if not eligible
                    if (!(result && result.treatment_name)) {
                        return;
                    }
                    _logger.$logger.info('is_nolegacy_iframe_ul_eligible');

                    try {
                        // fetch flag
                        var isSecondTime = window.sessionStorage.getItem('checkoutHermesNoLegacy');

                        // if eligible and we know it's the 2nd time loading hermes
                        if (isSecondTime) {
                            // it's business as usual. We don't need 'checkoutHermesNoLegacy' for now
                            _logger.$logger.info('is_nolegacy_iframe_ul_ryi_render');
                            window.sessionStorage.removeItem('checkoutHermesNoLegacy');
                            return;
                        } else {
                            // else, this is the 1st time we render hermes. We store sessionStorage flag to read on reload
                            _logger.$logger.info('is_nolegacy_iframe_ul_redirect');
                            window.sessionStorage.setItem('checkoutHermesNoLegacy', true);
                            return _index2.$AuthModel.instance().logoutAndRedirect('insufficientPermission');
                        }
                    } catch (err) {
                        // in the case sessionStorage is NOT enabled (ie, Android Webview) bust iframe as last resort
                        _logger.$logger.info('is_nolegacy_iframe_sessionStorage_not_impld');

                        return _miniBrowser.$miniBrowser.frameBust();
                    }
                });
            });
        }
    }];
});

_logger.$logger;

_integration.$integration;

_miniBrowser.$miniBrowser;

_constants.constants;

_squid.$Api;

_squid.$Class;

_squid.$config;

_squid.$dispatch;

_squid.$FallbackError;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$promise;

_squid.$util;

_squid.$elmo;

;

_index.$DeviceInfo;

_fn.$fn;

_index2.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_credit.$CreditDataModel;

_thirdPartyInfo.thirdPartyExperience;

_metadata.getClientMetadataID;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/middleware.js"))

/***/ }),

/***/ "./js/lib/miniBrowser.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$miniBrowser = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _error = __webpack_require__("./js/lib/error.js");

var _$stateGo = _uiRouter.$state.go;

var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
    var name = _ref.name,
        _ref$logName = _ref.logName,
        logName = _ref$logName === undefined ? '' : _ref$logName;

    _logger.$logger.error('state_not_found' + logName, {
        name: name,
        hash: window.location.hash
    });
    throw new Error('state_not_found' + logName + ': ' + name);
};

_uiRouter.$state.go = function (name, params) {
    var _this = this,
        _arguments = arguments;

    var stateObj = _uiRouter.$state.get(name);

    var stateGo = function stateGo(state) {
        if (!window.xchild) {
            return _$stateGo.apply(_this, _arguments);
        }

        if (!state.loginRequired) {
            return _$stateGo.apply(_this, _arguments);
        }

        // If we're allowed to collect data in this integration, we don't need this functionality
        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return _$stateGo.apply(_this, _arguments);
        }

        var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();

        if (forceIframe) {
            return _$stateGo.apply(_this, _arguments);
        }

        // First check our integration supports falling back to a popup
        if (!_integration.$integration.getConfig('CAN_FALLBACK_TO_POPUP')) {
            throw _integration.$integration.error('Can not fallback to popup for data collection');
        }

        window.xchild.hide();

        var url = window.location.href.split('#')[0] + '#/' + state.name.replace(/\./g, '/');
        var xprops = _extends({}, window.xprops);

        xprops.url = url;

        window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops)['catch'](function (err) {

            if (window.ppxo.PopupOpenError && err instanceof window.ppxo.PopupOpenError) {
                window.xchild.show();

                _logger.$logger.warn('framebust_from_' + name.replace(/[^a-zA-Z0-9]+/g, '_'));

                return _$stateGo.call(_this, 'checkout.framebust', { action: 'open', url: url });
            }

            (0, _error.$exceptionHandler)(err);
        });
    };

    if (stateObj) {
        return stateGo(stateObj);
    } else if (_squid.$meta.codeSplitting) {
        // in case of code split - attempt to load route and then change the state
        return (0, _squid.lazyLoadRoute)(name, params, false)['catch'](function () {
            logStateNotFoundAndThrow({ name: name, logName: '_lazy_loading' });
        }).then(function () {
            stateObj = _uiRouter.$state.get(name);
            return stateGo(stateObj);
        });
    } else {
        logStateNotFoundAndThrow({ name: name });
    }
};

var $miniBrowser = exports.$miniBrowser = {
    flags: {},
    config: {},
    isMiniBrowser: function isMiniBrowser() {
        return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
    },
    isFramed: function isFramed() {
        return _squid.$util.isIFrame();
    },
    getPartnerIntegration: function getPartnerIntegration(token) {
        return _squid.$promise.call(function () {
            if (window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1') {
                return true;
            }
            return _checkout.$CheckoutCartModel.instance(token).retrieve().then(function (cart) {
                return Boolean(cart.partnerIntegration);
            });
        });
    },
    getNativeCheckoutIntegration: function getNativeCheckoutIntegration(token) {
        return _squid.$promise.call(function () {
            if (_squid.$util.param('native_xo') === '1') {
                return true;
            }
            return false;
        });
    },
    getMessengerBAIntegration: function getMessengerBAIntegration(token) {
        return _squid.$promise.call(function () {
            if (window.xprops && window.xprops.experience && window.xprops.experience.messenger) {
                _logger.$logger.info('getMessengerBAIntegration == true');
                return true;
            }
            return false;
        });
    },
    getDirectIntegration: function getDirectIntegration(token) {
        return _squid.$promise.call(function () {
            if (_squid.$util.param('incontext')) {
                return true;
            }

            if (this.isMiniBrowser() || this.isFramed()) {
                return true;
            }

            if (window.location.pathname.indexOf('/checkoutnow') > -1 || window.location.pathname.indexOf('/webapps/hermes') > -1) {
                return true;
            }

            return this.getPartnerIntegration(token);
        }.bind(this));
    },
    getWPSIntegration: function getWPSIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            var isWPS = appData.is_wps_flow();

            // TODO: remove these, we should not use $rootScope
            _angular.$rootScope.invoice = appData.flags.is_invoice_flow;
            _angular.$rootScope.wps = isWPS;

            if (isWPS) {
                _logger.$logger.info('hermes_wps_flow', {
                    token: _angular.$rootScope.token
                });
            } else {
                _logger.$logger.info('hermes_xo_order_flow', {
                    token: _angular.$rootScope.token
                });
            }
            return isWPS;
        });
    },

    getWpsSubscriptionIntegration: function getWpsSubscriptionIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.is_wps_subscription_flow();
        });
    },

    getWpsAutobillingIntegration: function getWpsAutobillingIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.isWpsAutobillingFlow();
        });
    },

    getWpsInstallmentPlanIntegration: function getWpsInstallmentPlanIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.is_wps_installmentplan_flow();
        });
    },

    getFlags: function getFlags(token) {
        _logger.$logger.info('miniBrowser_getFlags');
        return _squid.$promise.hash({
            isMiniBrowser: this.isMiniBrowser(),
            isFramed: this.isFramed(),
            isPartnerIntegration: this.getPartnerIntegration(token),
            isDirectIntegration: this.getDirectIntegration(token),
            isNativeCheckout: this.getNativeCheckoutIntegration(token),
            isMessengerBAIntegration: this.getMessengerBAIntegration(token),
            isWPSIntegration: this.getWPSIntegration(token),
            isWpsSubscription: this.getWpsSubscriptionIntegration(token),
            isWpsAutobilling: this.getWpsAutobillingIntegration(token),
            isWpsInstallmentPlan: this.getWpsInstallmentPlanIntegration(token)
        }).then(function (flags) {

            // TODO: Remove these, we should not use $rootScope
            _angular.$rootScope.miniBrowser = flags.isMiniBrowser;
            _angular.$rootScope.partnerIntegration = flags.isPartnerIntegration;

            if (flags.isPartnerIntegration && !window.xchild) {
                _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
            } else if (flags.isFramed) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_LIGHTBOX);
                if (flags.isMessengerBAIntegration) {
                    _integration.$integration.setFlow(_integration.$FLOWS.MESSENGER_BA_INTEGRATION);
                    _logger.$logger.info('$integration.setFlow($FLOWS.MESSENGER_BA_INTEGRATION)');
                }
            } else if (flags.isMiniBrowser) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_POPUP);
            } else if (flags.isNativeCheckout) {
                _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
            } else if (flags.isWpsSubscription) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_SUBSCRIPTION);
            } else if (flags.isWpsAutobilling) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_AUTOBILLING);
            } else if (flags.isWpsInstallmentPlan) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_INSTALLMENTPLAN);
            } else if (flags.isWPSIntegration) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS);
            } else {
                _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
            }

            return flags;
        });
    },
    init: function init(token) {
        var _this2 = this;

        _logger.$logger.info('miniBrowser_init');
        return _squid.$promise.sequential([function () {
            return _this2.enableAutoResize();
        }, function () {
            return _this2.getFlags(token);
        }, function () {
            return _this2.logIntegration(token);
        }, function () {
            return _this2.sendPostMessage(token);
        }, function () {
            return _this2.handleWindowOpenerClose();
        }]);
    },
    enableAutoResize: function enableAutoResize() {
        _angular.$rootScope.$on('allLoaded', function () {
            if (window.xchild && window.xchild.enableAutoResize) {
                window.xchild.enableAutoResize();
            }
        });
    },
    logIntegration: function logIntegration(token) {
        _logger.$logger.info('miniBrowser_logIntegration');
        return this.getFlags(token).then(function (flags) {
            var match = window.name.match(/PPFrame(\w+)/);
            var guid = match && match[1];

            if (guid) {
                _logger.$logger.info('integration_guid', {
                    guid: guid
                });
            }

            if (window.xchild || guid) {
                var beacon = new Image();

                beacon.src = '/webapps/hermes/api/logger?event=ppxo_uid_token&uid=' + (window.xprops ? window.xprops.uid : guid) + '&token=' + token;
            }

            _logger.$logger.info(flags.isMiniBrowser ? 'minibrowser_flow' : 'non_minibrowser_flow');
            _logger.$logger.info(flags.isFramed ? 'framed_flow' : 'non_framed_flow');
            _logger.$logger.info(flags.isDirectIntegration ? 'direct_integration_flow' : 'non_direct_integration_flow');
            _logger.$logger.info(flags.isPartnerIntegration ? 'partner_integration_flow' : 'non_partner_integration_flow');
        });
    },

    handleWindowOpenerClose: function handleWindowOpenerClose() {
        _logger.$logger.info('miniBrowser_handleWindowOpenerClose');
        if (_integration.$integration.isContext(_integration.$CONTEXT.POPUP)) {
            var interval = setInterval(function () {
                try {
                    if (!window.opener || window.opener.closed) {
                        clearInterval(interval);
                        _logger.$logger.info('window_opener_closed');
                        // TODO: close this window if opener closed?
                    }
                } catch (err) {
                    // pass
                }
            }, 50);
        }
    },

    sendPostMessage: function sendPostMessage(token) {
        if (window.xchild) {
            return;
        }

        return _squid.$promise.hash({
            isPartnerIntegration: this.getPartnerIntegration(token),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token).retrieve()
        }).then(function (data) {
            if (!_integration.$integration.getConfig('POST_MESSAGE_PARENT')) {
                return;
            }

            var msg = void 0;

            try {
                msg = {
                    operation: 'init',
                    cancelUrl: data.checkoutAppData.urls.cancel_url,
                    landingUrl: window.location.href,
                    secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
                };
            } catch (err) {
                return _logger.$logger.error('minibrowser_msg_construction_failed', {
                    error: err
                });
            }

            if (!_util.$ReturnToMerchant.postToMerchant(msg)) {
                _logger.$logger.error('minibrowser_post_failed');
            }
        });
    },
    frameBust: function frameBust(token) {
        return _squid.$promise.hash({
            isFramed: this.isFramed()
        }).then(function (flags) {
            if (!flags.isFramed) {
                return;
            }

            var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();

            if (forceIframe) {
                return;
            }

            if (window.xchild) {
                _logger.$logger.info('frame_bust_xchild');
                _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
            } else {
                _logger.$logger.info('frame_bust');
                _squid.$util.redirect(window.location.href, { frameBust: true });
            }
        });
    }
};

angular.value("$miniBrowser", $miniBrowser);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_squid.$promise;

_squid.$util;

_squid.$locale;

_squid.$meta;

_squid.lazyLoadRoute;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_util.$ReturnToMerchant;

_integration.$integration;

_integration.$FLOWS;

_integration.$CONTEXT;

_error.$exceptionHandler;

/***/ }),

/***/ "./js/lib/security.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    var errorCount = 0;

    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        var auth = _index.$AuthModel.instance();

        if (toState.auth !== false && !auth.logged_in) {
            errorCount += 1;
            if (errorCount === 10) {
                _logger.$logger.error('max_state_requires_auth');
            }
            if (errorCount >= 10) {
                return;
            }
            _logger.$logger.warn('state_requires_auth', {
                stateName: toState.name
            });
            event.preventDefault();
            throw new _squid.$Forbidden('state_transition_forbidden', { fromState: fromState, toState: toState });
        }
    });

    (0, _angular.$interval)(function () {
        var auth = _index.$AuthModel.instance();

        if (auth.logged_in) {
            // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper) and prevent user to be logged out
            // instead we should show error page
            if (auth.disallow_login_switch) {
                _uiRouter.$state.go('checkout.genericError', {
                    code: 'DEFAULT_TOKENIZED_WALLET_ERROR'
                });
                return;
            }

            auth.reload({ silent: true }).then(function () {
                if (_uiRouter.$state.current.auth !== false && !auth.logged_in) {
                    errorCount += 1;
                    if (errorCount === 10) {
                        _logger.$logger.error('max_state_requires_auth');
                    }
                    if (errorCount >= 10) {
                        return;
                    }
                    _logger.$logger.info('idle_timeout');
                    _logger.$logger.warn('state_requires_auth', {
                        stateName: _uiRouter.$state.current.name
                    });
                    errorCount += 1;
                    throw new _squid.$Forbidden();
                }
            });
        }
    }, 30 * 60 * 1000);

    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
});

_uiRouter.$state;

_squid.$Forbidden;

_squid.$util;

_logger.$logger;

_index.$AuthModel;

/***/ }),

/***/ "./js/lib/stateChangeListener.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    // Decorate the current state with the transition params
    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        _uiRouter.$state.toState = toState;
        _uiRouter.$state.toParams = toParams;
        _uiRouter.$state.fromState = fromState;
        _uiRouter.$state.fromParams = fromParams;
    });
});

_uiRouter.$state;

/***/ }),

/***/ "./js/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.isConfigForRulesSummaryEnabled = isConfigForRulesSummaryEnabled;
exports.isConfigForMerchantPreferencesEnabled = isConfigForMerchantPreferencesEnabled;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function isConfigForRulesSummaryEnabled() {
    return _squid.$config.readRulesSummaryFromAppData === true || _squid.$config.readRulesSummaryFromAppData === 'true';
}

function isConfigForMerchantPreferencesEnabled() {
    return _squid.$config.readMerchantPreferencesFromAppData === true || _squid.$config.readMerchantPreferencesFromAppData === 'true';
}

_squid.$config;

/***/ }),

/***/ "./pages/services/balance/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BalanceEligibilityFactory', ['$rootScope', '$q', function ($rootScope, $q) {
    var state = {
        eligibility: null
    };
    var get = function get() {
        _logger.$logger.info('$BalanceEligibilityFactory_get');
        return state;
    };
    /**
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @returns {Promise<Object>} Returns the current $BalanceEligibilityFactory state
     */
    var init = function init() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$checkoutSession = _ref.checkoutSession,
            checkoutSession = _ref$checkoutSession === undefined ? _checkout.$CheckoutSessionModel.instance($rootScope.token) : _ref$checkoutSession;

        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);
        var hasBalanceInstrument = disallowedInstruments.length && disallowedInstruments.find(function (fi) {
            return fi.declineReason === 'CIP_INCOMPLETE' && fi.type === 'BALANCE';
        });
        if (hasBalanceInstrument) {
            var currentState = get();
            currentState.eligibility = false;
        }
        _logger.$logger.info('$BalanceEligibilityFactory_init', get());
        return $q.resolve(get());
    };
    // Expose public $BalanceEligibilityFactory APIs
    return {
        get: get,
        init: init
    };
}]);

_logger.$logger;

_checkout.$CheckoutSessionModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/services/balance", "pages/services/balance/index.js"))

/***/ }),

/***/ "./pages/services/cardart-instrument/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

/**
 * $CardartInstrument is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 *
 * Currently, $CardardInstrument is being used at:
 * - xo-review
 * - xo-select-fi
 * - xo-sidebar-manage-wallet
 * - xo-wallet
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$CardArtInstrument', function () {
    var CARD = 'CARD';
    var BALANCE = 'BALANCE';
    var wallet = _wallet.$WalletModel.instance(_squid.$meta.token);

    var isCardArtEnable = function isCardArtEnable(fiMeta) {
        return fiMeta && fiMeta.cardArtEnabled();
    };

    /**
     * @param {Ojbect} instrument A future payment instrument
     * @returns {Object}
     */
    var normalizeFutureInstrument = function normalizeFutureInstrument(instrument) {
        return {
            id: instrument.instrument_id,
            type: instrument.type,
            cardArtUrl: wallet.getCardArt(instrument)
        };
    };

    /**
     * @param {Object} options
     * @param {Object} otpions.primaryFs A primaryFs funding options
     * @returns {Object}
     */
    var normalizeFundingOptions = function normalizeFundingOptions(_ref) {
        var primaryFs = _ref.primaryFs;

        if (!primaryFs) {
            return {};
        }

        return {
            id: primaryFs.id,
            type: primaryFs.type,
            cardArtUrl: wallet.getCardArt(primaryFs)
        };
    };

    /**
     * @typedef {Object} FI
     * @property {String} fi_id
     * @property {String} fi_type
     * @property {String} is_cardart_shown
     * @property {String} eligible
     *
     * @typedef {Object} CardartInstrumentation
     * @property {Array<FI>} fi
     *
     * @param {Object} options
     * @param {Array} options.plans An array of fundingOptions plans or future payment instruments
     * @returns {Object<CardartInstrumentation>}
     */
    var normalizePayload = function normalizePayload(_ref2) {
        var _ref2$plans = _ref2.plans,
            plans = _ref2$plans === undefined ? [] : _ref2$plans;
        return {
            fi: plans.filter(function (plan, index, arr) {
                var id = arr.map(function (item) {
                    return item.id;
                });

                return index === id.indexOf(plan.id) && plan.type !== BALANCE;
            }).map(function (_ref3) {
                var id = _ref3.id,
                    type = _ref3.type,
                    cardArtUrl = _ref3.cardArtUrl;
                return {
                    fi_id: id,
                    fi_type: 'fi_' + (type && type.toLowerCase()),
                    is_cardart_shown: type === CARD && cardArtUrl ? '1' : '0',
                    eligible: type === CARD && cardArtUrl ? 'cardart' : null
                };
            })
        };
    };

    /**
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @returns {Array}
     */
    var getSelectedInstrument = function getSelectedInstrument(_ref4) {
        var checkoutSession = _ref4.checkoutSession;

        return checkoutSession.getSelectedStickyInstrument() ? [checkoutSession.getSelectedStickyInstrument()].map(normalizeFutureInstrument) : [];
    };

    /**
     * CreatePayload creates cardart instrumentation based on the following criteria:
     *
     * - showMultipleFiVariants pxp
     * - showMultipleFiVariants + 3FI pxp
     * - singleFI pxp
     *
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @param {Boolean} options.isBillingNoPurchase $CheckoutCartModel.isBillingNoPurchase()
     * @param {Boolean} options.stickyEligible Default to be false
     * @param {Boolean} options.renderMultipleFi Determines whether to render multiple FIs or not
     * @param {Boolean} options.renderSingleFi Determines whether to render single FI or not
     * @param {Object} options.showMoreFiState ShowMoreFiState to determine whether we renders `Show More` expereience or not.
     * See $ShowMoreFiFactory.get() for details implementation
     * @returns {Object<CardartInstrumentation>}
     */
    var createPayload = function createPayload(_ref5) {
        var checkoutSession = _ref5.checkoutSession,
            isBillingNoPurchase = _ref5.isBillingNoPurchase,
            _ref5$stickyEligible = _ref5.stickyEligible,
            stickyEligible = _ref5$stickyEligible === undefined ? false : _ref5$stickyEligible,
            _ref5$renderMultipleF = _ref5.renderMultipleFi,
            renderMultipleFi = _ref5$renderMultipleF === undefined ? false : _ref5$renderMultipleF,
            _ref5$renderSingleFi = _ref5.renderSingleFi,
            renderSingleFi = _ref5$renderSingleFi === undefined ? false : _ref5$renderSingleFi,
            _ref5$showMoreFiState = _ref5.showMoreFiState,
            showMoreFiState = _ref5$showMoreFiState === undefined ? {
            eligible: false,
            isTooManyFi: false,
            isShowMoreBtnClicked: false
        } : _ref5$showMoreFiState;
        var eligible = showMoreFiState.eligible,
            isTooManyFi = showMoreFiState.isTooManyFi,
            isShowMoreBtnClicked = showMoreFiState.isShowMoreBtnClicked;

        var plans = isBillingNoPurchase ? checkoutSession.get('futurePaymentInstruments', []).map(normalizeFutureInstrument) : (checkoutSession.getPlanList() || []).map(normalizeFundingOptions);

        // when we do decide to render multiple FIs experience
        if (renderMultipleFi) {
            plans = eligible && isTooManyFi // eslint-disable-line no-nested-ternary
            ? isShowMoreBtnClicked ? plans.slice(0) // If `addMore` action has been triggered, we log all FIs
            : plans.slice(0, 3) // otherwise, we only log the first 3FIs
            : plans;
        } else if (renderSingleFi) {
            // Or, render a single FI experience
            // ensure we check if we have a sticky plan
            if (stickyEligible) {
                plans = getSelectedInstrument({ checkoutSession: checkoutSession });
            } else {
                plans = plans.slice(0, 1);
            }
        }

        return normalizePayload({ plans: plans });
    };

    return {
        createPayload: createPayload,
        isCardArtEnable: isCardArtEnable
    };
});

_squid.$meta;

_wallet.$WalletModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/services/cardart-instrument", "pages/services/cardart-instrument/index.js"))

/***/ }),

/***/ "./pages/services/shared-util/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var DECLINE_TYPE = {
    PRE_AUTH: 'PREAUTH'
};

/**
 * $SharedUtil is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SharedUtil', function () {

    /**
     * checks at least one FI in the plan has cpa information
     * might not be required just having for now
     */
    var isAuthRequiredInAnyFI = function isAuthRequiredInAnyFI(checkoutSession) {
        var isAuthRequired = false;
        var plans = checkoutSession && checkoutSession.getPlanList();

        // Check if any existing plans has pre auth data.
        if (plans && plans.length) {
            isAuthRequired = plans.some(function (plan) {
                /**
                 * In the PPC CPA initiative, due to constraints in the backend, Risk layer sends PPC preAuthorization data to all member checkout flows, including hermes.
                 * However, hermes is not a part of the PPC PCA. Thus, we are disabling CPA disclaimer if user only has a PPC eligible for CPA
                 */
                var isPPCReuse = plan && plan.primaryFs && plan.primaryFs.name === 'BILL_ME_LATER';
                return plan.primaryFs && plan.primaryFs.pre_authorization_instruction && !isPPCReuse;
            });
        }

        _logger.$logger.info('is_auth_required_fi', {
            isAuthRequired: isAuthRequired
        });

        return isAuthRequired;
    };

    var isSelectedPlanRequiresAuth = function isSelectedPlanRequiresAuth(plan) {
        /**
         * In the PPC CPA initiative, due to constraints in the backend, Risk layer sends PPC preAuthorization data to all member checkout flows, including hermes.
         * However, hermes is not a part of the PPC PCA. Thus, we are preventing preAuthorization call from happening if user checks out with PPC.
         */
        var isPPCReuse = plan && plan.primaryFs && plan.primaryFs.name === 'BILL_ME_LATER';
        var isPlanRequireAuth = plan && plan.primaryFs && plan.primaryFs.pre_authorization_instruction && plan.primaryFs && !isPPCReuse;

        _logger.$logger.info('is_plan_require_auth', {
            isPlanRequireAuth: isPlanRequireAuth
        });

        return isPlanRequireAuth;
    };

    /*
     * check the declined instrument is for reason auth decline
     */
    var isAuthDeclinedInstrument = function isAuthDeclinedInstrument(checkoutSession) {
        var isDeclinedInstrument = false;

        var declinedInstruments = checkoutSession.declinedInstruments || [];

        // if yes, then we make elmo call, otherwise not.
        if (declinedInstruments && declinedInstruments.length) {
            isDeclinedInstrument = declinedInstruments.some(function (instrument) {
                return instrument.decline_type === DECLINE_TYPE.PRE_AUTH;
            });
        }

        _logger.$logger.info('is_auth_declined_instrument', {
            isDeclinedInstrument: isDeclinedInstrument
        });

        return isDeclinedInstrument;
    };

    var isBoolean = function isBoolean(value) {
        return Object.prototype.toString.call(value) === '[object Boolean]';
    };

    /*
        Check if the flow is supscription v1 or subscription WPS and log results
     */
    var getSubscriptionDetails = function getSubscriptionDetails(token) {
        if (!token) {
            return {};
        }
        var isSubscriptionV1 = _checkout.$CheckoutCartModel.instance(token) && _checkout.$CheckoutCartModel.instance(token).isSubscriptionsV1();
        var isWpsSubscription = _checkout.$CheckoutAppDataModel.instance(token) && _checkout.$CheckoutAppDataModel.instance(token).is_wps_subscription_flow();

        var subscriptionType = void 0,
            integrationType = void 0;
        // Check subscription type
        if (isSubscriptionV1) {
            subscriptionType = 'subscriptions_v1';
            // Check if SDK integration type
            integrationType = window && window.xprops ? 'SDK' : 'API';
        }
        if (isWpsSubscription) {
            subscriptionType = 'subscriptions_wps';
        }
        return {
            subscriptionType: subscriptionType,
            integrationType: integrationType
        };
    };

    var logSubscriptionDetails = function logSubscriptionDetails(token, pageName) {
        var subscriptionDetails = getSubscriptionDetails(token);
        if (!subscriptionDetails) {
            return;
        }

        var _ref = subscriptionDetails || {},
            subscriptionType = _ref.subscriptionType,
            integrationType = _ref.integrationType;
        // Event key and logging susbcription type


        if (subscriptionType) {
            var logKey = 'hermes_' + pageName + '_' + subscriptionType + '_integration=' + integrationType + '_rendered';
            _logger.$logger.info(logKey, subscriptionDetails);
        }
    };

    var isPPCashToBalanceEnabled = function isPPCashToBalanceEnabled($locale) {
        return $locale.country === 'US';
    };

    var logSubscriptionEvent = function logSubscriptionEvent(token) {
        var subscriptionDetails = getSubscriptionDetails(token);
        return function () {
            var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (subscriptionDetails.subscriptionType) {
                var prefixStateName = payload.from ? 'subscription_' + payload.from : payload.from;
                if (prefixStateName) {
                    payload.from = prefixStateName;
                }
                _logger.$logger.info('checkout_fpti', payload);
            }
        };
    };

    var getFiDetails = function getFiDetails(fiArray) {
        if (!fiArray || !Array.isArray(fiArray)) {
            return {};
        }
        var fi_cnt = fiArray.length || 0;

        var _ref2 = fiArray[0] || {},
            _ref2$is_preferred = _ref2.is_preferred,
            is_preferred = _ref2$is_preferred === undefined ? false : _ref2$is_preferred,
            _ref2$instrument_id = _ref2.instrument_id,
            chosen_fi_id = _ref2$instrument_id === undefined ? 'none' : _ref2$instrument_id,
            _ref2$type = _ref2.type,
            chosen_fi_type = _ref2$type === undefined ? 'none' : _ref2$type;

        var _ref3 = fiArray.find(function (fi) {
            return fi.is_preferred;
        }) || {},
            _ref3$instrument_id = _ref3.instrument_id,
            preferred_fi_id = _ref3$instrument_id === undefined ? 'none' : _ref3$instrument_id,
            _ref3$type = _ref3.type,
            preferred_fi_type = _ref3$type === undefined ? 'none' : _ref3$type;

        return {
            // Using approx keys here as we have to send FPTI data acc to this dictionary: https://github.paypal.com/Checkout/xo-hermes-beaver/blob/master/lib/dictionaries.js#L6
            funding_instrument_count: fi_cnt,
            chosen_funding_option: chosen_fi_id,
            card_type: chosen_fi_type,
            default_funding_option: preferred_fi_id,
            preferred_fi_type: preferred_fi_type,
            is_preferred: is_preferred
        };
    };

    return {
        isAuthRequiredInAnyFI: isAuthRequiredInAnyFI,
        isSelectedPlanRequiresAuth: isSelectedPlanRequiresAuth,
        isAuthDeclinedInstrument: isAuthDeclinedInstrument,
        getSubscriptionDetails: getSubscriptionDetails,
        logSubscriptionDetails: logSubscriptionDetails,
        isBoolean: isBoolean,
        isPPCashToBalanceEnabled: isPPCashToBalanceEnabled,
        logSubscriptionEvent: logSubscriptionEvent,
        getFiDetails: getFiDetails
    };
});

_logger.$logger;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/services/shared-util", "pages/services/shared-util/index.js"))

/***/ }),

/***/ "./pages/xo-add-card-meft/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageAddCardMeftPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

var _template = __webpack_require__("./pages/xo-add-card-meft/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddCardMeftPageComponent = exports.$xoPageAddCardMeftPageComponent = _squid.$Component.extend('$xoPageAddCardMeftPageComponent', {
    tag: 'xo-page-add-card-meft-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.locale = _squid.$locale;
        $scope.token = _angular.$rootScope.token;
        $scope.checkoutAppData = _checkout.$CheckoutAppDataModel.instance($scope.token);
        $scope.showmeftsection = {
            toggle: true
        };
        $scope.billingaddressupdated = {
            value: false
        };
        function populateInfoMessage() {
            var msg = _squid.$locale.content.get('DEMemberGuest.meftDeclinePageErrorMsg');

            $scope.message = {
                msgs: [msg],
                type: 'info'
            };
        }
        populateInfoMessage();

        $scope.useMeft = function () {
            return $scope.checkoutAppData.action('meft', {
                success: function success(result) {
                    // reload checkout session with new meft instrument.
                    _checkout.$CheckoutSessionModel.instance($scope.token).reload();
                    _uiRouter.$state.go('checkout.review');
                }
            });
        };

        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            }
        };
    }]
});

angular.value("$xoPageAddCardMeftPageComponent", $xoPageAddCardMeftPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "./pages/xo-add-card-meft/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddCardMeftRoute = undefined;

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-add-card-meft/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $AddCardMeftRoute = exports.$AddCardMeftRoute = _squid.$ComponentRoute.extend('$AddCardMeftRoute', {

    path: 'pageAddCardMeft',
    directive: 'xo-page-add-card-meft-page',
    titleContent: 'asideHeader.addCard',
    query: ['message'],
    trackingData: {
        templateName: 'meftDeclineAddCard.dust',
        pageGoal: 'Add Card for MEFT Decline',
        buzname: {
            'fullpage': {
                'pagename': '%:de:meft-addcard',
                'pagename2': '%:de:meft-addcard:member:hermes:',
                'hier1': '%de',
                'version': 'member:%:',
                'flowname': '%de',
                'subfeature2': '%de'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            pagetitle: 'pagetitle',
            billingaddressupdated: 'billingaddressupdated',
            showmeftsection: 'showmeftsection',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$AddCardMeftRoute", $AddCardMeftRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-card-meft/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n            <div ng-show=\"showmeftsection.toggle\">\n                <p class=\"useMeftInstead\">{{content ('DEMemberGuest.useMeftInstead')}}</p>\n\n                <div>\n                    <a track-link=\"meft_done\" id=\"submitBtnMeft\" href=\"\" class=\"btn btn-secondary\n                            btn-large full submit\" ng-click=\"useMeft()\"\n                       role=\"button\">{{content ('DEMemberGuest.useMeftBtn')}}</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageAddCardPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/factory.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _checkoutIncentive = __webpack_require__("../node_modules/xo-models/src/checkoutIncentive/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/no-balance/directive.js");

var _factory3 = __webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/factory.js");

var _template = __webpack_require__("./pages/xo-add-card/template.html");

var _template2 = _interopRequireDefault(_template);

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var disallowedExp = _factory3.$ExpiredFiPanelFactory.disallowedExp;
var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
    tag: 'xo-page-add-card-page',
    template: _template2['default'],
    scope: {},
    controller: ['$scope', function ($scope) {
        if (_uiRouter.$stateParams.cause === 'cpa') {
            $scope.cause = _uiRouter.$stateParams.cause;
        }
        $scope.locale = _squid.$locale;
        $scope.token = _angular.$rootScope.token;
        $scope.showIncentive = false; // Assume we won't show an incentive
        $scope.isProcessorDeclineExperiment = false;
        $scope.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);
        $scope.logSubscriptionEvent({
            from: 'add_card_rendered',
            to: 'prepare_add_card'
        });
        var models = {};

        $scope.callbacks = {
            finish: function finish() {
                $scope.logSubscriptionEvent({
                    from: 'add_card_completed',
                    to: 'process_add_card'
                });
                if (models.cart.isWalletTokenization() && models.walletPinModel.isSetupEligible()) {
                    _logger.$logger.debug('pinSetup_required');
                    _uiRouter.$state.go('checkout.pinSetup');
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            },
            cancel: function cancel(routeTo) {
                $scope.logSubscriptionEvent({
                    from: 'add_card_cancelled',
                    to: 'process_add_card'
                });
                var goTo = routeTo || $scope.parentState || '';

                _logger.$logger.debug('xoAddCard_cancel', { goTo: goTo });
                if (goTo) {
                    _uiRouter.$state.go(goTo);
                }
            }
        };

        (0, _squid.$populate)(models, {
            checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            unavailableCard: _fi.$UnavailableCardModel.instance(),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token),
            cart: _checkout.$CheckoutCartModel.instance($scope.token),
            auth: _auth.$AuthModel.instance().retrieve(),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token).retrieve(),
            noBalanceFactoryState: _factory.$NoBalanceFactory.decideEligibility(),
            fiMeta: _index2['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
        }).then(function () {
            $scope.PPBalanceFlow = _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale);
            $scope.noBalanceFactoryState = _factory.$NoBalanceFactory.get();
            // Resolve additional information needed
            var getWalletPinModel = function getWalletPinModel() {
                if (models.cart.isWalletTokenization()) {
                    return (0, _squid.$populate)(models, {
                        walletPinModel: _app.$TokenizedWalletPinModel.instance($scope.token)
                    });
                }
            };

            var getCheckoutIncentiveEligibility = function getCheckoutIncentiveEligibility() {
                return (0, _angular.$q)(function (resolve, reject) {
                    var fptiData = {
                        from: 'FI_addCardAccount',
                        to: 'prepare_FI_addCardAccount',
                        context_id: $scope.token,
                        eligibility_reason: ''
                    };

                    if (models.cart.isWalletTokenization()) {
                        fptiData.eligibility_reason = 'Incentive_Ineligible_Wallet_Tokenization';
                        _logger.$logger.info('checkout_fpti', fptiData);
                        return resolve(false);
                    }

                    if (models.payee.isGambling()) {
                        fptiData.eligibility_reason = 'Incentive_Ineligible_Gambling_Merchant';
                        _logger.$logger.info('checkout_fpti', fptiData);
                        return resolve(false);
                    }

                    var country_code = _squid.$locale.getCountryCodeISO();

                    var offerEligibilityData = {
                        payer_id: models.auth.buyer_id,
                        country_code: country_code,
                        language: _squid.$locale.getLocaleCode(),
                        touchpoint_code: 'CHECKOUT_INCENTIVE' // TODO don't hardcode this?
                    };

                    $scope.evaluateCheckoutOfferEligibilityModel = _checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel.instance();

                    $scope.evaluateCheckoutOfferEligibilityModel.save({
                        data: offerEligibilityData,
                        success: function success() {

                            if (!$scope.evaluateCheckoutOfferEligibilityModel.isEligible()) {
                                fptiData.eligibility_reason = 'Incentive_Ineligible_Not_In_MORS_Segment';
                                _logger.$logger.info('checkout_fpti', fptiData);
                                return resolve(false);
                            }

                            $scope.getOfferProgramModel = _checkoutIncentive.$GetOfferProgramModel.instance();
                            var offer_program_code = $scope.evaluateCheckoutOfferEligibilityModel.getOfferProgramCode();

                            $scope.getOfferProgramModel.retrieve({
                                params: { offer_program_code: offer_program_code },
                                success: function success() {
                                    var offerCurrencyCode = $scope.getOfferProgramModel.getOfferCurrencyCode();
                                    var cartCurrencyCode = models.cart.getCartCurrencyCode();

                                    if (cartCurrencyCode !== offerCurrencyCode) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Cart_Currency_Not_Offer_Currency';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    var txnMinimumLowestDenom = $scope.getOfferProgramModel.getMinCartTotalLowestDenom();
                                    var precisionDigits = _squid.$locale.metadata.currency.digits[offerCurrencyCode];
                                    var txnMinimum = txnMinimumLowestDenom;

                                    if (precisionDigits) {
                                        txnMinimum = (txnMinimumLowestDenom / Math.pow(10, precisionDigits)).toFixed(precisionDigits);
                                    }

                                    var txnAmt = models.cart.getPurchaseAmount();
                                    var isTxnWorthEnough = txnAmt >= txnMinimum;

                                    if (!isTxnWorthEnough) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Transaction_Not_Worth_Enough';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    var isUserInApplicableCountry = $scope.getOfferProgramModel.isUserInApplicableCountry(country_code);

                                    if (!isUserInApplicableCountry) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Country_Ineligible';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    fptiData.eligibility_reason = 'Incentive_Eligible';
                                    _logger.$logger.info('checkout_fpti', fptiData);

                                    var pxpFptiData = {
                                        state_name: 'FI_addCardAccount',
                                        transition_name: 'prepare_FI_addCardAccount_incentive',
                                        incentive_name: ''
                                    };

                                    return _factory2.$AddCardFactory.getCheckoutIncentivePxpResult().then(function (result) {
                                        if (result === 'xo_hermes_checkout_incentive_show') {
                                            pxpFptiData.incentive_name = $scope.getOfferProgramModel.offer_program_code;
                                            _logger.$logger.info('checkout_fpti', pxpFptiData);
                                            return resolve(true);
                                        }

                                        _logger.$logger.info('checkout_fpti', pxpFptiData);
                                        return resolve(false);
                                    })['catch'](function () {
                                        _logger.$logger.info('checkout_fpti', pxpFptiData);
                                        return resolve(false);
                                    });
                                },
                                contingencies: {
                                    DEFAULT: function DEFAULT(msg, contingency) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_' + msg;
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }
                                },
                                error: function error() {
                                    fptiData.eligibility_reason = 'Get_Program_Error';
                                    _logger.$logger.info('checkout_fpti', fptiData);
                                    return resolve(false);
                                }
                            });
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT(msg, contingency) {
                                fptiData.eligibility_reason = 'Incentive_Ineligible_' + msg;
                                _logger.$logger.info('checkout_fpti', fptiData);
                                return resolve(false);
                            }
                        },
                        error: function error() {
                            fptiData.eligibility_reason = 'MORS_Error';
                            _logger.$logger.info('checkout_fpti', fptiData);
                            return resolve(false);
                        }
                    });
                });
            };

            var getHideControlMsg = function getHideControlMsg() {
                return _newMember.$NewMemberEligibility.instance().isNmj($scope.token);
            };

            var getSelectFiVariant = function getSelectFiVariant() {
                return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                    var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                    if (selectFiVariants.indexOf(variant) !== -1) {
                        return true;
                    }

                    return false;
                });
            };

            var subscriptionAuRMG = function subscriptionAuRMG() {
                return (0, _squid.$elmo)('xo_hermes_au_rmg_msg', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_au_rmg_msg').then(function (result) {
                    return { enabled: Boolean(result && result.treatment_name) };
                });
            };

            var shouldShowPendingBalance = function shouldShowPendingBalance() {
                return (0, _squid.$elmo)('xo_hermes_no_balance_text', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_no_balance_text').then(function (result) {
                    return { enabled: Boolean(result && result.treatment_name) };
                });
            };
            shouldShowPendingBalance().then(function (result) {
                if (result.enabled === true) {
                    _logger.$logger.info('claim_balance_text_not_allowed_to_be_shown_elmo');
                    $scope.shouldShowPendingBalance = false;
                } else {
                    _logger.$logger.info('claim_balance_text_allowed_to_be_shown_elmo');
                    $scope.shouldShowPendingBalance = true;
                }
            });

            // Return the reason for disallowed in the wallet, due to preauth or bank
            var checkDeclineReason = function checkDeclineReason() {
                var disallowedInstruments = models.checkoutSession.get('fundingOptions').get('disallowedInstruments');
                var disallowedPreAuth = _squid.$util.filter(disallowedInstruments, function (instrument) {
                    return instrument.declineReason === 'INSTRUMENT_VERIFICATION_FAILED';
                });

                if (!disallowedInstruments) {
                    return;
                }

                if (disallowedPreAuth && disallowedPreAuth.length > 0) {
                    return 'PREAUTH';
                }

                var disallowedNonBankInstruments = _squid.$util.filter(disallowedInstruments, function (disallowedInstrument) {
                    return disallowedInstrument.type !== 'BANK';
                });

                if (disallowedNonBankInstruments && disallowedNonBankInstruments.length >= 1) {
                    return;
                }

                return 'BANK';
            };

            var checkProcessorDeclineIssuerExperiment = function checkProcessorDeclineIssuerExperiment() {
                var declinedInstruments = models.checkoutSession.get('declinedInstruments', []);
                if (declinedInstruments && declinedInstruments.length > 0) {
                    return _factory2.$AddCardFactory.getIssuerDeclineElmoResult();
                }
                return '';
            };

            var getInformalName = function getInformalName() {
                var formattedNameInformal = void 0;
                if (models.auth) {
                    formattedNameInformal = (0, _squid.formatNameInformal)({
                        first_name: models.auth.first_name,
                        last_name: models.auth.last_name
                    }) || models.auth.email;
                }
                return formattedNameInformal;
            };

            $scope.isCPAEligible = _sharedUtil.$SharedUtil.isAuthDeclinedInstrument(models.checkoutSession) || _sharedUtil.$SharedUtil.isAuthRequiredInAnyFI(models.checkoutSession);

            return _squid.$promise.hash({
                walletPinModel: getWalletPinModel(),
                hideControlMsg: getHideControlMsg(),
                checkoutIncentiveEligibility: getCheckoutIncentiveEligibility(),
                selectFiVariant: getSelectFiVariant(),
                checkDeclineReason: checkDeclineReason(),
                addCardContingency: _factory3.$ExpiredFiPanelFactory.getPxpResult(models),
                issuerDeclineTreatment: checkProcessorDeclineIssuerExperiment(),
                formattedNameInformal: getInformalName(),
                subscriptionAuRMGElmoResult: subscriptionAuRMG()

            });
        }).then(function (_ref) {
            var hideControlMsg = _ref.hideControlMsg,
                selectFiVariant = _ref.selectFiVariant,
                checkDeclineReason = _ref.checkDeclineReason,
                checkoutIncentiveEligibility = _ref.checkoutIncentiveEligibility,
                addCardContingency = _ref.addCardContingency,
                issuerDeclineTreatment = _ref.issuerDeclineTreatment,
                formattedNameInformal = _ref.formattedNameInformal,
                subscriptionAuRMGElmoResult = _ref.subscriptionAuRMGElmoResult;


            var message = void 0;

            // smartDollarAuthFailed is true when smart $x auth check fails on 'authorize'
            if (models.checkoutSession.smartDollarAuthFailed) {
                message = {
                    type: 'error',
                    msg: (0, _squid.$renderContent)('payment.authFailureSingleFI')
                };
            } else {
                if (issuerDeclineTreatment === 'Trmt_xo_hermesnodeweb_issuer_decline_1') {
                    $scope.isProcessorDeclineExperiment = true;
                }
                message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false, issuerDeclineTreatment, models.auth, models.fiMeta.wallet, formattedNameInformal);
            }

            var isCreditDisallowedForMerchant = models.checkoutSession.isCreditDisallowedForMerchant;
            if (isCreditDisallowedForMerchant) {
                $scope.creditDisallowedMessage = {
                    type: 'warning',
                    msgs: [_squid.$locale.content.get('addCard.creditCardNotAllowed')]
                };
            }

            var isGamblingMerchant = models.payee.isGambling();
            if (isGamblingMerchant && subscriptionAuRMGElmoResult.enabled === true) {
                _logger.$logger.info('credit_card_not_allowed_RMG', { country: _squid.$locale.country });
                $scope.gamblingMessage = {
                    type: 'warning',
                    msgs: [_squid.$locale.content.get('addCard.creditCardNotAllowed')]
                };
            }

            var redirectFromXoon = _squid.$util.param('redirectToHermes') ? true : false;
            var retry = _squid.$util.param('addFIContingency') === 'retry' ? true : false;
            var avsRetry = _squid.$util.param('avsRetry') ? true : false;

            var getContingencyDeclineMessage = function getContingencyDeclineMessage(declineReason, _ref2) {
                var disallowedInstruments = _ref2.disallowedInstruments;

                switch (declineReason) {
                    case 'BANK':
                        message = _fiMessages.$fiMessages.getAddBankTreatmentMsg();
                        break;
                    case 'PREAUTH':
                        var disallowed = _squid.$util.filter(disallowedInstruments, function (instrument) {
                            return instrument.declineReason === 'INSTRUMENT_VERIFICATION_FAILED';
                        });

                        message = _fiMessages.$fiMessages.getPreAuthTreatmentMsg(disallowed);
                        break;
                    default:
                        message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        break;
                }
            };
            // If no processor decline, get the message when contingency is anything but NEED_DEBIT_CARD
            if (!message && models.checkoutSession.get('errorData.cause') && _uiRouter.$stateParams.message !== 'NEED_DEBIT_CARD' && !(subscriptionAuRMGElmoResult.enabled === true && isGamblingMerchant)) {
                if (models.payee.isGambling()) {
                    message = _fiMessages.$fiMessages.getGamblingMsg();
                } else if (!hideControlMsg && addCardContingency && (addCardContingency === disallowedExp.disallowedFi || addCardContingency === disallowedExp.preAuth)) {
                    getContingencyDeclineMessage(checkDeclineReason, models.checkoutSession.get('fundingOptions'));
                } else {
                    message = _fiMessages.$fiMessages.getAddCardMsg(models.unavailableCard, { retry: retry, avsRetry: avsRetry, redirectFromXoon: redirectFromXoon }, models.checkoutSession);
                    var noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.noBillingFIContingency');

                    // Content changes for change card for indian billing start
                    if (models.cart.isConsumerCountry('IN') && models.cart.isBilling()) {
                        if (models.cart.isRecurringPayment() || models.checkoutAppData.is_wps_flow()) {
                            noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.not.immediate.noBillingFIContingency');
                        } else if (models.cart.isReferenceTransaction()) {

                            if (models.checkoutAppData.isMerchantCountry('IN')) {
                                if (models.cart.isChargePatternImmediateOrDeferred()) {
                                    noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.immediate.noBillingFIContingency');
                                } else {
                                    noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.not.immediate.noBillingFIContingency');
                                }
                            } else {
                                noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.not.immediate.noBillingFIContingency');
                            }
                        }
                    }
                    // Content changes for change card for indian billing end

                    if (models.cart.isBilling() && noBillingFIContingencyIndia && _squid.$locale.country === 'IN') {
                        message.msg = noBillingFIContingencyIndia;
                        message.type = 'info';
                    }
                }
            }

            function checkFor3DSDeclineMessage() {
                // extract card information from 3DS V1 contingency context
                var checkoutSession = models.checkoutSession;

                // if no checkoutSession exit early
                if (!checkoutSession) {
                    return;
                }

                // extract card information for 3DS V1 contingency
                var card = checkoutSession.resolve_3ds;
                var threeDSResolutionData = checkoutSession.threeDSResolutionData;

                // if no 3DS information exit early
                if (!card && !threeDSResolutionData) {
                    return;
                }

                // extract card information from 3DS V2 contingency context

                var _ref3 = threeDSResolutionData.resolutions || [],
                    resolutions = _ref3[0];

                var _ref4 = resolutions || {},
                    _ref4$funding_instrum = _ref4.funding_instrument_details;

                _ref4$funding_instrum = _ref4$funding_instrum === undefined ? {} : _ref4$funding_instrum;
                var _ref4$funding_instrum2 = _ref4$funding_instrum.payment_card,
                    payment_card = _ref4$funding_instrum2 === undefined ? {} : _ref4$funding_instrum2;

                // consider V1 or V2 card data

                var cardInformation = card || payment_card;

                if (cardInformation) {
                    message = {
                        msg: (0, _squid.$renderContent)('threeDS.memberDeclineAfter3DSAcceptNoFI', {
                            cardType: cardInformation.type,
                            last4: cardInformation.number
                        }),
                        type: 'warning'
                    };
                }
            }

            function isUSCrossCurrency() {
                if (models.cart && models.cart.grossTotalAmount && models.cart.get('grossTotalAmount.currency') !== 'USD' && _squid.$locale.country === 'US') {
                    return true;
                }
                return false;
            }

            function checkAvailableFI() {
                if (isUSCrossCurrency()) {
                    var plans = models.checkoutSession.fundingOptions.plans.filter(function (plan) {
                        return plan.primaryFs.name !== 'BILL_ME_LATER';
                    });
                    if (plans.length > 1) {
                        return true;
                    }
                    return false;
                } else {
                    if (models.checkoutSession.fundingOptions.plans && models.checkoutSession.fundingOptions.plans.length > 1) {
                        return true;
                    }
                    return false;
                }
            }

            /**
             * if we get add card contingency after we try to clear three ds contingency
             * check if we have add card contingency along with threeDSResolutionData to display
             * error message
             */
            // make sure we dont have any other message set in scope
            if (!message) {
                if (_uiRouter.$stateParams.message === 'NEED_CREDIT_CARD') {
                    checkFor3DSDeclineMessage();
                }
            }

            if (message) {
                $scope.logSubscriptionEvent({
                    from: 'add_card_contingency',
                    to: 'process_add_card',
                    message: message
                });
                $scope.message = {
                    type: message.type,
                    msgs: [message.msg]
                };
                if (message.title) {
                    $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                }
            }
            // Reset the message if it is CPA flow for single FI contingency.
            if ($scope.cause === 'cpa' && _uiRouter.$stateParams.message === 'NEED_CREDIT_CARD' || $scope.isCPAEligible) {
                $scope.message = null;
                $scope.messagetitle = null;
            }

            $scope.cart = models.cart;
            $scope.auth = models.auth;

            // Show this message if this is the first page the user sees (these cases usually have a message).
            // Do not show if entering from another page, like the select-fi page
            if (!hideControlMsg) {
                $scope.showHiMsg = message || !selectFiVariant;
                $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();
            }

            // Render the incentive banner if eligible
            $scope.showIncentive = checkoutIncentiveEligibility;

            if ($scope.showIncentive) {
                // This is of the form '$5.00'
                var offerValue = $scope.evaluateCheckoutOfferEligibilityModel.getOfferValue();

                $scope.incentiveAmount = offerValue;

                var currencyCode = $scope.evaluateCheckoutOfferEligibilityModel.getCurrencyCode();
                var precisionDigits = _squid.$locale.metadata.currency.digits[currencyCode];

                if (precisionDigits) {
                    var decimalDigitsStr = offerValue.substring(offerValue.length - precisionDigits);
                    var areAllDecimalDigitsZeroes = /^0*$/.test(decimalDigitsStr);

                    if (areAllDecimalDigitsZeroes) {
                        // Remove trailing decimals and punctuation
                        $scope.incentiveAmount = offerValue.substring(0, offerValue.length - precisionDigits - 1);
                    }
                }

                // Don't show incentive terms by default
                $scope.showIncentiveTerms = false;

                $scope.toggleShowIncentiveTerms = function () {
                    $scope.showIncentiveTerms = !$scope.showIncentiveTerms;
                };
            }

            // Show selectFi features if no contingency
            if (selectFiVariant && !message && !(subscriptionAuRMGElmoResult.enabled === true && isGamblingMerchant)) {
                $scope.showCancel = checkAvailableFI() ? true : false;
                $scope.parentState = 'checkout.selectFi';
                $scope.pagetitle = _squid.$locale.content.get('addCard.addACard');
            }
        });

        $scope.isAddCardContingency = function () {
            return _uiRouter.$stateParams.message === 'NEED_CREDIT_CARD';
        };

        $scope.isUpdateDebitCard = function () {
            return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
    }]
});

angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
_angular.$q;

_angular.$rootScope;

_angular.noop;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$promise;

_squid.$renderContent;

_squid.$util;

_squid.formatNameInformal;

_squid.$elmo;

_factory.$NoBalanceFactory;

_factory2.$AddCardFactory;

_auth.$AuthModel;

_fi.$UnavailableCardModel;

_choice.$ChoiceEligibility;

_app.$TokenizedWalletPinModel;

_fiMessages.$fiMessages;

_newMember.$NewMemberEligibility;

_checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel;

_checkoutIncentive.$GetOfferProgramModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_factory3.$ExpiredFiPanelFactory;

_sharedUtil.$SharedUtil;

/***/ }),

/***/ "./pages/xo-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddCardPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-add-card/directive.js");

var $AddCardPageRoute = exports.$AddCardPageRoute = _squid.$ComponentRoute.extend('$AddCardPageRoute', {
    path: 'pageAddCard',
    directive: 'xo-page-add-card-page',
    titleContent: 'asideHeader.addCard',
    query: ['cause', 'message'],
    trackingData: {
        templateName: 'addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            messagetitle: 'messagetitle',
            message: 'message',
            pagetitle: 'pagetitle',
            'parent-callbacks': 'callbacks',
            logout: 'logout',
            'show-cancel': 'showCancel',
            'show-balance-flow': 'PPBalanceFlow',
            'show-incentive': 'showIncentive',
            'incentive-amount': 'incentiveAmount',
            cause: 'cause'
        }
    }]
});

angular.value("$AddCardPageRoute", $AddCardPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <xo-modal\n        ng-if=\"showIncentive\"\n        id=\"incentive-terms\"\n        show=\"showIncentiveTerms\"\n        show-close-button=\"true\"\n        enable-close-on-escape=\"true\"\n        on-close=\"toggleShowIncentiveTerms\"\n        enable-mobile-interstitial=\"true\">\n\n        <h1 class=\"alpha\">{{ content('checkoutIncentive.termsHeader') }}</h1>\n        <h6>{{ content('checkoutIncentive.termsH1') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP1') }}</p>\n        <h6>{{ content('checkoutIncentive.termsH2') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP2') }}</p>\n        <h6>{{ content('checkoutIncentive.termsH3') }}</h6>\n        <p data-ng-bind-html=\"content('checkoutIncentive.termsP3')\"></p>\n        <h6>{{ content('checkoutIncentive.termsH4') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP4') }}</p>\n        <h6>{{ content('checkoutIncentive.termsH5') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP5') }}</p>\n        <h6>{{ content('checkoutIncentive.termsH6') }}</h6>\n        <p>{{ content('checkoutIncentive.termsP6') }}</p>\n\n        <div class=\"logo\"></div>\n    </xo-modal>\n\n    <div class=\"row-fluid\" ng-if=\"!cart.isWalletTokenization()\">\n        <div class=\"span14\">\n            <xo-no-balance-banner ng-if=\"noBalanceFactoryState.eligible && shouldShowPendingBalance && isAddCardContingency()\"></xo-no-balance-banner>\n            <xo-message ng-if=\"creditDisallowedMessage\" data-test-id=\"addBankDebitCardWarning\" message=\"creditDisallowedMessage\"></xo-message>\n            <xo-message ng-if=\"gamblingMessage\" data-test-id=\"addBankDebitCardWarning\" message=\"gamblingMessage\"></xo-message>\n            <div ng-if=\"showIncentive\" id=\"incentive\">\n                <p id=\"incentive-greeting\">\n                    {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                    <span ng-if=\"showNotYou\">\n                        <xo-not-you></xo-not-you>\n                    </span>\n                </p>\n                <div id=\"incentive-content\">\n                    <div id=\"incentive-icon\"></div>\n                    <div id=\"incentive-text\">\n                        <p>\n                            <strong>{{ content('checkoutIncentive.header', {incentiveAmount: incentiveAmount}) }}</strong>\n                            <br>\n                            <span>{{ content('checkoutIncentive.body') }}</span>\n                        </p>\n                        <a id=\"incentive-terms-toggle\" href=\"\" link-button ng-click=\"toggleShowIncentiveTerms()\" aria-label=\"{{ content('offers.seeTermsText') }}\">\n                            {{ content('offers.seeTermsText') }}\n                        </a>\n                    </div>\n                </div>\n            </div>\n\n            <p class=\"userEmail\" id=\"reviewUserInfo\" data-test-id=\"addCard-showHiMsg\" ng-if=\"showHiMsg && !showIncentive && !isProcessorDeclineExperiment\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span ng-if=\"showNotYou\">\n                    <xo-not-you></xo-not-you>\n                </span>\n            </p>\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"sidepage noSlide\" modal-box tabindex=\"-1\" ng-if=\"cart.isWalletTokenization()\">\n        <div class=\"aside noSlide\" id=\"sidepageAddCard\" modal-box>\n            <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                             hidex=\"true\"></xo-aside-header>\n            <div class=\"content\">\n                <ui-view></ui-view>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-fi/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageAddFiPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

var _template = __webpack_require__("./pages/xo-add-fi/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddFiPageComponent = exports.$xoPageAddFiPageComponent = _squid.$Component.extend('$xoPageAddFiPageComponent', {
    tag: 'xo-page-add-fi-page',
    template: _template2['default'],
    scope: {
        logout: '=?'
    },
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.hideparenthead = {
            toggle: false
        };
        $scope.title = _squid.$locale.content.get('addCard.addACard');
        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            },
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            },
            cancel: function cancel(routeTo) {
                var destination = routeTo || $scope.parentState || '';

                if (destination) {
                    _uiRouter.$state.go(destination);
                }
            }
        };

        var models = {};

        (0, _squid.$populate)($scope, {
            auth: _auth.$AuthModel.instance(),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            $scope.logout = function () {
                _logger.$logger.info('not_you_logout');
                $scope.auth.logoutAndRedirect('NOT_YOU');
            };
            $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();

            (0, _squid.$populate)(models, {
                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                return (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment', false, true).then(function (result) {
                    var message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false);

                    // If no processor decline, retrieve and display the contingency message
                    if (!message && models.checkoutSession.get('errorData.cause')) {
                        if ($scope.payee.isGambling()) {
                            message = _fiMessages.$fiMessages.getGamblingMsg();
                        } else if (result) {
                            message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        } else {
                            message = _fiMessages.$fiMessages.getAddCardControlMsg(models.checkoutSession);
                        }
                    }

                    if (message) {
                        $scope.pageLevel = $scope.pageLevel || {};
                        $scope.pageLevel.message = {
                            type: message.type,
                            msgs: [message.msg]
                        };
                        $scope.showHiMsg = true;
                        if (message.title) {
                            $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                        }
                    }

                    return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                        var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];
                        var displayCancelButton = selectFiVariants.indexOf(variant) > -1 && !message;

                        // show cancel button if no contingency
                        $scope.showCancel = displayCancelButton;
                        $scope.parentState = 'checkout.selectFi';
                    });
                });
            });
        });
    }]
});
angular.value("$xoPageAddFiPageComponent", $xoPageAddFiPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_auth.$AuthModel;

_choice.$ChoiceEligibility;

_fiMessages.$fiMessages;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "./pages/xo-add-fi/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddFiPageRoute = undefined;

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/route.js");

__webpack_require__("./pages/xo-add-fi/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $AddFiPageRoute = exports.$AddFiPageRoute = _squid.$ComponentRoute.extend('$AddFiPageRoute', {

    path: 'pageAddFi',

    directive: 'xo-page-add-fi-page',

    query: ['cause', 'message'],

    titleContent: 'addCard.addPaymentMethod',

    trackingData: {
        templateName: 'addFi.dust',
        pageGoal: 'Add Funding Instrument',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-fi',
                'pagename2': '%::fullpage-add-fi:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            billingaddressupdated: 'billingaddressupdated',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': 'showCancel'
        }
    }, {
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': 'showCancel'
        }
    }]
});

angular.value("$AddFiPageRoute", $AddFiPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-fi/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addFi\" id=\"addFi\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showHiMsg\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                    <span ng-if=\"showNotYou\">\n                        <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\" style=\"font-weight:700;\">{{ content('memberReview.notYou')}}</a>\n                    </span>\n            </p>\n            <div class=\"trayInner trayInnerDefault\">\n                <h1 class=\"gamma noHead\" ng-if=\"!hideparenthead.toggle\">\n                    {{content('addCard.addPaymentMethod')}}\n                </h1>\n                <xo-message message=\"pageLevel.message\"></xo-message>\n                <ul class=\"form-tabs\" id=\"paymentTab\" ng-if=\"!hideparenthead.toggle\">\n                    <li class=\"bank\" ui-sref-active=\"active\">\n                        <a ui-sref=\"checkout.pageAddFi.bank.add\" class=\"bankTab\">{{content('bank.bank')}}</a>\n                    </li>\n                    <li class=\"card\" ui-sref-active=\"active\">\n                        <a ui-sref=\"checkout.pageAddFi.addCardFlow.addCard\" class=\"cardTab\" for=\"cardTab\">{{content('bank.card')}}</a>\n                    </li>\n                </ul>\n                <ui-view></ui-view>\n            </div>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props  type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-national-id/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddNationalIdPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

var _template = __webpack_require__("./pages/xo-add-national-id/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddNationalIdPageComponent = exports.$xoAddNationalIdPageComponent = _squid.$Component.extend('$xoAddNationalIdPageComponent', {
    tag: 'xo-add-national-id-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.locale = _squid.$locale;
        $scope.user = {
            country: _squid.$locale.country,
            countryOfResidence: _squid.$locale.country
        };
        $scope.validate = function () {
            $scope.validated = true;
            return true;
        };
        $scope.onContinue = function () {
            $scope.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
            $scope.checkoutSession = _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token);
            $scope.addKYC = new _user.$AddKYCModel({
                token: _angular.$rootScope.token
            });
            $scope.KYCData = {
                nationalIdModel: $scope.nationalIdModel,
                user: $scope.user
            };
            $scope.addKYC.save({
                data: $scope.KYCData,
                success: function success() {
                    return _uiRouter.$state.go('checkout.review');
                },
                contingencies: {
                    DEFAULT: function DEFAULT(err, message) {
                        _logger.$logger.info('add_KYC_contingency', {
                            name: err,
                            message: message
                        });
                    }
                }
            });
        };
    }]
});

angular.value("$xoAddNationalIdPageComponent", $xoAddNationalIdPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_user.$AddKYCModel;

_checkout.$CheckoutSessionModel;

_directive.$NationalIdModel;

/***/ }),

/***/ "./pages/xo-add-national-id/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddNationalIdRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-add-national-id/directive.js");

var $AddNationalIdRoute = exports.$AddNationalIdRoute = _squid.$ComponentRoute.extend('$AddNationalIdRoute', {
    path: 'addNationalId',
    directive: 'xo-add-national-id-page',
    titleContent: 'addTaxId.nationalityUpdate',
    trackingData: {
        fptiState: 'add-national-id',
        buzname: {
            'fullpage': {
                'pagename': '%::add-national-id',
                'pagename2': '%::add-national-id:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: []
});

angular.value("$AddNationalIdRoute", $AddNationalIdRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-national-id/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addNationalId\" id=\"addNationalId\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner reviewSections\">\n            <p>\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span ng-if=\"auth.is_auth_api_call\">\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n\n            <div class=\"trayInner trayInnerDefault\">\n                <h1 class=\"gamma noHead\" ng-if=\"!hideparenthead.toggle\">\n                    {{ content( 'addTaxId.nationalityUpdate' ) }}\n                </h1>\n                <p>\n                    {{ content( 'addTaxId.nationalityNote' ) }}\n                </p>\n                <ui-view></ui-view>\n            </div>\n\n            <form id=\"addNationalIdForm\" name=\"addNationalIdForm\" ng-submit=\"addNationalIdForm.$valid && onContinue()\" ng-class=\"{'validated': validated}\" novalidate>\n                <xo-national-id-input country={{locale.country}} user=\"user\"></xo-national-id-input>\n\n                <div class=\"buttons\">\n                    <input track-submit id=\"nationalIdSubmit\" type=\"submit\" value=\"{{ content( 'common.agreeAndContinue' ) }}\" ng-click=\"validate()\" class=\"btn full signupFlowSubmit\"/>\n                </div>\n            </form>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props  type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageAddShippingPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

var _template = __webpack_require__("./pages/xo-add-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddShippingPageComponent = exports.$xoPageAddShippingPageComponent = _squid.$Component.extend('$xoPageAddShippingPageComponent', {
    tag: 'xo-page-add-shipping-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.sidebar = false;
        $scope.callbacks = {
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            }
        };

        (0, _squid.$populate)($scope, {
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token)
        }).then(function () {
            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');

            if (!(0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry)) {
                _uiRouter.$state.go('checkout.review');
            }
        });
    }]
});

angular.value("$xoPageAddShippingPageComponent", $xoPageAddShippingPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_checkout.$CheckoutAppDataModel;

/***/ }),

/***/ "./pages/xo-add-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddShippingPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js");

__webpack_require__("./pages/xo-add-shipping/directive.js");

var $AddShippingPageRoute = exports.$AddShippingPageRoute = _squid.$ComponentRoute.extend('$AddShippingPageRoute', {
    path: 'pageAddShipping',
    directive: 'xo-page-add-shipping-page',
    titleContent: 'addShipping.addAddress',
    query: ['message'],
    trackingData: {
        templateName: 'addShipping.dust',
        pageGoal: 'Add Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address-nonXB',
                'pagename2': '%::fullpage-add-shipping-address-nonXB:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token',
            'done-fn': 'callbacks.done',
            sidebar: 'sidebar'
        }
    }]
});

angular.value("$AddShippingPageRoute", $AddShippingPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addShipping\" id=\"addShipping\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-add-tax-id/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/add-tax-id/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

var _template = __webpack_require__("./pages/xo-add-tax-id/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoAddTaxIdPageComponent', {
    tag: 'xo-add-tax-id-page',
    template: _template2['default'],
    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            this.token = _angular.$rootScope.token;
            this.finish = function () {
                return _uiRouter.$state.go('checkout.review');
            };
        }
    }
});


_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-add-tax-id/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddTaxIdRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-add-tax-id/directive.js");

var $AddTaxIdRoute = exports.$AddTaxIdRoute = _squid.$ComponentRoute.extend('$AddTaxIdRoute', {
    path: 'addTaxId',
    directive: 'xo-add-tax-id-page',
    titleContent: 'addTaxId.addTaxId',
    query: ['message'],
    trackingData: {
        templateName: 'addTaxId.dust',
        pageGoal: 'Add Tax Id',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-tax-id',
                'pagename2': '%::fullpage-add-tax-id:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    loginRequired: true,
    children: []
});

angular.value("$AddTaxIdRoute", $AddTaxIdRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-add-tax-id/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addTaxId\" id=\"addTaxId\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-add-tax-id token=\"token\" finish=\"finish\"></xo-add-tax-id>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-authorization-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("./pages/xo-authorization-message/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoAuthorizationMessageComponent', {
    tag: 'xo-authorization-message',
    template: _template2['default']
});


_squid.$Component;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-authorization-message/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AuthorizationMessageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-authorization-message/directive.js");

var $AuthorizationMessageRoute = exports.$AuthorizationMessageRoute = _squid.$ComponentRoute.extend('$AuthorizationMessageRoute', {
    path: 'authorizationmessage',
    directive: 'xo-authorization-message',
    titleContent: 'authUserLearnMore.authUserTitle',
    trackingData: {
        fptiState: 'authorizationmessage',
        templateName: 'authorizationMessage.dust',
        pageGoal: 'Authorization Message',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-authorizationmessage',
                'pagename2': '%::fullpage-authorizationmessage:member:hermes:',
                'version': 'member:%:'
            }
        }
    }
});

angular.value("$AuthorizationMessageRoute", $AuthorizationMessageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-authorization-message/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"review\" content id=\"memberReview\" form-autofocus>\n\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner reviewSections\">\n            <div id=\"authMsg\" tabindex=\"-1\" modal-box aria-labelledby=\"authUserTitle\" aria-describedby=\"authUserContent1 authUserContent2\">\n                <div id=\"authUserLearnMore\" class=\"trayInner trayInnerDefault\">\n                    <h4 id=\"authUserTitle\" class=\"authUserTitle zeta\">{{content('authUserLearnMore.authUserTitle')}}</h4>\n                    <p id=\"authUserContent1\" class=\"authUserContent\">{{content('authUserLearnMore.authUserContentPara1')}}</p>\n                    <p id=\"authUserContent2\" class=\"authUserContent\">{{content('authUserLearnMore.authUserContentPara2')}}</p>\n                </div>\n                <div class=\"buttons\">\n                    <button class=\"btn authUserBtn full\" ui-sref=\"checkout.review\" focus-after-transition=\".authUserLink\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _utils = __webpack_require__("../node_modules/xo-login-components/src/dolphin/utils.js");

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/merchant-header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/footer/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login-overlay/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/dolphin/directive.js");

__webpack_require__("../node_modules/xo-third-party-components/src/venmo-stepUp/directive.js");

var _template = __webpack_require__("./pages/xo-checkout/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
    tag: 'xo-checkout',
    template: _template2['default'],
    controller: function controller() {
        if (_angular.$location.path() === '/checkout') {
            _uiRouter.$state.go('checkout.review');
        }
    },
    resolve: {
        ppBalanceRebrandedExperiment: function ppBalanceRebrandedExperiment() {
            return {
                enabled: _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            if (window.appPerformanceEvents) {
                // TimeToFirstIntractableElement: The moment client is ready to receive its first user interaction.
                // Should be the before the first promise on the page
                // If the cancel button is ready then the page is
                // ready for some user interaction
                window.appPerformanceEvents.TimeToFirstIntractableElement = parseInt(window.performance.now(), 10);
                _logger.$logger.info('APP_PERFORMANCE_EVENTS', window.appPerformanceEvents);
            }
            this.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            this.token = _angular.$rootScope.token;
            this.locale = _squid.$locale;
            this.redirectiframe = _angular.$rootScope.partnerIntegration;
            this.redirectLightbox = true;
            this.escapeHatchInContext = !_angular.$rootScope.partnerIntegration;
            this.displayHeader = true;

            this.reviewUrl = 'checkout.review';
            this.isApp = _dist.$DeviceInfo.isApp();

            this.isDolphinEligible = false;

            _angular.$document.bind('click', function (event) {
                _this.$broadcast('clickBody', event.target);
            });

            function rtl() {
                if ((0, _squid.$feature)('rtl')) {
                    _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
                }
            }

            this.$on('metadataChange', rtl);
            rtl();

            _fn.$fn.trigger();

            this.isGdprValid = _gdprCookieBanner.isGdprValid;
        },
        populate: function populate() {
            var _this2 = this;

            function requiresRiskyLogin(state) {
                var auth = _auth.$AuthModel.instance();

                if (auth.remembered) {
                    // riskyLogin if new state requires full auth login
                    // ignore if we're in crucial venmo Step Up states
                    return state.loginRequired && !(state.name === 'checkout.venmoAuth' || state.name === 'checkout.venmo');
                }

                return false;
            }

            function displayRiskyLogin(oldState, newState, newParams) {
                if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                    _logger.$logger.info('login_overlay_suppressed');
                    return;
                }

                var isUserinitiated = oldState.template && !oldState.name.match(/checkout\.login/);

                if (isUserinitiated) {
                    var stateName = newState && newState.name;
                    var subFlowName = stateName && stateName.replace(/^.*\./, '');

                    if (subFlowName === 'sepaAgreement') {
                        _uiRouter.$state.go('checkout.review');
                    }

                    var insufficientPermissionEvent = _thirdPartyInfo.thirdPartyExperience.getExperience(this.token) === 'VENMO_EXPERIENCE' ? '$insufficientPermissionVenmoOT' : '$insufficientPermission';

                    _angular.$rootScope.$broadcast(insufficientPermissionEvent, {
                        oldState: oldState.name,
                        newState: newState.name,
                        pageOnOverlay: newState.pageOnOverlay
                    });
                } else {
                    var auth = _auth.$AuthModel.instance();
                    var cause = newParams && newParams.message ? newParams.message : newState.name.replace(/^.*\./, '');

                    _logger.$logger.info('RISKY_LOGIN_TRANSITION_' + cause);

                    var showPasswordRecovery = (0, _squid.$feature)('pomaPasswordRecovery') && auth.password_less;
                    var transition = showPasswordRecovery ? 'checkout.createPassword' : 'checkout.login';

                    _uiRouter.$state.go(transition, {
                        targetPage: cause,
                        showNotYou: true
                    });
                }
                return false;
            }

            function displayHeader(stateName) {
                // We'll be hiding the header during the third party wallet flow, since the third Party will brand the flow from their end
                return !(stateName === 'checkout.thirdPartyWalletFlow');
            }

            var checkDolphinEligibility = function checkDolphinEligibility(stateName) {
                return (0, _utils.getDolphinEligibility)(stateName).then(function (eligibility) {
                    _this2.isDolphinEligible = eligibility;
                });
            };

            function determineOneTouchExperience() {
                var auth = _auth.$AuthModel.instance();
                var isVenmoOT = auth.get('tenant') === 'VENMO' && auth.get('remembered');
                var isPaypalOT = auth.get('tenant') !== 'VENMO' && auth.get('remembered');

                if (isVenmoOT) {
                    return 'venmo';
                } else if (isPaypalOT) {
                    return 'paypal';
                }

                return 'none';
            }

            // Check dolphin eligibility for explicit page reload
            checkDolphinEligibility(_uiRouter.$state.current && _uiRouter.$state.current.name);

            var cancelStateChangeEventListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
                // venmo flag
                _this2.showVenmoExperience = _thirdPartyInfo.thirdPartyExperience.getExperience(_this2.token) === 'VENMO_EXPERIENCE';

                _logger.$logger.info('checkout_fpti', {
                    'is_venmo_branding': _this2.showVenmoExperience ? '1' : '0',
                    'is_onetouch_enabled': determineOneTouchExperience()
                });

                _this2.displayHeader = displayHeader(newState && newState.name);

                if (requiresRiskyLogin(newState)) {
                    event.preventDefault();
                    displayRiskyLogin(oldState, newState, newParams);
                }
                checkDolphinEligibility(newState && newState.name);
            });

            this.$on('$destroy', cancelStateChangeEventListener);

            if (requiresRiskyLogin(_uiRouter.$state.current)) {
                displayRiskyLogin(_uiRouter.$state.current, _uiRouter.$state.current);
            }
        }
    }
});


_uiRouter.$state;

_logger.$logger;

_integration.$integration;

_angular.$rootScope;

_angular.$document;

_angular.$location;

_squid.$Component;

_squid.$feature;

_squid.$locale;

_auth.$AuthModel;

_gdprCookieBanner.isGdprValid;

_dist.$DeviceInfo;

_thirdPartyInfo.thirdPartyExperience;

_fn.$fn;

_utils.getDolphinEligibility;

_sharedUtil.$SharedUtil;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-checkout/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/jquery/dist/jquery.min.js");

__webpack_require__("../node_modules/xo-angular-shims-placeholder/dist/angular-shims-placeholder.min.js");

__webpack_require__("./js/lib/index.js");

__webpack_require__("../node_modules/xo-tracking/dist/index.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _middleware = __webpack_require__("./js/lib/middleware.js");

__webpack_require__("./pages/xo-landing/route.js");

__webpack_require__("./pages/xo-login/route.js");

__webpack_require__("./pages/xo-generic-error/route.js");

__webpack_require__("./pages/xo-generic-message/route.js");

__webpack_require__("./pages/xo-select-fi/route.js");

__webpack_require__("./pages/xo-review/route.js");

__webpack_require__("./pages/xo-authorization-message/route.js");

__webpack_require__("./pages/xo-add-card/route.js");

__webpack_require__("./pages/xo-add-fi/route.js");

__webpack_require__("./pages/xo-add-card-meft/route.js");

__webpack_require__("./pages/xo-add-tax-id/route.js");

__webpack_require__("./pages/xo-gambling-block-cool-off-period/index.js");

__webpack_require__("./pages/xo-gambling-block-enabled/route.js");

__webpack_require__("./pages/xo-add-shipping/route.js");

__webpack_require__("./pages/xo-add-national-id/route.js");

__webpack_require__("./pages/xo-update-card/route.js");

__webpack_require__("./pages/xo-eConsent/route.js");

__webpack_require__("./pages/xo-travel-rule/route.js");

__webpack_require__("./pages/xo-nbr/route.js");

__webpack_require__("./pages/xo-framebust/route.js");

__webpack_require__("./pages/xo-sepa/route.js");

__webpack_require__("./pages/xo-pay/index.js");

__webpack_require__("./pages/xo-end/route.js");

__webpack_require__("./pages/xo-de-guest/route.js");

__webpack_require__("../node_modules/xo-login-components/src/fullpage-onetouch-upsell/route.js");

__webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/route.js");

__webpack_require__("./pages/xo-create-password/route.js");

__webpack_require__("./pages/xo-tokenization-info/route.js");

__webpack_require__("./pages/xo-pin-setup/route.js");

__webpack_require__("./pages/xo-venmo/route.js");

__webpack_require__("./pages/xo-third-party-wallet/route.js");

__webpack_require__("./pages/xo-third-party-info/route.js");

__webpack_require__("./pages/xo-inventory-soldout/route.js");

__webpack_require__("../node_modules/xo-page-components/src/done/route.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/choose-credit-offer/route.js");

__webpack_require__("../node_modules/xo-credit-components/src/redirect-to-cape/route.js");

__webpack_require__("./pages/xo-pay-with-selection/route.js");

__webpack_require__("./pages/xo-cip-verification/route.js");

__webpack_require__("./pages/xo-venmoAuth/route.js");

__webpack_require__("./pages/xo-checkout/directive.js");

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {
    path: 'checkout',
    directive: 'xo-checkout',
    titleContent: 'base.payPal',
    defaultState: 'checkout.landing',
    middleware: _middleware.$Middleware,
    children: [{
        name: '$LandingRoute'
    }, {
        name: '$LoginRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$PayWithSelectionRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-pay-with-selection/route',
        slug: 'payWithSelection'
    }, {
        name: '$VenmoRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-venmo/route',
        slug: 'venmo'
    }, {
        name: '$VenmoAuthRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-venmoAuth/route',
        slug: 'venmoAuth'
    }, {
        name: '$ThirdPartyWalletFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-third-party-wallet/route',
        slug: 'thirdPartyWalletFlow'
    }, {
        name: '$ThirdPartyInfoCollectFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-third-party-info/route',
        slug: 'thirdPartyInfoCollectFlow'
    }, {
        name: '$GenericErrorRoute',
        lazyRoute: 'pages/xo-generic-error/route',
        slug: 'genericError'
    }, {
        name: '$ChooseCreditOfferRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'xo-credit-components/src/choose-credit-offer/route',
        slug: 'chooseCreditOffer'
    }, {
        name: '$RedirectToCapeRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'xo-credit-components/src/redirect-to-cape/route',
        slug: 'redirectToCape'
    }, {
        name: '$GenericMessageRoute',
        lazyRoute: 'pages/xo-generic-message/route',
        slug: 'genericMessage'
    }, {
        name: '$FullpageOnetouchUpsellRoute',
        lazyRoute: 'xo-login-components/src/fullpage-onetouch-upsell/route',
        slug: 'FullpageOnetouchUpsell'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token'
        },
        lazyRoute: 'xo-login-components/src/onetouch-interstitial/route',
        slug: 'oneTouchUpsell'
    }, {
        name: '$SelectFiRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-select-fi/route',
        slug: 'selectFi'
    }, {
        name: '$ReviewRoute'
    }, {
        name: '$AuthorizationMessageRoute',
        lazyRoute: 'pages/xo-authorization-message/route',
        slug: 'authorizationmessage'
    }, {
        name: '$AddPhoneRoute',
        lazyRoute: 'xo-form-components/src/phone/route',
        slug: 'addPhone'
    }, {
        name: '$AddCardPageRoute',
        lazyRoute: 'pages/xo-add-card/route',
        slug: 'pageAddCard'
    }, {
        name: '$AddFiPageRoute',
        lazyRoute: 'pages/xo-add-fi/route',
        slug: 'pageAddFi'
    }, {
        name: '$xoTokenizationInfoPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-tokenization-info/route',
        slug: 'tokenizationInfo'
    }, {
        name: '$xoPinSetupPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-pin-setup/route',
        slug: 'pinSetup'
    }, {
        name: '$AddCardMeftRoute',
        lazyRoute: 'pages/xo-add-card-meft/route',
        slug: 'pageAddCardMeft'
    }, {
        name: '$AddTaxIdRoute',
        lazyRoute: 'pages/xo-add-tax-id/route',
        slug: 'addTaxId'
    }, {
        name: '$GamblingBlockEnabled',
        lazyRoute: 'pages/xo-gambling-block-enabled/route',
        slug: 'gamblingBlockEnabled'
    }, {
        name: '$GamblingBlockCoolOffPeriod',
        lazyRoute: 'pages/xo-gambling-block-cool-off-period/route',
        slug: 'gamblingBlockCoolOffPeriod'
    }, {
        name: '$TravelRuleRoute',
        lazyRoute: 'pages/xo-travel-rule/route',
        slug: 'travelRule'
    }, {
        name: '$AddNationalIdRoute',
        lazyRoute: 'pages/xo-add-national-id/route',
        slug: 'addNationalId'
    }, {
        name: '$UpdateCardPageRoute',
        lazyRoute: 'pages/xo-update-card/route',
        slug: 'updateCard'
    }, {
        name: '$AddShippingPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-add-shipping/route',
        slug: 'pageAddShipping'
    }, {
        name: '$xoSoldOutPageRoute',
        lazyRoute: 'pages/xo-inventory-soldout/route',
        slug: 'soldout'
    }, {
        name: '$xoEConsentPageRoute',
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                success: function success() {
                    return _this.goto('this.review');
                }
            };
        },

        lazyRoute: 'pages/xo-eConsent/route',
        slug: 'econsent'

    }, {
        name: '$xoNbrDEPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-nbr/route',
        slug: 'negativeBalanceRecovery'

    }, {
        name: '$xoFrameBustRoute',
        lazyRoute: 'pages/xo-framebust/route',
        slug: 'framebust'
    }, {
        name: '$SepaPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-sepa/route',
        slug: 'sepapage'
    }, {
        name: '$PayRoute',
        lazyRoute: 'pages/xo-pay/route',
        slug: 'pay'
    }, {
        name: '$EndRoute',
        slug: 'end'
    }, {
        name: '$xoDeGuest',
        lazyRoute: 'pages/xo-de-guest/route',
        slug: 'xoDeGuest'
    }, {
        name: '$BMLDisplay',
        attributes: {
            'review-url': 'reviewUrl'
        },
        lazyRoute: 'xo-credit-components/src/bml-display/route',
        slug: 'bmldisplay'
    }, {
        name: '$DoneRoute',
        lazyRoute: 'xo-page-components/src/done/route',
        slug: 'done'
    }, {
        name: '$xoPageCreatePasswordRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-create-password/route',
        slug: 'createPassword'
    }, {
        name: '$xoCIPVerficationPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-cip-verification/route',
        slug: 'cipverification'

    }]
}); /* dynamic-import */

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */

_index.$Route;

_middleware.$Middleware;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-checkout/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"outerWrapper heightHundredPercent\" ng-class=\"[locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\" >\n    <xo-dolphin ng-if=\"isDolphinEligible\"></xo-dolphin>\n    <!-- Messenger BA .. HIDE this -->\n    <xo-merchant-header ng-if=\"!isMessengerBAIntegration\" token=\"token\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <div id=\"sliding-area\" tabindex=\"-1\">\n            <div id=\"main\" role=\"main\" tabindex=\"-1\">\n                <xo-header ng-if=\"displayHeader\" is-venmo-flow=\"showVenmoExperience\" token=\"token\" redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-header>\n                <div id=\"contents\">\n                    <div ui-view></div>\n                </div>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <!-- Messenger BA .. HIDE this -->\n    <xo-footer ng-if=\"!isMessengerBAIntegration\" token=\"token\" escape-hatch-incontext=\"escapeHatchInContext\" show-venmo-legal-links=\"showVenmoExperience\"></xo-footer>\n    <xo-login-overlay  token=\"token\"></xo-login-overlay>\n    <xo-venmo-stepup-overlay token=\"token\"></xo-venmo-stepup-overlay>\n</div>\n<xo-gdpr-cookie-banner ng-if=\"isGdprValid()\"></xo-gdpr-cookie-banner>\n"

/***/ }),

/***/ "./pages/xo-cip-verification/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("./pages/xo-cip-verification/styles.less");

var _template = __webpack_require__("./pages/xo-cip-verification/template.html");

var _template2 = _interopRequireDefault(_template);

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCIPVerificationPageDirective', {
    tag: 'xo-cip-verification',
    template: _template2['default'],

    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                auth: _auth.$AuthModel.instance().retrieve()
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            $('#outerWrapper').addClass('tokenization');
        },
        populate: function populate() {
            var tokenizedWalletInfoModel = this.models.tokenizedWalletInfoModel;

            var cfpbInfoContent4Key = _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale) ? 'topup.cfpb.info.content4PPBalance' : 'topup.cfpb.info.content4';

            // fpti logging
            _logger.$logger.info('checkout_fpti', {
                from: 'CIP_VERIFICATION',
                to: 'prepare_cip_verification',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token'
            });

            // content about the disclaimer
            this.showModal = true;
            this.brandName = tokenizedWalletInfoModel.brandName();
            this.cfpbHeading1 = (0, _squid.$renderContent)('topup.cfpb.commonHeading1');
            this.cfpbHeading2 = (0, _squid.$renderContent)('topup.cfpb.commonHeading2', { type: this.brandName });
            this.cfpbInfoContent1 = (0, _squid.$renderContent)('topup.cfpb.info.content1');
            this.cfpbInfoContent2 = (0, _squid.$renderContent)('topup.cfpb.info.content2', { type: this.brandName });
            this.cfpbInfoContent3 = (0, _squid.$renderContent)('topup.cfpb.info.content3');
            this.cfpbInfoContent4 = (0, _squid.$renderContent)(cfpbInfoContent4Key);
        },
        exit: function exit() {
            // fpti logging
            _logger.$logger.info('checkout_fpti', {
                from: 'CIP_VERIFICATION',
                to: 'redirect_cip_verification',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token'
            });
        }
    },

    actions: {
        submit: function submit() {
            // if buyer auth is not remembered
            if (this.models.auth.remembered === false) {
                var configUrls = _squid.$config.urls;
                var tokenizedWalletInfoModel = this.models.tokenizedWalletInfoModel;

                // we need pass hermes url as return URL to CFPB provision flow
                // this is getting used by CFPB flow to redirect back after successful CFBP provisioning

                var baseUrl = configUrls.baseUrl;
                var params = {
                    token: _squid.$meta.token,
                    ba_token: _squid.$meta.baToken,
                    jwt: _squid.$meta.query.jwt
                };
                var PPBalanceFlowParams = '';

                if (_sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale)) {
                    var appName = tokenizedWalletInfoModel.isAndroidPay() ? 'Google_app' : 'Samsung_app';

                    PPBalanceFlowParams = '&capability=reload&entryPoint=' + appName + '&intent=starpay';
                }

                var returnUrl = encodeURIComponent(_squid.$util.buildURL(baseUrl, params));

                this.redirectURL = _squid.$util.buildURL(configUrls.cipAgreementUrl) + '?successUrl=' + returnUrl + PPBalanceFlowParams;
                _logger.$logger.info('CIP_REDIRECTION_URL', { url: this.redirectURL });
                _squid.$util.redirect(this.redirectURL);
            } else {
                // if buyer is not loggedIn using credentials, then auth is remembered
                // redirect to UL as riskyLogin for this usecase
                this.models.auth.redirectToLogin('insufficientPermission', { ulClientKey: 'cipVerification' });
            }
        }
    }
});


_angular.$rootScope;

_logger.$logger;

_squid.$Component;

_squid.$locale;

_squid.$renderContent;

_squid.$config;

_squid.$util;

_squid.$meta;

_app.$TokenizedWalletInfoModel;

_auth.$AuthModel;

_sharedUtil.$SharedUtil;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-cip-verification/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCIPVerficationPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-cip-verification/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCIPVerficationPageRoute = exports.$xoCIPVerficationPageRoute = _index.$Route.extend('$xoCIPVerficationPageRoute', {

    path: 'cipverification',
    directive: _directive2['default'],

    trackingData: {
        fptiState: 'cipverification'
    },

    children: []
});

angular.value("$xoCIPVerficationPageRoute", $xoCIPVerficationPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-cip-verification/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-cip-verification/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"cipverification\" modal-box content>\n    <div class=\"infoPage\">\n        <div class=\"storeIcon\" />\n        <div class=\"info_content\">\n            <div class=\"heading_wrapper\">\n                <div>{{ cfpbHeading1 }}</div>\n                <div>{{ cfpbHeading2 }}</div>\n            </div>\n            <div class=\"content_wrapper\">\n                <div class=\"segment\">\n                    <div class=\"text\">{{ cfpbInfoContent1 }}</div>\n                    <div class=\"text\">{{ cfpbInfoContent2 }}</div>\n                </div>\n                <div class=\"segment1\">\n                    <div class=\"text1\">{{ cfpbInfoContent3 }}</div>\n                    <div class=\"text1\">{{ cfpbInfoContent4 }}</div>\n                </div>\n            </div>\n        </div>\n        <form name=\"cipForm\">\n            <div class=\"buttons\">\n                <input track-submit type=\"submit\" value={{content('msb.popupBtn')}} id=\"setItUpButton\"\n                       class=\"btn full confirmButton continueButton\" data-test-id=\"setitUpButton\" validate-submit=\"actions.submit()\" />\n            </div>\n        </form>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-create-password/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-login-components/src/create-password/directive.js");

var _template = __webpack_require__("./pages/xo-create-password/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-create-password/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPageCreatePasswordDirective', {
    tag: 'xo-page-create-password',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.auth = _auth.$AuthModel.instance();
            this.reason = _uiRouter.$stateParams.targetPage;
            this.onContinue = function () {
                return _this.goto('.passwordRecovery');
            };
            this.logout = function () {
                _logger.$logger.info('not_you_logout');
                _this.auth.logoutAndRedirect('NOT_YOU');
            };
        }
    }
});


_squid.$Component;

_uiRouter.$stateParams;

_auth.$AuthModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-create-password/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPageCreatePasswordRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-create-password/directive.js");

var _directive2 = _interopRequireDefault(_directive);

var _route = __webpack_require__("../node_modules/xo-login-components/src/password-recovery-overlay/route.js");

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageCreatePasswordRoute = exports.$xoPageCreatePasswordRoute = _squid.$Route.extend('$xoPageCreatePasswordRoute', {
    path: 'createPassword',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'quick_security_check'
    },
    params: {
        targetPage: null
    },
    children: [{
        route: _route2['default'],
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                cancel: function cancel() {
                    return _this.goto('^');
                },
                success: function success() {
                    return _this.goto('checkout.login');
                }
            };
        }
    }]
});

angular.value("$xoPageCreatePasswordRoute", $xoPageCreatePasswordRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-create-password/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-create-password/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"createPasswordPage\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-create-password token=\"token\" reason=\"reason\" on-continue=\"onContinue\"></xo-create-password>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-de-guest/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoDeGuest = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var $xoDeGuest = exports.$xoDeGuest = _squid.$ComponentRoute.extend('EndRoute', {
    path: 'xoDeGuest',
    resolve: {
        action: function action() {

            var models = {};
            var capeData = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);

                return creditDataModel.action('readCreditKey', {
                    data: {
                        capeKey: creditDataModel.getCapeKey()
                    },
                    success: function success(res) {
                        capeData = res;
                        return (0, _squid.$populate)(models, {
                            creditDataModel: creditDataModel
                        });
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            }).then(function () {
                var financial_instrument_id = capeData.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + capeData.financial_instrument_id : capeData.financial_instrument_id;
                var checkoutSession = _index.$CheckoutSessionModel.instance(_angular.$rootScope.token);

                return checkoutSession.action('create', {
                    data: {
                        pmode: 'FAST',
                        preselected_fi: financial_instrument_id,
                        ftype: 'GUEST_ACQUISITION'
                    },
                    params: {
                        pmode: 'FAST',
                        preselected_fi: financial_instrument_id,
                        ftype: 'GUEST_ACQUISITION'
                    },
                    success: function success() {
                        return (0, _squid.$populate)(models, {
                            checkoutSession: checkoutSession
                        });
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            }).then(function () {
                return models.checkoutSession.action('authorize', {
                    data: {
                        pmode: 'FAST'
                    },
                    success: function success() {
                        _uiRouter.$state.go('checkout.end');
                    },
                    contingencies: {
                        DEFAULT: _squid.$promise.reject
                    },
                    error: _squid.$promise.reject
                });
            })['catch'](function () {
                return 'checkout.genericError';
            });
        }
    }
});

angular.value("$xoDeGuest", $xoDeGuest);
_angular.$rootScope;

_uiRouter.$state;

_squid.$ComponentRoute;

_squid.$populate;

_squid.$promise;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_credit.$CreditDataModel;

/***/ }),

/***/ "./pages/xo-eConsent/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("./pages/xo-eConsent/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-eConsent/styles.less");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('$xoEConsentPageDirective', {
    tag: 'xo-econsent-page',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        success: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token),
                eConsent: _index4.$EConsentModel.instance(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                tokenizedWalletEligibility: _index3.$TokenizedWalletEligibilityModel.instance(this.props.token),
                userProductSubscription: _index4.$UserProductSubscriptionModel.instance(),
                tokenizedWalletPin: _index3.$TokenizedWalletPinModel.instance(this.props.token),
                tokenizedWalletInfoModel: _index3.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedWalletMsbOffer: _index3.$TokenizedWalletMsbOfferModel.instance(this.props.token)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
        }
    },
    actions: {
        submit: function submit() {
            var _this = this;

            var self = this;
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            var hardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

            self.handleSymphonyContingency = function (name, err) {
                // Check if negative case has been previously handled.
                if (!self.dependencyEligibility) {
                    return;
                }

                var errorCode = err.cause || name;

                fptiData.int_error_code = errorCode;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = hardErrors.indexOf(errorCode) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);
                throw err;
            };

            self.handleSymphonyNoValidTopupFiContingency = function (name, err) {
                // Check if negative case has been previously handled.
                if (!self.dependencyEligibility) {
                    return;
                }

                if (self.models.checkoutCart.isWalletTokenization()) {
                    fptiData.int_error_code = err.cause;
                    fptiData.error_source = 'paymentapiplatformserv';
                    fptiData.error_type = hardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                    _logger.$logger.info('checkout_fpti', fptiData);

                    self.models.checkoutSession.contingency = name;
                    return _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    self.handleSymphonyContingency(name, err);
                }
            };

            // We use this flag to tell if negative case has been previously handled.
            self.dependencyEligibility = true;

            // We use this flag to decide if we should to review page.
            // Set this to false if the next page is no review page.
            self.proceedToReview = true;

            var isPayPalCredit = self.models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            var eConsentBatch = [this.models.eConsent.save({
                batch: {
                    name: 'econsent',
                    id: 'accept'
                }
            }), this.models.checkoutSession.action('create', {
                data: {
                    baToken: this.models.checkoutCart.get('billing.ba_token'),
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined,
                    clear_installments: true
                },
                success: function success(result) {
                    // Check if negative case has been previously handled.
                    if (!self.dependencyEligibility) {
                        return;
                    }

                    _logger.$logger.info('checkout_fpti', {
                        from: 'CREATE_XO_SESSION',
                        to: 'process_create_xo_session'
                    });

                    // consider negative balance first
                    if (self.models.checkoutSession.negBals) {
                        self.proceedToReview = false;
                        return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                    }

                    // Handle routing to cape for second button
                    if (isPayPalCredit) {
                        self.proceedToReview = false;
                        return _util.$capeRedirectUtil.handleCapeRouting(result, self.models.checkoutCart, self.props.token);
                    }

                    // Check for tokenized wallet
                    if (self.models.checkoutCart.isWalletTokenization()) {
                        return _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                    }
                },

                contingencies: {
                    NEED_DEBIT_CARD: self.handleSymphonyNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: self.handleSymphonyNoValidTopupFiContingency,
                    DEFAULT: self.handleSymphonyContingency
                },
                batch: {
                    name: 'econsent',
                    id: 'createCheckout',
                    dependencies: self.models.checkoutCart.isWalletTokenization() ? ['accept', 'tokenizedWalletLightEligibility', 'userProductSubscription', 'tokenizedWalletPin'] : ['accept']
                }
            })['finally'](function () {
                // selectedInstallmentsData does not come from checkoutSession response from PAPS, so we need to keep track of this state ourselves.
                // We pass clear_installments when calling the checkout session API, so we need to reflect that this is being cleared.
                // See https://engineering.paypalcorp.com/jira/browse/PPPLMER-58580
                delete _this.models.checkoutSession.selectedInstallmentData;
            })];

            if (self.models.checkoutCart.isWalletTokenization()) {
                // Wallet tokenization always goes tokenization info page unless there is an error
                // which is tracked by a separate flag.
                self.proceedToReview = false;

                // these params are coming from Mayfly (see xo-hermes-app/apis/tokenizedWalletInfo)
                var _self$models$tokenize = self.models.tokenizedWalletInfoModel,
                    wallet_id = _self$models$tokenize.wallet_id,
                    external_device_id = _self$models$tokenize.external_device_id,
                    tr_client_id = _self$models$tokenize.tr_client_id,
                    product_name = _self$models$tokenize.product_name;

                var subject = self.models.tokenizedWalletInfoModel.getSubject();

                // TODO: move to TokenizedWalletInfoModel
                var WALLET_BRANDS = {
                    'google': 'APAY',
                    'Samsung': 'SAMSUNGPAY'
                };

                var params = {
                    wallet_brand: WALLET_BRANDS[subject],
                    tenant_id: 'Hermes',
                    wallet_id: wallet_id,
                    external_device_id: external_device_id,
                    subject: subject,
                    tr_client_id: tr_client_id,
                    product_name: product_name
                };

                if (_config.$meta.query && _config.$meta.query.wallet_id) {
                    params.wallet_id = _config.$meta.query.wallet_id;
                }
                if (_config.$meta.query && _config.$meta.query.jwt) {
                    params.jwt = _config.$meta.query.jwt;
                }

                eConsentBatch.push(this.models.tokenizedWalletEligibility.retrieve({
                    params: params,

                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';

                            _logger.$logger.info(msg);

                            fptiData.int_error_code = result.reason;
                            fptiData.error_source = 'paymenttokenserv';
                            fptiData.error_type = 'hard_decline';
                            _logger.$logger.info('checkout_fpti', fptiData);

                            self.dependencyEligibility = false;
                            var code = result.reason === 'WALLET_ID_ALREADY_PROVISIONED' ? 'ANDROID_PAY_ALREADY_PROVISIONED' : 'ANDROID_PAY_ELIGIBILITY_ERROR';

                            code = window.btoa(code);
                            return _uiRouter.$state.go('checkout.genericError', {
                                code: code
                            });
                        }
                    },


                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletLightEligibility',
                        dependencies: ['accept']
                    }
                }));

                // check we have product provision subscribed by buyer
                // if not subscribed redirect to splash screen of subscription upsell
                eConsentBatch.push(this.models.userProductSubscription.retrieve({
                    success: function success(result) {
                        // result is going to an object of { applicable: true, subscribed: true, reason: 'PAYPAL_CASH' }
                        if (result.applicable && !result.subscribed) {
                            self.dependencyEligibility = false;
                            _logger.$logger.info('econsent_product_subscription_enabled_not_subscribed');
                            return _uiRouter.$state.go('checkout.cipverification');
                        }
                    },

                    batch: {
                        name: 'econsent',
                        id: 'userProductSubscription',
                        dependencies: ['accept', 'tokenizedWalletLightEligibility']
                    }
                }));

                eConsentBatch.push(this.models.tokenizedWalletPin.retrieve({
                    success: function success(result) {
                        if (result.pinId) {
                            _logger.$logger.info('tokenized_wallet_get_pin_set', { pinOrigin: result.pinOrigin, pinId: result.pinId });
                        } else {
                            _logger.$logger.info('tokenized_wallet_get_pin_not_set');
                        }
                    },


                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('tokenized_wallet_get_pin_error');
                        }
                    },

                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletPin',
                        dependencies: ['accept']
                    }
                }));

                eConsentBatch.push(this.models.tokenizedWalletMsbOffer.retrieve({
                    params: {
                        tokenizedWalletToken: this.models.checkoutCart.tokenizedWalletToken
                    },
                    batch: {
                        name: 'econsent',
                        id: 'tokenizedWalletMsbOffer',
                        dependencies: ['accept']
                    },
                    success: function success(result) {
                        var msg = 'tokenized_wallet_msb_offer';

                        if (result && result.enabled) {
                            _logger.$logger.info(msg + '_enabled', result);
                        } else {
                            _logger.$logger.info(msg + '_disabled');
                        }
                    }
                }));
            }

            return _angular.$q.all(eConsentBatch).then(function () {
                if (self.proceedToReview) {
                    return _this.props.success();
                }
            });
        }
    }
});


_angular.$q;

_logger.$logger;

_index.$Component;

_index.$locale;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

_index3.$TokenizedWalletEligibilityModel;

_index3.$TokenizedWalletPinModel;

_index3.$TokenizedWalletInfoModel;

_index3.$TokenizedWalletMsbOfferModel;

_index4.$UserProductSubscriptionModel;

_index4.$EConsentModel;

_util.$capeRedirectUtil;

_uiRouter.$state;

_config.$meta;

_squid.$Class;

_factory.$TokenizedWalledLoaderFactory;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-eConsent/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoEConsentPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-eConsent/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoEConsentPageRoute = exports.$xoEConsentPageRoute = _index.$Route.extend('$xoEConsentPageRoute', {

    path: 'econsent',
    directive: _directive2['default'],
    titleContent: 'eConsent.title',

    trackingData: {
        fptiState: 'econsent',
        templateName: 'eConsent.dust',
        pageGoal: 'eConsent',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-econsent',
                'pagename2': '%::fullpage-econsent:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    children: []
});

angular.value("$xoEConsentPageRoute", $xoEConsentPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-eConsent/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-eConsent/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"eConsent\" id=\"eConsent\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <xo-title title-txt=\"{{content('eConsent.title')}}\"></xo-title>\n            <form name=\"eConsentForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n                <p class=\"content\">{{content('eConsent.consent')}}</p>\n\n                <div class=\"agree checkbox legal\">\n                    <input ng-model=\"fields.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" data-error-text=\"{{content('eConsent.eConsentError')}}\" xo-error-tooltip required />\n                    <label class=\"noBottom\" for=\"agree\" data-test-id=\"eConsentLabel\" ng-bind-html=\"content('eConsent.agreement')\"></label>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"submitEConsent\" value=\"{{content('common.agreeAndContinue')}}\" class=\"btn full\" validate-submit=\"actions.submit()\" />\n                </div>\n            </form>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-end/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$EndRoute = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _returnParams = __webpack_require__("../node_modules/xo-page-components/src/returnParams/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _subscription = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _util2 = __webpack_require__("./js/lib/util.js");

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

var $EndRoute = exports.$EndRoute = _squid.$ComponentRoute.extend('EndRoute', {
    path: 'end',
    trackingData: {
        fptiState: 'back_to_merchant',
        trackStateExit: true
    },
    resolve: {
        action: function action() {

            function returnMethod(merchantPreferences) {
                if (_squid.$integration.getConfig('RETURN_METHOD_BASED_ON_MERCHANT_PREFS') && merchantPreferences) {
                    return merchantPreferences.returnMethod();
                } else {
                    return 'GET';
                }
            }

            function returnMethodFromAppData(checkoutAppData) {
                var merchant_preferences = checkoutAppData && checkoutAppData.merchant_preferences || {};
                var pdt = merchant_preferences.pdt || {};
                var isPDTEnabled = pdt.enabled;
                if (checkoutAppData.flags.http_return_method === 'POST' && !isPDTEnabled) {
                    return 'POST';
                }
                return 'GET';
            }

            function shouldRedirectToSubscriptionsV1Done(checkoutCart, subscriptionV1Data) {
                var clientConfiguration = subscriptionV1Data && subscriptionV1Data.billingAgreementCart.client_configuration;
                var isRestRpMigrated = clientConfiguration && clientConfiguration.api === 'RECURRING_PAYMENTS_V1';

                return checkoutCart.isSubscriptionsV1() && !isRestRpMigrated;
            }

            function returnUrl(checkoutAppData, merchantPreferences, checkoutCart, subscriptionV1Data) {
                var return_uri = checkoutAppData.urls && checkoutAppData.urls.return_url;
                var billing = checkoutCart.billing || {};
                if (billing.intent === 'VAULT') {
                    var originalReturnUrl = checkoutAppData.urls && checkoutAppData.urls.original_urls && checkoutAppData.urls.original_urls.return_url;
                    return_uri = originalReturnUrl ? originalReturnUrl : return_uri;
                }

                if (checkoutAppData.is_wps_subscription_flow()) {
                    return _squid.$config.urls.wpsSubscriptionReturnUrl;
                }

                if (checkoutAppData.is_wps_installmentplan_flow()) {
                    return _squid.$config.urls.wpsInstallmentPlanReturnUrl;
                }

                if (checkoutAppData.isWpsAutobillingFlow()) {
                    return _squid.$config.urls.wpsAutobillingReturnUrl;
                }

                if (shouldRedirectToSubscriptionsV1Done(checkoutCart, subscriptionV1Data)) {
                    return _squid.$config.urls.subscriptionsV1ReturnUrl;
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && _squid.$util.param('redirect_uri')) {
                    return _squid.$util.param('redirect_uri');
                }

                if (_squid.$integration.getConfig('RETURN_URL_FROM_MERCHANT_PREFS') && merchantPreferences) {
                    return return_uri || merchantPreferences.returnUrl();
                }

                // By default, use return_uri from checkout session
                return return_uri;
            }

            function returnParams(checkoutCart, checkoutSession, checkoutAppData, subscriptionV1Data, returnToMerchantMethod) {
                var billingData = checkoutCart.billing || {};
                var paramsForWPSBillingFlows = {
                    token: _squid.$meta.token,
                    mfid: _squid.$meta.mfid,
                    sdkMeta: _squid.$meta.sdkMeta,
                    mode: 'member',
                    'country.x': _squid.$locale.country,
                    'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country
                };
                var paramsForVault = {
                    approval_token_id: billingData.vault_approval_token_id,
                    approval_session_id: billingData.vault_approval_session_id
                };

                if (billingData.intent === 'VAULT') {
                    return paramsForVault;
                }

                if (checkoutAppData.is_wps_subscription_flow() || checkoutAppData.is_wps_installmentplan_flow() || checkoutAppData.isWpsAutobillingFlow()) {
                    return paramsForWPSBillingFlows;
                }

                var params = {};

                if (shouldRedirectToSubscriptionsV1Done(checkoutCart, subscriptionV1Data)) {
                    params = _extends({}, paramsForWPSBillingFlows);
                }

                var nativeRedirect = _squid.$util.param('native_xo') === '1';
                if (nativeRedirect || _squid.$integration.getConfig('ALLOW_PAYER_ID_RETURN_PARAM') && !checkoutCart.isBillingNoPurchase()) {
                    params.PayerID = checkoutSession.payer.id;
                }

                if (billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                if (_squid.$integration.isFlow('WPS')) {
                    var isCartUpload = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow;

                    params = (0, _returnParams.$returnParams)(checkoutCart, checkoutSession, returnToMerchantMethod, 'WPS', isCartUpload);
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && _squid.$util.param('redirect_uri')) {
                    if (checkoutAppData.urls.return_url) {
                        params.return_uri = _squid.$util.buildURL(checkoutAppData.urls.return_url, params);
                    }

                    // Add these params after building `return_uri` to ensure they are not added into the final url
                    params.intent = checkoutCart.payment_action;
                    params.opType = 'payment';
                    params.paymentId = checkoutAppData.payment_id;
                    params.token = _angular.$rootScope.token;
                }

                return params;
            }

            function getMerchantPreferences(dataModel) {
                if (_squid.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES') && !(0, _util2.isConfigForMerchantPreferencesEnabled)()) {
                    return (0, _squid.$populate)(dataModel, {
                        merchantPreferences: _profilemanagement.$MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                    });
                } else {
                    return _angular.$q.when();
                }
            }

            function getSubscriptionV1Data(models) {
                var baToken = models.checkoutCart.getBaToken();
                if (baToken && models.checkoutCart.isSubscriptionsV1()) {
                    return (0, _squid.$populate)(models, {
                        subscriptionV1Data: _subscription.$SubscriptionsV1Model.instance(models.checkoutCart.getBaToken())
                    });
                }
                return _angular.$q.when();
            }

            function getPdtDisabledFromAppData(checkoutAppData) {
                var merchant_preferences = checkoutAppData && checkoutAppData.merchant_preferences || {};
                var pdt = merchant_preferences.pdt || {};
                return !pdt.enabled;
            }

            function getPdtDisabledFromMerchantSettings(merchantPreferences) {
                return merchantPreferences && !merchantPreferences.pdtEnabled();
            }

            var models = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
            }).then(function () {
                return _angular.$q.all([getMerchantPreferences(models), getSubscriptionV1Data(models)]);
            }).then(function () {
                var url = returnUrl(models.checkoutAppData, models.merchantPreferences, models.checkoutCart, models.subscriptionV1Data);
                var returnToMerchantMethod = (0, _util2.isConfigForMerchantPreferencesEnabled)() ? returnMethodFromAppData(models.checkoutAppData) : returnMethod(models.merchantPreferences);
                var isPdtDisabled = (0, _util2.isConfigForMerchantPreferencesEnabled)() ? getPdtDisabledFromAppData(models.checkoutAppData) : getPdtDisabledFromMerchantSettings(models.merchantPreferences);
                var params = returnParams(models.checkoutCart, models.checkoutSession, models.checkoutAppData, models.subscriptionV1Data, returnToMerchantMethod);
                _logger.$logger.info('checkout_fpti', {
                    'from': 'BACK_TO_MERCHANT',
                    'to': 'prepare_bk_to_merchant',
                    'redirect_url': url,
                    'client_epoch_ts': Date.now()
                });

                var logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);
                logSubscriptionEvent({
                    from: 'done_page_rendered',
                    to: 'prepare_done_page'
                });

                if (models.checkoutAppData.is_wps_subscription_flow() || shouldRedirectToSubscriptionsV1Done(models.checkoutCart, models.subscriptionV1Data) || models.checkoutAppData.isWpsAutobillingFlow()) {
                    return _squid.$util.redirect(_squid.$util.paypalURL(url, params));
                }
                if (models.checkoutAppData.is_wps_installmentplan_flow()) {
                    _squid.$util.redirect(_squid.$util.paypalURL(url, params));
                }

                // if V4 in-context integration, we'll call the onAuthorize handler.
                if (window.xprops && window.xprops.onAuthorize) {
                    _logger.$logger.info('xprops_onauthorize');
                    _logger.$logger.flush();
                    _angular.$rootScope.$emit('loading');

                    var xparams = {
                        paymentToken: _angular.$rootScope.token,
                        orderID: _angular.$rootScope.token,
                        billingToken: params['ba_token'],
                        payerID: params['PayerID'],
                        paymentID: params['paymentId'] || models.checkoutAppData.payment_id,
                        intent: models.checkoutCart.payment_action
                    };

                    if (url) {
                        xparams.returnUrl = _squid.$util.buildURL(url, params);
                    }

                    if (window.xprops && window.xprops.getConnectURL) {
                        _logger.$logger.info('xprops_connect_redirect');

                        return window.xprops.getConnectURL({ payerID: xparams.payerID }).then(function (connectURL) {
                            return _squid.$util.redirect(connectURL);
                        })['catch'](function (err) {
                            _logger.$logger.info('xprops_connect_redirect_error', {
                                err: err.stack || err.toString()
                            });
                            return window.xprops.onAuthorize(xparams);
                        });
                    }

                    return window.xprops.onAuthorize(xparams);
                }

                if (returnToMerchantMethod === 'POST') {
                    _logger.$logger.info('post_redirect');
                    _logger.$logger.flush();
                    _util.$ReturnToMerchant.postTo(url, params);
                } else {
                    _logger.$logger.info('standard_redirect');
                    _logger.$logger.flush();
                    // if PDT is applicable and disabled don't send params in the url
                    if (_squid.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES') && isPdtDisabled) {
                        return _util.$ReturnToMerchant.goTo(url);
                    }
                    _util.$ReturnToMerchant.goTo(_squid.$util.buildURL(url, params));
                }

                return _squid.$unresolved;
            });
        }
    }
});

angular.value("$EndRoute", $EndRoute);
_angular.$q;

_angular.$rootScope;

_logger.$logger;

_squid.$meta;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$unresolved;

_squid.$integration;

_squid.$ComponentRoute;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_util.$ReturnToMerchant;

_returnParams.$returnParams;

_profilemanagement.$MerchantPreferenceModel;

_subscription.$SubscriptionsV1Model;

_util2.isConfigForMerchantPreferencesEnabled;

_sharedUtil.$SharedUtil;

/***/ }),

/***/ "./pages/xo-framebust/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoFrameBustPageDirective = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getCenterPosition = getCenterPosition;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _icFallback = __webpack_require__("./js/lib/icFallback.js");

var _template = __webpack_require__("./pages/xo-framebust/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-framebust/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getCenterPosition(_ref) {
    var width = _ref.width,
        height = _ref.height;


    var left = void 0;
    var top = void 0;

    if (width) {
        if (window.outerWidth) {
            left = Math.round((window.outerWidth - width) / 2) + window.screenX;
        } else if (window.screen.width) {
            left = Math.round((window.screen.width - width) / 2);
        }
    }

    if (height) {
        if (window.outerHeight) {
            top = Math.round((window.outerHeight - height) / 2) + window.screenY;
        } else if (window.screen.height) {
            top = Math.round((window.screen.height - height) / 2);
        }
    }

    return { left: left, top: top };
}

var $xoFrameBustPageDirective = exports.$xoFrameBustPageDirective = _squid.$Component.extend('$xoFrameBustPageDirective', {

    tag: 'xo-framebust-page',
    template: _template2['default'],

    props: {},

    resolve: {},

    actions: {
        submit: function submit() {

            window.xchild.hide();

            var url = decodeURIComponent(_uiRouter.$stateParams.url);

            if ((0, _squid.isUnsafeRedirect)(url)) {
                // eslint-disable-line
                _logger.$logger.error('unsafe_redirect_url', {
                    url: url
                });
                throw new Error('Unsafe redirect url: ' + url);
            }

            if (_uiRouter.$stateParams.action === 'open') {

                var xprops = _extends({}, window.xprops);

                xprops.url = url;

                _logger.$logger.warn('framebust_click_to_hermes');

                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
            }

            if (_uiRouter.$stateParams.action === 'fallback') {

                _logger.$logger.warn('framebust_click_to_legacy');

                var width = 970;
                var height = 850;

                var _getCenterPosition = getCenterPosition({ width: width, height: height }),
                    left = _getCenterPosition.left,
                    top = _getCenterPosition.top;

                var win = window.open(url, 'hermes_fallback', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);

                (0, _icFallback.$incontextFallback)(win, url);
            }
        }
    }
});

angular.value("getCenterPosition", getCenterPosition);
angular.value("$xoFrameBustPageDirective", $xoFrameBustPageDirective);
_logger.$logger;

_uiRouter.$stateParams;

_squid.$Component;

_squid.isUnsafeRedirect;

_icFallback.$incontextFallback;

/***/ }),

/***/ "./pages/xo-framebust/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoFrameBustRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-framebust/directive.js");

var $xoFrameBustRoute = exports.$xoFrameBustRoute = _index.$Route.extend('$xoFrameBustRoute', {

    path: 'framebust',
    directive: _directive.$xoFrameBustPageDirective,

    auth: false,

    query: ['action', 'url'],

    children: []
});

angular.value("$xoFrameBustRoute", $xoFrameBustRoute);
_index.$Route;

_directive.$xoFrameBustPageDirective;

/***/ }),

/***/ "./pages/xo-framebust/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-framebust/template.html":
/***/ (function(module, exports) {

module.exports = "<form content novalidate=\"novalidate\" autocomplete=\"off\">\n    <input type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn frameBustBtn\" ng-click=\"actions.submit()\" />\n</form>\n\n\n"

/***/ }),

/***/ "./pages/xo-gambling-block-cool-off-period/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("./pages/xo-gambling-block-cool-off-period/template.html");

var _template2 = _interopRequireDefault(_template);

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

__webpack_require__("./pages/xo-gambling-block-cool-off-period/styles.less");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoGamblingBlockCoolOffPeriodPageComponent', {
    tag: 'xo-gambling-block-cool-off-period-page',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },
    actions: {
        redirectToCancelUrl: function redirectToCancelUrl() {
            var cancelUrl = this.models.checkoutAppData.urls.cancel_url;
            _index.$ReturnToMerchant.goTo(cancelUrl);
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            // on reload the header and the footer reappear, hence adding the timeout 
            (0, _angular.$timeout)(function () {
                $('.row-fluid.paypalHeaderWrapper').hide();
                $('.footer').hide();
            }, 0);
            this.token = _angular.$rootScope.token;
        },
        populate: function populate() {
            // to check if the merchant has a cancel_url present, if present the "return to merchant" button is displayed
            this.cancelUrlPresent = this.models.checkoutAppData.urls.cancel_url;
            _logger.$logger.info('checkout_fpti', {
                from: 'uk_gambling_block',
                to: 'uk_gambling_block_cool_down_page_loaded',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token'
            });
        }
    }
});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_checkout.$CheckoutAppDataModel;

_index.$ReturnToMerchant;

_angular.$timeout;

_logger.$logger;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-gambling-block-cool-off-period/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _route = __webpack_require__("./pages/xo-gambling-block-cool-off-period/route.js");

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});

var _directive = __webpack_require__("./pages/xo-gambling-block-cool-off-period/directive.js");

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});

/***/ }),

/***/ "./pages/xo-gambling-block-cool-off-period/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GamblingBlockCoolOffPeriod = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-gambling-block-cool-off-period/directive.js");

var $GamblingBlockCoolOffPeriod = exports.$GamblingBlockCoolOffPeriod = _squid.$ComponentRoute.extend('$GamblingBlockCoolOffPeriod', {
    path: 'gamblingBlockCoolOffPeriod',
    directive: 'xo-gambling-block-cool-off-period-page',
    titleContent: 'gamblingBlockCoolOffPeriod.heading',
    query: ['message'],
    trackingData: {
        templateName: 'gamblingBlockCoolOffPeriod.dust',
        pageGoal: 'Gambling Block Cool Off Period page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-gambling-block-cool-off-period',
                'pagename2': '%::fullpage-gambling-block-cool-off-period:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: []
});
angular.value("$GamblingBlockCoolOffPeriod", $GamblingBlockCoolOffPeriod);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-gambling-block-cool-off-period/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-gambling-block-cool-off-period/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"gamblingBlockCoolOffPeriod\" id=\"gamblingBlockCoolOffPeriod\" content>\n    <div class=\"info_content\" id=\"infoContent\">\n        <div class=\"blockedIcon\" id=\"blockedIcon\" />\n        <div class=\"heading\" id=\"heading\"> {{ content('gamblingBlockCoolOffPeriod.heading') }} </div>\n        <div class=\"content_wrapper\">\n            <div class=\"segment\" id=\"description\">\n                <div class=\"text\" ng-bing-html=\"gamblingContent.info1\"> {{ content('gamblingBlockCoolOffPeriod.description') }}</div>\n            </div>\n        </div>\n    </div>\n    <p ng-if=\"cancelUrlPresent\" class=\"cancel_back\" id=\"cancelBack\">\n        <a ng-click=\"actions.redirectToCancelUrl()\" role=\"button\" class=\"btn full\" id=\"returnToMerchantButton\"> {{ content('gamblingBlockCoolOffPeriod.returnToMerchant') }} </a>\n    </p>\n</section>"

/***/ }),

/***/ "./pages/xo-gambling-block-enabled/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("./pages/xo-gambling-block-enabled/template.html");

var _template2 = _interopRequireDefault(_template);

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

__webpack_require__("./pages/xo-gambling-block-enabled/styles.less");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoGamblingBlockEnabledPageComponent', {
    tag: 'xo-gambling-block-enabled-page',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },
    actions: {
        redirectToCancelUrl: function redirectToCancelUrl() {
            var cancelUrl = this.models.checkoutAppData.urls.cancel_url;
            _index.$ReturnToMerchant.goTo(cancelUrl);
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            // on reload the header and the footer reappear, hence adding the timeout
            (0, _angular.$timeout)(function () {
                $('.row-fluid.paypalHeaderWrapper').hide();
                $('.footer').hide();
            }, 0);
            this.token = _angular.$rootScope.token;
        },
        populate: function populate() {
            // to check if the merchant has a cancel_url present, if present the "return to merchant" button is displayed
            this.cancelUrlPresent = this.models.checkoutAppData.urls.cancel_url;
            _logger.$logger.info('checkout_fpti', {
                from: 'uk_gambling_block',
                to: 'uk_gambling_block_active_page_loaded',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token'
            });
        }
    }
});

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_checkout.$CheckoutAppDataModel;

_index.$ReturnToMerchant;

_angular.$timeout;

_logger.$logger;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-gambling-block-enabled/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GamblingBlockEnabled = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-gambling-block-enabled/directive.js");

var $GamblingBlockEnabled = exports.$GamblingBlockEnabled = _squid.$ComponentRoute.extend('$GamblingBlockEnabled', {
    path: 'gamblingBlockEnabled',
    directive: 'xo-gambling-block-enabled-page',
    titleContent: 'gamblingBlockEnabled.headingn',
    query: ['message'],
    trackingData: {
        templateName: 'gamblingBlockEnabled.dust',
        pageGoal: 'Gambling Block Enabled page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-gambling-block-enabled',
                'pagename2': '%::fullpage-gambling-block-enabled:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$GamblingBlockEnabled", $GamblingBlockEnabled);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-gambling-block-enabled/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-gambling-block-enabled/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"gamblingBlockEnabled\" id=\"gamblingBlockEnabled\" content>\n    <div class=\"info_content\" id=\"infoContent\">\n        <div class=\"activeIcon\" id=\"activeIcon\" />\n        <div class=\"heading\" id=\"heading\"> {{ content('gamblingBlockEnabled.heading') }} </div>\n        <div class=\"content_wrapper\">\n            <div class=\"segment\" id=\"description1>\n                <div class=\"text\" ng-bing-html=\"gamblingContent.info1\">{{ content('gamblingBlockEnabled.description1') }}</div>\n            </div>\n            <div class=\"segment\" id=\"description2>\n                <div class=\"text\" ng-bing-html=\"gamblingContent.info2\"> {{ content('gamblingBlockEnabled.description2') }}</div>\n            </div>\n        </div>\n    </div>\n    <p ng-if=\"cancelUrlPresent\" class=\"cancel_back\" id=\"cancelBack\">\n        <a ng-click=\"actions.redirectToCancelUrl()\" role=\"button\" class=\"btn full\" id=\"returnToMerchantButton\"> {{ content('gamblingBlockEnabled.returnToMerchant') }} </a>\n    </p>\n</section>"

/***/ }),

/***/ "./pages/xo-generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoGenericErrorPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/generic-error/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

var _template = __webpack_require__("./pages/xo-generic-error/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
    tag: 'xo-generic-error-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {

        $scope.token = _angular.$rootScope.token;

        var models = {};

        (0, _squid.$populate)(models, {
            auth: _auth.$AuthModel.instance().retrieve()
        }).then(function () {

            $scope.logout = function () {

                if (window.xchild && _squid.$util.isIFrame()) {

                    window.xchild.hide();

                    var url = window.location.href.split('#')[0];

                    var xprops = _extends({}, window.xprops);

                    xprops.url = url;
                    xprops.payment = function () {
                        return models.auth.logout().then(function () {
                            return $scope.token;
                        });
                    };

                    return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
                }

                models.auth.logoutAndRedirect('GENERIC_ERROR');
            };
        });

        var terminalKey = 'terminal-error-' + $scope.token,
            refreshKey = 'has-seen-error-' + $scope.token;

        if (!_squid.$util.sessionStorageEnabled() || !$scope.token || sessionStorage.getItem(terminalKey)) {
            return renderErrorPage();
        }

        // Google Pay - acount linking: show error page immediately without trying to redirect user to the login screen
        // as it's not allowed for the user to switch accounts in this flow
        if (_auth.$AuthModel.instance() && _auth.$AuthModel.instance().disallow_login_switch) {
            return renderErrorPage();
        }

        // is not a refresh
        if (!sessionStorage.getItem(refreshKey)) {
            sessionStorage.setItem(refreshKey, '1');
            return renderErrorPage();
        }

        // is a refresh
        else {
                _logger.$logger.info('checkout_fpti', {
                    user_refresh: 1
                });

                sessionStorage.removeItem(refreshKey);

                _uiRouter.$state.go('checkout.login')['catch'](function () {
                    return (
                        // don't try to do this again
                        sessionStorage.setItem(terminalKey, '1')
                    );
                });
            }

        function renderErrorPage() {
            // prevent render flicker
            $scope.shouldRender = true;
        }
    }]
});

angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$populate;

_squid.$util;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

/***/ }),

/***/ "./pages/xo-generic-error/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GenericErrorRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-generic-error/directive.js");

var $GenericErrorRoute = exports.$GenericErrorRoute = _squid.$ComponentRoute.extend('$GenericErrorRoute', {
    path: 'genericError',
    directive: 'xo-generic-error-page',
    titleContent: 'genericError.pleaseTryAgain',
    query: ['code'],
    // need to find these values
    trackingData: {
        fptiState: 'fatal_error',
        templateName: 'genericError.dust',
        pageGoal: 'Generic Error',
        pageQualifier: 'blockNonDomesticShipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-generic-error',
                'pagename2': '%::fullpage-generic-error:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    auth: false,
    children: []
});

angular.value("$GenericErrorRoute", $GenericErrorRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-generic-error/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-generic-error ng-if=shouldRender token=token logout=logout></xo-generic-error>\n"

/***/ }),

/***/ "./pages/xo-generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoGenericMessagePageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/generic-message/directive.js");

var _template = __webpack_require__("./pages/xo-generic-message/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericMessagePageComponent = exports.$xoGenericMessagePageComponent = _squid.$Component.extend('$xoGenericMessagePageComponent', {
    tag: 'xo-generic-message-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {

        $scope.token = _angular.$rootScope.token;

        (0, _jquery2['default'])('#defaultCancelLink').hide();

        _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            event.preventDefault();
        });
    }]
});

angular.value("$xoGenericMessagePageComponent", $xoGenericMessagePageComponent);
_angular.$rootScope;

_squid.$Component;

/***/ }),

/***/ "./pages/xo-generic-message/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GenericMessageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-generic-message/directive.js");

var $GenericMessageRoute = exports.$GenericMessageRoute = _squid.$ComponentRoute.extend('$GenericMessageRoute', {
    path: 'genericMessage',
    directive: 'xo-generic-message-page',
    query: ['code', 'returnUrl'],
    // need to find these values
    trackingData: {},
    auth: false,
    children: []
});

angular.value("$GenericMessageRoute", $GenericMessageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-generic-message/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-generic-message token=token></xo-generic-message>\n"

/***/ }),

/***/ "./pages/xo-inventory-soldout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _template = __webpack_require__("./pages/xo-inventory-soldout/template.html");

var _template2 = _interopRequireDefault(_template);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSoldoutPageDirective', {
    tag: 'xo-soldout-page',
    template: _template2['default'],
    auth: false,

    actions: {
        continueShoppingHandler: function continueShoppingHandler() {
            _util.$ReturnToMerchant.goTo(decodeURIComponent(_uiRouter.$state.params.soldOutUrl), true);
        }
    },
    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            angular.element('.paypalHeader').css('display', 'none');
            angular.element('#defaultCancelLink').css('display', 'none');
        },
        populate: function populate() {
            this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
        }
    }

});


_squid.$Component;

_squid.$locale;

_util.$ReturnToMerchant;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-inventory-soldout/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSoldOutPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-inventory-soldout/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSoldOutPageRoute = exports.$xoSoldOutPageRoute = _squid.$ComponentRoute.extend('$xoSoldOutPageRoute', {
    path: 'soldout',
    directive: _directive2['default'],
    titleContent: 'soldout.title',
    query: ['items', 'soldOutUrl'],
    auth: false,
    trackingData: {
        fptiState: 'soldout',
        templateName: 'soldout.dust',
        pageGoal: 'soldout page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-soldout',
                'pagename2': '%::fullpage-soldout:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$xoSoldOutPageRoute", $xoSoldOutPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-inventory-soldout/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"soldOut\" content>\n    <div id=\"soldouticon\">\n        <div class=\"left_section\"> </div>\n\n        <div class=\"text_lines\">\n            <span id=\"text\">{{content ('soldout.icon')}}</span>\n        </div>\n\n        <div id=\"rightSection\">\n            <span class=\"shape-right\">   </span>\n        </div>\n    </div>\n\n    <div class=\"soldOutMessage\" ng-bind-html=\"htmlContent('soldout.message', {item: item_name})\">\n    </div>\n    <div>\n        <input id= \"Continue-Shopping\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueShoppingButton')}}\" ng-click=\"actions.continueShoppingHandler()\"/>\n\n    </div>\n\n</div>\n"

/***/ }),

/***/ "./pages/xo-landing/ppcRoute.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var getPPCRoute = exports.getPPCRoute = function getPPCRoute($logger, _ref) {
    var showCYCOInCAPE = _ref.showCYCOInCAPE,
        hasInstallmentOptions = _ref.hasInstallmentOptions,
        hasThreeMonthInstallment = _ref.hasThreeMonthInstallment,
        isCapeReturnKey = _ref.isCapeReturnKey,
        isInstallmentEligible = _ref.isInstallmentEligible,
        isUserLoggedIn = _ref.isUserLoggedIn,
        merchantCountry = _ref.merchantCountry;

    if (isCapeReturnKey) {
        $logger.info('ppc_return_flow');
        if (merchantCountry === 'DE') {
            return 'checkout.xoDeGuest';
        } else {
            return 'checkout.login';
        }
    } else if (merchantCountry === 'US' || merchantCountry === 'GB' || merchantCountry === 'LU') {
        // Swapping CYCO and UL - adding LU for eBay support
        if (isUserLoggedIn) {
            $logger.info('ppc_second_btn_ul_treatment_loggedin');
            // We're redirect to login because it contains logic to redirect to xo-eConsent if needed (same as 1st button)
            return 'checkout.login';
        } else {
            $logger.info('ppc_second_btn_ul_treatment_not_loggedin');
            if (isInstallmentEligible && hasInstallmentOptions) {
                $logger.info('ppc_second_btn_ul_treatment_has_installments');
                if (showCYCOInCAPE) {
                    $logger.info('ppc_second_btn_cape_cyco_treatment');

                    return {
                        to: 'checkout.redirectToCape',
                        params: {
                            showCapeCyco: true
                        }
                    };
                } else if (hasThreeMonthInstallment) {
                    $logger.info('ppc_second_btn_has_three_month_installment_no_cyco_cape_redirect');
                    return 'checkout.redirectToCape';
                } else {
                    return 'checkout.chooseCreditOffer';
                }
            } else {
                return 'checkout.redirectToCape';
            }
        }
    } else {
        // bypass CYCO if no installments
        if (hasInstallmentOptions && (merchantCountry === 'US' && isInstallmentEligible || merchantCountry !== 'US')) {
            // eslint-disable-line
            if (showCYCOInCAPE) {
                $logger.info('ppc_second_btn_cape_cyco_treatment');
                return {
                    to: 'checkout.redirectToCape',
                    params: { showCapeCyco: true }
                };
            }
            $logger.info('ppc_second_btn_cyco');
            return 'checkout.chooseCreditOffer';
        } else if (merchantCountry === 'DE') {
            return {
                to: 'checkout.genericError',
                params: {
                    code: 'BLOCK_PPC_INELIGIBLE_USER'
                }
            };
        } else {
            $logger.info('ppc_second_btn_no_installments');
            return 'checkout.login';
        }
    }
};

/***/ }),

/***/ "./pages/xo-landing/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$LandingRoute = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _inventory = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");

var _ppcRoute = __webpack_require__("./pages/xo-landing/ppcRoute.js");

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {
    path: 'landing',
    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },
    auth: false,
    resolve: {

        action: function action() {
            var models = {};
            var isPayPalCredit = void 0;

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                auth: _auth.$AuthModel.instance(),
                checkoutPayeeModel: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                flowEligibility: _index.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                        braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })
            }).then(function () {
                isPayPalCredit = models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

                var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');

                if (isPayPalCredit) {
                    return _angular.$q.all([(0, _squid.$elmo)('xo_us_ppc_ezp', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': models.checkoutPayeeModel.getId()
                    }, 'Trmt_xo_us_ppc_.*|Trmt_xo_de_ppc_cape_cyco_.*', false, true), (0, _squid.$elmo)('xo_gb_ppc_merchant_country_override', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': models.checkoutPayeeModel.getId()
                    }, 'Trmt_xo_gb_ppc_merchant_country_override_.*', false, true)]).then(function (_ref) {
                        var ppcEZPRes = _ref[0],
                            merchantOverride = _ref[1];
                        return {
                            ppcEZPRes: ppcEZPRes,
                            merchantOverride: merchantOverride
                        };
                    });
                } else {
                    return {};
                }
            }).then(function (_ref2) {
                var ppcEZPRes = _ref2.ppcEZPRes,
                    merchantOverride = _ref2.merchantOverride;

                var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
                var previousMerchantCountry = models.checkoutAppData.get('merchant.merchant_country');
                var buyerCountry = _squid.$locale.country;
                var prevBuyerCountry = _squid.$locale.country;
                var prevBuyerLanguage = _squid.$locale.lang;

                var redirectToCapeCyco = merchantCountry === 'GB';
                var shouldOverrideLocale =
                // Only do this for PPC 2nd button
                isPayPalCredit && !models.auth.loggedIn();

                // Override buyer country to match merchant country for PPC 2nd button
                // https://engineering.paypalcorp.com/confluence/display/MICA/Locale+Issues+on+2nd+Button
                if (shouldOverrideLocale) {

                    if (merchantOverride) {
                        _logger.$logger.info('landing_overriding_merchant_country');
                        merchantCountry = 'GB';
                    }

                    if (
                    // Check that the merchant country is supported
                    merchantCountry && _squid.$config.supportedCountries[merchantCountry] && _squid.$config.creditEligibleCountries.indexOf(merchantCountry) !== -1) {
                        buyerCountry = merchantCountry;
                    } else if (
                    // Check that the buyer country is supported - no need to override if so
                    _squid.$config.supportedCountries[buyerCountry] && _squid.$config.creditEligibleCountries.indexOf(buyerCountry) !== -1) {
                        _logger.$logger.info('landing_overriding_locale_unsupported_merchant', {
                            buyerCountry: buyerCountry,
                            merchantCountry: merchantCountry
                        });
                    } else {
                        // Fallback to US because no supported country can be determined
                        _logger.$logger.warn('landing_overriding_locale_fallback', {
                            buyerCountry: prevBuyerCountry,
                            buyerLanguage: prevBuyerLanguage,
                            merchantCountry: merchantCountry
                        });
                        buyerCountry = 'US';
                    }

                    var supportedLanguages = _squid.$config.supportedCountries[buyerCountry];
                    var lang = void 0;

                    // If the buyer's language exists in the merchant's country, use that, otherwise use default
                    if (supportedLanguages.indexOf(prevBuyerLanguage) !== -1) {
                        lang = prevBuyerLanguage;
                    } else {
                        lang = supportedLanguages[0];
                    }

                    _logger.$logger.info('landing_overriding_locale_success', {
                        prevBuyerCountry: prevBuyerCountry,
                        prevBuyerLanguage: prevBuyerLanguage,
                        newBuyerCountry: buyerCountry,
                        newBuyerLanguage: lang,
                        merchantCountry: merchantCountry,
                        previousMerchantCountry: previousMerchantCountry
                    });

                    // Calling .change here instead of .chooseCountry because we don't want to store the
                    // locale - we want to persist the locale through to the login page, where the locale
                    // can be chosen after the user logs in
                    if (merchantCountry) {
                        _squid.$locale.change(merchantCountry, lang);
                    }
                }

                return {
                    ppcEZPRes: ppcEZPRes, redirectToCapeCyco: redirectToCapeCyco
                };
            }).then(function (_ref3) {
                var ppcEZPRes = _ref3.ppcEZPRes,
                    redirectToCapeCyco = _ref3.redirectToCapeCyco;

                var forced_signup_offered = models.flowEligibility.guest ? 0 : 1;

                _logger.$logger.info('checkout_fpti', { 'from': 'LANDING_PAGE_PARAM', 'forced_signup_offered': forced_signup_offered });

                var landingFlow = function landingFlow() {
                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country', 'US');
                    var supportBlockNonDomesticShipping = (0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry);
                    var prefillShippingAddress = models.checkoutCart.get('purchase.shipping_address');
                    var blockNonDomesticShipping = models.checkoutAppData.get('flags.block_non_domestic_shipping');
                    var allowChangeShipping = models.checkoutAppData.get('flags.allow_change_shipping');
                    var isVenmoOneTouch = models.auth.get('tenant') === 'VENMO' && models.auth.get('logged_in');

                    if (supportBlockNonDomesticShipping && blockNonDomesticShipping) {
                        _logger.$logger.info('block_non_domestic_shipping', {
                            block_non_domestic_shipping: blockNonDomesticShipping,
                            allow_change_shipping: allowChangeShipping,
                            setec_shipping_country_code: prefillShippingAddress
                        });
                    }

                    var shouldBlockBuyer = supportBlockNonDomesticShipping && blockNonDomesticShipping && !allowChangeShipping && prefillShippingAddress && prefillShippingAddress.country_code !== merchantCountry && prefillShippingAddress.country_code !== '';

                    if (shouldBlockBuyer) {
                        return {
                            to: 'checkout.genericError',
                            params: {
                                code: 'BLOCK_NON_DOMESTIC_SHIPPING'
                            }
                        };
                    }

                    if (isPayPalCredit) {
                        var ppcEZPTreatment = ppcEZPRes && ppcEZPRes.treatment_name;

                        _logger.$logger.info('checkout_fpti', {
                            'xo_us_ppc_ezp': ppcEZPTreatment ? ppcEZPTreatment : 'Ctrl_xo_us_ppc_ezp'
                        });

                        var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);
                        var isCapeReturnKey = creditDataModel.getCapeKey();
                        var offers = new _index2.$CreditInstallmentOptionsModel({
                            id: _angular.$rootScope.token,
                            payee: models.checkoutPayeeModel,
                            checkoutCart: models.checkoutCart,
                            checkoutAppData: models.checkoutAppData,
                            isMemberCredit: true
                        });
                        var isInstallmentEligible = models.flowEligibility && models.flowEligibility.installment;

                        return offers.save({
                            cache: true,
                            success: function success(result) {
                                var hasInstallmentOptions = offers.getInstallmentOptionsPresent();
                                var installmentOfferDetails = offers.getInstallmentOffers();

                                installmentOfferDetails = installmentOfferDetails && installmentOfferDetails.installment_options;

                                if (result && result.conversion_info && result.conversion_info.converted_transaction_amount) {
                                    _logger.$logger.info('xo_landing_ppc_conversion_info_present');
                                    creditDataModel.setCartAmountAndCurrency({
                                        cart_amount: result.conversion_info.converted_transaction_amount.value,
                                        cart_currency: result.conversion_info.converted_transaction_amount.currency_code
                                    });
                                }
                                // Unified login treatment + create account flow (user not logged in)
                                var isUserLoggedIn = models.auth.loggedIn();

                                var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                                var installmentOfferDetailsArray = installmentOfferDetails ? installmentOfferDetails.map(function (item) {
                                    return item.financingCode;
                                }) : [];
                                var hasThreeMonthInstallment = Boolean(installmentOfferDetailsArray.filter(function (value) {
                                    return threeMonthFinancingCodeArray.includes(value);
                                }).length > 0);
                                var showCYCOInCAPE = Boolean(ppcEZPTreatment) || redirectToCapeCyco;

                                return (0, _ppcRoute.getPPCRoute)(_logger.$logger, {
                                    showCYCOInCAPE: showCYCOInCAPE,
                                    hasInstallmentOptions: hasInstallmentOptions,
                                    hasThreeMonthInstallment: hasThreeMonthInstallment,
                                    isCapeReturnKey: isCapeReturnKey,
                                    isInstallmentEligible: isInstallmentEligible,
                                    merchantCountry: merchantCountry,
                                    isUserLoggedIn: isUserLoggedIn
                                });
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, err) {
                                    // Check error message === currencyNotCompatible
                                    return 'checkout.login';
                                }
                            }
                        });
                    }

                    if (isVenmoOneTouch) {

                        return 'checkout.venmoAuth';
                    }

                    return 'checkout.login';
                };

                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (_squid.$config.enableInventoryWPS && cartHasInventory) {
                    var inventoryModel = _inventory.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryInput = {
                        items: models.checkoutCart.get('purchase.items'),
                        merchantId: models.checkoutPayeeModel.getId()
                    };

                    return inventoryModel.action('getInventory', {
                        data: inventoryInput,
                        success: function success(inventoryResponse) {
                            if (inventoryResponse.showSoldoutPage) {
                                return {
                                    to: 'checkout.soldout',
                                    params: {
                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                    }
                                };
                            } else {
                                inventoryModel.setInvetoryItems(inventoryResponse);
                                return landingFlow();
                            }
                        }
                    });
                } else {
                    return landingFlow();
                }
            });
        }
    }
});

angular.value("$LandingRoute", $LandingRoute);
_angular.$q;

_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_squid.$Class;

_squid.$ComponentRoute;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$elmo;

_squid.$util;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$FlowEligibilityModel;

_index.$CheckoutAppDataModel;

_index2.$CreditInstallmentOptionsModel;

_credit.$CreditDataModel;

_inventory.$InventoryModel;

_ppcRoute.getPPCRoute;

/***/ }),

/***/ "./pages/xo-login/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoLoginPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index5 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/handler/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/unified-login/directive.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/vaulting/utils.js");

var _loginEligibility = __webpack_require__("./pages/xo-login/loginEligibility.js");

__webpack_require__("./pages/xo-login/onboarding/directive.js");

var _template = __webpack_require__("./pages/xo-login/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-login/tokenized-wallet-loader/directive.js");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

var _metricLogger = __webpack_require__("./js/lib/metricLogger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoLoginPageComponent = exports.$xoLoginPageComponent = _squid.$Component.extend('$xoLoginPageComponent', {
    tag: 'xo-login-page',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    link: function link() {
        _logger.$logger.info('login_link');
    },
    lifecycle: {
        populate: function populate() {
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index4.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            });
        }
    },
    rootEvents: {
        allLoaded: function allLoaded() {
            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    return _miniBrowser.$miniBrowser.frameBust(this.props.token);
                } else {
                    throw _integration.$integration.error('Can not framebust');
                }
            }
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('login_controller');

        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

        var memberSegmentMapper = {
            NEW_MEMBER: 'NEW_XO_MEMBER',
            YOUNG_MEMBER: 'YOUNG_XO_MEMBER',
            EXISTING_MEMBER: 'EXISTING_XO_MEMBER'
        };

        var ROUTE_MAPPING = {
            ECONSENT_REQUIRED: 'checkout.econsent'
        };

        $scope.ulEligibility = false;
        $scope.isWalletTokenization = false;

        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
         is attempting to navigate to a specific page, so we should not auto-redirect them.
          This also fixes an issue with users:
         - Authorizing the checkout session
         - Redirecting to the merchant
         - Hitting back and landing on login page
         - Calling create on checkout and overwriting the authorization
         - Hitting forward and landing again on merchant page
         */

        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
            _angular.$rootScope.forceLogin = true;
        }

        if (!_angular.$rootScope.forceLogin) {
            $scope.autoLogin = true;
        }

        _angular.$rootScope.forceLogin = true;
        $scope.hideGuest = _uiRouter.$stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || _uiRouter.$stateParams.showNotYou;
        $scope.promptlogin = $scope.hideGuest && !(0, _squid.$feature)('riskyLoginContingency');

        // log statement for mobile webview
        if (_index.$DeviceInfo.isApp()) {
            _logger.$logger.debug('HERMES_IN_MOBILE_WEBVIEW');
        }

        if (!_miniBrowser.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
            var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_login_design;

            (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                $scope.loginDesignExp = result;
            });
        }

        $scope.onContingency = function (name, contingency) {
            if (!ROUTE_MAPPING[name]) {
                throw new _squid.$FallbackError({
                    reason: name.toLowerCase(),
                    product: 'ux'
                });
            }

            _uiRouter.$state.go(ROUTE_MAPPING[name]);
        };

        $scope.checkoutSession = _index4.$CheckoutSessionModel.instance(_angular.$rootScope.token);
        $scope.eConsent = _user.$EConsentModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletEligibility = _index2.$TokenizedWalletEligibilityModel.instance(_angular.$rootScope.token);
        $scope.userProductSubscription = _index3.$UserProductSubscriptionModel.instance();
        $scope.tokenizedWalletPin = _index2.$TokenizedWalletPinModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletMsbOffer = _index2.$TokenizedWalletMsbOfferModel.instance(_angular.$rootScope.token);
        $scope.walletPreferences = _index5.$WalletPreferences.instance(_angular.$rootScope.token);
        $scope.memberSegment = _marketingoffer.$MemberSegmentModel.instance();
        $scope.dependencyEligibility = true;

        var isValidGamingContingencies = function isValidGamingContingencies(err) {
            // Map usRMG specific error cause to EOL message.
            var endOfLineErrorList = ['GAMER_INELIGIBLE', 'GAMER_FI_INELIGIBLE', 'GAMER_FI_UNCONFIRMED', 'GAMER_ACCOUNT_UNVERIFIED', 'GAMER_INVALID_ACCOUNT_TYPE', 'GAMER_LOGIN_OUT_OF_COUNTRY', 'GAMING_INVALID_PAYMENT_FLOW', 'GAMER_RESIDENCE_OUT_OF_COUNTRY', 'GAMER_NO_VALID_FUNDING_INSTRUMENT'];

            return err && err.cause && endOfLineErrorList.indexOf(err.cause) > -1;
        };

        var isUSGambling = function isUSGambling(_ref) {
            var err = _ref.err;

            var isUSBuyer = _squid.$locale.country === 'US';
            var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.get('merchant.merchant_country') === 'US';

            return isUSBuyer && isUSmerchant && $scope.checkoutPayeeModel.isGambling() && isValidGamingContingencies(err);
        };

        // preloading most popular routes where after setbuyer
        // we should keep the balance here to prevent over loading non needed javascript
        // basically the most popular routes should be added here
        var preloadCodeSplitRoutes = function preloadCodeSplitRoutes() {
            if (_squid.$meta.codeSplitting) {
                Promise.all([new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-select-fi/route.js")), new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-add-card/route.js"))])['catch'](function (err) {
                    _logger.$logger.info('code_split_setbuyer_routes_preload_failed', {
                        error: err && err.message
                    });
                });
            }
        };

        $scope.setBuyer = function () {
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            function handleContingency(name, err) {
                _logger.$logger.info('[xo login handleContingency]', {
                    name: name,
                    err: err
                });

                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }

                var errorCode = err.cause || name;

                fptiData.int_error_code = errorCode;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = fptiHardErrors.indexOf(errorCode) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);

                // NOTE: curently `GAMER_INELIGIBLE` is only designed for DE gambling
                // however, this new Contingency is expected to expand to all gambling
                // countries moving forward.
                if (isUSGambling({ err: err }) || errorCode === 'GAMER_INELIGIBLE') {
                    // US gambling buyer & merchant should get EOL
                    // for certain compliance Contingencies
                    return _uiRouter.$state.go('checkout.genericError', {
                        code: errorCode
                    });
                }

                if (name !== 'NEED_AUTHENTICATED_CARD') {
                    throw err;
                }

                // come from guest or have alternate FI options, go to review
                if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
                    _uiRouter.$state.go('checkout.review');
                } else {
                    // else go to addCard
                    _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
                }
            }

            function handleNoValidTopupFiContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                if ($scope.isWalletTokenization) {
                    fptiData.int_error_code = err.cause;
                    fptiData.error_source = 'paymentapiplatformserv';
                    fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                    _logger.$logger.info('checkout_fpti', fptiData);
                    $scope.checkoutSession.contingency = name;

                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    handleContingency(name, err);
                }
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'CREATE_XO_SESSION',
                to: 'prepare_create_xo_session'
            });

            $scope.isWalletTokenization = $scope.checkoutCart.isWalletTokenization();

            if ($scope.isWalletTokenization) {
                _angular.$rootScope.$emit('allLoaded');
            }

            $scope.eConsent.retrieve({
                batch: {
                    name: 'setbuyer',
                    silent: $scope.isWalletTokenization,
                    id: 'eConsent',
                    dependencies: []
                },
                contingencies: {
                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
                        if ($scope.dependencyEligibility) {
                            $scope.dependencyEligibility = false;
                            _logger.$logger.debug('ULLOGIN_ECONSENT_REQUIRED');
                            _uiRouter.$state.go('checkout.econsent');
                        }
                    }
                }
            });

            if ($scope.isWalletTokenization) {
                // these params are coming from Mayfly (see xo-hermes-app/apis/tokenizedWalletInfo)
                var _$scope$tokenizedWall = $scope.tokenizedWalletInfoModel,
                    wallet_id = _$scope$tokenizedWall.wallet_id,
                    external_device_id = _$scope$tokenizedWall.external_device_id,
                    tr_client_id = _$scope$tokenizedWall.tr_client_id,
                    product_name = _$scope$tokenizedWall.product_name;

                var subject = $scope.tokenizedWalletInfoModel.getSubject();

                // TODO: move to TokenizedWalletInfoModel
                var WALLET_BRANDS = {
                    'google': 'APAY',
                    'Samsung': 'SAMSUNGPAY'
                };

                var params = {
                    wallet_brand: WALLET_BRANDS[subject],
                    tenant_id: 'Hermes',
                    wallet_id: wallet_id,
                    external_device_id: external_device_id,
                    subject: subject,
                    tr_client_id: tr_client_id,
                    product_name: product_name
                };

                if (_squid.$meta.query && _squid.$meta.query.wallet_id) {
                    params.wallet_id = _squid.$meta.query.wallet_id;
                }
                if (_squid.$meta.query && _squid.$meta.query.jwt) {
                    params.jwt = _squid.$meta.query.jwt;
                }

                $scope.tokenizedWalletEligibility.retrieve({
                    params: params,
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletLightEligibility',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';

                            _logger.$logger.info(msg);

                            if ($scope.dependencyEligibility) {
                                $scope.dependencyEligibility = false;
                                var code = void 0;

                                fptiData.int_error_code = result.reason;
                                fptiData.error_source = 'paymenttokenserv';
                                fptiData.error_type = 'hard_decline';
                                _logger.$logger.info('checkout_fpti', fptiData);

                                switch (result.reason) {
                                    case 'WALLET_ID_ALREADY_PROVISIONED':
                                        code = 'ANDROID_PAY_ALREADY_PROVISIONED';
                                        break;

                                    case 'COUNTRY_NOT_SUPPORTED':
                                        code = 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED';
                                        break;

                                    default:
                                        code = 'ANDROID_PAY_ELIGIBILITY_ERROR';
                                        break;
                                }
                                code = window.btoa(code);

                                _uiRouter.$state.go('checkout.genericError', { code: code });
                            }
                        }
                    }
                });

                // check we have product provision subscribed by buyer
                // if not subscribed redirect to splash screen of subscription upsell
                $scope.userProductSubscription.retrieve({
                    batch: {
                        name: 'setbuyer',
                        id: 'userProductSubscription',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent', 'tokenizedWalletLightEligibility']
                    },

                    success: function success(result) {
                        // result is going to an object of { applicable: true, subscribed: true, reason: 'PAYPAL_CASH' }
                        if (result.applicable && !result.subscribed) {
                            _logger.$logger.info('product_subscription_enabled_not_subscribed');
                            $scope.dependencyEligibility = false;
                            _uiRouter.$state.go('checkout.cipverification');
                        }
                    }
                });

                $scope.tokenizedWalletPin.retrieve({
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletPin',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (result.pinId) {
                            _logger.$logger.info('tokenized_wallet_get_pin_set', {
                                pinOrigin: result.pinOrigin,
                                pinId: result.pinId
                            });
                        } else {
                            _logger.$logger.info('tokenized_wallet_get_pin_not_set', {
                                pinKey: result.suggestedKey ? result.suggestedKey : 'unavailable'
                            });
                        }
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('tokenized_wallet_get_pin_error');
                            return _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                        }
                    }
                });

                $scope.tokenizedWalletMsbOffer.retrieve({
                    params: {
                        tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken
                    },
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletMsbOffer',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        var msg = 'tokenized_wallet_msb_offer';

                        if (result && result.enabled) {
                            _logger.$logger.info(msg + '_enabled', result);
                        } else {
                            _logger.$logger.info(msg + '_disabled');
                        }
                    }
                });
            }

            if (_squid.$config.enableNewMemberDecisioning) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'CEP_decisioning',
                    to: 'prepare_cep_descisioning'
                });

                $scope.memberSegment.save({
                    data: $scope.memberSegmentData,
                    batch: {
                        name: 'setbuyer',
                        id: 'memberSegment',
                        silent: true,
                        dependencies: $scope.ulEligibility ? ['securityCtx'] : []
                    },
                    success: function success(result) {
                        var memberSegment = memberSegmentMapper[result.memberSegment] || result.memberSegment;

                        _logger.$logger.info('cep_member_decisioning_success', {
                            segment: memberSegment,
                            creditOffer: result.creditOffer
                        });
                        _logger.$logger.info('checkout_fpti', {
                            from: 'CEP_decisioning',
                            to: 'process_cep_descisioning',
                            cep_response: memberSegment + ':' + result.creditOffer
                        });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('cep_member_decisioning_failed');
                            _logger.$logger.info('checkout_fpti', {
                                from: 'CEP_decisioning',
                                to: 'process_cep_descisioning',
                                int_error_code: 'SERVICE_ERROR',
                                error_source: 'marketingofferreadserv',
                                error_type: 'soft_decline'
                            });
                        }
                    }
                });
            }

            var isPayPalCredit = $scope.checkoutAppData.isSecondButton();

            $scope.checkoutSession.action('create', {
                data: {
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined,
                    // user_selected_funding_source is referenced by xo-hermes-checkout, where it retrieves the product_name in it and passes it to the CreateXO api.
                    user_selected_funding_source: $scope.userSelectedFundingSource,
                    clear_installments: true
                },
                batch: {
                    name: 'setbuyer',
                    id: 'createCheckoutSession',
                    silent: $scope.isWalletTokenization,
                    dependencies: !$scope.isWalletTokenization ? ['eConsent'] : ['eConsent', 'tokenizedWalletLightEligibility', 'userProductSubscription', 'tokenizedWalletPin', 'tokenizedWalletMsbOffer']
                },
                success: function success(result) {
                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';
                    _logger.$logger.info('checkout_fpti', fptiData);

                    if (!$scope.dependencyEligibility) {
                        return;
                    }

                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        if ((0, _squid.$feature)('pomaPasswordRecovery')) {
                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
                        }
                        return;
                    }

                    if (isPayPalCredit) {
                        return _util.$capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, _angular.$rootScope.token);
                    }

                    if ($scope.isWalletTokenization) {
                        // no need to check upsell for wallet tokenization flows
                        // just set planDone prop for "<tokenized-wallet-loader>" component
                        $scope.planDone = true;
                        return;
                    }

                    return _kmliUpsell.$KmliUpsell.eligible(_angular.$rootScope.token).then(function (eligibility) {
                        var isEligible = eligibility && eligibility.interstitial ? eligibility.interstitial : {};

                        if (isEligible.eligible) {
                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';

                            _logger.$logger.info('checkout_fpti', {
                                from: stateName,
                                to: 'prepare_kmli_upsell'
                            });

                            _logger.$logger.info('ryi_optin', {
                                'from': 'OT_Toggle',
                                'to': 'prepare_inter_optin'
                            });
                            return _uiRouter.$state.go('checkout.oneTouchUpsell', { oneTouchFlowName: 'checkout' });
                        }

                        if ($scope.auth.rtExchanged && (0, _squid.$feature)('rmSpinnerText')) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['login.loggedInWithOneTouch']
                            };
                        }

                        if ($scope.checkoutSession.negBals) {
                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                        } else {
                            (0, _utils.checkVaultingEligibility)().then(function (eligible) {
                                if (eligible) {
                                    (0, _utils.authorize)($scope.checkoutSession, $scope.checkoutAppData).then(function (authorizePage) {
                                        return _uiRouter.$state.go(authorizePage);
                                    })['catch'](function (err) {
                                        // eslint-disable-line handle-callback-err
                                        _uiRouter.$state.go('checkout.review');
                                    });
                                } else {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        }
                    });
                },
                contingencies: {
                    // override contingency.js handler with custom logic to support both xoon/hermes flows
                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    DEFAULT: handleContingency
                }
            })['finally'](function () {
                // selectedInstallmentsData does not come from checkoutSession response from PAPS, so we need to keep track of this state ourselves.
                // We pass clear_installments when calling the checkout session API, so we need to reflect that this is being cleared.
                // See https://engineering.paypalcorp.com/jira/browse/PPPLMER-58580
                delete $scope.checkoutSession.selectedInstallmentData;
            });

            preloadCodeSplitRoutes();
        };

        /**
         * This call is made after the buyer is logged in, and before the CreateXO api call.
         * So that we can retrieve the tokenized funding capabilities for the buyer country.
         */
        $scope.getTokenizedFundingCapabilities = function () {
            return _index2.$TokenizedFundingCapabilitiesModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken,
                    country: $scope.auth.country
                }
            }).then(function (result) {
                if (result.isDirectFundingEnabled()) {
                    $scope.userSelectedFundingSource = {
                        product_name: result.getProductName()
                    };
                }
            });
        };

        $scope.preSetBuyerCalls = function () {
            var apiCalls = [];

            if ($scope.checkoutCart.isWalletTokenization()) {
                apiCalls.push($scope.getTokenizedFundingCapabilities());
            }
            return _angular.$q.all(apiCalls);
        };

        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
        $scope.preAuth = function () {
            if ($scope.ulEligibility) {
                // For UL, batch up eConsent, xoSession
                $scope.preSetBuyerCalls().then(function () {
                    return $scope.setBuyer();
                });
            }
        };

        $scope.onSuccess = function () {
            if ($scope.ulEligibility) {
                // If the experiment is enabled, we already have what we need, so /quit.
                return;
            }
            $scope.preSetBuyerCalls().then(function () {
                return $scope.setBuyer();
            });
        };

        (0, _squid.$populate)($scope, {
            flowEligibility: _index4.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    geolocation: _squid.$meta.geolocation,
                    localeCountry: _squid.$locale.country // We need this till we completely migrate to server side locale resolution
                }
            }),
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _index4.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _index4.$CheckoutCartModel.instance(_angular.$rootScope.token),
            checkoutPayeeModel: _index4.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
            tokenizedWalletInfoModel: _index2.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
            venmoEligibility: _venmoModels.$VenmoTransactionEligibility.instance(_angular.$rootScope.token).retrieve({
                params: {
                    braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                    fundingSource: _squid.$util.param('fundingSource'),
                    localeCountry: _squid.$locale.country,
                    venmoOverride: _squid.$util.param('venmoOverride'),
                    native_xo: _squid.$util.param('native_xo')
                }
            })
        }).then(function () {
            return _newMember.$NewMemberEligibility.instance().getMemberSegmentParameters(_angular.$rootScope.token).then(function (data) {
                $scope.memberSegmentData = data;
                // Set flag to indicate all data is loaded
                $scope.populateComplete = true;
                return;
            });
        }).then(function () {
            (0, _metricLogger.metricCounter)('venmo_eligibility_xo_login', { eligibility: $scope.venmoEligibility.venmo });
            // If the refresh token is present, the one touch experience must be preserved and the user must not
            // be presented with the venmo experience
            if (!$scope.auth.refresh_token) {
                var merchant_name = $scope.checkoutAppData.merchant.brand_name || $scope.checkoutAppData.merchant.merchant_name || $scope.checkoutAppData.merchant.merchant_email;

                $scope.infoVenmo = {
                    msgs: [(0, _squid.$renderContent)('landing.venmoAvailableSoon', { 'merchant': merchant_name })],
                    type: 'info'
                };

                var venmoPayloadID = window.xprops && window.xprops.venmoPayloadID;

                // if nativeSDK and SPB prop for payload_id exists, we go directly to venmo directive
                if (!_uiRouter.$stateParams.venmoError && $scope.venmoEligibility.venmo && venmoPayloadID) {

                    return _uiRouter.$state.go('checkout.venmo', { payload_id: venmoPayloadID });
                }

                if (!_uiRouter.$stateParams.venmoError && $scope.venmoEligibility.venmo) {
                    return _uiRouter.$state.go('checkout.payWithSelection');
                } else if (!_uiRouter.$stateParams.venmoError && _thirdPartyInfo.thirdPartyInfo.isVenmoCookiePresent()) {
                    $scope.showVenmoAvailableSoonMsg = true;
                }

                if (_uiRouter.$stateParams.venmoError && _squid.$util.param('marketplaces_venmo_client') === '1') {
                    return _uiRouter.$state.go('checkout.genericError', { code: 'VENMO_ERROR_WITH_CANCEL_URL' });
                }

                // Baidu eligibility checks. Pending pxp throttle
                return _thirdPartyInfo.thirdPartyInfo.isBaiduEligible().then(function (baiduEligible) {
                    if (!_uiRouter.$stateParams.baiduError && baiduEligible) {
                        return (0, _squid.$pxp)('xo_hermesnode_baidu', {
                            'ctx.COUNTRY': $scope.checkoutAppData.get('merchant.merchant_country'),
                            'uid': $scope.checkoutPayeeModel.getId()
                        }, '(xo_hermesnodeweb_baidu)(.*)').then(function (result) {
                            if (result && result.treatment_name === 'xo_hermesnodeweb_baidu_treatment_4660') {
                                return _uiRouter.$state.go('checkout.payWithSelection');
                            }
                        });
                    }
                });
            }
            if ($scope.flowEligibility.guest) {
                return;
            }

            $('.paypalHeaderWrapper').removeClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
        }).then(function () {
            var initKmliAndDeleteAT = function initKmliAndDeleteAT() {
                delete $scope.auth.access_token;
                _kmliUpsell.$KmliUpsell.init({});
            };

            // reload auth model for use cases where user is not logged in and access_token is in the hash
            // happens already in the middleware
            // basically if there is a param "euat" - there will be access token in the hash
            // otherwise I don't think we need to reload Auth model if user is logged in already
            if ($scope.auth.accessToken() && !$scope.auth.loggedIn()) {
                return $scope.auth.reload({
                    headers: {
                        'x-paypal-internal-euat': $scope.auth.accessToken()
                    },
                    resultModel: $scope.auth,
                    success: function success() {
                        initKmliAndDeleteAT();
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new _squid.$FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            } else if ($scope.auth.loggedIn()) {
                initKmliAndDeleteAT();
            }
        }).then(function () {
            return (0, _loginEligibility.$loginEligibility)(_angular.$rootScope.token, !$scope.autoLogin).then(function (result) {
                if (result === 'unifiedLogin') {
                    $scope.ulEligibility = true;
                } else if (result === 'apsIntegration') {
                    $scope.apsIntegration = 'apsIntegration';
                } else if (result === 'apsIntegrationRM') {
                    $scope.apsIntegration = 'apsIntegrationRM';
                }
            }).then(function () {
                var reinitDisplay = function reinitDisplay() {
                    $scope.promptlogin = false;
                    $scope.hideGuest = false;
                    $scope.autoLogin = true;
                    delete _uiRouter.$stateParams.targetPage;
                    delete _uiRouter.$stateParams.showNotYou;
                };

                $scope.logout = $scope.promptlogin ? function () {
                    _logger.$logger.info('not_you_logout');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'LOGIN_UL',
                        to: 'login_with_diff_user'
                    });
                    $scope.auth.logoutAndRedirect('NOT_YOU');
                } : function () {
                    _logger.$logger.info('logout_switch_display');
                    reinitDisplay();
                };
            });
        });
    }]
});

angular.value("$xoLoginPageComponent", $xoLoginPageComponent);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_miniBrowser.$miniBrowser;

_squid.$Component;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_squid.$pxpFactors;

_squid.$renderContent;

_squid.$util;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_kmliUpsell.$KmliUpsell;

_index2.$TokenizedFundingCapabilitiesModel;

_index2.$TokenizedWalletEligibilityModel;

_index2.$TokenizedWalletInfoModel;

_index2.$TokenizedWalletMsbOfferModel;

_index2.$TokenizedWalletPinModel;

_index3.$UserProductSubscriptionModel;

_auth.$AuthModel;

_index4.$CheckoutAppDataModel;

_index4.$CheckoutCartModel;

_index4.$CheckoutPayeeModel;

_index4.$CheckoutSessionModel;

_index4.$FlowEligibilityModel;

_index5.$WalletPreferences;

_marketingoffer.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_user.$EConsentModel;

_venmoModels.$VenmoTransactionEligibility;

_thirdPartyInfo.thirdPartyInfo;

_utils.checkVaultingEligibility;

_utils.authorize;

_loginEligibility.$loginEligibility;

_factory.$TokenizedWalledLoaderFactory;

_util.$capeRedirectUtil;

_metricLogger.metricCounter;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-login/guestThrottle.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$guestThrottle = $guestThrottle;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function $guestThrottle(flowName, token, lang, country, mfid) {

    function redirectToXoon() {
        return (0, _squid.$dispatch)('xoon', {
            exp: flowName,
            token: token,
            'locale.x': lang + '_' + country,
            'country.x': country,
            mfid: mfid
        });
    }

    function fallback(product, reason, params) {
        throw new _squid.$FallbackError({
            product: product || 'ux',
            reason: reason,
            entryPoint: flowName,
            params: params
        });
    }

    function isGuestFlowEnabled() {
        return _angular.$q.resolve(true);
    }

    return isGuestFlowEnabled().then(function (res) {
        if (!res) {
            _logger.$logger.info(flowName + '_to_ux_wps');
            return fallback('ux', flowName + '_to_ux_wps');
        }
        return redirectToXoon();
    });
}

angular.value("$guestThrottle", $guestThrottle);
_angular.$q;

_logger.$logger;

_squid.$dispatch;

_squid.$FallbackError;

/***/ }),

/***/ "./pages/xo-login/loginEligibility.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$forceLoginExperience = $forceLoginExperience;
exports.$loginEligibility = $loginEligibility;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function $forceLoginExperience(auth, merchant_country, forcedLogin) {
    var ULParam = _squid.$util.param('ul');

    if (auth.loggedIn() && !auth.stepupAuthRequired && !forcedLogin) {
        var ulReturn = _squid.$util.param('ulReturn');

        return {
            experience: 'apsIntegration',
            reason: ulReturn ? 'ulReturn' : 'sessionActive'
        };
    } else if (ULParam === '0' && !_squid.$config.deploy.isLive()) {
        return {
            experience: 'apsIntegration',
            reason: 'ulParamDisabled'
        };
    } else if (ULParam && ULParam.match(/[12]/)) {
        return {
            experience: 'unifiedLogin',
            reason: 'ulParam'
        };
    } else if (ULParam === '3') {
        return {
            experience: 'apsIntegrationRM',
            reason: 'ulParamApsRM'
        };
    } else if (auth.refreshToken()) {
        return {
            experience: 'unifiedLogin',
            reason: 'rememberedUser'
        };
    } else if (_squid.$meta.corp && _squid.$config.ulMeta.allowKMLIForInternalIP && (0, _squid.$feature)('enableOneTouchInternalIP', false, merchant_country)) {
        return {
            experience: 'unifiedLogin',
            reason: 'internalIP'
        };
    }
}

function $loginEligibility(token, forcedLogin) {
    var $scope = {};

    $scope.token = token;

    var routingReason = void 0;

    return (0, _squid.$populate)($scope, {
        auth: _index2.$AuthModel.instance(),
        checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
    }).then(function () {
        var forceLoginExperience = $forceLoginExperience($scope.auth, $scope.checkoutAppData.merchant.merchant_country, forcedLogin);
        var isIneligible = angular.isDefined(forceLoginExperience);

        // Check login param for hercules, otherwise, always using UL
        if (isIneligible) {
            routingReason = forceLoginExperience.reason;
            return forceLoginExperience.experience;
        } else {
            return 'unifiedLogin';
        }
    }).then(function (finalLoginExperience) {
        _logger.$logger.debug(finalLoginExperience === 'unifiedLogin' ? 'ULLOGIN_ELIGIBLE' : 'ULLOGIN_NOT_ELIGIBLE', {
            userGroup: [routingReason],
            routing_reason: routingReason
        });

        var app_int_type = _index3.$DeviceInfo.getAppIntegrationType();

        _logger.$logger.info('checkout_fpti', {
            'from': 'UL_ELG_CHK',
            'to': 'process_ul_elg_chk',
            'routing_reason': routingReason,
            'app_int_type': app_int_type
        });

        return finalLoginExperience;
    });
}

angular.value("$forceLoginExperience", $forceLoginExperience);
angular.value("$loginEligibility", $loginEligibility);
_squid.$util;

_squid.$meta;

_squid.$config;

_squid.$feature;

_squid.$populate;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index2.$AuthModel;

_index3.$DeviceInfo;

/***/ }),

/***/ "./pages/xo-login/onboarding/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoOnboardingSectionComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _guestThrottle = __webpack_require__("./pages/xo-login/guestThrottle.js");

var _paypalplus = __webpack_require__("./pages/xo-login/paypalplus.js");

__webpack_require__("../node_modules/xo-wallet-components/src/fi-logos/directive.js");

var _template = __webpack_require__("./pages/xo-login/onboarding/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoOnboardingSectionComponent = exports.$xoOnboardingSectionComponent = _squid.$Component.extend('$xoOnboardingSectionComponent', {
    tag: 'xo-onboarding-section',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    controller: ['$scope', function ($scope) {
        function throttleOnboardingFlow(flow) {
            return (0, _guestThrottle.$guestThrottle)(flow, $scope.token, _squid.$locale.lang, _squid.$locale.country, _squid.$meta.mfid);
        }

        $scope.signupThrottle = function () {
            if ($scope.forceCAPESignup) {
                _logger.$logger.info('redirecting_to_cape_acq_signup_throttle', {
                    showCapeCyco: $scope.showCapeCyco
                });

                return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: $scope.showCapeCyco });
            } else {
                throttleOnboardingFlow('signup');
            }
        };

        $scope.guestThrottle = function () {
            throttleOnboardingFlow('guest');
        };

        function getFlowEligibility() {
            return _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                params: {
                    'localeCountry': _squid.$locale.country
                }
            }).then(function (flowEligibility) {
                $scope.flowEligibility = flowEligibility;
            });
        }

        function getButtonLabelTreatment() {
            $scope.newUserVariant = false;
            $scope.newUserVariantWithText = false;

            return (0, _squid.$pxp)('xo_hermes_new_user', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermes_new_user_treatment_(a|b)', false, true).then(function (t) {
                if (t) {
                    $scope.newUserVariant = true;
                    if (t.treatment_name === 'xo_hermes_new_user_treatment_b') {
                        $scope.newUserVariantWithText = true;
                    }
                }
            });
        }

        function getPPCEZPTreatment() {
            $scope.showCapeCyco = false;

            /** We need to verify if the user has a valid credit offer before redirecting into the CYCO page
             * because if we don't CYCO page will end up in a 500 error, so before redirecting the user there,
             * we need to make sure is a valid route.
             */
            var checkoutAppData = _checkout.$CheckoutAppDataModel.instance($scope.token);
            var checkoutCartModel = _checkout.$CheckoutCartModel.instance($scope.token);
            var checkoutPayeeModel = _checkout.$CheckoutPayeeModel.instance($scope.token);
            var offers = new _credit.$CreditInstallmentOptionsModel({
                id: $scope.token,
                payee: checkoutPayeeModel,
                checkoutCart: checkoutCartModel,
                checkoutAppData: checkoutAppData,
                isMemberCredit: true
            });
            var hasInstallmentOptions = offers.getInstallmentOptionsPresent();

            return (0, _squid.$elmo)('xo_us_ppc_ezp', {
                'ctx.COUNTRY': $scope.checkoutAppData.get('merchant.merchant_country'),
                'ctx.merchantID': $scope.payee.get('merchant.id')
            }, 'Trmt_xo_us_ppc_.*', false, true).then(function (t) {
                if (t) {
                    if (t && t.treatment_name && hasInstallmentOptions) {
                        $scope.showCapeCyco = true;
                    }
                }
            });
        }

        (0, _squid.$populate)($scope, {
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            return getFlowEligibility();
        }).then(function () {
            return getPPCEZPTreatment();
        }).then(function () {
            return getButtonLabelTreatment();
        }).then(function () {
            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            $scope.creditDataModel = _credit.$CreditDataModel.instance($scope.token);
            $scope.forceCAPESignup = isPayPalCredit && !$scope.creditDataModel.payInFull;

            var useForcedSignupFlow = (0, _paypalplus.$isPayPalPlus)($scope.token) || $scope.forceCAPESignup;
            var guest = $scope.flowEligibility.guest;
            var signup = $scope.flowEligibility.signup;

            $scope.showGuestBtn = !useForcedSignupFlow && guest;
            $scope.showSignupBtn = useForcedSignupFlow || !guest && signup;
            $scope.hideOrSeparator = !$scope.showGuestBtn && !$scope.showSignupBtn;
        });
    }]
});

angular.value("$xoOnboardingSectionComponent", $xoOnboardingSectionComponent);
_uiRouter.$state;

_credit.$CreditDataModel;

_credit.$CreditInstallmentOptionsModel;

_squid.$Class;

_squid.$Component;

_squid.$elmo;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_logger.$logger;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_checkout.$FlowEligibilityModel;

_checkout.$CheckoutCartModel;

_guestThrottle.$guestThrottle;

_paypalplus.$isPayPalPlus;

/***/ }),

/***/ "./pages/xo-login/onboarding/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"onboardingSection\" id=\"onboardingSection\" content>\n    <div class=\"guestHeading\" ng-if=\"guestVariant.guestBtnOnTop\">\n        <xo-title title-txt=\"{{content('login.guestTitle')}}\"></xo-title>\n        <xo-language-options class=\"span7\"></xo-language-options>\n    </div>\n\n    <div class=\"orSeparator\" ng-if=\"!hideOrSeparator\">\n        <span class=\"textInDivider\">\n            {{content('login.orLowercase')}}\n        </span>\n    </div>\n\n    <a link-button track-link=\"guest\" class=\"btn btn-secondary full submit\" id=\"checkoutAsAGuestBtn\" ng-if=\"showGuestBtn\" ng-click=\"guestThrottle()\">\n        {{ content(newUserVariant ? 'login.newToPayPal' : 'login.guestLinkBtn') }}\n    </a>\n\n    <a link-button track-link=\"signup\" class=\"btn btn-secondary full submit\" id=\"signupBtn\" ng-if=\"showSignupBtn\" ng-click=\"signupThrottle()\">\n        {{ content(newUserVariant ? 'login.newToPayPal' : 'login.createAccount') }}\n    </a>\n\n    <div class=\"inline-prop\" ng-if=\"newUserVariantWithText\" ng-bind-html=\"content('login.guestProp')\"></div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-login/paypalplus.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$isPayPalPlus = $isPayPalPlus;

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function $isPayPalPlus(token) {
    var checkoutAppDataModel = _index.$CheckoutAppDataModel.instance(token);
    var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');
    return experienceInitiator === 'PAYPAL_PLUS';
}

angular.value("$isPayPalPlus", $isPayPalPlus);
_index.$CheckoutAppDataModel;

/***/ }),

/***/ "./pages/xo-login/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$LoginRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-login/directive.js");

var $LoginRoute = exports.$LoginRoute = _squid.$ComponentRoute.extend('$LoginRoute', {
    path: 'login',
    directive: 'xo-login-page',
    query: ['venmoError'],
    params: {
        targetPage: null,
        source: null,
        showNotYou: null
    },
    auth: false,
    titleContent: 'base.logIn',
    trackingData: {
        fptiState: 'login',
        suppressTransitionLog: true, // We will be suppressing the Server Side Tracking for this page
        templateName: 'login.dust',
        pageGoal: 'Payment Start',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-login',
                'pagename2': '%::fullpage-login:member:hermes:',
                'version': 'member:%:'
            },
            'ulLogin': {
                'pagename': '%::fullpage-ullogin',
                'pagename2': '%::fullpage-ullogin:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$LoginRoute", $LoginRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-login/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"login\"\n         id=\"login\" content>\n    <xo-message ng-if=\"showVenmoAvailableSoonMsg\" message=\"infoVenmo\"></xo-message>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n\n            <!--\n                SetBuyer Batch call is dependent on data from various models such as CheckoutCartDataModel etc.\n                Use of populateComplete flag ensures that the directive doesn't fire off until the required data is available.\n                Note that the flow works even without this flag in most cases since the code has failsafe paths\n                [ though they may be getting triggered due to insufficient and not the right data ]\n            -->\n\n            <xo-login-handler ng-if=\"populateComplete\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\"\n                              contingency-callback=\"onContingency\" ul-eligibility=\"ulEligibility\" pre-auth=\"preAuth\"\n                              aps-integration=\"apsIntegration\" batch=\"batch\"\n                              login-submit=\"loginSubmit\" flowcontext=\"flowcontext\" logout=\"logout\" export=\"loginHandler\"></xo-login-handler>\n\n            <div ng-if=\"promptlogin\" class=\"centerText\">\n                <hr class=\"sepPlain\" />\n\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\" class=\"ng-binding\" tabindex=\"0\">{{ content('memberReview.notYou')}}</a>\n            </div>\n\n            <xo-onboarding-section token=token ng-hide=\"hideGuest\"></xo-onboarding-section>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\"\n                            text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content(loginDesignExp.propHeader)}}\"\n                            text-content=\"{{loginDesignExp.propText}}\"\n                            image-url=\"{{loginDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n\n    <xo-tokenized-wallet-loader\n        ng-if='isWalletTokenization'\n        plan-done='planDone'\n    >\n    </xo-tokenized-wallet-loader>\n</section>\n"

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTokenizedWalletLoader = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/directive.js");

var _template = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ANIMATION_STATUSES = {
    NOT_STARTED: 'notStarted',
    PENDING: 'pending',
    COMPLETED: 'completed'
};

// card loader component - used only in tokenized wallet flows.
var $xoTokenizedWalletLoader = exports.$xoTokenizedWalletLoader = _squid.$Component.extend('$xoTokenizedWalletLoader', {
    tag: 'xo-tokenized-wallet-loader',
    template: _template2['default'],
    props: {
        planDone: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.auth = _auth.$AuthModel.instance();
            // start animation of the card
            this.setbuyerProgress = ANIMATION_STATUSES.NOT_STARTED;
            _logger.$logger.info('tokenized_wallet', {
                from: 'adding_pp_ap_animation',
                to: 'prepare_adding_pp_ap_animation',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token',
                billing_token: _squid.$meta.baToken
            });

            // sets animation state to 80%
            (0, _angular.$timeout)(function () {
                _this.setbuyerProgress = ANIMATION_STATUSES.PENDING;
                _logger.$logger.info('tokenized_wallet', {
                    from: 'adding_pp_ap_animation',
                    to: 'process_adding_pp_ap_animation',
                    context_id: _angular.$rootScope.token,
                    context_type: 'EC-Token',
                    billing_token: _squid.$meta.baToken
                });
            }, 300);

            // watch when planning is completed in xo-login/directive
            // to redirect to "checkout.tokenizationInfo" page
            this.$watch('planDone', function (planDone) {
                if (planDone) {
                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                }
            });
        },
        populate: function populate() {
            this.cardLoaderMessage = _factory.$TokenizedWalledLoaderFactory.getCardLoaderMessage(this.models.tokenizedWalletInfoModel);
            this.logoClass = this.models.tokenizedWalletInfoModel.getSubject();
        }
    }
});

angular.value("$xoTokenizedWalletLoader", $xoTokenizedWalletLoader);
_squid.$Component;

_squid.$meta;

_logger.$logger;

_angular.$timeout;

_angular.$rootScope;

_angular.noop;

_auth.$AuthModel;

_app.$TokenizedWalletInfoModel;

_factory.$TokenizedWalledLoaderFactory;

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$TokenizedWalledLoaderFactory', function () {
    var goToTokenizationInfoPage = function goToTokenizationInfoPage() {
        _logger.$logger.info('tokenized_wallet', {
            'from': 'PP_AndroidPay_Info',
            'to': 'prepare_PP_AndroidPay_Info',
            'context_id': _angular.$rootScope.token,
            'context_type': 'EC-Token',
            'billing_token': _squid.$meta.baToken
        });
        $('#outerWrapper').addClass('tokenization');
        _uiRouter.$state.go('checkout.tokenizationInfo');
    };

    var getCardLoaderMessage = function getCardLoaderMessage(tokenizedWalletInfoModel) {
        return (0, _squid.$renderContent)('topup.commonAdding', {
            type: tokenizedWalletInfoModel.brandName()
        }).toString();
    };

    return {
        goToTokenizationInfoPage: goToTokenizationInfoPage,
        getCardLoaderMessage: getCardLoaderMessage
    };
});

_uiRouter.$state;

_angular.$rootScope;

_squid.$meta;

_squid.$renderContent;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-login/tokenized-wallet-loader", "pages/xo-login/tokenized-wallet-loader/factory.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"infoLoader\">\n    <div class='logo_wrapper'>\n        <div class='partner_logo' ng-class=\"[logoClass]\"></div>\n    </div>\n    <div class=\"loader\">\n        <xo-card-loader\n            state=\"setbuyerProgress\"\n            auth=\"auth\"\n            message=\"{{cardLoaderMessage}}\"\n        ></xo-card-loader>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-login/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$capeRedirectUtil', function () {
    return {
        handleCapeRouting: function handleCapeRouting(checkoutSession, checkoutCart, token) {
            var checkoutAppData = _checkout.$CheckoutAppDataModel.instance(token);
            var checkoutCartModel = _checkout.$CheckoutCartModel.instance(token);
            var checkoutPayeeModel = _checkout.$CheckoutPayeeModel.instance(token);
            var creditDataModel = _credit.$CreditDataModel.instance(token);
            var selectedInstallmentModel = _credit.$CreditInstallmentModel.instance(token); // Only tracks selected financing option
            var merchantCountry = checkoutAppData.get('merchant.merchant_country');

            (0, _angular.$q)(function (resolve, reject) {
                if (checkoutAppData.isSecondButton()) {

                    _angular.$q.all([(0, _squid.$elmo)('xo_us_ppc_ezp', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': checkoutPayeeModel.getId()
                    }, 'Trmt_xo_us_ppc_.*', false, true)]).then(function (_ref) {
                        var ppcEZPRes = _ref[0];

                        resolve({ ppcEZPRes: ppcEZPRes });
                    })['catch'](function (err) {
                        reject(err);
                    });
                } else {
                    resolve();
                }
            }).then(function (_ref2) {
                var ppcEZPRes = _ref2.ppcEZPRes;

                var fundingInstruments = void 0;
                var isCreditInWallet = void 0;

                var redirectToCape = merchantCountry === 'GB';
                var redirectToCapeCyco = redirectToCape || ppcEZPRes;
                var ppcEZPTreatment = ppcEZPRes && ppcEZPRes.treatment_name;

                _logger.$logger.info('checkout_fpti', {
                    'xo_us_ppc_ezp': ppcEZPTreatment ? ppcEZPTreatment : 'Ctrl_xo_us_ppc_cape_cyco'
                });

                if (checkoutCart.isBillingNoPurchase()) {
                    fundingInstruments = checkoutSession.futurePaymentInstruments;
                    isCreditInWallet = checkoutSession.futurePayment && checkoutSession.futurePayment.isCreditInWallet;
                } else {
                    fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
                    isCreditInWallet = fundingInstruments && _squid.$util.find(fundingInstruments, function (fi) {
                        return fi.name === 'BILL_ME_LATER';
                    });
                }

                var isCapeReturnKey = creditDataModel.getCapeKey();
                var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');
                var isPPCEligible = checkoutSession.creditOffer;

                if (_squid.$locale.country !== checkoutAppData.get('merchant.merchant_country')) {
                    creditDataModel.setCrossBorder(true);
                }

                function handleRedirect(hasInstallmentOptions, hasThreeMonthInstallment) {
                    // User does not have any FI in wallet but they choose to pay in full.
                    // Show add card contingency page instead of redirecting to CAPE.
                    if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {
                        return _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                    }

                    // Handle return from CAPE
                    else if (isCapeReturn || creditDataModel.payInFull) {
                            return _uiRouter.$state.go('checkout.review');
                        }

                        // CYCO and Login swap
                        else if (!redirectToCapeCyco && checkoutAppData.isSecondButton() && hasInstallmentOptions && !hasThreeMonthInstallment) {
                                // Redirect to CYCO for reuse & acq 2nd button
                                return _uiRouter.$state.go('checkout.chooseCreditOffer');
                            }

                            // CYCO and Login swap
                            else if (checkoutAppData.isSecondButton() && hasInstallmentOptions) {
                                    // Redirect to CYCO for reuse & acq 2nd button with installments
                                    if (!redirectToCapeCyco && !hasThreeMonthInstallment) {
                                        _logger.$logger.info('redirecting_to_cyco_2nd_button');
                                        return _uiRouter.$state.go('checkout.chooseCreditOffer');
                                    } else if (isCreditInWallet && !redirectToCapeCyco && hasThreeMonthInstallment) {
                                        _logger.$logger.info('redirecting_to_review_reuse_2nd_button');
                                        return _uiRouter.$state.go('checkout.review');
                                    } else {
                                        var showCapeCyco = Boolean(redirectToCapeCyco);

                                        _logger.$logger.info('redirecting_to_cape_cyco_2nd_button', {
                                            showCapeCyco: showCapeCyco,
                                            hasThreeMonthInstallment: hasThreeMonthInstallment
                                        });

                                        return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: showCapeCyco });
                                    }
                                }

                                // Reuse scenario
                                else if (isCreditInWallet) {
                                        _logger.$logger.info('redirecting_to_review_reuse_2nd_button');
                                        return _uiRouter.$state.go('checkout.review');
                                    }

                                    // Acquisition scenario
                                    else if (isPPCEligible) {
                                            var _showCapeCyco = Boolean(redirectToCapeCyco) && hasInstallmentOptions;

                                            _logger.$logger.info('redirecting_to_cape_acq_2nd_button', {
                                                showCapeCyco: _showCapeCyco,
                                                hasThreeMonthInstallment: hasThreeMonthInstallment,
                                                hasInstallmentOptions: hasInstallmentOptions
                                            });

                                            return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: _showCapeCyco });
                                        } else {
                                            // show error message
                                            return _uiRouter.$state.go('checkout.review');
                                        }
                }

                // 2nd button, cross border, installment offer selected in API -- we cannot honor any offer the user chose, so must clear offer
                if (checkoutAppData.isSecondButton() && creditDataModel.isCrossBorder() && selectedInstallmentModel.get('meta.populated')) {
                    selectedInstallmentModel.action('delete', {
                        success: function success(result) {
                            _logger.$logger.info('patch_cart_installment_success');
                            _credit.$CreditInstallmentModel.create(token); // Clear cache for this token
                            handleRedirect(false, false);
                        },
                        error: function error(err) {
                            _logger.$logger.error('patch_cart_installment_fail', err);
                            _uiRouter.$state.go('checkout.genericError', {
                                code: 'DELETE_CREDIT_OPTION_ERROR'
                            });
                        }
                    });
                } else {
                    var offers = new _credit.$CreditInstallmentOptionsModel({
                        id: token,
                        payee: checkoutPayeeModel,
                        checkoutCart: checkoutCartModel,
                        checkoutAppData: checkoutAppData,
                        isMemberCredit: true
                    });

                    return offers.save({
                        cache: true,
                        success: function success(result) {
                            var hasInstallmentOptions = offers.getInstallmentOptionsPresent();
                            var installmentOfferDetails = offers.getInstallmentOffers();

                            installmentOfferDetails = installmentOfferDetails && installmentOfferDetails.installment_options;

                            var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                            var installmentOfferDetailsArray = installmentOfferDetails ? installmentOfferDetails.map(function (item) {
                                return item.financingCode;
                            }) : [];
                            var hasThreeMonthInstallment = Boolean(installmentOfferDetailsArray.filter(function (value) {
                                return threeMonthFinancingCodeArray.includes(value);
                            }).length > 0);

                            handleRedirect(hasInstallmentOptions, hasThreeMonthInstallment);
                        }
                    });
                }
            });
        }
    };
});

_angular.$q;

_squid.$util;

_squid.$locale;

_squid.$elmo;

_squid.$feature;

_uiRouter.$state;

_logger.$logger;

_credit.$CreditDataModel;

_credit.$CreditInstallmentModel;

_credit.$CreditInstallmentOptionsModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-login", "pages/xo-login/util.js"))

/***/ }),

/***/ "./pages/xo-nbr/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _template = __webpack_require__("./pages/xo-nbr/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-nbr/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoNbrDEPageDirective', {
    tag: 'xo-nbr-page',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            var token = this.props.token;


            if (token) {
                return {
                    checkoutSession: _index.$CheckoutSessionModel.instance(token).retrieve({
                        contingencies: {
                            NEGATIVE_BALANCE_RECOVERY: _angular.noop,
                            EXPIRED_CREDIT_CARD: _angular.noop
                        }
                    })['catch'](_angular.noop),
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(token).retrieve()['catch'](_angular.noop),
                    checkoutCart: _index.$CheckoutCartModel.instance(token).retrieve()['catch'](_angular.noop)
                };
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var self = this,
                configUrls = _squid.$config.urls;

            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
            (0, _jquery2['default'])('.footerWrapper').addClass('nbr');

            // this is only used by DE
            self.nbrUrl = configUrls.nbrUrl;

            // only invoked via DE view
            self.meft = function (evt) {
                evt.preventDefault();
                // forward to negative legacy balance collection flow
                _squid.$util.redirect(configUrls.nbrUrl);
            };

            self.resume = function (evt) {
                var models = self.models;

                evt.preventDefault();

                // throw original contingency
                if (models.checkoutSession.origContName) {
                    throw new _squid.$Contingency(models.checkoutSession.origContName);
                }

                // consider CAPE scenario first
                var isPayPalCredit = models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';
                if (isPayPalCredit) {
                    _util.$capeRedirectUtil.handleCapeRouting(models.checkoutSession, models.checkoutCart, self.props.token);
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            };
        },
        exit: function exit() {
            (0, _jquery2['default'])('.paypalHeaderWrapper').show();
            (0, _jquery2['default'])('.footerWrapper').removeClass('nbr');
        },
        populate: function populate() {
            var tokenHash,
                self = this,
                checkoutSession = self.models.checkoutSession,
                negBals = checkoutSession.negBals,
                plan = checkoutSession.plan.sources && checkoutSession.plan.sources[0],
                bodyContentKey = 'nbr.body',
                preBankBtnKey = 'nbr.preBankBtn',
                prePayBtnKey = 'nbr.prePayBtn';

            if (negBals && negBals[0]) {
                tokenHash = {
                    neg_bal: (0, _squid.formatCurrency)(negBals[0] && negBals[0].amount, negBals[0].currency_code, false),
                    amt: plan && plan.amount && (0, _squid.formatCurrency)(plan.amount.amount, plan.amount.currency_code, false)
                };
            }

            if (negBals && negBals.length > 1) {
                bodyContentKey += 'Plural';
                preBankBtnKey += 'Plural';
                tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
            }

            if (!plan) {
                prePayBtnKey += 'NoAmt';
            }

            self.bodyContentKey = bodyContentKey;
            self.tokenHash = tokenHash;
            self.isDE = _squid.$locale.metadata.country === 'DE';
            self.prePayBtnKey = prePayBtnKey;
            self.preBankBtnKey = preBankBtnKey;
        }
    }
});


_uiRouter.$state;

_angular.noop;

_squid.formatCurrency;

_squid.$Component;

_squid.$locale;

_squid.$util;

_squid.$config;

_squid.$Contingency;

_squid.$Class;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_util.$capeRedirectUtil;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-nbr/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoNbrDEPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-nbr/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoNbrDEPageRoute = exports.$xoNbrDEPageRoute = _index.$Route.extend('$xoNbrDEPageRoute', {

    path: 'negativeBalanceRecovery',
    directive: _directive2['default'],
    // titleContent: 'nbr.title',

    // trackingData: {
    //     fptiState: 'econsent',
    //     templateName: 'eConsent.dust',
    //     pageGoal: 'eConsent',
    //     buzname: {
    //         'fullpage': {
    //             'pagename': '%::fullpage-econsent',
    //             'pagename2': '%::fullpage-econsent:member:hermes:',
    //             'version': 'member:%:'
    //         }
    //         // More page qualifiers come here...
    //     }
    // },

    children: []
});

angular.value("$xoNbrDEPageRoute", $xoNbrDEPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-nbr/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-nbr/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"nbr\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n        <div class=\"title\">\n            {{ content('nbr.title') }}\n        </div>\n        <div class=\"message\" ng-bind-html=\"content(bodyContentKey, tokenHash)\"></div>\n        <div ng-if=\"isDE\" class=\"actions message\">\n            <p class=\"bold\" ng-bind-html=\"content(prePayBtnKey, tokenHash)\"></p>\n            <button ng-click=\"resume($event)\" class=\"btn full\">\n                {{ content('nbr.payBtn') }}\n            </button>\n            <p class=\"small\">\n                {{ content('nbr.postPayBtn') }}\n            </p>\n            <p class=\"bold\" ng-bind-html=\"content(preBankBtnKey, tokenHash)\"></p>\n            <a href=\"{{nbrUrl}}\" ng-click=\"meft($event)\" class=\"btn full btn-secondary\">\n                {{ content('nbr.bankBtn') }}\n            </a>\n            <p class=\"small\">\n                {{ content('nbr.postBankBtn') }}\n            </p>\n        </div>\n        <p class=\"btn-spaced\" ng-if=\"!isDE\">\n            <button ng-click=\"resume($event)\" class=\"btn full\">\n                {{ content('nbr.payBtn') }}\n            </button>\n        </p>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-pay-with-selection/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPayWithSelectionPageComponent = undefined;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("./js/lib/index.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

var _loginEligibility = __webpack_require__("./pages/xo-login/loginEligibility.js");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("./pages/xo-login/onboarding/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/unified-login/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/handler/directive.js");

var _template = __webpack_require__("./pages/xo-pay-with-selection/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-pay-with-selection/style.less");

var _metricLogger = __webpack_require__("./js/lib/metricLogger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPayWithSelectionPageComponent = exports.$xoPayWithSelectionPageComponent = _squid.$Component.extend('$xoPayWithSelectionPageComponent', {
    tag: 'xo-pay-with-selection-page',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    link: function link() {
        _logger.$logger.info('login_link');
    },
    lifecycle: {
        enter: function enter() {
            (0, _jquery2['default'])('#contents').addClass('payWithSelection');
        },
        populate: function populate() {
            var $scope = this;

            (0, _squid.$populate)($scope, {
                flowEligibility: _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                }),
                venmoEligibility: _venmoModels.$VenmoTransactionEligibility.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                        braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                        fundingSource: _squid.$util.param('fundingSource'),
                        venmoOverride: _squid.$util.param('venmoOverride'),
                        native_xo: _squid.$util.param('native_xo')
                    }
                })
            });
        }
    },
    rootEvents: {
        allLoaded: function allLoaded() {
            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    if (window.xchild) {
                        var isWebView = window.paypal && window.paypal.isWebView && window.paypal.isWebView();

                        if (!isWebView) {
                            _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
                        }
                    } else {
                        return _index.$miniBrowser.frameBust(this.props.token);
                    }
                } else {
                    throw _integration.$integration.error('Can not framebust');
                }
            }
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('xoPayWithSelection_controller');
        $scope.ulEligibility = false;
        $scope.useTokenizationAnimation = false;
        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
         is attempting to navigate to a specific page, so we should not auto-redirect them.
          This also fixes an issue with users:
         - Authorizing the checkout session
         - Redirecting to the merchant
         - Hitting back and landing on login page
         - Calling create on checkout and overwriting the authorization
         - Hitting forward and landing again on merchant page
         */
        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
            _angular.$rootScope.forceLogin = true;
        }

        if (!_angular.$rootScope.forceLogin) {
            $scope.autoLogin = true;
        }

        _angular.$rootScope.forceLogin = true;

        $scope.hideGuest = _uiRouter.$stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || _uiRouter.$stateParams.showNotYou;
        $scope.promptlogin = $scope.hideGuest && !(0, _squid.$feature)('riskyLoginContingency');

        // log statement for mobile webview
        if (_index2.$DeviceInfo.isApp()) {
            _logger.$logger.debug('HERMES_IN_MOBILE_WEBVIEW');
        }

        if (!_index.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
            var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_login_design;

            (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern, false, true).then(function (result) {
                $scope.loginDesignExp = result;
            });
        }

        var ROUTE_MAPPING = {
            ECONSENT_REQUIRED: 'checkout.econsent'
        };

        $scope.onContingency = function (name, contingency) {
            if (!ROUTE_MAPPING[name]) {
                throw new _squid.$FallbackError({
                    reason: name.toLowerCase(),
                    product: 'ux'
                });
            }
            _uiRouter.$state.go(ROUTE_MAPPING[name]);
        };

        $scope.checkoutSession = _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token);
        $scope.eConsent = _user.$EConsentModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletEligibility = _app.$TokenizedWalletEligibilityModel.instance(_angular.$rootScope.token);
        $scope.userProductSubscription = _index3.$UserProductSubscriptionModel.instance();
        $scope.dependencyEligibility = true;

        $scope.setBuyer = function () {
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            function handleContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                fptiData.int_error_code = err.cause;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);
                throw err;
            }

            function handleNoValidTopupFiContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                if ($scope.checkoutCart.isWalletTokenization()) {
                    $scope.checkoutSession.contingency = name;
                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    handleContingency(name, err);
                }
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'CREATE_XO_SESSION',
                to: 'prepare_create_xo_session'
            });

            $scope.useTokenizationAnimation = $scope.checkoutCart.isWalletTokenization();
            var walletTokenization = $scope.checkoutCart.isWalletTokenization();

            if ($scope.useTokenizationAnimation) {
                _angular.$rootScope.$emit('allLoaded');

                $scope.setbuyerProgress = 'notStarted';
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'adding_pp_ap_animation',
                    'to': 'prepare_adding_pp_ap_animation',
                    'context_id': _angular.$rootScope.token,
                    'context_type': 'EC-Token',
                    'billing_token': _squid.$meta.baToken
                });

                (0, _angular.$timeout)(function () {
                    $scope.setbuyerProgress = 'pending'; // sets animation state to 80%
                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'adding_pp_ap_animation',
                        'to': 'process_adding_pp_ap_animation',
                        'context_id': _angular.$rootScope.token,
                        'context_type': 'EC-Token',
                        'billing_token': _squid.$meta.baToken
                    });
                }, 300);
            }

            $scope.eConsent.reload({
                batch: {
                    name: 'setbuyer',
                    silent: $scope.useTokenizationAnimation,
                    id: 'eConsent',
                    dependencies: []
                },
                contingencies: {
                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
                        if ($scope.dependencyEligibility) {
                            $scope.dependencyEligibility = false;
                            _logger.$logger.debug('ULLOGIN_ECONSENT_REQUIRED');
                            _uiRouter.$state.go('checkout.econsent');
                        }
                    }
                }
            });

            if (walletTokenization) {
                var params = {
                    wallet_brand: 'APAY',
                    tenant_id: 'Hermes'
                };
                if (_squid.$meta.query && _squid.$meta.query.wallet_id) {
                    params.wallet_id = _squid.$meta.query.wallet_id;
                }
                if (_squid.$meta.query && _squid.$meta.query.jwt) {
                    params.jwt = _squid.$meta.query.jwt;
                }

                $scope.tokenizedWalletEligibility.reload({
                    params: params,
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletLightEligibility',
                        silent: $scope.useTokenizationAnimation,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';
                            _logger.$logger.info(msg);

                            if ($scope.dependencyEligibility) {
                                $scope.dependencyEligibility = false;
                                _uiRouter.$state.go('checkout.genericError', {
                                    code: 'ANDROID_PAY_ELIGIBILITY_ERROR'
                                });
                            }
                        }
                    }
                });

                // check we have product provision subscribed by buyer
                // if not subscribed redirect to splash screen of subscription upsell
                $scope.userProductSubscription.retrieve({
                    batch: {
                        name: 'setbuyer',
                        id: 'userProductSubscription',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent', 'tokenizedWalletLightEligibility']
                    },

                    success: function success(result) {
                        // result is going to an object of { applicable: true, subscribed: true, reason: 'PAYPAL_CASH' }
                        if (result.applicable && !result.subscribed) {
                            _logger.$logger.info('pws_product_subscription_enabled_not_subscribed');
                            $scope.dependencyEligibility = false;
                            _uiRouter.$state.go('checkout.cipverification');
                        }
                    }
                });
            }

            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            $scope.checkoutSession.action('create', {
                data: {
                    baToken: $scope.checkoutCart.billing && $scope.checkoutCart.billing.ba_token,
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined
                },
                batch: {
                    name: 'setbuyer',
                    id: 'createCheckoutSession',
                    silent: $scope.useTokenizationAnimation,
                    dependencies: walletTokenization ? ['eConsent', 'tokenizedWalletLightEligibility', 'userProductSubscription'] : ['eConsent']
                },
                success: function success(result) {
                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';

                    _logger.$logger.info('checkout_fpti', fptiData);

                    if (!$scope.dependencyEligibility) {
                        return;
                    }

                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        if ((0, _squid.$feature)('pomaPasswordRecovery')) {
                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
                        }
                        return;
                    }

                    if (isPayPalCredit) {
                        return _util.$capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, _angular.$rootScope.token);
                    }

                    return _kmliUpsell.$KmliUpsell.eligible(_angular.$rootScope.token).then(function (isEligible) {
                        if (isEligible.eligible) {
                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';

                            _logger.$logger.info('checkout_fpti', {
                                from: stateName,
                                to: 'prepare_kmli_upsell'
                            });

                            var path = _index2.$DeviceInfo.isMobile() ? 'checkout.FullpageOnetouchUpsell' : 'checkout.review.oneTouchUpsell';

                            return _uiRouter.$state.go(path, { oneTouchFlowName: 'checkout' });
                        }

                        if ($scope.auth.rtExchanged && (0, _squid.$feature)('rmSpinnerText')) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['login.loggedInWithOneTouch']
                            };
                        }

                        if ($scope.checkoutSession.negBals) {
                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                        }

                        if ($scope.checkoutCart.isWalletTokenization()) {
                            _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                        } else {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                },
                contingencies: {
                    // override contingency.js handler with custom logic to support both xoon/hermes flows
                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, err) {
                        // Check if negative case has been previously handled.
                        if (!$scope.dependencyEligibility) {
                            return;
                        }
                        // come from guest or have alternate FI options, go to review
                        if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
                            _uiRouter.$state.go('checkout.review');
                        } else {
                            // else go to addCard
                            _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
                        }
                    },
                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    DEFAULT: handleContingency
                }
            });
        };

        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
        $scope.preAuth = function () {
            // For UL, batch up eConsent, xoSession
            if ($scope.ulEligibility) {
                $scope.setBuyer();
            }
        };

        $scope.onSuccess = function () {
            _logger.$logger.info('checkout_fpti', {
                'from': 'CHOOSE_PAYMENT_METHOD',
                'to': 'process_continue_with_paypal'
            });

            // Once users are successfully authenticated, route them to checkout lite
            $scope.sendToCheckoutLite();
        };

        function fetchGuestButtonPxpVarients() {
            $scope.guestVariant = {};
            // PXP for showing Guest button Call-To-Actions
            return (0, _squid.$pxp)('xo_hermesnode_guest_cta', {
                'ctx.COUNTRY': _squid.$locale.country
            }, '(xo_hermesnode_guest_cta_)(.*)', false, true).then(function (result) {
                var treatmentName = result && result.treatment_name || '';

                switch (treatmentName) {
                    case 'xo_hermesnode_guest_cta_standard_label_treatment':
                        $scope.guestVariant.standardGuestBtn = true;
                        $scope.guestVariant.test = true;
                        break;
                    case 'xo_hermesnode_guest_cta_card_icons_treatment':
                        $scope.guestVariant.cardIconsAboveGuestBtn = true;
                        $scope.guestVariant.test = true;
                        break;
                    default:
                    // Do nothing
                }
            });
        }

        (0, _squid.$populate)($scope, {
            flowEligibility: _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    geolocation: _squid.$meta.geolocation,
                    localeCountry: _squid.$locale.country
                }
            }),
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token),
            venmoEligibility: _venmoModels.$VenmoTransactionEligibility.instance(_angular.$rootScope.token).retrieve({
                params: {
                    localeCountry: _squid.$locale.country,
                    braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                    fundingSource: _squid.$util.param('fundingSource')
                }
            })
        }).then(function () {
            if ($scope.flowEligibility.guest) {
                return fetchGuestButtonPxpVarients();
            }
            (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
            (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
        }).then(function () {
            $scope.expandPaypalDrawer = false;
            $scope.expandVenmoDrawer = false;
            $scope.expandBaiduDrawer = false;
            $scope.hideLoginHandlerTitle = true;

            $scope.clickPaypalDrawer = function () {
                $scope.expandPaypalDrawer = !$scope.expandPaypalDrawer;

                // if drawer expanded, we track it.
                if ($scope.expandPaypalDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_paypal_drawer'
                    });
                }

                // if Venmo is expanded, close it
                $scope.closeVenmoDrawer();
                $scope.closeBaiduDrawer();
                return $scope.expandPaypalDrawer;
            };

            $scope.clickVenmoDrawer = function () {
                $scope.expandVenmoDrawer = !$scope.expandVenmoDrawer;

                // if drawer expanded, we'll track it
                if ($scope.expandVenmoDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_venmo_drawer'
                    });
                }

                // if paypal is expanded, close it
                $scope.closePaypalDrawer();
                $scope.closeBaiduDrawer();
                return $scope.expandVenmoDrawer;
            };

            $scope.clickBaiduDrawer = function () {
                $scope.expandBaiduDrawer = !$scope.expandBaiduDrawer;

                if ($scope.expandBaiduDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_baidu_drawer'
                    });
                }

                // if other drawers expanded, close them
                $scope.closePaypalDrawer();
                $scope.closeVenmoDrawer();
                return $scope.expandBaiduDrawer;
            };

            $scope.closePaypalDrawer = function () {
                // if paypal is expanded, close it
                if ($scope.expandPaypalDrawer) {
                    $scope.expandPaypalDrawer = !$scope.expandPaypalDrawer;
                }
            };

            $scope.closeVenmoDrawer = function () {
                // if Venmo is expanded, close it
                if ($scope.expandVenmoDrawer) {
                    $scope.expandVenmoDrawer = !$scope.expandVenmoDrawer;
                }
            };

            $scope.closeBaiduDrawer = function () {
                // if other drawers expanded, close them
                if ($scope.expandBaiduDrawer) {
                    $scope.expandBaiduDrawer = !$scope.expandBaiduDrawer;
                }
            };

            (0, _metricLogger.metricCounter)('venmo_eligibility_xo_pay_with_selection', { eligibility: $scope.venmoEligibility.venmo });
            $scope.displayBaiduDrawer = $scope.flowEligibility.baiduWallet;
            $scope.displayVenmoDrawer = $scope.venmoEligibility.venmo;

            $scope.sendToVenmo = function () {
                (0, _thirdPartyInfo.redirect)(_thirdPartyInfo.thirdPartyInfo.buildVenmoURL());
            };

            $scope.sendToCheckoutLite = function () {
                var redirectXoLiteUrl = (0, _squid.$getRedirectUrl)('redirectXoLite', {
                    token: _angular.$rootScope.token
                });

                _logger.$logger.info('REDIRECT_TO_CHECKOUT_LITE', {
                    url: redirectXoLiteUrl
                });

                return _squid.$util.redirect(redirectXoLiteUrl);
            };

            $scope.proceedWithBaidu = function () {
                // if incontext, we'll resize and center to allow for the minimum size of the Baidu flow.
                if (window.xprops) {
                    var xPos = window.screen.width / 2 - 800 / 2;
                    var yPos = window.screen.height / 2 - 800 / 2;
                    window.resizeTo(800, 800);
                    window.moveTo(xPos, yPos);
                }
                _uiRouter.$state.go('checkout.thirdPartyWalletFlow');
            };

            if ($scope.displayBaiduDrawer && $scope.displayVenmoDrawer) {
                (0, _angular.$timeout)($scope.clickBaiduDrawer, 800);
            } else if ($scope.displayVenmoDrawer) {
                (0, _angular.$timeout)($scope.clickVenmoDrawer, 800);
            } else {
                (0, _angular.$timeout)($scope.clickBaiduDrawer, 800);
            }

            return (0, _loginEligibility.$loginEligibility)(_angular.$rootScope.token, !$scope.autoLogin).then(function (result) {
                if (result === 'unifiedLogin') {
                    $scope.ulEligibility = true;
                } else if (result === 'apsIntegration') {
                    $scope.apsIntegration = 'apsIntegration';
                } else if (result === 'apsIntegrationRM') {
                    $scope.apsIntegration = 'apsIntegrationRM';
                }
            }).then(function () {
                var reinitDisplay = function reinitDisplay() {
                    $scope.promptlogin = false;
                    $scope.hideGuest = false;
                    $scope.autoLogin = false;
                    delete _uiRouter.$stateParams.targetPage;
                    delete _uiRouter.$stateParams.showNotYou;
                };

                $scope.logout = $scope.promptlogin ? function () {
                    _logger.$logger.info('not_you_logout');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'LOGIN_UL',
                        to: 'login_with_diff_user'
                    });
                    $scope.auth.logout().then(function () {
                        $scope.auth.reload().then(function () {
                            reinitDisplay();
                            $scope.reload();
                        });
                    });
                } : function () {
                    _logger.$logger.info('logout_switch_display');
                    reinitDisplay();
                };
            });
        });
    }]
});

angular.value("$xoPayWithSelectionPageComponent", $xoPayWithSelectionPageComponent);
_angular.$rootScope;

_angular.$timeout;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$miniBrowser;

_integration.$integration;

_squid.$pxp;

_squid.$util;

_squid.$meta;

_squid.$Class;

_squid.$locale;

_squid.$config;

_squid.$feature;

_squid.$populate;

_squid.$Component;

_squid.$pxpFactors;

_squid.$FallbackError;

_squid.$getRedirectUrl;

_index2.$DeviceInfo;

_auth.$AuthModel;

_user.$EConsentModel;

_app.$TokenizedWalletEligibilityModel;

_venmoModels.$VenmoTransactionEligibility;

_thirdPartyInfo.redirect;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$FlowEligibilityModel;

_index3.$UserProductSubscriptionModel;

_thirdPartyInfo.thirdPartyInfo;

_util.$capeRedirectUtil;

_loginEligibility.$loginEligibility;

_factory.$TokenizedWalledLoaderFactory;

_kmliUpsell.$KmliUpsell;

_metricLogger.metricCounter;

/***/ }),

/***/ "./pages/xo-pay-with-selection/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PayWithSelectionRoute = undefined;

__webpack_require__("./pages/xo-pay-with-selection/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var $PayWithSelectionRoute = exports.$PayWithSelectionRoute = _squid.$ComponentRoute.extend('$PayWithSelectionRoute', {

    path: 'payWithSelection',

    directive: 'xo-pay-with-selection-page',

    params: {
        targetPage: null,
        source: null,
        showNotYou: null
    },

    resolve: {
        action: function action() {
            var fromState = _uiRouter.$state.fromState;

            var isBackButton = window.performance && window.performance.navigation && window.performance.navigation.type === 2;
            if (!isBackButton && fromState.name === 'checkout.login') {
                // reset force login if coming from login route
                _angular.$rootScope.forceLogin = false;
            }
        }
    },

    auth: false,

    titleContent: 'base.logIn',

    venmoHeaders: {
        venmoTabs: true
    },

    trackingData: {
        fptiState: 'choose_payment_method',
        templateName: 'login.dust',
        trackStateExit: false,
        pageGoal: 'Select a payment scheme',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-login',
                'pagename2': '%::fullpage-login:member:hermes:',
                'version': 'member:%:'
            },
            'ulLogin': {
                'pagename': '%::fullpage-ullogin',
                'pagename2': '%::fullpage-ullogin:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    children: []
});

angular.value("$PayWithSelectionRoute", $PayWithSelectionRoute);
_squid.$ComponentRoute;

_angular.$rootScope;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-pay-with-selection/style.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-pay-with-selection/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"payWithSelection\" ng-class=\"{standardGuestBtn: guestVariant.standardGuestBtn, guestBtnOnTop: guestVariant.guestBtnOnTop, cardIconsAboveGuestBtn: guestVariant.cardIconsAboveGuestBtn}\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\" id=\"selectPaymentMethodAccordion\">\n\n            <section id=\"paypalDrawer\" class=\"drawer\" ng-class=\"{hidden: !expandPaypalDrawer}\" ng-click=\"clickPaypalDrawer()\" content>\n                <xo-title title-txt=\"{{content('login.loginTitle')}}\" class=\"span17\"></xo-title>\n                <span class=\"arrow\" ng-class=\"{expand: expandPaypalDrawer }\"></span>\n\n                <xo-login-handler ng-click=\"$event.stopPropagation()\" ng-show=\"expandPaypalDrawer\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\"\n                                  contingency-callback=\"onContingency\" ul-eligibility=\"ulEligibility\" pre-auth=\"preAuth\"\n                                  aps-integration=\"apsIntegration\" batch=\"batch\"\n                                  login-submit=\"loginSubmit\" flowcontext=\"flowcontext\" logout=\"logout\" export=\"loginHandler\" hide-title=\"hideLoginHandlerTitle\"></xo-login-handler>\n                <xo-onboarding-section ng-show=\"expandPaypalDrawer\" ng-click=\"$event.stopPropagation()\" token=token ng-hide=\"hideGuest\"></xo-onboarding-section>\n            </section>\n\n            <section ng-if=\"displayVenmoDrawer\" id=\"venmoDrawer\" class=\"drawer\" ng-class=\"{hidden: !expandVenmoDrawer}\" ng-click=\"clickVenmoDrawer()\" content>\n                <xo-title title-txt=\"{{'Pay with '}}\" class=\"span17\"></xo-title>\n                <span class=\"venmoLogo\"></span>\n                <span class=\"arrow\" ng-class=\"{expand: expandVenmoDrawer, paypalExpanded: expandPaypalDrawer}\"></span>\n                <p ng-click=\"$event.stopPropagation()\" class=\"legal\" bind-html-compile=\"htmlContent('landing.venmoLegal')\"></p>\n                <a track-link=\"choose_venmo\" class=\"btn full venmoBtn\" link-button ng-click=\"sendToVenmo()\">{{content('landing.venmoButton')}}</a>\n            </section>\n\n            <section ng-if=\"displayBaiduDrawer\" id=\"baiduDrawer\" class=\"drawer\" ng-class=\"{hidden: !expandBaiduDrawer}\" ng-click=\"clickBaiduDrawer()\" content>\n                <xo-title title-txt=\"{{content('landing.payWithBaidu')}}\" class=\"span17\"></xo-title>\n                <span class=\"baiduLogo\"></span>\n                <span class=\"arrow\" ng-class=\"{expand: expandBaiduDrawer, paypalExpanded: expandPaypalDrawer}\"></span>\n                <p class=\"legal disclaimer\">{{content('landing.paypalBaiduDisclaimer')}}</p>\n                <p ng-click=\"$event.stopPropagation()\" class=\"legal\" ></p>\n                <a track-link=\"choose_baidu\" class=\"full baiduBtn\" link-button ng-click=\"proceedWithBaidu()\"></a>\n            </section>\n\n\n            <div ng-if=\"promptlogin\" class=\"centerText\">\n                <hr class=\"sepPlain\" />\n\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\" class=\"ng-binding\" tabindex=\"0\">{{ content('memberReview.notYou')}}</a>\n            </div>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\"\n                            text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content(loginDesignExp.propHeader)}}\"\n                            text-content=\"{{loginDesignExp.propText}}\"\n                            image-url=\"{{loginDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"infoLoader\"  ng-if='useTokenizationAnimation'>\n        <div class='logo_wrapper'>\n            <div class='partner_logo'></div>\n        </div>\n        <div class=\"loader\">\n            <xo-card-loader state=\"setbuyerProgress\" auth=\"auth\" message=\"{{content('topup.addingAndroidPay')}}\"></xo-card-loader>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-pay/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _route = __webpack_require__("./pages/xo-pay/route.js");

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});

/***/ }),

/***/ "./pages/xo-pay/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PayRoute = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _inventory = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _shoppingcart = __webpack_require__("../node_modules/xo-models/src/shoppingcart/index.js");

var _util = __webpack_require__("./js/lib/util.js");

/**
 * PayRoute
 * - Responsible for making the payment call and handling contingencies if any.
 */

var $PayRoute = exports.$PayRoute = _squid.$ComponentRoute.extend('PayRoute', {

    path: 'pay',

    trackingData: {
        fptiState: 'make_payment',
        trackStateExit: true
    },

    resolve: {
        action: function action() {

            var token = _angular.$rootScope.token;
            var models = {};

            var getMerchantPreferences = function getMerchantPreferences() {
                if ((0, _util.isConfigForMerchantPreferencesEnabled)()) {
                    // App Data will itself contains the necessary fields
                    return;
                } else {
                    return (0, _squid.$populate)(models, {
                        pref: _profilemanagement.$MerchantPreferenceModel.instance(models.payee.merchant.id)
                    });
                }
            };

            var markCartCheckedout = function markCartCheckedout() {

                var enabled = _squid.$config.enableShoppingCartWPS && models.checkoutAppData.flags.is_shopping_cart_flow;

                if (!enabled) {
                    return _angular.$q.when();
                }

                var shoppingCartModel = _shoppingcart.$ShoppingCartModel.instance(token);

                return shoppingCartModel.action('cartCheckedOut', {
                    data: {
                        payee_email: models.checkoutAppData.get('merchant.merchant_email')
                    },
                    success: function success(result) {
                        _logger.$logger.info('CART_CHECKED_OUT');
                    }
                });
            };

            var manageInventory = function manageInventory(paymentStatus) {
                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (!cartHasInventory) {
                    return _angular.$q.when();
                }

                var inventoryModel = _inventory.$InventoryModel.instance(token);

                var inventoryItems = inventoryModel.getInventoryItems();

                paymentStatus = paymentStatus ? paymentStatus : 'success';

                var inventoryPatchInput = {
                    inventoryItems: inventoryItems,
                    cartItems: models.checkoutCart.get('purchaseUnits')[0].item_list.items,
                    merchantId: models.payee.get('merchant.id', ''),
                    paymentStatus: paymentStatus
                };

                return inventoryModel.action('patchInventory', {
                    data: inventoryPatchInput,
                    success: function success(patchResponse) {
                        if (patchResponse && patchResponse.showSoldoutPage) {
                            // show soldout page
                            return _angular.$q.when({
                                soldoutpage: true,
                                items: encodeURIComponent(patchResponse.soldoutItems),
                                soldoutUrl: encodeURIComponent(patchResponse.soldoutUrl)
                            });
                        } else if (patchResponse && patchResponse.patchCart) {
                            // patch cart with updated inventory
                            var purchase_unit = models.checkoutCart.get('purchaseUnits')[0];

                            purchase_unit.item_list.items = patchResponse.cartItems;

                            var patchCartPayload = {
                                id: token,
                                patchEntities: [{
                                    field: 'inventoryItems',
                                    value: purchase_unit.item_list.items
                                }]
                            };

                            return models.checkoutCart.action('patchCartData', {
                                data: patchCartPayload
                            });
                        }
                        return _angular.$q.when();
                    }
                });
            };

            var showSoldOutPage = function showSoldOutPage(soldOutData) {
                return _angular.$q.when({
                    to: 'checkout.soldout',
                    params: {
                        items: soldOutData.items,
                        soldOutUrl: soldOutData.soldoutUrl
                    }
                });
            };

            var showGenericError = function showGenericError(code) {
                return function () {
                    var encoded = code ? window.btoa(code) : code;

                    manageInventory('failed');
                    return _uiRouter.$state.go('checkout.genericError', { code: encoded });
                };
            };

            var makePayment = function makePayment() {

                var xclickParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);

                return models.checkoutSession.action('createPayment', {
                    data: {
                        payer_id: models.checkoutSession.payer.id,
                        intent: models.checkoutCart.payment_action,
                        wa_type: xclickParams && xclickParams.wa_type,
                        correlation_id: _squid.$meta.correlationId,
                        merchant_id: models.payee.get('merchant.id'),
                        custom: models.checkoutCart.get('purchase.custom'),
                        invoice: models.checkoutCart.get('purchase.invoice')
                    },

                    success: function success(result) {
                        // flag used in other directives
                        _angular.$rootScope.paymentComplete = true;
                        // fire and forget
                        markCartCheckedout();
                        return 'success';
                    },

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                        DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE'),
                        COMPLIANCE_VIOLATION: showGenericError('COMPLIANCE_VIOLATION'),
                        DUPLICATE_INVOICE_ID: showGenericError('DUPLICATE_INVOICE_ID'),
                        CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED() {
                            manageInventory('failed');

                            // call createCheckout again and throw processor decline error which will be handled in
                            // xo-review
                            return models.checkoutSession.action('create', {
                                success: function success(result) {
                                    return _angular.$q.reject('CC_PROCESSOR_DECLINED');
                                }
                            });
                        },
                        DEFAULT: function DEFAULT(name, err) {
                            manageInventory('failed');
                            throw err;
                        }
                    }
                });
            };

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(token),
                checkoutCart: _index.$CheckoutCartModel.instance(token),
                checkoutSession: _index.$CheckoutSessionModel.instance(token),
                payee: _index.$CheckoutPayeeModel.instance(token)
            }).then(function () {
                // Check if inventory is available
                return manageInventory();
            }).then(function (inventoryStatus) {
                // Show Sold Out Page if inventory unavailable
                if (inventoryStatus && inventoryStatus.soldoutpage) {
                    return showSoldOutPage(inventoryStatus);
                }
                // Make Payment
                return _angular.$q.all([getMerchantPreferences(), // Load the preferences here so its cached for later use in the done page
                makePayment()]).then(function () {
                    if (_angular.$rootScope.paymentComplete) {
                        if (_integration.$integration.getConfig('DONE_PAGE')) {
                            // Show Done Page [ Payment Confirmation ]
                            return 'checkout.done';
                        }
                        // default end state
                        return 'checkout.end';
                    }
                })['catch'](function (error) {
                    _logger.$logger.info('XO_PAY_ERROR', { error: error });
                    return 'checkout.review';
                });
            });
        }
    }
});

angular.value("$PayRoute", $PayRoute);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_uiRouter.$state;

_squid.$ComponentRoute;

_squid.$config;

_squid.$meta;

_squid.$populate;

_squid.$util;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_inventory.$InventoryModel;

_profilemanagement.$MerchantPreferenceModel;

_shoppingcart.$ShoppingCartModel;

_util.isConfigForMerchantPreferencesEnabled;

/***/ }),

/***/ "./pages/xo-pin-setup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/app/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/mobile-pin/directive.js");

var _template = __webpack_require__("./pages/xo-pin-setup/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-pin-setup/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPinSetupPageDirective', {
    tag: 'xo-pin-setup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('tokenized_wallet', {
                'from': 'PINSETUP',
                'to': 'PREPARE_PINSETUP'
            });
        }
    },
    controller: ['$scope', function ($scope) {
        var currentPin = '';

        $scope.madeAttempt = false;
        $scope.pinError = '';
        $scope.pinChanged = false;

        function done(pinValue) {
            _index.$TokenizedWalletPinModel.instance(_angular.$rootScope.token).retrieve().then(function (WalletPinModel) {
                WalletPinModel.userPin = pinValue;
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'PINSETUP',
                    'to': 'PROCESS_PINSETUP'
                });
                (0, _angular.$timeout)(function () {
                    return _uiRouter.$state.go('checkout.review');
                }, 1500);
            });
        }

        $scope.pinComplete = function (result) {
            var value = result && result.value;

            if (result && result.error === 'pin_too_simple') {
                $scope.pinError = 'toEasy';
                $scope.madeAttempt = false;
                currentPin = '';
                $scope.$broadcast('resetPin');
                return;
            }

            $scope.pinChanged = $scope.madeAttempt && currentPin === value;
            $scope.pinError = $scope.madeAttempt && !$scope.pinChanged ? 'missMatch' : '';
            currentPin = $scope.madeAttempt ? '' : value; // reset old pin if already made an attempt
            $scope.madeAttempt = !$scope.madeAttempt; // flip flag

            if (!$scope.pinChanged) {
                $scope.$broadcast('resetPin');
            } else {
                done(value);
            }
        };
    }]
});


_uiRouter.$state;

_squid.$Component;

_angular.$rootScope;

_angular.$timeout;

_logger.$logger;

_index.$TokenizedWalletPinModel;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-pin-setup/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoPinSetupPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-pin-setup/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPinSetupPageRoute = exports.$xoPinSetupPageRoute = _index.$Route.extend('$xoPinSetupPageRoute', {
    path: 'pinSetup',
    directive: _directive2['default'],
    titleContent: 'Wallet Pin Setup',
    trackingData: {
        fptiState: 'pinSetup'
    },

    children: []
});

angular.value("$xoPinSetupPageRoute", $xoPinSetupPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-pin-setup/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-pin-setup/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"pinSetup\" modal-box content>\n    <div class=\"pinError\" ng-if=\"pinError\">\n        <div class=\"errorIcon\"></div>\n        <div class=\"errorText\">\n            <span ng-if=\"pinError==='missMatch'\">{{content('review.pinMissMatch')}}</span>\n            <span ng-if=\"pinError==='toEasy'\">{{content('review.pinEasy')}}</span>\n        </div>\n    </div>\n    <div class=\"content\">\n        <div class=\"pinUpdate\" ng-if=\"!pinChanged\">\n            <xo-mobile-pin done=\"pinComplete\"></xo-mobile-pin>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && !madeAttempt\">{{content('review.pinFirstEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && madeAttempt\">{{content('review.pinSecondEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"pinMissMatch\">{{content('review.pinBadEntry')}}</div>\n            <div class=\"secondarySubtext\">{{content('review.pinSubText')}}</div>\n        </div>\n        <div class=\"pinSuccess\" ng-if=\"pinChanged\">\n            <div class=\"successGif\"></div>\n            <div class=\"successText\">{{content('review.pinChanged')}}</div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-review/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var FptiEventType = exports.FptiEventType = {
    Impression: 'im', // User saw something
    Click: 'cl', // User interacted with something (either by clicking/tapping)
    Available: 'av', // Something loaded on the screen. This is not the same as impression as something could load.
    Activity: 'ac' // Catch-all event for events happening to the user. This is usually reserved for silent decisions, rerouting, toasts, etc.
};

/***/ }),

/***/ "./pages/xo-review/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoReviewPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _sanitizeCaja = __webpack_require__("../node_modules/sanitize-caja/index.js");

var _sanitizeCaja2 = _interopRequireDefault(_sanitizeCaja);

var _index = __webpack_require__("./js/lib/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _index2 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _ul = __webpack_require__("../node_modules/xo-login-components/src/unified-login/ul.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _fiApis = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js");

var _eligibility = __webpack_require__("../node_modules/xo-models/src/eligibility/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index4 = _interopRequireDefault(_index3);

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _donation = __webpack_require__("../node_modules/xo-models/src/donation/index.js");

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

var _marketingoffer2 = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _shippingMethod = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _factory3 = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

var _factory4 = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

var _factory5 = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/factory.js");

var _factory6 = __webpack_require__("../node_modules/xo-address-components/src/address-normalization-edit/factory.js");

var _gatherActiveConsent = __webpack_require__("./pages/xo-review/gatherActiveConsent.factory.js");

var _constants = __webpack_require__("./pages/xo-review/constants.js");

var _metricLogger = __webpack_require__("./js/lib/metricLogger.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-styles/dist/lib/toggle.less");

__webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

__webpack_require__("../node_modules/xo-wallet-components/src/3ds/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/three-ds/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-method/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-offer-top-banner/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/no-balance/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-topup/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-paywith/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/marketingOffers/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/messenger-plugin/directive.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/directive.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/expired-message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/directive.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _factory7 = __webpack_require__("./pages/xo-select-fi/factory.js");

var _factory8 = __webpack_require__("./pages/xo-review/factory.js");

var _tokenizedFactory = __webpack_require__("./pages/xo-review/tokenizedFactory.js");

var _shippingChangeFeature = __webpack_require__("./pages/xo-review/lib/shippingChangeFeature.js");

var _xoShippingOptions = __webpack_require__("../node_modules/xo-shipping-options/src/index.js");

var _template = __webpack_require__("./pages/xo-review/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cpa-disclaimer/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/decline-notification/directive.js");

__webpack_require__("./pages/xo-review/styles.less");

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

var _balance = __webpack_require__("./pages/services/balance/index.js");

var _qs = __webpack_require__("../node_modules/qs/lib/index.js");

var _util = __webpack_require__("./js/lib/util.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Create payload that contains relevant data about the checkout state at review page
function createReviewFptiPayload(_ref) {
    var checkoutSession = _ref.checkoutSession,
        _ref$isProcessTransit = _ref.isProcessTransition,
        isProcessTransition = _ref$isProcessTransit === undefined ? false : _ref$isProcessTransit;

    var payload = {
        shipping_address_id: checkoutSession.get('shipping.id')
    };

    if (checkoutSession.get('plan.conversion') && !isProcessTransition) {
        payload.currency_conversion_type = checkoutSession.get('plan.conversion.paypal') ? 'PAYPAL' : 'VENDOR';
        payload.is_conversion_shown = checkoutSession.get('plan.conversion.changeable') ? 1 : 0;
        payload.currency_conversion_from_curr = checkoutSession.get('plan.conversion.from_code');
        payload.currency_conversion_to_curr = checkoutSession.get('plan.conversion.to_code');
    } else if (checkoutSession.get('plan.conversion') && isProcessTransition) {
        payload.currency_conversion_selected = checkoutSession.get('plan.conversion.paypal') ? 'PAYPAL' : 'VENDOR';
        payload.currency_conversion_from_curr = checkoutSession.get('plan.conversion.from_code');
        payload.currency_conversion_to_curr = checkoutSession.get('plan.conversion.to_code');
    }
    if (_factory3.$RewardsCheckboxFactory.rewardsFound()) {
        var contentKeys = _factory3.$RewardsCheckboxFactory.getContentKeys(checkoutSession.plan);

        payload.fi_id = (0, _utils.getInstrumentID)(checkoutSession.plan);
        payload.rewards_type = contentKeys.issuerName;
        payload.rewards_amt = contentKeys.value.rewardAmount; // monetary amount
        if (!isProcessTransition) {
            payload.rewards_fi = _factory3.$RewardsCheckboxFactory.toString();
        }
    }
    if (checkoutSession.plan.sources && checkoutSession.plan.sources[0].isBillingPreferred) {
        payload.default_funding_option = checkoutSession.plan.sources[0].instrument_id;
    }
    payload.chosen_funding_option = checkoutSession.plan.primaryFs || checkoutSession.plan.sources ? (0, _utils.getInstrumentID)(checkoutSession.plan) : '';
    return payload;
}

var $xoReviewPageComponent = exports.$xoReviewPageComponent = _squid.$Component.extend('$xoReviewPageComponent', {
    tag: 'xo-review-page',
    template: _template2['default'],
    scope: {
        redirectiframe: '=?',
        redirectLightbox: '=?'
    },
    actions: {
        handleCancelApplicationModalClick: function handleCancelApplicationModalClick(event) {
            // if click anywhere else except X button on modal, do nothing
            if (event.target.className !== 'close ng-scope') {
                event.preventDefault();
            }
        },
        closeCancelApplicationModal: function closeCancelApplicationModal() {
            this.showCancelApplicationModal = false;
        },
        openCancelApplicationModal: function openCancelApplicationModal() {
            this.showCancelApplicationModal = true;
        },


        /** Workaround to add a listener only to the <a> key which is contained in
         *  a renderContent and rendered through data-ng-bind-html */
        onTermsAndConditionListenerClick: function onTermsAndConditionListenerClick(event) {
            // If the <p>(P) is clicked ingore, only trigger for <a/>(A, link)
            if (event.target.tagName === 'A') {
                var _userAgreementVersion = this.userAgreementVersions,
                    majorVersion = _userAgreementVersion.majorVersion,
                    minorVersion = _userAgreementVersion.minorVersion;


                _logger.$logger.info('active_consent_disclaimer_terms_pressed', {
                    flow: 'CHECKOUT',
                    encr_cust_id: this.auth.buyer_id,
                    product: 'checkout',
                    event_name: 'active_consent_disclaimer_terms_pressed',
                    evnt_type: _constants.FptiEventType.Click,
                    policy_minor_version: minorVersion,
                    policy_major_version: majorVersion,
                    transition_name: 'consent_disclaimer_terms_clicked',
                    state_name: 'consent_disclaimer'
                });
            }
        },
        updatePreferredFi: function updatePreferredFi(logger) {
            if (this.makeFiPreferred && this.makeFiPreferred.selected) {
                var PreferredFi = new _fi.$PreferredFi({
                    preferred: [this.makeFiPreferred.fiId]
                });

                logger.info('checkout_fpti', { 'pref_fi_set': '1' });
                return PreferredFi.save({
                    transientError: true,
                    contingencies: {
                        DEFAULT: function DEFAULT() {}
                    }
                });
            }

            logger.info('checkout_fpti', { 'pref_fi_set': '0' });

            return _angular.$q.when();
        },
        onThreedsModalClose: function onThreedsModalClose() {
            this.showThreedsPopup = false;
        }
    },
    resolve: {
        // Experiment that knows if buyers can or cannot use PayPal Balance
        noBalanceExp: function noBalanceExp() {
            return (0, _squid.$elmo)('xo_hermes_no_balance_agreement', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_no_balance_agreement_1').then(function (result) {
                return { enabled: Boolean(result && result.treatment_name) };
            });
        },
        disallowedBalanceExp: function disallowedBalanceExp() {
            return (0, _squid.$elmo)('xo_hermesnodeweb_disallowed_balance', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_FEATURE_HERMES_DISALLOWED_BALANCE').then(function (result) {
                return { enabled: Boolean(result && result.treatment_name) };
            });
        },
        subscriptionNoBalanceLegaTextExp: function subscriptionNoBalanceLegaTextExp() {
            return (0, _squid.$elmo)('xo_hermes_subs_no_balance_legal_text', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_subs_no_balance_legal_text').then(function (result) {
                return { enabled: Boolean(result && result.treatment_name) };
            });
        }
    },
    lifecycle: {
        reenter: function reenter() {
            var _this = this;

            var msgKeys = this.checkoutSession.get('message.msgKeys', []);

            if (msgKeys.indexOf('confirmUpop.confirmUpopOrChooseAltMethod') === -1) {
                this.showUnconfirmedUpopMsg = !!this.checkoutSession.unconfirmed_upop;
            }

            // Reset the selectedmethod indicator and state change listener
            if (this.setupMultipleFi) {
                this.setupMultipleFi();
            }

            var instrumentId = this.checkoutSession.get('fundingOptions.plans.0.primaryFs.id');

            // For CPA, if we reenter, e.g. from sidebar, into review page, we need to send the fundingOption plan
            // so the CPA disclaimer can be refreshed if plan changes. e.g. 2 page variant in PP Balance scenario.
            this.primaryplan = this.checkoutSession.get('fundingOptions.plans.0');

            // If FS has changed due to an update, reset the preferred FI checkbox
            if (this.makeFiPreferred && this.makeFiPreferred.fiId !== instrumentId) {
                _logger.$logger.info('checkout_fpti', { 'pref_fi_option_shown': '1' });
                this.makeFiPreferred.selected = false;
            }

            this.topupError = false; // set default value to false (hide error when enter)

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'prepare_review'
            }, createReviewFptiPayload({ checkoutSession: this.checkoutSession })));

            // TODO: turn off `xo_hermes_preferred_expired_msg_review_page` since currently
            // it's not running. However, AuthRate team will be running this experiement again
            // this.showExpiredMsg = $ExpiredMsgFactory.showExpiredMsg(
            //     this.isNmj,
            //     this.checkoutSession
            // );

            // if (this.showExpiredMsg) {
            //     $ExpiredMsgFactory.getPreferredExpiredPxpResult().then(result => {
            //         this.isNmjexpired = result === 'xo_hermes_preferred_expired_msg_review_page_nmj_treatment' ? true : false;
            //         this.preferredExpired = this.checkoutSession.getDisallowedPreferred();
            //     });
            // }
            (0, _xoShippingOptions.getShippingOptions)(this.token).then(function (shippingOptions) {
                _this.shippingOptions = shippingOptions;
            });

            // On re-enter to review page once after payment Method updated, forced to reset the cvv fields.
            if (msgKeys.indexOf('paymentMethod.paymentMethodUpdated') !== -1) {
                this.resetCVVContigency({ flow: 'page_refresh' });
            }

            _balance.$BalanceEligibilityFactory.init({ checkoutSession: this.checkoutSession }).then(function (currentState) {
                var eligibility = currentState.eligibility;

                if (_sharedUtil.$SharedUtil.isBoolean(eligibility) && !eligibility) {
                    _this.checkoutSession.message = {
                        type: 'info',
                        msgs: [_squid.$locale.content.get('compliance.cipIncomplete')]
                    };
                    _logger.$logger.info('reivew_page_reenter_render_cip_incomplete_message');
                }
            });
        },
        populate: function populate() {
            if (this.checkoutCart.isWalletTokenization()) {
                (0, _jquery2['default'])('#outerWrapper').addClass('tokenization topup');
                var windowHeight = window.innerHeight || document.documentElement && document.documentElement.clientHeight;
                var header = document.querySelector('xo-header .paypalHeader');
                var footer = document.querySelector('xo-footer .footer');
                var footerHeaderHeight = (header && header.clientHeight) + (footer && footer.clientHeight);

                document.querySelector('.review .reviewTopup').style.minHeight = windowHeight - footerHeaderHeight - 5 + 'px'; // 5px for header/footer alignment
            }

            if (_squid.$locale.country === 'DE' && this.checkoutSession.creditOffer) {
                // we will hide the old PPC-DE credit offer (DE-IIW) if we found inside checkoutSession a plan
                // with GPL-DE (PAY_LATER_DE). For this scenario user got previously approved for GPL in hermione
                // but somehow did fallback into Hermes
                var gplDEplanFound = false;
                var plans = this.checkoutSession.get('fundingOptions.plans');
                if (plans) {
                    gplDEplanFound = plans.filter(function (p) {
                        return p.primaryFs && p.primaryFs.type === 'CREDIT' && p.primaryFs.name === 'PAY_LATER_DE';
                    }).length > 0;
                }
                this.installment.showPPCAcquisitionRadioButton = !gplDEplanFound;
            }
        },
        exit: function exit() {
            if (this.checkoutCart.isWalletTokenization()) {
                (0, _jquery2['default'])('.tokenization').removeClass('topup');
            }
            _factory3.$RewardsCheckboxFactory.destroy();
        }
    },
    controller: ['$scope', '$element', function ($scope, $element) {
        var _this2 = this;

        // storing the buyer language on entry to review page
        // this is getting used when there is a language toggle for RTR (some other flows in future)
        $scope.buyerProfileLanguage = _squid.$locale.lang;
        $scope.choiceBalanceCheckboxState = _factory7.$BalanceFactory.get();
        $scope.tokenizedFactoryState = _tokenizedFactory.$TokenizedFactory.get();
        $scope.noBalanceFactoryState = _factory2.$NoBalanceFactory.get();
        $scope.vault = { checked: true };

        $scope.creditSharedInfo = _credit.$CreditSharedInfoModel.instance();

        $scope.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);

        $scope.isThirdPartyWalletExperience = function () {
            var experience = _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);

            return experience === 'BAIDU_EXPERIENCE' || experience === 'VENMO_EXPERIENCE';
        };

        $scope.determineThirdPartyWalletExperience = function () {
            return _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);
        };

        $scope.creditParentContext = {
            populated: false,
            newMember: {},
            showCreditOffer: true // Flag for experimenting with display of the Credit Offer based on CEP
        };

        $scope.showCreditDisallowedMessage = function () {
            var isCreditDisallowedForMerchant = $scope.checkoutSession && $scope.checkoutSession.isCreditDisallowedForMerchant;
            return isCreditDisallowedForMerchant && !_angular.$rootScope.showFiSelectPage;
        };

        $scope.creditDisallowedMessage = {
            type: 'info',
            msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
        };

        var subscriptionAuRMG = function subscriptionAuRMG() {
            return (0, _squid.$elmo)('xo_hermes_au_rmg_msg', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_au_rmg_msg').then(function (result) {
                return { enabled: Boolean(result && result.treatment_name) };
            });
        };

        subscriptionAuRMG().then(function (result) {
            if (result.enabled === true) {
                _logger.$logger.info('use_debit_card_RMG', { country: _squid.$locale.country });
                $scope.showGamblingMessage = function () {
                    return $scope.payee.isGambling();
                };
            }
        });

        $scope.gamblingMessage = {
            type: 'info',
            msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
        };
        var shouldShowPendingBalance = function shouldShowPendingBalance() {
            return (0, _squid.$elmo)('xo_hermes_no_balance_text', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_no_balance_text').then(function (result) {
                return { enabled: Boolean(result && result.treatment_name) };
            });
        };
        shouldShowPendingBalance().then(function (result) {
            if (result.enabled === true) {
                _logger.$logger.info('claim_balance_text_not_allowed_to_be_shown_elmo');
                $scope.shouldShowPendingBalance = false;
            } else {
                _logger.$logger.info('claim_balance_text_allowed_to_be_shown_elmo');
                $scope.shouldShowPendingBalance = true;
            }
        });

        $scope.memberSegment = _marketingoffer2.$MemberSegmentModel.instance();

        $scope.isPPCReuseAndNotSelected = function () {
            var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
            if (plans && plans.filter(function (fi) {
                return fi.name === 'BILL_ME_LATER' && !fi.selected;
            }).length === 1) {
                return true;
            } else {
                return false;
            }
        };
        $scope.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

        $scope.isDEInstallmentsApproved = function () {
            var deInstallmentsPlanSelected = false;
            if (_squid.$locale.country === 'DE') {
                var plans = $scope.checkoutSession.getPlanList();
                if (plans) {
                    deInstallmentsPlanSelected = plans.filter(function (p) {
                        return p.primaryFs.type === 'CREDIT' && p.primaryFs.name === 'BILL_ME_LATER' && p.selected;
                    }).length > 0;
                }
            }
            // User got approved in CAPE if the DE installments plan is selected - return true
            if (deInstallmentsPlanSelected) {
                return true;
            }
            return false;
        };

        $scope.showCreditPlacement = function () {
            // for xo-offer handling
            $scope.creditParentContext.newMember.creditOffer = $scope.memberSegment && $scope.memberSegment.creditOffer;

            var show = !$scope.isThirdPartyWalletExperience() && $scope.creditParentContext.populated && $scope.creditParentContext.showCreditOffer && !_angular.$rootScope.showFiSelectPage && ($scope.checkoutSession.creditOffer || $scope.isPPCReuseAndNotSelected()) && !$scope.isMessengerBAIntegration && _squid.$locale.country !== 'DE' && !isUSCrossCurrency();

            return show;
        };

        $scope.showRepresentativeExample = function () {
            function isPPCNotSelected() {
                var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
                var selectedFi = plans && plans.find(function (fi) {
                    return fi.selected;
                });

                return !(selectedFi && selectedFi.name === 'BILL_ME_LATER');
            }

            return _squid.$locale.country === 'GB' && !(_angular.$rootScope.showFiSelectPage && isPPCNotSelected()) && $scope.creditSharedInfo.shouldShowCreditExample();
        };

        $scope.isProcessorDeclineExperiment = false;

        var applyNewMemberVariant = function applyNewMemberVariant() {
            return _newMember.$NewMemberEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
                // feature flag for one page nmj experience
                var isNmjDesign1 = $scope.isNmjDesign1 = variant === 'one_page';
                // feature flag for one page nmj design 2 experience
                var isNmjDesign2 = $scope.isNmjDesign2 = variant === 'design_2';
                // feature flag for one page nmj design 3 experience
                var isNmjDesign3 = $scope.isNmjDesign3 = variant === 'design_3';
                // umbrella flag for nmj experience
                var isNmj = $scope.isNmj = isNmjDesign1 || isNmjDesign2 || isNmjDesign3;

                $scope.showViewYourPaymentRights = (isNmjDesign2 || isNmjDesign3) && _squid.$locale.country === 'US';
                $scope.showGreyHeader = $scope.isNmjDesign2 || $scope.isNmjDesign3;
                $scope.nmjExperience = {
                    one_page: $scope.isNmjDesign1,
                    design_2: $scope.isNmjDesign2,
                    design_3: $scope.isNmjDesign3
                };

                // set assist-banner content based on type of nmj flow - if any
                var isPayNow = $scope.useraction === 'commit';
                var userName = $scope.auth.first_name ? $scope.auth.first_name : $scope.auth.email;

                if (isNmjDesign1) {
                    $scope.assistBannerHeader = _squid.$locale.content.get('memberReview.assistHeader_1page');
                    $scope.assistBannerBody = _squid.$locale.content.get(isPayNow ? 'memberReview.assistBody_paynow_1page' : 'memberReview.assistBody_continue_1page');
                } else if ($scope.showGreyHeader) {
                    if (isPayNow) {
                        $scope.headerMsg = (0, _squid.$renderContent)('memberReview.nmjDesign2HeaderMsgPayNow', { userName: userName });
                    } else {
                        $scope.headerMsg = (0, _squid.$renderContent)('memberReview.nmjDesign2HeaderMsgContinue', { userName: userName });
                    }
                }
                $scope.creditParentContext.newMember.variant = variant;
                $scope.creditParentContext.newMember.useCEPDecision = isNmj;
                $scope.creditParentContext.populated = true;

                $scope.showPaypalPolicy = !$scope.isThirdPartyWalletExperience() && $scope.showPaypalPolicies && !$scope.showViewYourPaymentRights;
                $scope.showPaymentRights = !$scope.isThirdPartyWalletExperience() && $scope.showPaypalPolicies && $scope.showViewYourPaymentRights;
                _logger.$logger.info('member_ryi_variant_' + (variant || 'unknown'), {
                    isNmj: isNmj,
                    variant: variant
                });
                triggerPersonalizedBanner();
            });
        };

        var displayUserAgreementConsent = function displayUserAgreementConsent() {
            // Check if buyer needs to accept the new User Agreement
            var showUpdatedUserAgreement = _gatherActiveConsent.$GatherActiveConsentFactory.isConsentRequired();

            if (!showUpdatedUserAgreement) {
                return;
            }

            var _$GatherActiveConsent = _gatherActiveConsent.$GatherActiveConsentFactory.getUserAgreementVersions(),
                majorVersion = _$GatherActiveConsent.majorVersion,
                minorVersion = _$GatherActiveConsent.minorVersion;

            _logger.$logger.info('active_consent_disclaimer_shown', {
                flow: 'CHECKOUT',
                encr_cust_id: $scope.auth.buyer_id,
                product: 'checkout',
                event_name: 'active_consent_disclaimer_shown',
                evnt_type: _constants.FptiEventType.Impression,
                policy_minor_version: minorVersion,
                policy_major_version: majorVersion,
                transition_name: 'prepare_consent_disclaimer',
                state_name: 'consent_disclaimer'
            });

            $scope.showUpdatedUserAgreement = showUpdatedUserAgreement;
            $scope.userAgreementVersions = { majorVersion: majorVersion, minorVersion: minorVersion };

            // Disclaimer: if updating the content and adding more <a> links,
            // please check the onTermsAndConditionListenerClick() functionality
            $scope.updatedUserAgreementContent = (0, _squid.$renderContent)('memberReview.updatedUserAgreement', {
                country: _squid.$locale.country,
                lang: _squid.$locale.lang,
                userAgreementLink: _gatherActiveConsent.$GatherActiveConsentFactory.getUserAgreementUrl()
            });
        };

        var triggerPersonalizedBanner = function triggerPersonalizedBanner() {
            $scope.personalizedBanner.trigger();
        };

        if ($scope.isThirdPartyWalletExperience()) {
            // log buyer type for third Party usecases
            _logger.$logger.info('buyer_info', {
                fpti_buyer_type: $scope.determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE' ? 'Guestuser_venmo' : 'nonloginmember_benteley'
            });
        } else {
            // log existing buyer
            _logger.$logger.info('buyer_info', { fpti_buyer_type: 'Existinguser' });
        }

        // ----------------- OUTRO PXP VARS - START -------------------- //
        // NOTES: `xo_hermes_exit_msg` pxp has ramped to 100% and will always
        // return `xo_hermes_exit_msg_option5` treatment.
        // See: https://engineering.paypalcorp.com/pxptool/configuration?exptId=2609&version=9
        var pxpMerchNameLimit = 20; // max length of the merchant name
        var pxpMerchName = void 0; // the brand or merchant name - resolved after retrieving appdata

        // ----------------- OUTRO PXP VARS - END -------------------- //
        $scope.token = _angular.$rootScope.token;
        $scope.backUri = 'checkout.review';
        $scope.installmentNotSelected = false;
        $scope.installment = {
            showBanner: false,
            showCYCO: false,
            showCreditExample: false,
            financing_details: null
        };

        // PAD Toggle feature
        $scope.padToggleFeature = {
            applicable: false,
            checkboxEnabled: false,
            showCheckbox: false,
            defaultPlan: false,
            pxpControlEnabled: false,
            fptiLogged: false,
            multiFiCheckboxStates: {}
        };

        // 'continue' or 'pay now' button text
        $scope.payButtonText = function () {
            return '';
        };
        $scope.isGCcountry = (_squid.$config.giftCardSupportedCountries || '').indexOf(_squid.$locale.country) > -1;
        $scope.showPaypalPolicies = (0, _squid.$featureCountries)('showPaypalPolicies').indexOf(_squid.$locale.country) > -1;
        $scope.makeAddrPreferred = {
            shown: false,
            selected: false
        };
        $scope.showPolicyAgreement = (0, _squid.$feature)('showPolicyAgreement');

        var _ref2 = window.xprops || {},
            _ref2$experience = _ref2.experience,
            experience = _ref2$experience === undefined ? { facebook: false, autoBA: false } : _ref2$experience;

        $scope.isFacebookBAIntegration = experience.facebook;

        $scope.personalizedBanner = {
            show: false,

            trigger: function trigger() {
                var isOneTouchBanner = $scope.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');
                var newMemberDesign1 = $scope.isNmjDesign1;

                $scope.personalizedBanner.show = newMemberDesign1 || isOneTouchBanner || $scope.auth.isFBSkipLogin();

                // for Facebook skip login set isFBSkipLogin as true to modify the skip login content
                $scope.personalizedBanner.isFBSkipLogin = $scope.auth.isFBSkipLogin();

                // FPTI payload to track FB Login
                if ($scope.auth.isFBSkipLogin()) {
                    _logger.$logger.info('checkout_fpti', {
                        'design': 'facebook_onetouch'
                    });
                }
            }
        };

        $scope.optin_toggle = {
            isEnabled: false,
            value: false,
            showExpandedTerms: true,
            setValue: function setValue(val) {
                this.value = val;
                // this.showExpandedTerms = false; // hide terms upon user interaction
                _logger.$logger.debug('ryi_optin_toggle_setValue', {
                    value: this.value,
                    showExpandedTerms: this.showExpandedTerms
                });
            }
        };
        _logger.$logger.debug('kmliUpsell review: init');
        _kmliUpsell.$KmliUpsell.init(_angular.$rootScope.token, false, true);
        var creditBannerRegister = _angular.$rootScope.$on('allLoaded', function () {
            _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T1' });
            creditBannerRegister();
        });
        _angular.$rootScope.$on('$destroy', creditBannerRegister);

        function optInUser() {
            // eslint-disable-line no-unused-vars
            _logger.$logger.info('ryi_optin', {
                'from': 'OT_Toggle',
                'to': 'prepare_optin'
            });
            $scope.optin_toggle.setValue(true);
            var optinSource = 'checkoutToggle';
            var silentSpinner = true;

            return _ul.$ul.optInToOneTouch(_angular.$rootScope.token, _squid.$locale.country, _squid.$locale.lang, silentSpinner, {
                'stateName': 'OT_Toggle',
                'transInfix': 'process_optin'
            }, optinSource).then(function (res) {
                _logger.$logger.debug('ryi_optin_toggle_process_optin');
            })['catch'](function (err) {
                // eslint-disable-line handle-callback-err
                _logger.$logger.debug('ryi_optin_toggle_process_optin_Error', {
                    'int_error_description': err && err.message
                });
            });
        }

        function optOutUser() {
            // eslint-disable-line no-unused-vars
            _logger.$logger.info('ryi_optin', {
                'from': 'OT_Toggle',
                'to': 'prepare_optout'
            });
            return $scope.auth.action('optout', { silent: true }).then(function (res) {
                _logger.$logger.info('ryi_optin', {
                    'from': 'OT_Toggle',
                    'to': 'process_optout'
                });
                $scope.$applyAsync(function () {
                    var bannerElement = $element.find('.oneTouchBanner');

                    bannerElement.addClass('leave_animation');
                    _logger.$logger.debug('ryi_optin bannerElement animate');
                    (0, _angular.$timeout)(function () {
                        $scope.optin_toggle.setValue(false);
                        $scope.optin_toggle.isEnabled = false;
                    }, 1400);
                });
            })['catch'](function (err) {
                _logger.$logger.info('ryi_optin', {
                    'from': 'OT_Toggle',
                    'to': 'process_optout',
                    'error_source': 'identityauthorizationserv',
                    'int_error_code': 'optout_failure',
                    'int_error_description': err && err.message
                });
            });
        }

        $scope.onTouchToggle = function (value) {
            _logger.$logger.debug('optin_toggle_change_attempt', {
                'ryi_optin': $scope.optin_toggle,
                'remembered': $scope.auth.remembered,
                'value': value
            });
            if ($scope.optin_toggle.isEnabled) {
                if (value) {
                    optInUser();
                } else {
                    optOutUser();
                }
            }
        };

        $scope.tagFamilyComputer = function () {
            // creates a log to tag device as family computer.
            // if we can distinguish between single user, family computer and shared computer
            // we may be able to offer a way to switch accounts
            var buyer_id = $scope.auth.buyer_id;
            var logPayload = {
                localStorageEnabled: false,
                isMobile: _index2.$DeviceInfo.isMobile()
            };

            if (_squid.$util.localStorageEnabled()) {
                var family_device_key = 'family_device_test';
                var public_device_key = 'public_device_test';

                logPayload.localStorageEnabled = true;

                var objStr = localStorage.getItem(family_device_key);
                var publicDeviceTest = localStorage.getItem(public_device_key);

                if (publicDeviceTest === 'true') {
                    // dont overuse localStorage there is a size limit
                    localStorage.removeItem(family_device_key);
                    logPayload.isPublicDevice = true;
                } else {
                    var buyerList = objStr ? JSON.parse(objStr) : [];

                    if (buyerList.indexOf(buyer_id) === -1) {
                        buyerList.push(buyer_id);
                    }
                    // assuming 5 or less users on a device as family computer
                    logPayload.isFamilyDevice = Boolean(buyerList.length > 1 && buyerList.length < 6);
                    logPayload.isPublicDevice = Boolean(buyerList.length > 20);
                    logPayload.userCount = buyerList.length;
                    objStr = JSON.stringify(buyerList);
                    localStorage.setItem(family_device_key, objStr);
                    localStorage.setItem(public_device_key, logPayload.isPublicDevice.toString());
                }
            }
            var eligibility_reason = 'localStorage:' + logPayload.localStorageEnabled + '_isPublicDevice:' + logPayload.isPublicDevice + '_isFamilyDevice:' + logPayload.isFamilyDevice + '_userCount:' + logPayload.userCount;

            _logger.$logger.debug('family_device_test', logPayload);
            _logger.$logger.info('checkout_fpti', {
                'from': 'family_device_test',
                'to': 'process_elg_chk',
                'eligibility_reason': eligibility_reason
            });
        };

        function stickyCTA() {
            return _eligibility.$stickyCTA.instance().getEligibility().then(function (eligibility) {
                $scope.stickyEligibility = eligibility;
            });
        }

        // Format the informal name if populated
        function setInformalName() {
            if ($scope.auth) {
                $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                }) || $scope.auth.email;
            }
        }

        function donationAuthorize() {
            var _$GiveAtCheckoutFacto = _factory.$GiveAtCheckoutFactory.get(),
                donateCheckboxSelected = _$GiveAtCheckoutFacto.donateCheckboxSelected,
                charity = _$GiveAtCheckoutFacto.charity,
                tracking = _$GiveAtCheckoutFacto.tracking;

            if (donateCheckboxSelected) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'GIVE_AT_CHECKOUT',
                    to: 'process_give_at_checkout',
                    gac_model: charity.model_id,
                    gac_npid: charity.nonprofit_id
                });

                if (tracking && tracking.click_url) {
                    _marketingoffer.$fireMORSBeacon.fireBeacon(tracking.click_url);
                }

                return _donation.$GiveAtCheckoutModel.instance().action('donationAuthorize', {
                    data: {
                        'ec_token': _angular.$rootScope.token,
                        'nonprofit_id': charity.nonprofit_id,
                        'charity_name': charity.name,
                        'money': {
                            'value': charity.amount,
                            'currency_code': charity.currency
                        }
                    },
                    success: function success() {
                        return _logger.$logger.info('donation_authorize_success', {});
                    },
                    error: function error() {
                        return _logger.$logger.error('donation_authorize_failure');
                    }
                });
            }
        }

        function updateAddressAsPreferred() {
            if ($scope.makeAddrPreferred.shown) {
                _logger.$logger.info('makeAddrPreferred.shown', {});
            }

            if ($scope.makeAddrPreferred.selected) {
                _logger.$logger.info('makeAddrPreferred.selected', {});
                // Ignore all errors from setPreferred api, by passing transientError as true
                return $scope.checkoutSession.shipping.action('setPreferred', {
                    transientError: true
                });
            }
            return _angular.$q.when();
        }

        function setStickyInstrument() {
            if (!_squid.$config.features.DEFAULT.enableStickyFunding) {
                return _angular.$q.when();
            }

            // If the currently selected plan is not saved in the checkoutSession, make the call to save it.
            // For BA no purchase cases, the only way we track it is in the checkout session, so it should already be saved (selected id will equal sticky id).
            // For all other purchase cases, we need to look at the first in fundingOptions and match it to futurePaymentInstruments
            var savedSticky = $scope.checkoutSession.selectedFuturePaymentInstrument;
            var selectedSticky = $scope.checkoutSession.getSelectedStickyInstrument();

            // selectedSticky will not be populated if this isn't a billing case.
            if (!selectedSticky) {
                return _angular.$q.when();
            }

            // If we haven't saved the selected sticky instrument yet,
            // make the API call to save it
            if (!savedSticky || savedSticky.instrument_id !== selectedSticky.instrument_id) {
                return $scope.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: selectedSticky.instrument_id
                    }
                });
            }
            return _angular.$q.when();
        }

        function linkAuthConsent() {
            /* Check if its BA flow and we have merchant consent code */
            if ($scope.checkoutCart.isBilling() && $scope.checkoutCart.billing) {
                // Getting merchant account's billing consent code i.e. legal_text_code
                var billingConsentCode = $scope.checkoutCart.billing.consent_code;
                var FB_CONSENT_CODE = 'facebookp2p';
                var authConsentModel = _user.$AuthConsentModel.instance();

                if (billingConsentCode === FB_CONSENT_CODE) {
                    return authConsentModel.action('link', {
                        data: {
                            'ba_token': _squid.$meta.baToken
                        },
                        success: function success() {
                            return _logger.$logger.info('link_authconsent_success', {});
                        }
                    });
                }
            }
        }

        function setWalletTopupPreferences() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                $scope.walletPreferences = _fi.$WalletPreferences.instance(_angular.$rootScope.token);
                return $scope.walletPreferences.save();
            }
        }

        function isValidPinSetup() {
            if ($scope.walletPinModel && $scope.walletPinModel.isSetupEligible()) {
                if (!$scope.walletPinModel.userPin) {
                    return false;
                }
            }
            return true;
        }

        function prepareTokenizedWallet() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                return (0, _squid.$populate)($scope, {
                    walletPreferences: _fi.$WalletPreferences.instance(_angular.$rootScope.token),
                    walletPinModel: _app.$TokenizedWalletPinModel.instance(_angular.$rootScope.token),
                    tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(_angular.$rootScope.token).retrieve({
                        params: {
                            tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken,
                            country: $scope.auth.country
                        }
                    })
                }).then(function (result) {
                    var fundingInstrument = $scope.walletPreferences.getPreferred();
                    var instrument_id = fundingInstrument.instrument_id;
                    var defaultTopupFI = _squid.$util.find($scope.checkoutSession.topupFundingSources, function (fs) {
                        return fs.instrument_id === instrument_id;
                    }) || {};
                    var defaultDirectFI = _squid.$util.find($scope.checkoutSession.futurePaymentInstruments, function (fs) {
                        return fs.instrument_id === instrument_id;
                    }) || {};
                    var pinStatus = 'default_pin_unavailable';

                    if ($scope.walletPinModel.isPinIdPresent()) {
                        pinStatus = 'already_exist';
                    } else if ($scope.walletPinModel.getPinOrigin() !== 'UNSET') {
                        pinStatus = 'pin_error';
                    } else if ($scope.walletPinModel.getSuggestedPin()) {
                        pinStatus = 'default_pin_available';
                    }

                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'TopUp_REVIEW',
                        'to': 'prepare_review',
                        'context_id': $scope.token,
                        'context_type': 'EC-Token',
                        'billing_token': _squid.$meta.baToken,
                        'default_topup_fi': defaultTopupFI.type,
                        'default_direct_fi': defaultDirectFI.type,
                        'pin': pinStatus,
                        'flag': $scope.checkoutSession.get('sepa_mandate.bankId') ? 'sepa' : undefined
                    });
                });
            }
            return _angular.$q.when();
        }

        $scope.hasShippingOptions = function () {
            return Boolean($scope.shippingOptions && $scope.shippingOptions.length);
        };

        function checkJSV4PaymentDetails() {
            // Pass through if there are no shipping methods to choose from.
            if (!$scope.hasShippingOptions()) {
                return _angular.$q.when();
            }

            // Otherwise, if there are shipping methods but no selected method... Fail!
            if (!$scope.selectedShippingOption) {
                $scope.checkoutSession.message = {
                    type: 'error',
                    msgKeys: ['shipping.bopisErrorMessage']
                };

                throw new Error('IXO_CANNOT_CHECKOUT_WITHOUT_SHIPPING_SELECTION');
            }
        }

        /**
         * To resetCVVContingency once the page refresh/back happen.
         *
         * case1. browser_back:
         *          Reset the hash value in the url with '#', no page load occurs.
         *          once browser back click the cache clean and cvv text box will show.
         * case2. page_refresh:
         *          reset the lastAddedCard to false
         *          every page refresh the cvv text box will display.
         */
        $scope.resetCVVContigency = function (_ref3) {
            var flow = _ref3.flow;


            var isResolve3ds = $scope.checkoutSession && $scope.checkoutSession.resolve_3ds;
            var isReviewPage = _uiRouter.$state.current.name === 'checkout.review';

            if (isResolve3ds && isReviewPage && checkResetCvvAllowed()) {
                _logger.$logger.info('checkout_fpti', { from: 'resetCVVContigency_' + flow, to: 'process_resetCVVContigency_' + flow });
                var ccId = isResolve3ds.ccId,
                    type = isResolve3ds.type,
                    number = isResolve3ds.number;


                switch (flow) {
                    case 'page_refresh':
                        $scope.checkoutSession.set('cvvData', Object.assign({}, { type: type, number: number, ccId: ccId, id: ccId, lastAddedCard: false }));
                        break;
                    case 'browser_back':
                        _angular.$window.location.hash = '#';
                        break;
                    default:
                        break;
                }
            }
        };

        /**
         * Parse the queryString
         * - set the required scopes for init3DS paymentExperience
         * - set return query while return to merchaant
         */
        var parseQueryStringForExperience = function parseQueryStringForExperience() {
            var isDoEcEnabled = !window.xchild && $scope.checkoutAppData.doec_on_approve() ? 1 : 0;

            var searchParams = (0, _qs.parse)(_angular.$window.location.search.split('?')[1]);
            searchParams = Object.assign({}, searchParams, { isDoEcEnabled: isDoEcEnabled, hermes: '1', token: $scope.token });
            delete searchParams.cmd;
            $scope.process3dsReturnQueryParams = (0, _qs.stringify)(searchParams);
            var searchParamThreeDSexp = searchParams['threeDSexp'];

            if (searchParamThreeDSexp === 'redirect' || searchParamThreeDSexp === 'iframe') {
                $scope.isRedirectTreatment = searchParamThreeDSexp === 'redirect';
                _logger.$logger.info('checkout_fpti', { from: '3ds_exp_queryString_' + $scope.isRedirectTreatment, to: 'process_3ds_exp__queryString_' + $scope.isRedirectTreatment });
            }
        };

        /**
         * Get paymentExperience from URL for experiemenation
         *
         * @return {Array}
         */
        function getPaymentExperience() {
            var paymentExperience = void 0;

            $scope.threeDSexp = $scope.isRedirectTreatment ? 'REDIRECT' : 'IFRAME';
            $scope.channelType = $scope.threeDSexp === 'REDIRECT' ? 'MOBILE_APP' : 'WEB';
            paymentExperience = [$scope.threeDSexp];

            //  if the merchant integrated with incontext experience then we need to send 'IFRAME' as experience
            if (_index.$miniBrowser.isMiniBrowser()) {
                $scope.isMiniBrowser = _index.$miniBrowser.isMiniBrowser();
                _logger.$logger.info('checkout_fpti', { from: 'override_as_iframe', to: 'process_override_as_iframe' });
                $scope.channelType = 'WEB';
                $scope.isRedirectTreatment = false;
                paymentExperience = ['IFRAME'];
            }
            return paymentExperience;
        }

        /**
         * To check the elmo treatment for the 3ds experience
         *
         * return {Boolean}
         */
        var checkExperienceElmoTreatment = function checkExperienceElmoTreatment() {
            var _$scope$checkoutSessi = $scope.checkoutSession.payer;
            _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
            var payerId = _$scope$checkoutSessi.id;
            var _$config$pxpExperimen = _squid.$config.pxpExperiments.hermesElmo3dsExperience,
                id = _$config$pxpExperimen.id,
                testTreatmentName = _$config$pxpExperimen.testTreatmentName;

            var merchantCountryCode = $scope.checkoutAppData.get('merchant.merchant_country');

            if (!(0, _squid.$feature)('callElmoForPaymentExperience')) {
                parseQueryStringForExperience();
                return;
            }

            (0, _squid.$elmo)(id, { 'filters.Country': _squid.$locale.country, 'uid': payerId, 'filters.MerchantCountry': merchantCountryCode }, testTreatmentName, false, true).then(function (result) {
                var treatmentName = result && result.treatment_name || '';

                if (treatmentName) {
                    _logger.$logger.info('treatmentName_exist', treatmentName);
                    $scope.isRedirectTreatment = true;
                }

                _logger.$logger.info('checkout_fpti', {
                    from: 'isRedirectTreatment',
                    to: 'process_3ds_isRedirectTreatment',
                    data: { isRedirectTreatment: $scope.isRedirectTreatment }
                });
            })['finally'](function () {
                parseQueryStringForExperience();
            });
        };

        /**
         * Get Security code from cvvData
         */
        function getSecurityCode() {
            if (checkResetCvvAllowed()) {
                return _angular.$rootScope.cvvData && _angular.$rootScope.cvvData.security_code;
            }
        }

        /**
         * Set CVV data from CheckoutSessionModel
         */
        function setCvvData() {
            if (checkResetCvvAllowed()) {
                _angular.$rootScope.cvvData = $scope.checkoutSession.get('cvvData') ? $scope.checkoutSession.get('cvvData') : _angular.$rootScope.cvvData;
            }
        }

        /**
         * check whether to allow reset cvv based on country
         * - reset CVV value
         * - show cvv text box
         */
        function checkResetCvvAllowed() {
            var resetCVVAllowedCountries = ['IN'];
            _logger.$logger.info('checkout_fpti', {
                from: 'checkResetCvvAllowed',
                to: 'process_checkResetCvvAllowed',
                resetCVVAllowedCountries: resetCVVAllowedCountries
            });
            return resetCVVAllowedCountries.includes(_squid.$locale.country);
        }

        function show3DSLightbox() {
            $scope.resolve_3ds_data = set3DSv1ScopeVariable();

            $scope.launch3DSResolver = true;
        }

        // 3DS V2 device data collection - group it together with V1 for easy reference
        function show3dsDDCLightBox() {
            $scope.threedsData = set3DSv2ScopeVariable();
            $scope.showThreedsPopup = true;
        }

        function setProcessorDeclineMessage(checkoutSession) {
            var declinedInstruments = checkoutSession.declinedInstruments;

            // For CPA scenario, when pre auth decline, we reload the review page and for that we would have
            // decline instrument but we dont want to show existing Processor Decline Message. Instead CPA message
            // would be shown on review page (we have separate component 'decline-notification' for displaying CPA Message.
            // So filtering the below logic, if user is not CPA Eligible.
            if (declinedInstruments && declinedInstruments.length > 0 && !$scope.isCPAEligible) {
                _factory5.$AddCardFactory.getIssuerDeclineElmoResult().then(function (result) {
                    // reset the checkoutSession.message;
                    checkoutSession.message = null;

                    var planInstruments = checkoutSession.fundingOptions.plans || [];
                    var treatmentPAPS = null;

                    planInstruments.forEach(function (plan) {
                        if (plan.primaryFs.lastDigits === declinedInstruments[0].last4 && plan.primaryFs.name.toLowerCase() === declinedInstruments[0].card_type.toLowerCase()) {
                            treatmentPAPS = 'Trmt_xo_hermesnodeweb_issuer_decline_1';
                            $scope.isProcessorDeclineExperiment = true;
                        }
                    });

                    var processorDeclinedMsg = _fiMessages.$fiMessages.processorDeclinedMsg($scope.checkoutSession, true, treatmentPAPS, $scope.auth, $scope.fiMeta.wallet, $scope.formattedNameInformal);

                    if (processorDeclinedMsg) {
                        $scope.checkoutSession.message = {
                            type: processorDeclinedMsg.type,
                            msgs: [processorDeclinedMsg.msg],
                            keepMsg: processorDeclinedMsg.keepMsg
                        };
                    }
                });
            }
        }

        function getPadToggleStatus() {
            var toggleStatus = 'NA'; // NOT APPLICABLE status

            if (_factory8.$PADFactory.isPadToggleFeatureApplicable($scope.padToggleFeature, $scope.isPadToggleEnabled)) {
                if ($scope.padToggleFeature.checkboxEnabled) {
                    toggleStatus = 'ON';
                } else {
                    toggleStatus = 'OFF';
                }
            }
            return toggleStatus;
        }

        // method to extract information for 3DSv1.0
        function set3DSv1ScopeVariable() {
            // for v2 resolve_3ds is null, pass it from V2 mapping to get amount and currency
            var cc_id = $scope.checkoutSession.get('resolve_3ds.ccId');
            var plans = $scope.checkoutSession.get('plan.sources', null);
            var plan = plans && plans.filter(function (e) {
                return e.instrument_id === cc_id;
            })[0].amount || null;

            return {
                cc_id: cc_id,
                flow_id: 'HERMES',
                merchant_id: $scope.payee.get('merchant.id'),
                merchant_country_code: $scope.checkoutAppData.get('merchant.merchant_country'),
                transaction_amount_currency: plan && plan.currency_code || null,
                transaction_amount_value: plan && plan.amount || null,
                merchant_category_code: $scope.payee.get('merchant.merchant_category_code'),
                card_verification_code: getSecurityCode(),
                paymentExperience: getPaymentExperience(),
                channelType: $scope.channelType,
                isMiniBrowser: $scope.isMiniBrowser,
                isRedirectTreatment: $scope.isRedirectTreatment,
                process3dsReturnQueryParams: $scope.process3dsReturnQueryParams
            };
        }

        function getProductDetails() {
            // default to express checkout
            var productDetails = {
                productCode: 'EXPRESS_CHECKOUT',
                productFlow: 'HERMES'
            };

            var isWPSFlow = $scope.checkoutAppData.is_wps_flow();
            var isBillingWithoutPurchase = $scope.checkoutCart.isBillingNoPurchase();
            var isBillingWithPurchase = $scope.checkoutCart.isBillingPurchase();
            var isWPSSubscriptionFlow = $scope.checkoutAppData.is_wps_subscription_flow();
            var isWPSAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();

            if (isWPSFlow) {
                productDetails.productCode = 'WEBSITE_PAYMENT_STANDARD';
            } else if (isBillingWithoutPurchase || isBillingWithPurchase) {
                productDetails.productCode = 'BILLING_AGREEMENTS';
                productDetails.productFlow = 'BUYER_APPROVAL_BILLING_AGREEMENT_CREATE';
            } else if (isWPSSubscriptionFlow) {
                productDetails.productCode = 'BILLING_SUBSCRIPTIONS';
                productDetails.productFlow = 'BUYER_APPROVAL_SUBSCRIPTIONS_CREATE';
            } else if (isWPSAutobilling) {
                productDetails.productCode = 'BILLING_AUTOBILLING';
                productDetails.productFlow = 'BUYER_APPROVAL_AUTOBILLING_CREATE';
            } else if (isBillingWithPurchase) {
                productDetails.productCode = 'BILLING_AGREEMENT';
                productDetails.productFlow = 'BUYER_APPROVAL_BILLING_AGREEMENT_WITH_PURCHASE';
            }

            return productDetails;
        }

        /**
         * As part of the hermes deprecation effort, we want to figure out the reason we are staying on hermes.
         *
         * If it can't be determined, then we should redirect to xolite.
         */
        function getReasonToStayOnHermes() {
            var isWPSFlow = Boolean($scope.checkoutAppData.is_wps_flow());
            var isBillingWithoutPurchase = Boolean($scope.checkoutCart.isBillingNoPurchase());
            var isBillingWithPurchase = Boolean($scope.checkoutCart.isBillingPurchase());
            var isWPSSubscriptionFlow = Boolean($scope.checkoutAppData.is_wps_subscription_flow());
            var isWPSAutobilling = Boolean($scope.checkoutAppData.isWpsAutobillingFlow());
            var isTokenizedWallet = Boolean($scope.checkoutCart.isWalletTokenization());
            var isHermesQueryParam = Boolean(_squid.$util.param('hermes') === '1');

            var _$SharedUtil$getSubsc = _sharedUtil.$SharedUtil.getSubscriptionDetails(_angular.$rootScope && _angular.$rootScope.token),
                subscriptionType = _$SharedUtil$getSubsc.subscriptionType;

            var reasonToStayOnHermes = 'unknown';

            if (isWPSFlow) {
                reasonToStayOnHermes = 'website_payment_standard';
            } else if (typeof subscriptionType === 'string') {
                reasonToStayOnHermes = subscriptionType;
            } else if (isWPSSubscriptionFlow) {
                reasonToStayOnHermes = 'billing_subscriptions';
            } else if (isWPSAutobilling) {
                reasonToStayOnHermes = 'billing_autobilling';
            } else if (isTokenizedWallet) {
                reasonToStayOnHermes = 'wallet_tokenization';
            } else if (isBillingWithoutPurchase) {
                reasonToStayOnHermes = 'billing_without_purchase';
            } else if (isBillingWithPurchase) {
                reasonToStayOnHermes = 'billing_with_purchase';
            } else if (isHermesQueryParam) {
                reasonToStayOnHermes = 'hermes_queryparam';
            }
            return {
                reasonToStayOnHermes: reasonToStayOnHermes,
                isWPSFlow: isWPSFlow,
                isBillingWithoutPurchase: isBillingWithoutPurchase,
                isBillingWithPurchase: isBillingWithPurchase,
                isWPSSubscriptionFlow: isWPSSubscriptionFlow,
                isWPSAutobilling: isWPSAutobilling,
                isTokenizedWallet: isTokenizedWallet,
                isHermesQueryParam: isHermesQueryParam,
                subscriptionType: typeof subscriptionType === 'string' ? subscriptionType : 'not_a_subscription'
            };
        }

        function isBillingFlow() {
            return $scope.checkoutCart.isBilling() || $scope.checkoutAppData.is_wps_subscription_flow() || $scope.checkoutAppData.isWpsAutobillingFlow() || $scope.checkoutAppData.is_wps_installmentplan_flow() || $scope.checkoutCart.isSubscriptionsV1();
        }

        // method to extract information for 3DSv2.0
        function set3DSv2ScopeVariable() {
            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref4 = threeDSResolutionData.resolutions || [],
                resolutions = _ref4[0];

            var _ref5 = resolutions || {},
                _ref5$funding_instrum = _ref5.funding_instrument_details;

            _ref5$funding_instrum = _ref5$funding_instrum === undefined ? {} : _ref5$funding_instrum;
            var _ref5$funding_instrum2 = _ref5$funding_instrum.payment_card,
                payment_card = _ref5$funding_instrum2 === undefined ? {} : _ref5$funding_instrum2,
                _ref5$funding_instrum3 = _ref5$funding_instrum.three_ds_contingency_context,
                three_ds_contingency_context = _ref5$funding_instrum3 === undefined ? {} : _ref5$funding_instrum3;

            // logo image url

            var networkLogo = $scope.fiMeta.wallet.getCardArt(payment_card);
            var cc_id = payment_card.id; // ex: CC-XUBYA6TH5RJ2G
            var plans = $scope.checkoutSession.get('plan.sources', null);
            var plan = plans && plans.filter(function (e) {
                return e.instrument_id === cc_id;
            })[0].amount || null;
            var amount = {
                currencyCode: plan && plan.currency_code,
                currencyValue: plan && plan.amount
            };

            var jwtInfo = {
                jwtIssuer: three_ds_contingency_context.auth_specification.issuer,
                jwtOrgUnitId: three_ds_contingency_context.auth_specification.org_unit_id,
                jwtDuration: three_ds_contingency_context.auth_specification.validity_duration
            };

            var threeDSContingencySource = three_ds_contingency_context.source,
                threeDSContingencyReason = three_ds_contingency_context.reason;
            var id = payment_card.id,
                bank_identification_number = payment_card.bank_identification_number,
                billing_address = payment_card.billing_address,
                number_encrypted = payment_card.number_encrypted,
                card_product_class = payment_card.card_product_class,
                expire_month = payment_card.expire_month,
                expire_year = payment_card.expire_year,
                type = payment_card.type;


            if (isBillingFlow()) {
                amount.currencyValue = '0.00';
            }
            return {
                cardBin: bank_identification_number, // Needed for JWT
                ddcUrl: three_ds_contingency_context.device_data_collection_url,
                jwtInfo: jwtInfo, // Needed for JWT
                referenceId: three_ds_contingency_context.reference_id,
                integrationType: 'TRANSACTION',
                networkLogo: networkLogo,
                cardBrand: type,
                initThreedsData: {
                    referenceId: three_ds_contingency_context.reference_id,
                    creditCardId: id,
                    billing_address: billing_address,
                    number_encrypted: number_encrypted,
                    card_product_class: card_product_class,
                    expire_month: expire_month,
                    expire_year: expire_year,
                    amount: amount,
                    threeDSContingencySource: threeDSContingencySource,
                    threeDSContingencyReason: threeDSContingencyReason,
                    merchant_category_code: $scope.payee.get('merchant.merchant_category_code'),
                    productDetails: getProductDetails()
                }
            };
        }

        /**
         * `Exit message` feature is currently only applied to:
         * 1) Only in US
         * 2) user action **not** "commit"
         * 3) not a billing agreement
         * 4) `DONE_PAGE` integration is false
         * @returns {boolean}
         */
        var applyExitMessage = function applyExitMessage() {
            return _squid.$locale.country === 'US' && $scope.useraction !== 'commit' && !$scope.checkoutCart.isBilling() && !_integration.$integration.getConfig('DONE_PAGE');
        };

        var getPlanId = function getPlanId(obj) {
            return obj.planId || obj.id;
        };

        var getPlan = function getPlan(planId) {
            var planList = $scope.checkoutSession.get('fundingOptions.plans') || [];
            var selectedPlan = void 0;

            angular.forEach(planList, function (plan) {
                if (getPlanId(plan) === planId) {
                    selectedPlan = plan;
                }
            });
            return selectedPlan;
        };
        var getDefaultPlanId = function getDefaultPlanId() {
            return $scope.checkoutSession.plan.id || [];
        };

        var getSpinnerContentTest = function getSpinnerContentTest() {
            return (0, _squid.$elmo)('xo_hermesnodeweb_cpa_spinner', { 'ctx.country': _squid.$locale.country }, 'xo_hermesnodeweb_cpa_spinner_trmt(_[0-9]+)?').then(function (result) {
                return result && result.treatment_name;
            });
        };

        /* Function for Pre auth API - "/v2/payments/authorizations"
           Pre auth call would be invoked if the user is CPA Eligible and selected (or default, if user did not select)
           plan has pre auth data. otherwise we will skip and move forward with approve call.
         */
        var preAuthorize = function preAuthorize() {
            var selectedPlanId = decidePlanSelection() || getDefaultPlanId();
            var selectedPlan = getPlan(selectedPlanId);
            var preAuthorizationData = selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.pre_authorization_instruction;
            var _$scope$checkoutSessi2 = $scope.checkoutSession.payer;
            _$scope$checkoutSessi2 = _$scope$checkoutSessi2 === undefined ? {} : _$scope$checkoutSessi2;
            var payerId = _$scope$checkoutSessi2.id;

            var preAuthorizationRequired = false;
            var authAmount = void 0;

            if (preAuthorizationData) {
                var authType = preAuthorizationData.type;

                authAmount = preAuthorizationData.amount;
                preAuthorizationRequired = authType === 'FULL' || authType === 'PARTIAL';
            }

            if (preAuthorizationRequired) {
                var fptiData = {
                    fi_id: selectedPlan.primaryFs.id,
                    plan_id: selectedPlanId,
                    auth_type: preAuthorizationData.type,
                    buyer_id: payerId,
                    ryp_button_text: $scope.useraction === 'commit' ? 'PayNow' : 'Continue'
                };

                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'CREATE_FI_AUTH',
                    to: 'prepare_fi_auth',
                    client_epoch_ts: Date.now()
                }, fptiData));

                getSpinnerContentTest().then(function (treatment) {
                    if (treatment) {
                        _logger.$logger.info('xo_hermesnodeweb_cpa_spinner - treatment');

                        var loadingMessage = void 0;
                        var loadingSubMessage = void 0;
                        switch (treatment) {
                            case 'xo_hermesnodeweb_cpa_spinner_trmt':
                                loadingMessage = (0, _squid.$renderContent)('spinner.authFlowContinue', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine2', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                break;
                            case 'xo_hermesnodeweb_cpa_spinner_trmt_2':
                                loadingMessage = (0, _squid.$renderContent)('spinner.preAuthCard').toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine3').toString();
                                break;
                            case 'xo_hermesnodeweb_cpa_spinner_trmt_3':
                                loadingMessage = (0, _squid.$renderContent)('spinner.completePayment', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine3').toString();
                                break;
                            default:
                                loadingMessage = '';
                                loadingSubMessage = '';
                        }

                        _squid.$event.emit('loading');
                        _squid.$event.emit('loadingMessage', {
                            heading: loadingMessage,
                            subHeading: loadingSubMessage
                        });
                        // force spinner styling and content
                        // this is delayed, because (for some reason)
                        // the spinner isn't in the DOM _yet_,
                        // even though #showSpinner() fired... UGH!
                        (0, _angular.$timeout)(function () {
                            var spinnerMessageEl = (0, _jquery2['default'])('#spinner-message');
                            var spinnerSubMessageEl = (0, _jquery2['default'])('#spinner-submessage');

                            if (spinnerMessageEl) {
                                spinnerMessageEl = spinnerMessageEl.css({
                                    width: '150%',
                                    marginLeft: '-55px'
                                });
                            }
                            if (spinnerSubMessageEl) {
                                spinnerSubMessageEl = spinnerSubMessageEl.css({
                                    width: '168%',
                                    marginLeft: '-75px',
                                    marginTop: '20px'
                                });
                            }
                        }, 1);
                    } else {
                        _logger.$logger.info('xo_hermesnodeweb_cpa_spinner - control');
                    }
                });

                return $scope.checkoutSession.action('preAuthorize', {
                    data: {
                        authAmount: authAmount,
                        planId: selectedPlanId
                    },
                    success: function success() {
                        _logger.$logger.info('checkout_fpti', _extends({
                            from: 'CREATE_FI_AUTH',
                            to: 'process_fi_auth',
                            client_epoch_ts: Date.now()
                        }, fptiData));

                        return _angular.$q.when();
                    },
                    contingencies: {
                        CC_AUTHORIZATION_DECLINED: function CC_AUTHORIZATION_DECLINED() {
                            // For CC_AUTHORIZATION_DECLINED contingency retrieve the checkout session and
                            // 1. For Multi FI - Reload the xo-review page.
                            // 2. For Single FI - Redirect to Add Card contingency page.

                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'CREATE_FI_AUTH',
                                to: 'process_fi_auth',
                                client_epoch_ts: Date.now(),
                                int_error_code: 'CC_AUTHORIZATION_DECLINED'
                            }, fptiData));

                            $scope.checkoutSession.invalidate();
                            $scope.checkoutSession.smartDollarAuthFailed = true;
                            if ($scope.checkoutSession.selectedFuturePaymentInstrument) {
                                // Invalidate the saved FI selection to avoid display of stale selection on review page.
                                delete $scope.checkoutSession.selectedFuturePaymentInstrument;
                            }

                            // Retrieve the checkout session before reloading the xo-review Page.
                            // as we need to get latest declineInstument in the session.
                            return $scope.checkoutSession.retrieve({
                                success: function success() {
                                    $scope.checkoutSession.smartDollarAuthFailed = false;
                                    if ($scope.cancelUpdateListener) {
                                        $scope.cancelUpdateListener();
                                    }

                                    if (!$scope.selectFiVariant) {
                                        _uiRouter.$state.go('checkout.review', { message: 'CC_AUTHORIZATION_DECLINED' }, { reload: true });
                                        return _squid.$promise.shortCircuit();
                                    }

                                    // Check that there is more than one plan to choose from, or that plan is not preferred
                                    var plans = $scope.checkoutSession.get('fundingOptions.plans');
                                    var isPreferredDefault = $scope.skipSelectFiVariants.indexOf($scope.choiceVariant) > -1 && plans && plans[0].primaryFs.isPreferred;
                                    var stickyPlans = $scope.checkoutSession.futurePaymentInstruments;
                                    var hasManyPlans = plans && plans.length > 1;
                                    var hasStickyPlans = stickyPlans && stickyPlans.length > 1;

                                    if (!isPreferredDefault && (hasManyPlans || hasStickyPlans)) {
                                        _uiRouter.$state.go('checkout.selectFi', { newState: true }, { reload: true });
                                    } else {
                                        _uiRouter.$state.go('checkout.review', { message: 'CC_AUTHORIZATION_DECLINED' }, { reload: true });
                                    }
                                    return _squid.$promise.shortCircuit();
                                },
                                contingencies: {
                                    NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                                        // for single FI scenario, if preAuth fails, we would need to redirect to
                                        // Add Credit card contingency page.
                                        _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', { message: 'NEED_CREDIT_CARD', cause: 'cpa' });
                                        return _squid.$promise.shortCircuit();
                                    }
                                }
                            });
                        },
                        DEFAULT: function DEFAULT(name) {
                            // For any error / contingency other than CC_AUTHORIZATION_DECLINED, bypass it and move forward
                            // with Approve call.
                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'CREATE_FI_AUTH',
                                to: 'process_fi_auth',
                                client_epoch_ts: Date.now(),
                                int_error_code: name
                            }, fptiData));
                            return _angular.$q.when();
                        }
                    }
                });
            } else {
                return _angular.$q.when();
            }
        };

        function authorize() {

            function authorizeSuccess() {
                if ($scope.checkoutSession.get('plan.paypal_credit')) {
                    _logger.$logger.info('checkout_fpti', { 'ppc_reuse_status': 'success' });

                    // for PPC reuse radio banner testing we want to indicate whether the user selected PPC via radio button or banner.

                    _logger.$logger.info('checkout_fpti', {
                        from: 'clickPPCReuse',
                        to: 'radio_click'
                    });
                }

                var padToggleStatus = getPadToggleStatus();

                if (padToggleStatus === 'ON') {
                    _logger.$logger.info('checkout_fpti', {
                        'pad_toggle_status': 'padToggleOnSuccess'
                    });
                } else if (padToggleStatus === 'OFF') {
                    _logger.$logger.info('checkout_fpti', {
                        'pad_toggle_status': 'padToggleOffSuccess'
                    });
                }

                // for all tokenized flows except google account linking - log FPTI in authorize sucess callback
                if (!isGoogleAccountLinking && $scope.checkoutCart.isWalletTokenization()) {
                    _tokenizedFactory.$TokenizedFactory.logProcessReviewToFPTI();
                }

                // Just in case, cancel the state change listener checking if updateFs needs to be called
                if ($scope.cancelUpdateListener) {
                    $scope.cancelUpdateListener();
                }

                if ($scope.checkoutSession.get('sepa_mandate.bankId')) {
                    return _uiRouter.$state.go('checkout.sepapage');
                }

                // xchild = V4 Incontext Integration. Do not initiate Payment.
                if (!window.xchild && $scope.checkoutAppData.doec_on_approve()) {
                    return _uiRouter.$state.go('checkout.pay');
                }

                // for all flows except google account linking - go to end of checkout
                // for google account linking - redirect happens in "updateIssuanceScope" call (see tokenizedFactory)
                if (!isGoogleAccountLinking) {
                    return _uiRouter.$state.go('checkout.end');
                }
            }

            // making it as internal function to prevent calling directly
            function internalAuthorize() {
                return $scope.checkoutSession.action('authorize', {
                    batch: isGoogleAccountLinking && _tokenizedFactory.$TokenizedFactory.getAuthorizeBatch(),
                    data: {
                        alternateFundingOptionId: cardBackup && cardBackup.planId
                    },
                    success: authorizeSuccess,
                    contingencies: {
                        // Smart $x authorization check on the card fails
                        CREDIT_CARD_AUTH_FAILED: function CREDIT_CARD_AUTH_FAILED() {
                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'REVIEW',
                                to: 'process_review_err',
                                int_error_code: 'CREDIT_CARD_AUTH_FAILED'
                            }, cpaFptiData));
                            $scope.checkoutSession.invalidate();
                            $scope.checkoutSession.smartDollarAuthFailed = true;
                            if ($scope.checkoutSession.selectedFuturePaymentInstrument) {
                                // Invalidate the saved FI selection to avoid display of stale selection on review page.
                                delete $scope.checkoutSession.selectedFuturePaymentInstrument;
                            }
                            return $scope.checkoutSession.action('create', {
                                success: function success() {
                                    $scope.checkoutSession.smartDollarAuthFailed = false;
                                    $scope.errorHandlerHelper.addPageError('payment.authFailureMultipleFIs');
                                    return _uiRouter.$state.go('checkout.review', { message: 'CREDIT_CARD_AUTH_FAILED' });
                                }
                            });
                        },
                        NEED_DEBIT_CARD: function NEED_DEBIT_CARD() {

                            if ($scope.checkoutCart.isWalletTokenization() && $scope.balanceUsage) {
                                return authorizeSuccess();
                            }
                            _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                        }
                    }
                });
            }

            // 3DS 1.0 FI route to resolve
            if ($scope.checkoutSession.resolve_3ds) {
                _logger.$logger.info('3DS_v1_contingency_thrown');

                return show3DSLightbox();
            } else if ($scope.checkoutSession.threeDSResolutionData) {
                // 3DS ACE route data (call it as 3DSv2.0)
                // this is completely different set of APIs and data needs to be passed
                // grab them all from different source
                _logger.$logger.info('3DS_v2_contingency_thrown');
                return show3dsDDCLightBox();
            }

            function isXoonUpopRedirect() {
                if (!($scope.checkoutSession && $scope.checkoutSession.get('errorData.resolution.data.fi.type'))) {
                    return false;
                }

                return _squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' && $scope.checkoutSession.errorData.resolution.name === 'PAYER_TO_AUTHENTICATE_CARD' && !$scope.checkoutSession.errorData.resolution.data.alternate_options && $scope.checkoutSession.errorData.resolution.data.fi.type.toUpperCase() === 'CUP';
            }

            if ($scope.checkoutSession.unconfirmed_upop || isXoonUpopRedirect()) {
                var card = void 0;

                if ($scope.checkoutSession.unconfirmed_upop) {
                    card = $scope.checkoutSession.unconfirmed_upop;
                } else {
                    card = $scope.checkoutSession.errorData.resolution.data;
                }

                $scope.cardModel = new _fi.$AddCardModel({});
                $scope.cardModel.id = card.fundingId;
                $scope.cardModel.card = new _fi.$CardModel({
                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                    type: card.fi.type.toUpperCase(),
                    productType: card.fi.productType
                });
                _uiRouter.$state.go('.confirmUpop');
                return;
            }

            // Currently, exit message will only be applicable to US. If we'd like
            // to expand exit message feature to other countries, we will need
            // translation from other countries.
            if (applyExitMessage()) {
                // HACK - REMOVE and REFACTOR ONCE DONE
                // overload base.processing in strings
                // since quid is hardcoded to use string each time
                // required only for testing - remove and refactor,
                // to properly allow for dynamic spinner messages

                // resolve merchant name
                var merchantName = pxpMerchName;
                // flag when name is missing or longer than 20 chars
                var badMerchantName = !merchantName || merchantName.length > pxpMerchNameLimit;
                var outroMsg = badMerchantName ? 'We’re sending you back to the merchant to complete this purchase.' : 'We\u2019re sending you back to <strong style="white-space:nowrap">' + merchantName + '</strong> to complete this purchase.';

                // capture current route
                var reviewRoute = _uiRouter.$state.current;

                // listen to !startLoad
                // this is the only way we can then manipulate the spinner
                var cancelOutroOverride = _angular.$rootScope.$on('startLoad', function () {
                    // if this is the review route...
                    // this is needed, in case the session has ended
                    // at this point, we need this listener to do nothing
                    if (_uiRouter.$state.current === reviewRoute) {
                        // force spinner styling and content
                        // this is delayed, because (for some reason)
                        // the spinner isn't in the DOM _yet_,
                        // even though #showSpinner() fired... UGH!
                        (0, _angular.$timeout)(function () {
                            var spinnerMessageEl = (0, _jquery2['default'])('#spinner-message');

                            if (spinnerMessageEl) {
                                spinnerMessageEl = spinnerMessageEl.css({
                                    width: '130%',
                                    marginLeft: '-15%'
                                });
                                if (spinnerMessageEl) {
                                    // setting here, since `ng-bind-html` didn't work in spinner directive
                                    spinnerMessageEl.html(outroMsg);
                                }
                            }
                        }, 1);
                    } else {
                        // (otherwise) when no longer the review route...
                        // this means something happened before redirect
                        // likely an expired session
                        // In that case we'll remove this listener
                        // It will just be re-added, in the next redirect attempt
                        cancelOutroOverride();
                    }
                });

                _angular.$rootScope.$on('$destroy', cancelOutroOverride);
            }

            var cardBackup = $scope.checkoutSession.cardBackup.getPlan();

            _logger.$logger.info('checkout_fpti', {
                from: 'processor_decline_retry',
                to: 'processor_decline_retry_eligibility',
                'is_bkp_funding_chosen': cardBackup && cardBackup.planId ? 1 : 0
            });

            var isGoogleAccountLinking = _tokenizedFactory.$TokenizedFactory.isGoogleAccountLinking();

            // for Google account linking - make a batch call which includes "authorize" call first call
            // and updateIssuaceScope as second
            if (isGoogleAccountLinking) {
                _tokenizedFactory.$TokenizedFactory.updateIssuanceScope();
            }

            /**
             * now we have cleared all contingencies / error in  FI,
             * check for any pre-authorization required
             * possible usecases are CPA (Customer Present Auth)
             * and multi shipment payments (AS2 and BA flows), nothing to do anything with
             * shipping address / shipping amount , multi shipment means , multiple transaction allowed
             * using OrderId or Billing Agrement Id
             */
            var cpaFptiData = {};
            var selectedPlanId = decidePlanSelection() || getDefaultPlanId();
            var selectedPlan = getPlan(selectedPlanId);
            var _$scope$checkoutSessi3 = $scope.checkoutSession.payer;
            _$scope$checkoutSessi3 = _$scope$checkoutSessi3 === undefined ? {} : _$scope$checkoutSessi3;
            var payerId = _$scope$checkoutSessi3.id;
            // if the selected or default plan requires auth

            if (_sharedUtil.$SharedUtil.isSelectedPlanRequiresAuth(selectedPlan)) {
                cpaFptiData = {
                    fi_id: selectedPlan && selectedPlan.primaryFs ? selectedPlan.primaryFs.id : '',
                    plan_id: selectedPlanId,
                    buyer_id: payerId,
                    ryp_button_text: $scope.useraction === 'commit' ? 'PayNow' : 'Continue',
                    client_epoch_ts: Date.now()
                };

                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'REVIEW',
                    to: 'process_review'
                }, createReviewFptiPayload({ checkoutSession: $scope.checkoutSession, isProcessTransition: true }), cpaFptiData));

                // ok, we need to do preauthorize now, before making actual authorize
                return preAuthorize().then(function () {
                    return internalAuthorize();
                });
            } else {
                // if plan  doesn't require any auth - continue with auth
                return internalAuthorize();
            }
        }

        function setShowShippingMethodProperty() {
            return (0, _squid.$populate)($scope, {
                shippingRulesSummary: _shippingMethod.$ShippingRuleSummaryModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        merchant_id: $scope.payee.get('merchant.id'),
                        currency_code: $scope.checkoutCart.get('purchase.amounts.total.currency_code')
                    }
                })
            }).then(function () {
                if ($scope.shippingRulesSummary.isSnTEnabled) {
                    _logger.$logger.info('shipping_rules_summary_snt_enabled');
                } else {
                    _logger.$logger.info('shipping_rules_summary_snt_disabled');
                }
                $scope.showShippingMethod = $scope.shippingRulesSummary.isSnTEnabled || $scope.isInstantUpdateAPIFlow;
                return;
            });
        }

        function show3DSDeclineMsg(declineAfter3DSAccept) {
            // Instrument number of available plans for 3DS decline case.
            var numberOfPlans = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : 0;

            _logger.$logger.info('3DS_decline_plan_count', { 'plans': numberOfPlans });

            var key = 'threeDS.memberDecline';

            if (declineAfter3DSAccept) {
                key = 'threeDS.memberDeclineAfter3DSAccept';
            }

            // extract card information from 3DS V1 contingency context
            var card = $scope.checkoutSession && $scope.checkoutSession.resolve_3ds;

            // extract card information from 3DS V2 contingency context
            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref6 = threeDSResolutionData && threeDSResolutionData.resolutions || [],
                resolutions = _ref6[0];

            var _ref7 = resolutions || {},
                _ref7$funding_instrum = _ref7.funding_instrument_details;

            _ref7$funding_instrum = _ref7$funding_instrum === undefined ? {} : _ref7$funding_instrum;
            var _ref7$funding_instrum2 = _ref7$funding_instrum.payment_card,
                payment_card = _ref7$funding_instrum2 === undefined ? {} : _ref7$funding_instrum2;

            // consider V1 or V2 card data

            var cardInformation = card || payment_card;

            if (cardInformation) {
                var msg = (0, _squid.$renderContent)(key, {
                    cardType: cardInformation.type,
                    last4: cardInformation.number
                });

                $scope.checkoutSession.message = {
                    msgs: [msg],
                    type: 'warning'
                };
            }
        }

        /**
         * call patchXO API to clear the 3DS contingency and then call authorize API.
         */
        function clear3DSContingency() {
            _logger.$logger.info('3DS_v1_clear_contingency');
            var resolve_3ds = $scope.checkoutSession.resolve_3ds || {};

            return $scope.checkoutSession.action('clear3DSContingency', {
                data: {
                    ccId: resolve_3ds.ccId
                },
                success: function success() {
                    // Clear3DSContingency can change the plan ids, so reset the multipleFi indicator after this is called
                    if ($scope.setupMultipleFi) {
                        $scope.setupMultipleFi();
                    }

                    if (!$scope.checkoutSession.resolve_3ds) {
                        return authorize();
                    } else {
                        // Symphony is not able to clear the 3DS contingency
                        show3DSDeclineMsg(true);
                    }
                }
            });
        }

        /*
         * call to update the three ds status into checkout session
         * unlike 3DS V1 , we need to update the status with reference Id
         * 3DS reference id, and lookup or authenticaton id needs to passed
         * at the time of fulfillment
         */
        function updatethreedsStatus(status, threeDSTransactionId) {
            _logger.$logger.info('3DS_v2_clear_contingency');

            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref8 = threeDSResolutionData.resolutions || [],
                resolutions = _ref8[0];

            var _ref9 = resolutions || {},
                _ref9$funding_instrum = _ref9.funding_instrument_details;

            _ref9$funding_instrum = _ref9$funding_instrum === undefined ? {} : _ref9$funding_instrum;
            var _ref9$funding_instrum2 = _ref9$funding_instrum.payment_card,
                payment_card = _ref9$funding_instrum2 === undefined ? {} : _ref9$funding_instrum2,
                _ref9$funding_instrum3 = _ref9$funding_instrum.three_ds_contingency_context,
                three_ds_contingency_context = _ref9$funding_instrum3 === undefined ? {} : _ref9$funding_instrum3;

            // pass below information to blacklist if any of the 3DS resolution failed

            var cc_id = payment_card.id; // ex: CC-XUBYA6TH5RJ2G
            var card_number = payment_card.number;
            var card_type = payment_card.type;
            var referenceId = three_ds_contingency_context.reference_id;

            return $scope.checkoutSession.action('clear3DSContingency', {
                resultModel: $scope.checkoutSession,
                data: {
                    ccId: cc_id,
                    status: status !== 'SUCCESS' ? 'FAILURE' : status,
                    authId: threeDSTransactionId,
                    referenceId: referenceId
                },
                success: function success() {
                    // Clear3DSContingency can change the plan ids, so reset the multipleFi indicator after this is called
                    if ($scope.setupMultipleFi) {
                        $scope.setupMultipleFi();
                    }

                    if (!$scope.checkoutSession.threeDSResolutionData && status === 'SUCCESS') {
                        // if checkout session not having contingency and if 3DS success, continue with authorize
                        return authorize();
                    } else {
                        // Symphony might blacklist the earlier failed instrument
                        // inform about this with a error message
                        _logger.$logger.info('3DS_v1_black_listed_instrument');
                        var key = 'threeDS.memberDecline';

                        if (card_number) {
                            var msg = (0, _squid.$renderContent)(key, {
                                cardType: card_type,
                                last4: card_number
                            });

                            $scope.checkoutSession.message = {
                                msgs: [msg],
                                type: 'warning'
                            };
                        }
                    }
                }
            });
        }

        $scope.onComplete3DSHandler = function (status) {
            $scope.launch3DSResolver = false;
            if (status === 'success') {
                return clear3DSContingency();
            } else if (status === 'decline') {
                // 3DS got declined
                show3DSDeclineMsg();
            }
        };

        $scope.isOptionalVaulting = function () {
            var optionalVaulting = false;
            if ($scope.checkoutCart.billing && $scope.checkoutCart.billing.save_paypal_as_option && _squid.$config.baOptOutEnabledCountries.indexOf(_squid.$locale.country) > -1) {
                optionalVaulting = true;
            }
            return optionalVaulting;
        };

        $scope.getOptInContent = function () {
            var key = 'billingAgreement.bal' + ($scope.eligibleToHoldBalance ? 'Eligible' : 'Ineligible') + 'Vault' + ($scope.vault.checked ? 'Optin' : 'Optout');
            return (0, _squid.$renderContent)(key, { merchantName: $scope.merchantName, country: _squid.$locale.country, lang: _squid.$locale.lang });
        };

        $scope.changeVaultSelection = function () {
            _logger.$logger.info('optional_vault_user_selection_' + $scope.vault.checked);
        };

        $scope.onCompletethreedsHandler = function (status, transactionId) {
            $scope.showThreedsPopup = false;
            // safely convert the status
            if (status.toLowerCase() === 'success') {
                return updatethreedsStatus(status, transactionId.threeDSTransactionId);
            } else {
                // display 3DS decline message
                show3DSDeclineMsg();
            }
        };

        $scope.upopCallbacks = {
            onConfirmUpopSuccess: function onConfirmUpopSuccess() {
                _uiRouter.$state.go('checkout.review');
                return $scope.checkoutSession.action('clearContingency', {
                    data: {
                        contingency: 'UNCONFIRMED_UPOP',
                        ccId: $scope.checkoutSession.get('unconfirmed_upop.fundingId') || $scope.checkoutSession.get('errorData.resolution.data.fundingId')
                    },
                    success: function success() {
                        if (!$scope.checkoutSession.unconfirmed_upop) {
                            return authorize();
                        } else {
                            $scope.checkoutSession.message = {
                                type: 'warning',
                                msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                            };
                        }
                    }
                });
            },
            onConfirmUpopCancel: function onConfirmUpopCancel() {
                _uiRouter.$state.go('checkout.review');
                $scope.showUnconfirmedUpopMsg = false;
                $scope.checkoutSession.message = {
                    type: 'warning',
                    msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                };
            }
        };

        $scope.errorHandlerHelper = {};
        $scope.errorHandlerHelper.addPageError = function (contentKey, dynamicValuesInContent) {
            var messages = [];
            var msg = void 0;

            if (dynamicValuesInContent) {
                msg = (0, _squid.$renderContent)(contentKey, dynamicValuesInContent);
            } else {
                msg = _squid.$locale.content.get(contentKey);
            }

            messages.push(msg);
            $scope.checkoutSession.message = {
                msgs: messages,
                type: 'error'
            };
        };

        $scope.errorHandlerHelper.clearPageErrors = function () {
            $scope.checkoutSession.message = '';
        };

        $scope.returnFromCape = function (isCapeReturnKey) {

            return $scope.creditDataModel.action('readCreditKey', {
                data: {
                    capeKey: isCapeReturnKey
                },
                success: function success(res) {
                    // if CAPE includes this field inside the mayfly payload, we will show-up a warning message
                    // on the top of the page ('offers.bmlInWalletDeniedMsg') regarding the declined credit application
                    if (res.show_cape_declined_msg) {
                        $scope.checkoutSession.message = {
                            type: 'warning',
                            msgKeys: ['offers.bmlInWalletDeniedMsg']
                        };
                    }
                    // TODO: We want to remove this condition and make the two calls in parallel.
                    if (res.financial_instrument_id) {
                        var financial_instrument_id = res.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + res.financial_instrument_id : res.financial_instrument_id;

                        if (res.financial_instrument_details) {
                            return $scope.creditOptions.action('select', {
                                data: Object.assign({}, res.financial_instrument_details, { nominal_rate: undefined }),
                                success: function success() {
                                    $scope.installment.financing_details = res.financial_instrument_details;
                                    $scope.installment.showCYCO = false;

                                    if (_squid.$locale.country === 'DE' && res.credit_account_id) {
                                        return $scope.checkoutSession.fundingOptions.action('add', {
                                            resultModel: $scope.checkoutSession,
                                            data: {
                                                financialInstrumentID: financial_instrument_id,
                                                creditAccountID: res.credit_account_id,
                                                creditProductType: 'BILL_ME_LATER'
                                            },
                                            success: function success(result) {
                                                if ($scope.setupMultipleFi) {
                                                    $scope.setupMultipleFi();
                                                }
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            },
                                            error: function error() {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            }
                                        });
                                    } else {
                                        return $scope.checkoutSession.fundingOptions.action('update', {
                                            resultModel: $scope.checkoutSession,
                                            data: {
                                                planId: financial_instrument_id
                                            },
                                            success: function success(result) {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                                if (_squid.$locale.country !== 'DE' && $scope.isCapeReturnApproval && !res.is_reuse) {
                                                    $scope.checkoutSession.message = {
                                                        type: 'success',
                                                        msgKeys: ['offers.bmlInWalletSuccessMsg']
                                                    };
                                                }
                                                if ($scope.setupMultipleFi) {
                                                    $scope.setupMultipleFi();
                                                }
                                            },
                                            error: function error() {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            }
                                        });
                                    }
                                },
                                error: function error() {
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                }
                            });
                        } else {
                            return $scope.checkoutSession.fundingOptions.action('update', {
                                resultModel: $scope.checkoutSession,
                                data: {
                                    planId: financial_instrument_id
                                },
                                success: function success(result) {
                                    if ($scope.creditOptions.creditType === 'INST' && $scope.creditOptions.paypalSubsidy && (_squid.$locale.country === 'US' || _squid.$locale.country === 'GB')) {
                                        // This will prevent users from seeing GPL RYI details when PPC FI is selected, this issue was being caused by GPL in-house installments
                                        delete $scope.creditOptions.creditType;
                                    }
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                    if (_squid.$locale.country !== 'DE' && $scope.isCapeReturnApproval && !res.is_reuse) {
                                        $scope.checkoutSession.message = {
                                            type: 'success',
                                            msgKeys: ['offers.bmlInWalletSuccessMsg']
                                        };
                                    }
                                    if ($scope.setupMultipleFi) {
                                        $scope.setupMultipleFi();
                                    }
                                },
                                error: function error() {
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                }
                            });
                        }
                    } else {
                        $scope.creditDataModel.setReturnFromCapeComplete(true);
                        // User does not have any FI in wallet and they choose to pay in full.
                        if (!$scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.isCreditPromoted) {
                            _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                        } else if ($scope.creditDataModel.isCapeInternalServiceError()) {
                            // Todo Show error message from CAPE
                            return _angular.$q.when();
                        } else {
                            return _angular.$q.when();
                        }
                    }
                },
                error: function error() {
                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        $scope.creditDataModel.setReturnFromCapeComplete(true);
                        _logger.$logger.info('read_cape_key_failure');
                        return _angular.$q.when();
                    }
                }
            });
        };

        var ifPadThenUpdatePlan = function ifPadThenUpdatePlan(selectedMethodPlanId) {
            // For pad toggle feature with Choice Multi FI experience, we look up the plan ID here
            var padOrIachPlanId = _factory8.$PADFactory.isPadToggleFeatureApplicable($scope.padToggleFeature, $scope.isPadToggleEnabled) && _factory8.$PADFactory.getPadOrIachBankPlanId({
                selectedMethodPlanId: selectedMethodPlanId,
                fundingOptions: $scope.checkoutSession.fundingOptions,
                multiFiCheckboxStates: $scope.padToggleFeature.multiFiCheckboxStates
            });

            return padOrIachPlanId ? padOrIachPlanId : selectedMethodPlanId;
        };

        /**
         *  Decides the plan to use based on
         *  Pad, Credit, Rewards and any other
         *  bussiness logic
         *
         * @returns planID
         */
        var decidePlanSelection = function decidePlanSelection() {
            // TODO: Consider moving this to a generic wallet/plan factory
            // this will avoid repetition in RYI, SelectFI and PayWith
            var defaultPlan = $scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.get('plan.sources')[0];
            var hasRewards = _factory3.$RewardsCheckboxFactory.isRewardsPlan($scope.checkoutSession.plan);
            var selectedMethodPlanId = (0, _utils.getSelectedPlan)($scope.selectedmethod, $scope.checkoutSession);

            if (!$scope.selectedmethod && !hasRewards) {
                return '';
            }

            selectedMethodPlanId = ifPadThenUpdatePlan(selectedMethodPlanId);
            selectedMethodPlanId = _factory3.$RewardsCheckboxFactory.ifRewardsThenUpdatePlan(selectedMethodPlanId, $scope.selectedmethod, $scope.checkoutSession);

            // If the plan is already selected, we don't need to duplicate the call
            if (selectedMethodPlanId === (defaultPlan && defaultPlan.id)) {
                return '';
            }

            // This is handled in onPay
            if (selectedMethodPlanId === 'applyForPPCRadio') {
                return '';
            }
            return selectedMethodPlanId;
        };

        /**
         *  Given a plan id perform a selection
         *  and handle any errors/contingencies
         *
         * @returns planID
         */
        var doPlanSelection = function doPlanSelection(selectedMethodPlanId) {
            return $scope.checkoutSession.fundingOptions.action('select', {
                data: {
                    planId: selectedMethodPlanId
                },
                success: function success(result) {
                    $scope.checkoutSession.populate(result);

                    // for multi fi use case after replan we need to reset index to 0
                    // since selected instrument will always be first
                    if ($scope.selectedmethod) {
                        $scope.selectedmethod.index = 0;
                    }

                    // Double check on PayPal balance eligibility after CheckoutSession re-plan
                    return _balance.$BalanceEligibilityFactory.init({ checkoutSession: $scope.checkoutSession }).then(function (currentState) {
                        return shouldEnableBalance(currentState);
                    });
                },
                contingencies: {
                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                        // Route to the Confirm Upop page
                        if (result && result.resolution) {
                            var card = result.resolution.data;

                            if (card.fundingId && card.fi && card.fi.type) {
                                $scope.cardModel = new _fi.$AddCardModel();
                                $scope.cardModel.id = card.fundingId;
                                $scope.cardModel.card = new _fi.$CardModel({
                                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                    type: card.fi.type.toUpperCase(),
                                    productType: card.fi.productType
                                });
                            }
                        }

                        // Before routing to confirm Upop route, we cancel the state change listener so that we don't call updateFS. At this point, the user has already made their selection, so this is unneeded.
                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Route to the Confirm Upop page. We'll hold on to this deferred promise until the confirmation flow is finished, so we can then continue the chain or cancel out
                        var upopResult = _angular.$q.defer();

                        // Create the handlers for Upop, specifically for this flow. They will act on the deferred promise when the flow is completed
                        $scope.upopCallbacks.isOnUpdate = true;
                        $scope.upopCallbacks.onUpdateSuccess = function () {
                            // On confirmed, update the checkout session then continue
                            return $scope.checkoutSession.fundingOptions.action('update', {
                                resultModel: $scope.checkoutSession,
                                silent: true,
                                data: {
                                    planId: $scope.cardModel.id
                                },
                                success: function success() {
                                    if ($scope.checkoutSession.cvvData) {
                                        $scope.checkoutSession.set('cvvData.security_code', $scope.cardModel.get('card.security_code'));
                                    }

                                    // Reset the callback flag
                                    $scope.upopCallbacks.isOnUpdate = false;
                                    $scope.setupMultipleFi();
                                    // Return to this route, resolve the promise
                                    _uiRouter.$state.go('checkout.review');
                                    upopResult.resolve();
                                }
                            });
                        };
                        $scope.upopCallbacks.onUpdateCancel = function () {
                            // Break the promise chain and return to the review page
                            $scope.upopCallbacks.isOnUpdate = false;
                            $scope.setupMultipleFi();
                            upopResult.reject();
                            $scope.upopCallbacks.onConfirmUpopCancel();
                        };

                        _uiRouter.$state.go('.confirmUpop');
                        return upopResult.promise;
                    }
                }
            });
        };

        // For the multiple FI variant of the choice experiment:
        // Update the funding option in the plan based on the user's stored selection
        var updateFS = function updateFS() {
            // Decide plan to select based on priority and bussness logic
            var selectedMethodPlanId = decidePlanSelection();

            // Perform a selection only if required
            return selectedMethodPlanId ? doPlanSelection(selectedMethodPlanId) : _angular.$q.when();
        };

        var getBalanceEligibility = function getBalanceEligibility() {
            return _user.$UserEligibleToHoldBalanceModel.instance().retrieve().then(function (res) {
                var eligibleToHoldBalance = res && res.eligibleToHoldBalance;
                _logger.$logger.info('balance_eligibility_STATUS', { eligibleToHoldBalance: eligibleToHoldBalance });
                return eligibleToHoldBalance;
            })['catch'](function () {
                _logger.$logger.info('balance_eligibility_STATUS_CHECK_ERROR');
                return false;
            });
        };

        // The following functions are all used in the `$q.all` promise chain below
        var populateScope = function populateScope() {
            return (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                fiMeta: _index4['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
            }).then(function () {
                return _angular.$q.all([_this2.resolve.noBalanceExp(), _this2.resolve.disallowedBalanceExp()]);
            }).then(function (_ref10) {
                var noBalance = _ref10[0],
                    disallowedBalance = _ref10[1];

                // set the cpa eligible to get used  in review page to display CPA  error message and etc
                $scope.isCPAEligible = _sharedUtil.$SharedUtil.isAuthRequiredInAnyFI($scope.checkoutSession) || _sharedUtil.$SharedUtil.isAuthDeclinedInstrument($scope.checkoutSession);
                $scope.noBalance = noBalance.enabled && _factory2.$NoBalanceFactory.hasUserPendingBalance();
                $scope.disallowedBalance = disallowedBalance.enabled && $scope.checkoutSession.isBalanceDisallowed();
            }).then(function () {
                return $scope.isOptionalVaulting() && getBalanceEligibility().then(function (eligibleToHoldBalance) {
                    $scope.eligibleToHoldBalance = eligibleToHoldBalance;
                });
            });
        };

        /* Flag to determine whether merchant supports callback shipping options for given address
         1. Default : true
         2. shippingRegionSupported : false -> Show shipping region not supported error in review page and do not allow Pay
         */
        $scope.instantUpdateFeature = {
            shippingRegionSupported: true
        };
        $scope.shippingChangeFeature = {};

        var initAndCallOnShippingChange = function initAndCallOnShippingChange() {
            $scope.shippingChangeFeature = (0, _shippingChangeFeature.createShippingChangeFeature)({
                orderID: $scope.token,
                checkoutCart: $scope.checkoutCart,
                checkoutSession: $scope.checkoutSession,
                checkoutAppData: $scope.checkoutAppData,
                callbackFn: function callbackFn() {
                    /*
                      This function gets called after the onShippingChange
                      function is called on the merchant's page.
                    */
                    $scope.checkoutSession.reload().then(function () {
                        return $scope.checkForShippingOptions();
                    });
                }
            });

            $scope.shippingChangeFeature.callOnShippingChange();
        };

        var initializePadToggleSupport = function initializePadToggleSupport() {
            if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                return Experiments.padToggleFeatureSupported().then(function (result) {
                    $scope.isPadToggleEnabled = result;
                });
            } else {
                return _angular.$q.when($scope.isPadToggleEnabled = false);
            }
        };

        var initPPBalanceFlow = function initPPBalanceFlow() {
            $scope.PPBalanceFlow = _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale);
        };

        var initBalanceUsage = function initBalanceUsage() {
            return (0, _squid.$elmo)('paypal:isdc:products:balance:usage:us', {
                'filters.Country': _squid.$locale.country
            }, 'Trmt_balance_usage_us_products').then(function (balanceUsage) {
                $scope.balanceUsage = Boolean(balanceUsage && balanceUsage.treatment_name);
            });
        };

        var applyChoiceExperimentVariant = function applyChoiceExperimentVariant() {
            $scope.tagFamilyComputer();
            // Get the choice experiment variant to determine what needs to be shown in the UI
            return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                $scope.choiceVariant = variant;
                var checkboxVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];
                var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];
                var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                $scope.skipSelectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.skipSelectFi || [];

                if (checkboxVariants.indexOf(variant) !== -1 && !$scope.checkoutCart.isBilling() && !$scope.checkoutCart.referenceCheckout) {
                    // Do setup for preferred checkbox
                    $scope.makeFiPreferred = {
                        selected: false
                    };
                }

                $scope.showMultipleFiVariants = multipleFiVariants.indexOf(variant) !== -1;

                if ($scope.showMultipleFiVariants) {
                    // Do the setup for the multipleFiVariant
                    $scope.setupMultipleFi = function () {
                        var planList = $scope.checkoutSession.get('plan.sources');
                        var defaultPlanId = planList && planList[0] && planList[0].id;
                        $scope.selectedmethod = {
                            index: 0,
                            planId: defaultPlanId
                        };

                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Before changing state, persist the change that the user selected
                        var stateChangeListener = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                            $scope.cancelUpdateListener();

                            // ensure we only listen to state changes initiated from the review page
                            if (_uiRouter.$state.fromState.name !== 'checkout.review') {
                                return;
                            }

                            // ignore if the FI selection hasn't been updated
                            if (defaultPlanId === $scope.selectedmethod && $scope.selectedmethod.planId) {
                                return;
                            }

                            event.preventDefault();
                            updateFS().then(function () {
                                return _uiRouter.$state.go(toState, toParams);
                            });
                        });

                        // If the checkout session changes, also change the planId according to the selected index in case plan ids were changed. Save the listener to destroy the handler when changing routes or re-calling setupMultipleFi
                        var fundingOptionsListener = $scope.$watch('checkoutSession.fundingOptions', function (newVal, oldVal) {
                            if (!newVal) {
                                return;
                            }

                            $scope.selectedmethod.planId = newVal.get('plans.' + $scope.selectedmethod.index + '.planId');
                        });

                        $scope.cancelUpdateListener = function () {
                            stateChangeListener();
                            fundingOptionsListener();
                        };

                        $scope.$on('$destroy', $scope.cancelUpdateListener);
                    };

                    $scope.setupMultipleFi();
                }

                $scope.selectFiVariant = selectFiVariants.indexOf(variant) !== -1;

                if ($scope.isProcessorDeclineExperiment && $scope.selectFiVariant) {
                    $scope.hideBlacklistMsg = true;
                }
                // If there are decline instrument and customer is eligible for CPA, we dont want to show any existing message to user.
                // instead CPA message would be shown. A separate component 'decline-notification' has been created for this.
                if ($scope.isCPAEligible && $scope.checkoutSession.declinedInstruments && $scope.checkoutSession.declinedInstruments.length) {
                    $scope.hideBlacklistMsg = true;
                }
            })['catch'](function (err) {
                // TODO: Check what happens to PXP errors
                _logger.$logger.error('choice_eligibility_error', err);
            });
        };

        var applyMerchantName = function applyMerchantName() {
            // resolve merchant name now, just in case we're in a matching treatment
            pxpMerchName = (0, _sanitizeCaja2['default'])($scope.checkoutAppData.merchant.brand_name || $scope.checkoutAppData.merchant.merchant_name);
        };

        // Set the checks to allow the checkout button to be clicked
        $scope.showMissingShippingOptionMessage = false;
        $scope.showMissingPickupOptionMessage = false;

        // if IXO is providing shipping methods, we'll send them to xo-shipping-options component
        $scope.checkForShippingOptions = function () {
            return (0, _xoShippingOptions.getShippingOptions)($scope.token).then(function (options) {
                _logger.$logger.info('new_options_loaded', { options: options });
                $scope.shippingOptions = options;
            }).then(function () {
                return (0, _xoShippingOptions.getSelectedShippingOption)($scope.token);
            }).then(function (selectedOption) {
                _logger.$logger.info('new_option_selected', { selectedOption: selectedOption });
                $scope.selectedShippingOption = selectedOption;
            });
        };

        $scope.selectShippingOption = function (option, checkShippingWarn, checkPickupWarn) {
            $scope.showMissingPickupOptionMessage = checkPickupWarn;
            $scope.showMissingShippingOptionMessage = checkShippingWarn;

            if (!option) {
                return;
            }

            return (0, _xoShippingOptions.selectShippingOption)($scope.token, option).then(function () {

                // If the merchant is integrated with
                // the Callback API, let's call it and then
                // replan through that flow

                if ((0, _shippingChangeFeature.hasOnShippingChangeCallback)()) {
                    return $scope.shippingChangeFeature.callOnShippingChange();
                }

                return _angular.$q.when();
            });
        };

        /**
         * Set up $watch for if `showMore` button has been clicked.
         * When `showMore` button has been clicked, we also need to
         * log all FIs that has a cardart FI
         */
        $scope.$watch(function () {
            return _factory4.$ShowMoreFiFactory.get().isShowMoreBtnClicked;
        }, function (clickedMore) {
            // ensure `showMore` button has been clicked for 3FIs pxp
            if (clickedMore) {
                logSessionDetails();
            }
        });

        var showGAC = function showGAC() {
            _factory.$GiveAtCheckoutFactory.decideEligibility().then(function (result) {
                $scope.isDonation = _factory.$GiveAtCheckoutFactory.get().eligible;
                var charity = _factory.$GiveAtCheckoutFactory.get().charity;

                if (_factory.$GiveAtCheckoutFactory.get().eligible) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'GIVE_AT_CHECKOUT',
                        to: 'prepare_give_at_checkout',
                        gac_model: charity.model_id,
                        gac_npid: charity.nonprofit_id
                    });
                }
            });
        };

        /**
         * Cardart instrumentation for review page comes in a few variations, and
         * it all depends on the pxp result. Following logSessionDetails()
         * logs cardart instrumentation based on:
         *
         * - showMultipleFiVariants pxp
         * - showMultipleFiVariants + 3FI pxp
         * - singleFI pxp
         *
         * See $CardArtInstrument.createPayload() for detailed implementation & explanation
         */
        var logSessionDetails = function logSessionDetails() {
            var isCardArtExp = _cardartInstrument.$CardArtInstrument.isCardArtEnable($scope.fiMeta) && !$scope.isThirdPartyWalletExperience();
            var renderMultipleFi = $scope.showMultipleFiVariants;
            var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
            var isBilling = $scope.checkoutCart.isBilling();
            var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.get('merchant.id')) > -1;
            var stickyEligible = isBilling && !disableStickyForMerchant;

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'prepare_review'
            }, createReviewFptiPayload({ checkoutSession: $scope.checkoutSession }), isCardArtExp ? _cardartInstrument.$CardArtInstrument.createPayload({
                stickyEligible: stickyEligible,
                isBillingNoPurchase: isBillingNoPurchase,
                renderMultipleFi: renderMultipleFi,
                checkoutSession: $scope.checkoutSession,
                renderSingleFi: !$scope.showMultipleFiVariants,
                showMoreFiState: _factory4.$ShowMoreFiFactory.get()
            }) : null));
            // Log details about checkout session
        };

        // Reg E - Regulation E compliance guide mandates invoicing payers see a disclaimer message during payment review when RTR is present.
        // The Remittance Transfer Rule (RTR) is a rule published by the Consumer Financial Protection Bureau.
        // It applies to companies processing remittance transfers of more than $15 USD from a US-based consumer (Sender) to a foreign-based receiver (Recipient).
        var applyInvoicingRegEDetails = function applyInvoicingRegEDetails() {
            // Show invoicing RegE compliance message if its invoicing flow only and if RTR is present
            $scope.showInvoicingRegEMsg = $scope.checkoutAppData.flags.is_invoice_flow && $scope.checkoutSession.showRemittanceDisclosure ? true : false;

            _logger.$logger.info('show_invoicing_regE_msg', $scope.showInvoicingRegEMsg);

            if ($scope.showInvoicingRegEMsg) {
                var totalAmount = $scope.checkoutCart.purchase.amounts.total.amount_formatted_currency;
                var merchantName = $scope.checkoutAppData.merchant.brand_name;

                // The RegE message differs for cases with and without currency conversion
                if ($scope.checkoutSession.plan.hasConversion()) {
                    var total = 0;
                    var planSources = $scope.checkoutSession.get('plan.sources');
                    var currencyCode = planSources[0].amount.currency_code;

                    planSources.forEach(function (source) {
                        if (currencyCode !== source.amount.currency_code) {
                            $scope.showInvoicingRegEMsg = false;
                            return;
                        }

                        total = total + Number(source.amount.amount);
                    });

                    var totalInvoicePaymentAmount = (0, _squid.formatCurrency)(total, currencyCode);

                    $scope.invoicingRegEMsg = (0, _squid.$renderContent)('memberReview.invRegEMsgWithCurrConv', {
                        merchantName: merchantName,
                        amountInPayerCurrency: totalInvoicePaymentAmount,
                        amountInInvCurrency: totalAmount
                    });
                } else {
                    $scope.invoicingRegEMsg = (0, _squid.$renderContent)('memberReview.invRegEMsg', {
                        merchantName: merchantName,
                        amount: totalAmount
                    });
                }
            }
        };

        var showPaymentServiceActContent = function showPaymentServiceActContent() {
            // Payment Service Act, passed by the Singapore Gov. applies to SG customers only.

            $scope.isPaymentServiceActApplied = function () {
                if (_squid.$locale.country === 'SG' && (_integration.$integration.isFlow('WPS') || $scope.checkoutAppData.flags.is_invoice_flow || $scope.checkoutCart.isBilling())) {
                    return true;
                }
            };

            // If SG, then shows APAC compliance message
            $scope.shouldDisplayAPACDisclaimer = function () {
                if (_squid.$locale.country === 'SG' && !_integration.$integration.isFlow('WPS') && !$scope.checkoutAppData.flags.is_invoice_flow && !$scope.checkoutCart.isBilling()) {
                    return true;
                }
            };

            $scope.showBAPolicyAgreement = $scope.isPaymentServiceActApplied() && $scope.checkoutCart.isBilling();
        };

        // method to decide to show RTR language toggle
        var showLanguageToggleForRTR = function showLanguageToggleForRTR() {
            // get details about invoice and RTR decision
            var isRTRFlow = $scope.checkoutAppData.flags.is_invoice_flow && $scope.checkoutSession.showRemittanceDisclosure ? true : false;

            if (isRTRFlow) {
                if ($scope.checkoutSession.plan.hasConversion()) {
                    /**
                     * if RTR flow - compliance ask is to show a language toggle to switch
                     * between english and buyer's profile language (if both are english ignore showing this toggle)
                     */
                    var languageIgnoreToggle = 'en';
                    if (_squid.$locale.lang !== languageIgnoreToggle) {
                        _logger.$logger.info('show_invoicing_language_toggle', $scope.showInvoicingRegEMsg);
                        $scope.showRTRLanguageToggle = true;
                        $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                            language: (0, _squid.$renderContent)('languages.' + languageIgnoreToggle).toString()
                        });
                    }
                }
            }
        };

        // method to reload the page with selected locale
        $scope.reloadPageLanguageToggle = function () {
            if (_squid.$locale.lang === 'en') {
                _logger.$logger.info('rtr_toggle_to_' + $scope.buyerProfileLanguage);
                _squid.$locale.change(_squid.$locale.country, $scope.buyerProfileLanguage);
                applyInvoicingRegEDetails();
            } else {
                _logger.$logger.info('rtr_toggle_to_en');
                _squid.$locale.change(_squid.$locale.country, 'en');
                applyInvoicingRegEDetails();
            }
        };

        // method to change the RTR localized content - call for every locale change
        function changeRTRContent() {
            if (_squid.$locale.lang === 'en') {
                $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                    language: (0, _squid.$renderContent)('languages.' + $scope.buyerProfileLanguage).toString()
                });
            } else {
                $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                    language: (0, _squid.$renderContent)('languages.en').toString()
                });
            }
        }
        $scope.$on('localeChange', changeRTRContent);

        var applyKmliUpsellEligibility = function applyKmliUpsellEligibility() {
            if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon') {
                var fiModel = $scope.checkoutSession.get('plan.sources');

                if (fiModel && fiModel.length && fiModel[0].card_type === 'CHINA_UNION_PAY') {
                    $scope.checkoutSession.message = {
                        msgKeys: ['confirmUpop.confirmUpopToPay'],
                        type: 'warning'
                    };
                }
            }

            _kmliUpsell.$KmliUpsell.eligible().then(function (eligibility) {
                eligibility.interstitial = eligibility.interstitial ? eligibility.interstitial : {};
                $scope.optin_toggle.isEnabled = eligibility.banner;
                $scope.optin_toggle.value = $scope.auth.rememberedOT() // came in as OneTouch user
                || $scope.auth.isKmliSet // used to set toggle value via interstial
                || $scope.auth.loggedIn() && $scope.auth.refreshToken(); // FirstTime OT (check this for webview case)
                delete $scope.auth.isKmliSet;

                $scope.optin_toggle.showExpandedTerms = false; // collapse by default;
                var cookiePayload = {};

                if (eligibility.interstitial.eligible) {
                    // show optin interstitial only once per user per version
                    cookiePayload.ot_inter_shown = eligibility.interstitial.pxpVersion; // cookieList.push({ name: 'ot_inter_shown', value: eligibility.interstitial.pxpVersion });
                }
                if (Object.keys(cookiePayload).length > 0) {
                    $scope.auth.action('updateAuthExperience', {
                        silent: true,
                        data: cookiePayload
                    }).then(function (res) {
                        _logger.$logger.debug('optin_toggle_cookie_drop_success', res);
                    })['catch'](function (err) {
                        _logger.$logger.debug('optin_toggle_cookie_drop_err', err);
                    });
                }
                _logger.$logger.info('optin_toggle_init', $scope.optin_toggle);
            });

            $scope.personalizedBanner.trigger();
            $scope.showRemittanceDisclosure = _index2.$DeviceInfo.isMobile() && $scope.checkoutSession.showRemittanceDisclosure ? true : false;
        };

        // applyCreditOptions could potentially redirect out of the RYI.
        var applyCreditOptions = function applyCreditOptions() {
            $scope.creditDataModel = _credit.$CreditDataModel.instance($scope.token);
            var isChangeInstallments = $scope.creditDataModel.isChangeStatus();
            var isCapeReturnKey = $scope.creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');

            // value of success url param is true indicates user was approved
            $scope.isCapeReturnApproval = isCapeReturnKey && _squid.$util.param('success') === 'true';

            if (isChangeInstallments) {
                if ($scope.creditSharedInfo.getRedirectToCapeCyco()) {
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            }
            if (isCapeReturn) {
                $scope.returnFromCape(isCapeReturnKey);
            }

            if (((0, _squid.$feature)('creditInstallmentOffers') || _squid.$locale.country === 'DE') && ($scope.checkoutSession.get('plan.paypal_credit') || isCapeReturnKey)) {
                $scope.creditOptions = _credit.$CreditInstallmentModel.instance($scope.token);
                $scope.creditOptions.retrieve().then(function () {
                    if ($scope.creditOptions.totalPayment) {
                        $scope.installment.financing_details = {
                            apr: $scope.creditOptions.apr,
                            credit_type: $scope.creditOptions.creditType,
                            monthly_payment: $scope.creditOptions.monthlyPayment,
                            term: $scope.creditOptions.term,
                            total_cost: $scope.creditOptions.totalPayment,
                            total_interest: $scope.creditOptions.totalInterest,
                            currency: $scope.cartCurrency
                        };
                    }
                    $scope.creditOptions.apr = String($scope.creditOptions.apr);
                });
            }

            $scope.cartCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');

            // this function returns true if plan sources contains exactly PPCredit & Incentive
            $scope.isCreditIncentiveOption = function () {
                var plans = $scope.checkoutSession.get('plan.sources', null);

                if (plans && plans.length === 2 && plans.filter(function (fi) {
                    return fi.type === 'BILL_ME_LATER';
                }).length === 1 && plans.filter(function (fi) {
                    return fi.type === 'INCENTIVE';
                }).length === 1) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.isPPCReuseAndNotSelected = function () {
                var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
                if (plans && plans.filter(function (fi) {
                    return fi.name === 'BILL_ME_LATER' && !fi.selected;
                }).length === 1) {
                    return true;
                } else {
                    return false;
                }
            };

            // Tracking customers preferences for using PPC if it is a preferred FI
            var preferred_plan = $scope.checkoutSession.fundingOptions.getPreferred();
            _logger.$logger.info('checkout_fpti', {
                from: 'REVIEW_PREFERRED_FI',
                pref_fi_option_shown: preferred_plan && preferred_plan.primaryFs && preferred_plan.primaryFs.name
            });

            // if PPCredit & Incentive are showing in the page together with installments we will hide installment details
            $scope.showInstallmentOptionWithoutIncentives = function () {
                if ($scope.creditOptions.creditType === 'INST') {
                    if (!$scope.isCreditIncentiveOption()) {
                        $scope.creditOptions.apr = String($scope.creditOptions.apr);
                        return true;
                    }
                }
                return false;
            };

            $scope.showChange = function () {
                var cartAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');

                if (cartAmount >= 99) {
                    return true;
                }
                return false;
            };

            $scope.showInstallmentOption = function () {
                if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.creditOptions && $scope.creditOptions.creditType) {

                    if ($scope.creditOptions.creditType === 'INST') {
                        $scope.installmentInfo = {
                            monthlyPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.monthlyPayment, $scope.cartCurrency),
                            totalInterestAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalInterest, $scope.cartCurrency),
                            totalPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalPayment, $scope.cartCurrency)
                        };
                    }
                    return true;
                } else {
                    return false;
                }
            };

            // if PPCredit & Incentive are showing in the page together with installments, we will:
            // 1. add a warning message in the top of the page as the installment option selected in cyco page
            //    is not available with PayPal incentives balance.
            // 2. hide installment options (see above method showInstallmentOptionWithoutIncentives())
            if ($scope.showInstallmentOption() && $scope.creditOptions.creditType === 'INST' && $scope.isCreditIncentiveOption()) {
                $scope.checkoutSession.message = {
                    type: 'warning',
                    msgKeys: ['offers.bmlInWalletInvalidInstallmentsMsg']
                };
            } else if ($scope.checkoutSession.message && $scope.checkoutSession.message.msgKeys && $scope.checkoutSession.message.msgKeys[0] === 'offers.bmlInWalletInvalidInstallmentsMsg') {
                // Remove error message in review page if was showing before changing payment method
                $scope.checkoutSession.message = null;
            }

            $scope.showCYCO = function () {
                $scope.checkoutSession.message = null;
                if ($scope.creditSharedInfo.getRedirectToCapeCyco()) {
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            };

            if (_angular.$window.location.search.search('atoSuccess') !== -1) {
                _logger.$logger.debug('PLANNING_ATO_SUCCESS');
                var atoMsg = _squid.$locale.content.get('memberReview.stepupAuthSuccess');

                if (atoMsg) {
                    $scope.checkoutSession.message = {
                        msgs: [atoMsg],
                        type: 'success'
                    };
                }
            }

            $scope.$on('localeChange', setInformalName);
            setInformalName();

            $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();

            if (_squid.$util.param('redirectToHermesOn3DSDecline')) {
                // check and show the 3DS decline message when the app is redirected from Xoon app
                show3DSDeclineMsg();
            }

            $scope.showAuthMsg = ['authorize', 'order'].indexOf($scope.checkoutCart.get('payment_action')) > -1 && !$scope.checkoutSession.get('plan.paypal_credit');

            if ($scope.showAuthMsg) {
                /*
                    new compliance message for AS1 / AS2 is not for US which displays LearnMore Link
                    have this scope variable set based on country
                */
                $scope.showAuthMsgLearnMore = _squid.$locale.country !== 'US' ? true : false;
            }

            $scope.showAuthDisclaimer = !$scope.noBalance && !$scope.disallowedBalance && !$scope.isThirdPartyWalletExperience() && ($scope.checkoutSession.plan.isAuthSignupEnabled || $scope.showAuthMsg);

            $scope.showUnconfirmedUpopMsg = !!$scope.checkoutSession.unconfirmed_upop;

            $scope.useraction = $scope.checkoutAppData.useraction() && $scope.checkoutAppData.useraction().toLowerCase();

            // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
            // are not available and purchase amount is not zero.
            var noLineItemDetails = $scope.useraction !== 'commit' && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

            var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments', []);
            var isCreditInWallet = false;

            if ($scope.checkoutCart.isBillingNoPurchase()) {
                isCreditInWallet = $scope.checkoutSession.get('futurePayment.isCreditInWallet');
            } else {
                isCreditInWallet = fundingInstruments.find(function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            var isPPCEligible = $scope.checkoutSession && $scope.checkoutSession.creditOffer;
            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            _logger.$logger.debug('creditInstallmentOffer ' + $scope.checkoutSession.creditInstallmentOffer + ', ' + 'creditOffer ' + $scope.checkoutSession.creditOffer + ', ' + isCreditInWallet + ', ' + isPayPalCredit);

            if ($scope.checkoutSession.creditOffer) {
                if (!_angular.$rootScope.bml) {
                    _angular.$rootScope.bml = new _bml.$BMLModel();
                }
                _angular.$rootScope.bmlApply = new _bml.$ApplyForBMLModel();
            }
            // the second button user is ineligible for PPC and has not selected to "pay with paypal"
            else if (isPayPalCredit && !isPPCEligible && !$scope.creditDataModel.payInFull && !isCapeReturn) {
                    var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country');

                    // no credit in wallet
                    if (!isCreditInWallet) {
                        $scope.checkoutSession.message = {
                            type: 'info',
                            msgKeys: ['offers.bmlIneligibleHeader', 'offers.bmlIneligibleContent']
                        };

                        _logger.$logger.info('checkout_fpti', {
                            from: 'Login',
                            to: 'Review',
                            error_type: 'second_btn_ineligible'
                        });
                    }
                    // 2nd button, cross border, user saw CYCO page -- we cannot honor any offer the user chose
                    // for LU merchants, don't show banners for eBayRM for connect scenario
                    else if ($scope.creditDataModel.isCrossBorder() && merchantCountry !== 'LU' && $scope.creditDataModel.hasSelectedCYCOOffer()) {
                            var msg = (0, _squid.$renderContent)('offers.bmlCrossBorderIneligibleContent', {
                                merchantCountry: merchantCountry
                            });
                            $scope.checkoutSession.message = {
                                msgs: [msg],
                                type: 'warning'
                            };
                        }
                }

            $scope.showSoftDescriptor = !$scope.checkoutAppData.flags.hide_soft_descriptor && $scope.checkoutCart.get('purchaseUnits.length', 0) <= 1;

            return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                $scope.showAmt = showAmount;
            });
        };

        var checkIfSkipReview = function checkIfSkipReview() {

            var skipReviewFlag = _squid.$util.param('skip-review'),
                oneClickEligible = $scope.checkoutSession.oneClickEligible,
                merchantId = $scope.payee.get('merchant.id'),
                merchantIds = _squid.$config.skipReviewWhitelistedMerchants || [],
                deviceMobile = _index2.$DeviceInfo.isMobile();

            if (skipReviewFlag && oneClickEligible && merchantIds.some(function (id) {
                return id === merchantId;
            }) && deviceMobile) {

                _logger.$logger.info('review_skipped');
                $scope.onPay();
            }
        };

        var shouldEnableBalance = function shouldEnableBalance(currentState) {
            var eligibility = currentState.eligibility;

            // initial eligibilty is set to null so it's essential to
            // explicitly check current eligibility is not null

            if (_sharedUtil.$SharedUtil.isBoolean(eligibility) && !eligibility) {
                $scope.checkoutSession.message = {
                    type: 'info',
                    msgs: [_squid.$locale.content.get('compliance.cipIncomplete')]
                };
                _logger.$logger.info('review_page_controller_render_cip_incomplete_message');
            }
        };

        var applyNegativeBalanceStatus = function applyNegativeBalanceStatus() {
            var checkoutSession = $scope.checkoutSession;
            var negBals = checkoutSession.negBals;
            var nbrMsgContentKey = void 0;
            var tokenHash = void 0;

            if (negBals) {
                nbrMsgContentKey = 'memberReview.nbrMsg';
                tokenHash = {
                    neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
                    merchantName: $scope.checkoutAppData.get('merchant.brand_name')
                };

                if (negBals.length > 1) {
                    nbrMsgContentKey += 'Plural';
                    tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
                }

                checkoutSession.message = {
                    type: 'warning',
                    msgs: [(0, _squid.$renderContent)(nbrMsgContentKey, tokenHash)]
                };
            }
        };

        var applyBrPxp = function applyBrPxp() {
            if (!_index.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
                var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_ryi_design;

                return (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern, false, true).then(function (result) {
                    $scope.ryiDesignExp = result;
                });
            }
        };

        var applyShowShippingMethod = function applyShowShippingMethod() {
            $scope.isInstantUpdateAPIFlow = $scope.checkoutCart && $scope.checkoutCart.get('instantUpdateIntegration');
            $scope.showShippingMethod = $scope.isInstantUpdateAPIFlow ? true : false;
            if (_integration.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
                if (!$scope.showShippingMethod) {
                    if ((0, _util.isConfigForRulesSummaryEnabled)()) {
                        var isSnTEnabled = $scope.checkoutAppData.flags.is_snt_enabled;
                        $scope.showShippingMethod = isSnTEnabled || $scope.showShippingMethod;
                        _logger.$logger.info('checkout_appdata_snt_' + (isSnTEnabled ? 'enabled' : 'disabled'));
                        return;
                    } else {
                        return setShowShippingMethodProperty();
                    }
                }
            }
        };

        $scope.policyContentKey = function () {
            var policyContentKey = 'memberReview.viewPaypalPolicies';
            var buyerOptOut = $scope.isOptionalVaulting() && $scope.vault.checked === false;
            if (buyerOptOut) {
                policyContentKey = 'memberReview.viewPaypalPoliciesOptOut';
            } else if ($scope.isOptionalVaulting()) {
                policyContentKey = 'memberReview.viewPaypalPoliciesOptIn';
            }
            _logger.$logger.info('resolved_policy_content_key_' + policyContentKey);
            return policyContentKey;
        };

        var isPPCReuseAndSelected = function isPPCReuseAndSelected() {
            var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);

            if (plans && plans.filter(function (fi) {
                return fi.name === 'BILL_ME_LATER' && fi.selected;
            }).length === 1) {
                return true;
            } else {
                return false;
            }
        };

        var applyPayButtonOption = function applyPayButtonOption() {
            $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
            $scope.merchantMsg = $scope.checkoutCart.getBillingDescription();

            var isBilling = $scope.checkoutCart.isBilling();
            var merchant = $scope.checkoutAppData.merchant;
            var isWPSSubscriptionFlow = $scope.checkoutAppData.is_wps_subscription_flow();
            var isWPSAutoBillingFlow = $scope.checkoutAppData.isWpsAutobillingFlow();
            var isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();

            $scope.merchantName = (0, _sanitizeCaja2['default'])(merchant.brand_name || merchant.merchant_name);

            // Determine whether the button type is a Pay button or Continue button
            $scope.buttonLabelIsPay = $scope.useraction === 'commit' || _integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW');

            // if the user has credit selected the button label should be not be 'pay now'
            if (isPPCReuseAndSelected()) {
                $scope.buttonLabelIsPay = undefined;
            }

            // log paybuttonText as paynow or continue
            // irrespective of PAD, credit, etc
            _logger.$logger.info('checkout_fpti', {
                'ryp_button_text': $scope.buttonLabelIsPay ? 'paynnow_y' : 'paynnow_n'
            });

            // show shipping address based on merchant passed in parameter
            $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required && $scope.checkoutSession.shipping);

            // review page 'continue' or 'pay now' button logic to return the button text
            $scope.payButtonText = function () {
                var buyerOptOut = $scope.isOptionalVaulting() && $scope.vault.checked === false;
                var isPaymentServiceActApplied = $scope.isPaymentServiceActApplied();

                var hasAgreeAndPrefix = $scope.showUpdatedUserAgreement;

                if ($scope.selectedmethod && $scope.selectedmethod.planId === 'applyForPPCRadio') {
                    if (_squid.$locale.country === 'DE') {
                        return _squid.$locale.content.get('memberReview.bmlContinueToApplication');
                    }
                    return _squid.$locale.content.get('applyForBml.bmlApplyHeadline');
                }

                if ($scope.isDEInstallmentsApproved()) {
                    return _squid.$locale.content.get('memberReview.bmlBindingApply');
                }

                if (isBilling && !buyerOptOut) {
                    if ($scope.buttonLabelIsPay) {
                        if (isPaymentServiceActApplied) {
                            if (isWPSSubscriptionFlow || isSubscriptionsV1 || isWPSAutoBillingFlow || $scope.checkoutCart.isRecurringPayment()) {
                                return _squid.$locale.content.get('common.confirmAndSubscribe');
                            }

                            return _squid.$locale.content.get('common.confirmAndPay');
                        }
                        if (isWPSSubscriptionFlow || isSubscriptionsV1 || isWPSAutoBillingFlow) {
                            return _squid.$locale.content.get('memberReview.agreeAndSubscribeLabel');
                        }
                        return _squid.$locale.content.get('memberReview.agreeAndPayLabel');
                    } else {
                        if (isPaymentServiceActApplied) {
                            return _squid.$locale.content.get('common.confirmAndContinue');
                        }
                        return _squid.$locale.content.get('memberReview.agreeAndContinueLabel');
                    }
                } else if (getPadToggleStatus() === 'ON') {
                    return _squid.$locale.content.get('memberReview.padLabel');
                } else if ($scope.buttonLabelIsPay) {
                    if ($scope.checkoutSession.unconfirmed_upop) {
                        return _squid.$locale.content.get('memberReview.pay');
                    } else {
                        $scope.payButton = 'paynnow_y';
                        if (isPaymentServiceActApplied) {
                            return _squid.$locale.content.get('memberReview.confirmAndPayLabel');
                        }
                        if (hasAgreeAndPrefix) {
                            return _squid.$locale.content.get('buttons.agreeAndPayNow');
                        }
                        return _squid.$locale.content.get('memberReview.payLabel');
                    }
                } else {
                    $scope.payButton = 'paynnow_n';
                    if (hasAgreeAndPrefix) {
                        return _squid.$locale.content.get('scripts.agreeAndContinue');
                    }
                    return _squid.$locale.content.get('memberReview.continueLabel');
                }
            };

            $scope.onRedeemGC = function () {
                throw new _squid.$FallbackError({
                    reason: 'redeem_coupon_feature_not_supported',
                    product: 'ux'
                });
            };

            // Check if processor decline message needs to be set
            setProcessorDeclineMessage($scope.checkoutSession);

            $scope.promotion = {
                type: null,
                name: ''
            };

            var plccOffer = $scope.checkoutSession && $scope.checkoutSession.plccOffer;

            if (plccOffer) {
                $scope.promotion.logoUrl = plccOffer.product_logo;
                $scope.promotion.name = plccOffer.product_name;
            }

            $scope.onFBBANotNow = function () {
                var _$scope$checkoutSessi4 = $scope.checkoutSession.payer;
                _$scope$checkoutSessi4 = _$scope$checkoutSessi4 === undefined ? {} : _$scope$checkoutSessi4;
                var payerId = _$scope$checkoutSessi4.id;

                var isUnchecked = _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxPluginState') === 'unchecked';

                _logger.$logger.info('checkout_fpti', {
                    buyer_country: _squid.$locale.country,
                    buyer_id: payerId,
                    context_id: $scope.token,
                    design: 'fbmessenger',
                    from: 'BILLING_AGREEMENT',
                    to: 'process_billing_agreement',
                    eligibility_reason: isUnchecked ? 'checkbox_plugin_unchecked' : 'checkbox_plugin_checked',
                    click_source: 'not_now'
                });

                window.xchild.close();

                if (experience.autoBA) {
                    window.top.location.replace('fbiab://paypal/abort');
                }
            };

            $scope.onPay = function (result) {

                _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T4' });

                // If back clicked in browser and lands on review, we need to do the clear cvv contigency
                $scope.resetCVVContigency({ flow: 'browser_back' });

                // Track NMJ variations.
                var payEventName = void 0;

                if ($scope.isNmjDesign1) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design1_page';
                } else if ($scope.isNmjDesign2) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design2_page';
                } else if ($scope.isNmjDesign3) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design3_page';
                } else {
                    payEventName = 'member_ryi_onPayVariant_control';
                }

                _logger.$logger.info(payEventName);

                if ($scope.showMissingPickupOptionMessage || $scope.showMissingShippingOptionMessage) {
                    return;
                }

                if (!isValidPinSetup()) {
                    $scope.topupError = true;
                    _logger.$logger.debug('pin_missing');
                    _uiRouter.$state.go('checkout.pinSetup');
                    return;
                }

                if ($scope.checkoutSession.installments && $scope.checkoutSession.installments.length > 1 && !$scope.checkoutSession.selectedInstallmentData) {
                    $scope.installmentNotSelected = true;
                    return;
                }

                if ($scope.isInstantUpdateAPIFlow && !$scope.instantUpdateFeature.shippingRegionSupported) {
                    return;
                }

                // Determine whether or not to prevent going forward based on the status of the onShippingChange callback
                if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.status) {
                    switch ($scope.shippingChangeFeature.status) {
                        case $scope.shippingChangeFeature.enums.LOADING:
                        case $scope.shippingChangeFeature.enums.REJECTED:
                        case $scope.shippingChangeFeature.enums.FAILED:
                            return;
                        default:
                    }
                }

                if ((0, _squid.$feature)('creditInstallmentOffers') && isPPCReuseAndSelected() && !($scope.creditOptions && $scope.creditOptions.creditType) && $scope.creditSharedInfo.hasInstallmentOffers()) {
                    // customer is elgibile for installments and not selected an offer yet.
                    // if they fall under the treatment and they are no a return back from cape they will see the new cyco page
                    // else they will go to the CYCO page in hermes
                    return $scope.creditSharedInfo.getRedirectToCapeCyco() ? _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true }) : _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
                // "Paying" by applying for PPC
                if ($scope.selectedmethod && $scope.selectedmethod.planId === 'applyForPPCRadio') {
                    if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.installment && $scope.installment.installmentOptionsPresent) {
                        return $scope.creditSharedInfo.getRedirectToCapeCyco() ? _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true }) : _uiRouter.$state.go('checkout.chooseCreditOffer');
                    } else if (_squid.$locale.country === 'DE' && $scope.creditSharedInfo.hasInstallmentOffers() && $scope.creditSharedInfo.hasInstallmentOfferFinancingDetails()) {
                        return _uiRouter.$state.go('checkout.redirectToCape', { financing_option: $scope.creditSharedInfo.getInstallmentOfferFinancingDetails() });
                    } else {
                        return _uiRouter.$state.go('checkout.redirectToCape');
                    }
                }

                var fiDetails = _sharedUtil.$SharedUtil.getFiDetails($scope.checkoutSession.get('futurePaymentInstruments'));
                $scope.logSubscriptionEvent(_extends({
                    from: 'agree_clicked',
                    to: 'process_review'
                }, fiDetails));

                if ($scope.showUpdatedUserAgreement) {
                    var _$scope$userAgreement = $scope.userAgreementVersions,
                        majorVersion = _$scope$userAgreement.majorVersion,
                        minorVersion = _$scope$userAgreement.minorVersion;

                    _logger.$logger.info('active_consent_disclaimer_agree_pressed', {
                        flow: 'CHECKOUT',
                        encr_cust_id: $scope.auth.buyer_id,
                        product: 'checkout',
                        event_name: 'active_consent_disclaimer_agree_pressed',
                        evnt_type: _constants.FptiEventType.Click,
                        policy_minor_version: minorVersion,
                        policy_major_version: majorVersion,
                        transition_name: 'consent_disclaimer_agree_clicked',
                        state_name: 'consent_disclaimer'
                    });
                }

                // users are able to trigger multiple preAuthorize calls, disabling the button after first click to prevent that
                $scope.onPayButtonDisabled = true;
                return checkForAddressNormalization()['catch'](function (error) {
                    if (error instanceof _squid.$ShortCircuit) {
                        throw error;
                    }

                    _logger.$logger.error('checkForAddressNormalization_error', error);
                }).then(function () {
                    var padToggleStatus = getPadToggleStatus();

                    if (padToggleStatus === 'ON') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOnSubmit'
                        });
                    } else if (padToggleStatus === 'OFF') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOffSubmit'
                        });
                    }

                    /**
                     * Call updateFS so that if user has made a change in the multiple FI on RYI variant, we select their instrument before doing other logic
                     * Call patchCvv first, if error, need buyers to input again
                     * Call to set Sticky Funding Instrument for Billing Agreement.
                     * We have to ensure the sticky call happens before authorize due to symphony spec.
                     * We need to wait for the response from updateAddressAsPreferred before calling authorize                 */

                    var tokenizationPreAuthorizeError = void 0;

                    return updateFS()
                    // Make PAPS patch calls sequentially. Concurrent patch calls are currently not supported
                    .then(function () {
                        return checkJSV4PaymentDetails();
                    }).then(function () {
                        return _tokenizedFactory.$TokenizedFactory.tokenizedOnPayCalls($scope.checkoutCart, $scope.checkoutSession, $scope.tokenizedWalletInfoModel, $scope.walletPinModel);
                    }).then(function () {
                        setCvvData();
                        return _fiApis.$fiApis.patchCvv($scope.checkoutSession);
                    }).then(function () {
                        return setStickyInstrument();
                    })
                    // Other calls that won't affect the checkout session. Multiple patch calls to PAPS should not be made here
                    .then(function () {
                        var promises = [updateAddressAsPreferred(), // This is a patch call to PAPS
                        linkAuthConsent(), $scope.actions.updatePreferredFi(_logger.$logger), donationAuthorize()];

                        if (!$scope.balanceUsage) {
                            promises.push(setWalletTopupPreferences());
                        }

                        if (_gatherActiveConsent.$GatherActiveConsentFactory.isConsentRequired()) {
                            promises.push(_gatherActiveConsent.$GatherActiveConsentFactory.recordConsent());
                        }

                        return _angular.$q.all(promises)['catch'](function (err) {
                            // should we have more elaborate error handling here?
                            if ($scope.checkoutCart.isWalletTokenization()) {
                                if (err && err.message === 'WALLET_PREFERENCE_SET_ERROR') {
                                    tokenizationPreAuthorizeError = err;
                                }
                            }
                            _logger.$logger.error('onPay() error', err);
                        })['finally'](function () {
                            if (tokenizationPreAuthorizeError) {
                                var code = 'ANDROID_PAY_SET_WALLET_PREFERENCE_ERROR';
                                code = window.btoa(code);
                                _uiRouter.$state.go('checkout.genericError', { code: code });
                            } else {
                                return authorize();
                            }
                        });
                    }, function (err) {
                        if ($scope.hasShippingOptions() && err.message === 'IXO_CANNOT_CHECKOUT_WITHOUT_SHIPPING_SELECTION') {
                            return;
                        }

                        if ($scope.checkoutCart.isWalletTokenization()) {
                            if (err && err.message === 'ISSUANCE_PIN_SERVICE_ERROR') {
                                var code = 'ANDROID_PAY_SET_PIN_ERROR';
                                code = window.btoa(code);
                                _uiRouter.$state.go('checkout.genericError', { code: code });
                                return;
                            }
                        }
                        _logger.$logger.error('onPay() patchCvv error', err);
                    })['finally'](function () {
                        $scope.onPayButtonDisabled = false;
                    });
                });
            };

            $scope.cancelCreditApplication = function () {
                var baseUrl = window.location.href.split('?')[0];
                var params = _squid.$util.params();

                // Remove CAPE return parameters as the user has
                delete params.success;
                delete params.key;

                _squid.$util.redirect(_squid.$util.buildURL(baseUrl, params));
            };

            /* This is used for a BML 'popup' that opens covering the whole review page,
             hiding the rest of the review page when its open. */
            $scope.bmlPopupOpen = false;
            $scope.showBmlPopup = function () {
                $scope.bmlPopupOpen = true;
            };
            $scope.hideBmlPopup = function () {
                $scope.bmlPopupOpen = false;
            };
        };

        var checkForAddressNormalization = function checkForAddressNormalization() {
            // before any address normalization action , check whether it is required to do so
            // if buyer country and shipping address country different , then don't try to normalize that
            // address normalization enabled for BR and US buyers and now force only if shipping address also matches
            $scope.shippingAddress = $scope.checkoutSession.get('shipping');
            var country = $scope.shippingAddress && $scope.shippingAddress.country;
            if (_squid.$locale.country === country) {
                if (!$scope.AddressNormzalizationDone && $scope.checkoutAppData.get('flags.allow_change_shipping', false) && (0, _squid.$feature)('shippingAddressNormalization')) {
                    if ((0, _squid.$feature)('addressNormalizationEdit') && $scope.shippingAddress) {
                        return _factory6.$AddressNormalizationFactory.getAddressNormalizationElmoResult(country).then(function (treatment) {
                            if (treatment && $scope.shippingAddress.normalization_status === 'UNKNOWN') {
                                $scope.strictAddressNormalization = false;
                                _uiRouter.$state.go('checkout.review.sidebar.addressNormalizationEdit');
                                return _squid.$promise.shortCircuit();
                            } else {
                                return _angular.$q.when();
                            }
                        });
                    } else if ($scope.checkoutSession.get('shipping.normalization_status') === 'UNKNOWN') {
                        _uiRouter.$state.go('checkout.review.sidebar.updateShipping');
                        return _squid.$promise.shortCircuit();
                    }
                }
            }
            return _angular.$q.when();
        };

        // This function is sent to Address Normalziation process as callback
        // when Address normalization proccess finishes it'll redirect back to
        // here, review page.
        $scope.onAddressNormalized = function () {
            _uiRouter.$state.go('checkout.review').then(function () {
                $scope.AddressNormzalizationDone = true;
                $scope.onPay();
            });
        };

        var checkForReviewLaterText = function checkForReviewLaterText() {
            $scope.showReviewLaterText = true;

            if ($scope.checkoutCart.isSubscriptionsV1()) {
                $scope.showReviewLaterText = $scope.useraction === 'commit' ? false : true;
                return;
            }
            // only get pxp if buttonlabel is not pay and for billingWithOutPurchase
            if ($scope.useraction !== 'commit' && !_integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW') && $scope.checkoutCart.isBillingNoPurchase()) {
                _logger.$logger.info('billing_no_purchase_use_case');
                $scope.showReviewLaterText = false;
            }
        };

        var initBillingNoPurchasePlans = function initBillingNoPurchasePlans() {
            var isBillingNoPurchase = $scope.checkoutCart && $scope.checkoutCart.isBillingNoPurchase();

            $scope.plans = isBillingNoPurchase ? $scope.checkoutSession.get('futurePaymentInstruments') : $scope.checkoutSession.getPlanList();
        };

        var showBillingMessage = function showBillingMessage() {
            var merchant = $scope.checkoutAppData.get('merchant');
            var unsafeMerchantName = merchant.brand_name || merchant.merchant_name || 'Merchant';
            var merchantName = (0, _sanitizeCaja2['default'])(unsafeMerchantName);

            $scope.showMessage = true;
            var contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant', { merchantName: merchantName });

            if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                if ($scope.checkoutCart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow() || $scope.checkoutCart.isSubscriptionsV1()) {
                    contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant_rp', { merchantName: merchantName });
                } else {
                    contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant_rt', { merchantName: merchantName });
                }

                $scope.checkoutSession.message = {
                    type: 'info',
                    msgs: [contentDataKey]
                };
            }
        };

        var showMoreFiInit = function showMoreFiInit() {
            var showMoreFiEligibility = _factory4.$ShowMoreFiFactory.decideEligibility({ plans: $scope.plans });

            if (showMoreFiEligibility) {
                showMoreFiEligibility.then(function () {
                    _factory4.$ShowMoreFiFactory.init($scope.plans);
                });
            }
        };

        // TODO: please talk with AuthRate team on `xo_hermes_preferred_expired_msg_review_page` pxp when
        // they decide to turn the experiement on next year!
        // https://engineering.paypalcorp.com/pxptool/history?exptId=3935
        // const showExpiredMsgInit = () => {
        //     $scope.showExpiredMsg = $ExpiredMsgFactory.showExpiredMsg($scope.isNmj, $scope.checkoutSession);
        //     if ($scope.showExpiredMsg) {
        //         $ExpiredMsgFactory.getPreferredExpiredPxpResult().then(result => {
        //             $scope.isNmjexpired = result === 'xo_hermes_preferred_expired_msg_review_page_nmj_treatment' ? true : false;
        //             $scope.preferredExpired = $scope.checkoutSession.getDisallowedPreferred();
        //         });
        //     }
        // };

        // lazy load some of the most popular routes to increase loading time
        var preloadCodeSplitRoutes = function preloadCodeSplitRoutes() {
            if (_squid.$meta.codeSplitting) {
                var routes = [];

                if (_integration.$integration.isFlow('WPS')) {
                    routes.push.apply(routes, [new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-pay/route.js")), // eslint-disable-line
                    new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "../node_modules/xo-page-components/src/done/route.js")) // eslint-disable-line
                    ]);
                }

                routes.push.apply(routes, [new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-sidebar/route.js"))]);

                // preload checkout.genericMessage route which is shown when transaction is completed
                // on devices. So basically user will see `Thanks for using PayPal!` and `You can close this tab at any time.`
                // and at the same time there will be client side redirect
                // https://github.paypal.com/Checkout/xo-return-to-merchant/blob/master/dist/util.js#L44
                // May help reduce noise in case of code split when it's trying to first download the js chunk and then make redirect
                // which may take longer than usual
                if (_index2.$DeviceInfo.isDevice()) {
                    routes.push(new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "./pages/xo-generic-message/route.js")));
                }

                Promise.all(routes)['catch'](function (err) {
                    _logger.$logger.info('code_split_review_routes_preload_failed', {
                        error: err && err.message
                    });
                });
            }
        };

        var isUSCrossCurrency = function isUSCrossCurrency() {
            if ($scope.checkoutCart && $scope.checkoutCart.grossTotalAmount && $scope.checkoutCart.get('grossTotalAmount.currency') !== 'USD' && _squid.$locale.country === 'US') {
                return true;
            }
            return false;
        };

        var handleUnsupportUSCrossCurrency = function handleUnsupportUSCrossCurrency() {
            if ($scope.checkoutSession.fundingOptions && $scope.checkoutSession.fundingOptions.plans) {
                var plans = $scope.checkoutSession.fundingOptions.plans.filter(function (plan) {
                    return plan.primaryFs.name !== 'BILL_ME_LATER';
                });
                if (isUSCrossCurrency() && !plans.length) {
                    _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', { message: 'NEED_CREDIT_CARD', cause: 'cpa' });
                } else if (isUSCrossCurrency()) {
                    doPlanSelection(plans[0].planId);
                }
            }
        };

        _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T0' });

        /**
         * This promise chain renders critical content in the page. Avoid
         * the temptation to tack on another `.then` to this promise chain.
         *
         * If you are making a critical network request, consider putting
         * function inside the `$q.all` array so it can be run in parallel
         * and not slow down page rendering.
         *
         * If your function requires values available on `$scope` after
         * the critical functions in `$q.all` are complete, put your
         * function in the following `.then` block.
         *
         * Otherwise, your function can likely go somewhere else.
         */
        populateScope().then(function () {
            stickyCTA();
            _factory3.$RewardsCheckboxFactory.buildCache();
            // applyCreditOptions could potentially redirect out of the RYI.
            // Seperate it out from the rest of the pack to avoid unnecessary code execution
            handleUnsupportUSCrossCurrency();
            applyCreditOptions();
            triggerPersonalizedBanner();
            applyMerchantName();
            applyPayButtonOption();
            checkIfSkipReview();
            applyChoiceExperimentVariant();
            applyNegativeBalanceStatus();
            applyKmliUpsellEligibility();
            applyShowShippingMethod();
            applyInvoicingRegEDetails();
            showPaymentServiceActContent();
            showLanguageToggleForRTR();
            initAndCallOnShippingChange();
            checkForReviewLaterText();
            initBillingNoPurchasePlans();
            showBillingMessage();
            applyBrPxp();
            initializePadToggleSupport();
            initPPBalanceFlow();
            initBalanceUsage();
            showGAC();
            _factory2.$NoBalanceFactory.decideEligibility();
            prepareTokenizedWallet();
            applyNewMemberVariant();
            _gatherActiveConsent.$GatherActiveConsentFactory.decideEligibility().then(displayUserAgreementConsent);
            showMoreFiInit();
            logSessionDetails();
            preloadCodeSplitRoutes();

            //  To show cvv box even though the cvvData already resolved.
            $scope.resetCVVContigency({ flow: 'page_refresh' });
            checkExperienceElmoTreatment();

            // Decide whether to display CIP_INCOMPLETE (AU only) message and disable PayPal balance
            // as a valid funding instrument
            _balance.$BalanceEligibilityFactory.init({ checkoutSession: $scope.checkoutSession }).then(function (currentState) {
                return shouldEnableBalance(currentState);
            });

            // to fully deprecate member traffic, we need to figure out at this line whether or not we can safely redirect to xolite
            var reasonToStayOnHermes = getReasonToStayOnHermes();

            _logger.$logger.info('checkout_fpti', {
                from: 'reason_' + reasonToStayOnHermes.reasonToStayOnHermes,
                to: 'prepare_review'
            });
            (0, _metricLogger.metricCounter)('review_page_render', {
                reason_to_stay_on_hermes: reasonToStayOnHermes.reasonToStayOnHermes,
                is_wps_flow: String(reasonToStayOnHermes.isWPSFlow),
                is_billing_without_purchase: String(reasonToStayOnHermes.isBillingWithoutPurchase),
                is_billing_with_purchase: String(reasonToStayOnHermes.isBillingWithPurchase),
                is_wps_subscription_flow: String(reasonToStayOnHermes.isWPSSubscriptionFlow),
                is_wps_autobilling: String(reasonToStayOnHermes.isWPSAutobilling),
                is_tokenized_wallet: String(reasonToStayOnHermes.isTokenizedWallet),
                is_hermes_query_param: String(reasonToStayOnHermes.isHermesQueryParam),
                subscription_type: reasonToStayOnHermes.subscriptionType
            });
        })['finally'](function () {
            if (window.appPerformanceEvents) {
                // TimeToFullyRender: The moment client is ready to receive with all data for the user.
                // Should be the last promise on the page
                // to be triggered after all data loads
                window.appPerformanceEvents.TimeToFullyRender = parseInt(window.performance.now(), 10);
                _logger.$logger.info('APP_PERFORMANCE_EVENTS', window.appPerformanceEvents);
            }
        });
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');

        $scope.onComplete = function (params) {
            if (params) {
                _logger.$logger.debug('ryi_optin_isKmliSet_' + params.isKmliSet);
                if (params.isKmliSet) {
                    $scope.optin_toggle.setValue(true);
                }
            }
            _uiRouter.$state.go('checkout.review');
        };

        _sharedUtil.$SharedUtil.logSubscriptionDetails(_angular.$rootScope && _angular.$rootScope.token, 'review');
        $scope.logSubscriptionEvent({
            from: 'review_rendered',
            to: 'prepare_review'
        });

        $scope.propValueObj = {};
        if ((0, _squid.$feature)('propValue')) {
            $scope.propValueObj.propHeader = 'memberReview.propHead';
            $scope.propValueObj.propVal = 'memberReview.propVal';
            $scope.propValueObj.propImage = 'https://' + _squid.$meta.cdnHost + '/images/checkout/hermes/scr_vp_fprd_shield_bags.png';
        } else {
            $scope.propValueObj.propHeader = 'login.propHeadAlt';
            $scope.propValueObj.propVal = 'login.propValAlt';
            $scope.propValueObj.propImage = 'https://' + _squid.$meta.cdnHost + '/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png';
        }
    }]
});

angular.value("$xoReviewPageComponent", $xoReviewPageComponent);
_uiRouter.$state;

_index.$miniBrowser;

_logger.$logger;

_integration.$integration;

_index2.$DeviceInfo;

_ul.$ul;

_pxp.$pxpCartAmt;

_marketingoffer.$fireMORSBeacon;

_angular.$q;

_angular.$rootScope;

_angular.$timeout;

_angular.$window;

_angular.noop;

_kmliUpsell.$KmliUpsell;

_utils.getSelectedPlan;

_utils.getInstrumentID;

_squid.$Class;

_squid.$Component;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$featureCountries;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxpFactors;

_squid.$renderContent;

_squid.$util;

_squid.formatCurrency;

_squid.formatNameInformal;

_squid.$promise;

_squid.$ShortCircuit;

_squid.$elmo;

_squid.$event;

_thirdPartyInfo.thirdPartyExperience;

_auth.$AuthModel;

_fiApis.$fiApis;

_eligibility.$stickyCTA;

_choice.$ChoiceEligibility;

_fiMessages.$fiMessages;

_donation.$GiveAtCheckoutModel;

_bml.$ApplyForBMLModel;

_bml.$BMLModel;

_credit.$CreditDataModel;

_credit.$CreditInstallmentModel;

_credit.$CreditSharedInfoModel;

_fi.$AddCardModel;

_fi.$CardModel;

_fi.$PreferredFi;

_fi.$WalletPreferences;

_app.$TokenizedFundingCapabilitiesModel;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletPinModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_marketingoffer2.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_shippingMethod.$ShippingRuleSummaryModel;

_user.$AuthConsentModel;

_user.$UserEligibleToHoldBalanceModel;

_factory.$GiveAtCheckoutFactory;

_factory2.$NoBalanceFactory;

_factory3.$RewardsCheckboxFactory;

_factory4.$ShowMoreFiFactory;

_factory5.$AddCardFactory;

_factory6.$AddressNormalizationFactory;

_gatherActiveConsent.$GatherActiveConsentFactory;

_constants.FptiEventType;

_metricLogger.metricCounter;

_cardartInstrument.$CardArtInstrument;

_factory7.$BalanceFactory;

_factory8.$PADFactory;

_tokenizedFactory.$TokenizedFactory;

_shippingChangeFeature.createShippingChangeFeature;

_shippingChangeFeature.hasOnShippingChangeCallback;

_xoShippingOptions.getShippingOptions;

_xoShippingOptions.selectShippingOption;

_xoShippingOptions.getSelectedShippingOption;

_xoShippingOptions.$xoShippingOptions; // eslint-disable-line no-unused-vars;

_sharedUtil.$SharedUtil;

_balance.$BalanceEligibilityFactory;

_qs.parse;

_qs.stringify;

_util.isConfigForRulesSummaryEnabled;

/***/ }),

/***/ "./pages/xo-review/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$PADFactory', function () {

    /**
     *
     * get PAD or IACH plan id based on selected plan id and PAD toggle status
     * if selected plan is IACH and toggle is on -> use associated PAD plan id
     * if selected plan is IACH and toggle is off -> use it's ID
     * if selected plan is PAD and toggle is on -> use it's ID
     * if selected plan is PAD and toggle is off -> use associated IACH plan id
     */
    var getPadOrIachBankPlanId = function getPadOrIachBankPlanId(_ref) {
        var selectedMethodPlanId = _ref.selectedMethodPlanId,
            fundingOptions = _ref.fundingOptions,
            multiFiCheckboxStates = _ref.multiFiCheckboxStates;

        var plan = fundingOptions.getPlanByPlanId(selectedMethodPlanId);
        var padOrIachPlanId = void 0;

        if (fundingOptions.isPAD(plan) || fundingOptions.isIACH(plan)) {
            if (multiFiCheckboxStates[plan.primaryFs.id]) {
                padOrIachPlanId = fundingOptions.getPadOrIachPlanIdBySelectedPlan({ plan: plan, isPadToggleSelected: true });
            } else {
                padOrIachPlanId = fundingOptions.getPadOrIachPlanIdBySelectedPlan({ plan: plan, isPadToggleSelected: false });
            }
        }
        return padOrIachPlanId;
    };

    // check if PAD feature is applicable
    var isPadToggleFeatureApplicable = function isPadToggleFeatureApplicable(padToggleFeature, isPadToggleEnabled) {
        return padToggleFeature.applicable && isPadToggleEnabled;
    };

    return {
        getPadOrIachBankPlanId: getPadOrIachBankPlanId,
        isPadToggleFeatureApplicable: isPadToggleFeatureApplicable
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-review", "pages/xo-review/factory.js"))

/***/ }),

/***/ "./pages/xo-review/gatherActiveConsent.factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/consent/index.js");

var getNoticeAndConsentUserAgreementParameters = function getNoticeAndConsentUserAgreementParameters() {
    return {
        action: 'evalPolicy',
        params: {
            flow: 'CHECKOUT',
            policyType: 'UserLegalConsent'
        }
    };
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$GatherActiveConsentFactory', function () {
    var state = {};

    var userAgreementConsentModel = _index.$UserAgreementConsentModel.instance(_angular.$rootScope.token);

    var getUserAgreementUrl = function getUserAgreementUrl() {
        return state.upcomingUrl;
    };
    var getUserAgreementVersions = function getUserAgreementVersions() {
        var _state = state,
            majorVersion = _state.majorVersion,
            minorVersion = _state.minorVersion;


        return { majorVersion: majorVersion, minorVersion: minorVersion };
    };

    var isConsentRequired = function isConsentRequired() {
        return state.enabled && state.status === 'PENDING';
    };
    var clearState = function clearState() {
        state = {};
    };

    var gatherActiveConsentExp = function gatherActiveConsentExp() {
        return (0, _squid.$elmo)('xo::gatheractiveconsent', {
            'ctx.COUNTRY': _squid.$locale.country,
            'ctx.app_name': 'hermesnodeweb'
        }, 'Trmt_FEATURE_GATHER_ACTIVE_CONSENT').then(function (result) {
            var treatmentEnabled = Boolean(result && result.treatment_name);

            if (treatmentEnabled) {
                _logger.$logger.info('gatherActiveConsentExp_' + result.treatment_name);
            } else {
                _logger.$logger.info('gatherActiveConsentExp_Ctrl');
            }

            return {
                enabled: treatmentEnabled
            };
        });
    };

    var decideEligibility = function decideEligibility() {
        // Data already fetched, just resolve because state should be already populated
        if (userAgreementConsentModel.meta && userAgreementConsentModel.meta.populated) {
            return _squid.$promise.resolve({});
        }

        return gatherActiveConsentExp().then(function (_ref) {
            var enabled = _ref.enabled;

            state.enabled = enabled;

            if (!enabled) {
                return _squid.$promise.resolve();
            }

            return userAgreementConsentModel.retrieve(getNoticeAndConsentUserAgreementParameters()).then(function (consentData) {
                state.upcomingUrl = consentData.getUpcomingUrl();
                state.majorVersion = consentData.getMajorVersion();
                state.minorVersion = consentData.getMinorVersion();
                state.status = consentData.getStatus();

                _logger.$logger.info('gatherActiveConsentData_fetched', state);
            });
        })['catch'](function (err) {
            // If some error happens, we stick to default data
            _logger.$logger.error('gatherActiveConsent_error', err);
        });
    };

    var recordConsent = function recordConsent() {
        if (!isConsentRequired()) {
            return;
        }

        return userAgreementConsentModel.action('recordConsent', {
            data: {
                policyType: 'UserLegalConsent',
                consentValues: {
                    version: state.majorVersion + '.' + state.minorVersion
                }
            }
        });
    };

    return {
        getUserAgreementUrl: getUserAgreementUrl,
        getUserAgreementVersions: getUserAgreementVersions,
        isConsentRequired: isConsentRequired,
        clearState: clearState,
        decideEligibility: decideEligibility,
        recordConsent: recordConsent
    };
});

_squid.$elmo;

_squid.$locale;

_squid.$promise;

_logger.$logger;

_angular.$rootScope;

_index.$UserAgreementConsentModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-review", "pages/xo-review/gatherActiveConsent.factory.js"))

/***/ }),

/***/ "./pages/xo-review/lib/shippingChangeFeature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.createShippingChangeFeature = exports.hasOnShippingChangeCallback = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _factory = __webpack_require__("../node_modules/xo-shipping-change/src/factory.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var hasOnShippingChangeCallback = exports.hasOnShippingChangeCallback = function hasOnShippingChangeCallback() {
    return window.xprops && window.xprops.onShippingChange;
};

var createShippingChangeFeature = exports.createShippingChangeFeature = function createShippingChangeFeature() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        orderID = _ref.orderID,
        checkoutCart = _ref.checkoutCart,
        checkoutSession = _ref.checkoutSession,
        checkoutAppData = _ref.checkoutAppData,
        _ref$callbackFn = _ref.callbackFn,
        callbackFn = _ref$callbackFn === undefined ? _squid.$util.noop : _ref$callbackFn;

    var feature = {
        enums: {
            LOADING: 'loading',
            REJECTED: 'rejected',
            UPDATED: 'updated',
            FAILED: 'failed'
        },
        status: null,
        shippingChangeFactory: (0, _factory.$ShippingChangeFactory)({ orderID: orderID, checkoutAppData: checkoutAppData, checkoutCart: checkoutCart }),
        callOnShippingChange: _squid.$util.noop
    };

    feature.callOnShippingChange = function () {
        var doneFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$util.noop;

        if (!hasOnShippingChangeCallback()) {
            return doneFn();
        }

        var successFn = function successFn() {
            var updatedMsg = (0, _squid.$renderContent)('shippingCallback.updated', {
                amount: checkoutCart.get('purchase.amounts.total.amount_formatted_currency')
            });

            feature.status = feature.enums.UPDATED;
            checkoutSession.message = {
                msgs: [updatedMsg],
                type: 'info'
            };
        };

        var rejectFn = function rejectFn() {
            var rejectedMsg = (0, _squid.$renderContent)('shippingMethod.shippingRegionUnsupported', {
                merchant: checkoutAppData.getMerchantDisplayName()
            });

            feature.status = feature.enums.REJECTED;
            checkoutSession.message = {
                msgs: [rejectedMsg],
                type: 'warning'
            };
        };

        var loadingMsg = _squid.$locale.content.get('shippingCallback.loading');

        _squid.$event.emit('loading');
        _squid.$event.emit('loadingMessage', loadingMsg);

        return feature.shippingChangeFactory.getPayload(checkoutSession.get('shipping')).then(function (payload) {
            _logger.$logger.info('shipping_change_payload_recieved', payload);

            return feature.shippingChangeFactory.callOnShippingChange(payload);
        }).then(function (_ref2) {
            var cartHasChanged = _ref2.cartHasChanged,
                rejected = _ref2.rejected;


            _logger.$logger.info('shipping_change_called', { cartHasChanged: cartHasChanged, rejected: rejected });

            callbackFn();

            if (rejected) {
                return rejectFn();
            } else if (cartHasChanged) {
                return successFn();
            } else {
                // If the callback was not rejected, and the cart
                // was not changed we can remove any statuses
                // that prevent finishing checkout.
                feature.status = null;
            }
        }).then(doneFn)['catch'](function (err) {
            _logger.$logger.error('shipping_change_error', err);

            feature.status = feature.enums.FAILED;
            _uiRouter.$state.go('checkout.genericError');
        })['finally'](function () {
            _squid.$event.emit('loaded');
        });
    };

    return feature;
};

_squid.$renderContent;

_squid.$util;

_squid.$locale;

_squid.$event;

_factory.$ShippingChangeFactory;

_uiRouter.$state;

_logger.$logger;

/***/ }),

/***/ "./pages/xo-review/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ReviewRoute = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

__webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/route.js");

__webpack_require__("./pages/xo-sidebar/route.js");

__webpack_require__("./pages/xo-sidepage/route.js");

var _directive = __webpack_require__("./pages/xo-review/directive.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

/* dynamic-import */

/* dynamic-import */
var $ReviewRoute = exports.$ReviewRoute = _squid.$ComponentRoute.extend('$ReviewRoute', {

    path: 'review',
    directive: _directive.$xoReviewPageComponent,
    titleContent: 'memberReview.memberReviewTitle',
    params: { message: null },
    trackingData: {
        fptiState: 'review',
        templateName: 'memberReview.dust',
        pageGoal: 'Payment Review',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-review',
                'pagename2': '%::fullpage-review:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    resolve: {
        action: function action() {

            // Determine if we should instead route to the selectFi choice experiment page
            if (!(0, _squid.$feature)('choiceExperiment')) {
                return;
            }

            var _$config$choiceExperi = _squid.$config.choiceExperiment;
            _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
            var _$config$choiceExperi2 = _$config$choiceExperi.selectFi,
                fiPageVariants = _$config$choiceExperi2 === undefined ? [] : _$config$choiceExperi2,
                _$config$choiceExperi3 = _$config$choiceExperi.skipSelectFi,
                skipFiPageVariants = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3;
            var fromState = _uiRouter.$state.fromState,
                toParams = _uiRouter.$state.toParams;

            var skipStates = ['checkout.review', 'checkout.selectFi', 'checkout.authorizationmessage', 'checkout.pageAddCard.addCardFlow.addCard', 'checkout.chooseCreditOffer'];

            // Is review route hit a result of CREDIT_CARD_AUTH_FAILED, i.e. smart $x auth check failure?
            var isFromCcAuthFailure = toParams && toParams.message === 'CREDIT_CARD_AUTH_FAILED';
            if (!isFromCcAuthFailure && (!fromState.name ||
            // Current state contains one of the skip states (can be nested)
            skipStates.some(function (state) {
                return fromState.name.indexOf(state) !== -1;
            }))) {
                return;
            }

            // If returning from credit application, skip the selectFi page
            var isCapeReturnKey = _credit.$CreditDataModel.instance(_angular.$rootScope.token).getCapeKey();

            if (isCapeReturnKey) {
                return;
            }

            return _choice.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
                // Check if variant is selectFi variant
                if (fiPageVariants.indexOf(variant) === -1) {
                    return;
                }

                var models = {};

                // Check that there is more than one plan to choose from, or that plan is not preferred
                return (0, _squid.$populate)(models, {
                    checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                    checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token)
                }).then(function () {
                    /**
                     * instant update callback which is making external api calls
                     * to get shipping charge and same is getting updated into checkout session (patch call)
                     * selectFI page is updating the plan id from initial post on checkout session
                     * but because of patch call for shipping charge old plan id is not valid
                     * and the update to PAPS resulted in internal error
                     * skip the choice page if it is instant update flow
                     */
                    if (models.checkoutCart.get('instantUpdateIntegration')) {
                        return;
                    }

                    var plans = models.checkoutSession.get('fundingOptions.plans');
                    var isPreferredDefault = skipFiPageVariants.indexOf(variant) > -1 && plans && plans[0].primaryFs.isPreferred;
                    var stickyPlans = models.checkoutSession.futurePaymentInstruments;

                    if (!isPreferredDefault && (plans && plans.length > 1 || stickyPlans && stickyPlans.length > 1)) {
                        return {
                            to: 'checkout.selectFi',
                            newState: true
                        };
                    } else {
                        _logger.$logger.info('skip_selectFi', {
                            reason: isPreferredDefault ? 'default_is_preferred' : 'not_enough_plans'
                        });
                        return;
                    }
                });
            });
        }
    },

    children: [{
        name: '$SidebarRoute',
        attributes: {
            'back-uri': 'backUri',
            'shipping-change-feature': 'shippingChangeFeature',
            'promotion': 'promotion',
            'update': 'update',
            'token': 'token',
            'installment': 'installment',
            'strict-address-normalization': 'strictAddressNormalization',
            'shipping-address': 'shippingAddress',
            'on-address-normalized': 'onAddressNormalized'
        },
        lazyRoute: 'pages/xo-sidebar/route',
        slug: 'sidebar'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token',
            'on-complete': 'onComplete'
        },
        lazyRoute: 'xo-login-components/src/onetouch-interstitial/route',
        slug: 'oneTouchUpsell'
    }, {
        name: '$xoConfirmUpopRoute',
        props: function props() {
            var props = {
                token: this.token,
                cardmodel: this.cardModel
            };

            if (this.upopCallbacks.isOnUpdate) {
                props.onSuccess = this.upopCallbacks.onUpdateSuccess;
                props.onCancel = this.upopCallbacks.onUpdateCancel;
            } else {
                props.onSuccess = this.upopCallbacks.onConfirmUpopSuccess;
                props.onCancel = this.upopCallbacks.onConfirmUpopCancel;
            }

            return props;
        },

        lazyRoute: 'xo-wallet-components/src/confirm-upop/route',
        slug: 'confirmUpop'
    }, {
        name: '$SidepageRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-sidepage/route',
        slug: 'sidepage'
    }]
}); /* dynamic-import */
/* dynamic-import */


angular.value("$ReviewRoute", $ReviewRoute);
_logger.$logger;

_squid.$ComponentRoute;

_squid.$feature;

_squid.$config;

_squid.$populate;

_angular.$rootScope;

_uiRouter.$state;

_directive.$xoReviewPageComponent;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_choice.$ChoiceEligibility;

_credit.$CreditDataModel;

/***/ }),

/***/ "./pages/xo-review/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-review/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"review\" content ng-click=\"onPageClick($event)\" id=\"memberReview\" tabindex=-1 role=\"presentation\">\n    <xo-sticky-cta eligibility=\"stickyEligibility\" ng-if=\"stickyEligibility === 'top'\">\n        <!--Action button -->\n        <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('memberReview.viewPaypalPolicies')\"></p>\n\n        <div ng-if=\"showPaymentRights\">\n            <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n            <span class=\"diagonalArrow\"></span>\n        </div>\n\n        <!--Invoicing Flow RegE message in cases of RTR -->\n        <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n            <div>{{ invoicingRegEMsg }}</div>\n        </div>\n\n        <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n            {{ content('confirmUpop.confirmUpopToPay')}}\n        </p>\n\n        <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n        </p>\n\n        <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n            <!--content-->\n            <h4 class=\"noBottom paymentsHeader zeta\">{{ content('messenger.pluginHeader') }}</h4>\n            <div>\n                <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                <p class=\"messengerLegalTxt\" data-ng-bind-html=\"content('messenger.legal')\"></p>\n            </div>\n        </div>\n\n        <div id=\"button\" class=\"buttons reviewButton\">\n            <input\n                track-submit\n                type=\"submit\"\n                value=\"{{payButtonText()}}\"\n                id=\"confirmButtonTop\"\n                class=\"btn full confirmButton continueButton\"\n                data-test-id=\"continueButton\"\n                validate-submit=\"onPay()\"\n            />\n        </div>\n    </xo-sticky-cta>\n    <!-- >>> CTA Disclaimer -->\n    <span  ng-if=\"stickyEligibility === 'top'\" class=\"stickyCtaTopDisclaimers\">\n        <!-- checkoutSession.isRT need to review this -->\n        <p class=\"reviewLaterContainer disclaimer\" data-test-id=\"reviewLaterContainer\" ng-if=\"!buttonLabelIsPay && showReviewLaterText && !isCPAEligible\">\n                {{ content('common.reviewLater')}}\n            </p>\n\n            <xo-cpa-disclaimer selectedmethod=\"selectedmethod\" primaryplan=\"primaryplan\" ng-if=\"isCPAEligible\"></xo-cpa-disclaimer>\n\n            <div class=\"disclaimer reviewMsg singApacDisclaimer\" ng-if=\"shouldDisplayAPACDisclaimer()\"\n                ng-bind-html=\"content('common.textComplianceContinueMessage')\"\n            ></div>\n\n            <div id=\"disclaimerWithBmlCta\" class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && showSoftDescriptor && checkoutSession.plan.soft_descriptor\"\n                ng-bind-html=\"content('memberReview.disclaimer', {merchantName: checkoutSession.plan.soft_descriptor})\"></div>\n\n            <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.displayBankChargeDisclaimer\">{{ content('memberReview.bankChargeDisclaimer')}}</div>\n\n            <div class=\"billingAddressConsent reviewMsg\" ng-if=\"checkoutAppData.flags.billing_address_consent_required\">\n                <p class=\"disclaimer\">{{ content('memberReview.billingRequired') }}\n                    <p>\n            </div>\n\n            <div class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && (checkoutSession.plan.isAuthSignupEnabled || showAuthMsg)\">\n                <span class=\"authMsgContent\">{{ content('memberReview.authUser') }}</span>\n                <span ng-if=\"showAuthMsgLearnMore\">\n                    <a ui-sref=\"checkout.authorizationmessage\" class=\"authUserLink\" aria-describedby=\"authMsgHelp\">{{ content('memberReview.learnMore') }}</a>\n                    <span id=\"authMsgHelp\" class=\"accessAid\">{{content('authUserLearnMore.authUserTitle')}}</span>\n                </span>\n            </div>\n    </span>\n    <!-- <<< CTA Disclaimer -->\n\n    <xo-title title-txt=\"{{content('memberReview.memberReviewTitle')}}\" class=\"accessAid\"></xo-title>\n    <div ng-if=\"!checkoutCart.isWalletTokenization()\" class=\"row-fluid justMember\" ng-class=\"{ bmlPopupOpen: bmlPopupOpen }\">\n        <div class=\"span14 trayInner reviewSections\" ng-show=\"!bmlPopupOpen\">\n            <xo-message ng-if=\"showCreditDisallowedMessage()\" message=\"creditDisallowedMessage\"></xo-message>\n            <xo-message ng-if=\"showGamblingMessage()\" message=\"gamblingMessage\"></xo-message>\n            <xo-no-balance-banner ng-if=\"noBalanceFactoryState.eligible && shouldShowPendingBalance\"></xo-no-balance-banner>\n            <div class=\"rtrLanguageToggle\">\n                <a ng-if=\"showRTRLanguageToggle\" ng-click=\"reloadPageLanguageToggle()\">{{ rtrContent }}</a>\n            </div>\n            <div class=\"userBanner\">\n                <xo-banner ng-if=\"isNmjexpired || (personalizedBanner.show && !isMessengerBAIntegration)\" is-nmj=\"isNmj || isNmjexpired\">\n                    <p class=\"userEmail\" id=\"reviewUserInfo\">\n                        <span ng-if=\"isNmjDesign1\">{{ content('memberReview.hiUser_welcome', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"!isNmjDesign1 && !optin_toggle.isEnabled\">{{ content(!personalizedBanner.isFBSkipLogin ? 'memberReview.loggedInWithOneTouch' : 'memberReview.loggedInFaceBookBA', {userName: formattedNameInformal, lastName: auth.last_name, firstName: auth.first_name}) }}</span>\n                        <span ng-if=\"!isNmjDesign1 && optin_toggle.isEnabled\">{{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"isNmjexpired && optin_toggle.isEnabled\">{{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"showNotYou\">\n                            <xo-not-you></xo-not-you>\n                        </span>\n                        <div ng-if=\"isNmjexpired\" id=\"notifications\" content>\n                            <div class=\"msgPage msg-normal\">\n                                <span class=\"icon\"></span>\n                                <ul>\n                                    <li>\n                                        <span ng-bind-html=\"htmlContent('creditcard.preferredExpired', {cardType: preferredExpired.displayName, last4:\n                                            preferredExpired.lastDigits})\" ></span><span>\n                                            <a id=\"updatePreferredExpired\" track-submit=\"update_preferred_expired\" href\n                                               ng-click=\"actions.goToManageWallet(preferredExpired.id)\">{{content('creditcard.updateItNow')}}</a></span>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </p>\n                </xo-banner>\n                <div class=\"greyHeader\" ng-if=\"showGreyHeader\">\n                    <xo-banner is-nmj=\"showGreyHeader\">\n                        <p class=\"userEmail\" id=\"reviewUserInfo\">\n                            <span>{{ headerMsg }}</span>\n                            <span ng-if=\"showNotYou\" class=\"greyHeaderNotYou\">\n                                <xo-not-you></xo-not-you>\n                            </span>\n                        </p>\n                    </xo-banner>\n                </div>\n                <xo-expired-message ng-if=\"showExpiredMsg && !isNmjexpired\" token=\"token\"></xo-expired-message>\n                <xo-message ng-if=\"!hideBlacklistMsg  && showMessage\" message=\"checkoutSession.message\" isGreyHeader=\"showGreyHeader\"></xo-message>\n                <div ng-if=\"!isNmj && !personalizedBanner.show && !isMessengerBAIntegration && !isNmjexpired && !isProcessorDeclineExperiment\">\n                    <p class=\"userEmail\" id=\"reviewUserInfo\">\n                        {{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}\n                        <span ng-if=\"showNotYou\">\n                            <xo-not-you></xo-not-you>\n                        </span>\n                    </p>\n                </div>\n            </div>\n            <div ng-if=\"optin_toggle.isEnabled\" class=\"oneTouchBanner\">\n                <div ng-if=\"!isNmj\" class=\"highlight_bar\"></div>\n                <div class=\"oneTouchTerms\">\n                    <p class=\"enable_auto_login bold\" ng-if=\"!optin_toggle.value\">{{ content('memberReview.autoLoginOff') }}</p>\n                    <p class=\"enable_auto_login\" ng-if=\"optin_toggle.value\">{{ content('memberReview.autoLoginOn') }}</p>\n\n                    <div ng-show=\"optin_toggle.showExpandedTerms\" class=\"oneTouchTermsText\">\n                        <p class=\"expanded\" ng-bind-html=\"htmlContent('memberReview.expandedTermsOT')\"></p>\n                        <p class=\"securityInfo\">\n                            {{ content('memberReview.securityInfoOT') }} <a ng-click=\"optin_toggle.showExpandedTerms = !optin_toggle.showExpandedTerms\">{{ content('common.hide') }}</a>\n                        </p>\n                    </div>\n                    <div ng-show=\"!optin_toggle.showExpandedTerms\">\n                        <p class=\"securityInfo\">\n                            <span ng-show=\"!optin_toggle.value\">{{ content('memberReview.sharedDevicesOT') }}</span>\n                            <a ng-click=\"optin_toggle.showExpandedTerms = !optin_toggle.showExpandedTerms\">Details</a>\n                        </p>\n                    </div>\n                </div>\n                <div id=\"banner-switch\">\n                    <input id=\"optin_toggel\" class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\" ng-model=\"optin_toggle.value\" ng-change=\"onTouchToggle(optin_toggle.value)\">\n                    <label for=\"optin_toggel\"></label>\n                </div>\n            </div>\n            <xo-decline-notification ng-if=\"isCPAEligible\" />\n            <form name=\"confirm\" class=\"proceed\" novalidate=\"novalidate\" id=\"ryiForm\">\n                <!-- {@if cond=\"'{data.updated}' === 'bmlSuccess'\" } -->\n                <div class=\"reviews\" ng-if=\"isNmjDesign1\">\n                    <xo-assist-banner\n                        header=\"assistBannerHeader\"\n                        body=\"assistBannerBody\"\n                        hide-highlight=\"checkoutSession.message\">\n                    </xo-assist-banner>\n                </div>\n\n                <xo-offer-top-banner ng-if=\"!isThirdPartyWalletExperience()\"></xo-offer-top-banner>\n\n                <div class=\"reviews\" ng-if=\"merchantMsg\">\n                    <h4 ng-if=\"!isMessengerBAIntegration\" class=\"noBottom gamma\" id=\"merchantMsgHeader\">\n                        {{ content('memberReview.merchantMsgHeader', { merchantName: merchantName }) }}\n                    </h4>\n                    <!--content-->\n                    <h1 ng-if=\"isFacebookBAIntegration\" class=\"messengerBAHeader\" id=\"merchantMsgHeader\">\n                        {{ content('messenger.fbHeader') }}\n                    </h1>\n                    <h1 ng-if=\"!isFacebookBAIntegration && isMessengerBAIntegration\" class=\"messengerBAHeader\" id=\"merchantMsgHeader\">\n                        {{ content('messenger.baHeader') }}\n                    </h1>\n                    <div class=\"merchantMsg\" id=\"merchantMsg\">\n                        <span class=\"given-name\">\n                            {{ merchantMsg }}\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"isNmjDesign1 || isNmjDesign2\">\n                    <div class=\"addPadding\" ng-if=\"isNmjDesign2\"></div>\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-balance-rebranded=\"PPBalanceFlow\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\"\n                                       choice-balance-checkbox-state=\"choiceBalanceCheckboxState\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"showInstallmentOption()\">\n                    <div id=\"installmentPlanInfo\" data-test-id=\"installmentPlanInfo\">\n                        <h4 class=\"noBottom gamma\" id=\"installmentInfoHeader\">\n                            {{content('chooseCreditOption.reviewPaymentPlan')}}\n                        </h4>\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"showInstallmentOptionWithoutIncentives()\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: installmentInfo.monthlyPaymentAmt})\"> </p>\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: installmentInfo.totalInterestAmt, totalPayment: installmentInfo.totalPaymentAmt})\"> </p>\n                        </div>\n\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'SAC'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('fundingInstruments.bmlDetails')\"> </p>\n                        </div>\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'NI'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('fundingInstruments.bmlDetailsNI')\"> </p>\n                        </div>\n                        <a class=\"edits creditEdit\" ng-if=\"showChange()\" ng-click=\"showCYCO()\">\n                            {{ content('common.change') }}\n                            <span class=\"frontArrow goTray ng-scope\"></span>\n                        </a>\n                    </div>\n                </div>\n\n                <div\n                    class=\"reviews shippingOptionsWrapper\"\n                    ng-if=\"!showShippingMethod && hasShippingOptions()\">\n                    <div class=\"addPadding\" ng-if=\"isNmjDesign3\"></div>\n                    <h2 class=\"paymentsHeader zeta\">{{content('shipping.orderChoiceLabel')}}</h2>\n                    <xo-shipping-options\n                        ng-if=\"hasShippingOptions()\"\n                        token=\"token\"\n                        on-select=\"selectShippingOption\"\n                        selected-method=\"selectedShippingOption\"\n                        methods=\"shippingOptions\">\n                    </xo-shipping-options>\n                </div>\n                <div class=\"reviews\" ng-if=\"!hasShippingOptions() && showShippingAddress\">\n                    <div class=\"addPadding\" ng-if=\"isNmjDesign3\"></div>\n                    <xo-review-address\n                        token=\"token\"\n                        make-addr-preferred=\"makeAddrPreferred\"\n                        shipping-change-feature=\"shippingChangeFeature\"\n                        store-pick-up-selected=\"checkoutCart.isShippingMethodStorePickUp()\"\n                        nmj-experience=\"nmjExperience\"\n                    ></xo-review-address>\n                </div>\n\n                <xo-select-shipping-method ng-if=\"showShippingMethod\" token=\"token\" show-shipping-address=\"showShippingAddress\" error-handler-helper=\"errorHandlerHelper\" instant-update-feature=\"instantUpdateFeature\"></xo-select-shipping-method>\n\n                <div class=\"reviews\" ng-if=\"!isNmj\">\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-balance-rebranded=\"PPBalanceFlow\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\"\n                                       choice-balance-checkbox-state=\"choiceBalanceCheckboxState\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"isNmjDesign3\">\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-balance-rebranded=\"PPBalanceFlow\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <p ng-if=\"isMessengerBAIntegration\" class=\"secondary messengerDisclaimer\">{{ content('messenger.disclaimer') }}</p>\n\n                <div ng-if=\"showCreditPlacement()\" class=\"PPCOffers\" ng-class=\"{ 'reviews hideOffersSeparator hideSeparator': isNmj}\">\n                    <xo-credit-offer-banners token=\"token\" />\n                </div>\n\n                <div id=\"optionalVaulting\" data-test-id=\"optionalVaulting\" class=\"optional-vault\" ng-if=\"isOptionalVaulting()\">\n                    <div id=\"optionalVaultContainer\">\n                        <label data-test-id=\"save_paypal_checkmark\" class=\"container\">{{ content('billingAgreement.saveTextHeader', { merchantName: merchantName })}}\n                            <input type=\"checkbox\" ng-model=\"vault.checked\" ng-change=\"changeVaultSelection()\">\n                            <span class=\"checkmark\"></span>\n                        </label>\n                    </div>\n                    <p id=\"optionalAgreementText\" data-test-id=\"optionalAgreementText\"  class=\"agreement-content\" bind-html-compile=\"getOptInContent()\"></p>\n                </div>\n\n                <div ng-if=\"isDonation\" class=\"gacDonation\">\n                    <xo-donate merchant-name={{merchantName}}></xo-donate>\n                </div>\n\n                <div ng-if=\"showRemittanceDisclosure\" class=\"rtrWrap\">\n                    {{ content('memberReview.rtrMsg', { merchantName: checkoutAppData.merchant.brand_name }) }}\n                </div>\n\n                <!--inc/bmlLearnMore-->\n                <div>\n                    <div class=\"buttons bmlSeeTermsBtn hide\">\n                        <button class=\"btn full hide\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                    </div>\n                </div>\n                <xo-sticky-cta eligibility=\"stickyEligibility\" ng-if=\"stickyEligibility === 'bottom'\">\n                    <!--Action button -->\n                    <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('{{policyContentKey()}}', country: locale.country, lang: locale.lang)\"></p>\n\n                    <div ng-if=\"showPaymentRights\">\n                        <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n                        <span class=\"diagonalArrow\"></span>\n                    </div>\n\n                    <!--Invoicing Flow RegE message in cases of RTR -->\n                    <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n                        <div>{{ invoicingRegEMsg }}</div>\n                    </div>\n\n                    <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n                        {{ content('confirmUpop.confirmUpopToPay')}}\n                    </p>\n\n                    <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n                    </p>\n\n                    <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n                        <!--content-->\n                        <h4 class=\"noBottom paymentsHeader zeta\">{{ content('messenger.pluginHeader') }}</h4>\n                        <div>\n                            <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                            <p class=\"messengerLegalTxt\" data-ng-bind-html=\"content('messenger.legal')\"></p>\n                        </div>\n                    </div>\n\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" ng-disabled=\"onPayButtonDisabled\" data-test-id=\"continueButton\" validate-submit=\"onPay()\" />\n                    </div>\n                </xo-sticky-cta>\n                <div ng-if=\"!stickyEligibility\">\n                    <!--Action button -->\n                    <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('{{policyContentKey()}}')\"></p>\n\n                    <div ng-if=\"showPaymentRights\">\n                        <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n                        <span class=\"diagonalArrow\"></span>\n                    </div>\n\n                    <!--Invoicing Flow RegE message in cases of RTR -->\n                    <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n                        <div>{{ invoicingRegEMsg }}</div>\n                    </div>\n\n                    <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n                        {{ content('confirmUpop.confirmUpopToPay')}}\n                    </p>\n\n                    <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n                    </p>\n\n                    <p ng-if=\"showBAPolicyAgreement\" id=\"sgbaPolicyAgreement\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('memberReview.viewPaypalPolicies', {country: locale.country})\"></p>\n\n                    <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n                        <!--content-->\n                        <h4 class=\"noBottom paymentsHeader zeta\">{{ content('messenger.pluginHeader') }}</h4>\n                        <div>\n                            <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                            <p class=\"messengerLegalTxt\" data-ng-bind-html=\"content('messenger.legal')\"></p>\n                        </div>\n                    </div>\n\n                    <p ng-if=\"showUpdatedUserAgreement\" class=\"updatedUserAgreement\" data-ng-bind-html=\"updatedUserAgreementContent\" ng-click=\"actions.onTermsAndConditionListenerClick($event)\"></p>\n\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" ng-disabled=\"onPayButtonDisabled\" data-test-id=\"continueButton\" validate-submit=\"onPay()\" />\n                    </div>\n\n                    <div ng-if=\"isDEInstallmentsApproved()\" class=\"cancelButton\">\n\n                        <a href=\"\" ng-click=\"actions.openCancelApplicationModal()\">{{ content('memberReview.bmlCancelApplication') }}</a>\n\n                        <xo-modal show=showCancelApplicationModal show-close-button=\"true\" on-close=\"actions.closeCancelApplicationModal\"  ng-click=\"actions.handleCancelApplicationModalClick($event)\">\n                            <div class=\"confirmDialogTopBox\">\n                                <div class=\"confirmDialogText\">\n                                    <p>{{ content('memberReview.bmlCancelApplicationConfirmation') }}</p>\n                                </div>\n                                <div class=\"confirmDialogButtons\">\n                                    <input type=\"button\" class=\"btn full primary\" value=\"{{ content('memberReview.bmlCancelApplication') }}\" ng-click=\"cancelCreditApplication()\" />\n                                    <a href=\"\" ng-click=\"actions.closeCancelApplicationModal()\">{{ content('memberReview.bmlDoNotCancelApplication') }}</a>\n                                </div>\n                            </div>\n                        </xo-modal>\n                    </div>\n                </div>\n\n                <!--content-->\n                <div class=\"messengerBANotnow\" ng-if=\"isMessengerBAIntegration\">\n                    <a href=\"\" ng-click=\"onFBBANotNow()\">{{ content('messenger.button_notNow') }}</a>\n                </div>\n\n                <!-- >>> CTA Disclaimer -->\n                <span  ng-if=\"stickyEligibility !== 'top'\">\n                    <!-- checkoutSession.isRT need to review this -->\n                    <p class=\"reviewLaterContainer disclaimer\" data-test-id=\"reviewLaterContainer\" ng-if=\"!isThirdPartyWalletExperience() && !buttonLabelIsPay && showReviewLaterText && !isCPAEligible\">\n                        {{ content('common.reviewLater')}}\n                    </p>\n                    <p class=\"reviewLaterContainer disclaimer\" ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\">\n                        {{ content('paymentMethod.venmoReceipt') }}\n                    </p>\n\n                    <xo-cpa-disclaimer selectedmethod=\"selectedmethod\" primaryplan=\"primaryplan\" ng-if=\"isCPAEligible\"></xo-cpa-disclaimer>\n\n                    <div class=\"disclaimer reviewMsg singApacDisclaimer\" ng-if=\"shouldDisplayAPACDisclaimer()\"\n                        ng-bind-html=\"content('common.textComplianceContinueMessage')\"\n                    ></div>\n\n                    <div id=\"disclaimerWithBmlCta\" class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && showSoftDescriptor && checkoutSession.plan.soft_descriptor\"\n                        ng-bind-html=\"content('memberReview.disclaimer', {merchantName: checkoutSession.plan.soft_descriptor})\"></div>\n\n                    <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.displayBankChargeDisclaimer\">{{ content('memberReview.bankChargeDisclaimer')}}</div>\n\n                    <div class=\"billingAddressConsent reviewMsg\" ng-if=\"checkoutAppData.flags.billing_address_consent_required\">\n                        <p class=\"disclaimer\">{{ content('memberReview.billingRequired') }}\n                            <p>\n                    </div>\n\n                    <div class=\"disclaimer reviewMsg\" ng-if=\"showAuthDisclaimer\">\n                        <span class=\"authMsgContent\">{{ content('memberReview.authUser') }}</span>\n                        <span ng-if=\"showAuthMsgLearnMore\">\n                            <a ui-sref=\"checkout.authorizationmessage\" class=\"authUserLink\" aria-describedby=\"authMsgHelp\">{{ content('memberReview.learnMore') }}</a>\n                            <span id=\"authMsgHelp\" class=\"accessAid\">{{content('authUserLearnMore.authUserTitle')}}</span>\n                        </span>\n                    </div>\n                </span>\n                <!-- <<< CTA Disclaimer -->\n\n                <xo-credit-example-uk ng-if=\"showRepresentativeExample()\"/>\n            </form>\n\n        </div>\n\n        <xo-bml-popup ng-if=\"!isThirdPartyWalletExperience()\"></xo-bml-popup>\n\n        <div ng-show=\"bmlPopupOpen\" class=\"bmlPopup span14\">\n            <p>\n                {{ content('fundingInstruments.bmlLearnMoreDesc') }}\n            </p>\n\n            <input type=\"button\" class=\"btn full primary\" value=\"{{ content('fundingInstruments.ok') }}\" ng-click=\"hideBmlPopup()\" />\n        </div>\n\n        <div class=\"span10\" ng-if=\"!isThirdPartyWalletExperience()\">\n\n            <xo-marketing-offers placement-code=\"'202003'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"propValueObj.propHeader\"\n                                 subtitle-property=\"propValueObj.propVal\"\n                                 background-image= \"propValueObj.propImage\"\n                                 ng-if=\"!ryiDesignExp && !isMessengerBAIntegration\"\n            >\n            </xo-marketing-offers>\n\n            <xo-marketing-offers token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"'ryiDesignExp.propHeader'\"\n                                 subtitle-property=\"'ryiDesignExp.propText'\"\n                                 background-image=\"{{ryiDesignExp.propImage}}\"\n                                 ng-if=\"ryiDesignExp && !isMessengerBAIntegration\"\n\n            >\n            </xo-marketing-offers>\n        </div>\n    </div>\n    <div class=\"reviewTopup\" ng-if=\"checkoutCart.isWalletTokenization()\">\n        <div class=\"reviewTopupError\">\n            <xo-message message=\"tokenizedFactoryState.reviewTopupErrorMessage\"></xo-message>\n        </div>\n        <div class=\"topupError\" ng-if=\"topupError\">\n            <span class=\"topupErrorIcon\"></span>\n            <span>{{content('review.pinError')}}</span>\n        </div>\n        <span ng-if=\"!balanceUsage\">\n            <xo-title title-txt=\"{{content('review.reviewDetailsTitle', {type: tokenizedWalletInfoModel.brandName()})}}\"></xo-title>\n            <div class=\"topupMsg\" ng-if=\"!PPBalanceFlow\">\n                <span>{{content('review.tokenizationInfo', {type: tokenizedWalletInfoModel.brandName()})}}</span>\n            </div>\n            <div class=\"topupMsg\" ng-if=\"PPBalanceFlow\">\n                <span>{{content('review.tokenizationInfoPPBalance', {type: tokenizedWalletInfoModel.brandName()})}}</span>\n            </div>\n        </span>\n        <span ng-if=\"balanceUsage\" class=\"fillflex\">\n            <xo-title title-txt=\"{{content('review.balanceUsageTitle', {type: tokenizedWalletInfoModel.brandName()})}}\"></xo-title>\n            <div class=\"topupMsg\">\n                <span>{{content('review.tokenizationInfoBalanceUsage', {type: tokenizedWalletInfoModel.brandName()})}}</span>\n            </div>\n        </span>\n        <xo-review-topup ng-if=\"!balanceUsage\" class=\"fillflex\" token=\"token\" flags=\"tokenizedFactoryState.tokenizationFlags\" show-balance-flow=\"PPBalanceFlow\"></xo-review-topup>\n        <div data-test-id=\"updatedTokenizedUserAgreement\" ng-if=\"showUpdatedUserAgreement\" class=\"disclaimer reviewMsg\" data-ng-bind-html=\"updatedUserAgreementContent\" ng-click=\"actions.onTermsAndConditionListenerClick($event)\"></div>\n        <div ng-if=\"tokenizedFundingCapabilitiesModel.isTopupEnabled()\" class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.topupCommonSetting')\"></div>\n        <div ng-if=\"!balanceUsage\" class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.topupTokenizedWalletSetupAgreements', {type: tokenizedWalletInfoModel.brandName(), link: tokenizedWalletInfoModel.getDisclaimerLink()})\"></div>\n        <div ng-if=\"balanceUsage\" class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.balanceUsageTokenizedWalletSetupAgreements', {type: tokenizedWalletInfoModel.brandName(), link: tokenizedWalletInfoModel.getDisclaimerLink()})\"></div>\n        <div id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\"\n                class=\"btn full confirmButton continueButton\" data-test-id=\"continueButton\" ng-disabled=\"onPayButtonDisabled\" ng-click=\"onPay()\" />\n        </div>\n    </div>\n\n    <div ui-view></div>\n    <xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" ng-if=\"launch3DSResolver\"></xo-3ds>\n\n    <!-- 3ds 2.0 -->\n    <xo-modal\n        ng-if=\"showThreedsPopup\"\n        show=\"showThreedsPopup\"\n        enable-mobile-interstitial=\"true\"\n        show-close-button=\"true\"\n        on-close=\"actions.onThreedsModalClose\"\n        override-default-container=\"true\">\n        <xo-three-ds\n            token=\"token\"\n            reference-id=\"threedsData.referenceId\"\n            jwt-info=\"threedsData.jwtInfo\"\n            card-bin=\"threedsData.cardBin\"\n            network-logo=\"threedsData.networkLogo\"\n            ddc-url=\"threedsData.ddcUrl\"\n            card-brand=\"threedsData.cardBrand\"\n            integration-type=\"threedsData.integrationType\"\n            init-threeds-data=\"threedsData.initThreedsData\"\n            on-complete=\"onCompletethreedsHandler\">\n        </xo-three-ds>\n    </xo-modal>\n\n\n</section>\n"

/***/ }),

/***/ "./pages/xo-review/tokenizedFactory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$TokenizedFactory', function () {

    var state = {
        reviewTopupErrorMessage: {},
        tokenizationFlags: {
            sepaAgree: false
        }
    };

    var get = function get() {
        return state;
    };

    var AUTHORIZE_AND_UPDATE_SCOPE_BATCH = 'authorizeAndUpdateScope';
    var AUTHORIZE_CALL = 'authorize';

    /**
     * PatchXO api call for tokenization flows
     */
    var tokenizationPatchXO = function tokenizationPatchXO(checkoutSession, instrumentId) {
        return checkoutSession.action('setTopupFI', {
            data: {
                instrument_id: instrumentId
            }
        });
    };

    /**
     * Agree Sepa Mandate:
     *  When user has clicked on the checkbox, call SepaAccept api, then calls PatchXO
     *  When user has not clicked on the checkbox, show page level error message
     */
    var agreeSepaMandate = function agreeSepaMandate(checkoutCart, checkoutSession, tokenizedWalletInfoModel) {
        if (checkoutCart.isWalletTokenization()) {
            var bankId = checkoutSession.get('sepa_mandate.bankId');
            if (bankId && state.tokenizationFlags.sepaAgree) {
                // User agreed to the Sepa mandate by clicking on the checkbox
                return _fi.$SepaModel.instance().action('sepaAccept', {
                    data: {
                        bank: {
                            id: bankId
                        }
                    },
                    success: function success() {
                        // Patch XO after Sepa agreed by user, so as to update PAPS
                        return tokenizationPatchXO(checkoutSession, bankId);
                    }
                });
            } else if (bankId) {
                // User did not agree to the Sepa mandate
                var msg = (0, _squid.$renderContent)('tokenization.agreeToSepaMsg', {
                    type: tokenizedWalletInfoModel.brandName()
                });

                state.reviewTopupErrorMessage = {
                    msgs: [msg],
                    type: 'warning'
                };
                return _angular.$q.reject();
            }
        }
        return _angular.$q.when();
    };

    /**
     * Save the pin when its available
     */
    var setTokenizedWalletPin = function setTokenizedWalletPin(walletPinModel) {
        if (walletPinModel) {
            var pinModel = {
                data: {
                    pin: walletPinModel.userPin
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('tokenized_wallet', {
                            'from': 'TopUp_REVIEW',
                            'to': 'process_review',
                            'context_id': _angular.$rootScope.token,
                            'context_type': 'BA-Token',
                            'billing_token': _squid.$meta.baToken,
                            'int_error_code': 'pin_setup_contingencies',
                            'int_error_description': err,
                            'error_source': 'issuancemanagementserv'
                        });

                        throw err;
                    }
                }
            };

            if (walletPinModel.isSetupEligible()) {
                if (walletPinModel.isPinIdPresent()) {
                    pinModel.data.pinId = walletPinModel.getPinId();
                }
                return walletPinModel.save(pinModel);
            }
        }
        return _angular.$q.when();
    };

    var tokenizedOnPayCalls = function tokenizedOnPayCalls(checkoutCart, checkoutSession, tokenizedWalletInfoModel, walletPinModel) {
        return agreeSepaMandate(checkoutCart, checkoutSession, tokenizedWalletInfoModel).then(function () {
            return setTokenizedWalletPin(walletPinModel);
        });
    };

    /**
     * log FPTI event after authorize or authorizeAndUpdateScope call
     */
    var logProcessReviewToFPTI = function logProcessReviewToFPTI() {
        var _$WalletPreferences$i = _fi.$WalletPreferences.instance(_angular.$rootScope.token),
            _$WalletPreferences$i2 = _$WalletPreferences$i.topup,
            topup = _$WalletPreferences$i2 === undefined ? {} : _$WalletPreferences$i2,
            _$WalletPreferences$i3 = _$WalletPreferences$i.direct,
            direct = _$WalletPreferences$i3 === undefined ? {} : _$WalletPreferences$i3,
            currency = _$WalletPreferences$i.currency;

        _logger.$logger.info('tokenized_wallet', {
            'from': 'TopUp_REVIEW',
            'to': 'process_review',
            'topup_amt': topup.amount,
            'chosen_topup_fi': topup.fundingSource && topup.fundingSource.type,
            'chosen_direct_fi': direct.fundingSource && direct.fundingSource.type,
            'currency_code': currency || topup.currency,
            'context_id': _angular.$rootScope.token,
            'context_type': 'BA-Token',
            'billing_token': _squid.$meta.baToken
        });
    };

    /**
     * Update user's scope with "issuance" scope for Google account linking flow
     * Call must be triggered only after successfull "authorize" call
     *
     * If successfull - redirect back to success url
     *
     * If there is a contingency (UAL_ISSUANCE_UPDATE_SCOPE_ERROR) - go to default tokenized wallet error page (see public/js/lib/contingency.js)
     *
     * To improve latency - batch it with "authorize" call
     */
    var updateIssuanceScope = function updateIssuanceScope() {
        var authConsentModel = _user.$AuthConsentModel.instance();

        return authConsentModel.action('updateIssuanceScope', {
            batch: {
                name: AUTHORIZE_AND_UPDATE_SCOPE_BATCH,
                id: 'updateIssuanceScope',
                dependencies: [AUTHORIZE_CALL]
            },
            data: {
                'ba_token': _squid.$meta.baToken
            },
            success: function success() {
                _logger.$logger.info('ual_update_issuance_scope_success');
                logProcessReviewToFPTI();

                return _uiRouter.$state.go('checkout.end');
            }
        });
    };

    /**
     * Check if flow is Google account linking
     */
    var isGoogleAccountLinking = function isGoogleAccountLinking() {
        var checkoutCart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var auth = _auth.$AuthModel.instance();

        return checkoutCart.isWalletTokenization() && auth.logged_in && auth.disallow_login_switch;
    };

    /**
     * Construct batch object for "authorize" call
     */
    var getAuthorizeBatch = function getAuthorizeBatch() {
        return {
            name: AUTHORIZE_AND_UPDATE_SCOPE_BATCH,
            id: AUTHORIZE_CALL,
            dependencies: []
        };
    };

    return {
        get: get,
        agreeSepaMandate: agreeSepaMandate,
        setTokenizedWalletPin: setTokenizedWalletPin,
        tokenizedOnPayCalls: tokenizedOnPayCalls,
        updateIssuanceScope: updateIssuanceScope,
        isGoogleAccountLinking: isGoogleAccountLinking,
        logProcessReviewToFPTI: logProcessReviewToFPTI,
        getAuthorizeBatch: getAuthorizeBatch
    };
});

_angular.$q;

_angular.$rootScope;

_squid.$meta;

_squid.$renderContent;

_fi.$SepaModel;

_logger.$logger;

_user.$AuthConsentModel;

_auth.$AuthModel;

_fi.$WalletPreferences;

_checkout.$CheckoutCartModel;

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-review", "pages/xo-review/tokenizedFactory.js"))

/***/ }),

/***/ "./pages/xo-select-fi/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSelectFiComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

__webpack_require__("./js/lib/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-paywith/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/marketingOffers/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

var _factory = __webpack_require__("./pages/xo-select-fi/factory.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

var _template = __webpack_require__("./pages/xo-select-fi/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-select-fi/styles.less");

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

var _balance = __webpack_require__("./pages/services/balance/index.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSelectFiComponent = exports.$xoSelectFiComponent = _squid.$Component.extend('$xoSelectFiComponent', {
    tag: 'xo-select-fi',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                cart: _checkout.$CheckoutCartModel.instance(this.props.token).retrieve(),
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                variant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop),
                creditSharedInfo: _credit.$CreditSharedInfoModel.instance()
            };
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBilling: models.cart && models.cart.isBilling(),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        },
        padToggleFeature: function padToggleFeature(resolvers) {
            return resolvers.models.then(function (models) {
                var enabled = void 0;

                if (models.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    enabled = Experiments.padToggleFeatureSupported();
                } else {
                    // if pad not available
                    enabled = false;
                }
                return { enabled: enabled };
            });
        },
        cpaEligibility: function cpaEligibility(resolvers) {
            return resolvers.models.then(function (models) {
                return { isCPAEligible: _sharedUtil.$SharedUtil.isAuthRequiredInAnyFI(models.checkoutSession) || _sharedUtil.$SharedUtil.isAuthDeclinedInstrument(models.checkoutSession) };
            });
        },
        balanceComprehensionBannerExperiment: function balanceComprehensionBannerExperiment(resolvers) {
            return resolvers.models.then(function (models) {
                if (!models) {
                    return _angular.$q.when();
                }
                return Experiments.balanceComprehensionBannerExperiment.getTreatment({
                    page: 'choice',
                    cart: models.cart,
                    checkoutAppData: models.checkoutAppData,
                    checkoutSession: models.checkoutSession,
                    payee: models.checkoutPayeeModel
                })['catch'](function () {
                    _logger.$logger.info('balanceComprehensionBannerExperiment_GET_TREATMENT_ERROR', { page: 'choice' });
                    return _angular.$q.when();
                });
            });
        },
        balanceEligibility: function balanceEligibility(resolvers) {
            return resolvers.models.then(function (models) {
                if (!models) {
                    return _angular.$q.when();
                }
                return _balance.$BalanceEligibilityFactory.init({ checkoutSession: models.checkoutSession }).then(function (state) {
                    return state;
                })['catch'](function (err) {
                    _logger.$logger.warn('AU_BALANCE_ELIGIBILITY_INIT_ERROR', { error: err.toString() || err.stack });
                    return _angular.$q.when();
                });
            });
        },
        ppBalanceRebrandedExperiment: function ppBalanceRebrandedExperiment() {
            return {
                enabled: _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            // make this better
            this.propValueObj = {
                propHeader: 'memberReview.propHead',
                propVal: 'memberReview.propVal',
                propImage: 'https://' + _squid.$meta.cdnHost + '/images/checkout/hermes/scr_vp_fprd_shield_bags.png'
            };
            this.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            this.personalizedBanner = {
                show: false
            };
            this.locale = _squid.$locale;
            this.isCountryDE = _squid.$locale.country === 'DE';
            this.addBankAllowed = (0, _squid.$feature)('addBank');
        },
        populate: function populate() {
            var _this = this;

            var _models = this.models,
                cart = _models.cart,
                checkoutSession = _models.checkoutSession;
            var _fiSource = this.fiSource,
                isCardArtExp = _fiSource.isCardArtExp,
                isBilling = _fiSource.isBilling,
                isBillingNoPurchase = _fiSource.isBillingNoPurchase;
            var isCPAEligible = this.cpaEligibility.isCPAEligible;

            this.isCPAEligible = isCPAEligible;

            /**
             * returns a boolean if US cross-currency applied.
             * hermes doesn't properly support cross-currency for US customers.
             */
            var isUSCrossCurrency = function isUSCrossCurrency() {
                if (cart && cart.grossTotalAmount && cart.get('grossTotalAmount.currency') !== 'USD' && _squid.$locale.country === 'US') {
                    return true;
                }
                return false;
            };

            // initial fundingOptions
            var getFundingOptions = function getFundingOptions() {
                var plans = checkoutSession.getPlanList();
                if (isUSCrossCurrency()) {
                    return plans.filter(function (plan) {
                        return plan.primaryFs.name !== 'BILL_ME_LATER';
                    });
                }
                return plans;
            };

            var masterPlanList = getFundingOptions(); // initial fundingOptions that's returned by planning (unmodified)
            _fiMessages.$fiMessages.isDeclinedCard(checkoutSession);
            var isCreditDisallowedForMerchant = checkoutSession.isCreditDisallowedForMerchant;
            if (isCreditDisallowedForMerchant) {
                this.creditDisallowedMessage = {
                    type: 'info',
                    msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
                };
            }

            var subscriptionAuRMG = function subscriptionAuRMG() {
                return (0, _squid.$elmo)('xo_hermes_au_rmg_msg', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_au_rmg_msg').then(function (result) {
                    return { enabled: Boolean(result && result.treatment_name) };
                });
            };

            var isGamblingMerchant = this.models.checkoutPayeeModel.isGambling();

            var subscriptionAuRMGElmoResult = subscriptionAuRMG().then(function (result) {
                if (result.enabled === true) {
                    return true;
                }
            });

            if (subscriptionAuRMGElmoResult && isGamblingMerchant) {
                _logger.$logger.info('use_debit_card_RMG', { country: _squid.$locale.country });
                this.gamblingMessage = {
                    type: 'info',
                    msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
                };
            }

            if (this.balanceComprehensionBannerExperiment && this.balanceComprehensionBannerExperiment.treatment_name) {
                this.showBalanceComprehensionBannerTop = this.balanceComprehensionBannerExperiment.treatment_name === 'Trmt_balance_banner_ramp_hermes_top';
                this.showBalanceComprehensionBannerBottom = this.balanceComprehensionBannerExperiment.treatment_name === 'Trmt_balance_banner_ramp_hermes_bottom';
                this.balanceComprehensionBannerMessage = {
                    type: 'info',
                    msgs: [_squid.$locale.content.get('billingAgreement.paypalBalanceInfoBanner')]
                };
            }

            this.isBilling = isBilling;
            this.isBillingNoPurchase = isBillingNoPurchase;
            this.isReferenceCheckout = cart.referenceCheckout ? true : false;
            this.personalizedBanner.show = this.models.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization') || this.models.auth.isFBSkipLogin();
            // for Facebook skip login set isFBSkipLogin as true to modify the skip login content
            this.personalizedBanner.isFBSkipLogin = this.models.auth.isFBSkipLogin();
            this.showNotYou = this.models.auth && this.models.auth.showNotYou();
            this.formattedNameInformal = (0, _squid.formatNameInformal)({
                first_name: this.models.auth.first_name,
                last_name: this.models.auth.last_name
            }) || this.models.auth.email;
            this.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);

            if (_squid.$locale.country === 'DE' && checkoutSession.creditOffer) {
                // we will hide the old PPC-DE credit offer (DE-IIW) if we found inside checkoutSession a plan
                // with GPL-DE (PAY_LATER_DE). For this scenario user got previously approved for GPL in hermione
                // but somehow did fallback into Hermes
                var gplDEplanFound = false;
                var plans = checkoutSession.get('fundingOptions.plans');
                if (plans) {
                    gplDEplanFound = plans.filter(function (p) {
                        return p.primaryFs && p.primaryFs.type === 'CREDIT' && p.primaryFs.name === 'PAY_LATER_DE';
                    }).length > 0;
                }
                this.installment.showPPCAcquisitionRadioButton = !gplDEplanFound;
            }

            this.isIndiaDomesticBilling = isBilling && _squid.$locale.country === 'IN' && this.models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN';
            if (this.isIndiaDomesticBilling) {
                this.choicePageAddCardContentKey = 'fundingInstruments.addNewCardBilling';
                if (cart.isConsumerCountry('IN') && cart.isBilling()) {
                    if (cart.isChargePatternImmediateOrDeferred()) {
                        this.choicePageAddCardContentKey = 'fundingInstruments.immediate.addNewCardBilling';
                    } else {
                        this.choicePageAddCardContentKey = 'fundingInstruments.non.immediate.addNewCardBilling';
                    }
                }
            } else if (isCreditDisallowedForMerchant || isGamblingMerchant && subscriptionAuRMGElmoResult) {
                this.choicePageAddCardContentKey = 'addCard.addBankDebitCard';
            } else {
                this.choicePageAddCardContentKey = 'fundingInstruments.addNewCard';
            }

            var merchant = this.models.checkoutAppData.get('merchant');
            var merchantName = merchant.brand_name || merchant.merchant_name || 'Merchant';

            this.merchantName = merchantName;

            if (this.isIndiaDomesticBilling) {
                checkoutSession.message = {
                    type: 'info',
                    msgs: [(0, _squid.$renderContent)('memberReview.billingMerchant', { merchantName: merchantName })]
                };
            }

            var eligibility = this.balanceEligibility.eligibility;
            var ppBalanceRebranded = this.ppBalanceRebrandedExperiment.enabled;

            // render `CIP_INCOMPLETE` message for PayPal balance

            if (_sharedUtil.$SharedUtil.isBoolean(eligibility) && !eligibility) {
                checkoutSession.message = {
                    type: 'info',
                    msgs: [_squid.$locale.content.get(!ppBalanceRebranded ? 'compliance.cipIncomplete' : 'compliance.cipIncompleteRebranded')]
                };
            }

            /**
             * If it's cardart experience, log our current FIs (bank or cards)
             * NOTE: `balance` type is not being instrumented at the moment, cardart
             * instrumentation is only applicable to credit cards & banks right now.
             * See $CardArtInstrument.createPayload() for detail implmenetation
             */
            if (isCardArtExp) {
                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'CHOICE',
                    to: 'prepare_choice'
                }, _cardartInstrument.$CardArtInstrument.createPayload({
                    checkoutSession: checkoutSession,
                    isBillingNoPurchase: isBillingNoPurchase
                })));
            }

            /**
            * checks for PPC in the wallet and selected as fi
            * This Determines whether to show the banner or not for a reuse customer
            */
            var isPPCReuseAndNotSelected = function isPPCReuseAndNotSelected() {
                if (_this.isBillingNoPurchase) {
                    return checkoutSession.get('futurePayment.isCreditInWallet') && !checkoutSession.get('futurePayment.isCreditDefault');
                } else {
                    var _plans = checkoutSession.get('fundingOptions.instruments', null);
                    if (_plans && _plans.some(function (fi) {
                        return fi.name === 'BILL_ME_LATER' && !fi.selected;
                    })) {
                        return true;
                    } else {
                        return false;
                    }
                }
            };

            /**
            * checks for PPC in the wallet and selected as fi
            * This Determines whether to show the banner or not for a reuse customer
            */
            var isPPCReuseAndNotPreferred = function isPPCReuseAndNotPreferred() {
                if (_this.isBillingNoPurchase) {
                    return checkoutSession.get('futurePayment.isCreditInWallet') && !checkoutSession.get('futurePayment.isCreditDefault');
                } else {
                    var _plans2 = checkoutSession.get('fundingOptions.instruments', null);
                    if (_plans2 && _plans2.some(function (fi) {
                        return fi.name === 'BILL_ME_LATER' && !fi.isPreferred;
                    })) {
                        return true;
                    } else {
                        return false;
                    }
                }
            };

            /**
            * this is set in xo-credit-components for REUSE NI customers as apart of T1 for A/B tests
            **/
            this.showSpecialFinancingBadge = function () {
                return _angular.$rootScope.specialFinancingBadge && isPPCReuseAndNotPreferred();
            };

            /* checks for eligibility for acq PPC or PPC in wallet and not selected for reuse */
            this.creditOffer = checkoutSession.creditOffer || isPPCReuseAndNotSelected();

            this.showInstallmentsFiTitle = function () {
                return _this.isCountryDE && _this.ppcInstallmentContentReady();
            };

            this.getInstallmentsFiTitle = function () {
                if (_this.models.creditSharedInfo.getInstallmentOffer() && _this.models.creditSharedInfo.getInstallmentOffer().taglineText) {
                    // This tagline text will be localization already by Personalization platform
                    return _this.models.creditSharedInfo.getInstallmentOffer().taglineText;
                }
                return _squid.$locale.content.get('memberReview.installmentsTitle');
            };

            this.ppcInstallmentContentReady = function () {
                return _this.models.creditSharedInfo.hasInstallmentOffers() && _this.models.creditSharedInfo.hasInstallmentOfferFinancingDetails();
            };

            this.continueButtonText = function () {
                if (_this.selectedmethod && _this.selectedmethod.index === 'applyForPPCRadio') {
                    if (_squid.$locale.country === 'DE') {
                        return _squid.$locale.content.get('memberReview.bmlContinueToApplication');
                    }
                    return _squid.$locale.content.get('applyForBml.bmlApplyHeadline');
                } else {
                    return _squid.$locale.content.get('common.continuetext');
                }
            };

            /**
             * returns the cross currency conversion rate for the PPC wallet fi when a cross-currency
             * cart is found during the GB hermes checkout flow
             *
             */
            var getPPCCrossCurrencyInfo = function getPPCCrossCurrencyInfo() {
                if (!_this.isBillingNoPurchase && _squid.$locale.country === 'GB') {
                    var _plans3 = checkoutSession.get('fundingOptions.instruments', null);
                    var ppcPlans = _plans3 && _plans3.filter(function (fi) {
                        return fi.name === 'BILL_ME_LATER' && fi.currency_conversion;
                    });
                    if (ppcPlans && ppcPlans.length === 1) {
                        var ppcCurrencyConversion = ppcPlans[0].currency_conversion;
                        return Object.assign({ toTargetCurrency: ppcCurrencyConversion.to_amount_forex + ' ' + ppcCurrencyConversion.to_currency }, { fromUnitCurrency: ' 1 ' + ppcCurrencyConversion.from_currency });
                    }
                }
                return null;
            };
            this.ppcCrossCurrencyInfo = getPPCCrossCurrencyInfo();

            // selected plan model
            var selectedmethod = this.selectedmethod = {
                // first selection to start
                index: 0,
                // needed by xo-reuse and will be resolved later
                planId: 0
            };

            var serializedPlans = {}; // index of all plans by primary and balance currency code(s)
            var balanceCodes = {}; // index of cataloged currency codes
            var primaryList = []; // list of plans with unique primaryFs ids
            var balanceList = this.balanceList = []; // list of unique balance currencies
            var cardMap = { // FI names that we know map to content keys
                BILL_ME_LATER: 'BILL_ME_LATER',
                PAD: 'PAD',
                PAYPAL_EXTRAS_MASTERCARD: 'PAYPAL_EXTRAS_MASTERCARD'
            };

            this.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = _this.models.checkoutAppData && _this.models.checkoutAppData.get('merchant.merchant_country') === 'US';

                return _this.models.checkoutPayeeModel && _this.models.checkoutPayeeModel.isGambling() && isUSBuyer && isUSmerchant;
            };

            // Return a representation of the primaryFs of a plan
            // Based on id, currency code, subtype to ensure uniqueness
            // TODO(refactor): $MultiFiPlanFactory.getSerializedPrimary()
            var getSerializedPrimary = function getSerializedPrimary(primary) {
                var serial = primary.id + primary.amount.currency_code.toLowerCase();

                // if there's a subtype...
                if (primary.subtype) {
                    serial += primary.subtype;
                }
                return serial;
            };

            // return a serialized key for the plan
            // plan - a plan object from checkoutSession.fundingOptions.plans
            // balances - array of currency code strings
            // TODO (refactor): $MultiFiPlanFactory.getSerializedPlanId()
            var getSerializedPlanId = function getSerializedPlanId(plan, balances) {
                var pid = getSerializedPrimary(plan.primaryFs);

                // if no balances array...
                if (!balances) {
                    // just return the pid
                    return pid;
                }

                // (otherwise) sort balances
                balances.sort();

                return pid + balances.join();
            };

            if (masterPlanList) {
                // If more than one fully funded balance plan, show the balance currency next to instrument name
                // TODO(refactor): the entire `showBalanceCurrencies` logic can be abstracted away
                // with $MultiFiPlanFactory.getShowBalanceCurrenciesStatus()
                var showBalanceCurrencies = checkoutSession.isMultipleBalancePlan();

                // if not multiple balance plans...
                if (!showBalanceCurrencies) {
                    // start with first plan's currency
                    var knownCurrency = masterPlanList[0].primaryFs.amount.currency_code;

                    // update flag if any plan has more than two secondaries or one with a different currency
                    showBalanceCurrencies = masterPlanList.some(function (plan) {
                        // show currencies, when this plan has a different one, or...
                        return plan.primaryFs.amount.currency_code !== knownCurrency ||
                        // this plan has secondaries, where...
                        plan.secondaryFIs && (
                        // there's more than one
                        plan.secondaryFIs.length > 1 ||
                        // the one has a different currency
                        plan.secondaryFIs[0].amount.currency_code !== knownCurrency);
                    });
                }

                // index of captured primaryFs ids
                var primaryFsIds = {};

                // Filter through the masterPlanList, set up the split balance lists for the checkboxes if present, and set up the primary FI list. This is mostly needed for split balance cases
                // TODO(refactor): use $MultiFiPlanFactory.getCompositeBalances() to get `balanceCodes`, `balanceList` and `balCurCodes`
                masterPlanList.forEach(function (plan) {
                    var balances = plan.secondaryFIs || [];
                    var balCurCodes = [];

                    // catalog balances
                    balances.forEach(function (balance) {
                        var code = balance.amount.currency_code;

                        // capture code (for serialization, next)
                        balCurCodes.push(code);
                        // if this code has not been cataloged...
                        if (!balanceCodes.hasOwnProperty(code)) {
                            var balInfoAndState = {
                                code: code,
                                checked: false,
                                enabled: true,
                                intent: false,
                                fake: false
                            };

                            if (showBalanceCurrencies) {
                                balInfoAndState.amount = balance.amount.amount_formatted_currency;
                            } else {
                                balInfoAndState.amount = balance.amount.amount_formatted;
                            }
                            // flag that we've cataloged this code
                            balanceCodes[code] = balInfoAndState;
                            // capture balance details and initial ui state
                            balanceList.push(balInfoAndState);
                        }
                    });

                    // if this is a primary split-balance plan...
                    if (plan.primaryFs.type === 'BALANCE') {
                        // add key to template
                        // NOTE: easier to build string here, than with template tags
                        plan.currencies = [plan.primaryFs.amount.currency_code].concat(balCurCodes).join(', ');
                    }

                    // catalog plan by serial and balances
                    serializedPlans[getSerializedPlanId(plan, balCurCodes)] = plan;

                    // get plan primary
                    var serialPrimary = getSerializedPrimary(plan.primaryFs);

                    // if haven't indexed the primary...
                    if (!primaryFsIds.hasOwnProperty(serialPrimary)) {
                        // note that we've cataloged this primary
                        primaryFsIds[serialPrimary] = 1;
                        // capture plan with unique primary
                        primaryList.push(plan);
                    }
                });

                // sort unique balances by currency code
                // TODO(refactor): part of $MultiFiPlanFactory.getCompositeBalances() logic
                balanceList.sort(function (balA, balB) {
                    // balance codes are never the same, so no need to return 0
                    return balA.code < balB.code ? -1 : 1;
                });

                // expose to template
                this.isMultipleBalance = showBalanceCurrencies;

                // filtering primary list by PAD specific logic so it combines IACH and PAD together
                if (this.padToggleFeature.enabled) {
                    primaryList = checkoutSession.fundingOptions.getPadAndIachCombinedPlans(primaryList);
                }

                this.primaryList = primaryList;
            }

            // TODO(refactor): use $MultiFiPlanFactory.getPlansByPrimaryId()
            var getPlansByPrimaryId = function getPlansByPrimaryId(pid) {
                var matchingPlans = {};

                // with each serialized plan
                for (var key in serializedPlans) {
                    // if this key is not inherited and begins with this pid...
                    if (serializedPlans.hasOwnProperty(key) && !key.indexOf(pid)) {
                        // add to matched plans
                        matchingPlans[key] = serializedPlans[key];
                    }
                }
                return matchingPlans;
            };

            // checkPad() determines whether to show/hide the PAD warning message and PAD label
            var checkPad = function checkPad() {
                var _$BalanceFactory$getP = _factory.$BalanceFactory.getPadAndCheckboxStatus(_this.balanceList, masterPlanList),
                    isChecked = _$BalanceFactory$getP.isChecked,
                    hasPad = _$BalanceFactory$getP.hasPad;

                // only display this warning message to current user who have selected PayPal balance and
                // currently has a PAD type funding option


                _this.displayPadMessage = isChecked && hasPad;
                // display PAD label when PayPal balance is unchecked
                _this.displayPadLabel = isChecked === false;

                _factory.$BalanceFactory.set({ checkbox: isChecked });
            };

            // if user had previously selected any balance and then tried to select PayPal DE installments,
            // we automatically uncheck balance and surface warning message
            this.verifyBalanceWithInstallments = function () {
                if (balanceCodes) {
                    _squid.$util.forEach(balanceCodes, function (balance, code) {
                        if (balance.enabled && balance.checked && _this.selectedmethod && _this.selectedmethod.index === 'applyForPPCRadio') {

                            balance.enabled = false;
                            balance.checked = false;
                            balance.intent = false;
                            _this.displayDeInstallmentWarningMessage = true;
                        }
                    });
                }
            };

            // if DE installments is selected and user try to select balance, we allow balance to be selected but
            // then we switch their FI selection back-up to a card or bank and then surface warning message
            var checkBalanceWithInstallments = function checkBalanceWithInstallments() {
                if (_this.showInstallmentsFiTitle()) {
                    var anyBalanceChecked = false;
                    if (balanceCodes) {
                        _squid.$util.forEach(balanceCodes, function (balance, balanceCode) {
                            if (balance.enabled && balance.checked && _this.selectedmethod && _this.selectedmethod.index === 'applyForPPCRadio') {

                                anyBalanceChecked = true;
                                _this.selectedmethod.index = 0;
                                _this.displayDeInstallmentWarningMessage = true;
                            }
                        });
                    }
                    if (!anyBalanceChecked) {
                        _this.displayDeInstallmentWarningMessage = false;
                    }
                }
            };

            this.capUserIntent = function (code, state) {
                var balance = balanceCodes[code];

                // if this balance is enabled...
                if (balance.enabled) {
                    // capture user triggered state change
                    balance.intent = state;
                }

                // check DE installments related business logic to display installments and warning message
                checkBalanceWithInstallments();

                // check PAD related business logic to display PAD label and PAD warning message
                checkPad();
            };

            // check if plan is MEFT and has associated IACH bank
            var isMEFTWithIACH = function isMEFTWithIACH(plan) {
                if (!checkoutSession.fundingOptions.isMEFT(plan)) {
                    return false;
                }
                return masterPlanList.some(function (p) {
                    return plan.primaryFs && plan.primaryFs.id === p.primaryFs.id && checkoutSession.fundingOptions.isIACH(p);
                });
            };

            // for PAD eligible countries only we show preferred only for PAD or IACH banks
            var showPreferredLabelForPadEligibleCountries = function showPreferredLabelForPadEligibleCountries(isPAD, isMEFT, isIACHWithPad) {
                return (isPAD || isIACHWithPad) && _this.padToggleFeature.enabled && !isMEFT; // if it's pad or iach and not meft
            };

            // for all countries except DE check if it's not PAD bank and not a MEFT bank with associated IACH
            var showPreferredLabelForAll = function showPreferredLabelForAll(isPAD, meftWithIach) {
                return !isPAD && !meftWithIach;
            };

            // for PAD isPreferred will never be true
            // only MEFT and IACH subtypes can have isPreferred as true
            this.showPreferredLabel = function (plan) {
                var preferred = checkoutSession.fundingOptions.isPreferred(plan);
                var isPAD = checkoutSession.fundingOptions.isPAD(plan);
                var isMEFT = checkoutSession.fundingOptions.isMEFT(plan);
                var isIACHWithPad = checkoutSession.fundingOptions.isIACHWithPad(plan);
                var meftWithIach = isMEFTWithIACH(plan);

                return !_this.isBilling && !_this.isReferenceCheckout && preferred && _this.preferredFiVariant && (showPreferredLabelForAll(isPAD, meftWithIach) || showPreferredLabelForPadEligibleCountries(isPAD, isMEFT, isIACHWithPad));
            };

            // Update the balance checkbox states based on the index of primaryFs user has selected
            this.updateBalances = function (index, clickChosenPlan) {
                var primary = primaryList[index].primaryFs;
                var bankOrOther = primary.type === 'BANK' ? 'BANK' : 'OTHER';
                var primaryCodeAsBalance = primary.type === 'BALANCE' && primary.amount.currency_code;
                var pid = getSerializedPrimary(primary);
                var matchingPlans = getPlansByPrimaryId(pid);

                // if no balances, set selected planId to the matching primaryFs by pid (should only be one) and exit early
                if (!balanceList.length) {
                    if (matchingPlans.hasOwnProperty(pid)) {
                        // capture the matching plan (needed by xo-reuse)
                        selectedmethod.planId = matchingPlans[pid].planId;
                    }

                    return;
                }

                // Otherwise, match the balances based on index of user choice
                var combinedSerials = Object.keys(matchingPlans).join();
                var cardName = cardMap[primary.name] || bankOrOther;
                var includeCodes = [];
                var excludeCodes = [];

                var selectedPlan = primaryList[index]; // current selected plan
                var id = selectedPlan.secondaryFIs.length && selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.secondaryFIs === false && selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId;

                var foundCorrespondingPlan = masterPlanList.some(function (plan) {
                    return plan.planId === id;
                });

                // if we are displaying a balance warning message for de installments we will clear it
                if (_this.displayDeInstallmentWarningMessage) {
                    _this.displayDeInstallmentWarningMessage = false;
                }
                // with each balance...
                // TODO(refactor)
                _squid.$util.forEach(balanceCodes, function (balState, code) {
                    var isFake =

                    // When the primary is Balance with the same currency
                    // user cannot deselect this balance, so show fake selected+disabled checkbox
                    balState.fake = primaryCodeAsBalance === code;

                    // if faking this checkbox
                    if (isFake) {
                        // fake that it's being forced
                        includeCodes.push(code);
                    }

                    // if no plans allow this balance...
                    if (combinedSerials.indexOf(code) === -1 && !foundCorrespondingPlan) {
                        // deselect and disable this balance
                        balState.checked = balState.enabled = false;
                        if (!isFake) {
                            // add currency code to exclude list
                            excludeCodes.push(code);
                        }
                    } else if (foundCorrespondingPlan && _this.padToggleFeature.enabled) {
                        // checks for crossed combination between IACH and PAD
                        balState.enabled = true;
                        balState.checked = balState.intent;
                    } else if (selectedPlan.secondaryFIs === false && selectedPlan.primaryFs.subtype === 'PAD') {
                        // disable balance if selected plan is PAD
                        balState.enabled = false;
                        balState.checked = false;
                    } else {
                        _this.installment = _this.installment || {};
                        _this.installment.isSplitBalance = true;

                        // assume all plans require this balance
                        var requiresBalance = true;

                        // with each plan...
                        for (var serial in matchingPlans) {
                            // if it can be used without this balance...
                            if (matchingPlans.hasOwnProperty(serial) && serial.indexOf(code) === -1) {
                                // flag that all plans do not use this balance
                                requiresBalance = false;
                                break;
                            }
                        }
                        // if this balance is required for this (or all) plans...
                        if (requiresBalance) {
                            // select this balance
                            balState.checked = true;
                            // disable this balance
                            balState.enabled = false;

                            // add currency code to include list
                            includeCodes.push(code);
                        } else {
                            // (otherwise) when this balance is optional for this primaryFs...
                            // just enable the balance checkbox
                            balState.enabled = true;
                            // use intent state to persist user intent
                            balState.checked = balState.intent;
                        }
                    }
                });

                // if not a balance plan, and we have any include and/or exclude messages to display...
                if (primary.type !== 'BALANCE' && (includeCodes.length || excludeCodes.length)) {
                    var msgs = [];
                    var fiName = (0, _squid.$renderContent)('fsMappings.' + primary.name).string || primary.name;

                    // log when user messaging occurs
                    _logger.$logger.info('checkout_fpti', {
                        primary: primary.id || primary.type,
                        denied: excludeCodes.join(),
                        forced: includeCodes.join()
                    });

                    // build include and exclude messages
                    [['yes', includeCodes], ['no', excludeCodes]].forEach(function (pair) {
                        var codes = pair[1];
                        var codesLn = codes.length;

                        // if there are codes to report as in/ex-cluded...
                        if (codesLn) {
                            var msgKey = 'memberReview.' + pair[0] + 'Bal_' + cardName;
                            var msgObj = { fi: fiName };

                            // if more than one code...
                            if (codesLn > 1) {
                                // use plural content key
                                msgKey += '_plural';
                                // if more than two codes...
                                if (codesLn > 2) {
                                    // group all but the last as the first code
                                    msgObj.code1 = codes.slice(0, -1).join(', ');
                                    // use last code alone
                                    msgObj.code2 = codes[codes.length - 1];
                                } else {
                                    // set code to each token
                                    msgObj.code1 = codes[0];
                                    msgObj.code2 = codes[1];
                                }
                            } else {
                                // (otherwise) when only one code...
                                // list as first code
                                msgObj.code1 = codes[0];
                            }
                            if (_this.ppBalanceRebrandedExperiment.enabled) {
                                msgKey += '_Rebranded';
                            }
                            // capture final message
                            msgs.push((0, _squid.$renderContent)(msgKey, msgObj));
                        }
                    });
                    // show informational messages
                    checkoutSession.message = {
                        msgs: msgs,
                        type: 'info'
                    };
                } else {
                    // clear (any) existing message(s)
                    checkoutSession.message = '';
                }

                // check PAD related business logic to display PAD label and PAD warning message
                checkPad();
                if (_this.selectedmethod.planId === 0 && clickChosenPlan) {
                    _this.selectedmethod.planId = clickChosenPlan.planId;
                }
            };

            // determine which plan to pre-select

            // if BA txn...
            if (this.isBillingNoPurchase) {
                // just deal with plan id - ignore index approach
                var selectStickyInstrument = checkoutSession.getSelectedStickyInstrument();

                if (selectStickyInstrument) {
                    selectedmethod.planId = selectStickyInstrument.instrument_id;
                }
            } else if (balanceList.length) {
                // (or) there are balances...

                // Select checkboxes by default if first plan has balances by default
                if (masterPlanList[0].secondaryFIs) {
                    masterPlanList[0].secondaryFIs.forEach(function (bal) {
                        _this.capUserIntent(bal.amount.currency_code, true);
                    });
                }

                // update balance checkboxes for the first/default selected plan
                this.updateBalances(0);
            } else {

                // (otherwise) without balances...

                // honor preferred/active/current plan
                var preferredPlanId = checkoutSession.plan.id;

                // behave as if the preferred plan were selected - if not, the first/default
                var preferredPlanIndex = _squid.$util.findIndex(primaryList, function (plan) {
                    return plan.planId === preferredPlanId;
                }) || 0;

                var plan = primaryList[preferredPlanIndex];

                if (plan) {
                    // specify selected method
                    selectedmethod.index = preferredPlanIndex;

                    // capture preferred plan id - should be same as `preferredPlanId`
                    selectedmethod.planId = plan.planId;
                }
            }

            this.getBAPlans = function () {
                return checkoutSession.futurePaymentInstruments;
            };

            // Check if is variant where preferred can be set
            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.variant) > -1;

            var updateFS = function updateFS() {
                var planId = void 0;

                if (_this.selectedmethod.index === 'applyForPPCRadio') {
                    return _squid.$promise.resolve();
                }

                // if BA plans...
                if (_this.isBillingNoPurchase) {
                    planId = selectedmethod.planId;
                } else {

                    // (otherwise) resolve plan from index and checked balance checkboxes

                    var index = selectedmethod.index;
                    var _plan = primaryList[index];

                    // TODO: refactor this to FundingOptionsModel
                    var getPadSplitBalPlan = function getPadSplitBalPlan(currentPlan) {
                        return masterPlanList && masterPlanList.find(function (p) {
                            return p.primaryFs.id === currentPlan.primaryFs.id && p.primaryFs.subtype === 'IACH' && p.secondaryFIs && p.secondaryFIs.length;
                        });
                    };

                    // find iach or pad plan without balance
                    var getIachOrPadPlanWithoutBalance = function getIachOrPadPlanWithoutBalance(currentPlan) {
                        return masterPlanList.find(function (p) {
                            return p.primaryFs.id === currentPlan.primaryFs.id && (checkoutSession.fundingOptions.isIACH(p) || checkoutSession.fundingOptions.isPAD(p)) && !p.secondaryFIs;
                        });
                    };

                    // check if plan is IACH with a balance
                    var isPlanIachWithBalance = function isPlanIachWithBalance(p) {
                        return checkoutSession.fundingOptions.isIACH(p) && p.secondaryFIs && p.secondaryFIs.length;
                    };

                    var isChecked = balanceList.some(function (balance) {
                        return balance.checked;
                    });
                    var planWithSplitBal = getPadSplitBalPlan(_plan);

                    // if balance checkbox is checked make sure the selected plan is correct by looking for a plan with a balance
                    // otherwise if unchecked and selected plan has balance -> find plan without balance
                    if (isChecked) {
                        if (planWithSplitBal) {
                            _plan = planWithSplitBal;
                        }
                    } else if (isPlanIachWithBalance(_plan)) {
                        var planWithIachOrPad = getIachOrPadPlanWithoutBalance(_plan);

                        if (planWithIachOrPad) {
                            _plan = planWithIachOrPad;
                        }
                    }

                    // get plan with serial, built from user selections
                    // TODO(refactor): use $MultiFiPlanFactory.getCheckedBalances()
                    var checkedBalances = [];

                    _squid.$util.forEach(balanceCodes, function (balance, code) {
                        if (balance.checked) {
                            checkedBalances.push(code);
                        }
                    });

                    // use plan with this primaryFs and balance options
                    var fundingsource = serializedPlans[getSerializedPlanId(_plan, checkedBalances)];

                    // if no plan matches the user's selections...
                    if (!fundingsource) {

                        // FUZZY MATCHING x-{

                        var pid = getSerializedPrimary(_plan.primaryFs);
                        var pidForLogger = _plan.primaryFs.id || _plan.primaryFs.type;

                        _logger.$logger.info('checkout_fpti', {
                            primary: pidForLogger,
                            denied: checkedBalances.join()
                        });

                        // (perhaps only one of the selected balances is applicable?)

                        // find a plan with each individual balance
                        checkedBalances.some(function (code) {
                            // match plan with this serial combination
                            fundingsource = serializedPlans[pid + code];
                            return fundingsource;
                        });

                        // flag that one of the checked balances was unusable
                        if (fundingsource) {
                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                denied: checkedBalances.join()
                            });
                        }

                        // if no plan yet...
                        // (perhaps the plan doesn't have any balance combination?)
                        if (!fundingsource) {
                            // get the plan with just this primaryFs
                            fundingsource = serializedPlans[pid];
                            // if we now have a plan...
                            if (fundingsource) {
                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if still no plan...
                        // (at this point, the plan requires a specific balance combination)
                        if (!fundingsource) {
                            var serializedPlanKeys = Object.keys(serializedPlans);

                            // use the first plan that begins with this primary id
                            fundingsource = serializedPlans[serializedPlanKeys[_squid.$util.findIndex(serializedPlanKeys, function (serial) {
                                return serial.indexOf(pid) === 0;
                            })]];

                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                forced: balanceList.map(function (balance) {
                                    return balance.code;
                                }).join()
                            });
                        }
                    }
                    // use of the matched plan
                    planId = fundingsource.planId;
                }

                if (_this.isBillingNoPurchase && checkoutSession.getSelectedStickyInstrument() && checkoutSession.getSelectedStickyInstrument().instrument_id !== planId) {
                    return checkoutSession.action('setStickyFI', {
                        data: {
                            instrument_id: planId
                        },
                        success: function success(result) {
                            checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                            return result;
                        },
                        DEFAULT: function DEFAULT() {
                            // Error message for failures
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                } else if (!_this.isBillingNoPurchase && checkoutSession.get('plan.sources')[0].id !== planId) {

                    return checkoutSession.fundingOptions.action('select', {
                        data: {
                            planId: planId
                        },
                        success: function success(result) {
                            checkoutSession.populate(result);
                            return result;
                        },
                        contingencies: {
                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                                // Route to the Confirm Upop page. When finished, use the default handlers to return to the review page
                                if (result && result.resolution) {
                                    var card = result.resolution.data;

                                    if (card.fundingId && card.fi && card.fi.type) {
                                        _this.cardModel = new _index.$AddCardModel();
                                        _this.cardModel.id = card.fundingId;
                                        _this.cardModel.card = new _index.$CardModel({
                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                            type: card.fi.type.toUpperCase(),
                                            productType: card.fi.productType
                                        });
                                    }
                                }

                                // Reject to break out of the promise chain
                                _uiRouter.$state.go('.confirmUpop');
                                return _squid.$promise.shortCircuit();
                            },

                            DEFAULT: function DEFAULT() {
                                // Error message for failures
                                _uiRouter.$state.go('checkout.review');
                            }
                        }
                    });
                } else {
                    return _squid.$promise.resolve();
                }
            };

            this['continue'] = function (evt) {
                return updateFS().then(function (result) {
                    _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T4' });
                    // clear (any) existing message(s)
                    checkoutSession.message = '';

                    // Decide routing after update
                    if (result) {
                        // Update the installments to support the user selecting a card that does not support installments.
                        _this.models.checkoutSession.installments = result.installments;
                    }
                    if (_this.models.checkoutSession.get('plan.paypal_credit') || _this.selectedmethod.index === 'applyForPPCRadio') {
                        // for PPC reuse radio banner testing we want to indicate whether the user selected PPC via radio button or banner.
                        _logger.$logger.info('checkout_fpti', {
                            from: 'clickPPCReuse',
                            to: 'radio_click'
                        });
                    }
                    // If paypal credit, check for installments and redirect if needed
                    if ((_this.models.checkoutSession.get('plan.paypal_credit') || _this.selectedmethod.index === 'applyForPPCRadio') && _this.models.checkoutSession.creditInstallmentOffer) {
                        var token = _this.props.token;
                        var installments = _checkout.$InstallmentOptionsModel.instance(token);
                        var data = {
                            isMemberCredit: true
                        };

                        return (0, _squid.$populate)(data, {
                            payee: _this.models.checkoutPayeeModel,
                            checkoutCart: _checkout.$CheckoutCartModel.instance(token),
                            checkoutAppData: _this.models.checkoutAppData
                        }).then(function () {
                            if ((0, _squid.$feature)('creditInstallmentOffers')) {
                                return installments.save({
                                    cache: true, // Cache between here and $ChoiceEligibilityModel
                                    data: data,
                                    success: function success(installmentResult) {
                                        var offers = installmentResult.installments && installmentResult.installments[0];
                                        var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                                        return hasInstallments;
                                    },
                                    contingencies: {
                                        DEFAULT: function DEFAULT() {
                                            // Assume is eligible if contingency
                                            return false;
                                        }
                                    },
                                    error: function error() {
                                        return false;
                                    }
                                });
                            } else {
                                return false;
                            }
                        }).then(function (hasInstallments) {
                            if (hasInstallments) {
                                // This flag is set in the xo-credit-components banner. If its true we will take customers to the new CYCO page in CAPE
                                return _this.models.creditSharedInfo.getRedirectToCapeCyco() ? _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true }) : _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else if (_this.selectedmethod.index === 'applyForPPCRadio') {
                                if (_this.isCountryDE && _this.models.creditSharedInfo.hasInstallmentOffers() && _this.models.creditSharedInfo.hasInstallmentOfferFinancingDetails()) {
                                    return _uiRouter.$state.go('checkout.redirectToCape', { financing_option: _this.models.creditSharedInfo.getInstallmentOfferFinancingDetails() });
                                } else {
                                    return _uiRouter.$state.go('checkout.redirectToCape');
                                }
                            } else {
                                return _uiRouter.$state.go('checkout.review');
                            }
                        });
                    } else {
                        var fiDetails = _sharedUtil.$SharedUtil.getFiDetails(_this.models.checkoutSession.futurePaymentInstruments);
                        _this.logSubscriptionEvent(_extends({
                            from: 'continue_clicked',
                            to: 'process_choice'
                        }, fiDetails));
                        return _uiRouter.$state.go('checkout.review');
                    }
                });
            };
        }
    },
    controller: ['$scope', function ($scope) {
        $scope.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope.token);
        $scope.logSubscriptionEvent({
            from: 'choice',
            to: 'prepare_subscription_choice'
        });
        _angular.$rootScope.showFiSelectPage = true;
        $scope.installment = $scope.installment || {};
        $scope.installment.showBanner = false;
        $scope.installment.showCYCO = false;
        $scope.installment.showCreditExample = false;
        $scope.showPPCAcquisitionRadioButton = function () {
            return $scope.installment && $scope.installment.showPPCAcquisitionRadioButton;
        };
        $scope.showCreditPlacement = function (plan) {
            return plan && !plan.primaryFs.isPinlessDebit && plan.primaryFs.name === 'BILL_ME_LATER';
        };
    }]
});

angular.value("$xoSelectFiComponent", $xoSelectFiComponent);
_squid.$Component;

_squid.$renderContent;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$integration;

_squid.formatNameInformal;

_squid.$util;

_squid.$locale;

_squid.$promise;

_squid.$meta;

_squid.$elmo;

_angular.noop;

_angular.$rootScope;

_angular.$q;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_checkout.$CheckoutSessionModel;

_checkout.$InstallmentOptionsModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_credit.$CreditSharedInfoModel;

_choice.$ChoiceEligibility;

_index.$AddCardModel;

_index.$CardModel;

_fiMessages.$fiMessages;

_factory.$BalanceFactory;

_cardartInstrument.$CardArtInstrument;

_sharedUtil.$SharedUtil;

_balance.$BalanceEligibilityFactory;

/***/ }),

/***/ "./pages/xo-select-fi/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BalanceFactory', function () {
    // initial choiceBalanceState checkbox is unselected
    var state = {
        checkbox: undefined
    };

    var get = function get() {
        return state;
    };

    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    var getPadAndCheckboxStatus = function getPadAndCheckboxStatus() {
        var balanceList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var planList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var isChecked = balanceList.some(function (balance) {
            return balance.checked;
        });
        var hasPad = planList.some(function (plan) {
            return plan.primaryFs.subtype === 'PAD';
        });

        return {
            isChecked: isChecked,
            hasPad: hasPad
        };
    };

    return {
        get: get,
        set: set,
        getPadAndCheckboxStatus: getPadAndCheckboxStatus
    };
});

_squid.$util;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-select-fi", "pages/xo-select-fi/factory.js"))

/***/ }),

/***/ "./pages/xo-select-fi/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SelectFiRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

var _directive = __webpack_require__("./pages/xo-select-fi/directive.js");

var $SelectFiRoute = exports.$SelectFiRoute = _squid.$ComponentRoute.extend('$SelectFiRoute', {
    path: 'selectFi',
    directive: _directive.$xoSelectFiComponent,
    titleContent: 'memberReview.selectFi',
    trackingData: {
        fptiState: 'choose_FI_interstitial',
        buzname: {
            'fullpage': {
                'pagename': '%::select-fi',
                'pagename2': '%::select-fi:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: [{
        name: '$xoConfirmUpopRoute',
        props: function props() {
            return {
                token: this.props.token,
                cardmodel: this.cardModel
            };
        },

        lazyRoute: 'xo-wallet-components/src/confirm-upop/route',
        slug: 'confirmUpop'
    }]
}); /* dynamic-import */

angular.value("$SelectFiRoute", $SelectFiRoute);
_squid.$ComponentRoute;

_directive.$xoSelectFiComponent;

/***/ }),

/***/ "./pages/xo-select-fi/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-select-fi/template.html":
/***/ (function(module, exports) {

module.exports = "<section id='xoSelectFi' class=\"review\" content tabindex=-1 role=\"presentation\">\n    <xo-title title-txt=\"{{content('memberReview.memberReviewTitle')}}\" class=\"accessAid\"></xo-title>\n\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner reviewSections\">\n            <xo-message ng-if=\"creditDisallowedMessage\" data-test-id=\"creditDisallowedMessage\" message=\"creditDisallowedMessage\"></xo-message>\n            <xo-message ng-if=\"gamblingMessage\" data-test-id=\"gamblingMessage\" message=\"gamblingMessage\"></xo-message>            \n            <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration\">\n                <p class=\"userEmail\" id=\"reviewUserInfo\">\n                    {{ content(!personalizedBanner.isFBSkipLogin ? 'memberReview.loggedInWithOneTouch' : 'memberReview.loggedInFaceBookBA', {userName: formattedNameInformal, lastName: models.auth.last_name, firstName: models.auth.first_name}) }}\n                    <span ng-if=\"showNotYou\">\n                        <xo-not-you></xo-not-you>\n                    </span>\n                </p>\n            </xo-banner>\n            <xo-message message=\"models.checkoutSession.message\"></xo-message>\n            <xo-decline-notification ng-if=\"isCPAEligible\" />\n            <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration\">\n                <p class=\"userEmail\" id=\"reviewUserInfo\">\n                    {{ content('creditcard.hi', {userName: formattedNameInformal}) }}\n                    <span ng-if=\"showNotYou\">\n                        <xo-not-you></xo-not-you>\n                    </span>\n                </p>\n            </div>\n\n            <div class=\"reviews reviews_first\">\n                <div class=\"paywith asideView\" content>\n                    <div class=\"trayInner trayInnerDefault multipleFi\">\n                        <div class=\"\">\n                            <h4 class=\"noBottom paymentsHeader alpha\">\n                                {{ content('memberReview.selectFi') }}\n                            </h4>\n\n                            <div ng-if=\"showBalanceComprehensionBannerTop\" data-test-id=\"ppBalanceBanner\" class=\"ppBalanceBanner top\">\n                                <xo-message message=\"balanceComprehensionBannerMessage\"></xo-message>\n                            </div>\n\n                            <div\n                                class=\"split_bal_option\"\n                                ng-if=\"balanceList.length\">\n                                <div\n                                    class=\"sCheckbox checkbox\"\n                                    ng-repeat=\"balance in balanceList track by $index\"\n                                    ng-class=\"{disabled: !balance.enabled}\">\n                                    <input\n                                        ng-if=\"balance.fake\"\n                                        type=\"checkbox\"\n                                        disabled=\"disabled\"\n                                        checked=\"checked\">\n                                    <input\n                                        ng-if=\"!balance.fake\"\n                                        id=\"bal_{{balance.code}}\"\n                                        data-test-id=\"balanceCheckBox\"\n                                        type=\"checkbox\"\n                                        ng-model=\"balance.checked\"\n                                        ng-disabled=\"!balance.enabled\"\n                                        value=\"{{balance.code}}\"\n                                        ng-change=\"capUserIntent(balance.code, balance.checked)\">\n                                    <label\n                                        for=\"bal_{{balance.code}}\"\n                                        class=\"choice-split-balance\"\n                                        ng-class=\"{disabled: !balance.enabled}\"\n                                        bind-html-compile=\"htmlContent('memberReview.useBalanceLabel', { amt: balance.amount })\">\n                                    </label>\n                                </div>\n                            </div>\n\n                            <div ng-if=\"displayPadMessage\">\n                                <span class=\"padWarningMessage\">{{ content('memberReview.padWarningMsg') }}</span>\n                            </div>\n\n                            <div ng-if=\"displayDeInstallmentWarningMessage\">\n                                <span data-test-id=\"balanceDEwarningMessage\" class=\"balanceInstallmentsConflictMessage\">{{ content('memberReview.balanceInstallmentsConflictMsg') }}</span>\n                            </div>\n\n                            <ul class=\"charges\">\n                                <!--List of Plans-->\n                                <li role=\"presentation\" class=\"fundingsource\" ng-if=\"!isBillingNoPurchase\" ng-repeat=\"plan in primaryList track by $index\">\n                                    <experience flag='cardart'>\n                                        <div class=\"row-fluid radioButton fsPanelRadioWrapper\">\n                                            <input\n                                                type=\"radio\"\n                                                id=\"{{plan.planId}}\"\n                                                data-test-id=\"selectFIRadioButton\"\n                                                name=\"selectedFI\"\n                                                ng-value=\"$index\"\n                                                ng-model=\"selectedmethod.index\"\n                                                ng-change=\"updateBalances($index, plan)\"\n                                            />\n\n                                            <label class=\"noBottom\" for=\"{{plan.planId}}\">\n                                                <div class=\"positionDecoupler\">\n                                                    <xo-fi-panel fi=\"plan.primaryFs\" plan=\"plan\"\n                                                        show-all-currency-codes=\"\n                                                            plan.primaryFs.name === 'BALANCE' &&\n                                                            plan.secondaryFIs[0].name === 'BALANCE' &&\n                                                            isMultipleBalance\"\n                                                        show-currency-code=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\"\n                                                        name-override=\"\n                                                            plan.primaryFs.name === 'BALANCE' &&\n                                                            ppBalanceRebrandedExperiment.enabled &&\n                                                            content('paymentMethod.paypalBalanceRebranded')\"\n                                                    >\n                                                        <span ng-if=\"plan.gotDeclined\" class=\"gotDeclinedMessage\">\n                                                            {{ content('wallet.processorDeclinedCard') }}\n                                                        </span>\n                                                        <div class=\"fsSubdetails\">\n                                                            <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                                                {{ content('paymentMethod.eCheckDescription') }}\n                                                            </div>\n                                                            <div ng-if=\"showCreditPlacement(plan)\">\n                                                                <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n\n                                                            </div>\n                                                            <div class=\"conversion leftAlign\" data-test-id=\"selectFiPPCCrossCurrencyRate\" ng-if=\"plan.primaryFs.name === 'BILL_ME_LATER' && ppcCrossCurrencyInfo\">\n                                                                <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n                                                                <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: ppcCrossCurrencyInfo.fromUnitCurrency, currencyTo: ppcCrossCurrencyInfo.toTargetCurrency})}}</span>\n                                                            </div>\n                                                            <span class=\"preferredLabel\" ng-if=\"!isBilling && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\">{{ content('memberReview.preferred') }}</span>\n                                                        </div>\n                                                    </xo-fi-panel>\n                                                </div>\n                                            </label>\n                                        </div>\n                                    </experience>\n\n                                    <experience flag='!cardart'>\n                                        <div class=\"row-fluid radioButton\">\n                                            <input\n                                                type=\"radio\"\n                                                id=\"{{plan.planId}}\"\n                                                data-test-id=\"selectFIRadioButton\"\n                                                name=\"selectedFI\"\n                                                ng-value=\"$index\"\n                                                ng-model=\"selectedmethod.index\"\n                                                ng-change=\"updateBalances($index)\"\n                                            />\n\n                                            <label class=\"noBottom multiFiLabelContainer\" for=\"{{plan.planId}}\">\n                                                <div ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" class='fiContainer'>\n                                                    <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                                                    <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                                                    <div class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                                        <div ng-switch=\"plan.primaryFs.subtype\">\n                                                            <div class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                                                <div ng-if=\"!padToggleFeature.enabled\"><span class=\"subtype\">{{content('fundingInstruments.pad')}}</span></div>\n                                                                <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}} </span>\n                                                                <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                                <div class=\"iachMeftLabel\" ng-if=\"isCountryDE\">{{content('fundingInstruments.iach')}}</div>\n                                                            </div>\n\n                                                            <div ng-switch-default>\n                                                                <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                                                <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                                                <span ng-if=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.currencies}})</span>\n                                                                <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                                <div class=\"iachMeftLabel\" ng-if=\"isCountryDE  && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</div>\n                                                                <div class=\"iachMeftLabel\" ng-if=\"isCountryDE && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</div>\n                                                            </div>\n\n                                                        </div>\n                                                        <div ng-if=\"showPreferredLabel(plan)\">\n                                                            <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                                        </div>\n                                                        <div ng-if=\"plan.primaryFs.isBillingPreferred\">\n                                                            <span class=\"billingPreferredLabel\">{{ content('fundingInstruments.billingPreferredFi', {merchantName: merchantName}) }}</span>\n                                                        </div>\n                                                        <span ng-if=\"plan.gotDeclined\" class=\"gotDeclinedMessage\">\n                                                            {{ content('wallet.processorDeclinedCard') }}\n                                                        </span>\n                                                        <div class=\"padLabel\" ng-if=\"(plan.primaryFs.subtype === 'PAD' || plan.primaryFs.padPlanId) && padToggleFeature.enabled && displayPadLabel\">\n                                                            <span>{{ content('memberReview.padLabel_2') }}</span>\n                                                        </div>\n                                                    </div>\n\n                                                    <div ng-if=\"showCreditPlacement(plan)\">\n                                                        <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n\n                                                    </div>\n                                                    <div class=\"conversion leftAlign\" data-test-id=\"selectFiPPCCrossCurrencyRate\" ng-if=\"plan.primaryFs.name === 'BILL_ME_LATER' && ppcCrossCurrencyInfo\">\n                                                        <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n                                                        <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: ppcCrossCurrencyInfo.fromUnitCurrency, currencyTo: ppcCrossCurrencyInfo.toTargetCurrency})}}</span>\n                                                    </div>\n                                                </div>\n                                            </label>\n                                        </div>\n                                        <div class=\"fsSubdetails\">\n                                            <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                                {{ content('paymentMethod.eCheckDescription') }}\n                                            </div>\n                                        </div>\n                                    </experience>\n                                </li>\n                                <li role=\"presentation\" class=\"fundingsource\" ng-if=\"isBillingNoPurchase\" ng-repeat=\"stickyFI in getBAPlans() track by $index\">\n                                    <experience flag=\"!cardart\">\n                                        <div class=\"row-fluid radioButton\">\n                                            <input\n                                                type=\"radio\"\n                                                id=\"{{stickyFI.instrument_id}}\"\n                                                data-test-id=\"selectFIRadioButton\"\n                                                name=\"selectedFI\"\n                                                ng-value=\"stickyFI.instrument_id\"\n                                                ng-model=\"selectedmethod.planId\"\n                                            />\n                                            <label class=\"noBottom multiFiLabelContainer\" for=\"{{stickyFI.instrument_id}}\">\n                                                <div class=\"fiContainer\">\n                                                    <span class=\"fsIcon\" ng-class=\"[stickyFI.type, stickyFI.name, stickyFI.card_type]\"></span>\n                                                    <div class=\"fsdetails\">\n                                                        <span ng-switch=\"fundingsource.subtype\">\n                                                            <span ng-switch-default>\n                                                                <span class=\"name\">{{content('fsMappings.'+ stickyFI.name) || stickyFI.name}}</span>\n                                                                <span class=\"lastdigits\" ng-if=\"stickyFI.last4\">x-{{stickyFI.last4}}</span>\n                                                            </span>\n                                                        </span>\n                                                    </div>\n                                                    <div ng-if=\"stickyFI.type === 'BILL_ME_LATER'\">\n                                                        <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n\n                                                    </div>\n                                                </div>\n                                            </label>\n                                        </div>\n                                    </experience>\n                                    <experience flag=\"cardart\">\n                                        <div class=\"row-fluid radioButton\">\n                                            <input\n                                                type=\"radio\"\n                                                id=\"{{stickyFI.instrument_id}}\"\n                                                data-test-id=\"selectFIRadioButton\"\n                                                name=\"selectedFI\"\n                                                ng-value=\"stickyFI.instrument_id\"\n                                                ng-model=\"selectedmethod.planId\"\n                                            />\n\n                                            <label class=\"noBottom\" for=\"{{stickyFI.instrument_id}}\">\n                                                <div class=\"positionDecoupler\">\n                                                    <xo-fi-panel fi=\"stickyFI\" plan=\"plan\">\n                                                        <div class=\"fsSubdetails\">\n                                                            <div ng-if=\"stickyFI.type === 'BILL_ME_LATER'\">\n                                                                <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n\n                                                            </div>\n                                                        </div>\n                                                    </xo-fi-panel>\n                                                </div>\n                                    </experience>\n                                </li>\n\n                                <li role=\"presentation\" class=\"fundingsource\" ng-if=\"showPPCAcquisitionRadioButton()\">\n                                    <div ng-show=\"ppcInstallmentContentReady()\">\n                                        <h2 class=\"paymentsHeader alpha\" ng-bind-html=\"getInstallmentsFiTitle()\"></h2>\n                                        <div class=\"row-fluid radioButton\">\n                                            <input type=\"radio\" id=\"applyForPPCRadio\" name=\"selectedFI\" value=\"applyForPPCRadio\"\n                                                ng-model=\"selectedmethod.index\" ng-change=\"verifyBalanceWithInstallments()\"\n                                                data-test-id=\"deInstallmentsFI\"/>\n                                            <label class=\"noBottom\" for=\"applyForPPCRadio\">\n                                                <xo-credit-offer-banners token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"\n                                                    selectedmethod=\"selectedmethod\" radio=\"true\">\n                                                </xo-credit-offer-banners>\n                                            </label>\n                                        </div>\n                                    </div>\n                                </li>\n\n                            </ul>\n\n                            <div ng-if=\"showBalanceComprehensionBannerBottom\" data-test-id=\"ppBalanceBanner\" class=\"ppBalanceBanner bottom\">\n                                <xo-message message=\"balanceComprehensionBannerMessage\"></xo-message>\n                            </div>\n\n                            <div class=\"multipleFi addCard\" ng-if=\"!isUSGambling() && !addBankAllowed\">\n                                <a track-link=\"choose_FI_interstitial\" ui-sref=\"checkout.pageAddCard.addCardFlow.addCard\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                                    <span class=\"plusicon\"></span>\n                                    <p class=\"addOption\">\n                                        <span class=\"name\">{{content(choicePageAddCardContentKey)}}</span>\n                                    </p>\n                                </a>\n                            </div>\n\n                            <div class=\"multipleFi addCard\" ng-if=\"!isUSGambling() && addBankAllowed\">\n                                <a track-link=\"choose_FI_interstitial\" ui-sref=\"checkout.pageAddFi.bank.add\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                                    <span class=\"plusicon\"></span>\n                                    <p class=\"addOption\">\n                                        <span class=\"name\">{{ content('common.addNew') }}</span>\n                                    </p>\n                                </a>\n                            </div>\n\n                \n\n                            <div ng-if=\"creditOffer && !isCountryDE\" class=\"PPCOffers\">\n                                <xo-credit-offer-banners token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"\n                                    selectedmethod=\"selectedmethod\">\n                                </xo-credit-offer-banners>\n                            </div>\n                        </div>\n                    </div>\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <button track-submit='choose_FI_interstitial' class=\"btn full confirmButton continueButton\" ng-click=\"continue()\">{{continueButtonText()}}</button>\n                    </div>\n\n                    <xo-credit-example-uk ng-if=\"models.creditSharedInfo.shouldShowCreditExample()\" />\n\n                </div>\n            </div>\n        </div>\n        <div class=\"span10\">\n            <xo-marketing-offers placement-code=\"'202003'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"propValueObj.propHeader\"\n                                 subtitle-property=\"propValueObj.propVal\"\n                                 background-image= \"propValueObj.propImage\"\n            >\n            </xo-marketing-offers>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSepaPageComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _template = __webpack_require__("./pages/xo-sepa/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSepaPageComponent = exports.$xoSepaPageComponent = _squid.$Component.extend('$xoSepaPageComponent', {
    tag: 'xo-sepa-page',
    template: _template2['default'],

    scope: {
        token: '=?'
    },

    controller: ['$scope', function ($scope) {
        $scope.callbacks = {
            success: function success(sepaModel) {

                (0, _squid.$populate)($scope, {
                    checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
                }).then(function () {
                    return sepaModel.action('clearSepa', {
                        data: {
                            bank: {
                                id: sepaModel.bankId
                            },
                            token: $scope.token
                        },

                        success: function success() {
                            $scope.checkoutSession.action('authorize', {
                                success: function success() {
                                    // xchild = V4 Incontext Integration. Do not initiate Payment.
                                    if (!window.xchild && $scope.checkoutAppData.doec_on_approve()) {
                                        return _uiRouter.$state.go('checkout.pay');
                                    }
                                    _uiRouter.$state.go('checkout.end');
                                }

                            });
                        }

                    });
                });
            }
        };
        _uiRouter.$state.go('checkout.sepapage.membersepa.sepaAgreement');
    }]

});

angular.value("$xoSepaPageComponent", $xoSepaPageComponent);
_squid.$Component;

_squid.$populate;

_uiRouter.$state;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "./pages/xo-sepa/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SepaPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/member-sepa/route.js");

__webpack_require__("./pages/xo-sepa/directive.js");

var $SepaPageRoute = exports.$SepaPageRoute = _squid.$ComponentRoute.extend('$SepaPageRoute', {
    path: 'sepapage',
    directive: 'xo-sepa-page',
    titleContent: 'DEMemberGuest.sepaTitle',
    query: ['message'],
    trackingData: {
        fptiState: 'membersepa',
        templateName: 'membersepa.dust',
        pageGoal: 'SEPA Review'
    },
    children: [{
        name: '$MemberSepaRoute',
        attributes: {
            token: 'token',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$SepaPageRoute", $SepaPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sepa/template.html":
/***/ (function(module, exports) {

module.exports = "<ui-view></ui-view>\n"

/***/ }),

/***/ "./pages/xo-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoShippingComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/directive.js");

var _template = __webpack_require__("./pages/xo-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoShippingComponent = exports.$xoShippingComponent = _squid.$Component.extend('$xoShippingComponent', {
    tag: 'xo-shipping',
    template: _template2['default'],

    scope: {
        backUri: '=?',
        shippingChangeFeature: '=?'
    },

    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);
        $scope.logSubscriptionEvent({
            from: 'select_shipping_rendered',
            to: 'prepare_select_shipping'
        });
        $scope.onComplete = function (result) {
            _uiRouter.$state.go($scope.backUri || 'checkout.review');
        };
    }]
});

angular.value("$xoShippingComponent", $xoShippingComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

_sharedUtil.$SharedUtil;

/***/ }),

/***/ "./pages/xo-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarShippingRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-shipping/directive.js");

var $SidebarShippingRoute = exports.$SidebarShippingRoute = _squid.$ComponentRoute.extend('$SidebarShippingRoute', {
    path: 'shipping',
    directive: 'xo-shipping',
    titleContent: 'asideHeader.selectShipping',
    trackingData: {
        fptiState: 'select_shipping_address',
        templateName: 'selectShipping.dust',
        pageGoal: 'Select Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-select-shipping-address',
                'pagename2': '%::fullpage-select-shipping-address:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    }
});

angular.value("$SidebarShippingRoute", $SidebarShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"selectShipping\">\n    <xo-select-shipping done-fn=\"onComplete\" token=\"token\" shipping-change-feature=\"shippingChangeFeature\" back-uri=\"backUri\"></xo-select-shipping>\n</section>\n"

/***/ }),

/***/ "./pages/xo-sidebar-add-bank/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarAddBankPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-add-bank/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddBankPageComponent = exports.$xoSidebarAddBankPageComponent = _squid.$Component.extend('$xoSidebarAddBankPageComponent', {
    tag: 'xo-sidebar-add-bank-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.sidebar = true;
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
        $scope.callbacks = {
            done: function done() {
                _uiRouter.$state.go('checkout.review');
            }
        };
    }]
});

angular.value("$xoSidebarAddBankPageComponent", $xoSidebarAddBankPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-sidebar-add-bank/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarAddBankRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/route.js");

__webpack_require__("./pages/xo-sidebar-add-bank/directive.js");

var $SidebarAddBankRoute = exports.$SidebarAddBankRoute = _squid.$ComponentRoute.extend('$SidebarAddBankRoute', {
    path: 'sidebarAddBank',
    directive: 'xo-sidebar-add-bank-page',
    titleContent: 'asideHeader.addBank',
    trackingData: {
        templateName: 'tray/addBank.dust',
        pageGoal: 'Add Bank',
        buzname: {
            'fullpage': {
                'pagename': '%::add-bank',
                'pagename2': '%::add-bank:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$SidebarAddBankRoute", $SidebarAddBankRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-add-bank/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"addBank\" content>\n    <ui-view></ui-view>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarAddCardPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-add-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddCardPageComponent = exports.$xoSidebarAddCardPageComponent = _squid.$Component.extend('$xoSidebarAddCardPageComponent', {
    tag: 'xo-sidebar-add-card-page',
    template: _template2['default'],
    scope: {
        promotion: '=?',
        backUri: '=?',
        doneUri: '=?'
    },
    controller: ['$scope', function ($scope) {
        $scope.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);
        $scope.logSubscriptionEvent({
            from: 'sidebar_add_card_rendered',
            to: 'prepare_sidebar_add_card'
        });
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.sidebar = true;
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
        $scope.callbacks = {
            finish: function finish() {
                $scope.logSubscriptionEvent({
                    from: 'sidebar_add_card_completed',
                    to: 'processing_sidebar_add_card'
                });
                _uiRouter.$state.go($scope.doneUri || 'checkout.review');
            }
        };
    }]
});

angular.value("$xoSidebarAddCardPageComponent", $xoSidebarAddCardPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

_sharedUtil.$SharedUtil;

/***/ }),

/***/ "./pages/xo-sidebar-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarAddCardRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-sidebar-add-card/directive.js");

var $SidebarAddCardRoute = exports.$SidebarAddCardRoute = _squid.$ComponentRoute.extend('$SidebarAddCardRoute', {
    path: 'sidebarAddCard',
    directive: 'xo-sidebar-add-card-page',
    titleContent: 'asideHeader.addCard',
    trackingData: {
        templateName: 'tray/addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
                'version': 'member:%:tray'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'back-uri': 'backUri',
            'parent-callbacks': 'callbacks',
            promotion: 'promotion'
        }
    }]
});

angular.value("$SidebarAddCardRoute", $SidebarAddCardRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"addCard\" content>\n\t<ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-add-new/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarAddNewPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-add-new/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddNewPageComponent = exports.$xoSidebarAddNewPageComponent = _squid.$Component.extend('$xoSidebarAddNewPageComponent', {
    tag: 'xo-sidebar-add-new-page',
    template: _template2['default'],
    scope: {},
    controller: ['$scope', function ($scope) {
        $scope.sidebar = true;
        // TODO: refactor controller logic to use lifecycle() methods
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.hideparenthead = {
            toggle: false
        };
        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            },
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            },
            cancel: function cancel(routeTo) {
                var destination = routeTo || $scope.parentState || '';

                if (destination) {
                    _uiRouter.$state.go(destination);
                }
            }
        };

        // TODO: remove nested $populate() logic to `resolve` and `lifecycle`
        var models = {};

        (0, _squid.$populate)($scope, {
            auth: _auth.$AuthModel.instance(),
            payee: _index.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            (0, _squid.$populate)(models, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment', false, true).then(function (result) {
                    var message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false);

                    // If no processor decline, retrieve and display the contingency message
                    if (!message && models.checkoutSession.get('errorData.cause')) {
                        if ($scope.payee.isGambling()) {
                            message = _fiMessages.$fiMessages.getGamblingMsg();
                        } else if (result) {
                            message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        } else {
                            message = _fiMessages.$fiMessages.getAddCardControlMsg(models.checkoutSession);
                        }
                    }

                    if (message) {
                        $scope.pageLevel = $scope.pageLevel || {};
                        $scope.pageLevel.message = {
                            type: message.type,
                            msgs: [message.msg]
                        };
                        if (message.title) {
                            $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                        }
                    }
                });
            });
        });
    }]
});
angular.value("$xoSidebarAddNewPageComponent", $xoSidebarAddNewPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_uiRouter.$state;

_auth.$AuthModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_fiMessages.$fiMessages;

/***/ }),

/***/ "./pages/xo-sidebar-add-new/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarAddNewRoute = undefined;

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/route.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-sidebar-add-new/directive.js");

var $SidebarAddNewRoute = exports.$SidebarAddNewRoute = _squid.$ComponentRoute.extend('$SidebarAddNewRoute', {

    path: 'sidebarAddNew',

    directive: _directive.$xoSidebarAddNewPageComponent,

    titleContent: 'common.addNew',

    trackingData: {
        fptiState: 'add_new_de',
        templateName: 'tray/addNew.dust',
        pageGoal: 'Add a new bank or credit card for DE specific use case',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-new',
                'pagename2': '%::fullpage-add-new:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },

    children: [{
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'token',
            sidebar: 'sidebar',
            message: 'message',
            hideparenthead: 'hideparenthead',
            billingaddressupdated: 'billingaddressupdated',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': false
        }
    }, {
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            hideparenthead: 'hideparenthead',
            'parent-callbacks': 'callbacks',
            'page-level': 'pageLevel',
            'show-cancel': false
        }
    }]
});

angular.value("$SidebarAddNewRoute", $SidebarAddNewRoute);
_squid.$ComponentRoute;

_directive.$xoSidebarAddNewPageComponent;

/***/ }),

/***/ "./pages/xo-sidebar-add-new/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"addBank\" content>\n    <section id=\"sidepageAddCard\">\n\n        <xo-aside-header ng-if=\"!hideparenthead.toggle\"\n                        heading=\"common.addNew\"\n                        hidex=\"true\"\n                        header-left-icon=\"true\"\n                        header-left=\"common.back\"\n                        back-url=\"checkout.review\">\n        </xo-aside-header>\n\n        <div trayInner trayInnerDefault>\n            <xo-message message=\"pageLevel.message\"></xo-message>\n            <div class=\"addFi\">\n                <ul class=\"form-tabs\" id=\"paymentTab\" ng-if=\"!hideparenthead.toggle\">\n                    <li class=\"bank\" ui-sref-active=\"active\">\n                        <a ui-sref=\"checkout.review.sidebar.sidebarAddNew.bank.add\" class=\"bankTab\">{{ content('bank.bank') }}</a>\n                    </li>\n                    <li class=\"card\" ui-sref-active=\"active\">\n                        <a ui-sref=\"checkout.review.sidebar.sidebarAddNew.addCardFlow.addCard\" class=\"cardTab\" for=\"cardTab\">{{ content('bank.card_2') }}</a>\n                    </li>\n                </ul>\n            </div>\n\n            <div class=\"content\">\n                <ui-view></ui-view>\n            </div>\n        </div>\n    </section>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-add-shipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarAddShippingPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-add-shipping/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddShippingPageComponent = exports.$xoSidebarAddShippingPageComponent = _squid.$Component.extend('$xoSidebarAddShippingPageComponent', {
    tag: 'xo-sidebar-add-shipping-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.sidebar = true;

        $scope.onComplete = function () {
            _uiRouter.$state.go('checkout.review');
        };
    }]
});

angular.value("$xoSidebarAddShippingPageComponent", $xoSidebarAddShippingPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-sidebar-add-shipping/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarAddShippingRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-sidebar-add-shipping/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js");

var $SidebarAddShippingRoute = exports.$SidebarAddShippingRoute = _squid.$ComponentRoute.extend('$SidebarAddShippingRoute', {

    path: 'sidebarAddShipping',
    directive: 'xo-sidebar-add-shipping-page',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        templateName: 'tray/addShippingAddress.dust',
        pageGoal: 'Add Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address',
                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
                'version': 'member:%:tray'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token'
        },
        message: 'message',
        sidebar: 'sidebar',
        'parent-callbacks': 'callbacks'
    }]
});

angular.value("$SidebarAddShippingRoute", $SidebarAddShippingRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-add-shipping/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"addShipping\">\n\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-currency-conversion/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarCurrencyConversionPageComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-currency-conversion/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarCurrencyConversionPageComponent = exports.$xoSidebarCurrencyConversionPageComponent = _squid.$Component.extend('$xoSidebarCurrencyConversionPageComponent', {
    tag: 'xo-sidebar-currency-conversion-page',
    template: _template2['default'],
    controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
        $scope.token = $rootScope.token;

        $scope.onComplete = function (checkoutSession) {
            if (checkoutSession) {
                $rootScope.$broadcast('reloadCheckoutSession', { checkoutSession: checkoutSession });
            }
            _uiRouter.$state.go('checkout.review');
        };
        $scope.$emit('populated');
    }]
});

angular.value("$xoSidebarCurrencyConversionPageComponent", $xoSidebarCurrencyConversionPageComponent);
_uiRouter.$state;

_squid.$Component;

/***/ }),

/***/ "./pages/xo-sidebar-currency-conversion/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarCurrencyConversionRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-sidebar-currency-conversion/directive.js");

var $SidebarCurrencyConversionRoute = exports.$SidebarCurrencyConversionRoute = _squid.$ComponentRoute.extend('$SidebarCurrencyConversionRoute', {
    path: 'currencyConversion',
    directive: 'xo-sidebar-currency-conversion-page',
    titleContent: 'asideHeader.currencyConversion',
    trackingData: {
        fptiState: 'currency_conversion',
        templateName: 'tray/currencyOptions.dust',
        pageGoal: 'Currency Conversion',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-currency-options',
                'pagename2': '%::fullpage-currency-options::hermes:',
                'version': ':%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$SidebarCurrencyConversionRoute", $SidebarCurrencyConversionRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-currency-conversion/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"currencyConversion\">\n    <xo-aside-header heading='asideHeader.currencyConversion'></xo-aside-header>\n    <div class=\"currencyConversion asideContent container\" xo-tray-height>\n       <xo-currency-conversion token=\"token\" done-fn=\"onComplete\"></xo-currency-conversion>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarInstallmentOptionsPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/installment-options/directive.js");

var _template = __webpack_require__("./pages/xo-sidebar-installment-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarInstallmentOptionsPageComponent = exports.$xoSidebarInstallmentOptionsPageComponent = _squid.$Component.extend('$xoSidebarInstallmentOptionsPageComponent', {
    tag: 'xo-sidebar-installment-options-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.onComplete = function () {
            _uiRouter.$state.go('checkout.review');
        };
        $scope.$emit('populated');
    }]
});

angular.value("$xoSidebarInstallmentOptionsPageComponent", $xoSidebarInstallmentOptionsPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarInstallmentOptionsRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-sidebar-installment-options/directive.js");

var $SidebarInstallmentOptionsRoute = exports.$SidebarInstallmentOptionsRoute = _squid.$ComponentRoute.extend('$SidebarInstallmentOptionsRoute', {
    path: 'installmentOptions',
    directive: 'xo-sidebar-installment-options-page',
    titleContent: 'asideHeader.installmentsPanel',
    trackingData: {
        fptiState: 'installment_options',
        templateName: 'tray/installmentOptions.dust',
        pageGoal: 'Installment Options',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-installment-options',
                'pagename2': '%::fullpage-installment-options::hermes:',
                'version': ':%:'
            }
        }
    },
    children: []
});

angular.value("$SidebarInstallmentOptionsRoute", $SidebarInstallmentOptionsRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"installmentOptions\">\n    <xo-aside-header heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <xo-installment-options token=\"token\" done-fn=\"onComplete\"></xo-installment-options>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-manage-wallet/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _factory = __webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/factory.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/cardicon/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/directive.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

var _template = __webpack_require__("./pages/xo-sidebar-manage-wallet/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-sidebar-manage-wallet/styles.less");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$SidebarManageWalletDirective', {
    tag: 'xo-manage-wallet',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                variant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                cart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop)
            };
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    all: _factory.$ExpiredFiPanelFactory.getAllInstruments(models),
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        },
        padToggleFeature: function padToggleFeature(resolvers) {
            return resolvers.models.then(function (models) {
                var enabled = void 0;

                if (models.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    enabled = Experiments.padToggleFeatureSupported();
                } else {
                    // if pad not availabe
                    enabled = false;
                }
                return { enabled: enabled };
            });
        },
        ppBalanceRebrandedExperiment: function ppBalanceRebrandedExperiment() {
            return {
                enabled: _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale)
            };
        }
    },
    actions: {
        toggleInfoMsg: function toggleInfoMsg($index) {
            this.disallowedIndex = this.disallowedIndex === $index ? -1 : $index;
        },
        confirm: function confirm($index) {
            this.selectedIndex = $index;
            this.deleteCard = true;
        },
        deleteFS: function deleteFS(fundingsource) {
            var _this = this;

            /**
             * Call walletfiserv to delete selected card and call Symphony's notifyChangeFundingInstruments api
             * to get back updated funding options.
             */
            this.deleteCardModel = new _index.$DeleteCardModel({
                id: fundingsource.id
            });
            this.deleteCardModel.save({
                data: this.deleteCardModel,

                contingencies: {
                    DELETE_CARD_CONTINGENCY: function DELETE_CARD_CONTINGENCY() {
                        _this.handleSingleContingency('creditcard.errorDeleteCard');
                        return;
                    }
                },

                error: function error() {
                    _this.handleSingleContingency('creditcard.errorDeleteCard');
                    return;
                },

                /**
                 * Call notifyChangeFundingInstruments to get updated funding options from checkout session
                 * During this call if any error or contingencies return back, just remove the deleted FI from checkout
                 * session as its already deleted successfully
                 */
                success: function success() {
                    _this.models.checkoutSession.fundingOptions.action('notifyChange', {
                        resultModel: _this.models.checkoutSession,

                        data: {
                            planId: fundingsource.id,
                            operation: 'REMOVED'
                        },
                        success: function success() {
                            _logger.$logger.info('manage_wallet: deleted FI - 1', fundingsource.id);
                            _this.selectedIndex = -1;
                            _this.disallowedIndex = -1;
                            return _factory.$ExpiredFiPanelFactory.getAllInstruments(_this.models).then(function (result) {

                                // Showing all plans but not pad plans for PAD2.0
                                if (_this.padToggleFeature.enabled) {
                                    _this.instruments = result.filter(function (plan) {
                                        return plan.subtype !== 'PAD';
                                    });
                                } else {
                                    _this.instruments = result;
                                }
                            });
                        },
                        contingencies: {
                            NOTIFY_FUNDING_CHANGE_CONTINGENCY: function NOTIFY_FUNDING_CHANGE_CONTINGENCY() {
                                return _this.removeFIFromCheckoutSession(fundingsource);
                            }
                        },
                        error: function error() {
                            return _this.removeFIFromCheckoutSession(fundingsource);
                        }
                    });
                }
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.handleSingleContingency = function (errorKey) {
                var messages = [];

                messages.push(_squid.$locale.content.get(errorKey));
                _this2.message = {
                    msgs: messages,
                    type: 'error'
                };
                _this2.isSystemError = true;
                _this2.selectedIndex = -1;
                _this2.disallowedIndex = -1;
            };

            this.removeFIFromCheckoutSession = function (fundingsource) {
                return _factory.$ExpiredFiPanelFactory.getAllInstruments(_this2.models).then(function (result) {
                    _this2.instruments = _squid.$util.filter(result, function (instrument) {
                        return instrument.id !== fundingsource.id;
                    });
                });
            };

            this.editDisallowedMsg = function (fi) {
                return _this2.models.fiMeta.getEditDisallowedContentKey(fi);
            };
        },
        populate: function populate() {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                variant = _models.variant;
            var _fiSource = this.fiSource,
                all = _fiSource.all,
                isCardArtExp = _fiSource.isCardArtExp,
                isBillingNoPurchase = _fiSource.isBillingNoPurchase;

            var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

            this.isCreditDisallowedForMerchant = checkoutSession && checkoutSession.isCreditDisallowedForMerchant;
            this.creditDisallowedMessage = {
                type: 'info',
                msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
            };

            this.showMultipleFI = multipleFiVariants.indexOf(variant) > -1;
            this.message = checkoutSession && checkoutSession.message;
            this.isSystemError = this.message && this.message.type === 'error';

            if (this.models.checkoutSession.message && !this.models.checkoutSession.message.keepMsg) {
                this.models.checkoutSession.message = null;
            }
            // Showing all plans but not pad plans for PAD2.0
            if (this.padToggleFeature.enabled) {
                this.instruments = all.filter(function (plan) {
                    return plan.subtype !== 'PAD';
                });
            } else {
                this.instruments = all;
            }

            if (_squid.$locale.country === 'DE') {
                // Filter out the BILL_ME_LATER FI in DE since it is close-ended
                // and cannot be managed through hermes
                this.instruments = all.filter(function (plan) {
                    return !(plan.type === 'CREDIT' && plan.name === 'BILL_ME_LATER');
                });
            }

            /**
             * Log our cardart instrumentation.
             * See $CardArtInstrument.createPayload() for detailed implementation
             */
            if (isCardArtExp) {
                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'MANAGE_WALLET',
                    to: 'prepare_manage_wallet'
                }, _cardartInstrument.$CardArtInstrument.createPayload({
                    checkoutSession: checkoutSession,
                    isBillingNoPurchase: isBillingNoPurchase
                })));
            }
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$locale;

_squid.$config;

_squid.$util;

_logger.$logger;

_choice.$ChoiceEligibility;

_index.$DeleteCardModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_factory.$ExpiredFiPanelFactory;

_sharedUtil.$SharedUtil;

_cardartInstrument.$CardArtInstrument;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-sidebar-manage-wallet/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarManageWalletRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-sidebar-manage-wallet/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $SidebarManageWalletRoute = exports.$SidebarManageWalletRoute = _squid.$Route.extend('$SidebarManageWalletRoute', {
    path: 'sidebarManageWallet',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'manage_wallet',
        templateName: 'tray/manageWallet',
        pageGoal: 'Manage Instruments',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-manage-wallet',
                'pagename2': '%::fullpage-manage-wallet:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$SidebarManageWalletRoute", $SidebarManageWalletRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-sidebar-manage-wallet/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-sidebar-manage-wallet/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header\n    ng-if=\"!showMultipleFI\"\n    heading='asideHeader.manageWallet'\n    back-url='checkout.review.sidebar.wallet'>\n</xo-aside-header>\n\n<xo-aside-header\n    ng-if=\"showMultipleFI\"\n    heading='asideHeader.manageWallet'>\n</xo-aside-header>\n\n<div class=\"asideContent fundingCards\" id=\"manageFunding\" content xo-tray-height>\n    <xo-message ng-if=\"isCreditDisallowedForMerchant\" message=\"creditDisallowedMessage\"></xo-message>\n    <xo-message message=\"message\"></xo-message>\n\n    <div class=\"allCards\">\n        <ul class=\"allFundingInstrumentsList clearfix\" select-box=\"instruments track by $index\" select-allow-tab-escape>\n            <li role=\"presentation\" class=\"fundingsource item\" ng-class=\"{'disallowed':fundingsource.declineReason}\" ng-repeat=\"fundingsource in instruments track by $index\" ng-if=\"!isBillingNoPurchase\">\n                <div ng-if=\"fundingsource.declineReason\" ng-class=\"{'disabled':fundingsource.declineReason}\"></div>\n                <div class=\"source\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !editDisallowedMsg(fundingsource)}\">\n                    <!-- cardart experience -->\n                    <experience flag=\"cardart\">\n                        <div class=\"fsPanelRow\" ng-class=\"{'rowMask': editDisallowedMsg(fundingsource) || fundingsource.declineReason, slide: ($index == selectedIndex && deleteCard)}\">\n                            <xo-fi-panel fi=\"fundingsource\" name-override=\"fundingsource.type === 'BALANCE' && ppBalanceRebrandedExperiment.enabled && content('paymentMethod.paypalBalanceRebranded')\">\n                                <xo-expired-fi-panel token=\"token\" fi=\"fundingsource\"></xo-expired-fi-panel>\n                                <div class=\"manageLinks\" ng-class=\"{slideOut: ($index == selectedIndex && deleteCard)}\" ng-if=\"!editDisallowedMsg(fundingsource) && !isSystemError \">\n                                    <span ng-if=\"$index !== selectedIndex\">\n                                        <a track-submit=\"update_card\"\n                                           ui-sref='checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: fundingsource.id})'\n                                           class=\"updateButton focusableIcon\"\n                                           aria-label=\"{{content('wallet.update') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                            <span>{{ content('wallet.update') }}</span>\n                                        </a>\n                                        <span class=\"vertical\"></span>\n                                        <a href=\"\"\n                                           link-button class=\"deleteButton focusableIcon\"\n                                           ng-click=\"actions.confirm($index)\"\n                                           aria-label=\"{{content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                            {{ content('wallet.delete') }}\n                                        </a>\n                                    </span>\n                                    <span ng-if=\"$index === selectedIndex\">\n                                        <span class=\"updateButton focusableIcon\"\n                                           aria-label=\"{{content('wallet.update') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                            <span>{{ content('wallet.update') }}</span>\n                                        </span>\n                                        <span class=\"vertical\"></span>\n                                        <span class=\"deleteButton focusableIcon\"\n                                           aria-label=\"{{content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                            {{ content('wallet.delete') }}\n                                        </span>\n                                    </span>\n                                </div>\n                            </xo-fi-panel>\n                            <a ng-if=\"editDisallowedMsg(fundingsource)\"\n                               ui-sref=\"checkout.review.sidebar.sidebarManageWallet\"\n                               ng-click=\"actions.toggleInfoMsg($index)\"\n                               class=\"infoIcon\"\n                               role=\"button\"\n                               aria-expanded=\"{{$index == disallowedIndex}}\"\n                               title=\"{{'More Info on '+ fundingsource.name +' '+ fundingsource.lastDigits}}\"\n                               aria-label=\"{{'More Info on '+ fundingsource.name +' '+ fundingsource.lastDigits}}\"></a>\n                            <p ng-if=\"editDisallowedMsg(fundingsource)\" class=\"infoMsg\" ng-class=\"{showMsg: ($index == disallowedIndex)}\">\n                                {{ content(editDisallowedMsg(fundingsource)) }}\n                            </p>\n                        </div>\n                        <div ng-class=\"{slideIn: ($index === selectedIndex && deleteCard)}\" class=\"confirm\" ng-if=\"!editDisallowedMsg(fundingsource) && !isSystemError\">\n                            <a ng-if=\"$index !== selectedIndex\"\n                               class=\"confirmButton focusableIcon\"\n                               title=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\"\n                               aria-label=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('common.confirm') }}\n                            </a>\n                            <a ng-if=\"$index === selectedIndex\"\n                               href=\"\" link-button track-submit=\"delete_card\"\n                               class=\"confirmButton focusableIcon\"\n                               ng-click=\"actions.deleteFS(fundingsource)\"\n                               aria-label=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('common.confirm') }}\n                            </a>\n                        </div>\n                    </experience>\n\n                    <!-- non-cardart experience -->\n                    <experience flag=\"!cardart\">\n                        <div ng-class=\"{'rowMask': editDisallowedMsg(fundingsource) || fundingsource.declineReason, slide: ($index === selectedIndex && deleteCard)}\">\n                            <span class=\"fsIcon nonCardArt pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fundingsource.isPinlessDebit\"></span>\n                            <xo-fi-icon class-name=\"fsIcon nonCardArt\" fi=\"fundingsource\" ng-if=\"!fundingsource.isPinlessDebit\">\n                                <img class=\"plccInstIcon\" ng-src=\"{{fundingsource.productUrl}}\" ng-show=\"fundingsource.type === 'PLCC'\">\n                            </xo-fi-icon>\n                            <p class=\"fsdetails\">\n                                <span ng-switch=\"fundingsource.subtype\">\n                                    <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                        <span class=\"subtype\">{{ content('fundingInstruments.pad') }}</span>\n                                        <span class=\"name\">{{ content('fsMappings.'+fundingsource.name) || fundingsource.name }}</span>\n                                        <span class=\"lastdigits\" ng-if=\"fundingsource.lastDigits\">x-{{ fundingsource.lastDigits }}</span>\n                                    </span>\n                                    <span ng-switch-default>\n                                        <span class=\"name\" ng-if=\"fundingsource.isPinlessDebit\">{{ content('fsMappings.PINLESSDEBIT') }}</span>\n                                        <span class=\"name\" ng-if=\"!fundingsource.isPinlessDebit\">{{ content('fsMappings.'+fundingsource.name) || fundingsource.name }}</span>\n                                        <span class=\"lastdigits\" ng-if=\"fundingsource.lastDigits\">x-{{ fundingsource.lastDigits }}</span>\n                                    </span>\n                                </span>\n                            </p>\n                        </div>\n\n                        <a class=\"infoIcon\"\n                           ng-if=\"editDisallowedMsg(fundingsource)\"\n                           ui-sref=\"checkout.review.sidebar.sidebarManageWallet\"\n                           ng-click=\"actions.toggleInfoMsg($index)\"\n                           aria-expanded=\"{{$index == disallowedIndex}}\"\n                           role=\"button\"\n                           aria-label=\"{{'More Info on '+ fundingsource.name +' '+ fundingsource.lastDigits}}\">\n                        </a>\n\n                        <p class=\"infoMsg\"\n                           ng-if=\"editDisallowedMsg(fundingsource)\"\n                           ng-class=\"{showMsg: ($index == disallowedIndex)}\">\n                            {{ content(editDisallowedMsg(fundingsource)) }}\n                        </p>\n\n                        <div class=\"manageLinks\"\n                             ng-class=\"{slideOut: ($index === selectedIndex && deleteCard)}\"\n                             ng-if=\"!editDisallowedMsg(fundingsource) &&  ($index !== selectedIndex) && !isSystemError\">\n                             <xo-expired-fi-panel token=\"token\" fi=\"fundingsource\"></xo-expired-fi-panel>\n                             <a track-submit=\"update_card\"\n                               ui-sref='checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: fundingsource.id})'\n                               class=\"updateButton focusableIcon\"\n                               aria-label=\"{{content('wallet.update') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                <span>{{ content('wallet.update') }}</span>\n                            </a>\n                            <span class=\"vertical\"></span>\n                            <a href=\"\"\n                               link-button class=\"deleteButton focusableIcon\"\n                               ng-click=\"actions.confirm($index)\"\n                               aria-label=\"{{content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('wallet.delete') }}\n                            </a>\n                        </div>\n\n                        <div class=\"confirm\"\n                             ng-class=\"{slideIn: ($index === selectedIndex && deleteCard)}\"\n                             ng-if=\"!editDisallowedMsg(fundingsource) && !isSystemError\">\n                            <a ng-if=\"$index !== selectedIndex\"\n                               class=\"confirmButton focusableIcon\"\n                               aria-label=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('common.confirm') }}\n                            </a>\n                            <a ng-if=\"$index === selectedIndex\"\n                               href=\"\"\n                               link-button track-submit=\"delete_card\"\n                               class=\"confirmButton focusableIcon\"\n                               ng-click=\"actions.deleteFS(fundingsource)\"\n                               aria-label=\"{{content('common.confirm') +' '+ content('wallet.delete') +' '+ fundingsource.name +'-'+ fundingsource.lastDigits}}\">\n                                {{ content('common.confirm') }}\n                            </a>\n                        </div>\n                    </experience>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar-update-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidebarUpdateCardComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("./pages/xo-sidebar-update-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarUpdateCardComponent = exports.$xoSidebarUpdateCardComponent = _squid.$Component.extend('$xoSidebarUpdateCardComponent', {
    tag: 'xo-sidebar-update-card',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        backUri: {
            type: 'var',
            required: false
        },
        doneUri: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            this.fundingid = _uiRouter.$stateParams.planId;
            this.updateCardCPA = _uiRouter.$stateParams.updateCardCPA;
            this.sidebar = true;
            this.backUri = this.props.backUri;
            var doneUri = _uiRouter.$stateParams.doneUri;

            this.callbacks = {
                finish: function finish() {
                    _uiRouter.$state.go(doneUri || 'checkout.review.sidebar.sidebarManageWallet');
                }
            };
        }
    }
});

angular.value("$xoSidebarUpdateCardComponent", $xoSidebarUpdateCardComponent);
_squid.$Component;

_uiRouter.$state;

_uiRouter.$stateParams;

/***/ }),

/***/ "./pages/xo-sidebar-update-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarUpdateCardRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-sidebar-update-card/directive.js");

var $SidebarUpdateCardRoute = exports.$SidebarUpdateCardRoute = _squid.$Route.extend('$SidebarUpdateCardRoute', {
    params: {
        planId: null,
        doneUri: null,
        updateCardCPA: false
    },
    path: 'sidebarUpdateCard',
    directive: 'xo-sidebar-update-card',
    titleContent: 'asideHeader.updateCard',
    trackingData: {
        templateName: 'tray/updateCard.dust',
        pageGoal: 'update Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-update-cc',
                'pagename2': '%::fullpage-update-cc:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks',
            logout: 'logout',
            fundingid: 'fundingid',
            'back-uri': 'backUri',
            'update-card-cpa': 'updateCardCPA'
        }
    }]
});

angular.value("$SidebarUpdateCardRoute", $SidebarUpdateCardRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-sidebar-update-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside addCard\" id=\"addCard\" content>\n    <ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidebar/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _template = __webpack_require__("./pages/xo-sidebar/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSidebarComponent', {

    tag: 'xo-sidebar',
    template: _template2['default'],

    props: {
        token: {
            required: false,
            type: 'var'
        },
        backUri: {
            required: false,
            type: 'var'
        },
        doneUri: {
            required: false,
            type: 'var'
        },
        promotion: {
            required: false,
            type: 'var'
        },
        update: {
            required: false,
            type: 'var'
        },
        installment: {
            required: false,
            type: 'var'
        },
        strictAddressNormalization: {
            required: false,
            type: 'var'
        },
        shippingChangeFeature: {
            required: false,
            type: 'var'
        },
        shippingAddress: {
            required: false,
            type: 'var'
        },
        onAddressNormalized: {
            required: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            _squid.$util.assert(this.props.backUri, 'Expected backUri');
            this.sidebar = true;
            this.backUri = this.props.backUri;
            this.doneUri = this.props.doneUri;
            this.onPageClick = function ($event) {
                $event.stopPropagation();
            };

            /**
             * Stores history of sidebar nested routes to be able to go to
             * previous sidebar routes by calling back() on sidebar.
             */
            this.history = [this.props.backUri];
            this.cancelStateListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
                var index = _this.history.indexOf(to.name);

                if (index === -1) {
                    _this.history.push(from.name);
                } else {
                    _this.history = _this.history.slice(0, index);
                }
            });

            this.back = function () {
                _uiRouter.$state.go(_this.history[_this.history.length - 1]);
            };

            this.close = function () {
                _uiRouter.$state.go(_this.props.backUri);
            };

            this.callbacks = {
                done: function done() {
                    _uiRouter.$state.go(this.doneUri || 'checkout.review');
                }
            };
        },
        populate: function populate() {
            this.ryi = document.getElementById('ryiForm');
            this.ryi && this.ryi.setAttribute('aria-hidden', true); // eslint-disable-line no-unused-expressions

            (0, _jquery2['default'])('body').addClass('trayOpen');
            (0, _jquery2['default'])('#wrapper').addClass('maskMember');

            var payButton = (0, _jquery2['default'])('.confirmButton');

            if (payButton) {
                payButton.attr('disabled', true);
            }
        },
        exit: function exit() {
            (0, _jquery2['default'])('body').removeClass('trayOpen');

            // Ensure `RYI` page can be read via voice over devices when
            // users come back from other pages
            this.ryi && this.ryi.setAttribute('aria-hidden', false); // eslint-disable-line no-unused-expressions

            var payButton = (0, _jquery2['default'])('.confirmButton');

            if (payButton) {
                payButton.attr('disabled', false);
            }

            this.cancelStateListener();
        }
    }
});


_angular.$rootScope;

_uiRouter.$state;

_squid.$Component;

_squid.$util;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-sidebar/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarRoute = undefined;

__webpack_require__("../node_modules/xo-address-components/src/address-normalization-edit/route.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/route.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/delete-shipping/route.js");

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/update-shipping/route.js");

__webpack_require__("./pages/xo-shipping/route.js");

__webpack_require__("./pages/xo-sidebar-add-shipping/route.js");

__webpack_require__("./pages/xo-sidebar-add-card/route.js");

__webpack_require__("./pages/xo-sidebar-add-bank/route.js");

__webpack_require__("./pages/xo-sidebar-currency-conversion/route.js");

__webpack_require__("./pages/xo-sidebar-installment-options/route.js");

__webpack_require__("./pages/xo-wallet/route.js");

__webpack_require__("./pages/xo-add-card/route.js");

__webpack_require__("./pages/xo-sidebar/directive.js");

__webpack_require__("./pages/xo-sidebar-manage-wallet/route.js");

__webpack_require__("./pages/xo-sidebar-update-card/route.js");

__webpack_require__("./pages/xo-sidebar-add-new/route.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
var $SidebarRoute = exports.$SidebarRoute = _index.$Route.extend('$SidebarRoute', {
    path: 'sidebar',
    directive: 'xo-sidebar',
    children: [{
        name: '$SidebarShippingRoute',
        attributes: {
            token: 'props.token',
            'back-uri': 'props.backUri',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'pages/xo-shipping/route',
        slug: 'shipping'
    }, {
        name: '$SidebarAddShippingRoute',
        attributes: {
            token: 'props.token',
            'back-uri': 'props.backUri',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'pages/xo-sidebar-add-shipping/route',
        slug: 'sidebarAddShipping'
    }, {
        name: '$SidebarAddCardRoute',
        attributes: {
            token: 'props.token',
            promotion: 'props.promotion',
            'back-uri': 'props.backUri',
            'done-uri': 'props.doneUri'
        },
        lazyRoute: 'pages/xo-sidebar-add-card/route',
        slug: 'sidebarAddCard'
    }, {
        name: '$SidebarAddBankRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-add-bank/route',
        slug: 'sidebarAddBank'
    }, {
        name: '$SidebarWalletRoute',
        props: function props() {
            return {
                token: this.props.token,
                promotion: this.props.promotion,
                installment: this.props.installment
            };
        },
        config: function config() {
            return {
                heading: 'asideHeader.fundingInstruments',
                subHeading: 'asideHeader.fundingInstrumentsSubHead',
                addRoute: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'
            };
        },

        lazyRoute: 'pages/xo-wallet/route',
        slug: 'wallet'
    }, {
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks'
        },
        lazyRoute: 'xo-wallet-components/src/add-bank/route',
        slug: 'bank'
    }, {
        name: '$AddCardPageRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks'
        },
        lazyRoute: 'pages/xo-add-card/route',
        slug: 'pageAddCard'
    }, {
        name: '$AddShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            'done-fn': 'callbacks.done',
            'back-uri': 'props.backUri',
            sidebar: 'sidebar',
            update: 'props.update',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/add-shipping/route',
        slug: 'addShipping'
    }, {
        name: '$UpdateShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            'done-fn': 'callbacks.done',
            'shipping-change-feature': 'props.shippingChangeFeature',
            sidebar: 'sidebar'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/update-shipping/route',
        slug: 'updateShipping'
    }, {
        name: '$AddressNormalizationEditRoute',
        attributes: {
            id: 'props.token',
            sidebar: 'sidebar',
            'address': 'props.shippingAddress',
            'strict-address-normalization': 'props.strictAddressNormalization',
            'back-uri': 'props.backUri',
            'done-fn': 'props.onAddressNormalized'
        },
        lazyRoute: 'xo-address-components/src/address-normalization-edit/route',
        slug: 'addressNormalizationEdit'
    }, {
        name: '$DeleteShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            sidebar: 'sidebar'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/delete-shipping/route',
        slug: 'deleteShipping'
    }, {
        name: '$SidebarCurrencyConversionRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-currency-conversion/route',
        slug: 'currencyConversion'
    }, {
        name: '$SidebarInstallmentOptionsRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-installment-options/route',
        slug: 'installmentOptions'
    }, {
        name: '$SidebarManageWalletRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-sidebar-manage-wallet/route',
        slug: 'sidebarManageWallet'
    }, {
        name: '$SidebarUpdateCardRoute',
        props: function props() {
            return {
                token: this.token,
                backUri: this.props.backUri,
                doneUri: this.props.doneUri
            };
        },

        lazyRoute: 'pages/xo-sidebar-update-card/route',
        slug: 'sidebarUpdateCard'
    }, {
        name: '$SidebarAddNewRoute',
        props: function props() {
            return {
                token: this.props.token,
                backUri: this.props.backUri,
                doneUri: this.props.doneUri,
                promotion: this.props.promotion,
                'show-cancel': this.props.showCancel,
                'parent-callbacks': this.props.callbacks
            };
        },

        lazyRoute: 'pages/xo-sidebar-add-new/route',
        slug: 'sidebarAddNew'
    }]
}); /* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */


angular.value("$SidebarRoute", $SidebarRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-sidebar/template.html":
/***/ (function(module, exports) {

module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\" modal-box modal-cancel=\"back()\" tabindex=\"-1\">\n\n    <div class=\"aside\" id=\"{{viewConfig.aside}}\">\n        <xo-aside-header ng-if=\"viewConfig.aside\" hdrtype=\"tall\" heading=\"{{viewConfig.heading}}\" sub-head='{{viewConfig.subHeading}}' add-link='{{viewConfig.addRoute}}'></xo-aside-header>\n        <div ui-view></div>\n    </div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"

/***/ }),

/***/ "./pages/xo-sidepage-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSidepageAddCardPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

var _template = __webpack_require__("./pages/xo-sidepage-add-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidepageAddCardPageComponent = exports.$xoSidepageAddCardPageComponent = _squid.$Component.extend('$xoSidepageAddCardPageComponent', {
    tag: 'xo-sidepage-add-card-page',
    template: _template2['default'],
    scope: {
        token: '=?',
        callbacks: '=?'
    },
    lifecycle: {
        enter: function enter() {
            var interval = (0, _angular.$interval)(function () {
                var el = (0, _jquery2['default'])('#sidepageAddCard');

                if (el) {
                    _angular.$interval.cancel(interval);
                    el.addClass('sidepageAddCardOpen');
                }
            }, 100);
        }
    },
    controller: ['$scope', function ($scope) {
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.isUpdateDebitCard = function () {
            return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
    }]
});

angular.value("$xoSidepageAddCardPageComponent", $xoSidepageAddCardPageComponent);
_angular.$interval;

_angular.$rootScope;

_squid.$Component;

_uiRouter.$stateParams;

/***/ }),

/***/ "./pages/xo-sidepage-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidepageAddCardRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-sidepage-add-card/directive.js");

var $SidepageAddCardRoute = exports.$SidepageAddCardRoute = _squid.$ComponentRoute.extend('$SidepageAddCardRoute', {
    path: 'sidepageAddCard',
    directive: 'xo-sidepage-add-card-page',
    titleContent: 'asideHeader.addCard',
    trackingData: {
        templateName: 'tray/addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
                'version': 'member:%:tray'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks',
            promotion: 'promotion',
            'show-cancel': true
        }
    }]
});

angular.value("$SidepageAddCardRoute", $SidepageAddCardRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-sidepage-add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"sidepageAddCard\" modal-box content>\n    <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                     hidex=\"true\"></xo-aside-header>\n    <div class=\"content\">\n\t    <ui-view></ui-view>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-sidepage/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _template = __webpack_require__("./pages/xo-sidepage/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSidepage', {

    tag: 'xo-sidepage',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    actions: {
        done: function done() {
            (0, _jquery2['default'])('body').removeClass('sidePageOpen');
            (0, _angular.$timeout)(function () {
                return _uiRouter.$state.go('checkout.review');
            }, 300);
        }
    },

    lifecycle: {
        populate: function populate() {
            (0, _jquery2['default'])('body').addClass('sidePageOpen');
        },
        exit: function exit() {
            this.actions.done();
        }
    }
});


_angular.$timeout;

_squid.$Component;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-sidepage/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidepageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-sidepage/directive.js");

var _directive2 = _interopRequireDefault(_directive);

var _route = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-amount/route.js");

var _route2 = _interopRequireDefault(_route);

var _route3 = __webpack_require__("../node_modules/xo-wallet-components/src/topup/topup-funding/route.js");

var _route4 = _interopRequireDefault(_route3);

var _route5 = __webpack_require__("../node_modules/xo-wallet-components/src/topup/update-pin/route.js");

var _route6 = _interopRequireDefault(_route5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $SidepageRoute = exports.$SidepageRoute = _index.$Route.extend('$SidepageRoute', {

    path: 'sidepage',
    directive: _directive2['default'],
    children: [{
        route: _route4['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }, {
        route: _route2['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }, {
        route: _route6['default'],
        props: function props() {
            return {
                token: this.token,
                success: this.actions.done
            };
        }
    }]
});

angular.value("$SidepageRoute", $SidepageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-sidepage/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"sidepage\" modal-box tabindex=\"-1\">\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-third-party-info/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, console) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _template = __webpack_require__("./pages/xo-third-party-info/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-third-party-info/styles.less");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/thirdPartyWallet/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/emailInput/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThirdPartyInfoFlowComponent', {
    tag: 'xo-third-party-info-collect',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        models: function models() {
            return {
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        },
        payloadId: function payloadId() {
            return {
                payload_id: _uiRouter.$stateParams['payload_id']
            };
        }
    },

    actions: {
        handleFormValidation: function handleFormValidation(res) {
            var $el = $(this.$element);

            if (res && res.fields && res.fields.length) {
                res.fields.forEach(function (field) {
                    if (field.field) {
                        var $field = $($el.find('[name="' + field.field + '"]'));

                        if ($field.length === 0 && field.field === 'zip') {
                            $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                        }
                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    }
                });
            }

            $el.find('form').find('.backendError, .ng-invalid').first().focus();
        },
        onSubmit: function onSubmit() {
            var _this = this;

            var createCheckoutSession = function createCheckoutSession() {
                var checkoutSessionModel = _index.$CheckoutSessionModel.instance(_this.token);

                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: _this.models.cart.supplementary && _this.models.cart.supplementary.risk_correlation_id,
                        user_selected_funding_source: {
                            product_name: 'BAIDU'
                        },
                        is_skip_gfo: true
                    },
                    success: function success() {
                        return _uiRouter.$state.go('checkout.review');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('SYMPHONY CONTINGENCY', msg);
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }

                });
            };

            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();

                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var phone = this.buyerInfo.phone.telephone;

            phone = phone.replace(/\(|\)|\s|\-/g, ''); // removing parenthesis, commas, and dashes from the phone #

            var onboardRequest = {
                payload_id: this.buyerInfo.payload_id,
                phone: _extends({}, this.buyerInfo.phone, { telephone: phone }),
                email: this.buyerInfo.user.email,
                address: this.buyerInfo.address
            };

            var onboardMember = function onboardMember() {
                var thirdPartyModel = _index3.$ThirdPartyOnboard.instance(_this.token);

                return thirdPartyModel.action('onboard', {
                    data: onboardRequest,
                    success: function success(data) {
                        _logger.$logger.info('baidu_onboard_success');
                    },
                    error: function error(err) {
                        _logger.$logger.info('baidu_onboard_error: ', err);

                        _logger.$logger.info('checkout_fpti', {
                            from: 'third_party_info_collect',
                            to: 'process_third_party_info_collect',
                            'int_error_description': 'baidu_onboard_failure',
                            'error_type': 'soft_decline',
                            'error_source': 'hermesnodeweb'
                        });
                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('THIS IS ONBOARD CONTINGENCY: ', msg);

                            _logger.$logger.info('checkout_fpti', {
                                from: 'third_party_info_collect',
                                to: 'process_third_party_info_collect',
                                'int_error_description': msg,
                                'error_type': 'soft_decline',
                                'error_source': 'hermesnodeweb'
                            });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }
                });
            };

            var setBaiduExperience = function setBaiduExperience() {
                return _thirdPartyInfo.thirdPartyExperience.setAsBaiduExperience(_this.token);
            };

            var addressValidation = new _index2.$BillingAddressModel({
                line1: this.buyerInfo.address.line1,
                line2: this.buyerInfo.address.line2,
                city: this.buyerInfo.address.city,
                state: this.buyerInfo.address.state,
                postal_code: this.buyerInfo.address.postal_code,
                country: this.buyerInfo.address.country,
                id: '0'
            });

            addressValidation.save({
                success: function success() {
                    onboardMember().then(refreshAuthState).then(onAuth).then(setBaiduExperience).then(createCheckoutSession);
                },
                validation: function validation(res) {
                    _this.actions.handleFormValidation(res);
                },
                error: function error() {
                    console.log('address_validation_error');
                }
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            this.buyerInfo = {
                address: {
                    country: _squid.$locale.country
                },
                user: {},
                phone: {}
            };
        },
        populate: function populate() {
            var payloadId = this.payloadId,
                cart = this.models.cart;


            var phone = cart.get('purchase.phone_fields.shipping_phone_number');
            var email = cart.get('payer.email');
            var shipping_address = cart.get('purchase.shipping_address');

            if (shipping_address) {
                shipping_address.country = shipping_address.country_code ? shipping_address.country_code : this.buyerInfo.address.country;
                shipping_address.country = shipping_address.country === 'CN' ? 'C2' : shipping_address.country;
                this.buyerInfo.address = shipping_address;
            }

            if (email) {
                this.buyerInfo.user.email = email;
            }

            if (phone) {
                this.buyerInfo.phone.telephone = phone;
            }

            this.buyerInfo.payload_id = payloadId.payload_id;
        }
    }
});


_squid.$Component;

_squid.$locale;

_uiRouter.$stateParams;

_uiRouter.$state;

_logger.$logger;

_index.$CheckoutPayeeModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index2.$BillingAddressModel;

_auth.$AuthModel;

_index3.$ThirdPartyOnboard;

_thirdPartyInfo.thirdPartyExperience;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./pages/xo-third-party-info/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThirdPartyInfoCollectFlowRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-third-party-info/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ThirdPartyInfoCollectFlowRoute = exports.$ThirdPartyInfoCollectFlowRoute = _squid.$Route.extend('$ThirdPartyInfoCollectFlowRoute', {
    path: 'thirdPartyInfoCollectFlow',
    directive: _directive2['default'],
    query: ['payload_id'],

    auth: false,

    trackingData: {
        fptiState: 'third_party_info_collect'
    }
});

angular.value("$ThirdPartyInfoCollectFlowRoute", $ThirdPartyInfoCollectFlowRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-third-party-info/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-third-party-info/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"review\" content tabindex=-1 role=\"presentation\">\n    <div class=\"thirdPartyInfoCollect row-fluid\">\n        <div class=\"span14 trayInner reviewSections\">\n            <xo-message ng-if=\"message\" message=\"message\"></xo-message>\n            <h1 class=\"alpha\">{{ content('common.confirmShippingDetails') }}</h1>\n            <p class=\"subTitle\">{{content('common.confirmShippingDetailsReqs')}}</p>\n\n\n            <form id=\"buyerInformationForm\" name=\"buyerInformationForm\" class=\"\" content novalidate form-autofocus>\n                <h1 class=\"gamma\">{{content('common.confirmShippingDetailsSub')}}</h1>\n                <xo-select-shipping-country shipping-address=\"buyerInfo.address\"\n                                            token=\"token\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n\n                <xo-name-input  user=\"buyerInfo.address\" country=\"{{buyerInfo.address.country}}\"></xo-name-input>\n\n                <xo-phone-input phone=\"buyerInfo.phone\" country=\"buyerInfo.address.country\"></xo-phone-input>\n\n                <xo-add-address address=\"buyerInfo.address\" country=\"buyerInfo.address.country\"></xo-add-address>\n\n                <h1 class=\"gamma\">{{content('applyForBmlUK.personalInformation')}}</h1>\n\n                <xo-email-input class=\"emailInputBelowName\" hide-helper=\"true\" flags=\"flags\" user=\"buyerInfo.user\"></xo-email-input>\n\n                <p class=\"legal\" ng-bind-html='htmlContent(\"common.confirmBaiduPaypalPolicyAgreement\")'></p>\n\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{content('memberReview.agreeAndContinueLabel')}}\" class=\"btn full\"  validate-submit=\"actions.onSubmit()\"/>\n                </div>\n            </form>\n\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-third-party-wallet/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;

var _template = __webpack_require__("./pages/xo-third-party-wallet/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-third-party-wallet/styles.less");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/thirdPartyWallet/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThirdPartyFlowComponent', {
    tag: 'xo-third-party-flow',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {},

    lifecycle: {
        enter: function enter() {
            if (_squid.$locale.country === 'CN') {
                _squid.$locale.choose('C2', 'zh_C2', false);
            }
        },
        populate: function populate() {
            var _this = this;

            var routingDecision = function routingDecision(payload_id) {
                var thirdPartyOnboard = _index2.$ThirdPartyOnboard.instance(_this.token);

                return thirdPartyOnboard.action('lookup', {
                    data: { payload_id: payload_id },
                    success: function success(result) {

                        _logger.$logger.info('checkout_fpti', { 'is_repeat_buyer': '1' });

                        refreshAuthState().then(onAuth).then(setBaiduExperience).then(createCheckoutSession);
                    },
                    error: function error(err) {
                        _logger.$logger.error('lookup_api_error', err);
                        _logger.$logger.info('checkout_fpti', {
                            from: 'third_party_wallet_flow',
                            to: 'process_third_party_wallet_flow',
                            'int_error_description': 'baidu_lookup_failure',
                            'error_type': 'soft_decline',
                            'error_source': 'hermesnodeweb'
                        });

                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    },
                    contingencies: {
                        NO_PAYMENT_TOKEN_FOUND: function NO_PAYMENT_TOKEN_FOUND(msg, contingency) {
                            _uiRouter.$state.go('checkout.thirdPartyInfoCollectFlow', { payload_id: payload_id });
                        },
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'third_party_wallet_flow',
                                to: 'process_third_party_wallet_flow',
                                'int_error_description': 'baidu_lookup_failure',
                                'error_type': 'soft_decline',
                                'error_source': 'hermesnodeweb'
                            });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }
                });
            };

            var createCheckoutSession = function createCheckoutSession() {
                var checkoutSessionModel = _index.$CheckoutSessionModel.instance(_this.token);

                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: _this.models.cart.supplementary && _this.models.cart.supplementary.risk_correlation_id,
                        user_selected_funding_source: {
                            product_name: 'BAIDU'
                        },
                        is_skip_gfo: true
                    },
                    success: function success() {
                        return _uiRouter.$state.go('checkout.review');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('SYMPHONY CONTINGENCY', msg);
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }

                });
            };

            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();

                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {
                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {
                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var setBaiduExperience = function setBaiduExperience() {
                return _thirdPartyInfo.thirdPartyExperience.setAsBaiduExperience(_this.token);
            };

            var _models = this.models,
                cart = _models.cart,
                checkoutPayee = _models.checkoutPayee;


            var hashResult = _index2.$ThirdPartyOnboard.instance(this.token).action('hash-info', {
                data: {
                    payToken: this.token
                },
                success: function success(result) {
                    return result;
                },
                contingencies: {
                    DEFAULT: function DEFAULT(msg, contingency) {
                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    }
                }
            });

            hashResult.then(function (result) {
                return _squid.$dom.loadScript('baiduComponent', 'https://' + _squid.$meta.cdnHost + '/api/thirdPartyWallet.js').then(function () {
                    _logger.$logger.info('rendering_baidu_flow');
                    _logger.$logger.info('checkout_fpti', { to: 'rendering_baidu_iframe' });
                    return window.paypal.ThirdPartyWallet.render({
                        env: _squid.$config.thirdPartyWallet.baidu,
                        timeout: 10000,
                        properties: {
                            paypal_order_id: _this.token,

                            business_id: checkoutPayee.get('merchant.id'),

                            currency_code: cart.get('purchase.amounts.total.currency_code'),

                            transaction_amount: cart.get('purchase.amounts.total.amount'),

                            payload_hash: result.hash,

                            key_id: result.keyId
                        },

                        onComplete: function onComplete(data) {
                            _logger.$logger.info('complete_bently_flow', { payload_id: data.payloadID });
                            _logger.$logger.info('checkout_fpti', { to: 'completing_baidu_iframe' });

                            if (data && data.payloadID) {
                                return routingDecision(data.payloadID);
                            } else {

                                _uiRouter.$state.go('checkout.login', { baiduError: true });
                            }
                        },
                        onCancel: function onCancel(data) {

                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        },
                        onError: function onError(data) {
                            _logger.$logger.info('baidu_error', data);
                            _logger.$logger.info('checkout_fpti', { int_error_code: data.error_code, int_error_desc: data.error_message });
                        },
                        onTransitionStart: function onTransitionStart(data) {
                            console.log('transition start happened ', data);
                        },
                        onTransitionEnd: function onTransitionEnd(data) {
                            console.log('transition end happened ', data);
                        },
                        onTimeout: function onTimeout(data) {
                            _logger.$logger.info('baidu_flow_load_timeout');
                            _logger.$logger.info('checkout_fpti', { int_error_code: 'TIMEOUT', int_error_desc: 'Iframe timeout' });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }, '#thirdPartyWalletContainer')['catch'](function (err) {
                        _logger.$logger.info('baidu_render_error', {
                            error: err.message,
                            stack: err.stack
                        });
                    });
                });
            });
        },
        exit: function exit() {}
    }

});


_squid.$Component;

_squid.$dom;

_squid.$locale;

_squid.$config;

_squid.$meta;

_logger.$logger;

_index.$CheckoutPayeeModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_auth.$AuthModel;

_index2.$ThirdPartyOnboard;

_thirdPartyInfo.thirdPartyExperience;

_uiRouter.$state;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./pages/xo-third-party-wallet/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThirdPartyWalletFlowRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-third-party-wallet/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ThirdPartyWalletFlowRoute = exports.$ThirdPartyWalletFlowRoute = _squid.$Route.extend('$ThirdPartyWalletFlowRoute', {
    path: 'thirdPartyWalletFlow',
    directive: _directive2['default'],

    auth: false,

    trackingData: {
        fptiState: 'third_party_wallet_flow',
        trackStateExit: true
    }
});

angular.value("$ThirdPartyWalletFlowRoute", $ThirdPartyWalletFlowRoute);
_squid.$Route;

/***/ }),

/***/ "./pages/xo-third-party-wallet/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-third-party-wallet/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"thirdPartyWalletContainer\"></div>\n"

/***/ }),

/***/ "./pages/xo-tokenization-info/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("./pages/xo-tokenization-info/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-tokenization-info/styles.less");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

__webpack_require__("./pages/xo-tokenization-info/msbOffer/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTokenizationInfoPageDirective', {
    tag: 'xo-tokenization-info',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();
            return {
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPinModel: _app.$TokenizedWalletPinModel.instance(this.props.token).retrieve(),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedWalletMsbOfferModel: _app.$TokenizedWalletMsbOfferModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken
                    }
                }),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                }),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        },
        balanceUsageExperiment: function balanceUsageExperiment() {
            return (0, _squid.$elmo)('paypal:isdc:products:balance:usage:us', {
                'filters.Country': _squid.$locale.country
            }, 'Trmt_balance_usage_us_products').then(function (result) {
                return { enabled: Boolean(result && result.treatment_name) };
            });
        }
    },

    actions: {
        logout: function logout() {
            var _this = this;

            this.auth.logout().then(function () {
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'PP_AndroidPay_Info',
                    'to': 'process_PP_AndroidPay_Info',
                    'context_id': _this.props.token,
                    'context_type': 'EC-Token'
                });
                _this.auth.redirectToLogin('NOT_YOU');
            });
        },
        redirectToCancelUrl: function redirectToCancelUrl() {
            var cancelUrl = this.models.checkoutAppData.urls.cancel_url;
            _index.$ReturnToMerchant.goTo(cancelUrl);
        },
        'continue': function _continue() {
            _logger.$logger.info('tokenized_wallet', {
                'from': 'PP_AndroidPay_Info',
                'to': 'process_PP_AndroidPay_Info',
                'context_id': this.props.token,
                'context_type': 'EC-Token'
            });

            var fi = this.models.checkoutSession.get('errorData.resolution.data.fi');

            var balanceUsageEnabled = this.balanceUsageExperiment.enabled;

            if (fi && !balanceUsageEnabled) {
                var contingency = new _squid.$Contingency(fi.fundingId ? 'EXPIRED_DEBIT_CARD' : 'NEED_DEBIT_CARD');

                _squid.$util.extend(contingency, this.models.checkoutSession.errorData);
                throw contingency;
            }

            if (this.directFundingEnabled) {
                // if direct funding is enabled and the returned future payments does not have FI other than balance,
                // we should not allow user onboard
                var futurePaymentInstruments = this.models.checkoutSession.get('futurePaymentInstruments', []);
                var validFI = futurePaymentInstruments.filter(function (fufI) {
                    return fufI.type !== 'BALANCE';
                });

                _logger.$logger.info('direct_funding_instruments', {
                    'futurePaymentInstruments': futurePaymentInstruments.length,
                    'validFI': validFI.length
                });

                if (validFI && validFI.length === 0) {

                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'PP_AndroidPay_Info',
                        'to': 'process_PP_AndroidPay_Info',
                        'context_id': this.props.token,
                        'context_type': 'EC-Token',
                        'int_error_code': 'NoBankAlert'
                    });

                    // Show the No Bank Alert page
                    this.noBank = true;
                    return;
                }
            }
            if (this.models.walletPinModel.isSetupEligible()) {
                _logger.$logger.debug('pinSetup_required');
                _uiRouter.$state.go('checkout.pinSetup');
            } else {
                _uiRouter.$state.go('checkout.review');
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            this.auth = _auth.$AuthModel.instance();
            this.noBank = false;
            this.showNotYou = this.auth && this.auth.showNotYou();
            this.userName = (0, _squid.formatNameInformal)({
                first_name: this.auth.first_name,
                last_name: this.auth.last_name
            }) || this.auth.email;
        },
        populate: function populate() {
            (0, _jquery2['default'])('#tokenizationInfo .infoPage').css('min-height', function () {
                var height = window.innerHeight || document.documentElement && document.documentElement.clientHeight;

                return height && height - 125; // 125px => height of header & action button bottom padding
            });

            this.topupEnabled = this.models.tokenizedFundingCapabilitiesModel.isTopupEnabled();
            this.brandName = this.models.tokenizedWalletInfoModel.brandName();
            this.balanceUsageEnabled = this.balanceUsageExperiment.enabled;
            this.directFundingEnabled = this.models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled();
            var ppCashToBalanceExperimentEnabled = _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale);
            var topupInfo1Key = ppCashToBalanceExperimentEnabled ? 'topup.commonTopupInfo1PPBalance' : 'topup.commonTopupInfo1';
            var topupInfo2Key = ppCashToBalanceExperimentEnabled ? 'topup.commonTopupInfo2PPBalance' : 'topup.commonTopupInfo2';

            if (this.topupEnabled) {
                this.showMsbOffer = this.models.tokenizedWalletMsbOfferModel && this.models.tokenizedWalletMsbOfferModel.enabled;
                this.tokenizationContent = {
                    heading: (0, _squid.$renderContent)('topup.commonTopupInfoHeading', { type: this.brandName }),
                    info1: (0, _squid.$renderContent)(topupInfo1Key, { type: this.brandName }),
                    info2: (0, _squid.$renderContent)(topupInfo2Key, { type: this.brandName }),
                    infoMayNeedPin: (0, _squid.$renderContent)('topup.topupInfoMayNeedPin')
                };
            } else if (this.balanceUsageEnabled) {
                this.showMsbOffer = this.models.tokenizedWalletMsbOfferModel && this.models.tokenizedWalletMsbOfferModel.enabled;
                this.tokenizationContent = {
                    heading: (0, _squid.$renderContent)('topup.commonTopupInfoHeading', { type: this.brandName }),
                    info1: (0, _squid.$renderContent)(topupInfo1Key, { type: this.brandName }),
                    info2: (0, _squid.$renderContent)(topupInfo2Key, { type: this.brandName }),
                    infoMayNeedPin: (0, _squid.$renderContent)('topup.topupInfoMayNeedPin')
                };
            } else {
                this.tokenizationContent = {
                    heading: (0, _squid.$renderContent)('tokenization.infoHeading', { type: this.brandName }),
                    info1: (0, _squid.$renderContent)('tokenization.info1', { type: this.brandName }),
                    info2: (0, _squid.$renderContent)('tokenization.info2'),
                    infoMayNeedPin: (0, _squid.$renderContent)('tokenization.infoMayNeedPin')
                };
                this.noBankErrorMessage = {
                    type: 'warning',
                    msgs: [(0, _squid.$renderContent)('tokenization.noBankHeaderSuggestion', { type: this.brandName })]
                };
            }
        }
    }
});


_auth.$AuthModel;

_squid.$Component;

_squid.$Contingency;

_squid.$elmo;

_squid.$locale;

_squid.formatNameInformal;

_squid.$util;

_squid.$renderContent;

_uiRouter.$state;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletMsbOfferModel;

_app.$TokenizedFundingCapabilitiesModel;

_app.$TokenizedWalletPinModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_index.$ReturnToMerchant;

_sharedUtil.$SharedUtil;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-tokenization-info/msbOffer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("./pages/xo-tokenization-info/msbOffer/styles.less");

var _template = __webpack_require__("./pages/xo-tokenization-info/msbOffer/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var logFpti = function logFpti(tokenizedWalletMsbOfferModel, toState) {
    var currency = tokenizedWalletMsbOfferModel.currency,
        amount = tokenizedWalletMsbOfferModel.amount;


    _logger.$logger.info('tokenized_wallet', {
        from: 'msb_page',
        to: toState,
        context_id: _angular.$rootScope.token,
        context_type: 'EC-Token',
        msb_currency_code: currency,
        msb_amt: amount
    });
};

var POPUP_TIMEOUT = 1000;

exports['default'] = _squid.$Component.extend('$xoTokenizedWalletMsbDirective', {
    tag: 'msb-offer',
    template: _template2['default'],

    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                tokenizedWalletMsbOfferModel: _app.$TokenizedWalletMsbOfferModel.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },

    actions: {
        closeModal: function closeModal() {
            this.showModal = false;
            logFpti(this.models.tokenizedWalletMsbOfferModel, 'process_msb');
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var _models = this.models,
                tokenizedWalletMsbOfferModel = _models.tokenizedWalletMsbOfferModel,
                tokenizedWalletInfoModel = _models.tokenizedWalletInfoModel;


            logFpti(tokenizedWalletMsbOfferModel, 'prepare_msb');
            this.showModal = true;
            // show animated popup with a delay
            (0, _angular.$timeout)(function () {
                _this.$element.find('.modal-dialog, .modal-overlay').addClass('tokenizedWalletMsbFadeIn');
            }, POPUP_TIMEOUT);

            this.brandName = tokenizedWalletInfoModel.brandName();
            var currency = tokenizedWalletMsbOfferModel.currency,
                amount = tokenizedWalletMsbOfferModel.amount;


            this.amount = (0, _squid.formatCurrency)(amount, currency);
            this.termsLink = tokenizedWalletInfoModel.getMsbDisclaimerLink();
            this.brandName = tokenizedWalletInfoModel.brandName();
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.formatCurrency;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletMsbOfferModel;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-tokenization-info/msbOffer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-tokenization-info/msbOffer/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"tokenizedMsbOffer\" content>\n    <xo-modal show=showModal show-close-button=\"true\" on-close=\"actions.closeModal\">\n        <div class=\"modal-interior\">\n            <div class=\"gift-icon-wrap\">\n                 <span class=\"icon icon-gift\"></span>\n            </div>\n            <p class=\"content\" ng-bind-html=\"content('msb.popupContent', { amount: amount, type: brandName })\"></p>\n            <input type=\"button\" class=\"confirmation btn\" value=\"{{content('msb.popupBtn')}}\" ng-click=\"actions.closeModal()\">\n            <div>\n                <a class=\"termsLink\" target=\"_blank\" href=\"{{ termsLink }}\">{{content('msb.popupLink')}}</a>\n            </div>\n        </div>\n    </xo-modal>\n</div>\n"

/***/ }),

/***/ "./pages/xo-tokenization-info/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTokenizationInfoPageRoute = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-tokenization-info/directive.js");

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTokenizationInfoPageRoute = exports.$xoTokenizationInfoPageRoute = _index.$Route.extend('$xoTokenizationInfoPageRoute', {
    path: 'tokenizationInfo',
    directive: _directive2['default'],
    titleContent: 'Tokenization Info Page',
    trackingData: {
        fptiState: 'tokenizationInfo'
    },

    children: []
});

angular.value("$xoTokenizationInfoPageRoute", $xoTokenizationInfoPageRoute);
_index.$Route;

/***/ }),

/***/ "./pages/xo-tokenization-info/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-tokenization-info/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"tokenizationInfo\" modal-box content>\n    <div class=\"infoPage\" ng-if=\"!noBank\">\n        <span>\n            {{ content('creditcard.hi', {userName: userName}) }}\n            <span ng-if=\"showNotYou\">\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.logout()\">{{ content('memberReview.notYou')}}</a>\n            </span>\n        </span>\n        <div class=\"info_content\">\n            <div class=\"heading\">{{ tokenizationContent.heading }}</div>\n            <div class=\"content_wrapper\">\n                <div class=\"segment\">\n                    <div ng-class=\"{glyph_a: !directFundingEnabled, glyph_contactless: directFundingEnabled}\" class=\"glyph\"></div>\n                    <div class=\"text\" ng-bind-html=\"tokenizationContent.info1\"></div>\n                </div>\n                <div class=\"segment\" ng-if=\"!balanceUsageEnabled\">\n                    <div ng-class=\"{glyph_b: topupEnabled, glyph_bank: directFundingEnabled}\" class=\"glyph\"></div>\n                    <div class=\"text\" ng-bind-html=\"tokenizationContent.info2\"></div>\n                </div>\n                <div class=\"segment\">\n                    <div class=\"glyph glyph_c\"></div>\n                    <div class=\"text\" ng-bind-html=\"tokenizationContent.infoMayNeedPin\"></div>\n                </div>\n            </div>\n        </div>\n\n        <input ng-click=\"actions.continue()\" type=\"button\" value=\"{{content('common.next')}}\"\n            class=\"btn full continueButton\">\n    </div>\n    <div id=\"noBankInfo\" ng-if=\"noBank\">\n        <div class=\"noBankErrorMessage\">\n            <xo-message message=\"noBankErrorMessage\"></xo-message>\n        </div>\n        <div class=\"infoPage\">\n            <div class=\"info_content\">\n                <div class=\"no_bank_heading\" ng-bind-html=\"content('tokenization.noBankHeader1')\"></div>\n                <div class=\"content_wrapper\">\n                    <ol>\n                        <li>\n                            <span ng-bind-html=\"content('tokenization.noBankInfo1')\"></span>\n                        </li>\n                        <li>\n                            <span ng-bind-html=\"content('tokenization.noBankInfo2')\"></span>\n                        </li>\n                        <li>\n                            <span ng-bind-html=\"content('tokenization.noBankInfo3', {type: brandName})\"></span>\n                        </li>\n                    </ol>\n                </div>\n            </div>\n            <a href=\"/myaccount/money\" class=\"btn full continueButton\">{{content('tokenization.noBankBtnInfo')}}</a>\n            <div class=\"cancel_back\">\n                <a ng-click=\"actions.redirectToCancelUrl()\"\n                    ng-bind-html=\"content('tokenization.noBankRtnLink', {type: brandName})\"></a>\n            </div>\n        </div>\n    </div>\n    <msb-offer ng-if=\"showMsbOffer\"></msb-offer>\n</section>"

/***/ }),

/***/ "./pages/xo-travel-rule/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("./pages/xo-travel-rule/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-form-components/src/travel-rule/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTravelRulePageComponent', {

    tag: 'xo-travel-rule-page',

    template: _template2['default'],

    lifecycle: {
        enter: function enter() {
            this.token = _angular.$rootScope.token;
            this.locale = _squid.$locale;

            this.finish = function () {
                _uiRouter.$state.go('checkout.review');
            };
        }
    }

});


_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-travel-rule/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$TravelRuleRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-travel-rule/directive.js");

var $TravelRuleRoute = exports.$TravelRuleRoute = _squid.$ComponentRoute.extend('$TravelRuleRoute', {
    path: 'travelRule',
    directive: 'xo-travel-rule-page',
    titleContent: 'travelRule.travelRule',
    trackingData: {
        templateName: 'travelRule.dust',
        pageGoal: 'collect payer ssn and/or taxId',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-travel-rule',
                'pagename2': '%::fullpage-travel-rule:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    loginRequired: true,
    children: []
});

angular.value("$TravelRuleRoute", $TravelRuleRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-travel-rule/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"travelRule\" id=\"travelRule\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-travel-rule token=\"token\" finish=\"finish\"></xo-travel-rule>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-update-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoUpdateCardPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js");

var _template = __webpack_require__("./pages/xo-update-card/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoUpdateCardPageComponent = exports.$xoUpdateCardPageComponent = _squid.$Component.extend('$xoUpdateCardPageComponent', {

    tag: 'xo-update-card-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {
        // eslint-disable-line no-shadow
        $scope.callbacks = {
            finish: function finish() {
                _uiRouter.$state.go('checkout.review');
            }
        };
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;

        var models = {};

        function setErrorMessage(contentKey, msgType) {
            $scope.message = {
                msgs: [(0, _squid.$renderContent)(contentKey)],
                type: msgType
            };
        }

        (0, _squid.$populate)(models, {
            checkoutSession: _index.$CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
            checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token).retrieve()
        }).then(function () {

            if (models.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD') {
                setErrorMessage('creditcard.errorUnconfirmedCard');
            } else if (_squid.$locale.country === 'IN' && models.checkoutCart.isBilling() && models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN') {
                setErrorMessage('creditcard.errorBAExpiredCard', _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
                if (models.checkoutCart.isChargePatternImmediateOrDeferred()) {
                    setErrorMessage('creditcard.immediate.errorBAExpiredCard', _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
                } else {
                    setErrorMessage('creditcard.not.immediate.errorBAExpiredCard', _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
                }
            } else {
                setErrorMessage('creditcard.errorExpiredCard', _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
            }
        });
    }]
});
angular.value("$xoUpdateCardPageComponent", $xoUpdateCardPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_uiRouter.$state;

_uiRouter.$stateParams;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "./pages/xo-update-card/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UpdateCardPageRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js");

__webpack_require__("./pages/xo-update-card/directive.js");

var $UpdateCardPageRoute = exports.$UpdateCardPageRoute = _squid.$ComponentRoute.extend('$UpdateCardPageRoute', {
    path: 'updateCard',
    directive: 'xo-update-card-page',
    titleContent: 'asideHeader.update',
    query: ['message'],
    trackingData: {
        templateName: 'tray/editCard.dust',
        pageGoal: 'Update Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-edit-cc',
                'pagename2': '%::fullpage-edit-cc:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            pagetitle: 'pagetitle',
            isUpdateFlow: 'isUpdateFlow',
            cardmodel: 'cardmodel',
            'parent-callbacks': 'callbacks'

        }
    }]
});

angular.value("$UpdateCardPageRoute", $UpdateCardPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-update-card/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addCard updateCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "./pages/xo-venmo/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.COOKIE_AGE = exports.COOKIE_NAME = exports.AUTH_LINK_HATEOS = exports.VENMO_VERSION = exports.TOKEN_PARAM_NAME = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _template = __webpack_require__("./pages/xo-venmo/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TOKEN_PARAM_NAME = exports.TOKEN_PARAM_NAME = 'payload_id';
var VENMO_VERSION = exports.VENMO_VERSION = 'venmo-version';
var AUTH_LINK_HATEOS = exports.AUTH_LINK_HATEOS = 'ot_cookie_link';
var COOKIE_NAME = exports.COOKIE_NAME = 'pwv';
var COOKIE_AGE = exports.COOKIE_AGE = 365 * 4 * 24 * 60 * 60 * 1000;

exports['default'] = _squid.$Component.extend('$VenmoPayloadBootstrap', {
    tag: 'venmo-payload-bootstrap',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: true
        }
    },

    resolve: {
        venmoParams: function venmoParams() {
            var _ref;

            return _ref = {}, _ref[TOKEN_PARAM_NAME] = _uiRouter.$stateParams[TOKEN_PARAM_NAME], _ref[AUTH_LINK_HATEOS] = _uiRouter.$stateParams[AUTH_LINK_HATEOS], _ref;
        },
        venmoAppVersion: function venmoAppVersion() {
            var _ref2;

            return _ref2 = {}, _ref2[VENMO_VERSION] = _uiRouter.$stateParams[VENMO_VERSION], _ref2;
        },
        checkoutCart: function checkoutCart() {
            return _checkout.$CheckoutCartModel.instance(this.token).retrieve();
        },
        checkoutPayee: function checkoutPayee() {
            return _checkout.$CheckoutPayeeModel.instance(this.token).retrieve();
        },
        appData: function appData() {
            return _checkout.$CheckoutAppDataModel.instance(this.token).retrieve();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            _logger.$logger.info(['xo-venmo directive', 'lifecycle', 'enter'].join('::'));

            this.done = function (shippingAddress) {

                // usecase 1: the billing address of the venmo user existed
                // usecase 2: the checkbox was displayed on the shipping address form and the venmo user checked it
                // usecase 3: the checkbox was displayed on the shipping address form and the venmo user did not check it -> go to billing page

                if (!_this.renderBillingAddCheckbox) {
                    // usecase 1
                    _this.goto('checkout.review');
                } else if (shippingAddress) {
                    // usecase 2

                    // Transform shipping address into billing address : format
                    var add = {
                        newAddress: {
                            address1: shippingAddress.line1,
                            address2: shippingAddress.line2,
                            city: shippingAddress.city,
                            state: shippingAddress.state,
                            zip: shippingAddress.postal_code,
                            isoCountry: shippingAddress.country
                        }
                    };
                    var billingAddress = new _index.$AddBillingAddressModel({ instrumentid: _this.instrumentID });
                    var self = _this;
                    billingAddress.save({
                        data: add,
                        success: function success() {
                            _logger.$logger.info(['xo-venmo directive', 'Billing Address', 'added'].join('::'));

                            // Fix to mitigate the symphony issue with POSTAL CODE MISSING
                            // Need to have a better solution
                            _logger.$logger.info(['xo-venmo directive', 'Calling checkout session again'].join('::'));

                            var sessionModel = _checkout.$CheckoutSessionModel.instance(self.token);
                            var cartModel = _checkout.$CheckoutCartModel.instance(self.token);
                            var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(self.token);

                            sessionModel.action('create', {
                                data: {
                                    fraudnet_id: cartModel.supplementary && cartModel.supplementary.risk_correlation_id,
                                    baToken: cartModel.billing && cartModel.billing.ba_token,
                                    user_selected_funding_source: {
                                        dcvv: venmoOnboardModel.dcvv,
                                        product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                                    },
                                    is_skip_gfo: true
                                },
                                success: function success() {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        },
                        error: function error(err) {
                            _logger.$logger.error('billingAddressSaveError', err);
                            _uiRouter.$state.go('checkout.login', { venmoError: true });
                        },
                        validation: function validation(_validation) {
                            _logger.$logger.error('billingAddressValidationError', _validation);
                            _uiRouter.$state.go('checkout.login', { venmoError: true });
                        }
                    });
                } else {
                    // usecase 3
                    _this.goto('checkout.venmo.addBilling');
                }
            };
        },
        populate: function populate() {
            var _this2 = this;

            (0, _jquery2['default'])('#preloaderSpinner').show();
            var venmoParams = this.venmoParams,
                venmoAppVersion = this.venmoAppVersion,
                checkoutCart = this.checkoutCart,
                checkoutPayee = this.checkoutPayee,
                appData = this.appData;

            // Placeholder to update the value of the venmo cookie with the incoming app version

            this.updateVenmoCookie = function () {
                var appVersion = venmoAppVersion[VENMO_VERSION];
                if (appVersion) {
                    var expires = ';expires=' + new Date(Date.now() + COOKIE_AGE);
                    window.document.cookie = COOKIE_NAME + '=' + appVersion + expires + ';domain=.' + _squid.$meta.domain + ';path=/';
                    _logger.$logger.info('pwv_cookie_updated', appVersion);
                }
            };
            this.updateVenmoCookie();

            var checkoutSessionModel = _checkout.$CheckoutSessionModel.instance(this.token);
            var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(this.token);
            var venmoDcvv = void 0;

            var totalTransaction = checkoutCart && checkoutCart.purchase && checkoutCart.purchase.amounts && checkoutCart.purchase.amounts.total;

            var onboardRequest = {
                payload_id: venmoParams.payload_id,
                limit: {
                    currency: totalTransaction && totalTransaction.currency_code,
                    amount: totalTransaction && totalTransaction.amount
                },
                intent: checkoutCart.payment_action,
                merchant_id: checkoutPayee.merchant.id,
                baToken: checkoutCart.billing && checkoutCart.billing.ba_token
            };

            var facilitatorAccessToken = _squid.$util.param('facilitatorAccessToken');

            if (facilitatorAccessToken) {
                onboardRequest.facilitatorAccessToken = facilitatorAccessToken;
            }

            // define steps
            var onboardMember = function onboardMember() {
                return venmoOnboardModel.save({
                    data: onboardRequest,
                    success: function success(data) {
                        _logger.$logger.info(data);
                        venmoDcvv = data.dcvv;
                        _this2.instrumentID = data.instrument_id;
                        return data;
                    },
                    error: function error(err) {

                        failureHandling('hermesnodeweb', err && err.stack || err);
                    },
                    validation: function validation(_validation2) {
                        return _uiRouter.$state.go('checkout.login', { venmoError: true });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            failureHandling('hermesnodeweb', contingency && contingency.message);
                        }
                    }
                });
            };

            var setVenmoToken = function setVenmoToken() {
                return _thirdPartyInfo.thirdPartyExperience.setAsVenmoExperience(_this2.token);
            };

            var self = this;
            var createCheckoutSession = function createCheckoutSession() {
                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token,
                        user_selected_funding_source: {
                            dcvv: venmoDcvv,
                            product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                        },
                        is_skip_gfo: true
                    },
                    success: function success(result) {
                        return result;
                    },
                    contingencies: {
                        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS(msg, contingency) {

                            // In the case the merchant only ships to local country
                            _logger.$logger.info('venmo_shipping_contingency');

                            // If the user hasn't entered a billing address, we'll also take it into consideration.
                            return _index.$BillingAddressesModel.instance().retrieve().then(function (billingAddresses) {

                                self.renderBillingAddCheckbox = !(billingAddresses && billingAddresses.addresses && billingAddresses.addresses['0']);

                                _uiRouter.$state.go('checkout.venmo.addShipping');
                            });
                        },
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('venmo_unhandled_symphony_contingency', msg);
                            failureHandling('paymentapiplatserv', contingency && contingency.message);
                        }
                    }
                });
            };
            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();
                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var routeDecision = function routeDecision(checkoutSession) {

                if (checkoutSession) {

                    _index.$BillingAddressesModel.instance().retrieve().then(function (billingAddresses) {

                        // if the billing address model retrieves an existing address, the addresses array will have a property '0'
                        _this2.renderBillingAddCheckbox = !(billingAddresses && billingAddresses.addresses && billingAddresses.addresses['0']);

                        if (appData && appData.flags && appData.flags.shipping_address_required && !checkoutSession.shipping) {
                            // if shipping is required and no shipping is sent in xo session, we route to shipping address page
                            return _uiRouter.$state.go('checkout.venmo.addShipping');
                        } else if (_this2.renderBillingAddCheckbox) {
                            // shipping address exists, go to billing page
                            return _uiRouter.$state.go('checkout.venmo.addBilling');
                        } else {
                            // else, we go to review page

                            return _uiRouter.$state.go('checkout.review');
                        }
                    });
                } else {
                    _logger.$logger.info('venmo_empty_checkoutSession');
                }
            };

            var failureHandling = function failureHandling(source, err) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'VENMO_ENTRYPOINT',
                    to: 'process_venmo_entrypoint',
                    'int_error_description': 'venmo_onboard_failure',
                    'error_type': 'soft_decline',
                    'error_source': source
                });

                _logger.$logger.error('venmoOnboardingError', err);

                // go back to login with an error param to show the buyer oupon landing
                _uiRouter.$state.go('checkout.login', { venmoError: true });
            };

            onboardMember().then(setVenmoToken).then(refreshAuthState).then(onAuth).then(createCheckoutSession).then(routeDecision)['catch'](function (err) {
                venmoOnboardModel.invalidate();
                if (err instanceof _squid.$Forbidden) {// ignore forbidden errors

                } else {
                    failureHandling('hermesnodeweb', err && err.stack || err);
                }
            });
        },
        exit: function exit() {
            (0, _jquery2['default'])('#preloaderSpinner').hide();
        }
    }
});


_squid.$Component;

_squid.$locale;

_squid.$Forbidden;

_squid.$util;

_squid.$meta;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_index.$AddBillingAddressModel;

_index.$BillingAddressesModel;

_auth.$AuthModel;

_venmoModels.$VenmoOnboardModel;

_thirdPartyInfo.thirdPartyExperience;

_uiRouter.$stateParams;

_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-venmo/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$VenmoRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-venmo/directive.js");

var _directive2 = _interopRequireDefault(_directive);

var _route = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-billing/route.js");

var _route2 = _interopRequireDefault(_route);

__webpack_require__("../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $VenmoRoute = exports.$VenmoRoute = _squid.$Route.extend('$VenmoRoute', {
    path: 'venmo',
    directive: _directive2['default'],

    auth: false,
    query: [_directive.TOKEN_PARAM_NAME, _directive.VENMO_VERSION, _directive.AUTH_LINK_HATEOS],

    trackingData: {
        fptiState: 'venmo_entrypoint',
        trackStateExit: true
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token',
            'done-fn': 'done',
            sidebar: 'sidebar',
            'render-billing-add-checkbox': 'renderBillingAddCheckbox'
        }
    }, {
        route: _route2['default'],
        attributes: {
            token: 'token',
            sidebar: 'sidebar'
        }
    }]
});

angular.value("$VenmoRoute", $VenmoRoute);
_squid.$Route;

_directive.TOKEN_PARAM_NAME;

_directive.VENMO_VERSION;

_directive.AUTH_LINK_HATEOS;

/***/ }),

/***/ "./pages/xo-venmo/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addShipping\" id=\"addShipping\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ }),

/***/ "./pages/xo-venmoAuth/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.NEXT_STATE = exports.AUTH_LINK_HATEOS = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("./pages/xo-venmoAuth/template.html");

var _template2 = _interopRequireDefault(_template);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTH_LINK_HATEOS = exports.AUTH_LINK_HATEOS = 'ot_cookie_link';
var NEXT_STATE = exports.NEXT_STATE = 'nextState';

exports['default'] = _squid.$Component.extend('$VenmoAuthEntrypoint', {
    tag: 'venmo-auth-entrypoint',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: true
        }
    },

    resolve: {
        venmoParams: function venmoParams() {
            var _ref;

            return _ref = {}, _ref[AUTH_LINK_HATEOS] = _uiRouter.$stateParams[AUTH_LINK_HATEOS], _ref[NEXT_STATE] = _uiRouter.$stateParams[NEXT_STATE], _ref;
        },
        checkoutCart: function checkoutCart() {
            return _checkout.$CheckoutCartModel.instance(this.token).retrieve();
        },
        checkoutPayee: function checkoutPayee() {
            return _checkout.$CheckoutPayeeModel.instance(this.token).retrieve();
        },
        appData: function appData() {
            return _checkout.$CheckoutAppDataModel.instance(this.token).retrieve();
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var checkoutCart = this.checkoutCart,
                checkoutPayee = this.checkoutPayee;


            var venmoDcvv = void 0;

            var venmoUserModel = _venmoModels.$VenmoUserModel.instance(this.token);
            var checkoutSessionModel = _checkout.$CheckoutSessionModel.instance(this.token);

            var setVenmoToken = function setVenmoToken() {
                return _thirdPartyInfo.thirdPartyExperience.setAsVenmoExperience(_this.token);
            };

            var createCheckoutSession = function createCheckoutSession() {
                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token,
                        user_selected_funding_source: {
                            dcvv: venmoDcvv,
                            product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                        },
                        is_skip_gfo: true
                    },
                    success: function success(result) {
                        return result;
                    },
                    contingencies: {
                        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS(msg, contingency) {

                            // In the case the merchant only ships to local country
                            _logger.$logger.info('venmo_shipping_contingency');

                            // If the user hasn't entered a billing address, we'll also take it into consideration.
                            return _index.$BillingAddressesModel.instance().retrieve().then(function (billingAddresses) {

                                self.renderBillingAddCheckbox = !(billingAddresses && billingAddresses.addresses && billingAddresses.addresses['0']);

                                _uiRouter.$state.go('checkout.venmoAuth.infoGather');
                            });
                        },
                        PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED(msg, contingency) {
                            _angular.$rootScope.$broadcast('$insufficientPermissionVenmoOT', {
                                oldState: 'checkout.venmoAuth',
                                newState: 'checkout.venmoAuth'
                            });
                        },
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('venmo_unhandled_symphony_contingency', msg);
                        }
                    }
                });
            };

            var refreshAuthState = function refreshAuthState() {
                var authModel = _auth.$AuthModel.instance();
                _squid.$locale.choose(authModel.country, authModel.language, false);

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
                return authModel;
            };

            return venmoUserModel.save({
                data: {
                    intent: checkoutCart.payment_action,
                    merchant_id: checkoutPayee.merchant.id
                },
                success: function success(data) {
                    venmoDcvv = data.dcvv;

                    return createCheckoutSession().then(function (session) {
                        // setting Venmo Experience flag
                        setVenmoToken();
                        refreshAuthState();

                        // if session is populated, we proceed to RYI
                        if (session) {
                            return _uiRouter.$state.go('checkout.review');
                        }

                        // else we'll go back log buyer out and go to Drawer selection
                        return _auth.$AuthModel.instance().logout().then(function () {
                            return _uiRouter.$state.go('checkout.payWithSelection');
                        });
                    });
                },
                contingencies: {
                    SHIPPING_AND_BILLING_REQUIRED: function SHIPPING_AND_BILLING_REQUIRED(msg, contingency) {

                        setVenmoToken();
                        refreshAuthState();
                        _uiRouter.$state.go('checkout.venmoAuth.infoGather');
                    }
                }
            });
        }
    }
});


_squid.$Component;

_squid.$locale;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_auth.$AuthModel;

_index.$BillingAddressesModel;

_venmoModels.$VenmoUserModel;

_thirdPartyInfo.thirdPartyExperience;

_uiRouter.$stateParams;

_uiRouter.$state;

_angular.$rootScope;

/***/ }),

/***/ "./pages/xo-venmoAuth/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$VenmoAuthRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _directive = __webpack_require__("./pages/xo-venmoAuth/directive.js");

var _directive2 = _interopRequireDefault(_directive);

var _route = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-info-gather/route.js");

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $VenmoAuthRoute = exports.$VenmoAuthRoute = _squid.$Route.extend('$VenmoAuthRoute', {
    path: 'venmoAuth',
    directive: _directive2['default'],

    auth: false,
    query: [_directive.AUTH_LINK_HATEOS, _directive.NEXT_STATE],

    trackingData: {
        fptiState: 'venmo_remembered_entrypoint',
        trackStateExit: true
    },
    children: [{
        route: _route2['default'],
        attributes: {
            token: 'token',
            sidebar: 'sidebar'
        }
    }]
});

angular.value("$VenmoAuthRoute", $VenmoAuthRoute);
_squid.$Route;

_directive.AUTH_LINK_HATEOS;

_directive.NEXT_STATE;

/***/ }),

/***/ "./pages/xo-venmoAuth/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"venmoAuth\" id=\"venmoAuth\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ }),

/***/ "./pages/xo-wallet/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/directive.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _factory = __webpack_require__("../node_modules/xo-ui-components/src/expired-fi-panel/factory.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _template = __webpack_require__("./pages/xo-wallet/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-wallet/styles.less");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-wallet',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        promotion: {
            type: 'var',
            required: false
        },
        installment: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                choiceVariant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop)
            };
        },
        disallowedInstruments: function disallowedInstruments(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    expired: _factory.$ExpiredFiPanelFactory.getAllInstruments(models)
                };
            });
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        },
        ppBalanceRebrandedExperiment: function ppBalanceRebrandedExperiment() {
            return {
                enabled: _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale)
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.isDE = _squid.$locale.country === 'DE';
        },
        populate: function populate() {
            var _this = this;

            var $scope = this;

            $scope.locale = _squid.$locale;
            $scope.showDisallowedMessage = false;

            $scope.creditSharedInfoModel = _index2.$CreditSharedInfoModel.instance();

            $scope.toggleDisallowedMessage = function () {
                $scope.showDisallowedMessage = !$scope.showDisallowedMessage;
            };

            $scope.doneFn = function () {
                if ($scope.checkoutSession.plan.paypal_credit && $scope.creditSharedInfoModel.hasInstallmentOffers()) {
                    if ($scope.creditSharedInfoModel.getRedirectToCapeCyco()) {
                        _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                    } else {
                        _uiRouter.$state.go('checkout.chooseCreditOffer');
                    }
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            };

            $scope.showDualFi = (0, _squid.$feature)('addBank');
            $scope.padToggleFeature = _uiRouter.$stateParams.padToggleFeature;
            $scope.memberSegment = _marketingoffer.$MemberSegmentModel.instance();

            $scope.isPadToggleFeatureApplicable = function () {
                var applicable = false;

                if ($scope.padToggleFeature && $scope.padToggleFeature.applicable && $scope.padToggleFeatureSupported && $scope.padToggleFeature) {
                    applicable = true;
                }

                return applicable;
            };

            var initializePadToggleFeature = function initializePadToggleFeature() {
                if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    return Experiments.padToggleFeatureSupported().then(function (result) {
                        $scope.padToggleFeatureSupported = result;
                    });
                }

                return _squid.$promise.resolve();
            };

            $scope.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.get('merchant.merchant_country') === 'US';
                var isGambling = $scope.payee && $scope.payee.isGambling();

                return isGambling && isUSBuyer && isUSmerchant;
            };

            (0, _squid.$populate)($scope, {
                auth: _index4.$AuthModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                checkoutCart: _index.$CheckoutCartModel.create($scope.token),
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                payee: _index.$CheckoutPayeeModel.instance($scope.token)
            }).then(function () {
                _squid.$promise.all([_newMember.$NewMemberEligibility.instance().isNmj($scope.token), initializePadToggleFeature()]).then(function (_ref) {
                    var newMemberResult = _ref[0];


                    var padToggleApplicable = $scope.checkoutSession.fundingOptions.isPadToggleApplicable();

                    if (padToggleApplicable && $scope.padToggleFeatureSupported && $scope.padToggleFeature === null) {

                        $scope.padToggleFeature = {
                            applicable: padToggleApplicable
                        };
                    }

                    $scope.isCurrentPlanPad = $scope.checkoutSession.plan.isPAD();
                });
            }).then(function () {
                $scope.isCreditDisallowedForMerchant = $scope.checkoutSession && $scope.checkoutSession.isCreditDisallowedForMerchant;
                $scope.creditDisallowedMessage = {
                    type: 'info',
                    msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
                };
                $scope.isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
                $scope.isBilling = $scope.checkoutCart.isBilling();
                $scope.isReferenceCheckout = $scope.checkoutCart.referenceCheckout ? true : false;
                var merchant = $scope.checkoutAppData.merchant;
                $scope.merchantName = merchant.brand_name || merchant.merchant_name || 'Merchant';

                var disallowedList = $scope.checkoutSession.get('fundingOptions.disallowedInstruments');
                if (disallowedList) {
                    $scope.disallowedInstruments = $scope.disallowedInstruments.expired.length && $scope.disallowedInstruments.expired.filter(function (i) {
                        return disallowedList.includes(i);
                    });
                }

                if (!$scope.isBillingNoPurchase && $scope.disallowedInstruments && $scope.disallowedInstruments.length > 0) {
                    $scope.displayPosition = true;
                }
                if ((0, _squid.$feature)('giftCard')) {
                    $scope.showGC = Math.random() < 0.01 && !$scope.isBillingNoPurchase;

                    if ($scope.showGC) {
                        _logger.$logger.info('wallet_gift_card_redeem_link_shown');
                    } else {
                        _logger.$logger.info('wallet_gift_card_redeem_link_not_shown');
                    }
                }

                // Manage wallet feature can be turned on by country.
                // User will see manage link on wallet page if feature is turned on and has FIs allowed to edit.
                if ((0, _squid.$feature)('enableManageWallet')) {
                    var instruments = $scope.checkoutSession.get('fundingOptions.instruments');
                    var managebleFIs = _squid.$util.filter(instruments, function (funding) {
                        if (funding && !funding.editDisallowedMsg) {
                            return funding;
                        }
                    });

                    $scope.showManageLink = managebleFIs && managebleFIs.length > 0;
                }

                if (_this.models.checkoutSession.message && !_this.models.checkoutSession.message.keepMsg) {
                    _this.models.checkoutSession.message = null;
                }

                $scope.showAddLink = _squid.$locale.country !== 'DE';

                $scope.onRedeemGC = function () {
                    throw new _squid.$FallbackError({
                        reason: 'redeem_coupon_feature_not_supported',
                        product: 'ux',
                        entryPoint: 'giftCard'
                    });
                };

                $scope.cardModel = new _index3.$AddCardModel({
                    card: new _index3.$CardModel()
                });

                $scope.userSelectedFI = $scope.checkoutSession.getSelectedStickyInstrument() && $scope.checkoutSession.getSelectedStickyInstrument().instrument_id;

                $scope.updateStickyFS = function (stickyFI) {
                    if (stickyFI.instrument_id !== $scope.userSelectedFI) {
                        $scope.checkoutSession.action('setStickyFI', {
                            data: {
                                instrument_id: stickyFI.instrument_id
                            },
                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
                                };
                                $scope.doneFn(result);
                            }
                        });
                    } else {
                        _uiRouter.$state.go('checkout.review');
                    }
                };

                var _fiSource = _this.fiSource,
                    isCardArtExp = _fiSource.isCardArtExp,
                    isBillingNoPurchase = _fiSource.isBillingNoPurchase;

                var isUSCrossCurrency = function isUSCrossCurrency() {
                    if ($scope.checkoutCart && $scope.checkoutCart.grossTotalAmount && $scope.checkoutCart.get('grossTotalAmount.currency') !== 'USD' && _squid.$locale.country === 'US') {
                        return true;
                    }
                    return false;
                };
                // initial fundingOptions
                var getFundingOptions = function getFundingOptions() {
                    var plans = $scope.checkoutSession.getPlanList();
                    if (isUSCrossCurrency()) {
                        return plans.filter(function (plan) {
                            return plan.primaryFs.name !== 'BILL_ME_LATER';
                        });
                    }
                    return plans;
                };
                var masterPlanList = getFundingOptions();
                var serializedPlans = {}; // index of all plans by primary and balance currency code(s)
                var balanceCodes = {}; // index of cataloged currency codes
                var primaryList = []; // list of plans with unique primaryFs ids
                var balanceList = $scope.balanceList = []; // list of unique balance currencies
                // determine if the selectFi variant is active
                var isSelectFiVariant = $scope.isSelectFiVariant = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi && $scope.models && $scope.models.choiceVariant && _squid.$config.choiceExperiment.selectFi.indexOf($scope.models.choiceVariant) !== -1;

                // Log our cardart FIs instrumentation if we're currently in the cardart experience
                if (isCardArtExp) {
                    _logger.$logger.info('checkout_fpti', _extends({
                        from: 'WALLET',
                        to: 'prepare_wallet'
                    }, _cardartInstrument.$CardArtInstrument.createPayload({
                        isBillingNoPurchase: isBillingNoPurchase,
                        checkoutSession: $scope.checkoutSession
                    })));
                }

                // TODO(refactor): $MultiFiPlanFactory.getSerializedPrimary()
                var getSerializedPrimary = function getSerializedPrimary(primary) {
                    var serial = primary.id + primary.amount.currency_code.toLowerCase();

                    // if there's a subtype...
                    if (primary.subtype) {
                        serial += primary.subtype;
                    }
                    return serial;
                };

                // return a serialized key for the plan
                // plan - a plan object from checkoutSession.fundingOptions.plans
                // balances - array of currency code strings
                // TODO (refactor): $MultiFiPlanFactory.getSerializedPlanId()
                var getSerializedPlanId = function getSerializedPlanId(plan, balances) {
                    var pid = getSerializedPrimary(plan.primaryFs);

                    // if no balances array...
                    if (!balances) {
                        // just return the pid
                        return pid;
                    }

                    // (otherwise) sort balances
                    balances.sort();

                    return pid + balances.join();
                };

                if (masterPlanList) {
                    var initiallyActiveBalances = [];
                    // TODO(refactor): $MultiFiPlanFactory.getShowBalanceCurrenciesStatus()
                    var showBalanceCurrencies = $scope.checkoutSession.isMultipleBalancePlan();

                    // if selectFi variant...
                    if (isSelectFiVariant) {

                        // if not multiple balance plans...
                        if (!showBalanceCurrencies) {
                            // start with first plan's currency
                            var knownCurrency = masterPlanList[0].primaryFs.amount.currency_code;

                            // update flag if any plan has more than two secondaries or one with a different currency
                            showBalanceCurrencies = masterPlanList.some(function (plan) {
                                // show currencies, when this plan has a different one, or...
                                return plan.primaryFs.amount.currency_code !== knownCurrency ||
                                // this plan has secondaries, where...
                                plan.secondaryFIs && (
                                // there's more than one
                                plan.secondaryFIs.length > 1 ||
                                // the one has a different currency
                                plan.secondaryFIs[0].amount.currency_code !== knownCurrency);
                            });
                        }

                        // index of captured primaryFs ids
                        var primaryFsIds = {};

                        // with each plan...
                        // TODO(refactor): use $MultiFiPlanFactory.getCompositeBalances() to get `balanceCodes`, `balanceList` and `balCurCodes`
                        masterPlanList.forEach(function (plan) {
                            var balances = plan.secondaryFIs || [];
                            var balCurCodes = [];

                            // if this is the active plan...
                            if ($scope.checkoutSession.plan.id === plan.planId) {
                                // capture it's balances - to be processed later
                                initiallyActiveBalances = balances;
                            }

                            // catalog balances
                            balances.forEach(function (balance) {
                                var code = balance.amount.currency_code;

                                // capture code (for serialization, next)
                                balCurCodes.push(code);
                                // if this code has not been cataloged...
                                if (!balanceCodes.hasOwnProperty(code)) {
                                    var balInfoAndState = {
                                        code: code,
                                        checked: false
                                    };

                                    if (showBalanceCurrencies) {
                                        balInfoAndState.amount = balance.amount.amount_formatted_currency;
                                    } else {
                                        balInfoAndState.amount = balance.amount.amount_formatted;
                                    }
                                    // flag that we've cataloged this code
                                    balanceCodes[code] = balInfoAndState;
                                    // capture balance details and initial ui state
                                    balanceList.push(balInfoAndState);
                                }
                            });

                            // if this is a primary split-balance plan...
                            if (plan.primaryFs.type === 'BALANCE') {
                                // add key to template
                                // NOTE: easier to build string here, than with template tags
                                plan.currencies = [plan.primaryFs.amount.currency_code].concat(balCurCodes).join(', ');
                            }

                            // catalog plan by serial and balances
                            serializedPlans[getSerializedPlanId(plan, balCurCodes)] = plan;

                            // get plan primary
                            var serialPrimary = getSerializedPrimary(plan.primaryFs);

                            // if haven't indexed the primary...
                            if (!primaryFsIds.hasOwnProperty(serialPrimary)) {
                                // note that we've cataloged this primary
                                primaryFsIds[serialPrimary] = 1;
                                // capture plan with unique primary
                                primaryList.push(plan);
                            }
                        });

                        // sort unique balances by currency code
                        balanceList.sort(function (balA, balB) {
                            // balance codes are never the same, so no need to return 0
                            return balA.code < balB.code ? -1 : 1;
                        });

                        // pre-check balances that match the active plan's balances (if any)
                        initiallyActiveBalances.forEach(function (balance) {
                            balanceCodes[balance.amount.currency_code].checked = true;
                        });
                    } else {
                        // (otherwise) use master as local and scoped list
                        primaryList = masterPlanList;
                    }

                    // expose to template
                    $scope.isMultipleBalance = showBalanceCurrencies;
                    // expose final list
                    $scope.primaryList = primaryList;
                }

                $scope.updateFS = function (index) {
                    // impacts when/how to notify user that balances were unusable
                    var unusableBalances = 0;
                    // impacts when/how to notify user that balances were required
                    var requiredBalances = 0;
                    // the plan to use
                    var fundingsource = void 0;

                    // flag when the plan has changed
                    var updateMessaging = function updateMessaging(planWasChanged) {
                        // if this is a primary balance plan...
                        if ($scope.checkoutSession.plan.sources[0].type === 'BALANCE') {
                            // suppress any info messages
                            unusableBalances = requiredBalances = 0;
                        }
                        if (unusableBalances) {
                            var messageKey = unusableBalances === 1 ? 'memberReview.ryi_noBal' : 'memberReview.ryi_noBal_plural';

                            if (_this.ppBalanceRebrandedExperiment.enabled) {
                                messageKey += '_Rebranded';
                            }
                            // show info message about failed balances
                            $scope.checkoutSession.message = {
                                type: 'info',
                                msgKeys: [messageKey]
                            };
                        } else if (requiredBalances) {
                            var _messageKey = requiredBalances === 1 ? 'memberReview.ryi_yesBal' : 'memberReview.ryi_yesBal_plural';

                            if (_this.ppBalanceRebrandedExperiment.enabled) {
                                _messageKey += '_Rebranded';
                            }
                            // show info message about added balances
                            $scope.checkoutSession.message = {
                                type: 'info',
                                msgKeys: [_messageKey]
                            };
                        } else if (planWasChanged) {
                            // show that their selection went fine
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                        }
                    };

                    if (isSelectFiVariant) {
                        // get plan with serial, built from user selections
                        var checkedBalances = [];

                        // capture checked balance codes
                        _squid.$util.forEach(balanceCodes, function (balInfoAndState, code) {
                            if (balInfoAndState.checked) {
                                // capture balance object
                                // this is what getSerializedPlanId expects - ugh
                                checkedBalances.push(code);
                            }
                        });
                        var plan = primaryList[index];
                        var pid = void 0;
                        var pidForLogger = void 0;

                        // use plan with this primaryFs and balance options - if any
                        fundingsource = serializedPlans[getSerializedPlanId(plan, checkedBalances)];

                        // if no plan yet...
                        // (perhaps only one of the selected balances is applicable?)
                        if (!fundingsource) {
                            // resolve pid now
                            pid = getSerializedPrimary(plan.primaryFs);
                            pidForLogger = plan.primaryFs.id || plan.primaryFs.type;
                            // find a plan with each individual balance
                            checkedBalances.some(function (code) {
                                // match plan with this serial combination
                                fundingsource = serializedPlans[pid + code];
                                return fundingsource;
                            });
                            // flag that one of the checked balances was unusable
                            if (fundingsource) {
                                unusableBalances = 2;

                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if no plan yet...
                        // (perhaps the plan doesn't have any balance combination?)
                        if (!fundingsource) {
                            // get the plan with just this primaryFs
                            fundingsource = serializedPlans[pid];
                            // if we now have a plan...
                            if (fundingsource) {
                                // note how many desired balances we're ignoring (if any)
                                unusableBalances = checkedBalances.length;

                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if still no plan...
                        // (at this point, the plan requires a specific balance combination)
                        if (!fundingsource) {
                            var serializedPlanKeys = Object.keys(serializedPlans);

                            // use the first plan that begins with this primary
                            fundingsource = serializedPlans[serializedPlanKeys[_squid.$util.findIndex(serializedPlanKeys, function (serial) {
                                return serial.indexOf(pid) === 0;
                            })]];
                            // indicate that one or more balances were required for this plan
                            requiredBalances = balanceList.length;

                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                forced: balanceList.map(function (balance) {
                                    return balance.code;
                                }).join()
                            });
                        }
                    } else {
                        // (otherwise) when performing control logic...
                        // the first argument is the funding source
                        fundingsource = index;
                    }

                    // clear messaging - by default
                    $scope.checkoutSession.message = '';

                    if (fundingsource.infoMsg) {
                        $scope.disallowedIndex = index;
                        return;
                    }

                    // if the final plan hasn't changed...
                    if (fundingsource.planId === $scope.checkoutSession.plan.id) {
                        // tells user if any balances were not used or were required
                        updateMessaging();
                        // show message if balances were selected, but couldn't be used
                        $scope.doneFn();
                        return;
                    }

                    $scope.checkoutSession.fundingOptions.action('select', {
                        data: {
                            planId: fundingsource.planId
                        },
                        success: function success(result) {
                            $scope.checkoutSession.populate(result);

                            if (result) {
                                // Update the installments to support the user selecting a card that does not support installments.
                                $scope.checkoutSession.installments = result.installments;
                            }

                            if ($scope.checkoutSession.plan.paypal_credit && $scope.creditSharedInfoModel.hasInstallmentOffers()) {
                                if ($scope.creditSharedInfoModel.getRedirectToCapeCyco()) {
                                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                                } else {
                                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                                }
                            } else {
                                if (!fundingsource.selected) {
                                    // handle messaging around unusable balances (if any)
                                    // send flag that the plan was changed
                                    updateMessaging(true);

                                    if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
                                        // Resetting selected installment data, if installment change is not explicitly prohibited.
                                        $scope.checkoutSession.selectedInstallmentData = undefined;
                                    }
                                }

                                $scope.doneFn(result);
                            }
                        },
                        contingencies: {
                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                                if (result && result.resolution) {
                                    var card = result.resolution.data;

                                    if (card.fundingId && card.fi && card.fi.type) {
                                        $scope.cardModel.id = card.fundingId;
                                        $scope.cardModel.card = new _index3.$CardModel({
                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                            type: card.fi.type.toUpperCase(),
                                            productType: card.fi.productType
                                        });
                                    }
                                }

                                _uiRouter.$state.go('.confirmUpop');
                            }
                        }
                    });
                };

                $scope.shouldShowFSTile = function (fundingsource) {
                    var showFS = true;

                    if ($scope.isPadToggleFeatureApplicable()) {
                        // If PAD is not the current plan, then we will not show any PAD plan and show IACH plans.
                        // If PAD is the current plan, then we will visualize it as a bank plan and IACH plan without balance for corresponding bank will not be shown
                        if (!$scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'PAD') {
                            showFS = false;
                        } else if ($scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'PAD' && fundingsource.planId !== $scope.checkoutSession.plan.id) {
                            showFS = false;
                        } else if ($scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'IACH' && fundingsource.primaryFs.id === $scope.checkoutSession.plan.sources[0].instrument_id) {
                            showFS = false;
                        }
                    }

                    return showFS;
                };
            });

            // Check if is variant where preferred label can be shown
            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.choiceVariant) > -1;
        }
    }
});


_angular.noop;

_uiRouter.$state;

_uiRouter.$stateParams;

_squid.$Component;

_squid.$populate;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$util;

_squid.$config;

_squid.$promise;

_logger.$logger;

_choice.$ChoiceEligibility;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutPayeeModel;

_index2.$CreditSharedInfoModel;

_index3.$AddCardModel;

_index3.$CardModel;

_index4.$AuthModel;

_sharedUtil.$SharedUtil;

_marketingoffer.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_factory.$ExpiredFiPanelFactory;

_cardartInstrument.$CardArtInstrument;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-wallet/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SidebarWalletRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _route = __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js");

__webpack_require__("./pages/xo-wallet/directive.js");

var $SidebarWalletRoute = exports.$SidebarWalletRoute = _squid.$ComponentRoute.extend('$SidebarWalletRoute', {
    path: 'wallet',
    directive: 'xo-wallet',
    titleContent: 'asideHeader.wallet',
    trackingData: {
        fptiState: 'funding_option_selection',
        templateName: 'fundingInstruments.dust',
        pageGoal: 'Change Instruments',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-wallet-fundingsources',
                'pagename2': '%::fullpage-wallet-fundingsources:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    params: {
        padToggleFeature: null
    },
    children: [{
        route: _route.$xoConfirmUpopRoute,
        attributes: {
            token: 'token',
            phone: 'phone',
            cardmodel: 'cardModel'
        }
    }]
});

angular.value("$SidebarWalletRoute", $SidebarWalletRoute);
_squid.$ComponentRoute;

_route.$xoConfirmUpopRoute;

/***/ }),

/***/ "./pages/xo-wallet/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-wallet/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header ng-if=\"isUSGambling()\" hdrtype='tall' heading='asideHeader.fundingInstruments'\n                 sub-header-right-link='checkout.review.sidebar.sidebarManageWallet'\n                 sub-header-right=\"asideHeader.manage\"\n                 sub-header-right-icon=\"true\"\n                 show-dual-fi=\"showDualFi\"></xo-aside-header>\n<xo-aside-header ng-if=\"showManageLink && !isDE && !isUSGambling()\"\n                 hdrtype='tall'\n                 heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'\n                 sub-header-left=\"asideHeader.add\"\n                 sub-header-left-icon=\"true\"\n                 sub-header-right-link='checkout.review.sidebar.sidebarManageWallet'\n                 sub-header-right=\"asideHeader.manage\"\n                 sub-header-right-icon=\"true\"\n                 show-dual-fi=\"showDualFi\">\n</xo-aside-header>\n\n<xo-aside-header ng-if=\"!showManageLink && !isDE && !isUSGambling()\"\n                 hdrtype='tall'\n                 heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'\n                 sub-header-left=\"asideHeader.add\"\n                 sub-header-left-icon=\"true\"\n                 show-dual-fi=\"showDualFi\">\n</xo-aside-header>\n\n<xo-aside-header ng-if=\"!showManageLink && isDE\"\n                 hdrtype='tall'\n                 heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddNew.bank.add'\n                 sub-header-left=\"common.addNew\"\n                 sub-header-left-icon=\"true\"\n                 show-dual-fi=\"false\">\n</xo-aside-header>\n\n<xo-aside-header ng-if=\"showManageLink && isDE\"\n                 hdrtype='tall'\n                 heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddNew.bank.add'\n                 sub-header-left=\"common.addNew\"\n                 sub-header-left-icon=\"true\"\n                 show-dual-fi=\"false\"\n                 sub-header-right-link='checkout.review.sidebar.sidebarManageWallet'\n                 sub-header-right=\"asideHeader.manage\"\n                 sub-header-right-icon=\"true\">\n</xo-aside-header>\n\n<div class=\"asideContent fundingCards\" id=\"selectFunding\" content xo-tray-height>\n    <xo-message ng-if=\"isCreditDisallowedForMerchant\" message=\"creditDisallowedMessage\"></xo-message>\n    <xo-message message=\"checkoutSession.message\"></xo-message>\n    <div class=\"split_bal_option\" ng-if=\"balanceList.length\">\n        <div\n            class=\"sCheckbox checkbox\"\n            ng-repeat=\"balance in balanceList track by $index\">\n            <input\n                id=\"bal_{{balance.code}}\"\n                type=\"checkbox\"\n                ng-model=\"balance.checked\"\n                value=\"{{balance.code}}\">\n            <label\n                class=\"choice-split-balance\" for=\"bal_{{balance.code}}\"\n                bind-html-compile=\"htmlContent('memberReview.useBalanceLabel', { amt: balance.amount })\">\n            </label>\n        </div>\n    </div>\n    <div class=\"allCards\">\n        <ul\n            ng-class=\"{varSelectFi: isSelectFiVariant}\"\n            class=\"allPlanList clearfix\"\n            select-box=\"checkoutSession.fundingOptions.plans\"\n            select-allow-tab-escape>\n\n            <experience flag='cardart'>\n                <!--List of Plans : selectFi variant-->\n                <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList track by $index\" ng-if=\"isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                    <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS($index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                        <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                            <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                        </span>\n\n                        <div class=\"instrumentContainer\">\n                            <xo-fi-panel fi=\"plan.primaryFs\" plan=\"plan\"\n                                show-all-currency-codes=\"isSelectFiVariant && plan.primaryFs.type === 'BALANCE' && isMultipleBalance\"\n                                ignore-pad=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\"\n                                name-override=\"\n                                plan.primaryFs.type === 'BALANCE' &&\n                                ppBalanceRebrandedExperiment.enabled &&\n                                content('paymentMethod.paypalBalanceRebranded')\"\n                            >\n                                <div ng-if=\"!isBilling && !isReferenceCheckout && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\">\n                                    <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                </div>\n                                <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\"></p>\n                            </xo-fi-panel>\n                            <xo-expired-fi-panel token=\"token\" fi=\"plan\"></xo-expired-fi-panel>\n                        </div>\n                    </a>\n                </li>\n\n                <!--List of Plans : control-->\n                <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList track by $index\" ng-if=\"!isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                    <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS(plan, $index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                        <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                            <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                        </span>\n                        <div class=\"instrumentContainer\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length\">\n                            <xo-fi-panel fi=\"plan.secondaryFIs[0]\"\n                                show-amount=\"plan.secondaryFIs.length === 1\"\n                                name-override=\"\n                                plan.secondaryFIs[0].name === 'BALANCE' &&\n                                ppBalanceRebrandedExperiment.enabled &&\n                                content('paymentMethod.paypalBalanceRebranded')\"\n                            ></xo-fi-panel>\n                        </div>\n                        <div class=\"instrumentContainer\">\n                            <xo-fi-panel fi=\"plan.primaryFs\"\n                                show-amount=\"plan.secondaryFIs && plan.secondaryFIs.length === 1 && plan.primaryFs.amount && plan.primaryFs.type !== 'INCENTIVE'\"\n                                show-currency-code=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\"\n                                ignore-pad=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\"\n                                name-override=\"\n                                plan.primaryFs.name === 'BALANCE' &&\n                                ppBalanceRebrandedExperiment.enabled &&\n                                content('paymentMethod.paypalBalanceRebranded')\"\n                            >\n                                <div ng-if=\"!isBilling && !isReferenceCheckout && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\">\n                                    <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                </div>\n                                <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\"></p>\n                            </xo-fi-panel>\n                            <xo-expired-fi-panel token=\"token\" fi=\"plan\"></xo-expired-fi-panel>\n                        </div>\n                    </a>\n                </li>\n            </experience>\n            <experience flag='!cardart'>\n                <!--List of Plans : selectFi variant-->\n                <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList track by $index\" ng-if=\"isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                    <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS($index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                        <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                            <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                        </span>\n                        <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                            <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                <span>\n                                    <span class=\"fsName\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                    <div class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE'\">{{content('fundingInstruments.iach')}}</span>\n                                    </div>\n                                </span>\n                            </p>\n                        </div>\n                        <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"!(plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable())\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                            <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                <span ng-switch=\"plan.primaryFs.subtype\">\n                                    <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                        <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                        <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                        <span ng-if=\"!isBilling && !isReferenceCheckout && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\">\n                                            <br>\n                                            <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                        </span>\n                                    </span>\n                                    <span ng-switch-default>\n                                        <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                        <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                        <span ng-if=\"!isSelectFiVariant && plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.primaryFs.amount.currency_code}})</span>\n                                        <span ng-if=\"isSelectFiVariant && plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.currencies}})</span>\n                                        <div class=\"lastdigits\" ng-if=\"plan.primaryFs.subtype !== 'PAD'\">\n                                            <span ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                            <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                            <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                            <span class=\"subtype\" ng-if=\"plan.primaryFs.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                            <span ng-if=\"!isPreferLabelColor && !isBilling && !isReferenceCheckout && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\" class=\"preferredLabel\">\n                                                ({{ content('memberReview.preferred') }})\n                                            </span>\n                                            <span ng-if=\"isPreferLabelColor && !isBilling && !isReferenceCheckout && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\">\n                                                <br>\n                                                <span class=\"preferredLabel pxpColor\">{{ content('memberReview.preferred') }}</span>\n                                            </span>\n                                        </div>\n                                        <div ng-if=\"plan.primaryFs.isBillingPreferred\" class=\"billingPreferredLabel\">{{ content('fundingInstruments.billingPreferredFi', {merchantName: merchantName}) }}</div>\n                                    </span>\n                                </span>\n                                <xo-expired-fi-panel token=\"token\" fi=\"plan\"></xo-expired-fi-panel>\n                            </p>\n                        </div>\n                    </a>\n                </li>\n\n                <!--List of Plans : control-->\n                <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList track by $index\" ng-if=\"!isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                    <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS(plan, $index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                        <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                            <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                        </span>\n                        <div class=\"instrumentContainer\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length\">\n                            <p class=\"fsdetails\" ng-class=\"[plan.secondaryFIs[0].type]\">\n                                <span class=\"fsIcon\" ng-class=\"[plan.secondaryFIs[0].type, plan.secondaryFIs[0].name]\"></span>\n                                <span class=\"fsName\" ng-if=\"plan.secondaryFIs[0].name !== 'BALANCE' || !ppBalanceRebrandedExperiment.enabled\">{{content('fsMappings.'+ plan.secondaryFIs[0].name) || plan.secondaryFIs[0].name}}</span>\n                                <span class=\"fsName\" ng-if=\"plan.secondaryFIs[0].name === 'BALANCE' && ppBalanceRebrandedExperiment.enabled\">{{content('paymentMethod.paypalBalanceRebranded')}}</span>\n                                <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                <span class=\"amount\" ng-if=\"plan.secondaryFIs.length === 1 && plan.secondaryFIs[0].amount\">{{plan.secondaryFIs[0].amount.amount_formatted}}</span>\n                            </p>\n                        </div>\n                        <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                            <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                <span>\n                                    <span class=\"fsName\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE'\">{{content('fundingInstruments.iach')}}</span>\n                                    </span>\n                                </span>\n                            </p>\n                        </div>\n                        <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"!(plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable())\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                            <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                <span ng-switch=\"plan.primaryFs.subtype\">\n                                    <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                        <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                        <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                    </span>\n                                    <span ng-switch-default>\n                                        <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                        <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                        <span ng-if=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.primaryFs.amount.currency_code}})</span>\n                                        <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                            <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                            <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                            <span class=\"subtype\" ng-if=\"plan.primaryFs.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                        </span>\n                                        <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1 && plan.primaryFs.type !== 'INCENTIVE'\">: </span>\n                                    </span>\n                                </span>\n                                <span class=\"amount\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length === 1 && plan.primaryFs.amount && plan.primaryFs.type !== 'INCENTIVE'\">{{plan.primaryFs.amount.amount_formatted}}</span>\n                                <span ng-if=\"!isPreferLabelColor && !isBilling && !isReferenceCheckout && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\" class=\"preferredLabel\">\n                                    <br>\n                                    ({{ content('memberReview.preferred') }})\n                                </span>\n                                <span ng-if=\"isPreferLabelColor && !isBilling && !isReferenceCheckout && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\">\n                                    <br>\n                                    <span class=\"preferredLabel pxpColor\">{{ content('memberReview.preferred') }}</span>\n                                </span>\n                            </p>\n                            <xo-expired-fi-panel token=\"token\" fi=\"plan\"></xo-expired-fi-panel>\n                        </div>\n                    </a>\n                </li>\n            </experience>\n\n\n            <li role=\"presentation\" class=\"fundingsource fs-item\" ng-repeat=\"stickyFI in checkoutSession.futurePaymentInstruments track by $index\" ng-if=\"isBillingNoPurchase\">\n                <a class=\"source\" href=\"#\" ng-click=\"updateStickyFS(stickyFI)\" select-option role=\"button\"\n                    ng-attr-aria-selected=\"{{ (stickyFI.instrument_id===userSelectedFI) ? 'true' : undefined }}\"\n                    focus-when=\"stickyFI.instrument_id===userSelectedFI\">\n                    <div class=\"instrumentContainer singleInstrumentContainer\">\n                        <experience flag=\"!cardart\">\n                            <span class=\"fsIcon\" ng-class=\"[stickyFI.type, stickyFI.name, stickyFI.card_type]\"></span>\n                            <p class=\"fsdetails\">\n                                <span ng-switch=\"fundingsource.subtype\">\n                                    <span ng-switch-default>\n                                        <span class=\"name\">{{content('fsMappings.'+ stickyFI.name) || stickyFI.name}}</span>\n                                        <div class=\"lastdigits\" ng-if=\"stickyFI.last4\">x-{{stickyFI.last4}}</div>\n                                    </span>\n                                </span>\n                            </p>\n                        </experience>\n                        <experience flag=\"cardart\">\n                            <xo-fi-panel fi=\"stickyFI\"></xo-fi-panel>\n                        </experience>\n                    </div>\n                    <span class=\"checkIcon\" ng-if=\"stickyFI.instrument_id===userSelectedFI\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n\n            <div ng-if=\"displayPosition\" class=\"horizontalBar\"></div>\n            <li role=\"presentation\" ng-if=\"displayPosition\" class=\"fundingsource\"\n                ng-repeat=\"instrument in disallowedInstruments track by $index\">\n\n                <a href=\"#\" prevent-default class=\"source\" role=\"button\">\n                    <div class=\"disallowedContainer\">\n                        <experience flag='!cardart'>\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"instrument.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[instrument.type, instrument.name]\" ng-if=\"!instrument.isPinlessDebit\"></span>\n                            <div class=\"fsdetails\">\n                                <span ng-if=\"instrument.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                <span ng-if=\"!instrument.isPinlessDebit\">{{content('fsMappings.'+instrument.name) || instrument.name}}</span>\n                                <span class=\"lastdigits\" ng-if=\"instrument.lastDigits\">x-{{instrument.lastDigits}}\n                                    <span class=\"subtype\" ng-if=\"locale.country === 'DE' && instrument.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                    <span class=\"subtype\" ng-if=\"locale.country === 'DE' && instrument.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                    <span class=\"subtype\" ng-if=\"instrument.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                </span>\n                            </div>\n                            <xo-expired-fi-panel token=\"token\" fi=\"instrument\"></xo-expired-fi-panel>\n                        </experience>\n                        <experience flag='cardart'>\n                            <xo-fi-panel fi=\"instrument\">\n                                <xo-expired-fi-panel token=\"token\" fi=\"instrument\"></xo-expired-fi-panel>\n                            </xo-fi-panel>\n                            </experience>\n                    </div>\n                </a>\n            </li>\n\n            <!-- Gift Card link offer -->\n            <!-- changes for the coupon remdeem -->\n            <li role=\"presentation\" ng-if=\"showGC\" class=\"fundingsource redeemGC\" ng-click=\"onRedeemGC()\">\n                <p class=\"addOption\">\n                    <span>\n                        <a ng-click=\"onRedeemGC()\" class=\"proceed\" select-option> {{ content('memberReview.redeemGiftLink') }} {{ content('memberReview.giftCardDec') }}</a>\n                    </span>\n                </p>\n            </li>\n        </ul>\n    </div>\n\n    <ui-view></ui-view>\n\n</div>\n"

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/xo-webpack-config/polyfills.js");
module.exports = __webpack_require__("./js/bootstrap.js");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[0]);


// WEBPACK FOOTER //
// js/main.js